var $8 = Object.defineProperty;
var e5 = (t, e, A) => e in t ? $8(t, e, { enumerable: !0, configurable: !0, writable: !0, value: A }) : t[e] = A;
var Wh = (t, e, A) => e5(t, typeof e != "symbol" ? e + "" : e, A);
/**
* @vue/shared v3.5.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
// @__NO_SIDE_EFFECTS__
function BM(t) {
  const e = /* @__PURE__ */ Object.create(null);
  for (const A of t.split(",")) e[A] = 1;
  return (A) => A in e;
}
const kt = {}, $c = [], zr = () => {
}, A3 = () => !1, rw = (t) => t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && // uppercase letter
(t.charCodeAt(2) > 122 || t.charCodeAt(2) < 97), gM = (t) => t.startsWith("onUpdate:"), sA = Object.assign, hM = (t, e) => {
  const A = t.indexOf(e);
  A > -1 && t.splice(A, 1);
}, t5 = Object.prototype.hasOwnProperty, zt = (t, e) => t5.call(t, e), Ve = Array.isArray, el = (t) => iw(t) === "[object Map]", n3 = (t) => iw(t) === "[object Set]", et = (t) => typeof t == "function", rA = (t) => typeof t == "string", Zi = (t) => typeof t == "symbol", Pt = (t) => t !== null && typeof t == "object", s3 = (t) => (Pt(t) || et(t)) && et(t.then) && et(t.catch), r3 = Object.prototype.toString, iw = (t) => r3.call(t), A5 = (t) => iw(t).slice(8, -1), ow = (t) => iw(t) === "[object Object]", uM = (t) => rA(t) && t !== "NaN" && t[0] !== "-" && "" + parseInt(t, 10) === t, NB = /* @__PURE__ */ BM(
  // the leading comma is intentional so empty string "" is also included
  ",key,ref,ref_for,ref_key,onVnodeBeforeMount,onVnodeMounted,onVnodeBeforeUpdate,onVnodeUpdated,onVnodeBeforeUnmount,onVnodeUnmounted"
), aw = (t) => {
  const e = /* @__PURE__ */ Object.create(null);
  return ((A) => e[A] || (e[A] = t(A)));
}, n5 = /-\w/g, Nn = aw(
  (t) => t.replace(n5, (e) => e.slice(1).toUpperCase())
), s5 = /\B([A-Z])/g, is = aw(
  (t) => t.replace(s5, "-$1").toLowerCase()
), cw = aw((t) => t.charAt(0).toUpperCase() + t.slice(1)), Pf = aw(
  (t) => t ? `on${cw(t)}` : ""
), Ro = (t, e) => !Object.is(t, e), R0 = (t, ...e) => {
  for (let A = 0; A < t.length; A++)
    t[A](...e);
}, i3 = (t, e, A, n = !1) => {
  Object.defineProperty(t, e, {
    configurable: !0,
    enumerable: !1,
    writable: n,
    value: A
  });
}, dM = (t) => {
  const e = parseFloat(t);
  return isNaN(e) ? t : e;
}, rC = (t) => {
  const e = rA(t) ? Number(t) : NaN;
  return isNaN(e) ? t : e;
};
let WY;
const lw = () => WY || (WY = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : typeof global < "u" ? global : {});
function ia(t) {
  if (Ve(t)) {
    const e = {};
    for (let A = 0; A < t.length; A++) {
      const n = t[A], s = rA(n) ? a5(n) : ia(n);
      if (s)
        for (const r in s)
          e[r] = s[r];
    }
    return e;
  } else if (rA(t) || Pt(t))
    return t;
}
const r5 = /;(?![^(]*\))/g, i5 = /:([^]+)/, o5 = /\/\*[^]*?\*\//g;
function a5(t) {
  const e = {};
  return t.replace(o5, "").split(r5).forEach((A) => {
    if (A) {
      const n = A.split(i5);
      n.length > 1 && (e[n[0].trim()] = n[1].trim());
    }
  }), e;
}
function De(t) {
  let e = "";
  if (rA(t))
    e = t;
  else if (Ve(t))
    for (let A = 0; A < t.length; A++) {
      const n = De(t[A]);
      n && (e += n + " ");
    }
  else if (Pt(t))
    for (const A in t)
      t[A] && (e += A + " ");
  return e.trim();
}
const c5 = "itemscope,allowfullscreen,formnovalidate,ismap,nomodule,novalidate,readonly", l5 = /* @__PURE__ */ BM(c5);
function o3(t) {
  return !!t || t === "";
}
const a3 = (t) => !!(t && t.__v_isRef === !0), Mt = (t) => rA(t) ? t : t == null ? "" : Ve(t) || Pt(t) && (t.toString === r3 || !et(t.toString)) ? a3(t) ? Mt(t.value) : JSON.stringify(t, c3, 2) : String(t), c3 = (t, e) => a3(e) ? c3(t, e.value) : el(e) ? {
  [`Map(${e.size})`]: [...e.entries()].reduce(
    (A, [n, s], r) => (A[Kf(n, r) + " =>"] = s, A),
    {}
  )
} : n3(e) ? {
  [`Set(${e.size})`]: [...e.values()].map((A) => Kf(A))
} : Zi(e) ? Kf(e) : Pt(e) && !Ve(e) && !ow(e) ? String(e) : e, Kf = (t, e = "") => {
  var A;
  return (
    // Symbol.description in es2019+ so we need to cast here to pass
    // the lib: es2016 check
    Zi(t) ? `Symbol(${(A = t.description) != null ? A : e})` : t
  );
};
/**
* @vue/reactivity v3.5.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let Jn;
class B5 {
  constructor(e = !1) {
    this.detached = e, this._active = !0, this._on = 0, this.effects = [], this.cleanups = [], this._isPaused = !1, this.parent = Jn, !e && Jn && (this.index = (Jn.scopes || (Jn.scopes = [])).push(
      this
    ) - 1);
  }
  get active() {
    return this._active;
  }
  pause() {
    if (this._active) {
      this._isPaused = !0;
      let e, A;
      if (this.scopes)
        for (e = 0, A = this.scopes.length; e < A; e++)
          this.scopes[e].pause();
      for (e = 0, A = this.effects.length; e < A; e++)
        this.effects[e].pause();
    }
  }
  /**
   * Resumes the effect scope, including all child scopes and effects.
   */
  resume() {
    if (this._active && this._isPaused) {
      this._isPaused = !1;
      let e, A;
      if (this.scopes)
        for (e = 0, A = this.scopes.length; e < A; e++)
          this.scopes[e].resume();
      for (e = 0, A = this.effects.length; e < A; e++)
        this.effects[e].resume();
    }
  }
  run(e) {
    if (this._active) {
      const A = Jn;
      try {
        return Jn = this, e();
      } finally {
        Jn = A;
      }
    }
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  on() {
    ++this._on === 1 && (this.prevScope = Jn, Jn = this);
  }
  /**
   * This should only be called on non-detached scopes
   * @internal
   */
  off() {
    this._on > 0 && --this._on === 0 && (Jn = this.prevScope, this.prevScope = void 0);
  }
  stop(e) {
    if (this._active) {
      this._active = !1;
      let A, n;
      for (A = 0, n = this.effects.length; A < n; A++)
        this.effects[A].stop();
      for (this.effects.length = 0, A = 0, n = this.cleanups.length; A < n; A++)
        this.cleanups[A]();
      if (this.cleanups.length = 0, this.scopes) {
        for (A = 0, n = this.scopes.length; A < n; A++)
          this.scopes[A].stop(!0);
        this.scopes.length = 0;
      }
      if (!this.detached && this.parent && !e) {
        const s = this.parent.scopes.pop();
        s && s !== this && (this.parent.scopes[this.index] = s, s.index = this.index);
      }
      this.parent = void 0;
    }
  }
}
function g5() {
  return Jn;
}
let Jt;
const Vf = /* @__PURE__ */ new WeakSet();
class l3 {
  constructor(e) {
    this.fn = e, this.deps = void 0, this.depsTail = void 0, this.flags = 5, this.next = void 0, this.cleanup = void 0, this.scheduler = void 0, Jn && Jn.active && Jn.effects.push(this);
  }
  pause() {
    this.flags |= 64;
  }
  resume() {
    this.flags & 64 && (this.flags &= -65, Vf.has(this) && (Vf.delete(this), this.trigger()));
  }
  /**
   * @internal
   */
  notify() {
    this.flags & 2 && !(this.flags & 32) || this.flags & 8 || g3(this);
  }
  run() {
    if (!(this.flags & 1))
      return this.fn();
    this.flags |= 2, OY(this), h3(this);
    const e = Jt, A = er;
    Jt = this, er = !0;
    try {
      return this.fn();
    } finally {
      u3(this), Jt = e, er = A, this.flags &= -3;
    }
  }
  stop() {
    if (this.flags & 1) {
      for (let e = this.deps; e; e = e.nextDep)
        QM(e);
      this.deps = this.depsTail = void 0, OY(this), this.onStop && this.onStop(), this.flags &= -2;
    }
  }
  trigger() {
    this.flags & 64 ? Vf.add(this) : this.scheduler ? this.scheduler() : this.runIfDirty();
  }
  /**
   * @internal
   */
  runIfDirty() {
    iC(this) && this.run();
  }
  get dirty() {
    return iC(this);
  }
}
let B3 = 0, DB, xB;
function g3(t, e = !1) {
  if (t.flags |= 8, e) {
    t.next = xB, xB = t;
    return;
  }
  t.next = DB, DB = t;
}
function wM() {
  B3++;
}
function fM() {
  if (--B3 > 0)
    return;
  if (xB) {
    let e = xB;
    for (xB = void 0; e; ) {
      const A = e.next;
      e.next = void 0, e.flags &= -9, e = A;
    }
  }
  let t;
  for (; DB; ) {
    let e = DB;
    for (DB = void 0; e; ) {
      const A = e.next;
      if (e.next = void 0, e.flags &= -9, e.flags & 1)
        try {
          e.trigger();
        } catch (n) {
          t || (t = n);
        }
      e = A;
    }
  }
  if (t) throw t;
}
function h3(t) {
  for (let e = t.deps; e; e = e.nextDep)
    e.version = -1, e.prevActiveLink = e.dep.activeLink, e.dep.activeLink = e;
}
function u3(t) {
  let e, A = t.depsTail, n = A;
  for (; n; ) {
    const s = n.prevDep;
    n.version === -1 ? (n === A && (A = s), QM(n), h5(n)) : e = n, n.dep.activeLink = n.prevActiveLink, n.prevActiveLink = void 0, n = s;
  }
  t.deps = e, t.depsTail = A;
}
function iC(t) {
  for (let e = t.deps; e; e = e.nextDep)
    if (e.dep.version !== e.version || e.dep.computed && (d3(e.dep.computed) || e.dep.version !== e.version))
      return !0;
  return !!t._dirty;
}
function d3(t) {
  if (t.flags & 4 && !(t.flags & 16) || (t.flags &= -17, t.globalVersion === hg) || (t.globalVersion = hg, !t.isSSR && t.flags & 128 && (!t.deps && !t._dirty || !iC(t))))
    return;
  t.flags |= 2;
  const e = t.dep, A = Jt, n = er;
  Jt = t, er = !0;
  try {
    h3(t);
    const s = t.fn(t._value);
    (e.version === 0 || Ro(s, t._value)) && (t.flags |= 128, t._value = s, e.version++);
  } catch (s) {
    throw e.version++, s;
  } finally {
    Jt = A, er = n, u3(t), t.flags &= -3;
  }
}
function QM(t, e = !1) {
  const { dep: A, prevSub: n, nextSub: s } = t;
  if (n && (n.nextSub = s, t.prevSub = void 0), s && (s.prevSub = n, t.nextSub = void 0), A.subs === t && (A.subs = n, !n && A.computed)) {
    A.computed.flags &= -5;
    for (let r = A.computed.deps; r; r = r.nextDep)
      QM(r, !0);
  }
  !e && !--A.sc && A.map && A.map.delete(A.key);
}
function h5(t) {
  const { prevDep: e, nextDep: A } = t;
  e && (e.nextDep = A, t.prevDep = void 0), A && (A.prevDep = e, t.nextDep = void 0);
}
let er = !0;
const w3 = [];
function ki() {
  w3.push(er), er = !1;
}
function Ri() {
  const t = w3.pop();
  er = t === void 0 ? !0 : t;
}
function OY(t) {
  const { cleanup: e } = t;
  if (t.cleanup = void 0, e) {
    const A = Jt;
    Jt = void 0;
    try {
      e();
    } finally {
      Jt = A;
    }
  }
}
let hg = 0, u5 = class {
  constructor(e, A) {
    this.sub = e, this.dep = A, this.version = A.version, this.nextDep = this.prevDep = this.nextSub = this.prevSub = this.prevActiveLink = void 0;
  }
};
class Bw {
  // TODO isolatedDeclarations "__v_skip"
  constructor(e) {
    this.computed = e, this.version = 0, this.activeLink = void 0, this.subs = void 0, this.map = void 0, this.key = void 0, this.sc = 0, this.__v_skip = !0;
  }
  track(e) {
    if (!Jt || !er || Jt === this.computed)
      return;
    let A = this.activeLink;
    if (A === void 0 || A.sub !== Jt)
      A = this.activeLink = new u5(Jt, this), Jt.deps ? (A.prevDep = Jt.depsTail, Jt.depsTail.nextDep = A, Jt.depsTail = A) : Jt.deps = Jt.depsTail = A, f3(A);
    else if (A.version === -1 && (A.version = this.version, A.nextDep)) {
      const n = A.nextDep;
      n.prevDep = A.prevDep, A.prevDep && (A.prevDep.nextDep = n), A.prevDep = Jt.depsTail, A.nextDep = void 0, Jt.depsTail.nextDep = A, Jt.depsTail = A, Jt.deps === A && (Jt.deps = n);
    }
    return A;
  }
  trigger(e) {
    this.version++, hg++, this.notify(e);
  }
  notify(e) {
    wM();
    try {
      for (let A = this.subs; A; A = A.prevSub)
        A.sub.notify() && A.sub.dep.notify();
    } finally {
      fM();
    }
  }
}
function f3(t) {
  if (t.dep.sc++, t.sub.flags & 4) {
    const e = t.dep.computed;
    if (e && !t.dep.subs) {
      e.flags |= 20;
      for (let n = e.deps; n; n = n.nextDep)
        f3(n);
    }
    const A = t.dep.subs;
    A !== t && (t.prevSub = A, A && (A.nextSub = t)), t.dep.subs = t;
  }
}
const oC = /* @__PURE__ */ new WeakMap(), Ha = /* @__PURE__ */ Symbol(
  ""
), aC = /* @__PURE__ */ Symbol(
  ""
), ug = /* @__PURE__ */ Symbol(
  ""
);
function tn(t, e, A) {
  if (er && Jt) {
    let n = oC.get(t);
    n || oC.set(t, n = /* @__PURE__ */ new Map());
    let s = n.get(A);
    s || (n.set(A, s = new Bw()), s.map = n, s.key = A), s.track();
  }
}
function mi(t, e, A, n, s, r) {
  const i = oC.get(t);
  if (!i) {
    hg++;
    return;
  }
  const o = (a) => {
    a && a.trigger();
  };
  if (wM(), e === "clear")
    i.forEach(o);
  else {
    const a = Ve(t), c = a && uM(A);
    if (a && A === "length") {
      const l = Number(n);
      i.forEach((B, g) => {
        (g === "length" || g === ug || !Zi(g) && g >= l) && o(B);
      });
    } else
      switch ((A !== void 0 || i.has(void 0)) && o(i.get(A)), c && o(i.get(ug)), e) {
        case "add":
          a ? c && o(i.get("length")) : (o(i.get(Ha)), el(t) && o(i.get(aC)));
          break;
        case "delete":
          a || (o(i.get(Ha)), el(t) && o(i.get(aC)));
          break;
        case "set":
          el(t) && o(i.get(Ha));
          break;
      }
  }
  fM();
}
function mc(t) {
  const e = /* @__PURE__ */ Gt(t);
  return e === t ? e : (tn(e, "iterate", ug), /* @__PURE__ */ Us(t) ? e : e.map(sr));
}
function gw(t) {
  return tn(t = /* @__PURE__ */ Gt(t), "iterate", ug), t;
}
function Qo(t, e) {
  return /* @__PURE__ */ Li(t) ? wl(/* @__PURE__ */ ka(t) ? sr(e) : e) : sr(e);
}
const d5 = {
  __proto__: null,
  [Symbol.iterator]() {
    return Xf(this, Symbol.iterator, (t) => Qo(this, t));
  },
  concat(...t) {
    return mc(this).concat(
      ...t.map((e) => Ve(e) ? mc(e) : e)
    );
  },
  entries() {
    return Xf(this, "entries", (t) => (t[1] = Qo(this, t[1]), t));
  },
  every(t, e) {
    return oi(this, "every", t, e, void 0, arguments);
  },
  filter(t, e) {
    return oi(
      this,
      "filter",
      t,
      e,
      (A) => A.map((n) => Qo(this, n)),
      arguments
    );
  },
  find(t, e) {
    return oi(
      this,
      "find",
      t,
      e,
      (A) => Qo(this, A),
      arguments
    );
  },
  findIndex(t, e) {
    return oi(this, "findIndex", t, e, void 0, arguments);
  },
  findLast(t, e) {
    return oi(
      this,
      "findLast",
      t,
      e,
      (A) => Qo(this, A),
      arguments
    );
  },
  findLastIndex(t, e) {
    return oi(this, "findLastIndex", t, e, void 0, arguments);
  },
  // flat, flatMap could benefit from ARRAY_ITERATE but are not straight-forward to implement
  forEach(t, e) {
    return oi(this, "forEach", t, e, void 0, arguments);
  },
  includes(...t) {
    return Zf(this, "includes", t);
  },
  indexOf(...t) {
    return Zf(this, "indexOf", t);
  },
  join(t) {
    return mc(this).join(t);
  },
  // keys() iterator only reads `length`, no optimization required
  lastIndexOf(...t) {
    return Zf(this, "lastIndexOf", t);
  },
  map(t, e) {
    return oi(this, "map", t, e, void 0, arguments);
  },
  pop() {
    return tB(this, "pop");
  },
  push(...t) {
    return tB(this, "push", t);
  },
  reduce(t, ...e) {
    return PY(this, "reduce", t, e);
  },
  reduceRight(t, ...e) {
    return PY(this, "reduceRight", t, e);
  },
  shift() {
    return tB(this, "shift");
  },
  // slice could use ARRAY_ITERATE but also seems to beg for range tracking
  some(t, e) {
    return oi(this, "some", t, e, void 0, arguments);
  },
  splice(...t) {
    return tB(this, "splice", t);
  },
  toReversed() {
    return mc(this).toReversed();
  },
  toSorted(t) {
    return mc(this).toSorted(t);
  },
  toSpliced(...t) {
    return mc(this).toSpliced(...t);
  },
  unshift(...t) {
    return tB(this, "unshift", t);
  },
  values() {
    return Xf(this, "values", (t) => Qo(this, t));
  }
};
function Xf(t, e, A) {
  const n = gw(t), s = n[e]();
  return n !== t && !/* @__PURE__ */ Us(t) && (s._next = s.next, s.next = () => {
    const r = s._next();
    return r.done || (r.value = A(r.value)), r;
  }), s;
}
const w5 = Array.prototype;
function oi(t, e, A, n, s, r) {
  const i = gw(t), o = i !== t && !/* @__PURE__ */ Us(t), a = i[e];
  if (a !== w5[e]) {
    const B = a.apply(t, r);
    return o ? sr(B) : B;
  }
  let c = A;
  i !== t && (o ? c = function(B, g) {
    return A.call(this, Qo(t, B), g, t);
  } : A.length > 2 && (c = function(B, g) {
    return A.call(this, B, g, t);
  }));
  const l = a.call(i, c, n);
  return o && s ? s(l) : l;
}
function PY(t, e, A, n) {
  const s = gw(t);
  let r = A;
  return s !== t && (/* @__PURE__ */ Us(t) ? A.length > 3 && (r = function(i, o, a) {
    return A.call(this, i, o, a, t);
  }) : r = function(i, o, a) {
    return A.call(this, i, Qo(t, o), a, t);
  }), s[e](r, ...n);
}
function Zf(t, e, A) {
  const n = /* @__PURE__ */ Gt(t);
  tn(n, "iterate", ug);
  const s = n[e](...A);
  return (s === -1 || s === !1) && /* @__PURE__ */ MM(A[0]) ? (A[0] = /* @__PURE__ */ Gt(A[0]), n[e](...A)) : s;
}
function tB(t, e, A = []) {
  ki(), wM();
  const n = (/* @__PURE__ */ Gt(t))[e].apply(t, A);
  return fM(), Ri(), n;
}
const f5 = /* @__PURE__ */ BM("__proto__,__v_isRef,__isVue"), Q3 = new Set(
  /* @__PURE__ */ Object.getOwnPropertyNames(Symbol).filter((t) => t !== "arguments" && t !== "caller").map((t) => Symbol[t]).filter(Zi)
);
function Q5(t) {
  Zi(t) || (t = String(t));
  const e = /* @__PURE__ */ Gt(this);
  return tn(e, "has", t), e.hasOwnProperty(t);
}
class I3 {
  constructor(e = !1, A = !1) {
    this._isReadonly = e, this._isShallow = A;
  }
  get(e, A, n) {
    if (A === "__v_skip") return e.__v_skip;
    const s = this._isReadonly, r = this._isShallow;
    if (A === "__v_isReactive")
      return !s;
    if (A === "__v_isReadonly")
      return s;
    if (A === "__v_isShallow")
      return r;
    if (A === "__v_raw")
      return n === (s ? r ? N5 : p3 : r ? M3 : E3).get(e) || // receiver is not the reactive proxy, but has the same prototype
      // this means the receiver is a user proxy of the reactive proxy
      Object.getPrototypeOf(e) === Object.getPrototypeOf(n) ? e : void 0;
    const i = Ve(e);
    if (!s) {
      let a;
      if (i && (a = d5[A]))
        return a;
      if (A === "hasOwnProperty")
        return Q5;
    }
    const o = Reflect.get(
      e,
      A,
      // if this is a proxy wrapping a ref, return methods using the raw ref
      // as receiver so that we don't have to call `toRaw` on the ref in all
      // its class methods
      /* @__PURE__ */ rn(e) ? e : n
    );
    if ((Zi(A) ? Q3.has(A) : f5(A)) || (s || tn(e, "get", A), r))
      return o;
    if (/* @__PURE__ */ rn(o)) {
      const a = i && uM(A) ? o : o.value;
      return s && Pt(a) ? /* @__PURE__ */ lC(a) : a;
    }
    return Pt(o) ? s ? /* @__PURE__ */ lC(o) : /* @__PURE__ */ CM(o) : o;
  }
}
class C3 extends I3 {
  constructor(e = !1) {
    super(!1, e);
  }
  set(e, A, n, s) {
    let r = e[A];
    const i = Ve(e) && uM(A);
    if (!this._isShallow) {
      const c = /* @__PURE__ */ Li(r);
      if (!/* @__PURE__ */ Us(n) && !/* @__PURE__ */ Li(n) && (r = /* @__PURE__ */ Gt(r), n = /* @__PURE__ */ Gt(n)), !i && /* @__PURE__ */ rn(r) && !/* @__PURE__ */ rn(n))
        return c || (r.value = n), !0;
    }
    const o = i ? Number(A) < e.length : zt(e, A), a = Reflect.set(
      e,
      A,
      n,
      /* @__PURE__ */ rn(e) ? e : s
    );
    return e === /* @__PURE__ */ Gt(s) && (o ? Ro(n, r) && mi(e, "set", A, n) : mi(e, "add", A, n)), a;
  }
  deleteProperty(e, A) {
    const n = zt(e, A);
    e[A];
    const s = Reflect.deleteProperty(e, A);
    return s && n && mi(e, "delete", A, void 0), s;
  }
  has(e, A) {
    const n = Reflect.has(e, A);
    return (!Zi(A) || !Q3.has(A)) && tn(e, "has", A), n;
  }
  ownKeys(e) {
    return tn(
      e,
      "iterate",
      Ve(e) ? "length" : Ha
    ), Reflect.ownKeys(e);
  }
}
class I5 extends I3 {
  constructor(e = !1) {
    super(!0, e);
  }
  set(e, A) {
    return !0;
  }
  deleteProperty(e, A) {
    return !0;
  }
}
const C5 = /* @__PURE__ */ new C3(), E5 = /* @__PURE__ */ new I5(), M5 = /* @__PURE__ */ new C3(!0);
const cC = (t) => t, Oh = (t) => Reflect.getPrototypeOf(t);
function p5(t, e, A) {
  return function(...n) {
    const s = this.__v_raw, r = /* @__PURE__ */ Gt(s), i = el(r), o = t === "entries" || t === Symbol.iterator && i, a = t === "keys" && i, c = s[t](...n), l = A ? cC : e ? wl : sr;
    return !e && tn(
      r,
      "iterate",
      a ? aC : Ha
    ), sA(
      // inheriting all iterator properties
      Object.create(c),
      {
        // iterator protocol
        next() {
          const { value: B, done: g } = c.next();
          return g ? { value: B, done: g } : {
            value: o ? [l(B[0]), l(B[1])] : l(B),
            done: g
          };
        }
      }
    );
  };
}
function Ph(t) {
  return function(...e) {
    return t === "delete" ? !1 : t === "clear" ? void 0 : this;
  };
}
function m5(t, e) {
  const A = {
    get(s) {
      const r = this.__v_raw, i = /* @__PURE__ */ Gt(r), o = /* @__PURE__ */ Gt(s);
      t || (Ro(s, o) && tn(i, "get", s), tn(i, "get", o));
      const { has: a } = Oh(i), c = e ? cC : t ? wl : sr;
      if (a.call(i, s))
        return c(r.get(s));
      if (a.call(i, o))
        return c(r.get(o));
      r !== i && r.get(s);
    },
    get size() {
      const s = this.__v_raw;
      return !t && tn(/* @__PURE__ */ Gt(s), "iterate", Ha), s.size;
    },
    has(s) {
      const r = this.__v_raw, i = /* @__PURE__ */ Gt(r), o = /* @__PURE__ */ Gt(s);
      return t || (Ro(s, o) && tn(i, "has", s), tn(i, "has", o)), s === o ? r.has(s) : r.has(s) || r.has(o);
    },
    forEach(s, r) {
      const i = this, o = i.__v_raw, a = /* @__PURE__ */ Gt(o), c = e ? cC : t ? wl : sr;
      return !t && tn(a, "iterate", Ha), o.forEach((l, B) => s.call(r, c(l), c(B), i));
    }
  };
  return sA(
    A,
    t ? {
      add: Ph("add"),
      set: Ph("set"),
      delete: Ph("delete"),
      clear: Ph("clear")
    } : {
      add(s) {
        !e && !/* @__PURE__ */ Us(s) && !/* @__PURE__ */ Li(s) && (s = /* @__PURE__ */ Gt(s));
        const r = /* @__PURE__ */ Gt(this);
        return Oh(r).has.call(r, s) || (r.add(s), mi(r, "add", s, s)), this;
      },
      set(s, r) {
        !e && !/* @__PURE__ */ Us(r) && !/* @__PURE__ */ Li(r) && (r = /* @__PURE__ */ Gt(r));
        const i = /* @__PURE__ */ Gt(this), { has: o, get: a } = Oh(i);
        let c = o.call(i, s);
        c || (s = /* @__PURE__ */ Gt(s), c = o.call(i, s));
        const l = a.call(i, s);
        return i.set(s, r), c ? Ro(r, l) && mi(i, "set", s, r) : mi(i, "add", s, r), this;
      },
      delete(s) {
        const r = /* @__PURE__ */ Gt(this), { has: i, get: o } = Oh(r);
        let a = i.call(r, s);
        a || (s = /* @__PURE__ */ Gt(s), a = i.call(r, s)), o && o.call(r, s);
        const c = r.delete(s);
        return a && mi(r, "delete", s, void 0), c;
      },
      clear() {
        const s = /* @__PURE__ */ Gt(this), r = s.size !== 0, i = s.clear();
        return r && mi(
          s,
          "clear",
          void 0,
          void 0
        ), i;
      }
    }
  ), [
    "keys",
    "values",
    "entries",
    Symbol.iterator
  ].forEach((s) => {
    A[s] = p5(s, t, e);
  }), A;
}
function IM(t, e) {
  const A = m5(t, e);
  return (n, s, r) => s === "__v_isReactive" ? !t : s === "__v_isReadonly" ? t : s === "__v_raw" ? n : Reflect.get(
    zt(A, s) && s in n ? A : n,
    s,
    r
  );
}
const Y5 = {
  get: /* @__PURE__ */ IM(!1, !1)
}, y5 = {
  get: /* @__PURE__ */ IM(!1, !0)
}, F5 = {
  get: /* @__PURE__ */ IM(!0, !1)
};
const E3 = /* @__PURE__ */ new WeakMap(), M3 = /* @__PURE__ */ new WeakMap(), p3 = /* @__PURE__ */ new WeakMap(), N5 = /* @__PURE__ */ new WeakMap();
function D5(t) {
  switch (t) {
    case "Object":
    case "Array":
      return 1;
    case "Map":
    case "Set":
    case "WeakMap":
    case "WeakSet":
      return 2;
    default:
      return 0;
  }
}
function x5(t) {
  return t.__v_skip || !Object.isExtensible(t) ? 0 : D5(A5(t));
}
// @__NO_SIDE_EFFECTS__
function CM(t) {
  return /* @__PURE__ */ Li(t) ? t : EM(
    t,
    !1,
    C5,
    Y5,
    E3
  );
}
// @__NO_SIDE_EFFECTS__
function G5(t) {
  return EM(
    t,
    !1,
    M5,
    y5,
    M3
  );
}
// @__NO_SIDE_EFFECTS__
function lC(t) {
  return EM(
    t,
    !0,
    E5,
    F5,
    p3
  );
}
function EM(t, e, A, n, s) {
  if (!Pt(t) || t.__v_raw && !(e && t.__v_isReactive))
    return t;
  const r = x5(t);
  if (r === 0)
    return t;
  const i = s.get(t);
  if (i)
    return i;
  const o = new Proxy(
    t,
    r === 2 ? n : A
  );
  return s.set(t, o), o;
}
// @__NO_SIDE_EFFECTS__
function ka(t) {
  return /* @__PURE__ */ Li(t) ? /* @__PURE__ */ ka(t.__v_raw) : !!(t && t.__v_isReactive);
}
// @__NO_SIDE_EFFECTS__
function Li(t) {
  return !!(t && t.__v_isReadonly);
}
// @__NO_SIDE_EFFECTS__
function Us(t) {
  return !!(t && t.__v_isShallow);
}
// @__NO_SIDE_EFFECTS__
function MM(t) {
  return t ? !!t.__v_raw : !1;
}
// @__NO_SIDE_EFFECTS__
function Gt(t) {
  const e = t && t.__v_raw;
  return e ? /* @__PURE__ */ Gt(e) : t;
}
function m3(t) {
  return !zt(t, "__v_skip") && Object.isExtensible(t) && i3(t, "__v_skip", !0), t;
}
const sr = (t) => Pt(t) ? /* @__PURE__ */ CM(t) : t, wl = (t) => Pt(t) ? /* @__PURE__ */ lC(t) : t;
// @__NO_SIDE_EFFECTS__
function rn(t) {
  return t ? t.__v_isRef === !0 : !1;
}
// @__NO_SIDE_EFFECTS__
function me(t) {
  return Y3(t, !1);
}
// @__NO_SIDE_EFFECTS__
function qf(t) {
  return Y3(t, !0);
}
function Y3(t, e) {
  return /* @__PURE__ */ rn(t) ? t : new z5(t, e);
}
class z5 {
  constructor(e, A) {
    this.dep = new Bw(), this.__v_isRef = !0, this.__v_isShallow = !1, this._rawValue = A ? e : /* @__PURE__ */ Gt(e), this._value = A ? e : sr(e), this.__v_isShallow = A;
  }
  get value() {
    return this.dep.track(), this._value;
  }
  set value(e) {
    const A = this._rawValue, n = this.__v_isShallow || /* @__PURE__ */ Us(e) || /* @__PURE__ */ Li(e);
    e = n ? e : /* @__PURE__ */ Gt(e), Ro(e, A) && (this._rawValue = e, this._value = n ? e : sr(e), this.dep.trigger());
  }
}
function bs(t) {
  return /* @__PURE__ */ rn(t) ? t.value : t;
}
const U5 = {
  get: (t, e, A) => e === "__v_raw" ? t : bs(Reflect.get(t, e, A)),
  set: (t, e, A, n) => {
    const s = t[e];
    return /* @__PURE__ */ rn(s) && !/* @__PURE__ */ rn(A) ? (s.value = A, !0) : Reflect.set(t, e, A, n);
  }
};
function y3(t) {
  return /* @__PURE__ */ ka(t) ? t : new Proxy(t, U5);
}
class b5 {
  constructor(e) {
    this.__v_isRef = !0, this._value = void 0;
    const A = this.dep = new Bw(), { get: n, set: s } = e(A.track.bind(A), A.trigger.bind(A));
    this._get = n, this._set = s;
  }
  get value() {
    return this._value = this._get();
  }
  set value(e) {
    this._set(e);
  }
}
function v5(t) {
  return new b5(t);
}
class j5 {
  constructor(e, A, n) {
    this.fn = e, this.setter = A, this._value = void 0, this.dep = new Bw(this), this.__v_isRef = !0, this.deps = void 0, this.depsTail = void 0, this.flags = 16, this.globalVersion = hg - 1, this.next = void 0, this.effect = this, this.__v_isReadonly = !A, this.isSSR = n;
  }
  /**
   * @internal
   */
  notify() {
    if (this.flags |= 16, !(this.flags & 8) && // avoid infinite self recursion
    Jt !== this)
      return g3(this, !0), !0;
  }
  get value() {
    const e = this.dep.track();
    return d3(this), e && (e.version = this.dep.version), this._value;
  }
  set value(e) {
    this.setter && this.setter(e);
  }
}
// @__NO_SIDE_EFFECTS__
function H5(t, e, A = !1) {
  let n, s;
  return et(t) ? n = t : (n = t.get, s = t.set), new j5(n, s, A);
}
const Kh = {}, Cu = /* @__PURE__ */ new WeakMap();
let Na;
function k5(t, e = !1, A = Na) {
  if (A) {
    let n = Cu.get(A);
    n || Cu.set(A, n = []), n.push(t);
  }
}
function R5(t, e, A = kt) {
  const { immediate: n, deep: s, once: r, scheduler: i, augmentJob: o, call: a } = A, c = (I) => s ? I : /* @__PURE__ */ Us(I) || s === !1 || s === 0 ? Yi(I, 1) : Yi(I);
  let l, B, g, h, u = !1, d = !1;
  if (/* @__PURE__ */ rn(t) ? (B = () => t.value, u = /* @__PURE__ */ Us(t)) : /* @__PURE__ */ ka(t) ? (B = () => c(t), u = !0) : Ve(t) ? (d = !0, u = t.some((I) => /* @__PURE__ */ ka(I) || /* @__PURE__ */ Us(I)), B = () => t.map((I) => {
    if (/* @__PURE__ */ rn(I))
      return I.value;
    if (/* @__PURE__ */ ka(I))
      return c(I);
    if (et(I))
      return a ? a(I, 2) : I();
  })) : et(t) ? e ? B = a ? () => a(t, 2) : t : B = () => {
    if (g) {
      ki();
      try {
        g();
      } finally {
        Ri();
      }
    }
    const I = Na;
    Na = l;
    try {
      return a ? a(t, 3, [h]) : t(h);
    } finally {
      Na = I;
    }
  } : B = zr, e && s) {
    const I = B, N = s === !0 ? 1 / 0 : s;
    B = () => Yi(I(), N);
  }
  const w = g5(), Q = () => {
    l.stop(), w && w.active && hM(w.effects, l);
  };
  if (r && e) {
    const I = e;
    e = (...N) => {
      I(...N), Q();
    };
  }
  let p = d ? new Array(t.length).fill(Kh) : Kh;
  const M = (I) => {
    if (!(!(l.flags & 1) || !l.dirty && !I))
      if (e) {
        const N = l.run();
        if (s || u || (d ? N.some((m, E) => Ro(m, p[E])) : Ro(N, p))) {
          g && g();
          const m = Na;
          Na = l;
          try {
            const E = [
              N,
              // pass undefined as the old value when it's changed for the first time
              p === Kh ? void 0 : d && p[0] === Kh ? [] : p,
              h
            ];
            p = N, a ? a(e, 3, E) : (
              // @ts-expect-error
              e(...E)
            );
          } finally {
            Na = m;
          }
        }
      } else
        l.run();
  };
  return o && o(M), l = new l3(B), l.scheduler = i ? () => i(M, !1) : M, h = (I) => k5(I, !1, l), g = l.onStop = () => {
    const I = Cu.get(l);
    if (I) {
      if (a)
        a(I, 4);
      else
        for (const N of I) N();
      Cu.delete(l);
    }
  }, e ? n ? M(!0) : p = l.run() : i ? i(M.bind(null, !0), !0) : l.run(), Q.pause = l.pause.bind(l), Q.resume = l.resume.bind(l), Q.stop = Q, Q;
}
function Yi(t, e = 1 / 0, A) {
  if (e <= 0 || !Pt(t) || t.__v_skip || (A = A || /* @__PURE__ */ new Map(), (A.get(t) || 0) >= e))
    return t;
  if (A.set(t, e), e--, /* @__PURE__ */ rn(t))
    Yi(t.value, e, A);
  else if (Ve(t))
    for (let n = 0; n < t.length; n++)
      Yi(t[n], e, A);
  else if (n3(t) || el(t))
    t.forEach((n) => {
      Yi(n, e, A);
    });
  else if (ow(t)) {
    for (const n in t)
      Yi(t[n], e, A);
    for (const n of Object.getOwnPropertySymbols(t))
      Object.prototype.propertyIsEnumerable.call(t, n) && Yi(t[n], e, A);
  }
  return t;
}
/**
* @vue/runtime-core v3.5.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
function oh(t, e, A, n) {
  try {
    return n ? t(...n) : t();
  } catch (s) {
    hw(s, e, A);
  }
}
function rr(t, e, A, n) {
  if (et(t)) {
    const s = oh(t, e, A, n);
    return s && s3(s) && s.catch((r) => {
      hw(r, e, A);
    }), s;
  }
  if (Ve(t)) {
    const s = [];
    for (let r = 0; r < t.length; r++)
      s.push(rr(t[r], e, A, n));
    return s;
  }
}
function hw(t, e, A, n = !0) {
  const s = e ? e.vnode : null, { errorHandler: r, throwUnhandledErrorInProduction: i } = e && e.appContext.config || kt;
  if (e) {
    let o = e.parent;
    const a = e.proxy, c = `https://vuejs.org/error-reference/#runtime-${A}`;
    for (; o; ) {
      const l = o.ec;
      if (l) {
        for (let B = 0; B < l.length; B++)
          if (l[B](t, a, c) === !1)
            return;
      }
      o = o.parent;
    }
    if (r) {
      ki(), oh(r, null, 10, [
        t,
        a,
        c
      ]), Ri();
      return;
    }
  }
  L5(t, A, s, n, i);
}
function L5(t, e, A, n = !0, s = !1) {
  if (s)
    throw t;
  console.error(t);
}
const mn = [];
let Er = -1;
const tl = [];
let Io = null, kc = 0;
const F3 = /* @__PURE__ */ Promise.resolve();
let Eu = null;
function Yn(t) {
  const e = Eu || F3;
  return t ? e.then(this ? t.bind(this) : t) : e;
}
function S5(t) {
  let e = Er + 1, A = mn.length;
  for (; e < A; ) {
    const n = e + A >>> 1, s = mn[n], r = dg(s);
    r < t || r === t && s.flags & 2 ? e = n + 1 : A = n;
  }
  return e;
}
function pM(t) {
  if (!(t.flags & 1)) {
    const e = dg(t), A = mn[mn.length - 1];
    !A || // fast path when the job id is larger than the tail
    !(t.flags & 2) && e >= dg(A) ? mn.push(t) : mn.splice(S5(e), 0, t), t.flags |= 1, N3();
  }
}
function N3() {
  Eu || (Eu = F3.then(x3));
}
function T5(t) {
  Ve(t) ? tl.push(...t) : Io && t.id === -1 ? Io.splice(kc + 1, 0, t) : t.flags & 1 || (tl.push(t), t.flags |= 1), N3();
}
function KY(t, e, A = Er + 1) {
  for (; A < mn.length; A++) {
    const n = mn[A];
    if (n && n.flags & 2) {
      if (t && n.id !== t.uid)
        continue;
      mn.splice(A, 1), A--, n.flags & 4 && (n.flags &= -2), n(), n.flags & 4 || (n.flags &= -2);
    }
  }
}
function D3(t) {
  if (tl.length) {
    const e = [...new Set(tl)].sort(
      (A, n) => dg(A) - dg(n)
    );
    if (tl.length = 0, Io) {
      Io.push(...e);
      return;
    }
    for (Io = e, kc = 0; kc < Io.length; kc++) {
      const A = Io[kc];
      A.flags & 4 && (A.flags &= -2), A.flags & 8 || A(), A.flags &= -2;
    }
    Io = null, kc = 0;
  }
}
const dg = (t) => t.id == null ? t.flags & 2 ? -1 : 1 / 0 : t.id;
function x3(t) {
  try {
    for (Er = 0; Er < mn.length; Er++) {
      const e = mn[Er];
      e && !(e.flags & 8) && (e.flags & 4 && (e.flags &= -2), oh(
        e,
        e.i,
        e.i ? 15 : 14
      ), e.flags & 4 || (e.flags &= -2));
    }
  } finally {
    for (; Er < mn.length; Er++) {
      const e = mn[Er];
      e && (e.flags &= -2);
    }
    Er = -1, mn.length = 0, D3(), Eu = null, (mn.length || tl.length) && x3();
  }
}
let VA = null, G3 = null;
function Mu(t) {
  const e = VA;
  return VA = t, G3 = t && t.type.__scopeId || null, e;
}
function Ur(t, e = VA, A) {
  if (!e || t._n)
    return t;
  const n = (...s) => {
    n._d && Yu(-1);
    const r = Mu(e);
    let i;
    try {
      i = t(...s);
    } finally {
      Mu(r), n._d && Yu(1);
    }
    return i;
  };
  return n._n = !0, n._c = !0, n._d = !0, n;
}
function Go(t, e) {
  if (VA === null)
    return t;
  const A = Iw(VA), n = t.dirs || (t.dirs = []);
  for (let s = 0; s < e.length; s++) {
    let [r, i, o, a = kt] = e[s];
    r && (et(r) && (r = {
      mounted: r,
      updated: r
    }), r.deep && Yi(i), n.push({
      dir: r,
      instance: A,
      value: i,
      oldValue: void 0,
      arg: o,
      modifiers: a
    }));
  }
  return t;
}
function Qa(t, e, A, n) {
  const s = t.dirs, r = e && e.dirs;
  for (let i = 0; i < s.length; i++) {
    const o = s[i];
    r && (o.oldValue = r[i].value);
    let a = o.dir[n];
    a && (ki(), rr(a, A, 8, [
      t.el,
      o,
      t,
      e
    ]), Ri());
  }
}
function J5(t, e) {
  if (nn) {
    let A = nn.provides;
    const n = nn.parent && nn.parent.provides;
    n === A && (A = nn.provides = Object.create(n)), A[t] = e;
  }
}
function L0(t, e, A = !1) {
  const n = bn();
  if (n || nl) {
    let s = nl ? nl._context.provides : n ? n.parent == null || n.ce ? n.vnode.appContext && n.vnode.appContext.provides : n.parent.provides : void 0;
    if (s && t in s)
      return s[t];
    if (arguments.length > 1)
      return A && et(e) ? e.call(n && n.proxy) : e;
  }
}
const W5 = /* @__PURE__ */ Symbol.for("v-scx"), O5 = () => L0(W5);
function P5(t, e) {
  return mM(t, null, e);
}
function CA(t, e, A) {
  return mM(t, e, A);
}
function mM(t, e, A = kt) {
  const { immediate: n, deep: s, flush: r, once: i } = A, o = sA({}, A), a = e && n || !e && r !== "post";
  let c;
  if (Ig) {
    if (r === "sync") {
      const h = O5();
      c = h.__watcherHandles || (h.__watcherHandles = []);
    } else if (!a) {
      const h = () => {
      };
      return h.stop = zr, h.resume = zr, h.pause = zr, h;
    }
  }
  const l = nn;
  o.call = (h, u, d) => rr(h, l, u, d);
  let B = !1;
  r === "post" ? o.scheduler = (h) => {
    Mn(h, l && l.suspense);
  } : r !== "sync" && (B = !0, o.scheduler = (h, u) => {
    u ? h() : pM(h);
  }), o.augmentJob = (h) => {
    e && (h.flags |= 4), B && (h.flags |= 2, l && (h.id = l.uid, h.i = l));
  };
  const g = R5(t, e, o);
  return Ig && (c ? c.push(g) : a && g()), g;
}
function K5(t, e, A) {
  const n = this.proxy, s = rA(t) ? t.includes(".") ? z3(n, t) : () => n[t] : t.bind(n, n);
  let r;
  et(e) ? r = e : (r = e.handler, A = e);
  const i = ah(this), o = mM(s, r.bind(n), A);
  return i(), o;
}
function z3(t, e) {
  const A = e.split(".");
  return () => {
    let n = t;
    for (let s = 0; s < A.length && n; s++)
      n = n[A[s]];
    return n;
  };
}
const U3 = /* @__PURE__ */ Symbol("_vte"), b3 = (t) => t.__isTeleport, GB = (t) => t && (t.disabled || t.disabled === ""), VY = (t) => t && (t.defer || t.defer === ""), XY = (t) => typeof SVGElement < "u" && t instanceof SVGElement, ZY = (t) => typeof MathMLElement == "function" && t instanceof MathMLElement, BC = (t, e) => {
  const A = t && t.to;
  return rA(A) ? e ? e(A) : null : A;
}, v3 = {
  name: "Teleport",
  __isTeleport: !0,
  process(t, e, A, n, s, r, i, o, a, c) {
    const {
      mc: l,
      pc: B,
      pbc: g,
      o: { insert: h, querySelector: u, createText: d, createComment: w }
    } = c, Q = GB(e.props);
    let { shapeFlag: p, children: M, dynamicChildren: I } = e;
    if (t == null) {
      const N = e.el = d(""), m = e.anchor = d("");
      h(N, A, n), h(m, A, n);
      const E = (Y, U) => {
        p & 16 && l(
          M,
          Y,
          U,
          s,
          r,
          i,
          o,
          a
        );
      }, G = () => {
        const Y = e.target = BC(e.props, u), U = H3(Y, e, d, h);
        Y && (i !== "svg" && XY(Y) ? i = "svg" : i !== "mathml" && ZY(Y) && (i = "mathml"), s && s.isCE && (s.ce._teleportTargets || (s.ce._teleportTargets = /* @__PURE__ */ new Set())).add(Y), Q || (E(Y, U), S0(e, !1)));
      };
      Q && (E(A, m), S0(e, !0)), VY(e.props) ? (e.el.__isMounted = !1, Mn(() => {
        G(), delete e.el.__isMounted;
      }, r)) : G();
    } else {
      if (VY(e.props) && t.el.__isMounted === !1) {
        Mn(() => {
          v3.process(
            t,
            e,
            A,
            n,
            s,
            r,
            i,
            o,
            a,
            c
          );
        }, r);
        return;
      }
      e.el = t.el, e.targetStart = t.targetStart;
      const N = e.anchor = t.anchor, m = e.target = t.target, E = e.targetAnchor = t.targetAnchor, G = GB(t.props), Y = G ? A : m, U = G ? N : E;
      if (i === "svg" || XY(m) ? i = "svg" : (i === "mathml" || ZY(m)) && (i = "mathml"), I ? (g(
        t.dynamicChildren,
        I,
        Y,
        s,
        r,
        i,
        o
      ), DM(t, e, !0)) : a || B(
        t,
        e,
        Y,
        U,
        s,
        r,
        i,
        o,
        !1
      ), Q)
        G ? e.props && t.props && e.props.to !== t.props.to && (e.props.to = t.props.to) : Vh(
          e,
          A,
          N,
          c,
          1
        );
      else if ((e.props && e.props.to) !== (t.props && t.props.to)) {
        const v = e.target = BC(
          e.props,
          u
        );
        v && Vh(
          e,
          v,
          null,
          c,
          0
        );
      } else G && Vh(
        e,
        m,
        E,
        c,
        1
      );
      S0(e, Q);
    }
  },
  remove(t, e, A, { um: n, o: { remove: s } }, r) {
    const {
      shapeFlag: i,
      children: o,
      anchor: a,
      targetStart: c,
      targetAnchor: l,
      target: B,
      props: g
    } = t;
    if (B && (s(c), s(l)), r && s(a), i & 16) {
      const h = r || !GB(g);
      for (let u = 0; u < o.length; u++) {
        const d = o[u];
        n(
          d,
          e,
          A,
          h,
          !!d.dynamicChildren
        );
      }
    }
  },
  move: Vh,
  hydrate: V5
};
function Vh(t, e, A, { o: { insert: n }, m: s }, r = 2) {
  r === 0 && n(t.targetAnchor, e, A);
  const { el: i, anchor: o, shapeFlag: a, children: c, props: l } = t, B = r === 2;
  if (B && n(i, e, A), (!B || GB(l)) && a & 16)
    for (let g = 0; g < c.length; g++)
      s(
        c[g],
        e,
        A,
        2
      );
  B && n(o, e, A);
}
function V5(t, e, A, n, s, r, {
  o: { nextSibling: i, parentNode: o, querySelector: a, insert: c, createText: l }
}, B) {
  function g(d, w, Q, p) {
    w.anchor = B(
      i(d),
      w,
      o(d),
      A,
      n,
      s,
      r
    ), w.targetStart = Q, w.targetAnchor = p;
  }
  const h = e.target = BC(
    e.props,
    a
  ), u = GB(e.props);
  if (h) {
    const d = h._lpa || h.firstChild;
    if (e.shapeFlag & 16)
      if (u)
        g(
          t,
          e,
          d,
          d && i(d)
        );
      else {
        e.anchor = i(t);
        let w = d;
        for (; w; ) {
          if (w && w.nodeType === 8) {
            if (w.data === "teleport start anchor")
              e.targetStart = w;
            else if (w.data === "teleport anchor") {
              e.targetAnchor = w, h._lpa = e.targetAnchor && i(e.targetAnchor);
              break;
            }
          }
          w = i(w);
        }
        e.targetAnchor || H3(h, e, l, c), B(
          d && i(d),
          e,
          h,
          A,
          n,
          s,
          r
        );
      }
    S0(e, u);
  } else u && e.shapeFlag & 16 && g(t, e, t, i(t));
  return e.anchor && i(e.anchor);
}
const j3 = v3;
function S0(t, e) {
  const A = t.ctx;
  if (A && A.ut) {
    let n, s;
    for (e ? (n = t.el, s = t.anchor) : (n = t.targetStart, s = t.targetAnchor); n && n !== s; )
      n.nodeType === 1 && n.setAttribute("data-v-owner", A.uid), n = n.nextSibling;
    A.ut();
  }
}
function H3(t, e, A, n) {
  const s = e.targetStart = A(""), r = e.targetAnchor = A("");
  return s[U3] = r, t && (n(s, t), n(r, t)), r;
}
const Ei = /* @__PURE__ */ Symbol("_leaveCb"), Xh = /* @__PURE__ */ Symbol("_enterCb");
function X5() {
  const t = {
    isMounted: !1,
    isLeaving: !1,
    isUnmounting: !1,
    leavingVNodes: /* @__PURE__ */ new Map()
  };
  return Xr(() => {
    t.isMounted = !0;
  }), Zr(() => {
    t.isUnmounting = !0;
  }), t;
}
const Is = [Function, Array], k3 = {
  mode: String,
  appear: Boolean,
  persisted: Boolean,
  // enter
  onBeforeEnter: Is,
  onEnter: Is,
  onAfterEnter: Is,
  onEnterCancelled: Is,
  // leave
  onBeforeLeave: Is,
  onLeave: Is,
  onAfterLeave: Is,
  onLeaveCancelled: Is,
  // appear
  onBeforeAppear: Is,
  onAppear: Is,
  onAfterAppear: Is,
  onAppearCancelled: Is
}, R3 = (t) => {
  const e = t.subTree;
  return e.component ? R3(e.component) : e;
}, Z5 = {
  name: "BaseTransition",
  props: k3,
  setup(t, { slots: e }) {
    const A = bn(), n = X5();
    return () => {
      const s = e.default && T3(e.default(), !0);
      if (!s || !s.length)
        return;
      const r = L3(s), i = /* @__PURE__ */ Gt(t), { mode: o } = i;
      if (n.isLeaving)
        return _f(r);
      const a = qY(r);
      if (!a)
        return _f(r);
      let c = gC(
        a,
        i,
        n,
        A,
        // #11061, ensure enterHooks is fresh after clone
        (B) => c = B
      );
      a.type !== An && wg(a, c);
      let l = A.subTree && qY(A.subTree);
      if (l && l.type !== An && !Ga(l, a) && R3(A).type !== An) {
        let B = gC(
          l,
          i,
          n,
          A
        );
        if (wg(l, B), o === "out-in" && a.type !== An)
          return n.isLeaving = !0, B.afterLeave = () => {
            n.isLeaving = !1, A.job.flags & 8 || A.update(), delete B.afterLeave, l = void 0;
          }, _f(r);
        o === "in-out" && a.type !== An ? B.delayLeave = (g, h, u) => {
          const d = S3(
            n,
            l
          );
          d[String(l.key)] = l, g[Ei] = () => {
            h(), g[Ei] = void 0, delete c.delayedLeave, l = void 0;
          }, c.delayedLeave = () => {
            u(), delete c.delayedLeave, l = void 0;
          };
        } : l = void 0;
      } else l && (l = void 0);
      return r;
    };
  }
};
function L3(t) {
  let e = t[0];
  if (t.length > 1) {
    for (const A of t)
      if (A.type !== An) {
        e = A;
        break;
      }
  }
  return e;
}
const q5 = Z5;
function S3(t, e) {
  const { leavingVNodes: A } = t;
  let n = A.get(e.type);
  return n || (n = /* @__PURE__ */ Object.create(null), A.set(e.type, n)), n;
}
function gC(t, e, A, n, s) {
  const {
    appear: r,
    mode: i,
    persisted: o = !1,
    onBeforeEnter: a,
    onEnter: c,
    onAfterEnter: l,
    onEnterCancelled: B,
    onBeforeLeave: g,
    onLeave: h,
    onAfterLeave: u,
    onLeaveCancelled: d,
    onBeforeAppear: w,
    onAppear: Q,
    onAfterAppear: p,
    onAppearCancelled: M
  } = e, I = String(t.key), N = S3(A, t), m = (Y, U) => {
    Y && rr(
      Y,
      n,
      9,
      U
    );
  }, E = (Y, U) => {
    const v = U[1];
    m(Y, U), Ve(Y) ? Y.every((b) => b.length <= 1) && v() : Y.length <= 1 && v();
  }, G = {
    mode: i,
    persisted: o,
    beforeEnter(Y) {
      let U = a;
      if (!A.isMounted)
        if (r)
          U = w || a;
        else
          return;
      Y[Ei] && Y[Ei](
        !0
        /* cancelled */
      );
      const v = N[I];
      v && Ga(t, v) && v.el[Ei] && v.el[Ei](), m(U, [Y]);
    },
    enter(Y) {
      let U = c, v = l, b = B;
      if (!A.isMounted)
        if (r)
          U = Q || c, v = p || l, b = M || B;
        else
          return;
      let W = !1;
      const q = Y[Xh] = (ne) => {
        W || (W = !0, ne ? m(b, [Y]) : m(v, [Y]), G.delayedLeave && G.delayedLeave(), Y[Xh] = void 0);
      };
      U ? E(U, [Y, q]) : q();
    },
    leave(Y, U) {
      const v = String(t.key);
      if (Y[Xh] && Y[Xh](
        !0
        /* cancelled */
      ), A.isUnmounting)
        return U();
      m(g, [Y]);
      let b = !1;
      const W = Y[Ei] = (q) => {
        b || (b = !0, U(), q ? m(d, [Y]) : m(u, [Y]), Y[Ei] = void 0, N[v] === t && delete N[v]);
      };
      N[v] = t, h ? E(h, [Y, W]) : W();
    },
    clone(Y) {
      const U = gC(
        Y,
        e,
        A,
        n,
        s
      );
      return s && s(U), U;
    }
  };
  return G;
}
function _f(t) {
  if (uw(t))
    return t = Po(t), t.children = null, t;
}
function qY(t) {
  if (!uw(t))
    return b3(t.type) && t.children ? L3(t.children) : t;
  if (t.component)
    return t.component.subTree;
  const { shapeFlag: e, children: A } = t;
  if (A) {
    if (e & 16)
      return A[0];
    if (e & 32 && et(A.default))
      return A.default();
  }
}
function wg(t, e) {
  t.shapeFlag & 6 && t.component ? (t.transition = e, wg(t.component.subTree, e)) : t.shapeFlag & 128 ? (t.ssContent.transition = e.clone(t.ssContent), t.ssFallback.transition = e.clone(t.ssFallback)) : t.transition = e;
}
function T3(t, e = !1, A) {
  let n = [], s = 0;
  for (let r = 0; r < t.length; r++) {
    let i = t[r];
    const o = A == null ? i.key : String(A) + String(i.key != null ? i.key : r);
    i.type === ft ? (i.patchFlag & 128 && s++, n = n.concat(
      T3(i.children, e, o)
    )) : (e || i.type !== An) && n.push(o != null ? Po(i, { key: o }) : i);
  }
  if (s > 1)
    for (let r = 0; r < n.length; r++)
      n[r].patchFlag = -2;
  return n;
}
// @__NO_SIDE_EFFECTS__
function Un(t, e) {
  return et(t) ? (
    // #8236: extend call and options.name access are considered side-effects
    // by Rollup, so we have to wrap it in a pure-annotated IIFE.
    sA({ name: t.name }, e, { setup: t })
  ) : t;
}
function J3(t) {
  t.ids = [t.ids[0] + t.ids[2]++ + "-", 0, 0];
}
const pu = /* @__PURE__ */ new WeakMap();
function zB(t, e, A, n, s = !1) {
  if (Ve(t)) {
    t.forEach(
      (u, d) => zB(
        u,
        e && (Ve(e) ? e[d] : e),
        A,
        n,
        s
      )
    );
    return;
  }
  if (Al(n) && !s) {
    n.shapeFlag & 512 && n.type.__asyncResolved && n.component.subTree.component && zB(t, e, A, n.component.subTree);
    return;
  }
  const r = n.shapeFlag & 4 ? Iw(n.component) : n.el, i = s ? null : r, { i: o, r: a } = t, c = e && e.r, l = o.refs === kt ? o.refs = {} : o.refs, B = o.setupState, g = /* @__PURE__ */ Gt(B), h = B === kt ? A3 : (u) => zt(g, u);
  if (c != null && c !== a) {
    if (_Y(e), rA(c))
      l[c] = null, h(c) && (B[c] = null);
    else if (/* @__PURE__ */ rn(c)) {
      c.value = null;
      const u = e;
      u.k && (l[u.k] = null);
    }
  }
  if (et(a))
    oh(a, o, 12, [i, l]);
  else {
    const u = rA(a), d = /* @__PURE__ */ rn(a);
    if (u || d) {
      const w = () => {
        if (t.f) {
          const Q = u ? h(a) ? B[a] : l[a] : a.value;
          if (s)
            Ve(Q) && hM(Q, r);
          else if (Ve(Q))
            Q.includes(r) || Q.push(r);
          else if (u)
            l[a] = [r], h(a) && (B[a] = l[a]);
          else {
            const p = [r];
            a.value = p, t.k && (l[t.k] = p);
          }
        } else u ? (l[a] = i, h(a) && (B[a] = i)) : d && (a.value = i, t.k && (l[t.k] = i));
      };
      if (i) {
        const Q = () => {
          w(), pu.delete(t);
        };
        Q.id = -1, pu.set(t, Q), Mn(Q, A);
      } else
        _Y(t), w();
    }
  }
}
function _Y(t) {
  const e = pu.get(t);
  e && (e.flags |= 8, pu.delete(t));
}
lw().requestIdleCallback;
lw().cancelIdleCallback;
const Al = (t) => !!t.type.__asyncLoader, uw = (t) => t.type.__isKeepAlive;
function _5(t, e) {
  W3(t, "a", e);
}
function $5(t, e) {
  W3(t, "da", e);
}
function W3(t, e, A = nn) {
  const n = t.__wdc || (t.__wdc = () => {
    let s = A;
    for (; s; ) {
      if (s.isDeactivated)
        return;
      s = s.parent;
    }
    return t();
  });
  if (dw(e, n, A), A) {
    let s = A.parent;
    for (; s && s.parent; )
      uw(s.parent.vnode) && ek(n, e, A, s), s = s.parent;
  }
}
function ek(t, e, A, n) {
  const s = dw(
    e,
    t,
    n,
    !0
    /* prepend */
  );
  ww(() => {
    hM(n[e], s);
  }, A);
}
function dw(t, e, A = nn, n = !1) {
  if (A) {
    const s = A[t] || (A[t] = []), r = e.__weh || (e.__weh = (...i) => {
      ki();
      const o = ah(A), a = rr(e, A, t, i);
      return o(), Ri(), a;
    });
    return n ? s.unshift(r) : s.push(r), r;
  }
}
const qi = (t) => (e, A = nn) => {
  (!Ig || t === "sp") && dw(t, (...n) => e(...n), A);
}, tk = qi("bm"), Xr = qi("m"), Ak = qi(
  "bu"
), nk = qi("u"), Zr = qi(
  "bum"
), ww = qi("um"), sk = qi(
  "sp"
), rk = qi("rtg"), ik = qi("rtc");
function ok(t, e = nn) {
  dw("ec", t, e);
}
const YM = "components", ak = "directives";
function tr(t, e) {
  return yM(YM, t, !0, e) || t;
}
const O3 = /* @__PURE__ */ Symbol.for("v-ndc");
function ck(t) {
  return rA(t) ? yM(YM, t, !1) || t : t || O3;
}
function lk(t) {
  return yM(ak, t);
}
function yM(t, e, A = !0, n = !1) {
  const s = VA || nn;
  if (s) {
    const r = s.type;
    if (t === YM) {
      const o = Xk(
        r,
        !1
      );
      if (o && (o === e || o === Nn(e) || o === cw(Nn(e))))
        return r;
    }
    const i = (
      // local registration
      // check instance[type] first which is resolved for options API
      $Y(s[t] || r[t], e) || // global registration
      $Y(s.appContext[t], e)
    );
    return !i && n ? r : i;
  }
}
function $Y(t, e) {
  return t && (t[e] || t[Nn(e)] || t[cw(Nn(e))]);
}
function Ns(t, e, A, n) {
  let s;
  const r = A, i = Ve(t);
  if (i || rA(t)) {
    const o = i && /* @__PURE__ */ ka(t);
    let a = !1, c = !1;
    o && (a = !/* @__PURE__ */ Us(t), c = /* @__PURE__ */ Li(t), t = gw(t)), s = new Array(t.length);
    for (let l = 0, B = t.length; l < B; l++)
      s[l] = e(
        a ? c ? wl(sr(t[l])) : sr(t[l]) : t[l],
        l,
        void 0,
        r
      );
  } else if (typeof t == "number") {
    s = new Array(t);
    for (let o = 0; o < t; o++)
      s[o] = e(o + 1, o, void 0, r);
  } else if (Pt(t))
    if (t[Symbol.iterator])
      s = Array.from(
        t,
        (o, a) => e(o, a, void 0, r)
      );
    else {
      const o = Object.keys(t);
      s = new Array(o.length);
      for (let a = 0, c = o.length; a < c; a++) {
        const l = o[a];
        s[a] = e(t[l], l, a, r);
      }
    }
  else
    s = [];
  return s;
}
function Ni(t, e, A = {}, n, s) {
  if (VA.ce || VA.parent && Al(VA.parent) && VA.parent.ce) {
    const c = Object.keys(A).length > 0;
    return e !== "default" && (A.name = e), ee(), Lo(
      ft,
      null,
      [rt("slot", A, n && n())],
      c ? -2 : 64
    );
  }
  let r = t[e];
  r && r._c && (r._d = !1), ee();
  const i = r && P3(r(A)), o = A.key || // slot content array of a dynamic conditional slot may have a branch
  // key attached in the `createSlots` helper, respect that
  i && i.key, a = Lo(
    ft,
    {
      key: (o && !Zi(o) ? o : `_${e}`) + // #7256 force differentiate fallback content from actual content
      (!i && n ? "_fb" : "")
    },
    i || (n ? n() : []),
    i && t._ === 1 ? 64 : -2
  );
  return a.scopeId && (a.slotScopeIds = [a.scopeId + "-s"]), r && r._c && (r._d = !0), a;
}
function P3(t) {
  return t.some((e) => Qg(e) ? !(e.type === An || e.type === ft && !P3(e.children)) : !0) ? t : null;
}
const hC = (t) => t ? lx(t) ? Iw(t) : hC(t.parent) : null, UB = (
  // Move PURE marker to new line to workaround compiler discarding it
  // due to type annotation
  /* @__PURE__ */ sA(/* @__PURE__ */ Object.create(null), {
    $: (t) => t,
    $el: (t) => t.vnode.el,
    $data: (t) => t.data,
    $props: (t) => t.props,
    $attrs: (t) => t.attrs,
    $slots: (t) => t.slots,
    $refs: (t) => t.refs,
    $parent: (t) => hC(t.parent),
    $root: (t) => hC(t.root),
    $host: (t) => t.ce,
    $emit: (t) => t.emit,
    $options: (t) => V3(t),
    $forceUpdate: (t) => t.f || (t.f = () => {
      pM(t.update);
    }),
    $nextTick: (t) => t.n || (t.n = Yn.bind(t.proxy)),
    $watch: (t) => K5.bind(t)
  })
), $f = (t, e) => t !== kt && !t.__isScriptSetup && zt(t, e), Bk = {
  get({ _: t }, e) {
    if (e === "__v_skip")
      return !0;
    const { ctx: A, setupState: n, data: s, props: r, accessCache: i, type: o, appContext: a } = t;
    if (e[0] !== "$") {
      const g = i[e];
      if (g !== void 0)
        switch (g) {
          case 1:
            return n[e];
          case 2:
            return s[e];
          case 4:
            return A[e];
          case 3:
            return r[e];
        }
      else {
        if ($f(n, e))
          return i[e] = 1, n[e];
        if (s !== kt && zt(s, e))
          return i[e] = 2, s[e];
        if (zt(r, e))
          return i[e] = 3, r[e];
        if (A !== kt && zt(A, e))
          return i[e] = 4, A[e];
        uC && (i[e] = 0);
      }
    }
    const c = UB[e];
    let l, B;
    if (c)
      return e === "$attrs" && tn(t.attrs, "get", ""), c(t);
    if (
      // css module (injected by vue-loader)
      (l = o.__cssModules) && (l = l[e])
    )
      return l;
    if (A !== kt && zt(A, e))
      return i[e] = 4, A[e];
    if (
      // global properties
      B = a.config.globalProperties, zt(B, e)
    )
      return B[e];
  },
  set({ _: t }, e, A) {
    const { data: n, setupState: s, ctx: r } = t;
    return $f(s, e) ? (s[e] = A, !0) : n !== kt && zt(n, e) ? (n[e] = A, !0) : zt(t.props, e) || e[0] === "$" && e.slice(1) in t ? !1 : (r[e] = A, !0);
  },
  has({
    _: { data: t, setupState: e, accessCache: A, ctx: n, appContext: s, props: r, type: i }
  }, o) {
    let a;
    return !!(A[o] || t !== kt && o[0] !== "$" && zt(t, o) || $f(e, o) || zt(r, o) || zt(n, o) || zt(UB, o) || zt(s.config.globalProperties, o) || (a = i.__cssModules) && a[o]);
  },
  defineProperty(t, e, A) {
    return A.get != null ? t._.accessCache[e] = 0 : zt(A, "value") && this.set(t, e, A.value, null), Reflect.defineProperty(t, e, A);
  }
};
function gk() {
  return hk().slots;
}
function hk(t) {
  const e = bn();
  return e.setupContext || (e.setupContext = gx(e));
}
function e2(t) {
  return Ve(t) ? t.reduce(
    (e, A) => (e[A] = null, e),
    {}
  ) : t;
}
let uC = !0;
function uk(t) {
  const e = V3(t), A = t.proxy, n = t.ctx;
  uC = !1, e.beforeCreate && t2(e.beforeCreate, t, "bc");
  const {
    // state
    data: s,
    computed: r,
    methods: i,
    watch: o,
    provide: a,
    inject: c,
    // lifecycle
    created: l,
    beforeMount: B,
    mounted: g,
    beforeUpdate: h,
    updated: u,
    activated: d,
    deactivated: w,
    beforeDestroy: Q,
    beforeUnmount: p,
    destroyed: M,
    unmounted: I,
    render: N,
    renderTracked: m,
    renderTriggered: E,
    errorCaptured: G,
    serverPrefetch: Y,
    // public API
    expose: U,
    inheritAttrs: v,
    // assets
    components: b,
    directives: W,
    filters: q
  } = e;
  if (c && dk(c, n, null), i)
    for (const se in i) {
      const te = i[se];
      et(te) && (n[se] = te.bind(A));
    }
  if (s) {
    const se = s.call(A, A);
    Pt(se) && (t.data = /* @__PURE__ */ CM(se));
  }
  if (uC = !0, r)
    for (const se in r) {
      const te = r[se], be = et(te) ? te.bind(A, A) : et(te.get) ? te.get.bind(A, A) : zr, Oe = !et(te) && et(te.set) ? te.set.bind(A) : zr, ke = Fe({
        get: be,
        set: Oe
      });
      Object.defineProperty(n, se, {
        enumerable: !0,
        configurable: !0,
        get: () => ke.value,
        set: (Se) => ke.value = Se
      });
    }
  if (o)
    for (const se in o)
      K3(o[se], n, A, se);
  if (a) {
    const se = et(a) ? a.call(A) : a;
    Reflect.ownKeys(se).forEach((te) => {
      J5(te, se[te]);
    });
  }
  l && t2(l, t, "c");
  function V(se, te) {
    Ve(te) ? te.forEach((be) => se(be.bind(A))) : te && se(te.bind(A));
  }
  if (V(tk, B), V(Xr, g), V(Ak, h), V(nk, u), V(_5, d), V($5, w), V(ok, G), V(ik, m), V(rk, E), V(Zr, p), V(ww, I), V(sk, Y), Ve(U))
    if (U.length) {
      const se = t.exposed || (t.exposed = {});
      U.forEach((te) => {
        Object.defineProperty(se, te, {
          get: () => A[te],
          set: (be) => A[te] = be,
          enumerable: !0
        });
      });
    } else t.exposed || (t.exposed = {});
  N && t.render === zr && (t.render = N), v != null && (t.inheritAttrs = v), b && (t.components = b), W && (t.directives = W), Y && J3(t);
}
function dk(t, e, A = zr) {
  Ve(t) && (t = dC(t));
  for (const n in t) {
    const s = t[n];
    let r;
    Pt(s) ? "default" in s ? r = L0(
      s.from || n,
      s.default,
      !0
    ) : r = L0(s.from || n) : r = L0(s), /* @__PURE__ */ rn(r) ? Object.defineProperty(e, n, {
      enumerable: !0,
      configurable: !0,
      get: () => r.value,
      set: (i) => r.value = i
    }) : e[n] = r;
  }
}
function t2(t, e, A) {
  rr(
    Ve(t) ? t.map((n) => n.bind(e.proxy)) : t.bind(e.proxy),
    e,
    A
  );
}
function K3(t, e, A, n) {
  let s = n.includes(".") ? z3(A, n) : () => A[n];
  if (rA(t)) {
    const r = e[t];
    et(r) && CA(s, r);
  } else if (et(t))
    CA(s, t.bind(A));
  else if (Pt(t))
    if (Ve(t))
      t.forEach((r) => K3(r, e, A, n));
    else {
      const r = et(t.handler) ? t.handler.bind(A) : e[t.handler];
      et(r) && CA(s, r, t);
    }
}
function V3(t) {
  const e = t.type, { mixins: A, extends: n } = e, {
    mixins: s,
    optionsCache: r,
    config: { optionMergeStrategies: i }
  } = t.appContext, o = r.get(e);
  let a;
  return o ? a = o : !s.length && !A && !n ? a = e : (a = {}, s.length && s.forEach(
    (c) => mu(a, c, i, !0)
  ), mu(a, e, i)), Pt(e) && r.set(e, a), a;
}
function mu(t, e, A, n = !1) {
  const { mixins: s, extends: r } = e;
  r && mu(t, r, A, !0), s && s.forEach(
    (i) => mu(t, i, A, !0)
  );
  for (const i in e)
    if (!(n && i === "expose")) {
      const o = wk[i] || A && A[i];
      t[i] = o ? o(t[i], e[i]) : e[i];
    }
  return t;
}
const wk = {
  data: A2,
  props: n2,
  emits: n2,
  // objects
  methods: wB,
  computed: wB,
  // lifecycle
  beforeCreate: Qn,
  created: Qn,
  beforeMount: Qn,
  mounted: Qn,
  beforeUpdate: Qn,
  updated: Qn,
  beforeDestroy: Qn,
  beforeUnmount: Qn,
  destroyed: Qn,
  unmounted: Qn,
  activated: Qn,
  deactivated: Qn,
  errorCaptured: Qn,
  serverPrefetch: Qn,
  // assets
  components: wB,
  directives: wB,
  // watch
  watch: Qk,
  // provide / inject
  provide: A2,
  inject: fk
};
function A2(t, e) {
  return e ? t ? function() {
    return sA(
      et(t) ? t.call(this, this) : t,
      et(e) ? e.call(this, this) : e
    );
  } : e : t;
}
function fk(t, e) {
  return wB(dC(t), dC(e));
}
function dC(t) {
  if (Ve(t)) {
    const e = {};
    for (let A = 0; A < t.length; A++)
      e[t[A]] = t[A];
    return e;
  }
  return t;
}
function Qn(t, e) {
  return t ? [...new Set([].concat(t, e))] : e;
}
function wB(t, e) {
  return t ? sA(/* @__PURE__ */ Object.create(null), t, e) : e;
}
function n2(t, e) {
  return t ? Ve(t) && Ve(e) ? [.../* @__PURE__ */ new Set([...t, ...e])] : sA(
    /* @__PURE__ */ Object.create(null),
    e2(t),
    e2(e ?? {})
  ) : e;
}
function Qk(t, e) {
  if (!t) return e;
  if (!e) return t;
  const A = sA(/* @__PURE__ */ Object.create(null), t);
  for (const n in e)
    A[n] = Qn(t[n], e[n]);
  return A;
}
function X3() {
  return {
    app: null,
    config: {
      isNativeTag: A3,
      performance: !1,
      globalProperties: {},
      optionMergeStrategies: {},
      errorHandler: void 0,
      warnHandler: void 0,
      compilerOptions: {}
    },
    mixins: [],
    components: {},
    directives: {},
    provides: /* @__PURE__ */ Object.create(null),
    optionsCache: /* @__PURE__ */ new WeakMap(),
    propsCache: /* @__PURE__ */ new WeakMap(),
    emitsCache: /* @__PURE__ */ new WeakMap()
  };
}
let Ik = 0;
function Ck(t, e) {
  return function(n, s = null) {
    et(n) || (n = sA({}, n)), s != null && !Pt(s) && (s = null);
    const r = X3(), i = /* @__PURE__ */ new WeakSet(), o = [];
    let a = !1;
    const c = r.app = {
      _uid: Ik++,
      _component: n,
      _props: s,
      _container: null,
      _context: r,
      _instance: null,
      version: qk,
      get config() {
        return r.config;
      },
      set config(l) {
      },
      use(l, ...B) {
        return i.has(l) || (l && et(l.install) ? (i.add(l), l.install(c, ...B)) : et(l) && (i.add(l), l(c, ...B))), c;
      },
      mixin(l) {
        return r.mixins.includes(l) || r.mixins.push(l), c;
      },
      component(l, B) {
        return B ? (r.components[l] = B, c) : r.components[l];
      },
      directive(l, B) {
        return B ? (r.directives[l] = B, c) : r.directives[l];
      },
      mount(l, B, g) {
        if (!a) {
          const h = c._ceVNode || rt(n, s);
          return h.appContext = r, g === !0 ? g = "svg" : g === !1 && (g = void 0), t(h, l, g), a = !0, c._container = l, l.__vue_app__ = c, Iw(h.component);
        }
      },
      onUnmount(l) {
        o.push(l);
      },
      unmount() {
        a && (rr(
          o,
          c._instance,
          16
        ), t(null, c._container), delete c._container.__vue_app__);
      },
      provide(l, B) {
        return r.provides[l] = B, c;
      },
      runWithContext(l) {
        const B = nl;
        nl = c;
        try {
          return l();
        } finally {
          nl = B;
        }
      }
    };
    return c;
  };
}
let nl = null;
const Ek = (t, e) => e === "modelValue" || e === "model-value" ? t.modelModifiers : t[`${e}Modifiers`] || t[`${Nn(e)}Modifiers`] || t[`${is(e)}Modifiers`];
function Mk(t, e, ...A) {
  if (t.isUnmounted) return;
  const n = t.vnode.props || kt;
  let s = A;
  const r = e.startsWith("update:"), i = r && Ek(n, e.slice(7));
  i && (i.trim && (s = A.map((l) => rA(l) ? l.trim() : l)), i.number && (s = A.map(dM)));
  let o, a = n[o = Pf(e)] || // also try camelCase event handler (#2249)
  n[o = Pf(Nn(e))];
  !a && r && (a = n[o = Pf(is(e))]), a && rr(
    a,
    t,
    6,
    s
  );
  const c = n[o + "Once"];
  if (c) {
    if (!t.emitted)
      t.emitted = {};
    else if (t.emitted[o])
      return;
    t.emitted[o] = !0, rr(
      c,
      t,
      6,
      s
    );
  }
}
const pk = /* @__PURE__ */ new WeakMap();
function Z3(t, e, A = !1) {
  const n = A ? pk : e.emitsCache, s = n.get(t);
  if (s !== void 0)
    return s;
  const r = t.emits;
  let i = {}, o = !1;
  if (!et(t)) {
    const a = (c) => {
      const l = Z3(c, e, !0);
      l && (o = !0, sA(i, l));
    };
    !A && e.mixins.length && e.mixins.forEach(a), t.extends && a(t.extends), t.mixins && t.mixins.forEach(a);
  }
  return !r && !o ? (Pt(t) && n.set(t, null), null) : (Ve(r) ? r.forEach((a) => i[a] = null) : sA(i, r), Pt(t) && n.set(t, i), i);
}
function fw(t, e) {
  return !t || !rw(e) ? !1 : (e = e.slice(2).replace(/Once$/, ""), zt(t, e[0].toLowerCase() + e.slice(1)) || zt(t, is(e)) || zt(t, e));
}
function s2(t) {
  const {
    type: e,
    vnode: A,
    proxy: n,
    withProxy: s,
    propsOptions: [r],
    slots: i,
    attrs: o,
    emit: a,
    render: c,
    renderCache: l,
    props: B,
    data: g,
    setupState: h,
    ctx: u,
    inheritAttrs: d
  } = t, w = Mu(t);
  let Q, p;
  try {
    if (A.shapeFlag & 4) {
      const I = s || n, N = I;
      Q = Yr(
        c.call(
          N,
          I,
          l,
          B,
          h,
          g,
          u
        )
      ), p = o;
    } else {
      const I = e;
      Q = Yr(
        I.length > 1 ? I(
          B,
          { attrs: o, slots: i, emit: a }
        ) : I(
          B,
          null
        )
      ), p = e.props ? o : mk(o);
    }
  } catch (I) {
    bB.length = 0, hw(I, t, 1), Q = rt(An);
  }
  let M = Q;
  if (p && d !== !1) {
    const I = Object.keys(p), { shapeFlag: N } = M;
    I.length && N & 7 && (r && I.some(gM) && (p = Yk(
      p,
      r
    )), M = Po(M, p, !1, !0));
  }
  return A.dirs && (M = Po(M, null, !1, !0), M.dirs = M.dirs ? M.dirs.concat(A.dirs) : A.dirs), A.transition && wg(M, A.transition), Q = M, Mu(w), Q;
}
const mk = (t) => {
  let e;
  for (const A in t)
    (A === "class" || A === "style" || rw(A)) && ((e || (e = {}))[A] = t[A]);
  return e;
}, Yk = (t, e) => {
  const A = {};
  for (const n in t)
    (!gM(n) || !(n.slice(9) in e)) && (A[n] = t[n]);
  return A;
};
function yk(t, e, A) {
  const { props: n, children: s, component: r } = t, { props: i, children: o, patchFlag: a } = e, c = r.emitsOptions;
  if (e.dirs || e.transition)
    return !0;
  if (A && a >= 0) {
    if (a & 1024)
      return !0;
    if (a & 16)
      return n ? r2(n, i, c) : !!i;
    if (a & 8) {
      const l = e.dynamicProps;
      for (let B = 0; B < l.length; B++) {
        const g = l[B];
        if (i[g] !== n[g] && !fw(c, g))
          return !0;
      }
    }
  } else
    return (s || o) && (!o || !o.$stable) ? !0 : n === i ? !1 : n ? i ? r2(n, i, c) : !0 : !!i;
  return !1;
}
function r2(t, e, A) {
  const n = Object.keys(e);
  if (n.length !== Object.keys(t).length)
    return !0;
  for (let s = 0; s < n.length; s++) {
    const r = n[s];
    if (e[r] !== t[r] && !fw(A, r))
      return !0;
  }
  return !1;
}
function Fk({ vnode: t, parent: e }, A) {
  for (; e; ) {
    const n = e.subTree;
    if (n.suspense && n.suspense.activeBranch === t && (n.el = t.el), n === t)
      (t = e.vnode).el = A, e = e.parent;
    else
      break;
  }
}
const q3 = {}, _3 = () => Object.create(q3), $3 = (t) => Object.getPrototypeOf(t) === q3;
function Nk(t, e, A, n = !1) {
  const s = {}, r = _3();
  t.propsDefaults = /* @__PURE__ */ Object.create(null), ex(t, e, s, r);
  for (const i in t.propsOptions[0])
    i in s || (s[i] = void 0);
  A ? t.props = n ? s : /* @__PURE__ */ G5(s) : t.type.props ? t.props = s : t.props = r, t.attrs = r;
}
function Dk(t, e, A, n) {
  const {
    props: s,
    attrs: r,
    vnode: { patchFlag: i }
  } = t, o = /* @__PURE__ */ Gt(s), [a] = t.propsOptions;
  let c = !1;
  if (
    // always force full diff in dev
    // - #1942 if hmr is enabled with sfc component
    // - vite#872 non-sfc component used by sfc component
    (n || i > 0) && !(i & 16)
  ) {
    if (i & 8) {
      const l = t.vnode.dynamicProps;
      for (let B = 0; B < l.length; B++) {
        let g = l[B];
        if (fw(t.emitsOptions, g))
          continue;
        const h = e[g];
        if (a)
          if (zt(r, g))
            h !== r[g] && (r[g] = h, c = !0);
          else {
            const u = Nn(g);
            s[u] = wC(
              a,
              o,
              u,
              h,
              t,
              !1
            );
          }
        else
          h !== r[g] && (r[g] = h, c = !0);
      }
    }
  } else {
    ex(t, e, s, r) && (c = !0);
    let l;
    for (const B in o)
      (!e || // for camelCase
      !zt(e, B) && // it's possible the original props was passed in as kebab-case
      // and converted to camelCase (#955)
      ((l = is(B)) === B || !zt(e, l))) && (a ? A && // for camelCase
      (A[B] !== void 0 || // for kebab-case
      A[l] !== void 0) && (s[B] = wC(
        a,
        o,
        B,
        void 0,
        t,
        !0
      )) : delete s[B]);
    if (r !== o)
      for (const B in r)
        (!e || !zt(e, B)) && (delete r[B], c = !0);
  }
  c && mi(t.attrs, "set", "");
}
function ex(t, e, A, n) {
  const [s, r] = t.propsOptions;
  let i = !1, o;
  if (e)
    for (let a in e) {
      if (NB(a))
        continue;
      const c = e[a];
      let l;
      s && zt(s, l = Nn(a)) ? !r || !r.includes(l) ? A[l] = c : (o || (o = {}))[l] = c : fw(t.emitsOptions, a) || (!(a in n) || c !== n[a]) && (n[a] = c, i = !0);
    }
  if (r) {
    const a = /* @__PURE__ */ Gt(A), c = o || kt;
    for (let l = 0; l < r.length; l++) {
      const B = r[l];
      A[B] = wC(
        s,
        a,
        B,
        c[B],
        t,
        !zt(c, B)
      );
    }
  }
  return i;
}
function wC(t, e, A, n, s, r) {
  const i = t[A];
  if (i != null) {
    const o = zt(i, "default");
    if (o && n === void 0) {
      const a = i.default;
      if (i.type !== Function && !i.skipFactory && et(a)) {
        const { propsDefaults: c } = s;
        if (A in c)
          n = c[A];
        else {
          const l = ah(s);
          n = c[A] = a.call(
            null,
            e
          ), l();
        }
      } else
        n = a;
      s.ce && s.ce._setProp(A, n);
    }
    i[
      0
      /* shouldCast */
    ] && (r && !o ? n = !1 : i[
      1
      /* shouldCastTrue */
    ] && (n === "" || n === is(A)) && (n = !0));
  }
  return n;
}
const xk = /* @__PURE__ */ new WeakMap();
function tx(t, e, A = !1) {
  const n = A ? xk : e.propsCache, s = n.get(t);
  if (s)
    return s;
  const r = t.props, i = {}, o = [];
  let a = !1;
  if (!et(t)) {
    const l = (B) => {
      a = !0;
      const [g, h] = tx(B, e, !0);
      sA(i, g), h && o.push(...h);
    };
    !A && e.mixins.length && e.mixins.forEach(l), t.extends && l(t.extends), t.mixins && t.mixins.forEach(l);
  }
  if (!r && !a)
    return Pt(t) && n.set(t, $c), $c;
  if (Ve(r))
    for (let l = 0; l < r.length; l++) {
      const B = Nn(r[l]);
      i2(B) && (i[B] = kt);
    }
  else if (r)
    for (const l in r) {
      const B = Nn(l);
      if (i2(B)) {
        const g = r[l], h = i[B] = Ve(g) || et(g) ? { type: g } : sA({}, g), u = h.type;
        let d = !1, w = !0;
        if (Ve(u))
          for (let Q = 0; Q < u.length; ++Q) {
            const p = u[Q], M = et(p) && p.name;
            if (M === "Boolean") {
              d = !0;
              break;
            } else M === "String" && (w = !1);
          }
        else
          d = et(u) && u.name === "Boolean";
        h[
          0
          /* shouldCast */
        ] = d, h[
          1
          /* shouldCastTrue */
        ] = w, (d || zt(h, "default")) && o.push(B);
      }
    }
  const c = [i, o];
  return Pt(t) && n.set(t, c), c;
}
function i2(t) {
  return t[0] !== "$" && !NB(t);
}
const FM = (t) => t === "_" || t === "_ctx" || t === "$stable", NM = (t) => Ve(t) ? t.map(Yr) : [Yr(t)], Gk = (t, e, A) => {
  if (e._n)
    return e;
  const n = Ur((...s) => NM(e(...s)), A);
  return n._c = !1, n;
}, Ax = (t, e, A) => {
  const n = t._ctx;
  for (const s in t) {
    if (FM(s)) continue;
    const r = t[s];
    if (et(r))
      e[s] = Gk(s, r, n);
    else if (r != null) {
      const i = NM(r);
      e[s] = () => i;
    }
  }
}, nx = (t, e) => {
  const A = NM(e);
  t.slots.default = () => A;
}, sx = (t, e, A) => {
  for (const n in e)
    (A || !FM(n)) && (t[n] = e[n]);
}, zk = (t, e, A) => {
  const n = t.slots = _3();
  if (t.vnode.shapeFlag & 32) {
    const s = e._;
    s ? (sx(n, e, A), A && i3(n, "_", s, !0)) : Ax(e, n);
  } else e && nx(t, e);
}, Uk = (t, e, A) => {
  const { vnode: n, slots: s } = t;
  let r = !0, i = kt;
  if (n.shapeFlag & 32) {
    const o = e._;
    o ? A && o === 1 ? r = !1 : sx(s, e, A) : (r = !e.$stable, Ax(e, s)), i = e;
  } else e && (nx(t, e), i = { default: 1 });
  if (r)
    for (const o in s)
      !FM(o) && i[o] == null && delete s[o];
}, Mn = kk;
function bk(t) {
  return vk(t);
}
function vk(t, e) {
  const A = lw();
  A.__VUE__ = !0;
  const {
    insert: n,
    remove: s,
    patchProp: r,
    createElement: i,
    createText: o,
    createComment: a,
    setText: c,
    setElementText: l,
    parentNode: B,
    nextSibling: g,
    setScopeId: h = zr,
    insertStaticContent: u
  } = t, d = (H, L, _, R = null, P = null, X = null, ae = void 0, Be = null, he = !!L.dynamicChildren) => {
    if (H === L)
      return;
    H && !Ga(H, L) && (R = xt(H), Se(H, P, X, !0), H = null), L.patchFlag === -2 && (he = !1, L.dynamicChildren = null);
    const { type: ie, ref: ze, shapeFlag: Me } = L;
    switch (ie) {
      case Qw:
        w(H, L, _, R);
        break;
      case An:
        Q(H, L, _, R);
        break;
      case T0:
        H == null && p(L, _, R, ae);
        break;
      case ft:
        b(
          H,
          L,
          _,
          R,
          P,
          X,
          ae,
          Be,
          he
        );
        break;
      default:
        Me & 1 ? N(
          H,
          L,
          _,
          R,
          P,
          X,
          ae,
          Be,
          he
        ) : Me & 6 ? W(
          H,
          L,
          _,
          R,
          P,
          X,
          ae,
          Be,
          he
        ) : (Me & 64 || Me & 128) && ie.process(
          H,
          L,
          _,
          R,
          P,
          X,
          ae,
          Be,
          he,
          Ut
        );
    }
    ze != null && P ? zB(ze, H && H.ref, X, L || H, !L) : ze == null && H && H.ref != null && zB(H.ref, null, X, H, !0);
  }, w = (H, L, _, R) => {
    if (H == null)
      n(
        L.el = o(L.children),
        _,
        R
      );
    else {
      const P = L.el = H.el;
      L.children !== H.children && c(P, L.children);
    }
  }, Q = (H, L, _, R) => {
    H == null ? n(
      L.el = a(L.children || ""),
      _,
      R
    ) : L.el = H.el;
  }, p = (H, L, _, R) => {
    [H.el, H.anchor] = u(
      H.children,
      L,
      _,
      R,
      H.el,
      H.anchor
    );
  }, M = ({ el: H, anchor: L }, _, R) => {
    let P;
    for (; H && H !== L; )
      P = g(H), n(H, _, R), H = P;
    n(L, _, R);
  }, I = ({ el: H, anchor: L }) => {
    let _;
    for (; H && H !== L; )
      _ = g(H), s(H), H = _;
    s(L);
  }, N = (H, L, _, R, P, X, ae, Be, he) => {
    if (L.type === "svg" ? ae = "svg" : L.type === "math" && (ae = "mathml"), H == null)
      m(
        L,
        _,
        R,
        P,
        X,
        ae,
        Be,
        he
      );
    else {
      const ie = H.el && H.el._isVueCE ? H.el : null;
      try {
        ie && ie._beginPatch(), Y(
          H,
          L,
          P,
          X,
          ae,
          Be,
          he
        );
      } finally {
        ie && ie._endPatch();
      }
    }
  }, m = (H, L, _, R, P, X, ae, Be) => {
    let he, ie;
    const { props: ze, shapeFlag: Me, transition: xe, dirs: Ne } = H;
    if (he = H.el = i(
      H.type,
      X,
      ze && ze.is,
      ze
    ), Me & 8 ? l(he, H.children) : Me & 16 && G(
      H.children,
      he,
      null,
      R,
      P,
      eQ(H, X),
      ae,
      Be
    ), Ne && Qa(H, null, R, "created"), E(he, H, H.scopeId, ae, R), ze) {
      for (const Yt in ze)
        Yt !== "value" && !NB(Yt) && r(he, Yt, null, ze[Yt], X, R);
      "value" in ze && r(he, "value", null, ze.value, X), (ie = ze.onVnodeBeforeMount) && Qr(ie, R, H);
    }
    Ne && Qa(H, null, R, "beforeMount");
    const Xe = jk(P, xe);
    Xe && xe.beforeEnter(he), n(he, L, _), ((ie = ze && ze.onVnodeMounted) || Xe || Ne) && Mn(() => {
      ie && Qr(ie, R, H), Xe && xe.enter(he), Ne && Qa(H, null, R, "mounted");
    }, P);
  }, E = (H, L, _, R, P) => {
    if (_ && h(H, _), R)
      for (let X = 0; X < R.length; X++)
        h(H, R[X]);
    if (P) {
      let X = P.subTree;
      if (L === X || ox(X.type) && (X.ssContent === L || X.ssFallback === L)) {
        const ae = P.vnode;
        E(
          H,
          ae,
          ae.scopeId,
          ae.slotScopeIds,
          P.parent
        );
      }
    }
  }, G = (H, L, _, R, P, X, ae, Be, he = 0) => {
    for (let ie = he; ie < H.length; ie++) {
      const ze = H[ie] = Be ? Co(H[ie]) : Yr(H[ie]);
      d(
        null,
        ze,
        L,
        _,
        R,
        P,
        X,
        ae,
        Be
      );
    }
  }, Y = (H, L, _, R, P, X, ae) => {
    const Be = L.el = H.el;
    let { patchFlag: he, dynamicChildren: ie, dirs: ze } = L;
    he |= H.patchFlag & 16;
    const Me = H.props || kt, xe = L.props || kt;
    let Ne;
    if (_ && Ia(_, !1), (Ne = xe.onVnodeBeforeUpdate) && Qr(Ne, _, L, H), ze && Qa(L, H, _, "beforeUpdate"), _ && Ia(_, !0), (Me.innerHTML && xe.innerHTML == null || Me.textContent && xe.textContent == null) && l(Be, ""), ie ? U(
      H.dynamicChildren,
      ie,
      Be,
      _,
      R,
      eQ(L, P),
      X
    ) : ae || te(
      H,
      L,
      Be,
      null,
      _,
      R,
      eQ(L, P),
      X,
      !1
    ), he > 0) {
      if (he & 16)
        v(Be, Me, xe, _, P);
      else if (he & 2 && Me.class !== xe.class && r(Be, "class", null, xe.class, P), he & 4 && r(Be, "style", Me.style, xe.style, P), he & 8) {
        const Xe = L.dynamicProps;
        for (let Yt = 0; Yt < Xe.length; Yt++) {
          const gt = Xe[Yt], FA = Me[gt], NA = xe[gt];
          (NA !== FA || gt === "value") && r(Be, gt, FA, NA, P, _);
        }
      }
      he & 1 && H.children !== L.children && l(Be, L.children);
    } else !ae && ie == null && v(Be, Me, xe, _, P);
    ((Ne = xe.onVnodeUpdated) || ze) && Mn(() => {
      Ne && Qr(Ne, _, L, H), ze && Qa(L, H, _, "updated");
    }, R);
  }, U = (H, L, _, R, P, X, ae) => {
    for (let Be = 0; Be < L.length; Be++) {
      const he = H[Be], ie = L[Be], ze = (
        // oldVNode may be an errored async setup() component inside Suspense
        // which will not have a mounted element
        he.el && // - In the case of a Fragment, we need to provide the actual parent
        // of the Fragment itself so it can move its children.
        (he.type === ft || // - In the case of different nodes, there is going to be a replacement
        // which also requires the correct parent container
        !Ga(he, ie) || // - In the case of a component, it could contain anything.
        he.shapeFlag & 198) ? B(he.el) : (
          // In other cases, the parent container is not actually used so we
          // just pass the block element here to avoid a DOM parentNode call.
          _
        )
      );
      d(
        he,
        ie,
        ze,
        null,
        R,
        P,
        X,
        ae,
        !0
      );
    }
  }, v = (H, L, _, R, P) => {
    if (L !== _) {
      if (L !== kt)
        for (const X in L)
          !NB(X) && !(X in _) && r(
            H,
            X,
            L[X],
            null,
            P,
            R
          );
      for (const X in _) {
        if (NB(X)) continue;
        const ae = _[X], Be = L[X];
        ae !== Be && X !== "value" && r(H, X, Be, ae, P, R);
      }
      "value" in _ && r(H, "value", L.value, _.value, P);
    }
  }, b = (H, L, _, R, P, X, ae, Be, he) => {
    const ie = L.el = H ? H.el : o(""), ze = L.anchor = H ? H.anchor : o("");
    let { patchFlag: Me, dynamicChildren: xe, slotScopeIds: Ne } = L;
    Ne && (Be = Be ? Be.concat(Ne) : Ne), H == null ? (n(ie, _, R), n(ze, _, R), G(
      // #10007
      // such fragment like `<></>` will be compiled into
      // a fragment which doesn't have a children.
      // In this case fallback to an empty array
      L.children || [],
      _,
      ze,
      P,
      X,
      ae,
      Be,
      he
    )) : Me > 0 && Me & 64 && xe && // #2715 the previous fragment could've been a BAILed one as a result
    // of renderSlot() with no valid children
    H.dynamicChildren && H.dynamicChildren.length === xe.length ? (U(
      H.dynamicChildren,
      xe,
      _,
      P,
      X,
      ae,
      Be
    ), // #2080 if the stable fragment has a key, it's a <template v-for> that may
    //  get moved around. Make sure all root level vnodes inherit el.
    // #2134 or if it's a component root, it may also get moved around
    // as the component is being moved.
    (L.key != null || P && L === P.subTree) && DM(
      H,
      L,
      !0
      /* shallow */
    )) : te(
      H,
      L,
      _,
      ze,
      P,
      X,
      ae,
      Be,
      he
    );
  }, W = (H, L, _, R, P, X, ae, Be, he) => {
    L.slotScopeIds = Be, H == null ? L.shapeFlag & 512 ? P.ctx.activate(
      L,
      _,
      R,
      ae,
      he
    ) : q(
      L,
      _,
      R,
      P,
      X,
      ae,
      he
    ) : ne(H, L, he);
  }, q = (H, L, _, R, P, X, ae) => {
    const Be = H.component = Ok(
      H,
      R,
      P
    );
    if (uw(H) && (Be.ctx.renderer = Ut), Pk(Be, !1, ae), Be.asyncDep) {
      if (P && P.registerDep(Be, V, ae), !H.el) {
        const he = Be.subTree = rt(An);
        Q(null, he, L, _), H.placeholder = he.el;
      }
    } else
      V(
        Be,
        H,
        L,
        _,
        P,
        X,
        ae
      );
  }, ne = (H, L, _) => {
    const R = L.component = H.component;
    if (yk(H, L, _))
      if (R.asyncDep && !R.asyncResolved) {
        se(R, L, _);
        return;
      } else
        R.next = L, R.update();
    else
      L.el = H.el, R.vnode = L;
  }, V = (H, L, _, R, P, X, ae) => {
    const Be = () => {
      if (H.isMounted) {
        let { next: Me, bu: xe, u: Ne, parent: Xe, vnode: Yt } = H;
        {
          const un = rx(H);
          if (un) {
            Me && (Me.el = Yt.el, se(H, Me, ae)), un.asyncDep.then(() => {
              H.isUnmounted || Be();
            });
            return;
          }
        }
        let gt = Me, FA;
        Ia(H, !1), Me ? (Me.el = Yt.el, se(H, Me, ae)) : Me = Yt, xe && R0(xe), (FA = Me.props && Me.props.onVnodeBeforeUpdate) && Qr(FA, Xe, Me, Yt), Ia(H, !0);
        const NA = s2(H), hn = H.subTree;
        H.subTree = NA, d(
          hn,
          NA,
          // parent may have changed if it's in a teleport
          B(hn.el),
          // anchor may have changed if it's in a fragment
          xt(hn),
          H,
          P,
          X
        ), Me.el = NA.el, gt === null && Fk(H, NA.el), Ne && Mn(Ne, P), (FA = Me.props && Me.props.onVnodeUpdated) && Mn(
          () => Qr(FA, Xe, Me, Yt),
          P
        );
      } else {
        let Me;
        const { el: xe, props: Ne } = L, { bm: Xe, m: Yt, parent: gt, root: FA, type: NA } = H, hn = Al(L);
        Ia(H, !1), Xe && R0(Xe), !hn && (Me = Ne && Ne.onVnodeBeforeMount) && Qr(Me, gt, L), Ia(H, !0);
        {
          FA.ce && // @ts-expect-error _def is private
          FA.ce._def.shadowRoot !== !1 && FA.ce._injectChildStyle(NA);
          const un = H.subTree = s2(H);
          d(
            null,
            un,
            _,
            R,
            H,
            P,
            X
          ), L.el = un.el;
        }
        if (Yt && Mn(Yt, P), !hn && (Me = Ne && Ne.onVnodeMounted)) {
          const un = L;
          Mn(
            () => Qr(Me, gt, un),
            P
          );
        }
        (L.shapeFlag & 256 || gt && Al(gt.vnode) && gt.vnode.shapeFlag & 256) && H.a && Mn(H.a, P), H.isMounted = !0, L = _ = R = null;
      }
    };
    H.scope.on();
    const he = H.effect = new l3(Be);
    H.scope.off();
    const ie = H.update = he.run.bind(he), ze = H.job = he.runIfDirty.bind(he);
    ze.i = H, ze.id = H.uid, he.scheduler = () => pM(ze), Ia(H, !0), ie();
  }, se = (H, L, _) => {
    L.component = H;
    const R = H.vnode.props;
    H.vnode = L, H.next = null, Dk(H, L.props, R, _), Uk(H, L.children, _), ki(), KY(H), Ri();
  }, te = (H, L, _, R, P, X, ae, Be, he = !1) => {
    const ie = H && H.children, ze = H ? H.shapeFlag : 0, Me = L.children, { patchFlag: xe, shapeFlag: Ne } = L;
    if (xe > 0) {
      if (xe & 128) {
        Oe(
          ie,
          Me,
          _,
          R,
          P,
          X,
          ae,
          Be,
          he
        );
        return;
      } else if (xe & 256) {
        be(
          ie,
          Me,
          _,
          R,
          P,
          X,
          ae,
          Be,
          he
        );
        return;
      }
    }
    Ne & 8 ? (ze & 16 && pt(ie, P, X), Me !== ie && l(_, Me)) : ze & 16 ? Ne & 16 ? Oe(
      ie,
      Me,
      _,
      R,
      P,
      X,
      ae,
      Be,
      he
    ) : pt(ie, P, X, !0) : (ze & 8 && l(_, ""), Ne & 16 && G(
      Me,
      _,
      R,
      P,
      X,
      ae,
      Be,
      he
    ));
  }, be = (H, L, _, R, P, X, ae, Be, he) => {
    H = H || $c, L = L || $c;
    const ie = H.length, ze = L.length, Me = Math.min(ie, ze);
    let xe;
    for (xe = 0; xe < Me; xe++) {
      const Ne = L[xe] = he ? Co(L[xe]) : Yr(L[xe]);
      d(
        H[xe],
        Ne,
        _,
        null,
        P,
        X,
        ae,
        Be,
        he
      );
    }
    ie > ze ? pt(
      H,
      P,
      X,
      !0,
      !1,
      Me
    ) : G(
      L,
      _,
      R,
      P,
      X,
      ae,
      Be,
      he,
      Me
    );
  }, Oe = (H, L, _, R, P, X, ae, Be, he) => {
    let ie = 0;
    const ze = L.length;
    let Me = H.length - 1, xe = ze - 1;
    for (; ie <= Me && ie <= xe; ) {
      const Ne = H[ie], Xe = L[ie] = he ? Co(L[ie]) : Yr(L[ie]);
      if (Ga(Ne, Xe))
        d(
          Ne,
          Xe,
          _,
          null,
          P,
          X,
          ae,
          Be,
          he
        );
      else
        break;
      ie++;
    }
    for (; ie <= Me && ie <= xe; ) {
      const Ne = H[Me], Xe = L[xe] = he ? Co(L[xe]) : Yr(L[xe]);
      if (Ga(Ne, Xe))
        d(
          Ne,
          Xe,
          _,
          null,
          P,
          X,
          ae,
          Be,
          he
        );
      else
        break;
      Me--, xe--;
    }
    if (ie > Me) {
      if (ie <= xe) {
        const Ne = xe + 1, Xe = Ne < ze ? L[Ne].el : R;
        for (; ie <= xe; )
          d(
            null,
            L[ie] = he ? Co(L[ie]) : Yr(L[ie]),
            _,
            Xe,
            P,
            X,
            ae,
            Be,
            he
          ), ie++;
      }
    } else if (ie > xe)
      for (; ie <= Me; )
        Se(H[ie], P, X, !0), ie++;
    else {
      const Ne = ie, Xe = ie, Yt = /* @__PURE__ */ new Map();
      for (ie = Xe; ie <= xe; ie++) {
        const pe = L[ie] = he ? Co(L[ie]) : Yr(L[ie]);
        pe.key != null && Yt.set(pe.key, ie);
      }
      let gt, FA = 0;
      const NA = xe - Xe + 1;
      let hn = !1, un = 0;
      const ni = new Array(NA);
      for (ie = 0; ie < NA; ie++) ni[ie] = 0;
      for (ie = Ne; ie <= Me; ie++) {
        const pe = H[ie];
        if (FA >= NA) {
          Se(pe, P, X, !0);
          continue;
        }
        let ve;
        if (pe.key != null)
          ve = Yt.get(pe.key);
        else
          for (gt = Xe; gt <= xe; gt++)
            if (ni[gt - Xe] === 0 && Ga(pe, L[gt])) {
              ve = gt;
              break;
            }
        ve === void 0 ? Se(pe, P, X, !0) : (ni[ve - Xe] = ie + 1, ve >= un ? un = ve : hn = !0, d(
          pe,
          L[ve],
          _,
          null,
          P,
          X,
          ae,
          Be,
          he
        ), FA++);
      }
      const $ = hn ? Hk(ni) : $c;
      for (gt = $.length - 1, ie = NA - 1; ie >= 0; ie--) {
        const pe = Xe + ie, ve = L[pe], lt = L[pe + 1], ot = pe + 1 < ze ? (
          // #13559, #14173 fallback to el placeholder for unresolved async component
          lt.el || ix(lt)
        ) : R;
        ni[ie] === 0 ? d(
          null,
          ve,
          _,
          ot,
          P,
          X,
          ae,
          Be,
          he
        ) : hn && (gt < 0 || ie !== $[gt] ? ke(ve, _, ot, 2) : gt--);
      }
    }
  }, ke = (H, L, _, R, P = null) => {
    const { el: X, type: ae, transition: Be, children: he, shapeFlag: ie } = H;
    if (ie & 6) {
      ke(H.component.subTree, L, _, R);
      return;
    }
    if (ie & 128) {
      H.suspense.move(L, _, R);
      return;
    }
    if (ie & 64) {
      ae.move(H, L, _, Ut);
      return;
    }
    if (ae === ft) {
      n(X, L, _);
      for (let Me = 0; Me < he.length; Me++)
        ke(he[Me], L, _, R);
      n(H.anchor, L, _);
      return;
    }
    if (ae === T0) {
      M(H, L, _);
      return;
    }
    if (R !== 2 && ie & 1 && Be)
      if (R === 0)
        Be.beforeEnter(X), n(X, L, _), Mn(() => Be.enter(X), P);
      else {
        const { leave: Me, delayLeave: xe, afterLeave: Ne } = Be, Xe = () => {
          H.ctx.isUnmounted ? s(X) : n(X, L, _);
        }, Yt = () => {
          X._isLeaving && X[Ei](
            !0
            /* cancelled */
          ), Me(X, () => {
            Xe(), Ne && Ne();
          });
        };
        xe ? xe(X, Xe, Yt) : Yt();
      }
    else
      n(X, L, _);
  }, Se = (H, L, _, R = !1, P = !1) => {
    const {
      type: X,
      props: ae,
      ref: Be,
      children: he,
      dynamicChildren: ie,
      shapeFlag: ze,
      patchFlag: Me,
      dirs: xe,
      cacheIndex: Ne
    } = H;
    if (Me === -2 && (P = !1), Be != null && (ki(), zB(Be, null, _, H, !0), Ri()), Ne != null && (L.renderCache[Ne] = void 0), ze & 256) {
      L.ctx.deactivate(H);
      return;
    }
    const Xe = ze & 1 && xe, Yt = !Al(H);
    let gt;
    if (Yt && (gt = ae && ae.onVnodeBeforeUnmount) && Qr(gt, L, H), ze & 6)
      We(H.component, _, R);
    else {
      if (ze & 128) {
        H.suspense.unmount(_, R);
        return;
      }
      Xe && Qa(H, null, L, "beforeUnmount"), ze & 64 ? H.type.remove(
        H,
        L,
        _,
        Ut,
        R
      ) : ie && // #5154
      // when v-once is used inside a block, setBlockTracking(-1) marks the
      // parent block with hasOnce: true
      // so that it doesn't take the fast path during unmount - otherwise
      // components nested in v-once are never unmounted.
      !ie.hasOnce && // #1153: fast path should not be taken for non-stable (v-for) fragments
      (X !== ft || Me > 0 && Me & 64) ? pt(
        ie,
        L,
        _,
        !1,
        !0
      ) : (X === ft && Me & 384 || !P && ze & 16) && pt(he, L, _), R && dt(H);
    }
    (Yt && (gt = ae && ae.onVnodeUnmounted) || Xe) && Mn(() => {
      gt && Qr(gt, L, H), Xe && Qa(H, null, L, "unmounted");
    }, _);
  }, dt = (H) => {
    const { type: L, el: _, anchor: R, transition: P } = H;
    if (L === ft) {
      st(_, R);
      return;
    }
    if (L === T0) {
      I(H);
      return;
    }
    const X = () => {
      s(_), P && !P.persisted && P.afterLeave && P.afterLeave();
    };
    if (H.shapeFlag & 1 && P && !P.persisted) {
      const { leave: ae, delayLeave: Be } = P, he = () => ae(_, X);
      Be ? Be(H.el, X, he) : he();
    } else
      X();
  }, st = (H, L) => {
    let _;
    for (; H !== L; )
      _ = g(H), s(H), H = _;
    s(L);
  }, We = (H, L, _) => {
    const { bum: R, scope: P, job: X, subTree: ae, um: Be, m: he, a: ie } = H;
    o2(he), o2(ie), R && R0(R), P.stop(), X && (X.flags |= 8, Se(ae, H, L, _)), Be && Mn(Be, L), Mn(() => {
      H.isUnmounted = !0;
    }, L);
  }, pt = (H, L, _, R = !1, P = !1, X = 0) => {
    for (let ae = X; ae < H.length; ae++)
      Se(H[ae], L, _, R, P);
  }, xt = (H) => {
    if (H.shapeFlag & 6)
      return xt(H.component.subTree);
    if (H.shapeFlag & 128)
      return H.suspense.next();
    const L = g(H.anchor || H.el), _ = L && L[U3];
    return _ ? g(_) : L;
  };
  let mt = !1;
  const $t = (H, L, _) => {
    let R;
    H == null ? L._vnode && (Se(L._vnode, null, null, !0), R = L._vnode.component) : d(
      L._vnode || null,
      H,
      L,
      null,
      null,
      null,
      _
    ), L._vnode = H, mt || (mt = !0, KY(R), D3(), mt = !1);
  }, Ut = {
    p: d,
    um: Se,
    m: ke,
    r: dt,
    mt: q,
    mc: G,
    pc: te,
    pbc: U,
    n: xt,
    o: t
  };
  return {
    render: $t,
    hydrate: void 0,
    createApp: Ck($t)
  };
}
function eQ({ type: t, props: e }, A) {
  return A === "svg" && t === "foreignObject" || A === "mathml" && t === "annotation-xml" && e && e.encoding && e.encoding.includes("html") ? void 0 : A;
}
function Ia({ effect: t, job: e }, A) {
  A ? (t.flags |= 32, e.flags |= 4) : (t.flags &= -33, e.flags &= -5);
}
function jk(t, e) {
  return (!t || t && !t.pendingBranch) && e && !e.persisted;
}
function DM(t, e, A = !1) {
  const n = t.children, s = e.children;
  if (Ve(n) && Ve(s))
    for (let r = 0; r < n.length; r++) {
      const i = n[r];
      let o = s[r];
      o.shapeFlag & 1 && !o.dynamicChildren && ((o.patchFlag <= 0 || o.patchFlag === 32) && (o = s[r] = Co(s[r]), o.el = i.el), !A && o.patchFlag !== -2 && DM(i, o)), o.type === Qw && (o.patchFlag !== -1 ? o.el = i.el : o.__elIndex = r + // take fragment start anchor into account
      (t.type === ft ? 1 : 0)), o.type === An && !o.el && (o.el = i.el);
    }
}
function Hk(t) {
  const e = t.slice(), A = [0];
  let n, s, r, i, o;
  const a = t.length;
  for (n = 0; n < a; n++) {
    const c = t[n];
    if (c !== 0) {
      if (s = A[A.length - 1], t[s] < c) {
        e[n] = s, A.push(n);
        continue;
      }
      for (r = 0, i = A.length - 1; r < i; )
        o = r + i >> 1, t[A[o]] < c ? r = o + 1 : i = o;
      c < t[A[r]] && (r > 0 && (e[n] = A[r - 1]), A[r] = n);
    }
  }
  for (r = A.length, i = A[r - 1]; r-- > 0; )
    A[r] = i, i = e[i];
  return A;
}
function rx(t) {
  const e = t.subTree.component;
  if (e)
    return e.asyncDep && !e.asyncResolved ? e : rx(e);
}
function o2(t) {
  if (t)
    for (let e = 0; e < t.length; e++)
      t[e].flags |= 8;
}
function ix(t) {
  if (t.placeholder)
    return t.placeholder;
  const e = t.component;
  return e ? ix(e.subTree) : null;
}
const ox = (t) => t.__isSuspense;
function kk(t, e) {
  e && e.pendingBranch ? Ve(t) ? e.effects.push(...t) : e.effects.push(t) : T5(t);
}
const ft = /* @__PURE__ */ Symbol.for("v-fgt"), Qw = /* @__PURE__ */ Symbol.for("v-txt"), An = /* @__PURE__ */ Symbol.for("v-cmt"), T0 = /* @__PURE__ */ Symbol.for("v-stc"), bB = [];
let gs = null;
function ee(t = !1) {
  bB.push(gs = t ? null : []);
}
function Rk() {
  bB.pop(), gs = bB[bB.length - 1] || null;
}
let fg = 1;
function Yu(t, e = !1) {
  fg += t, t < 0 && gs && e && (gs.hasOnce = !0);
}
function ax(t) {
  return t.dynamicChildren = fg > 0 ? gs || $c : null, Rk(), fg > 0 && gs && gs.push(t), t;
}
function Ae(t, e, A, n, s, r) {
  return ax(
    F(
      t,
      e,
      A,
      n,
      s,
      r,
      !0
    )
  );
}
function Lo(t, e, A, n, s) {
  return ax(
    rt(
      t,
      e,
      A,
      n,
      s,
      !0
    )
  );
}
function Qg(t) {
  return t ? t.__v_isVNode === !0 : !1;
}
function Ga(t, e) {
  return t.type === e.type && t.key === e.key;
}
const cx = ({ key: t }) => t ?? null, J0 = ({
  ref: t,
  ref_key: e,
  ref_for: A
}) => (typeof t == "number" && (t = "" + t), t != null ? rA(t) || /* @__PURE__ */ rn(t) || et(t) ? { i: VA, r: t, k: e, f: !!A } : t : null);
function F(t, e = null, A = null, n = 0, s = null, r = t === ft ? 0 : 1, i = !1, o = !1) {
  const a = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t,
    props: e,
    key: e && cx(e),
    ref: e && J0(e),
    scopeId: G3,
    slotScopeIds: null,
    children: A,
    component: null,
    suspense: null,
    ssContent: null,
    ssFallback: null,
    dirs: null,
    transition: null,
    el: null,
    anchor: null,
    target: null,
    targetStart: null,
    targetAnchor: null,
    staticCount: 0,
    shapeFlag: r,
    patchFlag: n,
    dynamicProps: s,
    dynamicChildren: null,
    appContext: null,
    ctx: VA
  };
  return o ? (xM(a, A), r & 128 && t.normalize(a)) : A && (a.shapeFlag |= rA(A) ? 8 : 16), fg > 0 && // avoid a block node from tracking itself
  !i && // has current parent block
  gs && // presence of a patch flag indicates this node needs patching on updates.
  // component nodes also should always be patched, because even if the
  // component doesn't need to update, it needs to persist the instance on to
  // the next vnode so that it can be properly unmounted later.
  (a.patchFlag > 0 || r & 6) && // the EVENTS flag is only for hydration and if it is the only flag, the
  // vnode should not be considered dynamic due to handler caching.
  a.patchFlag !== 32 && gs.push(a), a;
}
const rt = Lk;
function Lk(t, e = null, A = null, n = 0, s = null, r = !1) {
  if ((!t || t === O3) && (t = An), Qg(t)) {
    const o = Po(
      t,
      e,
      !0
      /* mergeRef: true */
    );
    return A && xM(o, A), fg > 0 && !r && gs && (o.shapeFlag & 6 ? gs[gs.indexOf(t)] = o : gs.push(o)), o.patchFlag = -2, o;
  }
  if (Zk(t) && (t = t.__vccOpts), e) {
    e = Sk(e);
    let { class: o, style: a } = e;
    o && !rA(o) && (e.class = De(o)), Pt(a) && (/* @__PURE__ */ MM(a) && !Ve(a) && (a = sA({}, a)), e.style = ia(a));
  }
  const i = rA(t) ? 1 : ox(t) ? 128 : b3(t) ? 64 : Pt(t) ? 4 : et(t) ? 2 : 0;
  return F(
    t,
    e,
    A,
    n,
    s,
    i,
    r,
    !0
  );
}
function Sk(t) {
  return t ? /* @__PURE__ */ MM(t) || $3(t) ? sA({}, t) : t : null;
}
function Po(t, e, A = !1, n = !1) {
  const { props: s, ref: r, patchFlag: i, children: o, transition: a } = t, c = e ? Tk(s || {}, e) : s, l = {
    __v_isVNode: !0,
    __v_skip: !0,
    type: t.type,
    props: c,
    key: c && cx(c),
    ref: e && e.ref ? (
      // #2078 in the case of <component :is="vnode" ref="extra"/>
      // if the vnode itself already has a ref, cloneVNode will need to merge
      // the refs so the single vnode can be set on multiple refs
      A && r ? Ve(r) ? r.concat(J0(e)) : [r, J0(e)] : J0(e)
    ) : r,
    scopeId: t.scopeId,
    slotScopeIds: t.slotScopeIds,
    children: o,
    target: t.target,
    targetStart: t.targetStart,
    targetAnchor: t.targetAnchor,
    staticCount: t.staticCount,
    shapeFlag: t.shapeFlag,
    // if the vnode is cloned with extra props, we can no longer assume its
    // existing patch flag to be reliable and need to add the FULL_PROPS flag.
    // note: preserve flag for fragments since they use the flag for children
    // fast paths only.
    patchFlag: e && t.type !== ft ? i === -1 ? 16 : i | 16 : i,
    dynamicProps: t.dynamicProps,
    dynamicChildren: t.dynamicChildren,
    appContext: t.appContext,
    dirs: t.dirs,
    transition: a,
    // These should technically only be non-null on mounted VNodes. However,
    // they *should* be copied for kept-alive vnodes. So we just always copy
    // them since them being non-null during a mount doesn't affect the logic as
    // they will simply be overwritten.
    component: t.component,
    suspense: t.suspense,
    ssContent: t.ssContent && Po(t.ssContent),
    ssFallback: t.ssFallback && Po(t.ssFallback),
    placeholder: t.placeholder,
    el: t.el,
    anchor: t.anchor,
    ctx: t.ctx,
    ce: t.ce
  };
  return a && n && wg(
    l,
    a.clone(l)
  ), l;
}
function as(t = " ", e = 0) {
  return rt(Qw, null, t, e);
}
function fr(t, e) {
  const A = rt(T0, null, t);
  return A.staticCount = e, A;
}
function je(t = "", e = !1) {
  return e ? (ee(), Lo(An, null, t)) : rt(An, null, t);
}
function Yr(t) {
  return t == null || typeof t == "boolean" ? rt(An) : Ve(t) ? rt(
    ft,
    null,
    // #3666, avoid reference pollution when reusing vnode
    t.slice()
  ) : Qg(t) ? Co(t) : rt(Qw, null, String(t));
}
function Co(t) {
  return t.el === null && t.patchFlag !== -1 || t.memo ? t : Po(t);
}
function xM(t, e) {
  let A = 0;
  const { shapeFlag: n } = t;
  if (e == null)
    e = null;
  else if (Ve(e))
    A = 16;
  else if (typeof e == "object")
    if (n & 65) {
      const s = e.default;
      s && (s._c && (s._d = !1), xM(t, s()), s._c && (s._d = !0));
      return;
    } else {
      A = 32;
      const s = e._;
      !s && !$3(e) ? e._ctx = VA : s === 3 && VA && (VA.slots._ === 1 ? e._ = 1 : (e._ = 2, t.patchFlag |= 1024));
    }
  else et(e) ? (e = { default: e, _ctx: VA }, A = 32) : (e = String(e), n & 64 ? (A = 16, e = [as(e)]) : A = 8);
  t.children = e, t.shapeFlag |= A;
}
function Tk(...t) {
  const e = {};
  for (let A = 0; A < t.length; A++) {
    const n = t[A];
    for (const s in n)
      if (s === "class")
        e.class !== n.class && (e.class = De([e.class, n.class]));
      else if (s === "style")
        e.style = ia([e.style, n.style]);
      else if (rw(s)) {
        const r = e[s], i = n[s];
        i && r !== i && !(Ve(r) && r.includes(i)) && (e[s] = r ? [].concat(r, i) : i);
      } else s !== "" && (e[s] = n[s]);
  }
  return e;
}
function Qr(t, e, A, n = null) {
  rr(t, e, 7, [
    A,
    n
  ]);
}
const Jk = X3();
let Wk = 0;
function Ok(t, e, A) {
  const n = t.type, s = (e ? e.appContext : t.appContext) || Jk, r = {
    uid: Wk++,
    vnode: t,
    type: n,
    parent: e,
    appContext: s,
    root: null,
    // to be immediately set
    next: null,
    subTree: null,
    // will be set synchronously right after creation
    effect: null,
    update: null,
    // will be set synchronously right after creation
    job: null,
    scope: new B5(
      !0
      /* detached */
    ),
    render: null,
    proxy: null,
    exposed: null,
    exposeProxy: null,
    withProxy: null,
    provides: e ? e.provides : Object.create(s.provides),
    ids: e ? e.ids : ["", 0, 0],
    accessCache: null,
    renderCache: [],
    // local resolved assets
    components: null,
    directives: null,
    // resolved props and emits options
    propsOptions: tx(n, s),
    emitsOptions: Z3(n, s),
    // emit
    emit: null,
    // to be set immediately
    emitted: null,
    // props default value
    propsDefaults: kt,
    // inheritAttrs
    inheritAttrs: n.inheritAttrs,
    // state
    ctx: kt,
    data: kt,
    props: kt,
    attrs: kt,
    slots: kt,
    refs: kt,
    setupState: kt,
    setupContext: null,
    // suspense related
    suspense: A,
    suspenseId: A ? A.pendingId : 0,
    asyncDep: null,
    asyncResolved: !1,
    // lifecycle hooks
    // not using enums here because it results in computed properties
    isMounted: !1,
    isUnmounted: !1,
    isDeactivated: !1,
    bc: null,
    c: null,
    bm: null,
    m: null,
    bu: null,
    u: null,
    um: null,
    bum: null,
    da: null,
    a: null,
    rtg: null,
    rtc: null,
    ec: null,
    sp: null
  };
  return r.ctx = { _: r }, r.root = e ? e.root : r, r.emit = Mk.bind(null, r), t.ce && t.ce(r), r;
}
let nn = null;
const bn = () => nn || VA;
let yu, fC;
{
  const t = lw(), e = (A, n) => {
    let s;
    return (s = t[A]) || (s = t[A] = []), s.push(n), (r) => {
      s.length > 1 ? s.forEach((i) => i(r)) : s[0](r);
    };
  };
  yu = e(
    "__VUE_INSTANCE_SETTERS__",
    (A) => nn = A
  ), fC = e(
    "__VUE_SSR_SETTERS__",
    (A) => Ig = A
  );
}
const ah = (t) => {
  const e = nn;
  return yu(t), t.scope.on(), () => {
    t.scope.off(), yu(e);
  };
}, a2 = () => {
  nn && nn.scope.off(), yu(null);
};
function lx(t) {
  return t.vnode.shapeFlag & 4;
}
let Ig = !1;
function Pk(t, e = !1, A = !1) {
  e && fC(e);
  const { props: n, children: s } = t.vnode, r = lx(t);
  Nk(t, n, r, e), zk(t, s, A || e);
  const i = r ? Kk(t, e) : void 0;
  return e && fC(!1), i;
}
function Kk(t, e) {
  const A = t.type;
  t.accessCache = /* @__PURE__ */ Object.create(null), t.proxy = new Proxy(t.ctx, Bk);
  const { setup: n } = A;
  if (n) {
    ki();
    const s = t.setupContext = n.length > 1 ? gx(t) : null, r = ah(t), i = oh(
      n,
      t,
      0,
      [
        t.props,
        s
      ]
    ), o = s3(i);
    if (Ri(), r(), (o || t.sp) && !Al(t) && J3(t), o) {
      if (i.then(a2, a2), e)
        return i.then((a) => {
          c2(t, a);
        }).catch((a) => {
          hw(a, t, 0);
        });
      t.asyncDep = i;
    } else
      c2(t, i);
  } else
    Bx(t);
}
function c2(t, e, A) {
  et(e) ? t.type.__ssrInlineRender ? t.ssrRender = e : t.render = e : Pt(e) && (t.setupState = y3(e)), Bx(t);
}
function Bx(t, e, A) {
  const n = t.type;
  t.render || (t.render = n.render || zr);
  {
    const s = ah(t);
    ki();
    try {
      uk(t);
    } finally {
      Ri(), s();
    }
  }
}
const Vk = {
  get(t, e) {
    return tn(t, "get", ""), t[e];
  }
};
function gx(t) {
  const e = (A) => {
    t.exposed = A || {};
  };
  return {
    attrs: new Proxy(t.attrs, Vk),
    slots: t.slots,
    emit: t.emit,
    expose: e
  };
}
function Iw(t) {
  return t.exposed ? t.exposeProxy || (t.exposeProxy = new Proxy(y3(m3(t.exposed)), {
    get(e, A) {
      if (A in e)
        return e[A];
      if (A in UB)
        return UB[A](t);
    },
    has(e, A) {
      return A in e || A in UB;
    }
  })) : t.proxy;
}
function Xk(t, e = !0) {
  return et(t) ? t.displayName || t.name : t.name || e && t.__name;
}
function Zk(t) {
  return et(t) && "__vccOpts" in t;
}
const Fe = (t, e) => /* @__PURE__ */ H5(t, e, Ig);
function GM(t, e, A) {
  try {
    Yu(-1);
    const n = arguments.length;
    return n === 2 ? Pt(e) && !Ve(e) ? Qg(e) ? rt(t, null, [e]) : rt(t, e) : rt(t, null, e) : (n > 3 ? A = Array.prototype.slice.call(arguments, 2) : n === 3 && Qg(A) && (A = [A]), rt(t, e, A));
  } finally {
    Yu(1);
  }
}
const qk = "3.5.27";
/**
* @vue/runtime-dom v3.5.27
* (c) 2018-present Yuxi (Evan) You and Vue contributors
* @license MIT
**/
let QC;
const l2 = typeof window < "u" && window.trustedTypes;
if (l2)
  try {
    QC = /* @__PURE__ */ l2.createPolicy("vue", {
      createHTML: (t) => t
    });
  } catch {
  }
const hx = QC ? (t) => QC.createHTML(t) : (t) => t, _k = "http://www.w3.org/2000/svg", $k = "http://www.w3.org/1998/Math/MathML", Ii = typeof document < "u" ? document : null, B2 = Ii && /* @__PURE__ */ Ii.createElement("template"), e7 = {
  insert: (t, e, A) => {
    e.insertBefore(t, A || null);
  },
  remove: (t) => {
    const e = t.parentNode;
    e && e.removeChild(t);
  },
  createElement: (t, e, A, n) => {
    const s = e === "svg" ? Ii.createElementNS(_k, t) : e === "mathml" ? Ii.createElementNS($k, t) : A ? Ii.createElement(t, { is: A }) : Ii.createElement(t);
    return t === "select" && n && n.multiple != null && s.setAttribute("multiple", n.multiple), s;
  },
  createText: (t) => Ii.createTextNode(t),
  createComment: (t) => Ii.createComment(t),
  setText: (t, e) => {
    t.nodeValue = e;
  },
  setElementText: (t, e) => {
    t.textContent = e;
  },
  parentNode: (t) => t.parentNode,
  nextSibling: (t) => t.nextSibling,
  querySelector: (t) => Ii.querySelector(t),
  setScopeId(t, e) {
    t.setAttribute(e, "");
  },
  // __UNSAFE__
  // Reason: innerHTML.
  // Static content here can only come from compiled templates.
  // As long as the user only uses trusted templates, this is safe.
  insertStaticContent(t, e, A, n, s, r) {
    const i = A ? A.previousSibling : e.lastChild;
    if (s && (s === r || s.nextSibling))
      for (; e.insertBefore(s.cloneNode(!0), A), !(s === r || !(s = s.nextSibling)); )
        ;
    else {
      B2.innerHTML = hx(
        n === "svg" ? `<svg>${t}</svg>` : n === "mathml" ? `<math>${t}</math>` : t
      );
      const o = B2.content;
      if (n === "svg" || n === "mathml") {
        const a = o.firstChild;
        for (; a.firstChild; )
          o.appendChild(a.firstChild);
        o.removeChild(a);
      }
      e.insertBefore(o, A);
    }
    return [
      // first
      i ? i.nextSibling : e.firstChild,
      // last
      A ? A.previousSibling : e.lastChild
    ];
  }
}, co = "transition", AB = "animation", Cg = /* @__PURE__ */ Symbol("_vtc"), ux = {
  name: String,
  type: String,
  css: {
    type: Boolean,
    default: !0
  },
  duration: [String, Number, Object],
  enterFromClass: String,
  enterActiveClass: String,
  enterToClass: String,
  appearFromClass: String,
  appearActiveClass: String,
  appearToClass: String,
  leaveFromClass: String,
  leaveActiveClass: String,
  leaveToClass: String
}, t7 = /* @__PURE__ */ sA(
  {},
  k3,
  ux
), A7 = (t) => (t.displayName = "Transition", t.props = t7, t), g2 = /* @__PURE__ */ A7(
  (t, { slots: e }) => GM(q5, n7(t), e)
), Ca = (t, e = []) => {
  Ve(t) ? t.forEach((A) => A(...e)) : t && t(...e);
}, h2 = (t) => t ? Ve(t) ? t.some((e) => e.length > 1) : t.length > 1 : !1;
function n7(t) {
  const e = {};
  for (const b in t)
    b in ux || (e[b] = t[b]);
  if (t.css === !1)
    return e;
  const {
    name: A = "v",
    type: n,
    duration: s,
    enterFromClass: r = `${A}-enter-from`,
    enterActiveClass: i = `${A}-enter-active`,
    enterToClass: o = `${A}-enter-to`,
    appearFromClass: a = r,
    appearActiveClass: c = i,
    appearToClass: l = o,
    leaveFromClass: B = `${A}-leave-from`,
    leaveActiveClass: g = `${A}-leave-active`,
    leaveToClass: h = `${A}-leave-to`
  } = t, u = s7(s), d = u && u[0], w = u && u[1], {
    onBeforeEnter: Q,
    onEnter: p,
    onEnterCancelled: M,
    onLeave: I,
    onLeaveCancelled: N,
    onBeforeAppear: m = Q,
    onAppear: E = p,
    onAppearCancelled: G = M
  } = e, Y = (b, W, q, ne) => {
    b._enterCancelled = ne, Ea(b, W ? l : o), Ea(b, W ? c : i), q && q();
  }, U = (b, W) => {
    b._isLeaving = !1, Ea(b, B), Ea(b, h), Ea(b, g), W && W();
  }, v = (b) => (W, q) => {
    const ne = b ? E : p, V = () => Y(W, b, q);
    Ca(ne, [W, V]), u2(() => {
      Ea(W, b ? a : r), ai(W, b ? l : o), h2(ne) || d2(W, n, d, V);
    });
  };
  return sA(e, {
    onBeforeEnter(b) {
      Ca(Q, [b]), ai(b, r), ai(b, i);
    },
    onBeforeAppear(b) {
      Ca(m, [b]), ai(b, a), ai(b, c);
    },
    onEnter: v(!1),
    onAppear: v(!0),
    onLeave(b, W) {
      b._isLeaving = !0;
      const q = () => U(b, W);
      ai(b, B), b._enterCancelled ? (ai(b, g), Q2(b)) : (Q2(b), ai(b, g)), u2(() => {
        b._isLeaving && (Ea(b, B), ai(b, h), h2(I) || d2(b, n, w, q));
      }), Ca(I, [b, q]);
    },
    onEnterCancelled(b) {
      Y(b, !1, void 0, !0), Ca(M, [b]);
    },
    onAppearCancelled(b) {
      Y(b, !0, void 0, !0), Ca(G, [b]);
    },
    onLeaveCancelled(b) {
      U(b), Ca(N, [b]);
    }
  });
}
function s7(t) {
  if (t == null)
    return null;
  if (Pt(t))
    return [tQ(t.enter), tQ(t.leave)];
  {
    const e = tQ(t);
    return [e, e];
  }
}
function tQ(t) {
  return rC(t);
}
function ai(t, e) {
  e.split(/\s+/).forEach((A) => A && t.classList.add(A)), (t[Cg] || (t[Cg] = /* @__PURE__ */ new Set())).add(e);
}
function Ea(t, e) {
  e.split(/\s+/).forEach((n) => n && t.classList.remove(n));
  const A = t[Cg];
  A && (A.delete(e), A.size || (t[Cg] = void 0));
}
function u2(t) {
  requestAnimationFrame(() => {
    requestAnimationFrame(t);
  });
}
let r7 = 0;
function d2(t, e, A, n) {
  const s = t._endId = ++r7, r = () => {
    s === t._endId && n();
  };
  if (A != null)
    return setTimeout(r, A);
  const { type: i, timeout: o, propCount: a } = i7(t, e);
  if (!i)
    return n();
  const c = i + "end";
  let l = 0;
  const B = () => {
    t.removeEventListener(c, g), r();
  }, g = (h) => {
    h.target === t && ++l >= a && B();
  };
  setTimeout(() => {
    l < a && B();
  }, o + 1), t.addEventListener(c, g);
}
function i7(t, e) {
  const A = window.getComputedStyle(t), n = (u) => (A[u] || "").split(", "), s = n(`${co}Delay`), r = n(`${co}Duration`), i = w2(s, r), o = n(`${AB}Delay`), a = n(`${AB}Duration`), c = w2(o, a);
  let l = null, B = 0, g = 0;
  e === co ? i > 0 && (l = co, B = i, g = r.length) : e === AB ? c > 0 && (l = AB, B = c, g = a.length) : (B = Math.max(i, c), l = B > 0 ? i > c ? co : AB : null, g = l ? l === co ? r.length : a.length : 0);
  const h = l === co && /\b(?:transform|all)(?:,|$)/.test(
    n(`${co}Property`).toString()
  );
  return {
    type: l,
    timeout: B,
    propCount: g,
    hasTransform: h
  };
}
function w2(t, e) {
  for (; t.length < e.length; )
    t = t.concat(t);
  return Math.max(...e.map((A, n) => f2(A) + f2(t[n])));
}
function f2(t) {
  return t === "auto" ? 0 : Number(t.slice(0, -1).replace(",", ".")) * 1e3;
}
function Q2(t) {
  return (t ? t.ownerDocument : document).body.offsetHeight;
}
function o7(t, e, A) {
  const n = t[Cg];
  n && (e = (e ? [e, ...n] : [...n]).join(" ")), e == null ? t.removeAttribute("class") : A ? t.setAttribute("class", e) : t.className = e;
}
const Fu = /* @__PURE__ */ Symbol("_vod"), dx = /* @__PURE__ */ Symbol("_vsh"), IC = {
  // used for prop mismatch check during hydration
  name: "show",
  beforeMount(t, { value: e }, { transition: A }) {
    t[Fu] = t.style.display === "none" ? "" : t.style.display, A && e ? A.beforeEnter(t) : nB(t, e);
  },
  mounted(t, { value: e }, { transition: A }) {
    A && e && A.enter(t);
  },
  updated(t, { value: e, oldValue: A }, { transition: n }) {
    !e != !A && (n ? e ? (n.beforeEnter(t), nB(t, !0), n.enter(t)) : n.leave(t, () => {
      nB(t, !1);
    }) : nB(t, e));
  },
  beforeUnmount(t, { value: e }) {
    nB(t, e);
  }
};
function nB(t, e) {
  t.style.display = e ? t[Fu] : "none", t[dx] = !e;
}
const a7 = /* @__PURE__ */ Symbol(""), c7 = /(?:^|;)\s*display\s*:/;
function l7(t, e, A) {
  const n = t.style, s = rA(A);
  let r = !1;
  if (A && !s) {
    if (e)
      if (rA(e))
        for (const i of e.split(";")) {
          const o = i.slice(0, i.indexOf(":")).trim();
          A[o] == null && W0(n, o, "");
        }
      else
        for (const i in e)
          A[i] == null && W0(n, i, "");
    for (const i in A)
      i === "display" && (r = !0), W0(n, i, A[i]);
  } else if (s) {
    if (e !== A) {
      const i = n[a7];
      i && (A += ";" + i), n.cssText = A, r = c7.test(A);
    }
  } else e && t.removeAttribute("style");
  Fu in t && (t[Fu] = r ? n.display : "", t[dx] && (n.display = "none"));
}
const I2 = /\s*!important$/;
function W0(t, e, A) {
  if (Ve(A))
    A.forEach((n) => W0(t, e, n));
  else if (A == null && (A = ""), e.startsWith("--"))
    t.setProperty(e, A);
  else {
    const n = B7(t, e);
    I2.test(A) ? t.setProperty(
      is(n),
      A.replace(I2, ""),
      "important"
    ) : t[n] = A;
  }
}
const C2 = ["Webkit", "Moz", "ms"], AQ = {};
function B7(t, e) {
  const A = AQ[e];
  if (A)
    return A;
  let n = Nn(e);
  if (n !== "filter" && n in t)
    return AQ[e] = n;
  n = cw(n);
  for (let s = 0; s < C2.length; s++) {
    const r = C2[s] + n;
    if (r in t)
      return AQ[e] = r;
  }
  return e;
}
const E2 = "http://www.w3.org/1999/xlink";
function M2(t, e, A, n, s, r = l5(e)) {
  n && e.startsWith("xlink:") ? A == null ? t.removeAttributeNS(E2, e.slice(6, e.length)) : t.setAttributeNS(E2, e, A) : A == null || r && !o3(A) ? t.removeAttribute(e) : t.setAttribute(
    e,
    r ? "" : Zi(A) ? String(A) : A
  );
}
function p2(t, e, A, n, s) {
  if (e === "innerHTML" || e === "textContent") {
    A != null && (t[e] = e === "innerHTML" ? hx(A) : A);
    return;
  }
  const r = t.tagName;
  if (e === "value" && r !== "PROGRESS" && // custom elements may use _value internally
  !r.includes("-")) {
    const o = r === "OPTION" ? t.getAttribute("value") || "" : t.value, a = A == null ? (
      // #11647: value should be set as empty string for null and undefined,
      // but <input type="checkbox"> should be set as 'on'.
      t.type === "checkbox" ? "on" : ""
    ) : String(A);
    (o !== a || !("_value" in t)) && (t.value = a), A == null && t.removeAttribute(e), t._value = A;
    return;
  }
  let i = !1;
  if (A === "" || A == null) {
    const o = typeof t[e];
    o === "boolean" ? A = o3(A) : A == null && o === "string" ? (A = "", i = !0) : o === "number" && (A = 0, i = !0);
  }
  try {
    t[e] = A;
  } catch {
  }
  i && t.removeAttribute(s || e);
}
function Rc(t, e, A, n) {
  t.addEventListener(e, A, n);
}
function g7(t, e, A, n) {
  t.removeEventListener(e, A, n);
}
const m2 = /* @__PURE__ */ Symbol("_vei");
function h7(t, e, A, n, s = null) {
  const r = t[m2] || (t[m2] = {}), i = r[e];
  if (n && i)
    i.value = n;
  else {
    const [o, a] = u7(e);
    if (n) {
      const c = r[e] = f7(
        n,
        s
      );
      Rc(t, o, c, a);
    } else i && (g7(t, o, i, a), r[e] = void 0);
  }
}
const Y2 = /(?:Once|Passive|Capture)$/;
function u7(t) {
  let e;
  if (Y2.test(t)) {
    e = {};
    let n;
    for (; n = t.match(Y2); )
      t = t.slice(0, t.length - n[0].length), e[n[0].toLowerCase()] = !0;
  }
  return [t[2] === ":" ? t.slice(3) : is(t.slice(2)), e];
}
let nQ = 0;
const d7 = /* @__PURE__ */ Promise.resolve(), w7 = () => nQ || (d7.then(() => nQ = 0), nQ = Date.now());
function f7(t, e) {
  const A = (n) => {
    if (!n._vts)
      n._vts = Date.now();
    else if (n._vts <= A.attached)
      return;
    rr(
      Q7(n, A.value),
      e,
      5,
      [n]
    );
  };
  return A.value = t, A.attached = w7(), A;
}
function Q7(t, e) {
  if (Ve(e)) {
    const A = t.stopImmediatePropagation;
    return t.stopImmediatePropagation = () => {
      A.call(t), t._stopped = !0;
    }, e.map(
      (n) => (s) => !s._stopped && n && n(s)
    );
  } else
    return e;
}
const y2 = (t) => t.charCodeAt(0) === 111 && t.charCodeAt(1) === 110 && // lowercase letter
t.charCodeAt(2) > 96 && t.charCodeAt(2) < 123, I7 = (t, e, A, n, s, r) => {
  const i = s === "svg";
  e === "class" ? o7(t, n, i) : e === "style" ? l7(t, A, n) : rw(e) ? gM(e) || h7(t, e, A, n, r) : (e[0] === "." ? (e = e.slice(1), !0) : e[0] === "^" ? (e = e.slice(1), !1) : C7(t, e, n, i)) ? (p2(t, e, n), !t.tagName.includes("-") && (e === "value" || e === "checked" || e === "selected") && M2(t, e, n, i, r, e !== "value")) : /* #11081 force set props for possible async custom element */ t._isVueCE && (/[A-Z]/.test(e) || !rA(n)) ? p2(t, Nn(e), n, r, e) : (e === "true-value" ? t._trueValue = n : e === "false-value" && (t._falseValue = n), M2(t, e, n, i));
};
function C7(t, e, A, n) {
  if (n)
    return !!(e === "innerHTML" || e === "textContent" || e in t && y2(e) && et(A));
  if (e === "spellcheck" || e === "draggable" || e === "translate" || e === "autocorrect" || e === "sandbox" && t.tagName === "IFRAME" || e === "form" || e === "list" && t.tagName === "INPUT" || e === "type" && t.tagName === "TEXTAREA")
    return !1;
  if (e === "width" || e === "height") {
    const s = t.tagName;
    if (s === "IMG" || s === "VIDEO" || s === "CANVAS" || s === "SOURCE")
      return !1;
  }
  return y2(e) && rA(A) ? !1 : e in t;
}
const F2 = {};
// @__NO_SIDE_EFFECTS__
function E7(t, e, A) {
  let n = /* @__PURE__ */ Un(t, e);
  ow(n) && (n = sA({}, n, e));
  class s extends zM {
    constructor(i) {
      super(n, i, A);
    }
  }
  return s.def = n, s;
}
const M7 = typeof HTMLElement < "u" ? HTMLElement : class {
};
class zM extends M7 {
  constructor(e, A = {}, n = z2) {
    super(), this._def = e, this._props = A, this._createApp = n, this._isVueCE = !0, this._instance = null, this._app = null, this._nonce = this._def.nonce, this._connected = !1, this._resolved = !1, this._patching = !1, this._dirty = !1, this._numberProps = null, this._styleChildren = /* @__PURE__ */ new WeakSet(), this._ob = null, this.shadowRoot && n !== z2 ? this._root = this.shadowRoot : e.shadowRoot !== !1 ? (this.attachShadow(
      sA({}, e.shadowRootOptions, {
        mode: "open"
      })
    ), this._root = this.shadowRoot) : this._root = this;
  }
  connectedCallback() {
    if (!this.isConnected) return;
    !this.shadowRoot && !this._resolved && this._parseSlots(), this._connected = !0;
    let e = this;
    for (; e = e && (e.parentNode || e.host); )
      if (e instanceof zM) {
        this._parent = e;
        break;
      }
    this._instance || (this._resolved ? this._mount(this._def) : e && e._pendingResolve ? this._pendingResolve = e._pendingResolve.then(() => {
      this._pendingResolve = void 0, this._resolveDef();
    }) : this._resolveDef());
  }
  _setParent(e = this._parent) {
    e && (this._instance.parent = e._instance, this._inheritParentContext(e));
  }
  _inheritParentContext(e = this._parent) {
    e && this._app && Object.setPrototypeOf(
      this._app._context.provides,
      e._instance.provides
    );
  }
  disconnectedCallback() {
    this._connected = !1, Yn(() => {
      this._connected || (this._ob && (this._ob.disconnect(), this._ob = null), this._app && this._app.unmount(), this._instance && (this._instance.ce = void 0), this._app = this._instance = null, this._teleportTargets && (this._teleportTargets.clear(), this._teleportTargets = void 0));
    });
  }
  _processMutations(e) {
    for (const A of e)
      this._setAttr(A.attributeName);
  }
  /**
   * resolve inner component definition (handle possible async component)
   */
  _resolveDef() {
    if (this._pendingResolve)
      return;
    for (let n = 0; n < this.attributes.length; n++)
      this._setAttr(this.attributes[n].name);
    this._ob = new MutationObserver(this._processMutations.bind(this)), this._ob.observe(this, { attributes: !0 });
    const e = (n, s = !1) => {
      this._resolved = !0, this._pendingResolve = void 0;
      const { props: r, styles: i } = n;
      let o;
      if (r && !Ve(r))
        for (const a in r) {
          const c = r[a];
          (c === Number || c && c.type === Number) && (a in this._props && (this._props[a] = rC(this._props[a])), (o || (o = /* @__PURE__ */ Object.create(null)))[Nn(a)] = !0);
        }
      this._numberProps = o, this._resolveProps(n), this.shadowRoot && this._applyStyles(i), this._mount(n);
    }, A = this._def.__asyncLoader;
    A ? this._pendingResolve = A().then((n) => {
      n.configureApp = this._def.configureApp, e(this._def = n, !0);
    }) : e(this._def);
  }
  _mount(e) {
    this._app = this._createApp(e), this._inheritParentContext(), e.configureApp && e.configureApp(this._app), this._app._ceVNode = this._createVNode(), this._app.mount(this._root);
    const A = this._instance && this._instance.exposed;
    if (A)
      for (const n in A)
        zt(this, n) || Object.defineProperty(this, n, {
          // unwrap ref to be consistent with public instance behavior
          get: () => bs(A[n])
        });
  }
  _resolveProps(e) {
    const { props: A } = e, n = Ve(A) ? A : Object.keys(A || {});
    for (const s of Object.keys(this))
      s[0] !== "_" && n.includes(s) && this._setProp(s, this[s]);
    for (const s of n.map(Nn))
      Object.defineProperty(this, s, {
        get() {
          return this._getProp(s);
        },
        set(r) {
          this._setProp(s, r, !0, !this._patching);
        }
      });
  }
  _setAttr(e) {
    if (e.startsWith("data-v-")) return;
    const A = this.hasAttribute(e);
    let n = A ? this.getAttribute(e) : F2;
    const s = Nn(e);
    A && this._numberProps && this._numberProps[s] && (n = rC(n)), this._setProp(s, n, !1, !0);
  }
  /**
   * @internal
   */
  _getProp(e) {
    return this._props[e];
  }
  /**
   * @internal
   */
  _setProp(e, A, n = !0, s = !1) {
    if (A !== this._props[e] && (this._dirty = !0, A === F2 ? delete this._props[e] : (this._props[e] = A, e === "key" && this._app && (this._app._ceVNode.key = A)), s && this._instance && this._update(), n)) {
      const r = this._ob;
      r && (this._processMutations(r.takeRecords()), r.disconnect()), A === !0 ? this.setAttribute(is(e), "") : typeof A == "string" || typeof A == "number" ? this.setAttribute(is(e), A + "") : A || this.removeAttribute(is(e)), r && r.observe(this, { attributes: !0 });
    }
  }
  _update() {
    const e = this._createVNode();
    this._app && (e.appContext = this._app._context), N7(e, this._root);
  }
  _createVNode() {
    const e = {};
    this.shadowRoot || (e.onVnodeMounted = e.onVnodeUpdated = this._renderSlots.bind(this));
    const A = rt(this._def, sA(e, this._props));
    return this._instance || (A.ce = (n) => {
      this._instance = n, n.ce = this, n.isCE = !0;
      const s = (r, i) => {
        this.dispatchEvent(
          new CustomEvent(
            r,
            ow(i[0]) ? sA({ detail: i }, i[0]) : { detail: i }
          )
        );
      };
      n.emit = (r, ...i) => {
        s(r, i), is(r) !== r && s(is(r), i);
      }, this._setParent();
    }), A;
  }
  _applyStyles(e, A) {
    if (!e) return;
    if (A) {
      if (A === this._def || this._styleChildren.has(A))
        return;
      this._styleChildren.add(A);
    }
    const n = this._nonce;
    for (let s = e.length - 1; s >= 0; s--) {
      const r = document.createElement("style");
      n && r.setAttribute("nonce", n), r.textContent = e[s], this.shadowRoot.prepend(r);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _parseSlots() {
    const e = this._slots = {};
    let A;
    for (; A = this.firstChild; ) {
      const n = A.nodeType === 1 && A.getAttribute("slot") || "default";
      (e[n] || (e[n] = [])).push(A), this.removeChild(A);
    }
  }
  /**
   * Only called when shadowRoot is false
   */
  _renderSlots() {
    const e = this._getSlots(), A = this._instance.type.__scopeId;
    for (let n = 0; n < e.length; n++) {
      const s = e[n], r = s.getAttribute("name") || "default", i = this._slots[r], o = s.parentNode;
      if (i)
        for (const a of i) {
          if (A && a.nodeType === 1) {
            const c = A + "-s", l = document.createTreeWalker(a, 1);
            a.setAttribute(c, "");
            let B;
            for (; B = l.nextNode(); )
              B.setAttribute(c, "");
          }
          o.insertBefore(a, s);
        }
      else
        for (; s.firstChild; ) o.insertBefore(s.firstChild, s);
      o.removeChild(s);
    }
  }
  /**
   * @internal
   */
  _getSlots() {
    const e = [this];
    this._teleportTargets && e.push(...this._teleportTargets);
    const A = /* @__PURE__ */ new Set();
    for (const n of e) {
      const s = n.querySelectorAll("slot");
      for (let r = 0; r < s.length; r++)
        A.add(s[r]);
    }
    return Array.from(A);
  }
  /**
   * @internal
   */
  _injectChildStyle(e) {
    this._applyStyles(e.styles, e);
  }
  /**
   * @internal
   */
  _beginPatch() {
    this._patching = !0, this._dirty = !1;
  }
  /**
   * @internal
   */
  _endPatch() {
    this._patching = !1, this._dirty && this._instance && this._update();
  }
  /**
   * @internal
   */
  _removeChildStyle(e) {
  }
}
const N2 = (t) => {
  const e = t.props["onUpdate:modelValue"] || !1;
  return Ve(e) ? (A) => R0(e, A) : e;
};
function p7(t) {
  t.target.composing = !0;
}
function D2(t) {
  const e = t.target;
  e.composing && (e.composing = !1, e.dispatchEvent(new Event("input")));
}
const sQ = /* @__PURE__ */ Symbol("_assign");
function x2(t, e, A) {
  return e && (t = t.trim()), A && (t = dM(t)), t;
}
const Zh = {
  created(t, { modifiers: { lazy: e, trim: A, number: n } }, s) {
    t[sQ] = N2(s);
    const r = n || s.props && s.props.type === "number";
    Rc(t, e ? "change" : "input", (i) => {
      i.target.composing || t[sQ](x2(t.value, A, r));
    }), (A || r) && Rc(t, "change", () => {
      t.value = x2(t.value, A, r);
    }), e || (Rc(t, "compositionstart", p7), Rc(t, "compositionend", D2), Rc(t, "change", D2));
  },
  // set value on mounted so it's after min/max for type="range"
  mounted(t, { value: e }) {
    t.value = e ?? "";
  },
  beforeUpdate(t, { value: e, oldValue: A, modifiers: { lazy: n, trim: s, number: r } }, i) {
    if (t[sQ] = N2(i), t.composing) return;
    const o = (r || t.type === "number") && !/^0\d/.test(t.value) ? dM(t.value) : t.value, a = e ?? "";
    o !== a && (document.activeElement === t && t.type !== "range" && (n && e === A || s && t.value.trim() === a) || (t.value = a));
  }
}, m7 = ["ctrl", "shift", "alt", "meta"], Y7 = {
  stop: (t) => t.stopPropagation(),
  prevent: (t) => t.preventDefault(),
  self: (t) => t.target !== t.currentTarget,
  ctrl: (t) => !t.ctrlKey,
  shift: (t) => !t.shiftKey,
  alt: (t) => !t.altKey,
  meta: (t) => !t.metaKey,
  left: (t) => "button" in t && t.button !== 0,
  middle: (t) => "button" in t && t.button !== 1,
  right: (t) => "button" in t && t.button !== 2,
  exact: (t, e) => m7.some((A) => t[`${A}Key`] && !e.includes(A))
}, tA = (t, e) => {
  const A = t._withMods || (t._withMods = {}), n = e.join(".");
  return A[n] || (A[n] = ((s, ...r) => {
    for (let i = 0; i < e.length; i++) {
      const o = Y7[e[i]];
      if (o && o(s, e)) return;
    }
    return t(s, ...r);
  }));
}, y7 = {
  esc: "escape",
  space: " ",
  up: "arrow-up",
  left: "arrow-left",
  right: "arrow-right",
  down: "arrow-down",
  delete: "backspace"
}, Yc = (t, e) => {
  const A = t._withKeys || (t._withKeys = {}), n = e.join(".");
  return A[n] || (A[n] = ((s) => {
    if (!("key" in s))
      return;
    const r = is(s.key);
    if (e.some(
      (i) => i === r || y7[i] === r
    ))
      return t(s);
  }));
}, F7 = /* @__PURE__ */ sA({ patchProp: I7 }, e7);
let G2;
function wx() {
  return G2 || (G2 = bk(F7));
}
const N7 = ((...t) => {
  wx().render(...t);
}), z2 = ((...t) => {
  const e = wx().createApp(...t), { mount: A } = e;
  return e.mount = (n) => {
    const s = x7(n);
    if (!s) return;
    const r = e._component;
    !et(r) && !r.render && !r.template && (r.template = s.innerHTML), s.nodeType === 1 && (s.textContent = "");
    const i = A(s, !1, D7(s));
    return s instanceof Element && (s.removeAttribute("v-cloak"), s.setAttribute("data-v-app", "")), i;
  }, e;
});
function D7(t) {
  if (t instanceof SVGElement)
    return "svg";
  if (typeof MathMLElement == "function" && t instanceof MathMLElement)
    return "mathml";
}
function x7(t) {
  return rA(t) ? document.querySelector(t) : t;
}
const G7 = { class: "root" }, z7 = { class: "title" }, U7 = { class: "message" }, b7 = /* @__PURE__ */ Un({
  __name: "HelloCard.ce",
  props: {
    title: { type: String },
    message: { type: String }
  },
  emits: ["hello"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = bn();
    function r() {
      var o;
      const i = {
        title: A.title ?? "Hello from Web Component",
        message: A.message ?? "This event was emitted from a Vue 3 custom element."
      };
      if (n("hello", i), (o = s == null ? void 0 : s.proxy) != null && o.$el) {
        const a = new CustomEvent("hello", {
          detail: i,
          bubbles: !0,
          composed: !0
        });
        s.proxy.$el.dispatchEvent(a);
      }
    }
    return (i, o) => (ee(), Ae("div", G7, [
      F("div", z7, Mt(t.title), 1),
      F("div", U7, Mt(t.message), 1),
      F("button", {
        class: "button",
        type: "button",
        onClick: r
      }, " Emit event ")
    ]));
  }
}), v7 = '.root{font-family:ui-sans-serif,system-ui,-apple-system,Segoe UI,Roboto,Arial,"Apple Color Emoji","Segoe UI Emoji";border:1px solid #e5e7eb;border-radius:10px;padding:12px;background:#fff;color:#111827;max-width:420px}.title{font-weight:700;margin-bottom:6px}.message{opacity:.9;margin-bottom:10px}.button{border:1px solid #111827;background:#111827;color:#fff;border-radius:8px;padding:8px 10px;cursor:pointer}.button:hover{background:#0b1220}', ZA = (t, e) => {
  const A = t.__vccOpts || t;
  for (const [n, s] of e)
    A[n] = s;
  return A;
}, j7 = /* @__PURE__ */ ZA(b7, [["styles", [v7]]]), H7 = ["disabled"], k7 = ["innerHTML"], R7 = { class: "label" }, L7 = ["innerHTML"], U2 = `<svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M9.57524 2.39384C9.57524 1.95316 9.93339 1.59177 10.3719 1.63575C12.1605 1.81517 13.8451 2.59486 15.1437 3.86019C16.6337 5.312 17.4978 7.28832 17.5519 9.36798C17.6059 11.4476 16.8456 13.4662 15.433 14.9934C14.0204 16.5206 12.0672 17.4358 9.98962 17.5438C7.91207 17.6518 5.87447 16.9442 4.31106 15.5717C2.74766 14.1993 1.78209 12.2705 1.62013 10.1965C1.45817 8.12241 2.11262 6.06712 3.44402 4.4686C4.6044 3.07539 6.19903 2.12517 7.95939 1.76121C8.39095 1.67198 8.78465 1.99427 8.83036 2.43258C8.87607 2.87089 8.55588 3.25828 8.12669 3.35828C6.78028 3.67196 5.5642 4.41663 4.67026 5.48992C3.60514 6.76874 3.08158 8.41298 3.21115 10.0722C3.34072 11.7314 4.11318 13.2745 5.3639 14.3724C6.61462 15.4704 8.2447 16.0365 9.90674 15.9501C11.5688 15.8637 13.1314 15.1315 14.2614 13.9098C15.3915 12.688 15.9998 11.0732 15.9565 9.40943C15.9133 7.7457 15.222 6.16465 14.03 5.0032C13.0296 4.02841 11.7428 3.4139 10.3711 3.24156C9.93388 3.18663 9.57524 2.83453 9.57524 2.39384Z" fill="currentColor"/>
<path d="M16.7565 9.57524C17.1972 9.57524 17.5586 9.21711 17.5146 8.77863C17.4369 8.00404 17.2461 7.24354 16.9471 6.52168C16.5461 5.55359 15.9583 4.67395 15.2174 3.933C14.4764 3.19205 13.5968 2.6043 12.6287 2.2033C11.9069 1.9043 11.1463 1.71349 10.3718 1.63577C9.93328 1.59178 9.57515 1.95316 9.57515 2.39384C9.57515 2.83453 9.93377 3.18664 10.371 3.24158C10.9358 3.31256 11.4899 3.45892 12.018 3.67769C12.7925 3.99849 13.4962 4.46869 14.0889 5.06145C14.6817 5.65421 15.1519 6.35792 15.4727 7.13239C15.6915 7.66054 15.8378 8.21455 15.9088 8.77938C15.9638 9.21662 16.3159 9.57524 16.7565 9.57524Z" fill="currentColor" fill-opacity="0.3"/>
</svg>`, S7 = /* @__PURE__ */ Un({
  __name: "Button.ce",
  props: {
    variant: { type: String },
    size: { type: String },
    disabled: { type: Boolean },
    loading: { type: [Boolean, String] },
    fullWidth: { type: Boolean },
    text: { type: String },
    iconLeft: { type: String },
    iconRight: { type: String }
  },
  emits: ["exiq-click"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = bn(), r = gk(), i = Fe(() => !!r.default), o = Fe(() => !!A.disabled || !!A.loading), a = Fe(() => A.loading === "left" || A.loading === !0), c = Fe(() => A.loading === "right"), l = Fe(() => `is-${A.variant || "primary"}`), B = Fe(() => `is-${A.size || "md"}`);
    function g() {
      var u;
      if (o.value) return;
      const h = { variant: A.variant ?? "primary", size: A.size ?? "md" };
      if (n("exiq-click", h), (u = s == null ? void 0 : s.proxy) != null && u.$el) {
        const d = new CustomEvent("exiq-click", {
          detail: h,
          bubbles: !0,
          composed: !0
        });
        s.proxy.$el.dispatchEvent(d);
      }
    }
    return (h, u) => (ee(), Ae("button", {
      class: De(["btn", [
        l.value,
        B.value,
        {
          "is-full": t.fullWidth,
          "is-loading": !!t.loading,
          "is-disabled-visual": t.disabled
        }
      ]]),
      type: "button",
      disabled: o.value,
      onClick: g
    }, [
      a.value ? (ee(), Ae("span", {
        key: 0,
        class: "spinner",
        "aria-hidden": "true",
        innerHTML: U2
      })) : je("", !0),
      Ni(h.$slots, "iconLeft"),
      t.iconLeft && !a.value ? (ee(), Ae("span", {
        key: 1,
        innerHTML: t.iconLeft,
        class: "v-html-icon"
      }, null, 8, k7)) : je("", !0),
      F("span", R7, [
        Ni(h.$slots, "default"),
        i.value ? je("", !0) : (ee(), Ae(ft, { key: 0 }, [
          as(Mt(t.text), 1)
        ], 64))
      ]),
      Ni(h.$slots, "iconRight"),
      t.iconRight && !c.value ? (ee(), Ae("span", {
        key: 2,
        innerHTML: t.iconRight,
        class: "v-html-icon"
      }, null, 8, L7)) : je("", !0),
      c.value ? (ee(), Ae("span", {
        key: 3,
        class: "spinner",
        "aria-hidden": "true",
        innerHTML: U2
      })) : je("", !0)
    ], 10, H7));
  }
}), T7 = ":host{display:inline-block;--exiq-color-white: #ffffff;--exiq-color-primary: #7f56d9;--exiq-color-primary-hover: #5b2cc5;--exiq-color-primary-focus-shadow: rgba(158, 119, 237, .24);--exiq-radius-md: 8px;--exiq-shadow-xs: 0 1px 2px rgba(16, 24, 40, .05)}.btn{font-family:Inter,ui-sans-serif,system-ui,-apple-system,sans-serif;display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid transparent;border-radius:var(--exiq-radius-md);box-shadow:var(--exiq-shadow-xs);cursor:pointer;-webkit-user-select:none;user-select:none;transition:all .2s;white-space:nowrap}.btn.is-disabled-visual{background-color:#e0e0e0!important;border-color:#e0e0e0!important;color:#fff!important;cursor:not-allowed;box-shadow:var(--exiq-shadow-xs)}.btn.is-secondary.is-disabled-visual,.btn.is-tertiary.is-disabled-visual{background-color:#f2edff!important;border-color:#e0e0e0!important;color:#e0e0e0!important}.btn.is-loading{cursor:wait}.btn.is-full{width:100%}.btn.is-primary:not(.is-disabled-visual){background-color:var(--exiq-color-primary);color:var(--exiq-color-white);border:1px solid var(--exiq-color-primary)}.btn.is-primary:hover:not(:disabled){background-color:var(--exiq-color-primary-hover);border-color:var(--exiq-color-primary-hover)}.btn.is-secondary:not(.is-disabled-visual){background-color:#f2edff;color:var(--exiq-color-primary);border:1px solid #f2edff}.btn.is-secondary:hover:not(:disabled){background-color:#e4dbfc;border-color:#e4dbfc}.btn.is-tertiary:not(.is-disabled-visual){background-color:#f2edff!important;color:#7f56d9!important;border:1px solid #7F56D9!important}.btn.is-tertiary:hover:not(:disabled){background-color:#e4dbfc!important;border-color:#7f56d9!important;color:#7f56d9!important}.btn.is-xs{height:32px;padding:0 12px;font-size:12px;font-weight:600;gap:4px}.btn.is-sm{height:36px;padding:0 14px;font-size:14px;font-weight:600;gap:4px}.btn.is-md{height:40px;padding:0 16px;font-size:14px;font-weight:600;gap:8px}.btn.is-lg{height:44px;padding:0 18px;font-size:16px;font-weight:600;gap:8px}.btn.is-xl{height:48px;padding:0 20px;font-size:16px;font-weight:600;gap:8px}.btn.is-2xl{height:60px;padding:0 28px;font-size:18px;font-weight:600;gap:12px}.btn ::slotted(svg),.v-html-icon svg,.spinner svg{width:20px!important;height:20px!important;display:block}.btn.is-xs ::slotted(svg),.btn.is-xs .v-html-icon svg,.btn.is-xs .spinner svg{width:16px!important;height:16px!important}.spinner{display:inline-flex;align-items:center;justify-content:center;animation:exiq-spin 1s linear infinite}@keyframes exiq-spin{0%{transform:rotate(0)}to{transform:rotate(360deg)}}", J7 = /* @__PURE__ */ ZA(S7, [["styles", [T7]]]), W7 = { class: "edit-menu" }, O7 = { class: "tabs" }, P7 = { class: "actions" }, K7 = { class: "icon-group" }, V7 = /* @__PURE__ */ Un({
  __name: "BookContentEditMenu.ce",
  props: {
    initialTab: { type: String, default: "content" },
    // Accept Number or String because custom elements/attrs often arrive as strings
    notifications: { type: [Number, String], default: 0 },
    debug: { type: Boolean, default: !1 }
  },
  emits: ["add-procedure", "add-chapter", "open-chat", "more-options", "tab-change", "menu-click"],
  setup(t, { emit: e }) {
    const A = t, n = /* @__PURE__ */ me(A.initialTab || "content"), s = bn();
    CA(
      () => A.initialTab,
      (d) => {
        typeof d == "string" && d && d !== n.value && (n.value = d);
      }
    );
    const r = Fe(() => {
      const d = A.notifications, w = typeof d == "number" ? d : Number(d);
      return Number.isFinite(w) ? w : 0;
    }), i = /* @__PURE__ */ me([
      { name: "Edit", icon: null },
      { name: "Delete", icon: null, destructive: !0 }
    ]), o = e, a = (d, w) => {
      var Q;
      if (o(d, w), (Q = s == null ? void 0 : s.proxy) != null && Q.$el) {
        const p = new CustomEvent(d, {
          detail: w,
          bubbles: !0,
          composed: !0
        });
        s.proxy.$el.dispatchEvent(p);
      }
    }, c = (d) => d && d.detail ? Array.isArray(d.detail) ? d.detail[0] : d.detail : d, l = () => a("add-procedure"), B = () => a("add-chapter"), g = () => a("open-chat"), h = (d) => {
      n.value = d, a("tab-change", d);
    }, u = (d) => {
      const w = c(d);
      w && (a("menu-click", w), w.name === "Delete" && a("more-options"));
    };
    return (d, w) => {
      const Q = tr("exiq-button"), p = tr("exiq-chatter-icon"), M = tr("exiq-menu-icon");
      return ee(), Ae("div", W7, [
        F("div", O7, [
          F("div", {
            class: De(["tab", { active: n.value === "content" }]),
            onClick: w[0] || (w[0] = (I) => h("content"))
          }, " Content ", 2),
          F("div", {
            class: De(["tab", { active: n.value === "summary" }]),
            onClick: w[1] || (w[1] = (I) => h("summary"))
          }, " Summary ", 2)
        ]),
        F("div", P7, [
          rt(Q, {
            variant: "primary",
            size: "sm",
            onExiqClick: l
          }, {
            default: Ur(() => [...w[2] || (w[2] = [
              F("svg", {
                slot: "iconLeft",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                F("path", {
                  d: "M9.99984 4.16602V15.8327M4.1665 9.99935H15.8332",
                  stroke: "white",
                  "stroke-width": "1.67",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1),
              as(" Add Procedure ", -1)
            ])]),
            _: 1
          }),
          rt(Q, {
            variant: "tertiary",
            size: "sm",
            onExiqClick: B
          }, {
            default: Ur(() => [...w[3] || (w[3] = [
              F("svg", {
                slot: "iconLeft",
                width: "20",
                height: "20",
                viewBox: "0 0 20 20",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                F("path", {
                  d: "M9.99984 4.16602V15.8327M4.1665 9.99935H15.8332",
                  stroke: "#7F56D9",
                  "stroke-width": "1.67",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round"
                })
              ], -1),
              as(" Add Chapter ", -1)
            ])]),
            _: 1
          }),
          F("div", K7, [
            rt(p, {
              ".unread": r.value,
              "is-white": !1,
              onExiqClick: g
            }, null, 40, [".unread"]),
            rt(M, {
              "dropdown-items": JSON.stringify(i.value),
              "translate-x-offset": "10",
              onExiqClick: u
            }, null, 8, ["dropdown-items"])
          ])
        ])
      ]);
    };
  }
}), X7 = ':host{display:block;width:100%;font-family:Inter,ui-sans-serif,system-ui,-apple-system,sans-serif;position:relative;z-index:10}.edit-menu{display:flex;align-items:center;justify-content:space-between;padding-left:6px;padding-bottom:8px;border-bottom:1px solid #EAECF0;background-color:transparent;position:relative;z-index:2000}.tabs{display:flex;gap:24px}.tab{font-size:14px;font-weight:600;color:#667085;cursor:pointer;padding:0;position:relative;transition:color .2s}.tab:hover{color:#101828}.tab.active{color:#7f56d9}.tab.active:after{content:"";position:absolute;bottom:-13px;left:-6px;right:-6px;height:3px;background-color:#d6bbfb}.actions{display:flex;align-items:center;gap:12px;position:relative;z-index:2002}.icon-group{display:flex;align-items:center;gap:4px;padding-top:4px;position:relative;z-index:2003}', Z7 = /* @__PURE__ */ ZA(V7, [["styles", [X7]]]), q7 = { class: "procedure-page-menu" }, _7 = { class: "badge" }, $7 = /* @__PURE__ */ Un({
  __name: "ProcedurePageMenu.ce",
  props: {
    has_procedure: { type: Boolean, default: !1 },
    has_summary: { type: Boolean, default: !1 },
    has_changes: { type: Boolean, default: !1 },
    has_revisions: { default: 0, type: Number }
  },
  emits: ["tab-change"],
  setup(t, { emit: e }) {
    const A = /* @__PURE__ */ me("procedure"), n = bn(), s = e, r = (i) => {
      var o;
      if (A.value = i, s("tab-change", i), (o = n == null ? void 0 : n.proxy) != null && o.$el) {
        const a = new CustomEvent("tab-change", {
          detail: i,
          bubbles: !0,
          composed: !0
        });
        n.proxy.$el.dispatchEvent(a);
      }
    };
    return (i, o) => (ee(), Ae("div", q7, [
      F("div", {
        class: De(["tab", { active: A.value === "procedure" }]),
        onClick: o[0] || (o[0] = (a) => r("procedure"))
      }, Mt(t.has_procedure ? "Procedure" : "Draft Procedure"), 3),
      t.has_procedure && t.has_summary ? (ee(), Ae("div", {
        key: 0,
        class: De(["tab", { active: A.value === "summary" }]),
        onClick: o[1] || (o[1] = (a) => r("summary"))
      }, " Summary ", 2)) : je("", !0),
      t.has_changes ? (ee(), Ae("div", {
        key: 1,
        class: De(["tab", { active: A.value === "changes" }]),
        onClick: o[2] || (o[2] = (a) => r("changes"))
      }, " Draft Changes ", 2)) : je("", !0),
      t.has_changes ? (ee(), Ae("div", {
        key: 2,
        class: De(["tab", { active: A.value === "compare" }]),
        onClick: o[3] || (o[3] = (a) => r("compare"))
      }, " Compare ", 2)) : je("", !0),
      t.has_revisions > 0 ? (ee(), Ae("div", {
        key: 3,
        class: De(["tab", { active: A.value === "revisions" }]),
        onClick: o[4] || (o[4] = (a) => r("revisions"))
      }, [
        o[5] || (o[5] = F("span", null, "Revisions", -1)),
        F("div", _7, Mt(t.has_revisions), 1)
      ], 2)) : je("", !0)
    ]));
  }
}), eR = ':host{display:block;width:100%;font-family:Inter,ui-sans-serif,system-ui,-apple-system,sans-serif}.procedure-page-menu{display:flex;align-items:flex-start;gap:12px;width:100%;background-color:#fff}.tab{display:flex;align-items:center;justify-content:center;gap:8px;height:32px;padding:0 4px 6px;font-size:14px;font-weight:600;line-height:20px;color:#475467;cursor:pointer;position:relative;transition:color .2s;white-space:nowrap}.tab:hover{color:#101828}.tab.active{color:#7f56d9}.tab.active:after{content:"";position:absolute;bottom:0;left:0;right:0;height:2px;background-color:#d6bbfb}.badge{display:flex;align-items:center;justify-content:center;padding:2px 8px;background-color:#f9fafb;border:1px solid #EAECF0;border-radius:9999px;font-size:12px;font-weight:500;line-height:18px;color:#344054;text-align:center}', tR = /* @__PURE__ */ ZA($7, [["styles", [eR]]]), AR = { key: 0 }, nR = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, sR = ["stroke"], rR = { key: 1 }, iR = {
  width: "20",
  height: "21",
  viewBox: "0 0 20 21",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, oR = ["stroke"], aR = /* @__PURE__ */ Un({
  __name: "ChatterIcon.ce",
  props: {
    unread: {
      type: Number,
      default: 0
    },
    isWhite: {
      type: Boolean,
      default: !1
    }
  },
  emits: ["exiq-click"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = bn(), r = (i) => {
      var a;
      const o = { originalEvent: i, unread: A.unread };
      if (n("exiq-click", o), (a = s == null ? void 0 : s.proxy) != null && a.$el) {
        const c = new CustomEvent("exiq-click", {
          detail: o,
          bubbles: !0,
          composed: !0
        });
        s.proxy.$el.dispatchEvent(c);
      }
    };
    return (i, o) => (ee(), Ae("div", {
      class: De(["chatter-icon-ce", {
        "is-white": t.isWhite,
        "chatterIcon-zero": t.unread === 0,
        "chatterIcon-unread": t.unread > 0
      }]),
      onClick: r
    }, [
      t.unread === 0 ? (ee(), Ae("div", AR, [
        (ee(), Ae("svg", nR, [
          F("path", {
            d: "M5.00009 5H15.0001M5.00009 8.5H15.0001M5.00009 12H15.0001M5.00009 16V18.3355C5.00009 18.8684 5.00009 19.1348 5.10932 19.2716C5.20431 19.3906 5.34836 19.4599 5.50063 19.4597C5.67572 19.4595 5.88376 19.2931 6.29985 18.9602L8.6853 17.0518C9.17261 16.662 9.41626 16.4671 9.68758 16.3285C9.92829 16.2055 10.1845 16.1156 10.4493 16.0613C10.7478 16 11.0598 16 11.6838 16H14.2001C15.8802 16 16.7203 16 17.3621 15.673C17.9265 15.3854 18.3855 14.9265 18.6731 14.362C19.0001 13.7202 19.0001 12.8802 19.0001 11.2V5.8C19.0001 4.11984 19.0001 3.27976 18.6731 2.63803C18.3855 2.07354 17.9265 1.6146 17.3621 1.32698C16.7203 1 15.8802 1 14.2001 1H5.80009C4.11993 1 3.27986 1 2.63812 1.32698C2.07363 1.6146 1.61469 2.07354 1.32707 2.63803C1.00009 3.27976 1.00009 4.11984 1.00009 5.8V12C1.00009 12.93 1.00009 13.395 1.10231 13.7765C1.37972 14.8117 2.18836 15.6204 3.22363 15.8978C3.60513 16 4.07012 16 5.00009 16Z",
            stroke: t.isWhite ? "#FFFFFF" : "#666666",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, sR)
        ]))
      ])) : (ee(), Ae("div", rR, [
        (ee(), Ae("svg", iR, [
          F("path", {
            d: "M10.0001 8.5V5M10.0001 12H10.0101M5.00009 16V18.3355C5.00009 18.8684 5.00009 19.1348 5.10932 19.2716C5.20431 19.3906 5.34836 19.4599 5.50063 19.4597C5.67572 19.4595 5.88376 19.2931 6.29985 18.9602L8.6853 17.0518C9.17261 16.662 9.41626 16.4671 9.68758 16.3285C9.92829 16.2055 10.1845 16.1156 10.4493 16.0613C10.7478 16 11.0598 16 11.6838 16H14.2001C15.8802 16 16.7203 16 17.3621 15.673C17.9265 15.3854 18.3855 14.9265 18.6731 14.362C19.0001 13.7202 19.0001 12.8802 19.0001 11.2V5.8C19.0001 4.11984 19.0001 3.27976 18.6731 2.63803C18.3855 2.07354 17.9265 1.6146 17.3621 1.32698C16.7203 1 15.8802 1 14.2001 1H5.80009C4.11993 1 3.27986 1 2.63812 1.32698C2.07363 1.6146 1.61469 2.07354 1.32707 2.63803C1.00009 3.27976 1.00009 4.11984 1.00009 5.8V12C1.00009 12.93 1.00009 13.395 1.10231 13.7765C1.37972 14.8117 2.18836 15.6204 3.22363 15.8978C3.60513 16 4.07012 16 5.00009 16Z",
            stroke: t.isWhite ? "#FFFFFF" : "#7F56D9",
            "stroke-width": "2",
            "stroke-linecap": "round",
            "stroke-linejoin": "round"
          }, null, 8, oR)
        ])),
        t.unread > 0 ? (ee(), Ae("span", {
          key: 0,
          class: De(["unread-badge", {
            "unread-badge-9plus": t.unread > 9
          }])
        }, Mt(t.unread > 9 ? "9+" : t.unread), 3)) : je("", !0)
      ]))
    ], 2));
  }
}), cR = ":host{display:inline-block;vertical-align:middle}.chatter-icon-ce{position:relative;display:inline-block;cursor:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzMSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF81NjU0NV8zNzc0NykiPgo8cGF0aCBkPSJNMjMuMSAxNS44TDcgNkwxMC41IDI0LjlMMTQuNyAxNy45TDIzLjEgMTUuOFoiIGZpbGw9IiM5MDdDRkYiLz4KPHBhdGggZD0iTTIzLjI2OTggMTYuNDc5MUwyNC44OTQ2IDE2LjA3MjlMMjMuNDY0IDE1LjIwMjFMNy4zNjM5NiA1LjQwMjA2TDYuMDI2NjIgNC41ODgwM0w2LjMxMTcgNi4xMjc0Nkw5LjgxMTcgMjUuMDI3NUwxMC4xNDg1IDI2Ljg0NjNMMTEuMTAwMiAyNS4yNjAxTDE1LjE1MTEgMTguNTA4OEwyMy4yNjk4IDE2LjQ3OTFaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNCIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RfNTY1NDVfMzc3NDciIHg9IjAuODUzMjIzIiB5PSIwLjM3NjAyNiIgd2lkdGg9IjMwLjAzNjIiIGhlaWdodD0iMzQuMDE2NiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIxLjQiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMi4xIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjQgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd181NjU0NV8zNzc0NyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd181NjU0NV8zNzc0NyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K),auto;transition:all .2s ease;text-align:center}.chatterIcon-zero{width:25px;height:25px}.chatterIcon-unread{width:26px;height:26px}.chatterIcon-unread:hover,.chatterIcon-zero:hover{background-color:#344054;text-align:center;box-shadow:0 4px 4px #0000000f;border-radius:4px}.chatterIcon-unread:hover svg path,.chatterIcon-zero:hover svg path{stroke:#fcfcfe!important}.chatterIcon-zero svg path{stroke:#666}.is-white.chatterIcon-unread:hover,.is-white.chatterIcon-zero:hover{background-color:#fff}.is-white.chatterIcon-unread:hover svg path,.is-white.chatterIcon-zero:hover svg path{stroke:#666!important}.is-white.chatterIcon-unread{width:fit-content;padding:3px 3px 0}.chatter-icon-ce div>svg{position:relative}.chatterIcon-zero div>svg{top:2.5px}.chatterIcon-unread svg{top:3px}.is-white.chatterIcon-unread svg{top:-2px}.unread-badge{position:absolute;top:-3px;right:-1px;background-color:#7f56d9;color:#fff;border-radius:10px;padding:0 4px;font-size:6px;text-align:center;font-weight:700;pointer-events:none;transform:translate(-15%,40%)}.unread-badge-9plus{padding:0 2px}.is-white{background:#666;border-radius:4px}.is-white.chatterIcon-unread .unread-badge{background-color:#e6ddf9!important;color:#344054!important;top:0;right:0;transform:translate(25%,-40%)}.is-white.chatterIcon-unread svg path{stroke:#e6ddf9}.is-white.chatterIcon-zero svg path{stroke:#fff}", lR = /* @__PURE__ */ ZA(aR, [["styles", [cR]]]), BR = /* @__PURE__ */ Un({
  __name: "GenericSelector.ce",
  props: {
    isOpen: { type: [Boolean, String], default: !1 },
    value: { type: [Boolean, String], default: !1 },
    persistent: { type: [Boolean, String], default: !1 },
    tipSide: { type: String, default: "left" },
    width: { type: [Number, String], default: 156 },
    variant: { type: String, default: "shadow" },
    hideTip: { type: [Boolean, String], default: !1 },
    translateXOffset: { type: [Number, String], default: 0 },
    translateYOffset: { type: [Number, String], default: 0 },
    // When "body", the dropdown is teleported to document.body for reliable overlay.
    attachSelector: { type: String, default: "body" }
  },
  emits: ["input", "displayTop", "exiq-toggle"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = bn(), r = (N, m) => {
      var E;
      if (n(N, m), (E = s == null ? void 0 : s.proxy) != null && E.$el) {
        const G = new CustomEvent(N, {
          detail: m,
          bubbles: !0,
          composed: !0
        });
        s.proxy.$el.dispatchEvent(G);
      }
    }, i = /* @__PURE__ */ me(!1), o = /* @__PURE__ */ me(null), a = /* @__PURE__ */ me(null), c = /* @__PURE__ */ me(null), l = /* @__PURE__ */ me(!1), B = Fe(() => Number(A.width)), g = Fe(() => A.hideTip === !0 || A.hideTip === "true" || A.hideTip === ""), h = Fe(() => A.tipSide || "left"), u = Fe(() => A.attachSelector === "body"), d = /* @__PURE__ */ me(0), w = /* @__PURE__ */ me(0), Q = Fe(() => ({
      width: `${B.value}px`,
      position: u.value ? "fixed" : "absolute",
      left: u.value ? `${d.value}px` : h.value === "left" ? "0" : "auto",
      right: u.value ? "auto" : h.value === "right" ? "0" : "auto",
      top: u.value ? `${w.value}px` : void 0,
      transform: u.value ? "none" : `translate(${Number(A.translateXOffset)}px, ${Number(A.translateYOffset)}px)`
    })), p = async () => {
      i.value = !i.value, i.value && (await Yn(), M(), window.addEventListener("scroll", M, !0), window.addEventListener("resize", M)), r("input", i.value), r("exiq-toggle", { isOpen: i.value }), i.value || (window.removeEventListener("scroll", M, !0), window.removeEventListener("resize", M));
    }, M = () => {
      if (!a.value || !c.value) return;
      const N = a.value.getBoundingClientRect(), m = c.value.getBoundingClientRect(), E = window.innerHeight - N.bottom;
      if (l.value = E < m.height + 20 && N.top > m.height, r("displayTop", l.value), u.value) {
        const G = 10 + Number(A.translateYOffset || 0), Y = h.value === "right" ? N.right - B.value : N.left;
        d.value = Math.round(Y + Number(A.translateXOffset || 0)), w.value = Math.round(
          l.value ? N.top - m.height - G : N.bottom + G
        );
      }
    }, I = (N) => {
      var U, v;
      if (A.persistent === !0 || A.persistent === "true") return;
      const E = N.target, G = (U = o.value) == null ? void 0 : U.contains(E), Y = (v = c.value) == null ? void 0 : v.contains(E);
      !G && !Y && i.value && (i.value = !1, r("input", !1), r("exiq-toggle", { isOpen: !1 }), window.removeEventListener("scroll", M, !0), window.removeEventListener("resize", M));
    };
    return Xr(() => {
      i.value = A.isOpen === !0 || A.isOpen === "true", document.addEventListener("click", I);
    }), ww(() => {
      document.removeEventListener("click", I);
    }), CA(() => A.isOpen, (N) => {
      i.value = N === !0 || N === "true";
    }), (N, m) => (ee(), Ae("div", {
      class: "generic-selector-wrapper",
      ref_key: "wrapper",
      ref: o
    }, [
      F("div", {
        ref_key: "activator",
        ref: a,
        onClick: tA(p, ["stop"]),
        class: "ex-generic-selector-default-activator"
      }, [
        Ni(N.$slots, "activator")
      ], 512),
      (ee(), Lo(j3, {
        to: "body",
        disabled: !u.value
      }, [
        Go(F("div", {
          class: De(["menu-content", [h.value, t.variant, { "display-top": l.value }]]),
          ref_key: "menuElement",
          ref: c,
          style: ia(Q.value)
        }, [
          g.value ? je("", !0) : (ee(), Ae("div", {
            key: 0,
            class: De(["tip-container", [h.value, { "display-top": l.value }]])
          }, [...m[0] || (m[0] = [
            F("div", { class: "tip-body" }, null, -1)
          ])], 2)),
          F("div", {
            class: De(["content-container", [t.variant]])
          }, [
            Ni(N.$slots, "content")
          ], 2)
        ], 6), [
          [IC, i.value]
        ])
      ], 8, ["disabled"]))
    ], 512));
  }
}), gR = ":host{display:inline-block;position:relative;font-family:Inter,sans-serif}.generic-selector-wrapper{position:relative}.ex-generic-selector-default-activator{cursor:pointer;display:inline-flex}.menu-content{position:absolute;z-index:2147483647;top:100%;margin-top:10px}.menu-content.shadow{filter:drop-shadow(0px 0px 12px rgba(0,0,0,.2))}.menu-content.display-top{top:auto;bottom:100%;margin-top:0;margin-bottom:10px}.menu-content.right{right:0}.menu-content.left{left:0}.tip-container{width:28px;height:12px;position:absolute;top:-12px;overflow:hidden;display:flex;justify-content:center}.tip-container.display-top{top:auto;bottom:-12px;transform:scaleY(-1)}.tip-container.right{right:16px}.tip-container.left{left:16px}.tip-body{width:20px;height:20px;background-color:#fff;border-radius:2.5px;transform:translateY(8px) rotate(45deg)}.content-container{position:relative;background-color:#fff;border-radius:8px;overflow:clip}", hR = /* @__PURE__ */ ZA(BR, [["styles", [gR]]]), uR = { class: "menu-icon-ce" }, dR = {
  key: 0,
  width: "36",
  height: "36",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, wR = { filter: "url(#filter_hover_main)" }, fR = {
  key: 1,
  width: "36",
  height: "36",
  viewBox: "0 0 48 48",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, QR = { filter: "url(#filter_normal_main)" }, IR = { class: "dropdown-menu" }, CR = ["onClick"], ER = { class: "item-content" }, MR = { class: "item-name" }, pR = ["innerHTML"], mR = /* @__PURE__ */ Un({
  __name: "MenuIcon.ce",
  props: {
    dropdownItems: { type: [Array, String], default: () => [] },
    isOpen: { type: [Boolean, String], default: !1 },
    width: { type: [Number, String], default: 156 },
    tipSide: { type: String, default: "right" },
    vertical: { type: [Boolean, String], default: !0 },
    translateXOffset: { type: [Number, String], default: 0 },
    translateYOffset: { type: [Number, String], default: 0 },
    attachSelector: { type: String, default: "closest" }
  },
  emits: ["exiq-click", "onClick"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = bn(), r = /* @__PURE__ */ me(!1), i = Fe(() => {
      const B = A.vertical;
      return B !== !1 && B !== "false";
    }), o = /* @__PURE__ */ me(!1), a = Fe(() => {
      if (typeof A.dropdownItems == "string")
        try {
          return JSON.parse(A.dropdownItems);
        } catch {
          return [];
        }
      return A.dropdownItems || [];
    });
    CA(() => A.isOpen, (B) => {
      o.value = B === !0 || B === "true";
    }, { immediate: !0 });
    const c = (B) => {
      var h;
      const g = ((h = B.detail) == null ? void 0 : h[0]) || B.detail;
      g !== void 0 && (o.value = typeof g == "object" ? g.isOpen : g);
    }, l = (B) => {
      var g;
      if (!B.disabled) {
        if (n("exiq-click", B), n("onClick", B), (g = s == null ? void 0 : s.proxy) != null && g.$el) {
          const h = new CustomEvent("exiq-click", {
            detail: B,
            bubbles: !0,
            composed: !0
          });
          s.proxy.$el.dispatchEvent(h);
        }
        o.value = !1;
      }
    };
    return (B, g) => {
      const h = tr("exiq-generic-selector");
      return ee(), Ae("div", uR, [
        rt(h, {
          "is-open": o.value,
          width: t.width,
          "tip-side": t.tipSide,
          "translate-x-offset": t.translateXOffset,
          "translate-y-offset": t.translateYOffset,
          "attach-selector": t.attachSelector,
          onExiqToggle: c
        }, {
          activator: Ur(() => [
            F("div", {
              class: "ex-menu-icon-wrapper",
              onMouseenter: g[0] || (g[0] = (u) => r.value = !0),
              onMouseleave: g[1] || (g[1] = (u) => r.value = !1)
            }, [
              r.value ? (ee(), Ae("svg", dR, [
                F("g", wR, [
                  g[8] || (g[8] = F("rect", {
                    x: "4",
                    width: "40",
                    height: "40",
                    rx: "8",
                    fill: "#F2EDFF",
                    "shape-rendering": "crispEdges"
                  }, null, -1)),
                  i.value ? (ee(), Ae(ft, { key: 0 }, [
                    g[2] || (g[2] = F("path", {
                      d: "M24 25C24.5523 25 25 24.5523 25 24C25 23.4477 24.5523 23 24 23C23.4477 23 23 23.4477 23 24C23 24.5523 23.4477 25 24 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[3] || (g[3] = F("path", {
                      d: "M24 18C24.5523 18 25 17.5523 25 17C25 16.4477 24.5523 16 24 16C23.4477 16 23 16.4477 23 17C23 17.5523 23.4477 18 24 18Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[4] || (g[4] = F("path", {
                      d: "M24 32C24.5523 32 25 31.5523 25 31C25 30.4477 24.5523 30 24 30C23.4477 30 23 30.4477 23 31C23 31.5523 23.4477 32 24 32Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1))
                  ], 64)) : (ee(), Ae(ft, { key: 1 }, [
                    g[5] || (g[5] = F("path", {
                      d: "M24 25C24.5523 25 25 24.5523 25 24C25 23.4477 24.5523 23 24 23C23.4477 23 23 23.4477 23 24C23 24.5523 23.4477 25 24 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[6] || (g[6] = F("path", {
                      d: "M31 25C31.5523 25 32 24.5523 32 24C32 23.4477 31.5523 23 31 23C30.4477 23 30 23.4477 30 24C30 24.5523 30.4477 25 31 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[7] || (g[7] = F("path", {
                      d: "M17 25C17.5523 25 18 24.5523 18 24C18 23.4477 17.5523 23 17 23C16.4477 23 16 23.4477 16 24C16 24.5523 16.4477 25 17 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1))
                  ], 64))
                ]),
                g[9] || (g[9] = F("defs", null, [
                  F("filter", {
                    id: "filter_hover_main",
                    x: "0",
                    y: "0",
                    width: "48",
                    height: "48",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB"
                  }, [
                    F("feFlood", {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix"
                    }),
                    F("feColorMatrix", {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }),
                    F("feOffset", { dy: "4" }),
                    F("feGaussianBlur", { stdDeviation: "2" }),
                    F("feComposite", {
                      in2: "hardAlpha",
                      operator: "out"
                    }),
                    F("feColorMatrix", {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                    }),
                    F("feBlend", {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1"
                    }),
                    F("feBlend", {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1",
                      result: "shape"
                    })
                  ])
                ], -1))
              ])) : (ee(), Ae("svg", fR, [
                F("g", QR, [
                  i.value ? (ee(), Ae(ft, { key: 0 }, [
                    g[10] || (g[10] = F("path", {
                      d: "M24 25C24.5523 25 25 24.5523 25 24C25 23.4477 24.5523 23 24 23C23.4477 23 23 23.4477 23 24C23 24.5523 23.4477 25 24 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[11] || (g[11] = F("path", {
                      d: "M24 18C24.5523 18 25 17.5523 25 17C25 16.4477 24.5523 16 24 16C23.4477 16 23 16.4477 23 17C23 17.5523 23.4477 18 24 18Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[12] || (g[12] = F("path", {
                      d: "M24 32C24.5523 32 25 31.5523 25 31C25 30.4477 24.5523 30 24 30C23.4477 30 23 30.4477 23 31C23 31.5523 23.4477 32 24 32Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1))
                  ], 64)) : (ee(), Ae(ft, { key: 1 }, [
                    g[13] || (g[13] = F("path", {
                      d: "M24 25C24.5523 25 25 24.5523 25 24C25 23.4477 24.5523 23 24 23C23.4477 23 23 23.4477 23 24C23 24.5523 23.4477 25 24 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[14] || (g[14] = F("path", {
                      d: "M31 25C31.5523 25 32 24.5523 32 24C32 23.4477 31.5523 23 31 23C30.4477 23 30 23.4477 30 24C30 24.5523 30.4477 25 31 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1)),
                    g[15] || (g[15] = F("path", {
                      d: "M17 25C17.5523 25 18 24.5523 18 24C18 23.4477 17.5523 23 17 23C16.4477 23 16 23.4477 16 24C16 24.5523 16.4477 25 17 25Z",
                      stroke: "black",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, null, -1))
                  ], 64))
                ]),
                g[16] || (g[16] = F("defs", null, [
                  F("filter", {
                    id: "filter_normal_main",
                    x: "0",
                    y: "0",
                    width: "48",
                    height: "48",
                    filterUnits: "userSpaceOnUse",
                    "color-interpolation-filters": "sRGB"
                  }, [
                    F("feFlood", {
                      "flood-opacity": "0",
                      result: "BackgroundImageFix"
                    }),
                    F("feColorMatrix", {
                      in: "SourceAlpha",
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
                      result: "hardAlpha"
                    }),
                    F("feOffset", { dy: "4" }),
                    F("feGaussianBlur", { stdDeviation: "2" }),
                    F("feComposite", {
                      in2: "hardAlpha",
                      operator: "out"
                    }),
                    F("feColorMatrix", {
                      type: "matrix",
                      values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"
                    }),
                    F("feBlend", {
                      mode: "normal",
                      in2: "BackgroundImageFix",
                      result: "effect1"
                    }),
                    F("feBlend", {
                      mode: "normal",
                      in: "SourceGraphic",
                      in2: "effect1",
                      result: "shape"
                    })
                  ])
                ], -1))
              ]))
            ], 32)
          ]),
          content: Ur(() => [
            F("ul", IR, [
              (ee(!0), Ae(ft, null, Ns(a.value, (u, d) => (ee(), Ae("li", {
                key: d,
                class: De(["dropdown-item-row", {
                  disabled: u.disabled,
                  "has-border": d < a.value.length - 1
                }]),
                onClick: (w) => l(u)
              }, [
                F("div", {
                  class: De(["item-hover-box", { "is-destructive": u.destructive || u.negative, "is-primary": u.primary }])
                }, [
                  F("div", ER, [
                    F("span", MR, Mt(u.name), 1),
                    u.icon ? (ee(), Ae("div", {
                      key: 0,
                      class: "item-icon",
                      innerHTML: u.icon
                    }, null, 8, pR)) : je("", !0)
                  ])
                ], 2)
              ], 10, CR))), 128))
            ])
          ]),
          _: 1
        }, 8, ["is-open", "width", "tip-side", "translate-x-offset", "translate-y-offset", "attach-selector"])
      ]);
    };
  }
}), YR = ':host{display:inline-block;--exiq-font-family: "Inter", sans-serif}.menu-icon-ce{display:flex;font-family:var(--exiq-font-family)}.ex-menu-icon-wrapper{width:36px;height:36px;display:flex;align-items:center;justify-content:center;cursor:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzMSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF81NjU0NV8zNzc0NykiPgo8cGF0aCBkPSJNMjMuMSAxNS44TDcgNkwxMC41IDI0LjlMMTQuNyAxNy45TDIzLjEgMTUuOFoiIGZpbGw9IiM5MDdDRkYiLz4KPHBhdGggZD0iTTIzLjI2OTggMTYuNDc5MUwyNC44OTQ2IDE2LjA3MjlMMjMuNDY0IDE1LjIwMjFMNy4zNjM5NiA1LjQwMjA2TDYuMDI2NjIgNC41ODgwM0w2LjMxMTcgNi4xMjc0Nkw5LjgxMTcgMjUuMDI3NUwxMC4xNDg1IDI2Ljg0NjNMMTEuMTAwMiAyNS4yNjAxTDE1LjE1MTEgMTguNTA4OEwyMy4yNjk4IDE2LjQ3OTFaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNCIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RfNTY1NDVfMzc3NDciIHg9IjAuODUzMjIzIiB5PSIwLjM3NjAyNiIgd2lkdGg9IjMwLjAzNjIiIGhlaWdodD0iMzQuMDE2NiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIxLjQiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMi4xIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjQgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd181NjU0NV8zNzc0NyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd181NjU0NV8zNzc0NyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K),auto;position:relative;margin:0;padding:0}.ex-menu-icon-wrapper svg{display:block;flex-shrink:0}.dropdown-menu{list-style:none;padding:0;margin:0;background-color:#fff;min-width:100%;font-family:var(--exiq-font-family)}.dropdown-item-row{padding:4px;cursor:url(data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEiIGhlaWdodD0iMzUiIHZpZXdCb3g9IjAgMCAzMSAzNSIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGcgZmlsdGVyPSJ1cmwoI2ZpbHRlcjBfZF81NjU0NV8zNzc0NykiPgo8cGF0aCBkPSJNMjMuMSAxNS44TDcgNkwxMC41IDI0LjlMMTQuNyAxNy45TDIzLjEgMTUuOFoiIGZpbGw9IiM5MDdDRkYiLz4KPHBhdGggZD0iTTIzLjI2OTggMTYuNDc5MUwyNC44OTQ2IDE2LjA3MjlMMjMuNDY0IDE1LjIwMjFMNy4zNjM5NiA1LjQwMjA2TDYuMDI2NjIgNC41ODgwM0w2LjMxMTcgNi4xMjc0Nkw5LjgxMTcgMjUuMDI3NUwxMC4xNDg1IDI2Ljg0NjNMMTEuMTAwMiAyNS4yNjAxTDE1LjE1MTEgMTguNTA4OEwyMy4yNjk4IDE2LjQ3OTFaIiBzdHJva2U9IndoaXRlIiBzdHJva2Utd2lkdGg9IjEuNCIvPgo8L2c+CjxkZWZzPgo8ZmlsdGVyIGlkPSJmaWx0ZXIwX2RfNTY1NDVfMzc3NDciIHg9IjAuODUzMjIzIiB5PSIwLjM3NjAyNiIgd2lkdGg9IjMwLjAzNjIiIGhlaWdodD0iMzQuMDE2NiIgZmlsdGVyVW5pdHM9InVzZXJTcGFjZU9uVXNlIiBjb2xvci1pbnRlcnBvbGF0aW9uLWZpbHRlcnM9InNSR0IiPgo8ZmVGbG9vZCBmbG9vZC1vcGFjaXR5PSIwIiByZXN1bHQ9IkJhY2tncm91bmRJbWFnZUZpeCIvPgo8ZmVDb2xvck1hdHJpeCBpbj0iU291cmNlQWxwaGEiIHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAxMjcgMCIgcmVzdWx0PSJoYXJkQWxwaGEiLz4KPGZlT2Zmc2V0IGR5PSIxLjQiLz4KPGZlR2F1c3NpYW5CbHVyIHN0ZERldmlhdGlvbj0iMi4xIi8+CjxmZUNvbG9yTWF0cml4IHR5cGU9Im1hdHJpeCIgdmFsdWVzPSIwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwIDAgMCAwLjQgMCIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluMj0iQmFja2dyb3VuZEltYWdlRml4IiByZXN1bHQ9ImVmZmVjdDFfZHJvcFNoYWRvd181NjU0NV8zNzc0NyIvPgo8ZmVCbGVuZCBtb2RlPSJub3JtYWwiIGluPSJTb3VyY2VHcmFwaGljIiBpbjI9ImVmZmVjdDFfZHJvcFNoYWRvd181NjU0NV8zNzc0NyIgcmVzdWx0PSJzaGFwZSIvPgo8L2ZpbHRlcj4KPC9kZWZzPgo8L3N2Zz4K),auto}.dropdown-item-row.has-border{border-bottom:.5px solid #eaecf0}.item-hover-box{padding:8px 20px;border-radius:4px;transition:background-color .2s;display:flex;align-items:center}.item-name{font-family:var(--exiq-font-family);font-size:12px;font-weight:400;line-height:16px;color:#344054;white-space:nowrap;transition:color .2s}.item-icon{display:flex;align-items:center;width:16px;height:16px;color:#667085;transition:color .2s}.dropdown-item-row:not(.disabled):hover .item-hover-box:not(.is-destructive){background-color:#e4dbfc}.dropdown-item-row:not(.disabled):hover .item-hover-box:not(.is-destructive) .item-name{color:#7f56d9;font-weight:500}.dropdown-item-row:not(.disabled):hover .item-hover-box:not(.is-destructive) .item-icon{color:#7f56d9}.item-hover-box.is-primary .item-name{color:#7f56d9;font-weight:500}.item-hover-box.is-destructive .item-name{color:#d92d20}.dropdown-item-row:not(.disabled):hover .item-hover-box.is-destructive{background-color:#fbeae9}.dropdown-item-row.disabled{opacity:.5;pointer-events:none}.item-content{width:100%;display:flex;justify-content:space-between;align-items:center;gap:12px}', yR = /* @__PURE__ */ ZA(mR, [["styles", [YR]]]), rQ = {
  sidebar_home: () => import("./HomeIcon-CwhY5c-Y.js"),
  corner_right_down: () => import("./CornerRightDown-B51CyPHO.js"),
  corner_down_right: () => import("./CornerDownRight-D4UdtdRc.js"),
  sidebar_proficiency: () => import("./ProficiencyIcon-D8PkP_MQ.js"),
  sidebar_knowledge: () => import("./KnowledgeIcon-8yCU7T6g.js"),
  sidebar_performance: () => import("./PerformanceIcon-CQjzFYhg.js"),
  sidebar_compensation: () => import("./CompensationIcon-Dzas1eua.js"),
  sidebar_readiness: () => import("./ReadinessIcon-qs-TUK2n.js"),
  sidebar_onboarding: () => import("./OnboardingIcon-Cv2Qk75b.js"),
  sidebar_planning: () => import("./PlanningIcon-CMviPAZA.js"),
  sidebar_yourstuff: () => import("./YourStuffIcon-C8xoUIZx.js"),
  sidebar_managingothers: () => import("./ManagingOthersIcon-Cc8rhKJO.js"),
  sidebar_organization: () => import("./OrganizationIcon-CV_-fu61.js"),
  sidebaradmin_account: () => import("./AccountIcon-CYmZQl5k.js"),
  popup_check_circle: () => import("./CheckCircle-C9d_HkVx.js"),
  pass_check_circle: () => import("./CheckCircle-Dh5Q_p5p.js"),
  fail_cross_circle: () => import("./CrossCircle-CZ3YSlMA.js"),
  obsolete_lightning_bolt: () => import("./LightningBolt-Bt1CpD6B.js"),
  popup_pay_range: () => import("./PayRange-CsNRvWnx.js"),
  popup_close: () => import("./ClosePopup-MnXDAtOC.js"),
  interface_close: () => import("./CloseIcon-BvgmS6bI.js"),
  interface_close_circle: () => import("./CloseCircleIcon-DLa8cBt3.js"),
  org_icon_position: () => import("./PositionIcon-i73Q0iwl.js"),
  org_icon_jobfamily: () => import("./JobFamilyIcon-DBEJQZv3.js"),
  org_icon_jobcategory: () => import("./JobCategoryIcon-YnzT_xCC.js"),
  org_icon_role: () => import("./RoleIcon-BuHNuKwH.js"),
  org_icon_responsibility: () => import("./ResponsibilityIcon-BzqYO7qw.js"),
  org_icon_responsibility_template: () => import("./ResponsibilityTemplateIcon-BnctX36F.js"),
  org_icon_role_template: () => import("./RoleTemplateIcon-CwGnQZlr.js"),
  org_icon_knowledge: () => import("./KnowledgeIcon-D_CfEPST.js"),
  org_icon_online_course: () => import("./OnlineCourseIcon-B44EDSWu.js"),
  org_icon_course: () => import("./CourseIcon-BI-zIyHl.js"),
  org_icon_workshop: () => import("./WorkshopIcon-JTjphOFG.js"),
  org_icon_book: () => import("./BookIcon-DSwQZALY.js"),
  org_icon_chapter: () => import("./ChapterIcon-DIOoeltS.js"),
  org_icon_lesson: () => import("./LessonIcon-CV1ahQcD.js"),
  org_icon_featured_position: () => import("./FeaturedPositionIcon-BrD8b9Qw.js"),
  org_icon_attach: () => import("./Attach-CaNdYKnx.js"),
  interface_email: () => import("./EmailIcon-cMVYHPP7.js"),
  employee_add: () => import("./AddEmployeeIcon-BKnCQrv6.js"),
  occup_beg: () => import("./OccupationBegIcon-DvdsBNHV.js"),
  occup_theater: () => import("./OccupationTheaterIcon-DC7Dxd_I.js"),
  interface_search: () => import("./SearchIcon-c4-idiGl.js"),
  ask_question_attach: () => import("./AskQuestionAttachIcon-D6C5B9w4.js"),
  ask_question_send: () => import("./AskQuestionSendIcon-BlpUYCmc.js"),
  apprentice_icon: () => import("./ApprenticeIcon-Dfq3yrKw.js"),
  apprentice_icon_new: () => import("./ApprenticeIconNew-D4lUOjqy.js"),
  coach_icon: () => import("./CoachIcon-B3ShHOv6.js"),
  coach_icon_new: () => import("./CoachIconNew-D0iDm8wn.js"),
  master_icon: () => import("./MasterIcon-C1u_J69g.js"),
  master_icon_new: () => import("./MasterIconNew-D9_HAFvv.js"),
  professional_icon: () => import("./ProfessionalIcon-BH5VaEag.js"),
  professional_icon_new: () => import("./ProfessionalIconNew-BFOJwREk.js"),
  employee_search: () => import("./SearchEmployeeIcon-D9L8DwHD.js"),
  badge_indicator: () => import("./ExBadgeIndicatorIcon-Dx4dp6Mm.js"),
  badge_not_expire: () => import("./ExBadgeNotExpireIndicatorIcon-DLnX_HZX.js"),
  badge_expire: () => import("./ExBadgeExpireIndicatorIcon-MjUskudT.js"),
  badge_has_expire: () => import("./ExBadgeHasExpireIndicatorIcon-CfnBd4qH.js"),
  badge_about_expire: () => import("./ExBadgeAboutExpireIndicatorIcon-D5m9c_Lc.js"),
  badge_about_expire_soon: () => import("./ExBadgeAboutExpireSoonIcon-DvbegXdX.js"),
  badge_today_expire: () => import("./ExBadgeTodayExpireIndicatorIcon-Fcqt1o93.js"),
  badge_past_expiration: () => import("./ExBadgePastExpirationIcon-CQOBWKZq.js"),
  calendar_icon_date: () => import("./CalendarIconDateIcon-ZbW3Zek_.js"),
  calendar_icon_obsolete_date: () => import("./CalendarIconObsoleteDateIcon-BlQeIUvT.js"),
  employee_picker: () => import("./EmployeeModalIcon-Dvm64w7M.js"),
  checklist_icon: () => import("./ExCheckListIcon-BspDF819.js"),
  publish_quiz_modal_icon: () => import("./PublishQuizModalIcon-D6TFj1Su.js"),
  rename_action: () => import("./RenamePositionIcon-DrZTIYO6.js"),
  vacant_position: () => import("./VacantPosition-CHAlNIR2.js"),
  has_access_owner: () => import("./HasAccessOwnerIcon-BItwy5W9.js"),
  suspended_owner: () => import("./SuspendedOwnerIcon-KNZLJg3k.js"),
  blocked_owner: () => import("./BlockedOwnerIcon-D22LlAKw.js"),
  has_access_co_owner: () => import("./HasAccessCoOwnerIcon-DobP9_iV.js"),
  suspended_co_owner: () => import("./SuspendedCoOwnerIcon-CKjitAjt.js"),
  blocked_co_owner: () => import("./BlockedCoOwnerIcon-CL8fjeeU.js"),
  has_access_app_user: () => import("./HasAccessAppsUserIcon-DF7WS4Wl.js"),
  suspended_app_user: () => import("./SuspendedAppsUserIcon-B-urk9gV.js"),
  blocked_app_user: () => import("./BlockedAppsUserIcon-BqnlqTYx.js"),
  expiration_indicator_has_expiration: () => import("./HasExpiration-BIBYgTXG.js"),
  expiration_indicator_has_expiration_if_obsolete: () => import("./HasExpirationIfObsolete-hkz3pQ1A.js"),
  expiration_indicator_about_to_expire: () => import("./AboutToExpire-DY17x97K.js"),
  expiration_indicator_add_expiration: () => import("./AddExpirationIcon-BXcFIUtY.js"),
  expiration_indicator_does_not_expire: () => import("./DoesNotExpireIcon-CKH9dQTo.js"),
  ex_Terminated: () => import("./ExTerminatedNew-rVsuzoWy.js"),
  ex_Removed: () => import("./ExRemoved-BCuS2rgc.js"),
  ex_Expired: () => import("./ExExpiredNew-CytvM3bF.js"),
  ex_pro_badge_holder_close: () => import("./ExClose-D3k4PGU2.js"),
  notification_bell: () => import("./BellIcon-BncnSZp2.js"),
  notification_item_file: () => import("./FileIcon-ChWHCnK5.js"),
  notification_check_icon: () => import("./CheckIcon-DQNU3EuU.js"),
  chevron_right: () => import("./ChevronRight-CJlSjI2k.js"),
  chevron_down: () => import("./ChevronDownIcon-BhiDCdj6.js"),
  arrow_narrow_left_icon: () => import("./ArrowNarrowLeftIcon-pHijMr_v.js"),
  expand_03_icon: () => import("./Expand03Icon-RyF0vGqj.js"),
  link_external_icon: () => import("./LinkExternalIcon-DowCAGgQ.js"),
  breadcrumb_home: () => import("./BreadcrumbHome-nbCl73iN.js"),
  breadcrumb_ellipsis: () => import("./ellipsis-DlcmmT3Z.js"),
  accepted_icon: () => import("./AcceptedIcon-Du3erfrR.js"),
  primary_icon: () => import("./PrimaryIcon-BSezTLdB.js"),
  acting_as_icon: () => import("./ActingAsIcon-D41FiwHN.js"),
  backing_up_icon: () => import("./BackingUpIcon-DXoWLtG_.js"),
  preparing_for_icon: () => import("./PreparingForIcon-BT0_Y6KN.js"),
  e_learning_icon: () => import("./ELearningIcon-BEXSlJPU.js"),
  book_icon: () => import("./BookIcon-Cc21ORdz.js"),
  external_course_icon: () => import("./ExternalCourseIcon-C2r7zzUi.js"),
  workshop_icon: () => import("./WorkshopIcon-DSQe-X_z.js"),
  knowledge_icon: () => import("./KnowledgeIcon-CGVQ0vwf.js"),
  role_icon: () => import("./RoleIcon-CGVAnkMu.js"),
  position_icon: () => import("./PositionIcon-BnyMKs4G.js"),
  responsibility_icon: () => import("./ResponsibilityIcon-D9wA43PP.js"),
  position_check_icon: () => import("./PositionCheckIcon-CtHsisVp.js"),
  role_check_icon: () => import("./RoleCheckIcon-Da34Svs7.js"),
  line_pointer_icon: () => import("./LinePointer-Kqdo3wTW.js"),
  grant_dot_icon: () => import("./GrantDot-C1stiq55.js"),
  force_dot_icon: () => import("./ForceDot-C06axLrG.js"),
  force_plus_icon: () => import("./ForcePlus-CEtsJkjy.js"),
  grant_plus_icon: () => import("./GrantPlus-txUwbSX1.js"),
  forgot_password_key_icon: () => import("./KeyIcon-BKEErpa4.js"),
  forgot_password_credits_icon: () => import("./CreditsIcon-CpfN3EKw.js"),
  forgot_password_email_icon: () => import("./EmailIcon-BVkC36m2.js"),
  forgot_password_password_icon: () => import("./PasswordIcon-kT8RoWbO.js"),
  search_lg: () => import("./SearchLg-CawgPoxA.js"),
  ex_pro_badge_holder_hover_close: () => import("./ExHoverClose-BUwzTMeB.js"),
  org_icon_checkpoint: () => import("./checkpoint-CqfDGwVr.js"),
  checkpoint_pass: () => import("./CheckpointPass-3lLhE-og.js"),
  checkpoint_pass_green: () => import("./CheckpointPassGreen-CGAVRtKr.js"),
  renewal_interuption_icon: () => import("./RenewalInteruption-DJ57opLG.js"),
  unlimited_icon: () => import("./Unlimited-D-815WNc.js"),
  renewal_upgrade_icon: () => import("./RenewalUpgrade-C4AR802F.js"),
  renewal_icon: () => import("./Renewal-vBMDWUvC.js"),
  free_trial_icon: () => import("./FreeTrial-jiv43UJr.js"),
  first_upgrade_icon: () => import("./FirstUpgrade-Bmj8P55F.js"),
  first_icon: () => import("./First-DM237_LB.js"),
  alert_icon: () => import("./Alert-Cjz1s3KX.js"),
  sidebar_company_big: () => import("./CompanyBig-CtOty1HG.js"),
  alert: () => import("./AlertIcon-BhwUTJtS.js"),
  accounts_destructive: () => import("./Accounts-D1pRjt9q.js"),
  info_icon: () => import("./InfoIcon-iXZFHrs-.js"),
  sidebar_support: () => import("./Support-CWYuyQs6.js"),
  sidebar_settings: () => import("./Settings-DOP7xHMm.js"),
  simple_position_icon: () => import("./AssignmentAllocationPositionIcon-C5dcRIDp.js"),
  simple_position_person_icon: () => import("./SimplePositionPersonIcon-OO5dN3s0.js"),
  primary_alert: () => import("./PrimaryAlert-D-It_MNn.js"),
  expired_icon: () => import("./ExpiredIcon-Dm98vd_d.js"),
  terminated_icon: () => import("./TerminatedIcon-DJeo422x.js"),
  removed_icon: () => import("./RemovedIcon-C9vt7uFa.js"),
  removed_icon_gray: () => import("./RemovedIconGray-ZNlV3hQ2.js"),
  help_info_icon: () => import("./HelpInfoIcon-tiz5Mo9q.js"),
  evaluate_icon: () => import("./Evaluate-KnXha0jT.js"),
  logout_icon: () => import("./Logout-CqS7XKxm.js"),
  chevron_right_icon: () => import("./ChevronRight-BNTLC1_k.js"),
  checklist_board_black: () => import("./ChecklistBoardBlack-BH-v7bw1.js"),
  checklist_board_white: () => import("./ChecklistBoardWhite-KYmcn39U.js"),
  readiness_video_icon: () => import("./ReadinessVideoIcon-Ck67ha0I.js"),
  no_microlearning: () => import("./NoMicrolearningIcon-CeU2QUuv.js"),
  add_video: () => import("./AddVideoIcon-BMW86Xar.js"),
  watched_video: () => import("./WatchedVideoIcon-C0hilWrD.js"),
  pending_task_video: () => import("./PendingTaskVideoIcon-DhUqz5dV.js"),
  inspection_request_checklist: () => import("./inspectionChecklist-zVKi0DIk.js"),
  archive_icon: () => import("./ArchiveIcon-DdX15vZE.js"),
  unarchive_icon: () => import("./UnArchiveIcon-C5OfRMj7.js"),
  stars_icon: () => import("./StarsIcon-BawtnxKN.js"),
  kpi_badge_danger_icon: () => import("./KpiDangerIcon-DeFL4Ip4.js"),
  kpi_badge_success_icon: () => import("./KpiSuccessIcon-BhpXvPvb.js"),
  paid_assign_badge_base_icon: () => import("./grayArrowIcon-CUaKGrxM.js"),
  paid_assign_badge_overpaid_icon: () => import("./redDownArrowIcon-CHTxbhLY.js"),
  paid_assign_badge_adjustment_icon: () => import("./blueUpArrow-DQ8WL3E1.js"),
  paid_assign_badge_lover_icon: () => import("./greenChevronUp-C1TR5b_8.js"),
  paid_assign_badge_higher_icon: () => import("./greenChevronDown-DlRUzvGZ.js"),
  paid_assign_badge_over_range_icon: () => import("./dbDownRedArrow-CMZD5fi5.js"),
  paid_assign_badge_under_range_icon: () => import("./dbUpRedArrow-B5IsU216.js"),
  paid_assign_badge_fair_icon: () => import("./dbGreenRightChevron-Cdnq7zO-.js"),
  paid_assign_badge_position_icon: () => import("./smPosition-CAfQ1XlE.js"),
  scorecard_icon: () => import("./ScoreCardIcon-lNhvmlI6.js"),
  perspective_customer_icon: () => import("./CustomerIcon-2hqV5U-y.js"),
  perspective_financial_icon: () => import("./FinancialIcon-EkeYdZb6.js"),
  perspective_operations_icon: () => import("./OperationsIcon-DS8zf3Pw.js"),
  perspective_capacity_icon: () => import("./OrgCapacityIcon-DTIhht6D.js"),
  pay_range_right_icon: () => import("./PayRangeAlignRight-CIHFNArk.js"),
  pay_range_left_icon: () => import("./PayRangeAlignLeft-CkAhvIoO.js"),
  pay_range_top_icon: () => import("./PayRangeAlignTop-C4wjy6bq.js"),
  pay_range_bottom_icon: () => import("./PayRangeAlignBottom-1U0pMdh-.js"),
  pay_range_red_icon: () => import("./PayRangeRedIcon-CVAEKoL8.js"),
  pay_range_green_icon: () => import("./PayRangeGreenIcon-D3rXjHrc.js"),
  pay_range_blue_icon: () => import("./PayRangeBlueIcon-Cs325VRL.js"),
  searchbar_clear_selected: () => import("./ClearSelected-ChM44t3y.js"),
  collapse_icon: () => import("./CollapseIcon-B3D3PtNr.js"),
  expand_icon: () => import("./ExpandIcon-CwOVZoBB.js"),
  strategy_map_icon: () => import("./StrategyMapHeaderIcon-BFJ0cQo7.js"),
  reason_modal: () => import("./ReasonModalIcon-DNaHdZjq.js"),
  comment_icon: () => import("./commentIcon-DJWqp_67.js"),
  pay_range_editor_icon: () => import("./PayRangeEditorIcon-Bs4Q_zHw.js"),
  kpi_modal_icon: () => import("./KpiModalIcon-BvFp_J-3.js"),
  kpi_add_dialog_icon: () => import("./KpiAddDialogIcon-CSWhjZnT.js"),
  // A .vue wrapper, NOT the raw .svg: webpack resolves an asset import to a URL string and
  // `<component :is>` renders a string as a tag name — createElement('static/media/…svg')
  // threw on every screen showing it (ER-11180). Wrapper keeps stroke-width 1.5, so the
  // visual is unchanged; BadgeHolderTable/ChatterIcon.vue is the heavier 2.0 variant.
  chatter_icon: () => import("./ChatterIcon-Ds-Kd87F.js"),
  metrics_icon: () => import("./MetricsIcon-oaUBljq-.js"),
  rejected_icon: () => import("./RejectedIcon-C_UbHz8T.js"),
  accepted_icon: () => import("./AcceptedIcon-jofHCf5p.js"),
  pending_icon: () => import("./PendingIcon-BXa2eUdr.js"),
  rollup_icon: () => import("./RollUpIcon-C2pYW0q1.js"),
  kpi_icon: () => import("./KPIIcon-9RlDv2vH.js"),
  kpi_new_icon: () => import("./KpiNewIcon-BsHu-wOV.js"),
  badge_holder_chatter_icon: () => import("./ChatterIcon-CnBCxq8N.js"),
  currency_icon: () => import("./Currency-Z_TEyGnk.js"),
  org_icon_position_hover: () => import("./PositionHoverIcon-DCeGzH71.js"),
  help_icon: () => import("./HelpIcon-Bab4BbaE.js"),
  position_counter_icon: () => import("./PositionCounterIcon-DAFIsyOw.js"),
  grid_icon: () => import("./GridDots-XwmchtV3.js"),
  account_icon: () => import("./AccountIcon-Dh5StzJj.js"),
  effective_on_icon: () => import("./EffectiveOn-zfWcVxj3.js"),
  effective_by_icon: () => import("./EffectiveBy-BWoZhv1J.js"),
  briefcase_icon: () => import("./BriefcaseIcon-CULTUEmb.js"),
  preparing_icon: () => import("./PreparingIcon-DjhpG-kd.js"),
  acknowledged_yes_icon: () => import("./AcknowledgedYesIcon-BqVoh2iS.js"),
  acknowledged_no_icon: () => import("./AcknowledgedNoIcon-IUbdlVsL.js"),
  acknowledged_not_required_icon: () => import("./AcknowledgedNotRequiredIcon-BbKjNn7_.js"),
  expiration_icon_add: () => import("./AddExpirationIcon-WtzIY-iH.js"),
  expiration_icon_edit: () => import("./EditExpirationIcon-DrNG0wbg.js"),
  expiration_icon_if_obsolete: () => import("./IfObsoleteExpirationIcon-aHvkHwJr.js"),
  expiration_icon_soon: () => import("./SoonExpirationIcon-DA5i5whm.js"),
  expiration_icon_tonight: () => import("./TonightExpirationIcon-DIJ63xkZ.js"),
  expiration_icon_add_apprentice: () => import("./AddExpirationApprenticeIcon-UiN0bTqU.js"),
  expiration_icon_edit_apprentice: () => import("./EditExpirationApprenticeIcon-CYMFB9E_.js"),
  expiration_icon_if_obsolete_apprentice: () => import("./IfObsoleteExpirationApprenticeIcon-DEbNA59h.js"),
  expiration_icon_soon_apprentice: () => import("./SoonExpirationApprenticeIcon-DJAHcMiP.js"),
  expiration_icon_tonight_apprentice: () => import("./TonightExpirationApprenticeIcon-CV6pLwsk.js"),
  expiration_icon_add_coach: () => import("./AddExpirationCoachIcon-Cz3VNIx_.js"),
  expiration_icon_edit_coach: () => import("./EditExpirationCoachIcon-COlJ34yc.js"),
  expiration_icon_if_obsolete_coach: () => import("./IfObsoleteExpirationCoachIcon-CACz51DF.js"),
  expiration_icon_soon_coach: () => import("./SoonExpirationCoachIcon-e6glNiPx.js"),
  expiration_icon_tonight_coach: () => import("./TonightExpirationCoachIcon-CQzoNGm8.js"),
  expiration_icon_add_architect: () => import("./AddExpirationArchitectIcon-Dvhcwztd.js"),
  expiration_icon_edit_architect: () => import("./EditExpirationArchitectIcon-_ffBwvqh.js"),
  expiration_icon_if_obsolete_architect: () => import("./IfObsoleteExpirationArchitectIcon-t4nhuthP.js"),
  expiration_icon_soon_architect: () => import("./SoonExpirationArchitectIcon-C7eeUc2j.js"),
  expiration_icon_tonight_architect: () => import("./TonightExpirationArchitectIcon-NQGerghl.js"),
  expiration_icon_add_proficient: () => import("./AddExpirationProficientIcon-Da8uCODD.js"),
  expiration_icon_edit_proficient: () => import("./EditExpirationProficientIcon-B1DGAXQa.js"),
  expiration_icon_if_obsolete_proficient: () => import("./IfObsoleteExpirationProficientIcon-BsNTVD6y.js"),
  expiration_icon_soon_proficient: () => import("./SoonExpirationProficientIcon-D3Iik7cB.js"),
  expiration_icon_tonight_proficient: () => import("./TonightExpirationProficientIcon-DjL1Ltuk.js"),
  country_icon: () => import("./CountryIcon-BUN8xhh5.js"),
  expiration_icon_read_only: () => import("./ReadOnlyIcon-B3jKxWQ1.js"),
  expiration_icon_read_only_apprentice: () => import("./ReadOnlyApprenticeIcon-BzDJP0s8.js"),
  expiration_icon_read_only_proficient: () => import("./ReadOnlyProficientIcon-Bw2bCkfa.js"),
  expiration_icon_read_only_coach: () => import("./ReadOnlyCoachIcon-D3jLk9SF.js"),
  expiration_icon_read_only_architect: () => import("./ReadOnlyArchitectIcon-sd-1Qlhx.js"),
  arrow_up_icon: () => import("./ArrowUpIcon-DI8ASR_l.js"),
  arrow_down_icon: () => import("./ArrowDownIcon-DjNVTcNg.js"),
  trend_up_icon: () => import("./TrendUpIcon-C6h4XA5g.js"),
  trend_down_icon: () => import("./TrendDownIcon-zLh9XoeZ.js"),
  arrow_right_icon: () => import("./ArrowRightIcon-Bf8B67WK.js"),
  iq_large_icon: () => import("./IQLargeIcon-D2MpA0Qw.js"),
  iq_extlarge_icon: () => import("./IQExtLargeIcon-C_3_XUNg.js"),
  iq_small_icon: () => import("./IQSmallIcon-BEHnwdM9.js"),
  new_line_pointer_icon: () => import("./NewLinePointer-CXaR__JE.js"),
  instructions_icon: () => import("./InstructionsIcon-BbgssLg3.js"),
  microlearning_icon: () => import("./MicrolearningIcon-Czn_Fp5z.js"),
  generate_microlearning_header: () => import("./GenerateMicrolearningHeaderIcon-lyFZkAJQ.js"),
  quiz_icon: () => import("./QuizIcon-Dte7JoqU.js"),
  employee_banner_add: () => import("./AddEmployeeBannerIcon-BDdGvO_g.js"),
  employee_new_icon: () => import("./AddEmployeeNewIcon-rgxx4aEw.js"),
  book_stack_icon: () => import("./BookStackIcon-HMGuW54N.js"),
  book_stack_home: () => import("./HomeIcon-Dd3pkikM.js"),
  book_stack_book: () => import("./BookIcon-CpASX86U.js"),
  book_stack_chapter: () => import("./ChapterIcon-DIOoeltS.js"),
  book_stack_procedure: () => import("./ProcedureIcon-DYwTJg1B.js"),
  book_stack_versions: () => import("./VersionsIcon-CWhguNuv.js"),
  book_stack_separator: () => import("./BreadcrumbSeparator-CoZKkr54.js"),
  ability_icon: () => import("./Ability-BhUNegok.js"),
  behaviour_icon: () => import("./Behaviour-dsksl4LN.js"),
  knowledge_icon: () => import("./Knowledge-Dy4S6OYj.js"),
  confirmation_toast_icon: () => import("./ConfirmationToastIcon-Ccu9axJI.js"),
  problem_toast_icon: () => import("./ProblemToastIcon-CDnWsFxW.js"),
  remove_video_instructions_icon: () => import("./RemoveVideoInstructionsIcon-DoJjlUJn.js"),
  trash_03: () => import("./Trash03Icon-BoZJkysV.js"),
  check_circle: () => import("./CheckCircleIcon-Bc_20YeO.js"),
  org_icon_book_closed: () => import("./BookClosed-ei4Mqd78.js"),
  org_icon_procedure: () => import("./ProcedureIcon-DYwTJg1B.js"),
  checkpoint_video: () => import("./SquarePlayIcon-Bngq9v69.js"),
  checkpoint_info: () => import("./SquareInfoIcon-b-tB7H03.js"),
  actual_calculation_check_icon: () => import("./CheckIcon-BvclDFfb.js"),
  quiz_attempt_wizard_icon: () => import("./QuizAttemptWizardIcon-DH12LED1.js"),
  from_to_date_icon: () => import("./FromToDateIcon-CR5X_XTd.js"),
  date_to_from_icon: () => import("./DateToFromIcon-Cdp3buSe.js"),
  no_inspectors_icon: () => import("./NoInspectors-CD-Uqpyn.js"),
  chevron_double_icon: () => import("./ChevronDouble-_ZVRCgcA.js"),
  chevron_divider_icon: () => import("./ChevronDivider-eDWm3RJs.js"),
  perspective_financial: () => import("./FinancialIcon-EkeYdZb6.js"),
  perspective_customer: () => import("./CustomerIcon-2hqV5U-y.js"),
  perspective_operations: () => import("./OperationsIcon-DS8zf3Pw.js"),
  perspective_organizational_capacity: () => import("./OrgCapacityIcon-DTIhht6D.js"),
  pencil_line_icon: () => import("./PencilLineIcon-FUDCxKec.js"),
  calendar_icon: () => import("./CalendarIcon-DnWZJGGr.js"),
  language_translate: () => import("./TranslateIcon-DWjdtnSk.js"),
  lock_icon: () => import("./LockIcon-D2NcklK6.js"),
  template_icon: () => import("./TemplateIcon-8FgqP-87.js"),
  play_square_icon: () => import("./PlaySquareIcon-divLMlGS.js"),
  badge_icon: () => import("./BadgeIcon-CnaEf0N2.js"),
  corner_up_right_icon: () => import("./CornerUpRight-mjlm9A5y.js"),
  top_arrow_icon: () => import("./TopArrow-D9XlMkPi.js"),
  x_close_icon: () => import("./XClose-BrXMyn4p.js"),
  vacant_position_icon: () => import("./VacantPosition-nh2jyop1.js"),
  replace_icon: () => import("./ReplaceIcon-CMVPnFpi.js"),
  status_collapsed_icon: () => import("./StatusCollapsedIcon-Bt_OQk1X.js"),
  status_expanded_icon: () => import("./StatusExpandedIcon-BV1ZgoKq.js"),
  status_no_expand_icon: () => import("./StatusNoExpandIcon-XKWmj9iy.js"),
  drag_handle_icon: () => import("./DragHandleIcon-BKvtOvqE.js"),
  org_icon_department: () => import("./DepartmentIcon-DinTmIc9.js"),
  department_picker_icon: () => import("./DepartmentPickerIcon-C3FIM2BZ.js"),
  department_icon: () => import("./DepartmentIcon-OUA6LaB3.js"),
  department_featured_icon: () => import("./DepartmentFeaturedIcon-E4X_wATw.js"),
  app_user_icon: () => import("./AppUserIcon-C0IHeYdY.js"),
  qr_code: () => import("./QrCodeIcon-uoeQLnd4.js"),
  inspection_icon: () => import("./InspectionIcon-IgY5pHxv.js"),
  article_icon: () => import("./ArticleIcon-D3xKuFSq.js"),
  video_icon: () => import("./VideoIcon-BJKgVaJF.js"),
  quiz_icon: () => import("./QuizIcon-DWMNShiX.js"),
  department_tag_icon: () => import("./DepartmentTagIcon-DmIFv6R-.js"),
  mini_department_tag_icon: () => import("./MiniDepartmentTagIcon-DOHmVQDA.js"),
  no_learning_info_circle: () => import("./NoLearningInfoCircleIcon-DSj0Qnyy.js"),
  sparkle_empty: () => import("./SparkleEmptyIcon--oh4V93x.js"),
  alert_circle: () => import("./AlertCircleIcon-HMF_GrwC.js"),
  alert_triangle: () => import("./AlertTriangleIcon-D8tyXMVx.js"),
  lock_checkpoint_icon: () => import("./LockCheckpointIcon-DZFInsDH.js")
}, FR = {
  name: "Icon",
  props: {
    name: {
      type: String,
      required: !0,
      validator(t) {
        return Object.prototype.hasOwnProperty.call(rQ, t);
      }
    },
    color: {
      type: String,
      default: "dark"
    },
    size: {
      type: String,
      validator: function(t) {
        return ["normal", "small", "extra-small", "large"].includes(t);
      },
      default: "normal"
    },
    disabled: {
      type: Boolean,
      default: !1
    },
    active: {
      type: Boolean,
      default: !1
    }
  },
  data() {
    return {
      iconComponent: null
    };
  },
  async mounted() {
    this.loadIconComponent();
  },
  watch: {
    name: function() {
      this.loadIconComponent();
    }
  },
  methods: {
    async loadIconComponent() {
      if (await rQ[this.name]) {
        const t = await rQ[this.name]();
        this.iconComponent = t.default || t;
      }
    }
  }
};
function NR(t, e, A, n, s, r) {
  return ee(), Lo(ck(s.iconComponent), {
    color: A.color,
    size: A.size,
    disabled: A.disabled,
    active: A.active
  }, null, 8, ["color", "size", "disabled", "active"]);
}
const CC = /* @__PURE__ */ ZA(FR, [["render", NR]]), DR = ":host{display:block}.procedures-breadcrumb{padding:8px 0;display:flex;align-items:center}.d-flex{display:flex}.align-center{align-items:center}.mx-2{margin-left:8px;margin-right:8px}.mr-2{margin-right:8px}.breadcrumb-item{cursor:pointer;transition:all .2s ease;padding:4px 8px;border-radius:6px;display:flex;align-items:center;background-color:transparent}.breadcrumb-item:hover{background-color:#f9fafb}.item-icon{flex-shrink:0;display:flex;align-items:center}.item-label{font-family:Inter,sans-serif;font-size:14px;font-weight:500;line-height:20px;color:#475467;transition:color .2s ease}.breadcrumb-item:hover .item-label{color:#101828}.breadcrumb-item.is-active{background-color:#f9f5ff}.breadcrumb-item.no-label{padding:0;width:34px;height:30px;justify-content:center}.breadcrumb-item.is-active .item-label{color:#6941c6;font-weight:600;padding:0;background-color:transparent}.breadcrumb-item:not(.is-active) .item-label{color:#475467;font-weight:500}.breadcrumb-item.is-active:hover{background-color:#f4ebff}.breadcrumb-separator{display:flex;align-items:center}", xR = { class: "procedures-breadcrumb d-flex align-center" }, GR = {
  key: 0,
  class: "breadcrumb-separator mx-2"
}, zR = ["onMouseenter", "onClick"], UR = {
  key: 0,
  class: "item-label"
}, bR = {
  __name: "ProceduresBreadcrumb.ce",
  props: {
    location: {
      type: String,
      default: "Book"
    },
    bookName: {
      type: String,
      default: "Book Name"
    },
    chapterName: {
      type: String,
      default: "Chapter Name"
    },
    procedureName: {
      type: String,
      default: "Procedure"
    }
  },
  emits: ["onClick"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = /* @__PURE__ */ me(null), r = (a) => {
      n("onClick", {
        type: a.type,
        label: a.label || "Home"
      });
    }, i = Fe(() => {
      const a = [{ type: "home", active: !1 }];
      return A.location === "Book" ? a.push({ type: "book", label: A.bookName, active: !0 }) : A.location === "Chapter" ? (a.push({ type: "book", label: A.bookName, active: !1 }), a.push({ type: "chapter", label: "Chapter", active: !0 })) : A.location === "Procedure in Chapter" ? (a.push({ type: "book", label: A.bookName, active: !1 }), a.push({ type: "chapter", label: A.chapterName, active: !1 }), a.push({ type: "procedure", label: A.procedureName, active: !0 })) : A.location === "Procedure in Book" && (a.push({ type: "book", label: A.bookName, active: !1 }), a.push({ type: "procedure", label: A.procedureName, active: !0 })), a;
    }), o = (a) => ({
      home: "book_stack_home",
      book: "book_stack_book",
      chapter: "book_stack_chapter",
      procedure: "book_stack_procedure"
    })[a] || "book_stack_icon";
    return (a, c) => (ee(), Ae("nav", xR, [
      (ee(!0), Ae(ft, null, Ns(i.value, (l, B) => (ee(), Ae("div", {
        key: B,
        class: "breadcrumb-item-wrapper d-flex align-center"
      }, [
        B > 0 ? (ee(), Ae("div", GR, [
          rt(CC, { name: "book_stack_separator" })
        ])) : je("", !0),
        F("div", {
          class: De(["breadcrumb-item d-flex align-center", {
            "is-active": l.active || s.value === B,
            "no-label": !l.label
          }]),
          onMouseenter: (g) => s.value = B,
          onMouseleave: c[0] || (c[0] = (g) => s.value = null),
          onClick: (g) => r(l)
        }, [
          F("div", {
            class: De(["item-icon d-flex align-center", { "mr-2": l.label }])
          }, [
            rt(CC, {
              name: o(l.type),
              active: l.active || s.value === B
            }, null, 8, ["name", "active"])
          ], 2),
          l.label ? (ee(), Ae("span", UR, Mt(l.label), 1)) : je("", !0)
        ], 42, zR)
      ]))), 128))
    ]));
  }
}, vR = /* @__PURE__ */ ZA(bR, [["styles", [DR]]]), fx = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%206C12.5523%206%2013%205.55228%2013%205C13%204.44772%2012.5523%204%2012%204C11.4477%204%2011%204.44772%2011%205C11%205.55228%2011.4477%206%2012%206Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M12%2013C12.5523%2013%2013%2012.5523%2013%2012C13%2011.4477%2012.5523%2011%2012%2011C11.4477%2011%2011%2011.4477%2011%2012C11%2012.5523%2011.4477%2013%2012%2013Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M12%2020C12.5523%2020%2013%2019.5523%2013%2019C13%2018.4477%2012.5523%2018%2012%2018C11.4477%2018%2011%2018.4477%2011%2019C11%2019.5523%2011.4477%2020%2012%2020Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M19%206C19.5523%206%2020%205.55228%2020%205C20%204.44772%2019.5523%204%2019%204C18.4477%204%2018%204.44772%2018%205C18%205.55228%2018.4477%206%2019%206Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M19%2013C19.5523%2013%2020%2012.5523%2020%2012C20%2011.4477%2019.5523%2011%2019%2011C18.4477%2011%2018%2011.4477%2018%2012C18%2012.5523%2018.4477%2013%2019%2013Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M19%2020C19.5523%2020%2020%2019.5523%2020%2019C20%2018.4477%2019.5523%2018%2019%2018C18.4477%2018%2018%2018.4477%2018%2019C18%2019.5523%2018.4477%2020%2019%2020Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5%206C5.55228%206%206%205.55228%206%205C6%204.44772%205.55228%204%205%204C4.44772%204%204%204.44772%204%205C4%205.55228%204.44772%206%205%206Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5%2013C5.55228%2013%206%2012.5523%206%2012C6%2011.4477%205.55228%2011%205%2011C4.44772%2011%204%2011.4477%204%2012C4%2012.5523%204.44772%2013%205%2013Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M5%2020C5.55228%2020%206%2019.5523%206%2019C6%2018.4477%205.55228%2018%205%2018C4.44772%2018%204%2018.4477%204%2019C4%2019.5523%204.44772%2020%205%2020Z'%20stroke='black'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", Qx = "data:image/svg+xml,%3csvg%20width='24'%20height='24'%20viewBox='0%200%2024%2024'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M12%2013C12.5523%2013%2013%2012.5523%2013%2012C13%2011.4477%2012.5523%2011%2012%2011C11.4477%2011%2011%2011.4477%2011%2012C11%2012.5523%2011.4477%2013%2012%2013Z'%20stroke='%23101828'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M12%206C12.5523%206%2013%205.55228%2013%205C13%204.44772%2012.5523%204%2012%204C11.4477%204%2011%204.44772%2011%205C11%205.55228%2011.4477%206%2012%206Z'%20stroke='%23101828'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3cpath%20d='M12%2020C12.5523%2020%2013%2019.5523%2013%2019C13%2018.4477%2012.5523%2018%2012%2018C11.4477%2018%2011%2018.4477%2011%2019C11%2019.5523%2011.4477%2020%2012%2020Z'%20stroke='%23101828'%20stroke-width='2'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", jR = { class: "content" }, HR = {
  key: 0,
  class: "drag-icon"
}, kR = ["src"], RR = { class: "procedure-name" }, LR = ["src"], SR = /* @__PURE__ */ Un({
  shadow: !1,
  __name: "BookProcedureLine.ce",
  props: {
    name: {
      type: String,
      required: !0
    },
    status: {
      type: String,
      default: "Draft"
    },
    editable: {
      type: Boolean,
      default: !0
    }
  },
  emits: ["menu-click"],
  setup(t, { emit: e }) {
    const A = t, n = /* @__PURE__ */ me(!1), s = Fe(() => {
      switch (A.status) {
        case "Draft":
          return "status-draft";
        case "Published":
          return "status-published";
        case "Has Pending Changes":
          return "status-pending";
        default:
          return "status-draft";
      }
    }), r = Fe(() => A.status);
    return (i, o) => (ee(), Ae("div", {
      class: De(["book-procedure-line", { "is-hovered": n.value }]),
      onMouseenter: o[1] || (o[1] = (a) => n.value = !0),
      onMouseleave: o[2] || (o[2] = (a) => n.value = !1)
    }, [
      o[3] || (o[3] = F("div", { class: "blue-bar" }, null, -1)),
      F("div", jR, [
        t.editable ? (ee(), Ae("div", HR, [
          F("img", {
            src: bs(fx),
            alt: "Drag handle"
          }, null, 8, kR)
        ])) : je("", !0),
        F("div", RR, Mt(t.name), 1),
        F("div", {
          class: De(["status-badge", s.value])
        }, Mt(r.value), 3),
        F("div", {
          class: "menu-icon",
          onClick: o[0] || (o[0] = (a) => i.$emit("menu-click"))
        }, [
          F("img", {
            src: bs(Qx),
            alt: "Menu"
          }, null, 8, LR)
        ])
      ])
    ], 34));
  }
}), TR = ":host{display:block;width:100%}.book-procedure-line{display:flex;align-items:stretch;width:100%;height:65px;background-color:#fff;position:relative}.blue-bar{width:7px;height:100%;background-color:#026aa2;flex-shrink:0}.content{flex:1;display:flex;align-items:center;gap:10px;padding:0 5px 0 21px;background-color:#f2f2f2;transition:background-color .2s ease;min-width:0}.book-procedure-line.is-hovered .content{background-color:#ece6f9}.drag-icon{width:24px;height:24px;flex-shrink:0;display:flex;align-items:center;justify-content:center}.drag-icon img{width:100%;height:100%;display:block;pointer-events:none}.procedure-name{flex:1;font-family:Inter,sans-serif;font-size:20px;font-weight:600;line-height:28px;color:#475467;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}.status-badge{display:flex;align-items:center;padding:4px 12px;border-radius:9999px;flex-shrink:0;font-family:Inter,sans-serif;font-size:14px;font-weight:500;line-height:20px;text-align:center;white-space:nowrap;border:1px solid}.status-draft{background-color:#f9fafb;border-color:#eaecf0;color:#344054}.status-published{background-color:#ecfdf3;border-color:#abefc6;color:#067647}.status-pending{background-color:#fffaeb;border-color:#fedf89;color:#b54708}.menu-icon{width:40px;height:40px;flex-shrink:0;display:flex;align-items:center;justify-content:center;border-radius:8px;cursor:pointer;transition:background-color .2s ease}.menu-icon:hover{background-color:#0000000d}.menu-icon img{width:24px;height:24px;display:block}@media(max-width:960px){.procedure-name{font-size:18px;line-height:24px}}@media(max-width:600px){.book-procedure-line{height:auto;min-height:65px}.content{padding:12px 5px 12px 16px;gap:8px}.procedure-name{font-size:16px;line-height:22px}.status-badge{font-size:12px;padding:2px 8px}}", JR = /* @__PURE__ */ ZA(SR, [["styles", [TR]]]);
/**!
 * Sortable 1.15.6
 * @author	RubaXa   <trash@rubaxa.org>
 * @author	owenm    <owen23355@gmail.com>
 * @license MIT
 */
function b2(t, e) {
  var A = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), A.push.apply(A, n);
  }
  return A;
}
function Rr(t) {
  for (var e = 1; e < arguments.length; e++) {
    var A = arguments[e] != null ? arguments[e] : {};
    e % 2 ? b2(Object(A), !0).forEach(function(n) {
      WR(t, n, A[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(A)) : b2(Object(A)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(A, n));
    });
  }
  return t;
}
function O0(t) {
  "@babel/helpers - typeof";
  return typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? O0 = function(e) {
    return typeof e;
  } : O0 = function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, O0(t);
}
function WR(t, e, A) {
  return e in t ? Object.defineProperty(t, e, {
    value: A,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = A, t;
}
function Si() {
  return Si = Object.assign || function(t) {
    for (var e = 1; e < arguments.length; e++) {
      var A = arguments[e];
      for (var n in A)
        Object.prototype.hasOwnProperty.call(A, n) && (t[n] = A[n]);
    }
    return t;
  }, Si.apply(this, arguments);
}
function OR(t, e) {
  if (t == null) return {};
  var A = {}, n = Object.keys(t), s, r;
  for (r = 0; r < n.length; r++)
    s = n[r], !(e.indexOf(s) >= 0) && (A[s] = t[s]);
  return A;
}
function PR(t, e) {
  if (t == null) return {};
  var A = OR(t, e), n, s;
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    for (s = 0; s < r.length; s++)
      n = r[s], !(e.indexOf(n) >= 0) && Object.prototype.propertyIsEnumerable.call(t, n) && (A[n] = t[n]);
  }
  return A;
}
var KR = "1.15.6";
function Di(t) {
  if (typeof window < "u" && window.navigator)
    return !!/* @__PURE__ */ navigator.userAgent.match(t);
}
var _i = Di(/(?:Trident.*rv[ :]?11\.|msie|iemobile|Windows Phone)/i), ch = Di(/Edge/i), v2 = Di(/firefox/i), vB = Di(/safari/i) && !Di(/chrome/i) && !Di(/android/i), UM = Di(/iP(ad|od|hone)/i), Ix = Di(/chrome/i) && Di(/android/i), Cx = {
  capture: !1,
  passive: !1
};
function Et(t, e, A) {
  t.addEventListener(e, A, !_i && Cx);
}
function wt(t, e, A) {
  t.removeEventListener(e, A, !_i && Cx);
}
function Nu(t, e) {
  if (e) {
    if (e[0] === ">" && (e = e.substring(1)), t)
      try {
        if (t.matches)
          return t.matches(e);
        if (t.msMatchesSelector)
          return t.msMatchesSelector(e);
        if (t.webkitMatchesSelector)
          return t.webkitMatchesSelector(e);
      } catch {
        return !1;
      }
    return !1;
  }
}
function Ex(t) {
  return t.host && t !== document && t.host.nodeType ? t.host : t.parentNode;
}
function Ks(t, e, A, n) {
  if (t) {
    A = A || document;
    do {
      if (e != null && (e[0] === ">" ? t.parentNode === A && Nu(t, e) : Nu(t, e)) || n && t === A)
        return t;
      if (t === A) break;
    } while (t = Ex(t));
  }
  return null;
}
var j2 = /\s+/g;
function As(t, e, A) {
  if (t && e)
    if (t.classList)
      t.classList[A ? "add" : "remove"](e);
    else {
      var n = (" " + t.className + " ").replace(j2, " ").replace(" " + e + " ", " ");
      t.className = (n + (A ? " " + e : "")).replace(j2, " ");
    }
}
function qe(t, e, A) {
  var n = t && t.style;
  if (n) {
    if (A === void 0)
      return document.defaultView && document.defaultView.getComputedStyle ? A = document.defaultView.getComputedStyle(t, "") : t.currentStyle && (A = t.currentStyle), e === void 0 ? A : A[e];
    !(e in n) && e.indexOf("webkit") === -1 && (e = "-webkit-" + e), n[e] = A + (typeof A == "string" ? "" : "px");
  }
}
function sl(t, e) {
  var A = "";
  if (typeof t == "string")
    A = t;
  else
    do {
      var n = qe(t, "transform");
      n && n !== "none" && (A = n + " " + A);
    } while (!e && (t = t.parentNode));
  var s = window.DOMMatrix || window.WebKitCSSMatrix || window.CSSMatrix || window.MSCSSMatrix;
  return s && new s(A);
}
function Mx(t, e, A) {
  if (t) {
    var n = t.getElementsByTagName(e), s = 0, r = n.length;
    if (A)
      for (; s < r; s++)
        A(n[s], s);
    return n;
  }
  return [];
}
function br() {
  var t = document.scrollingElement;
  return t || document.documentElement;
}
function QA(t, e, A, n, s) {
  if (!(!t.getBoundingClientRect && t !== window)) {
    var r, i, o, a, c, l, B;
    if (t !== window && t.parentNode && t !== br() ? (r = t.getBoundingClientRect(), i = r.top, o = r.left, a = r.bottom, c = r.right, l = r.height, B = r.width) : (i = 0, o = 0, a = window.innerHeight, c = window.innerWidth, l = window.innerHeight, B = window.innerWidth), (e || A) && t !== window && (s = s || t.parentNode, !_i))
      do
        if (s && s.getBoundingClientRect && (qe(s, "transform") !== "none" || A && qe(s, "position") !== "static")) {
          var g = s.getBoundingClientRect();
          i -= g.top + parseInt(qe(s, "border-top-width")), o -= g.left + parseInt(qe(s, "border-left-width")), a = i + r.height, c = o + r.width;
          break;
        }
      while (s = s.parentNode);
    if (n && t !== window) {
      var h = sl(s || t), u = h && h.a, d = h && h.d;
      h && (i /= d, o /= u, B /= u, l /= d, a = i + l, c = o + B);
    }
    return {
      top: i,
      left: o,
      bottom: a,
      right: c,
      width: B,
      height: l
    };
  }
}
function H2(t, e, A) {
  for (var n = zo(t, !0), s = QA(t)[e]; n; ) {
    var r = QA(n)[A], i = void 0;
    if (i = s >= r, !i) return n;
    if (n === br()) break;
    n = zo(n, !1);
  }
  return !1;
}
function fl(t, e, A, n) {
  for (var s = 0, r = 0, i = t.children; r < i.length; ) {
    if (i[r].style.display !== "none" && i[r] !== Pe.ghost && (n || i[r] !== Pe.dragged) && Ks(i[r], A.draggable, t, !1)) {
      if (s === e)
        return i[r];
      s++;
    }
    r++;
  }
  return null;
}
function bM(t, e) {
  for (var A = t.lastElementChild; A && (A === Pe.ghost || qe(A, "display") === "none" || e && !Nu(A, e)); )
    A = A.previousElementSibling;
  return A || null;
}
function ps(t, e) {
  var A = 0;
  if (!t || !t.parentNode)
    return -1;
  for (; t = t.previousElementSibling; )
    t.nodeName.toUpperCase() !== "TEMPLATE" && t !== Pe.clone && (!e || Nu(t, e)) && A++;
  return A;
}
function k2(t) {
  var e = 0, A = 0, n = br();
  if (t)
    do {
      var s = sl(t), r = s.a, i = s.d;
      e += t.scrollLeft * r, A += t.scrollTop * i;
    } while (t !== n && (t = t.parentNode));
  return [e, A];
}
function VR(t, e) {
  for (var A in t)
    if (t.hasOwnProperty(A)) {
      for (var n in e)
        if (e.hasOwnProperty(n) && e[n] === t[A][n]) return Number(A);
    }
  return -1;
}
function zo(t, e) {
  if (!t || !t.getBoundingClientRect) return br();
  var A = t, n = !1;
  do
    if (A.clientWidth < A.scrollWidth || A.clientHeight < A.scrollHeight) {
      var s = qe(A);
      if (A.clientWidth < A.scrollWidth && (s.overflowX == "auto" || s.overflowX == "scroll") || A.clientHeight < A.scrollHeight && (s.overflowY == "auto" || s.overflowY == "scroll")) {
        if (!A.getBoundingClientRect || A === document.body) return br();
        if (n || e) return A;
        n = !0;
      }
    }
  while (A = A.parentNode);
  return br();
}
function XR(t, e) {
  if (t && e)
    for (var A in e)
      e.hasOwnProperty(A) && (t[A] = e[A]);
  return t;
}
function iQ(t, e) {
  return Math.round(t.top) === Math.round(e.top) && Math.round(t.left) === Math.round(e.left) && Math.round(t.height) === Math.round(e.height) && Math.round(t.width) === Math.round(e.width);
}
var jB;
function px(t, e) {
  return function() {
    if (!jB) {
      var A = arguments, n = this;
      A.length === 1 ? t.call(n, A[0]) : t.apply(n, A), jB = setTimeout(function() {
        jB = void 0;
      }, e);
    }
  };
}
function ZR() {
  clearTimeout(jB), jB = void 0;
}
function mx(t, e, A) {
  t.scrollLeft += e, t.scrollTop += A;
}
function Yx(t) {
  var e = window.Polymer, A = window.jQuery || window.Zepto;
  return e && e.dom ? e.dom(t).cloneNode(!0) : A ? A(t).clone(!0)[0] : t.cloneNode(!0);
}
function yx(t, e, A) {
  var n = {};
  return Array.from(t.children).forEach(function(s) {
    var r, i, o, a;
    if (!(!Ks(s, e.draggable, t, !1) || s.animated || s === A)) {
      var c = QA(s);
      n.left = Math.min((r = n.left) !== null && r !== void 0 ? r : 1 / 0, c.left), n.top = Math.min((i = n.top) !== null && i !== void 0 ? i : 1 / 0, c.top), n.right = Math.max((o = n.right) !== null && o !== void 0 ? o : -1 / 0, c.right), n.bottom = Math.max((a = n.bottom) !== null && a !== void 0 ? a : -1 / 0, c.bottom);
    }
  }), n.width = n.right - n.left, n.height = n.bottom - n.top, n.x = n.left, n.y = n.top, n;
}
var Kn = "Sortable" + (/* @__PURE__ */ new Date()).getTime();
function qR() {
  var t = [], e;
  return {
    captureAnimationState: function() {
      if (t = [], !!this.options.animation) {
        var n = [].slice.call(this.el.children);
        n.forEach(function(s) {
          if (!(qe(s, "display") === "none" || s === Pe.ghost)) {
            t.push({
              target: s,
              rect: QA(s)
            });
            var r = Rr({}, t[t.length - 1].rect);
            if (s.thisAnimationDuration) {
              var i = sl(s, !0);
              i && (r.top -= i.f, r.left -= i.e);
            }
            s.fromRect = r;
          }
        });
      }
    },
    addAnimationState: function(n) {
      t.push(n);
    },
    removeAnimationState: function(n) {
      t.splice(VR(t, {
        target: n
      }), 1);
    },
    animateAll: function(n) {
      var s = this;
      if (!this.options.animation) {
        clearTimeout(e), typeof n == "function" && n();
        return;
      }
      var r = !1, i = 0;
      t.forEach(function(o) {
        var a = 0, c = o.target, l = c.fromRect, B = QA(c), g = c.prevFromRect, h = c.prevToRect, u = o.rect, d = sl(c, !0);
        d && (B.top -= d.f, B.left -= d.e), c.toRect = B, c.thisAnimationDuration && iQ(g, B) && !iQ(l, B) && // Make sure animatingRect is on line between toRect & fromRect
        (u.top - B.top) / (u.left - B.left) === (l.top - B.top) / (l.left - B.left) && (a = $R(u, g, h, s.options)), iQ(B, l) || (c.prevFromRect = l, c.prevToRect = B, a || (a = s.options.animation), s.animate(c, u, B, a)), a && (r = !0, i = Math.max(i, a), clearTimeout(c.animationResetTimer), c.animationResetTimer = setTimeout(function() {
          c.animationTime = 0, c.prevFromRect = null, c.fromRect = null, c.prevToRect = null, c.thisAnimationDuration = null;
        }, a), c.thisAnimationDuration = a);
      }), clearTimeout(e), r ? e = setTimeout(function() {
        typeof n == "function" && n();
      }, i) : typeof n == "function" && n(), t = [];
    },
    animate: function(n, s, r, i) {
      if (i) {
        qe(n, "transition", ""), qe(n, "transform", "");
        var o = sl(this.el), a = o && o.a, c = o && o.d, l = (s.left - r.left) / (a || 1), B = (s.top - r.top) / (c || 1);
        n.animatingX = !!l, n.animatingY = !!B, qe(n, "transform", "translate3d(" + l + "px," + B + "px,0)"), this.forRepaintDummy = _R(n), qe(n, "transition", "transform " + i + "ms" + (this.options.easing ? " " + this.options.easing : "")), qe(n, "transform", "translate3d(0,0,0)"), typeof n.animated == "number" && clearTimeout(n.animated), n.animated = setTimeout(function() {
          qe(n, "transition", ""), qe(n, "transform", ""), n.animated = !1, n.animatingX = !1, n.animatingY = !1;
        }, i);
      }
    }
  };
}
function _R(t) {
  return t.offsetWidth;
}
function $R(t, e, A, n) {
  return Math.sqrt(Math.pow(e.top - t.top, 2) + Math.pow(e.left - t.left, 2)) / Math.sqrt(Math.pow(e.top - A.top, 2) + Math.pow(e.left - A.left, 2)) * n.animation;
}
var yc = [], oQ = {
  initializeByDefault: !0
}, lh = {
  mount: function(e) {
    for (var A in oQ)
      oQ.hasOwnProperty(A) && !(A in e) && (e[A] = oQ[A]);
    yc.forEach(function(n) {
      if (n.pluginName === e.pluginName)
        throw "Sortable: Cannot mount plugin ".concat(e.pluginName, " more than once");
    }), yc.push(e);
  },
  pluginEvent: function(e, A, n) {
    var s = this;
    this.eventCanceled = !1, n.cancel = function() {
      s.eventCanceled = !0;
    };
    var r = e + "Global";
    yc.forEach(function(i) {
      A[i.pluginName] && (A[i.pluginName][r] && A[i.pluginName][r](Rr({
        sortable: A
      }, n)), A.options[i.pluginName] && A[i.pluginName][e] && A[i.pluginName][e](Rr({
        sortable: A
      }, n)));
    });
  },
  initializePlugins: function(e, A, n, s) {
    yc.forEach(function(o) {
      var a = o.pluginName;
      if (!(!e.options[a] && !o.initializeByDefault)) {
        var c = new o(e, A, e.options);
        c.sortable = e, c.options = e.options, e[a] = c, Si(n, c.defaults);
      }
    });
    for (var r in e.options)
      if (e.options.hasOwnProperty(r)) {
        var i = this.modifyOption(e, r, e.options[r]);
        typeof i < "u" && (e.options[r] = i);
      }
  },
  getEventProperties: function(e, A) {
    var n = {};
    return yc.forEach(function(s) {
      typeof s.eventProperties == "function" && Si(n, s.eventProperties.call(A[s.pluginName], e));
    }), n;
  },
  modifyOption: function(e, A, n) {
    var s;
    return yc.forEach(function(r) {
      e[r.pluginName] && r.optionListeners && typeof r.optionListeners[A] == "function" && (s = r.optionListeners[A].call(e[r.pluginName], n));
    }), s;
  }
};
function eL(t) {
  var e = t.sortable, A = t.rootEl, n = t.name, s = t.targetEl, r = t.cloneEl, i = t.toEl, o = t.fromEl, a = t.oldIndex, c = t.newIndex, l = t.oldDraggableIndex, B = t.newDraggableIndex, g = t.originalEvent, h = t.putSortable, u = t.extraEventProperties;
  if (e = e || A && A[Kn], !!e) {
    var d, w = e.options, Q = "on" + n.charAt(0).toUpperCase() + n.substr(1);
    window.CustomEvent && !_i && !ch ? d = new CustomEvent(n, {
      bubbles: !0,
      cancelable: !0
    }) : (d = document.createEvent("Event"), d.initEvent(n, !0, !0)), d.to = i || A, d.from = o || A, d.item = s || A, d.clone = r, d.oldIndex = a, d.newIndex = c, d.oldDraggableIndex = l, d.newDraggableIndex = B, d.originalEvent = g, d.pullMode = h ? h.lastPutMode : void 0;
    var p = Rr(Rr({}, u), lh.getEventProperties(n, e));
    for (var M in p)
      d[M] = p[M];
    A && A.dispatchEvent(d), w[Q] && w[Q].call(e, d);
  }
}
var tL = ["evt"], Sn = function(e, A) {
  var n = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, s = n.evt, r = PR(n, tL);
  lh.pluginEvent.bind(Pe)(e, A, Rr({
    dragEl: Ce,
    parentEl: cA,
    ghostEl: $e,
    rootEl: qt,
    nextEl: Da,
    lastDownEl: P0,
    cloneEl: eA,
    cloneHidden: Yo,
    dragStarted: fB,
    putSortable: SA,
    activeSortable: Pe.active,
    originalEvent: s,
    oldIndex: Kc,
    oldDraggableIndex: HB,
    newIndex: ns,
    newDraggableIndex: Eo,
    hideGhostForTarget: xx,
    unhideGhostForTarget: Gx,
    cloneNowHidden: function() {
      Yo = !0;
    },
    cloneNowShown: function() {
      Yo = !1;
    },
    dispatchSortableEvent: function(o) {
      In({
        sortable: A,
        name: o,
        originalEvent: s
      });
    }
  }, r));
};
function In(t) {
  eL(Rr({
    putSortable: SA,
    cloneEl: eA,
    targetEl: Ce,
    rootEl: qt,
    oldIndex: Kc,
    oldDraggableIndex: HB,
    newIndex: ns,
    newDraggableIndex: Eo
  }, t));
}
var Ce, cA, $e, qt, Da, P0, eA, Yo, Kc, ns, HB, Eo, qh, SA, Lc = !1, Du = !1, xu = [], Ma, Ps, aQ, cQ, R2, L2, fB, Fc, kB, RB = !1, _h = !1, K0, _A, lQ = [], EC = !1, Gu = [], Cw = typeof document < "u", $h = UM, S2 = ch || _i ? "cssFloat" : "float", AL = Cw && !Ix && !UM && "draggable" in document.createElement("div"), Fx = (function() {
  if (Cw) {
    if (_i)
      return !1;
    var t = document.createElement("x");
    return t.style.cssText = "pointer-events:auto", t.style.pointerEvents === "auto";
  }
})(), Nx = function(e, A) {
  var n = qe(e), s = parseInt(n.width) - parseInt(n.paddingLeft) - parseInt(n.paddingRight) - parseInt(n.borderLeftWidth) - parseInt(n.borderRightWidth), r = fl(e, 0, A), i = fl(e, 1, A), o = r && qe(r), a = i && qe(i), c = o && parseInt(o.marginLeft) + parseInt(o.marginRight) + QA(r).width, l = a && parseInt(a.marginLeft) + parseInt(a.marginRight) + QA(i).width;
  if (n.display === "flex")
    return n.flexDirection === "column" || n.flexDirection === "column-reverse" ? "vertical" : "horizontal";
  if (n.display === "grid")
    return n.gridTemplateColumns.split(" ").length <= 1 ? "vertical" : "horizontal";
  if (r && o.float && o.float !== "none") {
    var B = o.float === "left" ? "left" : "right";
    return i && (a.clear === "both" || a.clear === B) ? "vertical" : "horizontal";
  }
  return r && (o.display === "block" || o.display === "flex" || o.display === "table" || o.display === "grid" || c >= s && n[S2] === "none" || i && n[S2] === "none" && c + l > s) ? "vertical" : "horizontal";
}, nL = function(e, A, n) {
  var s = n ? e.left : e.top, r = n ? e.right : e.bottom, i = n ? e.width : e.height, o = n ? A.left : A.top, a = n ? A.right : A.bottom, c = n ? A.width : A.height;
  return s === o || r === a || s + i / 2 === o + c / 2;
}, sL = function(e, A) {
  var n;
  return xu.some(function(s) {
    var r = s[Kn].options.emptyInsertThreshold;
    if (!(!r || bM(s))) {
      var i = QA(s), o = e >= i.left - r && e <= i.right + r, a = A >= i.top - r && A <= i.bottom + r;
      if (o && a)
        return n = s;
    }
  }), n;
}, Dx = function(e) {
  function A(r, i) {
    return function(o, a, c, l) {
      var B = o.options.group.name && a.options.group.name && o.options.group.name === a.options.group.name;
      if (r == null && (i || B))
        return !0;
      if (r == null || r === !1)
        return !1;
      if (i && r === "clone")
        return r;
      if (typeof r == "function")
        return A(r(o, a, c, l), i)(o, a, c, l);
      var g = (i ? o : a).options.group.name;
      return r === !0 || typeof r == "string" && r === g || r.join && r.indexOf(g) > -1;
    };
  }
  var n = {}, s = e.group;
  (!s || O0(s) != "object") && (s = {
    name: s
  }), n.name = s.name, n.checkPull = A(s.pull, !0), n.checkPut = A(s.put), n.revertClone = s.revertClone, e.group = n;
}, xx = function() {
  !Fx && $e && qe($e, "display", "none");
}, Gx = function() {
  !Fx && $e && qe($e, "display", "");
};
Cw && !Ix && document.addEventListener("click", function(t) {
  if (Du)
    return t.preventDefault(), t.stopPropagation && t.stopPropagation(), t.stopImmediatePropagation && t.stopImmediatePropagation(), Du = !1, !1;
}, !0);
var pa = function(e) {
  if (Ce) {
    e = e.touches ? e.touches[0] : e;
    var A = sL(e.clientX, e.clientY);
    if (A) {
      var n = {};
      for (var s in e)
        e.hasOwnProperty(s) && (n[s] = e[s]);
      n.target = n.rootEl = A, n.preventDefault = void 0, n.stopPropagation = void 0, A[Kn]._onDragOver(n);
    }
  }
}, rL = function(e) {
  Ce && Ce.parentNode[Kn]._isOutsideThisEl(e.target);
};
function Pe(t, e) {
  if (!(t && t.nodeType && t.nodeType === 1))
    throw "Sortable: `el` must be an HTMLElement, not ".concat({}.toString.call(t));
  this.el = t, this.options = e = Si({}, e), t[Kn] = this;
  var A = {
    group: null,
    sort: !0,
    disabled: !1,
    store: null,
    handle: null,
    draggable: /^[uo]l$/i.test(t.nodeName) ? ">li" : ">*",
    swapThreshold: 1,
    // percentage; 0 <= x <= 1
    invertSwap: !1,
    // invert always
    invertedSwapThreshold: null,
    // will be set to same as swapThreshold if default
    removeCloneOnHide: !0,
    direction: function() {
      return Nx(t, this.options);
    },
    ghostClass: "sortable-ghost",
    chosenClass: "sortable-chosen",
    dragClass: "sortable-drag",
    ignore: "a, img",
    filter: null,
    preventOnFilter: !0,
    animation: 0,
    easing: null,
    setData: function(i, o) {
      i.setData("Text", o.textContent);
    },
    dropBubble: !1,
    dragoverBubble: !1,
    dataIdAttr: "data-id",
    delay: 0,
    delayOnTouchOnly: !1,
    touchStartThreshold: (Number.parseInt ? Number : window).parseInt(window.devicePixelRatio, 10) || 1,
    forceFallback: !1,
    fallbackClass: "sortable-fallback",
    fallbackOnBody: !1,
    fallbackTolerance: 0,
    fallbackOffset: {
      x: 0,
      y: 0
    },
    // Disabled on Safari: #1571; Enabled on Safari IOS: #2244
    supportPointer: Pe.supportPointer !== !1 && "PointerEvent" in window && (!vB || UM),
    emptyInsertThreshold: 5
  };
  lh.initializePlugins(this, t, A);
  for (var n in A)
    !(n in e) && (e[n] = A[n]);
  Dx(e);
  for (var s in this)
    s.charAt(0) === "_" && typeof this[s] == "function" && (this[s] = this[s].bind(this));
  this.nativeDraggable = e.forceFallback ? !1 : AL, this.nativeDraggable && (this.options.touchStartThreshold = 1), e.supportPointer ? Et(t, "pointerdown", this._onTapStart) : (Et(t, "mousedown", this._onTapStart), Et(t, "touchstart", this._onTapStart)), this.nativeDraggable && (Et(t, "dragover", this), Et(t, "dragenter", this)), xu.push(this.el), e.store && e.store.get && this.sort(e.store.get(this) || []), Si(this, qR());
}
Pe.prototype = /** @lends Sortable.prototype */
{
  constructor: Pe,
  _isOutsideThisEl: function(e) {
    !this.el.contains(e) && e !== this.el && (Fc = null);
  },
  _getDirection: function(e, A) {
    return typeof this.options.direction == "function" ? this.options.direction.call(this, e, A, Ce) : this.options.direction;
  },
  _onTapStart: function(e) {
    if (e.cancelable) {
      var A = this, n = this.el, s = this.options, r = s.preventOnFilter, i = e.type, o = e.touches && e.touches[0] || e.pointerType && e.pointerType === "touch" && e, a = (o || e).target, c = e.target.shadowRoot && (e.path && e.path[0] || e.composedPath && e.composedPath()[0]) || a, l = s.filter;
      if (hL(n), !Ce && !(/mousedown|pointerdown/.test(i) && e.button !== 0 || s.disabled) && !c.isContentEditable && !(!this.nativeDraggable && vB && a && a.tagName.toUpperCase() === "SELECT") && (a = Ks(a, s.draggable, n, !1), !(a && a.animated) && P0 !== a)) {
        if (Kc = ps(a), HB = ps(a, s.draggable), typeof l == "function") {
          if (l.call(this, e, a, this)) {
            In({
              sortable: A,
              rootEl: c,
              name: "filter",
              targetEl: a,
              toEl: n,
              fromEl: n
            }), Sn("filter", A, {
              evt: e
            }), r && e.preventDefault();
            return;
          }
        } else if (l && (l = l.split(",").some(function(B) {
          if (B = Ks(c, B.trim(), n, !1), B)
            return In({
              sortable: A,
              rootEl: B,
              name: "filter",
              targetEl: a,
              fromEl: n,
              toEl: n
            }), Sn("filter", A, {
              evt: e
            }), !0;
        }), l)) {
          r && e.preventDefault();
          return;
        }
        s.handle && !Ks(c, s.handle, n, !1) || this._prepareDragStart(e, o, a);
      }
    }
  },
  _prepareDragStart: function(e, A, n) {
    var s = this, r = s.el, i = s.options, o = r.ownerDocument, a;
    if (n && !Ce && n.parentNode === r) {
      var c = QA(n);
      if (qt = r, Ce = n, cA = Ce.parentNode, Da = Ce.nextSibling, P0 = n, qh = i.group, Pe.dragged = Ce, Ma = {
        target: Ce,
        clientX: (A || e).clientX,
        clientY: (A || e).clientY
      }, R2 = Ma.clientX - c.left, L2 = Ma.clientY - c.top, this._lastX = (A || e).clientX, this._lastY = (A || e).clientY, Ce.style["will-change"] = "all", a = function() {
        if (Sn("delayEnded", s, {
          evt: e
        }), Pe.eventCanceled) {
          s._onDrop();
          return;
        }
        s._disableDelayedDragEvents(), !v2 && s.nativeDraggable && (Ce.draggable = !0), s._triggerDragStart(e, A), In({
          sortable: s,
          name: "choose",
          originalEvent: e
        }), As(Ce, i.chosenClass, !0);
      }, i.ignore.split(",").forEach(function(l) {
        Mx(Ce, l.trim(), BQ);
      }), Et(o, "dragover", pa), Et(o, "mousemove", pa), Et(o, "touchmove", pa), i.supportPointer ? (Et(o, "pointerup", s._onDrop), !this.nativeDraggable && Et(o, "pointercancel", s._onDrop)) : (Et(o, "mouseup", s._onDrop), Et(o, "touchend", s._onDrop), Et(o, "touchcancel", s._onDrop)), v2 && this.nativeDraggable && (this.options.touchStartThreshold = 4, Ce.draggable = !0), Sn("delayStart", this, {
        evt: e
      }), i.delay && (!i.delayOnTouchOnly || A) && (!this.nativeDraggable || !(ch || _i))) {
        if (Pe.eventCanceled) {
          this._onDrop();
          return;
        }
        i.supportPointer ? (Et(o, "pointerup", s._disableDelayedDrag), Et(o, "pointercancel", s._disableDelayedDrag)) : (Et(o, "mouseup", s._disableDelayedDrag), Et(o, "touchend", s._disableDelayedDrag), Et(o, "touchcancel", s._disableDelayedDrag)), Et(o, "mousemove", s._delayedDragTouchMoveHandler), Et(o, "touchmove", s._delayedDragTouchMoveHandler), i.supportPointer && Et(o, "pointermove", s._delayedDragTouchMoveHandler), s._dragStartTimer = setTimeout(a, i.delay);
      } else
        a();
    }
  },
  _delayedDragTouchMoveHandler: function(e) {
    var A = e.touches ? e.touches[0] : e;
    Math.max(Math.abs(A.clientX - this._lastX), Math.abs(A.clientY - this._lastY)) >= Math.floor(this.options.touchStartThreshold / (this.nativeDraggable && window.devicePixelRatio || 1)) && this._disableDelayedDrag();
  },
  _disableDelayedDrag: function() {
    Ce && BQ(Ce), clearTimeout(this._dragStartTimer), this._disableDelayedDragEvents();
  },
  _disableDelayedDragEvents: function() {
    var e = this.el.ownerDocument;
    wt(e, "mouseup", this._disableDelayedDrag), wt(e, "touchend", this._disableDelayedDrag), wt(e, "touchcancel", this._disableDelayedDrag), wt(e, "pointerup", this._disableDelayedDrag), wt(e, "pointercancel", this._disableDelayedDrag), wt(e, "mousemove", this._delayedDragTouchMoveHandler), wt(e, "touchmove", this._delayedDragTouchMoveHandler), wt(e, "pointermove", this._delayedDragTouchMoveHandler);
  },
  _triggerDragStart: function(e, A) {
    A = A || e.pointerType == "touch" && e, !this.nativeDraggable || A ? this.options.supportPointer ? Et(document, "pointermove", this._onTouchMove) : A ? Et(document, "touchmove", this._onTouchMove) : Et(document, "mousemove", this._onTouchMove) : (Et(Ce, "dragend", this), Et(qt, "dragstart", this._onDragStart));
    try {
      document.selection ? V0(function() {
        document.selection.empty();
      }) : window.getSelection().removeAllRanges();
    } catch {
    }
  },
  _dragStarted: function(e, A) {
    if (Lc = !1, qt && Ce) {
      Sn("dragStarted", this, {
        evt: A
      }), this.nativeDraggable && Et(document, "dragover", rL);
      var n = this.options;
      !e && As(Ce, n.dragClass, !1), As(Ce, n.ghostClass, !0), Pe.active = this, e && this._appendGhost(), In({
        sortable: this,
        name: "start",
        originalEvent: A
      });
    } else
      this._nulling();
  },
  _emulateDragOver: function() {
    if (Ps) {
      this._lastX = Ps.clientX, this._lastY = Ps.clientY, xx();
      for (var e = document.elementFromPoint(Ps.clientX, Ps.clientY), A = e; e && e.shadowRoot && (e = e.shadowRoot.elementFromPoint(Ps.clientX, Ps.clientY), e !== A); )
        A = e;
      if (Ce.parentNode[Kn]._isOutsideThisEl(e), A)
        do {
          if (A[Kn]) {
            var n = void 0;
            if (n = A[Kn]._onDragOver({
              clientX: Ps.clientX,
              clientY: Ps.clientY,
              target: e,
              rootEl: A
            }), n && !this.options.dragoverBubble)
              break;
          }
          e = A;
        } while (A = Ex(A));
      Gx();
    }
  },
  _onTouchMove: function(e) {
    if (Ma) {
      var A = this.options, n = A.fallbackTolerance, s = A.fallbackOffset, r = e.touches ? e.touches[0] : e, i = $e && sl($e, !0), o = $e && i && i.a, a = $e && i && i.d, c = $h && _A && k2(_A), l = (r.clientX - Ma.clientX + s.x) / (o || 1) + (c ? c[0] - lQ[0] : 0) / (o || 1), B = (r.clientY - Ma.clientY + s.y) / (a || 1) + (c ? c[1] - lQ[1] : 0) / (a || 1);
      if (!Pe.active && !Lc) {
        if (n && Math.max(Math.abs(r.clientX - this._lastX), Math.abs(r.clientY - this._lastY)) < n)
          return;
        this._onDragStart(e, !0);
      }
      if ($e) {
        i ? (i.e += l - (aQ || 0), i.f += B - (cQ || 0)) : i = {
          a: 1,
          b: 0,
          c: 0,
          d: 1,
          e: l,
          f: B
        };
        var g = "matrix(".concat(i.a, ",").concat(i.b, ",").concat(i.c, ",").concat(i.d, ",").concat(i.e, ",").concat(i.f, ")");
        qe($e, "webkitTransform", g), qe($e, "mozTransform", g), qe($e, "msTransform", g), qe($e, "transform", g), aQ = l, cQ = B, Ps = r;
      }
      e.cancelable && e.preventDefault();
    }
  },
  _appendGhost: function() {
    if (!$e) {
      var e = this.options.fallbackOnBody ? document.body : qt, A = QA(Ce, !0, $h, !0, e), n = this.options;
      if ($h) {
        for (_A = e; qe(_A, "position") === "static" && qe(_A, "transform") === "none" && _A !== document; )
          _A = _A.parentNode;
        _A !== document.body && _A !== document.documentElement ? (_A === document && (_A = br()), A.top += _A.scrollTop, A.left += _A.scrollLeft) : _A = br(), lQ = k2(_A);
      }
      $e = Ce.cloneNode(!0), As($e, n.ghostClass, !1), As($e, n.fallbackClass, !0), As($e, n.dragClass, !0), qe($e, "transition", ""), qe($e, "transform", ""), qe($e, "box-sizing", "border-box"), qe($e, "margin", 0), qe($e, "top", A.top), qe($e, "left", A.left), qe($e, "width", A.width), qe($e, "height", A.height), qe($e, "opacity", "0.8"), qe($e, "position", $h ? "absolute" : "fixed"), qe($e, "zIndex", "100000"), qe($e, "pointerEvents", "none"), Pe.ghost = $e, e.appendChild($e), qe($e, "transform-origin", R2 / parseInt($e.style.width) * 100 + "% " + L2 / parseInt($e.style.height) * 100 + "%");
    }
  },
  _onDragStart: function(e, A) {
    var n = this, s = e.dataTransfer, r = n.options;
    if (Sn("dragStart", this, {
      evt: e
    }), Pe.eventCanceled) {
      this._onDrop();
      return;
    }
    Sn("setupClone", this), Pe.eventCanceled || (eA = Yx(Ce), eA.removeAttribute("id"), eA.draggable = !1, eA.style["will-change"] = "", this._hideClone(), As(eA, this.options.chosenClass, !1), Pe.clone = eA), n.cloneId = V0(function() {
      Sn("clone", n), !Pe.eventCanceled && (n.options.removeCloneOnHide || qt.insertBefore(eA, Ce), n._hideClone(), In({
        sortable: n,
        name: "clone"
      }));
    }), !A && As(Ce, r.dragClass, !0), A ? (Du = !0, n._loopId = setInterval(n._emulateDragOver, 50)) : (wt(document, "mouseup", n._onDrop), wt(document, "touchend", n._onDrop), wt(document, "touchcancel", n._onDrop), s && (s.effectAllowed = "move", r.setData && r.setData.call(n, s, Ce)), Et(document, "drop", n), qe(Ce, "transform", "translateZ(0)")), Lc = !0, n._dragStartId = V0(n._dragStarted.bind(n, A, e)), Et(document, "selectstart", n), fB = !0, window.getSelection().removeAllRanges(), vB && qe(document.body, "user-select", "none");
  },
  // Returns true - if no further action is needed (either inserted or another condition)
  _onDragOver: function(e) {
    var A = this.el, n = e.target, s, r, i, o = this.options, a = o.group, c = Pe.active, l = qh === a, B = o.sort, g = SA || c, h, u = this, d = !1;
    if (EC) return;
    function w(te, be) {
      Sn(te, u, Rr({
        evt: e,
        isOwner: l,
        axis: h ? "vertical" : "horizontal",
        revert: i,
        dragRect: s,
        targetRect: r,
        canSort: B,
        fromSortable: g,
        target: n,
        completed: p,
        onMove: function(ke, Se) {
          return e0(qt, A, Ce, s, ke, QA(ke), e, Se);
        },
        changed: M
      }, be));
    }
    function Q() {
      w("dragOverAnimationCapture"), u.captureAnimationState(), u !== g && g.captureAnimationState();
    }
    function p(te) {
      return w("dragOverCompleted", {
        insertion: te
      }), te && (l ? c._hideClone() : c._showClone(u), u !== g && (As(Ce, SA ? SA.options.ghostClass : c.options.ghostClass, !1), As(Ce, o.ghostClass, !0)), SA !== u && u !== Pe.active ? SA = u : u === Pe.active && SA && (SA = null), g === u && (u._ignoreWhileAnimating = n), u.animateAll(function() {
        w("dragOverAnimationComplete"), u._ignoreWhileAnimating = null;
      }), u !== g && (g.animateAll(), g._ignoreWhileAnimating = null)), (n === Ce && !Ce.animated || n === A && !n.animated) && (Fc = null), !o.dragoverBubble && !e.rootEl && n !== document && (Ce.parentNode[Kn]._isOutsideThisEl(e.target), !te && pa(e)), !o.dragoverBubble && e.stopPropagation && e.stopPropagation(), d = !0;
    }
    function M() {
      ns = ps(Ce), Eo = ps(Ce, o.draggable), In({
        sortable: u,
        name: "change",
        toEl: A,
        newIndex: ns,
        newDraggableIndex: Eo,
        originalEvent: e
      });
    }
    if (e.preventDefault !== void 0 && e.cancelable && e.preventDefault(), n = Ks(n, o.draggable, A, !0), w("dragOver"), Pe.eventCanceled) return d;
    if (Ce.contains(e.target) || n.animated && n.animatingX && n.animatingY || u._ignoreWhileAnimating === n)
      return p(!1);
    if (Du = !1, c && !o.disabled && (l ? B || (i = cA !== qt) : SA === this || (this.lastPutMode = qh.checkPull(this, c, Ce, e)) && a.checkPut(this, c, Ce, e))) {
      if (h = this._getDirection(e, n) === "vertical", s = QA(Ce), w("dragOverValid"), Pe.eventCanceled) return d;
      if (i)
        return cA = qt, Q(), this._hideClone(), w("revert"), Pe.eventCanceled || (Da ? qt.insertBefore(Ce, Da) : qt.appendChild(Ce)), p(!0);
      var I = bM(A, o.draggable);
      if (!I || cL(e, h, this) && !I.animated) {
        if (I === Ce)
          return p(!1);
        if (I && A === e.target && (n = I), n && (r = QA(n)), e0(qt, A, Ce, s, n, r, e, !!n) !== !1)
          return Q(), I && I.nextSibling ? A.insertBefore(Ce, I.nextSibling) : A.appendChild(Ce), cA = A, M(), p(!0);
      } else if (I && aL(e, h, this)) {
        var N = fl(A, 0, o, !0);
        if (N === Ce)
          return p(!1);
        if (n = N, r = QA(n), e0(qt, A, Ce, s, n, r, e, !1) !== !1)
          return Q(), A.insertBefore(Ce, N), cA = A, M(), p(!0);
      } else if (n.parentNode === A) {
        r = QA(n);
        var m = 0, E, G = Ce.parentNode !== A, Y = !nL(Ce.animated && Ce.toRect || s, n.animated && n.toRect || r, h), U = h ? "top" : "left", v = H2(n, "top", "top") || H2(Ce, "top", "top"), b = v ? v.scrollTop : void 0;
        Fc !== n && (E = r[U], RB = !1, _h = !Y && o.invertSwap || G), m = lL(e, n, r, h, Y ? 1 : o.swapThreshold, o.invertedSwapThreshold == null ? o.swapThreshold : o.invertedSwapThreshold, _h, Fc === n);
        var W;
        if (m !== 0) {
          var q = ps(Ce);
          do
            q -= m, W = cA.children[q];
          while (W && (qe(W, "display") === "none" || W === $e));
        }
        if (m === 0 || W === n)
          return p(!1);
        Fc = n, kB = m;
        var ne = n.nextElementSibling, V = !1;
        V = m === 1;
        var se = e0(qt, A, Ce, s, n, r, e, V);
        if (se !== !1)
          return (se === 1 || se === -1) && (V = se === 1), EC = !0, setTimeout(oL, 30), Q(), V && !ne ? A.appendChild(Ce) : n.parentNode.insertBefore(Ce, V ? ne : n), v && mx(v, 0, b - v.scrollTop), cA = Ce.parentNode, E !== void 0 && !_h && (K0 = Math.abs(E - QA(n)[U])), M(), p(!0);
      }
      if (A.contains(Ce))
        return p(!1);
    }
    return !1;
  },
  _ignoreWhileAnimating: null,
  _offMoveEvents: function() {
    wt(document, "mousemove", this._onTouchMove), wt(document, "touchmove", this._onTouchMove), wt(document, "pointermove", this._onTouchMove), wt(document, "dragover", pa), wt(document, "mousemove", pa), wt(document, "touchmove", pa);
  },
  _offUpEvents: function() {
    var e = this.el.ownerDocument;
    wt(e, "mouseup", this._onDrop), wt(e, "touchend", this._onDrop), wt(e, "pointerup", this._onDrop), wt(e, "pointercancel", this._onDrop), wt(e, "touchcancel", this._onDrop), wt(document, "selectstart", this);
  },
  _onDrop: function(e) {
    var A = this.el, n = this.options;
    if (ns = ps(Ce), Eo = ps(Ce, n.draggable), Sn("drop", this, {
      evt: e
    }), cA = Ce && Ce.parentNode, ns = ps(Ce), Eo = ps(Ce, n.draggable), Pe.eventCanceled) {
      this._nulling();
      return;
    }
    Lc = !1, _h = !1, RB = !1, clearInterval(this._loopId), clearTimeout(this._dragStartTimer), MC(this.cloneId), MC(this._dragStartId), this.nativeDraggable && (wt(document, "drop", this), wt(A, "dragstart", this._onDragStart)), this._offMoveEvents(), this._offUpEvents(), vB && qe(document.body, "user-select", ""), qe(Ce, "transform", ""), e && (fB && (e.cancelable && e.preventDefault(), !n.dropBubble && e.stopPropagation()), $e && $e.parentNode && $e.parentNode.removeChild($e), (qt === cA || SA && SA.lastPutMode !== "clone") && eA && eA.parentNode && eA.parentNode.removeChild(eA), Ce && (this.nativeDraggable && wt(Ce, "dragend", this), BQ(Ce), Ce.style["will-change"] = "", fB && !Lc && As(Ce, SA ? SA.options.ghostClass : this.options.ghostClass, !1), As(Ce, this.options.chosenClass, !1), In({
      sortable: this,
      name: "unchoose",
      toEl: cA,
      newIndex: null,
      newDraggableIndex: null,
      originalEvent: e
    }), qt !== cA ? (ns >= 0 && (In({
      rootEl: cA,
      name: "add",
      toEl: cA,
      fromEl: qt,
      originalEvent: e
    }), In({
      sortable: this,
      name: "remove",
      toEl: cA,
      originalEvent: e
    }), In({
      rootEl: cA,
      name: "sort",
      toEl: cA,
      fromEl: qt,
      originalEvent: e
    }), In({
      sortable: this,
      name: "sort",
      toEl: cA,
      originalEvent: e
    })), SA && SA.save()) : ns !== Kc && ns >= 0 && (In({
      sortable: this,
      name: "update",
      toEl: cA,
      originalEvent: e
    }), In({
      sortable: this,
      name: "sort",
      toEl: cA,
      originalEvent: e
    })), Pe.active && ((ns == null || ns === -1) && (ns = Kc, Eo = HB), In({
      sortable: this,
      name: "end",
      toEl: cA,
      originalEvent: e
    }), this.save()))), this._nulling();
  },
  _nulling: function() {
    Sn("nulling", this), qt = Ce = cA = $e = Da = eA = P0 = Yo = Ma = Ps = fB = ns = Eo = Kc = HB = Fc = kB = SA = qh = Pe.dragged = Pe.ghost = Pe.clone = Pe.active = null, Gu.forEach(function(e) {
      e.checked = !0;
    }), Gu.length = aQ = cQ = 0;
  },
  handleEvent: function(e) {
    switch (e.type) {
      case "drop":
      case "dragend":
        this._onDrop(e);
        break;
      case "dragenter":
      case "dragover":
        Ce && (this._onDragOver(e), iL(e));
        break;
      case "selectstart":
        e.preventDefault();
        break;
    }
  },
  /**
   * Serializes the item into an array of string.
   * @returns {String[]}
   */
  toArray: function() {
    for (var e = [], A, n = this.el.children, s = 0, r = n.length, i = this.options; s < r; s++)
      A = n[s], Ks(A, i.draggable, this.el, !1) && e.push(A.getAttribute(i.dataIdAttr) || gL(A));
    return e;
  },
  /**
   * Sorts the elements according to the array.
   * @param  {String[]}  order  order of the items
   */
  sort: function(e, A) {
    var n = {}, s = this.el;
    this.toArray().forEach(function(r, i) {
      var o = s.children[i];
      Ks(o, this.options.draggable, s, !1) && (n[r] = o);
    }, this), A && this.captureAnimationState(), e.forEach(function(r) {
      n[r] && (s.removeChild(n[r]), s.appendChild(n[r]));
    }), A && this.animateAll();
  },
  /**
   * Save the current sorting
   */
  save: function() {
    var e = this.options.store;
    e && e.set && e.set(this);
  },
  /**
   * For each element in the set, get the first element that matches the selector by testing the element itself and traversing up through its ancestors in the DOM tree.
   * @param   {HTMLElement}  el
   * @param   {String}       [selector]  default: `options.draggable`
   * @returns {HTMLElement|null}
   */
  closest: function(e, A) {
    return Ks(e, A || this.options.draggable, this.el, !1);
  },
  /**
   * Set/get option
   * @param   {string} name
   * @param   {*}      [value]
   * @returns {*}
   */
  option: function(e, A) {
    var n = this.options;
    if (A === void 0)
      return n[e];
    var s = lh.modifyOption(this, e, A);
    typeof s < "u" ? n[e] = s : n[e] = A, e === "group" && Dx(n);
  },
  /**
   * Destroy
   */
  destroy: function() {
    Sn("destroy", this);
    var e = this.el;
    e[Kn] = null, wt(e, "mousedown", this._onTapStart), wt(e, "touchstart", this._onTapStart), wt(e, "pointerdown", this._onTapStart), this.nativeDraggable && (wt(e, "dragover", this), wt(e, "dragenter", this)), Array.prototype.forEach.call(e.querySelectorAll("[draggable]"), function(A) {
      A.removeAttribute("draggable");
    }), this._onDrop(), this._disableDelayedDragEvents(), xu.splice(xu.indexOf(this.el), 1), this.el = e = null;
  },
  _hideClone: function() {
    if (!Yo) {
      if (Sn("hideClone", this), Pe.eventCanceled) return;
      qe(eA, "display", "none"), this.options.removeCloneOnHide && eA.parentNode && eA.parentNode.removeChild(eA), Yo = !0;
    }
  },
  _showClone: function(e) {
    if (e.lastPutMode !== "clone") {
      this._hideClone();
      return;
    }
    if (Yo) {
      if (Sn("showClone", this), Pe.eventCanceled) return;
      Ce.parentNode == qt && !this.options.group.revertClone ? qt.insertBefore(eA, Ce) : Da ? qt.insertBefore(eA, Da) : qt.appendChild(eA), this.options.group.revertClone && this.animate(Ce, eA), qe(eA, "display", ""), Yo = !1;
    }
  }
};
function iL(t) {
  t.dataTransfer && (t.dataTransfer.dropEffect = "move"), t.cancelable && t.preventDefault();
}
function e0(t, e, A, n, s, r, i, o) {
  var a, c = t[Kn], l = c.options.onMove, B;
  return window.CustomEvent && !_i && !ch ? a = new CustomEvent("move", {
    bubbles: !0,
    cancelable: !0
  }) : (a = document.createEvent("Event"), a.initEvent("move", !0, !0)), a.to = e, a.from = t, a.dragged = A, a.draggedRect = n, a.related = s || e, a.relatedRect = r || QA(e), a.willInsertAfter = o, a.originalEvent = i, t.dispatchEvent(a), l && (B = l.call(c, a, i)), B;
}
function BQ(t) {
  t.draggable = !1;
}
function oL() {
  EC = !1;
}
function aL(t, e, A) {
  var n = QA(fl(A.el, 0, A.options, !0)), s = yx(A.el, A.options, $e), r = 10;
  return e ? t.clientX < s.left - r || t.clientY < n.top && t.clientX < n.right : t.clientY < s.top - r || t.clientY < n.bottom && t.clientX < n.left;
}
function cL(t, e, A) {
  var n = QA(bM(A.el, A.options.draggable)), s = yx(A.el, A.options, $e), r = 10;
  return e ? t.clientX > s.right + r || t.clientY > n.bottom && t.clientX > n.left : t.clientY > s.bottom + r || t.clientX > n.right && t.clientY > n.top;
}
function lL(t, e, A, n, s, r, i, o) {
  var a = n ? t.clientY : t.clientX, c = n ? A.height : A.width, l = n ? A.top : A.left, B = n ? A.bottom : A.right, g = !1;
  if (!i) {
    if (o && K0 < c * s) {
      if (!RB && (kB === 1 ? a > l + c * r / 2 : a < B - c * r / 2) && (RB = !0), RB)
        g = !0;
      else if (kB === 1 ? a < l + K0 : a > B - K0)
        return -kB;
    } else if (a > l + c * (1 - s) / 2 && a < B - c * (1 - s) / 2)
      return BL(e);
  }
  return g = g || i, g && (a < l + c * r / 2 || a > B - c * r / 2) ? a > l + c / 2 ? 1 : -1 : 0;
}
function BL(t) {
  return ps(Ce) < ps(t) ? 1 : -1;
}
function gL(t) {
  for (var e = t.tagName + t.className + t.src + t.href + t.textContent, A = e.length, n = 0; A--; )
    n += e.charCodeAt(A);
  return n.toString(36);
}
function hL(t) {
  Gu.length = 0;
  for (var e = t.getElementsByTagName("input"), A = e.length; A--; ) {
    var n = e[A];
    n.checked && Gu.push(n);
  }
}
function V0(t) {
  return setTimeout(t, 0);
}
function MC(t) {
  return clearTimeout(t);
}
Cw && Et(document, "touchmove", function(t) {
  (Pe.active || Lc) && t.cancelable && t.preventDefault();
});
Pe.utils = {
  on: Et,
  off: wt,
  css: qe,
  find: Mx,
  is: function(e, A) {
    return !!Ks(e, A, e, !1);
  },
  extend: XR,
  throttle: px,
  closest: Ks,
  toggleClass: As,
  clone: Yx,
  index: ps,
  nextTick: V0,
  cancelNextTick: MC,
  detectDirection: Nx,
  getChild: fl,
  expando: Kn
};
Pe.get = function(t) {
  return t[Kn];
};
Pe.mount = function() {
  for (var t = arguments.length, e = new Array(t), A = 0; A < t; A++)
    e[A] = arguments[A];
  e[0].constructor === Array && (e = e[0]), e.forEach(function(n) {
    if (!n.prototype || !n.prototype.constructor)
      throw "Sortable: Mounted plugin must be a constructor function, not ".concat({}.toString.call(n));
    n.utils && (Pe.utils = Rr(Rr({}, Pe.utils), n.utils)), lh.mount(n);
  });
};
Pe.create = function(t, e) {
  return new Pe(t, e);
};
Pe.version = KR;
var wA = [], QB, pC, mC = !1, gQ, hQ, zu, IB;
function uL() {
  function t() {
    this.defaults = {
      scroll: !0,
      forceAutoScrollFallback: !1,
      scrollSensitivity: 30,
      scrollSpeed: 10,
      bubbleScroll: !0
    };
    for (var e in this)
      e.charAt(0) === "_" && typeof this[e] == "function" && (this[e] = this[e].bind(this));
  }
  return t.prototype = {
    dragStarted: function(A) {
      var n = A.originalEvent;
      this.sortable.nativeDraggable ? Et(document, "dragover", this._handleAutoScroll) : this.options.supportPointer ? Et(document, "pointermove", this._handleFallbackAutoScroll) : n.touches ? Et(document, "touchmove", this._handleFallbackAutoScroll) : Et(document, "mousemove", this._handleFallbackAutoScroll);
    },
    dragOverCompleted: function(A) {
      var n = A.originalEvent;
      !this.options.dragOverBubble && !n.rootEl && this._handleAutoScroll(n);
    },
    drop: function() {
      this.sortable.nativeDraggable ? wt(document, "dragover", this._handleAutoScroll) : (wt(document, "pointermove", this._handleFallbackAutoScroll), wt(document, "touchmove", this._handleFallbackAutoScroll), wt(document, "mousemove", this._handleFallbackAutoScroll)), T2(), X0(), ZR();
    },
    nulling: function() {
      zu = pC = QB = mC = IB = gQ = hQ = null, wA.length = 0;
    },
    _handleFallbackAutoScroll: function(A) {
      this._handleAutoScroll(A, !0);
    },
    _handleAutoScroll: function(A, n) {
      var s = this, r = (A.touches ? A.touches[0] : A).clientX, i = (A.touches ? A.touches[0] : A).clientY, o = document.elementFromPoint(r, i);
      if (zu = A, n || this.options.forceAutoScrollFallback || ch || _i || vB) {
        uQ(A, this.options, o, n);
        var a = zo(o, !0);
        mC && (!IB || r !== gQ || i !== hQ) && (IB && T2(), IB = setInterval(function() {
          var c = zo(document.elementFromPoint(r, i), !0);
          c !== a && (a = c, X0()), uQ(A, s.options, c, n);
        }, 10), gQ = r, hQ = i);
      } else {
        if (!this.options.bubbleScroll || zo(o, !0) === br()) {
          X0();
          return;
        }
        uQ(A, this.options, zo(o, !1), !1);
      }
    }
  }, Si(t, {
    pluginName: "scroll",
    initializeByDefault: !0
  });
}
function X0() {
  wA.forEach(function(t) {
    clearInterval(t.pid);
  }), wA = [];
}
function T2() {
  clearInterval(IB);
}
var uQ = px(function(t, e, A, n) {
  if (e.scroll) {
    var s = (t.touches ? t.touches[0] : t).clientX, r = (t.touches ? t.touches[0] : t).clientY, i = e.scrollSensitivity, o = e.scrollSpeed, a = br(), c = !1, l;
    pC !== A && (pC = A, X0(), QB = e.scroll, l = e.scrollFn, QB === !0 && (QB = zo(A, !0)));
    var B = 0, g = QB;
    do {
      var h = g, u = QA(h), d = u.top, w = u.bottom, Q = u.left, p = u.right, M = u.width, I = u.height, N = void 0, m = void 0, E = h.scrollWidth, G = h.scrollHeight, Y = qe(h), U = h.scrollLeft, v = h.scrollTop;
      h === a ? (N = M < E && (Y.overflowX === "auto" || Y.overflowX === "scroll" || Y.overflowX === "visible"), m = I < G && (Y.overflowY === "auto" || Y.overflowY === "scroll" || Y.overflowY === "visible")) : (N = M < E && (Y.overflowX === "auto" || Y.overflowX === "scroll"), m = I < G && (Y.overflowY === "auto" || Y.overflowY === "scroll"));
      var b = N && (Math.abs(p - s) <= i && U + M < E) - (Math.abs(Q - s) <= i && !!U), W = m && (Math.abs(w - r) <= i && v + I < G) - (Math.abs(d - r) <= i && !!v);
      if (!wA[B])
        for (var q = 0; q <= B; q++)
          wA[q] || (wA[q] = {});
      (wA[B].vx != b || wA[B].vy != W || wA[B].el !== h) && (wA[B].el = h, wA[B].vx = b, wA[B].vy = W, clearInterval(wA[B].pid), (b != 0 || W != 0) && (c = !0, wA[B].pid = setInterval((function() {
        n && this.layer === 0 && Pe.active._onTouchMove(zu);
        var ne = wA[this.layer].vy ? wA[this.layer].vy * o : 0, V = wA[this.layer].vx ? wA[this.layer].vx * o : 0;
        typeof l == "function" && l.call(Pe.dragged.parentNode[Kn], V, ne, t, zu, wA[this.layer].el) !== "continue" || mx(wA[this.layer].el, V, ne);
      }).bind({
        layer: B
      }), 24))), B++;
    } while (e.bubbleScroll && g !== a && (g = zo(g, !1)));
    mC = c;
  }
}, 30), zx = function(e) {
  var A = e.originalEvent, n = e.putSortable, s = e.dragEl, r = e.activeSortable, i = e.dispatchSortableEvent, o = e.hideGhostForTarget, a = e.unhideGhostForTarget;
  if (A) {
    var c = n || r;
    o();
    var l = A.changedTouches && A.changedTouches.length ? A.changedTouches[0] : A, B = document.elementFromPoint(l.clientX, l.clientY);
    a(), c && !c.el.contains(B) && (i("spill"), this.onSpill({
      dragEl: s,
      putSortable: n
    }));
  }
};
function vM() {
}
vM.prototype = {
  startIndex: null,
  dragStart: function(e) {
    var A = e.oldDraggableIndex;
    this.startIndex = A;
  },
  onSpill: function(e) {
    var A = e.dragEl, n = e.putSortable;
    this.sortable.captureAnimationState(), n && n.captureAnimationState();
    var s = fl(this.sortable.el, this.startIndex, this.options);
    s ? this.sortable.el.insertBefore(A, s) : this.sortable.el.appendChild(A), this.sortable.animateAll(), n && n.animateAll();
  },
  drop: zx
};
Si(vM, {
  pluginName: "revertOnSpill"
});
function jM() {
}
jM.prototype = {
  onSpill: function(e) {
    var A = e.dragEl, n = e.putSortable, s = n || this.sortable;
    s.captureAnimationState(), A.parentNode && A.parentNode.removeChild(A), s.animateAll();
  },
  drop: zx
};
Si(jM, {
  pluginName: "removeOnSpill"
});
Pe.mount(new uL());
Pe.mount(jM, vM);
const dL = "data:image/svg+xml,%3csvg%20width='15'%20height='16'%20viewBox='0%200%2015%2016'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M7.4998%201.3332V14.6668M0.833008%208H14.1666'%20stroke='white'%20stroke-width='1.67'%20stroke-linecap='round'%20stroke-linejoin='round'/%3e%3c/svg%3e", wL = {
  class: "book-chapter-line",
  style: { border: "2px solid #eaecf0" }
}, fL = { class: "content" }, QL = {
  key: 0,
  class: "drag-icon"
}, IL = ["src"], CL = { class: "chapter-name" }, EL = ["src"], ML = ["src"], pL = { class: "procedures-section" }, mL = { class: "procedures-wrapper" }, YL = ["data-procedure"], yL = {
  key: 1,
  class: "procedures-list"
}, FL = /* @__PURE__ */ Un({
  shadow: !1,
  __name: "BookChapterLine.ce",
  props: {
    id: String,
    name: String,
    editable: Boolean,
    debug: {
      type: Boolean,
      default: !1
    },
    procedures: {
      type: [Array, String],
      default: () => []
    }
  },
  emits: ["add-procedure", "menu-click", "procedure-move"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = (u) => {
      if (!u) return [];
      if (Array.isArray(u)) return [...u];
      if (typeof u == "string") {
        const d = u.trim();
        if (!d) return [];
        try {
          const w = JSON.parse(d);
          return Array.isArray(w) ? [...w] : [];
        } catch {
          return [];
        }
      }
      return [];
    }, r = /* @__PURE__ */ me([]);
    CA(
      () => A.procedures,
      (u) => {
        r.value = s(u);
      },
      { immediate: !0, deep: !0 }
    );
    const i = Fe(() => r.value), o = (u, d) => {
      A.debug && console.log(`[BookChapterLine][drag] ${u}`, d);
    }, a = (u) => {
      try {
        return JSON.stringify(u);
      } catch {
        return "";
      }
    }, c = (u) => {
      var w, Q;
      const d = (Q = (w = u == null ? void 0 : u.item) == null ? void 0 : w.dataset) == null ? void 0 : Q.procedure;
      if (!d) return null;
      try {
        return JSON.parse(d);
      } catch {
        return null;
      }
    }, l = /* @__PURE__ */ me(null);
    let B = null;
    const g = (u) => {
      o("change", u), n("procedure-move", {
        chapterId: A.id,
        event: u,
        procedures: r.value
      });
    }, h = () => {
      l.value && (B == null || B.destroy(), B = Pe.create(l.value, {
        animation: 150,
        ghostClass: "ghost-procedure",
        draggable: ".procedure-item",
        handle: ".drag-icon",
        group: {
          name: "procedures",
          pull: !0,
          put: !0
        },
        forceFallback: !0,
        fallbackOnBody: !0,
        disabled: !A.editable,
        onStart: (u) => o("start", u),
        onEnd: (u) => o("end", u),
        onChoose: (u) => o("choose", u),
        onUnchoose: (u) => o("unchoose", u),
        onUpdate: (u) => {
          const { oldIndex: d, newIndex: w } = u;
          if (d == null || w == null || d === w) return;
          const Q = [...r.value], [p] = Q.splice(d, 1);
          Q.splice(w, 0, p), r.value = Q, g({ type: "update", oldIndex: d, newIndex: w });
        },
        onAdd: (u) => {
          const { newIndex: d } = u, w = c(u);
          if (!w) return;
          const Q = [...r.value], p = d ?? Q.length;
          Q.splice(p, 0, w), r.value = Q, g({ type: "add", newIndex: p, procedure: w });
        },
        onRemove: (u) => {
          const { oldIndex: d } = u;
          if (d == null) return;
          const w = [...r.value], [Q] = w.splice(d, 1);
          r.value = w, g({ type: "remove", oldIndex: d, procedure: Q });
        }
      }));
    };
    return CA(
      () => A.editable,
      (u) => {
        B && B.option("disabled", !u);
      }
    ), Xr(h), Zr(() => {
      B == null || B.destroy(), B = null;
    }), (u, d) => {
      const w = tr("exiq-book-procedure-line");
      return ee(), Ae("div", wL, [
        F("div", {
          class: De(["chapter-header", { "has-procedures": i.value.length > 0 }])
        }, [
          d[3] || (d[3] = F("div", { class: "orange-bar" }, null, -1)),
          F("div", fL, [
            t.editable ? (ee(), Ae("div", QL, [
              F("img", {
                src: bs(fx),
                alt: "Drag handle"
              }, null, 8, IL)
            ])) : je("", !0),
            F("div", CL, Mt(t.name), 1),
            F("button", {
              class: "add-procedure-btn",
              onClick: d[0] || (d[0] = (Q) => u.$emit("add-procedure"))
            }, [
              F("img", {
                src: bs(dL),
                alt: "Add",
                class: "plus-icon"
              }, null, 8, EL),
              d[2] || (d[2] = F("span", null, "Add Procedure", -1))
            ]),
            F("div", {
              class: "menu-icon",
              onClick: d[1] || (d[1] = (Q) => u.$emit("menu-click"))
            }, [
              F("img", {
                src: bs(Qx),
                alt: "Menu"
              }, null, 8, ML)
            ])
          ])
        ], 2),
        F("div", pL, [
          F("div", mL, [
            d[4] || (d[4] = F("div", { class: "orange-bar-continuation" }, null, -1)),
            u.$slots.procedures ? (ee(), Ae("div", yL, [
              Ni(u.$slots, "procedures")
            ])) : (ee(), Ae("div", {
              key: 0,
              ref_key: "proceduresListRef",
              ref: l,
              class: "procedures-list"
            }, [
              (ee(!0), Ae(ft, null, Ns(r.value, (Q, p) => (ee(), Ae("div", {
                key: Q.name + p,
                class: "procedure-item",
                "data-procedure": a(Q)
              }, [
                rt(w, {
                  name: Q.name,
                  status: Q.status,
                  editable: t.editable
                }, null, 8, ["name", "status", "editable"])
              ], 8, YL))), 128))
            ], 512))
          ])
        ])
      ]);
    };
  }
}), NL = ":host{display:block;width:100%}.book-chapter-line{display:flex;flex-direction:column;width:100%;border:1px solid #eaecf0;background-color:#fff;margin-bottom:16px}.chapter-header{display:flex;align-items:stretch;width:100%;height:65px;position:relative;z-index:2}.orange-bar{width:7px;height:100%;background-color:#d87f47;flex-shrink:0}.content{flex:1;display:flex;align-items:center;gap:10px;padding:0 5px 0 13px;background-color:#fff;transition:background-color .2s ease;min-width:0}.drag-icon{width:24px;height:24px;flex-shrink:0;display:flex;align-items:center;justify-content:center}.drag-icon img{width:100%;height:100%;display:block}.chapter-name{flex:1;font-family:Inter,sans-serif;font-size:20px;font-weight:600;line-height:28px;color:#475467;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;min-width:0}.add-procedure-btn{display:flex;align-items:center;justify-content:center;gap:8px;padding:8px 14px;background-color:#7f56d9;border:1px solid #7f56d9;border-radius:8px;color:#fff;font-family:Inter,sans-serif;font-size:14px;font-weight:600;line-height:20px;cursor:pointer;flex-shrink:0;box-shadow:0 1px 2px #1018280d;transition:background-color .2s ease,border-color .2s ease}.add-procedure-btn:hover{background-color:#6941c6;border-color:#6941c6}.plus-icon{width:20px;height:20px;display:block;filter:brightness(0) invert(1)}.menu-icon{width:40px;height:40px;flex-shrink:0;display:flex;align-items:center;justify-content:center;border-radius:8px;cursor:pointer;transition:background-color .2s ease}.menu-icon:hover{background-color:#0000000d}.menu-icon img{width:24px;height:24px;display:block}.procedures-section{width:100%;position:relative;z-index:1}.procedures-wrapper{display:flex;gap:21px;width:100%}.orange-bar-continuation{width:7px;flex-shrink:0;background-color:#d87f47;align-self:stretch}.procedures-list{flex:1;display:flex;flex-direction:column;gap:4px;min-width:0;min-height:20px;position:relative;z-index:1}.procedure-item{width:100%}.ghost-procedure{opacity:.5;background:#ece6f9}.draggable-area{display:flex;flex-direction:column;gap:4px;width:100%}.empty-procedures-placeholder{height:auto}@media(max-width:960px){.chapter-name{font-size:18px;line-height:24px}}@media(max-width:600px){.chapter-header{height:auto;min-height:65px}.content{padding:12px 5px 12px 13px;gap:8px;flex-wrap:wrap}.chapter-name{font-size:16px;line-height:22px;flex:1 1 100%}.add-procedure-btn{font-size:12px;padding:6px 10px}.add-procedure-btn span{display:none}.procedures-wrapper{gap:12px}}", DL = /* @__PURE__ */ ZA(FL, [["styles", [NL]]]), xL = { class: "book-toc-edit-box" }, GL = ["data-procedure"], zL = /* @__PURE__ */ Un({
  shadow: !1,
  __name: "BookTableOfContentEditBox.ce",
  props: {
    chapters: {
      type: [Array, String],
      default: () => []
    },
    procedures: {
      type: [Array, String],
      default: () => []
    },
    debug: {
      type: Boolean,
      default: !1
    }
  },
  emits: [
    "add-procedure",
    "chapter-menu-click",
    "chapters-update",
    "procedure-move",
    "procedure-menu-click",
    "procedures-update"
  ],
  setup(t, { emit: e }) {
    const A = t, n = e, s = /* @__PURE__ */ me([]), r = /* @__PURE__ */ me([]), i = (I, N) => {
      A.debug && console.log(`[BookTableOfContentEditBox][drag] ${I}`, N);
    }, o = (I) => {
      if (!I) return [];
      if (Array.isArray(I)) return [...I];
      if (typeof I == "string") {
        const N = I.trim();
        if (!N) return [];
        try {
          const m = JSON.parse(N);
          return Array.isArray(m) ? [...m] : [];
        } catch {
          return [];
        }
      }
      return [];
    };
    CA(
      () => A.procedures,
      (I) => {
        s.value = o(I);
      },
      { immediate: !0, deep: !0 }
    ), CA(
      () => A.chapters,
      (I) => {
        r.value = o(I);
      },
      { immediate: !0, deep: !0 }
    );
    const a = (I) => {
      try {
        return JSON.stringify(I);
      } catch {
        return "";
      }
    }, c = (I) => {
      var m, E;
      const N = (E = (m = I == null ? void 0 : I.item) == null ? void 0 : m.dataset) == null ? void 0 : E.procedure;
      if (!N) return null;
      try {
        return JSON.parse(N);
      } catch {
        return null;
      }
    }, l = /* @__PURE__ */ me(null), B = /* @__PURE__ */ me(null);
    let g = null, h = null;
    const u = (I) => {
      n("procedures-update", {
        procedures: s.value,
        event: I
      });
    }, d = (I) => {
      n("chapters-update", {
        chapters: r.value,
        event: I
      });
    }, w = () => {
      l.value && (g == null || g.destroy(), g = Pe.create(l.value, {
        animation: 150,
        ghostClass: "ghost-procedure",
        draggable: ".procedure-item",
        group: {
          name: "procedures",
          pull: !0,
          put: !0
        },
        forceFallback: !0,
        fallbackOnBody: !0,
        onStart: (I) => i("procedures-start", I),
        onEnd: (I) => i("procedures-end", I),
        onUpdate: (I) => {
          const { oldIndex: N, newIndex: m } = I;
          if (N == null || m == null || N === m) return;
          const E = [...s.value], [G] = E.splice(N, 1);
          E.splice(m, 0, G), s.value = E, u({ type: "update", oldIndex: N, newIndex: m });
        },
        onAdd: (I) => {
          const { newIndex: N } = I, m = c(I);
          if (!m) return;
          const E = [...s.value], G = N ?? E.length;
          E.splice(G, 0, m), s.value = E, u({ type: "add", newIndex: G, procedure: m });
        },
        onRemove: (I) => {
          const { oldIndex: N } = I;
          if (N == null) return;
          const m = [...s.value], [E] = m.splice(N, 1);
          s.value = m, u({ type: "remove", oldIndex: N, procedure: E });
        }
      }));
    }, Q = () => {
      g == null || g.destroy(), g = null;
    }, p = () => {
      B.value && (h == null || h.destroy(), h = Pe.create(B.value, {
        animation: 150,
        ghostClass: "ghost-chapter",
        draggable: ".chapter-item",
        handle: ".drag-icon",
        forceFallback: !0,
        fallbackOnBody: !0,
        onStart: (I) => i("chapters-start", I),
        onEnd: (I) => i("chapters-end", I),
        onUpdate: (I) => {
          const { oldIndex: N, newIndex: m } = I;
          if (N == null || m == null || N === m) return;
          const E = [...r.value], [G] = E.splice(N, 1);
          E.splice(m, 0, G), r.value = E, d({ type: "update", oldIndex: N, newIndex: m });
        }
      }));
    }, M = (I) => {
      if ((I == null ? void 0 : I.chapterId) != null) {
        const N = r.value.findIndex(
          (m) => String(m.id) === String(I.chapterId)
        );
        if (N >= 0 && Array.isArray(I.procedures)) {
          const m = [...r.value];
          m[N] = {
            ...m[N],
            procedures: I.procedures
          }, r.value = m;
        }
      }
      n("procedure-move", I);
    };
    return Xr(() => {
      w(), p();
    }), CA(
      () => s.value.length,
      async (I) => {
        I > 0 ? (await Yn(), w()) : Q();
      }
    ), Zr(() => {
      Q(), h == null || h.destroy(), h = null;
    }), (I, N) => {
      const m = tr("exiq-book-procedure-line"), E = tr("exiq-book-chapter-line");
      return ee(), Ae("div", xL, [
        s.value.length > 0 ? (ee(), Ae("div", {
          key: 0,
          ref_key: "proceduresOutsideRef",
          ref: l,
          class: "procedures-outside-container"
        }, [
          (ee(!0), Ae(ft, null, Ns(s.value, (G, Y) => (ee(), Ae("div", {
            key: G.name + Y,
            class: "procedure-item",
            "data-procedure": a(G)
          }, [
            rt(m, {
              name: G.name,
              status: G.status,
              editable: G.editable !== !1,
              onMenuClick: (U) => I.$emit("procedure-menu-click", G)
            }, null, 8, ["name", "status", "editable", "onMenuClick"])
          ], 8, GL))), 128))
        ], 512)) : je("", !0),
        F("div", {
          ref_key: "chaptersRef",
          ref: B,
          class: "chapters-container"
        }, [
          (ee(!0), Ae(ft, null, Ns(r.value, (G) => (ee(), Ae("div", {
            key: G.id,
            class: "chapter-item"
          }, [
            rt(E, {
              id: G.id,
              name: G.name,
              editable: G.editable !== !1,
              procedures: G.procedures,
              onAddProcedure: (Y) => I.$emit("add-procedure", G),
              onMenuClick: (Y) => I.$emit("chapter-menu-click", G),
              onProcedureMove: M
            }, null, 8, ["id", "name", "editable", "procedures", "onAddProcedure", "onMenuClick"])
          ]))), 128))
        ], 512)
      ]);
    };
  }
}), UL = ":host{display:block;width:100%}.book-toc-edit-box{display:flex;flex-direction:column;width:100%;min-height:50px}.chapters-container{display:flex;flex-direction:column;gap:24px}.procedures-outside-container{display:flex;flex-direction:column;gap:4px;margin-bottom:24px;min-height:20px}.procedure-item,.chapter-item{width:100%}.ghost-chapter{opacity:.5}.ghost-procedure{opacity:.5;background:#ece6f9}", bL = /* @__PURE__ */ ZA(zL, [["styles", [UL]]]), vL = { class: "book-content-editor" }, jL = { class: "editor-header" }, HL = { class: "book-title" }, kL = { class: "editor-main-container" }, RL = { class: "editor-main-card" }, LL = { class: "content-box-wrapper" }, SL = { class: "summary-wrapper" }, TL = {
  key: 0,
  class: "summary-wrapper"
}, JL = { class: "empty-state" }, WL = /* @__PURE__ */ Un({
  shadow: !1,
  __name: "BookContentEditor.ce",
  props: {
    // Breadcrumb props
    location: { type: String, default: "Book" },
    bookName: { type: String, default: "Book Name" },
    chapterName: { type: String, default: "Chapter Name" },
    procedureName: { type: String, default: "Procedure" },
    // Menu props
    notifications: { type: Number, default: 0 },
    debug: { type: Boolean, default: !1 },
    // Data props
    chapters: { type: [Array, String], default: () => [] },
    procedures: { type: [Array, String], default: () => [] }
  },
  emits: [
    "breadcrumb-click",
    "tab-change",
    "add-procedure",
    "add-chapter",
    "open-chat",
    "menu-click",
    "chapter-menu-click",
    "procedure-menu-click",
    "chapters-update",
    "procedures-update",
    "procedure-move"
  ],
  setup(t, { emit: e }) {
    const A = t, n = e, s = bn(), r = /* @__PURE__ */ me("content"), i = /* @__PURE__ */ me([]), o = /* @__PURE__ */ me([]), a = (Y, U) => {
      var v;
      if (n(Y, U), (v = s == null ? void 0 : s.proxy) != null && v.$el) {
        const b = new CustomEvent(Y, {
          detail: U,
          bubbles: !0,
          composed: !0
        });
        s.proxy.$el.dispatchEvent(b);
      }
    }, c = (Y) => Y && Y.detail ? Array.isArray(Y.detail) ? Y.detail[0] : Y.detail : Y, l = (Y) => {
      var U, v;
      try {
        (U = Y == null ? void 0 : Y.stopImmediatePropagation) == null || U.call(Y);
      } catch {
      }
      try {
        (v = Y == null ? void 0 : Y.stopPropagation) == null || v.call(Y);
      } catch {
      }
    }, B = (Y) => {
      if (!Y) return [];
      if (Array.isArray(Y)) return [...Y];
      if (typeof Y == "string") {
        const U = Y.trim();
        if (!U) return [];
        try {
          const v = JSON.parse(U);
          return Array.isArray(v) ? [...v] : [];
        } catch {
          return [];
        }
      }
      return [];
    };
    CA(
      () => A.chapters,
      (Y) => {
        i.value = B(Y);
      },
      { immediate: !0, deep: !0 }
    ), CA(
      () => A.procedures,
      (Y) => {
        o.value = B(Y);
      },
      { immediate: !0, deep: !0 }
    );
    const g = (Y) => {
      l(Y), a("breadcrumb-click", c(Y));
    }, h = (Y) => {
      l(Y);
      const U = c(Y);
      typeof U == "string" && (r.value = U, A.debug && console.log("[BookContentEditor] tab-change", U)), a("tab-change", U);
    }, u = (Y) => {
      l(Y), a("add-procedure");
    }, d = (Y) => {
      l(Y), a("add-chapter");
    }, w = (Y) => {
      l(Y), a("open-chat");
    }, Q = (Y) => {
      l(Y), a("menu-click", c(Y));
    }, p = (Y) => {
      l(Y), a("add-procedure", c(Y));
    }, M = (Y) => {
      l(Y), a("chapter-menu-click", c(Y));
    }, I = (Y) => {
      l(Y), a("procedure-menu-click", c(Y));
    }, N = (Y) => {
      l(Y);
      const U = c(Y);
      Array.isArray(U == null ? void 0 : U.chapters) && (i.value = U.chapters), a("chapters-update", U);
    }, m = (Y) => {
      l(Y);
      const U = c(Y);
      Array.isArray(U == null ? void 0 : U.procedures) && (o.value = U.procedures), a("procedures-update", U);
    }, E = (Y) => {
      l(Y);
      const U = c(Y);
      if ((U == null ? void 0 : U.chapterId) != null && Array.isArray(U == null ? void 0 : U.procedures)) {
        const v = i.value.findIndex(
          (b) => String(b.id) === String(U.chapterId)
        );
        if (v >= 0) {
          const b = [...i.value];
          b[v] = {
            ...b[v],
            procedures: U.procedures
          }, i.value = b;
        }
      }
      a("procedure-move", U);
    }, G = (Y) => {
      A.debug && console.log("[BookContentEditor] window tab-change", Y.detail);
    };
    return Xr(() => {
      A.debug && window.addEventListener("tab-change", G);
    }), Zr(() => {
      A.debug && window.removeEventListener("tab-change", G);
    }), (Y, U) => {
      const v = tr("exiq-procedures-breadcrumb"), b = tr("exiq-book-content-edit-menu"), W = tr("exiq-book-table-of-content-edit-box");
      return ee(), Ae("div", vL, [
        F("header", jL, [
          rt(v, {
            location: t.location,
            "book-name": t.bookName,
            "chapter-name": t.chapterName,
            "procedure-name": t.procedureName,
            onOnClick: g
          }, null, 8, ["location", "book-name", "chapter-name", "procedure-name"]),
          F("h1", HL, Mt(t.bookName), 1)
        ]),
        F("main", kL, [
          rt(b, {
            ".initial-tab": r.value,
            ".notifications": t.notifications,
            onTabChange: h,
            onAddProcedure: u,
            onAddChapter: d,
            onOpenChat: w,
            onMenuClick: Q
          }, null, 40, [".initial-tab", ".notifications"]),
          F("div", RL, [
            Go(F("div", LL, [
              Ni(Y.$slots, "content", {}, () => [
                rt(W, {
                  ".chapters": i.value,
                  ".procedures": o.value,
                  onAddProcedure: p,
                  onChapterMenuClick: M,
                  onProcedureMenuClick: I,
                  onChaptersUpdate: N,
                  onProceduresUpdate: m,
                  onProcedureMove: E
                }, null, 40, [".chapters", ".procedures"])
              ])
            ], 512), [
              [IC, r.value === "content"]
            ]),
            Go(F("div", SL, [
              Ni(Y.$slots, "summary", {}, () => [
                U[0] || (U[0] = F("div", { class: "empty-state" }, " Summary content goes here... ", -1))
              ])
            ], 512), [
              [IC, r.value === "summary"]
            ]),
            r.value !== "content" && r.value !== "summary" ? (ee(), Ae("div", TL, [
              Ni(Y.$slots, `tab-${r.value}`, {}, () => [
                F("div", JL, ' No content provided for "' + Mt(r.value) + '". ', 1)
              ])
            ])) : je("", !0)
          ])
        ])
      ]);
    };
  }
}), OL = ":host{display:block;width:100%;background-color:#f9fafb;min-height:100vh}.book-content-editor{display:flex;flex-direction:column;width:100%;max-width:1280px;margin:0 auto;padding:24px;box-sizing:border-box}.editor-header{margin-bottom:8px}.book-title{font-family:Inter,sans-serif;font-size:30px;font-weight:700;line-height:38px;color:#101828;margin:-4px 0 -12px}exiq-book-content-edit-menu{position:relative;z-index:50}.editor-main-container{display:flex;flex-direction:column}.editor-main-card{position:relative;z-index:0;background-color:#fff;border:1px solid #EAECF0;border-radius:12px;box-shadow:0 1px 2px #1018280d;overflow:hidden;min-height:200px;margin-top:0}.content-box-wrapper{padding:24px;display:block;min-height:100px;background-color:#fff}.summary-wrapper{padding:48px;text-align:center;color:#667085}.empty-state{font-family:Inter,sans-serif;font-size:16px}", PL = /* @__PURE__ */ ZA(WL, [["styles", [OL]]]);
function JA(t) {
  this.content = t;
}
JA.prototype = {
  constructor: JA,
  find: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      if (this.content[e] === t) return e;
    return -1;
  },
  // :: (string) → ?any
  // Retrieve the value stored under `key`, or return undefined when
  // no such key exists.
  get: function(t) {
    var e = this.find(t);
    return e == -1 ? void 0 : this.content[e + 1];
  },
  // :: (string, any, ?string) → OrderedMap
  // Create a new map by replacing the value of `key` with a new
  // value, or adding a binding to the end of the map. If `newKey` is
  // given, the key of the binding will be replaced with that key.
  update: function(t, e, A) {
    var n = A && A != t ? this.remove(A) : this, s = n.find(t), r = n.content.slice();
    return s == -1 ? r.push(A || t, e) : (r[s + 1] = e, A && (r[s] = A)), new JA(r);
  },
  // :: (string) → OrderedMap
  // Return a map with the given key removed, if it existed.
  remove: function(t) {
    var e = this.find(t);
    if (e == -1) return this;
    var A = this.content.slice();
    return A.splice(e, 2), new JA(A);
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the start of the map.
  addToStart: function(t, e) {
    return new JA([t, e].concat(this.remove(t).content));
  },
  // :: (string, any) → OrderedMap
  // Add a new key to the end of the map.
  addToEnd: function(t, e) {
    var A = this.remove(t).content.slice();
    return A.push(t, e), new JA(A);
  },
  // :: (string, string, any) → OrderedMap
  // Add a key after the given key. If `place` is not found, the new
  // key is added to the end.
  addBefore: function(t, e, A) {
    var n = this.remove(e), s = n.content.slice(), r = n.find(t);
    return s.splice(r == -1 ? s.length : r, 0, e, A), new JA(s);
  },
  // :: ((key: string, value: any))
  // Call the given function for each key/value pair in the map, in
  // order.
  forEach: function(t) {
    for (var e = 0; e < this.content.length; e += 2)
      t(this.content[e], this.content[e + 1]);
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by prepending the keys in this map that don't
  // appear in `map` before the keys in `map`.
  prepend: function(t) {
    return t = JA.from(t), t.size ? new JA(t.content.concat(this.subtract(t).content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a new map by appending the keys in this map that don't
  // appear in `map` after the keys in `map`.
  append: function(t) {
    return t = JA.from(t), t.size ? new JA(this.subtract(t).content.concat(t.content)) : this;
  },
  // :: (union<Object, OrderedMap>) → OrderedMap
  // Create a map containing all the keys in this map that don't
  // appear in `map`.
  subtract: function(t) {
    var e = this;
    t = JA.from(t);
    for (var A = 0; A < t.content.length; A += 2)
      e = e.remove(t.content[A]);
    return e;
  },
  // :: () → Object
  // Turn ordered map into a plain object.
  toObject: function() {
    var t = {};
    return this.forEach(function(e, A) {
      t[e] = A;
    }), t;
  },
  // :: number
  // The amount of keys in this map.
  get size() {
    return this.content.length >> 1;
  }
};
JA.from = function(t) {
  if (t instanceof JA) return t;
  var e = [];
  if (t) for (var A in t) e.push(A, t[A]);
  return new JA(e);
};
function Ux(t, e, A) {
  for (let n = 0; ; n++) {
    if (n == t.childCount || n == e.childCount)
      return t.childCount == e.childCount ? null : A;
    let s = t.child(n), r = e.child(n);
    if (s == r) {
      A += s.nodeSize;
      continue;
    }
    if (!s.sameMarkup(r))
      return A;
    if (s.isText && s.text != r.text) {
      for (let i = 0; s.text[i] == r.text[i]; i++)
        A++;
      return A;
    }
    if (s.content.size || r.content.size) {
      let i = Ux(s.content, r.content, A + 1);
      if (i != null)
        return i;
    }
    A += s.nodeSize;
  }
}
function bx(t, e, A, n) {
  for (let s = t.childCount, r = e.childCount; ; ) {
    if (s == 0 || r == 0)
      return s == r ? null : { a: A, b: n };
    let i = t.child(--s), o = e.child(--r), a = i.nodeSize;
    if (i == o) {
      A -= a, n -= a;
      continue;
    }
    if (!i.sameMarkup(o))
      return { a: A, b: n };
    if (i.isText && i.text != o.text) {
      let c = 0, l = Math.min(i.text.length, o.text.length);
      for (; c < l && i.text[i.text.length - c - 1] == o.text[o.text.length - c - 1]; )
        c++, A--, n--;
      return { a: A, b: n };
    }
    if (i.content.size || o.content.size) {
      let c = bx(i.content, o.content, A - 1, n - 1);
      if (c)
        return c;
    }
    A -= a, n -= a;
  }
}
class re {
  /**
  @internal
  */
  constructor(e, A) {
    if (this.content = e, this.size = A || 0, A == null)
      for (let n = 0; n < e.length; n++)
        this.size += e[n].nodeSize;
  }
  /**
  Invoke a callback for all descendant nodes between the given two
  positions (relative to start of this fragment). Doesn't descend
  into a node when the callback returns `false`.
  */
  nodesBetween(e, A, n, s = 0, r) {
    for (let i = 0, o = 0; o < A; i++) {
      let a = this.content[i], c = o + a.nodeSize;
      if (c > e && n(a, s + o, r || null, i) !== !1 && a.content.size) {
        let l = o + 1;
        a.nodesBetween(Math.max(0, e - l), Math.min(a.content.size, A - l), n, s + l);
      }
      o = c;
    }
  }
  /**
  Call the given callback for every descendant node. `pos` will be
  relative to the start of the fragment. The callback may return
  `false` to prevent traversal of a given node's children.
  */
  descendants(e) {
    this.nodesBetween(0, this.size, e);
  }
  /**
  Extract the text between `from` and `to`. See the same method on
  [`Node`](https://prosemirror.net/docs/ref/#model.Node.textBetween).
  */
  textBetween(e, A, n, s) {
    let r = "", i = !0;
    return this.nodesBetween(e, A, (o, a) => {
      let c = o.isText ? o.text.slice(Math.max(e, a) - a, A - a) : o.isLeaf ? s ? typeof s == "function" ? s(o) : s : o.type.spec.leafText ? o.type.spec.leafText(o) : "" : "";
      o.isBlock && (o.isLeaf && c || o.isTextblock) && n && (i ? i = !1 : r += n), r += c;
    }, 0), r;
  }
  /**
  Create a new fragment containing the combined content of this
  fragment and the other.
  */
  append(e) {
    if (!e.size)
      return this;
    if (!this.size)
      return e;
    let A = this.lastChild, n = e.firstChild, s = this.content.slice(), r = 0;
    for (A.isText && A.sameMarkup(n) && (s[s.length - 1] = A.withText(A.text + n.text), r = 1); r < e.content.length; r++)
      s.push(e.content[r]);
    return new re(s, this.size + e.size);
  }
  /**
  Cut out the sub-fragment between the two given positions.
  */
  cut(e, A = this.size) {
    if (e == 0 && A == this.size)
      return this;
    let n = [], s = 0;
    if (A > e)
      for (let r = 0, i = 0; i < A; r++) {
        let o = this.content[r], a = i + o.nodeSize;
        a > e && ((i < e || a > A) && (o.isText ? o = o.cut(Math.max(0, e - i), Math.min(o.text.length, A - i)) : o = o.cut(Math.max(0, e - i - 1), Math.min(o.content.size, A - i - 1))), n.push(o), s += o.nodeSize), i = a;
      }
    return new re(n, s);
  }
  /**
  @internal
  */
  cutByIndex(e, A) {
    return e == A ? re.empty : e == 0 && A == this.content.length ? this : new re(this.content.slice(e, A));
  }
  /**
  Create a new fragment in which the node at the given index is
  replaced by the given node.
  */
  replaceChild(e, A) {
    let n = this.content[e];
    if (n == A)
      return this;
    let s = this.content.slice(), r = this.size + A.nodeSize - n.nodeSize;
    return s[e] = A, new re(s, r);
  }
  /**
  Create a new fragment by prepending the given node to this
  fragment.
  */
  addToStart(e) {
    return new re([e].concat(this.content), this.size + e.nodeSize);
  }
  /**
  Create a new fragment by appending the given node to this
  fragment.
  */
  addToEnd(e) {
    return new re(this.content.concat(e), this.size + e.nodeSize);
  }
  /**
  Compare this fragment to another one.
  */
  eq(e) {
    if (this.content.length != e.content.length)
      return !1;
    for (let A = 0; A < this.content.length; A++)
      if (!this.content[A].eq(e.content[A]))
        return !1;
    return !0;
  }
  /**
  The first child of the fragment, or `null` if it is empty.
  */
  get firstChild() {
    return this.content.length ? this.content[0] : null;
  }
  /**
  The last child of the fragment, or `null` if it is empty.
  */
  get lastChild() {
    return this.content.length ? this.content[this.content.length - 1] : null;
  }
  /**
  The number of child nodes in this fragment.
  */
  get childCount() {
    return this.content.length;
  }
  /**
  Get the child node at the given index. Raise an error when the
  index is out of range.
  */
  child(e) {
    let A = this.content[e];
    if (!A)
      throw new RangeError("Index " + e + " out of range for " + this);
    return A;
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content[e] || null;
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    for (let A = 0, n = 0; A < this.content.length; A++) {
      let s = this.content[A];
      e(s, n, A), n += s.nodeSize;
    }
  }
  /**
  Find the first position at which this fragment and another
  fragment differ, or `null` if they are the same.
  */
  findDiffStart(e, A = 0) {
    return Ux(this, e, A);
  }
  /**
  Find the first position, searching from the end, at which this
  fragment and the given fragment differ, or `null` if they are
  the same. Since this position will not be the same in both
  nodes, an object with two separate positions is returned.
  */
  findDiffEnd(e, A = this.size, n = e.size) {
    return bx(this, e, A, n);
  }
  /**
  Find the index and inner offset corresponding to a given relative
  position in this fragment. The result object will be reused
  (overwritten) the next time the function is called. @internal
  */
  findIndex(e) {
    if (e == 0)
      return t0(0, e);
    if (e == this.size)
      return t0(this.content.length, e);
    if (e > this.size || e < 0)
      throw new RangeError(`Position ${e} outside of fragment (${this})`);
    for (let A = 0, n = 0; ; A++) {
      let s = this.child(A), r = n + s.nodeSize;
      if (r >= e)
        return r == e ? t0(A + 1, r) : t0(A, n);
      n = r;
    }
  }
  /**
  Return a debugging string that describes this fragment.
  */
  toString() {
    return "<" + this.toStringInner() + ">";
  }
  /**
  @internal
  */
  toStringInner() {
    return this.content.join(", ");
  }
  /**
  Create a JSON-serializeable representation of this fragment.
  */
  toJSON() {
    return this.content.length ? this.content.map((e) => e.toJSON()) : null;
  }
  /**
  Deserialize a fragment from its JSON representation.
  */
  static fromJSON(e, A) {
    if (!A)
      return re.empty;
    if (!Array.isArray(A))
      throw new RangeError("Invalid input for Fragment.fromJSON");
    return new re(A.map(e.nodeFromJSON));
  }
  /**
  Build a fragment from an array of nodes. Ensures that adjacent
  text nodes with the same marks are joined together.
  */
  static fromArray(e) {
    if (!e.length)
      return re.empty;
    let A, n = 0;
    for (let s = 0; s < e.length; s++) {
      let r = e[s];
      n += r.nodeSize, s && r.isText && e[s - 1].sameMarkup(r) ? (A || (A = e.slice(0, s)), A[A.length - 1] = r.withText(A[A.length - 1].text + r.text)) : A && A.push(r);
    }
    return new re(A || e, n);
  }
  /**
  Create a fragment from something that can be interpreted as a
  set of nodes. For `null`, it returns the empty fragment. For a
  fragment, the fragment itself. For a node or array of nodes, a
  fragment containing those nodes.
  */
  static from(e) {
    if (!e)
      return re.empty;
    if (e instanceof re)
      return e;
    if (Array.isArray(e))
      return this.fromArray(e);
    if (e.attrs)
      return new re([e], e.nodeSize);
    throw new RangeError("Can not convert " + e + " to a Fragment" + (e.nodesBetween ? " (looks like multiple versions of prosemirror-model were loaded)" : ""));
  }
}
re.empty = new re([], 0);
const dQ = { index: 0, offset: 0 };
function t0(t, e) {
  return dQ.index = t, dQ.offset = e, dQ;
}
function Uu(t, e) {
  if (t === e)
    return !0;
  if (!(t && typeof t == "object") || !(e && typeof e == "object"))
    return !1;
  let A = Array.isArray(t);
  if (Array.isArray(e) != A)
    return !1;
  if (A) {
    if (t.length != e.length)
      return !1;
    for (let n = 0; n < t.length; n++)
      if (!Uu(t[n], e[n]))
        return !1;
  } else {
    for (let n in t)
      if (!(n in e) || !Uu(t[n], e[n]))
        return !1;
    for (let n in e)
      if (!(n in t))
        return !1;
  }
  return !0;
}
let Lt = class YC {
  /**
  @internal
  */
  constructor(e, A) {
    this.type = e, this.attrs = A;
  }
  /**
  Given a set of marks, create a new set which contains this one as
  well, in the right position. If this mark is already in the set,
  the set itself is returned. If any marks that are set to be
  [exclusive](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) with this mark are present,
  those are replaced by this one.
  */
  addToSet(e) {
    let A, n = !1;
    for (let s = 0; s < e.length; s++) {
      let r = e[s];
      if (this.eq(r))
        return e;
      if (this.type.excludes(r.type))
        A || (A = e.slice(0, s));
      else {
        if (r.type.excludes(this.type))
          return e;
        !n && r.type.rank > this.type.rank && (A || (A = e.slice(0, s)), A.push(this), n = !0), A && A.push(r);
      }
    }
    return A || (A = e.slice()), n || A.push(this), A;
  }
  /**
  Remove this mark from the given set, returning a new set. If this
  mark is not in the set, the set itself is returned.
  */
  removeFromSet(e) {
    for (let A = 0; A < e.length; A++)
      if (this.eq(e[A]))
        return e.slice(0, A).concat(e.slice(A + 1));
    return e;
  }
  /**
  Test whether this mark is in the given set of marks.
  */
  isInSet(e) {
    for (let A = 0; A < e.length; A++)
      if (this.eq(e[A]))
        return !0;
    return !1;
  }
  /**
  Test whether this mark has the same type and attributes as
  another mark.
  */
  eq(e) {
    return this == e || this.type == e.type && Uu(this.attrs, e.attrs);
  }
  /**
  Convert this mark to a JSON-serializeable representation.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let A in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return e;
  }
  /**
  Deserialize a mark from JSON.
  */
  static fromJSON(e, A) {
    if (!A)
      throw new RangeError("Invalid input for Mark.fromJSON");
    let n = e.marks[A.type];
    if (!n)
      throw new RangeError(`There is no mark type ${A.type} in this schema`);
    let s = n.create(A.attrs);
    return n.checkAttrs(s.attrs), s;
  }
  /**
  Test whether two sets of marks are identical.
  */
  static sameSet(e, A) {
    if (e == A)
      return !0;
    if (e.length != A.length)
      return !1;
    for (let n = 0; n < e.length; n++)
      if (!e[n].eq(A[n]))
        return !1;
    return !0;
  }
  /**
  Create a properly sorted mark set from null, a single mark, or an
  unsorted array of marks.
  */
  static setFrom(e) {
    if (!e || Array.isArray(e) && e.length == 0)
      return YC.none;
    if (e instanceof YC)
      return [e];
    let A = e.slice();
    return A.sort((n, s) => n.type.rank - s.type.rank), A;
  }
};
Lt.none = [];
class bu extends Error {
}
class Ee {
  /**
  Create a slice. When specifying a non-zero open depth, you must
  make sure that there are nodes of at least that depth at the
  appropriate side of the fragment—i.e. if the fragment is an
  empty paragraph node, `openStart` and `openEnd` can't be greater
  than 1.
  
  It is not necessary for the content of open nodes to conform to
  the schema's content constraints, though it should be a valid
  start/end/middle for such a node, depending on which sides are
  open.
  */
  constructor(e, A, n) {
    this.content = e, this.openStart = A, this.openEnd = n;
  }
  /**
  The size this slice would add when inserted into a document.
  */
  get size() {
    return this.content.size - this.openStart - this.openEnd;
  }
  /**
  @internal
  */
  insertAt(e, A) {
    let n = jx(this.content, e + this.openStart, A);
    return n && new Ee(n, this.openStart, this.openEnd);
  }
  /**
  @internal
  */
  removeBetween(e, A) {
    return new Ee(vx(this.content, e + this.openStart, A + this.openStart), this.openStart, this.openEnd);
  }
  /**
  Tests whether this slice is equal to another slice.
  */
  eq(e) {
    return this.content.eq(e.content) && this.openStart == e.openStart && this.openEnd == e.openEnd;
  }
  /**
  @internal
  */
  toString() {
    return this.content + "(" + this.openStart + "," + this.openEnd + ")";
  }
  /**
  Convert a slice to a JSON-serializable representation.
  */
  toJSON() {
    if (!this.content.size)
      return null;
    let e = { content: this.content.toJSON() };
    return this.openStart > 0 && (e.openStart = this.openStart), this.openEnd > 0 && (e.openEnd = this.openEnd), e;
  }
  /**
  Deserialize a slice from its JSON representation.
  */
  static fromJSON(e, A) {
    if (!A)
      return Ee.empty;
    let n = A.openStart || 0, s = A.openEnd || 0;
    if (typeof n != "number" || typeof s != "number")
      throw new RangeError("Invalid input for Slice.fromJSON");
    return new Ee(re.fromJSON(e, A.content), n, s);
  }
  /**
  Create a slice from a fragment by taking the maximum possible
  open value on both side of the fragment.
  */
  static maxOpen(e, A = !0) {
    let n = 0, s = 0;
    for (let r = e.firstChild; r && !r.isLeaf && (A || !r.type.spec.isolating); r = r.firstChild)
      n++;
    for (let r = e.lastChild; r && !r.isLeaf && (A || !r.type.spec.isolating); r = r.lastChild)
      s++;
    return new Ee(e, n, s);
  }
}
Ee.empty = new Ee(re.empty, 0, 0);
function vx(t, e, A) {
  let { index: n, offset: s } = t.findIndex(e), r = t.maybeChild(n), { index: i, offset: o } = t.findIndex(A);
  if (s == e || r.isText) {
    if (o != A && !t.child(i).isText)
      throw new RangeError("Removing non-flat range");
    return t.cut(0, e).append(t.cut(A));
  }
  if (n != i)
    throw new RangeError("Removing non-flat range");
  return t.replaceChild(n, r.copy(vx(r.content, e - s - 1, A - s - 1)));
}
function jx(t, e, A, n) {
  let { index: s, offset: r } = t.findIndex(e), i = t.maybeChild(s);
  if (r == e || i.isText)
    return n && !n.canReplace(s, s, A) ? null : t.cut(0, e).append(A).append(t.cut(e));
  let o = jx(i.content, e - r - 1, A, i);
  return o && t.replaceChild(s, i.copy(o));
}
function KL(t, e, A) {
  if (A.openStart > t.depth)
    throw new bu("Inserted content deeper than insertion position");
  if (t.depth - A.openStart != e.depth - A.openEnd)
    throw new bu("Inconsistent open depths");
  return Hx(t, e, A, 0);
}
function Hx(t, e, A, n) {
  let s = t.index(n), r = t.node(n);
  if (s == e.index(n) && n < t.depth - A.openStart) {
    let i = Hx(t, e, A, n + 1);
    return r.copy(r.content.replaceChild(s, i));
  } else if (A.content.size)
    if (!A.openStart && !A.openEnd && t.depth == n && e.depth == n) {
      let i = t.parent, o = i.content;
      return La(i, o.cut(0, t.parentOffset).append(A.content).append(o.cut(e.parentOffset)));
    } else {
      let { start: i, end: o } = VL(A, t);
      return La(r, Rx(t, i, o, e, n));
    }
  else return La(r, vu(t, e, n));
}
function kx(t, e) {
  if (!e.type.compatibleContent(t.type))
    throw new bu("Cannot join " + e.type.name + " onto " + t.type.name);
}
function yC(t, e, A) {
  let n = t.node(A);
  return kx(n, e.node(A)), n;
}
function Ra(t, e) {
  let A = e.length - 1;
  A >= 0 && t.isText && t.sameMarkup(e[A]) ? e[A] = t.withText(e[A].text + t.text) : e.push(t);
}
function LB(t, e, A, n) {
  let s = (e || t).node(A), r = 0, i = e ? e.index(A) : s.childCount;
  t && (r = t.index(A), t.depth > A ? r++ : t.textOffset && (Ra(t.nodeAfter, n), r++));
  for (let o = r; o < i; o++)
    Ra(s.child(o), n);
  e && e.depth == A && e.textOffset && Ra(e.nodeBefore, n);
}
function La(t, e) {
  return t.type.checkContent(e), t.copy(e);
}
function Rx(t, e, A, n, s) {
  let r = t.depth > s && yC(t, e, s + 1), i = n.depth > s && yC(A, n, s + 1), o = [];
  return LB(null, t, s, o), r && i && e.index(s) == A.index(s) ? (kx(r, i), Ra(La(r, Rx(t, e, A, n, s + 1)), o)) : (r && Ra(La(r, vu(t, e, s + 1)), o), LB(e, A, s, o), i && Ra(La(i, vu(A, n, s + 1)), o)), LB(n, null, s, o), new re(o);
}
function vu(t, e, A) {
  let n = [];
  if (LB(null, t, A, n), t.depth > A) {
    let s = yC(t, e, A + 1);
    Ra(La(s, vu(t, e, A + 1)), n);
  }
  return LB(e, null, A, n), new re(n);
}
function VL(t, e) {
  let A = e.depth - t.openStart, s = e.node(A).copy(t.content);
  for (let r = A - 1; r >= 0; r--)
    s = e.node(r).copy(re.from(s));
  return {
    start: s.resolveNoCache(t.openStart + A),
    end: s.resolveNoCache(s.content.size - t.openEnd - A)
  };
}
class Eg {
  /**
  @internal
  */
  constructor(e, A, n) {
    this.pos = e, this.path = A, this.parentOffset = n, this.depth = A.length / 3 - 1;
  }
  /**
  @internal
  */
  resolveDepth(e) {
    return e == null ? this.depth : e < 0 ? this.depth + e : e;
  }
  /**
  The parent node that the position points into. Note that even if
  a position points into a text node, that node is not considered
  the parent—text nodes are ‘flat’ in this model, and have no content.
  */
  get parent() {
    return this.node(this.depth);
  }
  /**
  The root node in which the position was resolved.
  */
  get doc() {
    return this.node(0);
  }
  /**
  The ancestor node at the given level. `p.node(p.depth)` is the
  same as `p.parent`.
  */
  node(e) {
    return this.path[this.resolveDepth(e) * 3];
  }
  /**
  The index into the ancestor at the given level. If this points
  at the 3rd node in the 2nd paragraph on the top level, for
  example, `p.index(0)` is 1 and `p.index(1)` is 2.
  */
  index(e) {
    return this.path[this.resolveDepth(e) * 3 + 1];
  }
  /**
  The index pointing after this position into the ancestor at the
  given level.
  */
  indexAfter(e) {
    return e = this.resolveDepth(e), this.index(e) + (e == this.depth && !this.textOffset ? 0 : 1);
  }
  /**
  The (absolute) position at the start of the node at the given
  level.
  */
  start(e) {
    return e = this.resolveDepth(e), e == 0 ? 0 : this.path[e * 3 - 1] + 1;
  }
  /**
  The (absolute) position at the end of the node at the given
  level.
  */
  end(e) {
    return e = this.resolveDepth(e), this.start(e) + this.node(e).content.size;
  }
  /**
  The (absolute) position directly before the wrapping node at the
  given level, or, when `depth` is `this.depth + 1`, the original
  position.
  */
  before(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position before the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1];
  }
  /**
  The (absolute) position directly after the wrapping node at the
  given level, or the original position when `depth` is `this.depth + 1`.
  */
  after(e) {
    if (e = this.resolveDepth(e), !e)
      throw new RangeError("There is no position after the top-level node");
    return e == this.depth + 1 ? this.pos : this.path[e * 3 - 1] + this.path[e * 3].nodeSize;
  }
  /**
  When this position points into a text node, this returns the
  distance between the position and the start of the text node.
  Will be zero for positions that point between nodes.
  */
  get textOffset() {
    return this.pos - this.path[this.path.length - 1];
  }
  /**
  Get the node directly after the position, if any. If the position
  points into a text node, only the part of that node after the
  position is returned.
  */
  get nodeAfter() {
    let e = this.parent, A = this.index(this.depth);
    if (A == e.childCount)
      return null;
    let n = this.pos - this.path[this.path.length - 1], s = e.child(A);
    return n ? e.child(A).cut(n) : s;
  }
  /**
  Get the node directly before the position, if any. If the
  position points into a text node, only the part of that node
  before the position is returned.
  */
  get nodeBefore() {
    let e = this.index(this.depth), A = this.pos - this.path[this.path.length - 1];
    return A ? this.parent.child(e).cut(0, A) : e == 0 ? null : this.parent.child(e - 1);
  }
  /**
  Get the position at the given index in the parent node at the
  given depth (which defaults to `this.depth`).
  */
  posAtIndex(e, A) {
    A = this.resolveDepth(A);
    let n = this.path[A * 3], s = A == 0 ? 0 : this.path[A * 3 - 1] + 1;
    for (let r = 0; r < e; r++)
      s += n.child(r).nodeSize;
    return s;
  }
  /**
  Get the marks at this position, factoring in the surrounding
  marks' [`inclusive`](https://prosemirror.net/docs/ref/#model.MarkSpec.inclusive) property. If the
  position is at the start of a non-empty node, the marks of the
  node after it (if any) are returned.
  */
  marks() {
    let e = this.parent, A = this.index();
    if (e.content.size == 0)
      return Lt.none;
    if (this.textOffset)
      return e.child(A).marks;
    let n = e.maybeChild(A - 1), s = e.maybeChild(A);
    if (!n) {
      let o = n;
      n = s, s = o;
    }
    let r = n.marks;
    for (var i = 0; i < r.length; i++)
      r[i].type.spec.inclusive === !1 && (!s || !r[i].isInSet(s.marks)) && (r = r[i--].removeFromSet(r));
    return r;
  }
  /**
  Get the marks after the current position, if any, except those
  that are non-inclusive and not present at position `$end`. This
  is mostly useful for getting the set of marks to preserve after a
  deletion. Will return `null` if this position is at the end of
  its parent node or its parent node isn't a textblock (in which
  case no marks should be preserved).
  */
  marksAcross(e) {
    let A = this.parent.maybeChild(this.index());
    if (!A || !A.isInline)
      return null;
    let n = A.marks, s = e.parent.maybeChild(e.index());
    for (var r = 0; r < n.length; r++)
      n[r].type.spec.inclusive === !1 && (!s || !n[r].isInSet(s.marks)) && (n = n[r--].removeFromSet(n));
    return n;
  }
  /**
  The depth up to which this position and the given (non-resolved)
  position share the same parent nodes.
  */
  sharedDepth(e) {
    for (let A = this.depth; A > 0; A--)
      if (this.start(A) <= e && this.end(A) >= e)
        return A;
    return 0;
  }
  /**
  Returns a range based on the place where this position and the
  given position diverge around block content. If both point into
  the same textblock, for example, a range around that textblock
  will be returned. If they point into different blocks, the range
  around those blocks in their shared ancestor is returned. You can
  pass in an optional predicate that will be called with a parent
  node to see if a range into that parent is acceptable.
  */
  blockRange(e = this, A) {
    if (e.pos < this.pos)
      return e.blockRange(this);
    for (let n = this.depth - (this.parent.inlineContent || this.pos == e.pos ? 1 : 0); n >= 0; n--)
      if (e.pos <= this.end(n) && (!A || A(this.node(n))))
        return new Ql(this, e, n);
    return null;
  }
  /**
  Query whether the given position shares the same parent node.
  */
  sameParent(e) {
    return this.pos - this.parentOffset == e.pos - e.parentOffset;
  }
  /**
  Return the greater of this and the given position.
  */
  max(e) {
    return e.pos > this.pos ? e : this;
  }
  /**
  Return the smaller of this and the given position.
  */
  min(e) {
    return e.pos < this.pos ? e : this;
  }
  /**
  @internal
  */
  toString() {
    let e = "";
    for (let A = 1; A <= this.depth; A++)
      e += (e ? "/" : "") + this.node(A).type.name + "_" + this.index(A - 1);
    return e + ":" + this.parentOffset;
  }
  /**
  @internal
  */
  static resolve(e, A) {
    if (!(A >= 0 && A <= e.content.size))
      throw new RangeError("Position " + A + " out of range");
    let n = [], s = 0, r = A;
    for (let i = e; ; ) {
      let { index: o, offset: a } = i.content.findIndex(r), c = r - a;
      if (n.push(i, o, s + a), !c || (i = i.child(o), i.isText))
        break;
      r = c - 1, s += a + 1;
    }
    return new Eg(A, n, r);
  }
  /**
  @internal
  */
  static resolveCached(e, A) {
    let n = J2.get(e);
    if (n)
      for (let r = 0; r < n.elts.length; r++) {
        let i = n.elts[r];
        if (i.pos == A)
          return i;
      }
    else
      J2.set(e, n = new XL());
    let s = n.elts[n.i] = Eg.resolve(e, A);
    return n.i = (n.i + 1) % ZL, s;
  }
}
class XL {
  constructor() {
    this.elts = [], this.i = 0;
  }
}
const ZL = 12, J2 = /* @__PURE__ */ new WeakMap();
class Ql {
  /**
  Construct a node range. `$from` and `$to` should point into the
  same node until at least the given `depth`, since a node range
  denotes an adjacent set of nodes in a single parent node.
  */
  constructor(e, A, n) {
    this.$from = e, this.$to = A, this.depth = n;
  }
  /**
  The position at the start of the range.
  */
  get start() {
    return this.$from.before(this.depth + 1);
  }
  /**
  The position at the end of the range.
  */
  get end() {
    return this.$to.after(this.depth + 1);
  }
  /**
  The parent node that the range points into.
  */
  get parent() {
    return this.$from.node(this.depth);
  }
  /**
  The start index of the range in the parent node.
  */
  get startIndex() {
    return this.$from.index(this.depth);
  }
  /**
  The end index of the range in the parent node.
  */
  get endIndex() {
    return this.$to.indexAfter(this.depth);
  }
}
const qL = /* @__PURE__ */ Object.create(null);
let xi = class FC {
  /**
  @internal
  */
  constructor(e, A, n, s = Lt.none) {
    this.type = e, this.attrs = A, this.marks = s, this.content = n || re.empty;
  }
  /**
  The array of this node's child nodes.
  */
  get children() {
    return this.content.content;
  }
  /**
  The size of this node, as defined by the integer-based [indexing
  scheme](https://prosemirror.net/docs/guide/#doc.indexing). For text nodes, this is the
  amount of characters. For other leaf nodes, it is one. For
  non-leaf nodes, it is the size of the content plus two (the
  start and end token).
  */
  get nodeSize() {
    return this.isLeaf ? 1 : 2 + this.content.size;
  }
  /**
  The number of children that the node has.
  */
  get childCount() {
    return this.content.childCount;
  }
  /**
  Get the child node at the given index. Raises an error when the
  index is out of range.
  */
  child(e) {
    return this.content.child(e);
  }
  /**
  Get the child node at the given index, if it exists.
  */
  maybeChild(e) {
    return this.content.maybeChild(e);
  }
  /**
  Call `f` for every child node, passing the node, its offset
  into this parent node, and its index.
  */
  forEach(e) {
    this.content.forEach(e);
  }
  /**
  Invoke a callback for all descendant nodes recursively between
  the given two positions that are relative to start of this
  node's content. The callback is invoked with the node, its
  position relative to the original node (method receiver),
  its parent node, and its child index. When the callback returns
  false for a given node, that node's children will not be
  recursed over. The last parameter can be used to specify a
  starting position to count from.
  */
  nodesBetween(e, A, n, s = 0) {
    this.content.nodesBetween(e, A, n, s, this);
  }
  /**
  Call the given callback for every descendant node. Doesn't
  descend into a node when the callback returns `false`.
  */
  descendants(e) {
    this.nodesBetween(0, this.content.size, e);
  }
  /**
  Concatenates all the text nodes found in this fragment and its
  children.
  */
  get textContent() {
    return this.isLeaf && this.type.spec.leafText ? this.type.spec.leafText(this) : this.textBetween(0, this.content.size, "");
  }
  /**
  Get all text between positions `from` and `to`. When
  `blockSeparator` is given, it will be inserted to separate text
  from different block nodes. If `leafText` is given, it'll be
  inserted for every non-text leaf node encountered, otherwise
  [`leafText`](https://prosemirror.net/docs/ref/#model.NodeSpec.leafText) will be used.
  */
  textBetween(e, A, n, s) {
    return this.content.textBetween(e, A, n, s);
  }
  /**
  Returns this node's first child, or `null` if there are no
  children.
  */
  get firstChild() {
    return this.content.firstChild;
  }
  /**
  Returns this node's last child, or `null` if there are no
  children.
  */
  get lastChild() {
    return this.content.lastChild;
  }
  /**
  Test whether two nodes represent the same piece of document.
  */
  eq(e) {
    return this == e || this.sameMarkup(e) && this.content.eq(e.content);
  }
  /**
  Compare the markup (type, attributes, and marks) of this node to
  those of another. Returns `true` if both have the same markup.
  */
  sameMarkup(e) {
    return this.hasMarkup(e.type, e.attrs, e.marks);
  }
  /**
  Check whether this node's markup correspond to the given type,
  attributes, and marks.
  */
  hasMarkup(e, A, n) {
    return this.type == e && Uu(this.attrs, A || e.defaultAttrs || qL) && Lt.sameSet(this.marks, n || Lt.none);
  }
  /**
  Create a new node with the same markup as this node, containing
  the given content (or empty, if no content is given).
  */
  copy(e = null) {
    return e == this.content ? this : new FC(this.type, this.attrs, e, this.marks);
  }
  /**
  Create a copy of this node, with the given set of marks instead
  of the node's own marks.
  */
  mark(e) {
    return e == this.marks ? this : new FC(this.type, this.attrs, this.content, e);
  }
  /**
  Create a copy of this node with only the content between the
  given positions. If `to` is not given, it defaults to the end of
  the node.
  */
  cut(e, A = this.content.size) {
    return e == 0 && A == this.content.size ? this : this.copy(this.content.cut(e, A));
  }
  /**
  Cut out the part of the document between the given positions, and
  return it as a `Slice` object.
  */
  slice(e, A = this.content.size, n = !1) {
    if (e == A)
      return Ee.empty;
    let s = this.resolve(e), r = this.resolve(A), i = n ? 0 : s.sharedDepth(A), o = s.start(i), c = s.node(i).content.cut(s.pos - o, r.pos - o);
    return new Ee(c, s.depth - i, r.depth - i);
  }
  /**
  Replace the part of the document between the given positions with
  the given slice. The slice must 'fit', meaning its open sides
  must be able to connect to the surrounding content, and its
  content nodes must be valid children for the node they are placed
  into. If any of this is violated, an error of type
  [`ReplaceError`](https://prosemirror.net/docs/ref/#model.ReplaceError) is thrown.
  */
  replace(e, A, n) {
    return KL(this.resolve(e), this.resolve(A), n);
  }
  /**
  Find the node directly after the given position.
  */
  nodeAt(e) {
    for (let A = this; ; ) {
      let { index: n, offset: s } = A.content.findIndex(e);
      if (A = A.maybeChild(n), !A)
        return null;
      if (s == e || A.isText)
        return A;
      e -= s + 1;
    }
  }
  /**
  Find the (direct) child node after the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childAfter(e) {
    let { index: A, offset: n } = this.content.findIndex(e);
    return { node: this.content.maybeChild(A), index: A, offset: n };
  }
  /**
  Find the (direct) child node before the given offset, if any,
  and return it along with its index and offset relative to this
  node.
  */
  childBefore(e) {
    if (e == 0)
      return { node: null, index: 0, offset: 0 };
    let { index: A, offset: n } = this.content.findIndex(e);
    if (n < e)
      return { node: this.content.child(A), index: A, offset: n };
    let s = this.content.child(A - 1);
    return { node: s, index: A - 1, offset: n - s.nodeSize };
  }
  /**
  Resolve the given position in the document, returning an
  [object](https://prosemirror.net/docs/ref/#model.ResolvedPos) with information about its context.
  */
  resolve(e) {
    return Eg.resolveCached(this, e);
  }
  /**
  @internal
  */
  resolveNoCache(e) {
    return Eg.resolve(this, e);
  }
  /**
  Test whether a given mark or mark type occurs in this document
  between the two given positions.
  */
  rangeHasMark(e, A, n) {
    let s = !1;
    return A > e && this.nodesBetween(e, A, (r) => (n.isInSet(r.marks) && (s = !0), !s)), s;
  }
  /**
  True when this is a block (non-inline node)
  */
  get isBlock() {
    return this.type.isBlock;
  }
  /**
  True when this is a textblock node, a block node with inline
  content.
  */
  get isTextblock() {
    return this.type.isTextblock;
  }
  /**
  True when this node allows inline content.
  */
  get inlineContent() {
    return this.type.inlineContent;
  }
  /**
  True when this is an inline node (a text node or a node that can
  appear among text).
  */
  get isInline() {
    return this.type.isInline;
  }
  /**
  True when this is a text node.
  */
  get isText() {
    return this.type.isText;
  }
  /**
  True when this is a leaf node.
  */
  get isLeaf() {
    return this.type.isLeaf;
  }
  /**
  True when this is an atom, i.e. when it does not have directly
  editable content. This is usually the same as `isLeaf`, but can
  be configured with the [`atom` property](https://prosemirror.net/docs/ref/#model.NodeSpec.atom)
  on a node's spec (typically used when the node is displayed as
  an uneditable [node view](https://prosemirror.net/docs/ref/#view.NodeView)).
  */
  get isAtom() {
    return this.type.isAtom;
  }
  /**
  Return a string representation of this node for debugging
  purposes.
  */
  toString() {
    if (this.type.spec.toDebugString)
      return this.type.spec.toDebugString(this);
    let e = this.type.name;
    return this.content.size && (e += "(" + this.content.toStringInner() + ")"), Lx(this.marks, e);
  }
  /**
  Get the content match in this node at the given index.
  */
  contentMatchAt(e) {
    let A = this.type.contentMatch.matchFragment(this.content, 0, e);
    if (!A)
      throw new Error("Called contentMatchAt on a node with invalid content");
    return A;
  }
  /**
  Test whether replacing the range between `from` and `to` (by
  child index) with the given replacement fragment (which defaults
  to the empty fragment) would leave the node's content valid. You
  can optionally pass `start` and `end` indices into the
  replacement fragment.
  */
  canReplace(e, A, n = re.empty, s = 0, r = n.childCount) {
    let i = this.contentMatchAt(e).matchFragment(n, s, r), o = i && i.matchFragment(this.content, A);
    if (!o || !o.validEnd)
      return !1;
    for (let a = s; a < r; a++)
      if (!this.type.allowsMarks(n.child(a).marks))
        return !1;
    return !0;
  }
  /**
  Test whether replacing the range `from` to `to` (by index) with
  a node of the given type would leave the node's content valid.
  */
  canReplaceWith(e, A, n, s) {
    if (s && !this.type.allowsMarks(s))
      return !1;
    let r = this.contentMatchAt(e).matchType(n), i = r && r.matchFragment(this.content, A);
    return i ? i.validEnd : !1;
  }
  /**
  Test whether the given node's content could be appended to this
  node. If that node is empty, this will only return true if there
  is at least one node type that can appear in both nodes (to avoid
  merging completely incompatible nodes).
  */
  canAppend(e) {
    return e.content.size ? this.canReplace(this.childCount, this.childCount, e.content) : this.type.compatibleContent(e.type);
  }
  /**
  Check whether this node and its descendants conform to the
  schema, and raise an exception when they do not.
  */
  check() {
    this.type.checkContent(this.content), this.type.checkAttrs(this.attrs);
    let e = Lt.none;
    for (let A = 0; A < this.marks.length; A++) {
      let n = this.marks[A];
      n.type.checkAttrs(n.attrs), e = n.addToSet(e);
    }
    if (!Lt.sameSet(e, this.marks))
      throw new RangeError(`Invalid collection of marks for node ${this.type.name}: ${this.marks.map((A) => A.type.name)}`);
    this.content.forEach((A) => A.check());
  }
  /**
  Return a JSON-serializeable representation of this node.
  */
  toJSON() {
    let e = { type: this.type.name };
    for (let A in this.attrs) {
      e.attrs = this.attrs;
      break;
    }
    return this.content.size && (e.content = this.content.toJSON()), this.marks.length && (e.marks = this.marks.map((A) => A.toJSON())), e;
  }
  /**
  Deserialize a node from its JSON representation.
  */
  static fromJSON(e, A) {
    if (!A)
      throw new RangeError("Invalid input for Node.fromJSON");
    let n;
    if (A.marks) {
      if (!Array.isArray(A.marks))
        throw new RangeError("Invalid mark data for Node.fromJSON");
      n = A.marks.map(e.markFromJSON);
    }
    if (A.type == "text") {
      if (typeof A.text != "string")
        throw new RangeError("Invalid text node in JSON");
      return e.text(A.text, n);
    }
    let s = re.fromJSON(e, A.content), r = e.nodeType(A.type).create(A.attrs, s, n);
    return r.type.checkAttrs(r.attrs), r;
  }
};
xi.prototype.text = void 0;
let _L = class NC extends xi {
  /**
  @internal
  */
  constructor(e, A, n, s) {
    if (super(e, A, null, s), !n)
      throw new RangeError("Empty text nodes are not allowed");
    this.text = n;
  }
  toString() {
    return this.type.spec.toDebugString ? this.type.spec.toDebugString(this) : Lx(this.marks, JSON.stringify(this.text));
  }
  get textContent() {
    return this.text;
  }
  textBetween(e, A) {
    return this.text.slice(e, A);
  }
  get nodeSize() {
    return this.text.length;
  }
  mark(e) {
    return e == this.marks ? this : new NC(this.type, this.attrs, this.text, e);
  }
  withText(e) {
    return e == this.text ? this : new NC(this.type, this.attrs, e, this.marks);
  }
  cut(e = 0, A = this.text.length) {
    return e == 0 && A == this.text.length ? this : this.withText(this.text.slice(e, A));
  }
  eq(e) {
    return this.sameMarkup(e) && this.text == e.text;
  }
  toJSON() {
    let e = super.toJSON();
    return e.text = this.text, e;
  }
};
function Lx(t, e) {
  for (let A = t.length - 1; A >= 0; A--)
    e = t[A].type.name + "(" + e + ")";
  return e;
}
class Va {
  /**
  @internal
  */
  constructor(e) {
    this.validEnd = e, this.next = [], this.wrapCache = [];
  }
  /**
  @internal
  */
  static parse(e, A) {
    let n = new $L(e, A);
    if (n.next == null)
      return Va.empty;
    let s = Sx(n);
    n.next && n.err("Unexpected trailing text");
    let r = iS(rS(s));
    return oS(r, n), r;
  }
  /**
  Match a node type, returning a match after that node if
  successful.
  */
  matchType(e) {
    for (let A = 0; A < this.next.length; A++)
      if (this.next[A].type == e)
        return this.next[A].next;
    return null;
  }
  /**
  Try to match a fragment. Returns the resulting match when
  successful.
  */
  matchFragment(e, A = 0, n = e.childCount) {
    let s = this;
    for (let r = A; s && r < n; r++)
      s = s.matchType(e.child(r).type);
    return s;
  }
  /**
  @internal
  */
  get inlineContent() {
    return this.next.length != 0 && this.next[0].type.isInline;
  }
  /**
  Get the first matching node type at this match position that can
  be generated.
  */
  get defaultType() {
    for (let e = 0; e < this.next.length; e++) {
      let { type: A } = this.next[e];
      if (!(A.isText || A.hasRequiredAttrs()))
        return A;
    }
    return null;
  }
  /**
  @internal
  */
  compatible(e) {
    for (let A = 0; A < this.next.length; A++)
      for (let n = 0; n < e.next.length; n++)
        if (this.next[A].type == e.next[n].type)
          return !0;
    return !1;
  }
  /**
  Try to match the given fragment, and if that fails, see if it can
  be made to match by inserting nodes in front of it. When
  successful, return a fragment of inserted nodes (which may be
  empty if nothing had to be inserted). When `toEnd` is true, only
  return a fragment if the resulting match goes to the end of the
  content expression.
  */
  fillBefore(e, A = !1, n = 0) {
    let s = [this];
    function r(i, o) {
      let a = i.matchFragment(e, n);
      if (a && (!A || a.validEnd))
        return re.from(o.map((c) => c.createAndFill()));
      for (let c = 0; c < i.next.length; c++) {
        let { type: l, next: B } = i.next[c];
        if (!(l.isText || l.hasRequiredAttrs()) && s.indexOf(B) == -1) {
          s.push(B);
          let g = r(B, o.concat(l));
          if (g)
            return g;
        }
      }
      return null;
    }
    return r(this, []);
  }
  /**
  Find a set of wrapping node types that would allow a node of the
  given type to appear at this position. The result may be empty
  (when it fits directly) and will be null when no such wrapping
  exists.
  */
  findWrapping(e) {
    for (let n = 0; n < this.wrapCache.length; n += 2)
      if (this.wrapCache[n] == e)
        return this.wrapCache[n + 1];
    let A = this.computeWrapping(e);
    return this.wrapCache.push(e, A), A;
  }
  /**
  @internal
  */
  computeWrapping(e) {
    let A = /* @__PURE__ */ Object.create(null), n = [{ match: this, type: null, via: null }];
    for (; n.length; ) {
      let s = n.shift(), r = s.match;
      if (r.matchType(e)) {
        let i = [];
        for (let o = s; o.type; o = o.via)
          i.push(o.type);
        return i.reverse();
      }
      for (let i = 0; i < r.next.length; i++) {
        let { type: o, next: a } = r.next[i];
        !o.isLeaf && !o.hasRequiredAttrs() && !(o.name in A) && (!s.type || a.validEnd) && (n.push({ match: o.contentMatch, type: o, via: s }), A[o.name] = !0);
      }
    }
    return null;
  }
  /**
  The number of outgoing edges this node has in the finite
  automaton that describes the content expression.
  */
  get edgeCount() {
    return this.next.length;
  }
  /**
  Get the _n_​th outgoing edge from this node in the finite
  automaton that describes the content expression.
  */
  edge(e) {
    if (e >= this.next.length)
      throw new RangeError(`There's no ${e}th edge in this content match`);
    return this.next[e];
  }
  /**
  @internal
  */
  toString() {
    let e = [];
    function A(n) {
      e.push(n);
      for (let s = 0; s < n.next.length; s++)
        e.indexOf(n.next[s].next) == -1 && A(n.next[s].next);
    }
    return A(this), e.map((n, s) => {
      let r = s + (n.validEnd ? "*" : " ") + " ";
      for (let i = 0; i < n.next.length; i++)
        r += (i ? ", " : "") + n.next[i].type.name + "->" + e.indexOf(n.next[i].next);
      return r;
    }).join(`
`);
  }
}
Va.empty = new Va(!0);
class $L {
  constructor(e, A) {
    this.string = e, this.nodeTypes = A, this.inline = null, this.pos = 0, this.tokens = e.split(/\s*(?=\b|\W|$)/), this.tokens[this.tokens.length - 1] == "" && this.tokens.pop(), this.tokens[0] == "" && this.tokens.shift();
  }
  get next() {
    return this.tokens[this.pos];
  }
  eat(e) {
    return this.next == e && (this.pos++ || !0);
  }
  err(e) {
    throw new SyntaxError(e + " (in content expression '" + this.string + "')");
  }
}
function Sx(t) {
  let e = [];
  do
    e.push(eS(t));
  while (t.eat("|"));
  return e.length == 1 ? e[0] : { type: "choice", exprs: e };
}
function eS(t) {
  let e = [];
  do
    e.push(tS(t));
  while (t.next && t.next != ")" && t.next != "|");
  return e.length == 1 ? e[0] : { type: "seq", exprs: e };
}
function tS(t) {
  let e = sS(t);
  for (; ; )
    if (t.eat("+"))
      e = { type: "plus", expr: e };
    else if (t.eat("*"))
      e = { type: "star", expr: e };
    else if (t.eat("?"))
      e = { type: "opt", expr: e };
    else if (t.eat("{"))
      e = AS(t, e);
    else
      break;
  return e;
}
function W2(t) {
  /\D/.test(t.next) && t.err("Expected number, got '" + t.next + "'");
  let e = Number(t.next);
  return t.pos++, e;
}
function AS(t, e) {
  let A = W2(t), n = A;
  return t.eat(",") && (t.next != "}" ? n = W2(t) : n = -1), t.eat("}") || t.err("Unclosed braced range"), { type: "range", min: A, max: n, expr: e };
}
function nS(t, e) {
  let A = t.nodeTypes, n = A[e];
  if (n)
    return [n];
  let s = [];
  for (let r in A) {
    let i = A[r];
    i.isInGroup(e) && s.push(i);
  }
  return s.length == 0 && t.err("No node type or group '" + e + "' found"), s;
}
function sS(t) {
  if (t.eat("(")) {
    let e = Sx(t);
    return t.eat(")") || t.err("Missing closing paren"), e;
  } else if (/\W/.test(t.next))
    t.err("Unexpected token '" + t.next + "'");
  else {
    let e = nS(t, t.next).map((A) => (t.inline == null ? t.inline = A.isInline : t.inline != A.isInline && t.err("Mixing inline and block content"), { type: "name", value: A }));
    return t.pos++, e.length == 1 ? e[0] : { type: "choice", exprs: e };
  }
}
function rS(t) {
  let e = [[]];
  return s(r(t, 0), A()), e;
  function A() {
    return e.push([]) - 1;
  }
  function n(i, o, a) {
    let c = { term: a, to: o };
    return e[i].push(c), c;
  }
  function s(i, o) {
    i.forEach((a) => a.to = o);
  }
  function r(i, o) {
    if (i.type == "choice")
      return i.exprs.reduce((a, c) => a.concat(r(c, o)), []);
    if (i.type == "seq")
      for (let a = 0; ; a++) {
        let c = r(i.exprs[a], o);
        if (a == i.exprs.length - 1)
          return c;
        s(c, o = A());
      }
    else if (i.type == "star") {
      let a = A();
      return n(o, a), s(r(i.expr, a), a), [n(a)];
    } else if (i.type == "plus") {
      let a = A();
      return s(r(i.expr, o), a), s(r(i.expr, a), a), [n(a)];
    } else {
      if (i.type == "opt")
        return [n(o)].concat(r(i.expr, o));
      if (i.type == "range") {
        let a = o;
        for (let c = 0; c < i.min; c++) {
          let l = A();
          s(r(i.expr, a), l), a = l;
        }
        if (i.max == -1)
          s(r(i.expr, a), a);
        else
          for (let c = i.min; c < i.max; c++) {
            let l = A();
            n(a, l), s(r(i.expr, a), l), a = l;
          }
        return [n(a)];
      } else {
        if (i.type == "name")
          return [n(o, void 0, i.value)];
        throw new Error("Unknown expr type");
      }
    }
  }
}
function Tx(t, e) {
  return e - t;
}
function O2(t, e) {
  let A = [];
  return n(e), A.sort(Tx);
  function n(s) {
    let r = t[s];
    if (r.length == 1 && !r[0].term)
      return n(r[0].to);
    A.push(s);
    for (let i = 0; i < r.length; i++) {
      let { term: o, to: a } = r[i];
      !o && A.indexOf(a) == -1 && n(a);
    }
  }
}
function iS(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return A(O2(t, 0));
  function A(n) {
    let s = [];
    n.forEach((i) => {
      t[i].forEach(({ term: o, to: a }) => {
        if (!o)
          return;
        let c;
        for (let l = 0; l < s.length; l++)
          s[l][0] == o && (c = s[l][1]);
        O2(t, a).forEach((l) => {
          c || s.push([o, c = []]), c.indexOf(l) == -1 && c.push(l);
        });
      });
    });
    let r = e[n.join(",")] = new Va(n.indexOf(t.length - 1) > -1);
    for (let i = 0; i < s.length; i++) {
      let o = s[i][1].sort(Tx);
      r.next.push({ type: s[i][0], next: e[o.join(",")] || A(o) });
    }
    return r;
  }
}
function oS(t, e) {
  for (let A = 0, n = [t]; A < n.length; A++) {
    let s = n[A], r = !s.validEnd, i = [];
    for (let o = 0; o < s.next.length; o++) {
      let { type: a, next: c } = s.next[o];
      i.push(a.name), r && !(a.isText || a.hasRequiredAttrs()) && (r = !1), n.indexOf(c) == -1 && n.push(c);
    }
    r && e.err("Only non-generatable nodes (" + i.join(", ") + ") in a required position (see https://prosemirror.net/docs/guide/#generatable)");
  }
}
function Jx(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let A in t) {
    let n = t[A];
    if (!n.hasDefault)
      return null;
    e[A] = n.default;
  }
  return e;
}
function Wx(t, e) {
  let A = /* @__PURE__ */ Object.create(null);
  for (let n in t) {
    let s = e && e[n];
    if (s === void 0) {
      let r = t[n];
      if (r.hasDefault)
        s = r.default;
      else
        throw new RangeError("No value supplied for attribute " + n);
    }
    A[n] = s;
  }
  return A;
}
function Ox(t, e, A, n) {
  for (let s in e)
    if (!(s in t))
      throw new RangeError(`Unsupported attribute ${s} for ${A} of type ${s}`);
  for (let s in t) {
    let r = t[s];
    r.validate && r.validate(e[s]);
  }
}
function Px(t, e) {
  let A = /* @__PURE__ */ Object.create(null);
  if (e)
    for (let n in e)
      A[n] = new cS(t, n, e[n]);
  return A;
}
let P2 = class Kx {
  /**
  @internal
  */
  constructor(e, A, n) {
    this.name = e, this.schema = A, this.spec = n, this.markSet = null, this.groups = n.group ? n.group.split(" ") : [], this.attrs = Px(e, n.attrs), this.defaultAttrs = Jx(this.attrs), this.contentMatch = null, this.inlineContent = null, this.isBlock = !(n.inline || e == "text"), this.isText = e == "text";
  }
  /**
  True if this is an inline type.
  */
  get isInline() {
    return !this.isBlock;
  }
  /**
  True if this is a textblock type, a block that contains inline
  content.
  */
  get isTextblock() {
    return this.isBlock && this.inlineContent;
  }
  /**
  True for node types that allow no content.
  */
  get isLeaf() {
    return this.contentMatch == Va.empty;
  }
  /**
  True when this node is an atom, i.e. when it does not have
  directly editable content.
  */
  get isAtom() {
    return this.isLeaf || !!this.spec.atom;
  }
  /**
  Return true when this node type is part of the given
  [group](https://prosemirror.net/docs/ref/#model.NodeSpec.group).
  */
  isInGroup(e) {
    return this.groups.indexOf(e) > -1;
  }
  /**
  The node type's [whitespace](https://prosemirror.net/docs/ref/#model.NodeSpec.whitespace) option.
  */
  get whitespace() {
    return this.spec.whitespace || (this.spec.code ? "pre" : "normal");
  }
  /**
  Tells you whether this node type has any required attributes.
  */
  hasRequiredAttrs() {
    for (let e in this.attrs)
      if (this.attrs[e].isRequired)
        return !0;
    return !1;
  }
  /**
  Indicates whether this node allows some of the same content as
  the given node type.
  */
  compatibleContent(e) {
    return this == e || this.contentMatch.compatible(e.contentMatch);
  }
  /**
  @internal
  */
  computeAttrs(e) {
    return !e && this.defaultAttrs ? this.defaultAttrs : Wx(this.attrs, e);
  }
  /**
  Create a `Node` of this type. The given attributes are
  checked and defaulted (you can pass `null` to use the type's
  defaults entirely, if no required attributes exist). `content`
  may be a `Fragment`, a node, an array of nodes, or
  `null`. Similarly `marks` may be `null` to default to the empty
  set of marks.
  */
  create(e = null, A, n) {
    if (this.isText)
      throw new Error("NodeType.create can't construct text nodes");
    return new xi(this, this.computeAttrs(e), re.from(A), Lt.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but check the given content
  against the node type's content restrictions, and throw an error
  if it doesn't match.
  */
  createChecked(e = null, A, n) {
    return A = re.from(A), this.checkContent(A), new xi(this, this.computeAttrs(e), A, Lt.setFrom(n));
  }
  /**
  Like [`create`](https://prosemirror.net/docs/ref/#model.NodeType.create), but see if it is
  necessary to add nodes to the start or end of the given fragment
  to make it fit the node. If no fitting wrapping can be found,
  return null. Note that, due to the fact that required nodes can
  always be created, this will always succeed if you pass null or
  `Fragment.empty` as content.
  */
  createAndFill(e = null, A, n) {
    if (e = this.computeAttrs(e), A = re.from(A), A.size) {
      let i = this.contentMatch.fillBefore(A);
      if (!i)
        return null;
      A = i.append(A);
    }
    let s = this.contentMatch.matchFragment(A), r = s && s.fillBefore(re.empty, !0);
    return r ? new xi(this, e, A.append(r), Lt.setFrom(n)) : null;
  }
  /**
  Returns true if the given fragment is valid content for this node
  type.
  */
  validContent(e) {
    let A = this.contentMatch.matchFragment(e);
    if (!A || !A.validEnd)
      return !1;
    for (let n = 0; n < e.childCount; n++)
      if (!this.allowsMarks(e.child(n).marks))
        return !1;
    return !0;
  }
  /**
  Throws a RangeError if the given fragment is not valid content for this
  node type.
  @internal
  */
  checkContent(e) {
    if (!this.validContent(e))
      throw new RangeError(`Invalid content for node ${this.name}: ${e.toString().slice(0, 50)}`);
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Ox(this.attrs, e, "node", this.name);
  }
  /**
  Check whether the given mark type is allowed in this node.
  */
  allowsMarkType(e) {
    return this.markSet == null || this.markSet.indexOf(e) > -1;
  }
  /**
  Test whether the given set of marks are allowed in this node.
  */
  allowsMarks(e) {
    if (this.markSet == null)
      return !0;
    for (let A = 0; A < e.length; A++)
      if (!this.allowsMarkType(e[A].type))
        return !1;
    return !0;
  }
  /**
  Removes the marks that are not allowed in this node from the given set.
  */
  allowedMarks(e) {
    if (this.markSet == null)
      return e;
    let A;
    for (let n = 0; n < e.length; n++)
      this.allowsMarkType(e[n].type) ? A && A.push(e[n]) : A || (A = e.slice(0, n));
    return A ? A.length ? A : Lt.none : e;
  }
  /**
  @internal
  */
  static compile(e, A) {
    let n = /* @__PURE__ */ Object.create(null);
    e.forEach((r, i) => n[r] = new Kx(r, A, i));
    let s = A.spec.topNode || "doc";
    if (!n[s])
      throw new RangeError("Schema is missing its top node type ('" + s + "')");
    if (!n.text)
      throw new RangeError("Every schema needs a 'text' type");
    for (let r in n.text.attrs)
      throw new RangeError("The text node type should not have attributes");
    return n;
  }
};
function aS(t, e, A) {
  let n = A.split("|");
  return (s) => {
    let r = s === null ? "null" : typeof s;
    if (n.indexOf(r) < 0)
      throw new RangeError(`Expected value of type ${n} for attribute ${e} on type ${t}, got ${r}`);
  };
}
class cS {
  constructor(e, A, n) {
    this.hasDefault = Object.prototype.hasOwnProperty.call(n, "default"), this.default = n.default, this.validate = typeof n.validate == "string" ? aS(e, A, n.validate) : n.validate;
  }
  get isRequired() {
    return !this.hasDefault;
  }
}
class Ew {
  /**
  @internal
  */
  constructor(e, A, n, s) {
    this.name = e, this.rank = A, this.schema = n, this.spec = s, this.attrs = Px(e, s.attrs), this.excluded = null;
    let r = Jx(this.attrs);
    this.instance = r ? new Lt(this, r) : null;
  }
  /**
  Create a mark of this type. `attrs` may be `null` or an object
  containing only some of the mark's attributes. The others, if
  they have defaults, will be added.
  */
  create(e = null) {
    return !e && this.instance ? this.instance : new Lt(this, Wx(this.attrs, e));
  }
  /**
  @internal
  */
  static compile(e, A) {
    let n = /* @__PURE__ */ Object.create(null), s = 0;
    return e.forEach((r, i) => n[r] = new Ew(r, s++, A, i)), n;
  }
  /**
  When there is a mark of this type in the given set, a new set
  without it is returned. Otherwise, the input set is returned.
  */
  removeFromSet(e) {
    for (var A = 0; A < e.length; A++)
      e[A].type == this && (e = e.slice(0, A).concat(e.slice(A + 1)), A--);
    return e;
  }
  /**
  Tests whether there is a mark of this type in the given set.
  */
  isInSet(e) {
    for (let A = 0; A < e.length; A++)
      if (e[A].type == this)
        return e[A];
  }
  /**
  @internal
  */
  checkAttrs(e) {
    Ox(this.attrs, e, "mark", this.name);
  }
  /**
  Queries whether a given mark type is
  [excluded](https://prosemirror.net/docs/ref/#model.MarkSpec.excludes) by this one.
  */
  excludes(e) {
    return this.excluded.indexOf(e) > -1;
  }
}
let Vx = class {
  /**
  Construct a schema from a schema [specification](https://prosemirror.net/docs/ref/#model.SchemaSpec).
  */
  constructor(e) {
    this.linebreakReplacement = null, this.cached = /* @__PURE__ */ Object.create(null);
    let A = this.spec = {};
    for (let s in e)
      A[s] = e[s];
    A.nodes = JA.from(e.nodes), A.marks = JA.from(e.marks || {}), this.nodes = P2.compile(this.spec.nodes, this), this.marks = Ew.compile(this.spec.marks, this);
    let n = /* @__PURE__ */ Object.create(null);
    for (let s in this.nodes) {
      if (s in this.marks)
        throw new RangeError(s + " can not be both a node and a mark");
      let r = this.nodes[s], i = r.spec.content || "", o = r.spec.marks;
      if (r.contentMatch = n[i] || (n[i] = Va.parse(i, this.nodes)), r.inlineContent = r.contentMatch.inlineContent, r.spec.linebreakReplacement) {
        if (this.linebreakReplacement)
          throw new RangeError("Multiple linebreak nodes defined");
        if (!r.isInline || !r.isLeaf)
          throw new RangeError("Linebreak replacement nodes must be inline leaf nodes");
        this.linebreakReplacement = r;
      }
      r.markSet = o == "_" ? null : o ? K2(this, o.split(" ")) : o == "" || !r.inlineContent ? [] : null;
    }
    for (let s in this.marks) {
      let r = this.marks[s], i = r.spec.excludes;
      r.excluded = i == null ? [r] : i == "" ? [] : K2(this, i.split(" "));
    }
    this.nodeFromJSON = (s) => xi.fromJSON(this, s), this.markFromJSON = (s) => Lt.fromJSON(this, s), this.topNodeType = this.nodes[this.spec.topNode || "doc"], this.cached.wrappings = /* @__PURE__ */ Object.create(null);
  }
  /**
  Create a node in this schema. The `type` may be a string or a
  `NodeType` instance. Attributes will be extended with defaults,
  `content` may be a `Fragment`, `null`, a `Node`, or an array of
  nodes.
  */
  node(e, A = null, n, s) {
    if (typeof e == "string")
      e = this.nodeType(e);
    else if (e instanceof P2) {
      if (e.schema != this)
        throw new RangeError("Node type from different schema used (" + e.name + ")");
    } else throw new RangeError("Invalid node type: " + e);
    return e.createChecked(A, n, s);
  }
  /**
  Create a text node in the schema. Empty text nodes are not
  allowed.
  */
  text(e, A) {
    let n = this.nodes.text;
    return new _L(n, n.defaultAttrs, e, Lt.setFrom(A));
  }
  /**
  Create a mark with the given type and attributes.
  */
  mark(e, A) {
    return typeof e == "string" && (e = this.marks[e]), e.create(A);
  }
  /**
  @internal
  */
  nodeType(e) {
    let A = this.nodes[e];
    if (!A)
      throw new RangeError("Unknown node type: " + e);
    return A;
  }
};
function K2(t, e) {
  let A = [];
  for (let n = 0; n < e.length; n++) {
    let s = e[n], r = t.marks[s], i = r;
    if (r)
      A.push(r);
    else
      for (let o in t.marks) {
        let a = t.marks[o];
        (s == "_" || a.spec.group && a.spec.group.split(" ").indexOf(s) > -1) && A.push(i = a);
      }
    if (!i)
      throw new SyntaxError("Unknown mark type: '" + e[n] + "'");
  }
  return A;
}
function lS(t) {
  return t.tag != null;
}
function BS(t) {
  return t.style != null;
}
let SB = class DC {
  /**
  Create a parser that targets the given schema, using the given
  parsing rules.
  */
  constructor(e, A) {
    this.schema = e, this.rules = A, this.tags = [], this.styles = [];
    let n = this.matchedStyles = [];
    A.forEach((s) => {
      if (lS(s))
        this.tags.push(s);
      else if (BS(s)) {
        let r = /[^=]*/.exec(s.style)[0];
        n.indexOf(r) < 0 && n.push(r), this.styles.push(s);
      }
    }), this.normalizeLists = !this.tags.some((s) => {
      if (!/^(ul|ol)\b/.test(s.tag) || !s.node)
        return !1;
      let r = e.nodes[s.node];
      return r.contentMatch.matchType(r);
    });
  }
  /**
  Parse a document from the content of a DOM node.
  */
  parse(e, A = {}) {
    let n = new X2(this, A, !1);
    return n.addAll(e, Lt.none, A.from, A.to), n.finish();
  }
  /**
  Parses the content of the given DOM node, like
  [`parse`](https://prosemirror.net/docs/ref/#model.DOMParser.parse), and takes the same set of
  options. But unlike that method, which produces a whole node,
  this one returns a slice that is open at the sides, meaning that
  the schema constraints aren't applied to the start of nodes to
  the left of the input and the end of nodes at the end.
  */
  parseSlice(e, A = {}) {
    let n = new X2(this, A, !0);
    return n.addAll(e, Lt.none, A.from, A.to), Ee.maxOpen(n.finish());
  }
  /**
  @internal
  */
  matchTag(e, A, n) {
    for (let s = n ? this.tags.indexOf(n) + 1 : 0; s < this.tags.length; s++) {
      let r = this.tags[s];
      if (uS(e, r.tag) && (r.namespace === void 0 || e.namespaceURI == r.namespace) && (!r.context || A.matchesContext(r.context))) {
        if (r.getAttrs) {
          let i = r.getAttrs(e);
          if (i === !1)
            continue;
          r.attrs = i || void 0;
        }
        return r;
      }
    }
  }
  /**
  @internal
  */
  matchStyle(e, A, n, s) {
    for (let r = s ? this.styles.indexOf(s) + 1 : 0; r < this.styles.length; r++) {
      let i = this.styles[r], o = i.style;
      if (!(o.indexOf(e) != 0 || i.context && !n.matchesContext(i.context) || // Test that the style string either precisely matches the prop,
      // or has an '=' sign after the prop, followed by the given
      // value.
      o.length > e.length && (o.charCodeAt(e.length) != 61 || o.slice(e.length + 1) != A))) {
        if (i.getAttrs) {
          let a = i.getAttrs(A);
          if (a === !1)
            continue;
          i.attrs = a || void 0;
        }
        return i;
      }
    }
  }
  /**
  @internal
  */
  static schemaRules(e) {
    let A = [];
    function n(s) {
      let r = s.priority == null ? 50 : s.priority, i = 0;
      for (; i < A.length; i++) {
        let o = A[i];
        if ((o.priority == null ? 50 : o.priority) < r)
          break;
      }
      A.splice(i, 0, s);
    }
    for (let s in e.marks) {
      let r = e.marks[s].spec.parseDOM;
      r && r.forEach((i) => {
        n(i = Z2(i)), i.mark || i.ignore || i.clearMark || (i.mark = s);
      });
    }
    for (let s in e.nodes) {
      let r = e.nodes[s].spec.parseDOM;
      r && r.forEach((i) => {
        n(i = Z2(i)), i.node || i.ignore || i.mark || (i.node = s);
      });
    }
    return A;
  }
  /**
  Construct a DOM parser using the parsing rules listed in a
  schema's [node specs](https://prosemirror.net/docs/ref/#model.NodeSpec.parseDOM), reordered by
  [priority](https://prosemirror.net/docs/ref/#model.GenericParseRule.priority).
  */
  static fromSchema(e) {
    return e.cached.domParser || (e.cached.domParser = new DC(e, DC.schemaRules(e)));
  }
};
const Xx = {
  address: !0,
  article: !0,
  aside: !0,
  blockquote: !0,
  canvas: !0,
  dd: !0,
  div: !0,
  dl: !0,
  fieldset: !0,
  figcaption: !0,
  figure: !0,
  footer: !0,
  form: !0,
  h1: !0,
  h2: !0,
  h3: !0,
  h4: !0,
  h5: !0,
  h6: !0,
  header: !0,
  hgroup: !0,
  hr: !0,
  li: !0,
  noscript: !0,
  ol: !0,
  output: !0,
  p: !0,
  pre: !0,
  section: !0,
  table: !0,
  tfoot: !0,
  ul: !0
}, gS = {
  head: !0,
  noscript: !0,
  object: !0,
  script: !0,
  style: !0,
  title: !0
}, Zx = { ol: !0, ul: !0 }, Mg = 1, xC = 2, TB = 4;
function V2(t, e, A) {
  return e != null ? (e ? Mg : 0) | (e === "full" ? xC : 0) : t && t.whitespace == "pre" ? Mg | xC : A & ~TB;
}
class A0 {
  constructor(e, A, n, s, r, i) {
    this.type = e, this.attrs = A, this.marks = n, this.solid = s, this.options = i, this.content = [], this.activeMarks = Lt.none, this.match = r || (i & TB ? null : e.contentMatch);
  }
  findWrapping(e) {
    if (!this.match) {
      if (!this.type)
        return [];
      let A = this.type.contentMatch.fillBefore(re.from(e));
      if (A)
        this.match = this.type.contentMatch.matchFragment(A);
      else {
        let n = this.type.contentMatch, s;
        return (s = n.findWrapping(e.type)) ? (this.match = n, s) : null;
      }
    }
    return this.match.findWrapping(e.type);
  }
  finish(e) {
    if (!(this.options & Mg)) {
      let n = this.content[this.content.length - 1], s;
      if (n && n.isText && (s = /[ \t\r\n\u000c]+$/.exec(n.text))) {
        let r = n;
        n.text.length == s[0].length ? this.content.pop() : this.content[this.content.length - 1] = r.withText(r.text.slice(0, r.text.length - s[0].length));
      }
    }
    let A = re.from(this.content);
    return !e && this.match && (A = A.append(this.match.fillBefore(re.empty, !0))), this.type ? this.type.create(this.attrs, A, this.marks) : A;
  }
  inlineContext(e) {
    return this.type ? this.type.inlineContent : this.content.length ? this.content[0].isInline : e.parentNode && !Xx.hasOwnProperty(e.parentNode.nodeName.toLowerCase());
  }
}
class X2 {
  constructor(e, A, n) {
    this.parser = e, this.options = A, this.isOpen = n, this.open = 0, this.localPreserveWS = !1;
    let s = A.topNode, r, i = V2(null, A.preserveWhitespace, 0) | (n ? TB : 0);
    s ? r = new A0(s.type, s.attrs, Lt.none, !0, A.topMatch || s.type.contentMatch, i) : n ? r = new A0(null, null, Lt.none, !0, null, i) : r = new A0(e.schema.topNodeType, null, Lt.none, !0, null, i), this.nodes = [r], this.find = A.findPositions, this.needsBlock = !1;
  }
  get top() {
    return this.nodes[this.open];
  }
  // Add a DOM node to the content. Text is inserted as text node,
  // otherwise, the node is passed to `addElement` or, if it has a
  // `style` attribute, `addElementWithStyles`.
  addDOM(e, A) {
    e.nodeType == 3 ? this.addTextNode(e, A) : e.nodeType == 1 && this.addElement(e, A);
  }
  addTextNode(e, A) {
    let n = e.nodeValue, s = this.top, r = s.options & xC ? "full" : this.localPreserveWS || (s.options & Mg) > 0, { schema: i } = this.parser;
    if (r === "full" || s.inlineContext(e) || /[^ \t\r\n\u000c]/.test(n)) {
      if (r)
        if (r === "full")
          n = n.replace(/\r\n?/g, `
`);
        else if (i.linebreakReplacement && /[\r\n]/.test(n) && this.top.findWrapping(i.linebreakReplacement.create())) {
          let o = n.split(/\r?\n|\r/);
          for (let a = 0; a < o.length; a++)
            a && this.insertNode(i.linebreakReplacement.create(), A, !0), o[a] && this.insertNode(i.text(o[a]), A, !/\S/.test(o[a]));
          n = "";
        } else
          n = n.replace(/\r?\n|\r/g, " ");
      else if (n = n.replace(/[ \t\r\n\u000c]+/g, " "), /^[ \t\r\n\u000c]/.test(n) && this.open == this.nodes.length - 1) {
        let o = s.content[s.content.length - 1], a = e.previousSibling;
        (!o || a && a.nodeName == "BR" || o.isText && /[ \t\r\n\u000c]$/.test(o.text)) && (n = n.slice(1));
      }
      n && this.insertNode(i.text(n), A, !/\S/.test(n)), this.findInText(e);
    } else
      this.findInside(e);
  }
  // Try to find a handler for the given tag and use that to parse. If
  // none is found, the element's content nodes are added directly.
  addElement(e, A, n) {
    let s = this.localPreserveWS, r = this.top;
    (e.tagName == "PRE" || /pre/.test(e.style && e.style.whiteSpace)) && (this.localPreserveWS = !0);
    let i = e.nodeName.toLowerCase(), o;
    Zx.hasOwnProperty(i) && this.parser.normalizeLists && hS(e);
    let a = this.options.ruleFromNode && this.options.ruleFromNode(e) || (o = this.parser.matchTag(e, this, n));
    e: if (a ? a.ignore : gS.hasOwnProperty(i))
      this.findInside(e), this.ignoreFallback(e, A);
    else if (!a || a.skip || a.closeParent) {
      a && a.closeParent ? this.open = Math.max(0, this.open - 1) : a && a.skip.nodeType && (e = a.skip);
      let c, l = this.needsBlock;
      if (Xx.hasOwnProperty(i))
        r.content.length && r.content[0].isInline && this.open && (this.open--, r = this.top), c = !0, r.type || (this.needsBlock = !0);
      else if (!e.firstChild) {
        this.leafFallback(e, A);
        break e;
      }
      let B = a && a.skip ? A : this.readStyles(e, A);
      B && this.addAll(e, B), c && this.sync(r), this.needsBlock = l;
    } else {
      let c = this.readStyles(e, A);
      c && this.addElementByRule(e, a, c, a.consuming === !1 ? o : void 0);
    }
    this.localPreserveWS = s;
  }
  // Called for leaf DOM nodes that would otherwise be ignored
  leafFallback(e, A) {
    e.nodeName == "BR" && this.top.type && this.top.type.inlineContent && this.addTextNode(e.ownerDocument.createTextNode(`
`), A);
  }
  // Called for ignored nodes
  ignoreFallback(e, A) {
    e.nodeName == "BR" && (!this.top.type || !this.top.type.inlineContent) && this.findPlace(this.parser.schema.text("-"), A, !0);
  }
  // Run any style parser associated with the node's styles. Either
  // return an updated array of marks, or null to indicate some of the
  // styles had a rule with `ignore` set.
  readStyles(e, A) {
    let n = e.style;
    if (n && n.length)
      for (let s = 0; s < this.parser.matchedStyles.length; s++) {
        let r = this.parser.matchedStyles[s], i = n.getPropertyValue(r);
        if (i)
          for (let o = void 0; ; ) {
            let a = this.parser.matchStyle(r, i, this, o);
            if (!a)
              break;
            if (a.ignore)
              return null;
            if (a.clearMark ? A = A.filter((c) => !a.clearMark(c)) : A = A.concat(this.parser.schema.marks[a.mark].create(a.attrs)), a.consuming === !1)
              o = a;
            else
              break;
          }
      }
    return A;
  }
  // Look up a handler for the given node. If none are found, return
  // false. Otherwise, apply it, use its return value to drive the way
  // the node's content is wrapped, and return true.
  addElementByRule(e, A, n, s) {
    let r, i;
    if (A.node)
      if (i = this.parser.schema.nodes[A.node], i.isLeaf)
        this.insertNode(i.create(A.attrs), n, e.nodeName == "BR") || this.leafFallback(e, n);
      else {
        let a = this.enter(i, A.attrs || null, n, A.preserveWhitespace);
        a && (r = !0, n = a);
      }
    else {
      let a = this.parser.schema.marks[A.mark];
      n = n.concat(a.create(A.attrs));
    }
    let o = this.top;
    if (i && i.isLeaf)
      this.findInside(e);
    else if (s)
      this.addElement(e, n, s);
    else if (A.getContent)
      this.findInside(e), A.getContent(e, this.parser.schema).forEach((a) => this.insertNode(a, n, !1));
    else {
      let a = e;
      typeof A.contentElement == "string" ? a = e.querySelector(A.contentElement) : typeof A.contentElement == "function" ? a = A.contentElement(e) : A.contentElement && (a = A.contentElement), this.findAround(e, a, !0), this.addAll(a, n), this.findAround(e, a, !1);
    }
    r && this.sync(o) && this.open--;
  }
  // Add all child nodes between `startIndex` and `endIndex` (or the
  // whole node, if not given). If `sync` is passed, use it to
  // synchronize after every block element.
  addAll(e, A, n, s) {
    let r = n || 0;
    for (let i = n ? e.childNodes[n] : e.firstChild, o = s == null ? null : e.childNodes[s]; i != o; i = i.nextSibling, ++r)
      this.findAtPoint(e, r), this.addDOM(i, A);
    this.findAtPoint(e, r);
  }
  // Try to find a way to fit the given node type into the current
  // context. May add intermediate wrappers and/or leave non-solid
  // nodes that we're in.
  findPlace(e, A, n) {
    let s, r;
    for (let i = this.open, o = 0; i >= 0; i--) {
      let a = this.nodes[i], c = a.findWrapping(e);
      if (c && (!s || s.length > c.length + o) && (s = c, r = a, !c.length))
        break;
      if (a.solid) {
        if (n)
          break;
        o += 2;
      }
    }
    if (!s)
      return null;
    this.sync(r);
    for (let i = 0; i < s.length; i++)
      A = this.enterInner(s[i], null, A, !1);
    return A;
  }
  // Try to insert the given node, adjusting the context when needed.
  insertNode(e, A, n) {
    if (e.isInline && this.needsBlock && !this.top.type) {
      let r = this.textblockFromContext();
      r && (A = this.enterInner(r, null, A));
    }
    let s = this.findPlace(e, A, n);
    if (s) {
      this.closeExtra();
      let r = this.top;
      r.match && (r.match = r.match.matchType(e.type));
      let i = Lt.none;
      for (let o of s.concat(e.marks))
        (r.type ? r.type.allowsMarkType(o.type) : q2(o.type, e.type)) && (i = o.addToSet(i));
      return r.content.push(e.mark(i)), !0;
    }
    return !1;
  }
  // Try to start a node of the given type, adjusting the context when
  // necessary.
  enter(e, A, n, s) {
    let r = this.findPlace(e.create(A), n, !1);
    return r && (r = this.enterInner(e, A, n, !0, s)), r;
  }
  // Open a node of the given type
  enterInner(e, A, n, s = !1, r) {
    this.closeExtra();
    let i = this.top;
    i.match = i.match && i.match.matchType(e);
    let o = V2(e, r, i.options);
    i.options & TB && i.content.length == 0 && (o |= TB);
    let a = Lt.none;
    return n = n.filter((c) => (i.type ? i.type.allowsMarkType(c.type) : q2(c.type, e)) ? (a = c.addToSet(a), !1) : !0), this.nodes.push(new A0(e, A, a, s, null, o)), this.open++, n;
  }
  // Make sure all nodes above this.open are finished and added to
  // their parents
  closeExtra(e = !1) {
    let A = this.nodes.length - 1;
    if (A > this.open) {
      for (; A > this.open; A--)
        this.nodes[A - 1].content.push(this.nodes[A].finish(e));
      this.nodes.length = this.open + 1;
    }
  }
  finish() {
    return this.open = 0, this.closeExtra(this.isOpen), this.nodes[0].finish(!!(this.isOpen || this.options.topOpen));
  }
  sync(e) {
    for (let A = this.open; A >= 0; A--) {
      if (this.nodes[A] == e)
        return this.open = A, !0;
      this.localPreserveWS && (this.nodes[A].options |= Mg);
    }
    return !1;
  }
  get currentPos() {
    this.closeExtra();
    let e = 0;
    for (let A = this.open; A >= 0; A--) {
      let n = this.nodes[A].content;
      for (let s = n.length - 1; s >= 0; s--)
        e += n[s].nodeSize;
      A && e++;
    }
    return e;
  }
  findAtPoint(e, A) {
    if (this.find)
      for (let n = 0; n < this.find.length; n++)
        this.find[n].node == e && this.find[n].offset == A && (this.find[n].pos = this.currentPos);
  }
  findInside(e) {
    if (this.find)
      for (let A = 0; A < this.find.length; A++)
        this.find[A].pos == null && e.nodeType == 1 && e.contains(this.find[A].node) && (this.find[A].pos = this.currentPos);
  }
  findAround(e, A, n) {
    if (e != A && this.find)
      for (let s = 0; s < this.find.length; s++)
        this.find[s].pos == null && e.nodeType == 1 && e.contains(this.find[s].node) && A.compareDocumentPosition(this.find[s].node) & (n ? 2 : 4) && (this.find[s].pos = this.currentPos);
  }
  findInText(e) {
    if (this.find)
      for (let A = 0; A < this.find.length; A++)
        this.find[A].node == e && (this.find[A].pos = this.currentPos - (e.nodeValue.length - this.find[A].offset));
  }
  // Determines whether the given context string matches this context.
  matchesContext(e) {
    if (e.indexOf("|") > -1)
      return e.split(/\s*\|\s*/).some(this.matchesContext, this);
    let A = e.split("/"), n = this.options.context, s = !this.isOpen && (!n || n.parent.type == this.nodes[0].type), r = -(n ? n.depth + 1 : 0) + (s ? 0 : 1), i = (o, a) => {
      for (; o >= 0; o--) {
        let c = A[o];
        if (c == "") {
          if (o == A.length - 1 || o == 0)
            continue;
          for (; a >= r; a--)
            if (i(o - 1, a))
              return !0;
          return !1;
        } else {
          let l = a > 0 || a == 0 && s ? this.nodes[a].type : n && a >= r ? n.node(a - r).type : null;
          if (!l || l.name != c && !l.isInGroup(c))
            return !1;
          a--;
        }
      }
      return !0;
    };
    return i(A.length - 1, this.open);
  }
  textblockFromContext() {
    let e = this.options.context;
    if (e)
      for (let A = e.depth; A >= 0; A--) {
        let n = e.node(A).contentMatchAt(e.indexAfter(A)).defaultType;
        if (n && n.isTextblock && n.defaultAttrs)
          return n;
      }
    for (let A in this.parser.schema.nodes) {
      let n = this.parser.schema.nodes[A];
      if (n.isTextblock && n.defaultAttrs)
        return n;
    }
  }
}
function hS(t) {
  for (let e = t.firstChild, A = null; e; e = e.nextSibling) {
    let n = e.nodeType == 1 ? e.nodeName.toLowerCase() : null;
    n && Zx.hasOwnProperty(n) && A ? (A.appendChild(e), e = A) : n == "li" ? A = e : n && (A = null);
  }
}
function uS(t, e) {
  return (t.matches || t.msMatchesSelector || t.webkitMatchesSelector || t.mozMatchesSelector).call(t, e);
}
function Z2(t) {
  let e = {};
  for (let A in t)
    e[A] = t[A];
  return e;
}
function q2(t, e) {
  let A = e.schema.nodes;
  for (let n in A) {
    let s = A[n];
    if (!s.allowsMarkType(t))
      continue;
    let r = [], i = (o) => {
      r.push(o);
      for (let a = 0; a < o.edgeCount; a++) {
        let { type: c, next: l } = o.edge(a);
        if (c == e || r.indexOf(l) < 0 && i(l))
          return !0;
      }
    };
    if (i(s.contentMatch))
      return !0;
  }
}
class ac {
  /**
  Create a serializer. `nodes` should map node names to functions
  that take a node and return a description of the corresponding
  DOM. `marks` does the same for mark names, but also gets an
  argument that tells it whether the mark's content is block or
  inline content (for typical use, it'll always be inline). A mark
  serializer may be `null` to indicate that marks of that type
  should not be serialized.
  */
  constructor(e, A) {
    this.nodes = e, this.marks = A;
  }
  /**
  Serialize the content of this fragment to a DOM fragment. When
  not in the browser, the `document` option, containing a DOM
  document, should be passed so that the serializer can create
  nodes.
  */
  serializeFragment(e, A = {}, n) {
    n || (n = wQ(A).createDocumentFragment());
    let s = n, r = [];
    return e.forEach((i) => {
      if (r.length || i.marks.length) {
        let o = 0, a = 0;
        for (; o < r.length && a < i.marks.length; ) {
          let c = i.marks[a];
          if (!this.marks[c.type.name]) {
            a++;
            continue;
          }
          if (!c.eq(r[o][0]) || c.type.spec.spanning === !1)
            break;
          o++, a++;
        }
        for (; o < r.length; )
          s = r.pop()[1];
        for (; a < i.marks.length; ) {
          let c = i.marks[a++], l = this.serializeMark(c, i.isInline, A);
          l && (r.push([c, s]), s.appendChild(l.dom), s = l.contentDOM || l.dom);
        }
      }
      s.appendChild(this.serializeNodeInner(i, A));
    }), n;
  }
  /**
  @internal
  */
  serializeNodeInner(e, A) {
    let { dom: n, contentDOM: s } = Z0(wQ(A), this.nodes[e.type.name](e), null, e.attrs);
    if (s) {
      if (e.isLeaf)
        throw new RangeError("Content hole not allowed in a leaf node spec");
      this.serializeFragment(e.content, A, s);
    }
    return n;
  }
  /**
  Serialize this node to a DOM node. This can be useful when you
  need to serialize a part of a document, as opposed to the whole
  document. To serialize a whole document, use
  [`serializeFragment`](https://prosemirror.net/docs/ref/#model.DOMSerializer.serializeFragment) on
  its [content](https://prosemirror.net/docs/ref/#model.Node.content).
  */
  serializeNode(e, A = {}) {
    let n = this.serializeNodeInner(e, A);
    for (let s = e.marks.length - 1; s >= 0; s--) {
      let r = this.serializeMark(e.marks[s], e.isInline, A);
      r && ((r.contentDOM || r.dom).appendChild(n), n = r.dom);
    }
    return n;
  }
  /**
  @internal
  */
  serializeMark(e, A, n = {}) {
    let s = this.marks[e.type.name];
    return s && Z0(wQ(n), s(e, A), null, e.attrs);
  }
  static renderSpec(e, A, n = null, s) {
    return Z0(e, A, n, s);
  }
  /**
  Build a serializer using the [`toDOM`](https://prosemirror.net/docs/ref/#model.NodeSpec.toDOM)
  properties in a schema's node and mark specs.
  */
  static fromSchema(e) {
    return e.cached.domSerializer || (e.cached.domSerializer = new ac(this.nodesFromSchema(e), this.marksFromSchema(e)));
  }
  /**
  Gather the serializers in a schema's node specs into an object.
  This can be useful as a base to build a custom serializer from.
  */
  static nodesFromSchema(e) {
    let A = _2(e.nodes);
    return A.text || (A.text = (n) => n.text), A;
  }
  /**
  Gather the serializers in a schema's mark specs into an object.
  */
  static marksFromSchema(e) {
    return _2(e.marks);
  }
}
function _2(t) {
  let e = {};
  for (let A in t) {
    let n = t[A].spec.toDOM;
    n && (e[A] = n);
  }
  return e;
}
function wQ(t) {
  return t.document || window.document;
}
const $2 = /* @__PURE__ */ new WeakMap();
function dS(t) {
  let e = $2.get(t);
  return e === void 0 && $2.set(t, e = wS(t)), e;
}
function wS(t) {
  let e = null;
  function A(n) {
    if (n && typeof n == "object")
      if (Array.isArray(n))
        if (typeof n[0] == "string")
          e || (e = []), e.push(n);
        else
          for (let s = 0; s < n.length; s++)
            A(n[s]);
      else
        for (let s in n)
          A(n[s]);
  }
  return A(t), e;
}
function Z0(t, e, A, n) {
  if (typeof e == "string")
    return { dom: t.createTextNode(e) };
  if (e.nodeType != null)
    return { dom: e };
  if (e.dom && e.dom.nodeType != null)
    return e;
  let s = e[0], r;
  if (typeof s != "string")
    throw new RangeError("Invalid array passed to renderSpec");
  if (n && (r = dS(n)) && r.indexOf(e) > -1)
    throw new RangeError("Using an array from an attribute object as a DOM spec. This may be an attempted cross site scripting attack.");
  let i = s.indexOf(" ");
  i > 0 && (A = s.slice(0, i), s = s.slice(i + 1));
  let o, a = A ? t.createElementNS(A, s) : t.createElement(s), c = e[1], l = 1;
  if (c && typeof c == "object" && c.nodeType == null && !Array.isArray(c)) {
    l = 2;
    for (let B in c)
      if (c[B] != null) {
        let g = B.indexOf(" ");
        g > 0 ? a.setAttributeNS(B.slice(0, g), B.slice(g + 1), c[B]) : B == "style" && a.style ? a.style.cssText = c[B] : a.setAttribute(B, c[B]);
      }
  }
  for (let B = l; B < e.length; B++) {
    let g = e[B];
    if (g === 0) {
      if (B < e.length - 1 || B > l)
        throw new RangeError("Content hole must be the only child of its parent node");
      return { dom: a, contentDOM: a };
    } else {
      let { dom: h, contentDOM: u } = Z0(t, g, A, n);
      if (a.appendChild(h), u) {
        if (o)
          throw new RangeError("Multiple content holes");
        o = u;
      }
    }
  }
  return { dom: a, contentDOM: o };
}
const qx = 65535, _x = Math.pow(2, 16);
function fS(t, e) {
  return t + e * _x;
}
function ey(t) {
  return t & qx;
}
function QS(t) {
  return (t - (t & qx)) / _x;
}
const $x = 1, e4 = 2, q0 = 4, t4 = 8;
class GC {
  /**
  @internal
  */
  constructor(e, A, n) {
    this.pos = e, this.delInfo = A, this.recover = n;
  }
  /**
  Tells you whether the position was deleted, that is, whether the
  step removed the token on the side queried (via the `assoc`)
  argument from the document.
  */
  get deleted() {
    return (this.delInfo & t4) > 0;
  }
  /**
  Tells you whether the token before the mapped position was deleted.
  */
  get deletedBefore() {
    return (this.delInfo & ($x | q0)) > 0;
  }
  /**
  True when the token after the mapped position was deleted.
  */
  get deletedAfter() {
    return (this.delInfo & (e4 | q0)) > 0;
  }
  /**
  Tells whether any of the steps mapped through deletes across the
  position (including both the token before and after the
  position).
  */
  get deletedAcross() {
    return (this.delInfo & q0) > 0;
  }
}
class cs {
  /**
  Create a position map. The modifications to the document are
  represented as an array of numbers, in which each group of three
  represents a modified chunk as `[start, oldSize, newSize]`.
  */
  constructor(e, A = !1) {
    if (this.ranges = e, this.inverted = A, !e.length && cs.empty)
      return cs.empty;
  }
  /**
  @internal
  */
  recover(e) {
    let A = 0, n = ey(e);
    if (!this.inverted)
      for (let s = 0; s < n; s++)
        A += this.ranges[s * 3 + 2] - this.ranges[s * 3 + 1];
    return this.ranges[n * 3] + A + QS(e);
  }
  mapResult(e, A = 1) {
    return this._map(e, A, !1);
  }
  map(e, A = 1) {
    return this._map(e, A, !0);
  }
  /**
  @internal
  */
  _map(e, A, n) {
    let s = 0, r = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let o = 0; o < this.ranges.length; o += 3) {
      let a = this.ranges[o] - (this.inverted ? s : 0);
      if (a > e)
        break;
      let c = this.ranges[o + r], l = this.ranges[o + i], B = a + c;
      if (e <= B) {
        let g = c ? e == a ? -1 : e == B ? 1 : A : A, h = a + s + (g < 0 ? 0 : l);
        if (n)
          return h;
        let u = e == (A < 0 ? a : B) ? null : fS(o / 3, e - a), d = e == a ? e4 : e == B ? $x : q0;
        return (A < 0 ? e != a : e != B) && (d |= t4), new GC(h, d, u);
      }
      s += l - c;
    }
    return n ? e + s : new GC(e + s, 0, null);
  }
  /**
  @internal
  */
  touches(e, A) {
    let n = 0, s = ey(A), r = this.inverted ? 2 : 1, i = this.inverted ? 1 : 2;
    for (let o = 0; o < this.ranges.length; o += 3) {
      let a = this.ranges[o] - (this.inverted ? n : 0);
      if (a > e)
        break;
      let c = this.ranges[o + r], l = a + c;
      if (e <= l && o == s * 3)
        return !0;
      n += this.ranges[o + i] - c;
    }
    return !1;
  }
  /**
  Calls the given function on each of the changed ranges included in
  this map.
  */
  forEach(e) {
    let A = this.inverted ? 2 : 1, n = this.inverted ? 1 : 2;
    for (let s = 0, r = 0; s < this.ranges.length; s += 3) {
      let i = this.ranges[s], o = i - (this.inverted ? r : 0), a = i + (this.inverted ? 0 : r), c = this.ranges[s + A], l = this.ranges[s + n];
      e(o, o + c, a, a + l), r += l - c;
    }
  }
  /**
  Create an inverted version of this map. The result can be used to
  map positions in the post-step document to the pre-step document.
  */
  invert() {
    return new cs(this.ranges, !this.inverted);
  }
  /**
  @internal
  */
  toString() {
    return (this.inverted ? "-" : "") + JSON.stringify(this.ranges);
  }
  /**
  Create a map that moves all positions by offset `n` (which may be
  negative). This can be useful when applying steps meant for a
  sub-document to a larger document, or vice-versa.
  */
  static offset(e) {
    return e == 0 ? cs.empty : new cs(e < 0 ? [0, -e, 0] : [0, 0, e]);
  }
}
cs.empty = new cs([]);
class pg {
  /**
  Create a new mapping with the given position maps.
  */
  constructor(e, A, n = 0, s = e ? e.length : 0) {
    this.mirror = A, this.from = n, this.to = s, this._maps = e || [], this.ownData = !(e || A);
  }
  /**
  The step maps in this mapping.
  */
  get maps() {
    return this._maps;
  }
  /**
  Create a mapping that maps only through a part of this one.
  */
  slice(e = 0, A = this.maps.length) {
    return new pg(this._maps, this.mirror, e, A);
  }
  /**
  Add a step map to the end of this mapping. If `mirrors` is
  given, it should be the index of the step map that is the mirror
  image of this one.
  */
  appendMap(e, A) {
    this.ownData || (this._maps = this._maps.slice(), this.mirror = this.mirror && this.mirror.slice(), this.ownData = !0), this.to = this._maps.push(e), A != null && this.setMirror(this._maps.length - 1, A);
  }
  /**
  Add all the step maps in a given mapping to this one (preserving
  mirroring information).
  */
  appendMapping(e) {
    for (let A = 0, n = this._maps.length; A < e._maps.length; A++) {
      let s = e.getMirror(A);
      this.appendMap(e._maps[A], s != null && s < A ? n + s : void 0);
    }
  }
  /**
  Finds the offset of the step map that mirrors the map at the
  given offset, in this mapping (as per the second argument to
  `appendMap`).
  */
  getMirror(e) {
    if (this.mirror) {
      for (let A = 0; A < this.mirror.length; A++)
        if (this.mirror[A] == e)
          return this.mirror[A + (A % 2 ? -1 : 1)];
    }
  }
  /**
  @internal
  */
  setMirror(e, A) {
    this.mirror || (this.mirror = []), this.mirror.push(e, A);
  }
  /**
  Append the inverse of the given mapping to this one.
  */
  appendMappingInverted(e) {
    for (let A = e.maps.length - 1, n = this._maps.length + e._maps.length; A >= 0; A--) {
      let s = e.getMirror(A);
      this.appendMap(e._maps[A].invert(), s != null && s > A ? n - s - 1 : void 0);
    }
  }
  /**
  Create an inverted version of this mapping.
  */
  invert() {
    let e = new pg();
    return e.appendMappingInverted(this), e;
  }
  /**
  Map a position through this mapping.
  */
  map(e, A = 1) {
    if (this.mirror)
      return this._map(e, A, !0);
    for (let n = this.from; n < this.to; n++)
      e = this._maps[n].map(e, A);
    return e;
  }
  /**
  Map a position through this mapping, returning a mapping
  result.
  */
  mapResult(e, A = 1) {
    return this._map(e, A, !1);
  }
  /**
  @internal
  */
  _map(e, A, n) {
    let s = 0;
    for (let r = this.from; r < this.to; r++) {
      let i = this._maps[r], o = i.mapResult(e, A);
      if (o.recover != null) {
        let a = this.getMirror(r);
        if (a != null && a > r && a < this.to) {
          r = a, e = this._maps[a].recover(o.recover);
          continue;
        }
      }
      s |= o.delInfo, e = o.pos;
    }
    return n ? e : new GC(e, s, null);
  }
}
const fQ = /* @__PURE__ */ Object.create(null);
class Bn {
  /**
  Get the step map that represents the changes made by this step,
  and which can be used to transform between positions in the old
  and the new document.
  */
  getMap() {
    return cs.empty;
  }
  /**
  Try to merge this step with another one, to be applied directly
  after it. Returns the merged step when possible, null if the
  steps can't be merged.
  */
  merge(e) {
    return null;
  }
  /**
  Deserialize a step from its JSON representation. Will call
  through to the step class' own implementation of this method.
  */
  static fromJSON(e, A) {
    if (!A || !A.stepType)
      throw new RangeError("Invalid input for Step.fromJSON");
    let n = fQ[A.stepType];
    if (!n)
      throw new RangeError(`No step type ${A.stepType} defined`);
    return n.fromJSON(e, A);
  }
  /**
  To be able to serialize steps to JSON, each step needs a string
  ID to attach to its JSON representation. Use this method to
  register an ID for your step classes. Try to pick something
  that's unlikely to clash with steps from other modules.
  */
  static jsonID(e, A) {
    if (e in fQ)
      throw new RangeError("Duplicate use of step JSON ID " + e);
    return fQ[e] = A, A.prototype.jsonID = e, A;
  }
}
class EA {
  /**
  @internal
  */
  constructor(e, A) {
    this.doc = e, this.failed = A;
  }
  /**
  Create a successful step result.
  */
  static ok(e) {
    return new EA(e, null);
  }
  /**
  Create a failed step result.
  */
  static fail(e) {
    return new EA(null, e);
  }
  /**
  Call [`Node.replace`](https://prosemirror.net/docs/ref/#model.Node.replace) with the given
  arguments. Create a successful result if it succeeds, and a
  failed one if it throws a `ReplaceError`.
  */
  static fromReplace(e, A, n, s) {
    try {
      return EA.ok(e.replace(A, n, s));
    } catch (r) {
      if (r instanceof bu)
        return EA.fail(r.message);
      throw r;
    }
  }
}
function HM(t, e, A) {
  let n = [];
  for (let s = 0; s < t.childCount; s++) {
    let r = t.child(s);
    r.content.size && (r = r.copy(HM(r.content, e, r))), r.isInline && (r = e(r, A, s)), n.push(r);
  }
  return re.fromArray(n);
}
class Uo extends Bn {
  /**
  Create a mark step.
  */
  constructor(e, A, n) {
    super(), this.from = e, this.to = A, this.mark = n;
  }
  apply(e) {
    let A = e.slice(this.from, this.to), n = e.resolve(this.from), s = n.node(n.sharedDepth(this.to)), r = new Ee(HM(A.content, (i, o) => !i.isAtom || !o.type.allowsMarkType(this.mark.type) ? i : i.mark(this.mark.addToSet(i.marks)), s), A.openStart, A.openEnd);
    return EA.fromReplace(e, this.from, this.to, r);
  }
  invert() {
    return new Zs(this.from, this.to, this.mark);
  }
  map(e) {
    let A = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return A.deleted && n.deleted || A.pos >= n.pos ? null : new Uo(A.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof Uo && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Uo(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "addMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.from != "number" || typeof A.to != "number")
      throw new RangeError("Invalid input for AddMarkStep.fromJSON");
    return new Uo(A.from, A.to, e.markFromJSON(A.mark));
  }
}
Bn.jsonID("addMark", Uo);
class Zs extends Bn {
  /**
  Create a mark-removing step.
  */
  constructor(e, A, n) {
    super(), this.from = e, this.to = A, this.mark = n;
  }
  apply(e) {
    let A = e.slice(this.from, this.to), n = new Ee(HM(A.content, (s) => s.mark(this.mark.removeFromSet(s.marks)), e), A.openStart, A.openEnd);
    return EA.fromReplace(e, this.from, this.to, n);
  }
  invert() {
    return new Uo(this.from, this.to, this.mark);
  }
  map(e) {
    let A = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return A.deleted && n.deleted || A.pos >= n.pos ? null : new Zs(A.pos, n.pos, this.mark);
  }
  merge(e) {
    return e instanceof Zs && e.mark.eq(this.mark) && this.from <= e.to && this.to >= e.from ? new Zs(Math.min(this.from, e.from), Math.max(this.to, e.to), this.mark) : null;
  }
  toJSON() {
    return {
      stepType: "removeMark",
      mark: this.mark.toJSON(),
      from: this.from,
      to: this.to
    };
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.from != "number" || typeof A.to != "number")
      throw new RangeError("Invalid input for RemoveMarkStep.fromJSON");
    return new Zs(A.from, A.to, e.markFromJSON(A.mark));
  }
}
Bn.jsonID("removeMark", Zs);
class bo extends Bn {
  /**
  Create a node mark step.
  */
  constructor(e, A) {
    super(), this.pos = e, this.mark = A;
  }
  apply(e) {
    let A = e.nodeAt(this.pos);
    if (!A)
      return EA.fail("No node at mark step's position");
    let n = A.type.create(A.attrs, null, this.mark.addToSet(A.marks));
    return EA.fromReplace(e, this.pos, this.pos + 1, new Ee(re.from(n), 0, A.isLeaf ? 0 : 1));
  }
  invert(e) {
    let A = e.nodeAt(this.pos);
    if (A) {
      let n = this.mark.addToSet(A.marks);
      if (n.length == A.marks.length) {
        for (let s = 0; s < A.marks.length; s++)
          if (!A.marks[s].isInSet(n))
            return new bo(this.pos, A.marks[s]);
        return new bo(this.pos, this.mark);
      }
    }
    return new Xa(this.pos, this.mark);
  }
  map(e) {
    let A = e.mapResult(this.pos, 1);
    return A.deletedAfter ? null : new bo(A.pos, this.mark);
  }
  toJSON() {
    return { stepType: "addNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.pos != "number")
      throw new RangeError("Invalid input for AddNodeMarkStep.fromJSON");
    return new bo(A.pos, e.markFromJSON(A.mark));
  }
}
Bn.jsonID("addNodeMark", bo);
class Xa extends Bn {
  /**
  Create a mark-removing step.
  */
  constructor(e, A) {
    super(), this.pos = e, this.mark = A;
  }
  apply(e) {
    let A = e.nodeAt(this.pos);
    if (!A)
      return EA.fail("No node at mark step's position");
    let n = A.type.create(A.attrs, null, this.mark.removeFromSet(A.marks));
    return EA.fromReplace(e, this.pos, this.pos + 1, new Ee(re.from(n), 0, A.isLeaf ? 0 : 1));
  }
  invert(e) {
    let A = e.nodeAt(this.pos);
    return !A || !this.mark.isInSet(A.marks) ? this : new bo(this.pos, this.mark);
  }
  map(e) {
    let A = e.mapResult(this.pos, 1);
    return A.deletedAfter ? null : new Xa(A.pos, this.mark);
  }
  toJSON() {
    return { stepType: "removeNodeMark", pos: this.pos, mark: this.mark.toJSON() };
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.pos != "number")
      throw new RangeError("Invalid input for RemoveNodeMarkStep.fromJSON");
    return new Xa(A.pos, e.markFromJSON(A.mark));
  }
}
Bn.jsonID("removeNodeMark", Xa);
class GA extends Bn {
  /**
  The given `slice` should fit the 'gap' between `from` and
  `to`—the depths must line up, and the surrounding nodes must be
  able to be joined with the open sides of the slice. When
  `structure` is true, the step will fail if the content between
  from and to is not just a sequence of closing and then opening
  tokens (this is to guard against rebased replace steps
  overwriting something they weren't supposed to).
  */
  constructor(e, A, n, s = !1) {
    super(), this.from = e, this.to = A, this.slice = n, this.structure = s;
  }
  apply(e) {
    return this.structure && zC(e, this.from, this.to) ? EA.fail("Structure replace would overwrite content") : EA.fromReplace(e, this.from, this.to, this.slice);
  }
  getMap() {
    return new cs([this.from, this.to - this.from, this.slice.size]);
  }
  invert(e) {
    return new GA(this.from, this.from + this.slice.size, e.slice(this.from, this.to));
  }
  map(e) {
    let A = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1);
    return A.deletedAcross && n.deletedAcross ? null : new GA(A.pos, Math.max(A.pos, n.pos), this.slice, this.structure);
  }
  merge(e) {
    if (!(e instanceof GA) || e.structure || this.structure)
      return null;
    if (this.from + this.slice.size == e.from && !this.slice.openEnd && !e.slice.openStart) {
      let A = this.slice.size + e.slice.size == 0 ? Ee.empty : new Ee(this.slice.content.append(e.slice.content), this.slice.openStart, e.slice.openEnd);
      return new GA(this.from, this.to + (e.to - e.from), A, this.structure);
    } else if (e.to == this.from && !this.slice.openStart && !e.slice.openEnd) {
      let A = this.slice.size + e.slice.size == 0 ? Ee.empty : new Ee(e.slice.content.append(this.slice.content), e.slice.openStart, this.slice.openEnd);
      return new GA(e.from, this.to, A, this.structure);
    } else
      return null;
  }
  toJSON() {
    let e = { stepType: "replace", from: this.from, to: this.to };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.from != "number" || typeof A.to != "number")
      throw new RangeError("Invalid input for ReplaceStep.fromJSON");
    return new GA(A.from, A.to, Ee.fromJSON(e, A.slice), !!A.structure);
  }
}
Bn.jsonID("replace", GA);
class vA extends Bn {
  /**
  Create a replace-around step with the given range and gap.
  `insert` should be the point in the slice into which the content
  of the gap should be moved. `structure` has the same meaning as
  it has in the [`ReplaceStep`](https://prosemirror.net/docs/ref/#transform.ReplaceStep) class.
  */
  constructor(e, A, n, s, r, i, o = !1) {
    super(), this.from = e, this.to = A, this.gapFrom = n, this.gapTo = s, this.slice = r, this.insert = i, this.structure = o;
  }
  apply(e) {
    if (this.structure && (zC(e, this.from, this.gapFrom) || zC(e, this.gapTo, this.to)))
      return EA.fail("Structure gap-replace would overwrite content");
    let A = e.slice(this.gapFrom, this.gapTo);
    if (A.openStart || A.openEnd)
      return EA.fail("Gap is not a flat range");
    let n = this.slice.insertAt(this.insert, A.content);
    return n ? EA.fromReplace(e, this.from, this.to, n) : EA.fail("Content does not fit in gap");
  }
  getMap() {
    return new cs([
      this.from,
      this.gapFrom - this.from,
      this.insert,
      this.gapTo,
      this.to - this.gapTo,
      this.slice.size - this.insert
    ]);
  }
  invert(e) {
    let A = this.gapTo - this.gapFrom;
    return new vA(this.from, this.from + this.slice.size + A, this.from + this.insert, this.from + this.insert + A, e.slice(this.from, this.to).removeBetween(this.gapFrom - this.from, this.gapTo - this.from), this.gapFrom - this.from, this.structure);
  }
  map(e) {
    let A = e.mapResult(this.from, 1), n = e.mapResult(this.to, -1), s = this.from == this.gapFrom ? A.pos : e.map(this.gapFrom, -1), r = this.to == this.gapTo ? n.pos : e.map(this.gapTo, 1);
    return A.deletedAcross && n.deletedAcross || s < A.pos || r > n.pos ? null : new vA(A.pos, n.pos, s, r, this.slice, this.insert, this.structure);
  }
  toJSON() {
    let e = {
      stepType: "replaceAround",
      from: this.from,
      to: this.to,
      gapFrom: this.gapFrom,
      gapTo: this.gapTo,
      insert: this.insert
    };
    return this.slice.size && (e.slice = this.slice.toJSON()), this.structure && (e.structure = !0), e;
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.from != "number" || typeof A.to != "number" || typeof A.gapFrom != "number" || typeof A.gapTo != "number" || typeof A.insert != "number")
      throw new RangeError("Invalid input for ReplaceAroundStep.fromJSON");
    return new vA(A.from, A.to, A.gapFrom, A.gapTo, Ee.fromJSON(e, A.slice), A.insert, !!A.structure);
  }
}
Bn.jsonID("replaceAround", vA);
function zC(t, e, A) {
  let n = t.resolve(e), s = A - e, r = n.depth;
  for (; s > 0 && r > 0 && n.indexAfter(r) == n.node(r).childCount; )
    r--, s--;
  if (s > 0) {
    let i = n.node(r).maybeChild(n.indexAfter(r));
    for (; s > 0; ) {
      if (!i || i.isLeaf)
        return !0;
      i = i.firstChild, s--;
    }
  }
  return !1;
}
function IS(t, e, A, n) {
  let s = [], r = [], i, o;
  t.doc.nodesBetween(e, A, (a, c, l) => {
    if (!a.isInline)
      return;
    let B = a.marks;
    if (!n.isInSet(B) && l.type.allowsMarkType(n.type)) {
      let g = Math.max(c, e), h = Math.min(c + a.nodeSize, A), u = n.addToSet(B);
      for (let d = 0; d < B.length; d++)
        B[d].isInSet(u) || (i && i.to == g && i.mark.eq(B[d]) ? i.to = h : s.push(i = new Zs(g, h, B[d])));
      o && o.to == g ? o.to = h : r.push(o = new Uo(g, h, n));
    }
  }), s.forEach((a) => t.step(a)), r.forEach((a) => t.step(a));
}
function CS(t, e, A, n) {
  let s = [], r = 0;
  t.doc.nodesBetween(e, A, (i, o) => {
    if (!i.isInline)
      return;
    r++;
    let a = null;
    if (n instanceof Ew) {
      let c = i.marks, l;
      for (; l = n.isInSet(c); )
        (a || (a = [])).push(l), c = l.removeFromSet(c);
    } else n ? n.isInSet(i.marks) && (a = [n]) : a = i.marks;
    if (a && a.length) {
      let c = Math.min(o + i.nodeSize, A);
      for (let l = 0; l < a.length; l++) {
        let B = a[l], g;
        for (let h = 0; h < s.length; h++) {
          let u = s[h];
          u.step == r - 1 && B.eq(s[h].style) && (g = u);
        }
        g ? (g.to = c, g.step = r) : s.push({ style: B, from: Math.max(o, e), to: c, step: r });
      }
    }
  }), s.forEach((i) => t.step(new Zs(i.from, i.to, i.style)));
}
function kM(t, e, A, n = A.contentMatch, s = !0) {
  let r = t.doc.nodeAt(e), i = [], o = e + 1;
  for (let a = 0; a < r.childCount; a++) {
    let c = r.child(a), l = o + c.nodeSize, B = n.matchType(c.type);
    if (!B)
      i.push(new GA(o, l, Ee.empty));
    else {
      n = B;
      for (let g = 0; g < c.marks.length; g++)
        A.allowsMarkType(c.marks[g].type) || t.step(new Zs(o, l, c.marks[g]));
      if (s && c.isText && A.whitespace != "pre") {
        let g, h = /\r?\n|\r/g, u;
        for (; g = h.exec(c.text); )
          u || (u = new Ee(re.from(A.schema.text(" ", A.allowedMarks(c.marks))), 0, 0)), i.push(new GA(o + g.index, o + g.index + g[0].length, u));
      }
    }
    o = l;
  }
  if (!n.validEnd) {
    let a = n.fillBefore(re.empty, !0);
    t.replace(o, o, new Ee(a, 0, 0));
  }
  for (let a = i.length - 1; a >= 0; a--)
    t.step(i[a]);
}
function ES(t, e, A) {
  return (e == 0 || t.canReplace(e, t.childCount)) && (A == t.childCount || t.canReplace(0, A));
}
function cc(t) {
  let A = t.parent.content.cutByIndex(t.startIndex, t.endIndex);
  for (let n = t.depth, s = 0, r = 0; ; --n) {
    let i = t.$from.node(n), o = t.$from.index(n) + s, a = t.$to.indexAfter(n) - r;
    if (n < t.depth && i.canReplace(o, a, A))
      return n;
    if (n == 0 || i.type.spec.isolating || !ES(i, o, a))
      break;
    o && (s = 1), a < i.childCount && (r = 1);
  }
  return null;
}
function MS(t, e, A) {
  let { $from: n, $to: s, depth: r } = e, i = n.before(r + 1), o = s.after(r + 1), a = i, c = o, l = re.empty, B = 0;
  for (let u = r, d = !1; u > A; u--)
    d || n.index(u) > 0 ? (d = !0, l = re.from(n.node(u).copy(l)), B++) : a--;
  let g = re.empty, h = 0;
  for (let u = r, d = !1; u > A; u--)
    d || s.after(u + 1) < s.end(u) ? (d = !0, g = re.from(s.node(u).copy(g)), h++) : c++;
  t.step(new vA(a, c, i, o, new Ee(l.append(g), B, h), l.size - B, !0));
}
function Mw(t, e, A = null, n = t) {
  let s = pS(t, e), r = s && mS(n, e);
  return r ? s.map(ty).concat({ type: e, attrs: A }).concat(r.map(ty)) : null;
}
function ty(t) {
  return { type: t, attrs: null };
}
function pS(t, e) {
  let { parent: A, startIndex: n, endIndex: s } = t, r = A.contentMatchAt(n).findWrapping(e);
  if (!r)
    return null;
  let i = r.length ? r[0] : e;
  return A.canReplaceWith(n, s, i) ? r : null;
}
function mS(t, e) {
  let { parent: A, startIndex: n, endIndex: s } = t, r = A.child(n), i = e.contentMatch.findWrapping(r.type);
  if (!i)
    return null;
  let a = (i.length ? i[i.length - 1] : e).contentMatch;
  for (let c = n; a && c < s; c++)
    a = a.matchType(A.child(c).type);
  return !a || !a.validEnd ? null : i;
}
function YS(t, e, A) {
  let n = re.empty;
  for (let i = A.length - 1; i >= 0; i--) {
    if (n.size) {
      let o = A[i].type.contentMatch.matchFragment(n);
      if (!o || !o.validEnd)
        throw new RangeError("Wrapper type given to Transform.wrap does not form valid content of its parent wrapper");
    }
    n = re.from(A[i].type.create(A[i].attrs, n));
  }
  let s = e.start, r = e.end;
  t.step(new vA(s, r, s, r, new Ee(n, 0, 0), A.length, !0));
}
function yS(t, e, A, n, s) {
  if (!n.isTextblock)
    throw new RangeError("Type given to setBlockType should be a textblock");
  let r = t.steps.length;
  t.doc.nodesBetween(e, A, (i, o) => {
    let a = typeof s == "function" ? s(i) : s;
    if (i.isTextblock && !i.hasMarkup(n, a) && FS(t.doc, t.mapping.slice(r).map(o), n)) {
      let c = null;
      if (n.schema.linebreakReplacement) {
        let h = n.whitespace == "pre", u = !!n.contentMatch.matchType(n.schema.linebreakReplacement);
        h && !u ? c = !1 : !h && u && (c = !0);
      }
      c === !1 && n4(t, i, o, r), kM(t, t.mapping.slice(r).map(o, 1), n, void 0, c === null);
      let l = t.mapping.slice(r), B = l.map(o, 1), g = l.map(o + i.nodeSize, 1);
      return t.step(new vA(B, g, B + 1, g - 1, new Ee(re.from(n.create(a, null, i.marks)), 0, 0), 1, !0)), c === !0 && A4(t, i, o, r), !1;
    }
  });
}
function A4(t, e, A, n) {
  e.forEach((s, r) => {
    if (s.isText) {
      let i, o = /\r?\n|\r/g;
      for (; i = o.exec(s.text); ) {
        let a = t.mapping.slice(n).map(A + 1 + r + i.index);
        t.replaceWith(a, a + 1, e.type.schema.linebreakReplacement.create());
      }
    }
  });
}
function n4(t, e, A, n) {
  e.forEach((s, r) => {
    if (s.type == s.type.schema.linebreakReplacement) {
      let i = t.mapping.slice(n).map(A + 1 + r);
      t.replaceWith(i, i + 1, e.type.schema.text(`
`));
    }
  });
}
function FS(t, e, A) {
  let n = t.resolve(e), s = n.index();
  return n.parent.canReplaceWith(s, s + 1, A);
}
function NS(t, e, A, n, s) {
  let r = t.doc.nodeAt(e);
  if (!r)
    throw new RangeError("No node at given position");
  A || (A = r.type);
  let i = A.create(n, null, s || r.marks);
  if (r.isLeaf)
    return t.replaceWith(e, e + r.nodeSize, i);
  if (!A.validContent(r.content))
    throw new RangeError("Invalid content for node type " + A.name);
  t.step(new vA(e, e + r.nodeSize, e + 1, e + r.nodeSize - 1, new Ee(re.from(i), 0, 0), 1, !0));
}
function Gi(t, e, A = 1, n) {
  let s = t.resolve(e), r = s.depth - A, i = n && n[n.length - 1] || s.parent;
  if (r < 0 || s.parent.type.spec.isolating || !s.parent.canReplace(s.index(), s.parent.childCount) || !i.type.validContent(s.parent.content.cutByIndex(s.index(), s.parent.childCount)))
    return !1;
  for (let c = s.depth - 1, l = A - 2; c > r; c--, l--) {
    let B = s.node(c), g = s.index(c);
    if (B.type.spec.isolating)
      return !1;
    let h = B.content.cutByIndex(g, B.childCount), u = n && n[l + 1];
    u && (h = h.replaceChild(0, u.type.create(u.attrs)));
    let d = n && n[l] || B;
    if (!B.canReplace(g + 1, B.childCount) || !d.type.validContent(h))
      return !1;
  }
  let o = s.indexAfter(r), a = n && n[0];
  return s.node(r).canReplaceWith(o, o, a ? a.type : s.node(r + 1).type);
}
function DS(t, e, A = 1, n) {
  let s = t.doc.resolve(e), r = re.empty, i = re.empty;
  for (let o = s.depth, a = s.depth - A, c = A - 1; o > a; o--, c--) {
    r = re.from(s.node(o).copy(r));
    let l = n && n[c];
    i = re.from(l ? l.type.create(l.attrs, i) : s.node(o).copy(i));
  }
  t.step(new GA(e, e, new Ee(r.append(i), A, A), !0));
}
function oa(t, e) {
  let A = t.resolve(e), n = A.index();
  return s4(A.nodeBefore, A.nodeAfter) && A.parent.canReplace(n, n + 1);
}
function xS(t, e) {
  e.content.size || t.type.compatibleContent(e.type);
  let A = t.contentMatchAt(t.childCount), { linebreakReplacement: n } = t.type.schema;
  for (let s = 0; s < e.childCount; s++) {
    let r = e.child(s), i = r.type == n ? t.type.schema.nodes.text : r.type;
    if (A = A.matchType(i), !A || !t.type.allowsMarks(r.marks))
      return !1;
  }
  return A.validEnd;
}
function s4(t, e) {
  return !!(t && e && !t.isLeaf && xS(t, e));
}
function pw(t, e, A = -1) {
  let n = t.resolve(e);
  for (let s = n.depth; ; s--) {
    let r, i, o = n.index(s);
    if (s == n.depth ? (r = n.nodeBefore, i = n.nodeAfter) : A > 0 ? (r = n.node(s + 1), o++, i = n.node(s).maybeChild(o)) : (r = n.node(s).maybeChild(o - 1), i = n.node(s + 1)), r && !r.isTextblock && s4(r, i) && n.node(s).canReplace(o, o + 1))
      return e;
    if (s == 0)
      break;
    e = A < 0 ? n.before(s) : n.after(s);
  }
}
function GS(t, e, A) {
  let n = null, { linebreakReplacement: s } = t.doc.type.schema, r = t.doc.resolve(e - A), i = r.node().type;
  if (s && i.inlineContent) {
    let l = i.whitespace == "pre", B = !!i.contentMatch.matchType(s);
    l && !B ? n = !1 : !l && B && (n = !0);
  }
  let o = t.steps.length;
  if (n === !1) {
    let l = t.doc.resolve(e + A);
    n4(t, l.node(), l.before(), o);
  }
  i.inlineContent && kM(t, e + A - 1, i, r.node().contentMatchAt(r.index()), n == null);
  let a = t.mapping.slice(o), c = a.map(e - A);
  if (t.step(new GA(c, a.map(e + A, -1), Ee.empty, !0)), n === !0) {
    let l = t.doc.resolve(c);
    A4(t, l.node(), l.before(), t.steps.length);
  }
  return t;
}
function zS(t, e, A) {
  let n = t.resolve(e);
  if (n.parent.canReplaceWith(n.index(), n.index(), A))
    return e;
  if (n.parentOffset == 0)
    for (let s = n.depth - 1; s >= 0; s--) {
      let r = n.index(s);
      if (n.node(s).canReplaceWith(r, r, A))
        return n.before(s + 1);
      if (r > 0)
        return null;
    }
  if (n.parentOffset == n.parent.content.size)
    for (let s = n.depth - 1; s >= 0; s--) {
      let r = n.indexAfter(s);
      if (n.node(s).canReplaceWith(r, r, A))
        return n.after(s + 1);
      if (r < n.node(s).childCount)
        return null;
    }
  return null;
}
function r4(t, e, A) {
  let n = t.resolve(e);
  if (!A.content.size)
    return e;
  let s = A.content;
  for (let r = 0; r < A.openStart; r++)
    s = s.firstChild.content;
  for (let r = 1; r <= (A.openStart == 0 && A.size ? 2 : 1); r++)
    for (let i = n.depth; i >= 0; i--) {
      let o = i == n.depth ? 0 : n.pos <= (n.start(i + 1) + n.end(i + 1)) / 2 ? -1 : 1, a = n.index(i) + (o > 0 ? 1 : 0), c = n.node(i), l = !1;
      if (r == 1)
        l = c.canReplace(a, a, s);
      else {
        let B = c.contentMatchAt(a).findWrapping(s.firstChild.type);
        l = B && c.canReplaceWith(a, a, B[0]);
      }
      if (l)
        return o == 0 ? n.pos : o < 0 ? n.before(i + 1) : n.after(i + 1);
    }
  return null;
}
function mw(t, e, A = e, n = Ee.empty) {
  if (e == A && !n.size)
    return null;
  let s = t.resolve(e), r = t.resolve(A);
  return i4(s, r, n) ? new GA(e, A, n) : new US(s, r, n).fit();
}
function i4(t, e, A) {
  return !A.openStart && !A.openEnd && t.start() == e.start() && t.parent.canReplace(t.index(), e.index(), A.content);
}
class US {
  constructor(e, A, n) {
    this.$from = e, this.$to = A, this.unplaced = n, this.frontier = [], this.placed = re.empty;
    for (let s = 0; s <= e.depth; s++) {
      let r = e.node(s);
      this.frontier.push({
        type: r.type,
        match: r.contentMatchAt(e.indexAfter(s))
      });
    }
    for (let s = e.depth; s > 0; s--)
      this.placed = re.from(e.node(s).copy(this.placed));
  }
  get depth() {
    return this.frontier.length - 1;
  }
  fit() {
    for (; this.unplaced.size; ) {
      let c = this.findFittable();
      c ? this.placeNodes(c) : this.openMore() || this.dropNode();
    }
    let e = this.mustMoveInline(), A = this.placed.size - this.depth - this.$from.depth, n = this.$from, s = this.close(e < 0 ? this.$to : n.doc.resolve(e));
    if (!s)
      return null;
    let r = this.placed, i = n.depth, o = s.depth;
    for (; i && o && r.childCount == 1; )
      r = r.firstChild.content, i--, o--;
    let a = new Ee(r, i, o);
    return e > -1 ? new vA(n.pos, e, this.$to.pos, this.$to.end(), a, A) : a.size || n.pos != this.$to.pos ? new GA(n.pos, s.pos, a) : null;
  }
  // Find a position on the start spine of `this.unplaced` that has
  // content that can be moved somewhere on the frontier. Returns two
  // depths, one for the slice and one for the frontier.
  findFittable() {
    let e = this.unplaced.openStart;
    for (let A = this.unplaced.content, n = 0, s = this.unplaced.openEnd; n < e; n++) {
      let r = A.firstChild;
      if (A.childCount > 1 && (s = 0), r.type.spec.isolating && s <= n) {
        e = n;
        break;
      }
      A = r.content;
    }
    for (let A = 1; A <= 2; A++)
      for (let n = A == 1 ? e : this.unplaced.openStart; n >= 0; n--) {
        let s, r = null;
        n ? (r = QQ(this.unplaced.content, n - 1).firstChild, s = r.content) : s = this.unplaced.content;
        let i = s.firstChild;
        for (let o = this.depth; o >= 0; o--) {
          let { type: a, match: c } = this.frontier[o], l, B = null;
          if (A == 1 && (i ? c.matchType(i.type) || (B = c.fillBefore(re.from(i), !1)) : r && a.compatibleContent(r.type)))
            return { sliceDepth: n, frontierDepth: o, parent: r, inject: B };
          if (A == 2 && i && (l = c.findWrapping(i.type)))
            return { sliceDepth: n, frontierDepth: o, parent: r, wrap: l };
          if (r && c.matchType(r.type))
            break;
        }
      }
  }
  openMore() {
    let { content: e, openStart: A, openEnd: n } = this.unplaced, s = QQ(e, A);
    return !s.childCount || s.firstChild.isLeaf ? !1 : (this.unplaced = new Ee(e, A + 1, Math.max(n, s.size + A >= e.size - n ? A + 1 : 0)), !0);
  }
  dropNode() {
    let { content: e, openStart: A, openEnd: n } = this.unplaced, s = QQ(e, A);
    if (s.childCount <= 1 && A > 0) {
      let r = e.size - A <= A + s.size;
      this.unplaced = new Ee(CB(e, A - 1, 1), A - 1, r ? A - 1 : n);
    } else
      this.unplaced = new Ee(CB(e, A, 1), A, n);
  }
  // Move content from the unplaced slice at `sliceDepth` to the
  // frontier node at `frontierDepth`. Close that frontier node when
  // applicable.
  placeNodes({ sliceDepth: e, frontierDepth: A, parent: n, inject: s, wrap: r }) {
    for (; this.depth > A; )
      this.closeFrontierNode();
    if (r)
      for (let d = 0; d < r.length; d++)
        this.openFrontierNode(r[d]);
    let i = this.unplaced, o = n ? n.content : i.content, a = i.openStart - e, c = 0, l = [], { match: B, type: g } = this.frontier[A];
    if (s) {
      for (let d = 0; d < s.childCount; d++)
        l.push(s.child(d));
      B = B.matchFragment(s);
    }
    let h = o.size + e - (i.content.size - i.openEnd);
    for (; c < o.childCount; ) {
      let d = o.child(c), w = B.matchType(d.type);
      if (!w)
        break;
      c++, (c > 1 || a == 0 || d.content.size) && (B = w, l.push(o4(d.mark(g.allowedMarks(d.marks)), c == 1 ? a : 0, c == o.childCount ? h : -1)));
    }
    let u = c == o.childCount;
    u || (h = -1), this.placed = EB(this.placed, A, re.from(l)), this.frontier[A].match = B, u && h < 0 && n && n.type == this.frontier[this.depth].type && this.frontier.length > 1 && this.closeFrontierNode();
    for (let d = 0, w = o; d < h; d++) {
      let Q = w.lastChild;
      this.frontier.push({ type: Q.type, match: Q.contentMatchAt(Q.childCount) }), w = Q.content;
    }
    this.unplaced = u ? e == 0 ? Ee.empty : new Ee(CB(i.content, e - 1, 1), e - 1, h < 0 ? i.openEnd : e - 1) : new Ee(CB(i.content, e, c), i.openStart, i.openEnd);
  }
  mustMoveInline() {
    if (!this.$to.parent.isTextblock)
      return -1;
    let e = this.frontier[this.depth], A;
    if (!e.type.isTextblock || !IQ(this.$to, this.$to.depth, e.type, e.match, !1) || this.$to.depth == this.depth && (A = this.findCloseLevel(this.$to)) && A.depth == this.depth)
      return -1;
    let { depth: n } = this.$to, s = this.$to.after(n);
    for (; n > 1 && s == this.$to.end(--n); )
      ++s;
    return s;
  }
  findCloseLevel(e) {
    e: for (let A = Math.min(this.depth, e.depth); A >= 0; A--) {
      let { match: n, type: s } = this.frontier[A], r = A < e.depth && e.end(A + 1) == e.pos + (e.depth - (A + 1)), i = IQ(e, A, s, n, r);
      if (i) {
        for (let o = A - 1; o >= 0; o--) {
          let { match: a, type: c } = this.frontier[o], l = IQ(e, o, c, a, !0);
          if (!l || l.childCount)
            continue e;
        }
        return { depth: A, fit: i, move: r ? e.doc.resolve(e.after(A + 1)) : e };
      }
    }
  }
  close(e) {
    let A = this.findCloseLevel(e);
    if (!A)
      return null;
    for (; this.depth > A.depth; )
      this.closeFrontierNode();
    A.fit.childCount && (this.placed = EB(this.placed, A.depth, A.fit)), e = A.move;
    for (let n = A.depth + 1; n <= e.depth; n++) {
      let s = e.node(n), r = s.type.contentMatch.fillBefore(s.content, !0, e.index(n));
      this.openFrontierNode(s.type, s.attrs, r);
    }
    return e;
  }
  openFrontierNode(e, A = null, n) {
    let s = this.frontier[this.depth];
    s.match = s.match.matchType(e), this.placed = EB(this.placed, this.depth, re.from(e.create(A, n))), this.frontier.push({ type: e, match: e.contentMatch });
  }
  closeFrontierNode() {
    let A = this.frontier.pop().match.fillBefore(re.empty, !0);
    A.childCount && (this.placed = EB(this.placed, this.frontier.length, A));
  }
}
function CB(t, e, A) {
  return e == 0 ? t.cutByIndex(A, t.childCount) : t.replaceChild(0, t.firstChild.copy(CB(t.firstChild.content, e - 1, A)));
}
function EB(t, e, A) {
  return e == 0 ? t.append(A) : t.replaceChild(t.childCount - 1, t.lastChild.copy(EB(t.lastChild.content, e - 1, A)));
}
function QQ(t, e) {
  for (let A = 0; A < e; A++)
    t = t.firstChild.content;
  return t;
}
function o4(t, e, A) {
  if (e <= 0)
    return t;
  let n = t.content;
  return e > 1 && (n = n.replaceChild(0, o4(n.firstChild, e - 1, n.childCount == 1 ? A - 1 : 0))), e > 0 && (n = t.type.contentMatch.fillBefore(n).append(n), A <= 0 && (n = n.append(t.type.contentMatch.matchFragment(n).fillBefore(re.empty, !0)))), t.copy(n);
}
function IQ(t, e, A, n, s) {
  let r = t.node(e), i = s ? t.indexAfter(e) : t.index(e);
  if (i == r.childCount && !A.compatibleContent(r.type))
    return null;
  let o = n.fillBefore(r.content, !0, i);
  return o && !bS(A, r.content, i) ? o : null;
}
function bS(t, e, A) {
  for (let n = A; n < e.childCount; n++)
    if (!t.allowsMarks(e.child(n).marks))
      return !0;
  return !1;
}
function vS(t) {
  return t.spec.defining || t.spec.definingForContent;
}
function jS(t, e, A, n) {
  if (!n.size)
    return t.deleteRange(e, A);
  let s = t.doc.resolve(e), r = t.doc.resolve(A);
  if (i4(s, r, n))
    return t.step(new GA(e, A, n));
  let i = c4(s, r);
  i[i.length - 1] == 0 && i.pop();
  let o = -(s.depth + 1);
  i.unshift(o);
  for (let g = s.depth, h = s.pos - 1; g > 0; g--, h--) {
    let u = s.node(g).type.spec;
    if (u.defining || u.definingAsContext || u.isolating)
      break;
    i.indexOf(g) > -1 ? o = g : s.before(g) == h && i.splice(1, 0, -g);
  }
  let a = i.indexOf(o), c = [], l = n.openStart;
  for (let g = n.content, h = 0; ; h++) {
    let u = g.firstChild;
    if (c.push(u), h == n.openStart)
      break;
    g = u.content;
  }
  for (let g = l - 1; g >= 0; g--) {
    let h = c[g], u = vS(h.type);
    if (u && !h.sameMarkup(s.node(Math.abs(o) - 1)))
      l = g;
    else if (u || !h.type.isTextblock)
      break;
  }
  for (let g = n.openStart; g >= 0; g--) {
    let h = (g + l + 1) % (n.openStart + 1), u = c[h];
    if (u)
      for (let d = 0; d < i.length; d++) {
        let w = i[(d + a) % i.length], Q = !0;
        w < 0 && (Q = !1, w = -w);
        let p = s.node(w - 1), M = s.index(w - 1);
        if (p.canReplaceWith(M, M, u.type, u.marks))
          return t.replace(s.before(w), Q ? r.after(w) : A, new Ee(a4(n.content, 0, n.openStart, h), h, n.openEnd));
      }
  }
  let B = t.steps.length;
  for (let g = i.length - 1; g >= 0 && (t.replace(e, A, n), !(t.steps.length > B)); g--) {
    let h = i[g];
    h < 0 || (e = s.before(h), A = r.after(h));
  }
}
function a4(t, e, A, n, s) {
  if (e < A) {
    let r = t.firstChild;
    t = t.replaceChild(0, r.copy(a4(r.content, e + 1, A, n, r)));
  }
  if (e > n) {
    let r = s.contentMatchAt(0), i = r.fillBefore(t).append(t);
    t = i.append(r.matchFragment(i).fillBefore(re.empty, !0));
  }
  return t;
}
function HS(t, e, A, n) {
  if (!n.isInline && e == A && t.doc.resolve(e).parent.content.size) {
    let s = zS(t.doc, e, n.type);
    s != null && (e = A = s);
  }
  t.replaceRange(e, A, new Ee(re.from(n), 0, 0));
}
function kS(t, e, A) {
  let n = t.doc.resolve(e), s = t.doc.resolve(A), r = c4(n, s);
  for (let i = 0; i < r.length; i++) {
    let o = r[i], a = i == r.length - 1;
    if (a && o == 0 || n.node(o).type.contentMatch.validEnd)
      return t.delete(n.start(o), s.end(o));
    if (o > 0 && (a || n.node(o - 1).canReplace(n.index(o - 1), s.indexAfter(o - 1))))
      return t.delete(n.before(o), s.after(o));
  }
  for (let i = 1; i <= n.depth && i <= s.depth; i++)
    if (e - n.start(i) == n.depth - i && A > n.end(i) && s.end(i) - A != s.depth - i && n.start(i - 1) == s.start(i - 1) && n.node(i - 1).canReplace(n.index(i - 1), s.index(i - 1)))
      return t.delete(n.before(i), A);
  t.delete(e, A);
}
function c4(t, e) {
  let A = [], n = Math.min(t.depth, e.depth);
  for (let s = n; s >= 0; s--) {
    let r = t.start(s);
    if (r < t.pos - (t.depth - s) || e.end(s) > e.pos + (e.depth - s) || t.node(s).type.spec.isolating || e.node(s).type.spec.isolating)
      break;
    (r == e.start(s) || s == t.depth && s == e.depth && t.parent.inlineContent && e.parent.inlineContent && s && e.start(s - 1) == r - 1) && A.push(s);
  }
  return A;
}
class rl extends Bn {
  /**
  Construct an attribute step.
  */
  constructor(e, A, n) {
    super(), this.pos = e, this.attr = A, this.value = n;
  }
  apply(e) {
    let A = e.nodeAt(this.pos);
    if (!A)
      return EA.fail("No node at attribute step's position");
    let n = /* @__PURE__ */ Object.create(null);
    for (let r in A.attrs)
      n[r] = A.attrs[r];
    n[this.attr] = this.value;
    let s = A.type.create(n, null, A.marks);
    return EA.fromReplace(e, this.pos, this.pos + 1, new Ee(re.from(s), 0, A.isLeaf ? 0 : 1));
  }
  getMap() {
    return cs.empty;
  }
  invert(e) {
    return new rl(this.pos, this.attr, e.nodeAt(this.pos).attrs[this.attr]);
  }
  map(e) {
    let A = e.mapResult(this.pos, 1);
    return A.deletedAfter ? null : new rl(A.pos, this.attr, this.value);
  }
  toJSON() {
    return { stepType: "attr", pos: this.pos, attr: this.attr, value: this.value };
  }
  static fromJSON(e, A) {
    if (typeof A.pos != "number" || typeof A.attr != "string")
      throw new RangeError("Invalid input for AttrStep.fromJSON");
    return new rl(A.pos, A.attr, A.value);
  }
}
Bn.jsonID("attr", rl);
class mg extends Bn {
  /**
  Construct an attribute step.
  */
  constructor(e, A) {
    super(), this.attr = e, this.value = A;
  }
  apply(e) {
    let A = /* @__PURE__ */ Object.create(null);
    for (let s in e.attrs)
      A[s] = e.attrs[s];
    A[this.attr] = this.value;
    let n = e.type.create(A, e.content, e.marks);
    return EA.ok(n);
  }
  getMap() {
    return cs.empty;
  }
  invert(e) {
    return new mg(this.attr, e.attrs[this.attr]);
  }
  map(e) {
    return this;
  }
  toJSON() {
    return { stepType: "docAttr", attr: this.attr, value: this.value };
  }
  static fromJSON(e, A) {
    if (typeof A.attr != "string")
      throw new RangeError("Invalid input for DocAttrStep.fromJSON");
    return new mg(A.attr, A.value);
  }
}
Bn.jsonID("docAttr", mg);
let Il = class extends Error {
};
Il = function t(e) {
  let A = Error.call(this, e);
  return A.__proto__ = t.prototype, A;
};
Il.prototype = Object.create(Error.prototype);
Il.prototype.constructor = Il;
Il.prototype.name = "TransformError";
class RM {
  /**
  Create a transform that starts with the given document.
  */
  constructor(e) {
    this.doc = e, this.steps = [], this.docs = [], this.mapping = new pg();
  }
  /**
  The starting document.
  */
  get before() {
    return this.docs.length ? this.docs[0] : this.doc;
  }
  /**
  Apply a new step in this transform, saving the result. Throws an
  error when the step fails.
  */
  step(e) {
    let A = this.maybeStep(e);
    if (A.failed)
      throw new Il(A.failed);
    return this;
  }
  /**
  Try to apply a step in this transformation, ignoring it if it
  fails. Returns the step result.
  */
  maybeStep(e) {
    let A = e.apply(this.doc);
    return A.failed || this.addStep(e, A.doc), A;
  }
  /**
  True when the document has been changed (when there are any
  steps).
  */
  get docChanged() {
    return this.steps.length > 0;
  }
  /**
  Return a single range, in post-transform document positions,
  that covers all content changed by this transform. Returns null
  if no replacements are made. Note that this will ignore changes
  that add/remove marks without replacing the underlying content.
  */
  changedRange() {
    let e = 1e9, A = -1e9;
    for (let n = 0; n < this.mapping.maps.length; n++) {
      let s = this.mapping.maps[n];
      n && (e = s.map(e, 1), A = s.map(A, -1)), s.forEach((r, i, o, a) => {
        e = Math.min(e, o), A = Math.max(A, a);
      });
    }
    return e == 1e9 ? null : { from: e, to: A };
  }
  /**
  @internal
  */
  addStep(e, A) {
    this.docs.push(this.doc), this.steps.push(e), this.mapping.appendMap(e.getMap()), this.doc = A;
  }
  /**
  Replace the part of the document between `from` and `to` with the
  given `slice`.
  */
  replace(e, A = e, n = Ee.empty) {
    let s = mw(this.doc, e, A, n);
    return s && this.step(s), this;
  }
  /**
  Replace the given range with the given content, which may be a
  fragment, node, or array of nodes.
  */
  replaceWith(e, A, n) {
    return this.replace(e, A, new Ee(re.from(n), 0, 0));
  }
  /**
  Delete the content between the given positions.
  */
  delete(e, A) {
    return this.replace(e, A, Ee.empty);
  }
  /**
  Insert the given content at the given position.
  */
  insert(e, A) {
    return this.replaceWith(e, e, A);
  }
  /**
  Replace a range of the document with a given slice, using
  `from`, `to`, and the slice's
  [`openStart`](https://prosemirror.net/docs/ref/#model.Slice.openStart) property as hints, rather
  than fixed start and end points. This method may grow the
  replaced area or close open nodes in the slice in order to get a
  fit that is more in line with WYSIWYG expectations, by dropping
  fully covered parent nodes of the replaced region when they are
  marked [non-defining as
  context](https://prosemirror.net/docs/ref/#model.NodeSpec.definingAsContext), or including an
  open parent node from the slice that _is_ marked as [defining
  its content](https://prosemirror.net/docs/ref/#model.NodeSpec.definingForContent).
  
  This is the method, for example, to handle paste. The similar
  [`replace`](https://prosemirror.net/docs/ref/#transform.Transform.replace) method is a more
  primitive tool which will _not_ move the start and end of its given
  range, and is useful in situations where you need more precise
  control over what happens.
  */
  replaceRange(e, A, n) {
    return jS(this, e, A, n), this;
  }
  /**
  Replace the given range with a node, but use `from` and `to` as
  hints, rather than precise positions. When from and to are the same
  and are at the start or end of a parent node in which the given
  node doesn't fit, this method may _move_ them out towards a parent
  that does allow the given node to be placed. When the given range
  completely covers a parent node, this method may completely replace
  that parent node.
  */
  replaceRangeWith(e, A, n) {
    return HS(this, e, A, n), this;
  }
  /**
  Delete the given range, expanding it to cover fully covered
  parent nodes until a valid replace is found.
  */
  deleteRange(e, A) {
    return kS(this, e, A), this;
  }
  /**
  Split the content in the given range off from its parent, if there
  is sibling content before or after it, and move it up the tree to
  the depth specified by `target`. You'll probably want to use
  [`liftTarget`](https://prosemirror.net/docs/ref/#transform.liftTarget) to compute `target`, to make
  sure the lift is valid.
  */
  lift(e, A) {
    return MS(this, e, A), this;
  }
  /**
  Join the blocks around the given position. If depth is 2, their
  last and first siblings are also joined, and so on.
  */
  join(e, A = 1) {
    return GS(this, e, A), this;
  }
  /**
  Wrap the given [range](https://prosemirror.net/docs/ref/#model.NodeRange) in the given set of wrappers.
  The wrappers are assumed to be valid in this position, and should
  probably be computed with [`findWrapping`](https://prosemirror.net/docs/ref/#transform.findWrapping).
  */
  wrap(e, A) {
    return YS(this, e, A), this;
  }
  /**
  Set the type of all textblocks (partly) between `from` and `to` to
  the given node type with the given attributes.
  */
  setBlockType(e, A = e, n, s = null) {
    return yS(this, e, A, n, s), this;
  }
  /**
  Change the type, attributes, and/or marks of the node at `pos`.
  When `type` isn't given, the existing node type is preserved,
  */
  setNodeMarkup(e, A, n = null, s) {
    return NS(this, e, A, n, s), this;
  }
  /**
  Set a single attribute on a given node to a new value.
  The `pos` addresses the document content. Use `setDocAttribute`
  to set attributes on the document itself.
  */
  setNodeAttribute(e, A, n) {
    return this.step(new rl(e, A, n)), this;
  }
  /**
  Set a single attribute on the document to a new value.
  */
  setDocAttribute(e, A) {
    return this.step(new mg(e, A)), this;
  }
  /**
  Add a mark to the node at position `pos`.
  */
  addNodeMark(e, A) {
    return this.step(new bo(e, A)), this;
  }
  /**
  Remove a mark (or all marks of the given type) from the node at
  position `pos`.
  */
  removeNodeMark(e, A) {
    let n = this.doc.nodeAt(e);
    if (!n)
      throw new RangeError("No node at position " + e);
    if (A instanceof Lt)
      A.isInSet(n.marks) && this.step(new Xa(e, A));
    else {
      let s = n.marks, r, i = [];
      for (; r = A.isInSet(s); )
        i.push(new Xa(e, r)), s = r.removeFromSet(s);
      for (let o = i.length - 1; o >= 0; o--)
        this.step(i[o]);
    }
    return this;
  }
  /**
  Split the node at the given position, and optionally, if `depth` is
  greater than one, any number of nodes above that. By default, the
  parts split off will inherit the node type of the original node.
  This can be changed by passing an array of types and attributes to
  use after the split (with the outermost nodes coming first).
  */
  split(e, A = 1, n) {
    return DS(this, e, A, n), this;
  }
  /**
  Add the given mark to the inline content between `from` and `to`.
  */
  addMark(e, A, n) {
    return IS(this, e, A, n), this;
  }
  /**
  Remove marks from inline nodes between `from` and `to`. When
  `mark` is a single mark, remove precisely that mark. When it is
  a mark type, remove all marks of that type. When it is null,
  remove all marks of any type.
  */
  removeMark(e, A, n) {
    return CS(this, e, A, n), this;
  }
  /**
  Removes all marks and nodes from the content of the node at
  `pos` that don't match the given new parent node type. Accepts
  an optional starting [content match](https://prosemirror.net/docs/ref/#model.ContentMatch) as
  third argument.
  */
  clearIncompatible(e, A, n) {
    return kM(this, e, A, n), this;
  }
}
const CQ = /* @__PURE__ */ Object.create(null);
class Ke {
  /**
  Initialize a selection with the head and anchor and ranges. If no
  ranges are given, constructs a single range across `$anchor` and
  `$head`.
  */
  constructor(e, A, n) {
    this.$anchor = e, this.$head = A, this.ranges = n || [new LM(e.min(A), e.max(A))];
  }
  /**
  The selection's anchor, as an unresolved position.
  */
  get anchor() {
    return this.$anchor.pos;
  }
  /**
  The selection's head.
  */
  get head() {
    return this.$head.pos;
  }
  /**
  The lower bound of the selection's main range.
  */
  get from() {
    return this.$from.pos;
  }
  /**
  The upper bound of the selection's main range.
  */
  get to() {
    return this.$to.pos;
  }
  /**
  The resolved lower  bound of the selection's main range.
  */
  get $from() {
    return this.ranges[0].$from;
  }
  /**
  The resolved upper bound of the selection's main range.
  */
  get $to() {
    return this.ranges[0].$to;
  }
  /**
  Indicates whether the selection contains any content.
  */
  get empty() {
    let e = this.ranges;
    for (let A = 0; A < e.length; A++)
      if (e[A].$from.pos != e[A].$to.pos)
        return !1;
    return !0;
  }
  /**
  Get the content of this selection as a slice.
  */
  content() {
    return this.$from.doc.slice(this.from, this.to, !0);
  }
  /**
  Replace the selection with a slice or, if no slice is given,
  delete the selection. Will append to the given transaction.
  */
  replace(e, A = Ee.empty) {
    let n = A.content.lastChild, s = null;
    for (let o = 0; o < A.openEnd; o++)
      s = n, n = n.lastChild;
    let r = e.steps.length, i = this.ranges;
    for (let o = 0; o < i.length; o++) {
      let { $from: a, $to: c } = i[o], l = e.mapping.slice(r);
      e.replaceRange(l.map(a.pos), l.map(c.pos), o ? Ee.empty : A), o == 0 && sy(e, r, (n ? n.isInline : s && s.isTextblock) ? -1 : 1);
    }
  }
  /**
  Replace the selection with the given node, appending the changes
  to the given transaction.
  */
  replaceWith(e, A) {
    let n = e.steps.length, s = this.ranges;
    for (let r = 0; r < s.length; r++) {
      let { $from: i, $to: o } = s[r], a = e.mapping.slice(n), c = a.map(i.pos), l = a.map(o.pos);
      r ? e.deleteRange(c, l) : (e.replaceRangeWith(c, l, A), sy(e, n, A.isInline ? -1 : 1));
    }
  }
  /**
  Find a valid cursor or leaf node selection starting at the given
  position and searching back if `dir` is negative, and forward if
  positive. When `textOnly` is true, only consider cursor
  selections. Will return null when no valid selection position is
  found.
  */
  static findFrom(e, A, n = !1) {
    let s = e.parent.inlineContent ? new Re(e) : Sc(e.node(0), e.parent, e.pos, e.index(), A, n);
    if (s)
      return s;
    for (let r = e.depth - 1; r >= 0; r--) {
      let i = A < 0 ? Sc(e.node(0), e.node(r), e.before(r + 1), e.index(r), A, n) : Sc(e.node(0), e.node(r), e.after(r + 1), e.index(r) + 1, A, n);
      if (i)
        return i;
    }
    return null;
  }
  /**
  Find a valid cursor or leaf node selection near the given
  position. Searches forward first by default, but if `bias` is
  negative, it will search backwards first.
  */
  static near(e, A = 1) {
    return this.findFrom(e, A) || this.findFrom(e, -A) || new Xn(e.node(0));
  }
  /**
  Find the cursor or leaf node selection closest to the start of
  the given document. Will return an
  [`AllSelection`](https://prosemirror.net/docs/ref/#state.AllSelection) if no valid position
  exists.
  */
  static atStart(e) {
    return Sc(e, e, 0, 0, 1) || new Xn(e);
  }
  /**
  Find the cursor or leaf node selection closest to the end of the
  given document.
  */
  static atEnd(e) {
    return Sc(e, e, e.content.size, e.childCount, -1) || new Xn(e);
  }
  /**
  Deserialize the JSON representation of a selection. Must be
  implemented for custom classes (as a static class method).
  */
  static fromJSON(e, A) {
    if (!A || !A.type)
      throw new RangeError("Invalid input for Selection.fromJSON");
    let n = CQ[A.type];
    if (!n)
      throw new RangeError(`No selection type ${A.type} defined`);
    return n.fromJSON(e, A);
  }
  /**
  To be able to deserialize selections from JSON, custom selection
  classes must register themselves with an ID string, so that they
  can be disambiguated. Try to pick something that's unlikely to
  clash with classes from other modules.
  */
  static jsonID(e, A) {
    if (e in CQ)
      throw new RangeError("Duplicate use of selection JSON ID " + e);
    return CQ[e] = A, A.prototype.jsonID = e, A;
  }
  /**
  Get a [bookmark](https://prosemirror.net/docs/ref/#state.SelectionBookmark) for this selection,
  which is a value that can be mapped without having access to a
  current document, and later resolved to a real selection for a
  given document again. (This is used mostly by the history to
  track and restore old selections.) The default implementation of
  this method just converts the selection to a text selection and
  returns the bookmark for that.
  */
  getBookmark() {
    return Re.between(this.$anchor, this.$head).getBookmark();
  }
}
Ke.prototype.visible = !0;
class LM {
  /**
  Create a range.
  */
  constructor(e, A) {
    this.$from = e, this.$to = A;
  }
}
let Ay = !1;
function ny(t) {
  !Ay && !t.parent.inlineContent && (Ay = !0, console.warn("TextSelection endpoint not pointing into a node with inline content (" + t.parent.type.name + ")"));
}
class Re extends Ke {
  /**
  Construct a text selection between the given points.
  */
  constructor(e, A = e) {
    ny(e), ny(A), super(e, A);
  }
  /**
  Returns a resolved position if this is a cursor selection (an
  empty text selection), and null otherwise.
  */
  get $cursor() {
    return this.$anchor.pos == this.$head.pos ? this.$head : null;
  }
  map(e, A) {
    let n = e.resolve(A.map(this.head));
    if (!n.parent.inlineContent)
      return Ke.near(n);
    let s = e.resolve(A.map(this.anchor));
    return new Re(s.parent.inlineContent ? s : n, n);
  }
  replace(e, A = Ee.empty) {
    if (super.replace(e, A), A == Ee.empty) {
      let n = this.$from.marksAcross(this.$to);
      n && e.ensureMarks(n);
    }
  }
  eq(e) {
    return e instanceof Re && e.anchor == this.anchor && e.head == this.head;
  }
  getBookmark() {
    return new Yw(this.anchor, this.head);
  }
  toJSON() {
    return { type: "text", anchor: this.anchor, head: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.anchor != "number" || typeof A.head != "number")
      throw new RangeError("Invalid input for TextSelection.fromJSON");
    return new Re(e.resolve(A.anchor), e.resolve(A.head));
  }
  /**
  Create a text selection from non-resolved positions.
  */
  static create(e, A, n = A) {
    let s = e.resolve(A);
    return new this(s, n == A ? s : e.resolve(n));
  }
  /**
  Return a text selection that spans the given positions or, if
  they aren't text positions, find a text selection near them.
  `bias` determines whether the method searches forward (default)
  or backwards (negative number) first. Will fall back to calling
  [`Selection.near`](https://prosemirror.net/docs/ref/#state.Selection^near) when the document
  doesn't contain a valid text position.
  */
  static between(e, A, n) {
    let s = e.pos - A.pos;
    if ((!n || s) && (n = s >= 0 ? 1 : -1), !A.parent.inlineContent) {
      let r = Ke.findFrom(A, n, !0) || Ke.findFrom(A, -n, !0);
      if (r)
        A = r.$head;
      else
        return Ke.near(A, n);
    }
    return e.parent.inlineContent || (s == 0 ? e = A : (e = (Ke.findFrom(e, -n, !0) || Ke.findFrom(e, n, !0)).$anchor, e.pos < A.pos != s < 0 && (e = A))), new Re(e, A);
  }
}
Ke.jsonID("text", Re);
class Yw {
  constructor(e, A) {
    this.anchor = e, this.head = A;
  }
  map(e) {
    return new Yw(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    return Re.between(e.resolve(this.anchor), e.resolve(this.head));
  }
}
class Ue extends Ke {
  /**
  Create a node selection. Does not verify the validity of its
  argument.
  */
  constructor(e) {
    let A = e.nodeAfter, n = e.node(0).resolve(e.pos + A.nodeSize);
    super(e, n), this.node = A;
  }
  map(e, A) {
    let { deleted: n, pos: s } = A.mapResult(this.anchor), r = e.resolve(s);
    return n ? Ke.near(r) : new Ue(r);
  }
  content() {
    return new Ee(re.from(this.node), 0, 0);
  }
  eq(e) {
    return e instanceof Ue && e.anchor == this.anchor;
  }
  toJSON() {
    return { type: "node", anchor: this.anchor };
  }
  getBookmark() {
    return new SM(this.anchor);
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.anchor != "number")
      throw new RangeError("Invalid input for NodeSelection.fromJSON");
    return new Ue(e.resolve(A.anchor));
  }
  /**
  Create a node selection from non-resolved positions.
  */
  static create(e, A) {
    return new Ue(e.resolve(A));
  }
  /**
  Determines whether the given node may be selected as a node
  selection.
  */
  static isSelectable(e) {
    return !e.isText && e.type.spec.selectable !== !1;
  }
}
Ue.prototype.visible = !1;
Ke.jsonID("node", Ue);
class SM {
  constructor(e) {
    this.anchor = e;
  }
  map(e) {
    let { deleted: A, pos: n } = e.mapResult(this.anchor);
    return A ? new Yw(n, n) : new SM(n);
  }
  resolve(e) {
    let A = e.resolve(this.anchor), n = A.nodeAfter;
    return n && Ue.isSelectable(n) ? new Ue(A) : Ke.near(A);
  }
}
class Xn extends Ke {
  /**
  Create an all-selection over the given document.
  */
  constructor(e) {
    super(e.resolve(0), e.resolve(e.content.size));
  }
  replace(e, A = Ee.empty) {
    if (A == Ee.empty) {
      e.delete(0, e.doc.content.size);
      let n = Ke.atStart(e.doc);
      n.eq(e.selection) || e.setSelection(n);
    } else
      super.replace(e, A);
  }
  toJSON() {
    return { type: "all" };
  }
  /**
  @internal
  */
  static fromJSON(e) {
    return new Xn(e);
  }
  map(e) {
    return new Xn(e);
  }
  eq(e) {
    return e instanceof Xn;
  }
  getBookmark() {
    return RS;
  }
}
Ke.jsonID("all", Xn);
const RS = {
  map() {
    return this;
  },
  resolve(t) {
    return new Xn(t);
  }
};
function Sc(t, e, A, n, s, r = !1) {
  if (e.inlineContent)
    return Re.create(t, A);
  for (let i = n - (s > 0 ? 0 : 1); s > 0 ? i < e.childCount : i >= 0; i += s) {
    let o = e.child(i);
    if (o.isAtom) {
      if (!r && Ue.isSelectable(o))
        return Ue.create(t, A - (s < 0 ? o.nodeSize : 0));
    } else {
      let a = Sc(t, o, A + s, s < 0 ? o.childCount : 0, s, r);
      if (a)
        return a;
    }
    A += o.nodeSize * s;
  }
  return null;
}
function sy(t, e, A) {
  let n = t.steps.length - 1;
  if (n < e)
    return;
  let s = t.steps[n];
  if (!(s instanceof GA || s instanceof vA))
    return;
  let r = t.mapping.maps[n], i;
  r.forEach((o, a, c, l) => {
    i == null && (i = l);
  }), t.setSelection(Ke.near(t.doc.resolve(i), A));
}
const ry = 1, n0 = 2, iy = 4;
let LS = class extends RM {
  /**
  @internal
  */
  constructor(e) {
    super(e.doc), this.curSelectionFor = 0, this.updated = 0, this.meta = /* @__PURE__ */ Object.create(null), this.time = Date.now(), this.curSelection = e.selection, this.storedMarks = e.storedMarks;
  }
  /**
  The transaction's current selection. This defaults to the editor
  selection [mapped](https://prosemirror.net/docs/ref/#state.Selection.map) through the steps in the
  transaction, but can be overwritten with
  [`setSelection`](https://prosemirror.net/docs/ref/#state.Transaction.setSelection).
  */
  get selection() {
    return this.curSelectionFor < this.steps.length && (this.curSelection = this.curSelection.map(this.doc, this.mapping.slice(this.curSelectionFor)), this.curSelectionFor = this.steps.length), this.curSelection;
  }
  /**
  Update the transaction's current selection. Will determine the
  selection that the editor gets when the transaction is applied.
  */
  setSelection(e) {
    if (e.$from.doc != this.doc)
      throw new RangeError("Selection passed to setSelection must point at the current document");
    return this.curSelection = e, this.curSelectionFor = this.steps.length, this.updated = (this.updated | ry) & ~n0, this.storedMarks = null, this;
  }
  /**
  Whether the selection was explicitly updated by this transaction.
  */
  get selectionSet() {
    return (this.updated & ry) > 0;
  }
  /**
  Set the current stored marks.
  */
  setStoredMarks(e) {
    return this.storedMarks = e, this.updated |= n0, this;
  }
  /**
  Make sure the current stored marks or, if that is null, the marks
  at the selection, match the given set of marks. Does nothing if
  this is already the case.
  */
  ensureMarks(e) {
    return Lt.sameSet(this.storedMarks || this.selection.$from.marks(), e) || this.setStoredMarks(e), this;
  }
  /**
  Add a mark to the set of stored marks.
  */
  addStoredMark(e) {
    return this.ensureMarks(e.addToSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Remove a mark or mark type from the set of stored marks.
  */
  removeStoredMark(e) {
    return this.ensureMarks(e.removeFromSet(this.storedMarks || this.selection.$head.marks()));
  }
  /**
  Whether the stored marks were explicitly set for this transaction.
  */
  get storedMarksSet() {
    return (this.updated & n0) > 0;
  }
  /**
  @internal
  */
  addStep(e, A) {
    super.addStep(e, A), this.updated = this.updated & ~n0, this.storedMarks = null;
  }
  /**
  Update the timestamp for the transaction.
  */
  setTime(e) {
    return this.time = e, this;
  }
  /**
  Replace the current selection with the given slice.
  */
  replaceSelection(e) {
    return this.selection.replace(this, e), this;
  }
  /**
  Replace the selection with the given node. When `inheritMarks` is
  true and the content is inline, it inherits the marks from the
  place where it is inserted.
  */
  replaceSelectionWith(e, A = !0) {
    let n = this.selection;
    return A && (e = e.mark(this.storedMarks || (n.empty ? n.$from.marks() : n.$from.marksAcross(n.$to) || Lt.none))), n.replaceWith(this, e), this;
  }
  /**
  Delete the selection.
  */
  deleteSelection() {
    return this.selection.replace(this), this;
  }
  /**
  Replace the given range, or the selection if no range is given,
  with a text node containing the given string.
  */
  insertText(e, A, n) {
    let s = this.doc.type.schema;
    if (A == null)
      return e ? this.replaceSelectionWith(s.text(e), !0) : this.deleteSelection();
    {
      if (n == null && (n = A), !e)
        return this.deleteRange(A, n);
      let r = this.storedMarks;
      if (!r) {
        let i = this.doc.resolve(A);
        r = n == A ? i.marks() : i.marksAcross(this.doc.resolve(n));
      }
      return this.replaceRangeWith(A, n, s.text(e, r)), !this.selection.empty && this.selection.to == A + e.length && this.setSelection(Ke.near(this.selection.$to)), this;
    }
  }
  /**
  Store a metadata property in this transaction, keyed either by
  name or by plugin.
  */
  setMeta(e, A) {
    return this.meta[typeof e == "string" ? e : e.key] = A, this;
  }
  /**
  Retrieve a metadata property for a given name or plugin.
  */
  getMeta(e) {
    return this.meta[typeof e == "string" ? e : e.key];
  }
  /**
  Returns true if this transaction doesn't contain any metadata,
  and can thus safely be extended.
  */
  get isGeneric() {
    for (let e in this.meta)
      return !1;
    return !0;
  }
  /**
  Indicate that the editor should scroll the selection into view
  when updated to the state produced by this transaction.
  */
  scrollIntoView() {
    return this.updated |= iy, this;
  }
  /**
  True when this transaction has had `scrollIntoView` called on it.
  */
  get scrolledIntoView() {
    return (this.updated & iy) > 0;
  }
};
function oy(t, e) {
  return !e || !t ? t : t.bind(e);
}
class MB {
  constructor(e, A, n) {
    this.name = e, this.init = oy(A.init, n), this.apply = oy(A.apply, n);
  }
}
const SS = [
  new MB("doc", {
    init(t) {
      return t.doc || t.schema.topNodeType.createAndFill();
    },
    apply(t) {
      return t.doc;
    }
  }),
  new MB("selection", {
    init(t, e) {
      return t.selection || Ke.atStart(e.doc);
    },
    apply(t) {
      return t.selection;
    }
  }),
  new MB("storedMarks", {
    init(t) {
      return t.storedMarks || null;
    },
    apply(t, e, A, n) {
      return n.selection.$cursor ? t.storedMarks : null;
    }
  }),
  new MB("scrollToSelection", {
    init() {
      return 0;
    },
    apply(t, e) {
      return t.scrolledIntoView ? e + 1 : e;
    }
  })
];
class EQ {
  constructor(e, A) {
    this.schema = e, this.plugins = [], this.pluginsByKey = /* @__PURE__ */ Object.create(null), this.fields = SS.slice(), A && A.forEach((n) => {
      if (this.pluginsByKey[n.key])
        throw new RangeError("Adding different instances of a keyed plugin (" + n.key + ")");
      this.plugins.push(n), this.pluginsByKey[n.key] = n, n.spec.state && this.fields.push(new MB(n.key, n.spec.state, n));
    });
  }
}
class Vc {
  /**
  @internal
  */
  constructor(e) {
    this.config = e;
  }
  /**
  The schema of the state's document.
  */
  get schema() {
    return this.config.schema;
  }
  /**
  The plugins that are active in this state.
  */
  get plugins() {
    return this.config.plugins;
  }
  /**
  Apply the given transaction to produce a new state.
  */
  apply(e) {
    return this.applyTransaction(e).state;
  }
  /**
  @internal
  */
  filterTransaction(e, A = -1) {
    for (let n = 0; n < this.config.plugins.length; n++)
      if (n != A) {
        let s = this.config.plugins[n];
        if (s.spec.filterTransaction && !s.spec.filterTransaction.call(s, e, this))
          return !1;
      }
    return !0;
  }
  /**
  Verbose variant of [`apply`](https://prosemirror.net/docs/ref/#state.EditorState.apply) that
  returns the precise transactions that were applied (which might
  be influenced by the [transaction
  hooks](https://prosemirror.net/docs/ref/#state.PluginSpec.filterTransaction) of
  plugins) along with the new state.
  */
  applyTransaction(e) {
    if (!this.filterTransaction(e))
      return { state: this, transactions: [] };
    let A = [e], n = this.applyInner(e), s = null;
    for (; ; ) {
      let r = !1;
      for (let i = 0; i < this.config.plugins.length; i++) {
        let o = this.config.plugins[i];
        if (o.spec.appendTransaction) {
          let a = s ? s[i].n : 0, c = s ? s[i].state : this, l = a < A.length && o.spec.appendTransaction.call(o, a ? A.slice(a) : A, c, n);
          if (l && n.filterTransaction(l, i)) {
            if (l.setMeta("appendedTransaction", e), !s) {
              s = [];
              for (let B = 0; B < this.config.plugins.length; B++)
                s.push(B < i ? { state: n, n: A.length } : { state: this, n: 0 });
            }
            A.push(l), n = n.applyInner(l), r = !0;
          }
          s && (s[i] = { state: n, n: A.length });
        }
      }
      if (!r)
        return { state: n, transactions: A };
    }
  }
  /**
  @internal
  */
  applyInner(e) {
    if (!e.before.eq(this.doc))
      throw new RangeError("Applying a mismatched transaction");
    let A = new Vc(this.config), n = this.config.fields;
    for (let s = 0; s < n.length; s++) {
      let r = n[s];
      A[r.name] = r.apply(e, this[r.name], this, A);
    }
    return A;
  }
  /**
  Accessor that constructs and returns a new [transaction](https://prosemirror.net/docs/ref/#state.Transaction) from this state.
  */
  get tr() {
    return new LS(this);
  }
  /**
  Create a new state.
  */
  static create(e) {
    let A = new EQ(e.doc ? e.doc.type.schema : e.schema, e.plugins), n = new Vc(A);
    for (let s = 0; s < A.fields.length; s++)
      n[A.fields[s].name] = A.fields[s].init(e, n);
    return n;
  }
  /**
  Create a new state based on this one, but with an adjusted set
  of active plugins. State fields that exist in both sets of
  plugins are kept unchanged. Those that no longer exist are
  dropped, and those that are new are initialized using their
  [`init`](https://prosemirror.net/docs/ref/#state.StateField.init) method, passing in the new
  configuration object..
  */
  reconfigure(e) {
    let A = new EQ(this.schema, e.plugins), n = A.fields, s = new Vc(A);
    for (let r = 0; r < n.length; r++) {
      let i = n[r].name;
      s[i] = this.hasOwnProperty(i) ? this[i] : n[r].init(e, s);
    }
    return s;
  }
  /**
  Serialize this state to JSON. If you want to serialize the state
  of plugins, pass an object mapping property names to use in the
  resulting JSON object to plugin objects. The argument may also be
  a string or number, in which case it is ignored, to support the
  way `JSON.stringify` calls `toString` methods.
  */
  toJSON(e) {
    let A = { doc: this.doc.toJSON(), selection: this.selection.toJSON() };
    if (this.storedMarks && (A.storedMarks = this.storedMarks.map((n) => n.toJSON())), e && typeof e == "object")
      for (let n in e) {
        if (n == "doc" || n == "selection")
          throw new RangeError("The JSON fields `doc` and `selection` are reserved");
        let s = e[n], r = s.spec.state;
        r && r.toJSON && (A[n] = r.toJSON.call(s, this[s.key]));
      }
    return A;
  }
  /**
  Deserialize a JSON representation of a state. `config` should
  have at least a `schema` field, and should contain array of
  plugins to initialize the state with. `pluginFields` can be used
  to deserialize the state of plugins, by associating plugin
  instances with the property names they use in the JSON object.
  */
  static fromJSON(e, A, n) {
    if (!A)
      throw new RangeError("Invalid input for EditorState.fromJSON");
    if (!e.schema)
      throw new RangeError("Required config field 'schema' missing");
    let s = new EQ(e.schema, e.plugins), r = new Vc(s);
    return s.fields.forEach((i) => {
      if (i.name == "doc")
        r.doc = xi.fromJSON(e.schema, A.doc);
      else if (i.name == "selection")
        r.selection = Ke.fromJSON(r.doc, A.selection);
      else if (i.name == "storedMarks")
        A.storedMarks && (r.storedMarks = A.storedMarks.map(e.schema.markFromJSON));
      else {
        if (n)
          for (let o in n) {
            let a = n[o], c = a.spec.state;
            if (a.key == i.name && c && c.fromJSON && Object.prototype.hasOwnProperty.call(A, o)) {
              r[i.name] = c.fromJSON.call(a, e, A[o], r);
              return;
            }
          }
        r[i.name] = i.init(e, r);
      }
    }), r;
  }
}
function l4(t, e, A) {
  for (let n in t) {
    let s = t[n];
    s instanceof Function ? s = s.bind(e) : n == "handleDOMEvents" && (s = l4(s, e, {})), A[n] = s;
  }
  return A;
}
class ct {
  /**
  Create a plugin.
  */
  constructor(e) {
    this.spec = e, this.props = {}, e.props && l4(e.props, this, this.props), this.key = e.key ? e.key.key : B4("plugin");
  }
  /**
  Extract the plugin's state field from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const MQ = /* @__PURE__ */ Object.create(null);
function B4(t) {
  return t in MQ ? t + "$" + ++MQ[t] : (MQ[t] = 0, t + "$");
}
class Bt {
  /**
  Create a plugin key.
  */
  constructor(e = "key") {
    this.key = B4(e);
  }
  /**
  Get the active plugin with this key, if any, from an editor
  state.
  */
  get(e) {
    return e.config.pluginsByKey[this.key];
  }
  /**
  Get the plugin's state from an editor state.
  */
  getState(e) {
    return e[this.key];
  }
}
const TM = (t, e) => t.selection.empty ? !1 : (e && e(t.tr.deleteSelection().scrollIntoView()), !0);
function g4(t, e) {
  let { $cursor: A } = t.selection;
  return !A || (e ? !e.endOfTextblock("backward", t) : A.parentOffset > 0) ? null : A;
}
const h4 = (t, e, A) => {
  let n = g4(t, A);
  if (!n)
    return !1;
  let s = JM(n);
  if (!s) {
    let i = n.blockRange(), o = i && cc(i);
    return o == null ? !1 : (e && e(t.tr.lift(i, o).scrollIntoView()), !0);
  }
  let r = s.nodeBefore;
  if (M4(t, s, e, -1))
    return !0;
  if (n.parent.content.size == 0 && (Cl(r, "end") || Ue.isSelectable(r)))
    for (let i = n.depth; ; i--) {
      let o = mw(t.doc, n.before(i), n.after(i), Ee.empty);
      if (o && o.slice.size < o.to - o.from) {
        if (e) {
          let a = t.tr.step(o);
          a.setSelection(Cl(r, "end") ? Ke.findFrom(a.doc.resolve(a.mapping.map(s.pos, -1)), -1) : Ue.create(a.doc, s.pos - r.nodeSize)), e(a.scrollIntoView());
        }
        return !0;
      }
      if (i == 1 || n.node(i - 1).childCount > 1)
        break;
    }
  return r.isAtom && s.depth == n.depth - 1 ? (e && e(t.tr.delete(s.pos - r.nodeSize, s.pos).scrollIntoView()), !0) : !1;
}, TS = (t, e, A) => {
  let n = g4(t, A);
  if (!n)
    return !1;
  let s = JM(n);
  return s ? u4(t, s, e) : !1;
}, JS = (t, e, A) => {
  let n = w4(t, A);
  if (!n)
    return !1;
  let s = WM(n);
  return s ? u4(t, s, e) : !1;
};
function u4(t, e, A) {
  let n = e.nodeBefore, s = n, r = e.pos - 1;
  for (; !s.isTextblock; r--) {
    if (s.type.spec.isolating)
      return !1;
    let l = s.lastChild;
    if (!l)
      return !1;
    s = l;
  }
  let i = e.nodeAfter, o = i, a = e.pos + 1;
  for (; !o.isTextblock; a++) {
    if (o.type.spec.isolating)
      return !1;
    let l = o.firstChild;
    if (!l)
      return !1;
    o = l;
  }
  let c = mw(t.doc, r, a, Ee.empty);
  if (!c || c.from != r || c instanceof GA && c.slice.size >= a - r)
    return !1;
  if (A) {
    let l = t.tr.step(c);
    l.setSelection(Re.create(l.doc, r)), A(l.scrollIntoView());
  }
  return !0;
}
function Cl(t, e, A = !1) {
  for (let n = t; n; n = e == "start" ? n.firstChild : n.lastChild) {
    if (n.isTextblock)
      return !0;
    if (A && n.childCount != 1)
      return !1;
  }
  return !1;
}
const d4 = (t, e, A) => {
  let { $head: n, empty: s } = t.selection, r = n;
  if (!s)
    return !1;
  if (n.parent.isTextblock) {
    if (A ? !A.endOfTextblock("backward", t) : n.parentOffset > 0)
      return !1;
    r = JM(n);
  }
  let i = r && r.nodeBefore;
  return !i || !Ue.isSelectable(i) ? !1 : (e && e(t.tr.setSelection(Ue.create(t.doc, r.pos - i.nodeSize)).scrollIntoView()), !0);
};
function JM(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      if (t.index(e) > 0)
        return t.doc.resolve(t.before(e + 1));
      if (t.node(e).type.spec.isolating)
        break;
    }
  return null;
}
function w4(t, e) {
  let { $cursor: A } = t.selection;
  return !A || (e ? !e.endOfTextblock("forward", t) : A.parentOffset < A.parent.content.size) ? null : A;
}
const f4 = (t, e, A) => {
  let n = w4(t, A);
  if (!n)
    return !1;
  let s = WM(n);
  if (!s)
    return !1;
  let r = s.nodeAfter;
  if (M4(t, s, e, 1))
    return !0;
  if (n.parent.content.size == 0 && (Cl(r, "start") || Ue.isSelectable(r))) {
    let i = mw(t.doc, n.before(), n.after(), Ee.empty);
    if (i && i.slice.size < i.to - i.from) {
      if (e) {
        let o = t.tr.step(i);
        o.setSelection(Cl(r, "start") ? Ke.findFrom(o.doc.resolve(o.mapping.map(s.pos)), 1) : Ue.create(o.doc, o.mapping.map(s.pos))), e(o.scrollIntoView());
      }
      return !0;
    }
  }
  return r.isAtom && s.depth == n.depth - 1 ? (e && e(t.tr.delete(s.pos, s.pos + r.nodeSize).scrollIntoView()), !0) : !1;
}, Q4 = (t, e, A) => {
  let { $head: n, empty: s } = t.selection, r = n;
  if (!s)
    return !1;
  if (n.parent.isTextblock) {
    if (A ? !A.endOfTextblock("forward", t) : n.parentOffset < n.parent.content.size)
      return !1;
    r = WM(n);
  }
  let i = r && r.nodeAfter;
  return !i || !Ue.isSelectable(i) ? !1 : (e && e(t.tr.setSelection(Ue.create(t.doc, r.pos)).scrollIntoView()), !0);
};
function WM(t) {
  if (!t.parent.type.spec.isolating)
    for (let e = t.depth - 1; e >= 0; e--) {
      let A = t.node(e);
      if (t.index(e) + 1 < A.childCount)
        return t.doc.resolve(t.after(e + 1));
      if (A.type.spec.isolating)
        break;
    }
  return null;
}
const WS = (t, e) => {
  let A = t.selection, n = A instanceof Ue, s;
  if (n) {
    if (A.node.isTextblock || !oa(t.doc, A.from))
      return !1;
    s = A.from;
  } else if (s = pw(t.doc, A.from, -1), s == null)
    return !1;
  if (e) {
    let r = t.tr.join(s);
    n && r.setSelection(Ue.create(r.doc, s - t.doc.resolve(s).nodeBefore.nodeSize)), e(r.scrollIntoView());
  }
  return !0;
}, OS = (t, e) => {
  let A = t.selection, n;
  if (A instanceof Ue) {
    if (A.node.isTextblock || !oa(t.doc, A.to))
      return !1;
    n = A.to;
  } else if (n = pw(t.doc, A.to, 1), n == null)
    return !1;
  return e && e(t.tr.join(n).scrollIntoView()), !0;
}, PS = (t, e) => {
  let { $from: A, $to: n } = t.selection, s = A.blockRange(n), r = s && cc(s);
  return r == null ? !1 : (e && e(t.tr.lift(s, r).scrollIntoView()), !0);
}, I4 = (t, e) => {
  let { $head: A, $anchor: n } = t.selection;
  return !A.parent.type.spec.code || !A.sameParent(n) ? !1 : (e && e(t.tr.insertText(`
`).scrollIntoView()), !0);
};
function OM(t) {
  for (let e = 0; e < t.edgeCount; e++) {
    let { type: A } = t.edge(e);
    if (A.isTextblock && !A.hasRequiredAttrs())
      return A;
  }
  return null;
}
const KS = (t, e) => {
  let { $head: A, $anchor: n } = t.selection;
  if (!A.parent.type.spec.code || !A.sameParent(n))
    return !1;
  let s = A.node(-1), r = A.indexAfter(-1), i = OM(s.contentMatchAt(r));
  if (!i || !s.canReplaceWith(r, r, i))
    return !1;
  if (e) {
    let o = A.after(), a = t.tr.replaceWith(o, o, i.createAndFill());
    a.setSelection(Ke.near(a.doc.resolve(o), 1)), e(a.scrollIntoView());
  }
  return !0;
}, C4 = (t, e) => {
  let A = t.selection, { $from: n, $to: s } = A;
  if (A instanceof Xn || n.parent.inlineContent || s.parent.inlineContent)
    return !1;
  let r = OM(s.parent.contentMatchAt(s.indexAfter()));
  if (!r || !r.isTextblock)
    return !1;
  if (e) {
    let i = (!n.parentOffset && s.index() < s.parent.childCount ? n : s).pos, o = t.tr.insert(i, r.createAndFill());
    o.setSelection(Re.create(o.doc, i + 1)), e(o.scrollIntoView());
  }
  return !0;
}, E4 = (t, e) => {
  let { $cursor: A } = t.selection;
  if (!A || A.parent.content.size)
    return !1;
  if (A.depth > 1 && A.after() != A.end(-1)) {
    let r = A.before();
    if (Gi(t.doc, r))
      return e && e(t.tr.split(r).scrollIntoView()), !0;
  }
  let n = A.blockRange(), s = n && cc(n);
  return s == null ? !1 : (e && e(t.tr.lift(n, s).scrollIntoView()), !0);
};
function VS(t) {
  return (e, A) => {
    let { $from: n, $to: s } = e.selection;
    if (e.selection instanceof Ue && e.selection.node.isBlock)
      return !n.parentOffset || !Gi(e.doc, n.pos) ? !1 : (A && A(e.tr.split(n.pos).scrollIntoView()), !0);
    if (!n.depth)
      return !1;
    let r = [], i, o, a = !1, c = !1;
    for (let h = n.depth; ; h--)
      if (n.node(h).isBlock) {
        a = n.end(h) == n.pos + (n.depth - h), c = n.start(h) == n.pos - (n.depth - h), o = OM(n.node(h - 1).contentMatchAt(n.indexAfter(h - 1))), r.unshift(a && o ? { type: o } : null), i = h;
        break;
      } else {
        if (h == 1)
          return !1;
        r.unshift(null);
      }
    let l = e.tr;
    (e.selection instanceof Re || e.selection instanceof Xn) && l.deleteSelection();
    let B = l.mapping.map(n.pos), g = Gi(l.doc, B, r.length, r);
    if (g || (r[0] = o ? { type: o } : null, g = Gi(l.doc, B, r.length, r)), !g)
      return !1;
    if (l.split(B, r.length, r), !a && c && n.node(i).type != o) {
      let h = l.mapping.map(n.before(i)), u = l.doc.resolve(h);
      o && n.node(i - 1).canReplaceWith(u.index(), u.index() + 1, o) && l.setNodeMarkup(l.mapping.map(n.before(i)), o);
    }
    return A && A(l.scrollIntoView()), !0;
  };
}
const XS = VS(), ZS = (t, e) => {
  let { $from: A, to: n } = t.selection, s, r = A.sharedDepth(n);
  return r == 0 ? !1 : (s = A.before(r), e && e(t.tr.setSelection(Ue.create(t.doc, s))), !0);
};
function qS(t, e, A) {
  let n = e.nodeBefore, s = e.nodeAfter, r = e.index();
  return !n || !s || !n.type.compatibleContent(s.type) ? !1 : !n.content.size && e.parent.canReplace(r - 1, r) ? (A && A(t.tr.delete(e.pos - n.nodeSize, e.pos).scrollIntoView()), !0) : !e.parent.canReplace(r, r + 1) || !(s.isTextblock || oa(t.doc, e.pos)) ? !1 : (A && A(t.tr.join(e.pos).scrollIntoView()), !0);
}
function M4(t, e, A, n) {
  let s = e.nodeBefore, r = e.nodeAfter, i, o, a = s.type.spec.isolating || r.type.spec.isolating;
  if (!a && qS(t, e, A))
    return !0;
  let c = !a && e.parent.canReplace(e.index(), e.index() + 1);
  if (c && (i = (o = s.contentMatchAt(s.childCount)).findWrapping(r.type)) && o.matchType(i[0] || r.type).validEnd) {
    if (A) {
      let h = e.pos + r.nodeSize, u = re.empty;
      for (let Q = i.length - 1; Q >= 0; Q--)
        u = re.from(i[Q].create(null, u));
      u = re.from(s.copy(u));
      let d = t.tr.step(new vA(e.pos - 1, h, e.pos, h, new Ee(u, 1, 0), i.length, !0)), w = d.doc.resolve(h + 2 * i.length);
      w.nodeAfter && w.nodeAfter.type == s.type && oa(d.doc, w.pos) && d.join(w.pos), A(d.scrollIntoView());
    }
    return !0;
  }
  let l = r.type.spec.isolating || n > 0 && a ? null : Ke.findFrom(e, 1), B = l && l.$from.blockRange(l.$to), g = B && cc(B);
  if (g != null && g >= e.depth)
    return A && A(t.tr.lift(B, g).scrollIntoView()), !0;
  if (c && Cl(r, "start", !0) && Cl(s, "end")) {
    let h = s, u = [];
    for (; u.push(h), !h.isTextblock; )
      h = h.lastChild;
    let d = r, w = 1;
    for (; !d.isTextblock; d = d.firstChild)
      w++;
    if (h.canReplace(h.childCount, h.childCount, d.content)) {
      if (A) {
        let Q = re.empty;
        for (let M = u.length - 1; M >= 0; M--)
          Q = re.from(u[M].copy(Q));
        let p = t.tr.step(new vA(e.pos - u.length, e.pos + r.nodeSize, e.pos + w, e.pos + r.nodeSize - w, new Ee(Q, u.length, 0), 0, !0));
        A(p.scrollIntoView());
      }
      return !0;
    }
  }
  return !1;
}
function p4(t) {
  return function(e, A) {
    let n = e.selection, s = t < 0 ? n.$from : n.$to, r = s.depth;
    for (; s.node(r).isInline; ) {
      if (!r)
        return !1;
      r--;
    }
    return s.node(r).isTextblock ? (A && A(e.tr.setSelection(Re.create(e.doc, t < 0 ? s.start(r) : s.end(r)))), !0) : !1;
  };
}
const _S = p4(-1), $S = p4(1);
function eT(t, e = null) {
  return function(A, n) {
    let { $from: s, $to: r } = A.selection, i = s.blockRange(r), o = i && Mw(i, t, e);
    return o ? (n && n(A.tr.wrap(i, o).scrollIntoView()), !0) : !1;
  };
}
function ay(t, e = null) {
  return function(A, n) {
    let s = !1;
    for (let r = 0; r < A.selection.ranges.length && !s; r++) {
      let { $from: { pos: i }, $to: { pos: o } } = A.selection.ranges[r];
      A.doc.nodesBetween(i, o, (a, c) => {
        if (s)
          return !1;
        if (!(!a.isTextblock || a.hasMarkup(t, e)))
          if (a.type == t)
            s = !0;
          else {
            let l = A.doc.resolve(c), B = l.index();
            s = l.parent.canReplaceWith(B, B + 1, t);
          }
      });
    }
    if (!s)
      return !1;
    if (n) {
      let r = A.tr;
      for (let i = 0; i < A.selection.ranges.length; i++) {
        let { $from: { pos: o }, $to: { pos: a } } = A.selection.ranges[i];
        r.setBlockType(o, a, t, e);
      }
      n(r.scrollIntoView());
    }
    return !0;
  };
}
function PM(...t) {
  return function(e, A, n) {
    for (let s = 0; s < t.length; s++)
      if (t[s](e, A, n))
        return !0;
    return !1;
  };
}
PM(TM, h4, d4);
PM(TM, f4, Q4);
PM(I4, C4, E4, XS);
typeof navigator < "u" ? /Mac|iP(hone|[oa]d)/.test(navigator.platform) : typeof os < "u" && os.platform && os.platform() == "darwin";
function tT(t, e = null) {
  return function(A, n) {
    let { $from: s, $to: r } = A.selection, i = s.blockRange(r);
    if (!i)
      return !1;
    let o = n ? A.tr : null;
    return AT(o, i, t, e) ? (n && n(o.scrollIntoView()), !0) : !1;
  };
}
function AT(t, e, A, n = null) {
  let s = !1, r = e, i = e.$from.doc;
  if (e.depth >= 2 && e.$from.node(e.depth - 1).type.compatibleContent(A) && e.startIndex == 0) {
    if (e.$from.index(e.depth - 1) == 0)
      return !1;
    let a = i.resolve(e.start - 2);
    r = new Ql(a, a, e.depth), e.endIndex < e.parent.childCount && (e = new Ql(e.$from, i.resolve(e.$to.end(e.depth)), e.depth)), s = !0;
  }
  let o = Mw(r, A, n, e);
  return o ? (t && nT(t, e, o, s, A), !0) : !1;
}
function nT(t, e, A, n, s) {
  let r = re.empty;
  for (let l = A.length - 1; l >= 0; l--)
    r = re.from(A[l].type.create(A[l].attrs, r));
  t.step(new vA(e.start - (n ? 2 : 0), e.end, e.start, e.end, new Ee(r, 0, 0), A.length, !0));
  let i = 0;
  for (let l = 0; l < A.length; l++)
    A[l].type == s && (i = l + 1);
  let o = A.length - i, a = e.start + A.length - (n ? 2 : 0), c = e.parent;
  for (let l = e.startIndex, B = e.endIndex, g = !0; l < B; l++, g = !1)
    !g && Gi(t.doc, a, o) && (t.split(a, o), a += 2 * o), a += c.child(l).nodeSize;
  return t;
}
function sT(t) {
  return function(e, A) {
    let { $from: n, $to: s } = e.selection, r = n.blockRange(s, (i) => i.childCount > 0 && i.firstChild.type == t);
    return r ? A ? n.node(r.depth - 1).type == t ? rT(e, A, t, r) : iT(e, A, r) : !0 : !1;
  };
}
function rT(t, e, A, n) {
  let s = t.tr, r = n.end, i = n.$to.end(n.depth);
  r < i && (s.step(new vA(r - 1, i, r, i, new Ee(re.from(A.create(null, n.parent.copy())), 1, 0), 1, !0)), n = new Ql(s.doc.resolve(n.$from.pos), s.doc.resolve(i), n.depth));
  const o = cc(n);
  if (o == null)
    return !1;
  s.lift(n, o);
  let a = s.doc.resolve(s.mapping.map(r, -1) - 1);
  return oa(s.doc, a.pos) && a.nodeBefore.type == a.nodeAfter.type && s.join(a.pos), e(s.scrollIntoView()), !0;
}
function iT(t, e, A) {
  let n = t.tr, s = A.parent;
  for (let h = A.end, u = A.endIndex - 1, d = A.startIndex; u > d; u--)
    h -= s.child(u).nodeSize, n.delete(h - 1, h + 1);
  let r = n.doc.resolve(A.start), i = r.nodeAfter;
  if (n.mapping.map(A.end) != A.start + r.nodeAfter.nodeSize)
    return !1;
  let o = A.startIndex == 0, a = A.endIndex == s.childCount, c = r.node(-1), l = r.index(-1);
  if (!c.canReplace(l + (o ? 0 : 1), l + 1, i.content.append(a ? re.empty : re.from(s))))
    return !1;
  let B = r.pos, g = B + i.nodeSize;
  return n.step(new vA(B - (o ? 1 : 0), g + (a ? 1 : 0), B + 1, g - 1, new Ee((o ? re.empty : re.from(s.copy(re.empty))).append(a ? re.empty : re.from(s.copy(re.empty))), o ? 0 : 1, a ? 0 : 1), o ? 0 : 1)), e(n.scrollIntoView()), !0;
}
function oT(t) {
  return function(e, A) {
    let { $from: n, $to: s } = e.selection, r = n.blockRange(s, (c) => c.childCount > 0 && c.firstChild.type == t);
    if (!r)
      return !1;
    let i = r.startIndex;
    if (i == 0)
      return !1;
    let o = r.parent, a = o.child(i - 1);
    if (a.type != t)
      return !1;
    if (A) {
      let c = a.lastChild && a.lastChild.type == o.type, l = re.from(c ? t.create() : null), B = new Ee(re.from(t.create(null, re.from(o.type.create(null, l)))), c ? 3 : 1, 0), g = r.start, h = r.end;
      A(e.tr.step(new vA(g - (c ? 3 : 1), h, g, h, B, 1, !0)).scrollIntoView());
    }
    return !0;
  };
}
const PA = function(t) {
  for (var e = 0; ; e++)
    if (t = t.previousSibling, !t)
      return e;
}, El = function(t) {
  let e = t.assignedSlot || t.parentNode;
  return e && e.nodeType == 11 ? e.host : e;
};
let UC = null;
const Ci = function(t, e, A) {
  let n = UC || (UC = document.createRange());
  return n.setEnd(t, A ?? t.nodeValue.length), n.setStart(t, e || 0), n;
}, aT = function() {
  UC = null;
}, Za = function(t, e, A, n) {
  return A && (cy(t, e, A, n, -1) || cy(t, e, A, n, 1));
}, cT = /^(img|br|input|textarea|hr)$/i;
function cy(t, e, A, n, s) {
  for (var r; ; ) {
    if (t == A && e == n)
      return !0;
    if (e == (s < 0 ? 0 : Ys(t))) {
      let i = t.parentNode;
      if (!i || i.nodeType != 1 || Bh(t) || cT.test(t.nodeName) || t.contentEditable == "false")
        return !1;
      e = PA(t) + (s < 0 ? 0 : 1), t = i;
    } else if (t.nodeType == 1) {
      let i = t.childNodes[e + (s < 0 ? -1 : 0)];
      if (i.nodeType == 1 && i.contentEditable == "false")
        if (!((r = i.pmViewDesc) === null || r === void 0) && r.ignoreForSelection)
          e += s;
        else
          return !1;
      else
        t = i, e = s < 0 ? Ys(t) : 0;
    } else
      return !1;
  }
}
function Ys(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function lT(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e)
      return t;
    if (t.nodeType == 1 && e > 0) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e - 1], e = Ys(t);
    } else if (t.parentNode && !Bh(t))
      e = PA(t), t = t.parentNode;
    else
      return null;
  }
}
function BT(t, e) {
  for (; ; ) {
    if (t.nodeType == 3 && e < t.nodeValue.length)
      return t;
    if (t.nodeType == 1 && e < t.childNodes.length) {
      if (t.contentEditable == "false")
        return null;
      t = t.childNodes[e], e = 0;
    } else if (t.parentNode && !Bh(t))
      e = PA(t) + 1, t = t.parentNode;
    else
      return null;
  }
}
function gT(t, e, A) {
  for (let n = e == 0, s = e == Ys(t); n || s; ) {
    if (t == A)
      return !0;
    let r = PA(t);
    if (t = t.parentNode, !t)
      return !1;
    n = n && r == 0, s = s && r == Ys(t);
  }
}
function Bh(t) {
  let e;
  for (let A = t; A && !(e = A.pmViewDesc); A = A.parentNode)
    ;
  return e && e.node && e.node.isBlock && (e.dom == t || e.contentDOM == t);
}
const yw = function(t) {
  return t.focusNode && Za(t.focusNode, t.focusOffset, t.anchorNode, t.anchorOffset);
};
function za(t, e) {
  let A = document.createEvent("Event");
  return A.initEvent("keydown", !0, !0), A.keyCode = t, A.key = A.code = e, A;
}
function hT(t) {
  let e = t.activeElement;
  for (; e && e.shadowRoot; )
    e = e.shadowRoot.activeElement;
  return e;
}
function uT(t, e, A) {
  if (t.caretPositionFromPoint)
    try {
      let n = t.caretPositionFromPoint(e, A);
      if (n)
        return { node: n.offsetNode, offset: Math.min(Ys(n.offsetNode), n.offset) };
    } catch {
    }
  if (t.caretRangeFromPoint) {
    let n = t.caretRangeFromPoint(e, A);
    if (n)
      return { node: n.startContainer, offset: Math.min(Ys(n.startContainer), n.startOffset) };
  }
}
const Lr = typeof navigator < "u" ? navigator : null, ly = typeof document < "u" ? document : null, aa = Lr && Lr.userAgent || "", bC = /Edge\/(\d+)/.exec(aa), m4 = /MSIE \d/.exec(aa), vC = /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(aa), Zn = !!(m4 || vC || bC), So = m4 ? document.documentMode : vC ? +vC[1] : bC ? +bC[1] : 0, vs = !Zn && /gecko\/(\d+)/i.test(aa);
vs && +(/Firefox\/(\d+)/.exec(aa) || [0, 0])[1];
const jC = !Zn && /Chrome\/(\d+)/.exec(aa), bA = !!jC, Y4 = jC ? +jC[1] : 0, XA = !Zn && !!Lr && /Apple Computer/.test(Lr.vendor), Ml = XA && (/Mobile\/\w+/.test(aa) || !!Lr && Lr.maxTouchPoints > 2), ms = Ml || (Lr ? /Mac/.test(Lr.platform) : !1), y4 = Lr ? /Win/.test(Lr.platform) : !1, yi = /Android \d/.test(aa), gh = !!ly && "webkitFontSmoothing" in ly.documentElement.style, dT = gh ? +(/\bAppleWebKit\/(\d+)/.exec(navigator.userAgent) || [0, 0])[1] : 0;
function wT(t) {
  let e = t.defaultView && t.defaultView.visualViewport;
  return e ? {
    left: 0,
    right: e.width,
    top: 0,
    bottom: e.height
  } : {
    left: 0,
    right: t.documentElement.clientWidth,
    top: 0,
    bottom: t.documentElement.clientHeight
  };
}
function ci(t, e) {
  return typeof t == "number" ? t : t[e];
}
function fT(t) {
  let e = t.getBoundingClientRect(), A = e.width / t.offsetWidth || 1, n = e.height / t.offsetHeight || 1;
  return {
    left: e.left,
    right: e.left + t.clientWidth * A,
    top: e.top,
    bottom: e.top + t.clientHeight * n
  };
}
function By(t, e, A) {
  let n = t.someProp("scrollThreshold") || 0, s = t.someProp("scrollMargin") || 5, r = t.dom.ownerDocument;
  for (let i = A || t.dom; i; ) {
    if (i.nodeType != 1) {
      i = El(i);
      continue;
    }
    let o = i, a = o == r.body, c = a ? wT(r) : fT(o), l = 0, B = 0;
    if (e.top < c.top + ci(n, "top") ? B = -(c.top - e.top + ci(s, "top")) : e.bottom > c.bottom - ci(n, "bottom") && (B = e.bottom - e.top > c.bottom - c.top ? e.top + ci(s, "top") - c.top : e.bottom - c.bottom + ci(s, "bottom")), e.left < c.left + ci(n, "left") ? l = -(c.left - e.left + ci(s, "left")) : e.right > c.right - ci(n, "right") && (l = e.right - c.right + ci(s, "right")), l || B)
      if (a)
        r.defaultView.scrollBy(l, B);
      else {
        let h = o.scrollLeft, u = o.scrollTop;
        B && (o.scrollTop += B), l && (o.scrollLeft += l);
        let d = o.scrollLeft - h, w = o.scrollTop - u;
        e = { left: e.left - d, top: e.top - w, right: e.right - d, bottom: e.bottom - w };
      }
    let g = a ? "fixed" : getComputedStyle(i).position;
    if (/^(fixed|sticky)$/.test(g))
      break;
    i = g == "absolute" ? i.offsetParent : El(i);
  }
}
function QT(t) {
  let e = t.dom.getBoundingClientRect(), A = Math.max(0, e.top), n, s;
  for (let r = (e.left + e.right) / 2, i = A + 1; i < Math.min(innerHeight, e.bottom); i += 5) {
    let o = t.root.elementFromPoint(r, i);
    if (!o || o == t.dom || !t.dom.contains(o))
      continue;
    let a = o.getBoundingClientRect();
    if (a.top >= A - 20) {
      n = o, s = a.top;
      break;
    }
  }
  return { refDOM: n, refTop: s, stack: F4(t.dom) };
}
function F4(t) {
  let e = [], A = t.ownerDocument;
  for (let n = t; n && (e.push({ dom: n, top: n.scrollTop, left: n.scrollLeft }), t != A); n = El(n))
    ;
  return e;
}
function IT({ refDOM: t, refTop: e, stack: A }) {
  let n = t ? t.getBoundingClientRect().top : 0;
  N4(A, n == 0 ? 0 : n - e);
}
function N4(t, e) {
  for (let A = 0; A < t.length; A++) {
    let { dom: n, top: s, left: r } = t[A];
    n.scrollTop != s + e && (n.scrollTop = s + e), n.scrollLeft != r && (n.scrollLeft = r);
  }
}
let Nc = null;
function CT(t) {
  if (t.setActive)
    return t.setActive();
  if (Nc)
    return t.focus(Nc);
  let e = F4(t);
  t.focus(Nc == null ? {
    get preventScroll() {
      return Nc = { preventScroll: !0 }, !0;
    }
  } : void 0), Nc || (Nc = !1, N4(e, 0));
}
function D4(t, e) {
  let A, n = 2e8, s, r = 0, i = e.top, o = e.top, a, c;
  for (let l = t.firstChild, B = 0; l; l = l.nextSibling, B++) {
    let g;
    if (l.nodeType == 1)
      g = l.getClientRects();
    else if (l.nodeType == 3)
      g = Ci(l).getClientRects();
    else
      continue;
    for (let h = 0; h < g.length; h++) {
      let u = g[h];
      if (u.top <= i && u.bottom >= o) {
        i = Math.max(u.bottom, i), o = Math.min(u.top, o);
        let d = u.left > e.left ? u.left - e.left : u.right < e.left ? e.left - u.right : 0;
        if (d < n) {
          A = l, n = d, s = d && A.nodeType == 3 ? {
            left: u.right < e.left ? u.right : u.left,
            top: e.top
          } : e, l.nodeType == 1 && d && (r = B + (e.left >= (u.left + u.right) / 2 ? 1 : 0));
          continue;
        }
      } else u.top > e.top && !a && u.left <= e.left && u.right >= e.left && (a = l, c = { left: Math.max(u.left, Math.min(u.right, e.left)), top: u.top });
      !A && (e.left >= u.right && e.top >= u.top || e.left >= u.left && e.top >= u.bottom) && (r = B + 1);
    }
  }
  return !A && a && (A = a, s = c, n = 0), A && A.nodeType == 3 ? ET(A, s) : !A || n && A.nodeType == 1 ? { node: t, offset: r } : D4(A, s);
}
function ET(t, e) {
  let A = t.nodeValue.length, n = document.createRange(), s;
  for (let r = 0; r < A; r++) {
    n.setEnd(t, r + 1), n.setStart(t, r);
    let i = wo(n, 1);
    if (i.top != i.bottom && KM(e, i)) {
      s = { node: t, offset: r + (e.left >= (i.left + i.right) / 2 ? 1 : 0) };
      break;
    }
  }
  return n.detach(), s || { node: t, offset: 0 };
}
function KM(t, e) {
  return t.left >= e.left - 1 && t.left <= e.right + 1 && t.top >= e.top - 1 && t.top <= e.bottom + 1;
}
function MT(t, e) {
  let A = t.parentNode;
  return A && /^li$/i.test(A.nodeName) && e.left < t.getBoundingClientRect().left ? A : t;
}
function pT(t, e, A) {
  let { node: n, offset: s } = D4(e, A), r = -1;
  if (n.nodeType == 1 && !n.firstChild) {
    let i = n.getBoundingClientRect();
    r = i.left != i.right && A.left > (i.left + i.right) / 2 ? 1 : -1;
  }
  return t.docView.posFromDOM(n, s, r);
}
function mT(t, e, A, n) {
  let s = -1;
  for (let r = e, i = !1; r != t.dom; ) {
    let o = t.docView.nearestDesc(r, !0), a;
    if (!o)
      return null;
    if (o.dom.nodeType == 1 && (o.node.isBlock && o.parent || !o.contentDOM) && // Ignore elements with zero-size bounding rectangles
    ((a = o.dom.getBoundingClientRect()).width || a.height) && (o.node.isBlock && o.parent && !/^T(R|BODY|HEAD|FOOT)$/.test(o.dom.nodeName) && (!i && a.left > n.left || a.top > n.top ? s = o.posBefore : (!i && a.right < n.left || a.bottom < n.top) && (s = o.posAfter), i = !0), !o.contentDOM && s < 0 && !o.node.isText))
      return (o.node.isBlock ? n.top < (a.top + a.bottom) / 2 : n.left < (a.left + a.right) / 2) ? o.posBefore : o.posAfter;
    r = o.dom.parentNode;
  }
  return s > -1 ? s : t.docView.posFromDOM(e, A, -1);
}
function x4(t, e, A) {
  let n = t.childNodes.length;
  if (n && A.top < A.bottom)
    for (let s = Math.max(0, Math.min(n - 1, Math.floor(n * (e.top - A.top) / (A.bottom - A.top)) - 2)), r = s; ; ) {
      let i = t.childNodes[r];
      if (i.nodeType == 1) {
        let o = i.getClientRects();
        for (let a = 0; a < o.length; a++) {
          let c = o[a];
          if (KM(e, c))
            return x4(i, e, c);
        }
      }
      if ((r = (r + 1) % n) == s)
        break;
    }
  return t;
}
function YT(t, e) {
  let A = t.dom.ownerDocument, n, s = 0, r = uT(A, e.left, e.top);
  r && ({ node: n, offset: s } = r);
  let i = (t.root.elementFromPoint ? t.root : A).elementFromPoint(e.left, e.top), o;
  if (!i || !t.dom.contains(i.nodeType != 1 ? i.parentNode : i)) {
    let c = t.dom.getBoundingClientRect();
    if (!KM(e, c) || (i = x4(t.dom, e, c), !i))
      return null;
  }
  if (XA)
    for (let c = i; n && c; c = El(c))
      c.draggable && (n = void 0);
  if (i = MT(i, e), n) {
    if (vs && n.nodeType == 1 && (s = Math.min(s, n.childNodes.length), s < n.childNodes.length)) {
      let l = n.childNodes[s], B;
      l.nodeName == "IMG" && (B = l.getBoundingClientRect()).right <= e.left && B.bottom > e.top && s++;
    }
    let c;
    gh && s && n.nodeType == 1 && (c = n.childNodes[s - 1]).nodeType == 1 && c.contentEditable == "false" && c.getBoundingClientRect().top >= e.top && s--, n == t.dom && s == n.childNodes.length - 1 && n.lastChild.nodeType == 1 && e.top > n.lastChild.getBoundingClientRect().bottom ? o = t.state.doc.content.size : (s == 0 || n.nodeType != 1 || n.childNodes[s - 1].nodeName != "BR") && (o = mT(t, n, s, e));
  }
  o == null && (o = pT(t, i, e));
  let a = t.docView.nearestDesc(i, !0);
  return { pos: o, inside: a ? a.posAtStart - a.border : -1 };
}
function gy(t) {
  return t.top < t.bottom || t.left < t.right;
}
function wo(t, e) {
  let A = t.getClientRects();
  if (A.length) {
    let n = A[e < 0 ? 0 : A.length - 1];
    if (gy(n))
      return n;
  }
  return Array.prototype.find.call(A, gy) || t.getBoundingClientRect();
}
const yT = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac]/;
function G4(t, e, A) {
  let { node: n, offset: s, atom: r } = t.docView.domFromPos(e, A < 0 ? -1 : 1), i = gh || vs;
  if (n.nodeType == 3)
    if (i && (yT.test(n.nodeValue) || (A < 0 ? !s : s == n.nodeValue.length))) {
      let a = wo(Ci(n, s, s), A);
      if (vs && s && /\s/.test(n.nodeValue[s - 1]) && s < n.nodeValue.length) {
        let c = wo(Ci(n, s - 1, s - 1), -1);
        if (c.top == a.top) {
          let l = wo(Ci(n, s, s + 1), -1);
          if (l.top != a.top)
            return sB(l, l.left < c.left);
        }
      }
      return a;
    } else {
      let a = s, c = s, l = A < 0 ? 1 : -1;
      return A < 0 && !s ? (c++, l = -1) : A >= 0 && s == n.nodeValue.length ? (a--, l = 1) : A < 0 ? a-- : c++, sB(wo(Ci(n, a, c), l), l < 0);
    }
  if (!t.state.doc.resolve(e - (r || 0)).parent.inlineContent) {
    if (r == null && s && (A < 0 || s == Ys(n))) {
      let a = n.childNodes[s - 1];
      if (a.nodeType == 1)
        return pQ(a.getBoundingClientRect(), !1);
    }
    if (r == null && s < Ys(n)) {
      let a = n.childNodes[s];
      if (a.nodeType == 1)
        return pQ(a.getBoundingClientRect(), !0);
    }
    return pQ(n.getBoundingClientRect(), A >= 0);
  }
  if (r == null && s && (A < 0 || s == Ys(n))) {
    let a = n.childNodes[s - 1], c = a.nodeType == 3 ? Ci(a, Ys(a) - (i ? 0 : 1)) : a.nodeType == 1 && (a.nodeName != "BR" || !a.nextSibling) ? a : null;
    if (c)
      return sB(wo(c, 1), !1);
  }
  if (r == null && s < Ys(n)) {
    let a = n.childNodes[s];
    for (; a.pmViewDesc && a.pmViewDesc.ignoreForCoords; )
      a = a.nextSibling;
    let c = a ? a.nodeType == 3 ? Ci(a, 0, i ? 0 : 1) : a.nodeType == 1 ? a : null : null;
    if (c)
      return sB(wo(c, -1), !0);
  }
  return sB(wo(n.nodeType == 3 ? Ci(n) : n, -A), A >= 0);
}
function sB(t, e) {
  if (t.width == 0)
    return t;
  let A = e ? t.left : t.right;
  return { top: t.top, bottom: t.bottom, left: A, right: A };
}
function pQ(t, e) {
  if (t.height == 0)
    return t;
  let A = e ? t.top : t.bottom;
  return { top: A, bottom: A, left: t.left, right: t.right };
}
function z4(t, e, A) {
  let n = t.state, s = t.root.activeElement;
  n != e && t.updateState(e), s != t.dom && t.focus();
  try {
    return A();
  } finally {
    n != e && t.updateState(n), s != t.dom && s && s.focus();
  }
}
function FT(t, e, A) {
  let n = e.selection, s = A == "up" ? n.$from : n.$to;
  return z4(t, e, () => {
    let { node: r } = t.docView.domFromPos(s.pos, A == "up" ? -1 : 1);
    for (; ; ) {
      let o = t.docView.nearestDesc(r, !0);
      if (!o)
        break;
      if (o.node.isBlock) {
        r = o.contentDOM || o.dom;
        break;
      }
      r = o.dom.parentNode;
    }
    let i = G4(t, s.pos, 1);
    for (let o = r.firstChild; o; o = o.nextSibling) {
      let a;
      if (o.nodeType == 1)
        a = o.getClientRects();
      else if (o.nodeType == 3)
        a = Ci(o, 0, o.nodeValue.length).getClientRects();
      else
        continue;
      for (let c = 0; c < a.length; c++) {
        let l = a[c];
        if (l.bottom > l.top + 1 && (A == "up" ? i.top - l.top > (l.bottom - i.top) * 2 : l.bottom - i.bottom > (i.bottom - l.top) * 2))
          return !1;
      }
    }
    return !0;
  });
}
const NT = /[\u0590-\u08ac]/;
function DT(t, e, A) {
  let { $head: n } = e.selection;
  if (!n.parent.isTextblock)
    return !1;
  let s = n.parentOffset, r = !s, i = s == n.parent.content.size, o = t.domSelection();
  return o ? !NT.test(n.parent.textContent) || !o.modify ? A == "left" || A == "backward" ? r : i : z4(t, e, () => {
    let { focusNode: a, focusOffset: c, anchorNode: l, anchorOffset: B } = t.domSelectionRange(), g = o.caretBidiLevel;
    o.modify("move", A, "character");
    let h = n.depth ? t.docView.domAfterPos(n.before()) : t.dom, { focusNode: u, focusOffset: d } = t.domSelectionRange(), w = u && !h.contains(u.nodeType == 1 ? u : u.parentNode) || a == u && c == d;
    try {
      o.collapse(l, B), a && (a != l || c != B) && o.extend && o.extend(a, c);
    } catch {
    }
    return g != null && (o.caretBidiLevel = g), w;
  }) : n.pos == n.start() || n.pos == n.end();
}
let hy = null, uy = null, dy = !1;
function xT(t, e, A) {
  return hy == e && uy == A ? dy : (hy = e, uy = A, dy = A == "up" || A == "down" ? FT(t, e, A) : DT(t, e, A));
}
const js = 0, wy = 1, ba = 2, Sr = 3;
class hh {
  constructor(e, A, n, s) {
    this.parent = e, this.children = A, this.dom = n, this.contentDOM = s, this.dirty = js, n.pmViewDesc = this;
  }
  // Used to check whether a given description corresponds to a
  // widget/mark/node.
  matchesWidget(e) {
    return !1;
  }
  matchesMark(e) {
    return !1;
  }
  matchesNode(e, A, n) {
    return !1;
  }
  matchesHack(e) {
    return !1;
  }
  // When parsing in-editor content (in domchange.js), we allow
  // descriptions to determine the parse rules that should be used to
  // parse them.
  parseRule() {
    return null;
  }
  // Used by the editor's event handler to ignore events that come
  // from certain descs.
  stopEvent(e) {
    return !1;
  }
  // The size of the content represented by this desc.
  get size() {
    let e = 0;
    for (let A = 0; A < this.children.length; A++)
      e += this.children[A].size;
    return e;
  }
  // For block nodes, this represents the space taken up by their
  // start/end tokens.
  get border() {
    return 0;
  }
  destroy() {
    this.parent = void 0, this.dom.pmViewDesc == this && (this.dom.pmViewDesc = void 0);
    for (let e = 0; e < this.children.length; e++)
      this.children[e].destroy();
  }
  posBeforeChild(e) {
    for (let A = 0, n = this.posAtStart; ; A++) {
      let s = this.children[A];
      if (s == e)
        return n;
      n += s.size;
    }
  }
  get posBefore() {
    return this.parent.posBeforeChild(this);
  }
  get posAtStart() {
    return this.parent ? this.parent.posBeforeChild(this) + this.border : 0;
  }
  get posAfter() {
    return this.posBefore + this.size;
  }
  get posAtEnd() {
    return this.posAtStart + this.size - 2 * this.border;
  }
  localPosFromDOM(e, A, n) {
    if (this.contentDOM && this.contentDOM.contains(e.nodeType == 1 ? e : e.parentNode))
      if (n < 0) {
        let r, i;
        if (e == this.contentDOM)
          r = e.childNodes[A - 1];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          r = e.previousSibling;
        }
        for (; r && !((i = r.pmViewDesc) && i.parent == this); )
          r = r.previousSibling;
        return r ? this.posBeforeChild(i) + i.size : this.posAtStart;
      } else {
        let r, i;
        if (e == this.contentDOM)
          r = e.childNodes[A];
        else {
          for (; e.parentNode != this.contentDOM; )
            e = e.parentNode;
          r = e.nextSibling;
        }
        for (; r && !((i = r.pmViewDesc) && i.parent == this); )
          r = r.nextSibling;
        return r ? this.posBeforeChild(i) : this.posAtEnd;
      }
    let s;
    if (e == this.dom && this.contentDOM)
      s = A > PA(this.contentDOM);
    else if (this.contentDOM && this.contentDOM != this.dom && this.dom.contains(this.contentDOM))
      s = e.compareDocumentPosition(this.contentDOM) & 2;
    else if (this.dom.firstChild) {
      if (A == 0)
        for (let r = e; ; r = r.parentNode) {
          if (r == this.dom) {
            s = !1;
            break;
          }
          if (r.previousSibling)
            break;
        }
      if (s == null && A == e.childNodes.length)
        for (let r = e; ; r = r.parentNode) {
          if (r == this.dom) {
            s = !0;
            break;
          }
          if (r.nextSibling)
            break;
        }
    }
    return s ?? n > 0 ? this.posAtEnd : this.posAtStart;
  }
  nearestDesc(e, A = !1) {
    for (let n = !0, s = e; s; s = s.parentNode) {
      let r = this.getDesc(s), i;
      if (r && (!A || r.node))
        if (n && (i = r.nodeDOM) && !(i.nodeType == 1 ? i.contains(e.nodeType == 1 ? e : e.parentNode) : i == e))
          n = !1;
        else
          return r;
    }
  }
  getDesc(e) {
    let A = e.pmViewDesc;
    for (let n = A; n; n = n.parent)
      if (n == this)
        return A;
  }
  posFromDOM(e, A, n) {
    for (let s = e; s; s = s.parentNode) {
      let r = this.getDesc(s);
      if (r)
        return r.localPosFromDOM(e, A, n);
    }
    return -1;
  }
  // Find the desc for the node after the given pos, if any. (When a
  // parent node overrode rendering, there might not be one.)
  descAt(e) {
    for (let A = 0, n = 0; A < this.children.length; A++) {
      let s = this.children[A], r = n + s.size;
      if (n == e && r != n) {
        for (; !s.border && s.children.length; )
          for (let i = 0; i < s.children.length; i++) {
            let o = s.children[i];
            if (o.size) {
              s = o;
              break;
            }
          }
        return s;
      }
      if (e < r)
        return s.descAt(e - n - s.border);
      n = r;
    }
  }
  domFromPos(e, A) {
    if (!this.contentDOM)
      return { node: this.dom, offset: 0, atom: e + 1 };
    let n = 0, s = 0;
    for (let r = 0; n < this.children.length; n++) {
      let i = this.children[n], o = r + i.size;
      if (o > e || i instanceof b4) {
        s = e - r;
        break;
      }
      r = o;
    }
    if (s)
      return this.children[n].domFromPos(s - this.children[n].border, A);
    for (let r; n && !(r = this.children[n - 1]).size && r instanceof U4 && r.side >= 0; n--)
      ;
    if (A <= 0) {
      let r, i = !0;
      for (; r = n ? this.children[n - 1] : null, !(!r || r.dom.parentNode == this.contentDOM); n--, i = !1)
        ;
      return r && A && i && !r.border && !r.domAtom ? r.domFromPos(r.size, A) : { node: this.contentDOM, offset: r ? PA(r.dom) + 1 : 0 };
    } else {
      let r, i = !0;
      for (; r = n < this.children.length ? this.children[n] : null, !(!r || r.dom.parentNode == this.contentDOM); n++, i = !1)
        ;
      return r && i && !r.border && !r.domAtom ? r.domFromPos(0, A) : { node: this.contentDOM, offset: r ? PA(r.dom) : this.contentDOM.childNodes.length };
    }
  }
  // Used to find a DOM range in a single parent for a given changed
  // range.
  parseRange(e, A, n = 0) {
    if (this.children.length == 0)
      return { node: this.contentDOM, from: e, to: A, fromOffset: 0, toOffset: this.contentDOM.childNodes.length };
    let s = -1, r = -1;
    for (let i = n, o = 0; ; o++) {
      let a = this.children[o], c = i + a.size;
      if (s == -1 && e <= c) {
        let l = i + a.border;
        if (e >= l && A <= c - a.border && a.node && a.contentDOM && this.contentDOM.contains(a.contentDOM))
          return a.parseRange(e, A, l);
        e = i;
        for (let B = o; B > 0; B--) {
          let g = this.children[B - 1];
          if (g.size && g.dom.parentNode == this.contentDOM && !g.emptyChildAt(1)) {
            s = PA(g.dom) + 1;
            break;
          }
          e -= g.size;
        }
        s == -1 && (s = 0);
      }
      if (s > -1 && (c > A || o == this.children.length - 1)) {
        A = c;
        for (let l = o + 1; l < this.children.length; l++) {
          let B = this.children[l];
          if (B.size && B.dom.parentNode == this.contentDOM && !B.emptyChildAt(-1)) {
            r = PA(B.dom);
            break;
          }
          A += B.size;
        }
        r == -1 && (r = this.contentDOM.childNodes.length);
        break;
      }
      i = c;
    }
    return { node: this.contentDOM, from: e, to: A, fromOffset: s, toOffset: r };
  }
  emptyChildAt(e) {
    if (this.border || !this.contentDOM || !this.children.length)
      return !1;
    let A = this.children[e < 0 ? 0 : this.children.length - 1];
    return A.size == 0 || A.emptyChildAt(e);
  }
  domAfterPos(e) {
    let { node: A, offset: n } = this.domFromPos(e, 0);
    if (A.nodeType != 1 || n == A.childNodes.length)
      throw new RangeError("No node after pos " + e);
    return A.childNodes[n];
  }
  // View descs are responsible for setting any selection that falls
  // entirely inside of them, so that custom implementations can do
  // custom things with the selection. Note that this falls apart when
  // a selection starts in such a node and ends in another, in which
  // case we just use whatever domFromPos produces as a best effort.
  setSelection(e, A, n, s = !1) {
    let r = Math.min(e, A), i = Math.max(e, A);
    for (let h = 0, u = 0; h < this.children.length; h++) {
      let d = this.children[h], w = u + d.size;
      if (r > u && i < w)
        return d.setSelection(e - u - d.border, A - u - d.border, n, s);
      u = w;
    }
    let o = this.domFromPos(e, e ? -1 : 1), a = A == e ? o : this.domFromPos(A, A ? -1 : 1), c = n.root.getSelection(), l = n.domSelectionRange(), B = !1;
    if ((vs || XA) && e == A) {
      let { node: h, offset: u } = o;
      if (h.nodeType == 3) {
        if (B = !!(u && h.nodeValue[u - 1] == `
`), B && u == h.nodeValue.length)
          for (let d = h, w; d; d = d.parentNode) {
            if (w = d.nextSibling) {
              w.nodeName == "BR" && (o = a = { node: w.parentNode, offset: PA(w) + 1 });
              break;
            }
            let Q = d.pmViewDesc;
            if (Q && Q.node && Q.node.isBlock)
              break;
          }
      } else {
        let d = h.childNodes[u - 1];
        B = d && (d.nodeName == "BR" || d.contentEditable == "false");
      }
    }
    if (vs && l.focusNode && l.focusNode != a.node && l.focusNode.nodeType == 1) {
      let h = l.focusNode.childNodes[l.focusOffset];
      h && h.contentEditable == "false" && (s = !0);
    }
    if (!(s || B && XA) && Za(o.node, o.offset, l.anchorNode, l.anchorOffset) && Za(a.node, a.offset, l.focusNode, l.focusOffset))
      return;
    let g = !1;
    if ((c.extend || e == A) && !(B && vs)) {
      c.collapse(o.node, o.offset);
      try {
        e != A && c.extend(a.node, a.offset), g = !0;
      } catch {
      }
    }
    if (!g) {
      if (e > A) {
        let u = o;
        o = a, a = u;
      }
      let h = document.createRange();
      h.setEnd(a.node, a.offset), h.setStart(o.node, o.offset), c.removeAllRanges(), c.addRange(h);
    }
  }
  ignoreMutation(e) {
    return !this.contentDOM && e.type != "selection";
  }
  get contentLost() {
    return this.contentDOM && this.contentDOM != this.dom && !this.dom.contains(this.contentDOM);
  }
  // Remove a subtree of the element tree that has been touched
  // by a DOM change, so that the next update will redraw it.
  markDirty(e, A) {
    for (let n = 0, s = 0; s < this.children.length; s++) {
      let r = this.children[s], i = n + r.size;
      if (n == i ? e <= i && A >= n : e < i && A > n) {
        let o = n + r.border, a = i - r.border;
        if (e >= o && A <= a) {
          this.dirty = e == n || A == i ? ba : wy, e == o && A == a && (r.contentLost || r.dom.parentNode != this.contentDOM) ? r.dirty = Sr : r.markDirty(e - o, A - o);
          return;
        } else
          r.dirty = r.dom == r.contentDOM && r.dom.parentNode == this.contentDOM && !r.children.length ? ba : Sr;
      }
      n = i;
    }
    this.dirty = ba;
  }
  markParentsDirty() {
    let e = 1;
    for (let A = this.parent; A; A = A.parent, e++) {
      let n = e == 1 ? ba : wy;
      A.dirty < n && (A.dirty = n);
    }
  }
  get domAtom() {
    return !1;
  }
  get ignoreForCoords() {
    return !1;
  }
  get ignoreForSelection() {
    return !1;
  }
  isText(e) {
    return !1;
  }
}
class U4 extends hh {
  constructor(e, A, n, s) {
    let r, i = A.type.toDOM;
    if (typeof i == "function" && (i = i(n, () => {
      if (!r)
        return s;
      if (r.parent)
        return r.parent.posBeforeChild(r);
    })), !A.type.spec.raw) {
      if (i.nodeType != 1) {
        let o = document.createElement("span");
        o.appendChild(i), i = o;
      }
      i.contentEditable = "false", i.classList.add("ProseMirror-widget");
    }
    super(e, [], i, null), this.widget = A, this.widget = A, r = this;
  }
  matchesWidget(e) {
    return this.dirty == js && e.type.eq(this.widget.type);
  }
  parseRule() {
    return { ignore: !0 };
  }
  stopEvent(e) {
    let A = this.widget.spec.stopEvent;
    return A ? A(e) : !1;
  }
  ignoreMutation(e) {
    return e.type != "selection" || this.widget.spec.ignoreSelection;
  }
  destroy() {
    this.widget.type.destroy(this.dom), super.destroy();
  }
  get domAtom() {
    return !0;
  }
  get ignoreForSelection() {
    return !!this.widget.type.spec.relaxedSide;
  }
  get side() {
    return this.widget.type.side;
  }
}
class GT extends hh {
  constructor(e, A, n, s) {
    super(e, [], A, null), this.textDOM = n, this.text = s;
  }
  get size() {
    return this.text.length;
  }
  localPosFromDOM(e, A) {
    return e != this.textDOM ? this.posAtStart + (A ? this.size : 0) : this.posAtStart + A;
  }
  domFromPos(e) {
    return { node: this.textDOM, offset: e };
  }
  ignoreMutation(e) {
    return e.type === "characterData" && e.target.nodeValue == e.oldValue;
  }
}
class qa extends hh {
  constructor(e, A, n, s, r) {
    super(e, [], n, s), this.mark = A, this.spec = r;
  }
  static create(e, A, n, s) {
    let r = s.nodeViews[A.type.name], i = r && r(A, s, n);
    return (!i || !i.dom) && (i = ac.renderSpec(document, A.type.spec.toDOM(A, n), null, A.attrs)), new qa(e, A, i.dom, i.contentDOM || i.dom, i);
  }
  parseRule() {
    return this.dirty & Sr || this.mark.type.spec.reparseInView ? null : { mark: this.mark.type.name, attrs: this.mark.attrs, contentElement: this.contentDOM };
  }
  matchesMark(e) {
    return this.dirty != Sr && this.mark.eq(e);
  }
  markDirty(e, A) {
    if (super.markDirty(e, A), this.dirty != js) {
      let n = this.parent;
      for (; !n.node; )
        n = n.parent;
      n.dirty < this.dirty && (n.dirty = this.dirty), this.dirty = js;
    }
  }
  slice(e, A, n) {
    let s = qa.create(this.parent, this.mark, !0, n), r = this.children, i = this.size;
    A < i && (r = kC(r, A, i, n)), e > 0 && (r = kC(r, 0, e, n));
    for (let o = 0; o < r.length; o++)
      r[o].parent = s;
    return s.children = r, s;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
}
class To extends hh {
  constructor(e, A, n, s, r, i, o, a, c) {
    super(e, [], r, i), this.node = A, this.outerDeco = n, this.innerDeco = s, this.nodeDOM = o;
  }
  // By default, a node is rendered using the `toDOM` method from the
  // node type spec. But client code can use the `nodeViews` spec to
  // supply a custom node view, which can influence various aspects of
  // the way the node works.
  //
  // (Using subclassing for this was intentionally decided against,
  // since it'd require exposing a whole slew of finicky
  // implementation details to the user code that they probably will
  // never need.)
  static create(e, A, n, s, r, i) {
    let o = r.nodeViews[A.type.name], a, c = o && o(A, r, () => {
      if (!a)
        return i;
      if (a.parent)
        return a.parent.posBeforeChild(a);
    }, n, s), l = c && c.dom, B = c && c.contentDOM;
    if (A.isText) {
      if (!l)
        l = document.createTextNode(A.text);
      else if (l.nodeType != 3)
        throw new RangeError("Text must be rendered as a DOM text node");
    } else l || ({ dom: l, contentDOM: B } = ac.renderSpec(document, A.type.spec.toDOM(A), null, A.attrs));
    !B && !A.isText && l.nodeName != "BR" && (l.hasAttribute("contenteditable") || (l.contentEditable = "false"), A.type.spec.draggable && (l.draggable = !0));
    let g = l;
    return l = H4(l, n, A), c ? a = new zT(e, A, n, s, l, B || null, g, c, r, i + 1) : A.isText ? new Fw(e, A, n, s, l, g, r) : new To(e, A, n, s, l, B || null, g, r, i + 1);
  }
  parseRule() {
    if (this.node.type.spec.reparseInView)
      return null;
    let e = { node: this.node.type.name, attrs: this.node.attrs };
    if (this.node.type.whitespace == "pre" && (e.preserveWhitespace = "full"), !this.contentDOM)
      e.getContent = () => this.node.content;
    else if (!this.contentLost)
      e.contentElement = this.contentDOM;
    else {
      for (let A = this.children.length - 1; A >= 0; A--) {
        let n = this.children[A];
        if (this.dom.contains(n.dom.parentNode)) {
          e.contentElement = n.dom.parentNode;
          break;
        }
      }
      e.contentElement || (e.getContent = () => re.empty);
    }
    return e;
  }
  matchesNode(e, A, n) {
    return this.dirty == js && e.eq(this.node) && ju(A, this.outerDeco) && n.eq(this.innerDeco);
  }
  get size() {
    return this.node.nodeSize;
  }
  get border() {
    return this.node.isLeaf ? 0 : 1;
  }
  // Syncs `this.children` to match `this.node.content` and the local
  // decorations, possibly introducing nesting for marks. Then, in a
  // separate step, syncs the DOM inside `this.contentDOM` to
  // `this.children`.
  updateChildren(e, A) {
    let n = this.node.inlineContent, s = A, r = e.composing ? this.localCompositionInfo(e, A) : null, i = r && r.pos > -1 ? r : null, o = r && r.pos < 0, a = new bT(this, i && i.node, e);
    HT(this.node, this.innerDeco, (c, l, B) => {
      c.spec.marks ? a.syncToMarks(c.spec.marks, n, e, l) : c.type.side >= 0 && !B && a.syncToMarks(l == this.node.childCount ? Lt.none : this.node.child(l).marks, n, e, l), a.placeWidget(c, e, s);
    }, (c, l, B, g) => {
      a.syncToMarks(c.marks, n, e, g);
      let h;
      a.findNodeMatch(c, l, B, g) || o && e.state.selection.from > s && e.state.selection.to < s + c.nodeSize && (h = a.findIndexWithChild(r.node)) > -1 && a.updateNodeAt(c, l, B, h, e) || a.updateNextNode(c, l, B, e, g, s) || a.addNode(c, l, B, e, s), s += c.nodeSize;
    }), a.syncToMarks([], n, e, 0), this.node.isTextblock && a.addTextblockHacks(), a.destroyRest(), (a.changed || this.dirty == ba) && (i && this.protectLocalComposition(e, i), v4(this.contentDOM, this.children, e), Ml && kT(this.dom));
  }
  localCompositionInfo(e, A) {
    let { from: n, to: s } = e.state.selection;
    if (!(e.state.selection instanceof Re) || n < A || s > A + this.node.content.size)
      return null;
    let r = e.input.compositionNode;
    if (!r || !this.dom.contains(r.parentNode))
      return null;
    if (this.node.inlineContent) {
      let i = r.nodeValue, o = RT(this.node.content, i, n - A, s - A);
      return o < 0 ? null : { node: r, pos: o, text: i };
    } else
      return { node: r, pos: -1, text: "" };
  }
  protectLocalComposition(e, { node: A, pos: n, text: s }) {
    if (this.getDesc(A))
      return;
    let r = A;
    for (; r.parentNode != this.contentDOM; r = r.parentNode) {
      for (; r.previousSibling; )
        r.parentNode.removeChild(r.previousSibling);
      for (; r.nextSibling; )
        r.parentNode.removeChild(r.nextSibling);
      r.pmViewDesc && (r.pmViewDesc = void 0);
    }
    let i = new GT(this, r, A, s);
    e.input.compositionNodes.push(i), this.children = kC(this.children, n, n + s.length, e, i);
  }
  // If this desc must be updated to match the given node decoration,
  // do so and return true.
  update(e, A, n, s) {
    return this.dirty == Sr || !e.sameMarkup(this.node) ? !1 : (this.updateInner(e, A, n, s), !0);
  }
  updateInner(e, A, n, s) {
    this.updateOuterDeco(A), this.node = e, this.innerDeco = n, this.contentDOM && this.updateChildren(s, this.posAtStart), this.dirty = js;
  }
  updateOuterDeco(e) {
    if (ju(e, this.outerDeco))
      return;
    let A = this.nodeDOM.nodeType != 1, n = this.dom;
    this.dom = j4(this.dom, this.nodeDOM, HC(this.outerDeco, this.node, A), HC(e, this.node, A)), this.dom != n && (n.pmViewDesc = void 0, this.dom.pmViewDesc = this), this.outerDeco = e;
  }
  // Mark this node as being the selected node.
  selectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.add("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && (this.nodeDOM.draggable = !0));
  }
  // Remove selected node marking from this node.
  deselectNode() {
    this.nodeDOM.nodeType == 1 && (this.nodeDOM.classList.remove("ProseMirror-selectednode"), (this.contentDOM || !this.node.type.spec.draggable) && this.nodeDOM.removeAttribute("draggable"));
  }
  get domAtom() {
    return this.node.isAtom;
  }
}
function fy(t, e, A, n, s) {
  H4(n, e, t);
  let r = new To(void 0, t, e, A, n, n, n, s, 0);
  return r.contentDOM && r.updateChildren(s, 0), r;
}
class Fw extends To {
  constructor(e, A, n, s, r, i, o) {
    super(e, A, n, s, r, null, i, o, 0);
  }
  parseRule() {
    let e = this.nodeDOM.parentNode;
    for (; e && e != this.dom && !e.pmIsDeco; )
      e = e.parentNode;
    return { skip: e || !0 };
  }
  update(e, A, n, s) {
    return this.dirty == Sr || this.dirty != js && !this.inParent() || !e.sameMarkup(this.node) ? !1 : (this.updateOuterDeco(A), (this.dirty != js || e.text != this.node.text) && e.text != this.nodeDOM.nodeValue && (this.nodeDOM.nodeValue = e.text, s.trackWrites == this.nodeDOM && (s.trackWrites = null)), this.node = e, this.dirty = js, !0);
  }
  inParent() {
    let e = this.parent.contentDOM;
    for (let A = this.nodeDOM; A; A = A.parentNode)
      if (A == e)
        return !0;
    return !1;
  }
  domFromPos(e) {
    return { node: this.nodeDOM, offset: e };
  }
  localPosFromDOM(e, A, n) {
    return e == this.nodeDOM ? this.posAtStart + Math.min(A, this.node.text.length) : super.localPosFromDOM(e, A, n);
  }
  ignoreMutation(e) {
    return e.type != "characterData" && e.type != "selection";
  }
  slice(e, A, n) {
    let s = this.node.cut(e, A), r = document.createTextNode(s.text);
    return new Fw(this.parent, s, this.outerDeco, this.innerDeco, r, r, n);
  }
  markDirty(e, A) {
    super.markDirty(e, A), this.dom != this.nodeDOM && (e == 0 || A == this.nodeDOM.nodeValue.length) && (this.dirty = Sr);
  }
  get domAtom() {
    return !1;
  }
  isText(e) {
    return this.node.text == e;
  }
}
class b4 extends hh {
  parseRule() {
    return { ignore: !0 };
  }
  matchesHack(e) {
    return this.dirty == js && this.dom.nodeName == e;
  }
  get domAtom() {
    return !0;
  }
  get ignoreForCoords() {
    return this.dom.nodeName == "IMG";
  }
}
class zT extends To {
  constructor(e, A, n, s, r, i, o, a, c, l) {
    super(e, A, n, s, r, i, o, c, l), this.spec = a;
  }
  // A custom `update` method gets to decide whether the update goes
  // through. If it does, and there's a `contentDOM` node, our logic
  // updates the children.
  update(e, A, n, s) {
    if (this.dirty == Sr)
      return !1;
    if (this.spec.update && (this.node.type == e.type || this.spec.multiType)) {
      let r = this.spec.update(e, A, n);
      return r && this.updateInner(e, A, n, s), r;
    } else return !this.contentDOM && !e.isLeaf ? !1 : super.update(e, A, n, s);
  }
  selectNode() {
    this.spec.selectNode ? this.spec.selectNode() : super.selectNode();
  }
  deselectNode() {
    this.spec.deselectNode ? this.spec.deselectNode() : super.deselectNode();
  }
  setSelection(e, A, n, s) {
    this.spec.setSelection ? this.spec.setSelection(e, A, n.root) : super.setSelection(e, A, n, s);
  }
  destroy() {
    this.spec.destroy && this.spec.destroy(), super.destroy();
  }
  stopEvent(e) {
    return this.spec.stopEvent ? this.spec.stopEvent(e) : !1;
  }
  ignoreMutation(e) {
    return this.spec.ignoreMutation ? this.spec.ignoreMutation(e) : super.ignoreMutation(e);
  }
}
function v4(t, e, A) {
  let n = t.firstChild, s = !1;
  for (let r = 0; r < e.length; r++) {
    let i = e[r], o = i.dom;
    if (o.parentNode == t) {
      for (; o != n; )
        n = Qy(n), s = !0;
      n = n.nextSibling;
    } else
      s = !0, t.insertBefore(o, n);
    if (i instanceof qa) {
      let a = n ? n.previousSibling : t.lastChild;
      v4(i.contentDOM, i.children, A), n = a ? a.nextSibling : t.firstChild;
    }
  }
  for (; n; )
    n = Qy(n), s = !0;
  s && A.trackWrites == t && (A.trackWrites = null);
}
const JB = function(t) {
  t && (this.nodeName = t);
};
JB.prototype = /* @__PURE__ */ Object.create(null);
const va = [new JB()];
function HC(t, e, A) {
  if (t.length == 0)
    return va;
  let n = A ? va[0] : new JB(), s = [n];
  for (let r = 0; r < t.length; r++) {
    let i = t[r].type.attrs;
    if (i) {
      i.nodeName && s.push(n = new JB(i.nodeName));
      for (let o in i) {
        let a = i[o];
        a != null && (A && s.length == 1 && s.push(n = new JB(e.isInline ? "span" : "div")), o == "class" ? n.class = (n.class ? n.class + " " : "") + a : o == "style" ? n.style = (n.style ? n.style + ";" : "") + a : o != "nodeName" && (n[o] = a));
      }
    }
  }
  return s;
}
function j4(t, e, A, n) {
  if (A == va && n == va)
    return e;
  let s = e;
  for (let r = 0; r < n.length; r++) {
    let i = n[r], o = A[r];
    if (r) {
      let a;
      o && o.nodeName == i.nodeName && s != t && (a = s.parentNode) && a.nodeName.toLowerCase() == i.nodeName || (a = document.createElement(i.nodeName), a.pmIsDeco = !0, a.appendChild(s), o = va[0]), s = a;
    }
    UT(s, o || va[0], i);
  }
  return s;
}
function UT(t, e, A) {
  for (let n in e)
    n != "class" && n != "style" && n != "nodeName" && !(n in A) && t.removeAttribute(n);
  for (let n in A)
    n != "class" && n != "style" && n != "nodeName" && A[n] != e[n] && t.setAttribute(n, A[n]);
  if (e.class != A.class) {
    let n = e.class ? e.class.split(" ").filter(Boolean) : [], s = A.class ? A.class.split(" ").filter(Boolean) : [];
    for (let r = 0; r < n.length; r++)
      s.indexOf(n[r]) == -1 && t.classList.remove(n[r]);
    for (let r = 0; r < s.length; r++)
      n.indexOf(s[r]) == -1 && t.classList.add(s[r]);
    t.classList.length == 0 && t.removeAttribute("class");
  }
  if (e.style != A.style) {
    if (e.style) {
      let n = /\s*([\w\-\xa1-\uffff]+)\s*:(?:"(?:\\.|[^"])*"|'(?:\\.|[^'])*'|\(.*?\)|[^;])*/g, s;
      for (; s = n.exec(e.style); )
        t.style.removeProperty(s[1]);
    }
    A.style && (t.style.cssText += A.style);
  }
}
function H4(t, e, A) {
  return j4(t, t, va, HC(e, A, t.nodeType != 1));
}
function ju(t, e) {
  if (t.length != e.length)
    return !1;
  for (let A = 0; A < t.length; A++)
    if (!t[A].type.eq(e[A].type))
      return !1;
  return !0;
}
function Qy(t) {
  let e = t.nextSibling;
  return t.parentNode.removeChild(t), e;
}
class bT {
  constructor(e, A, n) {
    this.lock = A, this.view = n, this.index = 0, this.stack = [], this.changed = !1, this.top = e, this.preMatch = vT(e.node.content, e);
  }
  // Destroy and remove the children between the given indices in
  // `this.top`.
  destroyBetween(e, A) {
    if (e != A) {
      for (let n = e; n < A; n++)
        this.top.children[n].destroy();
      this.top.children.splice(e, A - e), this.changed = !0;
    }
  }
  // Destroy all remaining children in `this.top`.
  destroyRest() {
    this.destroyBetween(this.index, this.top.children.length);
  }
  // Sync the current stack of mark descs with the given array of
  // marks, reusing existing mark descs when possible.
  syncToMarks(e, A, n, s) {
    let r = 0, i = this.stack.length >> 1, o = Math.min(i, e.length);
    for (; r < o && (r == i - 1 ? this.top : this.stack[r + 1 << 1]).matchesMark(e[r]) && e[r].type.spec.spanning !== !1; )
      r++;
    for (; r < i; )
      this.destroyRest(), this.top.dirty = js, this.index = this.stack.pop(), this.top = this.stack.pop(), i--;
    for (; i < e.length; ) {
      this.stack.push(this.top, this.index + 1);
      let a = -1, c = this.top.children.length;
      s < this.preMatch.index && (c = Math.min(this.index + 3, c));
      for (let l = this.index; l < c; l++) {
        let B = this.top.children[l];
        if (B.matchesMark(e[i]) && !this.isLocked(B.dom)) {
          a = l;
          break;
        }
      }
      if (a > -1)
        a > this.index && (this.changed = !0, this.destroyBetween(this.index, a)), this.top = this.top.children[this.index];
      else {
        let l = qa.create(this.top, e[i], A, n);
        this.top.children.splice(this.index, 0, l), this.top = l, this.changed = !0;
      }
      this.index = 0, i++;
    }
  }
  // Try to find a node desc matching the given data. Skip over it and
  // return true when successful.
  findNodeMatch(e, A, n, s) {
    let r = -1, i;
    if (s >= this.preMatch.index && (i = this.preMatch.matches[s - this.preMatch.index]).parent == this.top && i.matchesNode(e, A, n))
      r = this.top.children.indexOf(i, this.index);
    else
      for (let o = this.index, a = Math.min(this.top.children.length, o + 5); o < a; o++) {
        let c = this.top.children[o];
        if (c.matchesNode(e, A, n) && !this.preMatch.matched.has(c)) {
          r = o;
          break;
        }
      }
    return r < 0 ? !1 : (this.destroyBetween(this.index, r), this.index++, !0);
  }
  updateNodeAt(e, A, n, s, r) {
    let i = this.top.children[s];
    return i.dirty == Sr && i.dom == i.contentDOM && (i.dirty = ba), i.update(e, A, n, r) ? (this.destroyBetween(this.index, s), this.index++, !0) : !1;
  }
  findIndexWithChild(e) {
    for (; ; ) {
      let A = e.parentNode;
      if (!A)
        return -1;
      if (A == this.top.contentDOM) {
        let n = e.pmViewDesc;
        if (n) {
          for (let s = this.index; s < this.top.children.length; s++)
            if (this.top.children[s] == n)
              return s;
        }
        return -1;
      }
      e = A;
    }
  }
  // Try to update the next node, if any, to the given data. Checks
  // pre-matches to avoid overwriting nodes that could still be used.
  updateNextNode(e, A, n, s, r, i) {
    for (let o = this.index; o < this.top.children.length; o++) {
      let a = this.top.children[o];
      if (a instanceof To) {
        let c = this.preMatch.matched.get(a);
        if (c != null && c != r)
          return !1;
        let l = a.dom, B, g = this.isLocked(l) && !(e.isText && a.node && a.node.isText && a.nodeDOM.nodeValue == e.text && a.dirty != Sr && ju(A, a.outerDeco));
        if (!g && a.update(e, A, n, s))
          return this.destroyBetween(this.index, o), a.dom != l && (this.changed = !0), this.index++, !0;
        if (!g && (B = this.recreateWrapper(a, e, A, n, s, i)))
          return this.destroyBetween(this.index, o), this.top.children[this.index] = B, B.contentDOM && (B.dirty = ba, B.updateChildren(s, i + 1), B.dirty = js), this.changed = !0, this.index++, !0;
        break;
      }
    }
    return !1;
  }
  // When a node with content is replaced by a different node with
  // identical content, move over its children.
  recreateWrapper(e, A, n, s, r, i) {
    if (e.dirty || A.isAtom || !e.children.length || !e.node.content.eq(A.content) || !ju(n, e.outerDeco) || !s.eq(e.innerDeco))
      return null;
    let o = To.create(this.top, A, n, s, r, i);
    if (o.contentDOM) {
      o.children = e.children, e.children = [];
      for (let a of o.children)
        a.parent = o;
    }
    return e.destroy(), o;
  }
  // Insert the node as a newly created node desc.
  addNode(e, A, n, s, r) {
    let i = To.create(this.top, e, A, n, s, r);
    i.contentDOM && i.updateChildren(s, r + 1), this.top.children.splice(this.index++, 0, i), this.changed = !0;
  }
  placeWidget(e, A, n) {
    let s = this.index < this.top.children.length ? this.top.children[this.index] : null;
    if (s && s.matchesWidget(e) && (e == s.widget || !s.widget.type.toDOM.parentNode))
      this.index++;
    else {
      let r = new U4(this.top, e, A, n);
      this.top.children.splice(this.index++, 0, r), this.changed = !0;
    }
  }
  // Make sure a textblock looks and behaves correctly in
  // contentEditable.
  addTextblockHacks() {
    let e = this.top.children[this.index - 1], A = this.top;
    for (; e instanceof qa; )
      A = e, e = A.children[A.children.length - 1];
    (!e || // Empty textblock
    !(e instanceof Fw) || /\n$/.test(e.node.text) || this.view.requiresGeckoHackNode && /\s$/.test(e.node.text)) && ((XA || bA) && e && e.dom.contentEditable == "false" && this.addHackNode("IMG", A), this.addHackNode("BR", this.top));
  }
  addHackNode(e, A) {
    if (A == this.top && this.index < A.children.length && A.children[this.index].matchesHack(e))
      this.index++;
    else {
      let n = document.createElement(e);
      e == "IMG" && (n.className = "ProseMirror-separator", n.alt = ""), e == "BR" && (n.className = "ProseMirror-trailingBreak");
      let s = new b4(this.top, [], n, null);
      A != this.top ? A.children.push(s) : A.children.splice(this.index++, 0, s), this.changed = !0;
    }
  }
  isLocked(e) {
    return this.lock && (e == this.lock || e.nodeType == 1 && e.contains(this.lock.parentNode));
  }
}
function vT(t, e) {
  let A = e, n = A.children.length, s = t.childCount, r = /* @__PURE__ */ new Map(), i = [];
  e: for (; s > 0; ) {
    let o;
    for (; ; )
      if (n) {
        let c = A.children[n - 1];
        if (c instanceof qa)
          A = c, n = c.children.length;
        else {
          o = c, n--;
          break;
        }
      } else {
        if (A == e)
          break e;
        n = A.parent.children.indexOf(A), A = A.parent;
      }
    let a = o.node;
    if (a) {
      if (a != t.child(s - 1))
        break;
      --s, r.set(o, s), i.push(o);
    }
  }
  return { index: s, matched: r, matches: i.reverse() };
}
function jT(t, e) {
  return t.type.side - e.type.side;
}
function HT(t, e, A, n) {
  let s = e.locals(t), r = 0;
  if (s.length == 0) {
    for (let c = 0; c < t.childCount; c++) {
      let l = t.child(c);
      n(l, s, e.forChild(r, l), c), r += l.nodeSize;
    }
    return;
  }
  let i = 0, o = [], a = null;
  for (let c = 0; ; ) {
    let l, B;
    for (; i < s.length && s[i].to == r; ) {
      let w = s[i++];
      w.widget && (l ? (B || (B = [l])).push(w) : l = w);
    }
    if (l)
      if (B) {
        B.sort(jT);
        for (let w = 0; w < B.length; w++)
          A(B[w], c, !!a);
      } else
        A(l, c, !!a);
    let g, h;
    if (a)
      h = -1, g = a, a = null;
    else if (c < t.childCount)
      h = c, g = t.child(c++);
    else
      break;
    for (let w = 0; w < o.length; w++)
      o[w].to <= r && o.splice(w--, 1);
    for (; i < s.length && s[i].from <= r && s[i].to > r; )
      o.push(s[i++]);
    let u = r + g.nodeSize;
    if (g.isText) {
      let w = u;
      i < s.length && s[i].from < w && (w = s[i].from);
      for (let Q = 0; Q < o.length; Q++)
        o[Q].to < w && (w = o[Q].to);
      w < u && (a = g.cut(w - r), g = g.cut(0, w - r), u = w, h = -1);
    } else
      for (; i < s.length && s[i].to < u; )
        i++;
    let d = g.isInline && !g.isLeaf ? o.filter((w) => !w.inline) : o.slice();
    n(g, d, e.forChild(r, g), h), r = u;
  }
}
function kT(t) {
  if (t.nodeName == "UL" || t.nodeName == "OL") {
    let e = t.style.cssText;
    t.style.cssText = e + "; list-style: square !important", window.getComputedStyle(t).listStyle, t.style.cssText = e;
  }
}
function RT(t, e, A, n) {
  for (let s = 0, r = 0; s < t.childCount && r <= n; ) {
    let i = t.child(s++), o = r;
    if (r += i.nodeSize, !i.isText)
      continue;
    let a = i.text;
    for (; s < t.childCount; ) {
      let c = t.child(s++);
      if (r += c.nodeSize, !c.isText)
        break;
      a += c.text;
    }
    if (r >= A) {
      if (r >= n && a.slice(n - e.length - o, n - o) == e)
        return n - e.length;
      let c = o < n ? a.lastIndexOf(e, n - o - 1) : -1;
      if (c >= 0 && c + e.length + o >= A)
        return o + c;
      if (A == n && a.length >= n + e.length - o && a.slice(n - o, n - o + e.length) == e)
        return n;
    }
  }
  return -1;
}
function kC(t, e, A, n, s) {
  let r = [];
  for (let i = 0, o = 0; i < t.length; i++) {
    let a = t[i], c = o, l = o += a.size;
    c >= A || l <= e ? r.push(a) : (c < e && r.push(a.slice(0, e - c, n)), s && (r.push(s), s = void 0), l > A && r.push(a.slice(A - c, a.size, n)));
  }
  return r;
}
function VM(t, e = null) {
  let A = t.domSelectionRange(), n = t.state.doc;
  if (!A.focusNode)
    return null;
  let s = t.docView.nearestDesc(A.focusNode), r = s && s.size == 0, i = t.docView.posFromDOM(A.focusNode, A.focusOffset, 1);
  if (i < 0)
    return null;
  let o = n.resolve(i), a, c;
  if (yw(A)) {
    for (a = i; s && !s.node; )
      s = s.parent;
    let B = s.node;
    if (s && B.isAtom && Ue.isSelectable(B) && s.parent && !(B.isInline && gT(A.focusNode, A.focusOffset, s.dom))) {
      let g = s.posBefore;
      c = new Ue(i == g ? o : n.resolve(g));
    }
  } else {
    if (A instanceof t.dom.ownerDocument.defaultView.Selection && A.rangeCount > 1) {
      let B = i, g = i;
      for (let h = 0; h < A.rangeCount; h++) {
        let u = A.getRangeAt(h);
        B = Math.min(B, t.docView.posFromDOM(u.startContainer, u.startOffset, 1)), g = Math.max(g, t.docView.posFromDOM(u.endContainer, u.endOffset, -1));
      }
      if (B < 0)
        return null;
      [a, i] = g == t.state.selection.anchor ? [g, B] : [B, g], o = n.resolve(i);
    } else
      a = t.docView.posFromDOM(A.anchorNode, A.anchorOffset, 1);
    if (a < 0)
      return null;
  }
  let l = n.resolve(a);
  if (!c) {
    let B = e == "pointer" || t.state.selection.head < o.pos && !r ? 1 : -1;
    c = XM(t, l, o, B);
  }
  return c;
}
function k4(t) {
  return t.editable ? t.hasFocus() : L4(t) && document.activeElement && document.activeElement.contains(t.dom);
}
function zi(t, e = !1) {
  let A = t.state.selection;
  if (R4(t, A), !!k4(t)) {
    if (!e && t.input.mouseDown && t.input.mouseDown.allowDefault && bA) {
      let n = t.domSelectionRange(), s = t.domObserver.currentSelection;
      if (n.anchorNode && s.anchorNode && Za(n.anchorNode, n.anchorOffset, s.anchorNode, s.anchorOffset)) {
        t.input.mouseDown.delayedSelectionSync = !0, t.domObserver.setCurSelection();
        return;
      }
    }
    if (t.domObserver.disconnectSelection(), t.cursorWrapper)
      ST(t);
    else {
      let { anchor: n, head: s } = A, r, i;
      Iy && !(A instanceof Re) && (A.$from.parent.inlineContent || (r = Cy(t, A.from)), !A.empty && !A.$from.parent.inlineContent && (i = Cy(t, A.to))), t.docView.setSelection(n, s, t, e), Iy && (r && Ey(r), i && Ey(i)), A.visible ? t.dom.classList.remove("ProseMirror-hideselection") : (t.dom.classList.add("ProseMirror-hideselection"), "onselectionchange" in document && LT(t));
    }
    t.domObserver.setCurSelection(), t.domObserver.connectSelection();
  }
}
const Iy = XA || bA && Y4 < 63;
function Cy(t, e) {
  let { node: A, offset: n } = t.docView.domFromPos(e, 0), s = n < A.childNodes.length ? A.childNodes[n] : null, r = n ? A.childNodes[n - 1] : null;
  if (XA && s && s.contentEditable == "false")
    return mQ(s);
  if ((!s || s.contentEditable == "false") && (!r || r.contentEditable == "false")) {
    if (s)
      return mQ(s);
    if (r)
      return mQ(r);
  }
}
function mQ(t) {
  return t.contentEditable = "true", XA && t.draggable && (t.draggable = !1, t.wasDraggable = !0), t;
}
function Ey(t) {
  t.contentEditable = "false", t.wasDraggable && (t.draggable = !0, t.wasDraggable = null);
}
function LT(t) {
  let e = t.dom.ownerDocument;
  e.removeEventListener("selectionchange", t.input.hideSelectionGuard);
  let A = t.domSelectionRange(), n = A.anchorNode, s = A.anchorOffset;
  e.addEventListener("selectionchange", t.input.hideSelectionGuard = () => {
    (A.anchorNode != n || A.anchorOffset != s) && (e.removeEventListener("selectionchange", t.input.hideSelectionGuard), setTimeout(() => {
      (!k4(t) || t.state.selection.visible) && t.dom.classList.remove("ProseMirror-hideselection");
    }, 20));
  });
}
function ST(t) {
  let e = t.domSelection();
  if (!e)
    return;
  let A = t.cursorWrapper.dom, n = A.nodeName == "IMG";
  n ? e.collapse(A.parentNode, PA(A) + 1) : e.collapse(A, 0), !n && !t.state.selection.visible && Zn && So <= 11 && (A.disabled = !0, A.disabled = !1);
}
function R4(t, e) {
  if (e instanceof Ue) {
    let A = t.docView.descAt(e.from);
    A != t.lastSelectedViewDesc && (My(t), A && A.selectNode(), t.lastSelectedViewDesc = A);
  } else
    My(t);
}
function My(t) {
  t.lastSelectedViewDesc && (t.lastSelectedViewDesc.parent && t.lastSelectedViewDesc.deselectNode(), t.lastSelectedViewDesc = void 0);
}
function XM(t, e, A, n) {
  return t.someProp("createSelectionBetween", (s) => s(t, e, A)) || Re.between(e, A, n);
}
function py(t) {
  return t.editable && !t.hasFocus() ? !1 : L4(t);
}
function L4(t) {
  let e = t.domSelectionRange();
  if (!e.anchorNode)
    return !1;
  try {
    return t.dom.contains(e.anchorNode.nodeType == 3 ? e.anchorNode.parentNode : e.anchorNode) && (t.editable || t.dom.contains(e.focusNode.nodeType == 3 ? e.focusNode.parentNode : e.focusNode));
  } catch {
    return !1;
  }
}
function TT(t) {
  let e = t.docView.domFromPos(t.state.selection.anchor, 0), A = t.domSelectionRange();
  return Za(e.node, e.offset, A.anchorNode, A.anchorOffset);
}
function RC(t, e) {
  let { $anchor: A, $head: n } = t.selection, s = e > 0 ? A.max(n) : A.min(n), r = s.parent.inlineContent ? s.depth ? t.doc.resolve(e > 0 ? s.after() : s.before()) : null : s;
  return r && Ke.findFrom(r, e);
}
function Mo(t, e) {
  return t.dispatch(t.state.tr.setSelection(e).scrollIntoView()), !0;
}
function my(t, e, A) {
  let n = t.state.selection;
  if (n instanceof Re)
    if (A.indexOf("s") > -1) {
      let { $head: s } = n, r = s.textOffset ? null : e < 0 ? s.nodeBefore : s.nodeAfter;
      if (!r || r.isText || !r.isLeaf)
        return !1;
      let i = t.state.doc.resolve(s.pos + r.nodeSize * (e < 0 ? -1 : 1));
      return Mo(t, new Re(n.$anchor, i));
    } else if (n.empty) {
      if (t.endOfTextblock(e > 0 ? "forward" : "backward")) {
        let s = RC(t.state, e);
        return s && s instanceof Ue ? Mo(t, s) : !1;
      } else if (!(ms && A.indexOf("m") > -1)) {
        let s = n.$head, r = s.textOffset ? null : e < 0 ? s.nodeBefore : s.nodeAfter, i;
        if (!r || r.isText)
          return !1;
        let o = e < 0 ? s.pos - r.nodeSize : s.pos;
        return r.isAtom || (i = t.docView.descAt(o)) && !i.contentDOM ? Ue.isSelectable(r) ? Mo(t, new Ue(e < 0 ? t.state.doc.resolve(s.pos - r.nodeSize) : s)) : gh ? Mo(t, new Re(t.state.doc.resolve(e < 0 ? o : o + r.nodeSize))) : !1 : !1;
      }
    } else return !1;
  else {
    if (n instanceof Ue && n.node.isInline)
      return Mo(t, new Re(e > 0 ? n.$to : n.$from));
    {
      let s = RC(t.state, e);
      return s ? Mo(t, s) : !1;
    }
  }
}
function Hu(t) {
  return t.nodeType == 3 ? t.nodeValue.length : t.childNodes.length;
}
function WB(t, e) {
  let A = t.pmViewDesc;
  return A && A.size == 0 && (e < 0 || t.nextSibling || t.nodeName != "BR");
}
function Dc(t, e) {
  return e < 0 ? JT(t) : WT(t);
}
function JT(t) {
  let e = t.domSelectionRange(), A = e.focusNode, n = e.focusOffset;
  if (!A)
    return;
  let s, r, i = !1;
  for (vs && A.nodeType == 1 && n < Hu(A) && WB(A.childNodes[n], -1) && (i = !0); ; )
    if (n > 0) {
      if (A.nodeType != 1)
        break;
      {
        let o = A.childNodes[n - 1];
        if (WB(o, -1))
          s = A, r = --n;
        else if (o.nodeType == 3)
          A = o, n = A.nodeValue.length;
        else
          break;
      }
    } else {
      if (S4(A))
        break;
      {
        let o = A.previousSibling;
        for (; o && WB(o, -1); )
          s = A.parentNode, r = PA(o), o = o.previousSibling;
        if (o)
          A = o, n = Hu(A);
        else {
          if (A = A.parentNode, A == t.dom)
            break;
          n = 0;
        }
      }
    }
  i ? LC(t, A, n) : s && LC(t, s, r);
}
function WT(t) {
  let e = t.domSelectionRange(), A = e.focusNode, n = e.focusOffset;
  if (!A)
    return;
  let s = Hu(A), r, i;
  for (; ; )
    if (n < s) {
      if (A.nodeType != 1)
        break;
      let o = A.childNodes[n];
      if (WB(o, 1))
        r = A, i = ++n;
      else
        break;
    } else {
      if (S4(A))
        break;
      {
        let o = A.nextSibling;
        for (; o && WB(o, 1); )
          r = o.parentNode, i = PA(o) + 1, o = o.nextSibling;
        if (o)
          A = o, n = 0, s = Hu(A);
        else {
          if (A = A.parentNode, A == t.dom)
            break;
          n = s = 0;
        }
      }
    }
  r && LC(t, r, i);
}
function S4(t) {
  let e = t.pmViewDesc;
  return e && e.node && e.node.isBlock;
}
function OT(t, e) {
  for (; t && e == t.childNodes.length && !Bh(t); )
    e = PA(t) + 1, t = t.parentNode;
  for (; t && e < t.childNodes.length; ) {
    let A = t.childNodes[e];
    if (A.nodeType == 3)
      return A;
    if (A.nodeType == 1 && A.contentEditable == "false")
      break;
    t = A, e = 0;
  }
}
function PT(t, e) {
  for (; t && !e && !Bh(t); )
    e = PA(t), t = t.parentNode;
  for (; t && e; ) {
    let A = t.childNodes[e - 1];
    if (A.nodeType == 3)
      return A;
    if (A.nodeType == 1 && A.contentEditable == "false")
      break;
    t = A, e = t.childNodes.length;
  }
}
function LC(t, e, A) {
  if (e.nodeType != 3) {
    let r, i;
    (i = OT(e, A)) ? (e = i, A = 0) : (r = PT(e, A)) && (e = r, A = r.nodeValue.length);
  }
  let n = t.domSelection();
  if (!n)
    return;
  if (yw(n)) {
    let r = document.createRange();
    r.setEnd(e, A), r.setStart(e, A), n.removeAllRanges(), n.addRange(r);
  } else n.extend && n.extend(e, A);
  t.domObserver.setCurSelection();
  let { state: s } = t;
  setTimeout(() => {
    t.state == s && zi(t);
  }, 50);
}
function Yy(t, e) {
  let A = t.state.doc.resolve(e);
  if (!(bA || y4) && A.parent.inlineContent) {
    let s = t.coordsAtPos(e);
    if (e > A.start()) {
      let r = t.coordsAtPos(e - 1), i = (r.top + r.bottom) / 2;
      if (i > s.top && i < s.bottom && Math.abs(r.left - s.left) > 1)
        return r.left < s.left ? "ltr" : "rtl";
    }
    if (e < A.end()) {
      let r = t.coordsAtPos(e + 1), i = (r.top + r.bottom) / 2;
      if (i > s.top && i < s.bottom && Math.abs(r.left - s.left) > 1)
        return r.left > s.left ? "ltr" : "rtl";
    }
  }
  return getComputedStyle(t.dom).direction == "rtl" ? "rtl" : "ltr";
}
function yy(t, e, A) {
  let n = t.state.selection;
  if (n instanceof Re && !n.empty || A.indexOf("s") > -1 || ms && A.indexOf("m") > -1)
    return !1;
  let { $from: s, $to: r } = n;
  if (!s.parent.inlineContent || t.endOfTextblock(e < 0 ? "up" : "down")) {
    let i = RC(t.state, e);
    if (i && i instanceof Ue)
      return Mo(t, i);
  }
  if (!s.parent.inlineContent) {
    let i = e < 0 ? s : r, o = n instanceof Xn ? Ke.near(i, e) : Ke.findFrom(i, e);
    return o ? Mo(t, o) : !1;
  }
  return !1;
}
function Fy(t, e) {
  if (!(t.state.selection instanceof Re))
    return !0;
  let { $head: A, $anchor: n, empty: s } = t.state.selection;
  if (!A.sameParent(n))
    return !0;
  if (!s)
    return !1;
  if (t.endOfTextblock(e > 0 ? "forward" : "backward"))
    return !0;
  let r = !A.textOffset && (e < 0 ? A.nodeBefore : A.nodeAfter);
  if (r && !r.isText) {
    let i = t.state.tr;
    return e < 0 ? i.delete(A.pos - r.nodeSize, A.pos) : i.delete(A.pos, A.pos + r.nodeSize), t.dispatch(i), !0;
  }
  return !1;
}
function Ny(t, e, A) {
  t.domObserver.stop(), e.contentEditable = A, t.domObserver.start();
}
function KT(t) {
  if (!XA || t.state.selection.$head.parentOffset > 0)
    return !1;
  let { focusNode: e, focusOffset: A } = t.domSelectionRange();
  if (e && e.nodeType == 1 && A == 0 && e.firstChild && e.firstChild.contentEditable == "false") {
    let n = e.firstChild;
    Ny(t, n, "true"), setTimeout(() => Ny(t, n, "false"), 20);
  }
  return !1;
}
function VT(t) {
  let e = "";
  return t.ctrlKey && (e += "c"), t.metaKey && (e += "m"), t.altKey && (e += "a"), t.shiftKey && (e += "s"), e;
}
function XT(t, e) {
  let A = e.keyCode, n = VT(e);
  if (A == 8 || ms && A == 72 && n == "c")
    return Fy(t, -1) || Dc(t, -1);
  if (A == 46 && !e.shiftKey || ms && A == 68 && n == "c")
    return Fy(t, 1) || Dc(t, 1);
  if (A == 13 || A == 27)
    return !0;
  if (A == 37 || ms && A == 66 && n == "c") {
    let s = A == 37 ? Yy(t, t.state.selection.from) == "ltr" ? -1 : 1 : -1;
    return my(t, s, n) || Dc(t, s);
  } else if (A == 39 || ms && A == 70 && n == "c") {
    let s = A == 39 ? Yy(t, t.state.selection.from) == "ltr" ? 1 : -1 : 1;
    return my(t, s, n) || Dc(t, s);
  } else {
    if (A == 38 || ms && A == 80 && n == "c")
      return yy(t, -1, n) || Dc(t, -1);
    if (A == 40 || ms && A == 78 && n == "c")
      return KT(t) || yy(t, 1, n) || Dc(t, 1);
    if (n == (ms ? "m" : "c") && (A == 66 || A == 73 || A == 89 || A == 90))
      return !0;
  }
  return !1;
}
function ZM(t, e) {
  t.someProp("transformCopied", (h) => {
    e = h(e, t);
  });
  let A = [], { content: n, openStart: s, openEnd: r } = e;
  for (; s > 1 && r > 1 && n.childCount == 1 && n.firstChild.childCount == 1; ) {
    s--, r--;
    let h = n.firstChild;
    A.push(h.type.name, h.attrs != h.type.defaultAttrs ? h.attrs : null), n = h.content;
  }
  let i = t.someProp("clipboardSerializer") || ac.fromSchema(t.state.schema), o = K4(), a = o.createElement("div");
  a.appendChild(i.serializeFragment(n, { document: o }));
  let c = a.firstChild, l, B = 0;
  for (; c && c.nodeType == 1 && (l = P4[c.nodeName.toLowerCase()]); ) {
    for (let h = l.length - 1; h >= 0; h--) {
      let u = o.createElement(l[h]);
      for (; a.firstChild; )
        u.appendChild(a.firstChild);
      a.appendChild(u), B++;
    }
    c = a.firstChild;
  }
  c && c.nodeType == 1 && c.setAttribute("data-pm-slice", `${s} ${r}${B ? ` -${B}` : ""} ${JSON.stringify(A)}`);
  let g = t.someProp("clipboardTextSerializer", (h) => h(e, t)) || e.content.textBetween(0, e.content.size, `

`);
  return { dom: a, text: g, slice: e };
}
function T4(t, e, A, n, s) {
  let r = s.parent.type.spec.code, i, o;
  if (!A && !e)
    return null;
  let a = !!e && (n || r || !A);
  if (a) {
    if (t.someProp("transformPastedText", (g) => {
      e = g(e, r || n, t);
    }), r)
      return o = new Ee(re.from(t.state.schema.text(e.replace(/\r\n?/g, `
`))), 0, 0), t.someProp("transformPasted", (g) => {
        o = g(o, t, !0);
      }), o;
    let B = t.someProp("clipboardTextParser", (g) => g(e, s, n, t));
    if (B)
      o = B;
    else {
      let g = s.marks(), { schema: h } = t.state, u = ac.fromSchema(h);
      i = document.createElement("div"), e.split(/(?:\r\n?|\n)+/).forEach((d) => {
        let w = i.appendChild(document.createElement("p"));
        d && w.appendChild(u.serializeNode(h.text(d, g)));
      });
    }
  } else
    t.someProp("transformPastedHTML", (B) => {
      A = B(A, t);
    }), i = $T(A), gh && e9(i);
  let c = i && i.querySelector("[data-pm-slice]"), l = c && /^(\d+) (\d+)(?: -(\d+))? (.*)/.exec(c.getAttribute("data-pm-slice") || "");
  if (l && l[3])
    for (let B = +l[3]; B > 0; B--) {
      let g = i.firstChild;
      for (; g && g.nodeType != 1; )
        g = g.nextSibling;
      if (!g)
        break;
      i = g;
    }
  if (o || (o = (t.someProp("clipboardParser") || t.someProp("domParser") || SB.fromSchema(t.state.schema)).parseSlice(i, {
    preserveWhitespace: !!(a || l),
    context: s,
    ruleFromNode(g) {
      return g.nodeName == "BR" && !g.nextSibling && g.parentNode && !ZT.test(g.parentNode.nodeName) ? { ignore: !0 } : null;
    }
  })), l)
    o = t9(Dy(o, +l[1], +l[2]), l[4]);
  else if (o = Ee.maxOpen(qT(o.content, s), !0), o.openStart || o.openEnd) {
    let B = 0, g = 0;
    for (let h = o.content.firstChild; B < o.openStart && !h.type.spec.isolating; B++, h = h.firstChild)
      ;
    for (let h = o.content.lastChild; g < o.openEnd && !h.type.spec.isolating; g++, h = h.lastChild)
      ;
    o = Dy(o, B, g);
  }
  return t.someProp("transformPasted", (B) => {
    o = B(o, t, a);
  }), o;
}
const ZT = /^(a|abbr|acronym|b|cite|code|del|em|i|ins|kbd|label|output|q|ruby|s|samp|span|strong|sub|sup|time|u|tt|var)$/i;
function qT(t, e) {
  if (t.childCount < 2)
    return t;
  for (let A = e.depth; A >= 0; A--) {
    let s = e.node(A).contentMatchAt(e.index(A)), r, i = [];
    if (t.forEach((o) => {
      if (!i)
        return;
      let a = s.findWrapping(o.type), c;
      if (!a)
        return i = null;
      if (c = i.length && r.length && W4(a, r, o, i[i.length - 1], 0))
        i[i.length - 1] = c;
      else {
        i.length && (i[i.length - 1] = O4(i[i.length - 1], r.length));
        let l = J4(o, a);
        i.push(l), s = s.matchType(l.type), r = a;
      }
    }), i)
      return re.from(i);
  }
  return t;
}
function J4(t, e, A = 0) {
  for (let n = e.length - 1; n >= A; n--)
    t = e[n].create(null, re.from(t));
  return t;
}
function W4(t, e, A, n, s) {
  if (s < t.length && s < e.length && t[s] == e[s]) {
    let r = W4(t, e, A, n.lastChild, s + 1);
    if (r)
      return n.copy(n.content.replaceChild(n.childCount - 1, r));
    if (n.contentMatchAt(n.childCount).matchType(s == t.length - 1 ? A.type : t[s + 1]))
      return n.copy(n.content.append(re.from(J4(A, t, s + 1))));
  }
}
function O4(t, e) {
  if (e == 0)
    return t;
  let A = t.content.replaceChild(t.childCount - 1, O4(t.lastChild, e - 1)), n = t.contentMatchAt(t.childCount).fillBefore(re.empty, !0);
  return t.copy(A.append(n));
}
function SC(t, e, A, n, s, r) {
  let i = e < 0 ? t.firstChild : t.lastChild, o = i.content;
  return t.childCount > 1 && (r = 0), s < n - 1 && (o = SC(o, e, A, n, s + 1, r)), s >= A && (o = e < 0 ? i.contentMatchAt(0).fillBefore(o, r <= s).append(o) : o.append(i.contentMatchAt(i.childCount).fillBefore(re.empty, !0))), t.replaceChild(e < 0 ? 0 : t.childCount - 1, i.copy(o));
}
function Dy(t, e, A) {
  return e < t.openStart && (t = new Ee(SC(t.content, -1, e, t.openStart, 0, t.openEnd), e, t.openEnd)), A < t.openEnd && (t = new Ee(SC(t.content, 1, A, t.openEnd, 0, 0), t.openStart, A)), t;
}
const P4 = {
  thead: ["table"],
  tbody: ["table"],
  tfoot: ["table"],
  caption: ["table"],
  colgroup: ["table"],
  col: ["table", "colgroup"],
  tr: ["table", "tbody"],
  td: ["table", "tbody", "tr"],
  th: ["table", "tbody", "tr"]
};
let xy = null;
function K4() {
  return xy || (xy = document.implementation.createHTMLDocument("title"));
}
let YQ = null;
function _T(t) {
  let e = window.trustedTypes;
  return e ? (YQ || (YQ = e.defaultPolicy || e.createPolicy("ProseMirrorClipboard", { createHTML: (A) => A })), YQ.createHTML(t)) : t;
}
function $T(t) {
  let e = /^(\s*<meta [^>]*>)*/.exec(t);
  e && (t = t.slice(e[0].length));
  let A = K4().createElement("div"), n = /<([a-z][^>\s]+)/i.exec(t), s;
  if ((s = n && P4[n[1].toLowerCase()]) && (t = s.map((r) => "<" + r + ">").join("") + t + s.map((r) => "</" + r + ">").reverse().join("")), A.innerHTML = _T(t), s)
    for (let r = 0; r < s.length; r++)
      A = A.querySelector(s[r]) || A;
  return A;
}
function e9(t) {
  let e = t.querySelectorAll(bA ? "span:not([class]):not([style])" : "span.Apple-converted-space");
  for (let A = 0; A < e.length; A++) {
    let n = e[A];
    n.childNodes.length == 1 && n.textContent == " " && n.parentNode && n.parentNode.replaceChild(t.ownerDocument.createTextNode(" "), n);
  }
}
function t9(t, e) {
  if (!t.size)
    return t;
  let A = t.content.firstChild.type.schema, n;
  try {
    n = JSON.parse(e);
  } catch {
    return t;
  }
  let { content: s, openStart: r, openEnd: i } = t;
  for (let o = n.length - 2; o >= 0; o -= 2) {
    let a = A.nodes[n[o]];
    if (!a || a.hasRequiredAttrs())
      break;
    s = re.from(a.create(n[o + 1], s)), r++, i++;
  }
  return new Ee(s, r, i);
}
const xn = {}, Gn = {}, A9 = { touchstart: !0, touchmove: !0 };
class n9 {
  constructor() {
    this.shiftKey = !1, this.mouseDown = null, this.lastKeyCode = null, this.lastKeyCodeTime = 0, this.lastClick = { time: 0, x: 0, y: 0, type: "", button: 0 }, this.lastSelectionOrigin = null, this.lastSelectionTime = 0, this.lastIOSEnter = 0, this.lastIOSEnterFallbackTimeout = -1, this.lastFocus = 0, this.lastTouch = 0, this.lastChromeDelete = 0, this.composing = !1, this.compositionNode = null, this.composingTimeout = -1, this.compositionNodes = [], this.compositionEndedAt = -2e8, this.compositionID = 1, this.badSafariComposition = !1, this.compositionPendingChanges = 0, this.domChangeCount = 0, this.eventHandlers = /* @__PURE__ */ Object.create(null), this.hideSelectionGuard = null;
  }
}
function s9(t) {
  for (let e in xn) {
    let A = xn[e];
    t.dom.addEventListener(e, t.input.eventHandlers[e] = (n) => {
      i9(t, n) && !qM(t, n) && (t.editable || !(n.type in Gn)) && A(t, n);
    }, A9[e] ? { passive: !0 } : void 0);
  }
  XA && t.dom.addEventListener("input", () => null), TC(t);
}
function vo(t, e) {
  t.input.lastSelectionOrigin = e, t.input.lastSelectionTime = Date.now();
}
function r9(t) {
  t.domObserver.stop();
  for (let e in t.input.eventHandlers)
    t.dom.removeEventListener(e, t.input.eventHandlers[e]);
  clearTimeout(t.input.composingTimeout), clearTimeout(t.input.lastIOSEnterFallbackTimeout);
}
function TC(t) {
  t.someProp("handleDOMEvents", (e) => {
    for (let A in e)
      t.input.eventHandlers[A] || t.dom.addEventListener(A, t.input.eventHandlers[A] = (n) => qM(t, n));
  });
}
function qM(t, e) {
  return t.someProp("handleDOMEvents", (A) => {
    let n = A[e.type];
    return n ? n(t, e) || e.defaultPrevented : !1;
  });
}
function i9(t, e) {
  if (!e.bubbles)
    return !0;
  if (e.defaultPrevented)
    return !1;
  for (let A = e.target; A != t.dom; A = A.parentNode)
    if (!A || A.nodeType == 11 || A.pmViewDesc && A.pmViewDesc.stopEvent(e))
      return !1;
  return !0;
}
function o9(t, e) {
  !qM(t, e) && xn[e.type] && (t.editable || !(e.type in Gn)) && xn[e.type](t, e);
}
Gn.keydown = (t, e) => {
  let A = e;
  if (t.input.shiftKey = A.keyCode == 16 || A.shiftKey, !X4(t, A) && (t.input.lastKeyCode = A.keyCode, t.input.lastKeyCodeTime = Date.now(), !(yi && bA && A.keyCode == 13)))
    if (A.keyCode != 229 && t.domObserver.forceFlush(), Ml && A.keyCode == 13 && !A.ctrlKey && !A.altKey && !A.metaKey) {
      let n = Date.now();
      t.input.lastIOSEnter = n, t.input.lastIOSEnterFallbackTimeout = setTimeout(() => {
        t.input.lastIOSEnter == n && (t.someProp("handleKeyDown", (s) => s(t, za(13, "Enter"))), t.input.lastIOSEnter = 0);
      }, 200);
    } else t.someProp("handleKeyDown", (n) => n(t, A)) || XT(t, A) ? A.preventDefault() : vo(t, "key");
};
Gn.keyup = (t, e) => {
  e.keyCode == 16 && (t.input.shiftKey = !1);
};
Gn.keypress = (t, e) => {
  let A = e;
  if (X4(t, A) || !A.charCode || A.ctrlKey && !A.altKey || ms && A.metaKey)
    return;
  if (t.someProp("handleKeyPress", (s) => s(t, A))) {
    A.preventDefault();
    return;
  }
  let n = t.state.selection;
  if (!(n instanceof Re) || !n.$from.sameParent(n.$to)) {
    let s = String.fromCharCode(A.charCode), r = () => t.state.tr.insertText(s).scrollIntoView();
    !/[\r\n]/.test(s) && !t.someProp("handleTextInput", (i) => i(t, n.$from.pos, n.$to.pos, s, r)) && t.dispatch(r()), A.preventDefault();
  }
};
function Nw(t) {
  return { left: t.clientX, top: t.clientY };
}
function a9(t, e) {
  let A = e.x - t.clientX, n = e.y - t.clientY;
  return A * A + n * n < 100;
}
function _M(t, e, A, n, s) {
  if (n == -1)
    return !1;
  let r = t.state.doc.resolve(n);
  for (let i = r.depth + 1; i > 0; i--)
    if (t.someProp(e, (o) => i > r.depth ? o(t, A, r.nodeAfter, r.before(i), s, !0) : o(t, A, r.node(i), r.before(i), s, !1)))
      return !0;
  return !1;
}
function il(t, e, A) {
  if (t.focused || t.focus(), t.state.selection.eq(e))
    return;
  let n = t.state.tr.setSelection(e);
  n.setMeta("pointer", !0), t.dispatch(n);
}
function c9(t, e) {
  if (e == -1)
    return !1;
  let A = t.state.doc.resolve(e), n = A.nodeAfter;
  return n && n.isAtom && Ue.isSelectable(n) ? (il(t, new Ue(A)), !0) : !1;
}
function l9(t, e) {
  if (e == -1)
    return !1;
  let A = t.state.selection, n, s;
  A instanceof Ue && (n = A.node);
  let r = t.state.doc.resolve(e);
  for (let i = r.depth + 1; i > 0; i--) {
    let o = i > r.depth ? r.nodeAfter : r.node(i);
    if (Ue.isSelectable(o)) {
      n && A.$from.depth > 0 && i >= A.$from.depth && r.before(A.$from.depth + 1) == A.$from.pos ? s = r.before(A.$from.depth) : s = r.before(i);
      break;
    }
  }
  return s != null ? (il(t, Ue.create(t.state.doc, s)), !0) : !1;
}
function B9(t, e, A, n, s) {
  return _M(t, "handleClickOn", e, A, n) || t.someProp("handleClick", (r) => r(t, e, n)) || (s ? l9(t, A) : c9(t, A));
}
function g9(t, e, A, n) {
  return _M(t, "handleDoubleClickOn", e, A, n) || t.someProp("handleDoubleClick", (s) => s(t, e, n));
}
function h9(t, e, A, n) {
  return _M(t, "handleTripleClickOn", e, A, n) || t.someProp("handleTripleClick", (s) => s(t, e, n)) || u9(t, A, n);
}
function u9(t, e, A) {
  if (A.button != 0)
    return !1;
  let n = t.state.doc;
  if (e == -1)
    return n.inlineContent ? (il(t, Re.create(n, 0, n.content.size)), !0) : !1;
  let s = n.resolve(e);
  for (let r = s.depth + 1; r > 0; r--) {
    let i = r > s.depth ? s.nodeAfter : s.node(r), o = s.before(r);
    if (i.inlineContent)
      il(t, Re.create(n, o + 1, o + 1 + i.content.size));
    else if (Ue.isSelectable(i))
      il(t, Ue.create(n, o));
    else
      continue;
    return !0;
  }
}
function $M(t) {
  return ku(t);
}
const V4 = ms ? "metaKey" : "ctrlKey";
xn.mousedown = (t, e) => {
  let A = e;
  t.input.shiftKey = A.shiftKey;
  let n = $M(t), s = Date.now(), r = "singleClick";
  s - t.input.lastClick.time < 500 && a9(A, t.input.lastClick) && !A[V4] && t.input.lastClick.button == A.button && (t.input.lastClick.type == "singleClick" ? r = "doubleClick" : t.input.lastClick.type == "doubleClick" && (r = "tripleClick")), t.input.lastClick = { time: s, x: A.clientX, y: A.clientY, type: r, button: A.button };
  let i = t.posAtCoords(Nw(A));
  i && (r == "singleClick" ? (t.input.mouseDown && t.input.mouseDown.done(), t.input.mouseDown = new d9(t, i, A, !!n)) : (r == "doubleClick" ? g9 : h9)(t, i.pos, i.inside, A) ? A.preventDefault() : vo(t, "pointer"));
};
class d9 {
  constructor(e, A, n, s) {
    this.view = e, this.pos = A, this.event = n, this.flushed = s, this.delayedSelectionSync = !1, this.mightDrag = null, this.startDoc = e.state.doc, this.selectNode = !!n[V4], this.allowDefault = n.shiftKey;
    let r, i;
    if (A.inside > -1)
      r = e.state.doc.nodeAt(A.inside), i = A.inside;
    else {
      let l = e.state.doc.resolve(A.pos);
      r = l.parent, i = l.depth ? l.before() : 0;
    }
    const o = s ? null : n.target, a = o ? e.docView.nearestDesc(o, !0) : null;
    this.target = a && a.nodeDOM.nodeType == 1 ? a.nodeDOM : null;
    let { selection: c } = e.state;
    (n.button == 0 && r.type.spec.draggable && r.type.spec.selectable !== !1 || c instanceof Ue && c.from <= i && c.to > i) && (this.mightDrag = {
      node: r,
      pos: i,
      addAttr: !!(this.target && !this.target.draggable),
      setUneditable: !!(this.target && vs && !this.target.hasAttribute("contentEditable"))
    }), this.target && this.mightDrag && (this.mightDrag.addAttr || this.mightDrag.setUneditable) && (this.view.domObserver.stop(), this.mightDrag.addAttr && (this.target.draggable = !0), this.mightDrag.setUneditable && setTimeout(() => {
      this.view.input.mouseDown == this && this.target.setAttribute("contentEditable", "false");
    }, 20), this.view.domObserver.start()), e.root.addEventListener("mouseup", this.up = this.up.bind(this)), e.root.addEventListener("mousemove", this.move = this.move.bind(this)), vo(e, "pointer");
  }
  done() {
    this.view.root.removeEventListener("mouseup", this.up), this.view.root.removeEventListener("mousemove", this.move), this.mightDrag && this.target && (this.view.domObserver.stop(), this.mightDrag.addAttr && this.target.removeAttribute("draggable"), this.mightDrag.setUneditable && this.target.removeAttribute("contentEditable"), this.view.domObserver.start()), this.delayedSelectionSync && setTimeout(() => zi(this.view)), this.view.input.mouseDown = null;
  }
  up(e) {
    if (this.done(), !this.view.dom.contains(e.target))
      return;
    let A = this.pos;
    this.view.state.doc != this.startDoc && (A = this.view.posAtCoords(Nw(e))), this.updateAllowDefault(e), this.allowDefault || !A ? vo(this.view, "pointer") : B9(this.view, A.pos, A.inside, e, this.selectNode) ? e.preventDefault() : e.button == 0 && (this.flushed || // Safari ignores clicks on draggable elements
    XA && this.mightDrag && !this.mightDrag.node.isAtom || // Chrome will sometimes treat a node selection as a
    // cursor, but still report that the node is selected
    // when asked through getSelection. You'll then get a
    // situation where clicking at the point where that
    // (hidden) cursor is doesn't change the selection, and
    // thus doesn't get a reaction from ProseMirror. This
    // works around that.
    bA && !this.view.state.selection.visible && Math.min(Math.abs(A.pos - this.view.state.selection.from), Math.abs(A.pos - this.view.state.selection.to)) <= 2) ? (il(this.view, Ke.near(this.view.state.doc.resolve(A.pos))), e.preventDefault()) : vo(this.view, "pointer");
  }
  move(e) {
    this.updateAllowDefault(e), vo(this.view, "pointer"), e.buttons == 0 && this.done();
  }
  updateAllowDefault(e) {
    !this.allowDefault && (Math.abs(this.event.x - e.clientX) > 4 || Math.abs(this.event.y - e.clientY) > 4) && (this.allowDefault = !0);
  }
}
xn.touchstart = (t) => {
  t.input.lastTouch = Date.now(), $M(t), vo(t, "pointer");
};
xn.touchmove = (t) => {
  t.input.lastTouch = Date.now(), vo(t, "pointer");
};
xn.contextmenu = (t) => $M(t);
function X4(t, e) {
  return t.composing ? !0 : XA && Math.abs(e.timeStamp - t.input.compositionEndedAt) < 500 ? (t.input.compositionEndedAt = -2e8, !0) : !1;
}
const w9 = yi ? 5e3 : -1;
Gn.compositionstart = Gn.compositionupdate = (t) => {
  if (!t.composing) {
    t.domObserver.flush();
    let { state: e } = t, A = e.selection.$to;
    if (e.selection instanceof Re && (e.storedMarks || !A.textOffset && A.parentOffset && A.nodeBefore.marks.some((n) => n.type.spec.inclusive === !1) || bA && y4 && f9(t)))
      t.markCursor = t.state.storedMarks || A.marks(), ku(t, !0), t.markCursor = null;
    else if (ku(t, !e.selection.empty), vs && e.selection.empty && A.parentOffset && !A.textOffset && A.nodeBefore.marks.length) {
      let n = t.domSelectionRange();
      for (let s = n.focusNode, r = n.focusOffset; s && s.nodeType == 1 && r != 0; ) {
        let i = r < 0 ? s.lastChild : s.childNodes[r - 1];
        if (!i)
          break;
        if (i.nodeType == 3) {
          let o = t.domSelection();
          o && o.collapse(i, i.nodeValue.length);
          break;
        } else
          s = i, r = -1;
      }
    }
    t.input.composing = !0;
  }
  Z4(t, w9);
};
function f9(t) {
  let { focusNode: e, focusOffset: A } = t.domSelectionRange();
  if (!e || e.nodeType != 1 || A >= e.childNodes.length)
    return !1;
  let n = e.childNodes[A];
  return n.nodeType == 1 && n.contentEditable == "false";
}
Gn.compositionend = (t, e) => {
  t.composing && (t.input.composing = !1, t.input.compositionEndedAt = e.timeStamp, t.input.compositionPendingChanges = t.domObserver.pendingRecords().length ? t.input.compositionID : 0, t.input.compositionNode = null, t.input.badSafariComposition ? t.domObserver.forceFlush() : t.input.compositionPendingChanges && Promise.resolve().then(() => t.domObserver.flush()), t.input.compositionID++, Z4(t, 20));
};
function Z4(t, e) {
  clearTimeout(t.input.composingTimeout), e > -1 && (t.input.composingTimeout = setTimeout(() => ku(t), e));
}
function q4(t) {
  for (t.composing && (t.input.composing = !1, t.input.compositionEndedAt = I9()); t.input.compositionNodes.length > 0; )
    t.input.compositionNodes.pop().markParentsDirty();
}
function Q9(t) {
  let e = t.domSelectionRange();
  if (!e.focusNode)
    return null;
  let A = lT(e.focusNode, e.focusOffset), n = BT(e.focusNode, e.focusOffset);
  if (A && n && A != n) {
    let s = n.pmViewDesc, r = t.domObserver.lastChangedTextNode;
    if (A == r || n == r)
      return r;
    if (!s || !s.isText(n.nodeValue))
      return n;
    if (t.input.compositionNode == n) {
      let i = A.pmViewDesc;
      if (!(!i || !i.isText(A.nodeValue)))
        return n;
    }
  }
  return A || n;
}
function I9() {
  let t = document.createEvent("Event");
  return t.initEvent("event", !0, !0), t.timeStamp;
}
function ku(t, e = !1) {
  if (!(yi && t.domObserver.flushingSoon >= 0)) {
    if (t.domObserver.forceFlush(), q4(t), e || t.docView && t.docView.dirty) {
      let A = VM(t), n = t.state.selection;
      return A && !A.eq(n) ? t.dispatch(t.state.tr.setSelection(A)) : (t.markCursor || e) && !n.$from.node(n.$from.sharedDepth(n.to)).inlineContent ? t.dispatch(t.state.tr.deleteSelection()) : t.updateState(t.state), !0;
    }
    return !1;
  }
}
function C9(t, e) {
  if (!t.dom.parentNode)
    return;
  let A = t.dom.parentNode.appendChild(document.createElement("div"));
  A.appendChild(e), A.style.cssText = "position: fixed; left: -10000px; top: 10px";
  let n = getSelection(), s = document.createRange();
  s.selectNodeContents(e), t.dom.blur(), n.removeAllRanges(), n.addRange(s), setTimeout(() => {
    A.parentNode && A.parentNode.removeChild(A), t.focus();
  }, 50);
}
const Yg = Zn && So < 15 || Ml && dT < 604;
xn.copy = Gn.cut = (t, e) => {
  let A = e, n = t.state.selection, s = A.type == "cut";
  if (n.empty)
    return;
  let r = Yg ? null : A.clipboardData, i = n.content(), { dom: o, text: a } = ZM(t, i);
  r ? (A.preventDefault(), r.clearData(), r.setData("text/html", o.innerHTML), r.setData("text/plain", a)) : C9(t, o), s && t.dispatch(t.state.tr.deleteSelection().scrollIntoView().setMeta("uiEvent", "cut"));
};
function E9(t) {
  return t.openStart == 0 && t.openEnd == 0 && t.content.childCount == 1 ? t.content.firstChild : null;
}
function M9(t, e) {
  if (!t.dom.parentNode)
    return;
  let A = t.input.shiftKey || t.state.selection.$from.parent.type.spec.code, n = t.dom.parentNode.appendChild(document.createElement(A ? "textarea" : "div"));
  A || (n.contentEditable = "true"), n.style.cssText = "position: fixed; left: -10000px; top: 10px", n.focus();
  let s = t.input.shiftKey && t.input.lastKeyCode != 45;
  setTimeout(() => {
    t.focus(), n.parentNode && n.parentNode.removeChild(n), A ? yg(t, n.value, null, s, e) : yg(t, n.textContent, n.innerHTML, s, e);
  }, 50);
}
function yg(t, e, A, n, s) {
  let r = T4(t, e, A, n, t.state.selection.$from);
  if (t.someProp("handlePaste", (a) => a(t, s, r || Ee.empty)))
    return !0;
  if (!r)
    return !1;
  let i = E9(r), o = i ? t.state.tr.replaceSelectionWith(i, n) : t.state.tr.replaceSelection(r);
  return t.dispatch(o.scrollIntoView().setMeta("paste", !0).setMeta("uiEvent", "paste")), !0;
}
function _4(t) {
  let e = t.getData("text/plain") || t.getData("Text");
  if (e)
    return e;
  let A = t.getData("text/uri-list");
  return A ? A.replace(/\r?\n/g, " ") : "";
}
Gn.paste = (t, e) => {
  let A = e;
  if (t.composing && !yi)
    return;
  let n = Yg ? null : A.clipboardData, s = t.input.shiftKey && t.input.lastKeyCode != 45;
  n && yg(t, _4(n), n.getData("text/html"), s, A) ? A.preventDefault() : M9(t, A);
};
class $4 {
  constructor(e, A, n) {
    this.slice = e, this.move = A, this.node = n;
  }
}
const p9 = ms ? "altKey" : "ctrlKey";
function eG(t, e) {
  let A = t.someProp("dragCopies", (n) => !n(e));
  return A ?? !e[p9];
}
xn.dragstart = (t, e) => {
  let A = e, n = t.input.mouseDown;
  if (n && n.done(), !A.dataTransfer)
    return;
  let s = t.state.selection, r = s.empty ? null : t.posAtCoords(Nw(A)), i;
  if (!(r && r.pos >= s.from && r.pos <= (s instanceof Ue ? s.to - 1 : s.to))) {
    if (n && n.mightDrag)
      i = Ue.create(t.state.doc, n.mightDrag.pos);
    else if (A.target && A.target.nodeType == 1) {
      let B = t.docView.nearestDesc(A.target, !0);
      B && B.node.type.spec.draggable && B != t.docView && (i = Ue.create(t.state.doc, B.posBefore));
    }
  }
  let o = (i || t.state.selection).content(), { dom: a, text: c, slice: l } = ZM(t, o);
  (!A.dataTransfer.files.length || !bA || Y4 > 120) && A.dataTransfer.clearData(), A.dataTransfer.setData(Yg ? "Text" : "text/html", a.innerHTML), A.dataTransfer.effectAllowed = "copyMove", Yg || A.dataTransfer.setData("text/plain", c), t.dragging = new $4(l, eG(t, A), i);
};
xn.dragend = (t) => {
  let e = t.dragging;
  window.setTimeout(() => {
    t.dragging == e && (t.dragging = null);
  }, 50);
};
Gn.dragover = Gn.dragenter = (t, e) => e.preventDefault();
Gn.drop = (t, e) => {
  try {
    m9(t, e, t.dragging);
  } finally {
    t.dragging = null;
  }
};
function m9(t, e, A) {
  if (!e.dataTransfer)
    return;
  let n = t.posAtCoords(Nw(e));
  if (!n)
    return;
  let s = t.state.doc.resolve(n.pos), r = A && A.slice;
  r ? t.someProp("transformPasted", (h) => {
    r = h(r, t, !1);
  }) : r = T4(t, _4(e.dataTransfer), Yg ? null : e.dataTransfer.getData("text/html"), !1, s);
  let i = !!(A && eG(t, e));
  if (t.someProp("handleDrop", (h) => h(t, e, r || Ee.empty, i))) {
    e.preventDefault();
    return;
  }
  if (!r)
    return;
  e.preventDefault();
  let o = r ? r4(t.state.doc, s.pos, r) : s.pos;
  o == null && (o = s.pos);
  let a = t.state.tr;
  if (i) {
    let { node: h } = A;
    h ? h.replace(a) : a.deleteSelection();
  }
  let c = a.mapping.map(o), l = r.openStart == 0 && r.openEnd == 0 && r.content.childCount == 1, B = a.doc;
  if (l ? a.replaceRangeWith(c, c, r.content.firstChild) : a.replaceRange(c, c, r), a.doc.eq(B))
    return;
  let g = a.doc.resolve(c);
  if (l && Ue.isSelectable(r.content.firstChild) && g.nodeAfter && g.nodeAfter.sameMarkup(r.content.firstChild))
    a.setSelection(new Ue(g));
  else {
    let h = a.mapping.map(o);
    a.mapping.maps[a.mapping.maps.length - 1].forEach((u, d, w, Q) => h = Q), a.setSelection(XM(t, g, a.doc.resolve(h)));
  }
  t.focus(), t.dispatch(a.setMeta("uiEvent", "drop"));
}
xn.focus = (t) => {
  t.input.lastFocus = Date.now(), t.focused || (t.domObserver.stop(), t.dom.classList.add("ProseMirror-focused"), t.domObserver.start(), t.focused = !0, setTimeout(() => {
    t.docView && t.hasFocus() && !t.domObserver.currentSelection.eq(t.domSelectionRange()) && zi(t);
  }, 20));
};
xn.blur = (t, e) => {
  let A = e;
  t.focused && (t.domObserver.stop(), t.dom.classList.remove("ProseMirror-focused"), t.domObserver.start(), A.relatedTarget && t.dom.contains(A.relatedTarget) && t.domObserver.currentSelection.clear(), t.focused = !1);
};
xn.beforeinput = (t, e) => {
  if (bA && yi && e.inputType == "deleteContentBackward") {
    t.domObserver.flushSoon();
    let { domChangeCount: n } = t.input;
    setTimeout(() => {
      if (t.input.domChangeCount != n || (t.dom.blur(), t.focus(), t.someProp("handleKeyDown", (r) => r(t, za(8, "Backspace")))))
        return;
      let { $cursor: s } = t.state.selection;
      s && s.pos > 0 && t.dispatch(t.state.tr.delete(s.pos - 1, s.pos).scrollIntoView());
    }, 50);
  }
};
for (let t in Gn)
  xn[t] = Gn[t];
function Fg(t, e) {
  if (t == e)
    return !0;
  for (let A in t)
    if (t[A] !== e[A])
      return !1;
  for (let A in e)
    if (!(A in t))
      return !1;
  return !0;
}
class Ru {
  constructor(e, A) {
    this.toDOM = e, this.spec = A || Sa, this.side = this.spec.side || 0;
  }
  map(e, A, n, s) {
    let { pos: r, deleted: i } = e.mapResult(A.from + s, this.side < 0 ? -1 : 1);
    return i ? null : new Wt(r - n, r - n, this);
  }
  valid() {
    return !0;
  }
  eq(e) {
    return this == e || e instanceof Ru && (this.spec.key && this.spec.key == e.spec.key || this.toDOM == e.toDOM && Fg(this.spec, e.spec));
  }
  destroy(e) {
    this.spec.destroy && this.spec.destroy(e);
  }
}
class Jo {
  constructor(e, A) {
    this.attrs = e, this.spec = A || Sa;
  }
  map(e, A, n, s) {
    let r = e.map(A.from + s, this.spec.inclusiveStart ? -1 : 1) - n, i = e.map(A.to + s, this.spec.inclusiveEnd ? 1 : -1) - n;
    return r >= i ? null : new Wt(r, i, this);
  }
  valid(e, A) {
    return A.from < A.to;
  }
  eq(e) {
    return this == e || e instanceof Jo && Fg(this.attrs, e.attrs) && Fg(this.spec, e.spec);
  }
  static is(e) {
    return e.type instanceof Jo;
  }
  destroy() {
  }
}
class ep {
  constructor(e, A) {
    this.attrs = e, this.spec = A || Sa;
  }
  map(e, A, n, s) {
    let r = e.mapResult(A.from + s, 1);
    if (r.deleted)
      return null;
    let i = e.mapResult(A.to + s, -1);
    return i.deleted || i.pos <= r.pos ? null : new Wt(r.pos - n, i.pos - n, this);
  }
  valid(e, A) {
    let { index: n, offset: s } = e.content.findIndex(A.from), r;
    return s == A.from && !(r = e.child(n)).isText && s + r.nodeSize == A.to;
  }
  eq(e) {
    return this == e || e instanceof ep && Fg(this.attrs, e.attrs) && Fg(this.spec, e.spec);
  }
  destroy() {
  }
}
class Wt {
  /**
  @internal
  */
  constructor(e, A, n) {
    this.from = e, this.to = A, this.type = n;
  }
  /**
  @internal
  */
  copy(e, A) {
    return new Wt(e, A, this.type);
  }
  /**
  @internal
  */
  eq(e, A = 0) {
    return this.type.eq(e.type) && this.from + A == e.from && this.to + A == e.to;
  }
  /**
  @internal
  */
  map(e, A, n) {
    return this.type.map(e, this, A, n);
  }
  /**
  Creates a widget decoration, which is a DOM node that's shown in
  the document at the given position. It is recommended that you
  delay rendering the widget by passing a function that will be
  called when the widget is actually drawn in a view, but you can
  also directly pass a DOM node. `getPos` can be used to find the
  widget's current document position.
  */
  static widget(e, A, n) {
    return new Wt(e, e, new Ru(A, n));
  }
  /**
  Creates an inline decoration, which adds the given attributes to
  each inline node between `from` and `to`.
  */
  static inline(e, A, n, s) {
    return new Wt(e, A, new Jo(n, s));
  }
  /**
  Creates a node decoration. `from` and `to` should point precisely
  before and after a node in the document. That node, and only that
  node, will receive the given attributes.
  */
  static node(e, A, n, s) {
    return new Wt(e, A, new ep(n, s));
  }
  /**
  The spec provided when creating this decoration. Can be useful
  if you've stored extra information in that object.
  */
  get spec() {
    return this.type.spec;
  }
  /**
  @internal
  */
  get inline() {
    return this.type instanceof Jo;
  }
  /**
  @internal
  */
  get widget() {
    return this.type instanceof Ru;
  }
}
const Tc = [], Sa = {};
class It {
  /**
  @internal
  */
  constructor(e, A) {
    this.local = e.length ? e : Tc, this.children = A.length ? A : Tc;
  }
  /**
  Create a set of decorations, using the structure of the given
  document. This will consume (modify) the `decorations` array, so
  you must make a copy if you want need to preserve that.
  */
  static create(e, A) {
    return A.length ? Lu(A, e, 0, Sa) : en;
  }
  /**
  Find all decorations in this set which touch the given range
  (including decorations that start or end directly at the
  boundaries) and match the given predicate on their spec. When
  `start` and `end` are omitted, all decorations in the set are
  considered. When `predicate` isn't given, all decorations are
  assumed to match.
  */
  find(e, A, n) {
    let s = [];
    return this.findInner(e ?? 0, A ?? 1e9, s, 0, n), s;
  }
  findInner(e, A, n, s, r) {
    for (let i = 0; i < this.local.length; i++) {
      let o = this.local[i];
      o.from <= A && o.to >= e && (!r || r(o.spec)) && n.push(o.copy(o.from + s, o.to + s));
    }
    for (let i = 0; i < this.children.length; i += 3)
      if (this.children[i] < A && this.children[i + 1] > e) {
        let o = this.children[i] + 1;
        this.children[i + 2].findInner(e - o, A - o, n, s + o, r);
      }
  }
  /**
  Map the set of decorations in response to a change in the
  document.
  */
  map(e, A, n) {
    return this == en || e.maps.length == 0 ? this : this.mapInner(e, A, 0, 0, n || Sa);
  }
  /**
  @internal
  */
  mapInner(e, A, n, s, r) {
    let i;
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o].map(e, n, s);
      a && a.type.valid(A, a) ? (i || (i = [])).push(a) : r.onRemove && r.onRemove(this.local[o].spec);
    }
    return this.children.length ? Y9(this.children, i || [], e, A, n, s, r) : i ? new It(i.sort(Ta), Tc) : en;
  }
  /**
  Add the given array of decorations to the ones in the set,
  producing a new set. Consumes the `decorations` array. Needs
  access to the current document to create the appropriate tree
  structure.
  */
  add(e, A) {
    return A.length ? this == en ? It.create(e, A) : this.addInner(e, A, 0) : this;
  }
  addInner(e, A, n) {
    let s, r = 0;
    e.forEach((o, a) => {
      let c = a + n, l;
      if (l = AG(A, o, c)) {
        for (s || (s = this.children.slice()); r < s.length && s[r] < a; )
          r += 3;
        s[r] == a ? s[r + 2] = s[r + 2].addInner(o, l, c + 1) : s.splice(r, 0, a, a + o.nodeSize, Lu(l, o, c + 1, Sa)), r += 3;
      }
    });
    let i = tG(r ? nG(A) : A, -n);
    for (let o = 0; o < i.length; o++)
      i[o].type.valid(e, i[o]) || i.splice(o--, 1);
    return new It(i.length ? this.local.concat(i).sort(Ta) : this.local, s || this.children);
  }
  /**
  Create a new set that contains the decorations in this set, minus
  the ones in the given array.
  */
  remove(e) {
    return e.length == 0 || this == en ? this : this.removeInner(e, 0);
  }
  removeInner(e, A) {
    let n = this.children, s = this.local;
    for (let r = 0; r < n.length; r += 3) {
      let i, o = n[r] + A, a = n[r + 1] + A;
      for (let l = 0, B; l < e.length; l++)
        (B = e[l]) && B.from > o && B.to < a && (e[l] = null, (i || (i = [])).push(B));
      if (!i)
        continue;
      n == this.children && (n = this.children.slice());
      let c = n[r + 2].removeInner(i, o + 1);
      c != en ? n[r + 2] = c : (n.splice(r, 3), r -= 3);
    }
    if (s.length) {
      for (let r = 0, i; r < e.length; r++)
        if (i = e[r])
          for (let o = 0; o < s.length; o++)
            s[o].eq(i, A) && (s == this.local && (s = this.local.slice()), s.splice(o--, 1));
    }
    return n == this.children && s == this.local ? this : s.length || n.length ? new It(s, n) : en;
  }
  forChild(e, A) {
    if (this == en)
      return this;
    if (A.isLeaf)
      return It.empty;
    let n, s;
    for (let o = 0; o < this.children.length; o += 3)
      if (this.children[o] >= e) {
        this.children[o] == e && (n = this.children[o + 2]);
        break;
      }
    let r = e + 1, i = r + A.content.size;
    for (let o = 0; o < this.local.length; o++) {
      let a = this.local[o];
      if (a.from < i && a.to > r && a.type instanceof Jo) {
        let c = Math.max(r, a.from) - r, l = Math.min(i, a.to) - r;
        c < l && (s || (s = [])).push(a.copy(c, l));
      }
    }
    if (s) {
      let o = new It(s.sort(Ta), Tc);
      return n ? new yo([o, n]) : o;
    }
    return n || en;
  }
  /**
  @internal
  */
  eq(e) {
    if (this == e)
      return !0;
    if (!(e instanceof It) || this.local.length != e.local.length || this.children.length != e.children.length)
      return !1;
    for (let A = 0; A < this.local.length; A++)
      if (!this.local[A].eq(e.local[A]))
        return !1;
    for (let A = 0; A < this.children.length; A += 3)
      if (this.children[A] != e.children[A] || this.children[A + 1] != e.children[A + 1] || !this.children[A + 2].eq(e.children[A + 2]))
        return !1;
    return !0;
  }
  /**
  @internal
  */
  locals(e) {
    return tp(this.localsInner(e));
  }
  /**
  @internal
  */
  localsInner(e) {
    if (this == en)
      return Tc;
    if (e.inlineContent || !this.local.some(Jo.is))
      return this.local;
    let A = [];
    for (let n = 0; n < this.local.length; n++)
      this.local[n].type instanceof Jo || A.push(this.local[n]);
    return A;
  }
  forEachSet(e) {
    e(this);
  }
}
It.empty = new It([], []);
It.removeOverlap = tp;
const en = It.empty;
class yo {
  constructor(e) {
    this.members = e;
  }
  map(e, A) {
    const n = this.members.map((s) => s.map(e, A, Sa));
    return yo.from(n);
  }
  forChild(e, A) {
    if (A.isLeaf)
      return It.empty;
    let n = [];
    for (let s = 0; s < this.members.length; s++) {
      let r = this.members[s].forChild(e, A);
      r != en && (r instanceof yo ? n = n.concat(r.members) : n.push(r));
    }
    return yo.from(n);
  }
  eq(e) {
    if (!(e instanceof yo) || e.members.length != this.members.length)
      return !1;
    for (let A = 0; A < this.members.length; A++)
      if (!this.members[A].eq(e.members[A]))
        return !1;
    return !0;
  }
  locals(e) {
    let A, n = !0;
    for (let s = 0; s < this.members.length; s++) {
      let r = this.members[s].localsInner(e);
      if (r.length)
        if (!A)
          A = r;
        else {
          n && (A = A.slice(), n = !1);
          for (let i = 0; i < r.length; i++)
            A.push(r[i]);
        }
    }
    return A ? tp(n ? A : A.sort(Ta)) : Tc;
  }
  // Create a group for the given array of decoration sets, or return
  // a single set when possible.
  static from(e) {
    switch (e.length) {
      case 0:
        return en;
      case 1:
        return e[0];
      default:
        return new yo(e.every((A) => A instanceof It) ? e : e.reduce((A, n) => A.concat(n instanceof It ? n : n.members), []));
    }
  }
  forEachSet(e) {
    for (let A = 0; A < this.members.length; A++)
      this.members[A].forEachSet(e);
  }
}
function Y9(t, e, A, n, s, r, i) {
  let o = t.slice();
  for (let c = 0, l = r; c < A.maps.length; c++) {
    let B = 0;
    A.maps[c].forEach((g, h, u, d) => {
      let w = d - u - (h - g);
      for (let Q = 0; Q < o.length; Q += 3) {
        let p = o[Q + 1];
        if (p < 0 || g > p + l - B)
          continue;
        let M = o[Q] + l - B;
        h >= M ? o[Q + 1] = g <= M ? -2 : -1 : g >= l && w && (o[Q] += w, o[Q + 1] += w);
      }
      B += w;
    }), l = A.maps[c].map(l, -1);
  }
  let a = !1;
  for (let c = 0; c < o.length; c += 3)
    if (o[c + 1] < 0) {
      if (o[c + 1] == -2) {
        a = !0, o[c + 1] = -1;
        continue;
      }
      let l = A.map(t[c] + r), B = l - s;
      if (B < 0 || B >= n.content.size) {
        a = !0;
        continue;
      }
      let g = A.map(t[c + 1] + r, -1), h = g - s, { index: u, offset: d } = n.content.findIndex(B), w = n.maybeChild(u);
      if (w && d == B && d + w.nodeSize == h) {
        let Q = o[c + 2].mapInner(A, w, l + 1, t[c] + r + 1, i);
        Q != en ? (o[c] = B, o[c + 1] = h, o[c + 2] = Q) : (o[c + 1] = -2, a = !0);
      } else
        a = !0;
    }
  if (a) {
    let c = y9(o, t, e, A, s, r, i), l = Lu(c, n, 0, i);
    e = l.local;
    for (let B = 0; B < o.length; B += 3)
      o[B + 1] < 0 && (o.splice(B, 3), B -= 3);
    for (let B = 0, g = 0; B < l.children.length; B += 3) {
      let h = l.children[B];
      for (; g < o.length && o[g] < h; )
        g += 3;
      o.splice(g, 0, l.children[B], l.children[B + 1], l.children[B + 2]);
    }
  }
  return new It(e.sort(Ta), o);
}
function tG(t, e) {
  if (!e || !t.length)
    return t;
  let A = [];
  for (let n = 0; n < t.length; n++) {
    let s = t[n];
    A.push(new Wt(s.from + e, s.to + e, s.type));
  }
  return A;
}
function y9(t, e, A, n, s, r, i) {
  function o(a, c) {
    for (let l = 0; l < a.local.length; l++) {
      let B = a.local[l].map(n, s, c);
      B ? A.push(B) : i.onRemove && i.onRemove(a.local[l].spec);
    }
    for (let l = 0; l < a.children.length; l += 3)
      o(a.children[l + 2], a.children[l] + c + 1);
  }
  for (let a = 0; a < t.length; a += 3)
    t[a + 1] == -1 && o(t[a + 2], e[a] + r + 1);
  return A;
}
function AG(t, e, A) {
  if (e.isLeaf)
    return null;
  let n = A + e.nodeSize, s = null;
  for (let r = 0, i; r < t.length; r++)
    (i = t[r]) && i.from > A && i.to < n && ((s || (s = [])).push(i), t[r] = null);
  return s;
}
function nG(t) {
  let e = [];
  for (let A = 0; A < t.length; A++)
    t[A] != null && e.push(t[A]);
  return e;
}
function Lu(t, e, A, n) {
  let s = [], r = !1;
  e.forEach((o, a) => {
    let c = AG(t, o, a + A);
    if (c) {
      r = !0;
      let l = Lu(c, o, A + a + 1, n);
      l != en && s.push(a, a + o.nodeSize, l);
    }
  });
  let i = tG(r ? nG(t) : t, -A).sort(Ta);
  for (let o = 0; o < i.length; o++)
    i[o].type.valid(e, i[o]) || (n.onRemove && n.onRemove(i[o].spec), i.splice(o--, 1));
  return i.length || s.length ? new It(i, s) : en;
}
function Ta(t, e) {
  return t.from - e.from || t.to - e.to;
}
function tp(t) {
  let e = t;
  for (let A = 0; A < e.length - 1; A++) {
    let n = e[A];
    if (n.from != n.to)
      for (let s = A + 1; s < e.length; s++) {
        let r = e[s];
        if (r.from == n.from) {
          r.to != n.to && (e == t && (e = t.slice()), e[s] = r.copy(r.from, n.to), Gy(e, s + 1, r.copy(n.to, r.to)));
          continue;
        } else {
          r.from < n.to && (e == t && (e = t.slice()), e[A] = n.copy(n.from, r.from), Gy(e, s, n.copy(r.from, n.to)));
          break;
        }
      }
  }
  return e;
}
function Gy(t, e, A) {
  for (; e < t.length && Ta(A, t[e]) > 0; )
    e++;
  t.splice(e, 0, A);
}
function yQ(t) {
  let e = [];
  return t.someProp("decorations", (A) => {
    let n = A(t.state);
    n && n != en && e.push(n);
  }), t.cursorWrapper && e.push(It.create(t.state.doc, [t.cursorWrapper.deco])), yo.from(e);
}
const F9 = {
  childList: !0,
  characterData: !0,
  characterDataOldValue: !0,
  attributes: !0,
  attributeOldValue: !0,
  subtree: !0
}, N9 = Zn && So <= 11;
class D9 {
  constructor() {
    this.anchorNode = null, this.anchorOffset = 0, this.focusNode = null, this.focusOffset = 0;
  }
  set(e) {
    this.anchorNode = e.anchorNode, this.anchorOffset = e.anchorOffset, this.focusNode = e.focusNode, this.focusOffset = e.focusOffset;
  }
  clear() {
    this.anchorNode = this.focusNode = null;
  }
  eq(e) {
    return e.anchorNode == this.anchorNode && e.anchorOffset == this.anchorOffset && e.focusNode == this.focusNode && e.focusOffset == this.focusOffset;
  }
}
class x9 {
  constructor(e, A) {
    this.view = e, this.handleDOMChange = A, this.queue = [], this.flushingSoon = -1, this.observer = null, this.currentSelection = new D9(), this.onCharData = null, this.suppressingSelectionUpdates = !1, this.lastChangedTextNode = null, this.observer = window.MutationObserver && new window.MutationObserver((n) => {
      for (let s = 0; s < n.length; s++)
        this.queue.push(n[s]);
      Zn && So <= 11 && n.some((s) => s.type == "childList" && s.removedNodes.length || s.type == "characterData" && s.oldValue.length > s.target.nodeValue.length) ? this.flushSoon() : XA && e.composing && n.some((s) => s.type == "childList" && s.target.nodeName == "TR") ? (e.input.badSafariComposition = !0, this.flushSoon()) : this.flush();
    }), N9 && (this.onCharData = (n) => {
      this.queue.push({ target: n.target, type: "characterData", oldValue: n.prevValue }), this.flushSoon();
    }), this.onSelectionChange = this.onSelectionChange.bind(this);
  }
  flushSoon() {
    this.flushingSoon < 0 && (this.flushingSoon = window.setTimeout(() => {
      this.flushingSoon = -1, this.flush();
    }, 20));
  }
  forceFlush() {
    this.flushingSoon > -1 && (window.clearTimeout(this.flushingSoon), this.flushingSoon = -1, this.flush());
  }
  start() {
    this.observer && (this.observer.takeRecords(), this.observer.observe(this.view.dom, F9)), this.onCharData && this.view.dom.addEventListener("DOMCharacterDataModified", this.onCharData), this.connectSelection();
  }
  stop() {
    if (this.observer) {
      let e = this.observer.takeRecords();
      if (e.length) {
        for (let A = 0; A < e.length; A++)
          this.queue.push(e[A]);
        window.setTimeout(() => this.flush(), 20);
      }
      this.observer.disconnect();
    }
    this.onCharData && this.view.dom.removeEventListener("DOMCharacterDataModified", this.onCharData), this.disconnectSelection();
  }
  connectSelection() {
    this.view.dom.ownerDocument.addEventListener("selectionchange", this.onSelectionChange);
  }
  disconnectSelection() {
    this.view.dom.ownerDocument.removeEventListener("selectionchange", this.onSelectionChange);
  }
  suppressSelectionUpdates() {
    this.suppressingSelectionUpdates = !0, setTimeout(() => this.suppressingSelectionUpdates = !1, 50);
  }
  onSelectionChange() {
    if (py(this.view)) {
      if (this.suppressingSelectionUpdates)
        return zi(this.view);
      if (Zn && So <= 11 && !this.view.state.selection.empty) {
        let e = this.view.domSelectionRange();
        if (e.focusNode && Za(e.focusNode, e.focusOffset, e.anchorNode, e.anchorOffset))
          return this.flushSoon();
      }
      this.flush();
    }
  }
  setCurSelection() {
    this.currentSelection.set(this.view.domSelectionRange());
  }
  ignoreSelectionChange(e) {
    if (!e.focusNode)
      return !0;
    let A = /* @__PURE__ */ new Set(), n;
    for (let r = e.focusNode; r; r = El(r))
      A.add(r);
    for (let r = e.anchorNode; r; r = El(r))
      if (A.has(r)) {
        n = r;
        break;
      }
    let s = n && this.view.docView.nearestDesc(n);
    if (s && s.ignoreMutation({
      type: "selection",
      target: n.nodeType == 3 ? n.parentNode : n
    }))
      return this.setCurSelection(), !0;
  }
  pendingRecords() {
    if (this.observer)
      for (let e of this.observer.takeRecords())
        this.queue.push(e);
    return this.queue;
  }
  flush() {
    let { view: e } = this;
    if (!e.docView || this.flushingSoon > -1)
      return;
    let A = this.pendingRecords();
    A.length && (this.queue = []);
    let n = e.domSelectionRange(), s = !this.suppressingSelectionUpdates && !this.currentSelection.eq(n) && py(e) && !this.ignoreSelectionChange(n), r = -1, i = -1, o = !1, a = [];
    if (e.editable)
      for (let l = 0; l < A.length; l++) {
        let B = this.registerMutation(A[l], a);
        B && (r = r < 0 ? B.from : Math.min(B.from, r), i = i < 0 ? B.to : Math.max(B.to, i), B.typeOver && (o = !0));
      }
    if (vs && a.length) {
      let l = a.filter((B) => B.nodeName == "BR");
      if (l.length == 2) {
        let [B, g] = l;
        B.parentNode && B.parentNode.parentNode == g.parentNode ? g.remove() : B.remove();
      } else {
        let { focusNode: B } = this.currentSelection;
        for (let g of l) {
          let h = g.parentNode;
          h && h.nodeName == "LI" && (!B || U9(e, B) != h) && g.remove();
        }
      }
    } else if ((bA || XA) && a.some((l) => l.nodeName == "BR") && (e.input.lastKeyCode == 8 || e.input.lastKeyCode == 46)) {
      for (let l of a)
        if (l.nodeName == "BR" && l.parentNode) {
          let B = l.nextSibling;
          B && B.nodeType == 1 && B.contentEditable == "false" && l.parentNode.removeChild(l);
        }
    }
    let c = null;
    r < 0 && s && e.input.lastFocus > Date.now() - 200 && Math.max(e.input.lastTouch, e.input.lastClick.time) < Date.now() - 300 && yw(n) && (c = VM(e)) && c.eq(Ke.near(e.state.doc.resolve(0), 1)) ? (e.input.lastFocus = 0, zi(e), this.currentSelection.set(n), e.scrollToSelection()) : (r > -1 || s) && (r > -1 && (e.docView.markDirty(r, i), G9(e)), e.input.badSafariComposition && (e.input.badSafariComposition = !1, b9(e, a)), this.handleDOMChange(r, i, o, a), e.docView && e.docView.dirty ? e.updateState(e.state) : this.currentSelection.eq(n) || zi(e), this.currentSelection.set(n));
  }
  registerMutation(e, A) {
    if (A.indexOf(e.target) > -1)
      return null;
    let n = this.view.docView.nearestDesc(e.target);
    if (e.type == "attributes" && (n == this.view.docView || e.attributeName == "contenteditable" || // Firefox sometimes fires spurious events for null/empty styles
    e.attributeName == "style" && !e.oldValue && !e.target.getAttribute("style")) || !n || n.ignoreMutation(e))
      return null;
    if (e.type == "childList") {
      for (let l = 0; l < e.addedNodes.length; l++) {
        let B = e.addedNodes[l];
        A.push(B), B.nodeType == 3 && (this.lastChangedTextNode = B);
      }
      if (n.contentDOM && n.contentDOM != n.dom && !n.contentDOM.contains(e.target))
        return { from: n.posBefore, to: n.posAfter };
      let s = e.previousSibling, r = e.nextSibling;
      if (Zn && So <= 11 && e.addedNodes.length)
        for (let l = 0; l < e.addedNodes.length; l++) {
          let { previousSibling: B, nextSibling: g } = e.addedNodes[l];
          (!B || Array.prototype.indexOf.call(e.addedNodes, B) < 0) && (s = B), (!g || Array.prototype.indexOf.call(e.addedNodes, g) < 0) && (r = g);
        }
      let i = s && s.parentNode == e.target ? PA(s) + 1 : 0, o = n.localPosFromDOM(e.target, i, -1), a = r && r.parentNode == e.target ? PA(r) : e.target.childNodes.length, c = n.localPosFromDOM(e.target, a, 1);
      return { from: o, to: c };
    } else return e.type == "attributes" ? { from: n.posAtStart - n.border, to: n.posAtEnd + n.border } : (this.lastChangedTextNode = e.target, {
      from: n.posAtStart,
      to: n.posAtEnd,
      // An event was generated for a text change that didn't change
      // any text. Mark the dom change to fall back to assuming the
      // selection was typed over with an identical value if it can't
      // find another change.
      typeOver: e.target.nodeValue == e.oldValue
    });
  }
}
let zy = /* @__PURE__ */ new WeakMap(), Uy = !1;
function G9(t) {
  if (!zy.has(t) && (zy.set(t, null), ["normal", "nowrap", "pre-line"].indexOf(getComputedStyle(t.dom).whiteSpace) !== -1)) {
    if (t.requiresGeckoHackNode = vs, Uy)
      return;
    console.warn("ProseMirror expects the CSS white-space property to be set, preferably to 'pre-wrap'. It is recommended to load style/prosemirror.css from the prosemirror-view package."), Uy = !0;
  }
}
function by(t, e) {
  let A = e.startContainer, n = e.startOffset, s = e.endContainer, r = e.endOffset, i = t.domAtPos(t.state.selection.anchor);
  return Za(i.node, i.offset, s, r) && ([A, n, s, r] = [s, r, A, n]), { anchorNode: A, anchorOffset: n, focusNode: s, focusOffset: r };
}
function z9(t, e) {
  if (e.getComposedRanges) {
    let s = e.getComposedRanges(t.root)[0];
    if (s)
      return by(t, s);
  }
  let A;
  function n(s) {
    s.preventDefault(), s.stopImmediatePropagation(), A = s.getTargetRanges()[0];
  }
  return t.dom.addEventListener("beforeinput", n, !0), document.execCommand("indent"), t.dom.removeEventListener("beforeinput", n, !0), A ? by(t, A) : null;
}
function U9(t, e) {
  for (let A = e.parentNode; A && A != t.dom; A = A.parentNode) {
    let n = t.docView.nearestDesc(A, !0);
    if (n && n.node.isBlock)
      return A;
  }
  return null;
}
function b9(t, e) {
  var A;
  let { focusNode: n, focusOffset: s } = t.domSelectionRange();
  for (let r of e)
    if (((A = r.parentNode) === null || A === void 0 ? void 0 : A.nodeName) == "TR") {
      let i = r.nextSibling;
      for (; i && i.nodeName != "TD" && i.nodeName != "TH"; )
        i = i.nextSibling;
      if (i) {
        let o = i;
        for (; ; ) {
          let a = o.firstChild;
          if (!a || a.nodeType != 1 || a.contentEditable == "false" || /^(BR|IMG)$/.test(a.nodeName))
            break;
          o = a;
        }
        o.insertBefore(r, o.firstChild), n == r && t.domSelection().collapse(r, s);
      } else
        r.parentNode.removeChild(r);
    }
}
function v9(t, e, A) {
  let { node: n, fromOffset: s, toOffset: r, from: i, to: o } = t.docView.parseRange(e, A), a = t.domSelectionRange(), c, l = a.anchorNode;
  if (l && t.dom.contains(l.nodeType == 1 ? l : l.parentNode) && (c = [{ node: l, offset: a.anchorOffset }], yw(a) || c.push({ node: a.focusNode, offset: a.focusOffset })), bA && t.input.lastKeyCode === 8)
    for (let w = r; w > s; w--) {
      let Q = n.childNodes[w - 1], p = Q.pmViewDesc;
      if (Q.nodeName == "BR" && !p) {
        r = w;
        break;
      }
      if (!p || p.size)
        break;
    }
  let B = t.state.doc, g = t.someProp("domParser") || SB.fromSchema(t.state.schema), h = B.resolve(i), u = null, d = g.parse(n, {
    topNode: h.parent,
    topMatch: h.parent.contentMatchAt(h.index()),
    topOpen: !0,
    from: s,
    to: r,
    preserveWhitespace: h.parent.type.whitespace == "pre" ? "full" : !0,
    findPositions: c,
    ruleFromNode: j9,
    context: h
  });
  if (c && c[0].pos != null) {
    let w = c[0].pos, Q = c[1] && c[1].pos;
    Q == null && (Q = w), u = { anchor: w + i, head: Q + i };
  }
  return { doc: d, sel: u, from: i, to: o };
}
function j9(t) {
  let e = t.pmViewDesc;
  if (e)
    return e.parseRule();
  if (t.nodeName == "BR" && t.parentNode) {
    if (XA && /^(ul|ol)$/i.test(t.parentNode.nodeName)) {
      let A = document.createElement("div");
      return A.appendChild(document.createElement("li")), { skip: A };
    } else if (t.parentNode.lastChild == t || XA && /^(tr|table)$/i.test(t.parentNode.nodeName))
      return { ignore: !0 };
  } else if (t.nodeName == "IMG" && t.getAttribute("mark-placeholder"))
    return { ignore: !0 };
  return null;
}
const H9 = /^(a|abbr|acronym|b|bd[io]|big|br|button|cite|code|data(list)?|del|dfn|em|i|img|ins|kbd|label|map|mark|meter|output|q|ruby|s|samp|small|span|strong|su[bp]|time|u|tt|var)$/i;
function k9(t, e, A, n, s) {
  let r = t.input.compositionPendingChanges || (t.composing ? t.input.compositionID : 0);
  if (t.input.compositionPendingChanges = 0, e < 0) {
    let E = t.input.lastSelectionTime > Date.now() - 50 ? t.input.lastSelectionOrigin : null, G = VM(t, E);
    if (G && !t.state.selection.eq(G)) {
      if (bA && yi && t.input.lastKeyCode === 13 && Date.now() - 100 < t.input.lastKeyCodeTime && t.someProp("handleKeyDown", (U) => U(t, za(13, "Enter"))))
        return;
      let Y = t.state.tr.setSelection(G);
      E == "pointer" ? Y.setMeta("pointer", !0) : E == "key" && Y.scrollIntoView(), r && Y.setMeta("composition", r), t.dispatch(Y);
    }
    return;
  }
  let i = t.state.doc.resolve(e), o = i.sharedDepth(A);
  e = i.before(o + 1), A = t.state.doc.resolve(A).after(o + 1);
  let a = t.state.selection, c = v9(t, e, A), l = t.state.doc, B = l.slice(c.from, c.to), g, h;
  t.input.lastKeyCode === 8 && Date.now() - 100 < t.input.lastKeyCodeTime ? (g = t.state.selection.to, h = "end") : (g = t.state.selection.from, h = "start"), t.input.lastKeyCode = null;
  let u = S9(B.content, c.doc.content, c.from, g, h);
  if (u && t.input.domChangeCount++, (Ml && t.input.lastIOSEnter > Date.now() - 225 || yi) && s.some((E) => E.nodeType == 1 && !H9.test(E.nodeName)) && (!u || u.endA >= u.endB) && t.someProp("handleKeyDown", (E) => E(t, za(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (!u)
    if (n && a instanceof Re && !a.empty && a.$head.sameParent(a.$anchor) && !t.composing && !(c.sel && c.sel.anchor != c.sel.head))
      u = { start: a.from, endA: a.to, endB: a.to };
    else {
      if (c.sel) {
        let E = vy(t, t.state.doc, c.sel);
        if (E && !E.eq(t.state.selection)) {
          let G = t.state.tr.setSelection(E);
          r && G.setMeta("composition", r), t.dispatch(G);
        }
      }
      return;
    }
  t.state.selection.from < t.state.selection.to && u.start == u.endB && t.state.selection instanceof Re && (u.start > t.state.selection.from && u.start <= t.state.selection.from + 2 && t.state.selection.from >= c.from ? u.start = t.state.selection.from : u.endA < t.state.selection.to && u.endA >= t.state.selection.to - 2 && t.state.selection.to <= c.to && (u.endB += t.state.selection.to - u.endA, u.endA = t.state.selection.to)), Zn && So <= 11 && u.endB == u.start + 1 && u.endA == u.start && u.start > c.from && c.doc.textBetween(u.start - c.from - 1, u.start - c.from + 1) == "  " && (u.start--, u.endA--, u.endB--);
  let d = c.doc.resolveNoCache(u.start - c.from), w = c.doc.resolveNoCache(u.endB - c.from), Q = l.resolve(u.start), p = d.sameParent(w) && d.parent.inlineContent && Q.end() >= u.endA;
  if ((Ml && t.input.lastIOSEnter > Date.now() - 225 && (!p || s.some((E) => E.nodeName == "DIV" || E.nodeName == "P")) || !p && d.pos < c.doc.content.size && (!d.sameParent(w) || !d.parent.inlineContent) && d.pos < w.pos && !/\S/.test(c.doc.textBetween(d.pos, w.pos, "", ""))) && t.someProp("handleKeyDown", (E) => E(t, za(13, "Enter")))) {
    t.input.lastIOSEnter = 0;
    return;
  }
  if (t.state.selection.anchor > u.start && L9(l, u.start, u.endA, d, w) && t.someProp("handleKeyDown", (E) => E(t, za(8, "Backspace")))) {
    yi && bA && t.domObserver.suppressSelectionUpdates();
    return;
  }
  bA && u.endB == u.start && (t.input.lastChromeDelete = Date.now()), yi && !p && d.start() != w.start() && w.parentOffset == 0 && d.depth == w.depth && c.sel && c.sel.anchor == c.sel.head && c.sel.head == u.endA && (u.endB -= 2, w = c.doc.resolveNoCache(u.endB - c.from), setTimeout(() => {
    t.someProp("handleKeyDown", function(E) {
      return E(t, za(13, "Enter"));
    });
  }, 20));
  let M = u.start, I = u.endA, N = (E) => {
    let G = E || t.state.tr.replace(M, I, c.doc.slice(u.start - c.from, u.endB - c.from));
    if (c.sel) {
      let Y = vy(t, G.doc, c.sel);
      Y && !(bA && t.composing && Y.empty && (u.start != u.endB || t.input.lastChromeDelete < Date.now() - 100) && (Y.head == M || Y.head == G.mapping.map(I) - 1) || Zn && Y.empty && Y.head == M) && G.setSelection(Y);
    }
    return r && G.setMeta("composition", r), G.scrollIntoView();
  }, m;
  if (p)
    if (d.pos == w.pos) {
      Zn && So <= 11 && d.parentOffset == 0 && (t.domObserver.suppressSelectionUpdates(), setTimeout(() => zi(t), 20));
      let E = N(t.state.tr.delete(M, I)), G = l.resolve(u.start).marksAcross(l.resolve(u.endA));
      G && E.ensureMarks(G), t.dispatch(E);
    } else if (
      // Adding or removing a mark
      u.endA == u.endB && (m = R9(d.parent.content.cut(d.parentOffset, w.parentOffset), Q.parent.content.cut(Q.parentOffset, u.endA - Q.start())))
    ) {
      let E = N(t.state.tr);
      m.type == "add" ? E.addMark(M, I, m.mark) : E.removeMark(M, I, m.mark), t.dispatch(E);
    } else if (d.parent.child(d.index()).isText && d.index() == w.index() - (w.textOffset ? 0 : 1)) {
      let E = d.parent.textBetween(d.parentOffset, w.parentOffset), G = () => N(t.state.tr.insertText(E, M, I));
      t.someProp("handleTextInput", (Y) => Y(t, M, I, E, G)) || t.dispatch(G());
    } else
      t.dispatch(N());
  else
    t.dispatch(N());
}
function vy(t, e, A) {
  return Math.max(A.anchor, A.head) > e.content.size ? null : XM(t, e.resolve(A.anchor), e.resolve(A.head));
}
function R9(t, e) {
  let A = t.firstChild.marks, n = e.firstChild.marks, s = A, r = n, i, o, a;
  for (let l = 0; l < n.length; l++)
    s = n[l].removeFromSet(s);
  for (let l = 0; l < A.length; l++)
    r = A[l].removeFromSet(r);
  if (s.length == 1 && r.length == 0)
    o = s[0], i = "add", a = (l) => l.mark(o.addToSet(l.marks));
  else if (s.length == 0 && r.length == 1)
    o = r[0], i = "remove", a = (l) => l.mark(o.removeFromSet(l.marks));
  else
    return null;
  let c = [];
  for (let l = 0; l < e.childCount; l++)
    c.push(a(e.child(l)));
  if (re.from(c).eq(t))
    return { mark: o, type: i };
}
function L9(t, e, A, n, s) {
  if (
    // The content must have shrunk
    A - e <= s.pos - n.pos || // newEnd must point directly at or after the end of the block that newStart points into
    FQ(n, !0, !1) < s.pos
  )
    return !1;
  let r = t.resolve(e);
  if (!n.parent.isTextblock) {
    let o = r.nodeAfter;
    return o != null && A == e + o.nodeSize;
  }
  if (r.parentOffset < r.parent.content.size || !r.parent.isTextblock)
    return !1;
  let i = t.resolve(FQ(r, !0, !0));
  return !i.parent.isTextblock || i.pos > A || FQ(i, !0, !1) < A ? !1 : n.parent.content.cut(n.parentOffset).eq(i.parent.content);
}
function FQ(t, e, A) {
  let n = t.depth, s = e ? t.end() : t.pos;
  for (; n > 0 && (e || t.indexAfter(n) == t.node(n).childCount); )
    n--, s++, e = !1;
  if (A) {
    let r = t.node(n).maybeChild(t.indexAfter(n));
    for (; r && !r.isLeaf; )
      r = r.firstChild, s++;
  }
  return s;
}
function S9(t, e, A, n, s) {
  let r = t.findDiffStart(e, A);
  if (r == null)
    return null;
  let { a: i, b: o } = t.findDiffEnd(e, A + t.size, A + e.size);
  if (s == "end") {
    let a = Math.max(0, r - Math.min(i, o));
    n -= i + a - r;
  }
  if (i < r && t.size < e.size) {
    let a = n <= r && n >= i ? r - n : 0;
    r -= a, r && r < e.size && jy(e.textBetween(r - 1, r + 1)) && (r += a ? 1 : -1), o = r + (o - i), i = r;
  } else if (o < r) {
    let a = n <= r && n >= o ? r - n : 0;
    r -= a, r && r < t.size && jy(t.textBetween(r - 1, r + 1)) && (r += a ? 1 : -1), i = r + (i - o), o = r;
  }
  return { start: r, endA: i, endB: o };
}
function jy(t) {
  if (t.length != 2)
    return !1;
  let e = t.charCodeAt(0), A = t.charCodeAt(1);
  return e >= 56320 && e <= 57343 && A >= 55296 && A <= 56319;
}
class sG {
  /**
  Create a view. `place` may be a DOM node that the editor should
  be appended to, a function that will place it into the document,
  or an object whose `mount` property holds the node to use as the
  document container. If it is `null`, the editor will not be
  added to the document.
  */
  constructor(e, A) {
    this._root = null, this.focused = !1, this.trackWrites = null, this.mounted = !1, this.markCursor = null, this.cursorWrapper = null, this.lastSelectedViewDesc = void 0, this.input = new n9(), this.prevDirectPlugins = [], this.pluginViews = [], this.requiresGeckoHackNode = !1, this.dragging = null, this._props = A, this.state = A.state, this.directPlugins = A.plugins || [], this.directPlugins.forEach(Sy), this.dispatch = this.dispatch.bind(this), this.dom = e && e.mount || document.createElement("div"), e && (e.appendChild ? e.appendChild(this.dom) : typeof e == "function" ? e(this.dom) : e.mount && (this.mounted = !0)), this.editable = Ry(this), ky(this), this.nodeViews = Ly(this), this.docView = fy(this.state.doc, Hy(this), yQ(this), this.dom, this), this.domObserver = new x9(this, (n, s, r, i) => k9(this, n, s, r, i)), this.domObserver.start(), s9(this), this.updatePluginViews();
  }
  /**
  Holds `true` when a
  [composition](https://w3c.github.io/uievents/#events-compositionevents)
  is active.
  */
  get composing() {
    return this.input.composing;
  }
  /**
  The view's current [props](https://prosemirror.net/docs/ref/#view.EditorProps).
  */
  get props() {
    if (this._props.state != this.state) {
      let e = this._props;
      this._props = {};
      for (let A in e)
        this._props[A] = e[A];
      this._props.state = this.state;
    }
    return this._props;
  }
  /**
  Update the view's props. Will immediately cause an update to
  the DOM.
  */
  update(e) {
    e.handleDOMEvents != this._props.handleDOMEvents && TC(this);
    let A = this._props;
    this._props = e, e.plugins && (e.plugins.forEach(Sy), this.directPlugins = e.plugins), this.updateStateInner(e.state, A);
  }
  /**
  Update the view by updating existing props object with the object
  given as argument. Equivalent to `view.update(Object.assign({},
  view.props, props))`.
  */
  setProps(e) {
    let A = {};
    for (let n in this._props)
      A[n] = this._props[n];
    A.state = this.state;
    for (let n in e)
      A[n] = e[n];
    this.update(A);
  }
  /**
  Update the editor's `state` prop, without touching any of the
  other props.
  */
  updateState(e) {
    this.updateStateInner(e, this._props);
  }
  updateStateInner(e, A) {
    var n;
    let s = this.state, r = !1, i = !1;
    e.storedMarks && this.composing && (q4(this), i = !0), this.state = e;
    let o = s.plugins != e.plugins || this._props.plugins != A.plugins;
    if (o || this._props.plugins != A.plugins || this._props.nodeViews != A.nodeViews) {
      let h = Ly(this);
      J9(h, this.nodeViews) && (this.nodeViews = h, r = !0);
    }
    (o || A.handleDOMEvents != this._props.handleDOMEvents) && TC(this), this.editable = Ry(this), ky(this);
    let a = yQ(this), c = Hy(this), l = s.plugins != e.plugins && !s.doc.eq(e.doc) ? "reset" : e.scrollToSelection > s.scrollToSelection ? "to selection" : "preserve", B = r || !this.docView.matchesNode(e.doc, c, a);
    (B || !e.selection.eq(s.selection)) && (i = !0);
    let g = l == "preserve" && i && this.dom.style.overflowAnchor == null && QT(this);
    if (i) {
      this.domObserver.stop();
      let h = B && (Zn || bA) && !this.composing && !s.selection.empty && !e.selection.empty && T9(s.selection, e.selection);
      if (B) {
        let u = bA ? this.trackWrites = this.domSelectionRange().focusNode : null;
        this.composing && (this.input.compositionNode = Q9(this)), (r || !this.docView.update(e.doc, c, a, this)) && (this.docView.updateOuterDeco(c), this.docView.destroy(), this.docView = fy(e.doc, c, a, this.dom, this)), u && (!this.trackWrites || !this.dom.contains(this.trackWrites)) && (h = !0);
      }
      h || !(this.input.mouseDown && this.domObserver.currentSelection.eq(this.domSelectionRange()) && TT(this)) ? zi(this, h) : (R4(this, e.selection), this.domObserver.setCurSelection()), this.domObserver.start();
    }
    this.updatePluginViews(s), !((n = this.dragging) === null || n === void 0) && n.node && !s.doc.eq(e.doc) && this.updateDraggedNode(this.dragging, s), l == "reset" ? this.dom.scrollTop = 0 : l == "to selection" ? this.scrollToSelection() : g && IT(g);
  }
  /**
  @internal
  */
  scrollToSelection() {
    let e = this.domSelectionRange().focusNode;
    if (!(!e || !this.dom.contains(e.nodeType == 1 ? e : e.parentNode))) {
      if (!this.someProp("handleScrollToSelection", (A) => A(this))) if (this.state.selection instanceof Ue) {
        let A = this.docView.domAfterPos(this.state.selection.from);
        A.nodeType == 1 && By(this, A.getBoundingClientRect(), e);
      } else
        By(this, this.coordsAtPos(this.state.selection.head, 1), e);
    }
  }
  destroyPluginViews() {
    let e;
    for (; e = this.pluginViews.pop(); )
      e.destroy && e.destroy();
  }
  updatePluginViews(e) {
    if (!e || e.plugins != this.state.plugins || this.directPlugins != this.prevDirectPlugins) {
      this.prevDirectPlugins = this.directPlugins, this.destroyPluginViews();
      for (let A = 0; A < this.directPlugins.length; A++) {
        let n = this.directPlugins[A];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
      for (let A = 0; A < this.state.plugins.length; A++) {
        let n = this.state.plugins[A];
        n.spec.view && this.pluginViews.push(n.spec.view(this));
      }
    } else
      for (let A = 0; A < this.pluginViews.length; A++) {
        let n = this.pluginViews[A];
        n.update && n.update(this, e);
      }
  }
  updateDraggedNode(e, A) {
    let n = e.node, s = -1;
    if (this.state.doc.nodeAt(n.from) == n.node)
      s = n.from;
    else {
      let r = n.from + (this.state.doc.content.size - A.doc.content.size);
      (r > 0 && this.state.doc.nodeAt(r)) == n.node && (s = r);
    }
    this.dragging = new $4(e.slice, e.move, s < 0 ? void 0 : Ue.create(this.state.doc, s));
  }
  someProp(e, A) {
    let n = this._props && this._props[e], s;
    if (n != null && (s = A ? A(n) : n))
      return s;
    for (let i = 0; i < this.directPlugins.length; i++) {
      let o = this.directPlugins[i].props[e];
      if (o != null && (s = A ? A(o) : o))
        return s;
    }
    let r = this.state.plugins;
    if (r)
      for (let i = 0; i < r.length; i++) {
        let o = r[i].props[e];
        if (o != null && (s = A ? A(o) : o))
          return s;
      }
  }
  /**
  Query whether the view has focus.
  */
  hasFocus() {
    if (Zn) {
      let e = this.root.activeElement;
      if (e == this.dom)
        return !0;
      if (!e || !this.dom.contains(e))
        return !1;
      for (; e && this.dom != e && this.dom.contains(e); ) {
        if (e.contentEditable == "false")
          return !1;
        e = e.parentElement;
      }
      return !0;
    }
    return this.root.activeElement == this.dom;
  }
  /**
  Focus the editor.
  */
  focus() {
    this.domObserver.stop(), this.editable && CT(this.dom), zi(this), this.domObserver.start();
  }
  /**
  Get the document root in which the editor exists. This will
  usually be the top-level `document`, but might be a [shadow
  DOM](https://developer.mozilla.org/en-US/docs/Web/Web_Components/Shadow_DOM)
  root if the editor is inside one.
  */
  get root() {
    let e = this._root;
    if (e == null) {
      for (let A = this.dom.parentNode; A; A = A.parentNode)
        if (A.nodeType == 9 || A.nodeType == 11 && A.host)
          return A.getSelection || (Object.getPrototypeOf(A).getSelection = () => A.ownerDocument.getSelection()), this._root = A;
    }
    return e || document;
  }
  /**
  When an existing editor view is moved to a new document or
  shadow tree, call this to make it recompute its root.
  */
  updateRoot() {
    this._root = null;
  }
  /**
  Given a pair of viewport coordinates, return the document
  position that corresponds to them. May return null if the given
  coordinates aren't inside of the editor. When an object is
  returned, its `pos` property is the position nearest to the
  coordinates, and its `inside` property holds the position of the
  inner node that the position falls inside of, or -1 if it is at
  the top level, not in any node.
  */
  posAtCoords(e) {
    return YT(this, e);
  }
  /**
  Returns the viewport rectangle at a given document position.
  `left` and `right` will be the same number, as this returns a
  flat cursor-ish rectangle. If the position is between two things
  that aren't directly adjacent, `side` determines which element
  is used. When < 0, the element before the position is used,
  otherwise the element after.
  */
  coordsAtPos(e, A = 1) {
    return G4(this, e, A);
  }
  /**
  Find the DOM position that corresponds to the given document
  position. When `side` is negative, find the position as close as
  possible to the content before the position. When positive,
  prefer positions close to the content after the position. When
  zero, prefer as shallow a position as possible.
  
  Note that you should **not** mutate the editor's internal DOM,
  only inspect it (and even that is usually not necessary).
  */
  domAtPos(e, A = 0) {
    return this.docView.domFromPos(e, A);
  }
  /**
  Find the DOM node that represents the document node after the
  given position. May return `null` when the position doesn't point
  in front of a node or if the node is inside an opaque node view.
  
  This is intended to be able to call things like
  `getBoundingClientRect` on that DOM node. Do **not** mutate the
  editor DOM directly, or add styling this way, since that will be
  immediately overriden by the editor as it redraws the node.
  */
  nodeDOM(e) {
    let A = this.docView.descAt(e);
    return A ? A.nodeDOM : null;
  }
  /**
  Find the document position that corresponds to a given DOM
  position. (Whenever possible, it is preferable to inspect the
  document structure directly, rather than poking around in the
  DOM, but sometimes—for example when interpreting an event
  target—you don't have a choice.)
  
  The `bias` parameter can be used to influence which side of a DOM
  node to use when the position is inside a leaf node.
  */
  posAtDOM(e, A, n = -1) {
    let s = this.docView.posFromDOM(e, A, n);
    if (s == null)
      throw new RangeError("DOM position not inside the editor");
    return s;
  }
  /**
  Find out whether the selection is at the end of a textblock when
  moving in a given direction. When, for example, given `"left"`,
  it will return true if moving left from the current cursor
  position would leave that position's parent textblock. Will apply
  to the view's current state by default, but it is possible to
  pass a different state.
  */
  endOfTextblock(e, A) {
    return xT(this, A || this.state, e);
  }
  /**
  Run the editor's paste logic with the given HTML string. The
  `event`, if given, will be passed to the
  [`handlePaste`](https://prosemirror.net/docs/ref/#view.EditorProps.handlePaste) hook.
  */
  pasteHTML(e, A) {
    return yg(this, "", e, !1, A || new ClipboardEvent("paste"));
  }
  /**
  Run the editor's paste logic with the given plain-text input.
  */
  pasteText(e, A) {
    return yg(this, e, null, !0, A || new ClipboardEvent("paste"));
  }
  /**
  Serialize the given slice as it would be if it was copied from
  this editor. Returns a DOM element that contains a
  representation of the slice as its children, a textual
  representation, and the transformed slice (which can be
  different from the given input due to hooks like
  [`transformCopied`](https://prosemirror.net/docs/ref/#view.EditorProps.transformCopied)).
  */
  serializeForClipboard(e) {
    return ZM(this, e);
  }
  /**
  Removes the editor from the DOM and destroys all [node
  views](https://prosemirror.net/docs/ref/#view.NodeView).
  */
  destroy() {
    this.docView && (r9(this), this.destroyPluginViews(), this.mounted ? (this.docView.update(this.state.doc, [], yQ(this), this), this.dom.textContent = "") : this.dom.parentNode && this.dom.parentNode.removeChild(this.dom), this.docView.destroy(), this.docView = null, aT());
  }
  /**
  This is true when the view has been
  [destroyed](https://prosemirror.net/docs/ref/#view.EditorView.destroy) (and thus should not be
  used anymore).
  */
  get isDestroyed() {
    return this.docView == null;
  }
  /**
  Used for testing.
  */
  dispatchEvent(e) {
    return o9(this, e);
  }
  /**
  @internal
  */
  domSelectionRange() {
    let e = this.domSelection();
    return e ? XA && this.root.nodeType === 11 && hT(this.dom.ownerDocument) == this.dom && z9(this, e) || e : { focusNode: null, focusOffset: 0, anchorNode: null, anchorOffset: 0 };
  }
  /**
  @internal
  */
  domSelection() {
    return this.root.getSelection();
  }
}
sG.prototype.dispatch = function(t) {
  let e = this._props.dispatchTransaction;
  e ? e.call(this, t) : this.updateState(this.state.apply(t));
};
function Hy(t) {
  let e = /* @__PURE__ */ Object.create(null);
  return e.class = "ProseMirror", e.contenteditable = String(t.editable), t.someProp("attributes", (A) => {
    if (typeof A == "function" && (A = A(t.state)), A)
      for (let n in A)
        n == "class" ? e.class += " " + A[n] : n == "style" ? e.style = (e.style ? e.style + ";" : "") + A[n] : !e[n] && n != "contenteditable" && n != "nodeName" && (e[n] = String(A[n]));
  }), e.translate || (e.translate = "no"), [Wt.node(0, t.state.doc.content.size, e)];
}
function ky(t) {
  if (t.markCursor) {
    let e = document.createElement("img");
    e.className = "ProseMirror-separator", e.setAttribute("mark-placeholder", "true"), e.setAttribute("alt", ""), t.cursorWrapper = { dom: e, deco: Wt.widget(t.state.selection.from, e, { raw: !0, marks: t.markCursor }) };
  } else
    t.cursorWrapper = null;
}
function Ry(t) {
  return !t.someProp("editable", (e) => e(t.state) === !1);
}
function T9(t, e) {
  let A = Math.min(t.$anchor.sharedDepth(t.head), e.$anchor.sharedDepth(e.head));
  return t.$anchor.start(A) != e.$anchor.start(A);
}
function Ly(t) {
  let e = /* @__PURE__ */ Object.create(null);
  function A(n) {
    for (let s in n)
      Object.prototype.hasOwnProperty.call(e, s) || (e[s] = n[s]);
  }
  return t.someProp("nodeViews", A), t.someProp("markViews", A), e;
}
function J9(t, e) {
  let A = 0, n = 0;
  for (let s in t) {
    if (t[s] != e[s])
      return !0;
    A++;
  }
  for (let s in e)
    n++;
  return A != n;
}
function Sy(t) {
  if (t.spec.state || t.spec.filterTransaction || t.spec.appendTransaction)
    throw new RangeError("Plugins passed directly to the view must not have a state component");
}
var Ko = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
}, Su = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
}, W9 = typeof navigator < "u" && /Mac/.test(navigator.platform), O9 = typeof navigator < "u" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var KA = 0; KA < 10; KA++) Ko[48 + KA] = Ko[96 + KA] = String(KA);
for (var KA = 1; KA <= 24; KA++) Ko[KA + 111] = "F" + KA;
for (var KA = 65; KA <= 90; KA++)
  Ko[KA] = String.fromCharCode(KA + 32), Su[KA] = String.fromCharCode(KA);
for (var NQ in Ko) Su.hasOwnProperty(NQ) || (Su[NQ] = Ko[NQ]);
function P9(t) {
  var e = W9 && t.metaKey && t.shiftKey && !t.ctrlKey && !t.altKey || O9 && t.shiftKey && t.key && t.key.length == 1 || t.key == "Unidentified", A = !e && t.key || (t.shiftKey ? Su : Ko)[t.keyCode] || t.key || "Unidentified";
  return A == "Esc" && (A = "Escape"), A == "Del" && (A = "Delete"), A == "Left" && (A = "ArrowLeft"), A == "Up" && (A = "ArrowUp"), A == "Right" && (A = "ArrowRight"), A == "Down" && (A = "ArrowDown"), A;
}
const K9 = typeof navigator < "u" && /Mac|iP(hone|[oa]d)/.test(navigator.platform), V9 = typeof navigator < "u" && /Win/.test(navigator.platform);
function X9(t) {
  let e = t.split(/-(?!$)/), A = e[e.length - 1];
  A == "Space" && (A = " ");
  let n, s, r, i;
  for (let o = 0; o < e.length - 1; o++) {
    let a = e[o];
    if (/^(cmd|meta|m)$/i.test(a))
      i = !0;
    else if (/^a(lt)?$/i.test(a))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      s = !0;
    else if (/^s(hift)?$/i.test(a))
      r = !0;
    else if (/^mod$/i.test(a))
      K9 ? i = !0 : s = !0;
    else
      throw new Error("Unrecognized modifier name: " + a);
  }
  return n && (A = "Alt-" + A), s && (A = "Ctrl-" + A), i && (A = "Meta-" + A), r && (A = "Shift-" + A), A;
}
function Z9(t) {
  let e = /* @__PURE__ */ Object.create(null);
  for (let A in t)
    e[X9(A)] = t[A];
  return e;
}
function DQ(t, e, A = !0) {
  return e.altKey && (t = "Alt-" + t), e.ctrlKey && (t = "Ctrl-" + t), e.metaKey && (t = "Meta-" + t), A && e.shiftKey && (t = "Shift-" + t), t;
}
function q9(t) {
  return new ct({ props: { handleKeyDown: Ap(t) } });
}
function Ap(t) {
  let e = Z9(t);
  return function(A, n) {
    let s = P9(n), r, i = e[DQ(s, n)];
    if (i && i(A.state, A.dispatch, A))
      return !0;
    if (s.length == 1 && s != " ") {
      if (n.shiftKey) {
        let o = e[DQ(s, n, !1)];
        if (o && o(A.state, A.dispatch, A))
          return !0;
      }
      if ((n.altKey || n.metaKey || n.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
      !(V9 && n.ctrlKey && n.altKey) && (r = Ko[n.keyCode]) && r != s) {
        let o = e[DQ(r, n)];
        if (o && o(A.state, A.dispatch, A))
          return !0;
      }
    }
    return !1;
  };
}
var _9 = Object.defineProperty, np = (t, e) => {
  for (var A in e)
    _9(t, A, { get: e[A], enumerable: !0 });
};
function Dw(t) {
  const { state: e, transaction: A } = t;
  let { selection: n } = A, { doc: s } = A, { storedMarks: r } = A;
  return {
    ...e,
    apply: e.apply.bind(e),
    applyTransaction: e.applyTransaction.bind(e),
    plugins: e.plugins,
    schema: e.schema,
    reconfigure: e.reconfigure.bind(e),
    toJSON: e.toJSON.bind(e),
    get storedMarks() {
      return r;
    },
    get selection() {
      return n;
    },
    get doc() {
      return s;
    },
    get tr() {
      return n = A.selection, s = A.doc, r = A.storedMarks, A;
    }
  };
}
var xw = class {
  constructor(t) {
    this.editor = t.editor, this.rawCommands = this.editor.extensionManager.commands, this.customState = t.state;
  }
  get hasCustomState() {
    return !!this.customState;
  }
  get state() {
    return this.customState || this.editor.state;
  }
  get commands() {
    const { rawCommands: t, editor: e, state: A } = this, { view: n } = e, { tr: s } = A, r = this.buildProps(s);
    return Object.fromEntries(
      Object.entries(t).map(([i, o]) => [i, (...c) => {
        const l = o(...c)(r);
        return !s.getMeta("preventDispatch") && !this.hasCustomState && n.dispatch(s), l;
      }])
    );
  }
  get chain() {
    return () => this.createChain();
  }
  get can() {
    return () => this.createCan();
  }
  createChain(t, e = !0) {
    const { rawCommands: A, editor: n, state: s } = this, { view: r } = n, i = [], o = !!t, a = t || s.tr, c = () => (!o && e && !a.getMeta("preventDispatch") && !this.hasCustomState && r.dispatch(a), i.every((B) => B === !0)), l = {
      ...Object.fromEntries(
        Object.entries(A).map(([B, g]) => [B, (...u) => {
          const d = this.buildProps(a, e), w = g(...u)(d);
          return i.push(w), l;
        }])
      ),
      run: c
    };
    return l;
  }
  createCan(t) {
    const { rawCommands: e, state: A } = this, n = !1, s = t || A.tr, r = this.buildProps(s, n);
    return {
      ...Object.fromEntries(
        Object.entries(e).map(([o, a]) => [o, (...c) => a(...c)({ ...r, dispatch: void 0 })])
      ),
      chain: () => this.createChain(s, n)
    };
  }
  buildProps(t, e = !0) {
    const { rawCommands: A, editor: n, state: s } = this, { view: r } = n, i = {
      tr: t,
      editor: n,
      view: r,
      state: Dw({
        state: s,
        transaction: t
      }),
      dispatch: e ? () => {
      } : void 0,
      chain: () => this.createChain(t, e),
      can: () => this.createCan(t),
      get commands() {
        return Object.fromEntries(
          Object.entries(A).map(([o, a]) => [o, (...c) => a(...c)(i)])
        );
      }
    };
    return i;
  }
}, rG = {};
np(rG, {
  blur: () => $9,
  clearContent: () => e6,
  clearNodes: () => t6,
  command: () => A6,
  createParagraphNear: () => n6,
  cut: () => s6,
  deleteCurrentNode: () => r6,
  deleteNode: () => i6,
  deleteRange: () => o6,
  deleteSelection: () => a6,
  enter: () => c6,
  exitCode: () => l6,
  extendMarkRange: () => B6,
  first: () => g6,
  focus: () => u6,
  forEach: () => d6,
  insertContent: () => w6,
  insertContentAt: () => I6,
  joinBackward: () => M6,
  joinDown: () => E6,
  joinForward: () => p6,
  joinItemBackward: () => m6,
  joinItemForward: () => Y6,
  joinTextblockBackward: () => y6,
  joinTextblockForward: () => F6,
  joinUp: () => C6,
  keyboardShortcut: () => D6,
  lift: () => x6,
  liftEmptyBlock: () => G6,
  liftListItem: () => z6,
  newlineInCode: () => U6,
  resetAttributes: () => b6,
  scrollIntoView: () => v6,
  selectAll: () => j6,
  selectNodeBackward: () => H6,
  selectNodeForward: () => k6,
  selectParentNode: () => R6,
  selectTextblockEnd: () => L6,
  selectTextblockStart: () => S6,
  setContent: () => T6,
  setMark: () => aJ,
  setMeta: () => cJ,
  setNode: () => lJ,
  setNodeSelection: () => BJ,
  setTextDirection: () => gJ,
  setTextSelection: () => hJ,
  sinkListItem: () => uJ,
  splitBlock: () => dJ,
  splitListItem: () => wJ,
  toggleList: () => fJ,
  toggleMark: () => QJ,
  toggleNode: () => IJ,
  toggleWrap: () => CJ,
  undoInputRule: () => EJ,
  unsetAllMarks: () => MJ,
  unsetMark: () => pJ,
  unsetTextDirection: () => mJ,
  updateAttributes: () => YJ,
  wrapIn: () => yJ,
  wrapInList: () => FJ
});
var $9 = () => ({ editor: t, view: e }) => (requestAnimationFrame(() => {
  var A;
  t.isDestroyed || (e.dom.blur(), (A = window == null ? void 0 : window.getSelection()) == null || A.removeAllRanges());
}), !0), e6 = (t = !0) => ({ commands: e }) => e.setContent("", { emitUpdate: t }), t6 = () => ({ state: t, tr: e, dispatch: A }) => {
  const { selection: n } = e, { ranges: s } = n;
  return A && s.forEach(({ $from: r, $to: i }) => {
    t.doc.nodesBetween(r.pos, i.pos, (o, a) => {
      if (o.type.isText)
        return;
      const { doc: c, mapping: l } = e, B = c.resolve(l.map(a)), g = c.resolve(l.map(a + o.nodeSize)), h = B.blockRange(g);
      if (!h)
        return;
      const u = cc(h);
      if (o.type.isTextblock) {
        const { defaultType: d } = B.parent.contentMatchAt(B.index());
        e.setNodeMarkup(h.start, d);
      }
      (u || u === 0) && e.lift(h, u);
    });
  }), !0;
}, A6 = (t) => (e) => t(e), n6 = () => ({ state: t, dispatch: e }) => C4(t, e), s6 = (t, e) => ({ editor: A, tr: n }) => {
  const { state: s } = A, r = s.doc.slice(t.from, t.to);
  n.deleteRange(t.from, t.to);
  const i = n.mapping.map(e);
  return n.insert(i, r.content), n.setSelection(new Re(n.doc.resolve(Math.max(i - 1, 0)))), !0;
}, r6 = () => ({ tr: t, dispatch: e }) => {
  const { selection: A } = t, n = A.$anchor.node();
  if (n.content.size > 0)
    return !1;
  const s = t.selection.$anchor;
  for (let r = s.depth; r > 0; r -= 1)
    if (s.node(r).type === n.type) {
      if (e) {
        const o = s.before(r), a = s.after(r);
        t.delete(o, a).scrollIntoView();
      }
      return !0;
    }
  return !1;
};
function MA(t, e) {
  if (typeof t == "string") {
    if (!e.nodes[t])
      throw Error(`There is no node type named '${t}'. Maybe you forgot to add the extension?`);
    return e.nodes[t];
  }
  return t;
}
var i6 = (t) => ({ tr: e, state: A, dispatch: n }) => {
  const s = MA(t, A.schema), r = e.selection.$anchor;
  for (let i = r.depth; i > 0; i -= 1)
    if (r.node(i).type === s) {
      if (n) {
        const a = r.before(i), c = r.after(i);
        e.delete(a, c).scrollIntoView();
      }
      return !0;
    }
  return !1;
}, o6 = (t) => ({ tr: e, dispatch: A }) => {
  const { from: n, to: s } = t;
  return A && e.delete(n, s), !0;
}, a6 = () => ({ state: t, dispatch: e }) => TM(t, e), c6 = () => ({ commands: t }) => t.keyboardShortcut("Enter"), l6 = () => ({ state: t, dispatch: e }) => KS(t, e);
function sp(t) {
  return Object.prototype.toString.call(t) === "[object RegExp]";
}
function Tu(t, e, A = { strict: !0 }) {
  const n = Object.keys(e);
  return n.length ? n.every((s) => A.strict ? e[s] === t[s] : sp(e[s]) ? e[s].test(t[s]) : e[s] === t[s]) : !0;
}
function iG(t, e, A = {}) {
  return t.find((n) => n.type === e && Tu(
    // Only check equality for the attributes that are provided
    Object.fromEntries(Object.keys(A).map((s) => [s, n.attrs[s]])),
    A
  ));
}
function Ty(t, e, A = {}) {
  return !!iG(t, e, A);
}
function rp(t, e, A) {
  var n;
  if (!t || !e)
    return;
  let s = t.parent.childAfter(t.parentOffset);
  if ((!s.node || !s.node.marks.some((l) => l.type === e)) && (s = t.parent.childBefore(t.parentOffset)), !s.node || !s.node.marks.some((l) => l.type === e) || (A = A || ((n = s.node.marks[0]) == null ? void 0 : n.attrs), !iG([...s.node.marks], e, A)))
    return;
  let i = s.index, o = t.start() + s.offset, a = i + 1, c = o + s.node.nodeSize;
  for (; i > 0 && Ty([...t.parent.child(i - 1).marks], e, A); )
    i -= 1, o -= t.parent.child(i).nodeSize;
  for (; a < t.parent.childCount && Ty([...t.parent.child(a).marks], e, A); )
    c += t.parent.child(a).nodeSize, a += 1;
  return {
    from: o,
    to: c
  };
}
function $i(t, e) {
  if (typeof t == "string") {
    if (!e.marks[t])
      throw Error(`There is no mark type named '${t}'. Maybe you forgot to add the extension?`);
    return e.marks[t];
  }
  return t;
}
var B6 = (t, e = {}) => ({ tr: A, state: n, dispatch: s }) => {
  const r = $i(t, n.schema), { doc: i, selection: o } = A, { $from: a, from: c, to: l } = o;
  if (s) {
    const B = rp(a, r, e);
    if (B && B.from <= c && B.to >= l) {
      const g = Re.create(i, B.from, B.to);
      A.setSelection(g);
    }
  }
  return !0;
}, g6 = (t) => (e) => {
  const A = typeof t == "function" ? t(e) : t;
  for (let n = 0; n < A.length; n += 1)
    if (A[n](e))
      return !0;
  return !1;
};
function ip(t) {
  return t instanceof Re;
}
function Fi(t = 0, e = 0, A = 0) {
  return Math.min(Math.max(t, e), A);
}
function oG(t, e = null) {
  if (!e)
    return null;
  const A = Ke.atStart(t), n = Ke.atEnd(t);
  if (e === "start" || e === !0)
    return A;
  if (e === "end")
    return n;
  const s = A.from, r = n.to;
  return e === "all" ? Re.create(t, Fi(0, s, r), Fi(t.content.size, s, r)) : Re.create(t, Fi(e, s, r), Fi(e, s, r));
}
function Jy() {
  return navigator.platform === "Android" || /android/i.test(navigator.userAgent);
}
function Ju() {
  return ["iPad Simulator", "iPhone Simulator", "iPod Simulator", "iPad", "iPhone", "iPod"].includes(navigator.platform) || // iPad on iOS 13 detection
  navigator.userAgent.includes("Mac") && "ontouchend" in document;
}
function h6() {
  return typeof navigator < "u" ? /^((?!chrome|android).)*safari/i.test(navigator.userAgent) : !1;
}
var u6 = (t = null, e = {}) => ({ editor: A, view: n, tr: s, dispatch: r }) => {
  e = {
    scrollIntoView: !0,
    ...e
  };
  const i = () => {
    (Ju() || Jy()) && n.dom.focus(), h6() && !Ju() && !Jy() && n.dom.focus({ preventScroll: !0 }), requestAnimationFrame(() => {
      A.isDestroyed || (n.focus(), e != null && e.scrollIntoView && A.commands.scrollIntoView());
    });
  };
  try {
    if (n.hasFocus() && t === null || t === !1)
      return !0;
  } catch {
    return !1;
  }
  if (r && t === null && !ip(A.state.selection))
    return i(), !0;
  const o = oG(s.doc, t) || A.state.selection, a = A.state.selection.eq(o);
  return r && (a || s.setSelection(o), a && s.storedMarks && s.setStoredMarks(s.storedMarks), i()), !0;
}, d6 = (t, e) => (A) => t.every((n, s) => e(n, { ...A, index: s })), w6 = (t, e) => ({ tr: A, commands: n }) => n.insertContentAt({ from: A.selection.from, to: A.selection.to }, t, e), aG = (t) => {
  const e = t.childNodes;
  for (let A = e.length - 1; A >= 0; A -= 1) {
    const n = e[A];
    n.nodeType === 3 && n.nodeValue && /^(\n\s\s|\n)$/.test(n.nodeValue) ? t.removeChild(n) : n.nodeType === 1 && aG(n);
  }
  return t;
};
function s0(t) {
  if (typeof window > "u")
    throw new Error("[tiptap error]: there is no window object available, so this function cannot be used");
  const e = `<body>${t}</body>`, A = new window.DOMParser().parseFromString(e, "text/html").body;
  return aG(A);
}
function Ng(t, e, A) {
  if (t instanceof xi || t instanceof re)
    return t;
  A = {
    slice: !0,
    parseOptions: {},
    ...A
  };
  const n = typeof t == "object" && t !== null, s = typeof t == "string";
  if (n)
    try {
      if (Array.isArray(t) && t.length > 0)
        return re.fromArray(t.map((o) => e.nodeFromJSON(o)));
      const i = e.nodeFromJSON(t);
      return A.errorOnInvalidContent && i.check(), i;
    } catch (r) {
      if (A.errorOnInvalidContent)
        throw new Error("[tiptap error]: Invalid JSON content", { cause: r });
      return console.warn("[tiptap warn]: Invalid content.", "Passed value:", t, "Error:", r), Ng("", e, A);
    }
  if (s) {
    if (A.errorOnInvalidContent) {
      let i = !1, o = "";
      const a = new Vx({
        topNode: e.spec.topNode,
        marks: e.spec.marks,
        // Prosemirror's schemas are executed such that: the last to execute, matches last
        // This means that we can add a catch-all node at the end of the schema to catch any content that we don't know how to handle
        nodes: e.spec.nodes.append({
          __tiptap__private__unknown__catch__all__node: {
            content: "inline*",
            group: "block",
            parseDOM: [
              {
                tag: "*",
                getAttrs: (c) => (i = !0, o = typeof c == "string" ? c : c.outerHTML, null)
              }
            ]
          }
        })
      });
      if (A.slice ? SB.fromSchema(a).parseSlice(s0(t), A.parseOptions) : SB.fromSchema(a).parse(s0(t), A.parseOptions), A.errorOnInvalidContent && i)
        throw new Error("[tiptap error]: Invalid HTML content", {
          cause: new Error(`Invalid element found: ${o}`)
        });
    }
    const r = SB.fromSchema(e);
    return A.slice ? r.parseSlice(s0(t), A.parseOptions).content : r.parse(s0(t), A.parseOptions);
  }
  return Ng("", e, A);
}
function f6(t, e, A) {
  const n = t.steps.length - 1;
  if (n < e)
    return;
  const s = t.steps[n];
  if (!(s instanceof GA || s instanceof vA))
    return;
  const r = t.mapping.maps[n];
  let i = 0;
  r.forEach((o, a, c, l) => {
    i === 0 && (i = l);
  }), t.setSelection(Ke.near(t.doc.resolve(i), A));
}
var Q6 = (t) => !("type" in t), I6 = (t, e, A) => ({ tr: n, dispatch: s, editor: r }) => {
  var i;
  if (s) {
    A = {
      parseOptions: r.options.parseOptions,
      updateSelection: !0,
      applyInputRules: !1,
      applyPasteRules: !1,
      ...A
    };
    let o;
    const a = (w) => {
      r.emit("contentError", {
        editor: r,
        error: w,
        disableCollaboration: () => {
          "collaboration" in r.storage && typeof r.storage.collaboration == "object" && r.storage.collaboration && (r.storage.collaboration.isDisabled = !0);
        }
      });
    }, c = {
      preserveWhitespace: "full",
      ...A.parseOptions
    };
    if (!A.errorOnInvalidContent && !r.options.enableContentCheck && r.options.emitContentError)
      try {
        Ng(e, r.schema, {
          parseOptions: c,
          errorOnInvalidContent: !0
        });
      } catch (w) {
        a(w);
      }
    try {
      o = Ng(e, r.schema, {
        parseOptions: c,
        errorOnInvalidContent: (i = A.errorOnInvalidContent) != null ? i : r.options.enableContentCheck
      });
    } catch (w) {
      return a(w), !1;
    }
    let { from: l, to: B } = typeof t == "number" ? { from: t, to: t } : { from: t.from, to: t.to }, g = !0, h = !0;
    if ((Q6(o) ? o : [o]).forEach((w) => {
      w.check(), g = g ? w.isText && w.marks.length === 0 : !1, h = h ? w.isBlock : !1;
    }), l === B && h) {
      const { parent: w } = n.doc.resolve(l);
      w.isTextblock && !w.type.spec.code && !w.childCount && (l -= 1, B += 1);
    }
    let d;
    if (g) {
      if (Array.isArray(e))
        d = e.map((w) => w.text || "").join("");
      else if (e instanceof re) {
        let w = "";
        e.forEach((Q) => {
          Q.text && (w += Q.text);
        }), d = w;
      } else typeof e == "object" && e && e.text ? d = e.text : d = e;
      n.insertText(d, l, B);
    } else {
      d = o;
      const w = n.doc.resolve(l), Q = w.node(), p = w.parentOffset === 0, M = Q.isText || Q.isTextblock, I = Q.content.size > 0;
      p && M && I && (l = Math.max(0, l - 1)), n.replaceWith(l, B, d);
    }
    A.updateSelection && f6(n, n.steps.length - 1, -1), A.applyInputRules && n.setMeta("applyInputRules", { from: l, text: d }), A.applyPasteRules && n.setMeta("applyPasteRules", { from: l, text: d });
  }
  return !0;
}, C6 = () => ({ state: t, dispatch: e }) => WS(t, e), E6 = () => ({ state: t, dispatch: e }) => OS(t, e), M6 = () => ({ state: t, dispatch: e }) => h4(t, e), p6 = () => ({ state: t, dispatch: e }) => f4(t, e), m6 = () => ({ state: t, dispatch: e, tr: A }) => {
  try {
    const n = pw(t.doc, t.selection.$from.pos, -1);
    return n == null ? !1 : (A.join(n, 2), e && e(A), !0);
  } catch {
    return !1;
  }
}, Y6 = () => ({ state: t, dispatch: e, tr: A }) => {
  try {
    const n = pw(t.doc, t.selection.$from.pos, 1);
    return n == null ? !1 : (A.join(n, 2), e && e(A), !0);
  } catch {
    return !1;
  }
}, y6 = () => ({ state: t, dispatch: e }) => TS(t, e), F6 = () => ({ state: t, dispatch: e }) => JS(t, e);
function cG() {
  return typeof navigator < "u" ? /Mac/.test(navigator.platform) : !1;
}
function N6(t) {
  const e = t.split(/-(?!$)/);
  let A = e[e.length - 1];
  A === "Space" && (A = " ");
  let n, s, r, i;
  for (let o = 0; o < e.length - 1; o += 1) {
    const a = e[o];
    if (/^(cmd|meta|m)$/i.test(a))
      i = !0;
    else if (/^a(lt)?$/i.test(a))
      n = !0;
    else if (/^(c|ctrl|control)$/i.test(a))
      s = !0;
    else if (/^s(hift)?$/i.test(a))
      r = !0;
    else if (/^mod$/i.test(a))
      Ju() || cG() ? i = !0 : s = !0;
    else
      throw new Error(`Unrecognized modifier name: ${a}`);
  }
  return n && (A = `Alt-${A}`), s && (A = `Ctrl-${A}`), i && (A = `Meta-${A}`), r && (A = `Shift-${A}`), A;
}
var D6 = (t) => ({ editor: e, view: A, tr: n, dispatch: s }) => {
  const r = N6(t).split(/-(?!$)/), i = r.find((c) => !["Alt", "Ctrl", "Meta", "Shift"].includes(c)), o = new KeyboardEvent("keydown", {
    key: i === "Space" ? " " : i,
    altKey: r.includes("Alt"),
    ctrlKey: r.includes("Ctrl"),
    metaKey: r.includes("Meta"),
    shiftKey: r.includes("Shift"),
    bubbles: !0,
    cancelable: !0
  }), a = e.captureTransaction(() => {
    A.someProp("handleKeyDown", (c) => c(A, o));
  });
  return a == null || a.steps.forEach((c) => {
    const l = c.map(n.mapping);
    l && s && n.maybeStep(l);
  }), !0;
};
function Vo(t, e, A = {}) {
  const { from: n, to: s, empty: r } = t.selection, i = e ? MA(e, t.schema) : null, o = [];
  t.doc.nodesBetween(n, s, (B, g) => {
    if (B.isText)
      return;
    const h = Math.max(n, g), u = Math.min(s, g + B.nodeSize);
    o.push({
      node: B,
      from: h,
      to: u
    });
  });
  const a = s - n, c = o.filter((B) => i ? i.name === B.node.type.name : !0).filter((B) => Tu(B.node.attrs, A, { strict: !1 }));
  return r ? !!c.length : c.reduce((B, g) => B + g.to - g.from, 0) >= a;
}
var x6 = (t, e = {}) => ({ state: A, dispatch: n }) => {
  const s = MA(t, A.schema);
  return Vo(A, s, e) ? PS(A, n) : !1;
}, G6 = () => ({ state: t, dispatch: e }) => E4(t, e), z6 = (t) => ({ state: e, dispatch: A }) => {
  const n = MA(t, e.schema);
  return sT(n)(e, A);
}, U6 = () => ({ state: t, dispatch: e }) => I4(t, e);
function Gw(t, e) {
  return e.nodes[t] ? "node" : e.marks[t] ? "mark" : null;
}
function Wy(t, e) {
  const A = typeof e == "string" ? [e] : e;
  return Object.keys(t).reduce((n, s) => (A.includes(s) || (n[s] = t[s]), n), {});
}
var b6 = (t, e) => ({ tr: A, state: n, dispatch: s }) => {
  let r = null, i = null;
  const o = Gw(
    typeof t == "string" ? t : t.name,
    n.schema
  );
  if (!o)
    return !1;
  o === "node" && (r = MA(t, n.schema)), o === "mark" && (i = $i(t, n.schema));
  let a = !1;
  return A.selection.ranges.forEach((c) => {
    n.doc.nodesBetween(c.$from.pos, c.$to.pos, (l, B) => {
      r && r === l.type && (a = !0, s && A.setNodeMarkup(B, void 0, Wy(l.attrs, e))), i && l.marks.length && l.marks.forEach((g) => {
        i === g.type && (a = !0, s && A.addMark(B, B + l.nodeSize, i.create(Wy(g.attrs, e))));
      });
    });
  }), a;
}, v6 = () => ({ tr: t, dispatch: e }) => (e && t.scrollIntoView(), !0), j6 = () => ({ tr: t, dispatch: e }) => {
  if (e) {
    const A = new Xn(t.doc);
    t.setSelection(A);
  }
  return !0;
}, H6 = () => ({ state: t, dispatch: e }) => d4(t, e), k6 = () => ({ state: t, dispatch: e }) => Q4(t, e), R6 = () => ({ state: t, dispatch: e }) => ZS(t, e), L6 = () => ({ state: t, dispatch: e }) => $S(t, e), S6 = () => ({ state: t, dispatch: e }) => _S(t, e);
function JC(t, e, A = {}, n = {}) {
  return Ng(t, e, {
    slice: !1,
    parseOptions: A,
    errorOnInvalidContent: n.errorOnInvalidContent
  });
}
var T6 = (t, { errorOnInvalidContent: e, emitUpdate: A = !0, parseOptions: n = {} } = {}) => ({ editor: s, tr: r, dispatch: i, commands: o }) => {
  const { doc: a } = r;
  if (n.preserveWhitespace !== "full") {
    const c = JC(t, s.schema, n, {
      errorOnInvalidContent: e ?? s.options.enableContentCheck
    });
    return i && r.replaceWith(0, a.content.size, c).setMeta("preventUpdate", !A), !0;
  }
  return i && r.setMeta("preventUpdate", !A), o.insertContentAt({ from: 0, to: a.content.size }, t, {
    parseOptions: n,
    errorOnInvalidContent: e ?? s.options.enableContentCheck
  });
};
function lG(t, e) {
  const A = $i(e, t.schema), { from: n, to: s, empty: r } = t.selection, i = [];
  r ? (t.storedMarks && i.push(...t.storedMarks), i.push(...t.selection.$head.marks())) : t.doc.nodesBetween(n, s, (a) => {
    i.push(...a.marks);
  });
  const o = i.find((a) => a.type.name === A.name);
  return o ? { ...o.attrs } : {};
}
function BG(t, e) {
  const A = new RM(t);
  return e.forEach((n) => {
    n.steps.forEach((s) => {
      A.step(s);
    });
  }), A;
}
function J6(t) {
  for (let e = 0; e < t.edgeCount; e += 1) {
    const { type: A } = t.edge(e);
    if (A.isTextblock && !A.hasRequiredAttrs())
      return A;
  }
  return null;
}
function W6(t, e, A) {
  const n = [];
  return t.nodesBetween(e.from, e.to, (s, r) => {
    A(s) && n.push({
      node: s,
      pos: r
    });
  }), n;
}
function gG(t, e) {
  for (let A = t.depth; A > 0; A -= 1) {
    const n = t.node(A);
    if (e(n))
      return {
        pos: A > 0 ? t.before(A) : 0,
        start: t.start(A),
        depth: A,
        node: n
      };
  }
}
function zw(t) {
  return (e) => gG(e.$from, t);
}
function He(t, e, A) {
  return t.config[e] === void 0 && t.parent ? He(t.parent, e, A) : typeof t.config[e] == "function" ? t.config[e].bind({
    ...A,
    parent: t.parent ? He(t.parent, e, A) : null
  }) : t.config[e];
}
function op(t) {
  return t.map((e) => {
    const A = {
      name: e.name,
      options: e.options,
      storage: e.storage
    }, n = He(e, "addExtensions", A);
    return n ? [e, ...op(n())] : e;
  }).flat(10);
}
function ap(t, e) {
  const A = ac.fromSchema(e).serializeFragment(t), s = document.implementation.createHTMLDocument().createElement("div");
  return s.appendChild(A), s.innerHTML;
}
function hG(t) {
  return typeof t == "function";
}
function Nt(t, e = void 0, ...A) {
  return hG(t) ? e ? t.bind(e)(...A) : t(...A) : t;
}
function O6(t = {}) {
  return Object.keys(t).length === 0 && t.constructor === Object;
}
function pl(t) {
  const e = t.filter((s) => s.type === "extension"), A = t.filter((s) => s.type === "node"), n = t.filter((s) => s.type === "mark");
  return {
    baseExtensions: e,
    nodeExtensions: A,
    markExtensions: n
  };
}
function uG(t) {
  const e = [], { nodeExtensions: A, markExtensions: n } = pl(t), s = [...A, ...n], r = {
    default: null,
    validate: void 0,
    rendered: !0,
    renderHTML: null,
    parseHTML: null,
    keepOnSplit: !0,
    isRequired: !1
  }, i = A.filter((c) => c.name !== "text").map((c) => c.name), o = n.map((c) => c.name), a = [...i, ...o];
  return t.forEach((c) => {
    const l = {
      name: c.name,
      options: c.options,
      storage: c.storage,
      extensions: s
    }, B = He(
      c,
      "addGlobalAttributes",
      l
    );
    if (!B)
      return;
    B().forEach((h) => {
      let u;
      Array.isArray(h.types) ? u = h.types : h.types === "*" ? u = a : h.types === "nodes" ? u = i : h.types === "marks" ? u = o : u = [], u.forEach((d) => {
        Object.entries(h.attributes).forEach(([w, Q]) => {
          e.push({
            type: d,
            name: w,
            attribute: {
              ...r,
              ...Q
            }
          });
        });
      });
    });
  }), s.forEach((c) => {
    const l = {
      name: c.name,
      options: c.options,
      storage: c.storage
    }, B = He(
      c,
      "addAttributes",
      l
    );
    if (!B)
      return;
    const g = B();
    Object.entries(g).forEach(([h, u]) => {
      const d = {
        ...r,
        ...u
      };
      typeof (d == null ? void 0 : d.default) == "function" && (d.default = d.default()), d != null && d.isRequired && (d == null ? void 0 : d.default) === void 0 && delete d.default, e.push({
        type: c.name,
        name: h,
        attribute: d
      });
    });
  }), e;
}
function P6(t) {
  const e = [];
  let A = "", n = !1, s = !1, r = 0;
  const i = t.length;
  for (let o = 0; o < i; o += 1) {
    const a = t[o];
    if (a === "'" && !s) {
      n = !n, A += a;
      continue;
    }
    if (a === '"' && !n) {
      s = !s, A += a;
      continue;
    }
    if (!n && !s) {
      if (a === "(") {
        r += 1, A += a;
        continue;
      }
      if (a === ")" && r > 0) {
        r -= 1, A += a;
        continue;
      }
      if (a === ";" && r === 0) {
        e.push(A), A = "";
        continue;
      }
    }
    A += a;
  }
  return A && e.push(A), e;
}
function Oy(t) {
  const e = [], A = P6(t || ""), n = A.length;
  for (let s = 0; s < n; s += 1) {
    const r = A[s], i = r.indexOf(":");
    if (i === -1)
      continue;
    const o = r.slice(0, i).trim(), a = r.slice(i + 1).trim();
    o && a && e.push([o, a]);
  }
  return e;
}
function Ct(...t) {
  return t.filter((e) => !!e).reduce((e, A) => {
    const n = { ...e };
    return Object.entries(A).forEach(([s, r]) => {
      if (!n[s]) {
        n[s] = r;
        return;
      }
      if (s === "class") {
        const o = r ? String(r).split(" ") : [], a = n[s] ? n[s].split(" ") : [], c = o.filter((l) => !a.includes(l));
        n[s] = [...a, ...c].join(" ");
      } else if (s === "style") {
        const o = new Map([...Oy(n[s]), ...Oy(r)]);
        n[s] = Array.from(o.entries()).map(([a, c]) => `${a}: ${c}`).join("; ");
      } else
        n[s] = r;
    }), n;
  }, {});
}
function Dg(t, e) {
  return e.filter((A) => A.type === t.type.name).filter((A) => A.attribute.rendered).map((A) => A.attribute.renderHTML ? A.attribute.renderHTML(t.attrs) || {} : {
    [A.name]: t.attrs[A.name]
  }).reduce((A, n) => Ct(A, n), {});
}
function K6(t) {
  return typeof t != "string" ? t : t.match(/^[+-]?(?:\d*\.)?\d+$/) ? Number(t) : t === "true" ? !0 : t === "false" ? !1 : t;
}
function Py(t, e) {
  return "style" in t ? t : {
    ...t,
    getAttrs: (A) => {
      const n = t.getAttrs ? t.getAttrs(A) : t.attrs;
      if (n === !1)
        return !1;
      const s = e.reduce((r, i) => {
        const o = i.attribute.parseHTML ? i.attribute.parseHTML(A) : K6(A.getAttribute(i.name));
        return o == null ? r : {
          ...r,
          [i.name]: o
        };
      }, {});
      return { ...n, ...s };
    }
  };
}
function Ky(t) {
  return Object.fromEntries(
    // @ts-ignore
    Object.entries(t).filter(([e, A]) => e === "attrs" && O6(A) ? !1 : A != null)
  );
}
function Vy(t) {
  var e, A;
  const n = {};
  return !((e = t == null ? void 0 : t.attribute) != null && e.isRequired) && "default" in ((t == null ? void 0 : t.attribute) || {}) && (n.default = t.attribute.default), ((A = t == null ? void 0 : t.attribute) == null ? void 0 : A.validate) !== void 0 && (n.validate = t.attribute.validate), [t.name, n];
}
function V6(t, e) {
  var A;
  const n = uG(t), { nodeExtensions: s, markExtensions: r } = pl(t), i = (A = s.find((c) => He(c, "topNode"))) == null ? void 0 : A.name, o = Object.fromEntries(
    s.map((c) => {
      const l = n.filter((Q) => Q.type === c.name), B = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, g = t.reduce((Q, p) => {
        const M = He(p, "extendNodeSchema", B);
        return {
          ...Q,
          ...M ? M(c) : {}
        };
      }, {}), h = Ky({
        ...g,
        content: Nt(He(c, "content", B)),
        marks: Nt(He(c, "marks", B)),
        group: Nt(He(c, "group", B)),
        inline: Nt(He(c, "inline", B)),
        atom: Nt(He(c, "atom", B)),
        selectable: Nt(He(c, "selectable", B)),
        draggable: Nt(He(c, "draggable", B)),
        code: Nt(He(c, "code", B)),
        whitespace: Nt(He(c, "whitespace", B)),
        linebreakReplacement: Nt(
          He(c, "linebreakReplacement", B)
        ),
        defining: Nt(He(c, "defining", B)),
        isolating: Nt(He(c, "isolating", B)),
        attrs: Object.fromEntries(l.map(Vy))
      }), u = Nt(He(c, "parseHTML", B));
      u && (h.parseDOM = u.map(
        (Q) => Py(Q, l)
      ));
      const d = He(c, "renderHTML", B);
      d && (h.toDOM = (Q) => d({
        node: Q,
        HTMLAttributes: Dg(Q, l)
      }));
      const w = He(c, "renderText", B);
      return w && (h.toText = w), [c.name, h];
    })
  ), a = Object.fromEntries(
    r.map((c) => {
      const l = n.filter((w) => w.type === c.name), B = {
        name: c.name,
        options: c.options,
        storage: c.storage,
        editor: e
      }, g = t.reduce((w, Q) => {
        const p = He(Q, "extendMarkSchema", B);
        return {
          ...w,
          ...p ? p(c) : {}
        };
      }, {}), h = Ky({
        ...g,
        inclusive: Nt(He(c, "inclusive", B)),
        excludes: Nt(He(c, "excludes", B)),
        group: Nt(He(c, "group", B)),
        spanning: Nt(He(c, "spanning", B)),
        code: Nt(He(c, "code", B)),
        attrs: Object.fromEntries(l.map(Vy))
      }), u = Nt(He(c, "parseHTML", B));
      u && (h.parseDOM = u.map(
        (w) => Py(w, l)
      ));
      const d = He(c, "renderHTML", B);
      return d && (h.toDOM = (w) => d({
        mark: w,
        HTMLAttributes: Dg(w, l)
      })), [c.name, h];
    })
  );
  return new Vx({
    topNode: i,
    nodes: o,
    marks: a
  });
}
function X6(t) {
  const e = t.filter((A, n) => t.indexOf(A) !== n);
  return Array.from(new Set(e));
}
function OB(t) {
  return t.sort((A, n) => {
    const s = He(A, "priority") || 100, r = He(n, "priority") || 100;
    return s > r ? -1 : s < r ? 1 : 0;
  });
}
function dG(t) {
  const e = OB(op(t)), A = X6(e.map((n) => n.name));
  return A.length && console.warn(
    `[tiptap warn]: Duplicate extension names found: [${A.map((n) => `'${n}'`).join(", ")}]. This can lead to issues.`
  ), e;
}
function wG(t, e, A) {
  const { from: n, to: s } = e, { blockSeparator: r = `

`, textSerializers: i = {} } = A || {};
  let o = "";
  return t.nodesBetween(n, s, (a, c, l, B) => {
    var g;
    a.isBlock && c > n && (o += r);
    const h = i == null ? void 0 : i[a.type.name];
    if (h)
      return l && (o += h({
        node: a,
        pos: c,
        parent: l,
        index: B,
        range: e
      })), !1;
    a.isText && (o += (g = a == null ? void 0 : a.text) == null ? void 0 : g.slice(Math.max(n, c) - c, s - c));
  }), o;
}
function Z6(t, e) {
  const A = {
    from: 0,
    to: t.content.size
  };
  return wG(t, A, e);
}
function fG(t) {
  return Object.fromEntries(
    Object.entries(t.nodes).filter(([, e]) => e.spec.toText).map(([e, A]) => [e, A.spec.toText])
  );
}
function q6(t, e) {
  const A = MA(e, t.schema), { from: n, to: s } = t.selection, r = [];
  t.doc.nodesBetween(n, s, (o) => {
    r.push(o);
  });
  const i = r.reverse().find((o) => o.type.name === A.name);
  return i ? { ...i.attrs } : {};
}
function QG(t, e) {
  const A = Gw(
    typeof e == "string" ? e : e.name,
    t.schema
  );
  return A === "node" ? q6(t, e) : A === "mark" ? lG(t, e) : {};
}
function _6(t, e = JSON.stringify) {
  const A = {};
  return t.filter((n) => {
    const s = e(n);
    return Object.prototype.hasOwnProperty.call(A, s) ? !1 : A[s] = !0;
  });
}
function $6(t) {
  const e = _6(t);
  return e.length === 1 ? e : e.filter((A, n) => !e.filter((r, i) => i !== n).some((r) => A.oldRange.from >= r.oldRange.from && A.oldRange.to <= r.oldRange.to && A.newRange.from >= r.newRange.from && A.newRange.to <= r.newRange.to));
}
function IG(t) {
  const { mapping: e, steps: A } = t, n = [];
  return e.maps.forEach((s, r) => {
    const i = [];
    if (s.ranges.length)
      s.forEach((o, a) => {
        i.push({ from: o, to: a });
      });
    else {
      const { from: o, to: a } = A[r];
      if (o === void 0 || a === void 0)
        return;
      i.push({ from: o, to: a });
    }
    i.forEach(({ from: o, to: a }) => {
      const c = e.slice(r).map(o, -1), l = e.slice(r).map(a), B = e.invert().map(c, -1), g = e.invert().map(l);
      n.push({
        oldRange: {
          from: B,
          to: g
        },
        newRange: {
          from: c,
          to: l
        }
      });
    });
  }), $6(n);
}
function cp(t, e, A) {
  const n = [];
  return t === e ? A.resolve(t).marks().forEach((s) => {
    const r = A.resolve(t), i = rp(r, s.type);
    i && n.push({
      mark: s,
      ...i
    });
  }) : A.nodesBetween(t, e, (s, r) => {
    !s || (s == null ? void 0 : s.nodeSize) === void 0 || n.push(
      ...s.marks.map((i) => ({
        from: r,
        to: r + s.nodeSize,
        mark: i
      }))
    );
  }), n;
}
var eJ = (t, e, A, n = 20) => {
  const s = t.doc.resolve(A);
  let r = n, i = null;
  for (; r > 0 && i === null; ) {
    const o = s.node(r);
    (o == null ? void 0 : o.type.name) === e ? i = o : r -= 1;
  }
  return [i, r];
};
function rB(t, e) {
  return e.nodes[t] || e.marks[t] || null;
}
function _0(t, e, A) {
  return Object.fromEntries(
    Object.entries(A).filter(([n]) => {
      const s = t.find((r) => r.type === e && r.name === n);
      return s ? s.attribute.keepOnSplit : !1;
    })
  );
}
var tJ = (t, e = 500) => {
  let A = "";
  const n = t.parentOffset;
  return t.parent.nodesBetween(Math.max(0, n - e), n, (s, r, i, o) => {
    var a, c;
    const l = ((c = (a = s.type.spec).toText) == null ? void 0 : c.call(a, {
      node: s,
      pos: r,
      parent: i,
      index: o
    })) || s.textContent || "%leaf%";
    A += s.isAtom && !s.isText ? l : l.slice(0, Math.max(0, n - r));
  }), A;
};
function WC(t, e, A = {}) {
  const { empty: n, ranges: s } = t.selection, r = e ? $i(e, t.schema) : null;
  if (n)
    return !!(t.storedMarks || t.selection.$from.marks()).filter((B) => r ? r.name === B.type.name : !0).find((B) => Tu(B.attrs, A, { strict: !1 }));
  let i = 0;
  const o = [];
  if (s.forEach(({ $from: B, $to: g }) => {
    const h = B.pos, u = g.pos;
    t.doc.nodesBetween(h, u, (d, w) => {
      if (r && d.inlineContent && !d.type.allowsMarkType(r))
        return !1;
      if (!d.isText && !d.marks.length)
        return;
      const Q = Math.max(h, w), p = Math.min(u, w + d.nodeSize), M = p - Q;
      i += M, o.push(
        ...d.marks.map((I) => ({
          mark: I,
          from: Q,
          to: p
        }))
      );
    });
  }), i === 0)
    return !1;
  const a = o.filter((B) => r ? r.name === B.mark.type.name : !0).filter((B) => Tu(B.mark.attrs, A, { strict: !1 })).reduce((B, g) => B + g.to - g.from, 0), c = o.filter((B) => r ? B.mark.type !== r && B.mark.type.excludes(r) : !0).reduce((B, g) => B + g.to - g.from, 0);
  return (a > 0 ? a + c : a) >= i;
}
function AJ(t, e, A = {}) {
  if (!e)
    return Vo(t, null, A) || WC(t, null, A);
  const n = Gw(e, t.schema);
  return n === "node" ? Vo(t, e, A) : n === "mark" ? WC(t, e, A) : !1;
}
var nJ = (t, e) => {
  const { $from: A, $to: n, $anchor: s } = t.selection;
  if (e) {
    const r = zw((o) => o.type.name === e)(t.selection);
    if (!r)
      return !1;
    const i = t.doc.resolve(r.pos + 1);
    return s.pos + 1 === i.end();
  }
  return !(n.parentOffset < n.parent.nodeSize - 2 || A.pos !== n.pos);
}, sJ = (t) => {
  const { $from: e, $to: A } = t.selection;
  return !(e.parentOffset > 0 || e.pos !== A.pos);
};
function Xy(t, e) {
  return Array.isArray(e) ? e.some((A) => (typeof A == "string" ? A : A.name) === t.name) : e;
}
function Zy(t, e) {
  const { nodeExtensions: A } = pl(e), n = A.find((i) => i.name === t);
  if (!n)
    return !1;
  const s = {
    name: n.name,
    options: n.options,
    storage: n.storage
  }, r = Nt(He(n, "group", s));
  return typeof r != "string" ? !1 : r.split(" ").includes("list");
}
function Uw(t, {
  checkChildren: e = !0,
  ignoreWhitespace: A = !1
} = {}) {
  var n;
  if (A) {
    if (t.type.name === "hardBreak")
      return !0;
    if (t.isText)
      return /^\s*$/m.test((n = t.text) != null ? n : "");
  }
  if (t.isText)
    return !t.text;
  if (t.isAtom || t.isLeaf)
    return !1;
  if (t.content.childCount === 0)
    return !0;
  if (e) {
    let s = !0;
    return t.content.forEach((r) => {
      s !== !1 && (Uw(r, { ignoreWhitespace: A, checkChildren: e }) || (s = !1));
    }), s;
  }
  return !1;
}
function CG(t) {
  return t instanceof Ue;
}
var lp = class EG {
  constructor(e) {
    this.position = e;
  }
  /**
   * Creates a MappablePosition from a JSON object.
   */
  static fromJSON(e) {
    return new EG(e.position);
  }
  /**
   * Converts the MappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position
    };
  }
};
function MG(t, e) {
  const A = e.mapping.mapResult(t.position);
  return {
    position: new lp(A.pos),
    mapResult: A
  };
}
function rJ(t) {
  return new lp(t);
}
function iJ(t, e, A) {
  const s = t.state.doc.content.size, r = Fi(e, 0, s), i = Fi(A, 0, s), o = t.coordsAtPos(r), a = t.coordsAtPos(i, -1), c = Math.min(o.top, a.top), l = Math.max(o.bottom, a.bottom), B = Math.min(o.left, a.left), g = Math.max(o.right, a.right), h = g - B, u = l - c, Q = {
    top: c,
    bottom: l,
    left: B,
    right: g,
    width: h,
    height: u,
    x: B,
    y: c
  };
  return {
    ...Q,
    toJSON: () => Q
  };
}
function oJ(t, e, A) {
  var n;
  const { selection: s } = e;
  let r = null;
  if (ip(s) && (r = s.$cursor), r) {
    const o = (n = t.storedMarks) != null ? n : r.marks();
    return r.parent.type.allowsMarkType(A) && (!!A.isInSet(o) || !o.some((c) => c.type.excludes(A)));
  }
  const { ranges: i } = s;
  return i.some(({ $from: o, $to: a }) => {
    let c = o.depth === 0 ? t.doc.inlineContent && t.doc.type.allowsMarkType(A) : !1;
    return t.doc.nodesBetween(o.pos, a.pos, (l, B, g) => {
      if (c)
        return !1;
      if (l.isInline) {
        const h = !g || g.type.allowsMarkType(A), u = !!A.isInSet(l.marks) || !l.marks.some((d) => d.type.excludes(A));
        c = h && u;
      }
      return !c;
    }), c;
  });
}
var aJ = (t, e = {}) => ({ tr: A, state: n, dispatch: s }) => {
  const { selection: r } = A, { empty: i, ranges: o } = r, a = $i(t, n.schema);
  if (s)
    if (i) {
      const c = lG(n, a);
      A.addStoredMark(
        a.create({
          ...c,
          ...e
        })
      );
    } else
      o.forEach((c) => {
        const l = c.$from.pos, B = c.$to.pos;
        n.doc.nodesBetween(l, B, (g, h) => {
          const u = Math.max(h, l), d = Math.min(h + g.nodeSize, B);
          g.marks.find((Q) => Q.type === a) ? g.marks.forEach((Q) => {
            a === Q.type && A.addMark(
              u,
              d,
              a.create({
                ...Q.attrs,
                ...e
              })
            );
          }) : A.addMark(u, d, a.create(e));
        });
      });
  return oJ(n, A, a);
}, cJ = (t, e) => ({ tr: A }) => (A.setMeta(t, e), !0), lJ = (t, e = {}) => ({ state: A, dispatch: n, chain: s }) => {
  const r = MA(t, A.schema);
  let i;
  return A.selection.$anchor.sameParent(A.selection.$head) && (i = A.selection.$anchor.parent.attrs), r.isTextblock ? s().command(({ commands: o }) => ay(r, { ...i, ...e })(A) ? !0 : o.clearNodes()).command(({ state: o }) => ay(r, { ...i, ...e })(o, n)).run() : (console.warn('[tiptap warn]: Currently "setNode()" only supports text block nodes.'), !1);
}, BJ = (t) => ({ tr: e, dispatch: A }) => {
  if (A) {
    const { doc: n } = e, s = Fi(t, 0, n.content.size), r = Ue.create(n, s);
    e.setSelection(r);
  }
  return !0;
}, gJ = (t, e) => ({ tr: A, state: n, dispatch: s }) => {
  const { selection: r } = n;
  let i, o;
  return typeof e == "number" ? (i = e, o = e) : e && "from" in e && "to" in e ? (i = e.from, o = e.to) : (i = r.from, o = r.to), s && A.doc.nodesBetween(i, o, (a, c) => {
    a.isText || A.setNodeMarkup(c, void 0, {
      ...a.attrs,
      dir: t
    });
  }), !0;
}, hJ = (t) => ({ tr: e, dispatch: A }) => {
  if (A) {
    const { doc: n } = e, { from: s, to: r } = typeof t == "number" ? { from: t, to: t } : t, i = Re.atStart(n).from, o = Re.atEnd(n).to, a = Fi(s, i, o), c = Fi(r, i, o), l = Re.create(n, a, c);
    e.setSelection(l);
  }
  return !0;
}, uJ = (t) => ({ state: e, dispatch: A }) => {
  const n = MA(t, e.schema);
  return oT(n)(e, A);
};
function qy(t, e) {
  const A = t.storedMarks || t.selection.$to.parentOffset && t.selection.$from.marks();
  if (A) {
    const n = A.filter((s) => e == null ? void 0 : e.includes(s.type.name));
    t.tr.ensureMarks(n);
  }
}
var dJ = ({ keepMarks: t = !0 } = {}) => ({ tr: e, state: A, dispatch: n, editor: s }) => {
  const { selection: r, doc: i } = e, { $from: o, $to: a } = r, c = s.extensionManager.attributes, l = _0(c, o.node().type.name, o.node().attrs);
  if (r instanceof Ue && r.node.isBlock)
    return !o.parentOffset || !Gi(i, o.pos) ? !1 : (n && (t && qy(A, s.extensionManager.splittableMarks), e.split(o.pos).scrollIntoView()), !0);
  if (!o.parent.isBlock)
    return !1;
  const B = a.parentOffset === a.parent.content.size, g = o.depth === 0 ? void 0 : J6(o.node(-1).contentMatchAt(o.indexAfter(-1)));
  let h = B && g ? [
    {
      type: g,
      attrs: l
    }
  ] : void 0, u = Gi(e.doc, e.mapping.map(o.pos), 1, h);
  if (!h && !u && Gi(e.doc, e.mapping.map(o.pos), 1, g ? [{ type: g }] : void 0) && (u = !0, h = g ? [
    {
      type: g,
      attrs: l
    }
  ] : void 0), n) {
    if (u && (r instanceof Re && e.deleteSelection(), e.split(e.mapping.map(o.pos), 1, h), g && !B && !o.parentOffset && o.parent.type !== g)) {
      const d = e.mapping.map(o.before()), w = e.doc.resolve(d);
      o.node(-1).canReplaceWith(w.index(), w.index() + 1, g) && e.setNodeMarkup(e.mapping.map(o.before()), g);
    }
    t && qy(A, s.extensionManager.splittableMarks), e.scrollIntoView();
  }
  return u;
}, wJ = (t, e = {}) => ({ tr: A, state: n, dispatch: s, editor: r }) => {
  var i;
  const o = MA(t, n.schema), { $from: a, $to: c } = n.selection, l = n.selection.node;
  if (l && l.isBlock || a.depth < 2 || !a.sameParent(c))
    return !1;
  const B = a.node(-1);
  if (B.type !== o)
    return !1;
  const g = r.extensionManager.attributes;
  if (a.parent.content.size === 0 && a.node(-1).childCount === a.indexAfter(-1)) {
    if (a.depth === 2 || a.node(-3).type !== o || a.index(-2) !== a.node(-2).childCount - 1)
      return !1;
    if (s) {
      let Q = re.empty;
      const p = a.index(-1) ? 1 : a.index(-2) ? 2 : 3;
      for (let G = a.depth - p; G >= a.depth - 3; G -= 1)
        Q = re.from(a.node(G).copy(Q));
      const M = (
        // eslint-disable-next-line no-nested-ternary
        a.indexAfter(-1) < a.node(-2).childCount ? 1 : a.indexAfter(-2) < a.node(-3).childCount ? 2 : 3
      ), I = {
        ..._0(g, a.node().type.name, a.node().attrs),
        ...e
      }, N = ((i = o.contentMatch.defaultType) == null ? void 0 : i.createAndFill(I)) || void 0;
      Q = Q.append(re.from(o.createAndFill(null, N) || void 0));
      const m = a.before(a.depth - (p - 1));
      A.replace(m, a.after(-M), new Ee(Q, 4 - p, 0));
      let E = -1;
      A.doc.nodesBetween(m, A.doc.content.size, (G, Y) => {
        if (E > -1)
          return !1;
        G.isTextblock && G.content.size === 0 && (E = Y + 1);
      }), E > -1 && A.setSelection(Re.near(A.doc.resolve(E))), A.scrollIntoView();
    }
    return !0;
  }
  const h = c.pos === a.end() ? B.contentMatchAt(0).defaultType : null, u = {
    ..._0(g, B.type.name, B.attrs),
    ...e
  }, d = {
    ..._0(g, a.node().type.name, a.node().attrs),
    ...e
  };
  A.delete(a.pos, c.pos);
  const w = h ? [
    { type: o, attrs: u },
    { type: h, attrs: d }
  ] : [{ type: o, attrs: u }];
  if (!Gi(A.doc, a.pos, 2))
    return !1;
  if (s) {
    const { selection: Q, storedMarks: p } = n, { splittableMarks: M } = r.extensionManager, I = p || Q.$to.parentOffset && Q.$from.marks();
    if (A.split(a.pos, 2, w).scrollIntoView(), !I || !s)
      return !0;
    const N = I.filter((m) => M.includes(m.type.name));
    A.ensureMarks(N);
  }
  return !0;
}, xQ = (t, e) => {
  const A = zw((i) => i.type === e)(t.selection);
  if (!A)
    return !0;
  const n = t.doc.resolve(Math.max(0, A.pos - 1)).before(A.depth);
  if (n === void 0)
    return !0;
  const s = t.doc.nodeAt(n);
  return A.node.type === (s == null ? void 0 : s.type) && oa(t.doc, A.pos) && t.join(A.pos), !0;
}, GQ = (t, e) => {
  const A = zw((i) => i.type === e)(t.selection);
  if (!A)
    return !0;
  const n = t.doc.resolve(A.start).after(A.depth);
  if (n === void 0)
    return !0;
  const s = t.doc.nodeAt(n);
  return A.node.type === (s == null ? void 0 : s.type) && oa(t.doc, n) && t.join(n), !0;
}, fJ = (t, e, A, n = {}) => ({ editor: s, tr: r, state: i, dispatch: o, chain: a, commands: c, can: l }) => {
  const { extensions: B, splittableMarks: g } = s.extensionManager, h = MA(t, i.schema), u = MA(e, i.schema), { selection: d, storedMarks: w } = i, { $from: Q, $to: p } = d, M = Q.blockRange(p), I = w || d.$to.parentOffset && d.$from.marks();
  if (!M)
    return !1;
  const N = zw((m) => Zy(m.type.name, B))(d);
  if (M.depth >= 1 && N && M.depth - N.depth <= 1) {
    if (N.node.type === h)
      return c.liftListItem(u);
    if (Zy(N.node.type.name, B) && h.validContent(N.node.content) && o)
      return a().command(() => (r.setNodeMarkup(N.pos, h), !0)).command(() => xQ(r, h)).command(() => GQ(r, h)).run();
  }
  return !A || !I || !o ? a().command(() => l().wrapInList(h, n) ? !0 : c.clearNodes()).wrapInList(h, n).command(() => xQ(r, h)).command(() => GQ(r, h)).run() : a().command(() => {
    const m = l().wrapInList(h, n), E = I.filter((G) => g.includes(G.type.name));
    return r.ensureMarks(E), m ? !0 : c.clearNodes();
  }).wrapInList(h, n).command(() => xQ(r, h)).command(() => GQ(r, h)).run();
}, QJ = (t, e = {}, A = {}) => ({ state: n, commands: s }) => {
  const { extendEmptyMarkRange: r = !1 } = A, i = $i(t, n.schema);
  return WC(n, i, e) ? s.unsetMark(i, { extendEmptyMarkRange: r }) : s.setMark(i, e);
}, IJ = (t, e, A = {}) => ({ state: n, commands: s }) => {
  const r = MA(t, n.schema), i = MA(e, n.schema), o = Vo(n, r, A);
  let a;
  return n.selection.$anchor.sameParent(n.selection.$head) && (a = n.selection.$anchor.parent.attrs), o ? s.setNode(i, a) : s.setNode(r, { ...a, ...A });
}, CJ = (t, e = {}) => ({ state: A, commands: n }) => {
  const s = MA(t, A.schema);
  return Vo(A, s, e) ? n.lift(s) : n.wrapIn(s, e);
}, EJ = () => ({ state: t, dispatch: e }) => {
  const A = t.plugins;
  for (let n = 0; n < A.length; n += 1) {
    const s = A[n];
    let r;
    if (s.spec.isInputRules && (r = s.getState(t))) {
      if (e) {
        const i = t.tr, o = r.transform;
        for (let a = o.steps.length - 1; a >= 0; a -= 1)
          i.step(o.steps[a].invert(o.docs[a]));
        if (r.text) {
          const a = i.doc.resolve(r.from).marks();
          i.replaceWith(r.from, r.to, t.schema.text(r.text, a));
        } else
          i.delete(r.from, r.to);
      }
      return !0;
    }
  }
  return !1;
}, MJ = () => ({ tr: t, dispatch: e }) => {
  const { selection: A } = t, { empty: n, ranges: s } = A;
  return n || e && s.forEach((r) => {
    t.removeMark(r.$from.pos, r.$to.pos);
  }), !0;
}, pJ = (t, e = {}) => ({ tr: A, state: n, dispatch: s }) => {
  var r;
  const { extendEmptyMarkRange: i = !1 } = e, { selection: o } = A, a = $i(t, n.schema), { $from: c, empty: l, ranges: B } = o;
  if (!s)
    return !0;
  if (l && i) {
    let { from: g, to: h } = o;
    const u = (r = c.marks().find((w) => w.type === a)) == null ? void 0 : r.attrs, d = rp(c, a, u);
    d && (g = d.from, h = d.to), A.removeMark(g, h, a);
  } else
    B.forEach((g) => {
      A.removeMark(g.$from.pos, g.$to.pos, a);
    });
  return A.removeStoredMark(a), !0;
}, mJ = (t) => ({ tr: e, state: A, dispatch: n }) => {
  const { selection: s } = A;
  let r, i;
  return typeof t == "number" ? (r = t, i = t) : t && "from" in t && "to" in t ? (r = t.from, i = t.to) : (r = s.from, i = s.to), n && e.doc.nodesBetween(r, i, (o, a) => {
    if (o.isText)
      return;
    const c = { ...o.attrs };
    delete c.dir, e.setNodeMarkup(a, void 0, c);
  }), !0;
}, YJ = (t, e = {}) => ({ tr: A, state: n, dispatch: s }) => {
  let r = null, i = null;
  const o = Gw(
    typeof t == "string" ? t : t.name,
    n.schema
  );
  if (!o)
    return !1;
  o === "node" && (r = MA(t, n.schema)), o === "mark" && (i = $i(t, n.schema));
  let a = !1;
  return A.selection.ranges.forEach((c) => {
    const l = c.$from.pos, B = c.$to.pos;
    let g, h, u, d;
    A.selection.empty ? n.doc.nodesBetween(l, B, (w, Q) => {
      r && r === w.type && (a = !0, u = Math.max(Q, l), d = Math.min(Q + w.nodeSize, B), g = Q, h = w);
    }) : n.doc.nodesBetween(l, B, (w, Q) => {
      Q < l && r && r === w.type && (a = !0, u = Math.max(Q, l), d = Math.min(Q + w.nodeSize, B), g = Q, h = w), Q >= l && Q <= B && (r && r === w.type && (a = !0, s && A.setNodeMarkup(Q, void 0, {
        ...w.attrs,
        ...e
      })), i && w.marks.length && w.marks.forEach((p) => {
        if (i === p.type && (a = !0, s)) {
          const M = Math.max(Q, l), I = Math.min(Q + w.nodeSize, B);
          A.addMark(
            M,
            I,
            i.create({
              ...p.attrs,
              ...e
            })
          );
        }
      }));
    }), h && (g !== void 0 && s && A.setNodeMarkup(g, void 0, {
      ...h.attrs,
      ...e
    }), i && h.marks.length && h.marks.forEach((w) => {
      i === w.type && s && A.addMark(
        u,
        d,
        i.create({
          ...w.attrs,
          ...e
        })
      );
    }));
  }), a;
}, yJ = (t, e = {}) => ({ state: A, dispatch: n }) => {
  const s = MA(t, A.schema);
  return eT(s, e)(A, n);
}, FJ = (t, e = {}) => ({ state: A, dispatch: n }) => {
  const s = MA(t, A.schema);
  return tT(s, e)(A, n);
}, NJ = class {
  constructor() {
    this.callbacks = {};
  }
  on(e, A) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(A), this;
  }
  emit(e, ...A) {
    const n = this.callbacks[e];
    return n && n.forEach((s) => s.apply(this, A)), this;
  }
  off(e, A) {
    const n = this.callbacks[e];
    return n && (A ? this.callbacks[e] = n.filter((s) => s !== A) : delete this.callbacks[e]), this;
  }
  once(e, A) {
    const n = (...s) => {
      this.off(e, n), A.apply(this, s);
    };
    return this.on(e, n);
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}, Sl = class {
  constructor(t) {
    var e;
    this.find = t.find, this.handler = t.handler, this.undoable = (e = t.undoable) != null ? e : !0;
  }
}, DJ = (t, e) => {
  if (sp(e))
    return e.exec(t);
  const A = e(t);
  if (!A)
    return null;
  const n = [A.text];
  return n.index = A.index, n.input = t, n.data = A.data, A.replaceWith && (A.text.includes(A.replaceWith) || console.warn('[tiptap warn]: "inputRuleMatch.replaceWith" must be part of "inputRuleMatch.text".'), n.push(A.replaceWith)), n;
};
function r0(t) {
  var e;
  const { editor: A, from: n, to: s, text: r, rules: i, plugin: o } = t, { view: a } = A;
  if (a.composing)
    return !1;
  const c = a.state.doc.resolve(n);
  if (
    // check for code node
    c.parent.type.spec.code || (e = c.nodeBefore || c.nodeAfter) != null && e.marks.find((g) => g.type.spec.code)
  )
    return !1;
  let l = !1;
  const B = tJ(c) + r;
  return i.forEach((g) => {
    if (l)
      return;
    const h = DJ(B, g.find);
    if (!h)
      return;
    const u = a.state.tr, d = Dw({
      state: a.state,
      transaction: u
    }), w = {
      from: n - (h[0].length - r.length),
      to: s
    }, { commands: Q, chain: p, can: M } = new xw({
      editor: A,
      state: d
    });
    g.handler({
      state: d,
      range: w,
      match: h,
      commands: Q,
      chain: p,
      can: M
    }) === null || !u.steps.length || (g.undoable && u.setMeta(o, {
      transform: u,
      from: n,
      to: s,
      text: r
    }), a.dispatch(u), l = !0);
  }), l;
}
function xJ(t) {
  const { editor: e, rules: A } = t, n = new ct({
    state: {
      init() {
        return null;
      },
      apply(s, r, i) {
        const o = s.getMeta(n);
        if (o)
          return o;
        const a = s.getMeta("applyInputRules");
        return !!a && setTimeout(() => {
          let { text: l } = a;
          typeof l == "string" ? l = l : l = ap(re.from(l), i.schema);
          const { from: B } = a, g = B + l.length;
          r0({
            editor: e,
            from: B,
            to: g,
            text: l,
            rules: A,
            plugin: n
          });
        }), s.selectionSet || s.docChanged ? null : r;
      }
    },
    props: {
      handleTextInput(s, r, i, o) {
        return r0({
          editor: e,
          from: r,
          to: i,
          text: o,
          rules: A,
          plugin: n
        });
      },
      handleDOMEvents: {
        compositionend: (s) => (setTimeout(() => {
          const { $cursor: r } = s.state.selection;
          r && r0({
            editor: e,
            from: r.pos,
            to: r.pos,
            text: "",
            rules: A,
            plugin: n
          });
        }), !1)
      },
      // add support for input rules to trigger on enter
      // this is useful for example for code blocks
      handleKeyDown(s, r) {
        if (r.key !== "Enter")
          return !1;
        const { $cursor: i } = s.state.selection;
        return i ? r0({
          editor: e,
          from: i.pos,
          to: i.pos,
          text: `
`,
          rules: A,
          plugin: n
        }) : !1;
      }
    },
    // @ts-ignore
    isInputRules: !0
  });
  return n;
}
function GJ(t) {
  return Object.prototype.toString.call(t).slice(8, -1);
}
function i0(t) {
  return GJ(t) !== "Object" ? !1 : t.constructor === Object && Object.getPrototypeOf(t) === Object.prototype;
}
function pG(t, e) {
  const A = { ...t };
  return i0(t) && i0(e) && Object.keys(e).forEach((n) => {
    i0(e[n]) && i0(t[n]) ? A[n] = pG(t[n], e[n]) : A[n] = e[n];
  }), A;
}
var Bp = class {
  constructor(t = {}) {
    this.type = "extendable", this.parent = null, this.child = null, this.name = "", this.config = {
      name: this.name
    }, this.config = {
      ...this.config,
      ...t
    }, this.name = this.config.name;
  }
  get options() {
    return {
      ...Nt(
        He(this, "addOptions", {
          name: this.name
        })
      ) || {}
    };
  }
  get storage() {
    return {
      ...Nt(
        He(this, "addStorage", {
          name: this.name,
          options: this.options
        })
      ) || {}
    };
  }
  configure(t = {}) {
    const e = this.extend({
      ...this.config,
      addOptions: () => pG(this.options, t)
    });
    return e.name = this.name, e.parent = this.parent, e;
  }
  extend(t = {}) {
    const e = new this.constructor({ ...this.config, ...t });
    return e.parent = this, this.child = e, e.name = "name" in t ? t.name : e.parent.name, e;
  }
}, qr = class mG extends Bp {
  constructor() {
    super(...arguments), this.type = "mark";
  }
  /**
   * Create a new Mark instance
   * @param config - Mark configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const A = typeof e == "function" ? e() : e;
    return new mG(A);
  }
  static handleExit({ editor: e, mark: A }) {
    const { tr: n } = e.state, s = e.state.selection.$from;
    if (s.pos === s.end()) {
      const i = s.marks();
      if (!!!i.find((c) => (c == null ? void 0 : c.type.name) === A.name))
        return !1;
      const a = i.find((c) => (c == null ? void 0 : c.type.name) === A.name);
      return a && n.removeStoredMark(a), n.insertText(" ", s.pos), e.view.dispatch(n), !0;
    }
    return !1;
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const A = typeof e == "function" ? e() : e;
    return super.extend(A);
  }
};
function zJ(t) {
  return typeof t == "number";
}
var YG = class {
  constructor(t) {
    this.find = t.find, this.handler = t.handler;
  }
}, UJ = (t, e, A) => {
  if (sp(e))
    return [...t.matchAll(e)];
  const n = e(t, A);
  return n ? n.map((s) => {
    const r = [s.text];
    return r.index = s.index, r.input = t, r.data = s.data, s.replaceWith && (s.text.includes(s.replaceWith) || console.warn('[tiptap warn]: "pasteRuleMatch.replaceWith" must be part of "pasteRuleMatch.text".'), r.push(s.replaceWith)), r;
  }) : [];
};
function bJ(t) {
  const { editor: e, state: A, from: n, to: s, rule: r, pasteEvent: i, dropEvent: o } = t, { commands: a, chain: c, can: l } = new xw({
    editor: e,
    state: A
  }), B = [];
  return A.doc.nodesBetween(n, s, (h, u) => {
    var d, w, Q, p, M;
    if ((w = (d = h.type) == null ? void 0 : d.spec) != null && w.code || !(h.isText || h.isTextblock || h.isInline))
      return;
    const I = (M = (p = (Q = h.content) == null ? void 0 : Q.size) != null ? p : h.nodeSize) != null ? M : 0, N = Math.max(n, u), m = Math.min(s, u + I);
    if (N >= m)
      return;
    const E = h.isText ? h.text || "" : h.textBetween(N - u, m - u, void 0, "￼");
    UJ(E, r.find, i).forEach((Y) => {
      if (Y.index === void 0)
        return;
      const U = N + Y.index + 1, v = U + Y[0].length, b = {
        from: A.tr.mapping.map(U),
        to: A.tr.mapping.map(v)
      }, W = r.handler({
        state: A,
        range: b,
        match: Y,
        commands: a,
        chain: c,
        can: l,
        pasteEvent: i,
        dropEvent: o
      });
      B.push(W);
    });
  }), B.every((h) => h !== null);
}
var o0 = null, vJ = (t) => {
  var e;
  const A = new ClipboardEvent("paste", {
    clipboardData: new DataTransfer()
  });
  return (e = A.clipboardData) == null || e.setData("text/html", t), A;
};
function jJ(t) {
  const { editor: e, rules: A } = t;
  let n = null, s = !1, r = !1, i = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, o;
  try {
    o = typeof DragEvent < "u" ? new DragEvent("drop") : null;
  } catch {
    o = null;
  }
  const a = ({
    state: l,
    from: B,
    to: g,
    rule: h,
    pasteEvt: u
  }) => {
    const d = l.tr, w = Dw({
      state: l,
      transaction: d
    });
    if (!(!bJ({
      editor: e,
      state: w,
      from: Math.max(B - 1, 0),
      to: g.b - 1,
      rule: h,
      pasteEvent: u,
      dropEvent: o
    }) || !d.steps.length)) {
      try {
        o = typeof DragEvent < "u" ? new DragEvent("drop") : null;
      } catch {
        o = null;
      }
      return i = typeof ClipboardEvent < "u" ? new ClipboardEvent("paste") : null, d;
    }
  };
  return A.map((l) => new ct({
    // we register a global drag handler to track the current drag source element
    view(B) {
      const g = (u) => {
        var d;
        n = (d = B.dom.parentElement) != null && d.contains(u.target) ? B.dom.parentElement : null, n && (o0 = e);
      }, h = () => {
        o0 && (o0 = null);
      };
      return window.addEventListener("dragstart", g), window.addEventListener("dragend", h), {
        destroy() {
          window.removeEventListener("dragstart", g), window.removeEventListener("dragend", h);
        }
      };
    },
    props: {
      handleDOMEvents: {
        drop: (B, g) => {
          if (r = n === B.dom.parentElement, o = g, !r) {
            const h = o0;
            h != null && h.isEditable && setTimeout(() => {
              const u = h.state.selection;
              u && h.commands.deleteRange({ from: u.from, to: u.to });
            }, 10);
          }
          return !1;
        },
        paste: (B, g) => {
          var h;
          const u = (h = g.clipboardData) == null ? void 0 : h.getData("text/html");
          return i = g, s = !!(u != null && u.includes("data-pm-slice")), !1;
        }
      }
    },
    appendTransaction: (B, g, h) => {
      const u = B[0], d = u.getMeta("uiEvent") === "paste" && !s, w = u.getMeta("uiEvent") === "drop" && !r, Q = u.getMeta("applyPasteRules"), p = !!Q;
      if (!d && !w && !p)
        return;
      if (p) {
        let { text: N } = Q;
        typeof N == "string" ? N = N : N = ap(re.from(N), h.schema);
        const { from: m } = Q, E = m + N.length, G = vJ(N);
        return a({
          rule: l,
          state: h,
          from: m,
          to: { b: E },
          pasteEvt: G
        });
      }
      const M = g.doc.content.findDiffStart(h.doc.content), I = g.doc.content.findDiffEnd(h.doc.content);
      if (!(!zJ(M) || !I || M === I.b))
        return a({
          rule: l,
          state: h,
          from: M,
          to: I,
          pasteEvt: i
        });
    }
  }));
}
var bw = class {
  constructor(t, e) {
    this.splittableMarks = [], this.editor = e, this.baseExtensions = t, this.extensions = dG(t), this.schema = V6(this.extensions, e), this.setupExtensions();
  }
  /**
   * Get all commands from the extensions.
   * @returns An object with all commands where the key is the command name and the value is the command function
   */
  get commands() {
    return this.extensions.reduce((t, e) => {
      const A = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: rB(e.name, this.schema)
      }, n = He(e, "addCommands", A);
      return n ? {
        ...t,
        ...n()
      } : t;
    }, {});
  }
  /**
   * Get all registered Prosemirror plugins from the extensions.
   * @returns An array of Prosemirror plugins
   */
  get plugins() {
    const { editor: t } = this;
    return OB([...this.extensions].reverse()).flatMap((n) => {
      const s = {
        name: n.name,
        options: n.options,
        storage: this.editor.extensionStorage[n.name],
        editor: t,
        type: rB(n.name, this.schema)
      }, r = [], i = He(
        n,
        "addKeyboardShortcuts",
        s
      );
      let o = {};
      if (n.type === "mark" && He(n, "exitable", s) && (o.ArrowRight = () => qr.handleExit({ editor: t, mark: n })), i) {
        const g = Object.fromEntries(
          Object.entries(i()).map(([h, u]) => [h, () => u({ editor: t })])
        );
        o = { ...o, ...g };
      }
      const a = q9(o);
      r.push(a);
      const c = He(n, "addInputRules", s);
      if (Xy(n, t.options.enableInputRules) && c) {
        const g = c();
        if (g && g.length) {
          const h = xJ({
            editor: t,
            rules: g
          }), u = Array.isArray(h) ? h : [h];
          r.push(...u);
        }
      }
      const l = He(n, "addPasteRules", s);
      if (Xy(n, t.options.enablePasteRules) && l) {
        const g = l();
        if (g && g.length) {
          const h = jJ({ editor: t, rules: g });
          r.push(...h);
        }
      }
      const B = He(
        n,
        "addProseMirrorPlugins",
        s
      );
      if (B) {
        const g = B();
        r.push(...g);
      }
      return r;
    });
  }
  /**
   * Get all attributes from the extensions.
   * @returns An array of attributes
   */
  get attributes() {
    return uG(this.extensions);
  }
  /**
   * Get all node views from the extensions.
   * @returns An object with all node views where the key is the node name and the value is the node view function
   */
  get nodeViews() {
    const { editor: t } = this, { nodeExtensions: e } = pl(this.extensions);
    return Object.fromEntries(
      e.filter((A) => !!He(A, "addNodeView")).map((A) => {
        const n = this.attributes.filter((a) => a.type === A.name), s = {
          name: A.name,
          options: A.options,
          storage: this.editor.extensionStorage[A.name],
          editor: t,
          type: MA(A.name, this.schema)
        }, r = He(A, "addNodeView", s);
        if (!r)
          return [];
        const i = r();
        if (!i)
          return [];
        const o = (a, c, l, B, g) => {
          const h = Dg(a, n);
          return i({
            // pass-through
            node: a,
            view: c,
            getPos: l,
            decorations: B,
            innerDecorations: g,
            // tiptap-specific
            editor: t,
            extension: A,
            HTMLAttributes: h
          });
        };
        return [A.name, o];
      })
    );
  }
  /**
   * Get the composed dispatchTransaction function from all extensions.
   * @param baseDispatch The base dispatch function (e.g. from the editor or user props)
   * @returns A composed dispatch function
   */
  dispatchTransaction(t) {
    const { editor: e } = this;
    return OB([...this.extensions].reverse()).reduceRight((n, s) => {
      const r = {
        name: s.name,
        options: s.options,
        storage: this.editor.extensionStorage[s.name],
        editor: e,
        type: rB(s.name, this.schema)
      }, i = He(
        s,
        "dispatchTransaction",
        r
      );
      return i ? (o) => {
        i.call(r, { transaction: o, next: n });
      } : n;
    }, t);
  }
  /**
   * Get the composed transformPastedHTML function from all extensions.
   * @param baseTransform The base transform function (e.g. from the editor props)
   * @returns A composed transform function that chains all extension transforms
   */
  transformPastedHTML(t) {
    const { editor: e } = this;
    return OB([...this.extensions]).reduce(
      (n, s) => {
        const r = {
          name: s.name,
          options: s.options,
          storage: this.editor.extensionStorage[s.name],
          editor: e,
          type: rB(s.name, this.schema)
        }, i = He(
          s,
          "transformPastedHTML",
          r
        );
        return i ? (o, a) => {
          const c = n(o, a);
          return i.call(r, c);
        } : n;
      },
      t || ((n) => n)
    );
  }
  get markViews() {
    const { editor: t } = this, { markExtensions: e } = pl(this.extensions);
    return Object.fromEntries(
      e.filter((A) => !!He(A, "addMarkView")).map((A) => {
        const n = this.attributes.filter((o) => o.type === A.name), s = {
          name: A.name,
          options: A.options,
          storage: this.editor.extensionStorage[A.name],
          editor: t,
          type: $i(A.name, this.schema)
        }, r = He(A, "addMarkView", s);
        if (!r)
          return [];
        const i = (o, a, c) => {
          const l = Dg(o, n);
          return r()({
            // pass-through
            mark: o,
            view: a,
            inline: c,
            // tiptap-specific
            editor: t,
            extension: A,
            HTMLAttributes: l,
            updateAttributes: (B) => {
              qJ(o, t, B);
            }
          });
        };
        return [A.name, i];
      })
    );
  }
  /**
   * Go through all extensions, create extension storages & setup marks
   * & bind editor event listener.
   */
  setupExtensions() {
    const t = this.extensions;
    this.editor.extensionStorage = Object.fromEntries(
      t.map((e) => [e.name, e.storage])
    ), t.forEach((e) => {
      var A;
      const n = {
        name: e.name,
        options: e.options,
        storage: this.editor.extensionStorage[e.name],
        editor: this.editor,
        type: rB(e.name, this.schema)
      };
      e.type === "mark" && ((A = Nt(He(e, "keepOnSplit", n))) == null || A) && this.splittableMarks.push(e.name);
      const s = He(e, "onBeforeCreate", n), r = He(e, "onCreate", n), i = He(e, "onUpdate", n), o = He(
        e,
        "onSelectionUpdate",
        n
      ), a = He(e, "onTransaction", n), c = He(e, "onFocus", n), l = He(e, "onBlur", n), B = He(e, "onDestroy", n);
      s && this.editor.on("beforeCreate", s), r && this.editor.on("create", r), i && this.editor.on("update", i), o && this.editor.on("selectionUpdate", o), a && this.editor.on("transaction", a), c && this.editor.on("focus", c), l && this.editor.on("blur", l), B && this.editor.on("destroy", B);
    });
  }
};
bw.resolve = dG;
bw.sort = OB;
bw.flatten = op;
var HJ = {};
np(HJ, {
  ClipboardTextSerializer: () => FG,
  Commands: () => NG,
  Delete: () => DG,
  Drop: () => xG,
  Editable: () => GG,
  FocusEvents: () => UG,
  Keymap: () => bG,
  Paste: () => vG,
  Tabindex: () => jG,
  TextDirection: () => HG,
  focusEventsPluginKey: () => zG
});
var tt = class yG extends Bp {
  constructor() {
    super(...arguments), this.type = "extension";
  }
  /**
   * Create a new Extension instance
   * @param config - Extension configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const A = typeof e == "function" ? e() : e;
    return new yG(A);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const A = typeof e == "function" ? e() : e;
    return super.extend(A);
  }
}, FG = tt.create({
  name: "clipboardTextSerializer",
  addOptions() {
    return {
      blockSeparator: void 0
    };
  },
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("clipboardTextSerializer"),
        props: {
          clipboardTextSerializer: () => {
            const { editor: t } = this, { state: e, schema: A } = t, { doc: n, selection: s } = e, { ranges: r } = s, i = Math.min(...r.map((l) => l.$from.pos)), o = Math.max(...r.map((l) => l.$to.pos)), a = fG(A);
            return wG(n, { from: i, to: o }, {
              ...this.options.blockSeparator !== void 0 ? { blockSeparator: this.options.blockSeparator } : {},
              textSerializers: a
            });
          }
        }
      })
    ];
  }
}), NG = tt.create({
  name: "commands",
  addCommands() {
    return {
      ...rG
    };
  }
}), DG = tt.create({
  name: "delete",
  onUpdate({ transaction: t, appendedTransactions: e }) {
    var A, n, s;
    const r = () => {
      var i, o, a, c;
      if ((c = (a = (o = (i = this.editor.options.coreExtensionOptions) == null ? void 0 : i.delete) == null ? void 0 : o.filterTransaction) == null ? void 0 : a.call(o, t)) != null ? c : t.getMeta("y-sync$"))
        return;
      const l = BG(t.before, [t, ...e]);
      IG(l).forEach((h) => {
        l.mapping.mapResult(h.oldRange.from).deletedAfter && l.mapping.mapResult(h.oldRange.to).deletedBefore && l.before.nodesBetween(h.oldRange.from, h.oldRange.to, (u, d) => {
          const w = d + u.nodeSize - 2, Q = h.oldRange.from <= d && w <= h.oldRange.to;
          this.editor.emit("delete", {
            type: "node",
            node: u,
            from: d,
            to: w,
            newFrom: l.mapping.map(d),
            newTo: l.mapping.map(w),
            deletedRange: h.oldRange,
            newRange: h.newRange,
            partial: !Q,
            editor: this.editor,
            transaction: t,
            combinedTransform: l
          });
        });
      });
      const g = l.mapping;
      l.steps.forEach((h, u) => {
        var d, w;
        if (h instanceof Zs) {
          const Q = g.slice(u).map(h.from, -1), p = g.slice(u).map(h.to), M = g.invert().map(Q, -1), I = g.invert().map(p), N = (d = l.doc.nodeAt(Q - 1)) == null ? void 0 : d.marks.some((E) => E.eq(h.mark)), m = (w = l.doc.nodeAt(p)) == null ? void 0 : w.marks.some((E) => E.eq(h.mark));
          this.editor.emit("delete", {
            type: "mark",
            mark: h.mark,
            from: h.from,
            to: h.to,
            deletedRange: {
              from: M,
              to: I
            },
            newRange: {
              from: Q,
              to: p
            },
            partial: !!(m || N),
            editor: this.editor,
            transaction: t,
            combinedTransform: l
          });
        }
      });
    };
    (s = (n = (A = this.editor.options.coreExtensionOptions) == null ? void 0 : A.delete) == null ? void 0 : n.async) == null || s ? setTimeout(r, 0) : r();
  }
}), xG = tt.create({
  name: "drop",
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("tiptapDrop"),
        props: {
          handleDrop: (t, e, A, n) => {
            this.editor.emit("drop", {
              editor: this.editor,
              event: e,
              slice: A,
              moved: n
            });
          }
        }
      })
    ];
  }
}), GG = tt.create({
  name: "editable",
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("editable"),
        props: {
          editable: () => this.editor.options.editable
        }
      })
    ];
  }
}), zG = new Bt("focusEvents"), UG = tt.create({
  name: "focusEvents",
  addProseMirrorPlugins() {
    const { editor: t } = this;
    return [
      new ct({
        key: zG,
        props: {
          handleDOMEvents: {
            focus: (e, A) => {
              t.isFocused = !0;
              const n = t.state.tr.setMeta("focus", { event: A }).setMeta("addToHistory", !1);
              return e.dispatch(n), !1;
            },
            blur: (e, A) => {
              t.isFocused = !1;
              const n = t.state.tr.setMeta("blur", { event: A }).setMeta("addToHistory", !1);
              return e.dispatch(n), !1;
            }
          }
        }
      })
    ];
  }
}), bG = tt.create({
  name: "keymap",
  addKeyboardShortcuts() {
    const t = () => this.editor.commands.first(({ commands: i }) => [
      () => i.undoInputRule(),
      // maybe convert first text block node to default node
      () => i.command(({ tr: o }) => {
        const { selection: a, doc: c } = o, { empty: l, $anchor: B } = a, { pos: g, parent: h } = B, u = B.parent.isTextblock && g > 0 ? o.doc.resolve(g - 1) : B, d = u.parent.type.spec.isolating, w = B.pos - B.parentOffset, Q = d && u.parent.childCount === 1 ? w === B.pos : Ke.atStart(c).from === g;
        return !l || !h.type.isTextblock || h.textContent.length || !Q || Q && B.parent.type.name === "paragraph" ? !1 : i.clearNodes();
      }),
      () => i.deleteSelection(),
      () => i.joinBackward(),
      () => i.selectNodeBackward()
    ]), e = () => this.editor.commands.first(({ commands: i }) => [
      () => i.deleteSelection(),
      () => i.deleteCurrentNode(),
      () => i.joinForward(),
      () => i.selectNodeForward()
    ]), n = {
      Enter: () => this.editor.commands.first(({ commands: i }) => [
        () => i.newlineInCode(),
        () => i.createParagraphNear(),
        () => i.liftEmptyBlock(),
        () => i.splitBlock()
      ]),
      "Mod-Enter": () => this.editor.commands.exitCode(),
      Backspace: t,
      "Mod-Backspace": t,
      "Shift-Backspace": t,
      Delete: e,
      "Mod-Delete": e,
      "Mod-a": () => this.editor.commands.selectAll()
    }, s = {
      ...n
    }, r = {
      ...n,
      "Ctrl-h": t,
      "Alt-Backspace": t,
      "Ctrl-d": e,
      "Ctrl-Alt-Backspace": e,
      "Alt-Delete": e,
      "Alt-d": e,
      "Ctrl-a": () => this.editor.commands.selectTextblockStart(),
      "Ctrl-e": () => this.editor.commands.selectTextblockEnd()
    };
    return Ju() || cG() ? r : s;
  },
  addProseMirrorPlugins() {
    return [
      // With this plugin we check if the whole document was selected and deleted.
      // In this case we will additionally call `clearNodes()` to convert e.g. a heading
      // to a paragraph if necessary.
      // This is an alternative to ProseMirror's `AllSelection`, which doesn’t work well
      // with many other commands.
      new ct({
        key: new Bt("clearDocument"),
        appendTransaction: (t, e, A) => {
          if (t.some((d) => d.getMeta("composition")))
            return;
          const n = t.some((d) => d.docChanged) && !e.doc.eq(A.doc), s = t.some((d) => d.getMeta("preventClearDocument"));
          if (!n || s)
            return;
          const { empty: r, from: i, to: o } = e.selection, a = Ke.atStart(e.doc).from, c = Ke.atEnd(e.doc).to;
          if (r || !(i === a && o === c) || !Uw(A.doc))
            return;
          const g = A.tr, h = Dw({
            state: A,
            transaction: g
          }), { commands: u } = new xw({
            editor: this.editor,
            state: h
          });
          if (u.clearNodes(), !!g.steps.length)
            return g;
        }
      })
    ];
  }
}), vG = tt.create({
  name: "paste",
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("tiptapPaste"),
        props: {
          handlePaste: (t, e, A) => {
            this.editor.emit("paste", {
              editor: this.editor,
              event: e,
              slice: A
            });
          }
        }
      })
    ];
  }
}), jG = tt.create({
  name: "tabindex",
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("tabindex"),
        props: {
          attributes: () => this.editor.isEditable ? { tabindex: "0" } : {}
        }
      })
    ];
  }
}), HG = tt.create({
  name: "textDirection",
  addOptions() {
    return {
      direction: void 0
    };
  },
  addGlobalAttributes() {
    if (!this.options.direction)
      return [];
    const { nodeExtensions: t } = pl(this.extensions);
    return [
      {
        types: t.filter((e) => e.name !== "text").map((e) => e.name),
        attributes: {
          dir: {
            default: this.options.direction,
            parseHTML: (e) => {
              const A = e.getAttribute("dir");
              return A && (A === "ltr" || A === "rtl" || A === "auto") ? A : this.options.direction;
            },
            renderHTML: (e) => e.dir ? {
              dir: e.dir
            } : {}
          }
        }
      }
    ];
  },
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("textDirection"),
        props: {
          attributes: () => {
            const t = this.options.direction;
            return t ? {
              dir: t
            } : {};
          }
        }
      })
    ];
  }
}), kJ = class pB {
  constructor(e, A, n = !1, s = null) {
    this.currentNode = null, this.actualDepth = null, this.isBlock = n, this.resolvedPos = e, this.editor = A, this.currentNode = s;
  }
  get name() {
    return this.node.type.name;
  }
  get node() {
    return this.currentNode || this.resolvedPos.node();
  }
  get element() {
    return this.editor.view.domAtPos(this.pos).node;
  }
  get depth() {
    var e;
    return (e = this.actualDepth) != null ? e : this.resolvedPos.depth;
  }
  get pos() {
    return this.resolvedPos.pos;
  }
  get content() {
    return this.node.content;
  }
  set content(e) {
    let A = this.from, n = this.to;
    if (this.isBlock) {
      if (this.content.size === 0) {
        console.error(`You can’t set content on a block node. Tried to set content on ${this.name} at ${this.pos}`);
        return;
      }
      A = this.from + 1, n = this.to - 1;
    }
    this.editor.commands.insertContentAt({ from: A, to: n }, e);
  }
  get attributes() {
    return this.node.attrs;
  }
  get textContent() {
    return this.node.textContent;
  }
  get size() {
    return this.node.nodeSize;
  }
  get from() {
    return this.isBlock ? this.pos : this.resolvedPos.start(this.resolvedPos.depth);
  }
  get range() {
    return {
      from: this.from,
      to: this.to
    };
  }
  get to() {
    return this.isBlock ? this.pos + this.size : this.resolvedPos.end(this.resolvedPos.depth) + (this.node.isText ? 0 : 1);
  }
  get parent() {
    if (this.depth === 0)
      return null;
    const e = this.resolvedPos.start(this.resolvedPos.depth - 1), A = this.resolvedPos.doc.resolve(e);
    return new pB(A, this.editor);
  }
  get before() {
    let e = this.resolvedPos.doc.resolve(this.from - (this.isBlock ? 1 : 2));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.from - 3)), new pB(e, this.editor);
  }
  get after() {
    let e = this.resolvedPos.doc.resolve(this.to + (this.isBlock ? 2 : 1));
    return e.depth !== this.depth && (e = this.resolvedPos.doc.resolve(this.to + 3)), new pB(e, this.editor);
  }
  get children() {
    const e = [];
    return this.node.content.forEach((A, n) => {
      const s = A.isBlock && !A.isTextblock, r = A.isAtom && !A.isText, i = A.isInline, o = this.pos + n + (r ? 0 : 1);
      if (o < 0 || o > this.resolvedPos.doc.nodeSize - 2)
        return;
      const a = this.resolvedPos.doc.resolve(o);
      if (!s && !i && a.depth <= this.depth)
        return;
      const c = new pB(a, this.editor, s, s || i ? A : null);
      s && (c.actualDepth = this.depth + 1), e.push(c);
    }), e;
  }
  get firstChild() {
    return this.children[0] || null;
  }
  get lastChild() {
    const e = this.children;
    return e[e.length - 1] || null;
  }
  closest(e, A = {}) {
    let n = null, s = this.parent;
    for (; s && !n; ) {
      if (s.node.type.name === e)
        if (Object.keys(A).length > 0) {
          const r = s.node.attrs, i = Object.keys(A);
          for (let o = 0; o < i.length; o += 1) {
            const a = i[o];
            if (r[a] !== A[a])
              break;
          }
        } else
          n = s;
      s = s.parent;
    }
    return n;
  }
  querySelector(e, A = {}) {
    return this.querySelectorAll(e, A, !0)[0] || null;
  }
  querySelectorAll(e, A = {}, n = !1) {
    let s = [];
    if (!this.children || this.children.length === 0)
      return s;
    const r = Object.keys(A);
    return this.children.forEach((i) => {
      n && s.length > 0 || (i.node.type.name === e && r.every((a) => A[a] === i.node.attrs[a]) && s.push(i), !(n && s.length > 0) && (s = s.concat(i.querySelectorAll(e, A, n))));
    }), s;
  }
  setAttribute(e) {
    const { tr: A } = this.editor.state;
    A.setNodeMarkup(this.from, void 0, {
      ...this.node.attrs,
      ...e
    }), this.editor.view.dispatch(A);
  }
}, RJ = `.ProseMirror {
  position: relative;
}

.ProseMirror {
  word-wrap: break-word;
  white-space: pre-wrap;
  white-space: break-spaces;
  -webkit-font-variant-ligatures: none;
  font-variant-ligatures: none;
  font-feature-settings: "liga" 0; /* the above doesn't seem to work in Edge */
}

.ProseMirror [contenteditable="false"] {
  white-space: normal;
}

.ProseMirror [contenteditable="false"] [contenteditable="true"] {
  white-space: pre-wrap;
}

.ProseMirror pre {
  white-space: pre-wrap;
}

img.ProseMirror-separator {
  display: inline !important;
  border: none !important;
  margin: 0 !important;
  width: 0 !important;
  height: 0 !important;
}

.ProseMirror-gapcursor {
  display: none;
  pointer-events: none;
  position: absolute;
  margin: 0;
}

.ProseMirror-gapcursor:after {
  content: "";
  display: block;
  position: absolute;
  top: -2px;
  width: 20px;
  border-top: 1px solid black;
  animation: ProseMirror-cursor-blink 1.1s steps(2, start) infinite;
}

@keyframes ProseMirror-cursor-blink {
  to {
    visibility: hidden;
  }
}

.ProseMirror-hideselection *::selection {
  background: transparent;
}

.ProseMirror-hideselection *::-moz-selection {
  background: transparent;
}

.ProseMirror-hideselection * {
  caret-color: transparent;
}

.ProseMirror-focused .ProseMirror-gapcursor {
  display: block;
}`;
function LJ(t, e, A) {
  const n = document.querySelector("style[data-tiptap-style]");
  if (n !== null)
    return n;
  const s = document.createElement("style");
  return e && s.setAttribute("nonce", e), s.setAttribute("data-tiptap-style", ""), s.innerHTML = t, document.getElementsByTagName("head")[0].appendChild(s), s;
}
var SJ = class extends NJ {
  constructor(e = {}) {
    super(), this.css = null, this.className = "tiptap", this.editorView = null, this.isFocused = !1, this.isInitialized = !1, this.extensionStorage = {}, this.instanceId = Math.random().toString(36).slice(2, 9), this.options = {
      element: typeof document < "u" ? document.createElement("div") : null,
      content: "",
      injectCSS: !0,
      injectNonce: void 0,
      extensions: [],
      autofocus: !1,
      editable: !0,
      textDirection: void 0,
      editorProps: {},
      parseOptions: {},
      coreExtensionOptions: {},
      enableInputRules: !0,
      enablePasteRules: !0,
      enableCoreExtensions: !0,
      enableContentCheck: !1,
      emitContentError: !1,
      onBeforeCreate: () => null,
      onCreate: () => null,
      onMount: () => null,
      onUnmount: () => null,
      onUpdate: () => null,
      onSelectionUpdate: () => null,
      onTransaction: () => null,
      onFocus: () => null,
      onBlur: () => null,
      onDestroy: () => null,
      onContentError: ({ error: s }) => {
        throw s;
      },
      onPaste: () => null,
      onDrop: () => null,
      onDelete: () => null,
      enableExtensionDispatchTransaction: !0
    }, this.isCapturingTransaction = !1, this.capturedTransaction = null, this.utils = {
      getUpdatedPosition: MG,
      createMappablePosition: rJ
    }, this.setOptions(e), this.createExtensionManager(), this.createCommandManager(), this.createSchema(), this.on("beforeCreate", this.options.onBeforeCreate), this.emit("beforeCreate", { editor: this }), this.on("mount", this.options.onMount), this.on("unmount", this.options.onUnmount), this.on("contentError", this.options.onContentError), this.on("create", this.options.onCreate), this.on("update", this.options.onUpdate), this.on("selectionUpdate", this.options.onSelectionUpdate), this.on("transaction", this.options.onTransaction), this.on("focus", this.options.onFocus), this.on("blur", this.options.onBlur), this.on("destroy", this.options.onDestroy), this.on("drop", ({ event: s, slice: r, moved: i }) => this.options.onDrop(s, r, i)), this.on("paste", ({ event: s, slice: r }) => this.options.onPaste(s, r)), this.on("delete", this.options.onDelete);
    const A = this.createDoc(), n = oG(A, this.options.autofocus);
    this.editorState = Vc.create({
      doc: A,
      schema: this.schema,
      selection: n || void 0
    }), this.options.element && this.mount(this.options.element);
  }
  /**
   * Attach the editor to the DOM, creating a new editor view.
   */
  mount(e) {
    if (typeof document > "u")
      throw new Error(
        "[tiptap error]: The editor cannot be mounted because there is no 'document' defined in this environment."
      );
    this.createView(e), this.emit("mount", { editor: this }), this.css && !document.head.contains(this.css) && document.head.appendChild(this.css), window.setTimeout(() => {
      this.isDestroyed || (this.options.autofocus !== !1 && this.options.autofocus !== null && this.commands.focus(this.options.autofocus), this.emit("create", { editor: this }), this.isInitialized = !0);
    }, 0);
  }
  /**
   * Remove the editor from the DOM, but still allow remounting at a different point in time
   */
  unmount() {
    if (this.editorView) {
      const e = this.editorView.dom;
      e != null && e.editor && delete e.editor, this.editorView.destroy();
    }
    if (this.editorView = null, this.isInitialized = !1, this.css && !document.querySelectorAll(`.${this.className}`).length)
      try {
        typeof this.css.remove == "function" ? this.css.remove() : this.css.parentNode && this.css.parentNode.removeChild(this.css);
      } catch (e) {
        console.warn("Failed to remove CSS element:", e);
      }
    this.css = null, this.emit("unmount", { editor: this });
  }
  /**
   * Returns the editor storage.
   */
  get storage() {
    return this.extensionStorage;
  }
  /**
   * An object of all registered commands.
   */
  get commands() {
    return this.commandManager.commands;
  }
  /**
   * Create a command chain to call multiple commands at once.
   */
  chain() {
    return this.commandManager.chain();
  }
  /**
   * Check if a command or a command chain can be executed. Without executing it.
   */
  can() {
    return this.commandManager.can();
  }
  /**
   * Inject CSS styles.
   */
  injectCSS() {
    this.options.injectCSS && typeof document < "u" && (this.css = LJ(RJ, this.options.injectNonce));
  }
  /**
   * Update editor options.
   *
   * @param options A list of options
   */
  setOptions(e = {}) {
    this.options = {
      ...this.options,
      ...e
    }, !(!this.editorView || !this.state || this.isDestroyed) && (this.options.editorProps && this.view.setProps(this.options.editorProps), this.view.updateState(this.state));
  }
  /**
   * Update editable state of the editor.
   */
  setEditable(e, A = !0) {
    this.setOptions({ editable: e }), A && this.emit("update", { editor: this, transaction: this.state.tr, appendedTransactions: [] });
  }
  /**
   * Returns whether the editor is editable.
   */
  get isEditable() {
    return this.options.editable && this.view && this.view.editable;
  }
  /**
   * Returns the editor view.
   */
  get view() {
    return this.editorView ? this.editorView : new Proxy(
      {
        state: this.editorState,
        updateState: (e) => {
          this.editorState = e;
        },
        dispatch: (e) => {
          this.dispatchTransaction(e);
        },
        // Stub some commonly accessed properties to prevent errors
        composing: !1,
        dragging: null,
        editable: !0,
        isDestroyed: !1
      },
      {
        get: (e, A) => {
          if (this.editorView)
            return this.editorView[A];
          if (A === "state")
            return this.editorState;
          if (A in e)
            return Reflect.get(e, A);
          throw new Error(
            `[tiptap error]: The editor view is not available. Cannot access view['${A}']. The editor may not be mounted yet.`
          );
        }
      }
    );
  }
  /**
   * Returns the editor state.
   */
  get state() {
    return this.editorView && (this.editorState = this.view.state), this.editorState;
  }
  /**
   * Register a ProseMirror plugin.
   *
   * @param plugin A ProseMirror plugin
   * @param handlePlugins Control how to merge the plugin into the existing plugins.
   * @returns The new editor state
   */
  registerPlugin(e, A) {
    const n = hG(A) ? A(e, [...this.state.plugins]) : [...this.state.plugins, e], s = this.state.reconfigure({ plugins: n });
    return this.view.updateState(s), s;
  }
  /**
   * Unregister a ProseMirror plugin.
   *
   * @param nameOrPluginKeyToRemove The plugins name
   * @returns The new editor state or undefined if the editor is destroyed
   */
  unregisterPlugin(e) {
    if (this.isDestroyed)
      return;
    const A = this.state.plugins;
    let n = A;
    if ([].concat(e).forEach((r) => {
      const i = typeof r == "string" ? `${r}$` : r.key;
      n = n.filter((o) => !o.key.startsWith(i));
    }), A.length === n.length)
      return;
    const s = this.state.reconfigure({
      plugins: n
    });
    return this.view.updateState(s), s;
  }
  /**
   * Creates an extension manager.
   */
  createExtensionManager() {
    var e, A;
    const s = [...this.options.enableCoreExtensions ? [
      GG,
      FG.configure({
        blockSeparator: (A = (e = this.options.coreExtensionOptions) == null ? void 0 : e.clipboardTextSerializer) == null ? void 0 : A.blockSeparator
      }),
      NG,
      UG,
      bG,
      jG,
      xG,
      vG,
      DG,
      HG.configure({
        direction: this.options.textDirection
      })
    ].filter((r) => typeof this.options.enableCoreExtensions == "object" ? this.options.enableCoreExtensions[r.name] !== !1 : !0) : [], ...this.options.extensions].filter((r) => ["extension", "node", "mark"].includes(r == null ? void 0 : r.type));
    this.extensionManager = new bw(s, this);
  }
  /**
   * Creates an command manager.
   */
  createCommandManager() {
    this.commandManager = new xw({
      editor: this
    });
  }
  /**
   * Creates a ProseMirror schema.
   */
  createSchema() {
    this.schema = this.extensionManager.schema;
  }
  /**
   * Creates the initial document.
   */
  createDoc() {
    let e;
    try {
      e = JC(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: this.options.enableContentCheck
      });
    } catch (A) {
      if (!(A instanceof Error) || !["[tiptap error]: Invalid JSON content", "[tiptap error]: Invalid HTML content"].includes(A.message))
        throw A;
      this.emit("contentError", {
        editor: this,
        error: A,
        disableCollaboration: () => {
          "collaboration" in this.storage && typeof this.storage.collaboration == "object" && this.storage.collaboration && (this.storage.collaboration.isDisabled = !0), this.options.extensions = this.options.extensions.filter((n) => n.name !== "collaboration"), this.createExtensionManager();
        }
      }), e = JC(this.options.content, this.schema, this.options.parseOptions, {
        errorOnInvalidContent: !1
      });
    }
    return e;
  }
  /**
   * Creates a ProseMirror view.
   */
  createView(e) {
    const { editorProps: A, enableExtensionDispatchTransaction: n } = this.options, s = A.dispatchTransaction || this.dispatchTransaction.bind(this), r = n ? this.extensionManager.dispatchTransaction(s) : s, i = A.transformPastedHTML, o = this.extensionManager.transformPastedHTML(i);
    this.editorView = new sG(e, {
      ...A,
      attributes: {
        // add `role="textbox"` to the editor element
        role: "textbox",
        ...A == null ? void 0 : A.attributes
      },
      dispatchTransaction: r,
      transformPastedHTML: o,
      state: this.editorState,
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
    const a = this.state.reconfigure({
      plugins: this.extensionManager.plugins
    });
    this.view.updateState(a), this.prependClass(), this.injectCSS();
    const c = this.view.dom;
    c.editor = this;
  }
  /**
   * Creates all node and mark views.
   */
  createNodeViews() {
    this.view.isDestroyed || this.view.setProps({
      markViews: this.extensionManager.markViews,
      nodeViews: this.extensionManager.nodeViews
    });
  }
  /**
   * Prepend class name to element.
   */
  prependClass() {
    this.view.dom.className = `${this.className} ${this.view.dom.className}`;
  }
  captureTransaction(e) {
    this.isCapturingTransaction = !0, e(), this.isCapturingTransaction = !1;
    const A = this.capturedTransaction;
    return this.capturedTransaction = null, A;
  }
  /**
   * The callback over which to send transactions (state updates) produced by the view.
   *
   * @param transaction An editor state transaction
   */
  dispatchTransaction(e) {
    if (this.view.isDestroyed)
      return;
    if (this.isCapturingTransaction) {
      if (!this.capturedTransaction) {
        this.capturedTransaction = e;
        return;
      }
      e.steps.forEach((l) => {
        var B;
        return (B = this.capturedTransaction) == null ? void 0 : B.step(l);
      });
      return;
    }
    const { state: A, transactions: n } = this.state.applyTransaction(e), s = !this.state.selection.eq(A.selection), r = n.includes(e), i = this.state;
    if (this.emit("beforeTransaction", {
      editor: this,
      transaction: e,
      nextState: A
    }), !r)
      return;
    this.view.updateState(A), this.emit("transaction", {
      editor: this,
      transaction: e,
      appendedTransactions: n.slice(1)
    }), s && this.emit("selectionUpdate", {
      editor: this,
      transaction: e
    });
    const o = n.findLast((l) => l.getMeta("focus") || l.getMeta("blur")), a = o == null ? void 0 : o.getMeta("focus"), c = o == null ? void 0 : o.getMeta("blur");
    a && this.emit("focus", {
      editor: this,
      event: a.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: o
    }), c && this.emit("blur", {
      editor: this,
      event: c.event,
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      transaction: o
    }), !(e.getMeta("preventUpdate") || !n.some((l) => l.docChanged) || i.doc.eq(A.doc)) && this.emit("update", {
      editor: this,
      transaction: e,
      appendedTransactions: n.slice(1)
    });
  }
  /**
   * Get attributes of the currently selected node or mark.
   */
  getAttributes(e) {
    return QG(this.state, e);
  }
  isActive(e, A) {
    const n = typeof e == "string" ? e : null, s = typeof e == "string" ? A : e;
    return AJ(this.state, n, s);
  }
  /**
   * Get the document as JSON.
   */
  getJSON() {
    return this.state.doc.toJSON();
  }
  /**
   * Get the document as HTML.
   */
  getHTML() {
    return ap(this.state.doc.content, this.schema);
  }
  /**
   * Get the document as text.
   */
  getText(e) {
    const { blockSeparator: A = `

`, textSerializers: n = {} } = e || {};
    return Z6(this.state.doc, {
      blockSeparator: A,
      textSerializers: {
        ...fG(this.schema),
        ...n
      }
    });
  }
  /**
   * Check if there is no content.
   */
  get isEmpty() {
    return Uw(this.state.doc);
  }
  /**
   * Destroy the editor.
   */
  destroy() {
    this.emit("destroy"), this.unmount(), this.removeAllListeners();
  }
  /**
   * Check if the editor is already destroyed.
   */
  get isDestroyed() {
    var e, A;
    return (A = (e = this.editorView) == null ? void 0 : e.isDestroyed) != null ? A : !0;
  }
  $node(e, A) {
    var n;
    return ((n = this.$doc) == null ? void 0 : n.querySelector(e, A)) || null;
  }
  $nodes(e, A) {
    var n;
    return ((n = this.$doc) == null ? void 0 : n.querySelectorAll(e, A)) || null;
  }
  $pos(e) {
    const A = this.state.doc.resolve(e);
    return new kJ(A, this);
  }
  get $doc() {
    return this.$pos(0);
  }
};
function _a(t) {
  return new Sl({
    find: t.find,
    handler: ({ state: e, range: A, match: n }) => {
      const s = Nt(t.getAttributes, void 0, n);
      if (s === !1 || s === null)
        return null;
      const { tr: r } = e, i = n[n.length - 1], o = n[0];
      if (i) {
        const a = o.search(/\S/), c = A.from + o.indexOf(i), l = c + i.length;
        if (cp(A.from, A.to, e.doc).filter((h) => h.mark.type.excluded.find((d) => d === t.type && d !== h.mark.type)).filter((h) => h.to > c).length)
          return null;
        l < A.to && r.delete(l, A.to), c > A.from && r.delete(A.from + a, c);
        const g = A.from + a + i.length;
        r.addMark(A.from + a, g, t.type.create(s || {})), r.removeStoredMark(t.type);
      }
    },
    undoable: t.undoable
  });
}
function kG(t) {
  return new Sl({
    find: t.find,
    handler: ({ state: e, range: A, match: n }) => {
      const s = Nt(t.getAttributes, void 0, n) || {}, { tr: r } = e, i = A.from;
      let o = A.to;
      const a = t.type.create(s);
      if (n[1]) {
        const c = n[0].lastIndexOf(n[1]);
        let l = i + c;
        l > o ? l = o : o = l + n[1].length;
        const B = n[0][n[0].length - 1];
        r.insertText(B, i + n[0].length - 1), r.replaceWith(l, o, a);
      } else if (n[0]) {
        const c = t.type.isInline ? i : i - 1;
        r.insert(c, t.type.create(s)).delete(r.mapping.map(i), r.mapping.map(o));
      }
      r.scrollIntoView();
    },
    undoable: t.undoable
  });
}
function OC(t) {
  return new Sl({
    find: t.find,
    handler: ({ state: e, range: A, match: n }) => {
      const s = e.doc.resolve(A.from), r = Nt(t.getAttributes, void 0, n) || {};
      if (!s.node(-1).canReplaceWith(s.index(-1), s.indexAfter(-1), t.type))
        return null;
      e.tr.delete(A.from, A.to).setBlockType(A.from, A.from, t.type, r);
    },
    undoable: t.undoable
  });
}
function ml(t) {
  return new Sl({
    find: t.find,
    handler: ({ state: e, range: A, match: n, chain: s }) => {
      const r = Nt(t.getAttributes, void 0, n) || {}, i = e.tr.delete(A.from, A.to), a = i.doc.resolve(A.from).blockRange(), c = a && Mw(a, t.type, r);
      if (!c)
        return null;
      if (i.wrap(a, c), t.keepMarks && t.editor) {
        const { selection: B, storedMarks: g } = e, { splittableMarks: h } = t.editor.extensionManager, u = g || B.$to.parentOffset && B.$from.marks();
        if (u) {
          const d = u.filter((w) => h.includes(w.type.name));
          i.ensureMarks(d);
        }
      }
      if (t.keepAttributes) {
        const B = t.type.name === "bulletList" || t.type.name === "orderedList" ? "listItem" : "taskList";
        s().updateAttributes(B, r).run();
      }
      const l = i.doc.resolve(A.from - 1).nodeBefore;
      l && l.type === t.type && oa(i.doc, A.from - 1) && (!t.joinPredicate || t.joinPredicate(n, l)) && i.join(A.from - 1);
    },
    undoable: t.undoable
  });
}
var TJ = (t) => "touches" in t, JJ = class {
  /**
   * Creates a new ResizableNodeView instance.
   *
   * The constructor sets up the resize handles, applies initial sizing from
   * node attributes, and configures all resize behavior options.
   *
   * @param options - Configuration options for the resizable node view
   */
  constructor(t) {
    this.directions = ["bottom-left", "bottom-right", "top-left", "top-right"], this.minSize = {
      height: 8,
      width: 8
    }, this.preserveAspectRatio = !1, this.classNames = {
      container: "",
      wrapper: "",
      handle: "",
      resizing: ""
    }, this.initialWidth = 0, this.initialHeight = 0, this.aspectRatio = 1, this.isResizing = !1, this.activeHandle = null, this.startX = 0, this.startY = 0, this.startWidth = 0, this.startHeight = 0, this.isShiftKeyPressed = !1, this.lastEditableState = void 0, this.handleMap = /* @__PURE__ */ new Map(), this.handleMouseMove = (o) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const a = o.clientX - this.startX, c = o.clientY - this.startY;
      this.handleResize(a, c);
    }, this.handleTouchMove = (o) => {
      if (!this.isResizing || !this.activeHandle)
        return;
      const a = o.touches[0];
      if (!a)
        return;
      const c = a.clientX - this.startX, l = a.clientY - this.startY;
      this.handleResize(c, l);
    }, this.handleMouseUp = () => {
      if (!this.isResizing)
        return;
      const o = this.element.offsetWidth, a = this.element.offsetHeight;
      this.onCommit(o, a), this.isResizing = !1, this.activeHandle = null, this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp);
    }, this.handleKeyDown = (o) => {
      o.key === "Shift" && (this.isShiftKeyPressed = !0);
    }, this.handleKeyUp = (o) => {
      o.key === "Shift" && (this.isShiftKeyPressed = !1);
    };
    var e, A, n, s, r, i;
    this.node = t.node, this.editor = t.editor, this.element = t.element, this.contentElement = t.contentElement, this.getPos = t.getPos, this.onResize = t.onResize, this.onCommit = t.onCommit, this.onUpdate = t.onUpdate, (e = t.options) != null && e.min && (this.minSize = {
      ...this.minSize,
      ...t.options.min
    }), (A = t.options) != null && A.max && (this.maxSize = t.options.max), (n = t == null ? void 0 : t.options) != null && n.directions && (this.directions = t.options.directions), (s = t.options) != null && s.preserveAspectRatio && (this.preserveAspectRatio = t.options.preserveAspectRatio), (r = t.options) != null && r.className && (this.classNames = {
      container: t.options.className.container || "",
      wrapper: t.options.className.wrapper || "",
      handle: t.options.className.handle || "",
      resizing: t.options.className.resizing || ""
    }), (i = t.options) != null && i.createCustomHandle && (this.createCustomHandle = t.options.createCustomHandle), this.wrapper = this.createWrapper(), this.container = this.createContainer(), this.applyInitialSize(), this.attachHandles(), this.editor.on("update", this.handleEditorUpdate.bind(this));
  }
  /**
   * Returns the top-level DOM node that should be placed in the editor.
   *
   * This is required by the ProseMirror NodeView interface. The container
   * includes the wrapper, handles, and the actual content element.
   *
   * @returns The container element to be inserted into the editor
   */
  get dom() {
    return this.container;
  }
  get contentDOM() {
    var t;
    return (t = this.contentElement) != null ? t : null;
  }
  handleEditorUpdate() {
    const t = this.editor.isEditable;
    t !== this.lastEditableState && (this.lastEditableState = t, t ? t && this.handleMap.size === 0 && this.attachHandles() : this.removeHandles());
  }
  /**
   * Called when the node's content or attributes change.
   *
   * Updates the internal node reference. If a custom `onUpdate` callback
   * was provided, it will be called to handle additional update logic.
   *
   * @param node - The new/updated node
   * @param decorations - Node decorations
   * @param innerDecorations - Inner decorations
   * @returns `false` if the node type has changed (requires full rebuild), otherwise the result of `onUpdate` or `true`
   */
  update(t, e, A) {
    return t.type !== this.node.type ? !1 : (this.node = t, this.onUpdate ? this.onUpdate(t, e, A) : !0);
  }
  /**
   * Cleanup method called when the node view is being removed.
   *
   * Removes all event listeners to prevent memory leaks. This is required
   * by the ProseMirror NodeView interface. If a resize is active when
   * destroy is called, it will be properly cancelled.
   */
  destroy() {
    this.isResizing && (this.container.dataset.resizeState = "false", this.classNames.resizing && this.container.classList.remove(this.classNames.resizing), document.removeEventListener("mousemove", this.handleMouseMove), document.removeEventListener("mouseup", this.handleMouseUp), document.removeEventListener("keydown", this.handleKeyDown), document.removeEventListener("keyup", this.handleKeyUp), this.isResizing = !1, this.activeHandle = null), this.editor.off("update", this.handleEditorUpdate.bind(this)), this.container.remove();
  }
  /**
   * Creates the outer container element.
   *
   * The container is the top-level element returned by the NodeView and
   * wraps the entire resizable node. It's set up with flexbox to handle
   * alignment and includes data attributes for styling and identification.
   *
   * @returns The container element
   */
  createContainer() {
    const t = document.createElement("div");
    return t.dataset.resizeContainer = "", t.dataset.node = this.node.type.name, t.style.display = "flex", this.classNames.container && (t.className = this.classNames.container), t.appendChild(this.wrapper), t;
  }
  /**
   * Creates the wrapper element that contains the content and handles.
   *
   * The wrapper uses relative positioning so that resize handles can be
   * positioned absolutely within it. This is the direct parent of the
   * content element being made resizable.
   *
   * @returns The wrapper element
   */
  createWrapper() {
    const t = document.createElement("div");
    return t.style.position = "relative", t.style.display = "block", t.dataset.resizeWrapper = "", this.classNames.wrapper && (t.className = this.classNames.wrapper), t.appendChild(this.element), t;
  }
  /**
   * Creates a resize handle element for a specific direction.
   *
   * Each handle is absolutely positioned and includes a data attribute
   * identifying its direction for styling purposes.
   *
   * @param direction - The resize direction for this handle
   * @returns The handle element
   */
  createHandle(t) {
    const e = document.createElement("div");
    return e.dataset.resizeHandle = t, e.style.position = "absolute", this.classNames.handle && (e.className = this.classNames.handle), e;
  }
  /**
   * Positions a handle element according to its direction.
   *
   * Corner handles (e.g., 'top-left') are positioned at the intersection
   * of two edges. Edge handles (e.g., 'top') span the full width or height.
   *
   * @param handle - The handle element to position
   * @param direction - The direction determining the position
   */
  positionHandle(t, e) {
    const A = e.includes("top"), n = e.includes("bottom"), s = e.includes("left"), r = e.includes("right");
    A && (t.style.top = "0"), n && (t.style.bottom = "0"), s && (t.style.left = "0"), r && (t.style.right = "0"), (e === "top" || e === "bottom") && (t.style.left = "0", t.style.right = "0"), (e === "left" || e === "right") && (t.style.top = "0", t.style.bottom = "0");
  }
  /**
   * Creates and attaches all resize handles to the wrapper.
   *
   * Iterates through the configured directions, creates a handle for each,
   * positions it, attaches the mousedown listener, and appends it to the DOM.
   */
  attachHandles() {
    this.directions.forEach((t) => {
      let e;
      this.createCustomHandle ? e = this.createCustomHandle(t) : e = this.createHandle(t), e instanceof HTMLElement || (console.warn(
        `[ResizableNodeView] createCustomHandle("${t}") did not return an HTMLElement. Falling back to default handle.`
      ), e = this.createHandle(t)), this.createCustomHandle || this.positionHandle(e, t), e.addEventListener("mousedown", (A) => this.handleResizeStart(A, t)), e.addEventListener("touchstart", (A) => this.handleResizeStart(A, t)), this.handleMap.set(t, e), this.wrapper.appendChild(e);
    });
  }
  /**
   * Removes all resize handles from the wrapper.
   *
   * Cleans up the handle map and removes each handle element from the DOM.
   */
  removeHandles() {
    this.handleMap.forEach((t) => t.remove()), this.handleMap.clear();
  }
  /**
   * Applies initial sizing from node attributes to the element.
   *
   * If width/height attributes exist on the node, they're applied to the element.
   * Otherwise, the element's natural/current dimensions are measured. The aspect
   * ratio is calculated for later use in aspect-ratio-preserving resizes.
   */
  applyInitialSize() {
    const t = this.node.attrs.width, e = this.node.attrs.height;
    t ? (this.element.style.width = `${t}px`, this.initialWidth = t) : this.initialWidth = this.element.offsetWidth, e ? (this.element.style.height = `${e}px`, this.initialHeight = e) : this.initialHeight = this.element.offsetHeight, this.initialWidth > 0 && this.initialHeight > 0 && (this.aspectRatio = this.initialWidth / this.initialHeight);
  }
  /**
   * Initiates a resize operation when a handle is clicked.
   *
   * Captures the starting mouse position and element dimensions, sets up
   * the resize state, adds the resizing class and state attribute, and
   * attaches document-level listeners for mouse movement and keyboard input.
   *
   * @param event - The mouse down event
   * @param direction - The direction of the handle being dragged
   */
  handleResizeStart(t, e) {
    t.preventDefault(), t.stopPropagation(), this.isResizing = !0, this.activeHandle = e, TJ(t) ? (this.startX = t.touches[0].clientX, this.startY = t.touches[0].clientY) : (this.startX = t.clientX, this.startY = t.clientY), this.startWidth = this.element.offsetWidth, this.startHeight = this.element.offsetHeight, this.startWidth > 0 && this.startHeight > 0 && (this.aspectRatio = this.startWidth / this.startHeight), this.getPos(), this.container.dataset.resizeState = "true", this.classNames.resizing && this.container.classList.add(this.classNames.resizing), document.addEventListener("mousemove", this.handleMouseMove), document.addEventListener("touchmove", this.handleTouchMove), document.addEventListener("mouseup", this.handleMouseUp), document.addEventListener("keydown", this.handleKeyDown), document.addEventListener("keyup", this.handleKeyUp);
  }
  handleResize(t, e) {
    if (!this.activeHandle)
      return;
    const A = this.preserveAspectRatio || this.isShiftKeyPressed, { width: n, height: s } = this.calculateNewDimensions(this.activeHandle, t, e), r = this.applyConstraints(n, s, A);
    this.element.style.width = `${r.width}px`, this.element.style.height = `${r.height}px`, this.onResize && this.onResize(r.width, r.height);
  }
  /**
   * Calculates new dimensions based on mouse delta and resize direction.
   *
   * Takes the starting dimensions and applies the mouse movement delta
   * according to the handle direction. For corner handles, both dimensions
   * are affected. For edge handles, only one dimension changes. If aspect
   * ratio should be preserved, delegates to applyAspectRatio.
   *
   * @param direction - The active resize handle direction
   * @param deltaX - Horizontal mouse movement since resize start
   * @param deltaY - Vertical mouse movement since resize start
   * @returns The calculated width and height
   */
  calculateNewDimensions(t, e, A) {
    let n = this.startWidth, s = this.startHeight;
    const r = t.includes("right"), i = t.includes("left"), o = t.includes("bottom"), a = t.includes("top");
    return r ? n = this.startWidth + e : i && (n = this.startWidth - e), o ? s = this.startHeight + A : a && (s = this.startHeight - A), (t === "right" || t === "left") && (n = this.startWidth + (r ? e : -e)), (t === "top" || t === "bottom") && (s = this.startHeight + (o ? A : -A)), this.preserveAspectRatio || this.isShiftKeyPressed ? this.applyAspectRatio(n, s, t) : { width: n, height: s };
  }
  /**
   * Applies min/max constraints to dimensions.
   *
   * When aspect ratio is NOT preserved, constraints are applied independently
   * to width and height. When aspect ratio IS preserved, constraints are
   * applied while maintaining the aspect ratio—if one dimension hits a limit,
   * the other is recalculated proportionally.
   *
   * This ensures that aspect ratio is never broken when constrained.
   *
   * @param width - The unconstrained width
   * @param height - The unconstrained height
   * @param preserveAspectRatio - Whether to maintain aspect ratio while constraining
   * @returns The constrained dimensions
   */
  applyConstraints(t, e, A) {
    var n, s, r, i;
    if (!A) {
      let c = Math.max(this.minSize.width, t), l = Math.max(this.minSize.height, e);
      return (n = this.maxSize) != null && n.width && (c = Math.min(this.maxSize.width, c)), (s = this.maxSize) != null && s.height && (l = Math.min(this.maxSize.height, l)), { width: c, height: l };
    }
    let o = t, a = e;
    return o < this.minSize.width && (o = this.minSize.width, a = o / this.aspectRatio), a < this.minSize.height && (a = this.minSize.height, o = a * this.aspectRatio), (r = this.maxSize) != null && r.width && o > this.maxSize.width && (o = this.maxSize.width, a = o / this.aspectRatio), (i = this.maxSize) != null && i.height && a > this.maxSize.height && (a = this.maxSize.height, o = a * this.aspectRatio), { width: o, height: a };
  }
  /**
   * Adjusts dimensions to maintain the original aspect ratio.
   *
   * For horizontal handles (left/right), uses width as the primary dimension
   * and calculates height from it. For vertical handles (top/bottom), uses
   * height as primary and calculates width. For corner handles, uses width
   * as the primary dimension.
   *
   * @param width - The new width
   * @param height - The new height
   * @param direction - The active resize direction
   * @returns Dimensions adjusted to preserve aspect ratio
   */
  applyAspectRatio(t, e, A) {
    const n = A === "left" || A === "right", s = A === "top" || A === "bottom";
    return n ? {
      width: t,
      height: t / this.aspectRatio
    } : s ? {
      width: e * this.aspectRatio,
      height: e
    } : {
      width: t,
      height: t / this.aspectRatio
    };
  }
};
function WJ(t, e) {
  const { selection: A } = t, { $from: n } = A;
  if (A instanceof Ue) {
    const r = n.index();
    return n.parent.canReplaceWith(r, r + 1, e);
  }
  let s = n.depth;
  for (; s >= 0; ) {
    const r = n.index(s);
    if (n.node(s).contentMatchAt(r).matchType(e))
      return !0;
    s -= 1;
  }
  return !1;
}
function OJ(t) {
  return t.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&");
}
function PJ() {
  return typeof navigator < "u" ? /Firefox/.test(navigator.userAgent) : !1;
}
var KJ = {};
np(KJ, {
  createAtomBlockMarkdownSpec: () => RG,
  createBlockMarkdownSpec: () => VJ,
  createInlineMarkdownSpec: () => LG,
  parseAttributes: () => gp,
  parseIndentedBlocks: () => PC,
  renderNestedMarkdownContent: () => up,
  serializeAttributes: () => hp
});
function gp(t) {
  if (!(t != null && t.trim()))
    return {};
  const e = {}, A = [], n = t.replace(/["']([^"']*)["']/g, (c) => (A.push(c), `__QUOTED_${A.length - 1}__`)), s = n.match(/(?:^|\s)\.([a-zA-Z][\w-]*)/g);
  if (s) {
    const c = s.map((l) => l.trim().slice(1));
    e.class = c.join(" ");
  }
  const r = n.match(/(?:^|\s)#([a-zA-Z][\w-]*)/);
  r && (e.id = r[1]);
  const i = /([a-zA-Z][\w-]*)\s*=\s*(__QUOTED_\d+__)/g;
  Array.from(n.matchAll(i)).forEach(([, c, l]) => {
    var B;
    const g = parseInt(((B = l.match(/__QUOTED_(\d+)__/)) == null ? void 0 : B[1]) || "0", 10), h = A[g];
    h && (e[c] = h.slice(1, -1));
  });
  const a = n.replace(/(?:^|\s)\.([a-zA-Z][\w-]*)/g, "").replace(/(?:^|\s)#([a-zA-Z][\w-]*)/g, "").replace(/([a-zA-Z][\w-]*)\s*=\s*__QUOTED_\d+__/g, "").trim();
  return a && a.split(/\s+/).filter(Boolean).forEach((l) => {
    l.match(/^[a-zA-Z][\w-]*$/) && (e[l] = !0);
  }), e;
}
function hp(t) {
  if (!t || Object.keys(t).length === 0)
    return "";
  const e = [];
  return t.class && String(t.class).split(/\s+/).filter(Boolean).forEach((n) => e.push(`.${n}`)), t.id && e.push(`#${t.id}`), Object.entries(t).forEach(([A, n]) => {
    A === "class" || A === "id" || (n === !0 ? e.push(A) : n !== !1 && n != null && e.push(`${A}="${String(n)}"`));
  }), e.join(" ");
}
function RG(t) {
  const {
    nodeName: e,
    name: A,
    parseAttributes: n = gp,
    serializeAttributes: s = hp,
    defaultAttributes: r = {},
    requiredAttributes: i = [],
    allowedAttributes: o
  } = t, a = A || e, c = (l) => {
    if (!o)
      return l;
    const B = {};
    return o.forEach((g) => {
      g in l && (B[g] = l[g]);
    }), B;
  };
  return {
    parseMarkdown: (l, B) => {
      const g = { ...r, ...l.attributes };
      return B.createNode(e, g, []);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(l) {
        var B;
        const g = new RegExp(`^:::${a}(?:\\s|$)`, "m"), h = (B = l.match(g)) == null ? void 0 : B.index;
        return h !== void 0 ? h : -1;
      },
      tokenize(l, B, g) {
        const h = new RegExp(`^:::${a}(?:\\s+\\{([^}]*)\\})?\\s*:::(?:\\n|$)`), u = l.match(h);
        if (!u)
          return;
        const d = u[1] || "", w = n(d);
        if (!i.find((p) => !(p in w)))
          return {
            type: e,
            raw: u[0],
            attributes: w
          };
      }
    },
    renderMarkdown: (l) => {
      const B = c(l.attrs || {}), g = s(B), h = g ? ` {${g}}` : "";
      return `:::${a}${h} :::`;
    }
  };
}
function VJ(t) {
  const {
    nodeName: e,
    name: A,
    getContent: n,
    parseAttributes: s = gp,
    serializeAttributes: r = hp,
    defaultAttributes: i = {},
    content: o = "block",
    allowedAttributes: a
  } = t, c = A || e, l = (B) => {
    if (!a)
      return B;
    const g = {};
    return a.forEach((h) => {
      h in B && (g[h] = B[h]);
    }), g;
  };
  return {
    parseMarkdown: (B, g) => {
      let h;
      if (n) {
        const d = n(B);
        h = typeof d == "string" ? [{ type: "text", text: d }] : d;
      } else o === "block" ? h = g.parseChildren(B.tokens || []) : h = g.parseInline(B.tokens || []);
      const u = { ...i, ...B.attributes };
      return g.createNode(e, u, h);
    },
    markdownTokenizer: {
      name: e,
      level: "block",
      start(B) {
        var g;
        const h = new RegExp(`^:::${c}`, "m"), u = (g = B.match(h)) == null ? void 0 : g.index;
        return u !== void 0 ? u : -1;
      },
      tokenize(B, g, h) {
        var u;
        const d = new RegExp(`^:::${c}(?:\\s+\\{([^}]*)\\})?\\s*\\n`), w = B.match(d);
        if (!w)
          return;
        const [Q, p = ""] = w, M = s(p);
        let I = 1;
        const N = Q.length;
        let m = "";
        const E = /^:::([\w-]*)(\s.*)?/gm, G = B.slice(N);
        for (E.lastIndex = 0; ; ) {
          const Y = E.exec(G);
          if (Y === null)
            break;
          const U = Y.index, v = Y[1];
          if (!((u = Y[2]) != null && u.endsWith(":::"))) {
            if (v)
              I += 1;
            else if (I -= 1, I === 0) {
              const b = G.slice(0, U);
              m = b.trim();
              const W = B.slice(0, N + U + Y[0].length);
              let q = [];
              if (m)
                if (o === "block")
                  for (q = h.blockTokens(b), q.forEach((ne) => {
                    ne.text && (!ne.tokens || ne.tokens.length === 0) && (ne.tokens = h.inlineTokens(ne.text));
                  }); q.length > 0; ) {
                    const ne = q[q.length - 1];
                    if (ne.type === "paragraph" && (!ne.text || ne.text.trim() === ""))
                      q.pop();
                    else
                      break;
                  }
                else
                  q = h.inlineTokens(m);
              return {
                type: e,
                raw: W,
                attributes: M,
                content: m,
                tokens: q
              };
            }
          }
        }
      }
    },
    renderMarkdown: (B, g) => {
      const h = l(B.attrs || {}), u = r(h), d = u ? ` {${u}}` : "", w = g.renderChildren(B.content || [], `

`);
      return `:::${c}${d}

${w}

:::`;
    }
  };
}
function XJ(t) {
  if (!t.trim())
    return {};
  const e = {}, A = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
  let n = A.exec(t);
  for (; n !== null; ) {
    const [, s, r, i] = n;
    e[s] = r || i, n = A.exec(t);
  }
  return e;
}
function ZJ(t) {
  return Object.entries(t).filter(([, e]) => e != null).map(([e, A]) => `${e}="${A}"`).join(" ");
}
function LG(t) {
  const {
    nodeName: e,
    name: A,
    getContent: n,
    parseAttributes: s = XJ,
    serializeAttributes: r = ZJ,
    defaultAttributes: i = {},
    selfClosing: o = !1,
    allowedAttributes: a
  } = t, c = A || e, l = (g) => {
    if (!a)
      return g;
    const h = {};
    return a.forEach((u) => {
      const d = typeof u == "string" ? u : u.name, w = typeof u == "string" ? void 0 : u.skipIfDefault;
      if (d in g) {
        const Q = g[d];
        if (w !== void 0 && Q === w)
          return;
        h[d] = Q;
      }
    }), h;
  }, B = c.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  return {
    parseMarkdown: (g, h) => {
      const u = { ...i, ...g.attributes };
      if (o)
        return h.createNode(e, u);
      const d = n ? n(g) : g.content || "";
      return d ? h.createNode(e, u, [h.createTextNode(d)]) : h.createNode(e, u, []);
    },
    markdownTokenizer: {
      name: e,
      level: "inline",
      start(g) {
        const h = o ? new RegExp(`\\[${B}\\s*[^\\]]*\\]`) : new RegExp(`\\[${B}\\s*[^\\]]*\\][\\s\\S]*?\\[\\/${B}\\]`), u = g.match(h), d = u == null ? void 0 : u.index;
        return d !== void 0 ? d : -1;
      },
      tokenize(g, h, u) {
        const d = o ? new RegExp(`^\\[${B}\\s*([^\\]]*)\\]`) : new RegExp(`^\\[${B}\\s*([^\\]]*)\\]([\\s\\S]*?)\\[\\/${B}\\]`), w = g.match(d);
        if (!w)
          return;
        let Q = "", p = "";
        if (o) {
          const [, I] = w;
          p = I;
        } else {
          const [, I, N] = w;
          p = I, Q = N || "";
        }
        const M = s(p.trim());
        return {
          type: e,
          raw: w[0],
          content: Q.trim(),
          attributes: M
        };
      }
    },
    renderMarkdown: (g) => {
      let h = "";
      n ? h = n(g) : g.content && g.content.length > 0 && (h = g.content.filter((Q) => Q.type === "text").map((Q) => Q.text).join(""));
      const u = l(g.attrs || {}), d = r(u), w = d ? ` ${d}` : "";
      return o ? `[${c}${w}]` : `[${c}${w}]${h}[/${c}]`;
    }
  };
}
function PC(t, e, A) {
  var n, s, r, i;
  const o = t.split(`
`), a = [];
  let c = "", l = 0;
  const B = e.baseIndentSize || 2;
  for (; l < o.length; ) {
    const g = o[l], h = g.match(e.itemPattern);
    if (!h) {
      if (a.length > 0)
        break;
      if (g.trim() === "") {
        l += 1, c = `${c}${g}
`;
        continue;
      } else
        return;
    }
    const u = e.extractItemData(h), { indentLevel: d, mainContent: w } = u;
    c = `${c}${g}
`;
    const Q = [w];
    for (l += 1; l < o.length; ) {
      const N = o[l];
      if (N.trim() === "") {
        const E = o.slice(l + 1).findIndex((U) => U.trim() !== "");
        if (E === -1)
          break;
        if ((((s = (n = o[l + 1 + E].match(/^(\s*)/)) == null ? void 0 : n[1]) == null ? void 0 : s.length) || 0) > d) {
          Q.push(N), c = `${c}${N}
`, l += 1;
          continue;
        } else
          break;
      }
      if ((((i = (r = N.match(/^(\s*)/)) == null ? void 0 : r[1]) == null ? void 0 : i.length) || 0) > d)
        Q.push(N), c = `${c}${N}
`, l += 1;
      else
        break;
    }
    let p;
    const M = Q.slice(1);
    if (M.length > 0) {
      const N = M.map((m) => m.slice(d + B)).join(`
`);
      N.trim() && (e.customNestedParser ? p = e.customNestedParser(N) : p = A.blockTokens(N));
    }
    const I = e.createToken(u, p);
    a.push(I);
  }
  if (a.length !== 0)
    return {
      items: a,
      raw: c
    };
}
function up(t, e, A, n) {
  if (!t || !Array.isArray(t.content))
    return "";
  const s = typeof A == "function" ? A(n) : A, [r, ...i] = t.content, o = e.renderChildren([r]), a = [`${s}${o}`];
  return i && i.length > 0 && i.forEach((c) => {
    const l = e.renderChildren([c]);
    if (l) {
      const B = l.split(`
`).map((g) => g ? e.indent(g) : "").join(`
`);
      a.push(B);
    }
  }), a.join(`
`);
}
function qJ(t, e, A = {}) {
  const { state: n } = e, { doc: s, tr: r } = n, i = t;
  s.descendants((o, a) => {
    const c = r.mapping.map(a), l = r.mapping.map(a) + o.nodeSize;
    let B = null;
    if (o.marks.forEach((h) => {
      if (h !== i)
        return !1;
      B = h;
    }), !B)
      return;
    let g = !1;
    if (Object.keys(A).forEach((h) => {
      A[h] !== B.attrs[h] && (g = !0);
    }), g) {
      const h = t.type.create({
        ...t.attrs,
        ...A
      });
      r.removeMark(c, l, t.type), r.addMark(c, l, h);
    }
  }), r.docChanged && e.view.dispatch(r);
}
var Zt = class SG extends Bp {
  constructor() {
    super(...arguments), this.type = "node";
  }
  /**
   * Create a new Node instance
   * @param config - Node configuration object or a function that returns a configuration object
   */
  static create(e = {}) {
    const A = typeof e == "function" ? e() : e;
    return new SG(A);
  }
  configure(e) {
    return super.configure(e);
  }
  extend(e) {
    const A = typeof e == "function" ? e() : e;
    return super.extend(A);
  }
};
function Xo(t) {
  return new YG({
    find: t.find,
    handler: ({ state: e, range: A, match: n, pasteEvent: s }) => {
      const r = Nt(t.getAttributes, void 0, n, s);
      if (r === !1 || r === null)
        return null;
      const { tr: i } = e, o = n[n.length - 1], a = n[0];
      let c = A.to;
      if (o) {
        const l = a.search(/\S/), B = A.from + a.indexOf(o), g = B + o.length;
        if (cp(A.from, A.to, e.doc).filter((u) => u.mark.type.excluded.find((w) => w === t.type && w !== u.mark.type)).filter((u) => u.to > B).length)
          return null;
        g < A.to && i.delete(g, A.to), B > A.from && i.delete(A.from + l, B), c = A.from + l + o.length, i.addMark(A.from + l, c, t.type.create(r || {})), i.removeStoredMark(t.type);
      }
    }
  });
}
function _J(t) {
  return new YG({
    find: t.find,
    handler({ match: e, chain: A, range: n, pasteEvent: s }) {
      const r = Nt(t.getAttributes, void 0, e, s), i = Nt(t.getContent, void 0, r);
      if (r === !1 || r === null)
        return null;
      const o = { type: t.type.name, attrs: r };
      i && (o.content = i), e.input && A().deleteRange(n).insertContentAt(n.from, o);
    }
  });
}
function _y(t) {
  return v5((e, A) => ({
    get() {
      return e(), t;
    },
    set(n) {
      t = n, requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          A();
        });
      });
    }
  }));
}
var $J = class extends SJ {
  constructor(t = {}) {
    return super(t), this.contentComponent = null, this.appContext = null, this.reactiveState = _y(this.view.state), this.reactiveExtensionStorage = _y(this.extensionStorage), this.on("beforeTransaction", ({ nextState: e }) => {
      this.reactiveState.value = e, this.reactiveExtensionStorage.value = this.extensionStorage;
    }), m3(this);
  }
  get state() {
    return this.reactiveState ? this.reactiveState.value : this.view.state;
  }
  get storage() {
    return this.reactiveExtensionStorage ? this.reactiveExtensionStorage.value : super.storage;
  }
  /**
   * Register a ProseMirror plugin.
   */
  registerPlugin(t, e) {
    const A = super.registerPlugin(t, e);
    return this.reactiveState && (this.reactiveState.value = A), A;
  }
  /**
   * Unregister a ProseMirror plugin.
   */
  unregisterPlugin(t) {
    const e = super.unregisterPlugin(t);
    return this.reactiveState && e && (this.reactiveState.value = e), e;
  }
}, eW = /* @__PURE__ */ Un({
  name: "EditorContent",
  props: {
    editor: {
      default: null,
      type: Object
    }
  },
  setup(t) {
    const e = /* @__PURE__ */ me(), A = bn();
    return P5(() => {
      const n = t.editor;
      n && n.options.element && e.value && Yn(() => {
        var s;
        if (!e.value || !((s = n.view.dom) != null && s.parentNode))
          return;
        const r = bs(e.value);
        e.value.append(...n.view.dom.parentNode.childNodes), n.contentComponent = A.ctx._, A && (n.appContext = {
          ...A.appContext,
          // Vue internally uses prototype chain to forward/shadow injects across the entire component chain
          // so don't use object spread operator or 'Object.assign' and just set `provides` as is on editor's appContext
          // @ts-expect-error forward instance's 'provides' into appContext
          provides: A.provides
        }), n.setOptions({
          element: r
        }), n.createNodeViews();
      });
    }), Zr(() => {
      const n = t.editor;
      n && (n.contentComponent = null, n.appContext = null);
    }), { rootEl: e };
  },
  render() {
    return GM("div", {
      ref: (t) => {
        this.rootEl = t;
      }
    });
  }
});
const TG = ["top", "right", "bottom", "left"], $y = ["start", "end"], e1 = /* @__PURE__ */ TG.reduce((t, e) => t.concat(e, e + "-" + $y[0], e + "-" + $y[1]), []), Tr = Math.min, yn = Math.max, Wu = Math.round, vr = (t) => ({
  x: t,
  y: t
}), tW = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, AW = {
  start: "end",
  end: "start"
};
function KC(t, e, A) {
  return yn(t, Tr(e, A));
}
function eo(t, e) {
  return typeof t == "function" ? t(e) : t;
}
function Ls(t) {
  return t.split("-")[0];
}
function Ar(t) {
  return t.split("-")[1];
}
function JG(t) {
  return t === "x" ? "y" : "x";
}
function dp(t) {
  return t === "y" ? "height" : "width";
}
const nW = /* @__PURE__ */ new Set(["top", "bottom"]);
function Nr(t) {
  return nW.has(Ls(t)) ? "y" : "x";
}
function wp(t) {
  return JG(Nr(t));
}
function WG(t, e, A) {
  A === void 0 && (A = !1);
  const n = Ar(t), s = wp(t), r = dp(s);
  let i = s === "x" ? n === (A ? "end" : "start") ? "right" : "left" : n === "start" ? "bottom" : "top";
  return e.reference[r] > e.floating[r] && (i = Pu(i)), [i, Pu(i)];
}
function sW(t) {
  const e = Pu(t);
  return [Ou(t), e, Ou(e)];
}
function Ou(t) {
  return t.replace(/start|end/g, (e) => AW[e]);
}
const t1 = ["left", "right"], A1 = ["right", "left"], rW = ["top", "bottom"], iW = ["bottom", "top"];
function oW(t, e, A) {
  switch (t) {
    case "top":
    case "bottom":
      return A ? e ? A1 : t1 : e ? t1 : A1;
    case "left":
    case "right":
      return e ? rW : iW;
    default:
      return [];
  }
}
function aW(t, e, A, n) {
  const s = Ar(t);
  let r = oW(Ls(t), A === "start", n);
  return s && (r = r.map((i) => i + "-" + s), e && (r = r.concat(r.map(Ou)))), r;
}
function Pu(t) {
  return t.replace(/left|right|bottom|top/g, (e) => tW[e]);
}
function cW(t) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...t
  };
}
function fp(t) {
  return typeof t != "number" ? cW(t) : {
    top: t,
    right: t,
    bottom: t,
    left: t
  };
}
function Yl(t) {
  const {
    x: e,
    y: A,
    width: n,
    height: s
  } = t;
  return {
    width: n,
    height: s,
    top: A,
    left: e,
    right: e + n,
    bottom: A + s,
    x: e,
    y: A
  };
}
function n1(t, e, A) {
  let {
    reference: n,
    floating: s
  } = t;
  const r = Nr(e), i = wp(e), o = dp(i), a = Ls(e), c = r === "y", l = n.x + n.width / 2 - s.width / 2, B = n.y + n.height / 2 - s.height / 2, g = n[o] / 2 - s[o] / 2;
  let h;
  switch (a) {
    case "top":
      h = {
        x: l,
        y: n.y - s.height
      };
      break;
    case "bottom":
      h = {
        x: l,
        y: n.y + n.height
      };
      break;
    case "right":
      h = {
        x: n.x + n.width,
        y: B
      };
      break;
    case "left":
      h = {
        x: n.x - s.width,
        y: B
      };
      break;
    default:
      h = {
        x: n.x,
        y: n.y
      };
  }
  switch (Ar(e)) {
    case "start":
      h[i] -= g * (A && c ? -1 : 1);
      break;
    case "end":
      h[i] += g * (A && c ? -1 : 1);
      break;
  }
  return h;
}
async function lW(t, e) {
  var A;
  e === void 0 && (e = {});
  const {
    x: n,
    y: s,
    platform: r,
    rects: i,
    elements: o,
    strategy: a
  } = t, {
    boundary: c = "clippingAncestors",
    rootBoundary: l = "viewport",
    elementContext: B = "floating",
    altBoundary: g = !1,
    padding: h = 0
  } = eo(e, t), u = fp(h), w = o[g ? B === "floating" ? "reference" : "floating" : B], Q = Yl(await r.getClippingRect({
    element: (A = await (r.isElement == null ? void 0 : r.isElement(w))) == null || A ? w : w.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(o.floating)),
    boundary: c,
    rootBoundary: l,
    strategy: a
  })), p = B === "floating" ? {
    x: n,
    y: s,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, M = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(o.floating)), I = await (r.isElement == null ? void 0 : r.isElement(M)) ? await (r.getScale == null ? void 0 : r.getScale(M)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, N = Yl(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: o,
    rect: p,
    offsetParent: M,
    strategy: a
  }) : p);
  return {
    top: (Q.top - N.top + u.top) / I.y,
    bottom: (N.bottom - Q.bottom + u.bottom) / I.y,
    left: (Q.left - N.left + u.left) / I.x,
    right: (N.right - Q.right + u.right) / I.x
  };
}
const BW = async (t, e, A) => {
  const {
    placement: n = "bottom",
    strategy: s = "absolute",
    middleware: r = [],
    platform: i
  } = A, o = r.filter(Boolean), a = await (i.isRTL == null ? void 0 : i.isRTL(e));
  let c = await i.getElementRects({
    reference: t,
    floating: e,
    strategy: s
  }), {
    x: l,
    y: B
  } = n1(c, n, a), g = n, h = {}, u = 0;
  for (let w = 0; w < o.length; w++) {
    var d;
    const {
      name: Q,
      fn: p
    } = o[w], {
      x: M,
      y: I,
      data: N,
      reset: m
    } = await p({
      x: l,
      y: B,
      initialPlacement: n,
      placement: g,
      strategy: s,
      middlewareData: h,
      rects: c,
      platform: {
        ...i,
        detectOverflow: (d = i.detectOverflow) != null ? d : lW
      },
      elements: {
        reference: t,
        floating: e
      }
    });
    l = M ?? l, B = I ?? B, h = {
      ...h,
      [Q]: {
        ...h[Q],
        ...N
      }
    }, m && u <= 50 && (u++, typeof m == "object" && (m.placement && (g = m.placement), m.rects && (c = m.rects === !0 ? await i.getElementRects({
      reference: t,
      floating: e,
      strategy: s
    }) : m.rects), {
      x: l,
      y: B
    } = n1(c, g, a)), w = -1);
  }
  return {
    x: l,
    y: B,
    placement: g,
    strategy: s,
    middlewareData: h
  };
}, gW = (t) => ({
  name: "arrow",
  options: t,
  async fn(e) {
    const {
      x: A,
      y: n,
      placement: s,
      rects: r,
      platform: i,
      elements: o,
      middlewareData: a
    } = e, {
      element: c,
      padding: l = 0
    } = eo(t, e) || {};
    if (c == null)
      return {};
    const B = fp(l), g = {
      x: A,
      y: n
    }, h = wp(s), u = dp(h), d = await i.getDimensions(c), w = h === "y", Q = w ? "top" : "left", p = w ? "bottom" : "right", M = w ? "clientHeight" : "clientWidth", I = r.reference[u] + r.reference[h] - g[h] - r.floating[u], N = g[h] - r.reference[h], m = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let E = m ? m[M] : 0;
    (!E || !await (i.isElement == null ? void 0 : i.isElement(m))) && (E = o.floating[M] || r.floating[u]);
    const G = I / 2 - N / 2, Y = E / 2 - d[u] / 2 - 1, U = Tr(B[Q], Y), v = Tr(B[p], Y), b = U, W = E - d[u] - v, q = E / 2 - d[u] / 2 + G, ne = KC(b, q, W), V = !a.arrow && Ar(s) != null && q !== ne && r.reference[u] / 2 - (q < b ? U : v) - d[u] / 2 < 0, se = V ? q < b ? q - b : q - W : 0;
    return {
      [h]: g[h] + se,
      data: {
        [h]: ne,
        centerOffset: q - ne - se,
        ...V && {
          alignmentOffset: se
        }
      },
      reset: V
    };
  }
});
function hW(t, e, A) {
  return (t ? [...A.filter((s) => Ar(s) === t), ...A.filter((s) => Ar(s) !== t)] : A.filter((s) => Ls(s) === s)).filter((s) => t ? Ar(s) === t || (e ? Ou(s) !== s : !1) : !0);
}
const uW = function(t) {
  return t === void 0 && (t = {}), {
    name: "autoPlacement",
    options: t,
    async fn(e) {
      var A, n, s;
      const {
        rects: r,
        middlewareData: i,
        placement: o,
        platform: a,
        elements: c
      } = e, {
        crossAxis: l = !1,
        alignment: B,
        allowedPlacements: g = e1,
        autoAlignment: h = !0,
        ...u
      } = eo(t, e), d = B !== void 0 || g === e1 ? hW(B || null, h, g) : g, w = await a.detectOverflow(e, u), Q = ((A = i.autoPlacement) == null ? void 0 : A.index) || 0, p = d[Q];
      if (p == null)
        return {};
      const M = WG(p, r, await (a.isRTL == null ? void 0 : a.isRTL(c.floating)));
      if (o !== p)
        return {
          reset: {
            placement: d[0]
          }
        };
      const I = [w[Ls(p)], w[M[0]], w[M[1]]], N = [...((n = i.autoPlacement) == null ? void 0 : n.overflows) || [], {
        placement: p,
        overflows: I
      }], m = d[Q + 1];
      if (m)
        return {
          data: {
            index: Q + 1,
            overflows: N
          },
          reset: {
            placement: m
          }
        };
      const E = N.map((U) => {
        const v = Ar(U.placement);
        return [U.placement, v && l ? (
          // Check along the mainAxis and main crossAxis side.
          U.overflows.slice(0, 2).reduce((b, W) => b + W, 0)
        ) : (
          // Check only the mainAxis.
          U.overflows[0]
        ), U.overflows];
      }).sort((U, v) => U[1] - v[1]), Y = ((s = E.filter((U) => U[2].slice(
        0,
        // Aligned placements should not check their opposite crossAxis
        // side.
        Ar(U[0]) ? 2 : 3
      ).every((v) => v <= 0))[0]) == null ? void 0 : s[0]) || E[0][0];
      return Y !== o ? {
        data: {
          index: Q + 1,
          overflows: N
        },
        reset: {
          placement: Y
        }
      } : {};
    }
  };
}, dW = function(t) {
  return t === void 0 && (t = {}), {
    name: "flip",
    options: t,
    async fn(e) {
      var A, n;
      const {
        placement: s,
        middlewareData: r,
        rects: i,
        initialPlacement: o,
        platform: a,
        elements: c
      } = e, {
        mainAxis: l = !0,
        crossAxis: B = !0,
        fallbackPlacements: g,
        fallbackStrategy: h = "bestFit",
        fallbackAxisSideDirection: u = "none",
        flipAlignment: d = !0,
        ...w
      } = eo(t, e);
      if ((A = r.arrow) != null && A.alignmentOffset)
        return {};
      const Q = Ls(s), p = Nr(o), M = Ls(o) === o, I = await (a.isRTL == null ? void 0 : a.isRTL(c.floating)), N = g || (M || !d ? [Pu(o)] : sW(o)), m = u !== "none";
      !g && m && N.push(...aW(o, d, u, I));
      const E = [o, ...N], G = await a.detectOverflow(e, w), Y = [];
      let U = ((n = r.flip) == null ? void 0 : n.overflows) || [];
      if (l && Y.push(G[Q]), B) {
        const q = WG(s, i, I);
        Y.push(G[q[0]], G[q[1]]);
      }
      if (U = [...U, {
        placement: s,
        overflows: Y
      }], !Y.every((q) => q <= 0)) {
        var v, b;
        const q = (((v = r.flip) == null ? void 0 : v.index) || 0) + 1, ne = E[q];
        if (ne && (!(B === "alignment" ? p !== Nr(ne) : !1) || // We leave the current main axis only if every placement on that axis
        // overflows the main axis.
        U.every((te) => Nr(te.placement) === p ? te.overflows[0] > 0 : !0)))
          return {
            data: {
              index: q,
              overflows: U
            },
            reset: {
              placement: ne
            }
          };
        let V = (b = U.filter((se) => se.overflows[0] <= 0).sort((se, te) => se.overflows[1] - te.overflows[1])[0]) == null ? void 0 : b.placement;
        if (!V)
          switch (h) {
            case "bestFit": {
              var W;
              const se = (W = U.filter((te) => {
                if (m) {
                  const be = Nr(te.placement);
                  return be === p || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  be === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((be) => be > 0).reduce((be, Oe) => be + Oe, 0)]).sort((te, be) => te[1] - be[1])[0]) == null ? void 0 : W[0];
              se && (V = se);
              break;
            }
            case "initialPlacement":
              V = o;
              break;
          }
        if (s !== V)
          return {
            reset: {
              placement: V
            }
          };
      }
      return {};
    }
  };
};
function s1(t, e) {
  return {
    top: t.top - e.height,
    right: t.right - e.width,
    bottom: t.bottom - e.height,
    left: t.left - e.width
  };
}
function r1(t) {
  return TG.some((e) => t[e] >= 0);
}
const wW = function(t) {
  return t === void 0 && (t = {}), {
    name: "hide",
    options: t,
    async fn(e) {
      const {
        rects: A,
        platform: n
      } = e, {
        strategy: s = "referenceHidden",
        ...r
      } = eo(t, e);
      switch (s) {
        case "referenceHidden": {
          const i = await n.detectOverflow(e, {
            ...r,
            elementContext: "reference"
          }), o = s1(i, A.reference);
          return {
            data: {
              referenceHiddenOffsets: o,
              referenceHidden: r1(o)
            }
          };
        }
        case "escaped": {
          const i = await n.detectOverflow(e, {
            ...r,
            altBoundary: !0
          }), o = s1(i, A.floating);
          return {
            data: {
              escapedOffsets: o,
              escaped: r1(o)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
function OG(t) {
  const e = Tr(...t.map((r) => r.left)), A = Tr(...t.map((r) => r.top)), n = yn(...t.map((r) => r.right)), s = yn(...t.map((r) => r.bottom));
  return {
    x: e,
    y: A,
    width: n - e,
    height: s - A
  };
}
function fW(t) {
  const e = t.slice().sort((s, r) => s.y - r.y), A = [];
  let n = null;
  for (let s = 0; s < e.length; s++) {
    const r = e[s];
    !n || r.y - n.y > n.height / 2 ? A.push([r]) : A[A.length - 1].push(r), n = r;
  }
  return A.map((s) => Yl(OG(s)));
}
const QW = function(t) {
  return t === void 0 && (t = {}), {
    name: "inline",
    options: t,
    async fn(e) {
      const {
        placement: A,
        elements: n,
        rects: s,
        platform: r,
        strategy: i
      } = e, {
        padding: o = 2,
        x: a,
        y: c
      } = eo(t, e), l = Array.from(await (r.getClientRects == null ? void 0 : r.getClientRects(n.reference)) || []), B = fW(l), g = Yl(OG(l)), h = fp(o);
      function u() {
        if (B.length === 2 && B[0].left > B[1].right && a != null && c != null)
          return B.find((w) => a > w.left - h.left && a < w.right + h.right && c > w.top - h.top && c < w.bottom + h.bottom) || g;
        if (B.length >= 2) {
          if (Nr(A) === "y") {
            const U = B[0], v = B[B.length - 1], b = Ls(A) === "top", W = U.top, q = v.bottom, ne = b ? U.left : v.left, V = b ? U.right : v.right, se = V - ne, te = q - W;
            return {
              top: W,
              bottom: q,
              left: ne,
              right: V,
              width: se,
              height: te,
              x: ne,
              y: W
            };
          }
          const w = Ls(A) === "left", Q = yn(...B.map((U) => U.right)), p = Tr(...B.map((U) => U.left)), M = B.filter((U) => w ? U.left === p : U.right === Q), I = M[0].top, N = M[M.length - 1].bottom, m = p, E = Q, G = E - m, Y = N - I;
          return {
            top: I,
            bottom: N,
            left: m,
            right: E,
            width: G,
            height: Y,
            x: m,
            y: I
          };
        }
        return g;
      }
      const d = await r.getElementRects({
        reference: {
          getBoundingClientRect: u
        },
        floating: n.floating,
        strategy: i
      });
      return s.reference.x !== d.reference.x || s.reference.y !== d.reference.y || s.reference.width !== d.reference.width || s.reference.height !== d.reference.height ? {
        reset: {
          rects: d
        }
      } : {};
    }
  };
}, IW = /* @__PURE__ */ new Set(["left", "top"]);
async function CW(t, e) {
  const {
    placement: A,
    platform: n,
    elements: s
  } = t, r = await (n.isRTL == null ? void 0 : n.isRTL(s.floating)), i = Ls(A), o = Ar(A), a = Nr(A) === "y", c = IW.has(i) ? -1 : 1, l = r && a ? -1 : 1, B = eo(e, t);
  let {
    mainAxis: g,
    crossAxis: h,
    alignmentAxis: u
  } = typeof B == "number" ? {
    mainAxis: B,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: B.mainAxis || 0,
    crossAxis: B.crossAxis || 0,
    alignmentAxis: B.alignmentAxis
  };
  return o && typeof u == "number" && (h = o === "end" ? u * -1 : u), a ? {
    x: h * l,
    y: g * c
  } : {
    x: g * c,
    y: h * l
  };
}
const EW = function(t) {
  return t === void 0 && (t = 0), {
    name: "offset",
    options: t,
    async fn(e) {
      var A, n;
      const {
        x: s,
        y: r,
        placement: i,
        middlewareData: o
      } = e, a = await CW(e, t);
      return i === ((A = o.offset) == null ? void 0 : A.placement) && (n = o.arrow) != null && n.alignmentOffset ? {} : {
        x: s + a.x,
        y: r + a.y,
        data: {
          ...a,
          placement: i
        }
      };
    }
  };
}, MW = function(t) {
  return t === void 0 && (t = {}), {
    name: "shift",
    options: t,
    async fn(e) {
      const {
        x: A,
        y: n,
        placement: s,
        platform: r
      } = e, {
        mainAxis: i = !0,
        crossAxis: o = !1,
        limiter: a = {
          fn: (Q) => {
            let {
              x: p,
              y: M
            } = Q;
            return {
              x: p,
              y: M
            };
          }
        },
        ...c
      } = eo(t, e), l = {
        x: A,
        y: n
      }, B = await r.detectOverflow(e, c), g = Nr(Ls(s)), h = JG(g);
      let u = l[h], d = l[g];
      if (i) {
        const Q = h === "y" ? "top" : "left", p = h === "y" ? "bottom" : "right", M = u + B[Q], I = u - B[p];
        u = KC(M, u, I);
      }
      if (o) {
        const Q = g === "y" ? "top" : "left", p = g === "y" ? "bottom" : "right", M = d + B[Q], I = d - B[p];
        d = KC(M, d, I);
      }
      const w = a.fn({
        ...e,
        [h]: u,
        [g]: d
      });
      return {
        ...w,
        data: {
          x: w.x - A,
          y: w.y - n,
          enabled: {
            [h]: i,
            [g]: o
          }
        }
      };
    }
  };
}, pW = function(t) {
  return t === void 0 && (t = {}), {
    name: "size",
    options: t,
    async fn(e) {
      var A, n;
      const {
        placement: s,
        rects: r,
        platform: i,
        elements: o
      } = e, {
        apply: a = () => {
        },
        ...c
      } = eo(t, e), l = await i.detectOverflow(e, c), B = Ls(s), g = Ar(s), h = Nr(s) === "y", {
        width: u,
        height: d
      } = r.floating;
      let w, Q;
      B === "top" || B === "bottom" ? (w = B, Q = g === (await (i.isRTL == null ? void 0 : i.isRTL(o.floating)) ? "start" : "end") ? "left" : "right") : (Q = B, w = g === "end" ? "top" : "bottom");
      const p = d - l.top - l.bottom, M = u - l.left - l.right, I = Tr(d - l[w], p), N = Tr(u - l[Q], M), m = !e.middlewareData.shift;
      let E = I, G = N;
      if ((A = e.middlewareData.shift) != null && A.enabled.x && (G = M), (n = e.middlewareData.shift) != null && n.enabled.y && (E = p), m && !g) {
        const U = yn(l.left, 0), v = yn(l.right, 0), b = yn(l.top, 0), W = yn(l.bottom, 0);
        h ? G = u - 2 * (U !== 0 || v !== 0 ? U + v : yn(l.left, l.right)) : E = d - 2 * (b !== 0 || W !== 0 ? b + W : yn(l.top, l.bottom));
      }
      await a({
        ...e,
        availableWidth: G,
        availableHeight: E
      });
      const Y = await i.getDimensions(o.floating);
      return u !== Y.width || d !== Y.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function vw() {
  return typeof window < "u";
}
function Tl(t) {
  return PG(t) ? (t.nodeName || "").toLowerCase() : "#document";
}
function us(t) {
  var e;
  return (t == null || (e = t.ownerDocument) == null ? void 0 : e.defaultView) || window;
}
function to(t) {
  var e;
  return (e = (PG(t) ? t.ownerDocument : t.document) || window.document) == null ? void 0 : e.documentElement;
}
function PG(t) {
  return vw() ? t instanceof Node || t instanceof us(t).Node : !1;
}
function ir(t) {
  return vw() ? t instanceof Element || t instanceof us(t).Element : !1;
}
function Jr(t) {
  return vw() ? t instanceof HTMLElement || t instanceof us(t).HTMLElement : !1;
}
function i1(t) {
  return !vw() || typeof ShadowRoot > "u" ? !1 : t instanceof ShadowRoot || t instanceof us(t).ShadowRoot;
}
const mW = /* @__PURE__ */ new Set(["inline", "contents"]);
function uh(t) {
  const {
    overflow: e,
    overflowX: A,
    overflowY: n,
    display: s
  } = or(t);
  return /auto|scroll|overlay|hidden|clip/.test(e + n + A) && !mW.has(s);
}
const YW = /* @__PURE__ */ new Set(["table", "td", "th"]);
function yW(t) {
  return YW.has(Tl(t));
}
const FW = [":popover-open", ":modal"];
function jw(t) {
  return FW.some((e) => {
    try {
      return t.matches(e);
    } catch {
      return !1;
    }
  });
}
const NW = ["transform", "translate", "scale", "rotate", "perspective"], DW = ["transform", "translate", "scale", "rotate", "perspective", "filter"], xW = ["paint", "layout", "strict", "content"];
function Qp(t) {
  const e = Ip(), A = ir(t) ? or(t) : t;
  return NW.some((n) => A[n] ? A[n] !== "none" : !1) || (A.containerType ? A.containerType !== "normal" : !1) || !e && (A.backdropFilter ? A.backdropFilter !== "none" : !1) || !e && (A.filter ? A.filter !== "none" : !1) || DW.some((n) => (A.willChange || "").includes(n)) || xW.some((n) => (A.contain || "").includes(n));
}
function GW(t) {
  let e = Zo(t);
  for (; Jr(e) && !yl(e); ) {
    if (Qp(e))
      return e;
    if (jw(e))
      return null;
    e = Zo(e);
  }
  return null;
}
function Ip() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
const zW = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function yl(t) {
  return zW.has(Tl(t));
}
function or(t) {
  return us(t).getComputedStyle(t);
}
function Hw(t) {
  return ir(t) ? {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  } : {
    scrollLeft: t.scrollX,
    scrollTop: t.scrollY
  };
}
function Zo(t) {
  if (Tl(t) === "html")
    return t;
  const e = (
    // Step into the shadow DOM of the parent of a slotted node.
    t.assignedSlot || // DOM Element detected.
    t.parentNode || // ShadowRoot detected.
    i1(t) && t.host || // Fallback.
    to(t)
  );
  return i1(e) ? e.host : e;
}
function KG(t) {
  const e = Zo(t);
  return yl(e) ? t.ownerDocument ? t.ownerDocument.body : t.body : Jr(e) && uh(e) ? e : KG(e);
}
function VG(t, e, A) {
  var n;
  e === void 0 && (e = []);
  const s = KG(t), r = s === ((n = t.ownerDocument) == null ? void 0 : n.body), i = us(s);
  return r ? (VC(i), e.concat(i, i.visualViewport || [], uh(s) ? s : [], [])) : e.concat(s, VG(s, []));
}
function VC(t) {
  return t.parent && Object.getPrototypeOf(t.parent) ? t.frameElement : null;
}
function XG(t) {
  const e = or(t);
  let A = parseFloat(e.width) || 0, n = parseFloat(e.height) || 0;
  const s = Jr(t), r = s ? t.offsetWidth : A, i = s ? t.offsetHeight : n, o = Wu(A) !== r || Wu(n) !== i;
  return o && (A = r, n = i), {
    width: A,
    height: n,
    $: o
  };
}
function ZG(t) {
  return ir(t) ? t : t.contextElement;
}
function ol(t) {
  const e = ZG(t);
  if (!Jr(e))
    return vr(1);
  const A = e.getBoundingClientRect(), {
    width: n,
    height: s,
    $: r
  } = XG(e);
  let i = (r ? Wu(A.width) : A.width) / n, o = (r ? Wu(A.height) : A.height) / s;
  return (!i || !Number.isFinite(i)) && (i = 1), (!o || !Number.isFinite(o)) && (o = 1), {
    x: i,
    y: o
  };
}
const UW = /* @__PURE__ */ vr(0);
function qG(t) {
  const e = us(t);
  return !Ip() || !e.visualViewport ? UW : {
    x: e.visualViewport.offsetLeft,
    y: e.visualViewport.offsetTop
  };
}
function bW(t, e, A) {
  return e === void 0 && (e = !1), !A || e && A !== us(t) ? !1 : e;
}
function xg(t, e, A, n) {
  e === void 0 && (e = !1), A === void 0 && (A = !1);
  const s = t.getBoundingClientRect(), r = ZG(t);
  let i = vr(1);
  e && (n ? ir(n) && (i = ol(n)) : i = ol(t));
  const o = bW(r, A, n) ? qG(r) : vr(0);
  let a = (s.left + o.x) / i.x, c = (s.top + o.y) / i.y, l = s.width / i.x, B = s.height / i.y;
  if (r) {
    const g = us(r), h = n && ir(n) ? us(n) : n;
    let u = g, d = VC(u);
    for (; d && n && h !== u; ) {
      const w = ol(d), Q = d.getBoundingClientRect(), p = or(d), M = Q.left + (d.clientLeft + parseFloat(p.paddingLeft)) * w.x, I = Q.top + (d.clientTop + parseFloat(p.paddingTop)) * w.y;
      a *= w.x, c *= w.y, l *= w.x, B *= w.y, a += M, c += I, u = us(d), d = VC(u);
    }
  }
  return Yl({
    width: l,
    height: B,
    x: a,
    y: c
  });
}
function kw(t, e) {
  const A = Hw(t).scrollLeft;
  return e ? e.left + A : xg(to(t)).left + A;
}
function _G(t, e) {
  const A = t.getBoundingClientRect(), n = A.left + e.scrollLeft - kw(t, A), s = A.top + e.scrollTop;
  return {
    x: n,
    y: s
  };
}
function vW(t) {
  let {
    elements: e,
    rect: A,
    offsetParent: n,
    strategy: s
  } = t;
  const r = s === "fixed", i = to(n), o = e ? jw(e.floating) : !1;
  if (n === i || o && r)
    return A;
  let a = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = vr(1);
  const l = vr(0), B = Jr(n);
  if ((B || !B && !r) && ((Tl(n) !== "body" || uh(i)) && (a = Hw(n)), Jr(n))) {
    const h = xg(n);
    c = ol(n), l.x = h.x + n.clientLeft, l.y = h.y + n.clientTop;
  }
  const g = i && !B && !r ? _G(i, a) : vr(0);
  return {
    width: A.width * c.x,
    height: A.height * c.y,
    x: A.x * c.x - a.scrollLeft * c.x + l.x + g.x,
    y: A.y * c.y - a.scrollTop * c.y + l.y + g.y
  };
}
function jW(t) {
  return Array.from(t.getClientRects());
}
function HW(t) {
  const e = to(t), A = Hw(t), n = t.ownerDocument.body, s = yn(e.scrollWidth, e.clientWidth, n.scrollWidth, n.clientWidth), r = yn(e.scrollHeight, e.clientHeight, n.scrollHeight, n.clientHeight);
  let i = -A.scrollLeft + kw(t);
  const o = -A.scrollTop;
  return or(n).direction === "rtl" && (i += yn(e.clientWidth, n.clientWidth) - s), {
    width: s,
    height: r,
    x: i,
    y: o
  };
}
const o1 = 25;
function kW(t, e) {
  const A = us(t), n = to(t), s = A.visualViewport;
  let r = n.clientWidth, i = n.clientHeight, o = 0, a = 0;
  if (s) {
    r = s.width, i = s.height;
    const l = Ip();
    (!l || l && e === "fixed") && (o = s.offsetLeft, a = s.offsetTop);
  }
  const c = kw(n);
  if (c <= 0) {
    const l = n.ownerDocument, B = l.body, g = getComputedStyle(B), h = l.compatMode === "CSS1Compat" && parseFloat(g.marginLeft) + parseFloat(g.marginRight) || 0, u = Math.abs(n.clientWidth - B.clientWidth - h);
    u <= o1 && (r -= u);
  } else c <= o1 && (r += c);
  return {
    width: r,
    height: i,
    x: o,
    y: a
  };
}
const RW = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function LW(t, e) {
  const A = xg(t, !0, e === "fixed"), n = A.top + t.clientTop, s = A.left + t.clientLeft, r = Jr(t) ? ol(t) : vr(1), i = t.clientWidth * r.x, o = t.clientHeight * r.y, a = s * r.x, c = n * r.y;
  return {
    width: i,
    height: o,
    x: a,
    y: c
  };
}
function a1(t, e, A) {
  let n;
  if (e === "viewport")
    n = kW(t, A);
  else if (e === "document")
    n = HW(to(t));
  else if (ir(e))
    n = LW(e, A);
  else {
    const s = qG(t);
    n = {
      x: e.x - s.x,
      y: e.y - s.y,
      width: e.width,
      height: e.height
    };
  }
  return Yl(n);
}
function $G(t, e) {
  const A = Zo(t);
  return A === e || !ir(A) || yl(A) ? !1 : or(A).position === "fixed" || $G(A, e);
}
function SW(t, e) {
  const A = e.get(t);
  if (A)
    return A;
  let n = VG(t, []).filter((o) => ir(o) && Tl(o) !== "body"), s = null;
  const r = or(t).position === "fixed";
  let i = r ? Zo(t) : t;
  for (; ir(i) && !yl(i); ) {
    const o = or(i), a = Qp(i);
    !a && o.position === "fixed" && (s = null), (r ? !a && !s : !a && o.position === "static" && !!s && RW.has(s.position) || uh(i) && !a && $G(t, i)) ? n = n.filter((l) => l !== i) : s = o, i = Zo(i);
  }
  return e.set(t, n), n;
}
function TW(t) {
  let {
    element: e,
    boundary: A,
    rootBoundary: n,
    strategy: s
  } = t;
  const i = [...A === "clippingAncestors" ? jw(e) ? [] : SW(e, this._c) : [].concat(A), n], o = i[0], a = i.reduce((c, l) => {
    const B = a1(e, l, s);
    return c.top = yn(B.top, c.top), c.right = Tr(B.right, c.right), c.bottom = Tr(B.bottom, c.bottom), c.left = yn(B.left, c.left), c;
  }, a1(e, o, s));
  return {
    width: a.right - a.left,
    height: a.bottom - a.top,
    x: a.left,
    y: a.top
  };
}
function JW(t) {
  const {
    width: e,
    height: A
  } = XG(t);
  return {
    width: e,
    height: A
  };
}
function WW(t, e, A) {
  const n = Jr(e), s = to(e), r = A === "fixed", i = xg(t, !0, r, e);
  let o = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const a = vr(0);
  function c() {
    a.x = kw(s);
  }
  if (n || !n && !r)
    if ((Tl(e) !== "body" || uh(s)) && (o = Hw(e)), n) {
      const h = xg(e, !0, r, e);
      a.x = h.x + e.clientLeft, a.y = h.y + e.clientTop;
    } else s && c();
  r && !n && s && c();
  const l = s && !n && !r ? _G(s, o) : vr(0), B = i.left + o.scrollLeft - a.x - l.x, g = i.top + o.scrollTop - a.y - l.y;
  return {
    x: B,
    y: g,
    width: i.width,
    height: i.height
  };
}
function zQ(t) {
  return or(t).position === "static";
}
function c1(t, e) {
  if (!Jr(t) || or(t).position === "fixed")
    return null;
  if (e)
    return e(t);
  let A = t.offsetParent;
  return to(t) === A && (A = A.ownerDocument.body), A;
}
function ez(t, e) {
  const A = us(t);
  if (jw(t))
    return A;
  if (!Jr(t)) {
    let s = Zo(t);
    for (; s && !yl(s); ) {
      if (ir(s) && !zQ(s))
        return s;
      s = Zo(s);
    }
    return A;
  }
  let n = c1(t, e);
  for (; n && yW(n) && zQ(n); )
    n = c1(n, e);
  return n && yl(n) && zQ(n) && !Qp(n) ? A : n || GW(t) || A;
}
const OW = async function(t) {
  const e = this.getOffsetParent || ez, A = this.getDimensions, n = await A(t.floating);
  return {
    reference: WW(t.reference, await e(t.floating), t.strategy),
    floating: {
      x: 0,
      y: 0,
      width: n.width,
      height: n.height
    }
  };
};
function PW(t) {
  return or(t).direction === "rtl";
}
const KW = {
  convertOffsetParentRelativeRectToViewportRelativeRect: vW,
  getDocumentElement: to,
  getClippingRect: TW,
  getOffsetParent: ez,
  getElementRects: OW,
  getClientRects: jW,
  getDimensions: JW,
  getScale: ol,
  isElement: ir,
  isRTL: PW
}, VW = EW, XW = uW, ZW = MW, qW = dW, _W = pW, $W = wW, eO = gW, tO = QW, tz = (t, e, A) => {
  const n = /* @__PURE__ */ new Map(), s = {
    platform: KW,
    ...A
  }, r = {
    ...s.platform,
    _c: n
  };
  return BW(t, e, {
    ...s,
    platform: r
  });
};
let XC, ZC;
if (typeof WeakMap < "u") {
  let t = /* @__PURE__ */ new WeakMap();
  XC = (e) => t.get(e), ZC = (e, A) => (t.set(e, A), A);
} else {
  const t = [];
  let A = 0;
  XC = (n) => {
    for (let s = 0; s < t.length; s += 2) if (t[s] == n) return t[s + 1];
  }, ZC = (n, s) => (A == 10 && (A = 0), t[A++] = n, t[A++] = s);
}
var BA = class {
  constructor(t, e, A, n) {
    this.width = t, this.height = e, this.map = A, this.problems = n;
  }
  findCell(t) {
    for (let e = 0; e < this.map.length; e++) {
      const A = this.map[e];
      if (A != t) continue;
      const n = e % this.width, s = e / this.width | 0;
      let r = n + 1, i = s + 1;
      for (let o = 1; r < this.width && this.map[e + o] == A; o++) r++;
      for (let o = 1; i < this.height && this.map[e + this.width * o] == A; o++) i++;
      return {
        left: n,
        top: s,
        right: r,
        bottom: i
      };
    }
    throw new RangeError(`No cell with offset ${t} found`);
  }
  colCount(t) {
    for (let e = 0; e < this.map.length; e++) if (this.map[e] == t) return e % this.width;
    throw new RangeError(`No cell with offset ${t} found`);
  }
  nextCell(t, e, A) {
    const { left: n, right: s, top: r, bottom: i } = this.findCell(t);
    return e == "horiz" ? (A < 0 ? n == 0 : s == this.width) ? null : this.map[r * this.width + (A < 0 ? n - 1 : s)] : (A < 0 ? r == 0 : i == this.height) ? null : this.map[n + this.width * (A < 0 ? r - 1 : i)];
  }
  rectBetween(t, e) {
    const { left: A, right: n, top: s, bottom: r } = this.findCell(t), { left: i, right: o, top: a, bottom: c } = this.findCell(e);
    return {
      left: Math.min(A, i),
      top: Math.min(s, a),
      right: Math.max(n, o),
      bottom: Math.max(r, c)
    };
  }
  cellsInRect(t) {
    const e = [], A = {};
    for (let n = t.top; n < t.bottom; n++) for (let s = t.left; s < t.right; s++) {
      const r = n * this.width + s, i = this.map[r];
      A[i] || (A[i] = !0, !(s == t.left && s && this.map[r - 1] == i || n == t.top && n && this.map[r - this.width] == i) && e.push(i));
    }
    return e;
  }
  positionAt(t, e, A) {
    for (let n = 0, s = 0; ; n++) {
      const r = s + A.child(n).nodeSize;
      if (n == t) {
        let i = e + t * this.width;
        const o = (t + 1) * this.width;
        for (; i < o && this.map[i] < s; ) i++;
        return i == o ? r - 1 : this.map[i];
      }
      s = r;
    }
  }
  static get(t) {
    return XC(t) || ZC(t, AO(t));
  }
};
function AO(t) {
  if (t.type.spec.tableRole != "table") throw new RangeError("Not a table node: " + t.type.name);
  const e = nO(t), A = t.childCount, n = [];
  let s = 0, r = null;
  const i = [];
  for (let c = 0, l = e * A; c < l; c++) n[c] = 0;
  for (let c = 0, l = 0; c < A; c++) {
    const B = t.child(c);
    l++;
    for (let u = 0; ; u++) {
      for (; s < n.length && n[s] != 0; ) s++;
      if (u == B.childCount) break;
      const d = B.child(u), { colspan: w, rowspan: Q, colwidth: p } = d.attrs;
      for (let M = 0; M < Q; M++) {
        if (M + c >= A) {
          (r || (r = [])).push({
            type: "overlong_rowspan",
            pos: l,
            n: Q - M
          });
          break;
        }
        const I = s + M * e;
        for (let N = 0; N < w; N++) {
          n[I + N] == 0 ? n[I + N] = l : (r || (r = [])).push({
            type: "collision",
            row: c,
            pos: l,
            n: w - N
          });
          const m = p && p[N];
          if (m) {
            const E = (I + N) % e * 2, G = i[E];
            G == null || G != m && i[E + 1] == 1 ? (i[E] = m, i[E + 1] = 1) : G == m && i[E + 1]++;
          }
        }
      }
      s += w, l += d.nodeSize;
    }
    const g = (c + 1) * e;
    let h = 0;
    for (; s < g; ) n[s++] == 0 && h++;
    h && (r || (r = [])).push({
      type: "missing",
      row: c,
      n: h
    }), l++;
  }
  (e === 0 || A === 0) && (r || (r = [])).push({ type: "zero_sized" });
  const o = new BA(e, A, n, r);
  let a = !1;
  for (let c = 0; !a && c < i.length; c += 2) i[c] != null && i[c + 1] < A && (a = !0);
  return a && sO(o, i, t), o;
}
function nO(t) {
  let e = -1, A = !1;
  for (let n = 0; n < t.childCount; n++) {
    const s = t.child(n);
    let r = 0;
    if (A) for (let i = 0; i < n; i++) {
      const o = t.child(i);
      for (let a = 0; a < o.childCount; a++) {
        const c = o.child(a);
        i + c.attrs.rowspan > n && (r += c.attrs.colspan);
      }
    }
    for (let i = 0; i < s.childCount; i++) {
      const o = s.child(i);
      r += o.attrs.colspan, o.attrs.rowspan > 1 && (A = !0);
    }
    e == -1 ? e = r : e != r && (e = Math.max(e, r));
  }
  return e;
}
function sO(t, e, A) {
  t.problems || (t.problems = []);
  const n = {};
  for (let s = 0; s < t.map.length; s++) {
    const r = t.map[s];
    if (n[r]) continue;
    n[r] = !0;
    const i = A.nodeAt(r);
    if (!i) throw new RangeError(`No cell with offset ${r} found`);
    let o = null;
    const a = i.attrs;
    for (let c = 0; c < a.colspan; c++) {
      const l = e[(s + c) % t.width * 2];
      l != null && (!a.colwidth || a.colwidth[c] != l) && ((o || (o = rO(a)))[c] = l);
    }
    o && t.problems.unshift({
      type: "colwidth mismatch",
      pos: r,
      colwidth: o
    });
  }
}
function rO(t) {
  if (t.colwidth) return t.colwidth.slice();
  const e = [];
  for (let A = 0; A < t.colspan; A++) e.push(0);
  return e;
}
function cn(t) {
  let e = t.cached.tableNodeTypes;
  if (!e) {
    e = t.cached.tableNodeTypes = {};
    for (const A in t.nodes) {
      const n = t.nodes[A], s = n.spec.tableRole;
      s && (e[s] = n);
    }
  }
  return e;
}
const Fo = new Bt("selectingCells");
function $a(t) {
  for (let e = t.depth - 1; e > 0; e--) if (t.node(e).type.spec.tableRole == "row") return t.node(0).resolve(t.before(e + 1));
  return null;
}
function iO(t) {
  for (let e = t.depth; e > 0; e--) {
    const A = t.node(e).type.spec.tableRole;
    if (A === "cell" || A === "header_cell") return t.node(e);
  }
  return null;
}
function gr(t) {
  const e = t.selection.$head;
  for (let A = e.depth; A > 0; A--) if (e.node(A).type.spec.tableRole == "row") return !0;
  return !1;
}
function Rw(t) {
  const e = t.selection;
  if ("$anchorCell" in e && e.$anchorCell) return e.$anchorCell.pos > e.$headCell.pos ? e.$anchorCell : e.$headCell;
  if ("node" in e && e.node && e.node.type.spec.tableRole == "cell") return e.$anchor;
  const A = $a(e.$head) || oO(e.$head);
  if (A) return A;
  throw new RangeError(`No cell found around position ${e.head}`);
}
function oO(t) {
  for (let e = t.nodeAfter, A = t.pos; e; e = e.firstChild, A++) {
    const n = e.type.spec.tableRole;
    if (n == "cell" || n == "header_cell") return t.doc.resolve(A);
  }
  for (let e = t.nodeBefore, A = t.pos; e; e = e.lastChild, A--) {
    const n = e.type.spec.tableRole;
    if (n == "cell" || n == "header_cell") return t.doc.resolve(A - e.nodeSize);
  }
}
function qC(t) {
  return t.parent.type.spec.tableRole == "row" && !!t.nodeAfter;
}
function aO(t) {
  return t.node(0).resolve(t.pos + t.nodeAfter.nodeSize);
}
function Cp(t, e) {
  return t.depth == e.depth && t.pos >= e.start(-1) && t.pos <= e.end(-1);
}
function Az(t, e, A) {
  const n = t.node(-1), s = BA.get(n), r = t.start(-1), i = s.nextCell(t.pos - r, e, A);
  return i == null ? null : t.node(0).resolve(r + i);
}
function ec(t, e, A = 1) {
  const n = {
    ...t,
    colspan: t.colspan - A
  };
  return n.colwidth && (n.colwidth = n.colwidth.slice(), n.colwidth.splice(e, A), n.colwidth.some((s) => s > 0) || (n.colwidth = null)), n;
}
function nz(t, e, A = 1) {
  const n = {
    ...t,
    colspan: t.colspan + A
  };
  if (n.colwidth) {
    n.colwidth = n.colwidth.slice();
    for (let s = 0; s < A; s++) n.colwidth.splice(e, 0, 0);
  }
  return n;
}
function cO(t, e, A) {
  const n = cn(e.type.schema).header_cell;
  for (let s = 0; s < t.height; s++) if (e.nodeAt(t.map[A + s * t.width]).type != n) return !1;
  return !0;
}
var St = class fi extends Ke {
  constructor(e, A = e) {
    const n = e.node(-1), s = BA.get(n), r = e.start(-1), i = s.rectBetween(e.pos - r, A.pos - r), o = e.node(0), a = s.cellsInRect(i).filter((l) => l != A.pos - r);
    a.unshift(A.pos - r);
    const c = a.map((l) => {
      const B = n.nodeAt(l);
      if (!B) throw new RangeError(`No cell with offset ${l} found`);
      const g = r + l + 1;
      return new LM(o.resolve(g), o.resolve(g + B.content.size));
    });
    super(c[0].$from, c[0].$to, c), this.$anchorCell = e, this.$headCell = A;
  }
  map(e, A) {
    const n = e.resolve(A.map(this.$anchorCell.pos)), s = e.resolve(A.map(this.$headCell.pos));
    if (qC(n) && qC(s) && Cp(n, s)) {
      const r = this.$anchorCell.node(-1) != n.node(-1);
      return r && this.isRowSelection() ? fi.rowSelection(n, s) : r && this.isColSelection() ? fi.colSelection(n, s) : new fi(n, s);
    }
    return Re.between(n, s);
  }
  content() {
    const e = this.$anchorCell.node(-1), A = BA.get(e), n = this.$anchorCell.start(-1), s = A.rectBetween(this.$anchorCell.pos - n, this.$headCell.pos - n), r = {}, i = [];
    for (let a = s.top; a < s.bottom; a++) {
      const c = [];
      for (let l = a * A.width + s.left, B = s.left; B < s.right; B++, l++) {
        const g = A.map[l];
        if (r[g]) continue;
        r[g] = !0;
        const h = A.findCell(g);
        let u = e.nodeAt(g);
        if (!u) throw new RangeError(`No cell with offset ${g} found`);
        const d = s.left - h.left, w = h.right - s.right;
        if (d > 0 || w > 0) {
          let Q = u.attrs;
          if (d > 0 && (Q = ec(Q, 0, d)), w > 0 && (Q = ec(Q, Q.colspan - w, w)), h.left < s.left) {
            if (u = u.type.createAndFill(Q), !u) throw new RangeError(`Could not create cell with attrs ${JSON.stringify(Q)}`);
          } else u = u.type.create(Q, u.content);
        }
        if (h.top < s.top || h.bottom > s.bottom) {
          const Q = {
            ...u.attrs,
            rowspan: Math.min(h.bottom, s.bottom) - Math.max(h.top, s.top)
          };
          h.top < s.top ? u = u.type.createAndFill(Q) : u = u.type.create(Q, u.content);
        }
        c.push(u);
      }
      i.push(e.child(a).copy(re.from(c)));
    }
    const o = this.isColSelection() && this.isRowSelection() ? e : i;
    return new Ee(re.from(o), 1, 1);
  }
  replace(e, A = Ee.empty) {
    const n = e.steps.length, s = this.ranges;
    for (let i = 0; i < s.length; i++) {
      const { $from: o, $to: a } = s[i], c = e.mapping.slice(n);
      e.replace(c.map(o.pos), c.map(a.pos), i ? Ee.empty : A);
    }
    const r = Ke.findFrom(e.doc.resolve(e.mapping.slice(n).map(this.to)), -1);
    r && e.setSelection(r);
  }
  replaceWith(e, A) {
    this.replace(e, new Ee(re.from(A), 0, 0));
  }
  forEachCell(e) {
    const A = this.$anchorCell.node(-1), n = BA.get(A), s = this.$anchorCell.start(-1), r = n.cellsInRect(n.rectBetween(this.$anchorCell.pos - s, this.$headCell.pos - s));
    for (let i = 0; i < r.length; i++) e(A.nodeAt(r[i]), s + r[i]);
  }
  isColSelection() {
    const e = this.$anchorCell.index(-1), A = this.$headCell.index(-1);
    if (Math.min(e, A) > 0) return !1;
    const n = e + this.$anchorCell.nodeAfter.attrs.rowspan, s = A + this.$headCell.nodeAfter.attrs.rowspan;
    return Math.max(n, s) == this.$headCell.node(-1).childCount;
  }
  static colSelection(e, A = e) {
    const n = e.node(-1), s = BA.get(n), r = e.start(-1), i = s.findCell(e.pos - r), o = s.findCell(A.pos - r), a = e.node(0);
    return i.top <= o.top ? (i.top > 0 && (e = a.resolve(r + s.map[i.left])), o.bottom < s.height && (A = a.resolve(r + s.map[s.width * (s.height - 1) + o.right - 1]))) : (o.top > 0 && (A = a.resolve(r + s.map[o.left])), i.bottom < s.height && (e = a.resolve(r + s.map[s.width * (s.height - 1) + i.right - 1]))), new fi(e, A);
  }
  isRowSelection() {
    const e = this.$anchorCell.node(-1), A = BA.get(e), n = this.$anchorCell.start(-1), s = A.colCount(this.$anchorCell.pos - n), r = A.colCount(this.$headCell.pos - n);
    if (Math.min(s, r) > 0) return !1;
    const i = s + this.$anchorCell.nodeAfter.attrs.colspan, o = r + this.$headCell.nodeAfter.attrs.colspan;
    return Math.max(i, o) == A.width;
  }
  eq(e) {
    return e instanceof fi && e.$anchorCell.pos == this.$anchorCell.pos && e.$headCell.pos == this.$headCell.pos;
  }
  static rowSelection(e, A = e) {
    const n = e.node(-1), s = BA.get(n), r = e.start(-1), i = s.findCell(e.pos - r), o = s.findCell(A.pos - r), a = e.node(0);
    return i.left <= o.left ? (i.left > 0 && (e = a.resolve(r + s.map[i.top * s.width])), o.right < s.width && (A = a.resolve(r + s.map[s.width * (o.top + 1) - 1]))) : (o.left > 0 && (A = a.resolve(r + s.map[o.top * s.width])), i.right < s.width && (e = a.resolve(r + s.map[s.width * (i.top + 1) - 1]))), new fi(e, A);
  }
  toJSON() {
    return {
      type: "cell",
      anchor: this.$anchorCell.pos,
      head: this.$headCell.pos
    };
  }
  static fromJSON(e, A) {
    return new fi(e.resolve(A.anchor), e.resolve(A.head));
  }
  static create(e, A, n = A) {
    return new fi(e.resolve(A), e.resolve(n));
  }
  getBookmark() {
    return new lO(this.$anchorCell.pos, this.$headCell.pos);
  }
};
St.prototype.visible = !1;
Ke.jsonID("cell", St);
var lO = class sz {
  constructor(e, A) {
    this.anchor = e, this.head = A;
  }
  map(e) {
    return new sz(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const A = e.resolve(this.anchor), n = e.resolve(this.head);
    return A.parent.type.spec.tableRole == "row" && n.parent.type.spec.tableRole == "row" && A.index() < A.parent.childCount && n.index() < n.parent.childCount && Cp(A, n) ? new St(A, n) : Ke.near(n, 1);
  }
};
function BO(t) {
  if (!(t.selection instanceof St)) return null;
  const e = [];
  return t.selection.forEachCell((A, n) => {
    e.push(Wt.node(n, n + A.nodeSize, { class: "selectedCell" }));
  }), It.create(t.doc, e);
}
function gO({ $from: t, $to: e }) {
  if (t.pos == e.pos || t.pos < e.pos - 6) return !1;
  let A = t.pos, n = e.pos, s = t.depth;
  for (; s >= 0 && !(t.after(s + 1) < t.end(s)); s--, A++) ;
  for (let r = e.depth; r >= 0 && !(e.before(r + 1) > e.start(r)); r--, n--) ;
  return A == n && /row|table/.test(t.node(s).type.spec.tableRole);
}
function hO({ $from: t, $to: e }) {
  let A, n;
  for (let s = t.depth; s > 0; s--) {
    const r = t.node(s);
    if (r.type.spec.tableRole === "cell" || r.type.spec.tableRole === "header_cell") {
      A = r;
      break;
    }
  }
  for (let s = e.depth; s > 0; s--) {
    const r = e.node(s);
    if (r.type.spec.tableRole === "cell" || r.type.spec.tableRole === "header_cell") {
      n = r;
      break;
    }
  }
  return A !== n && e.parentOffset === 0;
}
function uO(t, e, A) {
  const n = (e || t).selection, s = (e || t).doc;
  let r, i;
  if (n instanceof Ue && (i = n.node.type.spec.tableRole)) {
    if (i == "cell" || i == "header_cell") r = St.create(s, n.from);
    else if (i == "row") {
      const o = s.resolve(n.from + 1);
      r = St.rowSelection(o, o);
    } else if (!A) {
      const o = BA.get(n.node), a = n.from + 1, c = a + o.map[o.width * o.height - 1];
      r = St.create(s, a + 1, c);
    }
  } else n instanceof Re && gO(n) ? r = Re.create(s, n.from) : n instanceof Re && hO(n) && (r = Re.create(s, n.$from.start(), n.$from.end()));
  return r && (e || (e = t.tr)).setSelection(r), e;
}
const dO = new Bt("fix-tables");
function rz(t, e, A, n) {
  const s = t.childCount, r = e.childCount;
  e: for (let i = 0, o = 0; i < r; i++) {
    const a = e.child(i);
    for (let c = o, l = Math.min(s, i + 3); c < l; c++) if (t.child(c) == a) {
      o = c + 1, A += a.nodeSize;
      continue e;
    }
    n(a, A), o < s && t.child(o).sameMarkup(a) ? rz(t.child(o), a, A + 1, n) : a.nodesBetween(0, a.content.size, n, A + 1), A += a.nodeSize;
  }
}
function iz(t, e) {
  let A;
  const n = (s, r) => {
    s.type.spec.tableRole == "table" && (A = wO(t, s, r, A));
  };
  return e ? e.doc != t.doc && rz(e.doc, t.doc, 0, n) : t.doc.descendants(n), A;
}
function wO(t, e, A, n) {
  const s = BA.get(e);
  if (!s.problems) return n;
  n || (n = t.tr);
  const r = [];
  for (let a = 0; a < s.height; a++) r.push(0);
  for (let a = 0; a < s.problems.length; a++) {
    const c = s.problems[a];
    if (c.type == "collision") {
      const l = e.nodeAt(c.pos);
      if (!l) continue;
      const B = l.attrs;
      for (let g = 0; g < B.rowspan; g++) r[c.row + g] += c.n;
      n.setNodeMarkup(n.mapping.map(A + 1 + c.pos), null, ec(B, B.colspan - c.n, c.n));
    } else if (c.type == "missing") r[c.row] += c.n;
    else if (c.type == "overlong_rowspan") {
      const l = e.nodeAt(c.pos);
      if (!l) continue;
      n.setNodeMarkup(n.mapping.map(A + 1 + c.pos), null, {
        ...l.attrs,
        rowspan: l.attrs.rowspan - c.n
      });
    } else if (c.type == "colwidth mismatch") {
      const l = e.nodeAt(c.pos);
      if (!l) continue;
      n.setNodeMarkup(n.mapping.map(A + 1 + c.pos), null, {
        ...l.attrs,
        colwidth: c.colwidth
      });
    } else if (c.type == "zero_sized") {
      const l = n.mapping.map(A);
      n.delete(l, l + e.nodeSize);
    }
  }
  let i, o;
  for (let a = 0; a < r.length; a++) r[a] && (i == null && (i = a), o = a);
  for (let a = 0, c = A + 1; a < s.height; a++) {
    const l = e.child(a), B = c + l.nodeSize, g = r[a];
    if (g > 0) {
      let h = "cell";
      l.firstChild && (h = l.firstChild.type.spec.tableRole);
      const u = [];
      for (let w = 0; w < g; w++) {
        const Q = cn(t.schema)[h].createAndFill();
        Q && u.push(Q);
      }
      const d = (a == 0 || i == a - 1) && o == a ? c + 1 : B - 1;
      n.insert(n.mapping.map(d), u);
    }
    c = B;
  }
  return n.setMeta(dO, { fixTables: !0 });
}
function _r(t) {
  const e = t.selection, A = Rw(t), n = A.node(-1), s = A.start(-1), r = BA.get(n);
  return {
    ...e instanceof St ? r.rectBetween(e.$anchorCell.pos - s, e.$headCell.pos - s) : r.findCell(A.pos - s),
    tableStart: s,
    map: r,
    table: n
  };
}
function oz(t, { map: e, tableStart: A, table: n }, s) {
  let r = s > 0 ? -1 : 0;
  cO(e, n, s + r) && (r = s == 0 || s == e.width ? null : 0);
  for (let i = 0; i < e.height; i++) {
    const o = i * e.width + s;
    if (s > 0 && s < e.width && e.map[o - 1] == e.map[o]) {
      const a = e.map[o], c = n.nodeAt(a);
      t.setNodeMarkup(t.mapping.map(A + a), null, nz(c.attrs, s - e.colCount(a))), i += c.attrs.rowspan - 1;
    } else {
      const a = r == null ? cn(n.type.schema).cell : n.nodeAt(e.map[o + r]).type, c = e.positionAt(i, s, n);
      t.insert(t.mapping.map(A + c), a.createAndFill());
    }
  }
  return t;
}
function fO(t, e) {
  if (!gr(t)) return !1;
  if (e) {
    const A = _r(t);
    e(oz(t.tr, A, A.left));
  }
  return !0;
}
function QO(t, e) {
  if (!gr(t)) return !1;
  if (e) {
    const A = _r(t);
    e(oz(t.tr, A, A.right));
  }
  return !0;
}
function IO(t, { map: e, table: A, tableStart: n }, s) {
  const r = t.mapping.maps.length;
  for (let i = 0; i < e.height; ) {
    const o = i * e.width + s, a = e.map[o], c = A.nodeAt(a), l = c.attrs;
    if (s > 0 && e.map[o - 1] == a || s < e.width - 1 && e.map[o + 1] == a) t.setNodeMarkup(t.mapping.slice(r).map(n + a), null, ec(l, s - e.colCount(a)));
    else {
      const B = t.mapping.slice(r).map(n + a);
      t.delete(B, B + c.nodeSize);
    }
    i += l.rowspan;
  }
}
function CO(t, e) {
  if (!gr(t)) return !1;
  if (e) {
    const A = _r(t), n = t.tr;
    if (A.left == 0 && A.right == A.map.width) return !1;
    for (let s = A.right - 1; IO(n, A, s), s != A.left; s--) {
      const r = A.tableStart ? n.doc.nodeAt(A.tableStart - 1) : n.doc;
      if (!r) throw new RangeError("No table found");
      A.table = r, A.map = BA.get(r);
    }
    e(n);
  }
  return !0;
}
function EO(t, e, A) {
  var n;
  const s = cn(e.type.schema).header_cell;
  for (let r = 0; r < t.width; r++) if (((n = e.nodeAt(t.map[r + A * t.width])) === null || n === void 0 ? void 0 : n.type) != s) return !1;
  return !0;
}
function az(t, { map: e, tableStart: A, table: n }, s) {
  let r = A;
  for (let c = 0; c < s; c++) r += n.child(c).nodeSize;
  const i = [];
  let o = s > 0 ? -1 : 0;
  EO(e, n, s + o) && (o = s == 0 || s == e.height ? null : 0);
  for (let c = 0, l = e.width * s; c < e.width; c++, l++) if (s > 0 && s < e.height && e.map[l] == e.map[l - e.width]) {
    const B = e.map[l], g = n.nodeAt(B).attrs;
    t.setNodeMarkup(A + B, null, {
      ...g,
      rowspan: g.rowspan + 1
    }), c += g.colspan - 1;
  } else {
    var a;
    const B = o == null ? cn(n.type.schema).cell : (a = n.nodeAt(e.map[l + o * e.width])) === null || a === void 0 ? void 0 : a.type, g = B == null ? void 0 : B.createAndFill();
    g && i.push(g);
  }
  return t.insert(r, cn(n.type.schema).row.create(null, i)), t;
}
function MO(t, e) {
  if (!gr(t)) return !1;
  if (e) {
    const A = _r(t);
    e(az(t.tr, A, A.top));
  }
  return !0;
}
function pO(t, e) {
  if (!gr(t)) return !1;
  if (e) {
    const A = _r(t);
    e(az(t.tr, A, A.bottom));
  }
  return !0;
}
function mO(t, { map: e, table: A, tableStart: n }, s) {
  let r = 0;
  for (let c = 0; c < s; c++) r += A.child(c).nodeSize;
  const i = r + A.child(s).nodeSize, o = t.mapping.maps.length;
  t.delete(r + n, i + n);
  const a = /* @__PURE__ */ new Set();
  for (let c = 0, l = s * e.width; c < e.width; c++, l++) {
    const B = e.map[l];
    if (!a.has(B)) {
      if (a.add(B), s > 0 && B == e.map[l - e.width]) {
        const g = A.nodeAt(B).attrs;
        t.setNodeMarkup(t.mapping.slice(o).map(B + n), null, {
          ...g,
          rowspan: g.rowspan - 1
        }), c += g.colspan - 1;
      } else if (s < e.height && B == e.map[l + e.width]) {
        const g = A.nodeAt(B), h = g.attrs, u = g.type.create({
          ...h,
          rowspan: g.attrs.rowspan - 1
        }, g.content), d = e.positionAt(s + 1, c, A);
        t.insert(t.mapping.slice(o).map(n + d), u), c += h.colspan - 1;
      }
    }
  }
}
function YO(t, e) {
  if (!gr(t)) return !1;
  if (e) {
    const A = _r(t), n = t.tr;
    if (A.top == 0 && A.bottom == A.map.height) return !1;
    for (let s = A.bottom - 1; mO(n, A, s), s != A.top; s--) {
      const r = A.tableStart ? n.doc.nodeAt(A.tableStart - 1) : n.doc;
      if (!r) throw new RangeError("No table found");
      A.table = r, A.map = BA.get(A.table);
    }
    e(n);
  }
  return !0;
}
function l1(t) {
  const e = t.content;
  return e.childCount == 1 && e.child(0).isTextblock && e.child(0).childCount == 0;
}
function yO({ width: t, height: e, map: A }, n) {
  let s = n.top * t + n.left, r = s, i = (n.bottom - 1) * t + n.left, o = s + (n.right - n.left - 1);
  for (let a = n.top; a < n.bottom; a++) {
    if (n.left > 0 && A[r] == A[r - 1] || n.right < t && A[o] == A[o + 1]) return !0;
    r += t, o += t;
  }
  for (let a = n.left; a < n.right; a++) {
    if (n.top > 0 && A[s] == A[s - t] || n.bottom < e && A[i] == A[i + t]) return !0;
    s++, i++;
  }
  return !1;
}
function B1(t, e) {
  const A = t.selection;
  if (!(A instanceof St) || A.$anchorCell.pos == A.$headCell.pos) return !1;
  const n = _r(t), { map: s } = n;
  if (yO(s, n)) return !1;
  if (e) {
    const r = t.tr, i = {};
    let o = re.empty, a, c;
    for (let l = n.top; l < n.bottom; l++) for (let B = n.left; B < n.right; B++) {
      const g = s.map[l * s.width + B], h = n.table.nodeAt(g);
      if (!(i[g] || !h))
        if (i[g] = !0, a == null)
          a = g, c = h;
        else {
          l1(h) || (o = o.append(h.content));
          const u = r.mapping.map(g + n.tableStart);
          r.delete(u, u + h.nodeSize);
        }
    }
    if (a == null || c == null) return !0;
    if (r.setNodeMarkup(a + n.tableStart, null, {
      ...nz(c.attrs, c.attrs.colspan, n.right - n.left - c.attrs.colspan),
      rowspan: n.bottom - n.top
    }), o.size > 0) {
      const l = a + 1 + c.content.size, B = l1(c) ? a + 1 : l;
      r.replaceWith(B + n.tableStart, l + n.tableStart, o);
    }
    r.setSelection(new St(r.doc.resolve(a + n.tableStart))), e(r);
  }
  return !0;
}
function g1(t, e) {
  const A = cn(t.schema);
  return FO(({ node: n }) => A[n.type.spec.tableRole])(t, e);
}
function FO(t) {
  return (e, A) => {
    const n = e.selection;
    let s, r;
    if (n instanceof St) {
      if (n.$anchorCell.pos != n.$headCell.pos) return !1;
      s = n.$anchorCell.nodeAfter, r = n.$anchorCell.pos;
    } else {
      var i;
      if (s = iO(n.$from), !s) return !1;
      r = (i = $a(n.$from)) === null || i === void 0 ? void 0 : i.pos;
    }
    if (s == null || r == null || s.attrs.colspan == 1 && s.attrs.rowspan == 1) return !1;
    if (A) {
      let o = s.attrs;
      const a = [], c = o.colwidth;
      o.rowspan > 1 && (o = {
        ...o,
        rowspan: 1
      }), o.colspan > 1 && (o = {
        ...o,
        colspan: 1
      });
      const l = _r(e), B = e.tr;
      for (let h = 0; h < l.right - l.left; h++) a.push(c ? {
        ...o,
        colwidth: c && c[h] ? [c[h]] : null
      } : o);
      let g;
      for (let h = l.top; h < l.bottom; h++) {
        let u = l.map.positionAt(h, l.left, l.table);
        h == l.top && (u += s.nodeSize);
        for (let d = l.left, w = 0; d < l.right; d++, w++)
          d == l.left && h == l.top || B.insert(g = B.mapping.map(u + l.tableStart, 1), t({
            node: s,
            row: h,
            col: d
          }).createAndFill(a[w]));
      }
      B.setNodeMarkup(r, t({
        node: s,
        row: l.top,
        col: l.left
      }), a[0]), n instanceof St && B.setSelection(new St(B.doc.resolve(n.$anchorCell.pos), g ? B.doc.resolve(g) : void 0)), A(B);
    }
    return !0;
  };
}
function NO(t, e) {
  return function(A, n) {
    if (!gr(A)) return !1;
    const s = Rw(A);
    if (s.nodeAfter.attrs[t] === e) return !1;
    if (n) {
      const r = A.tr;
      A.selection instanceof St ? A.selection.forEachCell((i, o) => {
        i.attrs[t] !== e && r.setNodeMarkup(o, null, {
          ...i.attrs,
          [t]: e
        });
      }) : r.setNodeMarkup(s.pos, null, {
        ...s.nodeAfter.attrs,
        [t]: e
      }), n(r);
    }
    return !0;
  };
}
function DO(t) {
  return function(e, A) {
    if (!gr(e)) return !1;
    if (A) {
      const n = cn(e.schema), s = _r(e), r = e.tr, i = s.map.cellsInRect(t == "column" ? {
        left: s.left,
        top: 0,
        right: s.right,
        bottom: s.map.height
      } : t == "row" ? {
        left: 0,
        top: s.top,
        right: s.map.width,
        bottom: s.bottom
      } : s), o = i.map((a) => s.table.nodeAt(a));
      for (let a = 0; a < i.length; a++) o[a].type == n.header_cell && r.setNodeMarkup(s.tableStart + i[a], n.cell, o[a].attrs);
      if (r.steps.length === 0) for (let a = 0; a < i.length; a++) r.setNodeMarkup(s.tableStart + i[a], n.header_cell, o[a].attrs);
      A(r);
    }
    return !0;
  };
}
function h1(t, e, A) {
  const n = e.map.cellsInRect({
    left: 0,
    top: 0,
    right: t == "row" ? e.map.width : 1,
    bottom: t == "column" ? e.map.height : 1
  });
  for (let s = 0; s < n.length; s++) {
    const r = e.table.nodeAt(n[s]);
    if (r && r.type !== A.header_cell) return !1;
  }
  return !0;
}
function Gg(t, e) {
  return e = e || { useDeprecatedLogic: !1 }, e.useDeprecatedLogic ? DO(t) : function(A, n) {
    if (!gr(A)) return !1;
    if (n) {
      const s = cn(A.schema), r = _r(A), i = A.tr, o = h1("row", r, s), a = h1("column", r, s), c = (t === "column" ? o : t === "row" && a) ? 1 : 0, l = t == "column" ? {
        left: 0,
        top: c,
        right: 1,
        bottom: r.map.height
      } : t == "row" ? {
        left: c,
        top: 0,
        right: r.map.width,
        bottom: 1
      } : r, B = t == "column" ? a ? s.cell : s.header_cell : t == "row" ? o ? s.cell : s.header_cell : s.cell;
      r.map.cellsInRect(l).forEach((g) => {
        const h = g + r.tableStart, u = i.doc.nodeAt(h);
        u && i.setNodeMarkup(h, B, u.attrs);
      }), n(i);
    }
    return !0;
  };
}
Gg("row", { useDeprecatedLogic: !0 });
Gg("column", { useDeprecatedLogic: !0 });
const xO = Gg("cell", { useDeprecatedLogic: !0 });
function GO(t, e) {
  if (e < 0) {
    const A = t.nodeBefore;
    if (A) return t.pos - A.nodeSize;
    for (let n = t.index(-1) - 1, s = t.before(); n >= 0; n--) {
      const r = t.node(-1).child(n), i = r.lastChild;
      if (i) return s - 1 - i.nodeSize;
      s -= r.nodeSize;
    }
  } else {
    if (t.index() < t.parent.childCount - 1) return t.pos + t.nodeAfter.nodeSize;
    const A = t.node(-1);
    for (let n = t.indexAfter(-1), s = t.after(); n < A.childCount; n++) {
      const r = A.child(n);
      if (r.childCount) return s + 1;
      s += r.nodeSize;
    }
  }
  return null;
}
function u1(t) {
  return function(e, A) {
    if (!gr(e)) return !1;
    const n = GO(Rw(e), t);
    if (n == null) return !1;
    if (A) {
      const s = e.doc.resolve(n);
      A(e.tr.setSelection(Re.between(s, aO(s))).scrollIntoView());
    }
    return !0;
  };
}
function zO(t, e) {
  const A = t.selection.$anchor;
  for (let n = A.depth; n > 0; n--) if (A.node(n).type.spec.tableRole == "table")
    return e && e(t.tr.delete(A.before(n), A.after(n)).scrollIntoView()), !0;
  return !1;
}
function a0(t, e) {
  const A = t.selection;
  if (!(A instanceof St)) return !1;
  if (e) {
    const n = t.tr, s = cn(t.schema).cell.createAndFill().content;
    A.forEachCell((r, i) => {
      r.content.eq(s) || n.replace(n.mapping.map(i + 1), n.mapping.map(i + r.nodeSize - 1), new Ee(s, 0, 0));
    }), n.docChanged && e(n);
  }
  return !0;
}
function UO(t) {
  if (t.size === 0) return null;
  let { content: e, openStart: A, openEnd: n } = t;
  for (; e.childCount == 1 && (A > 0 && n > 0 || e.child(0).type.spec.tableRole == "table"); )
    A--, n--, e = e.child(0).content;
  const s = e.child(0), r = s.type.spec.tableRole, i = s.type.schema, o = [];
  if (r == "row") for (let a = 0; a < e.childCount; a++) {
    let c = e.child(a).content;
    const l = a ? 0 : Math.max(0, A - 1), B = a < e.childCount - 1 ? 0 : Math.max(0, n - 1);
    (l || B) && (c = _C(cn(i).row, new Ee(c, l, B)).content), o.push(c);
  }
  else if (r == "cell" || r == "header_cell") o.push(A || n ? _C(cn(i).row, new Ee(e, A, n)).content : e);
  else return null;
  return bO(i, o);
}
function bO(t, e) {
  const A = [];
  for (let s = 0; s < e.length; s++) {
    const r = e[s];
    for (let i = r.childCount - 1; i >= 0; i--) {
      const { rowspan: o, colspan: a } = r.child(i).attrs;
      for (let c = s; c < s + o; c++) A[c] = (A[c] || 0) + a;
    }
  }
  let n = 0;
  for (let s = 0; s < A.length; s++) n = Math.max(n, A[s]);
  for (let s = 0; s < A.length; s++)
    if (s >= e.length && e.push(re.empty), A[s] < n) {
      const r = cn(t).cell.createAndFill(), i = [];
      for (let o = A[s]; o < n; o++) i.push(r);
      e[s] = e[s].append(re.from(i));
    }
  return {
    height: e.length,
    width: n,
    rows: e
  };
}
function _C(t, e) {
  const A = t.createAndFill();
  return new RM(A).replace(0, A.content.size, e).doc;
}
function vO({ width: t, height: e, rows: A }, n, s) {
  if (t != n) {
    const r = [], i = [];
    for (let o = 0; o < A.length; o++) {
      const a = A[o], c = [];
      for (let l = r[o] || 0, B = 0; l < n; B++) {
        let g = a.child(B % a.childCount);
        l + g.attrs.colspan > n && (g = g.type.createChecked(ec(g.attrs, g.attrs.colspan, l + g.attrs.colspan - n), g.content)), c.push(g), l += g.attrs.colspan;
        for (let h = 1; h < g.attrs.rowspan; h++) r[o + h] = (r[o + h] || 0) + g.attrs.colspan;
      }
      i.push(re.from(c));
    }
    A = i, t = n;
  }
  if (e != s) {
    const r = [];
    for (let i = 0, o = 0; i < s; i++, o++) {
      const a = [], c = A[o % e];
      for (let l = 0; l < c.childCount; l++) {
        let B = c.child(l);
        i + B.attrs.rowspan > s && (B = B.type.create({
          ...B.attrs,
          rowspan: Math.max(1, s - B.attrs.rowspan)
        }, B.content)), a.push(B);
      }
      r.push(re.from(a));
    }
    A = r, e = s;
  }
  return {
    width: t,
    height: e,
    rows: A
  };
}
function jO(t, e, A, n, s, r, i) {
  const o = t.doc.type.schema, a = cn(o);
  let c, l;
  if (s > e.width) for (let B = 0, g = 0; B < e.height; B++) {
    const h = A.child(B);
    g += h.nodeSize;
    const u = [];
    let d;
    h.lastChild == null || h.lastChild.type == a.cell ? d = c || (c = a.cell.createAndFill()) : d = l || (l = a.header_cell.createAndFill());
    for (let w = e.width; w < s; w++) u.push(d);
    t.insert(t.mapping.slice(i).map(g - 1 + n), u);
  }
  if (r > e.height) {
    const B = [];
    for (let u = 0, d = (e.height - 1) * e.width; u < Math.max(e.width, s); u++) {
      const w = u >= e.width ? !1 : A.nodeAt(e.map[d + u]).type == a.header_cell;
      B.push(w ? l || (l = a.header_cell.createAndFill()) : c || (c = a.cell.createAndFill()));
    }
    const g = a.row.create(null, re.from(B)), h = [];
    for (let u = e.height; u < r; u++) h.push(g);
    t.insert(t.mapping.slice(i).map(n + A.nodeSize - 2), h);
  }
  return !!(c || l);
}
function d1(t, e, A, n, s, r, i, o) {
  if (i == 0 || i == e.height) return !1;
  let a = !1;
  for (let c = s; c < r; c++) {
    const l = i * e.width + c, B = e.map[l];
    if (e.map[l - e.width] == B) {
      a = !0;
      const g = A.nodeAt(B), { top: h, left: u } = e.findCell(B);
      t.setNodeMarkup(t.mapping.slice(o).map(B + n), null, {
        ...g.attrs,
        rowspan: i - h
      }), t.insert(t.mapping.slice(o).map(e.positionAt(i, u, A)), g.type.createAndFill({
        ...g.attrs,
        rowspan: h + g.attrs.rowspan - i
      })), c += g.attrs.colspan - 1;
    }
  }
  return a;
}
function w1(t, e, A, n, s, r, i, o) {
  if (i == 0 || i == e.width) return !1;
  let a = !1;
  for (let c = s; c < r; c++) {
    const l = c * e.width + i, B = e.map[l];
    if (e.map[l - 1] == B) {
      a = !0;
      const g = A.nodeAt(B), h = e.colCount(B), u = t.mapping.slice(o).map(B + n);
      t.setNodeMarkup(u, null, ec(g.attrs, i - h, g.attrs.colspan - (i - h))), t.insert(u + g.nodeSize, g.type.createAndFill(ec(g.attrs, 0, i - h))), c += g.attrs.rowspan - 1;
    }
  }
  return a;
}
function f1(t, e, A, n, s) {
  let r = A ? t.doc.nodeAt(A - 1) : t.doc;
  if (!r) throw new Error("No table found");
  let i = BA.get(r);
  const { top: o, left: a } = n, c = a + s.width, l = o + s.height, B = t.tr;
  let g = 0;
  function h() {
    if (r = A ? B.doc.nodeAt(A - 1) : B.doc, !r) throw new Error("No table found");
    i = BA.get(r), g = B.mapping.maps.length;
  }
  jO(B, i, r, A, c, l, g) && h(), d1(B, i, r, A, a, c, o, g) && h(), d1(B, i, r, A, a, c, l, g) && h(), w1(B, i, r, A, o, l, a, g) && h(), w1(B, i, r, A, o, l, c, g) && h();
  for (let u = o; u < l; u++) {
    const d = i.positionAt(u, a, r), w = i.positionAt(u, c, r);
    B.replace(B.mapping.slice(g).map(d + A), B.mapping.slice(g).map(w + A), new Ee(s.rows[u - o], 0, 0));
  }
  h(), B.setSelection(new St(B.doc.resolve(A + i.positionAt(o, a, r)), B.doc.resolve(A + i.positionAt(l - 1, c - 1, r)))), e(B);
}
const HO = Ap({
  ArrowLeft: c0("horiz", -1),
  ArrowRight: c0("horiz", 1),
  ArrowUp: c0("vert", -1),
  ArrowDown: c0("vert", 1),
  "Shift-ArrowLeft": l0("horiz", -1),
  "Shift-ArrowRight": l0("horiz", 1),
  "Shift-ArrowUp": l0("vert", -1),
  "Shift-ArrowDown": l0("vert", 1),
  Backspace: a0,
  "Mod-Backspace": a0,
  Delete: a0,
  "Mod-Delete": a0
});
function $0(t, e, A) {
  return A.eq(t.selection) ? !1 : (e && e(t.tr.setSelection(A).scrollIntoView()), !0);
}
function c0(t, e) {
  return (A, n, s) => {
    if (!s) return !1;
    const r = A.selection;
    if (r instanceof St) return $0(A, n, Ke.near(r.$headCell, e));
    if (t != "horiz" && !r.empty) return !1;
    const i = cz(s, t, e);
    if (i == null) return !1;
    if (t == "horiz") return $0(A, n, Ke.near(A.doc.resolve(r.head + e), e));
    {
      const o = A.doc.resolve(i), a = Az(o, t, e);
      let c;
      return a ? c = Ke.near(a, 1) : e < 0 ? c = Ke.near(A.doc.resolve(o.before(-1)), -1) : c = Ke.near(A.doc.resolve(o.after(-1)), 1), $0(A, n, c);
    }
  };
}
function l0(t, e) {
  return (A, n, s) => {
    if (!s) return !1;
    const r = A.selection;
    let i;
    if (r instanceof St) i = r;
    else {
      const a = cz(s, t, e);
      if (a == null) return !1;
      i = new St(A.doc.resolve(a));
    }
    const o = Az(i.$headCell, t, e);
    return o ? $0(A, n, new St(i.$anchorCell, o)) : !1;
  };
}
function kO(t, e) {
  const A = t.state.doc, n = $a(A.resolve(e));
  return n ? (t.dispatch(t.state.tr.setSelection(new St(n))), !0) : !1;
}
function RO(t, e, A) {
  if (!gr(t.state)) return !1;
  let n = UO(A);
  const s = t.state.selection;
  if (s instanceof St) {
    n || (n = {
      width: 1,
      height: 1,
      rows: [re.from(_C(cn(t.state.schema).cell, A))]
    });
    const r = s.$anchorCell.node(-1), i = s.$anchorCell.start(-1), o = BA.get(r).rectBetween(s.$anchorCell.pos - i, s.$headCell.pos - i);
    return n = vO(n, o.right - o.left, o.bottom - o.top), f1(t.state, t.dispatch, i, o, n), !0;
  } else if (n) {
    const r = Rw(t.state), i = r.start(-1);
    return f1(t.state, t.dispatch, i, BA.get(r.node(-1)).findCell(r.pos - i), n), !0;
  } else return !1;
}
function LO(t, e) {
  var A;
  if (e.button != 0 || e.ctrlKey || e.metaKey) return;
  const n = Q1(t, e.target);
  let s;
  if (e.shiftKey && t.state.selection instanceof St)
    r(t.state.selection.$anchorCell, e), e.preventDefault();
  else if (e.shiftKey && n && (s = $a(t.state.selection.$anchor)) != null && ((A = UQ(t, e)) === null || A === void 0 ? void 0 : A.pos) != s.pos)
    r(s, e), e.preventDefault();
  else if (!n) return;
  function r(a, c) {
    let l = UQ(t, c);
    const B = Fo.getState(t.state) == null;
    if (!l || !Cp(a, l)) if (B) l = a;
    else return;
    const g = new St(a, l);
    if (B || !t.state.selection.eq(g)) {
      const h = t.state.tr.setSelection(g);
      B && h.setMeta(Fo, a.pos), t.dispatch(h);
    }
  }
  function i() {
    t.root.removeEventListener("mouseup", i), t.root.removeEventListener("dragstart", i), t.root.removeEventListener("mousemove", o), Fo.getState(t.state) != null && t.dispatch(t.state.tr.setMeta(Fo, -1));
  }
  function o(a) {
    const c = a, l = Fo.getState(t.state);
    let B;
    if (l != null) B = t.state.doc.resolve(l);
    else if (Q1(t, c.target) != n && (B = UQ(t, e), !B))
      return i();
    B && r(B, c);
  }
  t.root.addEventListener("mouseup", i), t.root.addEventListener("dragstart", i), t.root.addEventListener("mousemove", o);
}
function cz(t, e, A) {
  if (!(t.state.selection instanceof Re)) return null;
  const { $head: n } = t.state.selection;
  for (let s = n.depth - 1; s >= 0; s--) {
    const r = n.node(s);
    if ((A < 0 ? n.index(s) : n.indexAfter(s)) != (A < 0 ? 0 : r.childCount)) return null;
    if (r.type.spec.tableRole == "cell" || r.type.spec.tableRole == "header_cell") {
      const i = n.before(s), o = e == "vert" ? A > 0 ? "down" : "up" : A > 0 ? "right" : "left";
      return t.endOfTextblock(o) ? i : null;
    }
  }
  return null;
}
function Q1(t, e) {
  for (; e && e != t.dom; e = e.parentNode) if (e.nodeName == "TD" || e.nodeName == "TH") return e;
  return null;
}
function UQ(t, e) {
  const A = t.posAtCoords({
    left: e.clientX,
    top: e.clientY
  });
  if (!A) return null;
  let { inside: n, pos: s } = A;
  return n >= 0 && $a(t.state.doc.resolve(n)) || $a(t.state.doc.resolve(s));
}
var SO = class {
  constructor(e, A) {
    this.node = e, this.defaultCellMinWidth = A, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), this.table.style.setProperty("--default-cell-min-width", `${A}px`), this.colgroup = this.table.appendChild(document.createElement("colgroup")), $C(e, this.colgroup, this.table, A), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(e) {
    return e.type != this.node.type ? !1 : (this.node = e, $C(e, this.colgroup, this.table, this.defaultCellMinWidth), !0);
  }
  ignoreMutation(e) {
    return e.type == "attributes" && (e.target == this.table || this.colgroup.contains(e.target));
  }
};
function $C(t, e, A, n, s, r) {
  let i = 0, o = !0, a = e.firstChild;
  const c = t.firstChild;
  if (c) {
    for (let B = 0, g = 0; B < c.childCount; B++) {
      const { colspan: h, colwidth: u } = c.child(B).attrs;
      for (let d = 0; d < h; d++, g++) {
        const w = s == g ? r : u && u[d], Q = w ? w + "px" : "";
        if (i += w || n, w || (o = !1), a)
          a.style.width != Q && (a.style.width = Q), a = a.nextSibling;
        else {
          const p = document.createElement("col");
          p.style.width = Q, e.appendChild(p);
        }
      }
    }
    for (; a; ) {
      var l;
      const B = a.nextSibling;
      (l = a.parentNode) === null || l === void 0 || l.removeChild(a), a = B;
    }
    o ? (A.style.width = i + "px", A.style.minWidth = "") : (A.style.width = "", A.style.minWidth = i + "px");
  }
}
const ls = new Bt("tableColumnResizing");
function TO({ handleWidth: t = 5, cellMinWidth: e = 25, defaultCellMinWidth: A = 100, View: n = SO, lastColumnResizable: s = !0 } = {}) {
  const r = new ct({
    key: ls,
    state: {
      init(i, o) {
        var a;
        const c = (a = r.spec) === null || a === void 0 || (a = a.props) === null || a === void 0 ? void 0 : a.nodeViews, l = cn(o.schema).table.name;
        return n && c && (c[l] = (B, g) => new n(B, A, g)), new JO(-1, !1);
      },
      apply(i, o) {
        return o.apply(i);
      }
    },
    props: {
      attributes: (i) => {
        const o = ls.getState(i);
        return o && o.activeHandle > -1 ? { class: "resize-cursor" } : {};
      },
      handleDOMEvents: {
        mousemove: (i, o) => {
          WO(i, o, t, s);
        },
        mouseleave: (i) => {
          OO(i);
        },
        mousedown: (i, o) => {
          PO(i, o, e, A);
        }
      },
      decorations: (i) => {
        const o = ls.getState(i);
        if (o && o.activeHandle > -1) return qO(i, o.activeHandle);
      },
      nodeViews: {}
    }
  });
  return r;
}
var JO = class eu {
  constructor(e, A) {
    this.activeHandle = e, this.dragging = A;
  }
  apply(e) {
    const A = this, n = e.getMeta(ls);
    if (n && n.setHandle != null) return new eu(n.setHandle, !1);
    if (n && n.setDragging !== void 0) return new eu(A.activeHandle, n.setDragging);
    if (A.activeHandle > -1 && e.docChanged) {
      let s = e.mapping.map(A.activeHandle, -1);
      return qC(e.doc.resolve(s)) || (s = -1), new eu(s, A.dragging);
    }
    return A;
  }
};
function WO(t, e, A, n) {
  if (!t.editable) return;
  const s = ls.getState(t.state);
  if (s && !s.dragging) {
    const r = VO(e.target);
    let i = -1;
    if (r) {
      const { left: o, right: a } = r.getBoundingClientRect();
      e.clientX - o <= A ? i = I1(t, e, "left", A) : a - e.clientX <= A && (i = I1(t, e, "right", A));
    }
    if (i != s.activeHandle) {
      if (!n && i !== -1) {
        const o = t.state.doc.resolve(i), a = o.node(-1), c = BA.get(a), l = o.start(-1);
        if (c.colCount(o.pos - l) + o.nodeAfter.attrs.colspan - 1 == c.width - 1) return;
      }
      lz(t, i);
    }
  }
}
function OO(t) {
  if (!t.editable) return;
  const e = ls.getState(t.state);
  e && e.activeHandle > -1 && !e.dragging && lz(t, -1);
}
function PO(t, e, A, n) {
  var s;
  if (!t.editable) return !1;
  const r = (s = t.dom.ownerDocument.defaultView) !== null && s !== void 0 ? s : window, i = ls.getState(t.state);
  if (!i || i.activeHandle == -1 || i.dragging) return !1;
  const o = t.state.doc.nodeAt(i.activeHandle), a = KO(t, i.activeHandle, o.attrs);
  t.dispatch(t.state.tr.setMeta(ls, { setDragging: {
    startX: e.clientX,
    startWidth: a
  } }));
  function c(B) {
    r.removeEventListener("mouseup", c), r.removeEventListener("mousemove", l);
    const g = ls.getState(t.state);
    g != null && g.dragging && (XO(t, g.activeHandle, C1(g.dragging, B, A)), t.dispatch(t.state.tr.setMeta(ls, { setDragging: null })));
  }
  function l(B) {
    if (!B.which) return c(B);
    const g = ls.getState(t.state);
    if (g && g.dragging) {
      const h = C1(g.dragging, B, A);
      E1(t, g.activeHandle, h, n);
    }
  }
  return E1(t, i.activeHandle, a, n), r.addEventListener("mouseup", c), r.addEventListener("mousemove", l), e.preventDefault(), !0;
}
function KO(t, e, { colspan: A, colwidth: n }) {
  const s = n && n[n.length - 1];
  if (s) return s;
  const r = t.domAtPos(e);
  let i = r.node.childNodes[r.offset].offsetWidth, o = A;
  if (n)
    for (let a = 0; a < A; a++) n[a] && (i -= n[a], o--);
  return i / o;
}
function VO(t) {
  for (; t && t.nodeName != "TD" && t.nodeName != "TH"; ) t = t.classList && t.classList.contains("ProseMirror") ? null : t.parentNode;
  return t;
}
function I1(t, e, A, n) {
  const s = A == "right" ? -n : n, r = t.posAtCoords({
    left: e.clientX + s,
    top: e.clientY
  });
  if (!r) return -1;
  const { pos: i } = r, o = $a(t.state.doc.resolve(i));
  if (!o) return -1;
  if (A == "right") return o.pos;
  const a = BA.get(o.node(-1)), c = o.start(-1), l = a.map.indexOf(o.pos - c);
  return l % a.width == 0 ? -1 : c + a.map[l - 1];
}
function C1(t, e, A) {
  const n = e.clientX - t.startX;
  return Math.max(A, t.startWidth + n);
}
function lz(t, e) {
  t.dispatch(t.state.tr.setMeta(ls, { setHandle: e }));
}
function XO(t, e, A) {
  const n = t.state.doc.resolve(e), s = n.node(-1), r = BA.get(s), i = n.start(-1), o = r.colCount(n.pos - i) + n.nodeAfter.attrs.colspan - 1, a = t.state.tr;
  for (let c = 0; c < r.height; c++) {
    const l = c * r.width + o;
    if (c && r.map[l] == r.map[l - r.width]) continue;
    const B = r.map[l], g = s.nodeAt(B).attrs, h = g.colspan == 1 ? 0 : o - r.colCount(B);
    if (g.colwidth && g.colwidth[h] == A) continue;
    const u = g.colwidth ? g.colwidth.slice() : ZO(g.colspan);
    u[h] = A, a.setNodeMarkup(i + B, null, {
      ...g,
      colwidth: u
    });
  }
  a.docChanged && t.dispatch(a);
}
function E1(t, e, A, n) {
  const s = t.state.doc.resolve(e), r = s.node(-1), i = s.start(-1), o = BA.get(r).colCount(s.pos - i) + s.nodeAfter.attrs.colspan - 1;
  let a = t.domAtPos(s.start(-1)).node;
  for (; a && a.nodeName != "TABLE"; ) a = a.parentNode;
  a && $C(r, a.firstChild, a, n, o, A);
}
function ZO(t) {
  return Array(t).fill(0);
}
function qO(t, e) {
  const A = [], n = t.doc.resolve(e), s = n.node(-1);
  if (!s) return It.empty;
  const r = BA.get(s), i = n.start(-1), o = r.colCount(n.pos - i) + n.nodeAfter.attrs.colspan - 1;
  for (let c = 0; c < r.height; c++) {
    const l = o + c * r.width;
    if ((o == r.width - 1 || r.map[l] != r.map[l + 1]) && (c == 0 || r.map[l] != r.map[l - r.width])) {
      var a;
      const B = r.map[l], g = i + B + s.nodeAt(B).nodeSize - 1, h = document.createElement("div");
      h.className = "column-resize-handle", !((a = ls.getState(t)) === null || a === void 0) && a.dragging && A.push(Wt.node(i + B, i + B + s.nodeAt(B).nodeSize, { class: "column-resize-dragging" })), A.push(Wt.widget(g, h));
    }
  }
  return It.create(t.doc, A);
}
function _O({ allowTableNodeSelection: t = !1 } = {}) {
  return new ct({
    key: Fo,
    state: {
      init() {
        return null;
      },
      apply(e, A) {
        const n = e.getMeta(Fo);
        if (n != null) return n == -1 ? null : n;
        if (A == null || !e.docChanged) return A;
        const { deleted: s, pos: r } = e.mapping.mapResult(A);
        return s ? null : r;
      }
    },
    props: {
      decorations: BO,
      handleDOMEvents: { mousedown: LO },
      createSelectionBetween(e) {
        return Fo.getState(e.state) != null ? e.state.selection : null;
      },
      handleTripleClick: kO,
      handleKeyDown: HO,
      handlePaste: RO
    },
    appendTransaction(e, A, n) {
      return uO(n, iz(n, A), t);
    }
  });
}
function $O(t, e) {
  const A = Math.min(t.top, e.top), n = Math.max(t.bottom, e.bottom), s = Math.min(t.left, e.left), i = Math.max(t.right, e.right) - s, o = n - A, a = s, c = A;
  return new DOMRect(a, c, i, o);
}
var eP = class {
  constructor({
    editor: t,
    element: e,
    view: A,
    updateDelay: n = 250,
    resizeDelay: s = 60,
    shouldShow: r,
    appendTo: i,
    getReferencedVirtualElement: o,
    options: a
  }) {
    this.preventHide = !1, this.isVisible = !1, this.scrollTarget = window, this.floatingUIOptions = {
      strategy: "absolute",
      placement: "top",
      offset: 8,
      flip: {},
      shift: {},
      arrow: !1,
      size: !1,
      autoPlacement: !1,
      hide: !1,
      inline: !1,
      onShow: void 0,
      onHide: void 0,
      onUpdate: void 0,
      onDestroy: void 0
    }, this.shouldShow = ({ view: l, state: B, from: g, to: h }) => {
      const { doc: u, selection: d } = B, { empty: w } = d, Q = !u.textBetween(g, h).length && ip(B.selection), p = this.element.contains(document.activeElement);
      return !(!(l.hasFocus() || p) || w || Q || !this.editor.isEditable);
    }, this.mousedownHandler = () => {
      this.preventHide = !0;
    }, this.dragstartHandler = () => {
      this.hide();
    }, this.resizeHandler = () => {
      this.resizeDebounceTimer && clearTimeout(this.resizeDebounceTimer), this.resizeDebounceTimer = window.setTimeout(() => {
        this.updatePosition();
      }, this.resizeDelay);
    }, this.focusHandler = () => {
      setTimeout(() => this.update(this.editor.view));
    }, this.blurHandler = ({ event: l }) => {
      var B;
      if (this.editor.isDestroyed) {
        this.destroy();
        return;
      }
      if (this.preventHide) {
        this.preventHide = !1;
        return;
      }
      l != null && l.relatedTarget && ((B = this.element.parentNode) != null && B.contains(l.relatedTarget)) || (l == null ? void 0 : l.relatedTarget) !== this.editor.view.dom && this.hide();
    }, this.handleDebouncedUpdate = (l, B) => {
      const g = !(B != null && B.selection.eq(l.state.selection)), h = !(B != null && B.doc.eq(l.state.doc));
      !g && !h || (this.updateDebounceTimer && clearTimeout(this.updateDebounceTimer), this.updateDebounceTimer = window.setTimeout(() => {
        this.updateHandler(l, g, h, B);
      }, this.updateDelay));
    }, this.updateHandler = (l, B, g, h) => {
      const { composing: u } = l;
      if (u || !B && !g)
        return;
      if (!this.getShouldShow(h)) {
        this.hide();
        return;
      }
      this.updatePosition(), this.show();
    }, this.transactionHandler = ({ transaction: l }) => {
      const B = l.getMeta("bubbleMenu");
      B === "updatePosition" ? this.updatePosition() : B && typeof B == "object" && B.type === "updateOptions" && this.updateOptions(B.options);
    };
    var c;
    this.editor = t, this.element = e, this.view = A, this.updateDelay = n, this.resizeDelay = s, this.appendTo = i, this.scrollTarget = (c = a == null ? void 0 : a.scrollTarget) != null ? c : window, this.getReferencedVirtualElement = o, this.floatingUIOptions = {
      ...this.floatingUIOptions,
      ...a
    }, this.element.tabIndex = 0, r && (this.shouldShow = r), this.element.addEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.addEventListener("dragstart", this.dragstartHandler), this.editor.on("focus", this.focusHandler), this.editor.on("blur", this.blurHandler), this.editor.on("transaction", this.transactionHandler), window.addEventListener("resize", this.resizeHandler), this.scrollTarget.addEventListener("scroll", this.resizeHandler), this.update(A, A.state), this.getShouldShow() && (this.show(), this.updatePosition());
  }
  get middlewares() {
    const t = [];
    return this.floatingUIOptions.flip && t.push(qW(typeof this.floatingUIOptions.flip != "boolean" ? this.floatingUIOptions.flip : void 0)), this.floatingUIOptions.shift && t.push(
      ZW(typeof this.floatingUIOptions.shift != "boolean" ? this.floatingUIOptions.shift : void 0)
    ), this.floatingUIOptions.offset && t.push(
      VW(typeof this.floatingUIOptions.offset != "boolean" ? this.floatingUIOptions.offset : void 0)
    ), this.floatingUIOptions.arrow && t.push(eO(this.floatingUIOptions.arrow)), this.floatingUIOptions.size && t.push(_W(typeof this.floatingUIOptions.size != "boolean" ? this.floatingUIOptions.size : void 0)), this.floatingUIOptions.autoPlacement && t.push(
      XW(
        typeof this.floatingUIOptions.autoPlacement != "boolean" ? this.floatingUIOptions.autoPlacement : void 0
      )
    ), this.floatingUIOptions.hide && t.push($W(typeof this.floatingUIOptions.hide != "boolean" ? this.floatingUIOptions.hide : void 0)), this.floatingUIOptions.inline && t.push(
      tO(typeof this.floatingUIOptions.inline != "boolean" ? this.floatingUIOptions.inline : void 0)
    ), t;
  }
  get virtualElement() {
    var t, e, A;
    const { selection: n } = this.editor.state, s = (t = this.getReferencedVirtualElement) == null ? void 0 : t.call(this);
    if (s)
      return s;
    if (!((A = (e = this.view) == null ? void 0 : e.dom) != null && A.parentNode))
      return;
    const r = iJ(this.view, n.from, n.to);
    let i = {
      getBoundingClientRect: () => r,
      getClientRects: () => [r]
    };
    if (n instanceof Ue) {
      let o = this.view.nodeDOM(n.from);
      const a = o.dataset.nodeViewWrapper ? o : o.querySelector("[data-node-view-wrapper]");
      a && (o = a), o && (i = {
        getBoundingClientRect: () => o.getBoundingClientRect(),
        getClientRects: () => [o.getBoundingClientRect()]
      });
    }
    if (n instanceof St) {
      const { $anchorCell: o, $headCell: a } = n, c = o ? o.pos : a.pos, l = a ? a.pos : o.pos, B = this.view.nodeDOM(c), g = this.view.nodeDOM(l);
      if (!B || !g)
        return;
      const h = B === g ? B.getBoundingClientRect() : $O(
        B.getBoundingClientRect(),
        g.getBoundingClientRect()
      );
      i = {
        getBoundingClientRect: () => h,
        getClientRects: () => [h]
      };
    }
    return i;
  }
  updatePosition() {
    const t = this.virtualElement;
    t && tz(t, this.element, {
      placement: this.floatingUIOptions.placement,
      strategy: this.floatingUIOptions.strategy,
      middleware: this.middlewares
    }).then(({ x: e, y: A, strategy: n, middlewareData: s }) => {
      var r, i;
      if ((r = s.hide) != null && r.referenceHidden || (i = s.hide) != null && i.escaped) {
        this.element.style.visibility = "hidden";
        return;
      }
      this.element.style.visibility = "visible", this.element.style.width = "max-content", this.element.style.position = n, this.element.style.left = `${e}px`, this.element.style.top = `${A}px`, this.isVisible && this.floatingUIOptions.onUpdate && this.floatingUIOptions.onUpdate();
    });
  }
  update(t, e) {
    const { state: A } = t, n = A.selection.from !== A.selection.to;
    if (this.updateDelay > 0 && n) {
      this.handleDebouncedUpdate(t, e);
      return;
    }
    const s = !(e != null && e.selection.eq(t.state.selection)), r = !(e != null && e.doc.eq(t.state.doc));
    this.updateHandler(t, s, r, e);
  }
  getShouldShow(t) {
    var e;
    const { state: A } = this.view, { selection: n } = A, { ranges: s } = n, r = Math.min(...s.map((a) => a.$from.pos)), i = Math.max(...s.map((a) => a.$to.pos));
    return ((e = this.shouldShow) == null ? void 0 : e.call(this, {
      editor: this.editor,
      element: this.element,
      view: this.view,
      state: A,
      oldState: t,
      from: r,
      to: i
    })) || !1;
  }
  show() {
    var t;
    if (this.isVisible)
      return;
    this.element.style.visibility = "visible", this.element.style.opacity = "1";
    const e = typeof this.appendTo == "function" ? this.appendTo() : this.appendTo;
    (t = e ?? this.view.dom.parentElement) == null || t.appendChild(this.element), this.floatingUIOptions.onShow && this.floatingUIOptions.onShow(), this.isVisible = !0;
  }
  hide() {
    this.isVisible && (this.element.style.visibility = "hidden", this.element.style.opacity = "0", this.element.remove(), this.floatingUIOptions.onHide && this.floatingUIOptions.onHide(), this.isVisible = !1);
  }
  updateOptions(t) {
    var e;
    if (t.updateDelay !== void 0 && (this.updateDelay = t.updateDelay), t.resizeDelay !== void 0 && (this.resizeDelay = t.resizeDelay), t.appendTo !== void 0 && (this.appendTo = t.appendTo), t.getReferencedVirtualElement !== void 0 && (this.getReferencedVirtualElement = t.getReferencedVirtualElement), t.shouldShow !== void 0 && t.shouldShow && (this.shouldShow = t.shouldShow), t.options !== void 0) {
      const A = (e = t.options.scrollTarget) != null ? e : window;
      A !== this.scrollTarget && (this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.scrollTarget = A, this.scrollTarget.addEventListener("scroll", this.resizeHandler)), this.floatingUIOptions = {
        ...this.floatingUIOptions,
        ...t.options
      };
    }
  }
  destroy() {
    this.hide(), this.element.removeEventListener("mousedown", this.mousedownHandler, { capture: !0 }), this.view.dom.removeEventListener("dragstart", this.dragstartHandler), window.removeEventListener("resize", this.resizeHandler), this.scrollTarget.removeEventListener("scroll", this.resizeHandler), this.editor.off("focus", this.focusHandler), this.editor.off("blur", this.blurHandler), this.editor.off("transaction", this.transactionHandler), this.floatingUIOptions.onDestroy && this.floatingUIOptions.onDestroy();
  }
}, tP = (t) => new ct({
  key: typeof t.pluginKey == "string" ? new Bt(t.pluginKey) : t.pluginKey,
  view: (e) => new eP({ view: e, ...t })
}), AP = /* @__PURE__ */ Un({
  name: "BubbleMenu",
  inheritAttrs: !1,
  props: {
    pluginKey: {
      type: [String, Object],
      default: "bubbleMenu"
    },
    editor: {
      type: Object,
      required: !0
    },
    updateDelay: {
      type: Number,
      default: void 0
    },
    resizeDelay: {
      type: Number,
      default: void 0
    },
    options: {
      type: Object,
      default: () => ({})
    },
    appendTo: {
      type: [Object, Function],
      default: void 0
    },
    shouldShow: {
      type: Function,
      default: null
    },
    getReferencedVirtualElement: {
      type: Function,
      default: void 0
    }
  },
  setup(t, { slots: e, attrs: A }) {
    const n = /* @__PURE__ */ me(null);
    return Xr(() => {
      const {
        editor: s,
        options: r,
        pluginKey: i,
        resizeDelay: o,
        appendTo: a,
        shouldShow: c,
        getReferencedVirtualElement: l,
        updateDelay: B
      } = t, g = n.value;
      g && (g.style.visibility = "hidden", g.style.position = "absolute", g.remove(), Yn(() => {
        s.registerPlugin(
          tP({
            editor: s,
            element: g,
            options: r,
            pluginKey: i,
            resizeDelay: o,
            appendTo: a,
            shouldShow: c,
            getReferencedVirtualElement: l,
            updateDelay: B
          })
        );
      }));
    }), Zr(() => {
      const { pluginKey: s, editor: r } = t;
      r.unregisterPlugin(s);
    }), () => {
      var s;
      return GM("div", { ref: n, ...A }, (s = e.default) == null ? void 0 : s.call(e));
    };
  }
}), Ku = (t, e) => {
  if (t === "slot")
    return 0;
  if (t instanceof Function)
    return t(e);
  const { children: A, ...n } = e ?? {};
  if (t === "svg")
    throw new Error("SVG elements are not supported in the JSX syntax, use the array syntax instead");
  return [t, n, A];
}, nP = /^\s*>\s$/, sP = Zt.create({
  name: "blockquote",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  group: "block",
  defining: !0,
  parseHTML() {
    return [{ tag: "blockquote" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return /* @__PURE__ */ Ku("blockquote", { ...Ct(this.options.HTMLAttributes, t), children: /* @__PURE__ */ Ku("slot", {}) });
  },
  parseMarkdown: (t, e) => e.createNode("blockquote", void 0, e.parseChildren(t.tokens || [])),
  renderMarkdown: (t, e) => {
    if (!t.content)
      return "";
    const A = ">", n = [];
    return t.content.forEach((s) => {
      const o = e.renderChildren([s]).split(`
`).map((a) => a.trim() === "" ? A : `${A} ${a}`);
      n.push(o.join(`
`));
    }), n.join(`
${A}
`);
  },
  addCommands() {
    return {
      setBlockquote: () => ({ commands: t }) => t.wrapIn(this.name),
      toggleBlockquote: () => ({ commands: t }) => t.toggleWrap(this.name),
      unsetBlockquote: () => ({ commands: t }) => t.lift(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-b": () => this.editor.commands.toggleBlockquote()
    };
  },
  addInputRules() {
    return [
      ml({
        find: nP,
        type: this.type
      })
    ];
  }
}), rP = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))$/, iP = /(?:^|\s)(\*\*(?!\s+\*\*)((?:[^*]+))\*\*(?!\s+\*\*))/g, oP = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))$/, aP = /(?:^|\s)(__(?!\s+__)((?:[^_]+))__(?!\s+__))/g, cP = qr.create({
  name: "bold",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "strong"
      },
      {
        tag: "b",
        getAttrs: (t) => t.style.fontWeight !== "normal" && null
      },
      {
        style: "font-weight=400",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-weight",
        getAttrs: (t) => /^(bold(er)?|[5-9]\d{2,})$/.test(t) && null
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return /* @__PURE__ */ Ku("strong", { ...Ct(this.options.HTMLAttributes, t), children: /* @__PURE__ */ Ku("slot", {}) });
  },
  markdownTokenName: "strong",
  parseMarkdown: (t, e) => e.applyMark("bold", e.parseInline(t.tokens || [])),
  renderMarkdown: (t, e) => `**${e.renderChildren(t)}**`,
  addCommands() {
    return {
      setBold: () => ({ commands: t }) => t.setMark(this.name),
      toggleBold: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetBold: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-b": () => this.editor.commands.toggleBold(),
      "Mod-B": () => this.editor.commands.toggleBold()
    };
  },
  addInputRules() {
    return [
      _a({
        find: rP,
        type: this.type
      }),
      _a({
        find: oP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Xo({
        find: iP,
        type: this.type
      }),
      Xo({
        find: aP,
        type: this.type
      })
    ];
  }
}), lP = /(^|[^`])`([^`]+)`(?!`)$/, BP = /(^|[^`])`([^`]+)`(?!`)/g, gP = qr.create({
  name: "code",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  excludes: "_",
  code: !0,
  exitable: !0,
  parseHTML() {
    return [{ tag: "code" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["code", Ct(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "codespan",
  parseMarkdown: (t, e) => e.applyMark("code", [{ type: "text", text: t.text || "" }]),
  renderMarkdown: (t, e) => t.content ? `\`${e.renderChildren(t.content)}\`` : "",
  addCommands() {
    return {
      setCode: () => ({ commands: t }) => t.setMark(this.name),
      toggleCode: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetCode: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-e": () => this.editor.commands.toggleCode()
    };
  },
  addInputRules() {
    return [
      _a({
        find: lP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Xo({
        find: BP,
        type: this.type
      })
    ];
  }
}), bQ = 4, hP = /^```([a-z]+)?[\s\n]$/, uP = /^~~~([a-z]+)?[\s\n]$/, dP = Zt.create({
  name: "codeBlock",
  addOptions() {
    return {
      languageClassPrefix: "language-",
      exitOnTripleEnter: !0,
      exitOnArrowDown: !0,
      defaultLanguage: null,
      enableTabIndentation: !1,
      tabSize: bQ,
      HTMLAttributes: {}
    };
  },
  content: "text*",
  marks: "",
  group: "block",
  code: !0,
  defining: !0,
  addAttributes() {
    return {
      language: {
        default: this.options.defaultLanguage,
        parseHTML: (t) => {
          var e;
          const { languageClassPrefix: A } = this.options;
          if (!A)
            return null;
          const r = [...((e = t.firstElementChild) == null ? void 0 : e.classList) || []].filter((i) => i.startsWith(A)).map((i) => i.replace(A, ""))[0];
          return r || null;
        },
        rendered: !1
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "pre",
        preserveWhitespace: "full"
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "pre",
      Ct(this.options.HTMLAttributes, e),
      [
        "code",
        {
          class: t.attrs.language ? this.options.languageClassPrefix + t.attrs.language : null
        },
        0
      ]
    ];
  },
  markdownTokenName: "code",
  parseMarkdown: (t, e) => {
    var A;
    return ((A = t.raw) == null ? void 0 : A.startsWith("```")) === !1 && t.codeBlockStyle !== "indented" ? [] : e.createNode(
      "codeBlock",
      { language: t.lang || null },
      t.text ? [e.createTextNode(t.text)] : []
    );
  },
  renderMarkdown: (t, e) => {
    var A;
    let n = "";
    const s = ((A = t.attrs) == null ? void 0 : A.language) || "";
    return t.content ? n = [`\`\`\`${s}`, e.renderChildren(t.content), "```"].join(`
`) : n = `\`\`\`${s}

\`\`\``, n;
  },
  addCommands() {
    return {
      setCodeBlock: (t) => ({ commands: e }) => e.setNode(this.name, t),
      toggleCodeBlock: (t) => ({ commands: e }) => e.toggleNode(this.name, "paragraph", t)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-c": () => this.editor.commands.toggleCodeBlock(),
      // remove code block when at start of document or code block is empty
      Backspace: () => {
        const { empty: t, $anchor: e } = this.editor.state.selection, A = e.pos === 1;
        return !t || e.parent.type.name !== this.name ? !1 : A || !e.parent.textContent.length ? this.editor.commands.clearNodes() : !1;
      },
      // handle tab indentation
      Tab: ({ editor: t }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const A = (e = this.options.tabSize) != null ? e : bQ, { state: n } = t, { selection: s } = n, { $from: r, empty: i } = s;
        if (r.parent.type !== this.type)
          return !1;
        const o = " ".repeat(A);
        return i ? t.commands.insertContent(o) : t.commands.command(({ tr: a }) => {
          const { from: c, to: l } = s, h = n.doc.textBetween(c, l, `
`, `
`).split(`
`).map((u) => o + u).join(`
`);
          return a.replaceWith(c, l, n.schema.text(h)), !0;
        });
      },
      // handle shift+tab reverse indentation
      "Shift-Tab": ({ editor: t }) => {
        var e;
        if (!this.options.enableTabIndentation)
          return !1;
        const A = (e = this.options.tabSize) != null ? e : bQ, { state: n } = t, { selection: s } = n, { $from: r, empty: i } = s;
        return r.parent.type !== this.type ? !1 : i ? t.commands.command(({ tr: o }) => {
          var a;
          const { pos: c } = r, l = r.start(), B = r.end(), h = n.doc.textBetween(l, B, `
`, `
`).split(`
`);
          let u = 0, d = 0;
          const w = c - l;
          for (let m = 0; m < h.length; m += 1) {
            if (d + h[m].length >= w) {
              u = m;
              break;
            }
            d += h[m].length + 1;
          }
          const p = ((a = h[u].match(/^ */)) == null ? void 0 : a[0]) || "", M = Math.min(p.length, A);
          if (M === 0)
            return !0;
          let I = l;
          for (let m = 0; m < u; m += 1)
            I += h[m].length + 1;
          return o.delete(I, I + M), c - I <= M && o.setSelection(Re.create(o.doc, I)), !0;
        }) : t.commands.command(({ tr: o }) => {
          const { from: a, to: c } = s, g = n.doc.textBetween(a, c, `
`, `
`).split(`
`).map((h) => {
            var u;
            const d = ((u = h.match(/^ */)) == null ? void 0 : u[0]) || "", w = Math.min(d.length, A);
            return h.slice(w);
          }).join(`
`);
          return o.replaceWith(a, c, n.schema.text(g)), !0;
        });
      },
      // exit node on triple enter
      Enter: ({ editor: t }) => {
        if (!this.options.exitOnTripleEnter)
          return !1;
        const { state: e } = t, { selection: A } = e, { $from: n, empty: s } = A;
        if (!s || n.parent.type !== this.type)
          return !1;
        const r = n.parentOffset === n.parent.nodeSize - 2, i = n.parent.textContent.endsWith(`

`);
        return !r || !i ? !1 : t.chain().command(({ tr: o }) => (o.delete(n.pos - 2, n.pos), !0)).exitCode().run();
      },
      // exit node on arrow down
      ArrowDown: ({ editor: t }) => {
        if (!this.options.exitOnArrowDown)
          return !1;
        const { state: e } = t, { selection: A, doc: n } = e, { $from: s, empty: r } = A;
        if (!r || s.parent.type !== this.type || !(s.parentOffset === s.parent.nodeSize - 2))
          return !1;
        const o = s.after();
        return o === void 0 ? !1 : n.nodeAt(o) ? t.commands.command(({ tr: c }) => (c.setSelection(Ke.near(n.resolve(o))), !0)) : t.commands.exitCode();
      }
    };
  },
  addInputRules() {
    return [
      OC({
        find: hP,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      }),
      OC({
        find: uP,
        type: this.type,
        getAttributes: (t) => ({
          language: t[1]
        })
      })
    ];
  },
  addProseMirrorPlugins() {
    return [
      // this plugin creates a code block for pasted content from VS Code
      // we can also detect the copied code language
      new ct({
        key: new Bt("codeBlockVSCodeHandler"),
        props: {
          handlePaste: (t, e) => {
            if (!e.clipboardData || this.editor.isActive(this.type.name))
              return !1;
            const A = e.clipboardData.getData("text/plain"), n = e.clipboardData.getData("vscode-editor-data"), s = n ? JSON.parse(n) : void 0, r = s == null ? void 0 : s.mode;
            if (!A || !r)
              return !1;
            const { tr: i, schema: o } = t.state, a = o.text(A.replace(/\r\n?/g, `
`));
            return i.replaceSelectionWith(this.type.create({ language: r }, a)), i.selection.$from.parent.type !== this.type && i.setSelection(Re.near(i.doc.resolve(Math.max(0, i.selection.from - 2)))), i.setMeta("paste", !0), t.dispatch(i), !0;
          }
        }
      })
    ];
  }
}), wP = Zt.create({
  name: "doc",
  topNode: !0,
  content: "block+",
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `

`) : ""
}), fP = Zt.create({
  name: "hardBreak",
  markdownTokenName: "br",
  addOptions() {
    return {
      keepMarks: !0,
      HTMLAttributes: {}
    };
  },
  inline: !0,
  group: "inline",
  selectable: !1,
  linebreakReplacement: !0,
  parseHTML() {
    return [{ tag: "br" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["br", Ct(this.options.HTMLAttributes, t)];
  },
  renderText() {
    return `
`;
  },
  renderMarkdown: () => `  
`,
  parseMarkdown: () => ({
    type: "hardBreak"
  }),
  addCommands() {
    return {
      setHardBreak: () => ({ commands: t, chain: e, state: A, editor: n }) => t.first([
        () => t.exitCode(),
        () => t.command(() => {
          const { selection: s, storedMarks: r } = A;
          if (s.$from.parent.type.spec.isolating)
            return !1;
          const { keepMarks: i } = this.options, { splittableMarks: o } = n.extensionManager, a = r || s.$to.parentOffset && s.$from.marks();
          return e().insertContent({ type: this.name }).command(({ tr: c, dispatch: l }) => {
            if (l && a && i) {
              const B = a.filter((g) => o.includes(g.type.name));
              c.ensureMarks(B);
            }
            return !0;
          }).run();
        })
      ])
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Enter": () => this.editor.commands.setHardBreak(),
      "Shift-Enter": () => this.editor.commands.setHardBreak()
    };
  }
}), QP = Zt.create({
  name: "heading",
  addOptions() {
    return {
      levels: [1, 2, 3, 4, 5, 6],
      HTMLAttributes: {}
    };
  },
  content: "inline*",
  group: "block",
  defining: !0,
  addAttributes() {
    return {
      level: {
        default: 1,
        rendered: !1
      }
    };
  },
  parseHTML() {
    return this.options.levels.map((t) => ({
      tag: `h${t}`,
      attrs: { level: t }
    }));
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [`h${this.options.levels.includes(t.attrs.level) ? t.attrs.level : this.options.levels[0]}`, Ct(this.options.HTMLAttributes, e), 0];
  },
  parseMarkdown: (t, e) => e.createNode("heading", { level: t.depth || 1 }, e.parseInline(t.tokens || [])),
  renderMarkdown: (t, e) => {
    var A;
    const n = (A = t.attrs) != null && A.level ? parseInt(t.attrs.level, 10) : 1, s = "#".repeat(n);
    return t.content ? `${s} ${e.renderChildren(t.content)}` : "";
  },
  addCommands() {
    return {
      setHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.setNode(this.name, t) : !1,
      toggleHeading: (t) => ({ commands: e }) => this.options.levels.includes(t.level) ? e.toggleNode(this.name, "paragraph", t) : !1
    };
  },
  addKeyboardShortcuts() {
    return this.options.levels.reduce(
      (t, e) => ({
        ...t,
        [`Mod-Alt-${e}`]: () => this.editor.commands.toggleHeading({ level: e })
      }),
      {}
    );
  },
  addInputRules() {
    return this.options.levels.map((t) => OC({
      find: new RegExp(`^(#{${Math.min(...this.options.levels)},${t}})\\s$`),
      type: this.type,
      getAttributes: {
        level: t
      }
    }));
  }
}), IP = Zt.create({
  name: "horizontalRule",
  addOptions() {
    return {
      HTMLAttributes: {},
      nextNodeType: "paragraph"
    };
  },
  group: "block",
  parseHTML() {
    return [{ tag: "hr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["hr", Ct(this.options.HTMLAttributes, t)];
  },
  markdownTokenName: "hr",
  parseMarkdown: (t, e) => e.createNode("horizontalRule"),
  renderMarkdown: () => "---",
  addCommands() {
    return {
      setHorizontalRule: () => ({ chain: t, state: e }) => {
        if (!WJ(e, e.schema.nodes[this.name]))
          return !1;
        const { selection: A } = e, { $to: n } = A, s = t();
        return CG(A) ? s.insertContentAt(n.pos, {
          type: this.name
        }) : s.insertContent({ type: this.name }), s.command(({ state: r, tr: i, dispatch: o }) => {
          if (o) {
            const { $to: a } = i.selection, c = a.end();
            if (a.nodeAfter)
              a.nodeAfter.isTextblock ? i.setSelection(Re.create(i.doc, a.pos + 1)) : a.nodeAfter.isBlock ? i.setSelection(Ue.create(i.doc, a.pos)) : i.setSelection(Re.create(i.doc, a.pos));
            else {
              const l = r.schema.nodes[this.options.nextNodeType] || a.parent.type.contentMatch.defaultType, B = l == null ? void 0 : l.create();
              B && (i.insert(c, B), i.setSelection(Re.create(i.doc, c + 1)));
            }
            i.scrollIntoView();
          }
          return !0;
        }).run();
      }
    };
  },
  addInputRules() {
    return [
      kG({
        find: /^(?:---|—-|___\s|\*\*\*\s)$/,
        type: this.type
      })
    ];
  }
}), CP = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))$/, EP = /(?:^|\s)(\*(?!\s+\*)((?:[^*]+))\*(?!\s+\*))/g, MP = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))$/, pP = /(?:^|\s)(_(?!\s+_)((?:[^_]+))_(?!\s+_))/g, mP = qr.create({
  name: "italic",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "em"
      },
      {
        tag: "i",
        getAttrs: (t) => t.style.fontStyle !== "normal" && null
      },
      {
        style: "font-style=normal",
        clearMark: (t) => t.type.name === this.name
      },
      {
        style: "font-style=italic"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["em", Ct(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      setItalic: () => ({ commands: t }) => t.setMark(this.name),
      toggleItalic: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetItalic: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  markdownTokenName: "em",
  parseMarkdown: (t, e) => e.applyMark("italic", e.parseInline(t.tokens || [])),
  renderMarkdown: (t, e) => `*${e.renderChildren(t)}*`,
  addKeyboardShortcuts() {
    return {
      "Mod-i": () => this.editor.commands.toggleItalic(),
      "Mod-I": () => this.editor.commands.toggleItalic()
    };
  },
  addInputRules() {
    return [
      _a({
        find: CP,
        type: this.type
      }),
      _a({
        find: MP,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Xo({
        find: EP,
        type: this.type
      }),
      Xo({
        find: pP,
        type: this.type
      })
    ];
  }
});
const YP = "aaa1rp3bb0ott3vie4c1le2ogado5udhabi7c0ademy5centure6ountant0s9o1tor4d0s1ult4e0g1ro2tna4f0l1rica5g0akhan5ency5i0g1rbus3force5tel5kdn3l0ibaba4pay4lfinanz6state5y2sace3tom5m0azon4ericanexpress7family11x2fam3ica3sterdam8nalytics7droid5quan4z2o0l2partments8p0le4q0uarelle8r0ab1mco4chi3my2pa2t0e3s0da2ia2sociates9t0hleta5torney7u0ction5di0ble3o3spost5thor3o0s4w0s2x0a2z0ure5ba0by2idu3namex4d1k2r0celona5laycard4s5efoot5gains6seball5ketball8uhaus5yern5b0c1t1va3cg1n2d1e0ats2uty4er2rlin4st0buy5t2f1g1h0arti5i0ble3d1ke2ng0o3o1z2j1lack0friday9ockbuster8g1omberg7ue3m0s1w2n0pparibas9o0ats3ehringer8fa2m1nd2o0k0ing5sch2tik2on4t1utique6x2r0adesco6idgestone9oadway5ker3ther5ussels7s1t1uild0ers6siness6y1zz3v1w1y1z0h3ca0b1fe2l0l1vinklein9m0era3p2non3petown5ital0one8r0avan4ds2e0er0s4s2sa1e1h1ino4t0ering5holic7ba1n1re3c1d1enter4o1rn3f0a1d2g1h0anel2nel4rity4se2t2eap3intai5ristmas6ome4urch5i0priani6rcle4sco3tadel4i0c2y3k1l0aims4eaning6ick2nic1que6othing5ud3ub0med6m1n1o0ach3des3ffee4llege4ogne5m0mbank4unity6pany2re3uter5sec4ndos3struction8ulting7tact3ractors9oking4l1p2rsica5untry4pon0s4rses6pa2r0edit0card4union9icket5own3s1uise0s6u0isinella9v1w1x1y0mru3ou3z2dad1nce3ta1e1ing3sun4y2clk3ds2e0al0er2s3gree4livery5l1oitte5ta3mocrat6ntal2ist5si0gn4v2hl2iamonds6et2gital5rect0ory7scount3ver5h2y2j1k1m1np2o0cs1tor4g1mains5t1wnload7rive4tv2ubai3nlop4pont4rban5vag2r2z2earth3t2c0o2deka3u0cation8e1g1mail3erck5nergy4gineer0ing9terprises10pson4quipment8r0icsson6ni3s0q1tate5t1u0rovision8s2vents5xchange6pert3osed4ress5traspace10fage2il1rwinds6th3mily4n0s2rm0ers5shion4t3edex3edback6rrari3ero6i0delity5o2lm2nal1nce1ial7re0stone6mdale6sh0ing5t0ness6j1k1lickr3ghts4r2orist4wers5y2m1o0o0d1tball6rd1ex2sale4um3undation8x2r0ee1senius7l1ogans4ntier7tr2ujitsu5n0d2rniture7tbol5yi3ga0l0lery3o1up4me0s3p1rden4y2b0iz3d0n2e0a1nt0ing5orge5f1g0ee3h1i0ft0s3ves2ing5l0ass3e1obal2o4m0ail3bh2o1x2n1odaddy5ld0point6f2o0dyear5g0le4p1t1v2p1q1r0ainger5phics5tis4een3ipe3ocery4up4s1t1u0cci3ge2ide2tars5ru3w1y2hair2mburg5ngout5us3bo2dfc0bank7ealth0care8lp1sinki6re1mes5iphop4samitsu7tachi5v2k0t2m1n1ockey4ldings5iday5medepot5goods5s0ense7nda3rse3spital5t0ing5t0els3mail5use3w2r1sbc3t1u0ghes5yatt3undai7ibm2cbc2e1u2d1e0ee3fm2kano4l1m0amat4db2mo0bilien9n0c1dustries8finiti5o2g1k1stitute6urance4e4t0ernational10uit4vestments10o1piranga7q1r0ish4s0maili5t0anbul7t0au2v3jaguar4va3cb2e0ep2tzt3welry6io2ll2m0p2nj2o0bs1urg4t1y2p0morgan6rs3uegos4niper7kaufen5ddi3e0rryhotels6properties14fh2g1h1i0a1ds2m1ndle4tchen5wi3m1n1oeln3matsu5sher5p0mg2n2r0d1ed3uokgroup8w1y0oto4z2la0caixa5mborghini8er3nd0rover6xess5salle5t0ino3robe5w0yer5b1c1ds2ease3clerc5frak4gal2o2xus4gbt3i0dl2fe0insurance9style7ghting6ke2lly3mited4o2ncoln4k2ve1ing5k1lc1p2oan0s3cker3us3l1ndon4tte1o3ve3pl0financial11r1s1t0d0a3u0ndbeck6xe1ury5v1y2ma0drid4if1son4keup4n0agement7go3p1rket0ing3s4riott5shalls7ttel5ba2c0kinsey7d1e0d0ia3et2lbourne7me1orial6n0u2rckmsd7g1h1iami3crosoft7l1ni1t2t0subishi9k1l0b1s2m0a2n1o0bi0le4da2e1i1m1nash3ey2ster5rmon3tgage6scow4to0rcycles9v0ie4p1q1r1s0d2t0n1r2u0seum3ic4v1w1x1y1z2na0b1goya4me2vy3ba2c1e0c1t0bank4flix4work5ustar5w0s2xt0direct7us4f0l2g0o2hk2i0co2ke1on3nja3ssan1y5l1o0kia3rton4w0ruz3tv4p1r0a1w2tt2u1yc2z2obi1server7ffice5kinawa6layan0group9lo3m0ega4ne1g1l0ine5oo2pen3racle3nge4g0anic5igins6saka4tsuka4t2vh3pa0ge2nasonic7ris2s1tners4s1y3y2ccw3e0t2f0izer5g1h0armacy6d1ilips5one2to0graphy6s4ysio5ics1tet2ures6d1n0g1k2oneer5zza4k1l0ace2y0station9umbing5s3m1n0c2ohl2ker3litie5rn2st3r0axi3ess3ime3o0d0uctions8f1gressive8mo2perties3y5tection8u0dential9s1t1ub2w0c2y2qa1pon3uebec3st5racing4dio4e0ad1lestate6tor2y4cipes5d0stone5umbrella9hab3ise0n3t2liance6n0t0als5pair3ort3ublican8st0aurant8view0s5xroth6ich0ardli6oh3l1o1p2o0cks3deo3gers4om3s0vp3u0gby3hr2n2w0e2yukyu6sa0arland6fe0ty4kura4le1on3msclub4ung5ndvik0coromant12ofi4p1rl2s1ve2xo3b0i1s2c0b1haeffler7midt4olarships8ol3ule3warz5ience5ot3d1e0arch3t2cure1ity6ek2lect4ner3rvices6ven3w1x0y3fr2g1h0angrila6rp3ell3ia1ksha5oes2p0ping5uji3w3i0lk2na1gles5te3j1k0i0n2y0pe4l0ing4m0art3ile4n0cf3o0ccer3ial4ftbank4ware6hu2lar2utions7ng1y2y2pa0ce3ort2t3r0l2s1t0ada2ples4r1tebank4farm7c0group6ockholm6rage3e3ream4udio2y3yle4u0cks3pplies3y2ort5rf1gery5zuki5v1watch4iss4x1y0dney4stems6z2tab1ipei4lk2obao4rget4tamotors6r2too4x0i3c0i2d0k2eam2ch0nology8l1masek5nnis4va3f1g1h0d1eater2re6iaa2ckets5enda4ps2res2ol4j0maxx4x2k0maxx5l1m0all4n1o0day3kyo3ols3p1ray3shiba5tal3urs3wn2yota3s3r0ade1ing4ining5vel0ers0insurance16ust3v2t1ube2i1nes3shu4v0s2w1z2ua1bank3s2g1k1nicom3versity8o2ol2ps2s1y1z2va0cations7na1guard7c1e0gas3ntures6risign5mögensberater2ung14sicherung10t2g1i0ajes4deo3g1king4llas4n1p1rgin4sa1ion4va1o3laanderen9n1odka3lvo3te1ing3o2yage5u2wales2mart4ter4ng0gou5tch0es6eather0channel12bcam3er2site5d0ding5ibo2r3f1hoswho6ien2ki2lliamhill9n0dows4e1ners6me2olterskluwer11odside6rk0s2ld3w2s1tc1f3xbox3erox4ihuan4n2xx2yz3yachts4hoo3maxun5ndex5e1odobashi7ga2kohama6u0tube6t1un3za0ppos4ra3ero3ip2m1one3uerich6w2", yP = "ελ1υ2бг1ел3дети4ею2католик6ом3мкд2он1сква6онлайн5рг3рус2ф2сайт3рб3укр3қаз3հայ3ישראל5קום3ابوظبي5رامكو5لاردن4بحرين5جزائر5سعودية6عليان5مغرب5مارات5یران5بارت2زار4يتك3ھارت5تونس4سودان3رية5شبكة4عراق2ب2مان4فلسطين6قطر3كاثوليك6وم3مصر2ليسيا5وريتانيا7قع4همراه5پاکستان7ڀارت4कॉम3नेट3भारत0म्3ोत5संगठन5বাংলা5ভারত2ৰত4ਭਾਰਤ4ભારત4ଭାରତ4இந்தியா6லங்கை6சிங்கப்பூர்11భారత్5ಭಾರತ4ഭാരതം5ලංකා4คอม3ไทย3ລາວ3გე2みんな3アマゾン4クラウド4グーグル4コム2ストア3セール3ファッション6ポイント4世界2中信1国1國1文网3亚马逊3企业2佛山2信息2健康2八卦2公司1益2台湾1灣2商城1店1标2嘉里0大酒店5在线2大拿2天主教3娱乐2家電2广东2微博2慈善2我爱你3手机2招聘2政务1府2新加坡2闻2时尚2書籍2机构2淡马锡3游戏2澳門2点看2移动2组织机构4网址1店1站1络2联通2谷歌2购物2通販2集团2電訊盈科4飞利浦3食品2餐厅2香格里拉3港2닷넷1컴2삼성2한국2", eE = "numeric", tE = "ascii", AE = "alpha", PB = "asciinumeric", mB = "alphanumeric", nE = "domain", Bz = "emoji", FP = "scheme", NP = "slashscheme", vQ = "whitespace";
function DP(t, e) {
  return t in e || (e[t] = []), e[t];
}
function ja(t, e, A) {
  e[eE] && (e[PB] = !0, e[mB] = !0), e[tE] && (e[PB] = !0, e[AE] = !0), e[PB] && (e[mB] = !0), e[AE] && (e[mB] = !0), e[mB] && (e[nE] = !0), e[Bz] && (e[nE] = !0);
  for (const n in e) {
    const s = DP(n, A);
    s.indexOf(t) < 0 && s.push(t);
  }
}
function xP(t, e) {
  const A = {};
  for (const n in e)
    e[n].indexOf(t) >= 0 && (A[n] = !0);
  return A;
}
function Pn(t = null) {
  this.j = {}, this.jr = [], this.jd = null, this.t = t;
}
Pn.groups = {};
Pn.prototype = {
  accepts() {
    return !!this.t;
  },
  /**
   * Follow an existing transition from the given input to the next state.
   * Does not mutate.
   * @param {string} input character or token type to transition on
   * @returns {?State<T>} the next state, if any
   */
  go(t) {
    const e = this, A = e.j[t];
    if (A)
      return A;
    for (let n = 0; n < e.jr.length; n++) {
      const s = e.jr[n][0], r = e.jr[n][1];
      if (r && s.test(t))
        return r;
    }
    return e.jd;
  },
  /**
   * Whether the state has a transition for the given input. Set the second
   * argument to true to only look for an exact match (and not a default or
   * regular-expression-based transition)
   * @param {string} input
   * @param {boolean} exactOnly
   */
  has(t, e = !1) {
    return e ? t in this.j : !!this.go(t);
  },
  /**
   * Short for "transition all"; create a transition from the array of items
   * in the given list to the same final resulting state.
   * @param {string | string[]} inputs Group of inputs to transition on
   * @param {Transition<T> | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   */
  ta(t, e, A, n) {
    for (let s = 0; s < t.length; s++)
      this.tt(t[s], e, A, n);
  },
  /**
   * Short for "take regexp transition"; defines a transition for this state
   * when it encounters a token which matches the given regular expression
   * @param {RegExp} regexp Regular expression transition (populate first)
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  tr(t, e, A, n) {
    n = n || Pn.groups;
    let s;
    return e && e.j ? s = e : (s = new Pn(e), A && n && ja(e, A, n)), this.jr.push([t, s]), s;
  },
  /**
   * Short for "take transitions", will take as many sequential transitions as
   * the length of the given input and returns the
   * resulting final state.
   * @param {string | string[]} input
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of token groups
   * @returns {State<T>} taken after the given input
   */
  ts(t, e, A, n) {
    let s = this;
    const r = t.length;
    if (!r)
      return s;
    for (let i = 0; i < r - 1; i++)
      s = s.tt(t[i]);
    return s.tt(t[r - 1], e, A, n);
  },
  /**
   * Short for "take transition", this is a method for building/working with
   * state machines.
   *
   * If a state already exists for the given input, returns it.
   *
   * If a token is specified, that state will emit that token when reached by
   * the linkify engine.
   *
   * If no state exists, it will be initialized with some default transitions
   * that resemble existing default transitions.
   *
   * If a state is given for the second argument, that state will be
   * transitioned to on the given input regardless of what that input
   * previously did.
   *
   * Specify a token group flags to define groups that this token belongs to.
   * The token will be added to corresponding entires in the given groups
   * object.
   *
   * @param {string} input character, token type to transition on
   * @param {T | State<T>} [next] Transition options
   * @param {Flags} [flags] Collections flags to add token to
   * @param {Collections<T>} [groups] Master list of groups
   * @returns {State<T>} taken after the given input
   */
  tt(t, e, A, n) {
    n = n || Pn.groups;
    const s = this;
    if (e && e.j)
      return s.j[t] = e, e;
    const r = e;
    let i, o = s.go(t);
    if (o ? (i = new Pn(), Object.assign(i.j, o.j), i.jr.push.apply(i.jr, o.jr), i.jd = o.jd, i.t = o.t) : i = new Pn(), r) {
      if (n)
        if (i.t && typeof i.t == "string") {
          const a = Object.assign(xP(i.t, n), A);
          ja(r, a, n);
        } else A && ja(r, A, n);
      i.t = r;
    }
    return s.j[t] = i, i;
  }
};
const at = (t, e, A, n, s) => t.ta(e, A, n, s), oA = (t, e, A, n, s) => t.tr(e, A, n, s), M1 = (t, e, A, n, s) => t.ts(e, A, n, s), ue = (t, e, A, n, s) => t.tt(e, A, n, s), Qi = "WORD", sE = "UWORD", gz = "ASCIINUMERICAL", hz = "ALPHANUMERICAL", zg = "LOCALHOST", rE = "TLD", iE = "UTLD", tu = "SCHEME", Jc = "SLASH_SCHEME", Ep = "NUM", oE = "WS", Mp = "NL", KB = "OPENBRACE", VB = "CLOSEBRACE", Vu = "OPENBRACKET", Xu = "CLOSEBRACKET", Zu = "OPENPAREN", qu = "CLOSEPAREN", _u = "OPENANGLEBRACKET", $u = "CLOSEANGLEBRACKET", ed = "FULLWIDTHLEFTPAREN", td = "FULLWIDTHRIGHTPAREN", Ad = "LEFTCORNERBRACKET", nd = "RIGHTCORNERBRACKET", sd = "LEFTWHITECORNERBRACKET", rd = "RIGHTWHITECORNERBRACKET", id = "FULLWIDTHLESSTHAN", od = "FULLWIDTHGREATERTHAN", ad = "AMPERSAND", cd = "APOSTROPHE", ld = "ASTERISK", po = "AT", Bd = "BACKSLASH", gd = "BACKTICK", hd = "CARET", No = "COLON", pp = "COMMA", ud = "DOLLAR", Mr = "DOT", dd = "EQUALS", mp = "EXCLAMATION", Ms = "HYPHEN", XB = "PERCENT", wd = "PIPE", fd = "PLUS", Qd = "POUND", ZB = "QUERY", Yp = "QUOTE", uz = "FULLWIDTHMIDDLEDOT", yp = "SEMI", pr = "SLASH", qB = "TILDE", Id = "UNDERSCORE", dz = "EMOJI", Cd = "SYM";
var wz = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ALPHANUMERICAL: hz,
  AMPERSAND: ad,
  APOSTROPHE: cd,
  ASCIINUMERICAL: gz,
  ASTERISK: ld,
  AT: po,
  BACKSLASH: Bd,
  BACKTICK: gd,
  CARET: hd,
  CLOSEANGLEBRACKET: $u,
  CLOSEBRACE: VB,
  CLOSEBRACKET: Xu,
  CLOSEPAREN: qu,
  COLON: No,
  COMMA: pp,
  DOLLAR: ud,
  DOT: Mr,
  EMOJI: dz,
  EQUALS: dd,
  EXCLAMATION: mp,
  FULLWIDTHGREATERTHAN: od,
  FULLWIDTHLEFTPAREN: ed,
  FULLWIDTHLESSTHAN: id,
  FULLWIDTHMIDDLEDOT: uz,
  FULLWIDTHRIGHTPAREN: td,
  HYPHEN: Ms,
  LEFTCORNERBRACKET: Ad,
  LEFTWHITECORNERBRACKET: sd,
  LOCALHOST: zg,
  NL: Mp,
  NUM: Ep,
  OPENANGLEBRACKET: _u,
  OPENBRACE: KB,
  OPENBRACKET: Vu,
  OPENPAREN: Zu,
  PERCENT: XB,
  PIPE: wd,
  PLUS: fd,
  POUND: Qd,
  QUERY: ZB,
  QUOTE: Yp,
  RIGHTCORNERBRACKET: nd,
  RIGHTWHITECORNERBRACKET: rd,
  SCHEME: tu,
  SEMI: yp,
  SLASH: pr,
  SLASH_SCHEME: Jc,
  SYM: Cd,
  TILDE: qB,
  TLD: rE,
  UNDERSCORE: Id,
  UTLD: iE,
  UWORD: sE,
  WORD: Qi,
  WS: oE
});
const li = /[a-z]/, iB = new RegExp("\\p{L}", "u"), jQ = new RegExp("\\p{Emoji}", "u"), Bi = /\d/, HQ = /\s/, p1 = "\r", kQ = `
`, GP = "️", zP = "‍", RQ = "￼";
let B0 = null, g0 = null;
function UP(t = []) {
  const e = {};
  Pn.groups = e;
  const A = new Pn();
  B0 == null && (B0 = m1(YP)), g0 == null && (g0 = m1(yP)), ue(A, "'", cd), ue(A, "{", KB), ue(A, "}", VB), ue(A, "[", Vu), ue(A, "]", Xu), ue(A, "(", Zu), ue(A, ")", qu), ue(A, "<", _u), ue(A, ">", $u), ue(A, "（", ed), ue(A, "）", td), ue(A, "「", Ad), ue(A, "」", nd), ue(A, "『", sd), ue(A, "』", rd), ue(A, "＜", id), ue(A, "＞", od), ue(A, "&", ad), ue(A, "*", ld), ue(A, "@", po), ue(A, "`", gd), ue(A, "^", hd), ue(A, ":", No), ue(A, ",", pp), ue(A, "$", ud), ue(A, ".", Mr), ue(A, "=", dd), ue(A, "!", mp), ue(A, "-", Ms), ue(A, "%", XB), ue(A, "|", wd), ue(A, "+", fd), ue(A, "#", Qd), ue(A, "?", ZB), ue(A, '"', Yp), ue(A, "/", pr), ue(A, ";", yp), ue(A, "~", qB), ue(A, "_", Id), ue(A, "\\", Bd), ue(A, "・", uz);
  const n = oA(A, Bi, Ep, {
    [eE]: !0
  });
  oA(n, Bi, n);
  const s = oA(n, li, gz, {
    [PB]: !0
  }), r = oA(n, iB, hz, {
    [mB]: !0
  }), i = oA(A, li, Qi, {
    [tE]: !0
  });
  oA(i, Bi, s), oA(i, li, i), oA(s, Bi, s), oA(s, li, s);
  const o = oA(A, iB, sE, {
    [AE]: !0
  });
  oA(o, li), oA(o, Bi, r), oA(o, iB, o), oA(r, Bi, r), oA(r, li), oA(r, iB, r);
  const a = ue(A, kQ, Mp, {
    [vQ]: !0
  }), c = ue(A, p1, oE, {
    [vQ]: !0
  }), l = oA(A, HQ, oE, {
    [vQ]: !0
  });
  ue(A, RQ, l), ue(c, kQ, a), ue(c, RQ, l), oA(c, HQ, l), ue(l, p1), ue(l, kQ), oA(l, HQ, l), ue(l, RQ, l);
  const B = oA(A, jQ, dz, {
    [Bz]: !0
  });
  ue(B, "#"), oA(B, jQ, B), ue(B, GP, B);
  const g = ue(B, zP);
  ue(g, "#"), oA(g, jQ, B);
  const h = [[li, i], [Bi, s]], u = [[li, null], [iB, o], [Bi, r]];
  for (let d = 0; d < B0.length; d++)
    lo(A, B0[d], rE, Qi, h);
  for (let d = 0; d < g0.length; d++)
    lo(A, g0[d], iE, sE, u);
  ja(rE, {
    tld: !0,
    ascii: !0
  }, e), ja(iE, {
    utld: !0,
    alpha: !0
  }, e), lo(A, "file", tu, Qi, h), lo(A, "mailto", tu, Qi, h), lo(A, "http", Jc, Qi, h), lo(A, "https", Jc, Qi, h), lo(A, "ftp", Jc, Qi, h), lo(A, "ftps", Jc, Qi, h), ja(tu, {
    scheme: !0,
    ascii: !0
  }, e), ja(Jc, {
    slashscheme: !0,
    ascii: !0
  }, e), t = t.sort((d, w) => d[0] > w[0] ? 1 : -1);
  for (let d = 0; d < t.length; d++) {
    const w = t[d][0], p = t[d][1] ? {
      [FP]: !0
    } : {
      [NP]: !0
    };
    w.indexOf("-") >= 0 ? p[nE] = !0 : li.test(w) ? Bi.test(w) ? p[PB] = !0 : p[tE] = !0 : p[eE] = !0, M1(A, w, w, p);
  }
  return M1(A, "localhost", zg, {
    ascii: !0
  }), A.jd = new Pn(Cd), {
    start: A,
    tokens: Object.assign({
      groups: e
    }, wz)
  };
}
function fz(t, e) {
  const A = bP(e.replace(/[A-Z]/g, (o) => o.toLowerCase())), n = A.length, s = [];
  let r = 0, i = 0;
  for (; i < n; ) {
    let o = t, a = null, c = 0, l = null, B = -1, g = -1;
    for (; i < n && (a = o.go(A[i])); )
      o = a, o.accepts() ? (B = 0, g = 0, l = o) : B >= 0 && (B += A[i].length, g++), c += A[i].length, r += A[i].length, i++;
    r -= B, i -= g, c -= B, s.push({
      t: l.t,
      // token type/name
      v: e.slice(r - c, r),
      // string value
      s: r - c,
      // start index
      e: r
      // end index (excluding)
    });
  }
  return s;
}
function bP(t) {
  const e = [], A = t.length;
  let n = 0;
  for (; n < A; ) {
    let s = t.charCodeAt(n), r, i = s < 55296 || s > 56319 || n + 1 === A || (r = t.charCodeAt(n + 1)) < 56320 || r > 57343 ? t[n] : t.slice(n, n + 2);
    e.push(i), n += i.length;
  }
  return e;
}
function lo(t, e, A, n, s) {
  let r;
  const i = e.length;
  for (let o = 0; o < i - 1; o++) {
    const a = e[o];
    t.j[a] ? r = t.j[a] : (r = new Pn(n), r.jr = s.slice(), t.j[a] = r), t = r;
  }
  return r = new Pn(A), r.jr = s.slice(), t.j[e[i - 1]] = r, r;
}
function m1(t) {
  const e = [], A = [];
  let n = 0, s = "0123456789";
  for (; n < t.length; ) {
    let r = 0;
    for (; s.indexOf(t[n + r]) >= 0; )
      r++;
    if (r > 0) {
      e.push(A.join(""));
      for (let i = parseInt(t.substring(n, n + r), 10); i > 0; i--)
        A.pop();
      n += r;
    } else
      A.push(t[n]), n++;
  }
  return e;
}
const Ug = {
  defaultProtocol: "http",
  events: null,
  format: Y1,
  formatHref: Y1,
  nl2br: !1,
  tagName: "a",
  target: null,
  rel: null,
  validate: !0,
  truncate: 1 / 0,
  className: null,
  attributes: null,
  ignoreTags: [],
  render: null
};
function Fp(t, e = null) {
  let A = Object.assign({}, Ug);
  t && (A = Object.assign(A, t instanceof Fp ? t.o : t));
  const n = A.ignoreTags, s = [];
  for (let r = 0; r < n.length; r++)
    s.push(n[r].toUpperCase());
  this.o = A, e && (this.defaultRender = e), this.ignoreTags = s;
}
Fp.prototype = {
  o: Ug,
  /**
   * @type string[]
   */
  ignoreTags: [],
  /**
   * @param {IntermediateRepresentation} ir
   * @returns {any}
   */
  defaultRender(t) {
    return t;
  },
  /**
   * Returns true or false based on whether a token should be displayed as a
   * link based on the user options.
   * @param {MultiToken} token
   * @returns {boolean}
   */
  check(t) {
    return this.get("validate", t.toString(), t);
  },
  // Private methods
  /**
   * Resolve an option's value based on the value of the option and the given
   * params. If operator and token are specified and the target option is
   * callable, automatically calls the function with the given argument.
   * @template {keyof Opts} K
   * @param {K} key Name of option to use
   * @param {string} [operator] will be passed to the target option if it's a
   * function. If not specified, RAW function value gets returned
   * @param {MultiToken} [token] The token from linkify.tokenize
   * @returns {Opts[K] | any}
   */
  get(t, e, A) {
    const n = e != null;
    let s = this.o[t];
    return s && (typeof s == "object" ? (s = A.t in s ? s[A.t] : Ug[t], typeof s == "function" && n && (s = s(e, A))) : typeof s == "function" && n && (s = s(e, A.t, A)), s);
  },
  /**
   * @template {keyof Opts} L
   * @param {L} key Name of options object to use
   * @param {string} [operator]
   * @param {MultiToken} [token]
   * @returns {Opts[L] | any}
   */
  getObj(t, e, A) {
    let n = this.o[t];
    return typeof n == "function" && e != null && (n = n(e, A.t, A)), n;
  },
  /**
   * Convert the given token to a rendered element that may be added to the
   * calling-interface's DOM
   * @param {MultiToken} token Token to render to an HTML element
   * @returns {any} Render result; e.g., HTML string, DOM element, React
   *   Component, etc.
   */
  render(t) {
    const e = t.render(this);
    return (this.get("render", null, t) || this.defaultRender)(e, t.t, t);
  }
};
function Y1(t) {
  return t;
}
function Qz(t, e) {
  this.t = "token", this.v = t, this.tk = e;
}
Qz.prototype = {
  isLink: !1,
  /**
   * Return the string this token represents.
   * @return {string}
   */
  toString() {
    return this.v;
  },
  /**
   * What should the value for this token be in the `href` HTML attribute?
   * Returns the `.toString` value by default.
   * @param {string} [scheme]
   * @return {string}
   */
  toHref(t) {
    return this.toString();
  },
  /**
   * @param {Options} options Formatting options
   * @returns {string}
   */
  toFormattedString(t) {
    const e = this.toString(), A = t.get("truncate", e, this), n = t.get("format", e, this);
    return A && n.length > A ? n.substring(0, A) + "…" : n;
  },
  /**
   *
   * @param {Options} options
   * @returns {string}
   */
  toFormattedHref(t) {
    return t.get("formatHref", this.toHref(t.get("defaultProtocol")), this);
  },
  /**
   * The start index of this token in the original input string
   * @returns {number}
   */
  startIndex() {
    return this.tk[0].s;
  },
  /**
   * The end index of this token in the original input string (up to this
   * index but not including it)
   * @returns {number}
   */
  endIndex() {
    return this.tk[this.tk.length - 1].e;
  },
  /**
  	Returns an object  of relevant values for this token, which includes keys
  	* type - Kind of token ('url', 'email', etc.)
  	* value - Original text
  	* href - The value that should be added to the anchor tag's href
  		attribute
  		@method toObject
  	@param {string} [protocol] `'http'` by default
  */
  toObject(t = Ug.defaultProtocol) {
    return {
      type: this.t,
      value: this.toString(),
      isLink: this.isLink,
      href: this.toHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   *
   * @param {Options} options Formatting option
   */
  toFormattedObject(t) {
    return {
      type: this.t,
      value: this.toFormattedString(t),
      isLink: this.isLink,
      href: this.toFormattedHref(t),
      start: this.startIndex(),
      end: this.endIndex()
    };
  },
  /**
   * Whether this token should be rendered as a link according to the given options
   * @param {Options} options
   * @returns {boolean}
   */
  validate(t) {
    return t.get("validate", this.toString(), this);
  },
  /**
   * Return an object that represents how this link should be rendered.
   * @param {Options} options Formattinng options
   */
  render(t) {
    const e = this, A = this.toHref(t.get("defaultProtocol")), n = t.get("formatHref", A, this), s = t.get("tagName", A, e), r = this.toFormattedString(t), i = {}, o = t.get("className", A, e), a = t.get("target", A, e), c = t.get("rel", A, e), l = t.getObj("attributes", A, e), B = t.getObj("events", A, e);
    return i.href = n, o && (i.class = o), a && (i.target = a), c && (i.rel = c), l && Object.assign(i, l), {
      tagName: s,
      attributes: i,
      content: r,
      eventListeners: B
    };
  }
};
function Lw(t, e) {
  class A extends Qz {
    constructor(s, r) {
      super(s, r), this.t = t;
    }
  }
  for (const n in e)
    A.prototype[n] = e[n];
  return A.t = t, A;
}
const y1 = Lw("email", {
  isLink: !0,
  toHref() {
    return "mailto:" + this.toString();
  }
}), F1 = Lw("text"), vP = Lw("nl"), h0 = Lw("url", {
  isLink: !0,
  /**
  	Lowercases relevant parts of the domain and adds the protocol if
  	required. Note that this will not escape unsafe HTML characters in the
  	URL.
  		@param {string} [scheme] default scheme (e.g., 'https')
  	@return {string} the full href
  */
  toHref(t = Ug.defaultProtocol) {
    return this.hasProtocol() ? this.v : `${t}://${this.v}`;
  },
  /**
   * Check whether this URL token has a protocol
   * @return {boolean}
   */
  hasProtocol() {
    const t = this.tk;
    return t.length >= 2 && t[0].t !== zg && t[1].t === No;
  }
}), Cs = (t) => new Pn(t);
function jP({
  groups: t
}) {
  const e = t.domain.concat([ad, ld, po, Bd, gd, hd, ud, dd, Ms, Ep, XB, wd, fd, Qd, pr, Cd, qB, Id]), A = [cd, No, pp, Mr, mp, XB, ZB, Yp, yp, _u, $u, KB, VB, Xu, Vu, Zu, qu, ed, td, Ad, nd, sd, rd, id, od], n = [ad, cd, ld, Bd, gd, hd, ud, dd, Ms, KB, VB, XB, wd, fd, Qd, ZB, pr, Cd, qB, Id], s = Cs(), r = ue(s, qB);
  at(r, n, r), at(r, t.domain, r);
  const i = Cs(), o = Cs(), a = Cs();
  at(s, t.domain, i), at(s, t.scheme, o), at(s, t.slashscheme, a), at(i, n, r), at(i, t.domain, i);
  const c = ue(i, po);
  ue(r, po, c), ue(o, po, c), ue(a, po, c);
  const l = ue(r, Mr);
  at(l, n, r), at(l, t.domain, r);
  const B = Cs();
  at(c, t.domain, B), at(B, t.domain, B);
  const g = ue(B, Mr);
  at(g, t.domain, B);
  const h = Cs(y1);
  at(g, t.tld, h), at(g, t.utld, h), ue(c, zg, h);
  const u = ue(B, Ms);
  ue(u, Ms, u), at(u, t.domain, B), at(h, t.domain, B), ue(h, Mr, g), ue(h, Ms, u);
  const d = ue(h, No);
  at(d, t.numeric, y1);
  const w = ue(i, Ms), Q = ue(i, Mr);
  ue(w, Ms, w), at(w, t.domain, i), at(Q, n, r), at(Q, t.domain, i);
  const p = Cs(h0);
  at(Q, t.tld, p), at(Q, t.utld, p), at(p, t.domain, i), at(p, n, r), ue(p, Mr, Q), ue(p, Ms, w), ue(p, po, c);
  const M = ue(p, No), I = Cs(h0);
  at(M, t.numeric, I);
  const N = Cs(h0), m = Cs();
  at(N, e, N), at(N, A, m), at(m, e, N), at(m, A, m), ue(p, pr, N), ue(I, pr, N);
  const E = ue(o, No), G = ue(a, No), Y = ue(G, pr), U = ue(Y, pr);
  at(o, t.domain, i), ue(o, Mr, Q), ue(o, Ms, w), at(a, t.domain, i), ue(a, Mr, Q), ue(a, Ms, w), at(E, t.domain, N), ue(E, pr, N), ue(E, ZB, N), at(U, t.domain, N), at(U, e, N), ue(U, pr, N);
  const v = [
    [KB, VB],
    // {}
    [Vu, Xu],
    // []
    [Zu, qu],
    // ()
    [_u, $u],
    // <>
    [ed, td],
    // （）
    [Ad, nd],
    // 「」
    [sd, rd],
    // 『』
    [id, od]
    // ＜＞
  ];
  for (let b = 0; b < v.length; b++) {
    const [W, q] = v[b], ne = ue(N, W);
    ue(m, W, ne), ue(ne, q, N);
    const V = Cs(h0);
    at(ne, e, V);
    const se = Cs();
    at(ne, A), at(V, e, V), at(V, A, se), at(se, e, V), at(se, A, se), ue(V, q, N), ue(se, q, N);
  }
  return ue(s, zg, p), ue(s, Mp, vP), {
    start: s,
    tokens: wz
  };
}
function HP(t, e, A) {
  let n = A.length, s = 0, r = [], i = [];
  for (; s < n; ) {
    let o = t, a = null, c = null, l = 0, B = null, g = -1;
    for (; s < n && !(a = o.go(A[s].t)); )
      i.push(A[s++]);
    for (; s < n && (c = a || o.go(A[s].t)); )
      a = null, o = c, o.accepts() ? (g = 0, B = o) : g >= 0 && g++, s++, l++;
    if (g < 0)
      s -= l, s < n && (i.push(A[s]), s++);
    else {
      i.length > 0 && (r.push(LQ(F1, e, i)), i = []), s -= g, l -= g;
      const h = B.t, u = A.slice(s - l, s);
      r.push(LQ(h, e, u));
    }
  }
  return i.length > 0 && r.push(LQ(F1, e, i)), r;
}
function LQ(t, e, A) {
  const n = A[0].s, s = A[A.length - 1].e, r = e.slice(n, s);
  return new t(r, A);
}
const kP = typeof console < "u" && console && console.warn || (() => {
}), RP = "until manual call of linkify.init(). Register all schemes and plugins before invoking linkify the first time.", Vt = {
  scanner: null,
  parser: null,
  tokenQueue: [],
  pluginQueue: [],
  customSchemes: [],
  initialized: !1
};
function LP() {
  return Pn.groups = {}, Vt.scanner = null, Vt.parser = null, Vt.tokenQueue = [], Vt.pluginQueue = [], Vt.customSchemes = [], Vt.initialized = !1, Vt;
}
function N1(t, e = !1) {
  if (Vt.initialized && kP(`linkifyjs: already initialized - will not register custom scheme "${t}" ${RP}`), !/^[0-9a-z]+(-[0-9a-z]+)*$/.test(t))
    throw new Error(`linkifyjs: incorrect scheme format.
1. Must only contain digits, lowercase ASCII letters or "-"
2. Cannot start or end with "-"
3. "-" cannot repeat`);
  Vt.customSchemes.push([t, e]);
}
function SP() {
  Vt.scanner = UP(Vt.customSchemes);
  for (let t = 0; t < Vt.tokenQueue.length; t++)
    Vt.tokenQueue[t][1]({
      scanner: Vt.scanner
    });
  Vt.parser = jP(Vt.scanner.tokens);
  for (let t = 0; t < Vt.pluginQueue.length; t++)
    Vt.pluginQueue[t][1]({
      scanner: Vt.scanner,
      parser: Vt.parser
    });
  return Vt.initialized = !0, Vt;
}
function Np(t) {
  return Vt.initialized || SP(), HP(Vt.parser.start, t, fz(Vt.scanner.start, t));
}
Np.scan = fz;
function Iz(t, e = null, A = null) {
  if (e && typeof e == "object") {
    if (A)
      throw Error(`linkifyjs: Invalid link type ${e}; must be a string`);
    A = e, e = null;
  }
  const n = new Fp(A), s = Np(t), r = [];
  for (let i = 0; i < s.length; i++) {
    const o = s[i];
    o.isLink && (!e || o.t === e) && n.check(o) && r.push(o.toFormattedObject(n));
  }
  return r;
}
var Dp = "[\0-   ᠎ -\u2029 　]", TP = new RegExp(Dp), JP = new RegExp(`${Dp}$`), WP = new RegExp(Dp, "g");
function OP(t) {
  return t.length === 1 ? t[0].isLink : t.length === 3 && t[1].isLink ? ["()", "[]"].includes(t[0].value + t[2].value) : !1;
}
function PP(t) {
  return new ct({
    key: new Bt("autolink"),
    appendTransaction: (e, A, n) => {
      const s = e.some((c) => c.docChanged) && !A.doc.eq(n.doc), r = e.some((c) => c.getMeta("preventAutolink"));
      if (!s || r)
        return;
      const { tr: i } = n, o = BG(A.doc, [...e]);
      if (IG(o).forEach(({ newRange: c }) => {
        const l = W6(n.doc, c, (h) => h.isTextblock);
        let B, g;
        if (l.length > 1)
          B = l[0], g = n.doc.textBetween(
            B.pos,
            B.pos + B.node.nodeSize,
            void 0,
            " "
          );
        else if (l.length) {
          const h = n.doc.textBetween(c.from, c.to, " ", " ");
          if (!JP.test(h))
            return;
          B = l[0], g = n.doc.textBetween(B.pos, c.to, void 0, " ");
        }
        if (B && g) {
          const h = g.split(TP).filter(Boolean);
          if (h.length <= 0)
            return !1;
          const u = h[h.length - 1], d = B.pos + g.lastIndexOf(u);
          if (!u)
            return !1;
          const w = Np(u).map((Q) => Q.toObject(t.defaultProtocol));
          if (!OP(w))
            return !1;
          w.filter((Q) => Q.isLink).map((Q) => ({
            ...Q,
            from: d + Q.start + 1,
            to: d + Q.end + 1
          })).filter((Q) => n.schema.marks.code ? !n.doc.rangeHasMark(Q.from, Q.to, n.schema.marks.code) : !0).filter((Q) => t.validate(Q.value)).filter((Q) => t.shouldAutoLink(Q.value)).forEach((Q) => {
            cp(Q.from, Q.to, n.doc).some((p) => p.mark.type === t.type) || i.addMark(
              Q.from,
              Q.to,
              t.type.create({
                href: Q.href
              })
            );
          });
        }
      }), !!i.steps.length)
        return i;
    }
  });
}
function KP(t) {
  return new ct({
    key: new Bt("handleClickLink"),
    props: {
      handleClick: (e, A, n) => {
        var s, r;
        if (n.button !== 0 || !e.editable)
          return !1;
        let i = null;
        if (n.target instanceof HTMLAnchorElement)
          i = n.target;
        else {
          const a = n.target;
          if (!a)
            return !1;
          const c = t.editor.view.dom;
          i = a.closest("a"), i && !c.contains(i) && (i = null);
        }
        if (!i)
          return !1;
        let o = !1;
        if (t.enableClickSelection && (o = t.editor.commands.extendMarkRange(t.type.name)), t.openOnClick) {
          const a = QG(e.state, t.type.name), c = (s = i.href) != null ? s : a.href, l = (r = i.target) != null ? r : a.target;
          c && (window.open(c, l), o = !0);
        }
        return o;
      }
    }
  });
}
function VP(t) {
  return new ct({
    key: new Bt("handlePasteLink"),
    props: {
      handlePaste: (e, A, n) => {
        const { shouldAutoLink: s } = t, { state: r } = e, { selection: i } = r, { empty: o } = i;
        if (o)
          return !1;
        let a = "";
        n.content.forEach((l) => {
          a += l.textContent;
        });
        const c = Iz(a, { defaultProtocol: t.defaultProtocol }).find(
          (l) => l.isLink && l.value === a
        );
        return !a || !c || s !== void 0 && !s(c.value) ? !1 : t.editor.commands.setMark(t.type, {
          href: c.href
        });
      }
    }
  });
}
function ma(t, e) {
  const A = ["http", "https", "ftp", "ftps", "mailto", "tel", "callto", "sms", "cid", "xmpp"];
  return e && e.forEach((n) => {
    const s = typeof n == "string" ? n : n.scheme;
    s && A.push(s);
  }), !t || t.replace(WP, "").match(
    new RegExp(
      // eslint-disable-next-line no-useless-escape
      `^(?:(?:${A.join("|")}):|[^a-z]|[a-z0-9+.-]+(?:[^a-z+.-:]|$))`,
      "i"
    )
  );
}
var Cz = qr.create({
  name: "link",
  priority: 1e3,
  keepOnSplit: !1,
  exitable: !0,
  onCreate() {
    this.options.validate && !this.options.shouldAutoLink && (this.options.shouldAutoLink = this.options.validate, console.warn("The `validate` option is deprecated. Rename to the `shouldAutoLink` option instead.")), this.options.protocols.forEach((t) => {
      if (typeof t == "string") {
        N1(t);
        return;
      }
      N1(t.scheme, t.optionalSlashes);
    });
  },
  onDestroy() {
    LP();
  },
  inclusive() {
    return this.options.autolink;
  },
  addOptions() {
    return {
      openOnClick: !0,
      enableClickSelection: !1,
      linkOnPaste: !0,
      autolink: !0,
      protocols: [],
      defaultProtocol: "http",
      HTMLAttributes: {
        target: "_blank",
        rel: "noopener noreferrer nofollow",
        class: null
      },
      isAllowedUri: (t, e) => !!ma(t, e.protocols),
      validate: (t) => !!t,
      shouldAutoLink: (t) => {
        const e = /^[a-z][a-z0-9+.-]*:\/\//i.test(t), A = /^[a-z][a-z0-9+.-]*:/i.test(t);
        if (e || A && !t.includes("@"))
          return !0;
        const s = (t.includes("@") ? t.split("@").pop() : t).split(/[/?#:]/)[0];
        return !(/^\d{1,3}(\.\d{1,3}){3}$/.test(s) || !/\./.test(s));
      }
    };
  },
  addAttributes() {
    return {
      href: {
        default: null,
        parseHTML(t) {
          return t.getAttribute("href");
        }
      },
      target: {
        default: this.options.HTMLAttributes.target
      },
      rel: {
        default: this.options.HTMLAttributes.rel
      },
      class: {
        default: this.options.HTMLAttributes.class
      },
      title: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "a[href]",
        getAttrs: (t) => {
          const e = t.getAttribute("href");
          return !e || !this.options.isAllowedUri(e, {
            defaultValidate: (A) => !!ma(A, this.options.protocols),
            protocols: this.options.protocols,
            defaultProtocol: this.options.defaultProtocol
          }) ? !1 : null;
        }
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return this.options.isAllowedUri(t.href, {
      defaultValidate: (e) => !!ma(e, this.options.protocols),
      protocols: this.options.protocols,
      defaultProtocol: this.options.defaultProtocol
    }) ? ["a", Ct(this.options.HTMLAttributes, t), 0] : ["a", Ct(this.options.HTMLAttributes, { ...t, href: "" }), 0];
  },
  markdownTokenName: "link",
  parseMarkdown: (t, e) => e.applyMark("link", e.parseInline(t.tokens || []), {
    href: t.href,
    title: t.title || null
  }),
  renderMarkdown: (t, e) => {
    var A, n, s, r;
    const i = (n = (A = t.attrs) == null ? void 0 : A.href) != null ? n : "", o = (r = (s = t.attrs) == null ? void 0 : s.title) != null ? r : "", a = e.renderChildren(t);
    return o ? `[${a}](${i} "${o}")` : `[${a}](${i})`;
  },
  addCommands() {
    return {
      setLink: (t) => ({ chain: e }) => {
        const { href: A } = t;
        return this.options.isAllowedUri(A, {
          defaultValidate: (n) => !!ma(n, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? e().setMark(this.name, t).setMeta("preventAutolink", !0).run() : !1;
      },
      toggleLink: (t) => ({ chain: e }) => {
        const { href: A } = t || {};
        return A && !this.options.isAllowedUri(A, {
          defaultValidate: (n) => !!ma(n, this.options.protocols),
          protocols: this.options.protocols,
          defaultProtocol: this.options.defaultProtocol
        }) ? !1 : e().toggleMark(this.name, t, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run();
      },
      unsetLink: () => ({ chain: t }) => t().unsetMark(this.name, { extendEmptyMarkRange: !0 }).setMeta("preventAutolink", !0).run()
    };
  },
  addPasteRules() {
    return [
      Xo({
        find: (t) => {
          const e = [];
          if (t) {
            const { protocols: A, defaultProtocol: n } = this.options, s = Iz(t).filter(
              (r) => r.isLink && this.options.isAllowedUri(r.value, {
                defaultValidate: (i) => !!ma(i, A),
                protocols: A,
                defaultProtocol: n
              })
            );
            s.length && s.forEach((r) => {
              this.options.shouldAutoLink(r.value) && e.push({
                text: r.value,
                data: {
                  href: r.href
                },
                index: r.start
              });
            });
          }
          return e;
        },
        type: this.type,
        getAttributes: (t) => {
          var e;
          return {
            href: (e = t.data) == null ? void 0 : e.href
          };
        }
      })
    ];
  },
  addProseMirrorPlugins() {
    const t = [], { protocols: e, defaultProtocol: A } = this.options;
    return this.options.autolink && t.push(
      PP({
        type: this.type,
        defaultProtocol: this.options.defaultProtocol,
        validate: (n) => this.options.isAllowedUri(n, {
          defaultValidate: (s) => !!ma(s, e),
          protocols: e,
          defaultProtocol: A
        }),
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), t.push(
      KP({
        type: this.type,
        editor: this.editor,
        openOnClick: this.options.openOnClick === "whenNotEditable" ? !0 : this.options.openOnClick,
        enableClickSelection: this.options.enableClickSelection
      })
    ), this.options.linkOnPaste && t.push(
      VP({
        editor: this.editor,
        defaultProtocol: this.options.defaultProtocol,
        type: this.type,
        shouldAutoLink: this.options.shouldAutoLink
      })
    ), t;
  }
}), XP = Cz, ZP = Object.defineProperty, qP = (t, e) => {
  for (var A in e)
    ZP(t, A, { get: e[A], enumerable: !0 });
}, _P = "listItem", D1 = "textStyle", x1 = /^\s*([-+*])\s$/, Ez = Zt.create({
  name: "bulletList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [{ tag: "ul" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", Ct(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (t, e) => t.type !== "list" || t.ordered ? [] : {
    type: "bulletList",
    content: t.items ? e.parseChildren(t.items) : []
  },
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `
`) : "",
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleBulletList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(_P, this.editor.getAttributes(D1)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-8": () => this.editor.commands.toggleBulletList()
    };
  },
  addInputRules() {
    let t = ml({
      find: x1,
      type: this.type
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = ml({
      find: x1,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: () => this.editor.getAttributes(D1),
      editor: this.editor
    })), [t];
  }
}), Mz = Zt.create({
  name: "listItem",
  addOptions() {
    return {
      HTMLAttributes: {},
      bulletListTypeName: "bulletList",
      orderedListTypeName: "orderedList"
    };
  },
  content: "paragraph block*",
  defining: !0,
  parseHTML() {
    return [
      {
        tag: "li"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["li", Ct(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "list_item",
  parseMarkdown: (t, e) => {
    if (t.type !== "list_item")
      return [];
    let A = [];
    if (t.tokens && t.tokens.length > 0)
      if (t.tokens.some((s) => s.type === "paragraph"))
        A = e.parseChildren(t.tokens);
      else {
        const s = t.tokens[0];
        if (s && s.type === "text" && s.tokens && s.tokens.length > 0) {
          if (A = [
            {
              type: "paragraph",
              content: e.parseInline(s.tokens)
            }
          ], t.tokens.length > 1) {
            const i = t.tokens.slice(1), o = e.parseChildren(i);
            A.push(...o);
          }
        } else
          A = e.parseChildren(t.tokens);
      }
    return A.length === 0 && (A = [
      {
        type: "paragraph",
        content: []
      }
    ]), {
      type: "listItem",
      content: A
    };
  },
  renderMarkdown: (t, e, A) => up(
    t,
    e,
    (n) => {
      var s, r;
      return n.parentType === "bulletList" ? "- " : n.parentType === "orderedList" ? `${(((r = (s = n.meta) == null ? void 0 : s.parentAttrs) == null ? void 0 : r.start) || 1) + n.index}. ` : "- ";
    },
    A
  ),
  addKeyboardShortcuts() {
    return {
      Enter: () => this.editor.commands.splitListItem(this.name),
      Tab: () => this.editor.commands.sinkListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
  }
}), $P = {};
qP($P, {
  findListItemPos: () => dh,
  getNextListDepth: () => xp,
  handleBackspace: () => aE,
  handleDelete: () => cE,
  hasListBefore: () => pz,
  hasListItemAfter: () => eK,
  hasListItemBefore: () => mz,
  listItemHasSubList: () => Yz,
  nextListIsDeeper: () => yz,
  nextListIsHigher: () => Fz
});
var dh = (t, e) => {
  const { $from: A } = e.selection, n = MA(t, e.schema);
  let s = null, r = A.depth, i = A.pos, o = null;
  for (; r > 0 && o === null; )
    s = A.node(r), s.type === n ? o = r : (r -= 1, i -= 1);
  return o === null ? null : { $pos: e.doc.resolve(i), depth: o };
}, xp = (t, e) => {
  const A = dh(t, e);
  if (!A)
    return !1;
  const [, n] = eJ(e, t, A.$pos.pos + 4);
  return n;
}, pz = (t, e, A) => {
  const { $anchor: n } = t.selection, s = Math.max(0, n.pos - 2), r = t.doc.resolve(s).node();
  return !(!r || !A.includes(r.type.name));
}, mz = (t, e) => {
  var A;
  const { $anchor: n } = e.selection, s = e.doc.resolve(n.pos - 2);
  return !(s.index() === 0 || ((A = s.nodeBefore) == null ? void 0 : A.type.name) !== t);
}, Yz = (t, e, A) => {
  if (!A)
    return !1;
  const n = MA(t, e.schema);
  let s = !1;
  return A.descendants((r) => {
    r.type === n && (s = !0);
  }), s;
}, aE = (t, e, A) => {
  if (t.commands.undoInputRule())
    return !0;
  if (t.state.selection.from !== t.state.selection.to)
    return !1;
  if (!Vo(t.state, e) && pz(t.state, e, A)) {
    const { $anchor: o } = t.state.selection, a = t.state.doc.resolve(o.before() - 1), c = [];
    a.node().descendants((g, h) => {
      g.type.name === e && c.push({ node: g, pos: h });
    });
    const l = c.at(-1);
    if (!l)
      return !1;
    const B = t.state.doc.resolve(a.start() + l.pos + 1);
    return t.chain().cut({ from: o.start() - 1, to: o.end() + 1 }, B.end()).joinForward().run();
  }
  if (!Vo(t.state, e) || !sJ(t.state))
    return !1;
  const n = dh(e, t.state);
  if (!n)
    return !1;
  const r = t.state.doc.resolve(n.$pos.pos - 2).node(n.depth), i = Yz(e, t.state, r);
  return mz(e, t.state) && !i ? t.commands.joinItemBackward() : t.chain().liftListItem(e).run();
}, yz = (t, e) => {
  const A = xp(t, e), n = dh(t, e);
  return !n || !A ? !1 : A > n.depth;
}, Fz = (t, e) => {
  const A = xp(t, e), n = dh(t, e);
  return !n || !A ? !1 : A < n.depth;
}, cE = (t, e) => {
  if (!Vo(t.state, e) || !nJ(t.state, e))
    return !1;
  const { selection: A } = t.state, { $from: n, $to: s } = A;
  return !A.empty && n.sameParent(s) ? !1 : yz(e, t.state) ? t.chain().focus(t.state.selection.from + 4).lift(e).joinBackward().run() : Fz(e, t.state) ? t.chain().joinForward().joinBackward().run() : t.commands.joinItemForward();
}, eK = (t, e) => {
  var A;
  const { $anchor: n } = e.selection, s = e.doc.resolve(n.pos - n.parentOffset - 2);
  return !(s.index() === s.parent.childCount - 1 || ((A = s.nodeAfter) == null ? void 0 : A.type.name) !== t);
}, Nz = tt.create({
  name: "listKeymap",
  addOptions() {
    return {
      listTypes: [
        {
          itemName: "listItem",
          wrapperNames: ["bulletList", "orderedList"]
        },
        {
          itemName: "taskItem",
          wrapperNames: ["taskList"]
        }
      ]
    };
  },
  addKeyboardShortcuts() {
    return {
      Delete: ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: A }) => {
          t.state.schema.nodes[A] !== void 0 && cE(t, A) && (e = !0);
        }), e;
      },
      "Mod-Delete": ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: A }) => {
          t.state.schema.nodes[A] !== void 0 && cE(t, A) && (e = !0);
        }), e;
      },
      Backspace: ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: A, wrapperNames: n }) => {
          t.state.schema.nodes[A] !== void 0 && aE(t, A, n) && (e = !0);
        }), e;
      },
      "Mod-Backspace": ({ editor: t }) => {
        let e = !1;
        return this.options.listTypes.forEach(({ itemName: A, wrapperNames: n }) => {
          t.state.schema.nodes[A] !== void 0 && aE(t, A, n) && (e = !0);
        }), e;
      }
    };
  }
}), G1 = /^(\s*)(\d+)\.\s+(.*)$/, tK = /^\s/;
function AK(t) {
  const e = [];
  let A = 0, n = 0;
  for (; A < t.length; ) {
    const s = t[A], r = s.match(G1);
    if (!r)
      break;
    const [, i, o, a] = r, c = i.length;
    let l = a, B = A + 1;
    const g = [s];
    for (; B < t.length; ) {
      const h = t[B];
      if (h.match(G1))
        break;
      if (h.trim() === "")
        g.push(h), l += `
`, B += 1;
      else if (h.match(tK))
        g.push(h), l += `
${h.slice(c + 2)}`, B += 1;
      else
        break;
    }
    e.push({
      indent: c,
      number: parseInt(o, 10),
      content: l.trim(),
      raw: g.join(`
`)
    }), n = B, A = B;
  }
  return [e, n];
}
function Dz(t, e, A) {
  var n;
  const s = [];
  let r = 0;
  for (; r < t.length; ) {
    const i = t[r];
    if (i.indent === e) {
      const o = i.content.split(`
`), a = ((n = o[0]) == null ? void 0 : n.trim()) || "", c = [];
      a && c.push({
        type: "paragraph",
        raw: a,
        tokens: A.inlineTokens(a)
      });
      const l = o.slice(1).join(`
`).trim();
      if (l) {
        const h = A.blockTokens(l);
        c.push(...h);
      }
      let B = r + 1;
      const g = [];
      for (; B < t.length && t[B].indent > e; )
        g.push(t[B]), B += 1;
      if (g.length > 0) {
        const h = Math.min(...g.map((d) => d.indent)), u = Dz(g, h, A);
        c.push({
          type: "list",
          ordered: !0,
          start: g[0].number,
          items: u,
          raw: g.map((d) => d.raw).join(`
`)
        });
      }
      s.push({
        type: "list_item",
        raw: i.raw,
        tokens: c
      }), r = B;
    } else
      r += 1;
  }
  return s;
}
function nK(t, e) {
  return t.map((A) => {
    if (A.type !== "list_item")
      return e.parseChildren([A])[0];
    const n = [];
    return A.tokens && A.tokens.length > 0 && A.tokens.forEach((s) => {
      if (s.type === "paragraph" || s.type === "list" || s.type === "blockquote" || s.type === "code")
        n.push(...e.parseChildren([s]));
      else if (s.type === "text" && s.tokens) {
        const r = e.parseChildren([s]);
        n.push({
          type: "paragraph",
          content: r
        });
      } else {
        const r = e.parseChildren([s]);
        r.length > 0 && n.push(...r);
      }
    }), {
      type: "listItem",
      content: n
    };
  });
}
var sK = "listItem", z1 = "textStyle", U1 = /^(\d+)\.\s$/, xz = Zt.create({
  name: "orderedList",
  addOptions() {
    return {
      itemTypeName: "listItem",
      HTMLAttributes: {},
      keepMarks: !1,
      keepAttributes: !1
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  addAttributes() {
    return {
      start: {
        default: 1,
        parseHTML: (t) => t.hasAttribute("start") ? parseInt(t.getAttribute("start") || "", 10) : 1
      },
      type: {
        default: null,
        parseHTML: (t) => t.getAttribute("type")
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "ol"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    const { start: e, ...A } = t;
    return e === 1 ? ["ol", Ct(this.options.HTMLAttributes, A), 0] : ["ol", Ct(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "list",
  parseMarkdown: (t, e) => {
    if (t.type !== "list" || !t.ordered)
      return [];
    const A = t.start || 1, n = t.items ? nK(t.items, e) : [];
    return A !== 1 ? {
      type: "orderedList",
      attrs: { start: A },
      content: n
    } : {
      type: "orderedList",
      content: n
    };
  },
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `
`) : "",
  markdownTokenizer: {
    name: "orderedList",
    level: "block",
    start: (t) => {
      const e = t.match(/^(\s*)(\d+)\.\s+/), A = e == null ? void 0 : e.index;
      return A !== void 0 ? A : -1;
    },
    tokenize: (t, e, A) => {
      var n;
      const s = t.split(`
`), [r, i] = AK(s);
      if (r.length === 0)
        return;
      const o = Dz(r, 0, A);
      return o.length === 0 ? void 0 : {
        type: "list",
        ordered: !0,
        start: ((n = r[0]) == null ? void 0 : n.number) || 1,
        items: o,
        raw: s.slice(0, i).join(`
`)
      };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleOrderedList: () => ({ commands: t, chain: e }) => this.options.keepAttributes ? e().toggleList(this.name, this.options.itemTypeName, this.options.keepMarks).updateAttributes(sK, this.editor.getAttributes(z1)).run() : t.toggleList(this.name, this.options.itemTypeName, this.options.keepMarks)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-7": () => this.editor.commands.toggleOrderedList()
    };
  },
  addInputRules() {
    let t = ml({
      find: U1,
      type: this.type,
      getAttributes: (e) => ({ start: +e[1] }),
      joinPredicate: (e, A) => A.childCount + A.attrs.start === +e[1]
    });
    return (this.options.keepMarks || this.options.keepAttributes) && (t = ml({
      find: U1,
      type: this.type,
      keepMarks: this.options.keepMarks,
      keepAttributes: this.options.keepAttributes,
      getAttributes: (e) => ({ start: +e[1], ...this.editor.getAttributes(z1) }),
      joinPredicate: (e, A) => A.childCount + A.attrs.start === +e[1],
      editor: this.editor
    })), [t];
  }
}), rK = /^\s*(\[([( |x])?\])\s$/, Gz = Zt.create({
  name: "taskItem",
  addOptions() {
    return {
      nested: !1,
      HTMLAttributes: {},
      taskListTypeName: "taskList",
      a11y: void 0
    };
  },
  content() {
    return this.options.nested ? "paragraph block*" : "paragraph+";
  },
  defining: !0,
  addAttributes() {
    return {
      checked: {
        default: !1,
        keepOnSplit: !1,
        parseHTML: (t) => {
          const e = t.getAttribute("data-checked");
          return e === "" || e === "true";
        },
        renderHTML: (t) => ({
          "data-checked": t.checked
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `li[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    return [
      "li",
      Ct(this.options.HTMLAttributes, e, {
        "data-type": this.name
      }),
      [
        "label",
        [
          "input",
          {
            type: "checkbox",
            checked: t.attrs.checked ? "checked" : null
          }
        ],
        ["span"]
      ],
      ["div", 0]
    ];
  },
  parseMarkdown: (t, e) => {
    const A = [];
    if (t.tokens && t.tokens.length > 0 ? A.push(e.createNode("paragraph", {}, e.parseInline(t.tokens))) : t.text ? A.push(e.createNode("paragraph", {}, [e.createNode("text", { text: t.text })])) : A.push(e.createNode("paragraph", {}, [])), t.nestedTokens && t.nestedTokens.length > 0) {
      const n = e.parseChildren(t.nestedTokens);
      A.push(...n);
    }
    return e.createNode("taskItem", { checked: t.checked || !1 }, A);
  },
  renderMarkdown: (t, e) => {
    var A;
    const s = `- [${(A = t.attrs) != null && A.checked ? "x" : " "}] `;
    return up(t, e, s);
  },
  addKeyboardShortcuts() {
    const t = {
      Enter: () => this.editor.commands.splitListItem(this.name),
      "Shift-Tab": () => this.editor.commands.liftListItem(this.name)
    };
    return this.options.nested ? {
      ...t,
      Tab: () => this.editor.commands.sinkListItem(this.name)
    } : t;
  },
  addNodeView() {
    return ({ node: t, HTMLAttributes: e, getPos: A, editor: n }) => {
      const s = document.createElement("li"), r = document.createElement("label"), i = document.createElement("span"), o = document.createElement("input"), a = document.createElement("div"), c = (B) => {
        var g, h;
        o.ariaLabel = ((h = (g = this.options.a11y) == null ? void 0 : g.checkboxLabel) == null ? void 0 : h.call(g, B, o.checked)) || `Task item checkbox for ${B.textContent || "empty task item"}`;
      };
      c(t), r.contentEditable = "false", o.type = "checkbox", o.addEventListener("mousedown", (B) => B.preventDefault()), o.addEventListener("change", (B) => {
        if (!n.isEditable && !this.options.onReadOnlyChecked) {
          o.checked = !o.checked;
          return;
        }
        const { checked: g } = B.target;
        n.isEditable && typeof A == "function" && n.chain().focus(void 0, { scrollIntoView: !1 }).command(({ tr: h }) => {
          const u = A();
          if (typeof u != "number")
            return !1;
          const d = h.doc.nodeAt(u);
          return h.setNodeMarkup(u, void 0, {
            ...d == null ? void 0 : d.attrs,
            checked: g
          }), !0;
        }).run(), !n.isEditable && this.options.onReadOnlyChecked && (this.options.onReadOnlyChecked(t, g) || (o.checked = !o.checked));
      }), Object.entries(this.options.HTMLAttributes).forEach(([B, g]) => {
        s.setAttribute(B, g);
      }), s.dataset.checked = t.attrs.checked, o.checked = t.attrs.checked, r.append(o, i), s.append(r, a), Object.entries(e).forEach(([B, g]) => {
        s.setAttribute(B, g);
      });
      let l = new Set(Object.keys(e));
      return {
        dom: s,
        contentDOM: a,
        update: (B) => {
          if (B.type !== this.type)
            return !1;
          s.dataset.checked = B.attrs.checked, o.checked = B.attrs.checked, c(B);
          const g = n.extensionManager.attributes, h = Dg(B, g), u = new Set(Object.keys(h)), d = this.options.HTMLAttributes;
          return l.forEach((w) => {
            u.has(w) || (w in d ? s.setAttribute(w, d[w]) : s.removeAttribute(w));
          }), Object.entries(h).forEach(([w, Q]) => {
            Q == null ? w in d ? s.setAttribute(w, d[w]) : s.removeAttribute(w) : s.setAttribute(w, Q);
          }), l = u, !0;
        }
      };
    };
  },
  addInputRules() {
    return [
      ml({
        find: rK,
        type: this.type,
        getAttributes: (t) => ({
          checked: t[t.length - 1] === "x"
        })
      })
    ];
  }
}), zz = Zt.create({
  name: "taskList",
  addOptions() {
    return {
      itemTypeName: "taskItem",
      HTMLAttributes: {}
    };
  },
  group: "block list",
  content() {
    return `${this.options.itemTypeName}+`;
  },
  parseHTML() {
    return [
      {
        tag: `ul[data-type="${this.name}"]`,
        priority: 51
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["ul", Ct(this.options.HTMLAttributes, t, { "data-type": this.name }), 0];
  },
  parseMarkdown: (t, e) => e.createNode("taskList", {}, e.parseChildren(t.items || [])),
  renderMarkdown: (t, e) => t.content ? e.renderChildren(t.content, `
`) : "",
  markdownTokenizer: {
    name: "taskList",
    level: "block",
    start(t) {
      var e;
      const A = (e = t.match(/^\s*[-+*]\s+\[([ xX])\]\s+/)) == null ? void 0 : e.index;
      return A !== void 0 ? A : -1;
    },
    tokenize(t, e, A) {
      const n = (r) => {
        const i = PC(
          r,
          {
            itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
            extractItemData: (o) => ({
              indentLevel: o[1].length,
              mainContent: o[4],
              checked: o[3].toLowerCase() === "x"
            }),
            createToken: (o, a) => ({
              type: "taskItem",
              raw: "",
              mainContent: o.mainContent,
              indentLevel: o.indentLevel,
              checked: o.checked,
              text: o.mainContent,
              tokens: A.inlineTokens(o.mainContent),
              nestedTokens: a
            }),
            // Allow recursive nesting
            customNestedParser: n
          },
          A
        );
        return i ? [
          {
            type: "taskList",
            raw: i.raw,
            items: i.items
          }
        ] : A.blockTokens(r);
      }, s = PC(
        t,
        {
          itemPattern: /^(\s*)([-+*])\s+\[([ xX])\]\s+(.*)$/,
          extractItemData: (r) => ({
            indentLevel: r[1].length,
            mainContent: r[4],
            checked: r[3].toLowerCase() === "x"
          }),
          createToken: (r, i) => ({
            type: "taskItem",
            raw: "",
            mainContent: r.mainContent,
            indentLevel: r.indentLevel,
            checked: r.checked,
            text: r.mainContent,
            tokens: A.inlineTokens(r.mainContent),
            nestedTokens: i
          }),
          // Use the recursive parser for nested content
          customNestedParser: n
        },
        A
      );
      if (s)
        return {
          type: "taskList",
          raw: s.raw,
          items: s.items
        };
    }
  },
  markdownOptions: {
    indentsContent: !0
  },
  addCommands() {
    return {
      toggleTaskList: () => ({ commands: t }) => t.toggleList(this.name, this.options.itemTypeName)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-9": () => this.editor.commands.toggleTaskList()
    };
  }
});
tt.create({
  name: "listKit",
  addExtensions() {
    const t = [];
    return this.options.bulletList !== !1 && t.push(Ez.configure(this.options.bulletList)), this.options.listItem !== !1 && t.push(Mz.configure(this.options.listItem)), this.options.listKeymap !== !1 && t.push(Nz.configure(this.options.listKeymap)), this.options.orderedList !== !1 && t.push(xz.configure(this.options.orderedList)), this.options.taskItem !== !1 && t.push(Gz.configure(this.options.taskItem)), this.options.taskList !== !1 && t.push(zz.configure(this.options.taskList)), t;
  }
});
var b1 = "&nbsp;", iK = " ", oK = Zt.create({
  name: "paragraph",
  priority: 1e3,
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  group: "block",
  content: "inline*",
  parseHTML() {
    return [{ tag: "p" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["p", Ct(this.options.HTMLAttributes, t), 0];
  },
  parseMarkdown: (t, e) => {
    const A = t.tokens || [];
    if (A.length === 1 && A[0].type === "image")
      return e.parseChildren([A[0]]);
    const n = e.parseInline(A);
    return n.length === 1 && n[0].type === "text" && (n[0].text === b1 || n[0].text === iK) ? e.createNode("paragraph", void 0, []) : e.createNode("paragraph", void 0, n);
  },
  renderMarkdown: (t, e) => {
    if (!t)
      return "";
    const A = Array.isArray(t.content) ? t.content : [];
    return A.length === 0 ? b1 : e.renderChildren(A);
  },
  addCommands() {
    return {
      setParagraph: () => ({ commands: t }) => t.setNode(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Alt-0": () => this.editor.commands.setParagraph()
    };
  }
}), aK = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))$/, cK = /(?:^|\s)(~~(?!\s+~~)((?:[^~]+))~~(?!\s+~~))/g, lK = qr.create({
  name: "strike",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "s"
      },
      {
        tag: "del"
      },
      {
        tag: "strike"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("line-through") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["s", Ct(this.options.HTMLAttributes, t), 0];
  },
  markdownTokenName: "del",
  parseMarkdown: (t, e) => e.applyMark("strike", e.parseInline(t.tokens || [])),
  renderMarkdown: (t, e) => `~~${e.renderChildren(t)}~~`,
  addCommands() {
    return {
      setStrike: () => ({ commands: t }) => t.setMark(this.name),
      toggleStrike: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetStrike: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-s": () => this.editor.commands.toggleStrike()
    };
  },
  addInputRules() {
    return [
      _a({
        find: aK,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Xo({
        find: cK,
        type: this.type
      })
    ];
  }
}), BK = Zt.create({
  name: "text",
  group: "inline",
  parseMarkdown: (t) => ({
    type: "text",
    text: t.text || ""
  }),
  renderMarkdown: (t) => t.text || ""
}), Uz = qr.create({
  name: "underline",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  parseHTML() {
    return [
      {
        tag: "u"
      },
      {
        style: "text-decoration",
        consuming: !1,
        getAttrs: (t) => t.includes("underline") ? {} : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["u", Ct(this.options.HTMLAttributes, t), 0];
  },
  parseMarkdown(t, e) {
    return e.applyMark(this.name || "underline", e.parseInline(t.tokens || []));
  },
  renderMarkdown(t, e) {
    return `++${e.renderChildren(t)}++`;
  },
  markdownTokenizer: {
    name: "underline",
    level: "inline",
    start(t) {
      return t.indexOf("++");
    },
    tokenize(t, e, A) {
      const s = /^(\+\+)([\s\S]+?)(\+\+)/.exec(t);
      if (!s)
        return;
      const r = s[2].trim();
      return {
        type: "underline",
        raw: s[0],
        text: r,
        tokens: A.inlineTokens(r)
      };
    }
  },
  addCommands() {
    return {
      setUnderline: () => ({ commands: t }) => t.setMark(this.name),
      toggleUnderline: () => ({ commands: t }) => t.toggleMark(this.name),
      unsetUnderline: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-u": () => this.editor.commands.toggleUnderline(),
      "Mod-U": () => this.editor.commands.toggleUnderline()
    };
  }
});
function gK(t = {}) {
  return new ct({
    view(e) {
      return new hK(e, t);
    }
  });
}
class hK {
  constructor(e, A) {
    var n;
    this.editorView = e, this.cursorPos = null, this.element = null, this.timeout = -1, this.width = (n = A.width) !== null && n !== void 0 ? n : 1, this.color = A.color === !1 ? void 0 : A.color || "black", this.class = A.class, this.handlers = ["dragover", "dragend", "drop", "dragleave"].map((s) => {
      let r = (i) => {
        this[s](i);
      };
      return e.dom.addEventListener(s, r), { name: s, handler: r };
    });
  }
  destroy() {
    this.handlers.forEach(({ name: e, handler: A }) => this.editorView.dom.removeEventListener(e, A));
  }
  update(e, A) {
    this.cursorPos != null && A.doc != e.state.doc && (this.cursorPos > e.state.doc.content.size ? this.setCursor(null) : this.updateOverlay());
  }
  setCursor(e) {
    e != this.cursorPos && (this.cursorPos = e, e == null ? (this.element.parentNode.removeChild(this.element), this.element = null) : this.updateOverlay());
  }
  updateOverlay() {
    let e = this.editorView.state.doc.resolve(this.cursorPos), A = !e.parent.inlineContent, n, s = this.editorView.dom, r = s.getBoundingClientRect(), i = r.width / s.offsetWidth, o = r.height / s.offsetHeight;
    if (A) {
      let B = e.nodeBefore, g = e.nodeAfter;
      if (B || g) {
        let h = this.editorView.nodeDOM(this.cursorPos - (B ? B.nodeSize : 0));
        if (h) {
          let u = h.getBoundingClientRect(), d = B ? u.bottom : u.top;
          B && g && (d = (d + this.editorView.nodeDOM(this.cursorPos).getBoundingClientRect().top) / 2);
          let w = this.width / 2 * o;
          n = { left: u.left, right: u.right, top: d - w, bottom: d + w };
        }
      }
    }
    if (!n) {
      let B = this.editorView.coordsAtPos(this.cursorPos), g = this.width / 2 * i;
      n = { left: B.left - g, right: B.left + g, top: B.top, bottom: B.bottom };
    }
    let a = this.editorView.dom.offsetParent;
    this.element || (this.element = a.appendChild(document.createElement("div")), this.class && (this.element.className = this.class), this.element.style.cssText = "position: absolute; z-index: 50; pointer-events: none;", this.color && (this.element.style.backgroundColor = this.color)), this.element.classList.toggle("prosemirror-dropcursor-block", A), this.element.classList.toggle("prosemirror-dropcursor-inline", !A);
    let c, l;
    if (!a || a == document.body && getComputedStyle(a).position == "static")
      c = -pageXOffset, l = -pageYOffset;
    else {
      let B = a.getBoundingClientRect(), g = B.width / a.offsetWidth, h = B.height / a.offsetHeight;
      c = B.left - a.scrollLeft * g, l = B.top - a.scrollTop * h;
    }
    this.element.style.left = (n.left - c) / i + "px", this.element.style.top = (n.top - l) / o + "px", this.element.style.width = (n.right - n.left) / i + "px", this.element.style.height = (n.bottom - n.top) / o + "px";
  }
  scheduleRemoval(e) {
    clearTimeout(this.timeout), this.timeout = setTimeout(() => this.setCursor(null), e);
  }
  dragover(e) {
    if (!this.editorView.editable)
      return;
    let A = this.editorView.posAtCoords({ left: e.clientX, top: e.clientY }), n = A && A.inside >= 0 && this.editorView.state.doc.nodeAt(A.inside), s = n && n.type.spec.disableDropCursor, r = typeof s == "function" ? s(this.editorView, A, e) : s;
    if (A && !r) {
      let i = A.pos;
      if (this.editorView.dragging && this.editorView.dragging.slice) {
        let o = r4(this.editorView.state.doc, i, this.editorView.dragging.slice);
        o != null && (i = o);
      }
      this.setCursor(i), this.scheduleRemoval(5e3);
    }
  }
  dragend() {
    this.scheduleRemoval(20);
  }
  drop() {
    this.scheduleRemoval(20);
  }
  dragleave(e) {
    this.editorView.dom.contains(e.relatedTarget) || this.setCursor(null);
  }
}
class lA extends Ke {
  /**
  Create a gap cursor.
  */
  constructor(e) {
    super(e, e);
  }
  map(e, A) {
    let n = e.resolve(A.map(this.head));
    return lA.valid(n) ? new lA(n) : Ke.near(n);
  }
  content() {
    return Ee.empty;
  }
  eq(e) {
    return e instanceof lA && e.head == this.head;
  }
  toJSON() {
    return { type: "gapcursor", pos: this.head };
  }
  /**
  @internal
  */
  static fromJSON(e, A) {
    if (typeof A.pos != "number")
      throw new RangeError("Invalid input for GapCursor.fromJSON");
    return new lA(e.resolve(A.pos));
  }
  /**
  @internal
  */
  getBookmark() {
    return new Gp(this.anchor);
  }
  /**
  @internal
  */
  static valid(e) {
    let A = e.parent;
    if (A.isTextblock || !uK(e) || !dK(e))
      return !1;
    let n = A.type.spec.allowGapCursor;
    if (n != null)
      return n;
    let s = A.contentMatchAt(e.index()).defaultType;
    return s && s.isTextblock;
  }
  /**
  @internal
  */
  static findGapCursorFrom(e, A, n = !1) {
    e: for (; ; ) {
      if (!n && lA.valid(e))
        return e;
      let s = e.pos, r = null;
      for (let i = e.depth; ; i--) {
        let o = e.node(i);
        if (A > 0 ? e.indexAfter(i) < o.childCount : e.index(i) > 0) {
          r = o.child(A > 0 ? e.indexAfter(i) : e.index(i) - 1);
          break;
        } else if (i == 0)
          return null;
        s += A;
        let a = e.doc.resolve(s);
        if (lA.valid(a))
          return a;
      }
      for (; ; ) {
        let i = A > 0 ? r.firstChild : r.lastChild;
        if (!i) {
          if (r.isAtom && !r.isText && !Ue.isSelectable(r)) {
            e = e.doc.resolve(s + r.nodeSize * A), n = !1;
            continue e;
          }
          break;
        }
        r = i, s += A;
        let o = e.doc.resolve(s);
        if (lA.valid(o))
          return o;
      }
      return null;
    }
  }
}
lA.prototype.visible = !1;
lA.findFrom = lA.findGapCursorFrom;
Ke.jsonID("gapcursor", lA);
class Gp {
  constructor(e) {
    this.pos = e;
  }
  map(e) {
    return new Gp(e.map(this.pos));
  }
  resolve(e) {
    let A = e.resolve(this.pos);
    return lA.valid(A) ? new lA(A) : Ke.near(A);
  }
}
function bz(t) {
  return t.isAtom || t.spec.isolating || t.spec.createGapCursor;
}
function uK(t) {
  for (let e = t.depth; e >= 0; e--) {
    let A = t.index(e), n = t.node(e);
    if (A == 0) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let s = n.child(A - 1); ; s = s.lastChild) {
      if (s.childCount == 0 && !s.inlineContent || bz(s.type))
        return !0;
      if (s.inlineContent)
        return !1;
    }
  }
  return !0;
}
function dK(t) {
  for (let e = t.depth; e >= 0; e--) {
    let A = t.indexAfter(e), n = t.node(e);
    if (A == n.childCount) {
      if (n.type.spec.isolating)
        return !0;
      continue;
    }
    for (let s = n.child(A); ; s = s.firstChild) {
      if (s.childCount == 0 && !s.inlineContent || bz(s.type))
        return !0;
      if (s.inlineContent)
        return !1;
    }
  }
  return !0;
}
function wK() {
  return new ct({
    props: {
      decorations: CK,
      createSelectionBetween(t, e, A) {
        return e.pos == A.pos && lA.valid(A) ? new lA(A) : null;
      },
      handleClick: QK,
      handleKeyDown: fK,
      handleDOMEvents: { beforeinput: IK }
    }
  });
}
const fK = Ap({
  ArrowLeft: u0("horiz", -1),
  ArrowRight: u0("horiz", 1),
  ArrowUp: u0("vert", -1),
  ArrowDown: u0("vert", 1)
});
function u0(t, e) {
  const A = t == "vert" ? e > 0 ? "down" : "up" : e > 0 ? "right" : "left";
  return function(n, s, r) {
    let i = n.selection, o = e > 0 ? i.$to : i.$from, a = i.empty;
    if (i instanceof Re) {
      if (!r.endOfTextblock(A) || o.depth == 0)
        return !1;
      a = !1, o = n.doc.resolve(e > 0 ? o.after() : o.before());
    }
    let c = lA.findGapCursorFrom(o, e, a);
    return c ? (s && s(n.tr.setSelection(new lA(c))), !0) : !1;
  };
}
function QK(t, e, A) {
  if (!t || !t.editable)
    return !1;
  let n = t.state.doc.resolve(e);
  if (!lA.valid(n))
    return !1;
  let s = t.posAtCoords({ left: A.clientX, top: A.clientY });
  return s && s.inside > -1 && Ue.isSelectable(t.state.doc.nodeAt(s.inside)) ? !1 : (t.dispatch(t.state.tr.setSelection(new lA(n))), !0);
}
function IK(t, e) {
  if (e.inputType != "insertCompositionText" || !(t.state.selection instanceof lA))
    return !1;
  let { $from: A } = t.state.selection, n = A.parent.contentMatchAt(A.index()).findWrapping(t.state.schema.nodes.text);
  if (!n)
    return !1;
  let s = re.empty;
  for (let i = n.length - 1; i >= 0; i--)
    s = re.from(n[i].createAndFill(null, s));
  let r = t.state.tr.replace(A.pos, A.pos, new Ee(s, 0, 0));
  return r.setSelection(Re.near(r.doc.resolve(A.pos + 1))), t.dispatch(r), !1;
}
function CK(t) {
  if (!(t.selection instanceof lA))
    return null;
  let e = document.createElement("div");
  return e.className = "ProseMirror-gapcursor", It.create(t.doc, [Wt.widget(t.selection.head, e, { key: "gapcursor" })]);
}
var Ed = 200, jA = function() {
};
jA.prototype.append = function(e) {
  return e.length ? (e = jA.from(e), !this.length && e || e.length < Ed && this.leafAppend(e) || this.length < Ed && e.leafPrepend(this) || this.appendInner(e)) : this;
};
jA.prototype.prepend = function(e) {
  return e.length ? jA.from(e).append(this) : this;
};
jA.prototype.appendInner = function(e) {
  return new EK(this, e);
};
jA.prototype.slice = function(e, A) {
  return e === void 0 && (e = 0), A === void 0 && (A = this.length), e >= A ? jA.empty : this.sliceInner(Math.max(0, e), Math.min(this.length, A));
};
jA.prototype.get = function(e) {
  if (!(e < 0 || e >= this.length))
    return this.getInner(e);
};
jA.prototype.forEach = function(e, A, n) {
  A === void 0 && (A = 0), n === void 0 && (n = this.length), A <= n ? this.forEachInner(e, A, n, 0) : this.forEachInvertedInner(e, A, n, 0);
};
jA.prototype.map = function(e, A, n) {
  A === void 0 && (A = 0), n === void 0 && (n = this.length);
  var s = [];
  return this.forEach(function(r, i) {
    return s.push(e(r, i));
  }, A, n), s;
};
jA.from = function(e) {
  return e instanceof jA ? e : e && e.length ? new vz(e) : jA.empty;
};
var vz = /* @__PURE__ */ (function(t) {
  function e(n) {
    t.call(this), this.values = n;
  }
  t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e;
  var A = { length: { configurable: !0 }, depth: { configurable: !0 } };
  return e.prototype.flatten = function() {
    return this.values;
  }, e.prototype.sliceInner = function(s, r) {
    return s == 0 && r == this.length ? this : new e(this.values.slice(s, r));
  }, e.prototype.getInner = function(s) {
    return this.values[s];
  }, e.prototype.forEachInner = function(s, r, i, o) {
    for (var a = r; a < i; a++)
      if (s(this.values[a], o + a) === !1)
        return !1;
  }, e.prototype.forEachInvertedInner = function(s, r, i, o) {
    for (var a = r - 1; a >= i; a--)
      if (s(this.values[a], o + a) === !1)
        return !1;
  }, e.prototype.leafAppend = function(s) {
    if (this.length + s.length <= Ed)
      return new e(this.values.concat(s.flatten()));
  }, e.prototype.leafPrepend = function(s) {
    if (this.length + s.length <= Ed)
      return new e(s.flatten().concat(this.values));
  }, A.length.get = function() {
    return this.values.length;
  }, A.depth.get = function() {
    return 0;
  }, Object.defineProperties(e.prototype, A), e;
})(jA);
jA.empty = new vz([]);
var EK = /* @__PURE__ */ (function(t) {
  function e(A, n) {
    t.call(this), this.left = A, this.right = n, this.length = A.length + n.length, this.depth = Math.max(A.depth, n.depth) + 1;
  }
  return t && (e.__proto__ = t), e.prototype = Object.create(t && t.prototype), e.prototype.constructor = e, e.prototype.flatten = function() {
    return this.left.flatten().concat(this.right.flatten());
  }, e.prototype.getInner = function(n) {
    return n < this.left.length ? this.left.get(n) : this.right.get(n - this.left.length);
  }, e.prototype.forEachInner = function(n, s, r, i) {
    var o = this.left.length;
    if (s < o && this.left.forEachInner(n, s, Math.min(r, o), i) === !1 || r > o && this.right.forEachInner(n, Math.max(s - o, 0), Math.min(this.length, r) - o, i + o) === !1)
      return !1;
  }, e.prototype.forEachInvertedInner = function(n, s, r, i) {
    var o = this.left.length;
    if (s > o && this.right.forEachInvertedInner(n, s - o, Math.max(r, o) - o, i + o) === !1 || r < o && this.left.forEachInvertedInner(n, Math.min(s, o), r, i) === !1)
      return !1;
  }, e.prototype.sliceInner = function(n, s) {
    if (n == 0 && s == this.length)
      return this;
    var r = this.left.length;
    return s <= r ? this.left.slice(n, s) : n >= r ? this.right.slice(n - r, s - r) : this.left.slice(n, r).append(this.right.slice(0, s - r));
  }, e.prototype.leafAppend = function(n) {
    var s = this.right.leafAppend(n);
    if (s)
      return new e(this.left, s);
  }, e.prototype.leafPrepend = function(n) {
    var s = this.left.leafPrepend(n);
    if (s)
      return new e(s, this.right);
  }, e.prototype.appendInner = function(n) {
    return this.left.depth >= Math.max(this.right.depth, n.depth) + 1 ? new e(this.left, new e(this.right, n)) : new e(this, n);
  }, e;
})(jA);
const MK = 500;
class Xs {
  constructor(e, A) {
    this.items = e, this.eventCount = A;
  }
  // Pop the latest event off the branch's history and apply it
  // to a document transform.
  popEvent(e, A) {
    if (this.eventCount == 0)
      return null;
    let n = this.items.length;
    for (; ; n--)
      if (this.items.get(n - 1).selection) {
        --n;
        break;
      }
    let s, r;
    A && (s = this.remapping(n, this.items.length), r = s.maps.length);
    let i = e.tr, o, a, c = [], l = [];
    return this.items.forEach((B, g) => {
      if (!B.step) {
        s || (s = this.remapping(n, g + 1), r = s.maps.length), r--, l.push(B);
        return;
      }
      if (s) {
        l.push(new Bo(B.map));
        let h = B.step.map(s.slice(r)), u;
        h && i.maybeStep(h).doc && (u = i.mapping.maps[i.mapping.maps.length - 1], c.push(new Bo(u, void 0, void 0, c.length + l.length))), r--, u && s.appendMap(u, r);
      } else
        i.maybeStep(B.step);
      if (B.selection)
        return o = s ? B.selection.map(s.slice(r)) : B.selection, a = new Xs(this.items.slice(0, n).append(l.reverse().concat(c)), this.eventCount - 1), !1;
    }, this.items.length, 0), { remaining: a, transform: i, selection: o };
  }
  // Create a new branch with the given transform added.
  addTransform(e, A, n, s) {
    let r = [], i = this.eventCount, o = this.items, a = !s && o.length ? o.get(o.length - 1) : null;
    for (let l = 0; l < e.steps.length; l++) {
      let B = e.steps[l].invert(e.docs[l]), g = new Bo(e.mapping.maps[l], B, A), h;
      (h = a && a.merge(g)) && (g = h, l ? r.pop() : o = o.slice(0, o.length - 1)), r.push(g), A && (i++, A = void 0), s || (a = g);
    }
    let c = i - n.depth;
    return c > mK && (o = pK(o, c), i -= c), new Xs(o.append(r), i);
  }
  remapping(e, A) {
    let n = new pg();
    return this.items.forEach((s, r) => {
      let i = s.mirrorOffset != null && r - s.mirrorOffset >= e ? n.maps.length - s.mirrorOffset : void 0;
      n.appendMap(s.map, i);
    }, e, A), n;
  }
  addMaps(e) {
    return this.eventCount == 0 ? this : new Xs(this.items.append(e.map((A) => new Bo(A))), this.eventCount);
  }
  // When the collab module receives remote changes, the history has
  // to know about those, so that it can adjust the steps that were
  // rebased on top of the remote changes, and include the position
  // maps for the remote changes in its array of items.
  rebased(e, A) {
    if (!this.eventCount)
      return this;
    let n = [], s = Math.max(0, this.items.length - A), r = e.mapping, i = e.steps.length, o = this.eventCount;
    this.items.forEach((g) => {
      g.selection && o--;
    }, s);
    let a = A;
    this.items.forEach((g) => {
      let h = r.getMirror(--a);
      if (h == null)
        return;
      i = Math.min(i, h);
      let u = r.maps[h];
      if (g.step) {
        let d = e.steps[h].invert(e.docs[h]), w = g.selection && g.selection.map(r.slice(a + 1, h));
        w && o++, n.push(new Bo(u, d, w));
      } else
        n.push(new Bo(u));
    }, s);
    let c = [];
    for (let g = A; g < i; g++)
      c.push(new Bo(r.maps[g]));
    let l = this.items.slice(0, s).append(c).append(n), B = new Xs(l, o);
    return B.emptyItemCount() > MK && (B = B.compress(this.items.length - n.length)), B;
  }
  emptyItemCount() {
    let e = 0;
    return this.items.forEach((A) => {
      A.step || e++;
    }), e;
  }
  // Compressing a branch means rewriting it to push the air (map-only
  // items) out. During collaboration, these naturally accumulate
  // because each remote change adds one. The `upto` argument is used
  // to ensure that only the items below a given level are compressed,
  // because `rebased` relies on a clean, untouched set of items in
  // order to associate old items with rebased steps.
  compress(e = this.items.length) {
    let A = this.remapping(0, e), n = A.maps.length, s = [], r = 0;
    return this.items.forEach((i, o) => {
      if (o >= e)
        s.push(i), i.selection && r++;
      else if (i.step) {
        let a = i.step.map(A.slice(n)), c = a && a.getMap();
        if (n--, c && A.appendMap(c, n), a) {
          let l = i.selection && i.selection.map(A.slice(n));
          l && r++;
          let B = new Bo(c.invert(), a, l), g, h = s.length - 1;
          (g = s.length && s[h].merge(B)) ? s[h] = g : s.push(B);
        }
      } else i.map && n--;
    }, this.items.length, 0), new Xs(jA.from(s.reverse()), r);
  }
}
Xs.empty = new Xs(jA.empty, 0);
function pK(t, e) {
  let A;
  return t.forEach((n, s) => {
    if (n.selection && e-- == 0)
      return A = s, !1;
  }), t.slice(A);
}
let Bo = class jz {
  constructor(e, A, n, s) {
    this.map = e, this.step = A, this.selection = n, this.mirrorOffset = s;
  }
  merge(e) {
    if (this.step && e.step && !e.selection) {
      let A = e.step.merge(this.step);
      if (A)
        return new jz(A.getMap().invert(), A, this.selection);
    }
  }
};
class mo {
  constructor(e, A, n, s, r) {
    this.done = e, this.undone = A, this.prevRanges = n, this.prevTime = s, this.prevComposition = r;
  }
}
const mK = 20;
function YK(t, e, A, n) {
  let s = A.getMeta(Ja), r;
  if (s)
    return s.historyState;
  A.getMeta(NK) && (t = new mo(t.done, t.undone, null, 0, -1));
  let i = A.getMeta("appendedTransaction");
  if (A.steps.length == 0)
    return t;
  if (i && i.getMeta(Ja))
    return i.getMeta(Ja).redo ? new mo(t.done.addTransform(A, void 0, n, Au(e)), t.undone, v1(A.mapping.maps), t.prevTime, t.prevComposition) : new mo(t.done, t.undone.addTransform(A, void 0, n, Au(e)), null, t.prevTime, t.prevComposition);
  if (A.getMeta("addToHistory") !== !1 && !(i && i.getMeta("addToHistory") === !1)) {
    let o = A.getMeta("composition"), a = t.prevTime == 0 || !i && t.prevComposition != o && (t.prevTime < (A.time || 0) - n.newGroupDelay || !yK(A, t.prevRanges)), c = i ? SQ(t.prevRanges, A.mapping) : v1(A.mapping.maps);
    return new mo(t.done.addTransform(A, a ? e.selection.getBookmark() : void 0, n, Au(e)), Xs.empty, c, A.time, o ?? t.prevComposition);
  } else return (r = A.getMeta("rebased")) ? new mo(t.done.rebased(A, r), t.undone.rebased(A, r), SQ(t.prevRanges, A.mapping), t.prevTime, t.prevComposition) : new mo(t.done.addMaps(A.mapping.maps), t.undone.addMaps(A.mapping.maps), SQ(t.prevRanges, A.mapping), t.prevTime, t.prevComposition);
}
function yK(t, e) {
  if (!e)
    return !1;
  if (!t.docChanged)
    return !0;
  let A = !1;
  return t.mapping.maps[0].forEach((n, s) => {
    for (let r = 0; r < e.length; r += 2)
      n <= e[r + 1] && s >= e[r] && (A = !0);
  }), A;
}
function v1(t) {
  let e = [];
  for (let A = t.length - 1; A >= 0 && e.length == 0; A--)
    t[A].forEach((n, s, r, i) => e.push(r, i));
  return e;
}
function SQ(t, e) {
  if (!t)
    return null;
  let A = [];
  for (let n = 0; n < t.length; n += 2) {
    let s = e.map(t[n], 1), r = e.map(t[n + 1], -1);
    s <= r && A.push(s, r);
  }
  return A;
}
function FK(t, e, A) {
  let n = Au(e), s = Ja.get(e).spec.config, r = (A ? t.undone : t.done).popEvent(e, n);
  if (!r)
    return null;
  let i = r.selection.resolve(r.transform.doc), o = (A ? t.done : t.undone).addTransform(r.transform, e.selection.getBookmark(), s, n), a = new mo(A ? o : r.remaining, A ? r.remaining : o, null, 0, -1);
  return r.transform.setSelection(i).setMeta(Ja, { redo: A, historyState: a });
}
let TQ = !1, j1 = null;
function Au(t) {
  let e = t.plugins;
  if (j1 != e) {
    TQ = !1, j1 = e;
    for (let A = 0; A < e.length; A++)
      if (e[A].spec.historyPreserveItems) {
        TQ = !0;
        break;
      }
  }
  return TQ;
}
const Ja = new Bt("history"), NK = new Bt("closeHistory");
function DK(t = {}) {
  return t = {
    depth: t.depth || 100,
    newGroupDelay: t.newGroupDelay || 500
  }, new ct({
    key: Ja,
    state: {
      init() {
        return new mo(Xs.empty, Xs.empty, null, 0, -1);
      },
      apply(e, A, n) {
        return YK(A, n, e, t);
      }
    },
    config: t,
    props: {
      handleDOMEvents: {
        beforeinput(e, A) {
          let n = A.inputType, s = n == "historyUndo" ? kz : n == "historyRedo" ? Rz : null;
          return !s || !e.editable ? !1 : (A.preventDefault(), s(e.state, e.dispatch));
        }
      }
    }
  });
}
function Hz(t, e) {
  return (A, n) => {
    let s = Ja.getState(A);
    if (!s || (t ? s.undone : s.done).eventCount == 0)
      return !1;
    if (n) {
      let r = FK(s, A, t);
      r && n(e ? r.scrollIntoView() : r);
    }
    return !0;
  };
}
const kz = Hz(!1, !0), Rz = Hz(!0, !0);
var xK = tt.create({
  name: "characterCount",
  addOptions() {
    return {
      limit: null,
      mode: "textSize",
      textCounter: (t) => t.length,
      wordCounter: (t) => t.split(" ").filter((e) => e !== "").length
    };
  },
  addStorage() {
    return {
      characters: () => 0,
      words: () => 0
    };
  },
  onBeforeCreate() {
    this.storage.characters = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc;
      if (((t == null ? void 0 : t.mode) || this.options.mode) === "textSize") {
        const n = e.textBetween(0, e.content.size, void 0, " ");
        return this.options.textCounter(n);
      }
      return e.nodeSize;
    }, this.storage.words = (t) => {
      const e = (t == null ? void 0 : t.node) || this.editor.state.doc, A = e.textBetween(0, e.content.size, " ", " ");
      return this.options.wordCounter(A);
    };
  },
  addProseMirrorPlugins() {
    let t = !1;
    return [
      new ct({
        key: new Bt("characterCount"),
        appendTransaction: (e, A, n) => {
          if (t)
            return;
          const s = this.options.limit;
          if (s == null || s === 0) {
            t = !0;
            return;
          }
          const r = this.storage.characters({ node: n.doc });
          if (r > s) {
            const i = r - s, o = 0, a = i;
            console.warn(
              `[CharacterCount] Initial content exceeded limit of ${s} characters. Content was automatically trimmed.`
            );
            const c = n.tr.deleteRange(o, a);
            return t = !0, c;
          }
          t = !0;
        },
        filterTransaction: (e, A) => {
          const n = this.options.limit;
          if (!e.docChanged || n === 0 || n === null || n === void 0)
            return !0;
          const s = this.storage.characters({ node: A.doc }), r = this.storage.characters({ node: e.doc });
          if (r <= n || s > n && r > n && r <= s)
            return !0;
          if (s > n && r > n && r > s || !e.getMeta("paste"))
            return !1;
          const o = e.selection.$head.pos, a = r - n, c = o - a, l = o;
          return e.deleteRange(c, l), !(this.storage.characters({ node: e.doc }) > n);
        }
      })
    ];
  }
}), GK = tt.create({
  name: "dropCursor",
  addOptions() {
    return {
      color: "currentColor",
      width: 1,
      class: void 0
    };
  },
  addProseMirrorPlugins() {
    return [gK(this.options)];
  }
});
tt.create({
  name: "focus",
  addOptions() {
    return {
      className: "has-focus",
      mode: "all"
    };
  },
  addProseMirrorPlugins() {
    return [
      new ct({
        key: new Bt("focus"),
        props: {
          decorations: ({ doc: t, selection: e }) => {
            const { isEditable: A, isFocused: n } = this.editor, { anchor: s } = e, r = [];
            if (!A || !n)
              return It.create(t, []);
            let i = 0;
            this.options.mode === "deepest" && t.descendants((a, c) => {
              if (a.isText)
                return;
              if (!(s >= c && s <= c + a.nodeSize - 1))
                return !1;
              i += 1;
            });
            let o = 0;
            return t.descendants((a, c) => {
              if (a.isText || !(s >= c && s <= c + a.nodeSize - 1))
                return !1;
              if (o += 1, this.options.mode === "deepest" && i - o > 0 || this.options.mode === "shallowest" && o > 1)
                return this.options.mode === "deepest";
              r.push(
                Wt.node(c, c + a.nodeSize, {
                  class: this.options.className
                })
              );
            }), It.create(t, r);
          }
        }
      })
    ];
  }
});
var zK = tt.create({
  name: "gapCursor",
  addProseMirrorPlugins() {
    return [wK()];
  },
  extendNodeSchema(t) {
    var e;
    const A = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      allowGapCursor: (e = Nt(He(t, "allowGapCursor", A))) != null ? e : null
    };
  }
}), H1 = "placeholder";
function UK(t) {
  return t.replace(/\s+/g, "-").replace(/[^a-zA-Z0-9-]/g, "").replace(/^[0-9-]+/, "").replace(/^-+/, "").toLowerCase();
}
var bK = tt.create({
  name: "placeholder",
  addOptions() {
    return {
      emptyEditorClass: "is-editor-empty",
      emptyNodeClass: "is-empty",
      dataAttribute: H1,
      placeholder: "Write something …",
      showOnlyWhenEditable: !0,
      showOnlyCurrent: !0,
      includeChildren: !1
    };
  },
  addProseMirrorPlugins() {
    const t = this.options.dataAttribute ? `data-${UK(this.options.dataAttribute)}` : `data-${H1}`;
    return [
      new ct({
        key: new Bt("placeholder"),
        props: {
          decorations: ({ doc: e, selection: A }) => {
            const n = this.editor.isEditable || !this.options.showOnlyWhenEditable, { anchor: s } = A, r = [];
            if (!n)
              return null;
            const i = this.editor.isEmpty;
            return e.descendants((o, a) => {
              const c = s >= a && s <= a + o.nodeSize, l = !o.isLeaf && Uw(o);
              if ((c || !this.options.showOnlyCurrent) && l) {
                const B = [this.options.emptyNodeClass];
                i && B.push(this.options.emptyEditorClass);
                const g = Wt.node(a, a + o.nodeSize, {
                  class: B.join(" "),
                  [t]: typeof this.options.placeholder == "function" ? this.options.placeholder({
                    editor: this.editor,
                    node: o,
                    pos: a,
                    hasAnchor: c
                  }) : this.options.placeholder
                });
                r.push(g);
              }
              return this.options.includeChildren;
            }), It.create(e, r);
          }
        }
      })
    ];
  }
});
tt.create({
  name: "selection",
  addOptions() {
    return {
      className: "selection"
    };
  },
  addProseMirrorPlugins() {
    const { editor: t, options: e } = this;
    return [
      new ct({
        key: new Bt("selection"),
        props: {
          decorations(A) {
            return A.selection.empty || t.isFocused || !t.isEditable || CG(A.selection) || t.view.dragging ? null : It.create(A.doc, [
              Wt.inline(A.selection.from, A.selection.to, {
                class: e.className
              })
            ]);
          }
        }
      })
    ];
  }
});
function k1({ types: t, node: e }) {
  return e && Array.isArray(t) && t.includes(e.type) || (e == null ? void 0 : e.type) === t;
}
var vK = tt.create({
  name: "trailingNode",
  addOptions() {
    return {
      node: void 0,
      notAfter: []
    };
  },
  addProseMirrorPlugins() {
    var t;
    const e = new Bt(this.name), A = this.options.node || ((t = this.editor.schema.topNodeType.contentMatch.defaultType) == null ? void 0 : t.name) || "paragraph", n = Object.entries(this.editor.schema.nodes).map(([, s]) => s).filter((s) => (this.options.notAfter || []).concat(A).includes(s.name));
    return [
      new ct({
        key: e,
        appendTransaction: (s, r, i) => {
          const { doc: o, tr: a, schema: c } = i, l = e.getState(i), B = o.content.size, g = c.nodes[A];
          if (l)
            return a.insert(B, g.create());
        },
        state: {
          init: (s, r) => {
            const i = r.tr.doc.lastChild;
            return !k1({ node: i, types: n });
          },
          apply: (s, r) => {
            if (!s.docChanged || s.getMeta("__uniqueIDTransaction"))
              return r;
            const i = s.doc.lastChild;
            return !k1({ node: i, types: n });
          }
        }
      })
    ];
  }
}), jK = tt.create({
  name: "undoRedo",
  addOptions() {
    return {
      depth: 100,
      newGroupDelay: 500
    };
  },
  addCommands() {
    return {
      undo: () => ({ state: t, dispatch: e }) => kz(t, e),
      redo: () => ({ state: t, dispatch: e }) => Rz(t, e)
    };
  },
  addProseMirrorPlugins() {
    return [DK(this.options)];
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Shift-Mod-z": () => this.editor.commands.redo(),
      "Mod-y": () => this.editor.commands.redo(),
      // Russian keyboard layouts
      "Mod-я": () => this.editor.commands.undo(),
      "Shift-Mod-я": () => this.editor.commands.redo()
    };
  }
}), HK = tt.create({
  name: "starterKit",
  addExtensions() {
    var t, e, A, n;
    const s = [];
    return this.options.bold !== !1 && s.push(cP.configure(this.options.bold)), this.options.blockquote !== !1 && s.push(sP.configure(this.options.blockquote)), this.options.bulletList !== !1 && s.push(Ez.configure(this.options.bulletList)), this.options.code !== !1 && s.push(gP.configure(this.options.code)), this.options.codeBlock !== !1 && s.push(dP.configure(this.options.codeBlock)), this.options.document !== !1 && s.push(wP.configure(this.options.document)), this.options.dropcursor !== !1 && s.push(GK.configure(this.options.dropcursor)), this.options.gapcursor !== !1 && s.push(zK.configure(this.options.gapcursor)), this.options.hardBreak !== !1 && s.push(fP.configure(this.options.hardBreak)), this.options.heading !== !1 && s.push(QP.configure(this.options.heading)), this.options.undoRedo !== !1 && s.push(jK.configure(this.options.undoRedo)), this.options.horizontalRule !== !1 && s.push(IP.configure(this.options.horizontalRule)), this.options.italic !== !1 && s.push(mP.configure(this.options.italic)), this.options.listItem !== !1 && s.push(Mz.configure(this.options.listItem)), this.options.listKeymap !== !1 && s.push(Nz.configure((t = this.options) == null ? void 0 : t.listKeymap)), this.options.link !== !1 && s.push(Cz.configure((e = this.options) == null ? void 0 : e.link)), this.options.orderedList !== !1 && s.push(xz.configure(this.options.orderedList)), this.options.paragraph !== !1 && s.push(oK.configure(this.options.paragraph)), this.options.strike !== !1 && s.push(lK.configure(this.options.strike)), this.options.text !== !1 && s.push(BK.configure(this.options.text)), this.options.underline !== !1 && s.push(Uz.configure((A = this.options) == null ? void 0 : A.underline)), this.options.trailingNode !== !1 && s.push(vK.configure((n = this.options) == null ? void 0 : n.trailingNode)), s;
  }
}), kK = HK;
const RK = tt.create({
  name: "textAlign",
  addOptions() {
    return {
      types: [],
      alignments: [
        "left",
        "center",
        "right",
        "justify"
      ],
      defaultAlignment: null
    };
  },
  addGlobalAttributes() {
    return [{
      types: this.options.types,
      attributes: { textAlign: {
        default: this.options.defaultAlignment,
        parseHTML: (t) => {
          const e = t.style.textAlign;
          return this.options.alignments.includes(e) ? e : this.options.defaultAlignment;
        },
        renderHTML: (t) => t.textAlign ? { style: `text-align: ${t.textAlign}` } : {}
      } }
    }];
  },
  addCommands() {
    return {
      setTextAlign: (t) => ({ commands: e }) => this.options.alignments.includes(t) ? this.options.types.map((A) => e.updateAttributes(A, { textAlign: t })).some((A) => A) : !1,
      unsetTextAlign: () => ({ commands: t }) => this.options.types.map((e) => t.resetAttributes(e, "textAlign")).some((e) => e),
      toggleTextAlign: (t) => ({ editor: e, commands: A }) => this.options.alignments.includes(t) ? e.isActive({ textAlign: t }) ? A.unsetTextAlign() : A.setTextAlign(t) : !1
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-l": () => this.editor.commands.setTextAlign("left"),
      "Mod-Shift-e": () => this.editor.commands.setTextAlign("center"),
      "Mod-Shift-r": () => this.editor.commands.setTextAlign("right"),
      "Mod-Shift-j": () => this.editor.commands.setTextAlign("justify")
    };
  }
});
var LK = RK, SK = bK, TK = Gz, JK = zz, Lz = Zt.create({
  name: "tableCell",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          var e, A;
          const n = t.getAttribute("colwidth"), s = n ? n.split(",").map((r) => parseInt(r, 10)) : null;
          if (!s) {
            const r = (e = t.closest("table")) == null ? void 0 : e.querySelectorAll("colgroup > col"), i = Array.from(((A = t.parentElement) == null ? void 0 : A.children) || []).indexOf(t);
            if (i && i > -1 && r && r[i]) {
              const o = r[i].getAttribute("width");
              return o ? [parseInt(o, 10)] : null;
            }
          }
          return s;
        }
      }
    };
  },
  tableRole: "cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "td" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["td", Ct(this.options.HTMLAttributes, t), 0];
  }
}), Sz = Zt.create({
  name: "tableHeader",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "block+",
  addAttributes() {
    return {
      colspan: {
        default: 1
      },
      rowspan: {
        default: 1
      },
      colwidth: {
        default: null,
        parseHTML: (t) => {
          const e = t.getAttribute("colwidth");
          return e ? e.split(",").map((n) => parseInt(n, 10)) : null;
        }
      }
    };
  },
  tableRole: "header_cell",
  isolating: !0,
  parseHTML() {
    return [{ tag: "th" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["th", Ct(this.options.HTMLAttributes, t), 0];
  }
}), Tz = Zt.create({
  name: "tableRow",
  addOptions() {
    return {
      HTMLAttributes: {}
    };
  },
  content: "(tableCell | tableHeader)*",
  tableRole: "row",
  parseHTML() {
    return [{ tag: "tr" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["tr", Ct(this.options.HTMLAttributes, t), 0];
  }
});
function lE(t, e) {
  return e ? ["width", `${Math.max(e, t)}px`] : ["min-width", `${t}px`];
}
function R1(t, e, A, n, s, r) {
  var i;
  let o = 0, a = !0, c = e.firstChild;
  const l = t.firstChild;
  if (l !== null)
    for (let g = 0, h = 0; g < l.childCount; g += 1) {
      const { colspan: u, colwidth: d } = l.child(g).attrs;
      for (let w = 0; w < u; w += 1, h += 1) {
        const Q = s === h ? r : d && d[w], p = Q ? `${Q}px` : "";
        if (o += Q || n, Q || (a = !1), c) {
          if (c.style.width !== p) {
            const [M, I] = lE(n, Q);
            c.style.setProperty(M, I);
          }
          c = c.nextSibling;
        } else {
          const M = document.createElement("col"), [I, N] = lE(n, Q);
          M.style.setProperty(I, N), e.appendChild(M);
        }
      }
    }
  for (; c; ) {
    const g = c.nextSibling;
    (i = c.parentNode) == null || i.removeChild(c), c = g;
  }
  const B = t.attrs.style && typeof t.attrs.style == "string" && /\bwidth\s*:/i.test(t.attrs.style);
  a && !B ? (A.style.width = `${o}px`, A.style.minWidth = "") : (A.style.width = "", A.style.minWidth = `${o}px`);
}
var WK = class {
  constructor(t, e) {
    this.node = t, this.cellMinWidth = e, this.dom = document.createElement("div"), this.dom.className = "tableWrapper", this.table = this.dom.appendChild(document.createElement("table")), t.attrs.style && (this.table.style.cssText = t.attrs.style), this.colgroup = this.table.appendChild(document.createElement("colgroup")), R1(t, this.colgroup, this.table, e), this.contentDOM = this.table.appendChild(document.createElement("tbody"));
  }
  update(t) {
    return t.type !== this.node.type ? !1 : (this.node = t, R1(t, this.colgroup, this.table, this.cellMinWidth), !0);
  }
  ignoreMutation(t) {
    const e = t.target, A = this.dom.contains(e), n = this.contentDOM.contains(e);
    return !!(A && !n && (t.type === "attributes" || t.type === "childList" || t.type === "characterData"));
  }
};
function OK(t, e, A, n) {
  let s = 0, r = !0;
  const i = [], o = t.firstChild;
  if (!o)
    return {};
  for (let B = 0, g = 0; B < o.childCount; B += 1) {
    const { colspan: h, colwidth: u } = o.child(B).attrs;
    for (let d = 0; d < h; d += 1, g += 1) {
      const w = A === g ? n : u && u[d];
      s += w || e, w || (r = !1);
      const [Q, p] = lE(e, w);
      i.push(["col", { style: `${Q}: ${p}` }]);
    }
  }
  const a = r ? `${s}px` : "", c = r ? "" : `${s}px`;
  return { colgroup: ["colgroup", {}, ...i], tableWidth: a, tableMinWidth: c };
}
function L1(t, e) {
  return t.createAndFill();
}
function PK(t) {
  if (t.cached.tableNodeTypes)
    return t.cached.tableNodeTypes;
  const e = {};
  return Object.keys(t.nodes).forEach((A) => {
    const n = t.nodes[A];
    n.spec.tableRole && (e[n.spec.tableRole] = n);
  }), t.cached.tableNodeTypes = e, e;
}
function KK(t, e, A, n, s) {
  const r = PK(t), i = [], o = [];
  for (let c = 0; c < A; c += 1) {
    const l = L1(r.cell);
    if (l && o.push(l), n) {
      const B = L1(r.header_cell);
      B && i.push(B);
    }
  }
  const a = [];
  for (let c = 0; c < e; c += 1)
    a.push(r.row.createChecked(null, n && c === 0 ? i : o));
  return r.table.createChecked(null, a);
}
function VK(t) {
  return t instanceof St;
}
var d0 = ({ editor: t }) => {
  const { selection: e } = t.state;
  if (!VK(e))
    return !1;
  let A = 0;
  const n = gG(e.ranges[0].$from, (r) => r.type.name === "table");
  return n == null || n.node.descendants((r) => {
    if (r.type.name === "table")
      return !1;
    ["tableCell", "tableHeader"].includes(r.type.name) && (A += 1);
  }), A === e.ranges.length ? (t.commands.deleteTable(), !0) : !1;
}, XK = "";
function ZK(t) {
  return (t || "").replace(/\s+/g, " ").trim();
}
function qK(t, e, A = {}) {
  var n;
  const s = (n = A.cellLineSeparator) != null ? n : XK;
  if (!t || !t.content || t.content.length === 0)
    return "";
  const r = [];
  t.content.forEach((u) => {
    const d = [];
    u.content && u.content.forEach((w) => {
      let Q = "";
      w.content && Array.isArray(w.content) && w.content.length > 1 ? Q = w.content.map((N) => e.renderChildren(N)).join(s) : Q = w.content ? e.renderChildren(w.content) : "";
      const p = ZK(Q), M = w.type === "tableHeader";
      d.push({ text: p, isHeader: M });
    }), r.push(d);
  });
  const i = r.reduce((u, d) => Math.max(u, d.length), 0);
  if (i === 0)
    return "";
  const o = new Array(i).fill(0);
  r.forEach((u) => {
    var d;
    for (let w = 0; w < i; w += 1) {
      const p = (((d = u[w]) == null ? void 0 : d.text) || "").length;
      p > o[w] && (o[w] = p), o[w] < 3 && (o[w] = 3);
    }
  });
  const a = (u, d) => u + " ".repeat(Math.max(0, d - u.length)), c = r[0], l = c.some((u) => u.isHeader);
  let B = `
`;
  const g = new Array(i).fill(0).map((u, d) => l && c[d] && c[d].text || "");
  return B += `| ${g.map((u, d) => a(u, o[d])).join(" | ")} |
`, B += `| ${o.map((u) => "-".repeat(Math.max(3, u))).join(" | ")} |
`, (l ? r.slice(1) : r).forEach((u) => {
    B += `| ${new Array(i).fill(0).map((d, w) => a(u[w] && u[w].text || "", o[w])).join(" | ")} |
`;
  }), B;
}
var _K = qK, Jz = Zt.create({
  name: "table",
  // @ts-ignore
  addOptions() {
    return {
      HTMLAttributes: {},
      resizable: !1,
      renderWrapper: !1,
      handleWidth: 5,
      cellMinWidth: 25,
      // TODO: fix
      View: WK,
      lastColumnResizable: !0,
      allowTableNodeSelection: !1
    };
  },
  content: "tableRow+",
  tableRole: "table",
  isolating: !0,
  group: "block",
  parseHTML() {
    return [{ tag: "table" }];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    const { colgroup: A, tableWidth: n, tableMinWidth: s } = OK(t, this.options.cellMinWidth), r = e.style;
    function i() {
      return r || (n ? `width: ${n}` : `min-width: ${s}`);
    }
    const o = [
      "table",
      Ct(this.options.HTMLAttributes, e, {
        style: i()
      }),
      A,
      ["tbody", 0]
    ];
    return this.options.renderWrapper ? ["div", { class: "tableWrapper" }, o] : o;
  },
  parseMarkdown: (t, e) => {
    const A = [];
    if (t.header) {
      const n = [];
      t.header.forEach((s) => {
        n.push(e.createNode("tableHeader", {}, [{ type: "paragraph", content: e.parseInline(s.tokens) }]));
      }), A.push(e.createNode("tableRow", {}, n));
    }
    return t.rows && t.rows.forEach((n) => {
      const s = [];
      n.forEach((r) => {
        s.push(e.createNode("tableCell", {}, [{ type: "paragraph", content: e.parseInline(r.tokens) }]));
      }), A.push(e.createNode("tableRow", {}, s));
    }), e.createNode("table", void 0, A);
  },
  renderMarkdown: (t, e) => _K(t, e),
  addCommands() {
    return {
      insertTable: ({ rows: t = 3, cols: e = 3, withHeaderRow: A = !0 } = {}) => ({ tr: n, dispatch: s, editor: r }) => {
        const i = KK(r.schema, t, e, A);
        if (s) {
          const o = n.selection.from + 1;
          n.replaceSelectionWith(i).scrollIntoView().setSelection(Re.near(n.doc.resolve(o)));
        }
        return !0;
      },
      addColumnBefore: () => ({ state: t, dispatch: e }) => fO(t, e),
      addColumnAfter: () => ({ state: t, dispatch: e }) => QO(t, e),
      deleteColumn: () => ({ state: t, dispatch: e }) => CO(t, e),
      addRowBefore: () => ({ state: t, dispatch: e }) => MO(t, e),
      addRowAfter: () => ({ state: t, dispatch: e }) => pO(t, e),
      deleteRow: () => ({ state: t, dispatch: e }) => YO(t, e),
      deleteTable: () => ({ state: t, dispatch: e }) => zO(t, e),
      mergeCells: () => ({ state: t, dispatch: e }) => B1(t, e),
      splitCell: () => ({ state: t, dispatch: e }) => g1(t, e),
      toggleHeaderColumn: () => ({ state: t, dispatch: e }) => Gg("column")(t, e),
      toggleHeaderRow: () => ({ state: t, dispatch: e }) => Gg("row")(t, e),
      toggleHeaderCell: () => ({ state: t, dispatch: e }) => xO(t, e),
      mergeOrSplit: () => ({ state: t, dispatch: e }) => B1(t, e) ? !0 : g1(t, e),
      setCellAttribute: (t, e) => ({ state: A, dispatch: n }) => NO(t, e)(A, n),
      goToNextCell: () => ({ state: t, dispatch: e }) => u1(1)(t, e),
      goToPreviousCell: () => ({ state: t, dispatch: e }) => u1(-1)(t, e),
      fixTables: () => ({ state: t, dispatch: e }) => (e && iz(t), !0),
      setCellSelection: (t) => ({ tr: e, dispatch: A }) => {
        if (A) {
          const n = St.create(e.doc, t.anchorCell, t.headCell);
          e.setSelection(n);
        }
        return !0;
      }
    };
  },
  addKeyboardShortcuts() {
    return {
      Tab: () => this.editor.commands.goToNextCell() ? !0 : this.editor.can().addRowAfter() ? this.editor.chain().addRowAfter().goToNextCell().run() : !1,
      "Shift-Tab": () => this.editor.commands.goToPreviousCell(),
      Backspace: d0,
      "Mod-Backspace": d0,
      Delete: d0,
      "Mod-Delete": d0
    };
  },
  addProseMirrorPlugins() {
    return [
      ...this.options.resizable && this.editor.isEditable ? [
        TO({
          handleWidth: this.options.handleWidth,
          cellMinWidth: this.options.cellMinWidth,
          defaultCellMinWidth: this.options.cellMinWidth,
          View: this.options.View,
          lastColumnResizable: this.options.lastColumnResizable
        })
      ] : [],
      _O({
        allowTableNodeSelection: this.options.allowTableNodeSelection
      })
    ];
  },
  extendNodeSchema(t) {
    const e = {
      name: t.name,
      options: t.options,
      storage: t.storage
    };
    return {
      tableRole: Nt(He(t, "tableRole", e))
    };
  }
});
tt.create({
  name: "tableKit",
  addExtensions() {
    const t = [];
    return this.options.table !== !1 && t.push(Jz.configure(this.options.table)), this.options.tableCell !== !1 && t.push(Lz.configure(this.options.tableCell)), this.options.tableHeader !== !1 && t.push(Sz.configure(this.options.tableHeader)), this.options.tableRow !== !1 && t.push(Tz.configure(this.options.tableRow)), t;
  }
});
var $K = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))$/, eV = /(?:^|\s)(==(?!\s+==)((?:[^=]+))==(?!\s+==))/g, tV = qr.create({
  name: "highlight",
  addOptions() {
    return {
      multicolor: !1,
      HTMLAttributes: {}
    };
  },
  addAttributes() {
    return this.options.multicolor ? {
      color: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-color") || t.style.backgroundColor,
        renderHTML: (t) => t.color ? {
          "data-color": t.color,
          style: `background-color: ${t.color}; color: inherit`
        } : {}
      }
    } : {};
  },
  parseHTML() {
    return [
      {
        tag: "mark"
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["mark", Ct(this.options.HTMLAttributes, t), 0];
  },
  renderMarkdown: (t, e) => `==${e.renderChildren(t)}==`,
  parseMarkdown: (t, e) => e.applyMark("highlight", e.parseInline(t.tokens || [])),
  markdownTokenizer: {
    name: "highlight",
    level: "inline",
    start: (t) => t.indexOf("=="),
    tokenize(t, e, A) {
      const s = /^(==)([^=]+)(==)/.exec(t);
      if (s) {
        const r = s[2].trim(), i = A.inlineTokens(r);
        return {
          type: "highlight",
          raw: s[0],
          text: r,
          tokens: i
        };
      }
    }
  },
  addCommands() {
    return {
      setHighlight: (t) => ({ commands: e }) => e.setMark(this.name, t),
      toggleHighlight: (t) => ({ commands: e }) => e.toggleMark(this.name, t),
      unsetHighlight: () => ({ commands: t }) => t.unsetMark(this.name)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-Shift-h": () => this.editor.commands.toggleHighlight()
    };
  },
  addInputRules() {
    return [
      _a({
        find: $K,
        type: this.type
      })
    ];
  },
  addPasteRules() {
    return [
      Xo({
        find: eV,
        type: this.type
      })
    ];
  }
}), AV = /(?:^|\s)(!\[(.+|:?)]\((\S+)(?:(?:\s+)["'](\S+)["'])?\))$/, nV = Zt.create({
  name: "image",
  addOptions() {
    return {
      inline: !1,
      allowBase64: !1,
      HTMLAttributes: {},
      resize: !1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      alt: {
        default: null
      },
      title: {
        default: null
      },
      width: {
        default: null
      },
      height: {
        default: null
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: this.options.allowBase64 ? "img[src]" : 'img[src]:not([src^="data:"])'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["img", Ct(this.options.HTMLAttributes, t)];
  },
  parseMarkdown: (t, e) => e.createNode("image", {
    src: t.href,
    title: t.title,
    alt: t.text
  }),
  renderMarkdown: (t) => {
    var e, A, n, s, r, i;
    const o = (A = (e = t.attrs) == null ? void 0 : e.src) != null ? A : "", a = (s = (n = t.attrs) == null ? void 0 : n.alt) != null ? s : "", c = (i = (r = t.attrs) == null ? void 0 : r.title) != null ? i : "";
    return c ? `![${a}](${o} "${c}")` : `![${a}](${o})`;
  },
  addNodeView() {
    if (!this.options.resize || !this.options.resize.enabled || typeof document > "u")
      return null;
    const { directions: t, minWidth: e, minHeight: A, alwaysPreserveAspectRatio: n } = this.options.resize;
    return ({ node: s, getPos: r, HTMLAttributes: i, editor: o }) => {
      const a = document.createElement("img");
      Object.entries(i).forEach(([B, g]) => {
        if (g != null)
          switch (B) {
            case "width":
            case "height":
              break;
            default:
              a.setAttribute(B, g);
              break;
          }
      }), a.src = i.src;
      const c = new JJ({
        element: a,
        editor: o,
        node: s,
        getPos: r,
        onResize: (B, g) => {
          a.style.width = `${B}px`, a.style.height = `${g}px`;
        },
        onCommit: (B, g) => {
          const h = r();
          h !== void 0 && this.editor.chain().setNodeSelection(h).updateAttributes(this.name, {
            width: B,
            height: g
          }).run();
        },
        onUpdate: (B, g, h) => B.type === s.type,
        options: {
          directions: t,
          min: {
            width: e,
            height: A
          },
          preserveAspectRatio: n === !0
        }
      }), l = c.dom;
      return l.style.visibility = "hidden", l.style.pointerEvents = "none", a.onload = () => {
        l.style.visibility = "", l.style.pointerEvents = "";
      }, c;
    };
  },
  addCommands() {
    return {
      setImage: (t) => ({ commands: e }) => e.insertContent({
        type: this.name,
        attrs: t
      })
    };
  },
  addInputRules() {
    return [
      kG({
        find: AV,
        type: this.type,
        getAttributes: (t) => {
          const [, , e, A, n] = t;
          return { src: A, alt: e, title: n };
        }
      })
    ];
  }
});
function sV(t) {
  var e;
  const { char: A, allowSpaces: n, allowToIncludeChar: s, allowedPrefixes: r, startOfLine: i, $position: o } = t, a = n && !s, c = OJ(A), l = new RegExp(`\\s${c}$`), B = i ? "^" : "", g = s ? "" : c, h = a ? new RegExp(`${B}${c}.*?(?=\\s${g}|$)`, "gm") : new RegExp(`${B}(?:^)?${c}[^\\s${g}]*`, "gm"), u = ((e = o.nodeBefore) == null ? void 0 : e.isText) && o.nodeBefore.text;
  if (!u)
    return null;
  const d = o.pos - u.length, w = Array.from(u.matchAll(h)).pop();
  if (!w || w.input === void 0 || w.index === void 0)
    return null;
  const Q = w.input.slice(Math.max(0, w.index - 1), w.index), p = new RegExp(`^[${r == null ? void 0 : r.join("")}\0]?$`).test(Q);
  if (r !== null && !p)
    return null;
  const M = d + w.index;
  let I = M + w[0].length;
  return a && l.test(u.slice(I - 1, I + 1)) && (w[0] += " ", I += 1), M < o.pos && I >= o.pos ? {
    range: {
      from: M,
      to: I
    },
    query: w[0].slice(A.length),
    text: w[0]
  } : null;
}
var rV = new Bt("suggestion");
function Wz({
  pluginKey: t = rV,
  editor: e,
  char: A = "@",
  allowSpaces: n = !1,
  allowToIncludeChar: s = !1,
  allowedPrefixes: r = [" "],
  startOfLine: i = !1,
  decorationTag: o = "span",
  decorationClass: a = "suggestion",
  decorationContent: c = "",
  decorationEmptyClass: l = "is-empty",
  command: B = () => null,
  items: g = () => [],
  render: h = () => ({}),
  allow: u = () => !0,
  findSuggestionMatch: d = sV,
  shouldShow: w
}) {
  let Q;
  const p = h == null ? void 0 : h(), M = () => {
    const E = e.state.selection.$anchor.pos, G = e.view.coordsAtPos(E), { top: Y, right: U, bottom: v, left: b } = G;
    try {
      return new DOMRect(b, Y, U - b, v - Y);
    } catch {
      return null;
    }
  }, I = (E, G) => G ? () => {
    const Y = t.getState(e.state), U = Y == null ? void 0 : Y.decorationId, v = E.dom.querySelector(`[data-decoration-id="${U}"]`);
    return (v == null ? void 0 : v.getBoundingClientRect()) || null;
  } : M;
  function N(E, G) {
    var Y;
    try {
      const v = t.getState(E.state), b = v != null && v.decorationId ? E.dom.querySelector(`[data-decoration-id="${v.decorationId}"]`) : null, W = {
        // @ts-ignore editor is available in closure
        editor: e,
        range: (v == null ? void 0 : v.range) || { from: 0, to: 0 },
        query: (v == null ? void 0 : v.query) || null,
        text: (v == null ? void 0 : v.text) || null,
        items: [],
        command: (q) => B({ editor: e, range: (v == null ? void 0 : v.range) || { from: 0, to: 0 }, props: q }),
        decorationNode: b,
        clientRect: I(E, b)
      };
      (Y = p == null ? void 0 : p.onExit) == null || Y.call(p, W);
    } catch {
    }
    const U = E.state.tr.setMeta(G, { exit: !0 });
    E.dispatch(U);
  }
  const m = new ct({
    key: t,
    view() {
      return {
        update: async (E, G) => {
          var Y, U, v, b, W, q, ne;
          const V = (Y = this.key) == null ? void 0 : Y.getState(G), se = (U = this.key) == null ? void 0 : U.getState(E.state), te = V.active && se.active && V.range.from !== se.range.from, be = !V.active && se.active, Oe = V.active && !se.active, ke = !be && !Oe && V.query !== se.query, Se = be || te && ke, dt = ke || te, st = Oe || te && ke;
          if (!Se && !dt && !st)
            return;
          const We = st && !Se ? V : se, pt = E.dom.querySelector(`[data-decoration-id="${We.decorationId}"]`);
          Q = {
            editor: e,
            range: We.range,
            query: We.query,
            text: We.text,
            items: [],
            command: (xt) => B({
              editor: e,
              range: We.range,
              props: xt
            }),
            decorationNode: pt,
            clientRect: I(E, pt)
          }, Se && ((v = p == null ? void 0 : p.onBeforeStart) == null || v.call(p, Q)), dt && ((b = p == null ? void 0 : p.onBeforeUpdate) == null || b.call(p, Q)), (dt || Se) && (Q.items = await g({
            editor: e,
            query: We.query
          })), st && ((W = p == null ? void 0 : p.onExit) == null || W.call(p, Q)), dt && ((q = p == null ? void 0 : p.onUpdate) == null || q.call(p, Q)), Se && ((ne = p == null ? void 0 : p.onStart) == null || ne.call(p, Q));
        },
        destroy: () => {
          var E;
          Q && ((E = p == null ? void 0 : p.onExit) == null || E.call(p, Q));
        }
      };
    },
    state: {
      // Initialize the plugin's internal state.
      init() {
        return {
          active: !1,
          range: {
            from: 0,
            to: 0
          },
          query: null,
          text: null,
          composing: !1
        };
      },
      // Apply changes to the plugin state from a view transaction.
      apply(E, G, Y, U) {
        const { isEditable: v } = e, { composing: b } = e.view, { selection: W } = E, { empty: q, from: ne } = W, V = { ...G }, se = E.getMeta(t);
        if (se && se.exit)
          return V.active = !1, V.decorationId = null, V.range = { from: 0, to: 0 }, V.query = null, V.text = null, V;
        if (V.composing = b, v && (q || e.view.composing)) {
          (ne < G.range.from || ne > G.range.to) && !b && !G.composing && (V.active = !1);
          const te = d({
            char: A,
            allowSpaces: n,
            allowToIncludeChar: s,
            allowedPrefixes: r,
            startOfLine: i,
            $position: W.$from
          }), be = `id_${Math.floor(Math.random() * 4294967295)}`;
          te && u({
            editor: e,
            state: U,
            range: te.range,
            isActive: G.active
          }) && (!w || w({
            editor: e,
            range: te.range,
            query: te.query,
            text: te.text,
            transaction: E
          })) ? (V.active = !0, V.decorationId = G.decorationId ? G.decorationId : be, V.range = te.range, V.query = te.query, V.text = te.text) : V.active = !1;
        } else
          V.active = !1;
        return V.active || (V.decorationId = null, V.range = { from: 0, to: 0 }, V.query = null, V.text = null), V;
      }
    },
    props: {
      // Call the keydown hook if suggestion is active.
      handleKeyDown(E, G) {
        var Y, U, v, b;
        const { active: W, range: q } = m.getState(E.state);
        if (!W)
          return !1;
        if (G.key === "Escape" || G.key === "Esc") {
          const V = m.getState(E.state), se = (Y = Q == null ? void 0 : Q.decorationNode) != null ? Y : null, te = se ?? (V != null && V.decorationId ? E.dom.querySelector(`[data-decoration-id="${V.decorationId}"]`) : null);
          if (((U = p == null ? void 0 : p.onKeyDown) == null ? void 0 : U.call(p, { view: E, event: G, range: V.range })) || !1)
            return !0;
          const Oe = {
            editor: e,
            range: V.range,
            query: V.query,
            text: V.text,
            items: [],
            command: (ke) => B({ editor: e, range: V.range, props: ke }),
            decorationNode: te,
            // If we have a cached decoration node, use it for the clientRect
            // to avoid another DOM lookup. If not, leave clientRect null and
            // let consumer decide if they want to query.
            clientRect: te ? () => te.getBoundingClientRect() || null : null
          };
          return (v = p == null ? void 0 : p.onExit) == null || v.call(p, Oe), N(E, t), !0;
        }
        return ((b = p == null ? void 0 : p.onKeyDown) == null ? void 0 : b.call(p, { view: E, event: G, range: q })) || !1;
      },
      // Setup decorator on the currently active suggestion.
      decorations(E) {
        const { active: G, range: Y, decorationId: U, query: v } = m.getState(E);
        if (!G)
          return null;
        const b = !(v != null && v.length), W = [a];
        return b && W.push(l), It.create(E.doc, [
          Wt.inline(Y.from, Y.to, {
            nodeName: o,
            class: W.join(" "),
            "data-decoration-id": U,
            "data-decoration-content": c
          })
        ]);
      }
    }
  });
  return m;
}
var Oz = Wz;
function iV({
  editor: t,
  overrideSuggestionOptions: e,
  extensionName: A,
  char: n = "@"
}) {
  const s = new Bt();
  return {
    editor: t,
    char: n,
    pluginKey: s,
    command: ({ editor: r, range: i, props: o }) => {
      var a, c, l;
      const B = r.view.state.selection.$to.nodeAfter;
      ((a = B == null ? void 0 : B.text) == null ? void 0 : a.startsWith(" ")) && (i.to += 1), r.chain().focus().insertContentAt(i, [
        {
          type: A,
          attrs: { ...o, mentionSuggestionChar: n }
        },
        {
          type: "text",
          text: " "
        }
      ]).run(), (l = (c = r.view.dom.ownerDocument.defaultView) == null ? void 0 : c.getSelection()) == null || l.collapseToEnd();
    },
    allow: ({ state: r, range: i }) => {
      const o = r.doc.resolve(i.from), a = r.schema.nodes[A];
      return !!o.parent.type.contentMatch.matchType(a);
    },
    ...e
  };
}
function Pz(t) {
  return (t.options.suggestions.length ? t.options.suggestions : [t.options.suggestion]).map(
    (e) => iV({
      // @ts-ignore `editor` can be `undefined` when converting the document to HTML with the HTML utility
      editor: t.editor,
      overrideSuggestionOptions: e,
      extensionName: t.name,
      char: e.char
    })
  );
}
function S1(t, e) {
  const A = Pz(t), n = A.find((s) => s.char === e);
  return n || (A.length ? A[0] : null);
}
var oV = Zt.create({
  name: "mention",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      renderText({ node: t, suggestion: e }) {
        var A, n;
        return `${(A = e == null ? void 0 : e.char) != null ? A : "@"}${(n = t.attrs.label) != null ? n : t.attrs.id}`;
      },
      deleteTriggerWithBackspace: !1,
      renderHTML({ options: t, node: e, suggestion: A }) {
        var n, s;
        return [
          "span",
          Ct(this.HTMLAttributes, t.HTMLAttributes),
          `${(n = A == null ? void 0 : A.char) != null ? n : "@"}${(s = e.attrs.label) != null ? s : e.attrs.id}`
        ];
      },
      suggestions: [],
      suggestion: {}
    };
  },
  group: "inline",
  inline: !0,
  selectable: !1,
  atom: !0,
  addAttributes() {
    return {
      id: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-id"),
        renderHTML: (t) => t.id ? {
          "data-id": t.id
        } : {}
      },
      label: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-label"),
        renderHTML: (t) => t.label ? {
          "data-label": t.label
        } : {}
      },
      // When there are multiple types of mentions, this attribute helps distinguish them
      mentionSuggestionChar: {
        default: "@",
        parseHTML: (t) => t.getAttribute("data-mention-suggestion-char"),
        renderHTML: (t) => ({
          "data-mention-suggestion-char": t.mentionSuggestionChar
        })
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: `span[data-type="${this.name}"]`
      }
    ];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    const A = S1(this, t.attrs.mentionSuggestionChar);
    if (this.options.renderLabel !== void 0)
      return console.warn("renderLabel is deprecated use renderText and renderHTML instead"), [
        "span",
        Ct({ "data-type": this.name }, this.options.HTMLAttributes, e),
        this.options.renderLabel({
          options: this.options,
          node: t,
          suggestion: A
        })
      ];
    const n = { ...this.options };
    n.HTMLAttributes = Ct(
      { "data-type": this.name },
      this.options.HTMLAttributes,
      e
    );
    const s = this.options.renderHTML({
      options: n,
      node: t,
      suggestion: A
    });
    return typeof s == "string" ? ["span", Ct({ "data-type": this.name }, this.options.HTMLAttributes, e), s] : s;
  },
  ...LG({
    nodeName: "mention",
    name: "@",
    selfClosing: !0,
    allowedAttributes: ["id", "label", { name: "mentionSuggestionChar", skipIfDefault: "@" }],
    parseAttributes: (t) => {
      const e = {}, A = /(\w+)=(?:"([^"]*)"|'([^']*)')/g;
      let n = A.exec(t);
      for (; n !== null; ) {
        const [, s, r, i] = n, o = r ?? i;
        e[s === "char" ? "mentionSuggestionChar" : s] = o, n = A.exec(t);
      }
      return e;
    },
    serializeAttributes: (t) => Object.entries(t).filter(([, e]) => e != null).map(([e, A]) => `${e === "mentionSuggestionChar" ? "char" : e}="${A}"`).join(" ")
  }),
  renderText({ node: t }) {
    const e = {
      options: this.options,
      node: t,
      suggestion: S1(this, t.attrs.mentionSuggestionChar)
    };
    return this.options.renderLabel !== void 0 ? (console.warn("renderLabel is deprecated use renderText and renderHTML instead"), this.options.renderLabel(e)) : this.options.renderText(e);
  },
  addKeyboardShortcuts() {
    return {
      Backspace: () => this.editor.commands.command(({ tr: t, state: e }) => {
        let A = !1;
        const { selection: n } = e, { empty: s, anchor: r } = n;
        if (!s)
          return !1;
        let i = new xi(), o = 0;
        return e.doc.nodesBetween(r - 1, r, (a, c) => {
          if (a.type.name === this.name)
            return A = !0, i = a, o = c, !1;
        }), A && t.insertText(
          this.options.deleteTriggerWithBackspace ? "" : i.attrs.mentionSuggestionChar,
          o,
          o + i.nodeSize
        ), A;
      })
    };
  },
  addProseMirrorPlugins() {
    return Pz(this).map(Wz);
  }
}), aV = /^((?:https?:)?\/\/)?((?:www|m|music)\.)?((?:youtube\.com|youtu\.be|youtube-nocookie\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/, cV = /^((?:https?:)?\/\/)?((?:www|m|music)\.)?((?:youtube\.com|youtu\.be|youtube-nocookie\.com))(\/(?:[\w-]+\?v=|embed\/|v\/)?)([\w-]+)(\S+)?$/g, Kz = (t) => t.match(aV), T1 = (t, e) => e ? "https://www.youtube-nocookie.com/embed/videoseries?list=" : t ? "https://www.youtube-nocookie.com/embed/" : "https://www.youtube.com/embed/", lV = (t) => {
  const {
    url: e,
    allowFullscreen: A,
    autoplay: n,
    ccLanguage: s,
    ccLoadPolicy: r,
    controls: i,
    disableKBcontrols: o,
    enableIFrameApi: a,
    endTime: c,
    interfaceLanguage: l,
    ivLoadPolicy: B,
    loop: g,
    modestBranding: h,
    nocookie: u,
    origin: d,
    playlist: w,
    progressBarColor: Q,
    startAt: p,
    rel: M
  } = t;
  if (!Kz(e))
    return null;
  if (e.includes("/embed/"))
    return e;
  if (e.includes("youtu.be")) {
    const G = e.split("/").pop();
    return G ? `${T1(u)}${G}` : null;
  }
  const N = /(?:(v|list)=|shorts\/)([-\w]+)/gm.exec(e);
  if (!N || !N[2])
    return null;
  let m = `${T1(u, N[1] === "list")}${N[2]}`;
  const E = [];
  return A === !1 && E.push("fs=0"), n && E.push("autoplay=1"), s && E.push(`cc_lang_pref=${s}`), r && E.push("cc_load_policy=1"), i || E.push("controls=0"), o && E.push("disablekb=1"), a && E.push("enablejsapi=1"), c && E.push(`end=${c}`), l && E.push(`hl=${l}`), B && E.push(`iv_load_policy=${B}`), g && E.push("loop=1"), h && E.push("modestbranding=1"), d && E.push(`origin=${d}`), w && E.push(`playlist=${w}`), p && E.push(`start=${p}`), Q && E.push(`color=${Q}`), M !== void 0 && E.push(`rel=${M}`), E.length && (m += `${N[1] === "list" ? "&" : "?"}${E.join("&")}`), m;
}, BV = Zt.create({
  name: "youtube",
  addOptions() {
    return {
      addPasteHandler: !0,
      allowFullscreen: !0,
      autoplay: !1,
      ccLanguage: void 0,
      ccLoadPolicy: void 0,
      controls: !0,
      disableKBcontrols: !1,
      enableIFrameApi: !1,
      endTime: 0,
      height: 480,
      interfaceLanguage: void 0,
      ivLoadPolicy: 0,
      loop: !1,
      modestBranding: !1,
      HTMLAttributes: {},
      inline: !1,
      nocookie: !1,
      origin: "",
      playlist: "",
      progressBarColor: void 0,
      width: 640,
      rel: 1
    };
  },
  inline() {
    return this.options.inline;
  },
  group() {
    return this.options.inline ? "inline" : "block";
  },
  draggable: !0,
  addAttributes() {
    return {
      src: {
        default: null
      },
      start: {
        default: 0
      },
      width: {
        default: this.options.width
      },
      height: {
        default: this.options.height
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: "div[data-youtube-video] iframe"
      }
    ];
  },
  addCommands() {
    return {
      setYoutubeVideo: (t) => ({ commands: e }) => Kz(t.src) ? e.insertContent({
        type: this.name,
        attrs: t
      }) : !1
    };
  },
  addPasteRules() {
    return this.options.addPasteHandler ? [
      _J({
        find: cV,
        type: this.type,
        getAttributes: (t) => ({ src: t.input })
      })
    ] : [];
  },
  renderHTML({ HTMLAttributes: t }) {
    const e = lV({
      url: t.src,
      allowFullscreen: this.options.allowFullscreen,
      autoplay: this.options.autoplay,
      ccLanguage: this.options.ccLanguage,
      ccLoadPolicy: this.options.ccLoadPolicy,
      controls: this.options.controls,
      disableKBcontrols: this.options.disableKBcontrols,
      enableIFrameApi: this.options.enableIFrameApi,
      endTime: this.options.endTime,
      interfaceLanguage: this.options.interfaceLanguage,
      ivLoadPolicy: this.options.ivLoadPolicy,
      loop: this.options.loop,
      modestBranding: this.options.modestBranding,
      nocookie: this.options.nocookie,
      origin: this.options.origin,
      playlist: this.options.playlist,
      progressBarColor: this.options.progressBarColor,
      startAt: t.start || 0,
      rel: this.options.rel
    });
    return t.src = e, [
      "div",
      { "data-youtube-video": "" },
      [
        "iframe",
        Ct(
          this.options.HTMLAttributes,
          {
            width: this.options.width,
            height: this.options.height,
            allowfullscreen: this.options.allowFullscreen,
            autoplay: this.options.autoplay,
            ccLanguage: this.options.ccLanguage,
            ccLoadPolicy: this.options.ccLoadPolicy,
            disableKBcontrols: this.options.disableKBcontrols,
            enableIFrameApi: this.options.enableIFrameApi,
            endTime: this.options.endTime,
            interfaceLanguage: this.options.interfaceLanguage,
            ivLoadPolicy: this.options.ivLoadPolicy,
            loop: this.options.loop,
            modestBranding: this.options.modestBranding,
            origin: this.options.origin,
            playlist: this.options.playlist,
            progressBarColor: this.options.progressBarColor,
            rel: this.options.rel
          },
          t
        )
      ]
    ];
  },
  ...RG({
    nodeName: "youtube",
    allowedAttributes: ["src", "width", "height", "start"]
  })
}), gV = 20, Vz = (t, e = 0) => {
  const A = [];
  return !t.children.length || e > gV || Array.from(t.children).forEach((n) => {
    n.tagName === "SPAN" ? A.push(n) : n.children.length && A.push(...Vz(n, e + 1));
  }), A;
}, hV = (t) => {
  if (!t.children.length)
    return;
  const e = Vz(t);
  e && e.forEach((A) => {
    var n, s;
    const r = A.getAttribute("style"), i = (s = (n = A.parentElement) == null ? void 0 : n.closest("span")) == null ? void 0 : s.getAttribute("style");
    A.setAttribute("style", `${i};${r}`);
  });
}, Xz = qr.create({
  name: "textStyle",
  priority: 101,
  addOptions() {
    return {
      HTMLAttributes: {},
      mergeNestedSpanStyles: !0
    };
  },
  parseHTML() {
    return [
      {
        tag: "span",
        consuming: !1,
        getAttrs: (t) => t.hasAttribute("style") ? (this.options.mergeNestedSpanStyles && hV(t), {}) : !1
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", Ct(this.options.HTMLAttributes, t), 0];
  },
  addCommands() {
    return {
      toggleTextStyle: (t) => ({ commands: e }) => e.toggleMark(this.name, t),
      removeEmptyTextStyle: () => ({ tr: t }) => {
        const { selection: e } = t;
        return t.doc.nodesBetween(e.from, e.to, (A, n) => {
          if (A.isTextblock)
            return !0;
          A.marks.filter((s) => s.type === this.type).some((s) => Object.values(s.attrs).some((r) => !!r)) || t.removeMark(n, n + A.nodeSize, this.type);
        }), !0;
      }
    };
  }
}), Zz = tt.create({
  name: "backgroundColor",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          backgroundColor: {
            default: null,
            parseHTML: (t) => {
              var e;
              const A = t.getAttribute("style");
              if (A) {
                const n = A.split(";").map((s) => s.trim()).filter(Boolean);
                for (let s = n.length - 1; s >= 0; s -= 1) {
                  const r = n[s].split(":");
                  if (r.length >= 2) {
                    const i = r[0].trim().toLowerCase(), o = r.slice(1).join(":").trim();
                    if (i === "background-color")
                      return o.replace(/['"]+/g, "");
                  }
                }
              }
              return (e = t.style.backgroundColor) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.backgroundColor ? {
              style: `background-color: ${t.backgroundColor}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setBackgroundColor: (t) => ({ chain: e }) => e().setMark("textStyle", { backgroundColor: t }).run(),
      unsetBackgroundColor: () => ({ chain: t }) => t().setMark("textStyle", { backgroundColor: null }).removeEmptyTextStyle().run()
    };
  }
}), qz = tt.create({
  name: "color",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          color: {
            default: null,
            parseHTML: (t) => {
              var e;
              const A = t.getAttribute("style");
              if (A) {
                const n = A.split(";").map((s) => s.trim()).filter(Boolean);
                for (let s = n.length - 1; s >= 0; s -= 1) {
                  const r = n[s].split(":");
                  if (r.length >= 2) {
                    const i = r[0].trim().toLowerCase(), o = r.slice(1).join(":").trim();
                    if (i === "color")
                      return o.replace(/['"]+/g, "");
                  }
                }
              }
              return (e = t.style.color) == null ? void 0 : e.replace(/['"]+/g, "");
            },
            renderHTML: (t) => t.color ? {
              style: `color: ${t.color}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setColor: (t) => ({ chain: e }) => e().setMark("textStyle", { color: t }).run(),
      unsetColor: () => ({ chain: t }) => t().setMark("textStyle", { color: null }).removeEmptyTextStyle().run()
    };
  }
}), uV = tt.create({
  name: "fontFamily",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontFamily: {
            default: null,
            parseHTML: (t) => t.style.fontFamily,
            renderHTML: (t) => t.fontFamily ? {
              style: `font-family: ${t.fontFamily}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontFamily: (t) => ({ chain: e }) => e().setMark("textStyle", { fontFamily: t }).run(),
      unsetFontFamily: () => ({ chain: t }) => t().setMark("textStyle", { fontFamily: null }).removeEmptyTextStyle().run()
    };
  }
}), dV = tt.create({
  name: "fontSize",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          fontSize: {
            default: null,
            parseHTML: (t) => t.style.fontSize,
            renderHTML: (t) => t.fontSize ? {
              style: `font-size: ${t.fontSize}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setFontSize: (t) => ({ chain: e }) => e().setMark("textStyle", { fontSize: t }).run(),
      unsetFontSize: () => ({ chain: t }) => t().setMark("textStyle", { fontSize: null }).removeEmptyTextStyle().run()
    };
  }
}), wV = tt.create({
  name: "lineHeight",
  addOptions() {
    return {
      types: ["textStyle"]
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.types,
        attributes: {
          lineHeight: {
            default: null,
            parseHTML: (t) => t.style.lineHeight,
            renderHTML: (t) => t.lineHeight ? {
              style: `line-height: ${t.lineHeight}`
            } : {}
          }
        }
      }
    ];
  },
  addCommands() {
    return {
      setLineHeight: (t) => ({ chain: e }) => e().setMark("textStyle", { lineHeight: t }).run(),
      unsetLineHeight: () => ({ chain: t }) => t().setMark("textStyle", { lineHeight: null }).removeEmptyTextStyle().run()
    };
  }
});
tt.create({
  name: "textStyleKit",
  addExtensions() {
    const t = [];
    return this.options.backgroundColor !== !1 && t.push(Zz.configure(this.options.backgroundColor)), this.options.color !== !1 && t.push(qz.configure(this.options.color)), this.options.fontFamily !== !1 && t.push(uV.configure(this.options.fontFamily)), this.options.fontSize !== !1 && t.push(dV.configure(this.options.fontSize)), this.options.lineHeight !== !1 && t.push(wV.configure(this.options.lineHeight)), this.options.textStyle !== !1 && t.push(Xz.configure(this.options.textStyle)), t;
  }
});
var fV = xK;
const Hs = () => /* @__PURE__ */ new Map(), BE = (t) => {
  const e = Hs();
  return t.forEach((A, n) => {
    e.set(n, A);
  }), e;
}, $r = (t, e, A) => {
  let n = t.get(e);
  return n === void 0 && t.set(e, n = A()), n;
}, QV = (t, e) => {
  const A = [];
  for (const [n, s] of t)
    A.push(e(s, n));
  return A;
}, IV = (t, e) => {
  for (const [A, n] of t)
    if (e(n, A))
      return !0;
  return !1;
}, tc = () => /* @__PURE__ */ new Set(), JQ = (t) => t[t.length - 1], CV = (t, e) => {
  for (let A = 0; A < e.length; A++)
    t.push(e[A]);
}, qo = Array.from, zp = (t, e) => {
  for (let A = 0; A < t.length; A++)
    if (!e(t[A], A, t))
      return !1;
  return !0;
}, Up = (t, e) => {
  for (let A = 0; A < t.length; A++)
    if (e(t[A], A, t))
      return !0;
  return !1;
}, EV = (t, e) => {
  const A = new Array(t);
  for (let n = 0; n < t; n++)
    A[n] = e(n, A);
  return A;
}, Fl = Array.isArray;
class _z {
  constructor() {
    this._observers = Hs();
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  on(e, A) {
    return $r(
      this._observers,
      /** @type {string} */
      e,
      tc
    ).add(A), A;
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  once(e, A) {
    const n = (...s) => {
      this.off(
        e,
        /** @type {any} */
        n
      ), A(...s);
    };
    this.on(
      e,
      /** @type {any} */
      n
    );
  }
  /**
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name
   * @param {EVENTS[NAME]} f
   */
  off(e, A) {
    const n = this._observers.get(e);
    n !== void 0 && (n.delete(A), n.size === 0 && this._observers.delete(e));
  }
  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @template {keyof EVENTS & string} NAME
   * @param {NAME} name The event name.
   * @param {Parameters<EVENTS[NAME]>} args The arguments that are applied to the event listener.
   */
  emit(e, A) {
    return qo((this._observers.get(e) || Hs()).values()).forEach((n) => n(...A));
  }
  destroy() {
    this._observers = Hs();
  }
}
const ar = Math.floor, nu = Math.abs, Ui = (t, e) => t < e ? t : e, cr = (t, e) => t > e ? t : e, $z = (t) => t !== 0 ? t < 0 : 1 / t < 0, J1 = 1, W1 = 2, WQ = 4, OQ = 8, bg = 32, bi = 64, Dn = 128, MV = 1 << 29, Sw = 31, gE = 63, Wa = 127, pV = 2147483647, Md = Number.MAX_SAFE_INTEGER, O1 = Number.MIN_SAFE_INTEGER, mV = Number.isInteger || ((t) => typeof t == "number" && isFinite(t) && ar(t) === t), eU = String.fromCharCode, YV = (t) => t.toLowerCase(), yV = /^\s*/g, FV = (t) => t.replace(yV, ""), NV = /([A-Z])/g, P1 = (t, e) => FV(t.replace(NV, (A) => `${e}${YV(A)}`)), DV = (t) => {
  const e = unescape(encodeURIComponent(t)), A = e.length, n = new Uint8Array(A);
  for (let s = 0; s < A; s++)
    n[s] = /** @type {number} */
    e.codePointAt(s);
  return n;
}, vg = (
  /** @type {TextEncoder} */
  typeof TextEncoder < "u" ? new TextEncoder() : null
), xV = (t) => vg.encode(t), GV = vg ? xV : DV;
let _B = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
_B && _B.decode(new Uint8Array()).length === 1 && (_B = null);
const zV = (t, e) => EV(e, () => t).join("");
let wh = class {
  constructor() {
    this.cpos = 0, this.cbuf = new Uint8Array(100), this.bufs = [];
  }
};
const fh = () => new wh(), UV = (t) => {
  const e = fh();
  return t(e), qs(e);
}, bV = (t) => {
  let e = t.cpos;
  for (let A = 0; A < t.bufs.length; A++)
    e += t.bufs[A].length;
  return e;
}, qs = (t) => {
  const e = new Uint8Array(bV(t));
  let A = 0;
  for (let n = 0; n < t.bufs.length; n++) {
    const s = t.bufs[n];
    e.set(s, A), A += s.length;
  }
  return e.set(new Uint8Array(t.cbuf.buffer, 0, t.cpos), A), e;
}, vV = (t, e) => {
  const A = t.cbuf.length;
  A - t.cpos < e && (t.bufs.push(new Uint8Array(t.cbuf.buffer, 0, t.cpos)), t.cbuf = new Uint8Array(cr(A, e) * 2), t.cpos = 0);
}, xA = (t, e) => {
  const A = t.cbuf.length;
  t.cpos === A && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(A * 2), t.cpos = 0), t.cbuf[t.cpos++] = e;
}, hE = xA, Qt = (t, e) => {
  for (; e > Wa; )
    xA(t, Dn | Wa & e), e = ar(e / 128);
  xA(t, Wa & e);
}, bp = (t, e) => {
  const A = $z(e);
  for (A && (e = -e), xA(t, (e > gE ? Dn : 0) | (A ? bi : 0) | gE & e), e = ar(e / 64); e > 0; )
    xA(t, (e > Wa ? Dn : 0) | Wa & e), e = ar(e / 128);
}, uE = new Uint8Array(3e4), jV = uE.length / 3, HV = (t, e) => {
  if (e.length < jV) {
    const A = vg.encodeInto(e, uE).written || 0;
    Qt(t, A);
    for (let n = 0; n < A; n++)
      xA(t, uE[n]);
  } else
    ss(t, GV(e));
}, kV = (t, e) => {
  const A = unescape(encodeURIComponent(e)), n = A.length;
  Qt(t, n);
  for (let s = 0; s < n; s++)
    xA(
      t,
      /** @type {number} */
      A.codePointAt(s)
    );
}, al = vg && /** @type {any} */
vg.encodeInto ? HV : kV, Tw = (t, e) => {
  const A = t.cbuf.length, n = t.cpos, s = Ui(A - n, e.length), r = e.length - s;
  t.cbuf.set(e.subarray(0, s), n), t.cpos += s, r > 0 && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(cr(A * 2, r)), t.cbuf.set(e.subarray(s)), t.cpos = r);
}, ss = (t, e) => {
  Qt(t, e.byteLength), Tw(t, e);
}, vp = (t, e) => {
  vV(t, e);
  const A = new DataView(t.cbuf.buffer, t.cpos, e);
  return t.cpos += e, A;
}, RV = (t, e) => vp(t, 4).setFloat32(0, e, !1), LV = (t, e) => vp(t, 8).setFloat64(0, e, !1), SV = (t, e) => (
  /** @type {any} */
  vp(t, 8).setBigInt64(0, e, !1)
), K1 = new DataView(new ArrayBuffer(4)), TV = (t) => (K1.setFloat32(0, t), K1.getFloat32(0) === t), Nl = (t, e) => {
  switch (typeof e) {
    case "string":
      xA(t, 119), al(t, e);
      break;
    case "number":
      mV(e) && nu(e) <= pV ? (xA(t, 125), bp(t, e)) : TV(e) ? (xA(t, 124), RV(t, e)) : (xA(t, 123), LV(t, e));
      break;
    case "bigint":
      xA(t, 122), SV(t, e);
      break;
    case "object":
      if (e === null)
        xA(t, 126);
      else if (Fl(e)) {
        xA(t, 117), Qt(t, e.length);
        for (let A = 0; A < e.length; A++)
          Nl(t, e[A]);
      } else if (e instanceof Uint8Array)
        xA(t, 116), ss(t, e);
      else {
        xA(t, 118);
        const A = Object.keys(e);
        Qt(t, A.length);
        for (let n = 0; n < A.length; n++) {
          const s = A[n];
          al(t, s), Nl(t, e[s]);
        }
      }
      break;
    case "boolean":
      xA(t, e ? 120 : 121);
      break;
    default:
      xA(t, 127);
  }
};
class V1 extends wh {
  /**
   * @param {function(Encoder, T):void} writer
   */
  constructor(e) {
    super(), this.w = e, this.s = null, this.count = 0;
  }
  /**
   * @param {T} v
   */
  write(e) {
    this.s === e ? this.count++ : (this.count > 0 && Qt(this, this.count - 1), this.count = 1, this.w(this, e), this.s = e);
  }
}
const X1 = (t) => {
  t.count > 0 && (bp(t.encoder, t.count === 1 ? t.s : -t.s), t.count > 1 && Qt(t.encoder, t.count - 2));
};
class su {
  constructor() {
    this.encoder = new wh(), this.s = 0, this.count = 0;
  }
  /**
   * @param {number} v
   */
  write(e) {
    this.s === e ? this.count++ : (X1(this), this.count = 1, this.s = e);
  }
  /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */
  toUint8Array() {
    return X1(this), qs(this.encoder);
  }
}
const Z1 = (t) => {
  if (t.count > 0) {
    const e = t.diff * 2 + (t.count === 1 ? 0 : 1);
    bp(t.encoder, e), t.count > 1 && Qt(t.encoder, t.count - 2);
  }
};
class PQ {
  constructor() {
    this.encoder = new wh(), this.s = 0, this.count = 0, this.diff = 0;
  }
  /**
   * @param {number} v
   */
  write(e) {
    this.diff === e - this.s ? (this.s = e, this.count++) : (Z1(this), this.count = 1, this.diff = e - this.s, this.s = e);
  }
  /**
   * Flush the encoded state and transform this to a Uint8Array.
   *
   * Note that this should only be called once.
   */
  toUint8Array() {
    return Z1(this), qs(this.encoder);
  }
}
class JV {
  constructor() {
    this.sarr = [], this.s = "", this.lensE = new su();
  }
  /**
   * @param {string} string
   */
  write(e) {
    this.s += e, this.s.length > 19 && (this.sarr.push(this.s), this.s = ""), this.lensE.write(e.length);
  }
  toUint8Array() {
    const e = new wh();
    return this.sarr.push(this.s), this.s = "", al(e, this.sarr.join("")), Tw(e, this.lensE.toUint8Array()), qs(e);
  }
}
const Wr = (t) => new Error(t), ks = () => {
  throw Wr("Method unimplemented");
}, ln = () => {
  throw Wr("Unexpected case");
}, tU = Wr("Unexpected end of array"), AU = Wr("Integer out of Range");
let Jw = class {
  /**
   * @param {Uint8Array<Buf>} uint8Array Binary data to decode
   */
  constructor(e) {
    this.arr = e, this.pos = 0;
  }
};
const _o = (t) => new Jw(t), WV = (t) => t.pos !== t.arr.length, OV = (t, e) => {
  const A = new Uint8Array(t.arr.buffer, t.pos + t.arr.byteOffset, e);
  return t.pos += e, A;
}, rs = (t) => OV(t, ut(t)), Dl = (t) => t.arr[t.pos++], ut = (t) => {
  let e = 0, A = 1;
  const n = t.arr.length;
  for (; t.pos < n; ) {
    const s = t.arr[t.pos++];
    if (e = e + (s & Wa) * A, A *= 128, s < Dn)
      return e;
    if (e > Md)
      throw AU;
  }
  throw tU;
}, jp = (t) => {
  let e = t.arr[t.pos++], A = e & gE, n = 64;
  const s = (e & bi) > 0 ? -1 : 1;
  if ((e & Dn) === 0)
    return s * A;
  const r = t.arr.length;
  for (; t.pos < r; ) {
    if (e = t.arr[t.pos++], A = A + (e & Wa) * n, n *= 128, e < Dn)
      return s * A;
    if (A > Md)
      throw AU;
  }
  throw tU;
}, PV = (t) => {
  let e = ut(t);
  if (e === 0)
    return "";
  {
    let A = String.fromCodePoint(Dl(t));
    if (--e < 100)
      for (; e--; )
        A += String.fromCodePoint(Dl(t));
    else
      for (; e > 0; ) {
        const n = e < 1e4 ? e : 1e4, s = t.arr.subarray(t.pos, t.pos + n);
        t.pos += n, A += String.fromCodePoint.apply(
          null,
          /** @type {any} */
          s
        ), e -= n;
      }
    return decodeURIComponent(escape(A));
  }
}, KV = (t) => (
  /** @type any */
  _B.decode(rs(t))
), cl = _B ? KV : PV, Hp = (t, e) => {
  const A = new DataView(t.arr.buffer, t.arr.byteOffset + t.pos, e);
  return t.pos += e, A;
}, VV = (t) => Hp(t, 4).getFloat32(0, !1), XV = (t) => Hp(t, 8).getFloat64(0, !1), ZV = (t) => (
  /** @type {any} */
  Hp(t, 8).getBigInt64(0, !1)
), qV = [
  (t) => {
  },
  // CASE 127: undefined
  (t) => null,
  // CASE 126: null
  jp,
  // CASE 125: integer
  VV,
  // CASE 124: float32
  XV,
  // CASE 123: float64
  ZV,
  // CASE 122: bigint
  (t) => !1,
  // CASE 121: boolean (false)
  (t) => !0,
  // CASE 120: boolean (true)
  cl,
  // CASE 119: string
  (t) => {
    const e = ut(t), A = {};
    for (let n = 0; n < e; n++) {
      const s = cl(t);
      A[s] = jg(t);
    }
    return A;
  },
  (t) => {
    const e = ut(t), A = [];
    for (let n = 0; n < e; n++)
      A.push(jg(t));
    return A;
  },
  rs
  // CASE 116: Uint8Array
], jg = (t) => qV[127 - Dl(t)](t);
class q1 extends Jw {
  /**
   * @param {Uint8Array} uint8Array
   * @param {function(Decoder):T} reader
   */
  constructor(e, A) {
    super(e), this.reader = A, this.s = null, this.count = 0;
  }
  read() {
    return this.count === 0 && (this.s = this.reader(this), WV(this) ? this.count = ut(this) + 1 : this.count = -1), this.count--, /** @type {T} */
    this.s;
  }
}
class ru extends Jw {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    super(e), this.s = 0, this.count = 0;
  }
  read() {
    if (this.count === 0) {
      this.s = jp(this);
      const e = $z(this.s);
      this.count = 1, e && (this.s = -this.s, this.count = ut(this) + 2);
    }
    return this.count--, /** @type {number} */
    this.s;
  }
}
class KQ extends Jw {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    super(e), this.s = 0, this.count = 0, this.diff = 0;
  }
  /**
   * @return {number}
   */
  read() {
    if (this.count === 0) {
      const e = jp(this), A = e & 1;
      this.diff = ar(e / 2), this.count = 1, A && (this.count = ut(this) + 2);
    }
    return this.s += this.diff, this.count--, this.s;
  }
}
class _V {
  /**
   * @param {Uint8Array} uint8Array
   */
  constructor(e) {
    this.decoder = new ru(e), this.str = cl(this.decoder), this.spos = 0;
  }
  /**
   * @return {string}
   */
  read() {
    const e = this.spos + this.decoder.read(), A = this.str.slice(this.spos, e);
    return this.spos = e, A;
  }
}
const $V = crypto.getRandomValues.bind(crypto), eX = Math.random, nU = () => $V(new Uint32Array(1))[0], tX = (t) => t[ar(eX() * t.length)], AX = "10000000-1000-4000-8000" + -1e11, dE = () => AX.replace(
  /[018]/g,
  /** @param {number} c */
  (t) => (t ^ nU() & 15 >> t / 4).toString(16)
), nX = Date.now, _1 = (t) => (
  /** @type {Promise<T>} */
  new Promise(t)
);
Promise.all.bind(Promise);
const $1 = (t) => t === void 0 ? null : t;
class sX {
  constructor() {
    this.map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {string} key
   * @param {any} newValue
   */
  setItem(e, A) {
    this.map.set(e, A);
  }
  /**
   * @param {string} key
   */
  getItem(e) {
    return this.map.get(e);
  }
}
let sU = new sX(), rX = !0;
try {
  typeof localStorage < "u" && localStorage && (sU = localStorage, rX = !1);
} catch {
}
const iX = sU, Hg = Symbol("Equality"), rU = (t, e) => {
  var A;
  return t === e || !!((A = t == null ? void 0 : t[Hg]) != null && A.call(t, e)) || !1;
}, oX = (t) => typeof t == "object", aX = Object.assign, iU = Object.keys, cX = (t, e) => {
  for (const A in t)
    e(t[A], A);
}, pd = (t) => iU(t).length, lX = (t) => {
  for (const e in t)
    return !1;
  return !0;
}, Jl = (t, e) => {
  for (const A in t)
    if (!e(t[A], A))
      return !1;
  return !0;
}, kp = (t, e) => Object.prototype.hasOwnProperty.call(t, e), BX = (t, e) => t === e || pd(t) === pd(e) && Jl(t, (A, n) => (A !== void 0 || kp(e, n)) && rU(e[n], A)), gX = Object.freeze, oU = (t) => {
  for (const e in t) {
    const A = t[e];
    (typeof A == "object" || typeof A == "function") && oU(t[e]);
  }
  return gX(t);
}, Rp = (t, e, A = 0) => {
  try {
    for (; A < t.length; A++)
      t[A](...e);
  } finally {
    A < t.length && Rp(t, e, A + 1);
  }
}, hX = (t) => t, iu = (t, e) => {
  if (t === e)
    return !0;
  if (t == null || e == null || t.constructor !== e.constructor && (t.constructor || Object) !== (e.constructor || Object))
    return !1;
  if (t[Hg] != null)
    return t[Hg](e);
  switch (t.constructor) {
    case ArrayBuffer:
      t = new Uint8Array(t), e = new Uint8Array(e);
    // eslint-disable-next-line no-fallthrough
    case Uint8Array: {
      if (t.byteLength !== e.byteLength)
        return !1;
      for (let A = 0; A < t.length; A++)
        if (t[A] !== e[A])
          return !1;
      break;
    }
    case Set: {
      if (t.size !== e.size)
        return !1;
      for (const A of t)
        if (!e.has(A))
          return !1;
      break;
    }
    case Map: {
      if (t.size !== e.size)
        return !1;
      for (const A of t.keys())
        if (!e.has(A) || !iu(t.get(A), e.get(A)))
          return !1;
      break;
    }
    case void 0:
    case Object:
      if (pd(t) !== pd(e))
        return !1;
      for (const A in t)
        if (!kp(t, A) || !iu(t[A], e[A]))
          return !1;
      break;
    case Array:
      if (t.length !== e.length)
        return !1;
      for (let A = 0; A < t.length; A++)
        if (!iu(t[A], e[A]))
          return !1;
      break;
    default:
      return !1;
  }
  return !0;
}, uX = (t, e) => e.includes(t);
var aU = {};
const xl = typeof process < "u" && process.release && /node|io\.js/.test(process.release.name) && Object.prototype.toString.call(typeof process < "u" ? process : 0) === "[object process]", cU = typeof window < "u" && typeof document < "u" && !xl;
let Ir;
const dX = () => {
  if (Ir === void 0)
    if (xl) {
      Ir = Hs();
      const t = process.argv;
      let e = null;
      for (let A = 0; A < t.length; A++) {
        const n = t[A];
        n[0] === "-" ? (e !== null && Ir.set(e, ""), e = n) : e !== null && (Ir.set(e, n), e = null);
      }
      e !== null && Ir.set(e, "");
    } else typeof location == "object" ? (Ir = Hs(), (location.search || "?").slice(1).split("&").forEach((t) => {
      if (t.length !== 0) {
        const [e, A] = t.split("=");
        Ir.set(`--${P1(e, "-")}`, A), Ir.set(`-${P1(e, "-")}`, A);
      }
    })) : Ir = Hs();
  return Ir;
}, wE = (t) => dX().has(t), md = (t) => $1(xl ? aU[t.toUpperCase().replaceAll("-", "_")] : iX.getItem(t)), lU = (t) => wE("--" + t) || md(t) !== null, wX = lU("production"), fX = xl && uX(aU.FORCE_COLOR, ["true", "1", "2"]), QX = fX || !wE("--no-colors") && // @todo deprecate --no-colors
!lU("no-color") && (!xl || process.stdout.isTTY) && (!xl || wE("--color") || md("COLORTERM") !== null || (md("TERM") || "").includes("color")), IX = (t) => new Uint8Array(t), CX = (t) => {
  let e = "";
  for (let A = 0; A < t.byteLength; A++)
    e += eU(t[A]);
  return btoa(e);
}, EX = (t) => Buffer.from(t.buffer, t.byteOffset, t.byteLength).toString("base64"), MX = cU ? CX : EX, pX = (t) => {
  const e = IX(t.byteLength);
  return e.set(t), e;
}, mX = (t) => UV((e) => Nl(e, t));
class YX {
  /**
   * @param {L} left
   * @param {R} right
   */
  constructor(e, A) {
    this.left = e, this.right = A;
  }
}
const gi = (t, e) => new YX(t, e), eF = (t) => t.next() >= 0.5, VQ = (t, e, A) => ar(t.next() * (A + 1 - e) + e), BU = (t, e, A) => ar(t.next() * (A + 1 - e) + e), Lp = (t, e, A) => BU(t, e, A), yX = (t) => eU(Lp(t, 97, 122)), FX = (t, e = 0, A = 20) => {
  const n = Lp(t, e, A);
  let s = "";
  for (let r = 0; r < n; r++)
    s += yX(t);
  return s;
}, XQ = (t, e) => e[Lp(t, 0, e.length - 1)], NX = Symbol("0schema");
class DX {
  constructor() {
    this._rerrs = [];
  }
  /**
   * @param {string?} path
   * @param {string} expected
   * @param {string} has
   * @param {string?} message
   */
  extend(e, A, n, s = null) {
    this._rerrs.push({ path: e, expected: A, has: n, message: s });
  }
  toString() {
    const e = [];
    for (let A = this._rerrs.length - 1; A > 0; A--) {
      const n = this._rerrs[A];
      e.push(zV(" ", (this._rerrs.length - A) * 2) + `${n.path != null ? `[${n.path}] ` : ""}${n.has} doesn't match ${n.expected}. ${n.message}`);
    }
    return e.join(`
`);
  }
}
const fE = (t, e) => t === e ? !0 : t == null || e == null || t.constructor !== e.constructor ? !1 : t[Hg] ? rU(t, e) : Fl(t) ? zp(
  t,
  (A) => Up(e, (n) => fE(A, n))
) : oX(t) ? Jl(
  t,
  (A, n) => fE(A, e[n])
) : !1;
class gn {
  /**
   * @param {Schema<any>} other
   */
  extends(e) {
    let [A, n] = [
      /** @type {any} */
      this.shape,
      /** @type {any} */
      e.shape
    ];
    return (
      /** @type {typeof Schema<any>} */
      this.constructor._dilutes && ([n, A] = [A, n]), fE(A, n)
    );
  }
  /**
   * Overwrite this when necessary. By default, we only check the `shape` property which every shape
   * should have.
   * @param {Schema<any>} other
   */
  equals(e) {
    return this.constructor === e.constructor && iu(this.shape, e.shape);
  }
  [NX]() {
    return !0;
  }
  /**
   * @param {object} other
   */
  [Hg](e) {
    return this.equals(
      /** @type {any} */
      e
    );
  }
  /**
   * Use `schema.validate(obj)` with a typed parameter that is already of typed to be an instance of
   * Schema. Validate will check the structure of the parameter and return true iff the instance
   * really is an instance of Schema.
   *
   * @param {T} o
   * @return {boolean}
   */
  validate(e) {
    return this.check(e);
  }
  /* c8 ignore start */
  /**
   * Similar to validate, but this method accepts untyped parameters.
   *
   * @param {any} _o
   * @param {ValidationError} [_err]
   * @return {_o is T}
   */
  check(e, A) {
    ks();
  }
  /* c8 ignore stop */
  /**
   * @type {Schema<T?>}
   */
  get nullable() {
    return Wl(this, Vw);
  }
  /**
   * @type {$Optional<Schema<T>>}
   */
  get optional() {
    return new uU(
      /** @type {Schema<T>} */
      this
    );
  }
  /**
   * Cast a variable to a specific type. Returns the casted value, or throws an exception otherwise.
   * Use this if you know that the type is of a specific type and you just want to convince the type
   * system.
   *
   * **Do not rely on these error messages!**
   * Performs an assertion check only if not in a production environment.
   *
   * @template OO
   * @param {OO} o
   * @return {Extract<OO, T> extends never ? T : (OO extends Array<never> ? T : Extract<OO,T>)}
   */
  cast(e) {
    return tF(e, this), /** @type {any} */
    e;
  }
  /**
   * EXPECTO PATRONUM!! 🪄
   * This function protects against type errors. Though it may not work in the real world.
   *
   * "After all this time?"
   * "Always." - Snape, talking about type safety
   *
   * Ensures that a variable is a a specific type. Returns the value, or throws an exception if the assertion check failed.
   * Use this if you know that the type is of a specific type and you just want to convince the type
   * system.
   *
   * Can be useful when defining lambdas: `s.lambda(s.$number, s.$void).expect((n) => n + 1)`
   *
   * **Do not rely on these error messages!**
   * Performs an assertion check if not in a production environment.
   *
   * @param {T} o
   * @return {o extends T ? T : never}
   */
  expect(e) {
    return tF(e, this), e;
  }
}
// this.shape must not be defined on Schema. Otherwise typecheck on metatypes (e.g. $$object) won't work as expected anymore
/**
 * If true, the more things are added to the shape the more objects this schema will accept (e.g.
 * union). By default, the more objects are added, the the fewer objects this schema will accept.
 * @protected
 */
Wh(gn, "_dilutes", !1);
class Sp extends gn {
  /**
   * @param {C} c
   * @param {((o:Instance<C>)=>boolean)|null} check
   */
  constructor(e, A) {
    super(), this.shape = e, this._c = A;
  }
  /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is C extends ((...args:any[]) => infer T) ? T : (C extends (new (...args:any[]) => any) ? InstanceType<C> : never)} o
   */
  check(e, A = void 0) {
    const n = (e == null ? void 0 : e.constructor) === this.shape && (this._c == null || this._c(e));
    return !n && (A == null || A.extend(null, this.shape.name, e == null ? void 0 : e.constructor.name, (e == null ? void 0 : e.constructor) !== this.shape ? "Constructor match failed" : "Check failed")), n;
  }
}
const mA = (t, e = null) => new Sp(t, e);
mA(Sp);
class Tp extends gn {
  /**
   * @param {(o:any) => boolean} check
   */
  constructor(e) {
    super(), this.shape = e;
  }
  /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is any}
   */
  check(e, A) {
    const n = this.shape(e);
    return !n && (A == null || A.extend(null, "custom prop", e == null ? void 0 : e.constructor.name, "failed to check custom prop")), n;
  }
}
const kA = (t) => new Tp(t);
mA(Tp);
class Ww extends gn {
  /**
   * @param {Array<T>} literals
   */
  constructor(e) {
    super(), this.shape = e;
  }
  /**
   *
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is T}
   */
  check(e, A) {
    const n = this.shape.some((s) => s === e);
    return !n && (A == null || A.extend(null, this.shape.join(" | "), e.toString())), n;
  }
}
const Ow = (...t) => new Ww(t), gU = mA(Ww), xX = (
  /** @type {any} */
  RegExp.escape || /** @type {(str:string) => string} */
  ((t) => t.replace(/[().|&,$^[\]]/g, (e) => "\\" + e))
), hU = (t) => {
  if (Gl.check(t))
    return [xX(t)];
  if (gU.check(t))
    return (
      /** @type {Array<string|number>} */
      t.shape.map((e) => e + "")
    );
  if (pU.check(t))
    return ["[+-]?\\d+.?\\d*"];
  if (mU.check(t))
    return [".*"];
  if (yd.check(t))
    return t.shape.map(hU).flat(1);
  ln();
};
class GX extends gn {
  /**
   * @param {T} shape
   */
  constructor(e) {
    super(), this.shape = e, this._r = new RegExp("^" + e.map(hU).map((A) => `(${A.join("|")})`).join("") + "$");
  }
  /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is CastStringTemplateArgsToTemplate<T>}
   */
  check(e, A) {
    const n = this._r.exec(e) != null;
    return !n && (A == null || A.extend(null, this._r.toString(), e.toString(), "String doesn't match string template.")), n;
  }
}
mA(GX);
const zX = Symbol("optional");
class uU extends gn {
  /**
   * @param {S} shape
   */
  constructor(e) {
    super(), this.shape = e;
  }
  /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is (Unwrap<S>|undefined)}
   */
  check(e, A) {
    const n = e === void 0 || this.shape.check(e);
    return !n && (A == null || A.extend(null, "undefined (optional)", "()")), n;
  }
  get [zX]() {
    return !0;
  }
}
const UX = mA(uU);
class bX extends gn {
  /**
   * @param {any} _o
   * @param {ValidationError} [err]
   * @return {_o is never}
   */
  check(e, A) {
    return A == null || A.extend(null, "never", typeof e), !1;
  }
}
mA(bX);
const sw = class sw extends gn {
  /**
   * @param {S} shape
   * @param {boolean} partial
   */
  constructor(e, A = !1) {
    super(), this.shape = e, this._isPartial = A;
  }
  /**
   * @type {Schema<Partial<$ObjectToType<S>>>}
   */
  get partial() {
    return new sw(this.shape, !0);
  }
  /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is $ObjectToType<S>}
   */
  check(e, A) {
    return e == null ? (A == null || A.extend(null, "object", "null"), !1) : Jl(this.shape, (n, s) => {
      const r = this._isPartial && !kp(e, s) || n.check(e[s], A);
      return !r && (A == null || A.extend(s.toString(), n.toString(), typeof e[s], "Object property does not match")), r;
    });
  }
};
Wh(sw, "_dilutes", !0);
let Yd = sw;
const vX = (t) => (
  /** @type {any} */
  new Yd(t)
), jX = mA(Yd), HX = kA((t) => t != null && (t.constructor === Object || t.constructor == null));
class dU extends gn {
  /**
   * @param {Keys} keys
   * @param {Values} values
   */
  constructor(e, A) {
    super(), this.shape = {
      keys: e,
      values: A
    };
  }
  /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is { [key in Unwrap<Keys>]: Unwrap<Values> }}
   */
  check(e, A) {
    return e != null && Jl(e, (n, s) => {
      const r = this.shape.keys.check(s, A);
      return !r && (A == null || A.extend(s + "", "Record", typeof e, r ? "Key doesn't match schema" : "Value doesn't match value")), r && this.shape.values.check(n, A);
    });
  }
}
const wU = (t, e) => new dU(t, e), kX = mA(dU);
class fU extends gn {
  /**
   * @param {S} shape
   */
  constructor(e) {
    super(), this.shape = e;
  }
  /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is { [K in keyof S]: S[K] extends Schema<infer Type> ? Type : never }}
   */
  check(e, A) {
    return e != null && Jl(this.shape, (n, s) => {
      const r = (
        /** @type {Schema<any>} */
        n.check(e[s], A)
      );
      return !r && (A == null || A.extend(s.toString(), "Tuple", typeof n)), r;
    });
  }
}
const RX = (...t) => new fU(t);
mA(fU);
class QU extends gn {
  /**
   * @param {Array<S>} v
   */
  constructor(e) {
    super(), this.shape = e.length === 1 ? e[0] : new Pw(e);
  }
  /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is Array<S extends Schema<infer T> ? T : never>} o
   */
  check(e, A) {
    const n = Fl(e) && zp(e, (s) => this.shape.check(s));
    return !n && (A == null || A.extend(null, "Array", "")), n;
  }
}
const IU = (...t) => new QU(t), LX = mA(QU), SX = kA((t) => Fl(t));
class CU extends gn {
  /**
   * @param {new (...args:any) => T} constructor
   * @param {((o:T) => boolean)|null} check
   */
  constructor(e, A) {
    super(), this.shape = e, this._c = A;
  }
  /**
   * @param {any} o
   * @param {ValidationError} err
   * @return {o is T}
   */
  check(e, A) {
    const n = e instanceof this.shape && (this._c == null || this._c(e));
    return !n && (A == null || A.extend(null, this.shape.name, e == null ? void 0 : e.constructor.name)), n;
  }
}
const TX = (t, e = null) => new CU(t, e);
mA(CU);
const JX = TX(gn);
class WX extends gn {
  /**
   * @param {Args} args
   */
  constructor(e) {
    super(), this.len = e.length - 1, this.args = RX(...e.slice(-1)), this.res = e[this.len];
  }
  /**
   * @param {any} f
   * @param {ValidationError} err
   * @return {f is _LArgsToLambdaDef<Args>}
   */
  check(e, A) {
    const n = e.constructor === Function && e.length <= this.len;
    return !n && (A == null || A.extend(null, "function", typeof e)), n;
  }
}
const OX = mA(WX), PX = kA((t) => typeof t == "function");
class KX extends gn {
  /**
   * @param {T} v
   */
  constructor(e) {
    super(), this.shape = e;
  }
  /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is Intersect<UnwrapArray<T>>}
   */
  check(e, A) {
    const n = zp(this.shape, (s) => s.check(e, A));
    return !n && (A == null || A.extend(null, "Intersectinon", typeof e)), n;
  }
}
mA(KX, (t) => t.shape.length > 0);
class Pw extends gn {
  /**
   * @param {Array<Schema<S>>} v
   */
  constructor(e) {
    super(), this.shape = e;
  }
  /**
   * @param {any} o
   * @param {ValidationError} [err]
   * @return {o is S}
   */
  check(e, A) {
    const n = Up(this.shape, (s) => s.check(e, A));
    return A == null || A.extend(null, "Union", typeof e), n;
  }
}
Wh(Pw, "_dilutes", !0);
const Wl = (...t) => t.findIndex((e) => yd.check(e)) >= 0 ? Wl(...t.map((e) => kg(e)).map((e) => yd.check(e) ? e.shape : [e]).flat(1)) : t.length === 1 ? t[0] : new Pw(t), yd = (
  /** @type {Schema<$Union<any>>} */
  mA(Pw)
), EU = () => !0, Fd = kA(EU), VX = (
  /** @type {Schema<Schema<any>>} */
  mA(Tp, (t) => t.shape === EU)
), Jp = kA((t) => typeof t == "bigint"), XX = (
  /** @type {Schema<Schema<BigInt>>} */
  kA((t) => t === Jp)
), MU = kA((t) => typeof t == "symbol");
kA((t) => t === MU);
const ll = kA((t) => typeof t == "number"), pU = (
  /** @type {Schema<Schema<number>>} */
  kA((t) => t === ll)
), Gl = kA((t) => typeof t == "string"), mU = (
  /** @type {Schema<Schema<string>>} */
  kA((t) => t === Gl)
), Kw = kA((t) => typeof t == "boolean"), ZX = (
  /** @type {Schema<Schema<Boolean>>} */
  kA((t) => t === Kw)
), YU = Ow(void 0);
mA(Ww, (t) => t.shape.length === 1 && t.shape[0] === void 0);
Ow(void 0);
const Vw = Ow(null), qX = (
  /** @type {Schema<Schema<null>>} */
  mA(Ww, (t) => t.shape.length === 1 && t.shape[0] === null)
);
mA(Uint8Array);
mA(Sp, (t) => t.shape === Uint8Array);
const _X = Wl(ll, Gl, Vw, YU, Jp, Kw, MU);
(() => {
  const t = (
    /** @type {$Array<$any>} */
    IU(Fd)
  ), e = (
    /** @type {$Record<$string,$any>} */
    wU(Gl, Fd)
  ), A = Wl(ll, Gl, Vw, Kw, t, e);
  return t.shape = A, e.shape.values = A, A;
})();
const kg = (t) => {
  if (JX.check(t))
    return (
      /** @type {any} */
      t
    );
  if (HX.check(t)) {
    const e = {};
    for (const A in t)
      e[A] = kg(t[A]);
    return (
      /** @type {any} */
      vX(e)
    );
  } else {
    if (SX.check(t))
      return (
        /** @type {any} */
        Wl(...t.map(kg))
      );
    if (_X.check(t))
      return (
        /** @type {any} */
        Ow(t)
      );
    if (PX.check(t))
      return (
        /** @type {any} */
        mA(
          /** @type {any} */
          t
        )
      );
  }
  ln();
}, tF = wX ? () => {
} : (t, e) => {
  const A = new DX();
  if (!e.check(t, A))
    throw Wr(`Expected value to be of type ${e.constructor.name}.
${A.toString()}`);
};
class $X {
  /**
   * @param {Schema<State>} [$state]
   */
  constructor(e) {
    this.patterns = [], this.$state = e;
  }
  /**
   * @template P
   * @template R
   * @param {P} pattern
   * @param {(o:NoInfer<Unwrap<ReadSchema<P>>>,s:State)=>R} handler
   * @return {PatternMatcher<State,Patterns|Pattern<Unwrap<ReadSchema<P>>,R>>}
   */
  if(e, A) {
    return this.patterns.push({ if: kg(e), h: A }), this;
  }
  /**
   * @template R
   * @param {(o:any,s:State)=>R} h
   */
  else(e) {
    return this.if(Fd, e);
  }
  /**
   * @return {State extends undefined
   *   ? <In extends Unwrap<Patterns['if']>>(o:In,state?:undefined)=>PatternMatchResult<Patterns,In>
   *   : <In extends Unwrap<Patterns['if']>>(o:In,state:State)=>PatternMatchResult<Patterns,In>}
   */
  done() {
    return (
      /** @type {any} */
      (e, A) => {
        for (let n = 0; n < this.patterns.length; n++) {
          const s = this.patterns[n];
          if (s.if.check(e))
            return s.h(e, A);
        }
        throw Wr("Unhandled pattern");
      }
    );
  }
}
const eZ = (t) => new $X(
  /** @type {any} */
  t
), yU = (
  /** @type {any} */
  eZ(
    /** @type {Schema<prng.PRNG>} */
    Fd
  ).if(pU, (t, e) => VQ(e, O1, Md)).if(mU, (t, e) => FX(e)).if(ZX, (t, e) => eF(e)).if(XX, (t, e) => BigInt(VQ(e, O1, Md))).if(yd, (t, e) => xc(e, XQ(e, t.shape))).if(jX, (t, e) => {
    const A = {};
    for (const n in t.shape) {
      let s = t.shape[n];
      if (UX.check(s)) {
        if (eF(e))
          continue;
        s = s.shape;
      }
      A[n] = yU(s, e);
    }
    return A;
  }).if(LX, (t, e) => {
    const A = [], n = BU(e, 0, 42);
    for (let s = 0; s < n; s++)
      A.push(xc(e, t.shape));
    return A;
  }).if(gU, (t, e) => XQ(e, t.shape)).if(qX, (t, e) => null).if(OX, (t, e) => {
    const A = xc(e, t.res);
    return () => A;
  }).if(VX, (t, e) => xc(e, XQ(e, [
    ll,
    Gl,
    Vw,
    YU,
    Jp,
    Kw,
    IU(ll),
    wU(Wl("a", "b", "c"), ll)
  ]))).if(kX, (t, e) => {
    const A = {}, n = VQ(e, 0, 3);
    for (let s = 0; s < n; s++) {
      const r = xc(e, t.shape.keys), i = xc(e, t.shape.values);
      A[r] = i;
    }
    return A;
  }).done()
), xc = (t, e) => (
  /** @type {any} */
  yU(kg(e), t)
), Qh = (
  /** @type {Document} */
  typeof document < "u" ? document : {}
);
kA((t) => t.nodeType === rZ);
typeof DOMParser < "u" && new DOMParser();
kA((t) => t.nodeType === AZ);
kA((t) => t.nodeType === nZ);
const tZ = (t) => QV(t, (e, A) => `${A}:${e};`).join(""), AZ = Qh.ELEMENT_NODE, nZ = Qh.TEXT_NODE, sZ = Qh.DOCUMENT_NODE, rZ = Qh.DOCUMENT_FRAGMENT_NODE;
kA((t) => t.nodeType === sZ);
const iZ = (t) => class {
  /**
   * @param {number} timeoutId
   */
  constructor(A) {
    this._ = A;
  }
  destroy() {
    t(this._);
  }
}, oZ = iZ(clearTimeout), Wp = (t, e) => new oZ(setTimeout(e, t)), Ao = Symbol, FU = Ao(), NU = Ao(), aZ = Ao(), cZ = Ao(), lZ = Ao(), DU = Ao(), BZ = Ao(), Op = Ao(), gZ = Ao(), hZ = (t) => {
  var s;
  t.length === 1 && ((s = t[0]) == null ? void 0 : s.constructor) === Function && (t = /** @type {Array<string|Symbol|Object|number>} */
  /** @type {[function]} */
  t[0]());
  const e = [], A = [];
  let n = 0;
  for (; n < t.length; n++) {
    const r = t[n];
    if (r === void 0)
      break;
    if (r.constructor === String || r.constructor === Number)
      e.push(r);
    else if (r.constructor === Object)
      break;
  }
  for (n > 0 && A.push(e.join("")); n < t.length; n++) {
    const r = t[n];
    r instanceof Symbol || A.push(r);
  }
  return A;
}, uZ = {
  [FU]: gi("font-weight", "bold"),
  [NU]: gi("font-weight", "normal"),
  [aZ]: gi("color", "blue"),
  [lZ]: gi("color", "green"),
  [cZ]: gi("color", "grey"),
  [DU]: gi("color", "red"),
  [BZ]: gi("color", "purple"),
  [Op]: gi("color", "orange"),
  // not well supported in chrome when debugging node with inspector - TODO: deprecate
  [gZ]: gi("color", "black")
}, dZ = (t) => {
  var i;
  t.length === 1 && ((i = t[0]) == null ? void 0 : i.constructor) === Function && (t = /** @type {Array<string|Symbol|Object|number>} */
  /** @type {[function]} */
  t[0]());
  const e = [], A = [], n = Hs();
  let s = [], r = 0;
  for (; r < t.length; r++) {
    const o = t[r], a = uZ[o];
    if (a !== void 0)
      n.set(a.left, a.right);
    else {
      if (o === void 0)
        break;
      if (o.constructor === String || o.constructor === Number) {
        const c = tZ(n);
        r > 0 || c.length > 0 ? (e.push("%c" + o), A.push(c)) : e.push(o);
      } else
        break;
    }
  }
  for (r > 0 && (s = A, s.unshift(e.join(""))); r < t.length; r++) {
    const o = t[r];
    o instanceof Symbol || s.push(o);
  }
  return s;
}, xU = QX ? dZ : hZ, wZ = (...t) => {
  console.log(...xU(t)), zU.forEach((e) => e.print(t));
}, GU = (...t) => {
  console.warn(...xU(t)), t.unshift(Op), zU.forEach((e) => e.print(t));
}, zU = tc(), UU = (t) => ({
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator]() {
    return this;
  },
  // @ts-ignore
  next: t
}), fZ = (t, e) => UU(() => {
  let A;
  do
    A = t.next();
  while (!A.done && !e(A.value));
  return A;
}), ZQ = (t, e) => UU(() => {
  const { done: A, value: n } = t.next();
  return { done: A, value: A ? void 0 : e(n) };
});
class Pp {
  /**
   * @param {number} clock
   * @param {number} len
   */
  constructor(e, A) {
    this.clock = e, this.len = A;
  }
}
class Ol {
  constructor() {
    this.clients = /* @__PURE__ */ new Map();
  }
}
const $o = (t, e, A) => e.clients.forEach((n, s) => {
  const r = (
    /** @type {Array<GC|Item>} */
    t.doc.store.clients.get(s)
  );
  if (r != null) {
    const i = r[r.length - 1], o = i.id.clock + i.length;
    for (let a = 0, c = n[a]; a < n.length && c.clock < o; c = n[++a])
      WU(t, r, c.clock, c.len, A);
  }
}), QZ = (t, e) => {
  let A = 0, n = t.length - 1;
  for (; A <= n; ) {
    const s = ar((A + n) / 2), r = t[s], i = r.clock;
    if (i <= e) {
      if (e < i + r.len)
        return s;
      A = s + 1;
    } else
      n = s - 1;
  }
  return null;
}, lc = (t, e) => {
  const A = t.clients.get(e.client);
  return A !== void 0 && QZ(A, e.clock) !== null;
}, Kp = (t) => {
  t.clients.forEach((e) => {
    e.sort((s, r) => s.clock - r.clock);
    let A, n;
    for (A = 1, n = 1; A < e.length; A++) {
      const s = e[n - 1], r = e[A];
      s.clock + s.len >= r.clock ? s.len = cr(s.len, r.clock + r.len - s.clock) : (n < A && (e[n] = r), n++);
    }
    e.length = n;
  });
}, Rg = (t) => {
  const e = new Ol();
  for (let A = 0; A < t.length; A++)
    t[A].clients.forEach((n, s) => {
      if (!e.clients.has(s)) {
        const r = n.slice();
        for (let i = A + 1; i < t.length; i++)
          CV(r, t[i].clients.get(s) || []);
        e.clients.set(s, r);
      }
    });
  return Kp(e), e;
}, Lg = (t, e, A, n) => {
  $r(t.clients, e, () => (
    /** @type {Array<DeleteItem>} */
    []
  )).push(new Pp(A, n));
}, Vp = () => new Ol(), bU = (t) => {
  const e = Vp();
  return t.clients.forEach((A, n) => {
    const s = [];
    for (let r = 0; r < A.length; r++) {
      const i = A[r];
      if (i.deleted) {
        const o = i.id.clock;
        let a = i.length;
        if (r + 1 < A.length)
          for (let c = A[r + 1]; r + 1 < A.length && c.deleted; c = A[++r + 1])
            a += c.length;
        s.push(new Pp(o, a));
      }
    }
    s.length > 0 && e.clients.set(n, s);
  }), e;
}, ea = (t, e) => {
  Qt(t.restEncoder, e.clients.size), qo(e.clients.entries()).sort((A, n) => n[0] - A[0]).forEach(([A, n]) => {
    t.resetDsCurVal(), Qt(t.restEncoder, A);
    const s = n.length;
    Qt(t.restEncoder, s);
    for (let r = 0; r < s; r++) {
      const i = n[r];
      t.writeDsClock(i.clock), t.writeDsLen(i.len);
    }
  });
}, Sg = (t) => {
  const e = new Ol(), A = ut(t.restDecoder);
  for (let n = 0; n < A; n++) {
    t.resetDsCurVal();
    const s = ut(t.restDecoder), r = ut(t.restDecoder);
    if (r > 0) {
      const i = $r(e.clients, s, () => (
        /** @type {Array<DeleteItem>} */
        []
      ));
      for (let o = 0; o < r; o++)
        i.push(new Pp(t.readDsClock(), t.readDsLen()));
    }
  }
  return e;
}, AF = (t, e, A) => {
  const n = new Ol(), s = ut(t.restDecoder);
  for (let r = 0; r < s; r++) {
    t.resetDsCurVal();
    const i = ut(t.restDecoder), o = ut(t.restDecoder), a = A.clients.get(i) || [], c = uA(A, i);
    for (let l = 0; l < o; l++) {
      const B = t.readDsClock(), g = B + t.readDsLen();
      if (B < c) {
        c < g && Lg(n, i, c, g - c);
        let h = lr(a, B), u = a[h];
        for (!u.deleted && u.id.clock < B && (a.splice(h + 1, 0, Hd(e, u, B - u.id.clock)), h++); h < a.length && (u = a[h++], u.id.clock < g); )
          u.deleted || (g < u.id.clock + u.length && a.splice(h, 0, Hd(e, u, g - u.id.clock)), u.delete(e));
      } else
        Lg(n, i, B, g - B);
    }
  }
  if (n.clients.size > 0) {
    const r = new Ac();
    return Qt(r.restEncoder, 0), ea(r, n), r.toUint8Array();
  }
  return null;
}, vU = nU;
class no extends _z {
  /**
   * @param {DocOpts} opts configuration
   */
  constructor({ guid: e = dE(), collectionid: A = null, gc: n = !0, gcFilter: s = () => !0, meta: r = null, autoLoad: i = !1, shouldLoad: o = !0 } = {}) {
    super(), this.gc = n, this.gcFilter = s, this.clientID = vU(), this.guid = e, this.collectionid = A, this.share = /* @__PURE__ */ new Map(), this.store = new TU(), this._transaction = null, this._transactionCleanups = [], this.subdocs = /* @__PURE__ */ new Set(), this._item = null, this.shouldLoad = o, this.autoLoad = i, this.meta = r, this.isLoaded = !1, this.isSynced = !1, this.isDestroyed = !1, this.whenLoaded = _1((c) => {
      this.on("load", () => {
        this.isLoaded = !0, c(this);
      });
    });
    const a = () => _1((c) => {
      const l = (B) => {
        (B === void 0 || B === !0) && (this.off("sync", l), c());
      };
      this.on("sync", l);
    });
    this.on("sync", (c) => {
      c === !1 && this.isSynced && (this.whenSynced = a()), this.isSynced = c === void 0 || c === !0, this.isSynced && !this.isLoaded && this.emit("load", [this]);
    }), this.whenSynced = a();
  }
  /**
   * Notify the parent document that you request to load data into this subdocument (if it is a subdocument).
   *
   * `load()` might be used in the future to request any provider to load the most current data.
   *
   * It is safe to call `load()` multiple times.
   */
  load() {
    const e = this._item;
    e !== null && !this.shouldLoad && Rt(
      /** @type {any} */
      e.parent.doc,
      (A) => {
        A.subdocsLoaded.add(this);
      },
      null,
      !0
    ), this.shouldLoad = !0;
  }
  getSubdocs() {
    return this.subdocs;
  }
  getSubdocGuids() {
    return new Set(qo(this.subdocs).map((e) => e.guid));
  }
  /**
   * Changes that happen inside of a transaction are bundled. This means that
   * the observer fires _after_ the transaction is finished and that all changes
   * that happened inside of the transaction are sent as one message to the
   * other peers.
   *
   * @template T
   * @param {function(Transaction):T} f The function that should be executed as a transaction
   * @param {any} [origin] Origin of who started the transaction. Will be stored on transaction.origin
   * @return T
   *
   * @public
   */
  transact(e, A = null) {
    return Rt(this, e, A);
  }
  /**
   * Define a shared data type.
   *
   * Multiple calls of `ydoc.get(name, TypeConstructor)` yield the same result
   * and do not overwrite each other. I.e.
   * `ydoc.get(name, Y.Array) === ydoc.get(name, Y.Array)`
   *
   * After this method is called, the type is also available on `ydoc.share.get(name)`.
   *
   * *Best Practices:*
   * Define all types right after the Y.Doc instance is created and store them in a separate object.
   * Also use the typed methods `getText(name)`, `getArray(name)`, ..
   *
   * @template {typeof AbstractType<any>} Type
   * @example
   *   const ydoc = new Y.Doc(..)
   *   const appState = {
   *     document: ydoc.getText('document')
   *     comments: ydoc.getArray('comments')
   *   }
   *
   * @param {string} name
   * @param {Type} TypeConstructor The constructor of the type definition. E.g. Y.Text, Y.Array, Y.Map, ...
   * @return {InstanceType<Type>} The created type. Constructed with TypeConstructor
   *
   * @public
   */
  get(e, A = (
    /** @type {any} */
    HA
  )) {
    const n = $r(this.share, e, () => {
      const r = new A();
      return r._integrate(this, null), r;
    }), s = n.constructor;
    if (A !== HA && s !== A)
      if (s === HA) {
        const r = new A();
        r._map = n._map, n._map.forEach(
          /** @param {Item?} n */
          (i) => {
            for (; i !== null; i = i.left)
              i.parent = r;
          }
        ), r._start = n._start;
        for (let i = r._start; i !== null; i = i.right)
          i.parent = r;
        return r._length = n._length, this.share.set(e, r), r._integrate(this, null), /** @type {InstanceType<Type>} */
        r;
      } else
        throw new Error(`Type with the name ${e} has already been defined with a different constructor`);
    return (
      /** @type {InstanceType<Type>} */
      n
    );
  }
  /**
   * @template T
   * @param {string} [name]
   * @return {YArray<T>}
   *
   * @public
   */
  getArray(e = "") {
    return (
      /** @type {YArray<T>} */
      this.get(e, Ds)
    );
  }
  /**
   * @param {string} [name]
   * @return {YText}
   *
   * @public
   */
  getText(e = "") {
    return this.get(e, ta);
  }
  /**
   * @template T
   * @param {string} [name]
   * @return {YMap<T>}
   *
   * @public
   */
  getMap(e = "") {
    return (
      /** @type {YMap<T>} */
      this.get(e, jr)
    );
  }
  /**
   * @param {string} [name]
   * @return {YXmlElement}
   *
   * @public
   */
  getXmlElement(e = "") {
    return (
      /** @type {YXmlElement<{[key:string]:string}>} */
      this.get(e, sn)
    );
  }
  /**
   * @param {string} [name]
   * @return {YXmlFragment}
   *
   * @public
   */
  getXmlFragment(e = "") {
    return this.get(e, nc);
  }
  /**
   * Converts the entire document into a js object, recursively traversing each yjs type
   * Doesn't log types that have not been defined (using ydoc.getType(..)).
   *
   * @deprecated Do not use this method and rather call toJSON directly on the shared types.
   *
   * @return {Object<string, any>}
   */
  toJSON() {
    const e = {};
    return this.share.forEach((A, n) => {
      e[n] = A.toJSON();
    }), e;
  }
  /**
   * Emit `destroy` event and unregister all event handlers.
   */
  destroy() {
    this.isDestroyed = !0, qo(this.subdocs).forEach((A) => A.destroy());
    const e = this._item;
    if (e !== null) {
      this._item = null;
      const A = (
        /** @type {ContentDoc} */
        e.content
      );
      A.doc = new no({ guid: this.guid, ...A.opts, shouldLoad: !1 }), A.doc._item = e, Rt(
        /** @type {any} */
        e.parent.doc,
        (n) => {
          const s = A.doc;
          e.deleted || n.subdocsAdded.add(s), n.subdocsRemoved.add(this);
        },
        null,
        !0
      );
    }
    this.emit("destroyed", [!0]), this.emit("destroy", [this]), super.destroy();
  }
}
class Nd {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    this.restDecoder = e;
  }
  resetDsCurVal() {
  }
  /**
   * @return {number}
   */
  readDsClock() {
    return ut(this.restDecoder);
  }
  /**
   * @return {number}
   */
  readDsLen() {
    return ut(this.restDecoder);
  }
}
class jU extends Nd {
  /**
   * @return {ID}
   */
  readLeftID() {
    return At(ut(this.restDecoder), ut(this.restDecoder));
  }
  /**
   * @return {ID}
   */
  readRightID() {
    return At(ut(this.restDecoder), ut(this.restDecoder));
  }
  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient() {
    return ut(this.restDecoder);
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo() {
    return Dl(this.restDecoder);
  }
  /**
   * @return {string}
   */
  readString() {
    return cl(this.restDecoder);
  }
  /**
   * @return {boolean} isKey
   */
  readParentInfo() {
    return ut(this.restDecoder) === 1;
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readTypeRef() {
    return ut(this.restDecoder);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number} len
   */
  readLen() {
    return ut(this.restDecoder);
  }
  /**
   * @return {any}
   */
  readAny() {
    return jg(this.restDecoder);
  }
  /**
   * @return {Uint8Array}
   */
  readBuf() {
    return pX(rs(this.restDecoder));
  }
  /**
   * Legacy implementation uses JSON parse. We use any-decoding in v2.
   *
   * @return {any}
   */
  readJSON() {
    return JSON.parse(cl(this.restDecoder));
  }
  /**
   * @return {string}
   */
  readKey() {
    return cl(this.restDecoder);
  }
}
class IZ {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    this.dsCurrVal = 0, this.restDecoder = e;
  }
  resetDsCurVal() {
    this.dsCurrVal = 0;
  }
  /**
   * @return {number}
   */
  readDsClock() {
    return this.dsCurrVal += ut(this.restDecoder), this.dsCurrVal;
  }
  /**
   * @return {number}
   */
  readDsLen() {
    const e = ut(this.restDecoder) + 1;
    return this.dsCurrVal += e, e;
  }
}
class zl extends IZ {
  /**
   * @param {decoding.Decoder} decoder
   */
  constructor(e) {
    super(e), this.keys = [], ut(e), this.keyClockDecoder = new KQ(rs(e)), this.clientDecoder = new ru(rs(e)), this.leftClockDecoder = new KQ(rs(e)), this.rightClockDecoder = new KQ(rs(e)), this.infoDecoder = new q1(rs(e), Dl), this.stringDecoder = new _V(rs(e)), this.parentInfoDecoder = new q1(rs(e), Dl), this.typeRefDecoder = new ru(rs(e)), this.lenDecoder = new ru(rs(e));
  }
  /**
   * @return {ID}
   */
  readLeftID() {
    return new Bl(this.clientDecoder.read(), this.leftClockDecoder.read());
  }
  /**
   * @return {ID}
   */
  readRightID() {
    return new Bl(this.clientDecoder.read(), this.rightClockDecoder.read());
  }
  /**
   * Read the next client id.
   * Use this in favor of readID whenever possible to reduce the number of objects created.
   */
  readClient() {
    return this.clientDecoder.read();
  }
  /**
   * @return {number} info An unsigned 8-bit integer
   */
  readInfo() {
    return (
      /** @type {number} */
      this.infoDecoder.read()
    );
  }
  /**
   * @return {string}
   */
  readString() {
    return this.stringDecoder.read();
  }
  /**
   * @return {boolean}
   */
  readParentInfo() {
    return this.parentInfoDecoder.read() === 1;
  }
  /**
   * @return {number} An unsigned 8-bit integer
   */
  readTypeRef() {
    return this.typeRefDecoder.read();
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @return {number}
   */
  readLen() {
    return this.lenDecoder.read();
  }
  /**
   * @return {any}
   */
  readAny() {
    return jg(this.restDecoder);
  }
  /**
   * @return {Uint8Array}
   */
  readBuf() {
    return rs(this.restDecoder);
  }
  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @return {any}
   */
  readJSON() {
    return jg(this.restDecoder);
  }
  /**
   * @return {string}
   */
  readKey() {
    const e = this.keyClockDecoder.read();
    if (e < this.keys.length)
      return this.keys[e];
    {
      const A = this.stringDecoder.read();
      return this.keys.push(A), A;
    }
  }
}
class Dd {
  constructor() {
    this.restEncoder = fh();
  }
  toUint8Array() {
    return qs(this.restEncoder);
  }
  resetDsCurVal() {
  }
  /**
   * @param {number} clock
   */
  writeDsClock(e) {
    Qt(this.restEncoder, e);
  }
  /**
   * @param {number} len
   */
  writeDsLen(e) {
    Qt(this.restEncoder, e);
  }
}
class Ih extends Dd {
  /**
   * @param {ID} id
   */
  writeLeftID(e) {
    Qt(this.restEncoder, e.client), Qt(this.restEncoder, e.clock);
  }
  /**
   * @param {ID} id
   */
  writeRightID(e) {
    Qt(this.restEncoder, e.client), Qt(this.restEncoder, e.clock);
  }
  /**
   * Use writeClient and writeClock instead of writeID if possible.
   * @param {number} client
   */
  writeClient(e) {
    Qt(this.restEncoder, e);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo(e) {
    hE(this.restEncoder, e);
  }
  /**
   * @param {string} s
   */
  writeString(e) {
    al(this.restEncoder, e);
  }
  /**
   * @param {boolean} isYKey
   */
  writeParentInfo(e) {
    Qt(this.restEncoder, e ? 1 : 0);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef(e) {
    Qt(this.restEncoder, e);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen(e) {
    Qt(this.restEncoder, e);
  }
  /**
   * @param {any} any
   */
  writeAny(e) {
    Nl(this.restEncoder, e);
  }
  /**
   * @param {Uint8Array} buf
   */
  writeBuf(e) {
    ss(this.restEncoder, e);
  }
  /**
   * @param {any} embed
   */
  writeJSON(e) {
    al(this.restEncoder, JSON.stringify(e));
  }
  /**
   * @param {string} key
   */
  writeKey(e) {
    al(this.restEncoder, e);
  }
}
class HU {
  constructor() {
    this.restEncoder = fh(), this.dsCurrVal = 0;
  }
  toUint8Array() {
    return qs(this.restEncoder);
  }
  resetDsCurVal() {
    this.dsCurrVal = 0;
  }
  /**
   * @param {number} clock
   */
  writeDsClock(e) {
    const A = e - this.dsCurrVal;
    this.dsCurrVal = e, Qt(this.restEncoder, A);
  }
  /**
   * @param {number} len
   */
  writeDsLen(e) {
    e === 0 && ln(), Qt(this.restEncoder, e - 1), this.dsCurrVal += e;
  }
}
class Ac extends HU {
  constructor() {
    super(), this.keyMap = /* @__PURE__ */ new Map(), this.keyClock = 0, this.keyClockEncoder = new PQ(), this.clientEncoder = new su(), this.leftClockEncoder = new PQ(), this.rightClockEncoder = new PQ(), this.infoEncoder = new V1(hE), this.stringEncoder = new JV(), this.parentInfoEncoder = new V1(hE), this.typeRefEncoder = new su(), this.lenEncoder = new su();
  }
  toUint8Array() {
    const e = fh();
    return Qt(e, 0), ss(e, this.keyClockEncoder.toUint8Array()), ss(e, this.clientEncoder.toUint8Array()), ss(e, this.leftClockEncoder.toUint8Array()), ss(e, this.rightClockEncoder.toUint8Array()), ss(e, qs(this.infoEncoder)), ss(e, this.stringEncoder.toUint8Array()), ss(e, qs(this.parentInfoEncoder)), ss(e, this.typeRefEncoder.toUint8Array()), ss(e, this.lenEncoder.toUint8Array()), Tw(e, qs(this.restEncoder)), qs(e);
  }
  /**
   * @param {ID} id
   */
  writeLeftID(e) {
    this.clientEncoder.write(e.client), this.leftClockEncoder.write(e.clock);
  }
  /**
   * @param {ID} id
   */
  writeRightID(e) {
    this.clientEncoder.write(e.client), this.rightClockEncoder.write(e.clock);
  }
  /**
   * @param {number} client
   */
  writeClient(e) {
    this.clientEncoder.write(e);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeInfo(e) {
    this.infoEncoder.write(e);
  }
  /**
   * @param {string} s
   */
  writeString(e) {
    this.stringEncoder.write(e);
  }
  /**
   * @param {boolean} isYKey
   */
  writeParentInfo(e) {
    this.parentInfoEncoder.write(e ? 1 : 0);
  }
  /**
   * @param {number} info An unsigned 8-bit integer
   */
  writeTypeRef(e) {
    this.typeRefEncoder.write(e);
  }
  /**
   * Write len of a struct - well suited for Opt RLE encoder.
   *
   * @param {number} len
   */
  writeLen(e) {
    this.lenEncoder.write(e);
  }
  /**
   * @param {any} any
   */
  writeAny(e) {
    Nl(this.restEncoder, e);
  }
  /**
   * @param {Uint8Array} buf
   */
  writeBuf(e) {
    ss(this.restEncoder, e);
  }
  /**
   * This is mainly here for legacy purposes.
   *
   * Initial we incoded objects using JSON. Now we use the much faster lib0/any-encoder. This method mainly exists for legacy purposes for the v1 encoder.
   *
   * @param {any} embed
   */
  writeJSON(e) {
    Nl(this.restEncoder, e);
  }
  /**
   * Property keys are often reused. For example, in y-prosemirror the key `bold` might
   * occur very often. For a 3d application, the key `position` might occur very often.
   *
   * We cache these keys in a Map and refer to them via a unique number.
   *
   * @param {string} key
   */
  writeKey(e) {
    const A = this.keyMap.get(e);
    A === void 0 ? (this.keyClockEncoder.write(this.keyClock++), this.stringEncoder.write(e)) : this.keyClockEncoder.write(A);
  }
}
const CZ = (t, e, A, n) => {
  n = cr(n, e[0].id.clock);
  const s = lr(e, n);
  Qt(t.restEncoder, e.length - s), t.writeClient(A), Qt(t.restEncoder, n);
  const r = e[s];
  r.write(t, n - r.id.clock);
  for (let i = s + 1; i < e.length; i++)
    e[i].write(t, 0);
}, Xp = (t, e, A) => {
  const n = /* @__PURE__ */ new Map();
  A.forEach((s, r) => {
    uA(e, r) > s && n.set(r, s);
  }), Ch(e).forEach((s, r) => {
    A.has(r) || n.set(r, 0);
  }), Qt(t.restEncoder, n.size), qo(n.entries()).sort((s, r) => r[0] - s[0]).forEach(([s, r]) => {
    CZ(
      t,
      /** @type {Array<GC|Item>} */
      e.clients.get(s),
      s,
      r
    );
  });
}, EZ = (t, e) => {
  const A = Hs(), n = ut(t.restDecoder);
  for (let s = 0; s < n; s++) {
    const r = ut(t.restDecoder), i = new Array(r), o = t.readClient();
    let a = ut(t.restDecoder);
    A.set(o, { i: 0, refs: i });
    for (let c = 0; c < r; c++) {
      const l = t.readInfo();
      switch (Sw & l) {
        case 0: {
          const B = t.readLen();
          i[c] = new ys(At(o, a), B), a += B;
          break;
        }
        case 10: {
          const B = ut(t.restDecoder);
          i[c] = new Fs(At(o, a), B), a += B;
          break;
        }
        default: {
          const B = (l & (bi | Dn)) === 0, g = new jt(
            At(o, a),
            null,
            // left
            (l & Dn) === Dn ? t.readLeftID() : null,
            // origin
            null,
            // right
            (l & bi) === bi ? t.readRightID() : null,
            // right origin
            B ? t.readParentInfo() ? e.get(t.readString()) : t.readLeftID() : null,
            // parent
            B && (l & bg) === bg ? t.readString() : null,
            // parentSub
            gb(t, l)
            // item content
          );
          i[c] = g, a += g.length;
        }
      }
    }
  }
  return A;
}, MZ = (t, e, A) => {
  const n = [];
  let s = qo(A.keys()).sort((h, u) => h - u);
  if (s.length === 0)
    return null;
  const r = () => {
    if (s.length === 0)
      return null;
    let h = (
      /** @type {{i:number,refs:Array<GC|Item>}} */
      A.get(s[s.length - 1])
    );
    for (; h.refs.length === h.i; )
      if (s.pop(), s.length > 0)
        h = /** @type {{i:number,refs:Array<GC|Item>}} */
        A.get(s[s.length - 1]);
      else
        return null;
    return h;
  };
  let i = r();
  if (i === null)
    return null;
  const o = new TU(), a = /* @__PURE__ */ new Map(), c = (h, u) => {
    const d = a.get(h);
    (d == null || d > u) && a.set(h, u);
  };
  let l = (
    /** @type {any} */
    i.refs[
      /** @type {any} */
      i.i++
    ]
  );
  const B = /* @__PURE__ */ new Map(), g = () => {
    for (const h of n) {
      const u = h.id.client, d = A.get(u);
      d ? (d.i--, o.clients.set(u, d.refs.slice(d.i)), A.delete(u), d.i = 0, d.refs = []) : o.clients.set(u, [h]), s = s.filter((w) => w !== u);
    }
    n.length = 0;
  };
  for (; ; ) {
    if (l.constructor !== Fs) {
      const u = $r(B, l.id.client, () => uA(e, l.id.client)) - l.id.clock;
      if (u < 0)
        n.push(l), c(l.id.client, l.id.clock - 1), g();
      else {
        const d = l.getMissing(t, e);
        if (d !== null) {
          n.push(l);
          const w = A.get(
            /** @type {number} */
            d
          ) || { refs: [], i: 0 };
          if (w.refs.length === w.i)
            c(
              /** @type {number} */
              d,
              uA(e, d)
            ), g();
          else {
            l = w.refs[w.i++];
            continue;
          }
        } else (u === 0 || u < l.length) && (l.integrate(t, u), B.set(l.id.client, l.id.clock + l.length));
      }
    }
    if (n.length > 0)
      l = /** @type {GC|Item} */
      n.pop();
    else if (i !== null && i.i < i.refs.length)
      l = /** @type {GC|Item} */
      i.refs[i.i++];
    else {
      if (i = r(), i === null)
        break;
      l = /** @type {GC|Item} */
      i.refs[i.i++];
    }
  }
  if (o.clients.size > 0) {
    const h = new Ac();
    return Xp(h, o, /* @__PURE__ */ new Map()), Qt(h.restEncoder, 0), { missing: a, update: h.toUint8Array() };
  }
  return null;
}, pZ = (t, e) => Xp(t, e.doc.store, e.beforeState), mZ = (t, e, A, n = new zl(t)) => Rt(e, (s) => {
  s.local = !1;
  let r = !1;
  const i = s.doc, o = i.store, a = EZ(n, i), c = MZ(s, o, a), l = o.pendingStructs;
  if (l) {
    for (const [g, h] of l.missing)
      if (h < uA(o, g)) {
        r = !0;
        break;
      }
    if (c) {
      for (const [g, h] of c.missing) {
        const u = l.missing.get(g);
        (u == null || u > h) && l.missing.set(g, h);
      }
      l.update = zd([l.update, c.update]);
    }
  } else
    o.pendingStructs = c;
  const B = AF(n, s, o);
  if (o.pendingDs) {
    const g = new zl(_o(o.pendingDs));
    ut(g.restDecoder);
    const h = AF(g, s, o);
    B && h ? o.pendingDs = zd([B, h]) : o.pendingDs = B || h;
  } else
    o.pendingDs = B;
  if (r) {
    const g = (
      /** @type {{update: Uint8Array}} */
      o.pendingStructs.update
    );
    o.pendingStructs = null, xd(s.doc, g);
  }
}, A, !1), xd = (t, e, A, n = zl) => {
  const s = _o(e);
  mZ(s, t, A, new n(s));
}, YZ = (t, e, A) => xd(t, e, A, jU), yZ = (t, e, A = /* @__PURE__ */ new Map()) => {
  Xp(t, e.store, A), ea(t, bU(e.store));
}, FZ = (t, e = new Uint8Array([0]), A = new Ac()) => {
  const n = kU(e);
  yZ(A, t, n);
  const s = [A.toUint8Array()];
  if (t.store.pendingDs && s.push(t.store.pendingDs), t.store.pendingStructs && s.push(VZ(t.store.pendingStructs.update, e)), s.length > 1) {
    if (A.constructor === Ih)
      return PZ(s.map((r, i) => i === 0 ? r : ZZ(r)));
    if (A.constructor === Ac)
      return zd(s);
  }
  return s[0];
}, NZ = (t, e) => FZ(t, e, new Ih()), DZ = (t) => {
  const e = /* @__PURE__ */ new Map(), A = ut(t.restDecoder);
  for (let n = 0; n < A; n++) {
    const s = ut(t.restDecoder), r = ut(t.restDecoder);
    e.set(s, r);
  }
  return e;
}, kU = (t) => DZ(new Nd(_o(t))), RU = (t, e) => (Qt(t.restEncoder, e.size), qo(e.entries()).sort((A, n) => n[0] - A[0]).forEach(([A, n]) => {
  Qt(t.restEncoder, A), Qt(t.restEncoder, n);
}), t), xZ = (t, e) => RU(t, Ch(e.store)), GZ = (t, e = new HU()) => (t instanceof Map ? RU(e, t) : xZ(e, t), e.toUint8Array()), zZ = (t) => GZ(t, new Dd());
class UZ {
  constructor() {
    this.l = [];
  }
}
const nF = () => new UZ(), sF = (t, e) => t.l.push(e), rF = (t, e) => {
  const A = t.l, n = A.length;
  t.l = A.filter((s) => e !== s), n === t.l.length && console.error("[yjs] Tried to remove event handler that doesn't exist.");
}, LU = (t, e, A) => Rp(t.l, [e, A]);
class Bl {
  /**
   * @param {number} client client id
   * @param {number} clock unique per client id, continuous number
   */
  constructor(e, A) {
    this.client = e, this.clock = A;
  }
}
const Xc = (t, e) => t === e || t !== null && e !== null && t.client === e.client && t.clock === e.clock, At = (t, e) => new Bl(t, e), Tg = (t) => {
  for (const [e, A] of t.doc.share.entries())
    if (A === t)
      return e;
  throw ln();
}, Jg = (t, e) => {
  for (; e !== null; ) {
    if (e.parent === t)
      return !0;
    e = /** @type {AbstractType<any>} */
    e.parent._item;
  }
  return !1;
};
class bZ {
  /**
   * @param {Doc} doc
   * @param {YMap<any>} [storeType]
   */
  constructor(e, A = e.getMap("users")) {
    const n = /* @__PURE__ */ new Map();
    this.yusers = A, this.doc = e, this.clients = /* @__PURE__ */ new Map(), this.dss = n;
    const s = (r, i) => {
      const o = r.get("ds"), a = r.get("ids"), c = (
        /** @param {number} clientid */
        (l) => this.clients.set(l, i)
      );
      o.observe(
        /** @param {YArrayEvent<any>} event */
        (l) => {
          l.changes.added.forEach((B) => {
            B.content.getContent().forEach((g) => {
              g instanceof Uint8Array && this.dss.set(i, Rg([this.dss.get(i) || Vp(), Sg(new Nd(_o(g)))]));
            });
          });
        }
      ), this.dss.set(i, Rg(o.map((l) => Sg(new Nd(_o(l)))))), a.observe(
        /** @param {YArrayEvent<any>} event */
        (l) => l.changes.added.forEach((B) => B.content.getContent().forEach(c))
      ), a.forEach(c);
    };
    A.observe((r) => {
      r.keysChanged.forEach(
        (i) => s(A.get(i), i)
      );
    }), A.forEach(s);
  }
  /**
   * @param {Doc} doc
   * @param {number} clientid
   * @param {string} userDescription
   * @param {Object} conf
   * @param {function(Transaction, DeleteSet):boolean} [conf.filter]
   */
  setUserMapping(e, A, n, { filter: s = () => !0 } = {}) {
    const r = this.yusers;
    let i = r.get(n);
    i || (i = new jr(), i.set("ids", new Ds()), i.set("ds", new Ds()), r.set(n, i)), i.get("ids").push([A]), r.observe((o) => {
      setTimeout(() => {
        const a = r.get(n);
        if (a !== i) {
          i = a, this.clients.forEach((B, g) => {
            n === B && i.get("ids").push([g]);
          });
          const c = new Dd(), l = this.dss.get(n);
          l && (ea(c, l), i.get("ds").push([c.toUint8Array()]));
        }
      }, 0);
    }), e.on(
      "afterTransaction",
      /** @param {Transaction} transaction */
      (o) => {
        setTimeout(() => {
          const a = i.get("ds"), c = o.deleteSet;
          if (o.local && c.clients.size > 0 && s(o, c)) {
            const l = new Dd();
            ea(l, c), a.push([l.toUint8Array()]);
          }
        });
      }
    );
  }
  /**
   * @param {number} clientid
   * @return {any}
   */
  getUserByClientId(e) {
    return this.clients.get(e) || null;
  }
  /**
   * @param {ID} id
   * @return {string | null}
   */
  getUserByDeletedId(e) {
    for (const [A, n] of this.dss.entries())
      if (lc(n, e))
        return A;
    return null;
  }
}
class Wg {
  /**
   * @param {ID|null} type
   * @param {string|null} tname
   * @param {ID|null} item
   * @param {number} assoc
   */
  constructor(e, A, n, s = 0) {
    this.type = e, this.tname = A, this.item = n, this.assoc = s;
  }
}
const Oa = (t) => new Wg(t.type == null ? null : At(t.type.client, t.type.clock), t.tname ?? null, t.item == null ? null : At(t.item.client, t.item.clock), t.assoc == null ? 0 : t.assoc);
class vZ {
  /**
   * @param {AbstractType<any>} type
   * @param {number} index
   * @param {number} [assoc]
   */
  constructor(e, A, n = 0) {
    this.type = e, this.index = A, this.assoc = n;
  }
}
const jZ = (t, e, A = 0) => new vZ(t, e, A), w0 = (t, e, A) => {
  let n = null, s = null;
  return t._item === null ? s = Tg(t) : n = At(t._item.id.client, t._item.id.clock), new Wg(n, s, e, A);
}, qQ = (t, e, A = 0) => {
  let n = t._start;
  if (A < 0) {
    if (e === 0)
      return w0(t, null, A);
    e--;
  }
  for (; n !== null; ) {
    if (!n.deleted && n.countable) {
      if (n.length > e)
        return w0(t, At(n.id.client, n.id.clock + e), A);
      e -= n.length;
    }
    if (n.right === null && A < 0)
      return w0(t, n.lastId, A);
    n = n.right;
  }
  return w0(t, null, A);
}, HZ = (t, e) => {
  const A = gl(t, e), n = e.clock - A.id.clock;
  return {
    item: A,
    diff: n
  };
}, kZ = (t, e, A = !0) => {
  const n = e.store, s = t.item, r = t.type, i = t.tname, o = t.assoc;
  let a = null, c = 0;
  if (s !== null) {
    if (uA(n, s.client) <= s.clock)
      return null;
    const l = A ? EE(n, s) : HZ(n, s), B = l.item;
    if (!(B instanceof jt))
      return null;
    if (a = /** @type {AbstractType<any>} */
    B.parent, a._item === null || !a._item.deleted) {
      c = B.deleted || !B.countable ? 0 : l.diff + (o >= 0 ? 0 : 1);
      let g = B.left;
      for (; g !== null; )
        !g.deleted && g.countable && (c += g.length), g = g.left;
    }
  } else {
    if (i !== null)
      a = e.get(i);
    else if (r !== null) {
      if (uA(n, r.client) <= r.clock)
        return null;
      const { item: l } = A ? EE(n, r) : { item: gl(n, r) };
      if (l instanceof jt && l.content instanceof hr)
        a = l.content.type;
      else
        return null;
    } else
      throw ln();
    o >= 0 ? c = a._length : c = 0;
  }
  return jZ(a, c, t.assoc);
}, Gd = (t, e) => t === e || t !== null && e !== null && t.tname === e.tname && Xc(t.item, e.item) && Xc(t.type, e.type) && t.assoc === e.assoc;
class Zp {
  /**
   * @param {DeleteSet} ds
   * @param {Map<number,number>} sv state map
   */
  constructor(e, A) {
    this.ds = e, this.sv = A;
  }
}
const SU = (t, e) => new Zp(t, e), _Q = (t) => SU(bU(t.store), Ch(t.store)), Ua = (t, e) => e === void 0 ? !t.deleted : e.sv.has(t.id.client) && (e.sv.get(t.id.client) || 0) > t.id.clock && !lc(e.ds, t.id), QE = (t, e) => {
  const A = $r(t.meta, QE, tc), n = t.doc.store;
  A.has(e) || (e.sv.forEach((s, r) => {
    s < uA(n, r) && Vn(t, At(r, s));
  }), $o(t, e.ds, (s) => {
  }), A.add(e));
};
class TU {
  constructor() {
    this.clients = /* @__PURE__ */ new Map(), this.pendingStructs = null, this.pendingDs = null;
  }
}
const Ch = (t) => {
  const e = /* @__PURE__ */ new Map();
  return t.clients.forEach((A, n) => {
    const s = A[A.length - 1];
    e.set(n, s.id.clock + s.length);
  }), e;
}, uA = (t, e) => {
  const A = t.clients.get(e);
  if (A === void 0)
    return 0;
  const n = A[A.length - 1];
  return n.id.clock + n.length;
}, JU = (t, e) => {
  let A = t.clients.get(e.id.client);
  if (A === void 0)
    A = [], t.clients.set(e.id.client, A);
  else {
    const n = A[A.length - 1];
    if (n.id.clock + n.length !== e.id.clock)
      throw ln();
  }
  A.push(e);
}, lr = (t, e) => {
  let A = 0, n = t.length - 1, s = t[n], r = s.id.clock;
  if (r === e)
    return n;
  let i = ar(e / (r + s.length - 1) * n);
  for (; A <= n; ) {
    if (s = t[i], r = s.id.clock, r <= e) {
      if (e < r + s.length)
        return i;
      A = i + 1;
    } else
      n = i - 1;
    i = ar((A + n) / 2);
  }
  throw ln();
}, RZ = (t, e) => {
  const A = t.clients.get(e.client);
  return A[lr(A, e.clock)];
}, gl = (
  /** @type {function(StructStore,ID):Item} */
  RZ
), IE = (t, e, A) => {
  const n = lr(e, A), s = e[n];
  return s.id.clock < A && s instanceof jt ? (e.splice(n + 1, 0, Hd(t, s, A - s.id.clock)), n + 1) : n;
}, Vn = (t, e) => {
  const A = (
    /** @type {Array<Item>} */
    t.doc.store.clients.get(e.client)
  );
  return A[IE(t, A, e.clock)];
}, iF = (t, e, A) => {
  const n = e.clients.get(A.client), s = lr(n, A.clock), r = n[s];
  return A.clock !== r.id.clock + r.length - 1 && r.constructor !== ys && n.splice(s + 1, 0, Hd(t, r, A.clock - r.id.clock + 1)), r;
}, LZ = (t, e, A) => {
  const n = (
    /** @type {Array<GC|Item>} */
    t.clients.get(e.id.client)
  );
  n[lr(n, e.id.clock)] = A;
}, WU = (t, e, A, n, s) => {
  if (n === 0)
    return;
  const r = A + n;
  let i = IE(t, e, A), o;
  do
    o = e[i++], r < o.id.clock + o.length && IE(t, e, r), s(o);
  while (i < e.length && e[i].id.clock < r);
};
class SZ {
  /**
   * @param {Doc} doc
   * @param {any} origin
   * @param {boolean} local
   */
  constructor(e, A, n) {
    this.doc = e, this.deleteSet = new Ol(), this.beforeState = Ch(e.store), this.afterState = /* @__PURE__ */ new Map(), this.changed = /* @__PURE__ */ new Map(), this.changedParentTypes = /* @__PURE__ */ new Map(), this._mergeStructs = [], this.origin = A, this.meta = /* @__PURE__ */ new Map(), this.local = n, this.subdocsAdded = /* @__PURE__ */ new Set(), this.subdocsRemoved = /* @__PURE__ */ new Set(), this.subdocsLoaded = /* @__PURE__ */ new Set(), this._needFormattingCleanup = !1;
  }
}
const oF = (t, e) => e.deleteSet.clients.size === 0 && !IV(e.afterState, (A, n) => e.beforeState.get(n) !== A) ? !1 : (Kp(e.deleteSet), pZ(t, e), ea(t, e.deleteSet), !0), aF = (t, e, A) => {
  const n = e._item;
  (n === null || n.id.clock < (t.beforeState.get(n.id.client) || 0) && !n.deleted) && $r(t.changed, e, tc).add(A);
}, ou = (t, e) => {
  let A = t[e], n = t[e - 1], s = e;
  for (; s > 0; A = n, n = t[--s - 1]) {
    if (n.deleted === A.deleted && n.constructor === A.constructor && n.mergeWith(A)) {
      A instanceof jt && A.parentSub !== null && /** @type {AbstractType<any>} */
      A.parent._map.get(A.parentSub) === A && A.parent._map.set(
        A.parentSub,
        /** @type {Item} */
        n
      );
      continue;
    }
    break;
  }
  const r = e - s;
  return r && t.splice(e + 1 - r, r), r;
}, TZ = (t, e, A) => {
  for (const [n, s] of t.clients.entries()) {
    const r = (
      /** @type {Array<GC|Item>} */
      e.clients.get(n)
    );
    for (let i = s.length - 1; i >= 0; i--) {
      const o = s[i], a = o.clock + o.len;
      for (let c = lr(r, o.clock), l = r[c]; c < r.length && l.id.clock < a; l = r[++c]) {
        const B = r[c];
        if (o.clock + o.len <= B.id.clock)
          break;
        B instanceof jt && B.deleted && !B.keep && A(B) && B.gc(e, !1);
      }
    }
  }
}, JZ = (t, e) => {
  t.clients.forEach((A, n) => {
    const s = (
      /** @type {Array<GC|Item>} */
      e.clients.get(n)
    );
    for (let r = A.length - 1; r >= 0; r--) {
      const i = A[r], o = Ui(s.length - 1, 1 + lr(s, i.clock + i.len - 1));
      for (let a = o, c = s[a]; a > 0 && c.id.clock >= i.clock; c = s[a])
        a -= 1 + ou(s, a);
    }
  });
}, OU = (t, e) => {
  if (e < t.length) {
    const A = t[e], n = A.doc, s = n.store, r = A.deleteSet, i = A._mergeStructs;
    try {
      Kp(r), A.afterState = Ch(A.doc.store), n.emit("beforeObserverCalls", [A, n]);
      const o = [];
      A.changed.forEach(
        (a, c) => o.push(() => {
          (c._item === null || !c._item.deleted) && c._callObserver(A, a);
        })
      ), o.push(() => {
        A.changedParentTypes.forEach((a, c) => {
          c._dEH.l.length > 0 && (c._item === null || !c._item.deleted) && (a = a.filter(
            (l) => l.target._item === null || !l.target._item.deleted
          ), a.forEach((l) => {
            l.currentTarget = c, l._path = null;
          }), a.sort((l, B) => l.path.length - B.path.length), o.push(() => {
            LU(c._dEH, a, A);
          }));
        }), o.push(() => n.emit("afterTransaction", [A, n])), o.push(() => {
          A._needFormattingCleanup && lq(A);
        });
      }), Rp(o, []);
    } finally {
      n.gc && TZ(r, s, n.gcFilter), JZ(r, s), A.afterState.forEach((l, B) => {
        const g = A.beforeState.get(B) || 0;
        if (g !== l) {
          const h = (
            /** @type {Array<GC|Item>} */
            s.clients.get(B)
          ), u = cr(lr(h, g), 1);
          for (let d = h.length - 1; d >= u; )
            d -= 1 + ou(h, d);
        }
      });
      for (let l = i.length - 1; l >= 0; l--) {
        const { client: B, clock: g } = i[l].id, h = (
          /** @type {Array<GC|Item>} */
          s.clients.get(B)
        ), u = lr(h, g);
        u + 1 < h.length && ou(h, u + 1) > 1 || u > 0 && ou(h, u);
      }
      if (!A.local && A.afterState.get(n.clientID) !== A.beforeState.get(n.clientID) && (wZ(Op, FU, "[yjs] ", NU, DU, "Changed the client-id because another client seems to be using it."), n.clientID = vU()), n.emit("afterTransactionCleanup", [A, n]), n._observers.has("update")) {
        const l = new Ih();
        oF(l, A) && n.emit("update", [l.toUint8Array(), A.origin, n, A]);
      }
      if (n._observers.has("updateV2")) {
        const l = new Ac();
        oF(l, A) && n.emit("updateV2", [l.toUint8Array(), A.origin, n, A]);
      }
      const { subdocsAdded: o, subdocsLoaded: a, subdocsRemoved: c } = A;
      (o.size > 0 || c.size > 0 || a.size > 0) && (o.forEach((l) => {
        l.clientID = n.clientID, l.collectionid == null && (l.collectionid = n.collectionid), n.subdocs.add(l);
      }), c.forEach((l) => n.subdocs.delete(l)), n.emit("subdocs", [{ loaded: a, added: o, removed: c }, n, A]), c.forEach((l) => l.destroy())), t.length <= e + 1 ? (n._transactionCleanups = [], n.emit("afterAllTransactions", [n, t])) : OU(t, e + 1);
    }
  }
}, Rt = (t, e, A = null, n = !0) => {
  const s = t._transactionCleanups;
  let r = !1, i = null;
  t._transaction === null && (r = !0, t._transaction = new SZ(t, A, n), s.push(t._transaction), s.length === 1 && t.emit("beforeAllTransactions", [t]), t.emit("beforeTransaction", [t._transaction, t]));
  try {
    i = e(t._transaction);
  } finally {
    if (r) {
      const o = t._transaction === s[0];
      t._transaction = null, o && OU(s, 0);
    }
  }
  return i;
};
class WZ {
  /**
   * @param {DeleteSet} deletions
   * @param {DeleteSet} insertions
   */
  constructor(e, A) {
    this.insertions = A, this.deletions = e, this.meta = /* @__PURE__ */ new Map();
  }
}
const cF = (t, e, A) => {
  $o(t, A.deletions, (n) => {
    n instanceof jt && e.scope.some((s) => s === t.doc || Jg(
      /** @type {AbstractType<any>} */
      s,
      n
    )) && sm(n, !1);
  });
}, lF = (t, e, A) => {
  let n = null;
  const s = t.doc, r = t.scope;
  Rt(s, (o) => {
    for (; e.length > 0 && t.currStackItem === null; ) {
      const a = s.store, c = (
        /** @type {StackItem} */
        e.pop()
      ), l = /* @__PURE__ */ new Set(), B = [];
      let g = !1;
      $o(o, c.insertions, (h) => {
        if (h instanceof jt) {
          if (h.redone !== null) {
            let { item: u, diff: d } = EE(a, h.id);
            d > 0 && (u = Vn(o, At(u.id.client, u.id.clock + d))), h = u;
          }
          !h.deleted && r.some((u) => u === o.doc || Jg(
            /** @type {AbstractType<any>} */
            u,
            /** @type {Item} */
            h
          )) && B.push(h);
        }
      }), $o(o, c.deletions, (h) => {
        h instanceof jt && r.some((u) => u === o.doc || Jg(
          /** @type {AbstractType<any>} */
          u,
          h
        )) && // Never redo structs in stackItem.insertions because they were created and deleted in the same capture interval.
        !lc(c.insertions, h.id) && l.add(h);
      }), l.forEach((h) => {
        g = Bb(o, h, l, c.insertions, t.ignoreRemoteMapChanges, t) !== null || g;
      });
      for (let h = B.length - 1; h >= 0; h--) {
        const u = B[h];
        t.deleteFilter(u) && (u.delete(o), g = !0);
      }
      t.currStackItem = g ? c : null;
    }
    o.changed.forEach((a, c) => {
      a.has(null) && c._searchMarker && (c._searchMarker.length = 0);
    }), n = o;
  }, t);
  const i = t.currStackItem;
  if (i != null) {
    const o = n.changedParentTypes;
    t.emit("stack-item-popped", [{ stackItem: i, type: A, changedParentTypes: o, origin: t }, t]), t.currStackItem = null;
  }
  return i;
};
class PU extends _z {
  /**
   * @param {Doc|AbstractType<any>|Array<AbstractType<any>>} typeScope Limits the scope of the UndoManager. If this is set to a ydoc instance, all changes on that ydoc will be undone. If set to a specific type, only changes on that type or its children will be undone. Also accepts an array of types.
   * @param {UndoManagerOptions} options
   */
  constructor(e, {
    captureTimeout: A = 500,
    captureTransaction: n = (a) => !0,
    deleteFilter: s = () => !0,
    trackedOrigins: r = /* @__PURE__ */ new Set([null]),
    ignoreRemoteMapChanges: i = !1,
    doc: o = (
      /** @type {Doc} */
      Fl(e) ? e[0].doc : e instanceof no ? e : e.doc
    )
  } = {}) {
    super(), this.scope = [], this.doc = o, this.addToScope(e), this.deleteFilter = s, r.add(this), this.trackedOrigins = r, this.captureTransaction = n, this.undoStack = [], this.redoStack = [], this.undoing = !1, this.redoing = !1, this.currStackItem = null, this.lastChange = 0, this.ignoreRemoteMapChanges = i, this.captureTimeout = A, this.afterTransactionHandler = (a) => {
      if (!this.captureTransaction(a) || !this.scope.some((w) => a.changedParentTypes.has(
        /** @type {AbstractType<any>} */
        w
      ) || w === this.doc) || !this.trackedOrigins.has(a.origin) && (!a.origin || !this.trackedOrigins.has(a.origin.constructor)))
        return;
      const c = this.undoing, l = this.redoing, B = c ? this.redoStack : this.undoStack;
      c ? this.stopCapturing() : l || this.clear(!1, !0);
      const g = new Ol();
      a.afterState.forEach((w, Q) => {
        const p = a.beforeState.get(Q) || 0, M = w - p;
        M > 0 && Lg(g, Q, p, M);
      });
      const h = nX();
      let u = !1;
      if (this.lastChange > 0 && h - this.lastChange < this.captureTimeout && B.length > 0 && !c && !l) {
        const w = B[B.length - 1];
        w.deletions = Rg([w.deletions, a.deleteSet]), w.insertions = Rg([w.insertions, g]);
      } else
        B.push(new WZ(a.deleteSet, g)), u = !0;
      !c && !l && (this.lastChange = h), $o(
        a,
        a.deleteSet,
        /** @param {Item|GC} item */
        (w) => {
          w instanceof jt && this.scope.some((Q) => Q === a.doc || Jg(
            /** @type {AbstractType<any>} */
            Q,
            w
          )) && sm(w, !0);
        }
      );
      const d = [{ stackItem: B[B.length - 1], origin: a.origin, type: c ? "redo" : "undo", changedParentTypes: a.changedParentTypes }, this];
      u ? this.emit("stack-item-added", d) : this.emit("stack-item-updated", d);
    }, this.doc.on("afterTransaction", this.afterTransactionHandler), this.doc.on("destroy", () => {
      this.destroy();
    });
  }
  /**
   * Extend the scope.
   *
   * @param {Array<AbstractType<any> | Doc> | AbstractType<any> | Doc} ytypes
   */
  addToScope(e) {
    const A = new Set(this.scope);
    e = Fl(e) ? e : [e], e.forEach((n) => {
      A.has(n) || (A.add(n), (n instanceof HA ? n.doc !== this.doc : n !== this.doc) && GU("[yjs#509] Not same Y.Doc"), this.scope.push(n));
    });
  }
  /**
   * @param {any} origin
   */
  addTrackedOrigin(e) {
    this.trackedOrigins.add(e);
  }
  /**
   * @param {any} origin
   */
  removeTrackedOrigin(e) {
    this.trackedOrigins.delete(e);
  }
  clear(e = !0, A = !0) {
    (e && this.canUndo() || A && this.canRedo()) && this.doc.transact((n) => {
      e && (this.undoStack.forEach((s) => cF(n, this, s)), this.undoStack = []), A && (this.redoStack.forEach((s) => cF(n, this, s)), this.redoStack = []), this.emit("stack-cleared", [{ undoStackCleared: e, redoStackCleared: A }]);
    });
  }
  /**
   * UndoManager merges Undo-StackItem if they are created within time-gap
   * smaller than `options.captureTimeout`. Call `um.stopCapturing()` so that the next
   * StackItem won't be merged.
   *
   *
   * @example
   *     // without stopCapturing
   *     ytext.insert(0, 'a')
   *     ytext.insert(1, 'b')
   *     um.undo()
   *     ytext.toString() // => '' (note that 'ab' was removed)
   *     // with stopCapturing
   *     ytext.insert(0, 'a')
   *     um.stopCapturing()
   *     ytext.insert(0, 'b')
   *     um.undo()
   *     ytext.toString() // => 'a' (note that only 'b' was removed)
   *
   */
  stopCapturing() {
    this.lastChange = 0;
  }
  /**
   * Undo last changes on type.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  undo() {
    this.undoing = !0;
    let e;
    try {
      e = lF(this, this.undoStack, "undo");
    } finally {
      this.undoing = !1;
    }
    return e;
  }
  /**
   * Redo last undo operation.
   *
   * @return {StackItem?} Returns StackItem if a change was applied
   */
  redo() {
    this.redoing = !0;
    let e;
    try {
      e = lF(this, this.redoStack, "redo");
    } finally {
      this.redoing = !1;
    }
    return e;
  }
  /**
   * Are undo steps available?
   *
   * @return {boolean} `true` if undo is possible
   */
  canUndo() {
    return this.undoStack.length > 0;
  }
  /**
   * Are redo steps available?
   *
   * @return {boolean} `true` if redo is possible
   */
  canRedo() {
    return this.redoStack.length > 0;
  }
  destroy() {
    this.trackedOrigins.delete(this), this.doc.off("afterTransaction", this.afterTransactionHandler), super.destroy();
  }
}
function* OZ(t) {
  const e = ut(t.restDecoder);
  for (let A = 0; A < e; A++) {
    const n = ut(t.restDecoder), s = t.readClient();
    let r = ut(t.restDecoder);
    for (let i = 0; i < n; i++) {
      const o = t.readInfo();
      if (o === 10) {
        const a = ut(t.restDecoder);
        yield new Fs(At(s, r), a), r += a;
      } else if ((Sw & o) !== 0) {
        const a = (o & (bi | Dn)) === 0, c = new jt(
          At(s, r),
          null,
          // left
          (o & Dn) === Dn ? t.readLeftID() : null,
          // origin
          null,
          // right
          (o & bi) === bi ? t.readRightID() : null,
          // right origin
          // @ts-ignore Force writing a string here.
          a ? t.readParentInfo() ? t.readString() : t.readLeftID() : null,
          // parent
          a && (o & bg) === bg ? t.readString() : null,
          // parentSub
          gb(t, o)
          // item content
        );
        yield c, r += c.length;
      } else {
        const a = t.readLen();
        yield new ys(At(s, r), a), r += a;
      }
    }
  }
}
class qp {
  /**
   * @param {UpdateDecoderV1 | UpdateDecoderV2} decoder
   * @param {boolean} filterSkips
   */
  constructor(e, A) {
    this.gen = OZ(e), this.curr = null, this.done = !1, this.filterSkips = A, this.next();
  }
  /**
   * @return {Item | GC | Skip |null}
   */
  next() {
    do
      this.curr = this.gen.next().value || null;
    while (this.filterSkips && this.curr !== null && this.curr.constructor === Fs);
    return this.curr;
  }
}
class _p {
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  constructor(e) {
    this.currClient = 0, this.startClock = 0, this.written = 0, this.encoder = e, this.clientStructs = [];
  }
}
const PZ = (t) => zd(t, jU, Ih), KZ = (t, e) => {
  if (t.constructor === ys) {
    const { client: A, clock: n } = t.id;
    return new ys(At(A, n + e), t.length - e);
  } else if (t.constructor === Fs) {
    const { client: A, clock: n } = t.id;
    return new Fs(At(A, n + e), t.length - e);
  } else {
    const A = (
      /** @type {Item} */
      t
    ), { client: n, clock: s } = A.id;
    return new jt(
      At(n, s + e),
      null,
      At(n, s + e - 1),
      null,
      A.rightOrigin,
      A.parent,
      A.parentSub,
      A.content.splice(e)
    );
  }
}, zd = (t, e = zl, A = Ac) => {
  if (t.length === 1)
    return t[0];
  const n = t.map((l) => new e(_o(l)));
  let s = n.map((l) => new qp(l, !0)), r = null;
  const i = new A(), o = new _p(i);
  for (; s = s.filter((g) => g.curr !== null), s.sort(
    /** @type {function(any,any):number} */
    (g, h) => {
      if (g.curr.id.client === h.curr.id.client) {
        const u = g.curr.id.clock - h.curr.id.clock;
        return u === 0 ? g.curr.constructor === h.curr.constructor ? 0 : g.curr.constructor === Fs ? 1 : -1 : u;
      } else
        return h.curr.id.client - g.curr.id.client;
    }
  ), s.length !== 0; ) {
    const l = s[0], B = (
      /** @type {Item | GC} */
      l.curr.id.client
    );
    if (r !== null) {
      let g = (
        /** @type {Item | GC | null} */
        l.curr
      ), h = !1;
      for (; g !== null && g.id.clock + g.length <= r.struct.id.clock + r.struct.length && g.id.client >= r.struct.id.client; )
        g = l.next(), h = !0;
      if (g === null || // current decoder is empty
      g.id.client !== B || // check whether there is another decoder that has has updates from `firstClient`
      h && g.id.clock > r.struct.id.clock + r.struct.length)
        continue;
      if (B !== r.struct.id.client)
        Do(o, r.struct, r.offset), r = { struct: g, offset: 0 }, l.next();
      else if (r.struct.id.clock + r.struct.length < g.id.clock)
        if (r.struct.constructor === Fs)
          r.struct.length = g.id.clock + g.length - r.struct.id.clock;
        else {
          Do(o, r.struct, r.offset);
          const u = g.id.clock - r.struct.id.clock - r.struct.length;
          r = { struct: new Fs(At(B, r.struct.id.clock + r.struct.length), u), offset: 0 };
        }
      else {
        const u = r.struct.id.clock + r.struct.length - g.id.clock;
        u > 0 && (r.struct.constructor === Fs ? r.struct.length -= u : g = KZ(g, u)), r.struct.mergeWith(
          /** @type {any} */
          g
        ) || (Do(o, r.struct, r.offset), r = { struct: g, offset: 0 }, l.next());
      }
    } else
      r = { struct: (
        /** @type {Item | GC} */
        l.curr
      ), offset: 0 }, l.next();
    for (let g = l.curr; g !== null && g.id.client === B && g.id.clock === r.struct.id.clock + r.struct.length && g.constructor !== Fs; g = l.next())
      Do(o, r.struct, r.offset), r = { struct: g, offset: 0 };
  }
  r !== null && (Do(o, r.struct, r.offset), r = null), $p(o);
  const a = n.map((l) => Sg(l)), c = Rg(a);
  return ea(i, c), i.toUint8Array();
}, VZ = (t, e, A = zl, n = Ac) => {
  const s = kU(e), r = new n(), i = new _p(r), o = new A(_o(t)), a = new qp(o, !1);
  for (; a.curr; ) {
    const l = a.curr, B = l.id.client, g = s.get(B) || 0;
    if (a.curr.constructor === Fs) {
      a.next();
      continue;
    }
    if (l.id.clock + l.length > g)
      for (Do(i, l, cr(g - l.id.clock, 0)), a.next(); a.curr && a.curr.id.client === B; )
        Do(i, a.curr, 0), a.next();
    else
      for (; a.curr && a.curr.id.client === B && a.curr.id.clock + a.curr.length <= g; )
        a.next();
  }
  $p(i);
  const c = Sg(o);
  return ea(r, c), r.toUint8Array();
}, KU = (t) => {
  t.written > 0 && (t.clientStructs.push({ written: t.written, restEncoder: qs(t.encoder.restEncoder) }), t.encoder.restEncoder = fh(), t.written = 0);
}, Do = (t, e, A) => {
  t.written > 0 && t.currClient !== e.id.client && KU(t), t.written === 0 && (t.currClient = e.id.client, t.encoder.writeClient(e.id.client), Qt(t.encoder.restEncoder, e.id.clock + A)), e.write(t.encoder, A), t.written++;
}, $p = (t) => {
  KU(t);
  const e = t.encoder.restEncoder;
  Qt(e, t.clientStructs.length);
  for (let A = 0; A < t.clientStructs.length; A++) {
    const n = t.clientStructs[A];
    Qt(e, n.written), Tw(e, n.restEncoder);
  }
}, XZ = (t, e, A, n) => {
  const s = new A(_o(t)), r = new qp(s, !1), i = new n(), o = new _p(i);
  for (let c = r.curr; c !== null; c = r.next())
    Do(o, e(c), 0);
  $p(o);
  const a = Sg(s);
  return ea(i, a), i.toUint8Array();
}, ZZ = (t) => XZ(t, hX, zl, Ih), BF = "You must not compute changes after the event-handler fired.";
class Xw {
  /**
   * @param {T} target The changed type.
   * @param {Transaction} transaction
   */
  constructor(e, A) {
    this.target = e, this.currentTarget = e, this.transaction = A, this._changes = null, this._keys = null, this._delta = null, this._path = null;
  }
  /**
   * Computes the path from `y` to the changed type.
   *
   * @todo v14 should standardize on path: Array<{parent, index}> because that is easier to work with.
   *
   * The following property holds:
   * @example
   *   let type = y
   *   event.path.forEach(dir => {
   *     type = type.get(dir)
   *   })
   *   type === event.target // => true
   */
  get path() {
    return this._path || (this._path = qZ(this.currentTarget, this.target));
  }
  /**
   * Check if a struct is deleted by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  deletes(e) {
    return lc(this.transaction.deleteSet, e.id);
  }
  /**
   * @type {Map<string, { action: 'add' | 'update' | 'delete', oldValue: any }>}
   */
  get keys() {
    if (this._keys === null) {
      if (this.transaction.doc._transactionCleanups.length === 0)
        throw Wr(BF);
      const e = /* @__PURE__ */ new Map(), A = this.target;
      /** @type Set<string|null> */
      this.transaction.changed.get(A).forEach((s) => {
        if (s !== null) {
          const r = (
            /** @type {Item} */
            A._map.get(s)
          );
          let i, o;
          if (this.adds(r)) {
            let a = r.left;
            for (; a !== null && this.adds(a); )
              a = a.left;
            if (this.deletes(r))
              if (a !== null && this.deletes(a))
                i = "delete", o = JQ(a.content.getContent());
              else
                return;
            else
              a !== null && this.deletes(a) ? (i = "update", o = JQ(a.content.getContent())) : (i = "add", o = void 0);
          } else if (this.deletes(r))
            i = "delete", o = JQ(
              /** @type {Item} */
              r.content.getContent()
            );
          else
            return;
          e.set(s, { action: i, oldValue: o });
        }
      }), this._keys = e;
    }
    return this._keys;
  }
  /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {Array<{insert?: string | Array<any> | object | AbstractType<any>, retain?: number, delete?: number, attributes?: Object<string, any>}>}
   */
  get delta() {
    return this.changes.delta;
  }
  /**
   * Check if a struct is added by this event.
   *
   * In contrast to change.deleted, this method also returns true if the struct was added and then deleted.
   *
   * @param {AbstractStruct} struct
   * @return {boolean}
   */
  adds(e) {
    return e.id.clock >= (this.transaction.beforeState.get(e.id.client) || 0);
  }
  /**
   * This is a computed property. Note that this can only be safely computed during the
   * event call. Computing this property after other changes happened might result in
   * unexpected behavior (incorrect computation of deltas). A safe way to collect changes
   * is to store the `changes` or the `delta` object. Avoid storing the `transaction` object.
   *
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes() {
    let e = this._changes;
    if (e === null) {
      if (this.transaction.doc._transactionCleanups.length === 0)
        throw Wr(BF);
      const A = this.target, n = tc(), s = tc(), r = [];
      if (e = {
        added: n,
        deleted: s,
        delta: r,
        keys: this.keys
      }, /** @type Set<string|null> */
      this.transaction.changed.get(A).has(null)) {
        let o = null;
        const a = () => {
          o && r.push(o);
        };
        for (let c = A._start; c !== null; c = c.right)
          c.deleted ? this.deletes(c) && !this.adds(c) && ((o === null || o.delete === void 0) && (a(), o = { delete: 0 }), o.delete += c.length, s.add(c)) : this.adds(c) ? ((o === null || o.insert === void 0) && (a(), o = { insert: [] }), o.insert = o.insert.concat(c.content.getContent()), n.add(c)) : ((o === null || o.retain === void 0) && (a(), o = { retain: 0 }), o.retain += c.length);
        o !== null && o.retain === void 0 && a();
      }
      this._changes = e;
    }
    return (
      /** @type {any} */
      e
    );
  }
}
const qZ = (t, e) => {
  const A = [];
  for (; e._item !== null && e !== t; ) {
    if (e._item.parentSub !== null)
      A.unshift(e._item.parentSub);
    else {
      let n = 0, s = (
        /** @type {AbstractType<any>} */
        e._item.parent._start
      );
      for (; s !== e._item && s !== null; )
        !s.deleted && s.countable && (n += s.length), s = s.right;
      A.unshift(n);
    }
    e = /** @type {AbstractType<any>} */
    e._item.parent;
  }
  return A;
}, on = () => {
  GU("Invalid access: Add Yjs type to a document before reading data.");
}, VU = 80;
let em = 0;
class _Z {
  /**
   * @param {Item} p
   * @param {number} index
   */
  constructor(e, A) {
    e.marker = !0, this.p = e, this.index = A, this.timestamp = em++;
  }
}
const $Z = (t) => {
  t.timestamp = em++;
}, XU = (t, e, A) => {
  t.p.marker = !1, t.p = e, e.marker = !0, t.index = A, t.timestamp = em++;
}, eq = (t, e, A) => {
  if (t.length >= VU) {
    const n = t.reduce((s, r) => s.timestamp < r.timestamp ? s : r);
    return XU(n, e, A), n;
  } else {
    const n = new _Z(e, A);
    return t.push(n), n;
  }
}, Zw = (t, e) => {
  if (t._start === null || e === 0 || t._searchMarker === null)
    return null;
  const A = t._searchMarker.length === 0 ? null : t._searchMarker.reduce((r, i) => nu(e - r.index) < nu(e - i.index) ? r : i);
  let n = t._start, s = 0;
  for (A !== null && (n = A.p, s = A.index, $Z(A)); n.right !== null && s < e; ) {
    if (!n.deleted && n.countable) {
      if (e < s + n.length)
        break;
      s += n.length;
    }
    n = n.right;
  }
  for (; n.left !== null && s > e; )
    n = n.left, !n.deleted && n.countable && (s -= n.length);
  for (; n.left !== null && n.left.id.client === n.id.client && n.left.id.clock + n.left.length === n.id.clock; )
    n = n.left, !n.deleted && n.countable && (s -= n.length);
  return A !== null && nu(A.index - s) < /** @type {YText|YArray<any>} */
  n.parent.length / VU ? (XU(A, n, s), A) : eq(t._searchMarker, n, s);
}, Og = (t, e, A) => {
  for (let n = t.length - 1; n >= 0; n--) {
    const s = t[n];
    if (A > 0) {
      let r = s.p;
      for (r.marker = !1; r && (r.deleted || !r.countable); )
        r = r.left, r && !r.deleted && r.countable && (s.index -= r.length);
      if (r === null || r.marker === !0) {
        t.splice(n, 1);
        continue;
      }
      s.p = r, r.marker = !0;
    }
    (e < s.index || A > 0 && e === s.index) && (s.index = cr(e, s.index + A));
  }
}, qw = (t, e, A) => {
  const n = t, s = e.changedParentTypes;
  for (; $r(s, t, () => []).push(A), t._item !== null; )
    t = /** @type {AbstractType<any>} */
    t._item.parent;
  LU(n._eH, A, e);
};
class HA {
  constructor() {
    this._item = null, this._map = /* @__PURE__ */ new Map(), this._start = null, this.doc = null, this._length = 0, this._eH = nF(), this._dEH = nF(), this._searchMarker = null;
  }
  /**
   * @return {AbstractType<any>|null}
   */
  get parent() {
    return this._item ? (
      /** @type {AbstractType<any>} */
      this._item.parent
    ) : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item|null} item
   */
  _integrate(e, A) {
    this.doc = e, this._item = A;
  }
  /**
   * @return {AbstractType<EventType>}
   */
  _copy() {
    throw ks();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {AbstractType<EventType>}
   */
  clone() {
    throw ks();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} _encoder
   */
  _write(e) {
  }
  /**
   * The first non-deleted item
   */
  get _first() {
    let e = this._start;
    for (; e !== null && e.deleted; )
      e = e.right;
    return e;
  }
  /**
   * Creates YEvent and calls all type observers.
   * Must be implemented by each type.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} _parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, A) {
    !e.local && this._searchMarker && (this._searchMarker.length = 0);
  }
  /**
   * Observe all events that are created on this type.
   *
   * @param {function(EventType, Transaction):void} f Observer function
   */
  observe(e) {
    sF(this._eH, e);
  }
  /**
   * Observe all events that are created by this type and its children.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  observeDeep(e) {
    sF(this._dEH, e);
  }
  /**
   * Unregister an observer function.
   *
   * @param {function(EventType,Transaction):void} f Observer function
   */
  unobserve(e) {
    rF(this._eH, e);
  }
  /**
   * Unregister an observer function.
   *
   * @param {function(Array<YEvent<any>>,Transaction):void} f Observer function
   */
  unobserveDeep(e) {
    rF(this._dEH, e);
  }
  /**
   * @abstract
   * @return {any}
   */
  toJSON() {
  }
}
const ZU = (t, e, A) => {
  t.doc ?? on(), e < 0 && (e = t._length + e), A < 0 && (A = t._length + A);
  let n = A - e;
  const s = [];
  let r = t._start;
  for (; r !== null && n > 0; ) {
    if (r.countable && !r.deleted) {
      const i = r.content.getContent();
      if (i.length <= e)
        e -= i.length;
      else {
        for (let o = e; o < i.length && n > 0; o++)
          s.push(i[o]), n--;
        e = 0;
      }
    }
    r = r.right;
  }
  return s;
}, qU = (t) => {
  t.doc ?? on();
  const e = [];
  let A = t._start;
  for (; A !== null; ) {
    if (A.countable && !A.deleted) {
      const n = A.content.getContent();
      for (let s = 0; s < n.length; s++)
        e.push(n[s]);
    }
    A = A.right;
  }
  return e;
}, _U = (t, e) => {
  const A = [];
  let n = t._start;
  for (; n !== null; ) {
    if (n.countable && Ua(n, e)) {
      const s = n.content.getContent();
      for (let r = 0; r < s.length; r++)
        A.push(s[r]);
    }
    n = n.right;
  }
  return A;
}, Pg = (t, e) => {
  let A = 0, n = t._start;
  for (t.doc ?? on(); n !== null; ) {
    if (n.countable && !n.deleted) {
      const s = n.content.getContent();
      for (let r = 0; r < s.length; r++)
        e(s[r], A++, t);
    }
    n = n.right;
  }
}, $U = (t, e) => {
  const A = [];
  return Pg(t, (n, s) => {
    A.push(e(n, s, t));
  }), A;
}, tq = (t) => {
  let e = t._start, A = null, n = 0;
  return {
    [Symbol.iterator]() {
      return this;
    },
    next: () => {
      if (A === null) {
        for (; e !== null && e.deleted; )
          e = e.right;
        if (e === null)
          return {
            done: !0,
            value: void 0
          };
        A = e.content.getContent(), n = 0, e = e.right;
      }
      const s = A[n++];
      return A.length <= n && (A = null), {
        done: !1,
        value: s
      };
    }
  };
}, eb = (t, e) => {
  t.doc ?? on();
  const A = Zw(t, e);
  let n = t._start;
  for (A !== null && (n = A.p, e -= A.index); n !== null; n = n.right)
    if (!n.deleted && n.countable) {
      if (e < n.length)
        return n.content.getContent()[e];
      e -= n.length;
    }
}, Ud = (t, e, A, n) => {
  let s = A;
  const r = t.doc, i = r.clientID, o = r.store, a = A === null ? e._start : A.right;
  let c = [];
  const l = () => {
    c.length > 0 && (s = new jt(At(i, uA(o, i)), s, s && s.lastId, a, a && a.id, e, null, new sc(c)), s.integrate(t, 0), c = []);
  };
  n.forEach((B) => {
    if (B === null)
      c.push(B);
    else
      switch (B.constructor) {
        case Number:
        case Object:
        case Boolean:
        case Array:
        case String:
          c.push(B);
          break;
        default:
          switch (l(), B.constructor) {
            case Uint8Array:
            case ArrayBuffer:
              s = new jt(At(i, uA(o, i)), s, s && s.lastId, a, a && a.id, e, null, new Eh(new Uint8Array(
                /** @type {Uint8Array} */
                B
              ))), s.integrate(t, 0);
              break;
            case no:
              s = new jt(At(i, uA(o, i)), s, s && s.lastId, a, a && a.id, e, null, new Mh(
                /** @type {Doc} */
                B
              )), s.integrate(t, 0);
              break;
            default:
              if (B instanceof HA)
                s = new jt(At(i, uA(o, i)), s, s && s.lastId, a, a && a.id, e, null, new hr(B)), s.integrate(t, 0);
              else
                throw new Error("Unexpected content type in insert operation");
          }
      }
  }), l();
}, tb = () => Wr("Length exceeded!"), Ab = (t, e, A, n) => {
  if (A > e._length)
    throw tb();
  if (A === 0)
    return e._searchMarker && Og(e._searchMarker, A, n.length), Ud(t, e, null, n);
  const s = A, r = Zw(e, A);
  let i = e._start;
  for (r !== null && (i = r.p, A -= r.index, A === 0 && (i = i.prev, A += i && i.countable && !i.deleted ? i.length : 0)); i !== null; i = i.right)
    if (!i.deleted && i.countable) {
      if (A <= i.length) {
        A < i.length && Vn(t, At(i.id.client, i.id.clock + A));
        break;
      }
      A -= i.length;
    }
  return e._searchMarker && Og(e._searchMarker, s, n.length), Ud(t, e, i, n);
}, Aq = (t, e, A) => {
  let s = (e._searchMarker || []).reduce((r, i) => i.index > r.index ? i : r, { index: 0, p: e._start }).p;
  if (s)
    for (; s.right; )
      s = s.right;
  return Ud(t, e, s, A);
}, nb = (t, e, A, n) => {
  if (n === 0)
    return;
  const s = A, r = n, i = Zw(e, A);
  let o = e._start;
  for (i !== null && (o = i.p, A -= i.index); o !== null && A > 0; o = o.right)
    !o.deleted && o.countable && (A < o.length && Vn(t, At(o.id.client, o.id.clock + A)), A -= o.length);
  for (; n > 0 && o !== null; )
    o.deleted || (n < o.length && Vn(t, At(o.id.client, o.id.clock + n)), o.delete(t), n -= o.length), o = o.right;
  if (n > 0)
    throw tb();
  e._searchMarker && Og(
    e._searchMarker,
    s,
    -r + n
    /* in case we remove the above exception */
  );
}, bd = (t, e, A) => {
  const n = e._map.get(A);
  n !== void 0 && n.delete(t);
}, tm = (t, e, A, n) => {
  const s = e._map.get(A) || null, r = t.doc, i = r.clientID;
  let o;
  if (n == null)
    o = new sc([n]);
  else
    switch (n.constructor) {
      case Number:
      case Object:
      case Boolean:
      case Array:
      case String:
      case Date:
      case BigInt:
        o = new sc([n]);
        break;
      case Uint8Array:
        o = new Eh(
          /** @type {Uint8Array} */
          n
        );
        break;
      case no:
        o = new Mh(
          /** @type {Doc} */
          n
        );
        break;
      default:
        if (n instanceof HA)
          o = new hr(n);
        else
          throw new Error("Unexpected content type");
    }
  new jt(At(i, uA(r.store, i)), s, s && s.lastId, null, null, e, A, o).integrate(t, 0);
}, Am = (t, e) => {
  t.doc ?? on();
  const A = t._map.get(e);
  return A !== void 0 && !A.deleted ? A.content.getContent()[A.length - 1] : void 0;
}, sb = (t) => {
  const e = {};
  return t.doc ?? on(), t._map.forEach((A, n) => {
    A.deleted || (e[n] = A.content.getContent()[A.length - 1]);
  }), e;
}, rb = (t, e) => {
  t.doc ?? on();
  const A = t._map.get(e);
  return A !== void 0 && !A.deleted;
}, nq = (t, e) => {
  const A = {};
  return t._map.forEach((n, s) => {
    let r = n;
    for (; r !== null && (!e.sv.has(r.id.client) || r.id.clock >= (e.sv.get(r.id.client) || 0)); )
      r = r.left;
    r !== null && Ua(r, e) && (A[s] = r.content.getContent()[r.length - 1]);
  }), A;
}, f0 = (t) => (t.doc ?? on(), fZ(
  t._map.entries(),
  /** @param {any} entry */
  (e) => !e[1].deleted
));
class sq extends Xw {
}
class Ds extends HA {
  constructor() {
    super(), this._prelimContent = [], this._searchMarker = [];
  }
  /**
   * Construct a new YArray containing the specified items.
   * @template {Object<string,any>|Array<any>|number|null|string|Uint8Array} T
   * @param {Array<T>} items
   * @return {YArray<T>}
   */
  static from(e) {
    const A = new Ds();
    return A.push(e), A;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, A) {
    super._integrate(e, A), this.insert(
      0,
      /** @type {Array<any>} */
      this._prelimContent
    ), this._prelimContent = null;
  }
  /**
   * @return {YArray<T>}
   */
  _copy() {
    return new Ds();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YArray<T>}
   */
  clone() {
    const e = new Ds();
    return e.insert(0, this.toArray().map(
      (A) => A instanceof HA ? (
        /** @type {typeof el} */
        A.clone()
      ) : A
    )), e;
  }
  get length() {
    return this.doc ?? on(), this._length;
  }
  /**
   * Creates YArrayEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, A) {
    super._callObserver(e, A), qw(this, e, new sq(this, e));
  }
  /**
   * Inserts new content at an index.
   *
   * Important: This function expects an array of content. Not just a content
   * object. The reason for this "weirdness" is that inserting several elements
   * is very efficient when it is done as a single operation.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  yarray.insert(0, ['a'])
   *  // Insert numbers 1, 2 at position 1
   *  yarray.insert(1, [1, 2])
   *
   * @param {number} index The index to insert content at.
   * @param {Array<T>} content The array of content
   */
  insert(e, A) {
    this.doc !== null ? Rt(this.doc, (n) => {
      Ab(
        n,
        this,
        e,
        /** @type {any} */
        A
      );
    }) : this._prelimContent.splice(e, 0, ...A);
  }
  /**
   * Appends content to this YArray.
   *
   * @param {Array<T>} content Array of content to append.
   *
   * @todo Use the following implementation in all types.
   */
  push(e) {
    this.doc !== null ? Rt(this.doc, (A) => {
      Aq(
        A,
        this,
        /** @type {any} */
        e
      );
    }) : this._prelimContent.push(...e);
  }
  /**
   * Prepends content to this YArray.
   *
   * @param {Array<T>} content Array of content to prepend.
   */
  unshift(e) {
    this.insert(0, e);
  }
  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} length The number of elements to remove. Defaults to 1.
   */
  delete(e, A = 1) {
    this.doc !== null ? Rt(this.doc, (n) => {
      nb(n, this, e, A);
    }) : this._prelimContent.splice(e, A);
  }
  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {T}
   */
  get(e) {
    return eb(this, e);
  }
  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<T>}
   */
  toArray() {
    return qU(this);
  }
  /**
   * Returns a portion of this YArray into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<T>}
   */
  slice(e = 0, A = this.length) {
    return ZU(this, e, A);
  }
  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Array<any>}
   */
  toJSON() {
    return this.map((e) => e instanceof HA ? e.toJSON() : e);
  }
  /**
   * Returns an Array with the result of calling a provided function on every
   * element of this YArray.
   *
   * @template M
   * @param {function(T,number,YArray<T>):M} f Function that produces an element of the new Array
   * @return {Array<M>} A new array with each element being the result of the
   *                 callback function
   */
  map(e) {
    return $U(
      this,
      /** @type {any} */
      e
    );
  }
  /**
   * Executes a provided function once on every element of this YArray.
   *
   * @param {function(T,number,YArray<T>):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    Pg(this, e);
  }
  /**
   * @return {IterableIterator<T>}
   */
  [Symbol.iterator]() {
    return tq(this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(Dq);
  }
}
const rq = (t) => new Ds();
class iq extends Xw {
  /**
   * @param {YMap<T>} ymap The YArray that changed.
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed.
   */
  constructor(e, A, n) {
    super(e, A), this.keysChanged = n;
  }
}
class jr extends HA {
  /**
   *
   * @param {Iterable<readonly [string, any]>=} entries - an optional iterable to initialize the YMap
   */
  constructor(e) {
    super(), this._prelimContent = null, e === void 0 ? this._prelimContent = /* @__PURE__ */ new Map() : this._prelimContent = new Map(e);
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, A) {
    super._integrate(e, A), this._prelimContent.forEach((n, s) => {
      this.set(s, n);
    }), this._prelimContent = null;
  }
  /**
   * @return {YMap<MapType>}
   */
  _copy() {
    return new jr();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YMap<MapType>}
   */
  clone() {
    const e = new jr();
    return this.forEach((A, n) => {
      e.set(n, A instanceof HA ? (
        /** @type {typeof value} */
        A.clone()
      ) : A);
    }), e;
  }
  /**
   * Creates YMapEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, A) {
    qw(this, e, new iq(this, e, A));
  }
  /**
   * Transforms this Shared Type to a JSON object.
   *
   * @return {Object<string,any>}
   */
  toJSON() {
    this.doc ?? on();
    const e = {};
    return this._map.forEach((A, n) => {
      if (!A.deleted) {
        const s = A.content.getContent()[A.length - 1];
        e[n] = s instanceof HA ? s.toJSON() : s;
      }
    }), e;
  }
  /**
   * Returns the size of the YMap (count of key/value pairs)
   *
   * @return {number}
   */
  get size() {
    return [...f0(this)].length;
  }
  /**
   * Returns the keys for each element in the YMap Type.
   *
   * @return {IterableIterator<string>}
   */
  keys() {
    return ZQ(
      f0(this),
      /** @param {any} v */
      (e) => e[0]
    );
  }
  /**
   * Returns the values for each element in the YMap Type.
   *
   * @return {IterableIterator<MapType>}
   */
  values() {
    return ZQ(
      f0(this),
      /** @param {any} v */
      (e) => e[1].content.getContent()[e[1].length - 1]
    );
  }
  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */
  entries() {
    return ZQ(
      f0(this),
      /** @param {any} v */
      (e) => (
        /** @type {any} */
        [e[0], e[1].content.getContent()[e[1].length - 1]]
      )
    );
  }
  /**
   * Executes a provided function on once on every key-value pair.
   *
   * @param {function(MapType,string,YMap<MapType>):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    this.doc ?? on(), this._map.forEach((A, n) => {
      A.deleted || e(A.content.getContent()[A.length - 1], n, this);
    });
  }
  /**
   * Returns an Iterator of [key, value] pairs
   *
   * @return {IterableIterator<[string, MapType]>}
   */
  [Symbol.iterator]() {
    return this.entries();
  }
  /**
   * Remove a specified element from this YMap.
   *
   * @param {string} key The key of the element to remove.
   */
  delete(e) {
    this.doc !== null ? Rt(this.doc, (A) => {
      bd(A, this, e);
    }) : this._prelimContent.delete(e);
  }
  /**
   * Adds or updates an element with a specified key and value.
   * @template {MapType} VAL
   *
   * @param {string} key The key of the element to add to this YMap
   * @param {VAL} value The value of the element to add
   * @return {VAL}
   */
  set(e, A) {
    return this.doc !== null ? Rt(this.doc, (n) => {
      tm(
        n,
        this,
        e,
        /** @type {any} */
        A
      );
    }) : this._prelimContent.set(e, A), A;
  }
  /**
   * Returns a specified element from this YMap.
   *
   * @param {string} key
   * @return {MapType|undefined}
   */
  get(e) {
    return (
      /** @type {any} */
      Am(this, e)
    );
  }
  /**
   * Returns a boolean indicating whether the specified key exists or not.
   *
   * @param {string} key The key to test.
   * @return {boolean}
   */
  has(e) {
    return rb(this, e);
  }
  /**
   * Removes all elements from this YMap.
   */
  clear() {
    this.doc !== null ? Rt(this.doc, (e) => {
      this.forEach(function(A, n, s) {
        bd(e, s, n);
      });
    }) : this._prelimContent.clear();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(xq);
  }
}
const oq = (t) => new jr(), jo = (t, e) => t === e || typeof t == "object" && typeof e == "object" && t && e && BX(t, e);
class CE {
  /**
   * @param {Item|null} left
   * @param {Item|null} right
   * @param {number} index
   * @param {Map<string,any>} currentAttributes
   */
  constructor(e, A, n, s) {
    this.left = e, this.right = A, this.index = n, this.currentAttributes = s;
  }
  /**
   * Only call this if you know that this.right is defined
   */
  forward() {
    switch (this.right === null && ln(), this.right.content.constructor) {
      case pA:
        this.right.deleted || Pl(
          this.currentAttributes,
          /** @type {ContentFormat} */
          this.right.content
        );
        break;
      default:
        this.right.deleted || (this.index += this.right.length);
        break;
    }
    this.left = this.right, this.right = this.right.right;
  }
}
const gF = (t, e, A) => {
  for (; e.right !== null && A > 0; ) {
    switch (e.right.content.constructor) {
      case pA:
        e.right.deleted || Pl(
          e.currentAttributes,
          /** @type {ContentFormat} */
          e.right.content
        );
        break;
      default:
        e.right.deleted || (A < e.right.length && Vn(t, At(e.right.id.client, e.right.id.clock + A)), e.index += e.right.length, A -= e.right.length);
        break;
    }
    e.left = e.right, e.right = e.right.right;
  }
  return e;
}, Q0 = (t, e, A, n) => {
  const s = /* @__PURE__ */ new Map(), r = n ? Zw(e, A) : null;
  if (r) {
    const i = new CE(r.p.left, r.p, r.index, s);
    return gF(t, i, A - r.index);
  } else {
    const i = new CE(null, e._start, 0, s);
    return gF(t, i, A);
  }
}, ib = (t, e, A, n) => {
  for (; A.right !== null && (A.right.deleted === !0 || A.right.content.constructor === pA && jo(
    n.get(
      /** @type {ContentFormat} */
      A.right.content.key
    ),
    /** @type {ContentFormat} */
    A.right.content.value
  )); )
    A.right.deleted || n.delete(
      /** @type {ContentFormat} */
      A.right.content.key
    ), A.forward();
  const s = t.doc, r = s.clientID;
  n.forEach((i, o) => {
    const a = A.left, c = A.right, l = new jt(At(r, uA(s.store, r)), a, a && a.lastId, c, c && c.id, e, null, new pA(o, i));
    l.integrate(t, 0), A.right = l, A.forward();
  });
}, Pl = (t, e) => {
  const { key: A, value: n } = e;
  n === null ? t.delete(A) : t.set(A, n);
}, ob = (t, e) => {
  for (; t.right !== null; ) {
    if (!(t.right.deleted || t.right.content.constructor === pA && jo(
      e[
        /** @type {ContentFormat} */
        t.right.content.key
      ] ?? null,
      /** @type {ContentFormat} */
      t.right.content.value
    ))) break;
    t.forward();
  }
}, ab = (t, e, A, n) => {
  const s = t.doc, r = s.clientID, i = /* @__PURE__ */ new Map();
  for (const o in n) {
    const a = n[o], c = A.currentAttributes.get(o) ?? null;
    if (!jo(c, a)) {
      i.set(o, c);
      const { left: l, right: B } = A;
      A.right = new jt(At(r, uA(s.store, r)), l, l && l.lastId, B, B && B.id, e, null, new pA(o, a)), A.right.integrate(t, 0), A.forward();
    }
  }
  return i;
}, $Q = (t, e, A, n, s) => {
  A.currentAttributes.forEach((g, h) => {
    s[h] === void 0 && (s[h] = null);
  });
  const r = t.doc, i = r.clientID;
  ob(A, s);
  const o = ab(t, e, A, s), a = n.constructor === String ? new Br(
    /** @type {string} */
    n
  ) : n instanceof HA ? new hr(n) : new Bc(n);
  let { left: c, right: l, index: B } = A;
  e._searchMarker && Og(e._searchMarker, A.index, a.getLength()), l = new jt(At(i, uA(r.store, i)), c, c && c.lastId, l, l && l.id, e, null, a), l.integrate(t, 0), A.right = l, A.index = B, A.forward(), ib(t, e, A, o);
}, hF = (t, e, A, n, s) => {
  const r = t.doc, i = r.clientID;
  ob(A, s);
  const o = ab(t, e, A, s);
  e: for (; A.right !== null && (n > 0 || o.size > 0 && (A.right.deleted || A.right.content.constructor === pA)); ) {
    if (!A.right.deleted)
      switch (A.right.content.constructor) {
        case pA: {
          const { key: a, value: c } = (
            /** @type {ContentFormat} */
            A.right.content
          ), l = s[a];
          if (l !== void 0) {
            if (jo(l, c))
              o.delete(a);
            else {
              if (n === 0)
                break e;
              o.set(a, c);
            }
            A.right.delete(t);
          } else
            A.currentAttributes.set(a, c);
          break;
        }
        default:
          n < A.right.length && Vn(t, At(A.right.id.client, A.right.id.clock + n)), n -= A.right.length;
          break;
      }
    A.forward();
  }
  if (n > 0) {
    let a = "";
    for (; n > 0; n--)
      a += `
`;
    A.right = new jt(At(i, uA(r.store, i)), A.left, A.left && A.left.lastId, A.right, A.right && A.right.id, e, null, new Br(a)), A.right.integrate(t, 0), A.forward();
  }
  ib(t, e, A, o);
}, cb = (t, e, A, n, s) => {
  let r = e;
  const i = Hs();
  for (; r && (!r.countable || r.deleted); ) {
    if (!r.deleted && r.content.constructor === pA) {
      const c = (
        /** @type {ContentFormat} */
        r.content
      );
      i.set(c.key, c);
    }
    r = r.right;
  }
  let o = 0, a = !1;
  for (; e !== r; ) {
    if (A === e && (a = !0), !e.deleted) {
      const c = e.content;
      switch (c.constructor) {
        case pA: {
          const { key: l, value: B } = (
            /** @type {ContentFormat} */
            c
          ), g = n.get(l) ?? null;
          (i.get(l) !== c || g === B) && (e.delete(t), o++, !a && (s.get(l) ?? null) === B && g !== B && (g === null ? s.delete(l) : s.set(l, g))), !a && !e.deleted && Pl(
            s,
            /** @type {ContentFormat} */
            c
          );
          break;
        }
      }
    }
    e = /** @type {Item} */
    e.right;
  }
  return o;
}, aq = (t, e) => {
  for (; e && e.right && (e.right.deleted || !e.right.countable); )
    e = e.right;
  const A = /* @__PURE__ */ new Set();
  for (; e && (e.deleted || !e.countable); ) {
    if (!e.deleted && e.content.constructor === pA) {
      const n = (
        /** @type {ContentFormat} */
        e.content.key
      );
      A.has(n) ? e.delete(t) : A.add(n);
    }
    e = e.left;
  }
}, cq = (t) => {
  let e = 0;
  return Rt(
    /** @type {Doc} */
    t.doc,
    (A) => {
      let n = (
        /** @type {Item} */
        t._start
      ), s = t._start, r = Hs();
      const i = BE(r);
      for (; s; ) {
        if (s.deleted === !1)
          switch (s.content.constructor) {
            case pA:
              Pl(
                i,
                /** @type {ContentFormat} */
                s.content
              );
              break;
            default:
              e += cb(A, n, s, r, i), r = BE(i), n = s;
              break;
          }
        s = s.right;
      }
    }
  ), e;
}, lq = (t) => {
  const e = /* @__PURE__ */ new Set(), A = t.doc;
  for (const [n, s] of t.afterState.entries()) {
    const r = t.beforeState.get(n) || 0;
    s !== r && WU(
      t,
      /** @type {Array<Item|GC>} */
      A.store.clients.get(n),
      r,
      s,
      (i) => {
        !i.deleted && /** @type {Item} */
        i.content.constructor === pA && i.constructor !== ys && e.add(
          /** @type {any} */
          i.parent
        );
      }
    );
  }
  Rt(A, (n) => {
    $o(t, t.deleteSet, (s) => {
      if (s instanceof ys || !/** @type {YText} */
      s.parent._hasFormatting || e.has(
        /** @type {YText} */
        s.parent
      ))
        return;
      const r = (
        /** @type {YText} */
        s.parent
      );
      s.content.constructor === pA ? e.add(r) : aq(n, s);
    });
    for (const s of e)
      cq(s);
  });
}, uF = (t, e, A) => {
  const n = A, s = BE(e.currentAttributes), r = e.right;
  for (; A > 0 && e.right !== null; ) {
    if (e.right.deleted === !1)
      switch (e.right.content.constructor) {
        case hr:
        case Bc:
        case Br:
          A < e.right.length && Vn(t, At(e.right.id.client, e.right.id.clock + A)), A -= e.right.length, e.right.delete(t);
          break;
      }
    e.forward();
  }
  r && cb(t, r, e.right, s, e.currentAttributes);
  const i = (
    /** @type {AbstractType<any>} */
    /** @type {Item} */
    (e.left || e.right).parent
  );
  return i._searchMarker && Og(i._searchMarker, e.index, -n + A), e;
};
class Bq extends Xw {
  /**
   * @param {YText} ytext
   * @param {Transaction} transaction
   * @param {Set<any>} subs The keys that changed
   */
  constructor(e, A, n) {
    super(e, A), this.childListChanged = !1, this.keysChanged = /* @__PURE__ */ new Set(), n.forEach((s) => {
      s === null ? this.childListChanged = !0 : this.keysChanged.add(s);
    });
  }
  /**
   * @type {{added:Set<Item>,deleted:Set<Item>,keys:Map<string,{action:'add'|'update'|'delete',oldValue:any}>,delta:Array<{insert?:Array<any>|string, delete?:number, retain?:number}>}}
   */
  get changes() {
    if (this._changes === null) {
      const e = {
        keys: this.keys,
        delta: this.delta,
        added: /* @__PURE__ */ new Set(),
        deleted: /* @__PURE__ */ new Set()
      };
      this._changes = e;
    }
    return (
      /** @type {any} */
      this._changes
    );
  }
  /**
   * Compute the changes in the delta format.
   * A {@link https://quilljs.com/docs/delta/|Quill Delta}) that represents the changes on the document.
   *
   * @type {Array<{insert?:string|object|AbstractType<any>, delete?:number, retain?:number, attributes?: Object<string,any>}>}
   *
   * @public
   */
  get delta() {
    if (this._delta === null) {
      const e = (
        /** @type {Doc} */
        this.target.doc
      ), A = [];
      Rt(e, (n) => {
        const s = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
        let i = this.target._start, o = null;
        const a = {};
        let c = "", l = 0, B = 0;
        const g = () => {
          if (o !== null) {
            let h = null;
            switch (o) {
              case "delete":
                B > 0 && (h = { delete: B }), B = 0;
                break;
              case "insert":
                (typeof c == "object" || c.length > 0) && (h = { insert: c }, s.size > 0 && (h.attributes = {}, s.forEach((u, d) => {
                  u !== null && (h.attributes[d] = u);
                }))), c = "";
                break;
              case "retain":
                l > 0 && (h = { retain: l }, lX(a) || (h.attributes = aX({}, a))), l = 0;
                break;
            }
            h && A.push(h), o = null;
          }
        };
        for (; i !== null; ) {
          switch (i.content.constructor) {
            case hr:
            case Bc:
              this.adds(i) ? this.deletes(i) || (g(), o = "insert", c = i.content.getContent()[0], g()) : this.deletes(i) ? (o !== "delete" && (g(), o = "delete"), B += 1) : i.deleted || (o !== "retain" && (g(), o = "retain"), l += 1);
              break;
            case Br:
              this.adds(i) ? this.deletes(i) || (o !== "insert" && (g(), o = "insert"), c += /** @type {ContentString} */
              i.content.str) : this.deletes(i) ? (o !== "delete" && (g(), o = "delete"), B += i.length) : i.deleted || (o !== "retain" && (g(), o = "retain"), l += i.length);
              break;
            case pA: {
              const { key: h, value: u } = (
                /** @type {ContentFormat} */
                i.content
              );
              if (this.adds(i)) {
                if (!this.deletes(i)) {
                  const d = s.get(h) ?? null;
                  jo(d, u) ? u !== null && i.delete(n) : (o === "retain" && g(), jo(u, r.get(h) ?? null) ? delete a[h] : a[h] = u);
                }
              } else if (this.deletes(i)) {
                r.set(h, u);
                const d = s.get(h) ?? null;
                jo(d, u) || (o === "retain" && g(), a[h] = d);
              } else if (!i.deleted) {
                r.set(h, u);
                const d = a[h];
                d !== void 0 && (jo(d, u) ? d !== null && i.delete(n) : (o === "retain" && g(), u === null ? delete a[h] : a[h] = u));
              }
              i.deleted || (o === "insert" && g(), Pl(
                s,
                /** @type {ContentFormat} */
                i.content
              ));
              break;
            }
          }
          i = i.right;
        }
        for (g(); A.length > 0; ) {
          const h = A[A.length - 1];
          if (h.retain !== void 0 && h.attributes === void 0)
            A.pop();
          else
            break;
        }
      }), this._delta = A;
    }
    return (
      /** @type {any} */
      this._delta
    );
  }
}
class ta extends HA {
  /**
   * @param {String} [string] The initial value of the YText.
   */
  constructor(e) {
    super(), this._pending = e !== void 0 ? [() => this.insert(0, e)] : [], this._searchMarker = [], this._hasFormatting = !1;
  }
  /**
   * Number of characters of this text type.
   *
   * @type {number}
   */
  get length() {
    return this.doc ?? on(), this._length;
  }
  /**
   * @param {Doc} y
   * @param {Item} item
   */
  _integrate(e, A) {
    super._integrate(e, A);
    try {
      this._pending.forEach((n) => n());
    } catch (n) {
      console.error(n);
    }
    this._pending = null;
  }
  _copy() {
    return new ta();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YText}
   */
  clone() {
    const e = new ta();
    return e.applyDelta(this.toDelta()), e;
  }
  /**
   * Creates YTextEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, A) {
    super._callObserver(e, A);
    const n = new Bq(this, e, A);
    qw(this, e, n), !e.local && this._hasFormatting && (e._needFormattingCleanup = !0);
  }
  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @public
   */
  toString() {
    this.doc ?? on();
    let e = "", A = this._start;
    for (; A !== null; )
      !A.deleted && A.countable && A.content.constructor === Br && (e += /** @type {ContentString} */
      A.content.str), A = A.right;
    return e;
  }
  /**
   * Returns the unformatted string representation of this YText type.
   *
   * @return {string}
   * @public
   */
  toJSON() {
    return this.toString();
  }
  /**
   * Apply a {@link Delta} on this shared YText type.
   *
   * @param {Array<any>} delta The changes to apply on this element.
   * @param {object}  opts
   * @param {boolean} [opts.sanitize] Sanitize input delta. Removes ending newlines if set to true.
   *
   *
   * @public
   */
  applyDelta(e, { sanitize: A = !0 } = {}) {
    this.doc !== null ? Rt(this.doc, (n) => {
      const s = new CE(null, this._start, 0, /* @__PURE__ */ new Map());
      for (let r = 0; r < e.length; r++) {
        const i = e[r];
        if (i.insert !== void 0) {
          const o = !A && typeof i.insert == "string" && r === e.length - 1 && s.right === null && i.insert.slice(-1) === `
` ? i.insert.slice(0, -1) : i.insert;
          (typeof o != "string" || o.length > 0) && $Q(n, this, s, o, i.attributes || {});
        } else i.retain !== void 0 ? hF(n, this, s, i.retain, i.attributes || {}) : i.delete !== void 0 && uF(n, s, i.delete);
      }
    }) : this._pending.push(() => this.applyDelta(e));
  }
  /**
   * Returns the Delta representation of this YText type.
   *
   * @param {Snapshot} [snapshot]
   * @param {Snapshot} [prevSnapshot]
   * @param {function('removed' | 'added', ID):any} [computeYChange]
   * @return {any} The Delta representation of this type.
   *
   * @public
   */
  toDelta(e, A, n) {
    this.doc ?? on();
    const s = [], r = /* @__PURE__ */ new Map(), i = (
      /** @type {Doc} */
      this.doc
    );
    let o = "", a = this._start;
    function c() {
      if (o.length > 0) {
        const B = {};
        let g = !1;
        r.forEach((u, d) => {
          g = !0, B[d] = u;
        });
        const h = { insert: o };
        g && (h.attributes = B), s.push(h), o = "";
      }
    }
    const l = () => {
      for (; a !== null; ) {
        if (Ua(a, e) || A !== void 0 && Ua(a, A))
          switch (a.content.constructor) {
            case Br: {
              const B = r.get("ychange");
              e !== void 0 && !Ua(a, e) ? (B === void 0 || B.user !== a.id.client || B.type !== "removed") && (c(), r.set("ychange", n ? n("removed", a.id) : { type: "removed" })) : A !== void 0 && !Ua(a, A) ? (B === void 0 || B.user !== a.id.client || B.type !== "added") && (c(), r.set("ychange", n ? n("added", a.id) : { type: "added" })) : B !== void 0 && (c(), r.delete("ychange")), o += /** @type {ContentString} */
              a.content.str;
              break;
            }
            case hr:
            case Bc: {
              c();
              const B = {
                insert: a.content.getContent()[0]
              };
              if (r.size > 0) {
                const g = (
                  /** @type {Object<string,any>} */
                  {}
                );
                B.attributes = g, r.forEach((h, u) => {
                  g[u] = h;
                });
              }
              s.push(B);
              break;
            }
            case pA:
              Ua(a, e) && (c(), Pl(
                r,
                /** @type {ContentFormat} */
                a.content
              ));
              break;
          }
        a = a.right;
      }
      c();
    };
    return e || A ? Rt(i, (B) => {
      e && QE(B, e), A && QE(B, A), l();
    }, "cleanup") : l(), s;
  }
  /**
   * Insert text at a given index.
   *
   * @param {number} index The index at which to start inserting.
   * @param {String} text The text to insert at the specified position.
   * @param {TextAttributes} [attributes] Optionally define some formatting
   *                                    information to apply on the inserted
   *                                    Text.
   * @public
   */
  insert(e, A, n) {
    if (A.length <= 0)
      return;
    const s = this.doc;
    s !== null ? Rt(s, (r) => {
      const i = Q0(r, this, e, !n);
      n || (n = {}, i.currentAttributes.forEach((o, a) => {
        n[a] = o;
      })), $Q(r, this, i, A, n);
    }) : this._pending.push(() => this.insert(e, A, n));
  }
  /**
   * Inserts an embed at a index.
   *
   * @param {number} index The index to insert the embed at.
   * @param {Object | AbstractType<any>} embed The Object that represents the embed.
   * @param {TextAttributes} [attributes] Attribute information to apply on the
   *                                    embed
   *
   * @public
   */
  insertEmbed(e, A, n) {
    const s = this.doc;
    s !== null ? Rt(s, (r) => {
      const i = Q0(r, this, e, !n);
      $Q(r, this, i, A, n || {});
    }) : this._pending.push(() => this.insertEmbed(e, A, n || {}));
  }
  /**
   * Deletes text starting from an index.
   *
   * @param {number} index Index at which to start deleting.
   * @param {number} length The number of characters to remove. Defaults to 1.
   *
   * @public
   */
  delete(e, A) {
    if (A === 0)
      return;
    const n = this.doc;
    n !== null ? Rt(n, (s) => {
      uF(s, Q0(s, this, e, !0), A);
    }) : this._pending.push(() => this.delete(e, A));
  }
  /**
   * Assigns properties to a range of text.
   *
   * @param {number} index The position where to start formatting.
   * @param {number} length The amount of characters to assign properties to.
   * @param {TextAttributes} attributes Attribute information to apply on the
   *                                    text.
   *
   * @public
   */
  format(e, A, n) {
    if (A === 0)
      return;
    const s = this.doc;
    s !== null ? Rt(s, (r) => {
      const i = Q0(r, this, e, !1);
      i.right !== null && hF(r, this, i, A, n);
    }) : this._pending.push(() => this.format(e, A, n));
  }
  /**
   * Removes an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute(e) {
    this.doc !== null ? Rt(this.doc, (A) => {
      bd(A, this, e);
    }) : this._pending.push(() => this.removeAttribute(e));
  }
  /**
   * Sets or updates an attribute.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that is to be set.
   * @param {any} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute(e, A) {
    this.doc !== null ? Rt(this.doc, (n) => {
      tm(n, this, e, A);
    }) : this._pending.push(() => this.setAttribute(e, A));
  }
  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @param {String} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {any} The queried attribute value.
   *
   * @public
   */
  getAttribute(e) {
    return (
      /** @type {any} */
      Am(this, e)
    );
  }
  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @note Xml-Text nodes don't have attributes. You can use this feature to assign properties to complete text-blocks.
   *
   * @return {Object<string, any>} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes() {
    return sb(this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(Gq);
  }
}
const gq = (t) => new ta();
class eI {
  /**
   * @param {YXmlFragment | YXmlElement} root
   * @param {function(AbstractType<any>):boolean} [f]
   */
  constructor(e, A = () => !0) {
    this._filter = A, this._root = e, this._currentNode = /** @type {Item} */
    e._start, this._firstCall = !0, e.doc ?? on();
  }
  [Symbol.iterator]() {
    return this;
  }
  /**
   * Get the next node.
   *
   * @return {IteratorResult<YXmlElement|YXmlText|YXmlHook>} The next node.
   *
   * @public
   */
  next() {
    let e = this._currentNode, A = e && e.content && /** @type {any} */
    e.content.type;
    if (e !== null && (!this._firstCall || e.deleted || !this._filter(A)))
      do
        if (A = /** @type {any} */
        e.content.type, !e.deleted && (A.constructor === sn || A.constructor === nc) && A._start !== null)
          e = A._start;
        else
          for (; e !== null; ) {
            const n = e.next;
            if (n !== null) {
              e = n;
              break;
            } else e.parent === this._root ? e = null : e = /** @type {AbstractType<any>} */
            e.parent._item;
          }
      while (e !== null && (e.deleted || !this._filter(
        /** @type {ContentType} */
        e.content.type
      )));
    return this._firstCall = !1, e === null ? { value: void 0, done: !0 } : (this._currentNode = e, { value: (
      /** @type {any} */
      e.content.type
    ), done: !1 });
  }
}
class nc extends HA {
  constructor() {
    super(), this._prelimContent = [];
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get firstChild() {
    const e = this._first;
    return e ? e.content.getContent()[0] : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, A) {
    super._integrate(e, A), this.insert(
      0,
      /** @type {Array<any>} */
      this._prelimContent
    ), this._prelimContent = null;
  }
  _copy() {
    return new nc();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlFragment}
   */
  clone() {
    const e = new nc();
    return e.insert(0, this.toArray().map((A) => A instanceof HA ? A.clone() : A)), e;
  }
  get length() {
    return this.doc ?? on(), this._prelimContent === null ? this._length : this._prelimContent.length;
  }
  /**
   * Create a subtree of childNodes.
   *
   * @example
   * const walker = elem.createTreeWalker(dom => dom.nodeName === 'div')
   * for (let node in walker) {
   *   // `node` is a div node
   *   nop(node)
   * }
   *
   * @param {function(AbstractType<any>):boolean} filter Function that is called on each child element and
   *                          returns a Boolean indicating whether the child
   *                          is to be included in the subtree.
   * @return {YXmlTreeWalker} A subtree and a position within it.
   *
   * @public
   */
  createTreeWalker(e) {
    return new eI(this, e);
  }
  /**
   * Returns the first YXmlElement that matches the query.
   * Similar to DOM's {@link querySelector}.
   *
   * Query support:
   *   - tagname
   * TODO:
   *   - id
   *   - attribute
   *
   * @param {CSS_Selector} query The query on the children.
   * @return {YXmlElement|YXmlText|YXmlHook|null} The first element that matches the query or null.
   *
   * @public
   */
  querySelector(e) {
    e = e.toUpperCase();
    const n = new eI(this, (s) => s.nodeName && s.nodeName.toUpperCase() === e).next();
    return n.done ? null : n.value;
  }
  /**
   * Returns all YXmlElements that match the query.
   * Similar to Dom's {@link querySelectorAll}.
   *
   * @todo Does not yet support all queries. Currently only query by tagName.
   *
   * @param {CSS_Selector} query The query on the children
   * @return {Array<YXmlElement|YXmlText|YXmlHook|null>} The elements that match this query.
   *
   * @public
   */
  querySelectorAll(e) {
    return e = e.toUpperCase(), qo(new eI(this, (A) => A.nodeName && A.nodeName.toUpperCase() === e));
  }
  /**
   * Creates YXmlEvent and calls observers.
   *
   * @param {Transaction} transaction
   * @param {Set<null|string>} parentSubs Keys changed on this type. `null` if list was modified.
   */
  _callObserver(e, A) {
    qw(this, e, new dq(this, A, e));
  }
  /**
   * Get the string representation of all the children of this YXmlFragment.
   *
   * @return {string} The string representation of all children.
   */
  toString() {
    return $U(this, (e) => e.toString()).join("");
  }
  /**
   * @return {string}
   */
  toJSON() {
    return this.toString();
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, A = {}, n) {
    const s = e.createDocumentFragment();
    return n !== void 0 && n._createAssociation(s, this), Pg(this, (r) => {
      s.insertBefore(r.toDOM(e, A, n), null);
    }), s;
  }
  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {number} index The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insert(e, A) {
    this.doc !== null ? Rt(this.doc, (n) => {
      Ab(n, this, e, A);
    }) : this._prelimContent.splice(e, 0, ...A);
  }
  /**
   * Inserts new content at an index.
   *
   * @example
   *  // Insert character 'a' at position 0
   *  xml.insert(0, [new Y.XmlText('text')])
   *
   * @param {null|Item|YXmlElement|YXmlText} ref The index to insert content at
   * @param {Array<YXmlElement|YXmlText>} content The array of content
   */
  insertAfter(e, A) {
    if (this.doc !== null)
      Rt(this.doc, (n) => {
        const s = e && e instanceof HA ? e._item : e;
        Ud(n, this, s, A);
      });
    else {
      const n = (
        /** @type {Array<any>} */
        this._prelimContent
      ), s = e === null ? 0 : n.findIndex((r) => r === e) + 1;
      if (s === 0 && e !== null)
        throw Wr("Reference item not found");
      n.splice(s, 0, ...A);
    }
  }
  /**
   * Deletes elements starting from an index.
   *
   * @param {number} index Index at which to start deleting elements
   * @param {number} [length=1] The number of elements to remove. Defaults to 1.
   */
  delete(e, A = 1) {
    this.doc !== null ? Rt(this.doc, (n) => {
      nb(n, this, e, A);
    }) : this._prelimContent.splice(e, A);
  }
  /**
   * Transforms this YArray to a JavaScript Array.
   *
   * @return {Array<YXmlElement|YXmlText|YXmlHook>}
   */
  toArray() {
    return qU(this);
  }
  /**
   * Appends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to append.
   */
  push(e) {
    this.insert(this.length, e);
  }
  /**
   * Prepends content to this YArray.
   *
   * @param {Array<YXmlElement|YXmlText>} content Array of content to prepend.
   */
  unshift(e) {
    this.insert(0, e);
  }
  /**
   * Returns the i-th element from a YArray.
   *
   * @param {number} index The index of the element to return from the YArray
   * @return {YXmlElement|YXmlText}
   */
  get(e) {
    return eb(this, e);
  }
  /**
   * Returns a portion of this YXmlFragment into a JavaScript Array selected
   * from start to end (end not included).
   *
   * @param {number} [start]
   * @param {number} [end]
   * @return {Array<YXmlElement|YXmlText>}
   */
  slice(e = 0, A = this.length) {
    return ZU(this, e, A);
  }
  /**
   * Executes a provided function on once on every child element.
   *
   * @param {function(YXmlElement|YXmlText,number, typeof self):void} f A function to execute on every element of this YArray.
   */
  forEach(e) {
    Pg(this, e);
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(Uq);
  }
}
const hq = (t) => new nc();
class sn extends nc {
  constructor(e = "UNDEFINED") {
    super(), this.nodeName = e, this._prelimAttrs = /* @__PURE__ */ new Map();
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling() {
    const e = this._item ? this._item.next : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling() {
    const e = this._item ? this._item.prev : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * Integrate this type into the Yjs instance.
   *
   * * Save this struct in the os
   * * This type is sent to other client
   * * Observer functions are fired
   *
   * @param {Doc} y The Yjs instance
   * @param {Item} item
   */
  _integrate(e, A) {
    super._integrate(e, A), /** @type {Map<string, any>} */
    this._prelimAttrs.forEach((n, s) => {
      this.setAttribute(s, n);
    }), this._prelimAttrs = null;
  }
  /**
   * Creates an Item with the same effect as this Item (without position effect)
   *
   * @return {YXmlElement}
   */
  _copy() {
    return new sn(this.nodeName);
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlElement<KV>}
   */
  clone() {
    const e = new sn(this.nodeName), A = this.getAttributes();
    return cX(A, (n, s) => {
      e.setAttribute(
        s,
        /** @type {any} */
        n
      );
    }), e.insert(0, this.toArray().map((n) => n instanceof HA ? n.clone() : n)), e;
  }
  /**
   * Returns the XML serialization of this YXmlElement.
   * The attributes are ordered by attribute-name, so you can easily use this
   * method to compare YXmlElements
   *
   * @return {string} The string representation of this type.
   *
   * @public
   */
  toString() {
    const e = this.getAttributes(), A = [], n = [];
    for (const o in e)
      n.push(o);
    n.sort();
    const s = n.length;
    for (let o = 0; o < s; o++) {
      const a = n[o];
      A.push(a + '="' + e[a] + '"');
    }
    const r = this.nodeName.toLocaleLowerCase(), i = A.length > 0 ? " " + A.join(" ") : "";
    return `<${r}${i}>${super.toString()}</${r}>`;
  }
  /**
   * Removes an attribute from this YXmlElement.
   *
   * @param {string} attributeName The attribute name that is to be removed.
   *
   * @public
   */
  removeAttribute(e) {
    this.doc !== null ? Rt(this.doc, (A) => {
      bd(A, this, e);
    }) : this._prelimAttrs.delete(e);
  }
  /**
   * Sets or updates an attribute.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that is to be set.
   * @param {KV[KEY]} attributeValue The attribute value that is to be set.
   *
   * @public
   */
  setAttribute(e, A) {
    this.doc !== null ? Rt(this.doc, (n) => {
      tm(n, this, e, A);
    }) : this._prelimAttrs.set(e, A);
  }
  /**
   * Returns an attribute value that belongs to the attribute name.
   *
   * @template {keyof KV & string} KEY
   *
   * @param {KEY} attributeName The attribute name that identifies the
   *                               queried value.
   * @return {KV[KEY]|undefined} The queried attribute value.
   *
   * @public
   */
  getAttribute(e) {
    return (
      /** @type {any} */
      Am(this, e)
    );
  }
  /**
   * Returns whether an attribute exists
   *
   * @param {string} attributeName The attribute name to check for existence.
   * @return {boolean} whether the attribute exists.
   *
   * @public
   */
  hasAttribute(e) {
    return (
      /** @type {any} */
      rb(this, e)
    );
  }
  /**
   * Returns all attribute name/value pairs in a JSON Object.
   *
   * @param {Snapshot} [snapshot]
   * @return {{ [Key in Extract<keyof KV,string>]?: KV[Key]}} A JSON Object that describes the attributes.
   *
   * @public
   */
  getAttributes(e) {
    return (
      /** @type {any} */
      e ? nq(this, e) : sb(this)
    );
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks={}] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Node} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, A = {}, n) {
    const s = e.createElement(this.nodeName), r = this.getAttributes();
    for (const i in r) {
      const o = r[i];
      typeof o == "string" && s.setAttribute(i, o);
    }
    return Pg(this, (i) => {
      s.appendChild(i.toDOM(e, A, n));
    }), n !== void 0 && n._createAssociation(s, this), s;
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(zq), e.writeKey(this.nodeName);
  }
}
const uq = (t) => new sn(t.readKey());
class dq extends Xw {
  /**
   * @param {YXmlElement|YXmlText|YXmlFragment} target The target on which the event is created.
   * @param {Set<string|null>} subs The set of changed attributes. `null` is included if the
   *                   child list changed.
   * @param {Transaction} transaction The transaction instance with which the
   *                                  change was created.
   */
  constructor(e, A, n) {
    super(e, n), this.childListChanged = !1, this.attributesChanged = /* @__PURE__ */ new Set(), A.forEach((s) => {
      s === null ? this.childListChanged = !0 : this.attributesChanged.add(s);
    });
  }
}
class vd extends jr {
  /**
   * @param {string} hookName nodeName of the Dom Node.
   */
  constructor(e) {
    super(), this.hookName = e;
  }
  /**
   * Creates an Item with the same effect as this Item (without position effect)
   */
  _copy() {
    return new vd(this.hookName);
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlHook}
   */
  clone() {
    const e = new vd(this.hookName);
    return this.forEach((A, n) => {
      e.set(n, A);
    }), e;
  }
  /**
   * Creates a Dom Element that mirrors this YXmlElement.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object.<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type
   * @return {Element} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, A = {}, n) {
    const s = A[this.hookName];
    let r;
    return s !== void 0 ? r = s.createDom(this) : r = document.createElement(this.hookName), r.setAttribute("data-yjs-hook", this.hookName), n !== void 0 && n._createAssociation(r, this), r;
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   */
  _write(e) {
    e.writeTypeRef(bq), e.writeKey(this.hookName);
  }
}
const wq = (t) => new vd(t.readKey());
class qn extends ta {
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get nextSibling() {
    const e = this._item ? this._item.next : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  /**
   * @type {YXmlElement|YXmlText|null}
   */
  get prevSibling() {
    const e = this._item ? this._item.prev : null;
    return e ? (
      /** @type {YXmlElement|YXmlText} */
      /** @type {ContentType} */
      e.content.type
    ) : null;
  }
  _copy() {
    return new qn();
  }
  /**
   * Makes a copy of this data type that can be included somewhere else.
   *
   * Note that the content is only readable _after_ it has been included somewhere in the Ydoc.
   *
   * @return {YXmlText}
   */
  clone() {
    const e = new qn();
    return e.applyDelta(this.toDelta()), e;
  }
  /**
   * Creates a Dom Element that mirrors this YXmlText.
   *
   * @param {Document} [_document=document] The document object (you must define
   *                                        this when calling this method in
   *                                        nodejs)
   * @param {Object<string, any>} [hooks] Optional property to customize how hooks
   *                                             are presented in the DOM
   * @param {any} [binding] You should not set this property. This is
   *                               used if DomBinding wants to create a
   *                               association to the created DOM type.
   * @return {Text} The {@link https://developer.mozilla.org/en-US/docs/Web/API/Element|Dom Element}
   *
   * @public
   */
  toDOM(e = document, A, n) {
    const s = e.createTextNode(this.toString());
    return n !== void 0 && n._createAssociation(s, this), s;
  }
  toString() {
    return this.toDelta().map((e) => {
      const A = [];
      for (const s in e.attributes) {
        const r = [];
        for (const i in e.attributes[s])
          r.push({ key: i, value: e.attributes[s][i] });
        r.sort((i, o) => i.key < o.key ? -1 : 1), A.push({ nodeName: s, attrs: r });
      }
      A.sort((s, r) => s.nodeName < r.nodeName ? -1 : 1);
      let n = "";
      for (let s = 0; s < A.length; s++) {
        const r = A[s];
        n += `<${r.nodeName}`;
        for (let i = 0; i < r.attrs.length; i++) {
          const o = r.attrs[i];
          n += ` ${o.key}="${o.value}"`;
        }
        n += ">";
      }
      n += e.insert;
      for (let s = A.length - 1; s >= 0; s--)
        n += `</${A[s].nodeName}>`;
      return n;
    }).join("");
  }
  /**
   * @return {string}
   */
  toJSON() {
    return this.toString();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   */
  _write(e) {
    e.writeTypeRef(vq);
  }
}
const fq = (t) => new qn();
class nm {
  /**
   * @param {ID} id
   * @param {number} length
   */
  constructor(e, A) {
    this.id = e, this.length = A;
  }
  /**
   * @type {boolean}
   */
  get deleted() {
    throw ks();
  }
  /**
   * Merge this struct with the item to the right.
   * This method is already assuming that `this.id.clock + this.length === this.id.clock`.
   * Also this method does *not* remove right from StructStore!
   * @param {AbstractStruct} right
   * @return {boolean} whether this merged with right
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   * @param {number} encodingRef
   */
  write(e, A, n) {
    throw ks();
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, A) {
    throw ks();
  }
}
const Qq = 0;
class ys extends nm {
  get deleted() {
    return !0;
  }
  delete() {
  }
  /**
   * @param {GC} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.constructor !== e.constructor ? !1 : (this.length += e.length, !0);
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, A) {
    A > 0 && (this.id.clock += A, this.length -= A), JU(e.doc.store, this);
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeInfo(Qq), e.writeLen(this.length - A);
  }
  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, A) {
    return null;
  }
}
class Eh {
  /**
   * @param {Uint8Array} content
   */
  constructor(e) {
    this.content = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.content];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentBinary}
   */
  copy() {
    return new Eh(this.content);
  }
  /**
   * @param {number} offset
   * @return {ContentBinary}
   */
  splice(e) {
    throw ks();
  }
  /**
   * @param {ContentBinary} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeBuf(this.content);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 3;
  }
}
const Iq = (t) => new Eh(t.readBuf());
class Kg {
  /**
   * @param {number} len
   */
  constructor(e) {
    this.len = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.len;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !1;
  }
  /**
   * @return {ContentDeleted}
   */
  copy() {
    return new Kg(this.len);
  }
  /**
   * @param {number} offset
   * @return {ContentDeleted}
   */
  splice(e) {
    const A = new Kg(this.len - e);
    return this.len = e, A;
  }
  /**
   * @param {ContentDeleted} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.len += e.len, !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
    Lg(e.deleteSet, A.id.client, A.id.clock, this.len), A.markDeleted();
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeLen(this.len - A);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 1;
  }
}
const Cq = (t) => new Kg(t.readLen()), lb = (t, e) => new no({ guid: t, ...e, shouldLoad: e.shouldLoad || e.autoLoad || !1 });
class Mh {
  /**
   * @param {Doc} doc
   */
  constructor(e) {
    e._item && console.error("This document was already integrated as a sub-document. You should create a second instance instead with the same guid."), this.doc = e;
    const A = {};
    this.opts = A, e.gc || (A.gc = !1), e.autoLoad && (A.autoLoad = !0), e.meta !== null && (A.meta = e.meta);
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.doc];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentDoc}
   */
  copy() {
    return new Mh(lb(this.doc.guid, this.opts));
  }
  /**
   * @param {number} offset
   * @return {ContentDoc}
   */
  splice(e) {
    throw ks();
  }
  /**
   * @param {ContentDoc} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
    this.doc._item = A, e.subdocsAdded.add(this.doc), this.doc.shouldLoad && e.subdocsLoaded.add(this.doc);
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
    e.subdocsAdded.has(this.doc) ? e.subdocsAdded.delete(this.doc) : e.subdocsRemoved.add(this.doc);
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeString(this.doc.guid), e.writeAny(this.opts);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 9;
  }
}
const Eq = (t) => new Mh(lb(t.readString(), t.readAny()));
class Bc {
  /**
   * @param {Object} embed
   */
  constructor(e) {
    this.embed = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.embed];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentEmbed}
   */
  copy() {
    return new Bc(this.embed);
  }
  /**
   * @param {number} offset
   * @return {ContentEmbed}
   */
  splice(e) {
    throw ks();
  }
  /**
   * @param {ContentEmbed} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeJSON(this.embed);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 5;
  }
}
const Mq = (t) => new Bc(t.readJSON());
class pA {
  /**
   * @param {string} key
   * @param {Object} value
   */
  constructor(e, A) {
    this.key = e, this.value = A;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !1;
  }
  /**
   * @return {ContentFormat}
   */
  copy() {
    return new pA(this.key, this.value);
  }
  /**
   * @param {number} _offset
   * @return {ContentFormat}
   */
  splice(e) {
    throw ks();
  }
  /**
   * @param {ContentFormat} _right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} _transaction
   * @param {Item} item
   */
  integrate(e, A) {
    const n = (
      /** @type {YText} */
      A.parent
    );
    n._searchMarker = null, n._hasFormatting = !0;
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeKey(this.key), e.writeJSON(this.value);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 6;
  }
}
const pq = (t) => new pA(t.readKey(), t.readJSON());
class jd {
  /**
   * @param {Array<any>} arr
   */
  constructor(e) {
    this.arr = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.arr.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.arr;
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentJSON}
   */
  copy() {
    return new jd(this.arr);
  }
  /**
   * @param {number} offset
   * @return {ContentJSON}
   */
  splice(e) {
    const A = new jd(this.arr.slice(e));
    return this.arr = this.arr.slice(0, e), A;
  }
  /**
   * @param {ContentJSON} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.arr = this.arr.concat(e.arr), !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    const n = this.arr.length;
    e.writeLen(n - A);
    for (let s = A; s < n; s++) {
      const r = this.arr[s];
      e.writeString(r === void 0 ? "undefined" : JSON.stringify(r));
    }
  }
  /**
   * @return {number}
   */
  getRef() {
    return 2;
  }
}
const mq = (t) => {
  const e = t.readLen(), A = [];
  for (let n = 0; n < e; n++) {
    const s = t.readString();
    s === "undefined" ? A.push(void 0) : A.push(JSON.parse(s));
  }
  return new jd(A);
}, Yq = md("node_env") === "development";
class sc {
  /**
   * @param {Array<any>} arr
   */
  constructor(e) {
    this.arr = e, Yq && oU(e);
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.arr.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.arr;
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentAny}
   */
  copy() {
    return new sc(this.arr);
  }
  /**
   * @param {number} offset
   * @return {ContentAny}
   */
  splice(e) {
    const A = new sc(this.arr.slice(e));
    return this.arr = this.arr.slice(0, e), A;
  }
  /**
   * @param {ContentAny} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.arr = this.arr.concat(e.arr), !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    const n = this.arr.length;
    e.writeLen(n - A);
    for (let s = A; s < n; s++) {
      const r = this.arr[s];
      e.writeAny(r);
    }
  }
  /**
   * @return {number}
   */
  getRef() {
    return 8;
  }
}
const yq = (t) => {
  const e = t.readLen(), A = [];
  for (let n = 0; n < e; n++)
    A.push(t.readAny());
  return new sc(A);
};
class Br {
  /**
   * @param {string} str
   */
  constructor(e) {
    this.str = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return this.str.length;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return this.str.split("");
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentString}
   */
  copy() {
    return new Br(this.str);
  }
  /**
   * @param {number} offset
   * @return {ContentString}
   */
  splice(e) {
    const A = new Br(this.str.slice(e));
    this.str = this.str.slice(0, e);
    const n = this.str.charCodeAt(e - 1);
    return n >= 55296 && n <= 56319 && (this.str = this.str.slice(0, e - 1) + "�", A.str = "�" + A.str.slice(1)), A;
  }
  /**
   * @param {ContentString} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.str += e.str, !0;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeString(A === 0 ? this.str : this.str.slice(A));
  }
  /**
   * @return {number}
   */
  getRef() {
    return 4;
  }
}
const Fq = (t) => new Br(t.readString()), Nq = [
  rq,
  oq,
  gq,
  uq,
  hq,
  wq,
  fq
], Dq = 0, xq = 1, Gq = 2, zq = 3, Uq = 4, bq = 5, vq = 6;
class hr {
  /**
   * @param {AbstractType<any>} type
   */
  constructor(e) {
    this.type = e;
  }
  /**
   * @return {number}
   */
  getLength() {
    return 1;
  }
  /**
   * @return {Array<any>}
   */
  getContent() {
    return [this.type];
  }
  /**
   * @return {boolean}
   */
  isCountable() {
    return !0;
  }
  /**
   * @return {ContentType}
   */
  copy() {
    return new hr(this.type._copy());
  }
  /**
   * @param {number} offset
   * @return {ContentType}
   */
  splice(e) {
    throw ks();
  }
  /**
   * @param {ContentType} right
   * @return {boolean}
   */
  mergeWith(e) {
    return !1;
  }
  /**
   * @param {Transaction} transaction
   * @param {Item} item
   */
  integrate(e, A) {
    this.type._integrate(e.doc, A);
  }
  /**
   * @param {Transaction} transaction
   */
  delete(e) {
    let A = this.type._start;
    for (; A !== null; )
      A.deleted ? A.id.clock < (e.beforeState.get(A.id.client) || 0) && e._mergeStructs.push(A) : A.delete(e), A = A.right;
    this.type._map.forEach((n) => {
      n.deleted ? n.id.clock < (e.beforeState.get(n.id.client) || 0) && e._mergeStructs.push(n) : n.delete(e);
    }), e.changed.delete(this.type);
  }
  /**
   * @param {StructStore} store
   */
  gc(e) {
    let A = this.type._start;
    for (; A !== null; )
      A.gc(e, !0), A = A.right;
    this.type._start = null, this.type._map.forEach(
      /** @param {Item | null} item */
      (n) => {
        for (; n !== null; )
          n.gc(e, !0), n = n.left;
      }
    ), this.type._map = /* @__PURE__ */ new Map();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    this.type._write(e);
  }
  /**
   * @return {number}
   */
  getRef() {
    return 7;
  }
}
const jq = (t) => new hr(Nq[t.readTypeRef()](t)), EE = (t, e) => {
  let A = e, n = 0, s;
  do
    n > 0 && (A = At(A.client, A.clock + n)), s = gl(t, A), n = A.clock - s.id.clock, A = s.redone;
  while (A !== null && s instanceof jt);
  return {
    item: s,
    diff: n
  };
}, sm = (t, e) => {
  for (; t !== null && t.keep !== e; )
    t.keep = e, t = /** @type {AbstractType<any>} */
    t.parent._item;
}, Hd = (t, e, A) => {
  const { client: n, clock: s } = e.id, r = new jt(
    At(n, s + A),
    e,
    At(n, s + A - 1),
    e.right,
    e.rightOrigin,
    e.parent,
    e.parentSub,
    e.content.splice(A)
  );
  return e.deleted && r.markDeleted(), e.keep && (r.keep = !0), e.redone !== null && (r.redone = At(e.redone.client, e.redone.clock + A)), e.right = r, r.right !== null && (r.right.left = r), t._mergeStructs.push(r), r.parentSub !== null && r.right === null && r.parent._map.set(r.parentSub, r), e.length = A, r;
}, dF = (t, e) => Up(
  t,
  /** @param {StackItem} s */
  (A) => lc(A.deletions, e)
), Bb = (t, e, A, n, s, r) => {
  const i = t.doc, o = i.store, a = i.clientID, c = e.redone;
  if (c !== null)
    return Vn(t, c);
  let l = (
    /** @type {AbstractType<any>} */
    e.parent._item
  ), B = null, g;
  if (l !== null && l.deleted === !0) {
    if (l.redone === null && (!A.has(l) || Bb(t, l, A, n, s, r) === null))
      return null;
    for (; l.redone !== null; )
      l = Vn(t, l.redone);
  }
  const h = l === null ? (
    /** @type {AbstractType<any>} */
    e.parent
  ) : (
    /** @type {ContentType} */
    l.content.type
  );
  if (e.parentSub === null) {
    for (B = e.left, g = e; B !== null; ) {
      let Q = B;
      for (; Q !== null && /** @type {AbstractType<any>} */
      Q.parent._item !== l; )
        Q = Q.redone === null ? null : Vn(t, Q.redone);
      if (Q !== null && /** @type {AbstractType<any>} */
      Q.parent._item === l) {
        B = Q;
        break;
      }
      B = B.left;
    }
    for (; g !== null; ) {
      let Q = g;
      for (; Q !== null && /** @type {AbstractType<any>} */
      Q.parent._item !== l; )
        Q = Q.redone === null ? null : Vn(t, Q.redone);
      if (Q !== null && /** @type {AbstractType<any>} */
      Q.parent._item === l) {
        g = Q;
        break;
      }
      g = g.right;
    }
  } else if (g = null, e.right && !s) {
    for (B = e; B !== null && B.right !== null && (B.right.redone || lc(n, B.right.id) || dF(r.undoStack, B.right.id) || dF(r.redoStack, B.right.id)); )
      for (B = B.right; B.redone; ) B = Vn(t, B.redone);
    if (B && B.right !== null)
      return null;
  } else
    B = h._map.get(e.parentSub) || null;
  const u = uA(o, a), d = At(a, u), w = new jt(
    d,
    B,
    B && B.lastId,
    g,
    g && g.id,
    h,
    e.parentSub,
    e.content.copy()
  );
  return e.redone = d, sm(w, !0), w.integrate(t, 0), w;
};
class jt extends nm {
  /**
   * @param {ID} id
   * @param {Item | null} left
   * @param {ID | null} origin
   * @param {Item | null} right
   * @param {ID | null} rightOrigin
   * @param {AbstractType<any>|ID|null} parent Is a type if integrated, is null if it is possible to copy parent from left or right, is ID before integration to search for it.
   * @param {string | null} parentSub
   * @param {AbstractContent} content
   */
  constructor(e, A, n, s, r, i, o, a) {
    super(e, a.getLength()), this.origin = n, this.left = A, this.right = s, this.rightOrigin = r, this.parent = i, this.parentSub = o, this.redone = null, this.content = a, this.info = this.content.isCountable() ? W1 : 0;
  }
  /**
   * This is used to mark the item as an indexed fast-search marker
   *
   * @type {boolean}
   */
  set marker(e) {
    (this.info & OQ) > 0 !== e && (this.info ^= OQ);
  }
  get marker() {
    return (this.info & OQ) > 0;
  }
  /**
   * If true, do not garbage collect this Item.
   */
  get keep() {
    return (this.info & J1) > 0;
  }
  set keep(e) {
    this.keep !== e && (this.info ^= J1);
  }
  get countable() {
    return (this.info & W1) > 0;
  }
  /**
   * Whether this item was deleted or not.
   * @type {Boolean}
   */
  get deleted() {
    return (this.info & WQ) > 0;
  }
  set deleted(e) {
    this.deleted !== e && (this.info ^= WQ);
  }
  markDeleted() {
    this.info |= WQ;
  }
  /**
   * Return the creator clientID of the missing op or define missing items and return null.
   *
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, A) {
    if (this.origin && this.origin.client !== this.id.client && this.origin.clock >= uA(A, this.origin.client))
      return this.origin.client;
    if (this.rightOrigin && this.rightOrigin.client !== this.id.client && this.rightOrigin.clock >= uA(A, this.rightOrigin.client))
      return this.rightOrigin.client;
    if (this.parent && this.parent.constructor === Bl && this.id.client !== this.parent.client && this.parent.clock >= uA(A, this.parent.client))
      return this.parent.client;
    if (this.origin && (this.left = iF(e, A, this.origin), this.origin = this.left.lastId), this.rightOrigin && (this.right = Vn(e, this.rightOrigin), this.rightOrigin = this.right.id), this.left && this.left.constructor === ys || this.right && this.right.constructor === ys)
      this.parent = null;
    else if (!this.parent)
      this.left && this.left.constructor === jt ? (this.parent = this.left.parent, this.parentSub = this.left.parentSub) : this.right && this.right.constructor === jt && (this.parent = this.right.parent, this.parentSub = this.right.parentSub);
    else if (this.parent.constructor === Bl) {
      const n = gl(A, this.parent);
      n.constructor === ys ? this.parent = null : this.parent = /** @type {ContentType} */
      n.content.type;
    }
    return null;
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, A) {
    if (A > 0 && (this.id.clock += A, this.left = iF(e, e.doc.store, At(this.id.client, this.id.clock - 1)), this.origin = this.left.lastId, this.content = this.content.splice(A), this.length -= A), this.parent) {
      if (!this.left && (!this.right || this.right.left !== null) || this.left && this.left.right !== this.right) {
        let n = this.left, s;
        if (n !== null)
          s = n.right;
        else if (this.parentSub !== null)
          for (s = /** @type {AbstractType<any>} */
          this.parent._map.get(this.parentSub) || null; s !== null && s.left !== null; )
            s = s.left;
        else
          s = /** @type {AbstractType<any>} */
          this.parent._start;
        const r = /* @__PURE__ */ new Set(), i = /* @__PURE__ */ new Set();
        for (; s !== null && s !== this.right; ) {
          if (i.add(s), r.add(s), Xc(this.origin, s.origin)) {
            if (s.id.client < this.id.client)
              n = s, r.clear();
            else if (Xc(this.rightOrigin, s.rightOrigin))
              break;
          } else if (s.origin !== null && i.has(gl(e.doc.store, s.origin)))
            r.has(gl(e.doc.store, s.origin)) || (n = s, r.clear());
          else
            break;
          s = s.right;
        }
        this.left = n;
      }
      if (this.left !== null) {
        const n = this.left.right;
        this.right = n, this.left.right = this;
      } else {
        let n;
        if (this.parentSub !== null)
          for (n = /** @type {AbstractType<any>} */
          this.parent._map.get(this.parentSub) || null; n !== null && n.left !== null; )
            n = n.left;
        else
          n = /** @type {AbstractType<any>} */
          this.parent._start, this.parent._start = this;
        this.right = n;
      }
      this.right !== null ? this.right.left = this : this.parentSub !== null && (this.parent._map.set(this.parentSub, this), this.left !== null && this.left.delete(e)), this.parentSub === null && this.countable && !this.deleted && (this.parent._length += this.length), JU(e.doc.store, this), this.content.integrate(e, this), aF(
        e,
        /** @type {AbstractType<any>} */
        this.parent,
        this.parentSub
      ), /** @type {AbstractType<any>} */
      (this.parent._item !== null && /** @type {AbstractType<any>} */
      this.parent._item.deleted || this.parentSub !== null && this.right !== null) && this.delete(e);
    } else
      new ys(this.id, this.length).integrate(e, 0);
  }
  /**
   * Returns the next non-deleted item
   */
  get next() {
    let e = this.right;
    for (; e !== null && e.deleted; )
      e = e.right;
    return e;
  }
  /**
   * Returns the previous non-deleted item
   */
  get prev() {
    let e = this.left;
    for (; e !== null && e.deleted; )
      e = e.left;
    return e;
  }
  /**
   * Computes the last content address of this Item.
   */
  get lastId() {
    return this.length === 1 ? this.id : At(this.id.client, this.id.clock + this.length - 1);
  }
  /**
   * Try to merge two items
   *
   * @param {Item} right
   * @return {boolean}
   */
  mergeWith(e) {
    if (this.constructor === e.constructor && Xc(e.origin, this.lastId) && this.right === e && Xc(this.rightOrigin, e.rightOrigin) && this.id.client === e.id.client && this.id.clock + this.length === e.id.clock && this.deleted === e.deleted && this.redone === null && e.redone === null && this.content.constructor === e.content.constructor && this.content.mergeWith(e.content)) {
      const A = (
        /** @type {AbstractType<any>} */
        this.parent._searchMarker
      );
      return A && A.forEach((n) => {
        n.p === e && (n.p = this, !this.deleted && this.countable && (n.index -= this.length));
      }), e.keep && (this.keep = !0), this.right = e.right, this.right !== null && (this.right.left = this), this.length += e.length, !0;
    }
    return !1;
  }
  /**
   * Mark this Item as deleted.
   *
   * @param {Transaction} transaction
   */
  delete(e) {
    if (!this.deleted) {
      const A = (
        /** @type {AbstractType<any>} */
        this.parent
      );
      this.countable && this.parentSub === null && (A._length -= this.length), this.markDeleted(), Lg(e.deleteSet, this.id.client, this.id.clock, this.length), aF(e, A, this.parentSub), this.content.delete(e);
    }
  }
  /**
   * @param {StructStore} store
   * @param {boolean} parentGCd
   */
  gc(e, A) {
    if (!this.deleted)
      throw ln();
    this.content.gc(e), A ? LZ(e, this, new ys(this.id, this.length)) : this.content = new Kg(this.length);
  }
  /**
   * Transform the properties of this type to binary and write it to an
   * BinaryEncoder.
   *
   * This is called when this Item is sent to a remote peer.
   *
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder The encoder to write data to.
   * @param {number} offset
   */
  write(e, A) {
    const n = A > 0 ? At(this.id.client, this.id.clock + A - 1) : this.origin, s = this.rightOrigin, r = this.parentSub, i = this.content.getRef() & Sw | (n === null ? 0 : Dn) | // origin is defined
    (s === null ? 0 : bi) | // right origin is defined
    (r === null ? 0 : bg);
    if (e.writeInfo(i), n !== null && e.writeLeftID(n), s !== null && e.writeRightID(s), n === null && s === null) {
      const o = (
        /** @type {AbstractType<any>} */
        this.parent
      );
      if (o._item !== void 0) {
        const a = o._item;
        if (a === null) {
          const c = Tg(o);
          e.writeParentInfo(!0), e.writeString(c);
        } else
          e.writeParentInfo(!1), e.writeLeftID(a.id);
      } else o.constructor === String ? (e.writeParentInfo(!0), e.writeString(o)) : o.constructor === Bl ? (e.writeParentInfo(!1), e.writeLeftID(o)) : ln();
      r !== null && e.writeString(r);
    }
    this.content.write(e, A);
  }
}
const gb = (t, e) => Hq[e & Sw](t), Hq = [
  () => {
    ln();
  },
  // GC is not ItemContent
  Cq,
  // 1
  mq,
  // 2
  Iq,
  // 3
  Fq,
  // 4
  Mq,
  // 5
  pq,
  // 6
  jq,
  // 7
  yq,
  // 8
  Eq,
  // 9
  () => {
    ln();
  }
  // 10 - Skip is not ItemContent
], kq = 10;
class Fs extends nm {
  get deleted() {
    return !0;
  }
  delete() {
  }
  /**
   * @param {Skip} right
   * @return {boolean}
   */
  mergeWith(e) {
    return this.constructor !== e.constructor ? !1 : (this.length += e.length, !0);
  }
  /**
   * @param {Transaction} transaction
   * @param {number} offset
   */
  integrate(e, A) {
    ln();
  }
  /**
   * @param {UpdateEncoderV1 | UpdateEncoderV2} encoder
   * @param {number} offset
   */
  write(e, A) {
    e.writeInfo(kq), Qt(e.restEncoder, this.length - A);
  }
  /**
   * @param {Transaction} transaction
   * @param {StructStore} store
   * @return {null | number}
   */
  getMissing(e, A) {
    return null;
  }
}
const hb = (
  /** @type {any} */
  typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : {}
), ub = "__ $YJS$ __";
hb[ub] === !0 && console.error("Yjs was already imported. This breaks constructor checks and will lead to issues! - https://github.com/yjs/yjs/issues/438");
hb[ub] = !0;
const Rq = () => {
  let t = !0;
  return (e, A) => {
    if (t) {
      t = !1;
      try {
        e();
      } finally {
        t = !0;
      }
    } else A !== void 0 && A();
  };
}, Lq = /[\uD800-\uDBFF]/, Sq = /[\uDC00-\uDFFF]/, Tq = (t, e) => {
  let A = 0, n = 0;
  for (; A < t.length && A < e.length && t[A] === e[A]; )
    A++;
  for (A > 0 && Lq.test(t[A - 1]) && A--; n + A < t.length && n + A < e.length && t[t.length - n - 1] === e[e.length - n - 1]; )
    n++;
  return n > 0 && Sq.test(t[t.length - n]) && n--, {
    index: A,
    remove: t.length - A - n,
    insert: e.slice(A, e.length - n)
  };
}, Jq = Tq, Hr = (t, e) => t >>> e | t << 32 - e, Wq = (t) => Hr(t, 2) ^ Hr(t, 13) ^ Hr(t, 22), Oq = (t) => Hr(t, 6) ^ Hr(t, 11) ^ Hr(t, 25), Pq = (t) => Hr(t, 7) ^ Hr(t, 18) ^ t >>> 3, Kq = (t) => Hr(t, 17) ^ Hr(t, 19) ^ t >>> 10, Vq = new Uint32Array([
  1116352408,
  1899447441,
  3049323471,
  3921009573,
  961987163,
  1508970993,
  2453635748,
  2870763221,
  3624381080,
  310598401,
  607225278,
  1426881987,
  1925078388,
  2162078206,
  2614888103,
  3248222580,
  3835390401,
  4022224774,
  264347078,
  604807628,
  770255983,
  1249150122,
  1555081692,
  1996064986,
  2554220882,
  2821834349,
  2952996808,
  3210313671,
  3336571891,
  3584528711,
  113926993,
  338241895,
  666307205,
  773529912,
  1294757372,
  1396182291,
  1695183700,
  1986661051,
  2177026350,
  2456956037,
  2730485921,
  2820302411,
  3259730800,
  3345764771,
  3516065817,
  3600352804,
  4094571909,
  275423344,
  430227734,
  506948616,
  659060556,
  883997877,
  958139571,
  1322822218,
  1537002063,
  1747873779,
  1955562222,
  2024104815,
  2227730452,
  2361852424,
  2428436474,
  2756734187,
  3204031479,
  3329325298
]), Xq = new Uint32Array([
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
]);
class Zq {
  constructor() {
    const e = new ArrayBuffer(320);
    this._H = new Uint32Array(e, 0, 8), this._H.set(Xq), this._W = new Uint32Array(e, 64, 64);
  }
  _updateHash() {
    const e = this._H, A = this._W;
    for (let B = 16; B < 64; B++)
      A[B] = Kq(A[B - 2]) + A[B - 7] + Pq(A[B - 15]) + A[B - 16];
    let n = e[0], s = e[1], r = e[2], i = e[3], o = e[4], a = e[5], c = e[6], l = e[7];
    for (let B = 0, g, h; B < 64; B++)
      g = l + Oq(o) + (o & a ^ ~o & c) + Vq[B] + A[B] >>> 0, h = Wq(n) + (n & s ^ n & r ^ s & r) >>> 0, l = c, c = a, a = o, o = i + g >>> 0, i = r, r = s, s = n, n = g + h >>> 0;
    e[0] += n, e[1] += s, e[2] += r, e[3] += i, e[4] += o, e[5] += a, e[6] += c, e[7] += l;
  }
  /**
   * Returns a 32-byte hash.
   *
   * @param {Uint8Array} data
   */
  digest(e) {
    let A = 0;
    for (; A + 56 <= e.length; ) {
      let i = 0;
      for (; i < 16 && A + 3 < e.length; i++)
        this._W[i] = e[A++] << 24 | e[A++] << 16 | e[A++] << 8 | e[A++];
      if (A % 64 !== 0) {
        for (this._W.fill(0, i, 16); A < e.length; )
          this._W[i] |= e[A] << (3 - A % 4) * 8, A++;
        this._W[i] |= Dn << (3 - A % 4) * 8;
      }
      this._updateHash();
    }
    const n = A % 64 !== 0;
    this._W.fill(0, 0, 16);
    let s = 0;
    for (; A < e.length; s++)
      for (let i = 3; i >= 0 && A < e.length; i--)
        this._W[s] |= e[A++] << i * 8;
    n || (this._W[s - (A % 4 === 0 ? 0 : 1)] |= Dn << (3 - A % 4) * 8), this._W[14] = e.byteLength / MV, this._W[15] = e.byteLength * 8, this._updateHash();
    const r = new Uint8Array(32);
    for (let i = 0; i < this._H.length; i++)
      for (let o = 0; o < 4; o++)
        r[i * 4 + o] = this._H[i] >>> (3 - o) * 8;
    return r;
  }
}
const qq = (t) => new Zq().digest(t), vt = new Bt("y-sync"), vi = new Bt("y-undo"), I0 = new Bt("yjs-cursor"), _q = (t) => {
  for (let A = 6; A < t.length; A++)
    t[A % 6] = t[A % 6] ^ t[A];
  return t.slice(0, 6);
}, $q = (t) => MX(_q(qq(mX(t)))), kd = (t, e) => e === void 0 ? !t.deleted : e.sv.has(t.id.client) && /** @type {number} */
e.sv.get(t.id.client) > t.id.clock && !lc(e.ds, t.id), e_ = [{ light: "#ecd44433", dark: "#ecd444" }], t_ = (t, e, A) => {
  if (!t.has(A)) {
    if (t.size < e.length) {
      const n = tc();
      t.forEach((s) => n.add(s)), e = e.filter((s) => !n.has(s));
    }
    t.set(A, tX(e));
  }
  return (
    /** @type {ColorDef} */
    t.get(A)
  );
}, A_ = (t, {
  colors: e = e_,
  colorMapping: A = /* @__PURE__ */ new Map(),
  permanentUserData: n = null,
  onFirstRender: s = () => {
  },
  mapping: r
} = {}) => {
  let i = !1;
  const o = new r_(t, r), a = new ct({
    props: {
      editable: (c) => {
        const l = vt.getState(c);
        return l.snapshot == null && l.prevSnapshot == null;
      }
    },
    key: vt,
    state: {
      /**
       * @returns {any}
       */
      init: (c, l) => ({
        type: t,
        doc: t.doc,
        binding: o,
        snapshot: null,
        prevSnapshot: null,
        isChangeOrigin: !1,
        isUndoRedoOperation: !1,
        addToHistory: !0,
        colors: e,
        colorMapping: A,
        permanentUserData: n
      }),
      apply: (c, l) => {
        const B = c.getMeta(vt);
        if (B !== void 0) {
          l = Object.assign({}, l);
          for (const g in B)
            l[g] = B[g];
        }
        return l.addToHistory = c.getMeta("addToHistory") !== !1, l.isChangeOrigin = B !== void 0 && !!B.isChangeOrigin, l.isUndoRedoOperation = B !== void 0 && !!B.isChangeOrigin && !!B.isUndoRedoOperation, o.prosemirrorView !== null && B !== void 0 && (B.snapshot != null || B.prevSnapshot != null) && Wp(0, () => {
          o.prosemirrorView != null && (B.restore == null ? o._renderSnapshot(
            B.snapshot,
            B.prevSnapshot,
            l
          ) : (o._renderSnapshot(
            B.snapshot,
            B.snapshot,
            l
          ), delete l.restore, delete l.snapshot, delete l.prevSnapshot, o.mux(() => {
            o._prosemirrorChanged(
              o.prosemirrorView.state.doc
            );
          })));
        }), l;
      }
    },
    view: (c) => (o.initView(c), r == null && o._forceRerender(), s(), {
      update: () => {
        const l = a.getState(c.state);
        if (l.snapshot == null && l.prevSnapshot == null && // If the content doesn't change initially, we don't render anything to Yjs
        // If the content was cleared by a user action, we want to catch the change and
        // represent it in Yjs
        (i || c.state.doc.content.findDiffStart(
          c.state.doc.type.createAndFill().content
        ) !== null)) {
          if (i = !0, l.addToHistory === !1 && !l.isChangeOrigin) {
            const B = vi.getState(c.state), g = B && B.undoManager;
            g && g.stopCapturing();
          }
          o.mux(() => {
            l.doc.transact((B) => {
              B.meta.set("addToHistory", l.addToHistory), o._prosemirrorChanged(c.state.doc);
            }, vt);
          });
        }
      },
      destroy: () => {
        o.destroy();
      }
    })
  });
  return a;
}, n_ = (t, e, A) => {
  if (e !== null && e.anchor !== null && e.head !== null)
    if (e.type === "all")
      t.setSelection(new Xn(t.doc));
    else if (e.type === "node") {
      const n = Wo(
        A.doc,
        A.type,
        e.anchor,
        A.mapping
      );
      t.setSelection(s_(t, n));
    } else {
      const n = Wo(
        A.doc,
        A.type,
        e.anchor,
        A.mapping
      ), s = Wo(
        A.doc,
        A.type,
        e.head,
        A.mapping
      );
      n !== null && s !== null && t.setSelection(Re.between(t.doc.resolve(n), t.doc.resolve(s)));
    }
}, s_ = (t, e) => {
  const A = t.doc.resolve(e);
  return A.nodeAfter ? Ue.create(t.doc, e) : Re.near(A);
}, ME = (t, e) => ({
  type: (
    /** @type {any} */
    e.selection.jsonID
  ),
  anchor: Aa(
    e.selection.anchor,
    t.type,
    t.mapping
  ),
  head: Aa(
    e.selection.head,
    t.type,
    t.mapping
  )
});
class r_ {
  /**
   * @param {Y.XmlFragment} yXmlFragment The bind source
   * @param {ProsemirrorMapping} mapping
   */
  constructor(e, A = /* @__PURE__ */ new Map()) {
    this.type = e, this.prosemirrorView = null, this.mux = Rq(), this.mapping = A, this.isOMark = /* @__PURE__ */ new Map(), this._observeFunction = this._typeChanged.bind(this), this.doc = e.doc, this.beforeTransactionSelection = null, this.beforeAllTransactions = () => {
      this.beforeTransactionSelection === null && this.prosemirrorView != null && (this.beforeTransactionSelection = ME(
        this,
        this.prosemirrorView.state
      ));
    }, this.afterAllTransactions = () => {
      this.beforeTransactionSelection = null;
    }, this._domSelectionInView = null;
  }
  /**
   * Create a transaction for changing the prosemirror state.
   *
   * @returns
   */
  get _tr() {
    return this.prosemirrorView.state.tr.setMeta("addToHistory", !1);
  }
  _isLocalCursorInView() {
    return this.prosemirrorView.hasFocus() ? (cU && this._domSelectionInView === null && (Wp(0, () => {
      this._domSelectionInView = null;
    }), this._domSelectionInView = this._isDomSelectionInView()), this._domSelectionInView) : !1;
  }
  _isDomSelectionInView() {
    const e = this.prosemirrorView._root.getSelection();
    if (e == null || e.anchorNode == null) return !1;
    const A = this.prosemirrorView._root.createRange();
    A.setStart(e.anchorNode, e.anchorOffset), A.setEnd(e.focusNode, e.focusOffset), A.getClientRects().length === 0 && A.startContainer && A.collapsed && A.selectNodeContents(A.startContainer);
    const s = A.getBoundingClientRect(), r = Qh.documentElement;
    return s.bottom >= 0 && s.right >= 0 && s.left <= (window.innerWidth || r.clientWidth || 0) && s.top <= (window.innerHeight || r.clientHeight || 0);
  }
  /**
   * @param {Y.Snapshot} snapshot
   * @param {Y.Snapshot} prevSnapshot
   */
  renderSnapshot(e, A) {
    A || (A = SU(Vp(), /* @__PURE__ */ new Map())), this.prosemirrorView.dispatch(
      this._tr.setMeta(vt, { snapshot: e, prevSnapshot: A })
    );
  }
  unrenderSnapshot() {
    this.mapping.clear(), this.mux(() => {
      const e = this.type.toArray().map(
        (n) => au(
          /** @type {Y.XmlElement} */
          n,
          this.prosemirrorView.state.schema,
          this
        )
      ).filter((n) => n !== null), A = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new Ee(re.from(e), 0, 0)
      );
      A.setMeta(vt, { snapshot: null, prevSnapshot: null }), this.prosemirrorView.dispatch(A);
    });
  }
  _forceRerender() {
    this.mapping.clear(), this.mux(() => {
      const e = this.beforeTransactionSelection !== null ? null : this.prosemirrorView.state.selection, A = this.type.toArray().map(
        (s) => au(
          /** @type {Y.XmlElement} */
          s,
          this.prosemirrorView.state.schema,
          this
        )
      ).filter((s) => s !== null), n = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new Ee(re.from(A), 0, 0)
      );
      if (e) {
        const s = Ui(cr(e.anchor, 0), n.doc.content.size), r = Ui(cr(e.head, 0), n.doc.content.size);
        n.setSelection(Re.create(n.doc, s, r));
      }
      this.prosemirrorView.dispatch(
        n.setMeta(vt, { isChangeOrigin: !0, binding: this })
      );
    });
  }
  /**
   * @param {Y.Snapshot|Uint8Array} snapshot
   * @param {Y.Snapshot|Uint8Array} prevSnapshot
   * @param {Object} pluginState
   */
  _renderSnapshot(e, A, n) {
    let s = this.doc, r = this.type;
    if (e || (e = _Q(this.doc)), e instanceof Uint8Array || A instanceof Uint8Array)
      if ((!(e instanceof Uint8Array) || !(A instanceof Uint8Array)) && ln(), s = new no({ gc: !1 }), xd(s, A), A = _Q(s), xd(s, e), e = _Q(s), r._item === null) {
        const i = Array.from(this.doc.share.keys()).find(
          (o) => this.doc.share.get(o) === this.type
        );
        r = s.getXmlFragment(i);
      } else {
        const i = s.store.clients.get(r._item.id.client) ?? [], o = lr(
          i,
          r._item.id.clock
        );
        r = /** @type {Y.XmlFragment} */
        /** @type {Y.ContentType} */
        /** @type {Y.Item} */
        i[o].content.type;
      }
    this.mapping.clear(), this.mux(() => {
      s.transact((i) => {
        const o = n.permanentUserData;
        o && o.dss.forEach((B) => {
          $o(i, B, (g) => {
          });
        });
        const a = (B, g) => {
          const h = B === "added" ? o.getUserByClientId(g.client) : o.getUserByDeletedId(g);
          return {
            user: h,
            type: B,
            color: t_(
              n.colorMapping,
              n.colors,
              h
            )
          };
        }, c = _U(
          r,
          new Zp(A.ds, e.sv)
        ).map((B) => !B._item.deleted || kd(B._item, e) || kd(B._item, A) ? au(
          B,
          this.prosemirrorView.state.schema,
          { mapping: /* @__PURE__ */ new Map(), isOMark: /* @__PURE__ */ new Map() },
          e,
          A,
          a
        ) : null).filter((B) => B !== null), l = this._tr.replace(
          0,
          this.prosemirrorView.state.doc.content.size,
          new Ee(re.from(c), 0, 0)
        );
        this.prosemirrorView.dispatch(
          l.setMeta(vt, { isChangeOrigin: !0 })
        );
      }, vt);
    });
  }
  /**
   * @param {Array<Y.YEvent<any>>} events
   * @param {Y.Transaction} transaction
   */
  _typeChanged(e, A) {
    if (this.prosemirrorView == null) return;
    const n = vt.getState(this.prosemirrorView.state);
    if (e.length === 0 || n.snapshot != null || n.prevSnapshot != null) {
      this.renderSnapshot(n.snapshot, n.prevSnapshot);
      return;
    }
    this.mux(() => {
      const s = (o, a) => this.mapping.delete(a);
      $o(
        A,
        A.deleteSet,
        (o) => {
          if (o.constructor === jt) {
            const a = (
              /** @type {Y.ContentType} */
              /** @type {Y.Item} */
              o.content.type
            );
            a && this.mapping.delete(a);
          }
        }
      ), A.changed.forEach(s), A.changedParentTypes.forEach(s);
      const r = this.type.toArray().map(
        (o) => db(
          /** @type {Y.XmlElement | Y.XmlHook} */
          o,
          this.prosemirrorView.state.schema,
          this
        )
      ).filter((o) => o !== null);
      let i = this._tr.replace(
        0,
        this.prosemirrorView.state.doc.content.size,
        new Ee(re.from(r), 0, 0)
      );
      n_(i, this.beforeTransactionSelection, this), i = i.setMeta(vt, { isChangeOrigin: !0, isUndoRedoOperation: A.origin instanceof PU }), this.beforeTransactionSelection !== null && this._isLocalCursorInView() && i.scrollIntoView(), this.prosemirrorView.dispatch(i);
    });
  }
  /**
   * @param {import('prosemirror-model').Node} doc
   */
  _prosemirrorChanged(e) {
    this.doc.transact(() => {
      mE(this.doc, this.type, e, this), this.beforeTransactionSelection = ME(
        this,
        this.prosemirrorView.state
      );
    }, vt);
  }
  /**
   * View is ready to listen to changes. Register observers.
   * @param {any} prosemirrorView
   */
  initView(e) {
    this.prosemirrorView != null && this.destroy(), this.prosemirrorView = e, this.doc.on("beforeAllTransactions", this.beforeAllTransactions), this.doc.on("afterAllTransactions", this.afterAllTransactions), this.type.observeDeep(this._observeFunction);
  }
  destroy() {
    this.prosemirrorView != null && (this.prosemirrorView = null, this.type.unobserveDeep(this._observeFunction), this.doc.off("beforeAllTransactions", this.beforeAllTransactions), this.doc.off("afterAllTransactions", this.afterAllTransactions));
  }
}
const db = (t, e, A, n, s, r) => {
  const i = (
    /** @type {PModel.Node} */
    A.mapping.get(t)
  );
  if (i === void 0) {
    if (t instanceof sn)
      return au(
        t,
        e,
        A,
        n,
        s,
        r
      );
    throw ks();
  }
  return i;
}, au = (t, e, A, n, s, r) => {
  const i = [], o = (a) => {
    var c, l;
    if (a instanceof sn) {
      const B = db(
        a,
        e,
        A,
        n,
        s,
        r
      );
      B !== null && i.push(B);
    } else {
      const B = (
        /** @type {Y.ContentType} */
        (l = (c = a._item.right) == null ? void 0 : c.content) == null ? void 0 : l.type
      );
      B instanceof ta && !B._item.deleted && B._item.id.client === B.doc.clientID && (a.applyDelta([
        { retain: a.length },
        ...B.toDelta()
      ]), B.doc.transact((h) => {
        B._item.delete(h);
      }));
      const g = i_(
        a,
        e,
        A,
        n,
        s,
        r
      );
      g !== null && g.forEach((h) => {
        h !== null && i.push(h);
      });
    }
  };
  n === void 0 || s === void 0 ? t.toArray().forEach(o) : _U(t, new Zp(s.ds, n.sv)).forEach(o);
  try {
    const a = t.getAttributes(n);
    n !== void 0 && (kd(
      /** @type {Y.Item} */
      t._item,
      n
    ) ? kd(
      /** @type {Y.Item} */
      t._item,
      s
    ) || (a.ychange = r ? r(
      "added",
      /** @type {Y.Item} */
      t._item.id
    ) : { type: "added" }) : a.ychange = r ? r(
      "removed",
      /** @type {Y.Item} */
      t._item.id
    ) : { type: "removed" });
    const c = e.node(t.nodeName, a, i);
    return A.mapping.set(t, c), c;
  } catch {
    return t.doc.transact((c) => {
      t._item.delete(c);
    }, vt), A.mapping.delete(t), null;
  }
}, i_ = (t, e, A, n, s, r) => {
  const i = [], o = t.toDelta(n, s, r);
  try {
    for (let a = 0; a < o.length; a++) {
      const c = o[a];
      i.push(e.text(c.insert, g_(c.attributes, e)));
    }
  } catch {
    return t.doc.transact((c) => {
      t._item.delete(c);
    }, vt), null;
  }
  return i;
}, o_ = (t, e) => {
  const A = new qn(), n = t.map((s) => ({
    // @ts-ignore
    insert: s.text,
    attributes: fb(s.marks, e)
  }));
  return A.applyDelta(n), e.mapping.set(A, t), A;
}, a_ = (t, e) => {
  const A = new sn(t.type.name);
  for (const n in t.attrs) {
    const s = t.attrs[n];
    s !== null && n !== "ychange" && A.setAttribute(n, s);
  }
  return A.insert(
    0,
    _w(t).map(
      (n) => pE(n, e)
    )
  ), e.mapping.set(A, t), A;
}, pE = (t, e) => t instanceof Array ? o_(t, e) : a_(t, e), wF = (t) => typeof t == "object" && t !== null, rm = (t, e) => {
  const A = Object.keys(t).filter((s) => t[s] !== null);
  let n = A.length === Object.keys(e).filter((s) => e[s] !== null).length;
  for (let s = 0; s < A.length && n; s++) {
    const r = A[s], i = t[r], o = e[r];
    n = r === "ychange" || i === o || wF(i) && wF(o) && rm(i, o);
  }
  return n;
}, _w = (t) => {
  const e = t.content.content, A = [];
  for (let n = 0; n < e.length; n++) {
    const s = e[n];
    if (s.isText) {
      const r = [];
      for (let i = e[n]; n < e.length && i.isText; i = e[++n])
        r.push(i);
      n--, A.push(r);
    } else
      A.push(s);
  }
  return A;
}, wb = (t, e) => {
  const A = t.toDelta();
  return A.length === e.length && A.every(
    /** @type {(d:any,i:number) => boolean} */
    (n, s) => n.insert === /** @type {any} */
    e[s].text && iU(n.attributes || {}).length === e[s].marks.length && Jl(n.attributes, (r, i) => {
      var l;
      const o = im(i), a = e[s].marks;
      return a.find(
        /** @param {any} mark */
        (B) => B.type.name === o
      ) ? rm(r, (l = a.find(
        /** @param {any} mark */
        (B) => B.type.name === o
      )) == null ? void 0 : l.attrs) : !1;
    })
  );
}, Vg = (t, e) => {
  if (t instanceof sn && !(e instanceof Array) && YE(t, e)) {
    const A = _w(e);
    return t._length === A.length && rm(t.getAttributes(), e.attrs) && t.toArray().every(
      (n, s) => Vg(n, A[s])
    );
  }
  return t instanceof qn && e instanceof Array && wb(t, e);
}, Rd = (t, e) => t === e || t instanceof Array && e instanceof Array && t.length === e.length && t.every(
  (A, n) => e[n] === A
), fF = (t, e, A) => {
  const n = t.toArray(), s = _w(e), r = s.length, i = n.length, o = Ui(i, r);
  let a = 0, c = 0, l = !1;
  for (; a < o; a++) {
    const B = n[a], g = s[a];
    if (Rd(A.mapping.get(B), g))
      l = !0;
    else if (!Vg(B, g))
      break;
  }
  for (; a + c < o; c++) {
    const B = n[i - c - 1], g = s[r - c - 1];
    if (Rd(A.mapping.get(B), g))
      l = !0;
    else if (!Vg(B, g))
      break;
  }
  return {
    equalityFactor: a + c,
    foundMappedChild: l
  };
}, c_ = (t) => {
  let e = "", A = t._start;
  const n = {};
  for (; A !== null; )
    A.deleted || (A.countable && A.content instanceof Br ? e += A.content.str : A.content instanceof pA && (n[A.content.key] = null)), A = A.right;
  return {
    str: e,
    nAttrs: n
  };
}, l_ = (t, e, A) => {
  A.mapping.set(t, e);
  const { nAttrs: n, str: s } = c_(t), r = e.map((c) => ({
    insert: (
      /** @type {any} */
      c.text
    ),
    attributes: Object.assign({}, n, fb(c.marks, A))
  })), { insert: i, remove: o, index: a } = Jq(
    s,
    r.map((c) => c.insert).join("")
  );
  t.delete(a, o), t.insert(a, i), t.applyDelta(
    r.map((c) => ({ retain: c.insert.length, attributes: c.attributes }))
  );
}, B_ = /(.*)(--[a-zA-Z0-9+/=]{8})$/, im = (t) => {
  var e;
  return ((e = B_.exec(t)) == null ? void 0 : e[1]) ?? t;
}, g_ = (t, e) => {
  const A = [];
  for (const n in t)
    A.push(e.mark(im(n), t[n]));
  return A;
}, fb = (t, e) => {
  const A = {};
  return t.forEach((n) => {
    if (n.type.name !== "ychange") {
      const s = $r(e.isOMark, n.type, () => !n.type.excludes(n.type));
      A[s ? `${n.type.name}--${$q(n.toJSON())}` : n.type.name] = n.attrs;
    }
  }), A;
}, mE = (t, e, A, n) => {
  if (e instanceof sn && e.nodeName !== A.type.name)
    throw new Error("node name mismatch!");
  if (n.mapping.set(e, A), e instanceof sn) {
    const B = e.getAttributes(), g = A.attrs;
    for (const h in g)
      g[h] !== null ? B[h] !== g[h] && h !== "ychange" && e.setAttribute(h, g[h]) : e.removeAttribute(h);
    for (const h in B)
      g[h] === void 0 && e.removeAttribute(h);
  }
  const s = _w(A), r = s.length, i = e.toArray(), o = i.length, a = Ui(r, o);
  let c = 0, l = 0;
  for (; c < a; c++) {
    const B = i[c], g = s[c];
    if (!Rd(n.mapping.get(B), g))
      if (Vg(B, g))
        n.mapping.set(B, g);
      else
        break;
  }
  for (; l + c + 1 < a; l++) {
    const B = i[o - l - 1], g = s[r - l - 1];
    if (!Rd(n.mapping.get(B), g))
      if (Vg(B, g))
        n.mapping.set(B, g);
      else
        break;
  }
  t.transact(() => {
    for (; o - c - l > 0 && r - c - l > 0; ) {
      const g = i[c], h = s[c], u = i[o - l - 1], d = s[r - l - 1];
      if (g instanceof qn && h instanceof Array)
        wb(g, h) || l_(g, h, n), c += 1;
      else {
        let w = g instanceof sn && YE(g, h), Q = u instanceof sn && YE(u, d);
        if (w && Q) {
          const p = fF(
            /** @type {Y.XmlElement} */
            g,
            /** @type {PModel.Node} */
            h,
            n
          ), M = fF(
            /** @type {Y.XmlElement} */
            u,
            /** @type {PModel.Node} */
            d,
            n
          );
          p.foundMappedChild && !M.foundMappedChild ? Q = !1 : !p.foundMappedChild && M.foundMappedChild || p.equalityFactor < M.equalityFactor ? w = !1 : Q = !1;
        }
        w ? (mE(
          t,
          /** @type {Y.XmlFragment} */
          g,
          /** @type {PModel.Node} */
          h,
          n
        ), c += 1) : Q ? (mE(
          t,
          /** @type {Y.XmlFragment} */
          u,
          /** @type {PModel.Node} */
          d,
          n
        ), l += 1) : (n.mapping.delete(e.get(c)), e.delete(c, 1), e.insert(c, [
          pE(h, n)
        ]), c += 1);
      }
    }
    const B = o - c - l;
    if (o === 1 && r === 0 && i[0] instanceof qn ? (n.mapping.delete(i[0]), i[0].delete(0, i[0].length)) : B > 0 && (e.slice(c, c + B).forEach((g) => n.mapping.delete(g)), e.delete(c, B)), c + l < r) {
      const g = [];
      for (let h = c; h < r - l; h++)
        g.push(pE(s[h], n));
      e.insert(c, g);
    }
  }, vt);
}, YE = (t, e) => !(e instanceof Array) && t.nodeName === e.type.name;
let $B = null;
const h_ = () => {
  const t = (
    /** @type {Map<EditorView, Map<any, any>>} */
    $B
  );
  $B = null, t.forEach((e, A) => {
    const n = A.state.tr, s = vt.getState(A.state);
    s && s.binding && !s.binding.isDestroyed && (e.forEach((r, i) => {
      n.setMeta(i, r);
    }), A.dispatch(n));
  });
}, u_ = (t, e, A) => {
  $B || ($B = /* @__PURE__ */ new Map(), Wp(0, h_)), $r($B, t, Hs).set(e, A);
}, Aa = (t, e, A) => {
  if (t === 0)
    return qQ(e, 0, -1);
  let n = e._first === null ? null : (
    /** @type {Y.ContentType} */
    e._first.content.type
  );
  for (; n !== null && e !== n; ) {
    if (n instanceof qn) {
      if (n._length >= t)
        return qQ(n, t, -1);
      if (t -= n._length, n._item !== null && n._item.next !== null)
        n = /** @type {Y.ContentType} */
        n._item.next.content.type;
      else {
        do
          n = n._item === null ? null : n._item.parent, t--;
        while (n !== e && n !== null && n._item !== null && n._item.next === null);
        n !== null && n !== e && (n = n._item === null ? null : (
          /** @type {Y.ContentType} */
          /** @type Y.Item */
          n._item.next.content.type
        ));
      }
    } else {
      const s = (
        /** @type {any} */
        (A.get(n) || { nodeSize: 0 }).nodeSize
      );
      if (n._first !== null && t < s)
        n = /** @type {Y.ContentType} */
        n._first.content.type, t--;
      else {
        if (t === 1 && n._length === 0 && s > 1)
          return new Wg(n._item === null ? null : n._item.id, n._item === null ? Tg(n) : null, null);
        if (t -= s, n._item !== null && n._item.next !== null)
          n = /** @type {Y.ContentType} */
          n._item.next.content.type;
        else {
          if (t === 0)
            return n = n._item === null ? n : n._item.parent, new Wg(n._item === null ? null : n._item.id, n._item === null ? Tg(n) : null, null);
          do
            n = /** @type {Y.Item} */
            n._item.parent, t--;
          while (n !== e && /** @type {Y.Item} */
          n._item.next === null);
          n !== e && (n = /** @type {Y.ContentType} */
          /** @type {Y.Item} */
          /** @type {Y.Item} */
          n._item.next.content.type);
        }
      }
    }
    if (n === null)
      throw ln();
    if (t === 0 && n.constructor !== qn && n !== e)
      return d_(n._item.parent, n._item);
  }
  return qQ(e, e._length, -1);
}, d_ = (t, e) => {
  let A = null, n = null;
  return t._item === null ? n = Tg(t) : A = At(t._item.id.client, t._item.id.clock), new Wg(A, n, e.id);
}, Wo = (t, e, A, n) => {
  const s = kZ(A, t);
  if (s === null || s.type !== e && !Jg(e, s.type._item))
    return null;
  let r = s.type, i = 0;
  if (r.constructor === qn)
    i = s.index;
  else if (r._item === null || !r._item.deleted) {
    let o = r._first, a = 0;
    for (; a < r._length && a < s.index && o !== null; ) {
      if (!o.deleted) {
        const c = (
          /** @type {Y.ContentType} */
          o.content.type
        );
        a++, c instanceof qn ? i += c._length : i += /** @type {any} */
        n.get(c).nodeSize;
      }
      o = /** @type {Y.Item} */
      o.right;
    }
    i += 1;
  }
  for (; r !== e && r._item !== null; ) {
    const o = r._item.parent;
    if (o._item === null || !o._item.deleted) {
      i += 1;
      let a = (
        /** @type {Y.AbstractType} */
        o._first
      );
      for (; a !== null; ) {
        const c = (
          /** @type {Y.ContentType} */
          a.content.type
        );
        if (c === r)
          break;
        a.deleted || (c instanceof qn ? i += c._length : i += /** @type {any} */
        n.get(c).nodeSize), a = a.right;
      }
    }
    r = /** @type {Y.AbstractType} */
    o;
  }
  return i - 1;
};
function w_(t) {
  const e = t.toArray(), A = (n) => {
    let s;
    if (n instanceof qn)
      s = n.toDelta().map(
        /** @param {any} d */
        (i) => {
          const o = {
            type: "text",
            text: i.insert
          };
          return i.attributes && (o.marks = Object.keys(i.attributes).map((a) => {
            const c = i.attributes[a], B = {
              type: im(a)
            };
            return Object.keys(c) && (B.attrs = c), B;
          })), o;
        }
      );
    else if (n instanceof sn) {
      s = {
        type: n.nodeName
      };
      const r = n.getAttributes();
      Object.keys(r).length && (s.attrs = r);
      const i = n.toArray();
      i.length && (s.content = i.map(A).flat());
    } else
      ln();
    return s;
  };
  return {
    type: "doc",
    content: e.map(A)
  };
}
const f_ = (t, e, A) => t !== e, Q_ = (t) => {
  const e = document.createElement("span");
  e.classList.add("ProseMirror-yjs-cursor"), e.setAttribute("style", `border-color: ${t.color}`);
  const A = document.createElement("div");
  A.setAttribute("style", `background-color: ${t.color}`), A.insertBefore(document.createTextNode(t.name), null);
  const n = document.createTextNode("⁠"), s = document.createTextNode("⁠");
  return e.insertBefore(n, null), e.insertBefore(A, null), e.insertBefore(s, null), e;
}, Qb = (t) => ({
  style: `background-color: ${t.color}70`,
  class: "ProseMirror-yjs-selection"
}), I_ = /^#[0-9a-fA-F]{6}$/, QF = (t, e, A, n, s) => {
  const r = vt.getState(t);
  if (r == null || r.doc == null || r.binding == null)
    return It.create(t.doc, []);
  const i = r.doc, o = [];
  return r.snapshot != null || r.prevSnapshot != null || r.binding.mapping.size === 0 ? It.create(t.doc, []) : (e.getStates().forEach((a, c) => {
    if (A(i.clientID, c, a) && a.cursor != null) {
      const l = a.user || {};
      l.color == null ? l.color = "#ffa500" : I_.test(l.color) || console.warn("A user uses an unsupported color format", l), l.name == null && (l.name = `User: ${c}`);
      let B = Wo(
        i,
        r.type,
        Oa(a.cursor.anchor),
        r.binding.mapping
      ), g = Wo(
        i,
        r.type,
        Oa(a.cursor.head),
        r.binding.mapping
      );
      if (B !== null && g !== null) {
        const h = cr(t.doc.content.size - 1, 0);
        B = Ui(B, h), g = Ui(g, h), o.push(
          Wt.widget(g, () => n(l, c), {
            key: c + "",
            side: 10
          })
        );
        const u = Ui(B, g), d = cr(B, g);
        o.push(
          Wt.inline(u, d, s(l, c), {
            inclusiveEnd: !0,
            inclusiveStart: !1
          })
        );
      }
    }
  }), It.create(t.doc, o));
}, C_ = (t, {
  awarenessStateFilter: e = f_,
  cursorBuilder: A = Q_,
  selectionBuilder: n = Qb,
  getSelection: s = (i) => i.selection
} = {}, r = "cursor") => new ct({
  key: I0,
  state: {
    init(i, o) {
      return QF(
        o,
        t,
        e,
        A,
        n
      );
    },
    apply(i, o, a, c) {
      const l = vt.getState(c), B = i.getMeta(I0);
      return l && l.isChangeOrigin || B && B.awarenessUpdated ? QF(
        c,
        t,
        e,
        A,
        n
      ) : o.map(i.mapping, i.doc);
    }
  },
  props: {
    decorations: (i) => I0.getState(i)
  },
  view: (i) => {
    const o = () => {
      i.docView && u_(i, I0, { awarenessUpdated: !0 });
    }, a = () => {
      const c = vt.getState(i.state), l = t.getLocalState() || {};
      if (i.hasFocus()) {
        const B = s(i.state), g = Aa(
          B.anchor,
          c.type,
          c.binding.mapping
        ), h = Aa(
          B.head,
          c.type,
          c.binding.mapping
        );
        (l.cursor == null || !Gd(
          Oa(l.cursor.anchor),
          g
        ) || !Gd(
          Oa(l.cursor.head),
          h
        )) && t.setLocalStateField(r, {
          anchor: g,
          head: h
        });
      } else l.cursor != null && Wo(
        c.doc,
        c.type,
        Oa(l.cursor.anchor),
        c.binding.mapping
      ) !== null && t.setLocalStateField(r, null);
    };
    return t.on("change", o), i.dom.addEventListener("focusin", a), i.dom.addEventListener("focusout", a), {
      update: a,
      destroy: () => {
        i.dom.removeEventListener("focusin", a), i.dom.removeEventListener("focusout", a), t.off("change", o), t.setLocalStateField(r, null);
      }
    };
  }
}), E_ = (t) => {
  const e = vi.getState(t).undoManager;
  if (e != null)
    return e.undo(), !0;
}, M_ = (t) => {
  const e = vi.getState(t).undoManager;
  if (e != null)
    return e.redo(), !0;
}, p_ = /* @__PURE__ */ new Set(["paragraph"]), m_ = (t, e) => !(t instanceof jt) || !(t.content instanceof hr) || !(t.content.type instanceof ta || t.content.type instanceof sn && e.has(t.content.type.nodeName)) || t.content.type._length === 0, Y_ = ({ protectedNodes: t = p_, trackedOrigins: e = [], undoManager: A = null } = {}) => new ct({
  key: vi,
  state: {
    init: (n, s) => {
      const r = vt.getState(s), i = A || new PU(r.type, {
        trackedOrigins: new Set([vt].concat(e)),
        deleteFilter: (o) => m_(o, t),
        captureTransaction: (o) => o.meta.get("addToHistory") !== !1
      });
      return {
        undoManager: i,
        prevSel: null,
        hasUndoOps: i.undoStack.length > 0,
        hasRedoOps: i.redoStack.length > 0
      };
    },
    /**
     * @returns {any}
     */
    apply: (n, s, r, i) => {
      const o = vt.getState(i).binding, a = s.undoManager, c = a.undoStack.length > 0, l = a.redoStack.length > 0;
      return o ? {
        undoManager: a,
        prevSel: ME(o, r),
        hasUndoOps: c,
        hasRedoOps: l
      } : c !== s.hasUndoOps || l !== s.hasRedoOps ? Object.assign({}, s, {
        hasUndoOps: a.undoStack.length > 0,
        hasRedoOps: a.redoStack.length > 0
      }) : s;
    }
  },
  view: (n) => {
    const s = vt.getState(n.state), r = vi.getState(n.state).undoManager;
    return r.on("stack-item-added", ({ stackItem: i }) => {
      const o = s.binding;
      o && i.meta.set(o, vi.getState(n.state).prevSel);
    }), r.on("stack-item-popped", ({ stackItem: i }) => {
      const o = s.binding;
      o && (o.beforeTransactionSelection = i.meta.get(o) || o.beforeTransactionSelection);
    }), {
      destroy: () => {
        r.destroy();
      }
    };
  }
});
function Ib(t) {
  return !!t.getMeta(vt);
}
function y_(t, e) {
  const A = vt.getState(t);
  return Wo(A.doc, A.type, e, A.binding.mapping) || 0;
}
function Cb(t, e) {
  const A = vt.getState(t);
  return Aa(e, A.type, A.binding.mapping);
}
var cu = class Eb extends lp {
  constructor(e, A) {
    super(e), this.yRelativePosition = A;
  }
  /**
   * Creates a CollaborationMappablePosition from a JSON object.
   */
  static fromJSON(e) {
    return new Eb(e.position, e.yRelativePosition);
  }
  /**
   * Converts the CollaborationMappablePosition to a JSON object.
   */
  toJSON() {
    return {
      position: this.position,
      yRelativePosition: this.yRelativePosition
    };
  }
};
function F_(t, e) {
  const A = Cb(e, t);
  return new cu(t, A);
}
function N_(t, e, A) {
  const n = t instanceof cu ? t.yRelativePosition : null;
  if (Ib(e) && n) {
    const i = y_(A, n);
    return {
      position: new cu(i, n),
      mapResult: null
    };
  }
  const s = MG(t, e), r = s.position.position;
  return {
    position: new cu(
      r,
      n ?? Cb(A, r)
    ),
    mapResult: s.mapResult
  };
}
var D_ = tt.create({
  name: "collaboration",
  priority: 1e3,
  addOptions() {
    return {
      document: null,
      field: "default",
      fragment: null,
      provider: null
    };
  },
  addStorage() {
    return {
      isDisabled: !1
    };
  },
  onCreate() {
    this.editor.extensionManager.extensions.find((t) => t.name === "undoRedo") && console.warn(
      '[tiptap warn]: "@tiptap/extension-collaboration" comes with its own history support and is not compatible with "@tiptap/extension-undo-redo".'
    );
  },
  onBeforeCreate() {
    this.editor.utils.getUpdatedPosition = (t, e) => N_(t, e, this.editor.state), this.editor.utils.createMappablePosition = (t) => F_(t, this.editor.state);
  },
  addCommands() {
    return {
      undo: () => ({ tr: t, state: e, dispatch: A }) => (t.setMeta("preventDispatch", !0), vi.getState(e).undoManager.undoStack.length === 0 ? !1 : A ? E_(e) : !0),
      redo: () => ({ tr: t, state: e, dispatch: A }) => (t.setMeta("preventDispatch", !0), vi.getState(e).undoManager.redoStack.length === 0 ? !1 : A ? M_(e) : !0)
    };
  },
  addKeyboardShortcuts() {
    return {
      "Mod-z": () => this.editor.commands.undo(),
      "Mod-y": () => this.editor.commands.redo(),
      "Shift-Mod-z": () => this.editor.commands.redo()
    };
  },
  addProseMirrorPlugins() {
    var t;
    const e = this.options.fragment ? this.options.fragment : this.options.document.getXmlFragment(this.options.field), A = Y_(this.options.yUndoOptions), n = A.spec.view;
    A.spec.view = (i) => {
      const { undoManager: o } = vi.getState(i.state);
      o.restore && (o.restore(), o.restore = () => {
      });
      const a = n ? n(i) : void 0;
      return {
        destroy: () => {
          const c = o.trackedOrigins.has(o), l = o._observers;
          o.restore = () => {
            c && o.trackedOrigins.add(o), o.doc.on("afterTransaction", o.afterTransactionHandler), o._observers = l;
          }, a != null && a.destroy && a.destroy();
        }
      };
    };
    const s = {
      ...this.options.ySyncOptions,
      onFirstRender: this.options.onFirstRender
    }, r = A_(e, s);
    return this.editor.options.enableContentCheck && ((t = e.doc) == null || t.on("beforeTransaction", () => {
      try {
        const i = w_(e);
        if (i.content.length === 0)
          return;
        this.editor.schema.nodeFromJSON(i).check();
      } catch (i) {
        return this.editor.emit("contentError", {
          error: i,
          editor: this.editor,
          disableCollaboration: () => {
            var o;
            (o = e.doc) == null || o.destroy(), this.storage.isDisabled = !0;
          }
        }), !1;
      }
    })), [
      r,
      A,
      // Only add the filterInvalidContent plugin if content checking is enabled
      this.editor.options.enableContentCheck && new ct({
        key: new Bt("filterInvalidContent"),
        filterTransaction: () => {
          var i;
          return this.storage.isDisabled !== !1 && ((i = e.doc) == null || i.destroy()), !0;
        }
      })
    ].filter(Boolean);
  }
}), x_ = D_;
function IF(t) {
  if (!t.length)
    return It.empty;
  const e = [], A = t[0].$from.node(0);
  return t.forEach((n) => {
    const s = n.$from.pos, r = n.$from.nodeAfter;
    r && e.push(
      Wt.node(s, s + r.nodeSize, {
        class: "ProseMirror-selectednoderange"
      })
    );
  }), It.create(A, e);
}
function $w(t, e, A) {
  const n = [], s = t.node(0);
  typeof A == "number" && A >= 0 || (t.sameParent(e) ? A = Math.max(0, t.sharedDepth(e.pos) - 1) : A = t.sharedDepth(e.pos));
  const r = new Ql(t, e, A), i = r.depth === 0 ? 0 : s.resolve(r.start).posAtIndex(0);
  return r.parent.forEach((o, a) => {
    const c = i + a, l = c + o.nodeSize;
    if (c < r.start || c >= r.end)
      return;
    const B = new LM(s.resolve(c), s.resolve(l));
    n.push(B);
  }), n;
}
var G_ = class Mb {
  constructor(e, A) {
    this.anchor = e, this.head = A;
  }
  map(e) {
    return new Mb(e.map(this.anchor), e.map(this.head));
  }
  resolve(e) {
    const A = e.resolve(this.anchor), n = e.resolve(this.head);
    return new Ho(A, n);
  }
}, Ho = class fo extends Ke {
  constructor(e, A, n, s = 1) {
    const { doc: r } = e, i = e === A, o = e.pos === r.content.size && A.pos === r.content.size, a = i && !o ? r.resolve(A.pos + (s > 0 ? 1 : -1)) : A, c = i && o ? r.resolve(e.pos - (s > 0 ? 1 : -1)) : e, l = $w(c.min(a), c.max(a), n), B = a.pos >= e.pos ? l[0].$from : l[l.length - 1].$to, g = a.pos >= e.pos ? l[l.length - 1].$to : l[0].$from;
    super(B, g, l), this.depth = n;
  }
  // we can safely ignore this TypeScript error: https://github.com/Microsoft/TypeScript/issues/338
  // @ts-ignore
  get $to() {
    return this.ranges[this.ranges.length - 1].$to;
  }
  eq(e) {
    return e instanceof fo && e.$from.pos === this.$from.pos && e.$to.pos === this.$to.pos;
  }
  map(e, A) {
    const n = e.resolve(A.map(this.anchor)), s = e.resolve(A.map(this.head));
    return new fo(n, s);
  }
  toJSON() {
    return {
      type: "nodeRange",
      anchor: this.anchor,
      head: this.head
    };
  }
  get isForwards() {
    return this.head >= this.anchor;
  }
  get isBackwards() {
    return !this.isForwards;
  }
  extendBackwards() {
    const { doc: e } = this.$from;
    if (this.isForwards && this.ranges.length > 1) {
      const s = this.ranges.slice(0, -1), r = s[0].$from, i = s[s.length - 1].$to;
      return new fo(r, i, this.depth);
    }
    const A = this.ranges[0], n = e.resolve(Math.max(0, A.$from.pos - 1));
    return new fo(this.$anchor, n, this.depth);
  }
  extendForwards() {
    const { doc: e } = this.$from;
    if (this.isBackwards && this.ranges.length > 1) {
      const s = this.ranges.slice(1), r = s[0].$from, i = s[s.length - 1].$to;
      return new fo(i, r, this.depth);
    }
    const A = this.ranges[this.ranges.length - 1], n = e.resolve(Math.min(e.content.size, A.$to.pos + 1));
    return new fo(this.$anchor, n, this.depth);
  }
  static fromJSON(e, A) {
    return new fo(e.resolve(A.anchor), e.resolve(A.head));
  }
  static create(e, A, n, s, r = 1) {
    return new this(e.resolve(A), e.resolve(n), s, r);
  }
  getBookmark() {
    return new G_(this.anchor, this.head);
  }
};
Ho.prototype.visible = !1;
function C0(t) {
  return t instanceof Ho;
}
tt.create({
  name: "nodeRange",
  addOptions() {
    return {
      depth: void 0,
      key: "Mod"
    };
  },
  addKeyboardShortcuts() {
    return {
      // extend NodeRangeSelection upwards
      "Shift-ArrowUp": ({ editor: t }) => {
        const { depth: e } = this.options, { view: A, state: n } = t, { doc: s, selection: r, tr: i } = n, { anchor: o, head: a } = r;
        if (!C0(r)) {
          const l = Ho.create(s, o, a, e, -1);
          return i.setSelection(l), A.dispatch(i), !0;
        }
        const c = r.extendBackwards();
        return i.setSelection(c), A.dispatch(i), !0;
      },
      // extend NodeRangeSelection downwards
      "Shift-ArrowDown": ({ editor: t }) => {
        const { depth: e } = this.options, { view: A, state: n } = t, { doc: s, selection: r, tr: i } = n, { anchor: o, head: a } = r;
        if (!C0(r)) {
          const l = Ho.create(s, o, a, e);
          return i.setSelection(l), A.dispatch(i), !0;
        }
        const c = r.extendForwards();
        return i.setSelection(c), A.dispatch(i), !0;
      },
      // add `NodeRangeSelection` to all nodes
      "Mod-a": ({ editor: t }) => {
        const { depth: e } = this.options, { view: A, state: n } = t, { doc: s, tr: r } = n, i = Ho.create(s, 0, s.content.size, e);
        return r.setSelection(i), A.dispatch(r), !0;
      }
    };
  },
  onSelectionUpdate() {
    const { selection: t } = this.editor.state;
    C0(t) && this.editor.view.dom.classList.add("ProseMirror-noderangeselection");
  },
  addProseMirrorPlugins() {
    let t = !1, e = !1;
    return [
      new ct({
        key: new Bt("nodeRange"),
        props: {
          attributes: () => t ? {
            class: "ProseMirror-noderangeselection"
          } : { class: "" },
          handleDOMEvents: {
            mousedown: (A, n) => {
              const { key: s } = this.options, r = /Mac/.test(navigator.platform), i = !!n.shiftKey, o = !!n.ctrlKey, a = !!n.altKey, c = !!n.metaKey, l = r ? c : o;
              return (s == null || s === "Shift" && i || s === "Control" && o || s === "Alt" && a || s === "Meta" && c || s === "Mod" && l) && (e = !0), e && document.addEventListener(
                "mouseup",
                () => {
                  e = !1;
                  const { state: B } = A, { doc: g, selection: h, tr: u } = B, { $anchor: d, $head: w } = h;
                  if (d.sameParent(w))
                    return;
                  const Q = Ho.create(g, d.pos, w.pos, this.options.depth);
                  u.setSelection(Q), A.dispatch(u);
                },
                { once: !0 }
              ), !1;
            }
          },
          // when selecting some text we want to render some decorations
          // to preview a `NodeRangeSelection`
          decorations: (A) => {
            const { selection: n } = A, s = C0(n);
            if (t = !1, !e)
              return s ? (t = !0, IF(n.ranges)) : null;
            const { $from: r, $to: i } = n;
            if (!s && r.sameParent(i))
              return null;
            const o = $w(r, i, this.options.depth);
            return o.length ? (t = !0, IF(o)) : null;
          }
        }
      })
    ];
  }
});
function z_(t) {
  let e = "";
  const A = getComputedStyle(t);
  for (let n = 0; n < A.length; n += 1)
    e += `${A[n]}:${A.getPropertyValue(A[n])};`;
  return e;
}
function U_(t) {
  const e = t.cloneNode(!0), A = [t, ...Array.from(t.getElementsByTagName("*"))], n = [e, ...Array.from(e.getElementsByTagName("*"))];
  return A.forEach((s, r) => {
    n[r].style.cssText = z_(s);
  }), e;
}
var b_ = {
  id: "listItemFirstChild",
  evaluate: ({ parent: t, isFirst: e }) => e && t && ["listItem", "taskItem"].includes(t.type.name) ? 1e3 : 0
}, v_ = {
  id: "listWrapperDeprioritize",
  evaluate: ({ node: t }) => {
    const e = ["listItem", "taskItem"], A = t.firstChild;
    return A && e.includes(A.type.name) ? 1e3 : 0;
  }
}, j_ = {
  id: "tableStructure",
  evaluate: ({ node: t, parent: e }) => ["tableRow", "tableCell", "tableHeader"].includes(t.type.name) || e && e.type.name === "tableHeader" ? 1e3 : 0
}, H_ = {
  id: "inlineContent",
  evaluate: ({ node: t }) => t.isInline || t.isText ? 1e3 : 0
}, k_ = [
  b_,
  v_,
  j_,
  H_
], CF = {
  edges: ["left", "top"],
  threshold: 12,
  strength: 500
};
function tI(t) {
  return t === void 0 || t === "left" ? { ...CF } : t === "right" ? { edges: ["right", "top"], threshold: 12, strength: 500 } : t === "both" ? { edges: ["left", "right", "top"], threshold: 12, strength: 500 } : t === "none" ? { edges: [], threshold: 0, strength: 0 } : { ...CF, ...t };
}
function R_(t, e, A) {
  if (A.edges.length === 0)
    return !1;
  const n = e.getBoundingClientRect(), { threshold: s, edges: r } = A;
  return r.some((i) => i === "left" ? t.x - n.left < s : i === "right" ? n.right - t.x < s : i === "top" ? t.y - n.top < s : i === "bottom" ? n.bottom - t.y < s : !1);
}
function L_(t, e, A, n) {
  return !e || A.edges.length === 0 ? 0 : R_(t, e, A) ? A.strength * n : 0;
}
var S_ = 1e3;
function EF(t, e, A, n) {
  let s = S_, r = !1;
  if (e.every((o) => {
    const a = o.evaluate(t);
    return s -= a, s <= 0 ? (r = !0, !1) : !0;
  }), r)
    return -1;
  const i = t.view.nodeDOM(t.pos);
  return s -= L_(n, i, A, t.depth), s <= 0 ? -1 : s;
}
function MF(t, e, A) {
  return Array.from({ length: e }, (s, r) => e - 1 - r).some((s) => A.includes(t.node(s).type.name));
}
function T_(t, e, A) {
  if (!Number.isFinite(e.x) || !Number.isFinite(e.y))
    return null;
  const n = t.posAtCoords({ left: e.x, top: e.y });
  if (!n)
    return null;
  const { doc: s } = t.state, r = s.resolve(n.pos), i = [];
  A.defaultRules && i.push(...k_), i.push(...A.rules);
  const a = Array.from({ length: r.depth }, (B, g) => r.depth - g).map((B) => {
    const g = r.node(B), h = r.before(B);
    if (A.allowedContainers && B > 0 && !MF(r, B, A.allowedContainers))
      return null;
    const u = B > 0 ? r.node(B - 1) : null, d = B > 0 ? r.index(B - 1) : 0, w = u ? u.childCount : 1, Q = {
      node: g,
      pos: h,
      depth: B,
      parent: u,
      index: d,
      isFirst: d === 0,
      isLast: d === w - 1,
      $pos: r,
      view: t
    }, p = EF(Q, i, A.edgeDetection, e);
    if (p < 0)
      return null;
    const M = t.nodeDOM(h);
    return { node: g, pos: h, depth: B, score: p, dom: M };
  }).filter((B) => B !== null), c = r.nodeAfter;
  if (c && c.isAtom && !c.isInline) {
    const B = n.pos, g = r.depth + 1, h = r.parent, u = r.index(), d = h.childCount;
    let w = !0;
    if (A.allowedContainers && (w = MF(r, g, A.allowedContainers)), w) {
      const Q = {
        node: c,
        pos: B,
        depth: g,
        parent: h,
        index: u,
        isFirst: u === 0,
        isLast: u === d - 1,
        $pos: r,
        view: t
      }, p = EF(Q, i, A.edgeDetection, e);
      if (p >= 0) {
        const M = t.nodeDOM(B);
        M && a.push({ node: c, pos: B, depth: g, score: p, dom: M });
      }
    }
  }
  if (a.length === 0)
    return null;
  a.sort((B, g) => g.score !== B.score ? g.score - B.score : g.depth - B.depth);
  const l = a[0];
  return l.dom ? {
    node: l.node,
    pos: l.pos,
    dom: l.dom
  } : null;
}
function J_(t, e) {
  let A = t;
  for (; A != null && A.parentElement && A.parentElement !== e.dom; )
    A = A.parentElement;
  return (A == null ? void 0 : A.parentElement) === e.dom ? A : void 0;
}
function pF(t) {
  return Number.isFinite(t.top) && Number.isFinite(t.bottom) && Number.isFinite(t.left) && Number.isFinite(t.right) && t.width > 0 && t.height > 0;
}
function W_(t, e, A, n = 5) {
  if (!Number.isFinite(e) || !Number.isFinite(A))
    return null;
  const s = t.dom, r = s.firstElementChild, i = s.lastElementChild;
  if (!r || !i)
    return null;
  const o = r.getBoundingClientRect(), a = i.getBoundingClientRect();
  if (!pF(o) || !pF(a))
    return null;
  const c = Math.min(Math.max(o.top + n, A), a.bottom - n), l = 0.5, B = Math.abs(o.left - a.left) < l, g = Math.abs(o.right - a.right) < l;
  let h = o;
  B && g && (h = o);
  const u = Math.min(Math.max(h.left + n, e), h.right - n);
  return !Number.isFinite(u) || !Number.isFinite(c) ? null : { x: u, y: c };
}
var pb = (t) => {
  const { x: e, y: A, editor: n, nestedOptions: s } = t, { view: r, state: i } = n, o = W_(r, e, A, 5);
  if (!o)
    return { resultElement: null, resultNode: null, pos: null };
  const { x: a, y: c } = o;
  if (s != null && s.enabled) {
    const u = T_(r, { x: a, y: c }, s);
    return u ? {
      resultElement: u.dom,
      resultNode: u.node,
      pos: u.pos
    } : { resultElement: null, resultNode: null, pos: null };
  }
  const l = r.root.elementsFromPoint(a, c);
  let B;
  if (Array.prototype.some.call(l, (u) => {
    if (!r.dom.contains(u))
      return !1;
    const d = J_(u, r);
    return d ? (B = d, !0) : !1;
  }), !B)
    return { resultElement: null, resultNode: null, pos: null };
  let g;
  try {
    g = r.posAtDOM(B, 0);
  } catch {
    return { resultElement: null, resultNode: null, pos: null };
  }
  const h = i.doc.nodeAt(g);
  if (!h) {
    const u = i.doc.resolve(g), d = u.parent;
    return {
      resultElement: B,
      resultNode: d,
      pos: u.start()
    };
  }
  return {
    resultElement: B,
    resultNode: h,
    pos: g
  };
};
function mb(t) {
  var e;
  (e = t.parentNode) == null || e.removeChild(t);
}
function O_(t, e, A, n) {
  const { doc: s } = e.view.state;
  if (A != null && A.enabled && (n != null && n.node) && n.pos >= 0) {
    const c = n.pos, l = n.pos + n.node.nodeSize;
    return [
      {
        $from: s.resolve(c),
        $to: s.resolve(l)
      }
    ];
  }
  const r = pb({
    editor: e,
    x: t.clientX,
    y: t.clientY,
    nestedOptions: A
  });
  if (!r.resultNode || r.pos === null)
    return [];
  const i = r.resultNode.isText || r.resultNode.isAtom ? 0 : -1, o = s.resolve(r.pos), a = s.resolve(r.pos + r.resultNode.nodeSize + i);
  return $w(o, a, 0);
}
function P_(t, e, A, n) {
  const { view: s } = e;
  if (!t.dataTransfer)
    return;
  const { empty: r, $from: i, $to: o } = s.state.selection, a = O_(t, e, A, n), c = $w(i, o, 0), l = c.some((I) => a.find((N) => N.$from === I.$from && N.$to === I.$to)), B = r || !l ? a : c;
  if (!B.length)
    return;
  const { tr: g } = s.state, h = document.createElement("div"), u = B[0].$from.pos, d = B[B.length - 1].$to.pos, w = (A == null ? void 0 : A.enabled) && (n == null ? void 0 : n.node);
  let Q, p;
  w ? (Q = s.state.doc.slice(u, d), p = Ue.create(s.state.doc, u)) : (p = Ho.create(s.state.doc, u, d), Q = p.content()), B.forEach((I) => {
    const N = s.nodeDOM(I.$from.pos), m = U_(N);
    h.append(m);
  }), h.style.position = "absolute", h.style.top = "-10000px", document.body.append(h), t.dataTransfer.clearData(), t.dataTransfer.setDragImage(h, 0, 0);
  const M = p instanceof Ue ? p : void 0;
  s.dragging = { slice: Q, move: !0, node: M }, g.setSelection(p), s.dispatch(g), document.addEventListener("drop", () => mb(h), { once: !0 });
}
var mF = (t, e) => {
  const A = t.resolve(e), { depth: n } = A;
  return n === 0 ? e : A.pos - A.parentOffset - 1;
}, YF = (t, e) => {
  const A = t.nodeAt(e), n = t.resolve(e);
  let { depth: s } = n, r = A;
  for (; s > 0; ) {
    const i = n.node(s);
    s -= 1, s === 0 && (r = i);
  }
  return r;
}, AI = (t, e) => {
  const A = vt.getState(t);
  return A ? Aa(e, A.type, A.binding.mapping) : null;
}, K_ = (t, e) => {
  const A = vt.getState(t);
  return A ? Wo(A.doc, A.type, e, A.binding.mapping) || 0 : -1;
}, yF = (t, e) => {
  let A = e;
  for (; A != null && A.parentNode && A.parentNode !== t.dom; )
    A = A.parentNode;
  return A;
}, V_ = new Bt("dragHandle"), X_ = ({
  pluginKey: t = V_,
  element: e,
  editor: A,
  computePositionConfig: n,
  getReferencedVirtualElement: s,
  onNodeChange: r,
  onElementDragStart: i,
  onElementDragEnd: o,
  nestedOptions: a
}) => {
  const c = document.createElement("div");
  let l = !1, B = null, g = -1, h, u = null, d = null;
  function w() {
    e && (e.style.visibility = "hidden", e.style.pointerEvents = "none");
  }
  function Q() {
    if (e) {
      if (!A.isEditable) {
        w();
        return;
      }
      e.style.visibility = "", e.style.pointerEvents = "auto";
    }
  }
  function p(m) {
    const E = (s == null ? void 0 : s()) || {
      getBoundingClientRect: () => m.getBoundingClientRect()
    };
    tz(E, e, n).then((G) => {
      Object.assign(e.style, {
        position: G.strategy,
        left: `${G.x}px`,
        top: `${G.y}px`
      });
    });
  }
  function M(m) {
    i == null || i(m), P_(m, A, a, { node: B, pos: g }), e && (e.dataset.dragging = "true"), setTimeout(() => {
      e && (e.style.pointerEvents = "none");
    }, 0);
  }
  function I(m) {
    o == null || o(m), w(), e && (e.style.pointerEvents = "auto", e.dataset.dragging = "false");
  }
  function N() {
    if (PJ()) {
      const m = A.view.dom;
      requestAnimationFrame(() => {
        m.isContentEditable && (m.contentEditable = "false", m.contentEditable = "true");
      });
    }
  }
  return e.addEventListener("dragstart", M), e.addEventListener("dragend", I), document.addEventListener("drop", N), c.appendChild(e), {
    unbind() {
      e.removeEventListener("dragstart", M), e.removeEventListener("dragend", I), document.removeEventListener("drop", N), u && (cancelAnimationFrame(u), u = null, d = null);
    },
    plugin: new ct({
      key: typeof t == "string" ? new Bt(t) : t,
      state: {
        init() {
          return { locked: !1 };
        },
        apply(m, E, G, Y) {
          const U = m.getMeta("lockDragHandle"), v = m.getMeta("hideDragHandle");
          if (U !== void 0 && (l = U), v)
            return w(), l = !1, B = null, g = -1, r == null || r({ editor: A, node: null, pos: -1 }), E;
          if (m.docChanged && g !== -1 && e)
            if (Ib(m)) {
              const b = K_(Y, h);
              b !== g && (g = b);
            } else {
              const b = m.mapping.map(g);
              b !== g && (g = b, h = AI(Y, g));
            }
          return E;
        }
      },
      view: (m) => {
        var E;
        return e.draggable = !0, e.style.pointerEvents = "auto", e.dataset.dragging = "false", (E = A.view.dom.parentElement) == null || E.appendChild(c), c.style.pointerEvents = "none", c.style.position = "absolute", c.style.top = "0", c.style.left = "0", {
          update(G, Y) {
            if (!e)
              return;
            if (!A.isEditable) {
              w();
              return;
            }
            if (l ? e.draggable = !1 : e.draggable = !0, m.state.doc.eq(Y.doc) || g === -1)
              return;
            let U = m.nodeDOM(g);
            if (U = yF(m, U), U === m.dom || (U == null ? void 0 : U.nodeType) !== 1)
              return;
            const v = m.posAtDOM(U, 0), b = YF(A.state.doc, v), W = mF(A.state.doc, v);
            B = b, g = W, h = AI(m.state, g), r == null || r({ editor: A, node: B, pos: g }), p(U);
          },
          // TODO: Kills even on hot reload
          destroy() {
            e.removeEventListener("dragstart", M), e.removeEventListener("dragend", I), document.removeEventListener("drop", N), u && (cancelAnimationFrame(u), u = null, d = null), e && mb(c);
          }
        };
      },
      props: {
        handleDOMEvents: {
          keydown(m) {
            return !e || l || m.hasFocus() && (w(), B = null, g = -1, r == null || r({ editor: A, node: null, pos: -1 })), !1;
          },
          mouseleave(m, E) {
            return l || E.target && !c.contains(E.relatedTarget) && (w(), B = null, g = -1, r == null || r({ editor: A, node: null, pos: -1 })), !1;
          },
          mousemove(m, E) {
            return !e || l || (d = { x: E.clientX, y: E.clientY }, u) || (u = requestAnimationFrame(() => {
              if (u = null, !d)
                return;
              const { x: G, y: Y } = d;
              d = null;
              const U = pb({
                x: G,
                y: Y,
                editor: A,
                nestedOptions: a
              });
              if (!U.resultElement)
                return;
              let v = U.resultElement, b = U.resultNode, W = U.pos;
              if (!(a != null && a.enabled)) {
                if (v = yF(m, v), v === m.dom || (v == null ? void 0 : v.nodeType) !== 1)
                  return;
                const q = m.posAtDOM(v, 0);
                b = YF(A.state.doc, q), W = mF(A.state.doc, q);
              }
              b !== B && (B = b, g = W ?? -1, h = AI(m.state, g), r == null || r({ editor: A, node: B, pos: g }), p(v), Q());
            })), !1;
          }
        }
      }
    })
  };
};
function Z_(t) {
  var e, A;
  return t === !1 || t === void 0 ? {
    enabled: !1,
    rules: [],
    defaultRules: !0,
    allowedContainers: void 0,
    edgeDetection: tI("none")
  } : t === !0 ? {
    enabled: !0,
    rules: [],
    defaultRules: !0,
    allowedContainers: void 0,
    edgeDetection: tI("left")
  } : {
    enabled: !0,
    rules: (e = t.rules) != null ? e : [],
    defaultRules: (A = t.defaultRules) != null ? A : !0,
    allowedContainers: t.allowedContainers,
    edgeDetection: tI(t.edgeDetection)
  };
}
var q_ = {
  placement: "left-start",
  strategy: "absolute"
}, __ = tt.create({
  name: "dragHandle",
  addOptions() {
    return {
      render() {
        const t = document.createElement("div");
        return t.classList.add("drag-handle"), t;
      },
      computePositionConfig: {},
      locked: !1,
      onNodeChange: () => null,
      onElementDragStart: void 0,
      onElementDragEnd: void 0,
      nested: !1
    };
  },
  addCommands() {
    return {
      lockDragHandle: () => ({ editor: t }) => (this.options.locked = !0, t.commands.setMeta("lockDragHandle", this.options.locked)),
      unlockDragHandle: () => ({ editor: t }) => (this.options.locked = !1, t.commands.setMeta("lockDragHandle", this.options.locked)),
      toggleDragHandle: () => ({ editor: t }) => (this.options.locked = !this.options.locked, t.commands.setMeta("lockDragHandle", this.options.locked))
    };
  },
  addProseMirrorPlugins() {
    const t = this.options.render(), e = Z_(this.options.nested);
    return [
      X_({
        computePositionConfig: { ...q_, ...this.options.computePositionConfig },
        getReferencedVirtualElement: this.options.getReferencedVirtualElement,
        element: t,
        editor: this.editor,
        onNodeChange: this.options.onNodeChange,
        onElementDragStart: this.options.onElementDragStart,
        onElementDragEnd: this.options.onElementDragEnd,
        nestedOptions: e
      }).plugin
    ];
  }
}), $_ = __;
class On {
  // The + prefix indicates that these fields aren't writeable
  // Lexer holding the input string.
  // Start offset, zero-based inclusive.
  // End offset, zero-based exclusive.
  constructor(e, A, n) {
    this.lexer = void 0, this.start = void 0, this.end = void 0, this.lexer = e, this.start = A, this.end = n;
  }
  /**
   * Merges two `SourceLocation`s from location providers, given they are
   * provided in order of appearance.
   * - Returns the first one's location if only the first is provided.
   * - Returns a merged range of the first and the last if both are provided
   *   and their lexers match.
   * - Otherwise, returns null.
   */
  static range(e, A) {
    return A ? !e || !e.loc || !A.loc || e.loc.lexer !== A.loc.lexer ? null : new On(e.loc.lexer, e.loc.start, A.loc.end) : e && e.loc;
  }
}
class ds {
  // don't expand the token
  // used in \noexpand
  constructor(e, A) {
    this.text = void 0, this.loc = void 0, this.noexpand = void 0, this.treatAsRelax = void 0, this.text = e, this.loc = A;
  }
  /**
   * Given a pair of tokens (this and endToken), compute a `Token` encompassing
   * the whole input range enclosed by these two.
   */
  range(e, A) {
    return new ds(A, On.range(this, e));
  }
}
class de {
  // Error start position based on passed-in Token or ParseNode.
  // Length of affected text based on passed-in Token or ParseNode.
  // The underlying error message without any context added.
  constructor(e, A) {
    this.name = void 0, this.position = void 0, this.length = void 0, this.rawMessage = void 0;
    var n = "KaTeX parse error: " + e, s, r, i = A && A.loc;
    if (i && i.start <= i.end) {
      var o = i.lexer.input;
      s = i.start, r = i.end, s === o.length ? n += " at end of input: " : n += " at position " + (s + 1) + ": ";
      var a = o.slice(s, r).replace(/[^]/g, "$&̲"), c;
      s > 15 ? c = "…" + o.slice(s - 15, s) : c = o.slice(0, s);
      var l;
      r + 15 < o.length ? l = o.slice(r, r + 15) + "…" : l = o.slice(r), n += c + a + l;
    }
    var B = new Error(n);
    return B.name = "ParseError", B.__proto__ = de.prototype, B.position = s, s != null && r != null && (B.length = r - s), B.rawMessage = e, B;
  }
}
de.prototype.__proto__ = Error.prototype;
var e$ = function(e, A) {
  return e === void 0 ? A : e;
}, t$ = /([A-Z])/g, A$ = function(e) {
  return e.replace(t$, "-$1").toLowerCase();
}, n$ = {
  "&": "&amp;",
  ">": "&gt;",
  "<": "&lt;",
  '"': "&quot;",
  "'": "&#x27;"
}, s$ = /[&><"']/g;
function r$(t) {
  return String(t).replace(s$, (e) => n$[e]);
}
var Yb = function t(e) {
  return e.type === "ordgroup" || e.type === "color" ? e.body.length === 1 ? t(e.body[0]) : e : e.type === "font" ? t(e.body) : e;
}, i$ = function(e) {
  var A = Yb(e);
  return A.type === "mathord" || A.type === "textord" || A.type === "atom";
}, o$ = function(e) {
  if (!e)
    throw new Error("Expected non-null, but got " + String(e));
  return e;
}, a$ = function(e) {
  var A = /^[\x00-\x20]*([^\\/#?]*?)(:|&#0*58|&#x0*3a|&colon)/i.exec(e);
  return A ? A[2] !== ":" || !/^[a-zA-Z][a-zA-Z0-9+\-.]*$/.test(A[1]) ? null : A[1].toLowerCase() : "_relative";
}, Dt = {
  deflt: e$,
  escape: r$,
  hyphenate: A$,
  getBaseElem: Yb,
  isCharacterBox: i$,
  protocolFromUrl: a$
}, lu = {
  displayMode: {
    type: "boolean",
    description: "Render math in display mode, which puts the math in display style (so \\int and \\sum are large, for example), and centers the math on the page on its own line.",
    cli: "-d, --display-mode"
  },
  output: {
    type: {
      enum: ["htmlAndMathml", "html", "mathml"]
    },
    description: "Determines the markup language of the output.",
    cli: "-F, --format <type>"
  },
  leqno: {
    type: "boolean",
    description: "Render display math in leqno style (left-justified tags)."
  },
  fleqn: {
    type: "boolean",
    description: "Render display math flush left."
  },
  throwOnError: {
    type: "boolean",
    default: !0,
    cli: "-t, --no-throw-on-error",
    cliDescription: "Render errors (in the color given by --error-color) instead of throwing a ParseError exception when encountering an error."
  },
  errorColor: {
    type: "string",
    default: "#cc0000",
    cli: "-c, --error-color <color>",
    cliDescription: "A color string given in the format 'rgb' or 'rrggbb' (no #). This option determines the color of errors rendered by the -t option.",
    cliProcessor: (t) => "#" + t
  },
  macros: {
    type: "object",
    cli: "-m, --macro <def>",
    cliDescription: "Define custom macro of the form '\\foo:expansion' (use multiple -m arguments for multiple macros).",
    cliDefault: [],
    cliProcessor: (t, e) => (e.push(t), e)
  },
  minRuleThickness: {
    type: "number",
    description: "Specifies a minimum thickness, in ems, for fraction lines, `\\sqrt` top lines, `{array}` vertical lines, `\\hline`, `\\hdashline`, `\\underline`, `\\overline`, and the borders of `\\fbox`, `\\boxed`, and `\\fcolorbox`.",
    processor: (t) => Math.max(0, t),
    cli: "--min-rule-thickness <size>",
    cliProcessor: parseFloat
  },
  colorIsTextColor: {
    type: "boolean",
    description: "Makes \\color behave like LaTeX's 2-argument \\textcolor, instead of LaTeX's one-argument \\color mode change.",
    cli: "-b, --color-is-text-color"
  },
  strict: {
    type: [{
      enum: ["warn", "ignore", "error"]
    }, "boolean", "function"],
    description: "Turn on strict / LaTeX faithfulness mode, which throws an error if the input uses features that are not supported by LaTeX.",
    cli: "-S, --strict",
    cliDefault: !1
  },
  trust: {
    type: ["boolean", "function"],
    description: "Trust the input, enabling all HTML features such as \\url.",
    cli: "-T, --trust"
  },
  maxSize: {
    type: "number",
    default: 1 / 0,
    description: "If non-zero, all user-specified sizes, e.g. in \\rule{500em}{500em}, will be capped to maxSize ems. Otherwise, elements and spaces can be arbitrarily large",
    processor: (t) => Math.max(0, t),
    cli: "-s, --max-size <n>",
    cliProcessor: parseInt
  },
  maxExpand: {
    type: "number",
    default: 1e3,
    description: "Limit the number of macro expansions to the specified number, to prevent e.g. infinite macro loops. If set to Infinity, the macro expander will try to fully expand as in LaTeX.",
    processor: (t) => Math.max(0, t),
    cli: "-e, --max-expand <n>",
    cliProcessor: (t) => t === "Infinity" ? 1 / 0 : parseInt(t)
  },
  globalGroup: {
    type: "boolean",
    cli: !1
  }
};
function c$(t) {
  if (t.default)
    return t.default;
  var e = t.type, A = Array.isArray(e) ? e[0] : e;
  if (typeof A != "string")
    return A.enum[0];
  switch (A) {
    case "boolean":
      return !1;
    case "string":
      return "";
    case "number":
      return 0;
    case "object":
      return {};
  }
}
let om = class {
  constructor(e) {
    this.displayMode = void 0, this.output = void 0, this.leqno = void 0, this.fleqn = void 0, this.throwOnError = void 0, this.errorColor = void 0, this.macros = void 0, this.minRuleThickness = void 0, this.colorIsTextColor = void 0, this.strict = void 0, this.trust = void 0, this.maxSize = void 0, this.maxExpand = void 0, this.globalGroup = void 0, e = e || {};
    for (var A in lu)
      if (lu.hasOwnProperty(A)) {
        var n = lu[A];
        this[A] = e[A] !== void 0 ? n.processor ? n.processor(e[A]) : e[A] : c$(n);
      }
  }
  /**
   * Report nonstrict (non-LaTeX-compatible) input.
   * Can safely not be called if `this.strict` is false in JavaScript.
   */
  reportNonstrict(e, A, n) {
    var s = this.strict;
    if (typeof s == "function" && (s = s(e, A, n)), !(!s || s === "ignore")) {
      if (s === !0 || s === "error")
        throw new de("LaTeX-incompatible input and strict mode is set to 'error': " + (A + " [" + e + "]"), n);
      s === "warn" ? typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (A + " [" + e + "]")) : typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + s + "': " + A + " [" + e + "]"));
    }
  }
  /**
   * Check whether to apply strict (LaTeX-adhering) behavior for unusual
   * input (like `\\`).  Unlike `nonstrict`, will not throw an error;
   * instead, "error" translates to a return value of `true`, while "ignore"
   * translates to a return value of `false`.  May still print a warning:
   * "warn" prints a warning and returns `false`.
   * This is for the second category of `errorCode`s listed in the README.
   */
  useStrictBehavior(e, A, n) {
    var s = this.strict;
    if (typeof s == "function")
      try {
        s = s(e, A, n);
      } catch {
        s = "error";
      }
    return !s || s === "ignore" ? !1 : s === !0 || s === "error" ? !0 : s === "warn" ? (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to 'warn': " + (A + " [" + e + "]")), !1) : (typeof console < "u" && console.warn("LaTeX-incompatible input and strict mode is set to " + ("unrecognized '" + s + "': " + A + " [" + e + "]")), !1);
  }
  /**
   * Check whether to test potentially dangerous input, and return
   * `true` (trusted) or `false` (untrusted).  The sole argument `context`
   * should be an object with `command` field specifying the relevant LaTeX
   * command (as a string starting with `\`), and any other arguments, etc.
   * If `context` has a `url` field, a `protocol` field will automatically
   * get added by this function (changing the specified object).
   */
  isTrusted(e) {
    if (e.url && !e.protocol) {
      var A = Dt.protocolFromUrl(e.url);
      if (A == null)
        return !1;
      e.protocol = A;
    }
    var n = typeof this.trust == "function" ? this.trust(e) : this.trust;
    return !!n;
  }
}, go = class {
  constructor(e, A, n) {
    this.id = void 0, this.size = void 0, this.cramped = void 0, this.id = e, this.size = A, this.cramped = n;
  }
  /**
   * Get the style of a superscript given a base in the current style.
   */
  sup() {
    return yr[l$[this.id]];
  }
  /**
   * Get the style of a subscript given a base in the current style.
   */
  sub() {
    return yr[B$[this.id]];
  }
  /**
   * Get the style of a fraction numerator given the fraction in the current
   * style.
   */
  fracNum() {
    return yr[g$[this.id]];
  }
  /**
   * Get the style of a fraction denominator given the fraction in the current
   * style.
   */
  fracDen() {
    return yr[h$[this.id]];
  }
  /**
   * Get the cramped version of a style (in particular, cramping a cramped style
   * doesn't change the style).
   */
  cramp() {
    return yr[u$[this.id]];
  }
  /**
   * Get a text or display version of this style.
   */
  text() {
    return yr[d$[this.id]];
  }
  /**
   * Return true if this style is tightly spaced (scriptstyle/scriptscriptstyle)
   */
  isTight() {
    return this.size >= 2;
  }
};
var am = 0, Ld = 1, hl = 2, ji = 3, Xg = 4, xs = 5, Ul = 6, Fn = 7, yr = [new go(am, 0, !1), new go(Ld, 0, !0), new go(hl, 1, !1), new go(ji, 1, !0), new go(Xg, 2, !1), new go(xs, 2, !0), new go(Ul, 3, !1), new go(Fn, 3, !0)], l$ = [Xg, xs, Xg, xs, Ul, Fn, Ul, Fn], B$ = [xs, xs, xs, xs, Fn, Fn, Fn, Fn], g$ = [hl, ji, Xg, xs, Ul, Fn, Ul, Fn], h$ = [ji, ji, xs, xs, Fn, Fn, Fn, Fn], u$ = [Ld, Ld, ji, ji, xs, xs, Fn, Fn], d$ = [am, Ld, hl, ji, hl, ji, hl, ji], Je = {
  DISPLAY: yr[am],
  TEXT: yr[hl],
  SCRIPT: yr[Xg],
  SCRIPTSCRIPT: yr[Ul]
}, yE = [{
  // Latin characters beyond the Latin-1 characters we have metrics for.
  // Needed for Czech, Hungarian and Turkish text, for example.
  name: "latin",
  blocks: [
    [256, 591],
    // Latin Extended-A and Latin Extended-B
    [768, 879]
    // Combining Diacritical marks
  ]
}, {
  // The Cyrillic script used by Russian and related languages.
  // A Cyrillic subset used to be supported as explicitly defined
  // symbols in symbols.js
  name: "cyrillic",
  blocks: [[1024, 1279]]
}, {
  // Armenian
  name: "armenian",
  blocks: [[1328, 1423]]
}, {
  // The Brahmic scripts of South and Southeast Asia
  // Devanagari (0900–097F)
  // Bengali (0980–09FF)
  // Gurmukhi (0A00–0A7F)
  // Gujarati (0A80–0AFF)
  // Oriya (0B00–0B7F)
  // Tamil (0B80–0BFF)
  // Telugu (0C00–0C7F)
  // Kannada (0C80–0CFF)
  // Malayalam (0D00–0D7F)
  // Sinhala (0D80–0DFF)
  // Thai (0E00–0E7F)
  // Lao (0E80–0EFF)
  // Tibetan (0F00–0FFF)
  // Myanmar (1000–109F)
  name: "brahmic",
  blocks: [[2304, 4255]]
}, {
  name: "georgian",
  blocks: [[4256, 4351]]
}, {
  // Chinese and Japanese.
  // The "k" in cjk is for Korean, but we've separated Korean out
  name: "cjk",
  blocks: [
    [12288, 12543],
    // CJK symbols and punctuation, Hiragana, Katakana
    [19968, 40879],
    // CJK ideograms
    [65280, 65376]
    // Fullwidth punctuation
    // TODO: add halfwidth Katakana and Romanji glyphs
  ]
}, {
  // Korean
  name: "hangul",
  blocks: [[44032, 55215]]
}];
function w$(t) {
  for (var e = 0; e < yE.length; e++)
    for (var A = yE[e], n = 0; n < A.blocks.length; n++) {
      var s = A.blocks[n];
      if (t >= s[0] && t <= s[1])
        return A.name;
    }
  return null;
}
var Bu = [];
yE.forEach((t) => t.blocks.forEach((e) => Bu.push(...e)));
function yb(t) {
  for (var e = 0; e < Bu.length; e += 2)
    if (t >= Bu[e] && t <= Bu[e + 1])
      return !0;
  return !1;
}
var Gc = 80, f$ = function(e, A) {
  return "M95," + (622 + e + A) + `
c-2.7,0,-7.17,-2.7,-13.5,-8c-5.8,-5.3,-9.5,-10,-9.5,-14
c0,-2,0.3,-3.3,1,-4c1.3,-2.7,23.83,-20.7,67.5,-54
c44.2,-33.3,65.8,-50.3,66.5,-51c1.3,-1.3,3,-2,5,-2c4.7,0,8.7,3.3,12,10
s173,378,173,378c0.7,0,35.3,-71,104,-213c68.7,-142,137.5,-285,206.5,-429
c69,-144,104.5,-217.7,106.5,-221
l` + e / 2.075 + " -" + e + `
c5.3,-9.3,12,-14,20,-14
H400000v` + (40 + e) + `H845.2724
s-225.272,467,-225.272,467s-235,486,-235,486c-2.7,4.7,-9,7,-19,7
c-6,0,-10,-1,-12,-3s-194,-422,-194,-422s-65,47,-65,47z
M` + (834 + e) + " " + A + "h400000v" + (40 + e) + "h-400000z";
}, Q$ = function(e, A) {
  return "M263," + (601 + e + A) + `c0.7,0,18,39.7,52,119
c34,79.3,68.167,158.7,102.5,238c34.3,79.3,51.8,119.3,52.5,120
c340,-704.7,510.7,-1060.3,512,-1067
l` + e / 2.084 + " -" + e + `
c4.7,-7.3,11,-11,19,-11
H40000v` + (40 + e) + `H1012.3
s-271.3,567,-271.3,567c-38.7,80.7,-84,175,-136,283c-52,108,-89.167,185.3,-111.5,232
c-22.3,46.7,-33.8,70.3,-34.5,71c-4.7,4.7,-12.3,7,-23,7s-12,-1,-12,-1
s-109,-253,-109,-253c-72.7,-168,-109.3,-252,-110,-252c-10.7,8,-22,16.7,-34,26
c-22,17.3,-33.3,26,-34,26s-26,-26,-26,-26s76,-59,76,-59s76,-60,76,-60z
M` + (1001 + e) + " " + A + "h400000v" + (40 + e) + "h-400000z";
}, I$ = function(e, A) {
  return "M983 " + (10 + e + A) + `
l` + e / 3.13 + " -" + e + `
c4,-6.7,10,-10,18,-10 H400000v` + (40 + e) + `
H1013.1s-83.4,268,-264.1,840c-180.7,572,-277,876.3,-289,913c-4.7,4.7,-12.7,7,-24,7
s-12,0,-12,0c-1.3,-3.3,-3.7,-11.7,-7,-25c-35.3,-125.3,-106.7,-373.3,-214,-744
c-10,12,-21,25,-33,39s-32,39,-32,39c-6,-5.3,-15,-14,-27,-26s25,-30,25,-30
c26.7,-32.7,52,-63,76,-91s52,-60,52,-60s208,722,208,722
c56,-175.3,126.3,-397.3,211,-666c84.7,-268.7,153.8,-488.2,207.5,-658.5
c53.7,-170.3,84.5,-266.8,92.5,-289.5z
M` + (1001 + e) + " " + A + "h400000v" + (40 + e) + "h-400000z";
}, C$ = function(e, A) {
  return "M424," + (2398 + e + A) + `
c-1.3,-0.7,-38.5,-172,-111.5,-514c-73,-342,-109.8,-513.3,-110.5,-514
c0,-2,-10.7,14.3,-32,49c-4.7,7.3,-9.8,15.7,-15.5,25c-5.7,9.3,-9.8,16,-12.5,20
s-5,7,-5,7c-4,-3.3,-8.3,-7.7,-13,-13s-13,-13,-13,-13s76,-122,76,-122s77,-121,77,-121
s209,968,209,968c0,-2,84.7,-361.7,254,-1079c169.3,-717.3,254.7,-1077.7,256,-1081
l` + e / 4.223 + " -" + e + `c4,-6.7,10,-10,18,-10 H400000
v` + (40 + e) + `H1014.6
s-87.3,378.7,-272.6,1166c-185.3,787.3,-279.3,1182.3,-282,1185
c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2z M` + (1001 + e) + " " + A + `
h400000v` + (40 + e) + "h-400000z";
}, E$ = function(e, A) {
  return "M473," + (2713 + e + A) + `
c339.3,-1799.3,509.3,-2700,510,-2702 l` + e / 5.298 + " -" + e + `
c3.3,-7.3,9.3,-11,18,-11 H400000v` + (40 + e) + `H1017.7
s-90.5,478,-276.2,1466c-185.7,988,-279.5,1483,-281.5,1485c-2,6,-10,9,-24,9
c-8,0,-12,-0.7,-12,-2c0,-1.3,-5.3,-32,-16,-92c-50.7,-293.3,-119.7,-693.3,-207,-1200
c0,-1.3,-5.3,8.7,-16,30c-10.7,21.3,-21.3,42.7,-32,64s-16,33,-16,33s-26,-26,-26,-26
s76,-153,76,-153s77,-151,77,-151c0.7,0.7,35.7,202,105,604c67.3,400.7,102,602.7,104,
606zM` + (1001 + e) + " " + A + "h400000v" + (40 + e) + "H1017.7z";
}, M$ = function(e) {
  var A = e / 2;
  return "M400000 " + e + " H0 L" + A + " 0 l65 45 L145 " + (e - 80) + " H400000z";
}, p$ = function(e, A, n) {
  var s = n - 54 - A - e;
  return "M702 " + (e + A) + "H400000" + (40 + e) + `
H742v` + s + `l-4 4-4 4c-.667.7 -2 1.5-4 2.5s-4.167 1.833-6.5 2.5-5.5 1-9.5 1
h-12l-28-84c-16.667-52-96.667 -294.333-240-727l-212 -643 -85 170
c-4-3.333-8.333-7.667-13 -13l-13-13l77-155 77-156c66 199.333 139 419.667
219 661 l218 661zM702 ` + A + "H400000v" + (40 + e) + "H742z";
}, m$ = function(e, A, n) {
  A = 1e3 * A;
  var s = "";
  switch (e) {
    case "sqrtMain":
      s = f$(A, Gc);
      break;
    case "sqrtSize1":
      s = Q$(A, Gc);
      break;
    case "sqrtSize2":
      s = I$(A, Gc);
      break;
    case "sqrtSize3":
      s = C$(A, Gc);
      break;
    case "sqrtSize4":
      s = E$(A, Gc);
      break;
    case "sqrtTall":
      s = p$(A, Gc, n);
  }
  return s;
}, Y$ = function(e, A) {
  switch (e) {
    case "⎜":
      return "M291 0 H417 V" + A + " H291z M291 0 H417 V" + A + " H291z";
    case "∣":
      return "M145 0 H188 V" + A + " H145z M145 0 H188 V" + A + " H145z";
    case "∥":
      return "M145 0 H188 V" + A + " H145z M145 0 H188 V" + A + " H145z" + ("M367 0 H410 V" + A + " H367z M367 0 H410 V" + A + " H367z");
    case "⎟":
      return "M457 0 H583 V" + A + " H457z M457 0 H583 V" + A + " H457z";
    case "⎢":
      return "M319 0 H403 V" + A + " H319z M319 0 H403 V" + A + " H319z";
    case "⎥":
      return "M263 0 H347 V" + A + " H263z M263 0 H347 V" + A + " H263z";
    case "⎪":
      return "M384 0 H504 V" + A + " H384z M384 0 H504 V" + A + " H384z";
    case "⏐":
      return "M312 0 H355 V" + A + " H312z M312 0 H355 V" + A + " H312z";
    case "‖":
      return "M257 0 H300 V" + A + " H257z M257 0 H300 V" + A + " H257z" + ("M478 0 H521 V" + A + " H478z M478 0 H521 V" + A + " H478z");
    default:
      return "";
  }
}, FF = {
  // The doubleleftarrow geometry is from glyph U+21D0 in the font KaTeX Main
  doubleleftarrow: `M262 157
l10-10c34-36 62.7-77 86-123 3.3-8 5-13.3 5-16 0-5.3-6.7-8-20-8-7.3
 0-12.2.5-14.5 1.5-2.3 1-4.8 4.5-7.5 10.5-49.3 97.3-121.7 169.3-217 216-28
 14-57.3 25-88 33-6.7 2-11 3.8-13 5.5-2 1.7-3 4.2-3 7.5s1 5.8 3 7.5
c2 1.7 6.3 3.5 13 5.5 68 17.3 128.2 47.8 180.5 91.5 52.3 43.7 93.8 96.2 124.5
 157.5 9.3 8 15.3 12.3 18 13h6c12-.7 18-4 18-10 0-2-1.7-7-5-15-23.3-46-52-87
-86-123l-10-10h399738v-40H218c328 0 0 0 0 0l-10-8c-26.7-20-65.7-43-117-69 2.7
-2 6-3.7 10-5 36.7-16 72.3-37.3 107-64l10-8h399782v-40z
m8 0v40h399730v-40zm0 194v40h399730v-40z`,
  // doublerightarrow is from glyph U+21D2 in font KaTeX Main
  doublerightarrow: `M399738 392l
-10 10c-34 36-62.7 77-86 123-3.3 8-5 13.3-5 16 0 5.3 6.7 8 20 8 7.3 0 12.2-.5
 14.5-1.5 2.3-1 4.8-4.5 7.5-10.5 49.3-97.3 121.7-169.3 217-216 28-14 57.3-25 88
-33 6.7-2 11-3.8 13-5.5 2-1.7 3-4.2 3-7.5s-1-5.8-3-7.5c-2-1.7-6.3-3.5-13-5.5-68
-17.3-128.2-47.8-180.5-91.5-52.3-43.7-93.8-96.2-124.5-157.5-9.3-8-15.3-12.3-18
-13h-6c-12 .7-18 4-18 10 0 2 1.7 7 5 15 23.3 46 52 87 86 123l10 10H0v40h399782
c-328 0 0 0 0 0l10 8c26.7 20 65.7 43 117 69-2.7 2-6 3.7-10 5-36.7 16-72.3 37.3
-107 64l-10 8H0v40zM0 157v40h399730v-40zm0 194v40h399730v-40z`,
  // leftarrow is from glyph U+2190 in font KaTeX Main
  leftarrow: `M400000 241H110l3-3c68.7-52.7 113.7-120
 135-202 4-14.7 6-23 6-25 0-7.3-7-11-21-11-8 0-13.2.8-15.5 2.5-2.3 1.7-4.2 5.8
-5.5 12.5-1.3 4.7-2.7 10.3-4 17-12 48.7-34.8 92-68.5 130S65.3 228.3 18 247
c-10 4-16 7.7-18 11 0 8.7 6 14.3 18 17 47.3 18.7 87.8 47 121.5 85S196 441.3 208
 490c.7 2 1.3 5 2 9s1.2 6.7 1.5 8c.3 1.3 1 3.3 2 6s2.2 4.5 3.5 5.5c1.3 1 3.3
 1.8 6 2.5s6 1 10 1c14 0 21-3.7 21-11 0-2-2-10.3-6-25-20-79.3-65-146.7-135-202
 l-3-3h399890zM100 241v40h399900v-40z`,
  // overbrace is from glyphs U+23A9/23A8/23A7 in font KaTeX_Size4-Regular
  leftbrace: `M6 548l-6-6v-35l6-11c56-104 135.3-181.3 238-232 57.3-28.7 117
-45 179-50h399577v120H403c-43.3 7-81 15-113 26-100.7 33-179.7 91-237 174-2.7
 5-6 9-10 13-.7 1-7.3 1-20 1H6z`,
  leftbraceunder: `M0 6l6-6h17c12.688 0 19.313.3 20 1 4 4 7.313 8.3 10 13
 35.313 51.3 80.813 93.8 136.5 127.5 55.688 33.7 117.188 55.8 184.5 66.5.688
 0 2 .3 4 1 18.688 2.7 76 4.3 172 5h399450v120H429l-6-1c-124.688-8-235-61.7
-331-161C60.687 138.7 32.312 99.3 7 54L0 41V6z`,
  // overgroup is from the MnSymbol package (public domain)
  leftgroup: `M400000 80
H435C64 80 168.3 229.4 21 260c-5.9 1.2-18 0-18 0-2 0-3-1-3-3v-38C76 61 257 0
 435 0h399565z`,
  leftgroupunder: `M400000 262
H435C64 262 168.3 112.6 21 82c-5.9-1.2-18 0-18 0-2 0-3 1-3 3v38c76 158 257 219
 435 219h399565z`,
  // Harpoons are from glyph U+21BD in font KaTeX Main
  leftharpoon: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3
-3.3 10.2-9.5 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5
-18.3 3-21-1.3-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7
-196 228-6.7 4.7-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40z`,
  leftharpoonplus: `M0 267c.7 5.3 3 10 7 14h399993v-40H93c3.3-3.3 10.2-9.5
 20.5-18.5s17.8-15.8 22.5-20.5c50.7-52 88-110.3 112-175 4-11.3 5-18.3 3-21-1.3
-4-7.3-6-18-6-8 0-13 .7-15 2s-4.7 6.7-8 16c-42 98.7-107.3 174.7-196 228-6.7 4.7
-10.7 8-12 10-1.3 2-2 5.7-2 11zm100-26v40h399900v-40zM0 435v40h400000v-40z
m0 0v40h400000v-40z`,
  leftharpoondown: `M7 241c-4 4-6.333 8.667-7 14 0 5.333.667 9 2 11s5.333
 5.333 12 10c90.667 54 156 130 196 228 3.333 10.667 6.333 16.333 9 17 2 .667 5
 1 9 1h5c10.667 0 16.667-2 18-6 2-2.667 1-9.667-3-21-32-87.333-82.667-157.667
-152-211l-3-3h399907v-40zM93 281 H400000 v-40L7 241z`,
  leftharpoondownplus: `M7 435c-4 4-6.3 8.7-7 14 0 5.3.7 9 2 11s5.3 5.3 12
 10c90.7 54 156 130 196 228 3.3 10.7 6.3 16.3 9 17 2 .7 5 1 9 1h5c10.7 0 16.7
-2 18-6 2-2.7 1-9.7-3-21-32-87.3-82.7-157.7-152-211l-3-3h399907v-40H7zm93 0
v40h399900v-40zM0 241v40h399900v-40zm0 0v40h399900v-40z`,
  // hook is from glyph U+21A9 in font KaTeX Main
  lefthook: `M400000 281 H103s-33-11.2-61-33.5S0 197.3 0 164s14.2-61.2 42.5
-83.5C70.8 58.2 104 47 142 47 c16.7 0 25 6.7 25 20 0 12-8.7 18.7-26 20-40 3.3
-68.7 15.7-86 37-10 12-15 25.3-15 40 0 22.7 9.8 40.7 29.5 54 19.7 13.3 43.5 21
 71.5 23h399859zM103 281v-40h399897v40z`,
  leftlinesegment: `M40 281 V428 H0 V94 H40 V241 H400000 v40z
M40 281 V428 H0 V94 H40 V241 H400000 v40z`,
  leftmapsto: `M40 281 V448H0V74H40V241H400000v40z
M40 281 V448H0V74H40V241H400000v40z`,
  // tofrom is from glyph U+21C4 in font KaTeX AMS Regular
  leftToFrom: `M0 147h400000v40H0zm0 214c68 40 115.7 95.7 143 167h22c15.3 0 23
-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69-70-101l-7-8h399905v-40H95l7-8
c28.7-32 52-65.7 70-101 10.7-23.3 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 265.3
 68 321 0 361zm0-174v-40h399900v40zm100 154v40h399900v-40z`,
  longequal: `M0 50 h400000 v40H0z m0 194h40000v40H0z
M0 50 h400000 v40H0z m0 194h40000v40H0z`,
  midbrace: `M200428 334
c-100.7-8.3-195.3-44-280-108-55.3-42-101.7-93-139-153l-9-14c-2.7 4-5.7 8.7-9 14
-53.3 86.7-123.7 153-211 199-66.7 36-137.3 56.3-212 62H0V214h199568c178.3-11.7
 311.7-78.3 403-201 6-8 9.7-12 11-12 .7-.7 6.7-1 18-1s17.3.3 18 1c1.3 0 5 4 11
 12 44.7 59.3 101.3 106.3 170 141s145.3 54.3 229 60h199572v120z`,
  midbraceunder: `M199572 214
c100.7 8.3 195.3 44 280 108 55.3 42 101.7 93 139 153l9 14c2.7-4 5.7-8.7 9-14
 53.3-86.7 123.7-153 211-199 66.7-36 137.3-56.3 212-62h199568v120H200432c-178.3
 11.7-311.7 78.3-403 201-6 8-9.7 12-11 12-.7.7-6.7 1-18 1s-17.3-.3-18-1c-1.3 0
-5-4-11-12-44.7-59.3-101.3-106.3-170-141s-145.3-54.3-229-60H0V214z`,
  oiintSize1: `M512.6 71.6c272.6 0 320.3 106.8 320.3 178.2 0 70.8-47.7 177.6
-320.3 177.6S193.1 320.6 193.1 249.8c0-71.4 46.9-178.2 319.5-178.2z
m368.1 178.2c0-86.4-60.9-215.4-368.1-215.4-306.4 0-367.3 129-367.3 215.4 0 85.8
60.9 214.8 367.3 214.8 307.2 0 368.1-129 368.1-214.8z`,
  oiintSize2: `M757.8 100.1c384.7 0 451.1 137.6 451.1 230 0 91.3-66.4 228.8
-451.1 228.8-386.3 0-452.7-137.5-452.7-228.8 0-92.4 66.4-230 452.7-230z
m502.4 230c0-111.2-82.4-277.2-502.4-277.2s-504 166-504 277.2
c0 110 84 276 504 276s502.4-166 502.4-276z`,
  oiiintSize1: `M681.4 71.6c408.9 0 480.5 106.8 480.5 178.2 0 70.8-71.6 177.6
-480.5 177.6S202.1 320.6 202.1 249.8c0-71.4 70.5-178.2 479.3-178.2z
m525.8 178.2c0-86.4-86.8-215.4-525.7-215.4-437.9 0-524.7 129-524.7 215.4 0
85.8 86.8 214.8 524.7 214.8 438.9 0 525.7-129 525.7-214.8z`,
  oiiintSize2: `M1021.2 53c603.6 0 707.8 165.8 707.8 277.2 0 110-104.2 275.8
-707.8 275.8-606 0-710.2-165.8-710.2-275.8C311 218.8 415.2 53 1021.2 53z
m770.4 277.1c0-131.2-126.4-327.6-770.5-327.6S248.4 198.9 248.4 330.1
c0 130 128.8 326.4 772.7 326.4s770.5-196.4 770.5-326.4z`,
  rightarrow: `M0 241v40h399891c-47.3 35.3-84 78-110 128
-16.7 32-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20
 11 8 0 13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7
 39-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85
-40.5-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
 151.7 139 205zm0 0v40h399900v-40z`,
  rightbrace: `M400000 542l
-6 6h-17c-12.7 0-19.3-.3-20-1-4-4-7.3-8.3-10-13-35.3-51.3-80.8-93.8-136.5-127.5
s-117.2-55.8-184.5-66.5c-.7 0-2-.3-4-1-18.7-2.7-76-4.3-172-5H0V214h399571l6 1
c124.7 8 235 61.7 331 161 31.3 33.3 59.7 72.7 85 118l7 13v35z`,
  rightbraceunder: `M399994 0l6 6v35l-6 11c-56 104-135.3 181.3-238 232-57.3
 28.7-117 45-179 50H-300V214h399897c43.3-7 81-15 113-26 100.7-33 179.7-91 237
-174 2.7-5 6-9 10-13 .7-1 7.3-1 20-1h17z`,
  rightgroup: `M0 80h399565c371 0 266.7 149.4 414 180 5.9 1.2 18 0 18 0 2 0
 3-1 3-3v-38c-76-158-257-219-435-219H0z`,
  rightgroupunder: `M0 262h399565c371 0 266.7-149.4 414-180 5.9-1.2 18 0 18
 0 2 0 3 1 3 3v38c-76 158-257 219-435 219H0z`,
  rightharpoon: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3
-3.7-15.3-11-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2
-10.7 0-16.7 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58
 69.2 92 94.5zm0 0v40h399900v-40z`,
  rightharpoonplus: `M0 241v40h399993c4.7-4.7 7-9.3 7-14 0-9.3-3.7-15.3-11
-18-92.7-56.7-159-133.7-199-231-3.3-9.3-6-14.7-8-16-2-1.3-7-2-15-2-10.7 0-16.7
 2-18 6-2 2.7-1 9.7 3 21 15.3 42 36.7 81.8 64 119.5 27.3 37.7 58 69.2 92 94.5z
m0 0v40h399900v-40z m100 194v40h399900v-40zm0 0v40h399900v-40z`,
  rightharpoondown: `M399747 511c0 7.3 6.7 11 20 11 8 0 13-.8 15-2.5s4.7-6.8
 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3 8.5-5.8 9.5
-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3-64.7 57-92 95
-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 241v40h399900v-40z`,
  rightharpoondownplus: `M399747 705c0 7.3 6.7 11 20 11 8 0 13-.8
 15-2.5s4.7-6.8 8-15.5c40-94 99.3-166.3 178-217 13.3-8 20.3-12.3 21-13 5.3-3.3
 8.5-5.8 9.5-7.5 1-1.7 1.5-5.2 1.5-10.5s-2.3-10.3-7-15H0v40h399908c-34 25.3
-64.7 57-92 95-27.3 38-48.7 77.7-64 119-3.3 8.7-5 14-5 16zM0 435v40h399900v-40z
m0-194v40h400000v-40zm0 0v40h400000v-40z`,
  righthook: `M399859 241c-764 0 0 0 0 0 40-3.3 68.7-15.7 86-37 10-12 15-25.3
 15-40 0-22.7-9.8-40.7-29.5-54-19.7-13.3-43.5-21-71.5-23-17.3-1.3-26-8-26-20 0
-13.3 8.7-20 26-20 38 0 71 11.2 99 33.5 0 0 7 5.6 21 16.7 14 11.2 21 33.5 21
 66.8s-14 61.2-42 83.5c-28 22.3-61 33.5-99 33.5L0 241z M0 281v-40h399859v40z`,
  rightlinesegment: `M399960 241 V94 h40 V428 h-40 V281 H0 v-40z
M399960 241 V94 h40 V428 h-40 V281 H0 v-40z`,
  rightToFrom: `M400000 167c-70.7-42-118-97.7-142-167h-23c-15.3 0-23 .3-23
 1 0 1.3 5.3 13.7 16 37 18 35.3 41.3 69 70 101l7 8H0v40h399905l-7 8c-28.7 32
-52 65.7-70 101-10.7 23.3-16 35.7-16 37 0 .7 7.7 1 23 1h23c24-69.3 71.3-125 142
-167z M100 147v40h399900v-40zM0 341v40h399900v-40z`,
  // twoheadleftarrow is from glyph U+219E in font KaTeX AMS Regular
  twoheadleftarrow: `M0 167c68 40
 115.7 95.7 143 167h22c15.3 0 23-.3 23-1 0-1.3-5.3-13.7-16-37-18-35.3-41.3-69
-70-101l-7-8h125l9 7c50.7 39.3 85 86 103 140h46c0-4.7-6.3-18.7-19-42-18-35.3
-40-67.3-66-96l-9-9h399716v-40H284l9-9c26-28.7 48-60.7 66-96 12.7-23.333 19
-37.333 19-42h-46c-18 54-52.3 100.7-103 140l-9 7H95l7-8c28.7-32 52-65.7 70-101
 10.7-23.333 16-35.7 16-37 0-.7-7.7-1-23-1h-22C115.7 71.3 68 127 0 167z`,
  twoheadrightarrow: `M400000 167
c-68-40-115.7-95.7-143-167h-22c-15.3 0-23 .3-23 1 0 1.3 5.3 13.7 16 37 18 35.3
 41.3 69 70 101l7 8h-125l-9-7c-50.7-39.3-85-86-103-140h-46c0 4.7 6.3 18.7 19 42
 18 35.3 40 67.3 66 96l9 9H0v40h399716l-9 9c-26 28.7-48 60.7-66 96-12.7 23.333
-19 37.333-19 42h46c18-54 52.3-100.7 103-140l9-7h125l-7 8c-28.7 32-52 65.7-70
 101-10.7 23.333-16 35.7-16 37 0 .7 7.7 1 23 1h22c27.3-71.3 75-127 143-167z`,
  // tilde1 is a modified version of a glyph from the MnSymbol package
  tilde1: `M200 55.538c-77 0-168 73.953-177 73.953-3 0-7
-2.175-9-5.437L2 97c-1-2-2-4-2-6 0-4 2-7 5-9l20-12C116 12 171 0 207 0c86 0
 114 68 191 68 78 0 168-68 177-68 4 0 7 2 9 5l12 19c1 2.175 2 4.35 2 6.525 0
 4.35-2 7.613-5 9.788l-19 13.05c-92 63.077-116.937 75.308-183 76.128
-68.267.847-113-73.952-191-73.952z`,
  // ditto tilde2, tilde3, & tilde4
  tilde2: `M344 55.266c-142 0-300.638 81.316-311.5 86.418
-8.01 3.762-22.5 10.91-23.5 5.562L1 120c-1-2-1-3-1-4 0-5 3-9 8-10l18.4-9C160.9
 31.9 283 0 358 0c148 0 188 122 331 122s314-97 326-97c4 0 8 2 10 7l7 21.114
c1 2.14 1 3.21 1 4.28 0 5.347-3 9.626-7 10.696l-22.3 12.622C852.6 158.372 751
 181.476 676 181.476c-149 0-189-126.21-332-126.21z`,
  tilde3: `M786 59C457 59 32 175.242 13 175.242c-6 0-10-3.457
-11-10.37L.15 138c-1-7 3-12 10-13l19.2-6.4C378.4 40.7 634.3 0 804.3 0c337 0
 411.8 157 746.8 157 328 0 754-112 773-112 5 0 10 3 11 9l1 14.075c1 8.066-.697
 16.595-6.697 17.492l-21.052 7.31c-367.9 98.146-609.15 122.696-778.15 122.696
 -338 0-409-156.573-744-156.573z`,
  tilde4: `M786 58C457 58 32 177.487 13 177.487c-6 0-10-3.345
-11-10.035L.15 143c-1-7 3-12 10-13l22-6.7C381.2 35 637.15 0 807.15 0c337 0 409
 177 744 177 328 0 754-127 773-127 5 0 10 3 11 9l1 14.794c1 7.805-3 13.38-9
 14.495l-20.7 5.574c-366.85 99.79-607.3 139.372-776.3 139.372-338 0-409
 -175.236-744-175.236z`,
  // vec is from glyph U+20D7 in font KaTeX Main
  vec: `M377 20c0-5.333 1.833-10 5.5-14S391 0 397 0c4.667 0 8.667 1.667 12 5
3.333 2.667 6.667 9 10 19 6.667 24.667 20.333 43.667 41 57 7.333 4.667 11
10.667 11 18 0 6-1 10-3 12s-6.667 5-14 9c-28.667 14.667-53.667 35.667-75 63
-1.333 1.333-3.167 3.5-5.5 6.5s-4 4.833-5 5.5c-1 .667-2.5 1.333-4.5 2s-4.333 1
-7 1c-4.667 0-9.167-1.833-13.5-5.5S337 184 337 178c0-12.667 15.667-32.333 47-59
H213l-171-1c-8.667-6-13-12.333-13-19 0-4.667 4.333-11.333 13-20h359
c-16-25.333-24-45-24-59z`,
  // widehat1 is a modified version of a glyph from the MnSymbol package
  widehat1: `M529 0h5l519 115c5 1 9 5 9 10 0 1-1 2-1 3l-4 22
c-1 5-5 9-11 9h-2L532 67 19 159h-2c-5 0-9-4-11-9l-5-22c-1-6 2-12 8-13z`,
  // ditto widehat2, widehat3, & widehat4
  widehat2: `M1181 0h2l1171 176c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 220h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat3: `M1181 0h2l1171 236c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 280h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  widehat4: `M1181 0h2l1171 296c6 0 10 5 10 11l-2 23c-1 6-5 10
-11 10h-1L1182 67 15 340h-1c-6 0-10-4-11-10l-2-23c-1-6 4-11 10-11z`,
  // widecheck paths are all inverted versions of widehat
  widecheck1: `M529,159h5l519,-115c5,-1,9,-5,9,-10c0,-1,-1,-2,-1,-3l-4,-22c-1,
-5,-5,-9,-11,-9h-2l-512,92l-513,-92h-2c-5,0,-9,4,-11,9l-5,22c-1,6,2,12,8,13z`,
  widecheck2: `M1181,220h2l1171,-176c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,153l-1167,-153h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck3: `M1181,280h2l1171,-236c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,213l-1167,-213h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  widecheck4: `M1181,340h2l1171,-296c6,0,10,-5,10,-11l-2,-23c-1,-6,-5,-10,
-11,-10h-1l-1168,273l-1167,-273h-1c-6,0,-10,4,-11,10l-2,23c-1,6,4,11,10,11z`,
  // The next ten paths support reaction arrows from the mhchem package.
  // Arrows for \ce{<-->} are offset from xAxis by 0.22ex, per mhchem in LaTeX
  // baraboveleftarrow is mostly from glyph U+2190 in font KaTeX Main
  baraboveleftarrow: `M400000 620h-399890l3 -3c68.7 -52.7 113.7 -120 135 -202
c4 -14.7 6 -23 6 -25c0 -7.3 -7 -11 -21 -11c-8 0 -13.2 0.8 -15.5 2.5
c-2.3 1.7 -4.2 5.8 -5.5 12.5c-1.3 4.7 -2.7 10.3 -4 17c-12 48.7 -34.8 92 -68.5 130
s-74.2 66.3 -121.5 85c-10 4 -16 7.7 -18 11c0 8.7 6 14.3 18 17c47.3 18.7 87.8 47
121.5 85s56.5 81.3 68.5 130c0.7 2 1.3 5 2 9s1.2 6.7 1.5 8c0.3 1.3 1 3.3 2 6
s2.2 4.5 3.5 5.5c1.3 1 3.3 1.8 6 2.5s6 1 10 1c14 0 21 -3.7 21 -11
c0 -2 -2 -10.3 -6 -25c-20 -79.3 -65 -146.7 -135 -202l-3 -3h399890z
M100 620v40h399900v-40z M0 241v40h399900v-40zM0 241v40h399900v-40z`,
  // rightarrowabovebar is mostly from glyph U+2192, KaTeX Main
  rightarrowabovebar: `M0 241v40h399891c-47.3 35.3-84 78-110 128-16.7 32
-27.7 63.7-33 95 0 1.3-.2 2.7-.5 4-.3 1.3-.5 2.3-.5 3 0 7.3 6.7 11 20 11 8 0
13.2-.8 15.5-2.5 2.3-1.7 4.2-5.5 5.5-11.5 2-13.3 5.7-27 11-41 14.7-44.7 39
-84.5 73-119.5s73.7-60.2 119-75.5c6-2 9-5.7 9-11s-3-9-9-11c-45.3-15.3-85-40.5
-119-75.5s-58.3-74.8-73-119.5c-4.7-14-8.3-27.3-11-40-1.3-6.7-3.2-10.8-5.5
-12.5-2.3-1.7-7.5-2.5-15.5-2.5-14 0-21 3.7-21 11 0 2 2 10.3 6 25 20.7 83.3 67
151.7 139 205zm96 379h399894v40H0zm0 0h399904v40H0z`,
  // The short left harpoon has 0.5em (i.e. 500 units) kern on the left end.
  // Ref from mhchem.sty: \rlap{\raisebox{-.22ex}{$\kern0.5em
  baraboveshortleftharpoon: `M507,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17
c2,0.7,5,1,9,1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21
c-32,-87.3,-82.7,-157.7,-152,-211c0,0,-3,-3,-3,-3l399351,0l0,-40
c-398570,0,-399437,0,-399437,0z M593 435 v40 H399500 v-40z
M0 281 v-40 H399908 v40z M0 281 v-40 H399908 v40z`,
  rightharpoonaboveshortbar: `M0,241 l0,40c399126,0,399993,0,399993,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M0 241 v40 H399908 v-40z M0 475 v-40 H399500 v40z M0 475 v-40 H399500 v40z`,
  shortbaraboveleftharpoon: `M7,435c-4,4,-6.3,8.7,-7,14c0,5.3,0.7,9,2,11
c1.3,2,5.3,5.3,12,10c90.7,54,156,130,196,228c3.3,10.7,6.3,16.3,9,17c2,0.7,5,1,9,
1c0,0,5,0,5,0c10.7,0,16.7,-2,18,-6c2,-2.7,1,-9.7,-3,-21c-32,-87.3,-82.7,-157.7,
-152,-211c0,0,-3,-3,-3,-3l399907,0l0,-40c-399126,0,-399993,0,-399993,0z
M93 435 v40 H400000 v-40z M500 241 v40 H400000 v-40z M500 241 v40 H400000 v-40z`,
  shortrightharpoonabovebar: `M53,241l0,40c398570,0,399437,0,399437,0
c4.7,-4.7,7,-9.3,7,-14c0,-9.3,-3.7,-15.3,-11,-18c-92.7,-56.7,-159,-133.7,-199,
-231c-3.3,-9.3,-6,-14.7,-8,-16c-2,-1.3,-7,-2,-15,-2c-10.7,0,-16.7,2,-18,6
c-2,2.7,-1,9.7,3,21c15.3,42,36.7,81.8,64,119.5c27.3,37.7,58,69.2,92,94.5z
M500 241 v40 H399408 v-40z M500 435 v40 H400000 v-40z`
}, y$ = function(e, A) {
  switch (e) {
    case "lbrack":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + A + ` v1759 h347 v-84
H403z M403 1759 V0 H319 V1759 v` + A + " v1759 h84z";
    case "rbrack":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + A + ` v1759 H0 v84 H347z
M347 1759 V0 H263 V1759 v` + A + " v1759 h84z";
    case "vert":
      return "M145 15 v585 v" + A + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -A + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + A + " v585 h43z";
    case "doublevert":
      return "M145 15 v585 v" + A + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -A + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M188 15 H145 v585 v` + A + ` v585 h43z
M367 15 v585 v` + A + ` v585 c2.667,10,9.667,15,21,15
c10,0,16.667,-5,20,-15 v-585 v` + -A + ` v-585 c-2.667,-10,-9.667,-15,-21,-15
c-10,0,-16.667,5,-20,15z M410 15 H367 v585 v` + A + " v585 h43z";
    case "lfloor":
      return "M319 602 V0 H403 V602 v" + A + ` v1715 h263 v84 H319z
MM319 602 V0 H403 V602 v` + A + " v1715 H319z";
    case "rfloor":
      return "M319 602 V0 H403 V602 v" + A + ` v1799 H0 v-84 H319z
MM319 602 V0 H403 V602 v` + A + " v1715 H319z";
    case "lceil":
      return "M403 1759 V84 H666 V0 H319 V1759 v" + A + ` v602 h84z
M403 1759 V0 H319 V1759 v` + A + " v602 h84z";
    case "rceil":
      return "M347 1759 V0 H0 V84 H263 V1759 v" + A + ` v602 h84z
M347 1759 V0 h-84 V1759 v` + A + " v602 h84z";
    case "lparen":
      return `M863,9c0,-2,-2,-5,-6,-9c0,0,-17,0,-17,0c-12.7,0,-19.3,0.3,-20,1
c-5.3,5.3,-10.3,11,-15,17c-242.7,294.7,-395.3,682,-458,1162c-21.3,163.3,-33.3,349,
-36,557 l0,` + (A + 84) + `c0.2,6,0,26,0,60c2,159.3,10,310.7,24,454c53.3,528,210,
949.7,470,1265c4.7,6,9.7,11.7,15,17c0.7,0.7,7,1,19,1c0,0,18,0,18,0c4,-4,6,-7,6,-9
c0,-2.7,-3.3,-8.7,-10,-18c-135.3,-192.7,-235.5,-414.3,-300.5,-665c-65,-250.7,-102.5,
-544.7,-112.5,-882c-2,-104,-3,-167,-3,-189
l0,-` + (A + 92) + `c0,-162.7,5.7,-314,17,-454c20.7,-272,63.7,-513,129,-723c65.3,
-210,155.3,-396.3,270,-559c6.7,-9.3,10,-15.3,10,-18z`;
    case "rparen":
      return `M76,0c-16.7,0,-25,3,-25,9c0,2,2,6.3,6,13c21.3,28.7,42.3,60.3,
63,95c96.7,156.7,172.8,332.5,228.5,527.5c55.7,195,92.8,416.5,111.5,664.5
c11.3,139.3,17,290.7,17,454c0,28,1.7,43,3.3,45l0,` + (A + 9) + `
c-3,4,-3.3,16.7,-3.3,38c0,162,-5.7,313.7,-17,455c-18.7,248,-55.8,469.3,-111.5,664
c-55.7,194.7,-131.8,370.3,-228.5,527c-20.7,34.7,-41.7,66.3,-63,95c-2,3.3,-4,7,-6,11
c0,7.3,5.7,11,17,11c0,0,11,0,11,0c9.3,0,14.3,-0.3,15,-1c5.3,-5.3,10.3,-11,15,-17
c242.7,-294.7,395.3,-681.7,458,-1161c21.3,-164.7,33.3,-350.7,36,-558
l0,-` + (A + 144) + `c-2,-159.3,-10,-310.7,-24,-454c-53.3,-528,-210,-949.7,
-470,-1265c-4.7,-6,-9.7,-11.7,-15,-17c-0.7,-0.7,-6.7,-1,-18,-1z`;
    default:
      throw new Error("Unknown stretchy delimiter.");
  }
};
class ph {
  // Never used; needed for satisfying interface.
  constructor(e) {
    this.children = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.children = e, this.classes = [], this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = {};
  }
  hasClass(e) {
    return this.classes.includes(e);
  }
  /** Convert the fragment into a node. */
  toNode() {
    for (var e = document.createDocumentFragment(), A = 0; A < this.children.length; A++)
      e.appendChild(this.children[A].toNode());
    return e;
  }
  /** Convert the fragment into HTML markup. */
  toMarkup() {
    for (var e = "", A = 0; A < this.children.length; A++)
      e += this.children[A].toMarkup();
    return e;
  }
  /**
   * Converts the math node into a string, similar to innerText. Applies to
   * MathDomNode's only.
   */
  toText() {
    var e = (A) => A.toText();
    return this.children.map(e).join("");
  }
}
var Dr = {
  "AMS-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68889, 0, 0, 0.72222],
    66: [0, 0.68889, 0, 0, 0.66667],
    67: [0, 0.68889, 0, 0, 0.72222],
    68: [0, 0.68889, 0, 0, 0.72222],
    69: [0, 0.68889, 0, 0, 0.66667],
    70: [0, 0.68889, 0, 0, 0.61111],
    71: [0, 0.68889, 0, 0, 0.77778],
    72: [0, 0.68889, 0, 0, 0.77778],
    73: [0, 0.68889, 0, 0, 0.38889],
    74: [0.16667, 0.68889, 0, 0, 0.5],
    75: [0, 0.68889, 0, 0, 0.77778],
    76: [0, 0.68889, 0, 0, 0.66667],
    77: [0, 0.68889, 0, 0, 0.94445],
    78: [0, 0.68889, 0, 0, 0.72222],
    79: [0.16667, 0.68889, 0, 0, 0.77778],
    80: [0, 0.68889, 0, 0, 0.61111],
    81: [0.16667, 0.68889, 0, 0, 0.77778],
    82: [0, 0.68889, 0, 0, 0.72222],
    83: [0, 0.68889, 0, 0, 0.55556],
    84: [0, 0.68889, 0, 0, 0.66667],
    85: [0, 0.68889, 0, 0, 0.72222],
    86: [0, 0.68889, 0, 0, 0.72222],
    87: [0, 0.68889, 0, 0, 1],
    88: [0, 0.68889, 0, 0, 0.72222],
    89: [0, 0.68889, 0, 0, 0.72222],
    90: [0, 0.68889, 0, 0, 0.66667],
    107: [0, 0.68889, 0, 0, 0.55556],
    160: [0, 0, 0, 0, 0.25],
    165: [0, 0.675, 0.025, 0, 0.75],
    174: [0.15559, 0.69224, 0, 0, 0.94666],
    240: [0, 0.68889, 0, 0, 0.55556],
    295: [0, 0.68889, 0, 0, 0.54028],
    710: [0, 0.825, 0, 0, 2.33334],
    732: [0, 0.9, 0, 0, 2.33334],
    770: [0, 0.825, 0, 0, 2.33334],
    771: [0, 0.9, 0, 0, 2.33334],
    989: [0.08167, 0.58167, 0, 0, 0.77778],
    1008: [0, 0.43056, 0.04028, 0, 0.66667],
    8245: [0, 0.54986, 0, 0, 0.275],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8487: [0, 0.68889, 0, 0, 0.72222],
    8498: [0, 0.68889, 0, 0, 0.55556],
    8502: [0, 0.68889, 0, 0, 0.66667],
    8503: [0, 0.68889, 0, 0, 0.44445],
    8504: [0, 0.68889, 0, 0, 0.66667],
    8513: [0, 0.68889, 0, 0, 0.63889],
    8592: [-0.03598, 0.46402, 0, 0, 0.5],
    8594: [-0.03598, 0.46402, 0, 0, 0.5],
    8602: [-0.13313, 0.36687, 0, 0, 1],
    8603: [-0.13313, 0.36687, 0, 0, 1],
    8606: [0.01354, 0.52239, 0, 0, 1],
    8608: [0.01354, 0.52239, 0, 0, 1],
    8610: [0.01354, 0.52239, 0, 0, 1.11111],
    8611: [0.01354, 0.52239, 0, 0, 1.11111],
    8619: [0, 0.54986, 0, 0, 1],
    8620: [0, 0.54986, 0, 0, 1],
    8621: [-0.13313, 0.37788, 0, 0, 1.38889],
    8622: [-0.13313, 0.36687, 0, 0, 1],
    8624: [0, 0.69224, 0, 0, 0.5],
    8625: [0, 0.69224, 0, 0, 0.5],
    8630: [0, 0.43056, 0, 0, 1],
    8631: [0, 0.43056, 0, 0, 1],
    8634: [0.08198, 0.58198, 0, 0, 0.77778],
    8635: [0.08198, 0.58198, 0, 0, 0.77778],
    8638: [0.19444, 0.69224, 0, 0, 0.41667],
    8639: [0.19444, 0.69224, 0, 0, 0.41667],
    8642: [0.19444, 0.69224, 0, 0, 0.41667],
    8643: [0.19444, 0.69224, 0, 0, 0.41667],
    8644: [0.1808, 0.675, 0, 0, 1],
    8646: [0.1808, 0.675, 0, 0, 1],
    8647: [0.1808, 0.675, 0, 0, 1],
    8648: [0.19444, 0.69224, 0, 0, 0.83334],
    8649: [0.1808, 0.675, 0, 0, 1],
    8650: [0.19444, 0.69224, 0, 0, 0.83334],
    8651: [0.01354, 0.52239, 0, 0, 1],
    8652: [0.01354, 0.52239, 0, 0, 1],
    8653: [-0.13313, 0.36687, 0, 0, 1],
    8654: [-0.13313, 0.36687, 0, 0, 1],
    8655: [-0.13313, 0.36687, 0, 0, 1],
    8666: [0.13667, 0.63667, 0, 0, 1],
    8667: [0.13667, 0.63667, 0, 0, 1],
    8669: [-0.13313, 0.37788, 0, 0, 1],
    8672: [-0.064, 0.437, 0, 0, 1.334],
    8674: [-0.064, 0.437, 0, 0, 1.334],
    8705: [0, 0.825, 0, 0, 0.5],
    8708: [0, 0.68889, 0, 0, 0.55556],
    8709: [0.08167, 0.58167, 0, 0, 0.77778],
    8717: [0, 0.43056, 0, 0, 0.42917],
    8722: [-0.03598, 0.46402, 0, 0, 0.5],
    8724: [0.08198, 0.69224, 0, 0, 0.77778],
    8726: [0.08167, 0.58167, 0, 0, 0.77778],
    8733: [0, 0.69224, 0, 0, 0.77778],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8737: [0, 0.69224, 0, 0, 0.72222],
    8738: [0.03517, 0.52239, 0, 0, 0.72222],
    8739: [0.08167, 0.58167, 0, 0, 0.22222],
    8740: [0.25142, 0.74111, 0, 0, 0.27778],
    8741: [0.08167, 0.58167, 0, 0, 0.38889],
    8742: [0.25142, 0.74111, 0, 0, 0.5],
    8756: [0, 0.69224, 0, 0, 0.66667],
    8757: [0, 0.69224, 0, 0, 0.66667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8765: [-0.13313, 0.37788, 0, 0, 0.77778],
    8769: [-0.13313, 0.36687, 0, 0, 0.77778],
    8770: [-0.03625, 0.46375, 0, 0, 0.77778],
    8774: [0.30274, 0.79383, 0, 0, 0.77778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8778: [0.08167, 0.58167, 0, 0, 0.77778],
    8782: [0.06062, 0.54986, 0, 0, 0.77778],
    8783: [0.06062, 0.54986, 0, 0, 0.77778],
    8785: [0.08198, 0.58198, 0, 0, 0.77778],
    8786: [0.08198, 0.58198, 0, 0, 0.77778],
    8787: [0.08198, 0.58198, 0, 0, 0.77778],
    8790: [0, 0.69224, 0, 0, 0.77778],
    8791: [0.22958, 0.72958, 0, 0, 0.77778],
    8796: [0.08198, 0.91667, 0, 0, 0.77778],
    8806: [0.25583, 0.75583, 0, 0, 0.77778],
    8807: [0.25583, 0.75583, 0, 0, 0.77778],
    8808: [0.25142, 0.75726, 0, 0, 0.77778],
    8809: [0.25142, 0.75726, 0, 0, 0.77778],
    8812: [0.25583, 0.75583, 0, 0, 0.5],
    8814: [0.20576, 0.70576, 0, 0, 0.77778],
    8815: [0.20576, 0.70576, 0, 0, 0.77778],
    8816: [0.30274, 0.79383, 0, 0, 0.77778],
    8817: [0.30274, 0.79383, 0, 0, 0.77778],
    8818: [0.22958, 0.72958, 0, 0, 0.77778],
    8819: [0.22958, 0.72958, 0, 0, 0.77778],
    8822: [0.1808, 0.675, 0, 0, 0.77778],
    8823: [0.1808, 0.675, 0, 0, 0.77778],
    8828: [0.13667, 0.63667, 0, 0, 0.77778],
    8829: [0.13667, 0.63667, 0, 0, 0.77778],
    8830: [0.22958, 0.72958, 0, 0, 0.77778],
    8831: [0.22958, 0.72958, 0, 0, 0.77778],
    8832: [0.20576, 0.70576, 0, 0, 0.77778],
    8833: [0.20576, 0.70576, 0, 0, 0.77778],
    8840: [0.30274, 0.79383, 0, 0, 0.77778],
    8841: [0.30274, 0.79383, 0, 0, 0.77778],
    8842: [0.13597, 0.63597, 0, 0, 0.77778],
    8843: [0.13597, 0.63597, 0, 0, 0.77778],
    8847: [0.03517, 0.54986, 0, 0, 0.77778],
    8848: [0.03517, 0.54986, 0, 0, 0.77778],
    8858: [0.08198, 0.58198, 0, 0, 0.77778],
    8859: [0.08198, 0.58198, 0, 0, 0.77778],
    8861: [0.08198, 0.58198, 0, 0, 0.77778],
    8862: [0, 0.675, 0, 0, 0.77778],
    8863: [0, 0.675, 0, 0, 0.77778],
    8864: [0, 0.675, 0, 0, 0.77778],
    8865: [0, 0.675, 0, 0, 0.77778],
    8872: [0, 0.69224, 0, 0, 0.61111],
    8873: [0, 0.69224, 0, 0, 0.72222],
    8874: [0, 0.69224, 0, 0, 0.88889],
    8876: [0, 0.68889, 0, 0, 0.61111],
    8877: [0, 0.68889, 0, 0, 0.61111],
    8878: [0, 0.68889, 0, 0, 0.72222],
    8879: [0, 0.68889, 0, 0, 0.72222],
    8882: [0.03517, 0.54986, 0, 0, 0.77778],
    8883: [0.03517, 0.54986, 0, 0, 0.77778],
    8884: [0.13667, 0.63667, 0, 0, 0.77778],
    8885: [0.13667, 0.63667, 0, 0, 0.77778],
    8888: [0, 0.54986, 0, 0, 1.11111],
    8890: [0.19444, 0.43056, 0, 0, 0.55556],
    8891: [0.19444, 0.69224, 0, 0, 0.61111],
    8892: [0.19444, 0.69224, 0, 0, 0.61111],
    8901: [0, 0.54986, 0, 0, 0.27778],
    8903: [0.08167, 0.58167, 0, 0, 0.77778],
    8905: [0.08167, 0.58167, 0, 0, 0.77778],
    8906: [0.08167, 0.58167, 0, 0, 0.77778],
    8907: [0, 0.69224, 0, 0, 0.77778],
    8908: [0, 0.69224, 0, 0, 0.77778],
    8909: [-0.03598, 0.46402, 0, 0, 0.77778],
    8910: [0, 0.54986, 0, 0, 0.76042],
    8911: [0, 0.54986, 0, 0, 0.76042],
    8912: [0.03517, 0.54986, 0, 0, 0.77778],
    8913: [0.03517, 0.54986, 0, 0, 0.77778],
    8914: [0, 0.54986, 0, 0, 0.66667],
    8915: [0, 0.54986, 0, 0, 0.66667],
    8916: [0, 0.69224, 0, 0, 0.66667],
    8918: [0.0391, 0.5391, 0, 0, 0.77778],
    8919: [0.0391, 0.5391, 0, 0, 0.77778],
    8920: [0.03517, 0.54986, 0, 0, 1.33334],
    8921: [0.03517, 0.54986, 0, 0, 1.33334],
    8922: [0.38569, 0.88569, 0, 0, 0.77778],
    8923: [0.38569, 0.88569, 0, 0, 0.77778],
    8926: [0.13667, 0.63667, 0, 0, 0.77778],
    8927: [0.13667, 0.63667, 0, 0, 0.77778],
    8928: [0.30274, 0.79383, 0, 0, 0.77778],
    8929: [0.30274, 0.79383, 0, 0, 0.77778],
    8934: [0.23222, 0.74111, 0, 0, 0.77778],
    8935: [0.23222, 0.74111, 0, 0, 0.77778],
    8936: [0.23222, 0.74111, 0, 0, 0.77778],
    8937: [0.23222, 0.74111, 0, 0, 0.77778],
    8938: [0.20576, 0.70576, 0, 0, 0.77778],
    8939: [0.20576, 0.70576, 0, 0, 0.77778],
    8940: [0.30274, 0.79383, 0, 0, 0.77778],
    8941: [0.30274, 0.79383, 0, 0, 0.77778],
    8994: [0.19444, 0.69224, 0, 0, 0.77778],
    8995: [0.19444, 0.69224, 0, 0, 0.77778],
    9416: [0.15559, 0.69224, 0, 0, 0.90222],
    9484: [0, 0.69224, 0, 0, 0.5],
    9488: [0, 0.69224, 0, 0, 0.5],
    9492: [0, 0.37788, 0, 0, 0.5],
    9496: [0, 0.37788, 0, 0, 0.5],
    9585: [0.19444, 0.68889, 0, 0, 0.88889],
    9586: [0.19444, 0.74111, 0, 0, 0.88889],
    9632: [0, 0.675, 0, 0, 0.77778],
    9633: [0, 0.675, 0, 0, 0.77778],
    9650: [0, 0.54986, 0, 0, 0.72222],
    9651: [0, 0.54986, 0, 0, 0.72222],
    9654: [0.03517, 0.54986, 0, 0, 0.77778],
    9660: [0, 0.54986, 0, 0, 0.72222],
    9661: [0, 0.54986, 0, 0, 0.72222],
    9664: [0.03517, 0.54986, 0, 0, 0.77778],
    9674: [0.11111, 0.69224, 0, 0, 0.66667],
    9733: [0.19444, 0.69224, 0, 0, 0.94445],
    10003: [0, 0.69224, 0, 0, 0.83334],
    10016: [0, 0.69224, 0, 0, 0.83334],
    10731: [0.11111, 0.69224, 0, 0, 0.66667],
    10846: [0.19444, 0.75583, 0, 0, 0.61111],
    10877: [0.13667, 0.63667, 0, 0, 0.77778],
    10878: [0.13667, 0.63667, 0, 0, 0.77778],
    10885: [0.25583, 0.75583, 0, 0, 0.77778],
    10886: [0.25583, 0.75583, 0, 0, 0.77778],
    10887: [0.13597, 0.63597, 0, 0, 0.77778],
    10888: [0.13597, 0.63597, 0, 0, 0.77778],
    10889: [0.26167, 0.75726, 0, 0, 0.77778],
    10890: [0.26167, 0.75726, 0, 0, 0.77778],
    10891: [0.48256, 0.98256, 0, 0, 0.77778],
    10892: [0.48256, 0.98256, 0, 0, 0.77778],
    10901: [0.13667, 0.63667, 0, 0, 0.77778],
    10902: [0.13667, 0.63667, 0, 0, 0.77778],
    10933: [0.25142, 0.75726, 0, 0, 0.77778],
    10934: [0.25142, 0.75726, 0, 0, 0.77778],
    10935: [0.26167, 0.75726, 0, 0, 0.77778],
    10936: [0.26167, 0.75726, 0, 0, 0.77778],
    10937: [0.26167, 0.75726, 0, 0, 0.77778],
    10938: [0.26167, 0.75726, 0, 0, 0.77778],
    10949: [0.25583, 0.75583, 0, 0, 0.77778],
    10950: [0.25583, 0.75583, 0, 0, 0.77778],
    10955: [0.28481, 0.79383, 0, 0, 0.77778],
    10956: [0.28481, 0.79383, 0, 0, 0.77778],
    57350: [0.08167, 0.58167, 0, 0, 0.22222],
    57351: [0.08167, 0.58167, 0, 0, 0.38889],
    57352: [0.08167, 0.58167, 0, 0, 0.77778],
    57353: [0, 0.43056, 0.04028, 0, 0.66667],
    57356: [0.25142, 0.75726, 0, 0, 0.77778],
    57357: [0.25142, 0.75726, 0, 0, 0.77778],
    57358: [0.41951, 0.91951, 0, 0, 0.77778],
    57359: [0.30274, 0.79383, 0, 0, 0.77778],
    57360: [0.30274, 0.79383, 0, 0, 0.77778],
    57361: [0.41951, 0.91951, 0, 0, 0.77778],
    57366: [0.25142, 0.75726, 0, 0, 0.77778],
    57367: [0.25142, 0.75726, 0, 0, 0.77778],
    57368: [0.25142, 0.75726, 0, 0, 0.77778],
    57369: [0.25142, 0.75726, 0, 0, 0.77778],
    57370: [0.13597, 0.63597, 0, 0, 0.77778],
    57371: [0.13597, 0.63597, 0, 0, 0.77778]
  },
  "Caligraphic-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.68333, 0, 0.19445, 0.79847],
    66: [0, 0.68333, 0.03041, 0.13889, 0.65681],
    67: [0, 0.68333, 0.05834, 0.13889, 0.52653],
    68: [0, 0.68333, 0.02778, 0.08334, 0.77139],
    69: [0, 0.68333, 0.08944, 0.11111, 0.52778],
    70: [0, 0.68333, 0.09931, 0.11111, 0.71875],
    71: [0.09722, 0.68333, 0.0593, 0.11111, 0.59487],
    72: [0, 0.68333, 965e-5, 0.11111, 0.84452],
    73: [0, 0.68333, 0.07382, 0, 0.54452],
    74: [0.09722, 0.68333, 0.18472, 0.16667, 0.67778],
    75: [0, 0.68333, 0.01445, 0.05556, 0.76195],
    76: [0, 0.68333, 0, 0.13889, 0.68972],
    77: [0, 0.68333, 0, 0.13889, 1.2009],
    78: [0, 0.68333, 0.14736, 0.08334, 0.82049],
    79: [0, 0.68333, 0.02778, 0.11111, 0.79611],
    80: [0, 0.68333, 0.08222, 0.08334, 0.69556],
    81: [0.09722, 0.68333, 0, 0.11111, 0.81667],
    82: [0, 0.68333, 0, 0.08334, 0.8475],
    83: [0, 0.68333, 0.075, 0.13889, 0.60556],
    84: [0, 0.68333, 0.25417, 0, 0.54464],
    85: [0, 0.68333, 0.09931, 0.08334, 0.62583],
    86: [0, 0.68333, 0.08222, 0, 0.61278],
    87: [0, 0.68333, 0.08222, 0.08334, 0.98778],
    88: [0, 0.68333, 0.14643, 0.13889, 0.7133],
    89: [0.09722, 0.68333, 0.08222, 0.08334, 0.66834],
    90: [0, 0.68333, 0.07944, 0.13889, 0.72473],
    160: [0, 0, 0, 0, 0.25]
  },
  "Fraktur-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69141, 0, 0, 0.29574],
    34: [0, 0.69141, 0, 0, 0.21471],
    38: [0, 0.69141, 0, 0, 0.73786],
    39: [0, 0.69141, 0, 0, 0.21201],
    40: [0.24982, 0.74947, 0, 0, 0.38865],
    41: [0.24982, 0.74947, 0, 0, 0.38865],
    42: [0, 0.62119, 0, 0, 0.27764],
    43: [0.08319, 0.58283, 0, 0, 0.75623],
    44: [0, 0.10803, 0, 0, 0.27764],
    45: [0.08319, 0.58283, 0, 0, 0.75623],
    46: [0, 0.10803, 0, 0, 0.27764],
    47: [0.24982, 0.74947, 0, 0, 0.50181],
    48: [0, 0.47534, 0, 0, 0.50181],
    49: [0, 0.47534, 0, 0, 0.50181],
    50: [0, 0.47534, 0, 0, 0.50181],
    51: [0.18906, 0.47534, 0, 0, 0.50181],
    52: [0.18906, 0.47534, 0, 0, 0.50181],
    53: [0.18906, 0.47534, 0, 0, 0.50181],
    54: [0, 0.69141, 0, 0, 0.50181],
    55: [0.18906, 0.47534, 0, 0, 0.50181],
    56: [0, 0.69141, 0, 0, 0.50181],
    57: [0.18906, 0.47534, 0, 0, 0.50181],
    58: [0, 0.47534, 0, 0, 0.21606],
    59: [0.12604, 0.47534, 0, 0, 0.21606],
    61: [-0.13099, 0.36866, 0, 0, 0.75623],
    63: [0, 0.69141, 0, 0, 0.36245],
    65: [0, 0.69141, 0, 0, 0.7176],
    66: [0, 0.69141, 0, 0, 0.88397],
    67: [0, 0.69141, 0, 0, 0.61254],
    68: [0, 0.69141, 0, 0, 0.83158],
    69: [0, 0.69141, 0, 0, 0.66278],
    70: [0.12604, 0.69141, 0, 0, 0.61119],
    71: [0, 0.69141, 0, 0, 0.78539],
    72: [0.06302, 0.69141, 0, 0, 0.7203],
    73: [0, 0.69141, 0, 0, 0.55448],
    74: [0.12604, 0.69141, 0, 0, 0.55231],
    75: [0, 0.69141, 0, 0, 0.66845],
    76: [0, 0.69141, 0, 0, 0.66602],
    77: [0, 0.69141, 0, 0, 1.04953],
    78: [0, 0.69141, 0, 0, 0.83212],
    79: [0, 0.69141, 0, 0, 0.82699],
    80: [0.18906, 0.69141, 0, 0, 0.82753],
    81: [0.03781, 0.69141, 0, 0, 0.82699],
    82: [0, 0.69141, 0, 0, 0.82807],
    83: [0, 0.69141, 0, 0, 0.82861],
    84: [0, 0.69141, 0, 0, 0.66899],
    85: [0, 0.69141, 0, 0, 0.64576],
    86: [0, 0.69141, 0, 0, 0.83131],
    87: [0, 0.69141, 0, 0, 1.04602],
    88: [0, 0.69141, 0, 0, 0.71922],
    89: [0.18906, 0.69141, 0, 0, 0.83293],
    90: [0.12604, 0.69141, 0, 0, 0.60201],
    91: [0.24982, 0.74947, 0, 0, 0.27764],
    93: [0.24982, 0.74947, 0, 0, 0.27764],
    94: [0, 0.69141, 0, 0, 0.49965],
    97: [0, 0.47534, 0, 0, 0.50046],
    98: [0, 0.69141, 0, 0, 0.51315],
    99: [0, 0.47534, 0, 0, 0.38946],
    100: [0, 0.62119, 0, 0, 0.49857],
    101: [0, 0.47534, 0, 0, 0.40053],
    102: [0.18906, 0.69141, 0, 0, 0.32626],
    103: [0.18906, 0.47534, 0, 0, 0.5037],
    104: [0.18906, 0.69141, 0, 0, 0.52126],
    105: [0, 0.69141, 0, 0, 0.27899],
    106: [0, 0.69141, 0, 0, 0.28088],
    107: [0, 0.69141, 0, 0, 0.38946],
    108: [0, 0.69141, 0, 0, 0.27953],
    109: [0, 0.47534, 0, 0, 0.76676],
    110: [0, 0.47534, 0, 0, 0.52666],
    111: [0, 0.47534, 0, 0, 0.48885],
    112: [0.18906, 0.52396, 0, 0, 0.50046],
    113: [0.18906, 0.47534, 0, 0, 0.48912],
    114: [0, 0.47534, 0, 0, 0.38919],
    115: [0, 0.47534, 0, 0, 0.44266],
    116: [0, 0.62119, 0, 0, 0.33301],
    117: [0, 0.47534, 0, 0, 0.5172],
    118: [0, 0.52396, 0, 0, 0.5118],
    119: [0, 0.52396, 0, 0, 0.77351],
    120: [0.18906, 0.47534, 0, 0, 0.38865],
    121: [0.18906, 0.47534, 0, 0, 0.49884],
    122: [0.18906, 0.47534, 0, 0, 0.39054],
    160: [0, 0, 0, 0, 0.25],
    8216: [0, 0.69141, 0, 0, 0.21471],
    8217: [0, 0.69141, 0, 0, 0.21471],
    58112: [0, 0.62119, 0, 0, 0.49749],
    58113: [0, 0.62119, 0, 0, 0.4983],
    58114: [0.18906, 0.69141, 0, 0, 0.33328],
    58115: [0.18906, 0.69141, 0, 0, 0.32923],
    58116: [0.18906, 0.47534, 0, 0, 0.50343],
    58117: [0, 0.69141, 0, 0, 0.33301],
    58118: [0, 0.62119, 0, 0, 0.33409],
    58119: [0, 0.47534, 0, 0, 0.50073]
  },
  "Main-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.35],
    34: [0, 0.69444, 0, 0, 0.60278],
    35: [0.19444, 0.69444, 0, 0, 0.95833],
    36: [0.05556, 0.75, 0, 0, 0.575],
    37: [0.05556, 0.75, 0, 0, 0.95833],
    38: [0, 0.69444, 0, 0, 0.89444],
    39: [0, 0.69444, 0, 0, 0.31944],
    40: [0.25, 0.75, 0, 0, 0.44722],
    41: [0.25, 0.75, 0, 0, 0.44722],
    42: [0, 0.75, 0, 0, 0.575],
    43: [0.13333, 0.63333, 0, 0, 0.89444],
    44: [0.19444, 0.15556, 0, 0, 0.31944],
    45: [0, 0.44444, 0, 0, 0.38333],
    46: [0, 0.15556, 0, 0, 0.31944],
    47: [0.25, 0.75, 0, 0, 0.575],
    48: [0, 0.64444, 0, 0, 0.575],
    49: [0, 0.64444, 0, 0, 0.575],
    50: [0, 0.64444, 0, 0, 0.575],
    51: [0, 0.64444, 0, 0, 0.575],
    52: [0, 0.64444, 0, 0, 0.575],
    53: [0, 0.64444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0, 0.64444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0, 0.64444, 0, 0, 0.575],
    58: [0, 0.44444, 0, 0, 0.31944],
    59: [0.19444, 0.44444, 0, 0, 0.31944],
    60: [0.08556, 0.58556, 0, 0, 0.89444],
    61: [-0.10889, 0.39111, 0, 0, 0.89444],
    62: [0.08556, 0.58556, 0, 0, 0.89444],
    63: [0, 0.69444, 0, 0, 0.54305],
    64: [0, 0.69444, 0, 0, 0.89444],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0, 0, 0.81805],
    67: [0, 0.68611, 0, 0, 0.83055],
    68: [0, 0.68611, 0, 0, 0.88194],
    69: [0, 0.68611, 0, 0, 0.75555],
    70: [0, 0.68611, 0, 0, 0.72361],
    71: [0, 0.68611, 0, 0, 0.90416],
    72: [0, 0.68611, 0, 0, 0.9],
    73: [0, 0.68611, 0, 0, 0.43611],
    74: [0, 0.68611, 0, 0, 0.59444],
    75: [0, 0.68611, 0, 0, 0.90138],
    76: [0, 0.68611, 0, 0, 0.69166],
    77: [0, 0.68611, 0, 0, 1.09166],
    78: [0, 0.68611, 0, 0, 0.9],
    79: [0, 0.68611, 0, 0, 0.86388],
    80: [0, 0.68611, 0, 0, 0.78611],
    81: [0.19444, 0.68611, 0, 0, 0.86388],
    82: [0, 0.68611, 0, 0, 0.8625],
    83: [0, 0.68611, 0, 0, 0.63889],
    84: [0, 0.68611, 0, 0, 0.8],
    85: [0, 0.68611, 0, 0, 0.88472],
    86: [0, 0.68611, 0.01597, 0, 0.86944],
    87: [0, 0.68611, 0.01597, 0, 1.18888],
    88: [0, 0.68611, 0, 0, 0.86944],
    89: [0, 0.68611, 0.02875, 0, 0.86944],
    90: [0, 0.68611, 0, 0, 0.70277],
    91: [0.25, 0.75, 0, 0, 0.31944],
    92: [0.25, 0.75, 0, 0, 0.575],
    93: [0.25, 0.75, 0, 0, 0.31944],
    94: [0, 0.69444, 0, 0, 0.575],
    95: [0.31, 0.13444, 0.03194, 0, 0.575],
    97: [0, 0.44444, 0, 0, 0.55902],
    98: [0, 0.69444, 0, 0, 0.63889],
    99: [0, 0.44444, 0, 0, 0.51111],
    100: [0, 0.69444, 0, 0, 0.63889],
    101: [0, 0.44444, 0, 0, 0.52708],
    102: [0, 0.69444, 0.10903, 0, 0.35139],
    103: [0.19444, 0.44444, 0.01597, 0, 0.575],
    104: [0, 0.69444, 0, 0, 0.63889],
    105: [0, 0.69444, 0, 0, 0.31944],
    106: [0.19444, 0.69444, 0, 0, 0.35139],
    107: [0, 0.69444, 0, 0, 0.60694],
    108: [0, 0.69444, 0, 0, 0.31944],
    109: [0, 0.44444, 0, 0, 0.95833],
    110: [0, 0.44444, 0, 0, 0.63889],
    111: [0, 0.44444, 0, 0, 0.575],
    112: [0.19444, 0.44444, 0, 0, 0.63889],
    113: [0.19444, 0.44444, 0, 0, 0.60694],
    114: [0, 0.44444, 0, 0, 0.47361],
    115: [0, 0.44444, 0, 0, 0.45361],
    116: [0, 0.63492, 0, 0, 0.44722],
    117: [0, 0.44444, 0, 0, 0.63889],
    118: [0, 0.44444, 0.01597, 0, 0.60694],
    119: [0, 0.44444, 0.01597, 0, 0.83055],
    120: [0, 0.44444, 0, 0, 0.60694],
    121: [0.19444, 0.44444, 0.01597, 0, 0.60694],
    122: [0, 0.44444, 0, 0, 0.51111],
    123: [0.25, 0.75, 0, 0, 0.575],
    124: [0.25, 0.75, 0, 0, 0.31944],
    125: [0.25, 0.75, 0, 0, 0.575],
    126: [0.35, 0.34444, 0, 0, 0.575],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.86853],
    168: [0, 0.69444, 0, 0, 0.575],
    172: [0, 0.44444, 0, 0, 0.76666],
    176: [0, 0.69444, 0, 0, 0.86944],
    177: [0.13333, 0.63333, 0, 0, 0.89444],
    184: [0.17014, 0, 0, 0, 0.51111],
    198: [0, 0.68611, 0, 0, 1.04166],
    215: [0.13333, 0.63333, 0, 0, 0.89444],
    216: [0.04861, 0.73472, 0, 0, 0.89444],
    223: [0, 0.69444, 0, 0, 0.59722],
    230: [0, 0.44444, 0, 0, 0.83055],
    247: [0.13333, 0.63333, 0, 0, 0.89444],
    248: [0.09722, 0.54167, 0, 0, 0.575],
    305: [0, 0.44444, 0, 0, 0.31944],
    338: [0, 0.68611, 0, 0, 1.16944],
    339: [0, 0.44444, 0, 0, 0.89444],
    567: [0.19444, 0.44444, 0, 0, 0.35139],
    710: [0, 0.69444, 0, 0, 0.575],
    711: [0, 0.63194, 0, 0, 0.575],
    713: [0, 0.59611, 0, 0, 0.575],
    714: [0, 0.69444, 0, 0, 0.575],
    715: [0, 0.69444, 0, 0, 0.575],
    728: [0, 0.69444, 0, 0, 0.575],
    729: [0, 0.69444, 0, 0, 0.31944],
    730: [0, 0.69444, 0, 0, 0.86944],
    732: [0, 0.69444, 0, 0, 0.575],
    733: [0, 0.69444, 0, 0, 0.575],
    915: [0, 0.68611, 0, 0, 0.69166],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0, 0, 0.89444],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0, 0, 0.76666],
    928: [0, 0.68611, 0, 0, 0.9],
    931: [0, 0.68611, 0, 0, 0.83055],
    933: [0, 0.68611, 0, 0, 0.89444],
    934: [0, 0.68611, 0, 0, 0.83055],
    936: [0, 0.68611, 0, 0, 0.89444],
    937: [0, 0.68611, 0, 0, 0.83055],
    8211: [0, 0.44444, 0.03194, 0, 0.575],
    8212: [0, 0.44444, 0.03194, 0, 1.14999],
    8216: [0, 0.69444, 0, 0, 0.31944],
    8217: [0, 0.69444, 0, 0, 0.31944],
    8220: [0, 0.69444, 0, 0, 0.60278],
    8221: [0, 0.69444, 0, 0, 0.60278],
    8224: [0.19444, 0.69444, 0, 0, 0.51111],
    8225: [0.19444, 0.69444, 0, 0, 0.51111],
    8242: [0, 0.55556, 0, 0, 0.34444],
    8407: [0, 0.72444, 0.15486, 0, 0.575],
    8463: [0, 0.69444, 0, 0, 0.66759],
    8465: [0, 0.69444, 0, 0, 0.83055],
    8467: [0, 0.69444, 0, 0, 0.47361],
    8472: [0.19444, 0.44444, 0, 0, 0.74027],
    8476: [0, 0.69444, 0, 0, 0.83055],
    8501: [0, 0.69444, 0, 0, 0.70277],
    8592: [-0.10889, 0.39111, 0, 0, 1.14999],
    8593: [0.19444, 0.69444, 0, 0, 0.575],
    8594: [-0.10889, 0.39111, 0, 0, 1.14999],
    8595: [0.19444, 0.69444, 0, 0, 0.575],
    8596: [-0.10889, 0.39111, 0, 0, 1.14999],
    8597: [0.25, 0.75, 0, 0, 0.575],
    8598: [0.19444, 0.69444, 0, 0, 1.14999],
    8599: [0.19444, 0.69444, 0, 0, 1.14999],
    8600: [0.19444, 0.69444, 0, 0, 1.14999],
    8601: [0.19444, 0.69444, 0, 0, 1.14999],
    8636: [-0.10889, 0.39111, 0, 0, 1.14999],
    8637: [-0.10889, 0.39111, 0, 0, 1.14999],
    8640: [-0.10889, 0.39111, 0, 0, 1.14999],
    8641: [-0.10889, 0.39111, 0, 0, 1.14999],
    8656: [-0.10889, 0.39111, 0, 0, 1.14999],
    8657: [0.19444, 0.69444, 0, 0, 0.70277],
    8658: [-0.10889, 0.39111, 0, 0, 1.14999],
    8659: [0.19444, 0.69444, 0, 0, 0.70277],
    8660: [-0.10889, 0.39111, 0, 0, 1.14999],
    8661: [0.25, 0.75, 0, 0, 0.70277],
    8704: [0, 0.69444, 0, 0, 0.63889],
    8706: [0, 0.69444, 0.06389, 0, 0.62847],
    8707: [0, 0.69444, 0, 0, 0.63889],
    8709: [0.05556, 0.75, 0, 0, 0.575],
    8711: [0, 0.68611, 0, 0, 0.95833],
    8712: [0.08556, 0.58556, 0, 0, 0.76666],
    8715: [0.08556, 0.58556, 0, 0, 0.76666],
    8722: [0.13333, 0.63333, 0, 0, 0.89444],
    8723: [0.13333, 0.63333, 0, 0, 0.89444],
    8725: [0.25, 0.75, 0, 0, 0.575],
    8726: [0.25, 0.75, 0, 0, 0.575],
    8727: [-0.02778, 0.47222, 0, 0, 0.575],
    8728: [-0.02639, 0.47361, 0, 0, 0.575],
    8729: [-0.02639, 0.47361, 0, 0, 0.575],
    8730: [0.18, 0.82, 0, 0, 0.95833],
    8733: [0, 0.44444, 0, 0, 0.89444],
    8734: [0, 0.44444, 0, 0, 1.14999],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.31944],
    8741: [0.25, 0.75, 0, 0, 0.575],
    8743: [0, 0.55556, 0, 0, 0.76666],
    8744: [0, 0.55556, 0, 0, 0.76666],
    8745: [0, 0.55556, 0, 0, 0.76666],
    8746: [0, 0.55556, 0, 0, 0.76666],
    8747: [0.19444, 0.69444, 0.12778, 0, 0.56875],
    8764: [-0.10889, 0.39111, 0, 0, 0.89444],
    8768: [0.19444, 0.69444, 0, 0, 0.31944],
    8771: [222e-5, 0.50222, 0, 0, 0.89444],
    8773: [0.027, 0.638, 0, 0, 0.894],
    8776: [0.02444, 0.52444, 0, 0, 0.89444],
    8781: [222e-5, 0.50222, 0, 0, 0.89444],
    8801: [222e-5, 0.50222, 0, 0, 0.89444],
    8804: [0.19667, 0.69667, 0, 0, 0.89444],
    8805: [0.19667, 0.69667, 0, 0, 0.89444],
    8810: [0.08556, 0.58556, 0, 0, 1.14999],
    8811: [0.08556, 0.58556, 0, 0, 1.14999],
    8826: [0.08556, 0.58556, 0, 0, 0.89444],
    8827: [0.08556, 0.58556, 0, 0, 0.89444],
    8834: [0.08556, 0.58556, 0, 0, 0.89444],
    8835: [0.08556, 0.58556, 0, 0, 0.89444],
    8838: [0.19667, 0.69667, 0, 0, 0.89444],
    8839: [0.19667, 0.69667, 0, 0, 0.89444],
    8846: [0, 0.55556, 0, 0, 0.76666],
    8849: [0.19667, 0.69667, 0, 0, 0.89444],
    8850: [0.19667, 0.69667, 0, 0, 0.89444],
    8851: [0, 0.55556, 0, 0, 0.76666],
    8852: [0, 0.55556, 0, 0, 0.76666],
    8853: [0.13333, 0.63333, 0, 0, 0.89444],
    8854: [0.13333, 0.63333, 0, 0, 0.89444],
    8855: [0.13333, 0.63333, 0, 0, 0.89444],
    8856: [0.13333, 0.63333, 0, 0, 0.89444],
    8857: [0.13333, 0.63333, 0, 0, 0.89444],
    8866: [0, 0.69444, 0, 0, 0.70277],
    8867: [0, 0.69444, 0, 0, 0.70277],
    8868: [0, 0.69444, 0, 0, 0.89444],
    8869: [0, 0.69444, 0, 0, 0.89444],
    8900: [-0.02639, 0.47361, 0, 0, 0.575],
    8901: [-0.02639, 0.47361, 0, 0, 0.31944],
    8902: [-0.02778, 0.47222, 0, 0, 0.575],
    8968: [0.25, 0.75, 0, 0, 0.51111],
    8969: [0.25, 0.75, 0, 0, 0.51111],
    8970: [0.25, 0.75, 0, 0, 0.51111],
    8971: [0.25, 0.75, 0, 0, 0.51111],
    8994: [-0.13889, 0.36111, 0, 0, 1.14999],
    8995: [-0.13889, 0.36111, 0, 0, 1.14999],
    9651: [0.19444, 0.69444, 0, 0, 1.02222],
    9657: [-0.02778, 0.47222, 0, 0, 0.575],
    9661: [0.19444, 0.69444, 0, 0, 1.02222],
    9667: [-0.02778, 0.47222, 0, 0, 0.575],
    9711: [0.19444, 0.69444, 0, 0, 1.14999],
    9824: [0.12963, 0.69444, 0, 0, 0.89444],
    9825: [0.12963, 0.69444, 0, 0, 0.89444],
    9826: [0.12963, 0.69444, 0, 0, 0.89444],
    9827: [0.12963, 0.69444, 0, 0, 0.89444],
    9837: [0, 0.75, 0, 0, 0.44722],
    9838: [0.19444, 0.69444, 0, 0, 0.44722],
    9839: [0.19444, 0.69444, 0, 0, 0.44722],
    10216: [0.25, 0.75, 0, 0, 0.44722],
    10217: [0.25, 0.75, 0, 0, 0.44722],
    10815: [0, 0.68611, 0, 0, 0.9],
    10927: [0.19667, 0.69667, 0, 0, 0.89444],
    10928: [0.19667, 0.69667, 0, 0, 0.89444],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Main-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.11417, 0, 0.38611],
    34: [0, 0.69444, 0.07939, 0, 0.62055],
    35: [0.19444, 0.69444, 0.06833, 0, 0.94444],
    37: [0.05556, 0.75, 0.12861, 0, 0.94444],
    38: [0, 0.69444, 0.08528, 0, 0.88555],
    39: [0, 0.69444, 0.12945, 0, 0.35555],
    40: [0.25, 0.75, 0.15806, 0, 0.47333],
    41: [0.25, 0.75, 0.03306, 0, 0.47333],
    42: [0, 0.75, 0.14333, 0, 0.59111],
    43: [0.10333, 0.60333, 0.03306, 0, 0.88555],
    44: [0.19444, 0.14722, 0, 0, 0.35555],
    45: [0, 0.44444, 0.02611, 0, 0.41444],
    46: [0, 0.14722, 0, 0, 0.35555],
    47: [0.25, 0.75, 0.15806, 0, 0.59111],
    48: [0, 0.64444, 0.13167, 0, 0.59111],
    49: [0, 0.64444, 0.13167, 0, 0.59111],
    50: [0, 0.64444, 0.13167, 0, 0.59111],
    51: [0, 0.64444, 0.13167, 0, 0.59111],
    52: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    53: [0, 0.64444, 0.13167, 0, 0.59111],
    54: [0, 0.64444, 0.13167, 0, 0.59111],
    55: [0.19444, 0.64444, 0.13167, 0, 0.59111],
    56: [0, 0.64444, 0.13167, 0, 0.59111],
    57: [0, 0.64444, 0.13167, 0, 0.59111],
    58: [0, 0.44444, 0.06695, 0, 0.35555],
    59: [0.19444, 0.44444, 0.06695, 0, 0.35555],
    61: [-0.10889, 0.39111, 0.06833, 0, 0.88555],
    63: [0, 0.69444, 0.11472, 0, 0.59111],
    64: [0, 0.69444, 0.09208, 0, 0.88555],
    65: [0, 0.68611, 0, 0, 0.86555],
    66: [0, 0.68611, 0.0992, 0, 0.81666],
    67: [0, 0.68611, 0.14208, 0, 0.82666],
    68: [0, 0.68611, 0.09062, 0, 0.87555],
    69: [0, 0.68611, 0.11431, 0, 0.75666],
    70: [0, 0.68611, 0.12903, 0, 0.72722],
    71: [0, 0.68611, 0.07347, 0, 0.89527],
    72: [0, 0.68611, 0.17208, 0, 0.8961],
    73: [0, 0.68611, 0.15681, 0, 0.47166],
    74: [0, 0.68611, 0.145, 0, 0.61055],
    75: [0, 0.68611, 0.14208, 0, 0.89499],
    76: [0, 0.68611, 0, 0, 0.69777],
    77: [0, 0.68611, 0.17208, 0, 1.07277],
    78: [0, 0.68611, 0.17208, 0, 0.8961],
    79: [0, 0.68611, 0.09062, 0, 0.85499],
    80: [0, 0.68611, 0.0992, 0, 0.78721],
    81: [0.19444, 0.68611, 0.09062, 0, 0.85499],
    82: [0, 0.68611, 0.02559, 0, 0.85944],
    83: [0, 0.68611, 0.11264, 0, 0.64999],
    84: [0, 0.68611, 0.12903, 0, 0.7961],
    85: [0, 0.68611, 0.17208, 0, 0.88083],
    86: [0, 0.68611, 0.18625, 0, 0.86555],
    87: [0, 0.68611, 0.18625, 0, 1.15999],
    88: [0, 0.68611, 0.15681, 0, 0.86555],
    89: [0, 0.68611, 0.19803, 0, 0.86555],
    90: [0, 0.68611, 0.14208, 0, 0.70888],
    91: [0.25, 0.75, 0.1875, 0, 0.35611],
    93: [0.25, 0.75, 0.09972, 0, 0.35611],
    94: [0, 0.69444, 0.06709, 0, 0.59111],
    95: [0.31, 0.13444, 0.09811, 0, 0.59111],
    97: [0, 0.44444, 0.09426, 0, 0.59111],
    98: [0, 0.69444, 0.07861, 0, 0.53222],
    99: [0, 0.44444, 0.05222, 0, 0.53222],
    100: [0, 0.69444, 0.10861, 0, 0.59111],
    101: [0, 0.44444, 0.085, 0, 0.53222],
    102: [0.19444, 0.69444, 0.21778, 0, 0.4],
    103: [0.19444, 0.44444, 0.105, 0, 0.53222],
    104: [0, 0.69444, 0.09426, 0, 0.59111],
    105: [0, 0.69326, 0.11387, 0, 0.35555],
    106: [0.19444, 0.69326, 0.1672, 0, 0.35555],
    107: [0, 0.69444, 0.11111, 0, 0.53222],
    108: [0, 0.69444, 0.10861, 0, 0.29666],
    109: [0, 0.44444, 0.09426, 0, 0.94444],
    110: [0, 0.44444, 0.09426, 0, 0.64999],
    111: [0, 0.44444, 0.07861, 0, 0.59111],
    112: [0.19444, 0.44444, 0.07861, 0, 0.59111],
    113: [0.19444, 0.44444, 0.105, 0, 0.53222],
    114: [0, 0.44444, 0.11111, 0, 0.50167],
    115: [0, 0.44444, 0.08167, 0, 0.48694],
    116: [0, 0.63492, 0.09639, 0, 0.385],
    117: [0, 0.44444, 0.09426, 0, 0.62055],
    118: [0, 0.44444, 0.11111, 0, 0.53222],
    119: [0, 0.44444, 0.11111, 0, 0.76777],
    120: [0, 0.44444, 0.12583, 0, 0.56055],
    121: [0.19444, 0.44444, 0.105, 0, 0.56166],
    122: [0, 0.44444, 0.13889, 0, 0.49055],
    126: [0.35, 0.34444, 0.11472, 0, 0.59111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0.11473, 0, 0.59111],
    176: [0, 0.69444, 0, 0, 0.94888],
    184: [0.17014, 0, 0, 0, 0.53222],
    198: [0, 0.68611, 0.11431, 0, 1.02277],
    216: [0.04861, 0.73472, 0.09062, 0, 0.88555],
    223: [0.19444, 0.69444, 0.09736, 0, 0.665],
    230: [0, 0.44444, 0.085, 0, 0.82666],
    248: [0.09722, 0.54167, 0.09458, 0, 0.59111],
    305: [0, 0.44444, 0.09426, 0, 0.35555],
    338: [0, 0.68611, 0.11431, 0, 1.14054],
    339: [0, 0.44444, 0.085, 0, 0.82666],
    567: [0.19444, 0.44444, 0.04611, 0, 0.385],
    710: [0, 0.69444, 0.06709, 0, 0.59111],
    711: [0, 0.63194, 0.08271, 0, 0.59111],
    713: [0, 0.59444, 0.10444, 0, 0.59111],
    714: [0, 0.69444, 0.08528, 0, 0.59111],
    715: [0, 0.69444, 0, 0, 0.59111],
    728: [0, 0.69444, 0.10333, 0, 0.59111],
    729: [0, 0.69444, 0.12945, 0, 0.35555],
    730: [0, 0.69444, 0, 0, 0.94888],
    732: [0, 0.69444, 0.11472, 0, 0.59111],
    733: [0, 0.69444, 0.11472, 0, 0.59111],
    915: [0, 0.68611, 0.12903, 0, 0.69777],
    916: [0, 0.68611, 0, 0, 0.94444],
    920: [0, 0.68611, 0.09062, 0, 0.88555],
    923: [0, 0.68611, 0, 0, 0.80666],
    926: [0, 0.68611, 0.15092, 0, 0.76777],
    928: [0, 0.68611, 0.17208, 0, 0.8961],
    931: [0, 0.68611, 0.11431, 0, 0.82666],
    933: [0, 0.68611, 0.10778, 0, 0.88555],
    934: [0, 0.68611, 0.05632, 0, 0.82666],
    936: [0, 0.68611, 0.10778, 0, 0.88555],
    937: [0, 0.68611, 0.0992, 0, 0.82666],
    8211: [0, 0.44444, 0.09811, 0, 0.59111],
    8212: [0, 0.44444, 0.09811, 0, 1.18221],
    8216: [0, 0.69444, 0.12945, 0, 0.35555],
    8217: [0, 0.69444, 0.12945, 0, 0.35555],
    8220: [0, 0.69444, 0.16772, 0, 0.62055],
    8221: [0, 0.69444, 0.07939, 0, 0.62055]
  },
  "Main-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.12417, 0, 0.30667],
    34: [0, 0.69444, 0.06961, 0, 0.51444],
    35: [0.19444, 0.69444, 0.06616, 0, 0.81777],
    37: [0.05556, 0.75, 0.13639, 0, 0.81777],
    38: [0, 0.69444, 0.09694, 0, 0.76666],
    39: [0, 0.69444, 0.12417, 0, 0.30667],
    40: [0.25, 0.75, 0.16194, 0, 0.40889],
    41: [0.25, 0.75, 0.03694, 0, 0.40889],
    42: [0, 0.75, 0.14917, 0, 0.51111],
    43: [0.05667, 0.56167, 0.03694, 0, 0.76666],
    44: [0.19444, 0.10556, 0, 0, 0.30667],
    45: [0, 0.43056, 0.02826, 0, 0.35778],
    46: [0, 0.10556, 0, 0, 0.30667],
    47: [0.25, 0.75, 0.16194, 0, 0.51111],
    48: [0, 0.64444, 0.13556, 0, 0.51111],
    49: [0, 0.64444, 0.13556, 0, 0.51111],
    50: [0, 0.64444, 0.13556, 0, 0.51111],
    51: [0, 0.64444, 0.13556, 0, 0.51111],
    52: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    53: [0, 0.64444, 0.13556, 0, 0.51111],
    54: [0, 0.64444, 0.13556, 0, 0.51111],
    55: [0.19444, 0.64444, 0.13556, 0, 0.51111],
    56: [0, 0.64444, 0.13556, 0, 0.51111],
    57: [0, 0.64444, 0.13556, 0, 0.51111],
    58: [0, 0.43056, 0.0582, 0, 0.30667],
    59: [0.19444, 0.43056, 0.0582, 0, 0.30667],
    61: [-0.13313, 0.36687, 0.06616, 0, 0.76666],
    63: [0, 0.69444, 0.1225, 0, 0.51111],
    64: [0, 0.69444, 0.09597, 0, 0.76666],
    65: [0, 0.68333, 0, 0, 0.74333],
    66: [0, 0.68333, 0.10257, 0, 0.70389],
    67: [0, 0.68333, 0.14528, 0, 0.71555],
    68: [0, 0.68333, 0.09403, 0, 0.755],
    69: [0, 0.68333, 0.12028, 0, 0.67833],
    70: [0, 0.68333, 0.13305, 0, 0.65277],
    71: [0, 0.68333, 0.08722, 0, 0.77361],
    72: [0, 0.68333, 0.16389, 0, 0.74333],
    73: [0, 0.68333, 0.15806, 0, 0.38555],
    74: [0, 0.68333, 0.14028, 0, 0.525],
    75: [0, 0.68333, 0.14528, 0, 0.76888],
    76: [0, 0.68333, 0, 0, 0.62722],
    77: [0, 0.68333, 0.16389, 0, 0.89666],
    78: [0, 0.68333, 0.16389, 0, 0.74333],
    79: [0, 0.68333, 0.09403, 0, 0.76666],
    80: [0, 0.68333, 0.10257, 0, 0.67833],
    81: [0.19444, 0.68333, 0.09403, 0, 0.76666],
    82: [0, 0.68333, 0.03868, 0, 0.72944],
    83: [0, 0.68333, 0.11972, 0, 0.56222],
    84: [0, 0.68333, 0.13305, 0, 0.71555],
    85: [0, 0.68333, 0.16389, 0, 0.74333],
    86: [0, 0.68333, 0.18361, 0, 0.74333],
    87: [0, 0.68333, 0.18361, 0, 0.99888],
    88: [0, 0.68333, 0.15806, 0, 0.74333],
    89: [0, 0.68333, 0.19383, 0, 0.74333],
    90: [0, 0.68333, 0.14528, 0, 0.61333],
    91: [0.25, 0.75, 0.1875, 0, 0.30667],
    93: [0.25, 0.75, 0.10528, 0, 0.30667],
    94: [0, 0.69444, 0.06646, 0, 0.51111],
    95: [0.31, 0.12056, 0.09208, 0, 0.51111],
    97: [0, 0.43056, 0.07671, 0, 0.51111],
    98: [0, 0.69444, 0.06312, 0, 0.46],
    99: [0, 0.43056, 0.05653, 0, 0.46],
    100: [0, 0.69444, 0.10333, 0, 0.51111],
    101: [0, 0.43056, 0.07514, 0, 0.46],
    102: [0.19444, 0.69444, 0.21194, 0, 0.30667],
    103: [0.19444, 0.43056, 0.08847, 0, 0.46],
    104: [0, 0.69444, 0.07671, 0, 0.51111],
    105: [0, 0.65536, 0.1019, 0, 0.30667],
    106: [0.19444, 0.65536, 0.14467, 0, 0.30667],
    107: [0, 0.69444, 0.10764, 0, 0.46],
    108: [0, 0.69444, 0.10333, 0, 0.25555],
    109: [0, 0.43056, 0.07671, 0, 0.81777],
    110: [0, 0.43056, 0.07671, 0, 0.56222],
    111: [0, 0.43056, 0.06312, 0, 0.51111],
    112: [0.19444, 0.43056, 0.06312, 0, 0.51111],
    113: [0.19444, 0.43056, 0.08847, 0, 0.46],
    114: [0, 0.43056, 0.10764, 0, 0.42166],
    115: [0, 0.43056, 0.08208, 0, 0.40889],
    116: [0, 0.61508, 0.09486, 0, 0.33222],
    117: [0, 0.43056, 0.07671, 0, 0.53666],
    118: [0, 0.43056, 0.10764, 0, 0.46],
    119: [0, 0.43056, 0.10764, 0, 0.66444],
    120: [0, 0.43056, 0.12042, 0, 0.46389],
    121: [0.19444, 0.43056, 0.08847, 0, 0.48555],
    122: [0, 0.43056, 0.12292, 0, 0.40889],
    126: [0.35, 0.31786, 0.11585, 0, 0.51111],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.66786, 0.10474, 0, 0.51111],
    176: [0, 0.69444, 0, 0, 0.83129],
    184: [0.17014, 0, 0, 0, 0.46],
    198: [0, 0.68333, 0.12028, 0, 0.88277],
    216: [0.04861, 0.73194, 0.09403, 0, 0.76666],
    223: [0.19444, 0.69444, 0.10514, 0, 0.53666],
    230: [0, 0.43056, 0.07514, 0, 0.71555],
    248: [0.09722, 0.52778, 0.09194, 0, 0.51111],
    338: [0, 0.68333, 0.12028, 0, 0.98499],
    339: [0, 0.43056, 0.07514, 0, 0.71555],
    710: [0, 0.69444, 0.06646, 0, 0.51111],
    711: [0, 0.62847, 0.08295, 0, 0.51111],
    713: [0, 0.56167, 0.10333, 0, 0.51111],
    714: [0, 0.69444, 0.09694, 0, 0.51111],
    715: [0, 0.69444, 0, 0, 0.51111],
    728: [0, 0.69444, 0.10806, 0, 0.51111],
    729: [0, 0.66786, 0.11752, 0, 0.30667],
    730: [0, 0.69444, 0, 0, 0.83129],
    732: [0, 0.66786, 0.11585, 0, 0.51111],
    733: [0, 0.69444, 0.1225, 0, 0.51111],
    915: [0, 0.68333, 0.13305, 0, 0.62722],
    916: [0, 0.68333, 0, 0, 0.81777],
    920: [0, 0.68333, 0.09403, 0, 0.76666],
    923: [0, 0.68333, 0, 0, 0.69222],
    926: [0, 0.68333, 0.15294, 0, 0.66444],
    928: [0, 0.68333, 0.16389, 0, 0.74333],
    931: [0, 0.68333, 0.12028, 0, 0.71555],
    933: [0, 0.68333, 0.11111, 0, 0.76666],
    934: [0, 0.68333, 0.05986, 0, 0.71555],
    936: [0, 0.68333, 0.11111, 0, 0.76666],
    937: [0, 0.68333, 0.10257, 0, 0.71555],
    8211: [0, 0.43056, 0.09208, 0, 0.51111],
    8212: [0, 0.43056, 0.09208, 0, 1.02222],
    8216: [0, 0.69444, 0.12417, 0, 0.30667],
    8217: [0, 0.69444, 0.12417, 0, 0.30667],
    8220: [0, 0.69444, 0.1685, 0, 0.51444],
    8221: [0, 0.69444, 0.06961, 0, 0.51444],
    8463: [0, 0.68889, 0, 0, 0.54028]
  },
  "Main-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.27778],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.77778],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.19444, 0.10556, 0, 0, 0.27778],
    45: [0, 0.43056, 0, 0, 0.33333],
    46: [0, 0.10556, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.64444, 0, 0, 0.5],
    49: [0, 0.64444, 0, 0, 0.5],
    50: [0, 0.64444, 0, 0, 0.5],
    51: [0, 0.64444, 0, 0, 0.5],
    52: [0, 0.64444, 0, 0, 0.5],
    53: [0, 0.64444, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0, 0.64444, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0, 0.64444, 0, 0, 0.5],
    58: [0, 0.43056, 0, 0, 0.27778],
    59: [0.19444, 0.43056, 0, 0, 0.27778],
    60: [0.0391, 0.5391, 0, 0, 0.77778],
    61: [-0.13313, 0.36687, 0, 0, 0.77778],
    62: [0.0391, 0.5391, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.77778],
    65: [0, 0.68333, 0, 0, 0.75],
    66: [0, 0.68333, 0, 0, 0.70834],
    67: [0, 0.68333, 0, 0, 0.72222],
    68: [0, 0.68333, 0, 0, 0.76389],
    69: [0, 0.68333, 0, 0, 0.68056],
    70: [0, 0.68333, 0, 0, 0.65278],
    71: [0, 0.68333, 0, 0, 0.78472],
    72: [0, 0.68333, 0, 0, 0.75],
    73: [0, 0.68333, 0, 0, 0.36111],
    74: [0, 0.68333, 0, 0, 0.51389],
    75: [0, 0.68333, 0, 0, 0.77778],
    76: [0, 0.68333, 0, 0, 0.625],
    77: [0, 0.68333, 0, 0, 0.91667],
    78: [0, 0.68333, 0, 0, 0.75],
    79: [0, 0.68333, 0, 0, 0.77778],
    80: [0, 0.68333, 0, 0, 0.68056],
    81: [0.19444, 0.68333, 0, 0, 0.77778],
    82: [0, 0.68333, 0, 0, 0.73611],
    83: [0, 0.68333, 0, 0, 0.55556],
    84: [0, 0.68333, 0, 0, 0.72222],
    85: [0, 0.68333, 0, 0, 0.75],
    86: [0, 0.68333, 0.01389, 0, 0.75],
    87: [0, 0.68333, 0.01389, 0, 1.02778],
    88: [0, 0.68333, 0, 0, 0.75],
    89: [0, 0.68333, 0.025, 0, 0.75],
    90: [0, 0.68333, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.27778],
    92: [0.25, 0.75, 0, 0, 0.5],
    93: [0.25, 0.75, 0, 0, 0.27778],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.31, 0.12056, 0.02778, 0, 0.5],
    97: [0, 0.43056, 0, 0, 0.5],
    98: [0, 0.69444, 0, 0, 0.55556],
    99: [0, 0.43056, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.55556],
    101: [0, 0.43056, 0, 0, 0.44445],
    102: [0, 0.69444, 0.07778, 0, 0.30556],
    103: [0.19444, 0.43056, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.55556],
    105: [0, 0.66786, 0, 0, 0.27778],
    106: [0.19444, 0.66786, 0, 0, 0.30556],
    107: [0, 0.69444, 0, 0, 0.52778],
    108: [0, 0.69444, 0, 0, 0.27778],
    109: [0, 0.43056, 0, 0, 0.83334],
    110: [0, 0.43056, 0, 0, 0.55556],
    111: [0, 0.43056, 0, 0, 0.5],
    112: [0.19444, 0.43056, 0, 0, 0.55556],
    113: [0.19444, 0.43056, 0, 0, 0.52778],
    114: [0, 0.43056, 0, 0, 0.39167],
    115: [0, 0.43056, 0, 0, 0.39445],
    116: [0, 0.61508, 0, 0, 0.38889],
    117: [0, 0.43056, 0, 0, 0.55556],
    118: [0, 0.43056, 0.01389, 0, 0.52778],
    119: [0, 0.43056, 0.01389, 0, 0.72222],
    120: [0, 0.43056, 0, 0, 0.52778],
    121: [0.19444, 0.43056, 0.01389, 0, 0.52778],
    122: [0, 0.43056, 0, 0, 0.44445],
    123: [0.25, 0.75, 0, 0, 0.5],
    124: [0.25, 0.75, 0, 0, 0.27778],
    125: [0.25, 0.75, 0, 0, 0.5],
    126: [0.35, 0.31786, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    163: [0, 0.69444, 0, 0, 0.76909],
    167: [0.19444, 0.69444, 0, 0, 0.44445],
    168: [0, 0.66786, 0, 0, 0.5],
    172: [0, 0.43056, 0, 0, 0.66667],
    176: [0, 0.69444, 0, 0, 0.75],
    177: [0.08333, 0.58333, 0, 0, 0.77778],
    182: [0.19444, 0.69444, 0, 0, 0.61111],
    184: [0.17014, 0, 0, 0, 0.44445],
    198: [0, 0.68333, 0, 0, 0.90278],
    215: [0.08333, 0.58333, 0, 0, 0.77778],
    216: [0.04861, 0.73194, 0, 0, 0.77778],
    223: [0, 0.69444, 0, 0, 0.5],
    230: [0, 0.43056, 0, 0, 0.72222],
    247: [0.08333, 0.58333, 0, 0, 0.77778],
    248: [0.09722, 0.52778, 0, 0, 0.5],
    305: [0, 0.43056, 0, 0, 0.27778],
    338: [0, 0.68333, 0, 0, 1.01389],
    339: [0, 0.43056, 0, 0, 0.77778],
    567: [0.19444, 0.43056, 0, 0, 0.30556],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.62847, 0, 0, 0.5],
    713: [0, 0.56778, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.66786, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.75],
    732: [0, 0.66786, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.68333, 0, 0, 0.625],
    916: [0, 0.68333, 0, 0, 0.83334],
    920: [0, 0.68333, 0, 0, 0.77778],
    923: [0, 0.68333, 0, 0, 0.69445],
    926: [0, 0.68333, 0, 0, 0.66667],
    928: [0, 0.68333, 0, 0, 0.75],
    931: [0, 0.68333, 0, 0, 0.72222],
    933: [0, 0.68333, 0, 0, 0.77778],
    934: [0, 0.68333, 0, 0, 0.72222],
    936: [0, 0.68333, 0, 0, 0.77778],
    937: [0, 0.68333, 0, 0, 0.72222],
    8211: [0, 0.43056, 0.02778, 0, 0.5],
    8212: [0, 0.43056, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5],
    8224: [0.19444, 0.69444, 0, 0, 0.44445],
    8225: [0.19444, 0.69444, 0, 0, 0.44445],
    8230: [0, 0.123, 0, 0, 1.172],
    8242: [0, 0.55556, 0, 0, 0.275],
    8407: [0, 0.71444, 0.15382, 0, 0.5],
    8463: [0, 0.68889, 0, 0, 0.54028],
    8465: [0, 0.69444, 0, 0, 0.72222],
    8467: [0, 0.69444, 0, 0.11111, 0.41667],
    8472: [0.19444, 0.43056, 0, 0.11111, 0.63646],
    8476: [0, 0.69444, 0, 0, 0.72222],
    8501: [0, 0.69444, 0, 0, 0.61111],
    8592: [-0.13313, 0.36687, 0, 0, 1],
    8593: [0.19444, 0.69444, 0, 0, 0.5],
    8594: [-0.13313, 0.36687, 0, 0, 1],
    8595: [0.19444, 0.69444, 0, 0, 0.5],
    8596: [-0.13313, 0.36687, 0, 0, 1],
    8597: [0.25, 0.75, 0, 0, 0.5],
    8598: [0.19444, 0.69444, 0, 0, 1],
    8599: [0.19444, 0.69444, 0, 0, 1],
    8600: [0.19444, 0.69444, 0, 0, 1],
    8601: [0.19444, 0.69444, 0, 0, 1],
    8614: [0.011, 0.511, 0, 0, 1],
    8617: [0.011, 0.511, 0, 0, 1.126],
    8618: [0.011, 0.511, 0, 0, 1.126],
    8636: [-0.13313, 0.36687, 0, 0, 1],
    8637: [-0.13313, 0.36687, 0, 0, 1],
    8640: [-0.13313, 0.36687, 0, 0, 1],
    8641: [-0.13313, 0.36687, 0, 0, 1],
    8652: [0.011, 0.671, 0, 0, 1],
    8656: [-0.13313, 0.36687, 0, 0, 1],
    8657: [0.19444, 0.69444, 0, 0, 0.61111],
    8658: [-0.13313, 0.36687, 0, 0, 1],
    8659: [0.19444, 0.69444, 0, 0, 0.61111],
    8660: [-0.13313, 0.36687, 0, 0, 1],
    8661: [0.25, 0.75, 0, 0, 0.61111],
    8704: [0, 0.69444, 0, 0, 0.55556],
    8706: [0, 0.69444, 0.05556, 0.08334, 0.5309],
    8707: [0, 0.69444, 0, 0, 0.55556],
    8709: [0.05556, 0.75, 0, 0, 0.5],
    8711: [0, 0.68333, 0, 0, 0.83334],
    8712: [0.0391, 0.5391, 0, 0, 0.66667],
    8715: [0.0391, 0.5391, 0, 0, 0.66667],
    8722: [0.08333, 0.58333, 0, 0, 0.77778],
    8723: [0.08333, 0.58333, 0, 0, 0.77778],
    8725: [0.25, 0.75, 0, 0, 0.5],
    8726: [0.25, 0.75, 0, 0, 0.5],
    8727: [-0.03472, 0.46528, 0, 0, 0.5],
    8728: [-0.05555, 0.44445, 0, 0, 0.5],
    8729: [-0.05555, 0.44445, 0, 0, 0.5],
    8730: [0.2, 0.8, 0, 0, 0.83334],
    8733: [0, 0.43056, 0, 0, 0.77778],
    8734: [0, 0.43056, 0, 0, 1],
    8736: [0, 0.69224, 0, 0, 0.72222],
    8739: [0.25, 0.75, 0, 0, 0.27778],
    8741: [0.25, 0.75, 0, 0, 0.5],
    8743: [0, 0.55556, 0, 0, 0.66667],
    8744: [0, 0.55556, 0, 0, 0.66667],
    8745: [0, 0.55556, 0, 0, 0.66667],
    8746: [0, 0.55556, 0, 0, 0.66667],
    8747: [0.19444, 0.69444, 0.11111, 0, 0.41667],
    8764: [-0.13313, 0.36687, 0, 0, 0.77778],
    8768: [0.19444, 0.69444, 0, 0, 0.27778],
    8771: [-0.03625, 0.46375, 0, 0, 0.77778],
    8773: [-0.022, 0.589, 0, 0, 0.778],
    8776: [-0.01688, 0.48312, 0, 0, 0.77778],
    8781: [-0.03625, 0.46375, 0, 0, 0.77778],
    8784: [-0.133, 0.673, 0, 0, 0.778],
    8801: [-0.03625, 0.46375, 0, 0, 0.77778],
    8804: [0.13597, 0.63597, 0, 0, 0.77778],
    8805: [0.13597, 0.63597, 0, 0, 0.77778],
    8810: [0.0391, 0.5391, 0, 0, 1],
    8811: [0.0391, 0.5391, 0, 0, 1],
    8826: [0.0391, 0.5391, 0, 0, 0.77778],
    8827: [0.0391, 0.5391, 0, 0, 0.77778],
    8834: [0.0391, 0.5391, 0, 0, 0.77778],
    8835: [0.0391, 0.5391, 0, 0, 0.77778],
    8838: [0.13597, 0.63597, 0, 0, 0.77778],
    8839: [0.13597, 0.63597, 0, 0, 0.77778],
    8846: [0, 0.55556, 0, 0, 0.66667],
    8849: [0.13597, 0.63597, 0, 0, 0.77778],
    8850: [0.13597, 0.63597, 0, 0, 0.77778],
    8851: [0, 0.55556, 0, 0, 0.66667],
    8852: [0, 0.55556, 0, 0, 0.66667],
    8853: [0.08333, 0.58333, 0, 0, 0.77778],
    8854: [0.08333, 0.58333, 0, 0, 0.77778],
    8855: [0.08333, 0.58333, 0, 0, 0.77778],
    8856: [0.08333, 0.58333, 0, 0, 0.77778],
    8857: [0.08333, 0.58333, 0, 0, 0.77778],
    8866: [0, 0.69444, 0, 0, 0.61111],
    8867: [0, 0.69444, 0, 0, 0.61111],
    8868: [0, 0.69444, 0, 0, 0.77778],
    8869: [0, 0.69444, 0, 0, 0.77778],
    8872: [0.249, 0.75, 0, 0, 0.867],
    8900: [-0.05555, 0.44445, 0, 0, 0.5],
    8901: [-0.05555, 0.44445, 0, 0, 0.27778],
    8902: [-0.03472, 0.46528, 0, 0, 0.5],
    8904: [5e-3, 0.505, 0, 0, 0.9],
    8942: [0.03, 0.903, 0, 0, 0.278],
    8943: [-0.19, 0.313, 0, 0, 1.172],
    8945: [-0.1, 0.823, 0, 0, 1.282],
    8968: [0.25, 0.75, 0, 0, 0.44445],
    8969: [0.25, 0.75, 0, 0, 0.44445],
    8970: [0.25, 0.75, 0, 0, 0.44445],
    8971: [0.25, 0.75, 0, 0, 0.44445],
    8994: [-0.14236, 0.35764, 0, 0, 1],
    8995: [-0.14236, 0.35764, 0, 0, 1],
    9136: [0.244, 0.744, 0, 0, 0.412],
    9137: [0.244, 0.745, 0, 0, 0.412],
    9651: [0.19444, 0.69444, 0, 0, 0.88889],
    9657: [-0.03472, 0.46528, 0, 0, 0.5],
    9661: [0.19444, 0.69444, 0, 0, 0.88889],
    9667: [-0.03472, 0.46528, 0, 0, 0.5],
    9711: [0.19444, 0.69444, 0, 0, 1],
    9824: [0.12963, 0.69444, 0, 0, 0.77778],
    9825: [0.12963, 0.69444, 0, 0, 0.77778],
    9826: [0.12963, 0.69444, 0, 0, 0.77778],
    9827: [0.12963, 0.69444, 0, 0, 0.77778],
    9837: [0, 0.75, 0, 0, 0.38889],
    9838: [0.19444, 0.69444, 0, 0, 0.38889],
    9839: [0.19444, 0.69444, 0, 0, 0.38889],
    10216: [0.25, 0.75, 0, 0, 0.38889],
    10217: [0.25, 0.75, 0, 0, 0.38889],
    10222: [0.244, 0.744, 0, 0, 0.412],
    10223: [0.244, 0.745, 0, 0, 0.412],
    10229: [0.011, 0.511, 0, 0, 1.609],
    10230: [0.011, 0.511, 0, 0, 1.638],
    10231: [0.011, 0.511, 0, 0, 1.859],
    10232: [0.024, 0.525, 0, 0, 1.609],
    10233: [0.024, 0.525, 0, 0, 1.638],
    10234: [0.024, 0.525, 0, 0, 1.858],
    10236: [0.011, 0.511, 0, 0, 1.638],
    10815: [0, 0.68333, 0, 0, 0.75],
    10927: [0.13597, 0.63597, 0, 0, 0.77778],
    10928: [0.13597, 0.63597, 0, 0, 0.77778],
    57376: [0.19444, 0.69444, 0, 0, 0]
  },
  "Math-BoldItalic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.44444, 0, 0, 0.575],
    49: [0, 0.44444, 0, 0, 0.575],
    50: [0, 0.44444, 0, 0, 0.575],
    51: [0.19444, 0.44444, 0, 0, 0.575],
    52: [0.19444, 0.44444, 0, 0, 0.575],
    53: [0.19444, 0.44444, 0, 0, 0.575],
    54: [0, 0.64444, 0, 0, 0.575],
    55: [0.19444, 0.44444, 0, 0, 0.575],
    56: [0, 0.64444, 0, 0, 0.575],
    57: [0.19444, 0.44444, 0, 0, 0.575],
    65: [0, 0.68611, 0, 0, 0.86944],
    66: [0, 0.68611, 0.04835, 0, 0.8664],
    67: [0, 0.68611, 0.06979, 0, 0.81694],
    68: [0, 0.68611, 0.03194, 0, 0.93812],
    69: [0, 0.68611, 0.05451, 0, 0.81007],
    70: [0, 0.68611, 0.15972, 0, 0.68889],
    71: [0, 0.68611, 0, 0, 0.88673],
    72: [0, 0.68611, 0.08229, 0, 0.98229],
    73: [0, 0.68611, 0.07778, 0, 0.51111],
    74: [0, 0.68611, 0.10069, 0, 0.63125],
    75: [0, 0.68611, 0.06979, 0, 0.97118],
    76: [0, 0.68611, 0, 0, 0.75555],
    77: [0, 0.68611, 0.11424, 0, 1.14201],
    78: [0, 0.68611, 0.11424, 0, 0.95034],
    79: [0, 0.68611, 0.03194, 0, 0.83666],
    80: [0, 0.68611, 0.15972, 0, 0.72309],
    81: [0.19444, 0.68611, 0, 0, 0.86861],
    82: [0, 0.68611, 421e-5, 0, 0.87235],
    83: [0, 0.68611, 0.05382, 0, 0.69271],
    84: [0, 0.68611, 0.15972, 0, 0.63663],
    85: [0, 0.68611, 0.11424, 0, 0.80027],
    86: [0, 0.68611, 0.25555, 0, 0.67778],
    87: [0, 0.68611, 0.15972, 0, 1.09305],
    88: [0, 0.68611, 0.07778, 0, 0.94722],
    89: [0, 0.68611, 0.25555, 0, 0.67458],
    90: [0, 0.68611, 0.06979, 0, 0.77257],
    97: [0, 0.44444, 0, 0, 0.63287],
    98: [0, 0.69444, 0, 0, 0.52083],
    99: [0, 0.44444, 0, 0, 0.51342],
    100: [0, 0.69444, 0, 0, 0.60972],
    101: [0, 0.44444, 0, 0, 0.55361],
    102: [0.19444, 0.69444, 0.11042, 0, 0.56806],
    103: [0.19444, 0.44444, 0.03704, 0, 0.5449],
    104: [0, 0.69444, 0, 0, 0.66759],
    105: [0, 0.69326, 0, 0, 0.4048],
    106: [0.19444, 0.69326, 0.0622, 0, 0.47083],
    107: [0, 0.69444, 0.01852, 0, 0.6037],
    108: [0, 0.69444, 88e-4, 0, 0.34815],
    109: [0, 0.44444, 0, 0, 1.0324],
    110: [0, 0.44444, 0, 0, 0.71296],
    111: [0, 0.44444, 0, 0, 0.58472],
    112: [0.19444, 0.44444, 0, 0, 0.60092],
    113: [0.19444, 0.44444, 0.03704, 0, 0.54213],
    114: [0, 0.44444, 0.03194, 0, 0.5287],
    115: [0, 0.44444, 0, 0, 0.53125],
    116: [0, 0.63492, 0, 0, 0.41528],
    117: [0, 0.44444, 0, 0, 0.68102],
    118: [0, 0.44444, 0.03704, 0, 0.56666],
    119: [0, 0.44444, 0.02778, 0, 0.83148],
    120: [0, 0.44444, 0, 0, 0.65903],
    121: [0.19444, 0.44444, 0.03704, 0, 0.59028],
    122: [0, 0.44444, 0.04213, 0, 0.55509],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68611, 0.15972, 0, 0.65694],
    916: [0, 0.68611, 0, 0, 0.95833],
    920: [0, 0.68611, 0.03194, 0, 0.86722],
    923: [0, 0.68611, 0, 0, 0.80555],
    926: [0, 0.68611, 0.07458, 0, 0.84125],
    928: [0, 0.68611, 0.08229, 0, 0.98229],
    931: [0, 0.68611, 0.05451, 0, 0.88507],
    933: [0, 0.68611, 0.15972, 0, 0.67083],
    934: [0, 0.68611, 0, 0, 0.76666],
    936: [0, 0.68611, 0.11653, 0, 0.71402],
    937: [0, 0.68611, 0.04835, 0, 0.8789],
    945: [0, 0.44444, 0, 0, 0.76064],
    946: [0.19444, 0.69444, 0.03403, 0, 0.65972],
    947: [0.19444, 0.44444, 0.06389, 0, 0.59003],
    948: [0, 0.69444, 0.03819, 0, 0.52222],
    949: [0, 0.44444, 0, 0, 0.52882],
    950: [0.19444, 0.69444, 0.06215, 0, 0.50833],
    951: [0.19444, 0.44444, 0.03704, 0, 0.6],
    952: [0, 0.69444, 0.03194, 0, 0.5618],
    953: [0, 0.44444, 0, 0, 0.41204],
    954: [0, 0.44444, 0, 0, 0.66759],
    955: [0, 0.69444, 0, 0, 0.67083],
    956: [0.19444, 0.44444, 0, 0, 0.70787],
    957: [0, 0.44444, 0.06898, 0, 0.57685],
    958: [0.19444, 0.69444, 0.03021, 0, 0.50833],
    959: [0, 0.44444, 0, 0, 0.58472],
    960: [0, 0.44444, 0.03704, 0, 0.68241],
    961: [0.19444, 0.44444, 0, 0, 0.6118],
    962: [0.09722, 0.44444, 0.07917, 0, 0.42361],
    963: [0, 0.44444, 0.03704, 0, 0.68588],
    964: [0, 0.44444, 0.13472, 0, 0.52083],
    965: [0, 0.44444, 0.03704, 0, 0.63055],
    966: [0.19444, 0.44444, 0, 0, 0.74722],
    967: [0.19444, 0.44444, 0, 0, 0.71805],
    968: [0.19444, 0.69444, 0.03704, 0, 0.75833],
    969: [0, 0.44444, 0.03704, 0, 0.71782],
    977: [0, 0.69444, 0, 0, 0.69155],
    981: [0.19444, 0.69444, 0, 0, 0.7125],
    982: [0, 0.44444, 0.03194, 0, 0.975],
    1009: [0.19444, 0.44444, 0, 0, 0.6118],
    1013: [0, 0.44444, 0, 0, 0.48333],
    57649: [0, 0.44444, 0, 0, 0.39352],
    57911: [0.19444, 0.44444, 0, 0, 0.43889]
  },
  "Math-Italic": {
    32: [0, 0, 0, 0, 0.25],
    48: [0, 0.43056, 0, 0, 0.5],
    49: [0, 0.43056, 0, 0, 0.5],
    50: [0, 0.43056, 0, 0, 0.5],
    51: [0.19444, 0.43056, 0, 0, 0.5],
    52: [0.19444, 0.43056, 0, 0, 0.5],
    53: [0.19444, 0.43056, 0, 0, 0.5],
    54: [0, 0.64444, 0, 0, 0.5],
    55: [0.19444, 0.43056, 0, 0, 0.5],
    56: [0, 0.64444, 0, 0, 0.5],
    57: [0.19444, 0.43056, 0, 0, 0.5],
    65: [0, 0.68333, 0, 0.13889, 0.75],
    66: [0, 0.68333, 0.05017, 0.08334, 0.75851],
    67: [0, 0.68333, 0.07153, 0.08334, 0.71472],
    68: [0, 0.68333, 0.02778, 0.05556, 0.82792],
    69: [0, 0.68333, 0.05764, 0.08334, 0.7382],
    70: [0, 0.68333, 0.13889, 0.08334, 0.64306],
    71: [0, 0.68333, 0, 0.08334, 0.78625],
    72: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    73: [0, 0.68333, 0.07847, 0.11111, 0.43958],
    74: [0, 0.68333, 0.09618, 0.16667, 0.55451],
    75: [0, 0.68333, 0.07153, 0.05556, 0.84931],
    76: [0, 0.68333, 0, 0.02778, 0.68056],
    77: [0, 0.68333, 0.10903, 0.08334, 0.97014],
    78: [0, 0.68333, 0.10903, 0.08334, 0.80347],
    79: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    80: [0, 0.68333, 0.13889, 0.08334, 0.64201],
    81: [0.19444, 0.68333, 0, 0.08334, 0.79056],
    82: [0, 0.68333, 773e-5, 0.08334, 0.75929],
    83: [0, 0.68333, 0.05764, 0.08334, 0.6132],
    84: [0, 0.68333, 0.13889, 0.08334, 0.58438],
    85: [0, 0.68333, 0.10903, 0.02778, 0.68278],
    86: [0, 0.68333, 0.22222, 0, 0.58333],
    87: [0, 0.68333, 0.13889, 0, 0.94445],
    88: [0, 0.68333, 0.07847, 0.08334, 0.82847],
    89: [0, 0.68333, 0.22222, 0, 0.58056],
    90: [0, 0.68333, 0.07153, 0.08334, 0.68264],
    97: [0, 0.43056, 0, 0, 0.52859],
    98: [0, 0.69444, 0, 0, 0.42917],
    99: [0, 0.43056, 0, 0.05556, 0.43276],
    100: [0, 0.69444, 0, 0.16667, 0.52049],
    101: [0, 0.43056, 0, 0.05556, 0.46563],
    102: [0.19444, 0.69444, 0.10764, 0.16667, 0.48959],
    103: [0.19444, 0.43056, 0.03588, 0.02778, 0.47697],
    104: [0, 0.69444, 0, 0, 0.57616],
    105: [0, 0.65952, 0, 0, 0.34451],
    106: [0.19444, 0.65952, 0.05724, 0, 0.41181],
    107: [0, 0.69444, 0.03148, 0, 0.5206],
    108: [0, 0.69444, 0.01968, 0.08334, 0.29838],
    109: [0, 0.43056, 0, 0, 0.87801],
    110: [0, 0.43056, 0, 0, 0.60023],
    111: [0, 0.43056, 0, 0.05556, 0.48472],
    112: [0.19444, 0.43056, 0, 0.08334, 0.50313],
    113: [0.19444, 0.43056, 0.03588, 0.08334, 0.44641],
    114: [0, 0.43056, 0.02778, 0.05556, 0.45116],
    115: [0, 0.43056, 0, 0.05556, 0.46875],
    116: [0, 0.61508, 0, 0.08334, 0.36111],
    117: [0, 0.43056, 0, 0.02778, 0.57246],
    118: [0, 0.43056, 0.03588, 0.02778, 0.48472],
    119: [0, 0.43056, 0.02691, 0.08334, 0.71592],
    120: [0, 0.43056, 0, 0.02778, 0.57153],
    121: [0.19444, 0.43056, 0.03588, 0.05556, 0.49028],
    122: [0, 0.43056, 0.04398, 0.05556, 0.46505],
    160: [0, 0, 0, 0, 0.25],
    915: [0, 0.68333, 0.13889, 0.08334, 0.61528],
    916: [0, 0.68333, 0, 0.16667, 0.83334],
    920: [0, 0.68333, 0.02778, 0.08334, 0.76278],
    923: [0, 0.68333, 0, 0.16667, 0.69445],
    926: [0, 0.68333, 0.07569, 0.08334, 0.74236],
    928: [0, 0.68333, 0.08125, 0.05556, 0.83125],
    931: [0, 0.68333, 0.05764, 0.08334, 0.77986],
    933: [0, 0.68333, 0.13889, 0.05556, 0.58333],
    934: [0, 0.68333, 0, 0.08334, 0.66667],
    936: [0, 0.68333, 0.11, 0.05556, 0.61222],
    937: [0, 0.68333, 0.05017, 0.08334, 0.7724],
    945: [0, 0.43056, 37e-4, 0.02778, 0.6397],
    946: [0.19444, 0.69444, 0.05278, 0.08334, 0.56563],
    947: [0.19444, 0.43056, 0.05556, 0, 0.51773],
    948: [0, 0.69444, 0.03785, 0.05556, 0.44444],
    949: [0, 0.43056, 0, 0.08334, 0.46632],
    950: [0.19444, 0.69444, 0.07378, 0.08334, 0.4375],
    951: [0.19444, 0.43056, 0.03588, 0.05556, 0.49653],
    952: [0, 0.69444, 0.02778, 0.08334, 0.46944],
    953: [0, 0.43056, 0, 0.05556, 0.35394],
    954: [0, 0.43056, 0, 0, 0.57616],
    955: [0, 0.69444, 0, 0, 0.58334],
    956: [0.19444, 0.43056, 0, 0.02778, 0.60255],
    957: [0, 0.43056, 0.06366, 0.02778, 0.49398],
    958: [0.19444, 0.69444, 0.04601, 0.11111, 0.4375],
    959: [0, 0.43056, 0, 0.05556, 0.48472],
    960: [0, 0.43056, 0.03588, 0, 0.57003],
    961: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    962: [0.09722, 0.43056, 0.07986, 0.08334, 0.36285],
    963: [0, 0.43056, 0.03588, 0, 0.57141],
    964: [0, 0.43056, 0.1132, 0.02778, 0.43715],
    965: [0, 0.43056, 0.03588, 0.02778, 0.54028],
    966: [0.19444, 0.43056, 0, 0.08334, 0.65417],
    967: [0.19444, 0.43056, 0, 0.05556, 0.62569],
    968: [0.19444, 0.69444, 0.03588, 0.11111, 0.65139],
    969: [0, 0.43056, 0.03588, 0, 0.62245],
    977: [0, 0.69444, 0, 0.08334, 0.59144],
    981: [0.19444, 0.69444, 0, 0.08334, 0.59583],
    982: [0, 0.43056, 0.02778, 0, 0.82813],
    1009: [0.19444, 0.43056, 0, 0.08334, 0.51702],
    1013: [0, 0.43056, 0, 0.05556, 0.4059],
    57649: [0, 0.43056, 0, 0.02778, 0.32246],
    57911: [0.19444, 0.43056, 0, 0.08334, 0.38403]
  },
  "SansSerif-Bold": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.36667],
    34: [0, 0.69444, 0, 0, 0.55834],
    35: [0.19444, 0.69444, 0, 0, 0.91667],
    36: [0.05556, 0.75, 0, 0, 0.55],
    37: [0.05556, 0.75, 0, 0, 1.02912],
    38: [0, 0.69444, 0, 0, 0.83056],
    39: [0, 0.69444, 0, 0, 0.30556],
    40: [0.25, 0.75, 0, 0, 0.42778],
    41: [0.25, 0.75, 0, 0, 0.42778],
    42: [0, 0.75, 0, 0, 0.55],
    43: [0.11667, 0.61667, 0, 0, 0.85556],
    44: [0.10556, 0.13056, 0, 0, 0.30556],
    45: [0, 0.45833, 0, 0, 0.36667],
    46: [0, 0.13056, 0, 0, 0.30556],
    47: [0.25, 0.75, 0, 0, 0.55],
    48: [0, 0.69444, 0, 0, 0.55],
    49: [0, 0.69444, 0, 0, 0.55],
    50: [0, 0.69444, 0, 0, 0.55],
    51: [0, 0.69444, 0, 0, 0.55],
    52: [0, 0.69444, 0, 0, 0.55],
    53: [0, 0.69444, 0, 0, 0.55],
    54: [0, 0.69444, 0, 0, 0.55],
    55: [0, 0.69444, 0, 0, 0.55],
    56: [0, 0.69444, 0, 0, 0.55],
    57: [0, 0.69444, 0, 0, 0.55],
    58: [0, 0.45833, 0, 0, 0.30556],
    59: [0.10556, 0.45833, 0, 0, 0.30556],
    61: [-0.09375, 0.40625, 0, 0, 0.85556],
    63: [0, 0.69444, 0, 0, 0.51945],
    64: [0, 0.69444, 0, 0, 0.73334],
    65: [0, 0.69444, 0, 0, 0.73334],
    66: [0, 0.69444, 0, 0, 0.73334],
    67: [0, 0.69444, 0, 0, 0.70278],
    68: [0, 0.69444, 0, 0, 0.79445],
    69: [0, 0.69444, 0, 0, 0.64167],
    70: [0, 0.69444, 0, 0, 0.61111],
    71: [0, 0.69444, 0, 0, 0.73334],
    72: [0, 0.69444, 0, 0, 0.79445],
    73: [0, 0.69444, 0, 0, 0.33056],
    74: [0, 0.69444, 0, 0, 0.51945],
    75: [0, 0.69444, 0, 0, 0.76389],
    76: [0, 0.69444, 0, 0, 0.58056],
    77: [0, 0.69444, 0, 0, 0.97778],
    78: [0, 0.69444, 0, 0, 0.79445],
    79: [0, 0.69444, 0, 0, 0.79445],
    80: [0, 0.69444, 0, 0, 0.70278],
    81: [0.10556, 0.69444, 0, 0, 0.79445],
    82: [0, 0.69444, 0, 0, 0.70278],
    83: [0, 0.69444, 0, 0, 0.61111],
    84: [0, 0.69444, 0, 0, 0.73334],
    85: [0, 0.69444, 0, 0, 0.76389],
    86: [0, 0.69444, 0.01528, 0, 0.73334],
    87: [0, 0.69444, 0.01528, 0, 1.03889],
    88: [0, 0.69444, 0, 0, 0.73334],
    89: [0, 0.69444, 0.0275, 0, 0.73334],
    90: [0, 0.69444, 0, 0, 0.67223],
    91: [0.25, 0.75, 0, 0, 0.34306],
    93: [0.25, 0.75, 0, 0, 0.34306],
    94: [0, 0.69444, 0, 0, 0.55],
    95: [0.35, 0.10833, 0.03056, 0, 0.55],
    97: [0, 0.45833, 0, 0, 0.525],
    98: [0, 0.69444, 0, 0, 0.56111],
    99: [0, 0.45833, 0, 0, 0.48889],
    100: [0, 0.69444, 0, 0, 0.56111],
    101: [0, 0.45833, 0, 0, 0.51111],
    102: [0, 0.69444, 0.07639, 0, 0.33611],
    103: [0.19444, 0.45833, 0.01528, 0, 0.55],
    104: [0, 0.69444, 0, 0, 0.56111],
    105: [0, 0.69444, 0, 0, 0.25556],
    106: [0.19444, 0.69444, 0, 0, 0.28611],
    107: [0, 0.69444, 0, 0, 0.53056],
    108: [0, 0.69444, 0, 0, 0.25556],
    109: [0, 0.45833, 0, 0, 0.86667],
    110: [0, 0.45833, 0, 0, 0.56111],
    111: [0, 0.45833, 0, 0, 0.55],
    112: [0.19444, 0.45833, 0, 0, 0.56111],
    113: [0.19444, 0.45833, 0, 0, 0.56111],
    114: [0, 0.45833, 0.01528, 0, 0.37222],
    115: [0, 0.45833, 0, 0, 0.42167],
    116: [0, 0.58929, 0, 0, 0.40417],
    117: [0, 0.45833, 0, 0, 0.56111],
    118: [0, 0.45833, 0.01528, 0, 0.5],
    119: [0, 0.45833, 0.01528, 0, 0.74445],
    120: [0, 0.45833, 0, 0, 0.5],
    121: [0.19444, 0.45833, 0.01528, 0, 0.5],
    122: [0, 0.45833, 0, 0, 0.47639],
    126: [0.35, 0.34444, 0, 0, 0.55],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.69444, 0, 0, 0.55],
    176: [0, 0.69444, 0, 0, 0.73334],
    180: [0, 0.69444, 0, 0, 0.55],
    184: [0.17014, 0, 0, 0, 0.48889],
    305: [0, 0.45833, 0, 0, 0.25556],
    567: [0.19444, 0.45833, 0, 0, 0.28611],
    710: [0, 0.69444, 0, 0, 0.55],
    711: [0, 0.63542, 0, 0, 0.55],
    713: [0, 0.63778, 0, 0, 0.55],
    728: [0, 0.69444, 0, 0, 0.55],
    729: [0, 0.69444, 0, 0, 0.30556],
    730: [0, 0.69444, 0, 0, 0.73334],
    732: [0, 0.69444, 0, 0, 0.55],
    733: [0, 0.69444, 0, 0, 0.55],
    915: [0, 0.69444, 0, 0, 0.58056],
    916: [0, 0.69444, 0, 0, 0.91667],
    920: [0, 0.69444, 0, 0, 0.85556],
    923: [0, 0.69444, 0, 0, 0.67223],
    926: [0, 0.69444, 0, 0, 0.73334],
    928: [0, 0.69444, 0, 0, 0.79445],
    931: [0, 0.69444, 0, 0, 0.79445],
    933: [0, 0.69444, 0, 0, 0.85556],
    934: [0, 0.69444, 0, 0, 0.79445],
    936: [0, 0.69444, 0, 0, 0.85556],
    937: [0, 0.69444, 0, 0, 0.79445],
    8211: [0, 0.45833, 0.03056, 0, 0.55],
    8212: [0, 0.45833, 0.03056, 0, 1.10001],
    8216: [0, 0.69444, 0, 0, 0.30556],
    8217: [0, 0.69444, 0, 0, 0.30556],
    8220: [0, 0.69444, 0, 0, 0.55834],
    8221: [0, 0.69444, 0, 0, 0.55834]
  },
  "SansSerif-Italic": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0.05733, 0, 0.31945],
    34: [0, 0.69444, 316e-5, 0, 0.5],
    35: [0.19444, 0.69444, 0.05087, 0, 0.83334],
    36: [0.05556, 0.75, 0.11156, 0, 0.5],
    37: [0.05556, 0.75, 0.03126, 0, 0.83334],
    38: [0, 0.69444, 0.03058, 0, 0.75834],
    39: [0, 0.69444, 0.07816, 0, 0.27778],
    40: [0.25, 0.75, 0.13164, 0, 0.38889],
    41: [0.25, 0.75, 0.02536, 0, 0.38889],
    42: [0, 0.75, 0.11775, 0, 0.5],
    43: [0.08333, 0.58333, 0.02536, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0.01946, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0.13164, 0, 0.5],
    48: [0, 0.65556, 0.11156, 0, 0.5],
    49: [0, 0.65556, 0.11156, 0, 0.5],
    50: [0, 0.65556, 0.11156, 0, 0.5],
    51: [0, 0.65556, 0.11156, 0, 0.5],
    52: [0, 0.65556, 0.11156, 0, 0.5],
    53: [0, 0.65556, 0.11156, 0, 0.5],
    54: [0, 0.65556, 0.11156, 0, 0.5],
    55: [0, 0.65556, 0.11156, 0, 0.5],
    56: [0, 0.65556, 0.11156, 0, 0.5],
    57: [0, 0.65556, 0.11156, 0, 0.5],
    58: [0, 0.44444, 0.02502, 0, 0.27778],
    59: [0.125, 0.44444, 0.02502, 0, 0.27778],
    61: [-0.13, 0.37, 0.05087, 0, 0.77778],
    63: [0, 0.69444, 0.11809, 0, 0.47222],
    64: [0, 0.69444, 0.07555, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0.08293, 0, 0.66667],
    67: [0, 0.69444, 0.11983, 0, 0.63889],
    68: [0, 0.69444, 0.07555, 0, 0.72223],
    69: [0, 0.69444, 0.11983, 0, 0.59722],
    70: [0, 0.69444, 0.13372, 0, 0.56945],
    71: [0, 0.69444, 0.11983, 0, 0.66667],
    72: [0, 0.69444, 0.08094, 0, 0.70834],
    73: [0, 0.69444, 0.13372, 0, 0.27778],
    74: [0, 0.69444, 0.08094, 0, 0.47222],
    75: [0, 0.69444, 0.11983, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0.08094, 0, 0.875],
    78: [0, 0.69444, 0.08094, 0, 0.70834],
    79: [0, 0.69444, 0.07555, 0, 0.73611],
    80: [0, 0.69444, 0.08293, 0, 0.63889],
    81: [0.125, 0.69444, 0.07555, 0, 0.73611],
    82: [0, 0.69444, 0.08293, 0, 0.64584],
    83: [0, 0.69444, 0.09205, 0, 0.55556],
    84: [0, 0.69444, 0.13372, 0, 0.68056],
    85: [0, 0.69444, 0.08094, 0, 0.6875],
    86: [0, 0.69444, 0.1615, 0, 0.66667],
    87: [0, 0.69444, 0.1615, 0, 0.94445],
    88: [0, 0.69444, 0.13372, 0, 0.66667],
    89: [0, 0.69444, 0.17261, 0, 0.66667],
    90: [0, 0.69444, 0.11983, 0, 0.61111],
    91: [0.25, 0.75, 0.15942, 0, 0.28889],
    93: [0.25, 0.75, 0.08719, 0, 0.28889],
    94: [0, 0.69444, 0.0799, 0, 0.5],
    95: [0.35, 0.09444, 0.08616, 0, 0.5],
    97: [0, 0.44444, 981e-5, 0, 0.48056],
    98: [0, 0.69444, 0.03057, 0, 0.51667],
    99: [0, 0.44444, 0.08336, 0, 0.44445],
    100: [0, 0.69444, 0.09483, 0, 0.51667],
    101: [0, 0.44444, 0.06778, 0, 0.44445],
    102: [0, 0.69444, 0.21705, 0, 0.30556],
    103: [0.19444, 0.44444, 0.10836, 0, 0.5],
    104: [0, 0.69444, 0.01778, 0, 0.51667],
    105: [0, 0.67937, 0.09718, 0, 0.23889],
    106: [0.19444, 0.67937, 0.09162, 0, 0.26667],
    107: [0, 0.69444, 0.08336, 0, 0.48889],
    108: [0, 0.69444, 0.09483, 0, 0.23889],
    109: [0, 0.44444, 0.01778, 0, 0.79445],
    110: [0, 0.44444, 0.01778, 0, 0.51667],
    111: [0, 0.44444, 0.06613, 0, 0.5],
    112: [0.19444, 0.44444, 0.0389, 0, 0.51667],
    113: [0.19444, 0.44444, 0.04169, 0, 0.51667],
    114: [0, 0.44444, 0.10836, 0, 0.34167],
    115: [0, 0.44444, 0.0778, 0, 0.38333],
    116: [0, 0.57143, 0.07225, 0, 0.36111],
    117: [0, 0.44444, 0.04169, 0, 0.51667],
    118: [0, 0.44444, 0.10836, 0, 0.46111],
    119: [0, 0.44444, 0.10836, 0, 0.68334],
    120: [0, 0.44444, 0.09169, 0, 0.46111],
    121: [0.19444, 0.44444, 0.10836, 0, 0.46111],
    122: [0, 0.44444, 0.08752, 0, 0.43472],
    126: [0.35, 0.32659, 0.08826, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0.06385, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.73752],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0.04169, 0, 0.23889],
    567: [0.19444, 0.44444, 0.04169, 0, 0.26667],
    710: [0, 0.69444, 0.0799, 0, 0.5],
    711: [0, 0.63194, 0.08432, 0, 0.5],
    713: [0, 0.60889, 0.08776, 0, 0.5],
    714: [0, 0.69444, 0.09205, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0.09483, 0, 0.5],
    729: [0, 0.67937, 0.07774, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.73752],
    732: [0, 0.67659, 0.08826, 0, 0.5],
    733: [0, 0.69444, 0.09205, 0, 0.5],
    915: [0, 0.69444, 0.13372, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0.07555, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0.12816, 0, 0.66667],
    928: [0, 0.69444, 0.08094, 0, 0.70834],
    931: [0, 0.69444, 0.11983, 0, 0.72222],
    933: [0, 0.69444, 0.09031, 0, 0.77778],
    934: [0, 0.69444, 0.04603, 0, 0.72222],
    936: [0, 0.69444, 0.09031, 0, 0.77778],
    937: [0, 0.69444, 0.08293, 0, 0.72222],
    8211: [0, 0.44444, 0.08616, 0, 0.5],
    8212: [0, 0.44444, 0.08616, 0, 1],
    8216: [0, 0.69444, 0.07816, 0, 0.27778],
    8217: [0, 0.69444, 0.07816, 0, 0.27778],
    8220: [0, 0.69444, 0.14205, 0, 0.5],
    8221: [0, 0.69444, 316e-5, 0, 0.5]
  },
  "SansSerif-Regular": {
    32: [0, 0, 0, 0, 0.25],
    33: [0, 0.69444, 0, 0, 0.31945],
    34: [0, 0.69444, 0, 0, 0.5],
    35: [0.19444, 0.69444, 0, 0, 0.83334],
    36: [0.05556, 0.75, 0, 0, 0.5],
    37: [0.05556, 0.75, 0, 0, 0.83334],
    38: [0, 0.69444, 0, 0, 0.75834],
    39: [0, 0.69444, 0, 0, 0.27778],
    40: [0.25, 0.75, 0, 0, 0.38889],
    41: [0.25, 0.75, 0, 0, 0.38889],
    42: [0, 0.75, 0, 0, 0.5],
    43: [0.08333, 0.58333, 0, 0, 0.77778],
    44: [0.125, 0.08333, 0, 0, 0.27778],
    45: [0, 0.44444, 0, 0, 0.33333],
    46: [0, 0.08333, 0, 0, 0.27778],
    47: [0.25, 0.75, 0, 0, 0.5],
    48: [0, 0.65556, 0, 0, 0.5],
    49: [0, 0.65556, 0, 0, 0.5],
    50: [0, 0.65556, 0, 0, 0.5],
    51: [0, 0.65556, 0, 0, 0.5],
    52: [0, 0.65556, 0, 0, 0.5],
    53: [0, 0.65556, 0, 0, 0.5],
    54: [0, 0.65556, 0, 0, 0.5],
    55: [0, 0.65556, 0, 0, 0.5],
    56: [0, 0.65556, 0, 0, 0.5],
    57: [0, 0.65556, 0, 0, 0.5],
    58: [0, 0.44444, 0, 0, 0.27778],
    59: [0.125, 0.44444, 0, 0, 0.27778],
    61: [-0.13, 0.37, 0, 0, 0.77778],
    63: [0, 0.69444, 0, 0, 0.47222],
    64: [0, 0.69444, 0, 0, 0.66667],
    65: [0, 0.69444, 0, 0, 0.66667],
    66: [0, 0.69444, 0, 0, 0.66667],
    67: [0, 0.69444, 0, 0, 0.63889],
    68: [0, 0.69444, 0, 0, 0.72223],
    69: [0, 0.69444, 0, 0, 0.59722],
    70: [0, 0.69444, 0, 0, 0.56945],
    71: [0, 0.69444, 0, 0, 0.66667],
    72: [0, 0.69444, 0, 0, 0.70834],
    73: [0, 0.69444, 0, 0, 0.27778],
    74: [0, 0.69444, 0, 0, 0.47222],
    75: [0, 0.69444, 0, 0, 0.69445],
    76: [0, 0.69444, 0, 0, 0.54167],
    77: [0, 0.69444, 0, 0, 0.875],
    78: [0, 0.69444, 0, 0, 0.70834],
    79: [0, 0.69444, 0, 0, 0.73611],
    80: [0, 0.69444, 0, 0, 0.63889],
    81: [0.125, 0.69444, 0, 0, 0.73611],
    82: [0, 0.69444, 0, 0, 0.64584],
    83: [0, 0.69444, 0, 0, 0.55556],
    84: [0, 0.69444, 0, 0, 0.68056],
    85: [0, 0.69444, 0, 0, 0.6875],
    86: [0, 0.69444, 0.01389, 0, 0.66667],
    87: [0, 0.69444, 0.01389, 0, 0.94445],
    88: [0, 0.69444, 0, 0, 0.66667],
    89: [0, 0.69444, 0.025, 0, 0.66667],
    90: [0, 0.69444, 0, 0, 0.61111],
    91: [0.25, 0.75, 0, 0, 0.28889],
    93: [0.25, 0.75, 0, 0, 0.28889],
    94: [0, 0.69444, 0, 0, 0.5],
    95: [0.35, 0.09444, 0.02778, 0, 0.5],
    97: [0, 0.44444, 0, 0, 0.48056],
    98: [0, 0.69444, 0, 0, 0.51667],
    99: [0, 0.44444, 0, 0, 0.44445],
    100: [0, 0.69444, 0, 0, 0.51667],
    101: [0, 0.44444, 0, 0, 0.44445],
    102: [0, 0.69444, 0.06944, 0, 0.30556],
    103: [0.19444, 0.44444, 0.01389, 0, 0.5],
    104: [0, 0.69444, 0, 0, 0.51667],
    105: [0, 0.67937, 0, 0, 0.23889],
    106: [0.19444, 0.67937, 0, 0, 0.26667],
    107: [0, 0.69444, 0, 0, 0.48889],
    108: [0, 0.69444, 0, 0, 0.23889],
    109: [0, 0.44444, 0, 0, 0.79445],
    110: [0, 0.44444, 0, 0, 0.51667],
    111: [0, 0.44444, 0, 0, 0.5],
    112: [0.19444, 0.44444, 0, 0, 0.51667],
    113: [0.19444, 0.44444, 0, 0, 0.51667],
    114: [0, 0.44444, 0.01389, 0, 0.34167],
    115: [0, 0.44444, 0, 0, 0.38333],
    116: [0, 0.57143, 0, 0, 0.36111],
    117: [0, 0.44444, 0, 0, 0.51667],
    118: [0, 0.44444, 0.01389, 0, 0.46111],
    119: [0, 0.44444, 0.01389, 0, 0.68334],
    120: [0, 0.44444, 0, 0, 0.46111],
    121: [0.19444, 0.44444, 0.01389, 0, 0.46111],
    122: [0, 0.44444, 0, 0, 0.43472],
    126: [0.35, 0.32659, 0, 0, 0.5],
    160: [0, 0, 0, 0, 0.25],
    168: [0, 0.67937, 0, 0, 0.5],
    176: [0, 0.69444, 0, 0, 0.66667],
    184: [0.17014, 0, 0, 0, 0.44445],
    305: [0, 0.44444, 0, 0, 0.23889],
    567: [0.19444, 0.44444, 0, 0, 0.26667],
    710: [0, 0.69444, 0, 0, 0.5],
    711: [0, 0.63194, 0, 0, 0.5],
    713: [0, 0.60889, 0, 0, 0.5],
    714: [0, 0.69444, 0, 0, 0.5],
    715: [0, 0.69444, 0, 0, 0.5],
    728: [0, 0.69444, 0, 0, 0.5],
    729: [0, 0.67937, 0, 0, 0.27778],
    730: [0, 0.69444, 0, 0, 0.66667],
    732: [0, 0.67659, 0, 0, 0.5],
    733: [0, 0.69444, 0, 0, 0.5],
    915: [0, 0.69444, 0, 0, 0.54167],
    916: [0, 0.69444, 0, 0, 0.83334],
    920: [0, 0.69444, 0, 0, 0.77778],
    923: [0, 0.69444, 0, 0, 0.61111],
    926: [0, 0.69444, 0, 0, 0.66667],
    928: [0, 0.69444, 0, 0, 0.70834],
    931: [0, 0.69444, 0, 0, 0.72222],
    933: [0, 0.69444, 0, 0, 0.77778],
    934: [0, 0.69444, 0, 0, 0.72222],
    936: [0, 0.69444, 0, 0, 0.77778],
    937: [0, 0.69444, 0, 0, 0.72222],
    8211: [0, 0.44444, 0.02778, 0, 0.5],
    8212: [0, 0.44444, 0.02778, 0, 1],
    8216: [0, 0.69444, 0, 0, 0.27778],
    8217: [0, 0.69444, 0, 0, 0.27778],
    8220: [0, 0.69444, 0, 0, 0.5],
    8221: [0, 0.69444, 0, 0, 0.5]
  },
  "Script-Regular": {
    32: [0, 0, 0, 0, 0.25],
    65: [0, 0.7, 0.22925, 0, 0.80253],
    66: [0, 0.7, 0.04087, 0, 0.90757],
    67: [0, 0.7, 0.1689, 0, 0.66619],
    68: [0, 0.7, 0.09371, 0, 0.77443],
    69: [0, 0.7, 0.18583, 0, 0.56162],
    70: [0, 0.7, 0.13634, 0, 0.89544],
    71: [0, 0.7, 0.17322, 0, 0.60961],
    72: [0, 0.7, 0.29694, 0, 0.96919],
    73: [0, 0.7, 0.19189, 0, 0.80907],
    74: [0.27778, 0.7, 0.19189, 0, 1.05159],
    75: [0, 0.7, 0.31259, 0, 0.91364],
    76: [0, 0.7, 0.19189, 0, 0.87373],
    77: [0, 0.7, 0.15981, 0, 1.08031],
    78: [0, 0.7, 0.3525, 0, 0.9015],
    79: [0, 0.7, 0.08078, 0, 0.73787],
    80: [0, 0.7, 0.08078, 0, 1.01262],
    81: [0, 0.7, 0.03305, 0, 0.88282],
    82: [0, 0.7, 0.06259, 0, 0.85],
    83: [0, 0.7, 0.19189, 0, 0.86767],
    84: [0, 0.7, 0.29087, 0, 0.74697],
    85: [0, 0.7, 0.25815, 0, 0.79996],
    86: [0, 0.7, 0.27523, 0, 0.62204],
    87: [0, 0.7, 0.27523, 0, 0.80532],
    88: [0, 0.7, 0.26006, 0, 0.94445],
    89: [0, 0.7, 0.2939, 0, 0.70961],
    90: [0, 0.7, 0.24037, 0, 0.8212],
    160: [0, 0, 0, 0, 0.25]
  },
  "Size1-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.35001, 0.85, 0, 0, 0.45834],
    41: [0.35001, 0.85, 0, 0, 0.45834],
    47: [0.35001, 0.85, 0, 0, 0.57778],
    91: [0.35001, 0.85, 0, 0, 0.41667],
    92: [0.35001, 0.85, 0, 0, 0.57778],
    93: [0.35001, 0.85, 0, 0, 0.41667],
    123: [0.35001, 0.85, 0, 0, 0.58334],
    125: [0.35001, 0.85, 0, 0, 0.58334],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.72222, 0, 0, 0.55556],
    732: [0, 0.72222, 0, 0, 0.55556],
    770: [0, 0.72222, 0, 0, 0.55556],
    771: [0, 0.72222, 0, 0, 0.55556],
    8214: [-99e-5, 0.601, 0, 0, 0.77778],
    8593: [1e-5, 0.6, 0, 0, 0.66667],
    8595: [1e-5, 0.6, 0, 0, 0.66667],
    8657: [1e-5, 0.6, 0, 0, 0.77778],
    8659: [1e-5, 0.6, 0, 0, 0.77778],
    8719: [0.25001, 0.75, 0, 0, 0.94445],
    8720: [0.25001, 0.75, 0, 0, 0.94445],
    8721: [0.25001, 0.75, 0, 0, 1.05556],
    8730: [0.35001, 0.85, 0, 0, 1],
    8739: [-599e-5, 0.606, 0, 0, 0.33333],
    8741: [-599e-5, 0.606, 0, 0, 0.55556],
    8747: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8748: [0.306, 0.805, 0.19445, 0, 0.47222],
    8749: [0.306, 0.805, 0.19445, 0, 0.47222],
    8750: [0.30612, 0.805, 0.19445, 0, 0.47222],
    8896: [0.25001, 0.75, 0, 0, 0.83334],
    8897: [0.25001, 0.75, 0, 0, 0.83334],
    8898: [0.25001, 0.75, 0, 0, 0.83334],
    8899: [0.25001, 0.75, 0, 0, 0.83334],
    8968: [0.35001, 0.85, 0, 0, 0.47222],
    8969: [0.35001, 0.85, 0, 0, 0.47222],
    8970: [0.35001, 0.85, 0, 0, 0.47222],
    8971: [0.35001, 0.85, 0, 0, 0.47222],
    9168: [-99e-5, 0.601, 0, 0, 0.66667],
    10216: [0.35001, 0.85, 0, 0, 0.47222],
    10217: [0.35001, 0.85, 0, 0, 0.47222],
    10752: [0.25001, 0.75, 0, 0, 1.11111],
    10753: [0.25001, 0.75, 0, 0, 1.11111],
    10754: [0.25001, 0.75, 0, 0, 1.11111],
    10756: [0.25001, 0.75, 0, 0, 0.83334],
    10758: [0.25001, 0.75, 0, 0, 0.83334]
  },
  "Size2-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.65002, 1.15, 0, 0, 0.59722],
    41: [0.65002, 1.15, 0, 0, 0.59722],
    47: [0.65002, 1.15, 0, 0, 0.81111],
    91: [0.65002, 1.15, 0, 0, 0.47222],
    92: [0.65002, 1.15, 0, 0, 0.81111],
    93: [0.65002, 1.15, 0, 0, 0.47222],
    123: [0.65002, 1.15, 0, 0, 0.66667],
    125: [0.65002, 1.15, 0, 0, 0.66667],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1],
    732: [0, 0.75, 0, 0, 1],
    770: [0, 0.75, 0, 0, 1],
    771: [0, 0.75, 0, 0, 1],
    8719: [0.55001, 1.05, 0, 0, 1.27778],
    8720: [0.55001, 1.05, 0, 0, 1.27778],
    8721: [0.55001, 1.05, 0, 0, 1.44445],
    8730: [0.65002, 1.15, 0, 0, 1],
    8747: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8748: [0.862, 1.36, 0.44445, 0, 0.55556],
    8749: [0.862, 1.36, 0.44445, 0, 0.55556],
    8750: [0.86225, 1.36, 0.44445, 0, 0.55556],
    8896: [0.55001, 1.05, 0, 0, 1.11111],
    8897: [0.55001, 1.05, 0, 0, 1.11111],
    8898: [0.55001, 1.05, 0, 0, 1.11111],
    8899: [0.55001, 1.05, 0, 0, 1.11111],
    8968: [0.65002, 1.15, 0, 0, 0.52778],
    8969: [0.65002, 1.15, 0, 0, 0.52778],
    8970: [0.65002, 1.15, 0, 0, 0.52778],
    8971: [0.65002, 1.15, 0, 0, 0.52778],
    10216: [0.65002, 1.15, 0, 0, 0.61111],
    10217: [0.65002, 1.15, 0, 0, 0.61111],
    10752: [0.55001, 1.05, 0, 0, 1.51112],
    10753: [0.55001, 1.05, 0, 0, 1.51112],
    10754: [0.55001, 1.05, 0, 0, 1.51112],
    10756: [0.55001, 1.05, 0, 0, 1.11111],
    10758: [0.55001, 1.05, 0, 0, 1.11111]
  },
  "Size3-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [0.95003, 1.45, 0, 0, 0.73611],
    41: [0.95003, 1.45, 0, 0, 0.73611],
    47: [0.95003, 1.45, 0, 0, 1.04445],
    91: [0.95003, 1.45, 0, 0, 0.52778],
    92: [0.95003, 1.45, 0, 0, 1.04445],
    93: [0.95003, 1.45, 0, 0, 0.52778],
    123: [0.95003, 1.45, 0, 0, 0.75],
    125: [0.95003, 1.45, 0, 0, 0.75],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.75, 0, 0, 1.44445],
    732: [0, 0.75, 0, 0, 1.44445],
    770: [0, 0.75, 0, 0, 1.44445],
    771: [0, 0.75, 0, 0, 1.44445],
    8730: [0.95003, 1.45, 0, 0, 1],
    8968: [0.95003, 1.45, 0, 0, 0.58334],
    8969: [0.95003, 1.45, 0, 0, 0.58334],
    8970: [0.95003, 1.45, 0, 0, 0.58334],
    8971: [0.95003, 1.45, 0, 0, 0.58334],
    10216: [0.95003, 1.45, 0, 0, 0.75],
    10217: [0.95003, 1.45, 0, 0, 0.75]
  },
  "Size4-Regular": {
    32: [0, 0, 0, 0, 0.25],
    40: [1.25003, 1.75, 0, 0, 0.79167],
    41: [1.25003, 1.75, 0, 0, 0.79167],
    47: [1.25003, 1.75, 0, 0, 1.27778],
    91: [1.25003, 1.75, 0, 0, 0.58334],
    92: [1.25003, 1.75, 0, 0, 1.27778],
    93: [1.25003, 1.75, 0, 0, 0.58334],
    123: [1.25003, 1.75, 0, 0, 0.80556],
    125: [1.25003, 1.75, 0, 0, 0.80556],
    160: [0, 0, 0, 0, 0.25],
    710: [0, 0.825, 0, 0, 1.8889],
    732: [0, 0.825, 0, 0, 1.8889],
    770: [0, 0.825, 0, 0, 1.8889],
    771: [0, 0.825, 0, 0, 1.8889],
    8730: [1.25003, 1.75, 0, 0, 1],
    8968: [1.25003, 1.75, 0, 0, 0.63889],
    8969: [1.25003, 1.75, 0, 0, 0.63889],
    8970: [1.25003, 1.75, 0, 0, 0.63889],
    8971: [1.25003, 1.75, 0, 0, 0.63889],
    9115: [0.64502, 1.155, 0, 0, 0.875],
    9116: [1e-5, 0.6, 0, 0, 0.875],
    9117: [0.64502, 1.155, 0, 0, 0.875],
    9118: [0.64502, 1.155, 0, 0, 0.875],
    9119: [1e-5, 0.6, 0, 0, 0.875],
    9120: [0.64502, 1.155, 0, 0, 0.875],
    9121: [0.64502, 1.155, 0, 0, 0.66667],
    9122: [-99e-5, 0.601, 0, 0, 0.66667],
    9123: [0.64502, 1.155, 0, 0, 0.66667],
    9124: [0.64502, 1.155, 0, 0, 0.66667],
    9125: [-99e-5, 0.601, 0, 0, 0.66667],
    9126: [0.64502, 1.155, 0, 0, 0.66667],
    9127: [1e-5, 0.9, 0, 0, 0.88889],
    9128: [0.65002, 1.15, 0, 0, 0.88889],
    9129: [0.90001, 0, 0, 0, 0.88889],
    9130: [0, 0.3, 0, 0, 0.88889],
    9131: [1e-5, 0.9, 0, 0, 0.88889],
    9132: [0.65002, 1.15, 0, 0, 0.88889],
    9133: [0.90001, 0, 0, 0, 0.88889],
    9143: [0.88502, 0.915, 0, 0, 1.05556],
    10216: [1.25003, 1.75, 0, 0, 0.80556],
    10217: [1.25003, 1.75, 0, 0, 0.80556],
    57344: [-499e-5, 0.605, 0, 0, 1.05556],
    57345: [-499e-5, 0.605, 0, 0, 1.05556],
    57680: [0, 0.12, 0, 0, 0.45],
    57681: [0, 0.12, 0, 0, 0.45],
    57682: [0, 0.12, 0, 0, 0.45],
    57683: [0, 0.12, 0, 0, 0.45]
  },
  "Typewriter-Regular": {
    32: [0, 0, 0, 0, 0.525],
    33: [0, 0.61111, 0, 0, 0.525],
    34: [0, 0.61111, 0, 0, 0.525],
    35: [0, 0.61111, 0, 0, 0.525],
    36: [0.08333, 0.69444, 0, 0, 0.525],
    37: [0.08333, 0.69444, 0, 0, 0.525],
    38: [0, 0.61111, 0, 0, 0.525],
    39: [0, 0.61111, 0, 0, 0.525],
    40: [0.08333, 0.69444, 0, 0, 0.525],
    41: [0.08333, 0.69444, 0, 0, 0.525],
    42: [0, 0.52083, 0, 0, 0.525],
    43: [-0.08056, 0.53055, 0, 0, 0.525],
    44: [0.13889, 0.125, 0, 0, 0.525],
    45: [-0.08056, 0.53055, 0, 0, 0.525],
    46: [0, 0.125, 0, 0, 0.525],
    47: [0.08333, 0.69444, 0, 0, 0.525],
    48: [0, 0.61111, 0, 0, 0.525],
    49: [0, 0.61111, 0, 0, 0.525],
    50: [0, 0.61111, 0, 0, 0.525],
    51: [0, 0.61111, 0, 0, 0.525],
    52: [0, 0.61111, 0, 0, 0.525],
    53: [0, 0.61111, 0, 0, 0.525],
    54: [0, 0.61111, 0, 0, 0.525],
    55: [0, 0.61111, 0, 0, 0.525],
    56: [0, 0.61111, 0, 0, 0.525],
    57: [0, 0.61111, 0, 0, 0.525],
    58: [0, 0.43056, 0, 0, 0.525],
    59: [0.13889, 0.43056, 0, 0, 0.525],
    60: [-0.05556, 0.55556, 0, 0, 0.525],
    61: [-0.19549, 0.41562, 0, 0, 0.525],
    62: [-0.05556, 0.55556, 0, 0, 0.525],
    63: [0, 0.61111, 0, 0, 0.525],
    64: [0, 0.61111, 0, 0, 0.525],
    65: [0, 0.61111, 0, 0, 0.525],
    66: [0, 0.61111, 0, 0, 0.525],
    67: [0, 0.61111, 0, 0, 0.525],
    68: [0, 0.61111, 0, 0, 0.525],
    69: [0, 0.61111, 0, 0, 0.525],
    70: [0, 0.61111, 0, 0, 0.525],
    71: [0, 0.61111, 0, 0, 0.525],
    72: [0, 0.61111, 0, 0, 0.525],
    73: [0, 0.61111, 0, 0, 0.525],
    74: [0, 0.61111, 0, 0, 0.525],
    75: [0, 0.61111, 0, 0, 0.525],
    76: [0, 0.61111, 0, 0, 0.525],
    77: [0, 0.61111, 0, 0, 0.525],
    78: [0, 0.61111, 0, 0, 0.525],
    79: [0, 0.61111, 0, 0, 0.525],
    80: [0, 0.61111, 0, 0, 0.525],
    81: [0.13889, 0.61111, 0, 0, 0.525],
    82: [0, 0.61111, 0, 0, 0.525],
    83: [0, 0.61111, 0, 0, 0.525],
    84: [0, 0.61111, 0, 0, 0.525],
    85: [0, 0.61111, 0, 0, 0.525],
    86: [0, 0.61111, 0, 0, 0.525],
    87: [0, 0.61111, 0, 0, 0.525],
    88: [0, 0.61111, 0, 0, 0.525],
    89: [0, 0.61111, 0, 0, 0.525],
    90: [0, 0.61111, 0, 0, 0.525],
    91: [0.08333, 0.69444, 0, 0, 0.525],
    92: [0.08333, 0.69444, 0, 0, 0.525],
    93: [0.08333, 0.69444, 0, 0, 0.525],
    94: [0, 0.61111, 0, 0, 0.525],
    95: [0.09514, 0, 0, 0, 0.525],
    96: [0, 0.61111, 0, 0, 0.525],
    97: [0, 0.43056, 0, 0, 0.525],
    98: [0, 0.61111, 0, 0, 0.525],
    99: [0, 0.43056, 0, 0, 0.525],
    100: [0, 0.61111, 0, 0, 0.525],
    101: [0, 0.43056, 0, 0, 0.525],
    102: [0, 0.61111, 0, 0, 0.525],
    103: [0.22222, 0.43056, 0, 0, 0.525],
    104: [0, 0.61111, 0, 0, 0.525],
    105: [0, 0.61111, 0, 0, 0.525],
    106: [0.22222, 0.61111, 0, 0, 0.525],
    107: [0, 0.61111, 0, 0, 0.525],
    108: [0, 0.61111, 0, 0, 0.525],
    109: [0, 0.43056, 0, 0, 0.525],
    110: [0, 0.43056, 0, 0, 0.525],
    111: [0, 0.43056, 0, 0, 0.525],
    112: [0.22222, 0.43056, 0, 0, 0.525],
    113: [0.22222, 0.43056, 0, 0, 0.525],
    114: [0, 0.43056, 0, 0, 0.525],
    115: [0, 0.43056, 0, 0, 0.525],
    116: [0, 0.55358, 0, 0, 0.525],
    117: [0, 0.43056, 0, 0, 0.525],
    118: [0, 0.43056, 0, 0, 0.525],
    119: [0, 0.43056, 0, 0, 0.525],
    120: [0, 0.43056, 0, 0, 0.525],
    121: [0.22222, 0.43056, 0, 0, 0.525],
    122: [0, 0.43056, 0, 0, 0.525],
    123: [0.08333, 0.69444, 0, 0, 0.525],
    124: [0.08333, 0.69444, 0, 0, 0.525],
    125: [0.08333, 0.69444, 0, 0, 0.525],
    126: [0, 0.61111, 0, 0, 0.525],
    127: [0, 0.61111, 0, 0, 0.525],
    160: [0, 0, 0, 0, 0.525],
    176: [0, 0.61111, 0, 0, 0.525],
    184: [0.19445, 0, 0, 0, 0.525],
    305: [0, 0.43056, 0, 0, 0.525],
    567: [0.22222, 0.43056, 0, 0, 0.525],
    711: [0, 0.56597, 0, 0, 0.525],
    713: [0, 0.56555, 0, 0, 0.525],
    714: [0, 0.61111, 0, 0, 0.525],
    715: [0, 0.61111, 0, 0, 0.525],
    728: [0, 0.61111, 0, 0, 0.525],
    730: [0, 0.61111, 0, 0, 0.525],
    770: [0, 0.61111, 0, 0, 0.525],
    771: [0, 0.61111, 0, 0, 0.525],
    776: [0, 0.61111, 0, 0, 0.525],
    915: [0, 0.61111, 0, 0, 0.525],
    916: [0, 0.61111, 0, 0, 0.525],
    920: [0, 0.61111, 0, 0, 0.525],
    923: [0, 0.61111, 0, 0, 0.525],
    926: [0, 0.61111, 0, 0, 0.525],
    928: [0, 0.61111, 0, 0, 0.525],
    931: [0, 0.61111, 0, 0, 0.525],
    933: [0, 0.61111, 0, 0, 0.525],
    934: [0, 0.61111, 0, 0, 0.525],
    936: [0, 0.61111, 0, 0, 0.525],
    937: [0, 0.61111, 0, 0, 0.525],
    8216: [0, 0.61111, 0, 0, 0.525],
    8217: [0, 0.61111, 0, 0, 0.525],
    8242: [0, 0.61111, 0, 0, 0.525],
    9251: [0.11111, 0.21944, 0, 0, 0.525]
  }
}, E0 = {
  slant: [0.25, 0.25, 0.25],
  // sigma1
  space: [0, 0, 0],
  // sigma2
  stretch: [0, 0, 0],
  // sigma3
  shrink: [0, 0, 0],
  // sigma4
  xHeight: [0.431, 0.431, 0.431],
  // sigma5
  quad: [1, 1.171, 1.472],
  // sigma6
  extraSpace: [0, 0, 0],
  // sigma7
  num1: [0.677, 0.732, 0.925],
  // sigma8
  num2: [0.394, 0.384, 0.387],
  // sigma9
  num3: [0.444, 0.471, 0.504],
  // sigma10
  denom1: [0.686, 0.752, 1.025],
  // sigma11
  denom2: [0.345, 0.344, 0.532],
  // sigma12
  sup1: [0.413, 0.503, 0.504],
  // sigma13
  sup2: [0.363, 0.431, 0.404],
  // sigma14
  sup3: [0.289, 0.286, 0.294],
  // sigma15
  sub1: [0.15, 0.143, 0.2],
  // sigma16
  sub2: [0.247, 0.286, 0.4],
  // sigma17
  supDrop: [0.386, 0.353, 0.494],
  // sigma18
  subDrop: [0.05, 0.071, 0.1],
  // sigma19
  delim1: [2.39, 1.7, 1.98],
  // sigma20
  delim2: [1.01, 1.157, 1.42],
  // sigma21
  axisHeight: [0.25, 0.25, 0.25],
  // sigma22
  // These font metrics are extracted from TeX by using tftopl on cmex10.tfm;
  // they correspond to the font parameters of the extension fonts (family 3).
  // See the TeXbook, page 441. In AMSTeX, the extension fonts scale; to
  // match cmex7, we'd use cmex7.tfm values for script and scriptscript
  // values.
  defaultRuleThickness: [0.04, 0.049, 0.049],
  // xi8; cmex7: 0.049
  bigOpSpacing1: [0.111, 0.111, 0.111],
  // xi9
  bigOpSpacing2: [0.166, 0.166, 0.166],
  // xi10
  bigOpSpacing3: [0.2, 0.2, 0.2],
  // xi11
  bigOpSpacing4: [0.6, 0.611, 0.611],
  // xi12; cmex7: 0.611
  bigOpSpacing5: [0.1, 0.143, 0.143],
  // xi13; cmex7: 0.143
  // The \sqrt rule width is taken from the height of the surd character.
  // Since we use the same font at all sizes, this thickness doesn't scale.
  sqrtRuleThickness: [0.04, 0.04, 0.04],
  // This value determines how large a pt is, for metrics which are defined
  // in terms of pts.
  // This value is also used in katex.scss; if you change it make sure the
  // values match.
  ptPerEm: [10, 10, 10],
  // The space between adjacent `|` columns in an array definition. From
  // `\showthe\doublerulesep` in LaTeX. Equals 2.0 / ptPerEm.
  doubleRuleSep: [0.2, 0.2, 0.2],
  // The width of separator lines in {array} environments. From
  // `\showthe\arrayrulewidth` in LaTeX. Equals 0.4 / ptPerEm.
  arrayRuleWidth: [0.04, 0.04, 0.04],
  // Two values from LaTeX source2e:
  fboxsep: [0.3, 0.3, 0.3],
  //        3 pt / ptPerEm
  fboxrule: [0.04, 0.04, 0.04]
  // 0.4 pt / ptPerEm
}, NF = {
  // Latin-1
  Å: "A",
  Ð: "D",
  Þ: "o",
  å: "a",
  ð: "d",
  þ: "o",
  // Cyrillic
  А: "A",
  Б: "B",
  В: "B",
  Г: "F",
  Д: "A",
  Е: "E",
  Ж: "K",
  З: "3",
  И: "N",
  Й: "N",
  К: "K",
  Л: "N",
  М: "M",
  Н: "H",
  О: "O",
  П: "N",
  Р: "P",
  С: "C",
  Т: "T",
  У: "y",
  Ф: "O",
  Х: "X",
  Ц: "U",
  Ч: "h",
  Ш: "W",
  Щ: "W",
  Ъ: "B",
  Ы: "X",
  Ь: "B",
  Э: "3",
  Ю: "X",
  Я: "R",
  а: "a",
  б: "b",
  в: "a",
  г: "r",
  д: "y",
  е: "e",
  ж: "m",
  з: "e",
  и: "n",
  й: "n",
  к: "n",
  л: "n",
  м: "m",
  н: "n",
  о: "o",
  п: "n",
  р: "p",
  с: "c",
  т: "o",
  у: "y",
  ф: "b",
  х: "x",
  ц: "n",
  ч: "n",
  ш: "w",
  щ: "w",
  ъ: "a",
  ы: "m",
  ь: "a",
  э: "e",
  ю: "m",
  я: "r"
};
function F$(t, e) {
  Dr[t] = e;
}
function cm(t, e, A) {
  if (!Dr[e])
    throw new Error("Font metrics not found for font: " + e + ".");
  var n = t.charCodeAt(0), s = Dr[e][n];
  if (!s && t[0] in NF && (n = NF[t[0]].charCodeAt(0), s = Dr[e][n]), !s && A === "text" && yb(n) && (s = Dr[e][77]), s)
    return {
      depth: s[0],
      height: s[1],
      italic: s[2],
      skew: s[3],
      width: s[4]
    };
}
var nI = {};
function N$(t) {
  var e;
  if (t >= 5 ? e = 0 : t >= 3 ? e = 1 : e = 2, !nI[e]) {
    var A = nI[e] = {
      cssEmPerMu: E0.quad[e] / 18
    };
    for (var n in E0)
      E0.hasOwnProperty(n) && (A[n] = E0[n][e]);
  }
  return nI[e];
}
var D$ = [
  // Each element contains [textsize, scriptsize, scriptscriptsize].
  // The size mappings are taken from TeX with \normalsize=10pt.
  [1, 1, 1],
  // size1: [5, 5, 5]              \tiny
  [2, 1, 1],
  // size2: [6, 5, 5]
  [3, 1, 1],
  // size3: [7, 5, 5]              \scriptsize
  [4, 2, 1],
  // size4: [8, 6, 5]              \footnotesize
  [5, 2, 1],
  // size5: [9, 6, 5]              \small
  [6, 3, 1],
  // size6: [10, 7, 5]             \normalsize
  [7, 4, 2],
  // size7: [12, 8, 6]             \large
  [8, 6, 3],
  // size8: [14.4, 10, 7]          \Large
  [9, 7, 6],
  // size9: [17.28, 12, 10]        \LARGE
  [10, 8, 7],
  // size10: [20.74, 14.4, 12]     \huge
  [11, 10, 9]
  // size11: [24.88, 20.74, 17.28] \HUGE
], DF = [
  // fontMetrics.js:getGlobalMetrics also uses size indexes, so if
  // you change size indexes, change that function.
  0.5,
  0.6,
  0.7,
  0.8,
  0.9,
  1,
  1.2,
  1.44,
  1.728,
  2.074,
  2.488
], xF = function(e, A) {
  return A.size < 2 ? e : D$[e - 1][A.size - 1];
};
class Mi {
  // A font family applies to a group of fonts (i.e. SansSerif), while a font
  // represents a specific font (i.e. SansSerif Bold).
  // See: https://tex.stackexchange.com/questions/22350/difference-between-textrm-and-mathrm
  /**
   * The base size index.
   */
  constructor(e) {
    this.style = void 0, this.color = void 0, this.size = void 0, this.textSize = void 0, this.phantom = void 0, this.font = void 0, this.fontFamily = void 0, this.fontWeight = void 0, this.fontShape = void 0, this.sizeMultiplier = void 0, this.maxSize = void 0, this.minRuleThickness = void 0, this._fontMetrics = void 0, this.style = e.style, this.color = e.color, this.size = e.size || Mi.BASESIZE, this.textSize = e.textSize || this.size, this.phantom = !!e.phantom, this.font = e.font || "", this.fontFamily = e.fontFamily || "", this.fontWeight = e.fontWeight || "", this.fontShape = e.fontShape || "", this.sizeMultiplier = DF[this.size - 1], this.maxSize = e.maxSize, this.minRuleThickness = e.minRuleThickness, this._fontMetrics = void 0;
  }
  /**
   * Returns a new options object with the same properties as "this".  Properties
   * from "extension" will be copied to the new options object.
   */
  extend(e) {
    var A = {
      style: this.style,
      size: this.size,
      textSize: this.textSize,
      color: this.color,
      phantom: this.phantom,
      font: this.font,
      fontFamily: this.fontFamily,
      fontWeight: this.fontWeight,
      fontShape: this.fontShape,
      maxSize: this.maxSize,
      minRuleThickness: this.minRuleThickness
    };
    for (var n in e)
      e.hasOwnProperty(n) && (A[n] = e[n]);
    return new Mi(A);
  }
  /**
   * Return an options object with the given style. If `this.style === style`,
   * returns `this`.
   */
  havingStyle(e) {
    return this.style === e ? this : this.extend({
      style: e,
      size: xF(this.textSize, e)
    });
  }
  /**
   * Return an options object with a cramped version of the current style. If
   * the current style is cramped, returns `this`.
   */
  havingCrampedStyle() {
    return this.havingStyle(this.style.cramp());
  }
  /**
   * Return an options object with the given size and in at least `\textstyle`.
   * Returns `this` if appropriate.
   */
  havingSize(e) {
    return this.size === e && this.textSize === e ? this : this.extend({
      style: this.style.text(),
      size: e,
      textSize: e,
      sizeMultiplier: DF[e - 1]
    });
  }
  /**
   * Like `this.havingSize(BASESIZE).havingStyle(style)`. If `style` is omitted,
   * changes to at least `\textstyle`.
   */
  havingBaseStyle(e) {
    e = e || this.style.text();
    var A = xF(Mi.BASESIZE, e);
    return this.size === A && this.textSize === Mi.BASESIZE && this.style === e ? this : this.extend({
      style: e,
      size: A
    });
  }
  /**
   * Remove the effect of sizing changes such as \Huge.
   * Keep the effect of the current style, such as \scriptstyle.
   */
  havingBaseSizing() {
    var e;
    switch (this.style.id) {
      case 4:
      case 5:
        e = 3;
        break;
      case 6:
      case 7:
        e = 1;
        break;
      default:
        e = 6;
    }
    return this.extend({
      style: this.style.text(),
      size: e
    });
  }
  /**
   * Create a new options object with the given color.
   */
  withColor(e) {
    return this.extend({
      color: e
    });
  }
  /**
   * Create a new options object with "phantom" set to true.
   */
  withPhantom() {
    return this.extend({
      phantom: !0
    });
  }
  /**
   * Creates a new options object with the given math font or old text font.
   * @type {[type]}
   */
  withFont(e) {
    return this.extend({
      font: e
    });
  }
  /**
   * Create a new options objects with the given fontFamily.
   */
  withTextFontFamily(e) {
    return this.extend({
      fontFamily: e,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontWeight(e) {
    return this.extend({
      fontWeight: e,
      font: ""
    });
  }
  /**
   * Creates a new options object with the given font weight
   */
  withTextFontShape(e) {
    return this.extend({
      fontShape: e,
      font: ""
    });
  }
  /**
   * Return the CSS sizing classes required to switch from enclosing options
   * `oldOptions` to `this`. Returns an array of classes.
   */
  sizingClasses(e) {
    return e.size !== this.size ? ["sizing", "reset-size" + e.size, "size" + this.size] : [];
  }
  /**
   * Return the CSS sizing classes required to switch to the base size. Like
   * `this.havingSize(BASESIZE).sizingClasses(this)`.
   */
  baseSizingClasses() {
    return this.size !== Mi.BASESIZE ? ["sizing", "reset-size" + this.size, "size" + Mi.BASESIZE] : [];
  }
  /**
   * Return the font metrics for this size.
   */
  fontMetrics() {
    return this._fontMetrics || (this._fontMetrics = N$(this.size)), this._fontMetrics;
  }
  /**
   * Gets the CSS color of the current options object
   */
  getColor() {
    return this.phantom ? "transparent" : this.color;
  }
}
Mi.BASESIZE = 6;
var FE = {
  // https://en.wikibooks.org/wiki/LaTeX/Lengths and
  // https://tex.stackexchange.com/a/8263
  pt: 1,
  // TeX point
  mm: 7227 / 2540,
  // millimeter
  cm: 7227 / 254,
  // centimeter
  in: 72.27,
  // inch
  bp: 803 / 800,
  // big (PostScript) points
  pc: 12,
  // pica
  dd: 1238 / 1157,
  // didot
  cc: 14856 / 1157,
  // cicero (12 didot)
  nd: 685 / 642,
  // new didot
  nc: 1370 / 107,
  // new cicero (12 new didot)
  sp: 1 / 65536,
  // scaled point (TeX's internal smallest unit)
  // https://tex.stackexchange.com/a/41371
  px: 803 / 800
  // \pdfpxdimen defaults to 1 bp in pdfTeX and LuaTeX
}, x$ = {
  ex: !0,
  em: !0,
  mu: !0
}, Fb = function(e) {
  return typeof e != "string" && (e = e.unit), e in FE || e in x$ || e === "ex";
}, nA = function(e, A) {
  var n;
  if (e.unit in FE)
    n = FE[e.unit] / A.fontMetrics().ptPerEm / A.sizeMultiplier;
  else if (e.unit === "mu")
    n = A.fontMetrics().cssEmPerMu;
  else {
    var s;
    if (A.style.isTight() ? s = A.havingStyle(A.style.text()) : s = A, e.unit === "ex")
      n = s.fontMetrics().xHeight;
    else if (e.unit === "em")
      n = s.fontMetrics().quad;
    else
      throw new de("Invalid unit: '" + e.unit + "'");
    s !== A && (n *= s.sizeMultiplier / A.sizeMultiplier);
  }
  return Math.min(e.number * n, A.maxSize);
}, Ie = function(e) {
  return +e.toFixed(4) + "em";
}, na = function(e) {
  return e.filter((A) => A).join(" ");
}, Nb = function(e, A, n) {
  if (this.classes = e || [], this.attributes = {}, this.height = 0, this.depth = 0, this.maxFontSize = 0, this.style = n || {}, A) {
    A.style.isTight() && this.classes.push("mtight");
    var s = A.getColor();
    s && (this.style.color = s);
  }
}, Db = function(e) {
  var A = document.createElement(e);
  A.className = na(this.classes);
  for (var n in this.style)
    this.style.hasOwnProperty(n) && (A.style[n] = this.style[n]);
  for (var s in this.attributes)
    this.attributes.hasOwnProperty(s) && A.setAttribute(s, this.attributes[s]);
  for (var r = 0; r < this.children.length; r++)
    A.appendChild(this.children[r].toNode());
  return A;
}, G$ = /[\s"'>/=\x00-\x1f]/, xb = function(e) {
  var A = "<" + e;
  this.classes.length && (A += ' class="' + Dt.escape(na(this.classes)) + '"');
  var n = "";
  for (var s in this.style)
    this.style.hasOwnProperty(s) && (n += Dt.hyphenate(s) + ":" + this.style[s] + ";");
  n && (A += ' style="' + Dt.escape(n) + '"');
  for (var r in this.attributes)
    if (this.attributes.hasOwnProperty(r)) {
      if (G$.test(r))
        throw new de("Invalid attribute name '" + r + "'");
      A += " " + r + '="' + Dt.escape(this.attributes[r]) + '"';
    }
  A += ">";
  for (var i = 0; i < this.children.length; i++)
    A += this.children[i].toMarkup();
  return A += "</" + e + ">", A;
};
class mh {
  constructor(e, A, n, s) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.width = void 0, this.maxFontSize = void 0, this.style = void 0, Nb.call(this, e, n, s), this.children = A || [];
  }
  /**
   * Sets an arbitrary attribute on the span. Warning: use this wisely. Not
   * all browsers support attributes the same, and having too many custom
   * attributes is probably bad.
   */
  setAttribute(e, A) {
    this.attributes[e] = A;
  }
  hasClass(e) {
    return this.classes.includes(e);
  }
  toNode() {
    return Db.call(this, "span");
  }
  toMarkup() {
    return xb.call(this, "span");
  }
}
let lm = class {
  constructor(e, A, n, s) {
    this.children = void 0, this.attributes = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, Nb.call(this, A, s), this.children = n || [], this.setAttribute("href", e);
  }
  setAttribute(e, A) {
    this.attributes[e] = A;
  }
  hasClass(e) {
    return this.classes.includes(e);
  }
  toNode() {
    return Db.call(this, "a");
  }
  toMarkup() {
    return xb.call(this, "a");
  }
};
class z$ {
  constructor(e, A, n) {
    this.src = void 0, this.alt = void 0, this.classes = void 0, this.height = void 0, this.depth = void 0, this.maxFontSize = void 0, this.style = void 0, this.alt = A, this.src = e, this.classes = ["mord"], this.style = n;
  }
  hasClass(e) {
    return this.classes.includes(e);
  }
  toNode() {
    var e = document.createElement("img");
    e.src = this.src, e.alt = this.alt, e.className = "mord";
    for (var A in this.style)
      this.style.hasOwnProperty(A) && (e.style[A] = this.style[A]);
    return e;
  }
  toMarkup() {
    var e = '<img src="' + Dt.escape(this.src) + '"' + (' alt="' + Dt.escape(this.alt) + '"'), A = "";
    for (var n in this.style)
      this.style.hasOwnProperty(n) && (A += Dt.hyphenate(n) + ":" + this.style[n] + ";");
    return A && (e += ' style="' + Dt.escape(A) + '"'), e += "'/>", e;
  }
}
var U$ = {
  î: "ı̂",
  ï: "ı̈",
  í: "ı́",
  // 'ī': '\u0131\u0304', // enable when we add Extended Latin
  ì: "ı̀"
};
class Ss {
  constructor(e, A, n, s, r, i, o, a) {
    this.text = void 0, this.height = void 0, this.depth = void 0, this.italic = void 0, this.skew = void 0, this.width = void 0, this.maxFontSize = void 0, this.classes = void 0, this.style = void 0, this.text = e, this.height = A || 0, this.depth = n || 0, this.italic = s || 0, this.skew = r || 0, this.width = i || 0, this.classes = o || [], this.style = a || {}, this.maxFontSize = 0;
    var c = w$(this.text.charCodeAt(0));
    c && this.classes.push(c + "_fallback"), /[îïíì]/.test(this.text) && (this.text = U$[this.text]);
  }
  hasClass(e) {
    return this.classes.includes(e);
  }
  /**
   * Creates a text node or span from a symbol node. Note that a span is only
   * created if it is needed.
   */
  toNode() {
    var e = document.createTextNode(this.text), A = null;
    this.italic > 0 && (A = document.createElement("span"), A.style.marginRight = Ie(this.italic)), this.classes.length > 0 && (A = A || document.createElement("span"), A.className = na(this.classes));
    for (var n in this.style)
      this.style.hasOwnProperty(n) && (A = A || document.createElement("span"), A.style[n] = this.style[n]);
    return A ? (A.appendChild(e), A) : e;
  }
  /**
   * Creates markup for a symbol node.
   */
  toMarkup() {
    var e = !1, A = "<span";
    this.classes.length && (e = !0, A += ' class="', A += Dt.escape(na(this.classes)), A += '"');
    var n = "";
    this.italic > 0 && (n += "margin-right:" + this.italic + "em;");
    for (var s in this.style)
      this.style.hasOwnProperty(s) && (n += Dt.hyphenate(s) + ":" + this.style[s] + ";");
    n && (e = !0, A += ' style="' + Dt.escape(n) + '"');
    var r = Dt.escape(this.text);
    return e ? (A += ">", A += r, A += "</span>", A) : r;
  }
}
class Ti {
  constructor(e, A) {
    this.children = void 0, this.attributes = void 0, this.children = e || [], this.attributes = A || {};
  }
  toNode() {
    var e = "http://www.w3.org/2000/svg", A = document.createElementNS(e, "svg");
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && A.setAttribute(n, this.attributes[n]);
    for (var s = 0; s < this.children.length; s++)
      A.appendChild(this.children[s].toNode());
    return A;
  }
  toMarkup() {
    var e = '<svg xmlns="http://www.w3.org/2000/svg"';
    for (var A in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, A) && (e += " " + A + '="' + Dt.escape(this.attributes[A]) + '"');
    e += ">";
    for (var n = 0; n < this.children.length; n++)
      e += this.children[n].toMarkup();
    return e += "</svg>", e;
  }
}
class sa {
  constructor(e, A) {
    this.pathName = void 0, this.alternate = void 0, this.pathName = e, this.alternate = A;
  }
  toNode() {
    var e = "http://www.w3.org/2000/svg", A = document.createElementNS(e, "path");
    return this.alternate ? A.setAttribute("d", this.alternate) : A.setAttribute("d", FF[this.pathName]), A;
  }
  toMarkup() {
    return this.alternate ? '<path d="' + Dt.escape(this.alternate) + '"/>' : '<path d="' + Dt.escape(FF[this.pathName]) + '"/>';
  }
}
class NE {
  constructor(e) {
    this.attributes = void 0, this.attributes = e || {};
  }
  toNode() {
    var e = "http://www.w3.org/2000/svg", A = document.createElementNS(e, "line");
    for (var n in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, n) && A.setAttribute(n, this.attributes[n]);
    return A;
  }
  toMarkup() {
    var e = "<line";
    for (var A in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, A) && (e += " " + A + '="' + Dt.escape(this.attributes[A]) + '"');
    return e += "/>", e;
  }
}
function GF(t) {
  if (t instanceof Ss)
    return t;
  throw new Error("Expected symbolNode but got " + String(t) + ".");
}
function b$(t) {
  if (t instanceof mh)
    return t;
  throw new Error("Expected span<HtmlDomNode> but got " + String(t) + ".");
}
var v$ = {
  bin: 1,
  close: 1,
  inner: 1,
  open: 1,
  punct: 1,
  rel: 1
}, j$ = {
  "accent-token": 1,
  mathord: 1,
  "op-token": 1,
  spacing: 1,
  textord: 1
}, Ot = {
  math: {},
  text: {}
};
function f(t, e, A, n, s, r) {
  Ot[t][s] = {
    font: e,
    group: A,
    replace: n
  }, r && n && (Ot[t][n] = Ot[t][s]);
}
var C = "math", le = "text", D = "main", j = "ams", _t = "accent-token", ye = "bin", vn = "close", Kl = "inner", Te = "mathord", YA = "op-token", fs = "open", ef = "punct", k = "rel", so = "spacing", S = "textord";
f(C, D, k, "≡", "\\equiv", !0);
f(C, D, k, "≺", "\\prec", !0);
f(C, D, k, "≻", "\\succ", !0);
f(C, D, k, "∼", "\\sim", !0);
f(C, D, k, "⊥", "\\perp");
f(C, D, k, "⪯", "\\preceq", !0);
f(C, D, k, "⪰", "\\succeq", !0);
f(C, D, k, "≃", "\\simeq", !0);
f(C, D, k, "∣", "\\mid", !0);
f(C, D, k, "≪", "\\ll", !0);
f(C, D, k, "≫", "\\gg", !0);
f(C, D, k, "≍", "\\asymp", !0);
f(C, D, k, "∥", "\\parallel");
f(C, D, k, "⋈", "\\bowtie", !0);
f(C, D, k, "⌣", "\\smile", !0);
f(C, D, k, "⊑", "\\sqsubseteq", !0);
f(C, D, k, "⊒", "\\sqsupseteq", !0);
f(C, D, k, "≐", "\\doteq", !0);
f(C, D, k, "⌢", "\\frown", !0);
f(C, D, k, "∋", "\\ni", !0);
f(C, D, k, "∝", "\\propto", !0);
f(C, D, k, "⊢", "\\vdash", !0);
f(C, D, k, "⊣", "\\dashv", !0);
f(C, D, k, "∋", "\\owns");
f(C, D, ef, ".", "\\ldotp");
f(C, D, ef, "⋅", "\\cdotp");
f(C, D, S, "#", "\\#");
f(le, D, S, "#", "\\#");
f(C, D, S, "&", "\\&");
f(le, D, S, "&", "\\&");
f(C, D, S, "ℵ", "\\aleph", !0);
f(C, D, S, "∀", "\\forall", !0);
f(C, D, S, "ℏ", "\\hbar", !0);
f(C, D, S, "∃", "\\exists", !0);
f(C, D, S, "∇", "\\nabla", !0);
f(C, D, S, "♭", "\\flat", !0);
f(C, D, S, "ℓ", "\\ell", !0);
f(C, D, S, "♮", "\\natural", !0);
f(C, D, S, "♣", "\\clubsuit", !0);
f(C, D, S, "℘", "\\wp", !0);
f(C, D, S, "♯", "\\sharp", !0);
f(C, D, S, "♢", "\\diamondsuit", !0);
f(C, D, S, "ℜ", "\\Re", !0);
f(C, D, S, "♡", "\\heartsuit", !0);
f(C, D, S, "ℑ", "\\Im", !0);
f(C, D, S, "♠", "\\spadesuit", !0);
f(C, D, S, "§", "\\S", !0);
f(le, D, S, "§", "\\S");
f(C, D, S, "¶", "\\P", !0);
f(le, D, S, "¶", "\\P");
f(C, D, S, "†", "\\dag");
f(le, D, S, "†", "\\dag");
f(le, D, S, "†", "\\textdagger");
f(C, D, S, "‡", "\\ddag");
f(le, D, S, "‡", "\\ddag");
f(le, D, S, "‡", "\\textdaggerdbl");
f(C, D, vn, "⎱", "\\rmoustache", !0);
f(C, D, fs, "⎰", "\\lmoustache", !0);
f(C, D, vn, "⟯", "\\rgroup", !0);
f(C, D, fs, "⟮", "\\lgroup", !0);
f(C, D, ye, "∓", "\\mp", !0);
f(C, D, ye, "⊖", "\\ominus", !0);
f(C, D, ye, "⊎", "\\uplus", !0);
f(C, D, ye, "⊓", "\\sqcap", !0);
f(C, D, ye, "∗", "\\ast");
f(C, D, ye, "⊔", "\\sqcup", !0);
f(C, D, ye, "◯", "\\bigcirc", !0);
f(C, D, ye, "∙", "\\bullet", !0);
f(C, D, ye, "‡", "\\ddagger");
f(C, D, ye, "≀", "\\wr", !0);
f(C, D, ye, "⨿", "\\amalg");
f(C, D, ye, "&", "\\And");
f(C, D, k, "⟵", "\\longleftarrow", !0);
f(C, D, k, "⇐", "\\Leftarrow", !0);
f(C, D, k, "⟸", "\\Longleftarrow", !0);
f(C, D, k, "⟶", "\\longrightarrow", !0);
f(C, D, k, "⇒", "\\Rightarrow", !0);
f(C, D, k, "⟹", "\\Longrightarrow", !0);
f(C, D, k, "↔", "\\leftrightarrow", !0);
f(C, D, k, "⟷", "\\longleftrightarrow", !0);
f(C, D, k, "⇔", "\\Leftrightarrow", !0);
f(C, D, k, "⟺", "\\Longleftrightarrow", !0);
f(C, D, k, "↦", "\\mapsto", !0);
f(C, D, k, "⟼", "\\longmapsto", !0);
f(C, D, k, "↗", "\\nearrow", !0);
f(C, D, k, "↩", "\\hookleftarrow", !0);
f(C, D, k, "↪", "\\hookrightarrow", !0);
f(C, D, k, "↘", "\\searrow", !0);
f(C, D, k, "↼", "\\leftharpoonup", !0);
f(C, D, k, "⇀", "\\rightharpoonup", !0);
f(C, D, k, "↙", "\\swarrow", !0);
f(C, D, k, "↽", "\\leftharpoondown", !0);
f(C, D, k, "⇁", "\\rightharpoondown", !0);
f(C, D, k, "↖", "\\nwarrow", !0);
f(C, D, k, "⇌", "\\rightleftharpoons", !0);
f(C, j, k, "≮", "\\nless", !0);
f(C, j, k, "", "\\@nleqslant");
f(C, j, k, "", "\\@nleqq");
f(C, j, k, "⪇", "\\lneq", !0);
f(C, j, k, "≨", "\\lneqq", !0);
f(C, j, k, "", "\\@lvertneqq");
f(C, j, k, "⋦", "\\lnsim", !0);
f(C, j, k, "⪉", "\\lnapprox", !0);
f(C, j, k, "⊀", "\\nprec", !0);
f(C, j, k, "⋠", "\\npreceq", !0);
f(C, j, k, "⋨", "\\precnsim", !0);
f(C, j, k, "⪹", "\\precnapprox", !0);
f(C, j, k, "≁", "\\nsim", !0);
f(C, j, k, "", "\\@nshortmid");
f(C, j, k, "∤", "\\nmid", !0);
f(C, j, k, "⊬", "\\nvdash", !0);
f(C, j, k, "⊭", "\\nvDash", !0);
f(C, j, k, "⋪", "\\ntriangleleft");
f(C, j, k, "⋬", "\\ntrianglelefteq", !0);
f(C, j, k, "⊊", "\\subsetneq", !0);
f(C, j, k, "", "\\@varsubsetneq");
f(C, j, k, "⫋", "\\subsetneqq", !0);
f(C, j, k, "", "\\@varsubsetneqq");
f(C, j, k, "≯", "\\ngtr", !0);
f(C, j, k, "", "\\@ngeqslant");
f(C, j, k, "", "\\@ngeqq");
f(C, j, k, "⪈", "\\gneq", !0);
f(C, j, k, "≩", "\\gneqq", !0);
f(C, j, k, "", "\\@gvertneqq");
f(C, j, k, "⋧", "\\gnsim", !0);
f(C, j, k, "⪊", "\\gnapprox", !0);
f(C, j, k, "⊁", "\\nsucc", !0);
f(C, j, k, "⋡", "\\nsucceq", !0);
f(C, j, k, "⋩", "\\succnsim", !0);
f(C, j, k, "⪺", "\\succnapprox", !0);
f(C, j, k, "≆", "\\ncong", !0);
f(C, j, k, "", "\\@nshortparallel");
f(C, j, k, "∦", "\\nparallel", !0);
f(C, j, k, "⊯", "\\nVDash", !0);
f(C, j, k, "⋫", "\\ntriangleright");
f(C, j, k, "⋭", "\\ntrianglerighteq", !0);
f(C, j, k, "", "\\@nsupseteqq");
f(C, j, k, "⊋", "\\supsetneq", !0);
f(C, j, k, "", "\\@varsupsetneq");
f(C, j, k, "⫌", "\\supsetneqq", !0);
f(C, j, k, "", "\\@varsupsetneqq");
f(C, j, k, "⊮", "\\nVdash", !0);
f(C, j, k, "⪵", "\\precneqq", !0);
f(C, j, k, "⪶", "\\succneqq", !0);
f(C, j, k, "", "\\@nsubseteqq");
f(C, j, ye, "⊴", "\\unlhd");
f(C, j, ye, "⊵", "\\unrhd");
f(C, j, k, "↚", "\\nleftarrow", !0);
f(C, j, k, "↛", "\\nrightarrow", !0);
f(C, j, k, "⇍", "\\nLeftarrow", !0);
f(C, j, k, "⇏", "\\nRightarrow", !0);
f(C, j, k, "↮", "\\nleftrightarrow", !0);
f(C, j, k, "⇎", "\\nLeftrightarrow", !0);
f(C, j, k, "△", "\\vartriangle");
f(C, j, S, "ℏ", "\\hslash");
f(C, j, S, "▽", "\\triangledown");
f(C, j, S, "◊", "\\lozenge");
f(C, j, S, "Ⓢ", "\\circledS");
f(C, j, S, "®", "\\circledR");
f(le, j, S, "®", "\\circledR");
f(C, j, S, "∡", "\\measuredangle", !0);
f(C, j, S, "∄", "\\nexists");
f(C, j, S, "℧", "\\mho");
f(C, j, S, "Ⅎ", "\\Finv", !0);
f(C, j, S, "⅁", "\\Game", !0);
f(C, j, S, "‵", "\\backprime");
f(C, j, S, "▲", "\\blacktriangle");
f(C, j, S, "▼", "\\blacktriangledown");
f(C, j, S, "■", "\\blacksquare");
f(C, j, S, "⧫", "\\blacklozenge");
f(C, j, S, "★", "\\bigstar");
f(C, j, S, "∢", "\\sphericalangle", !0);
f(C, j, S, "∁", "\\complement", !0);
f(C, j, S, "ð", "\\eth", !0);
f(le, D, S, "ð", "ð");
f(C, j, S, "╱", "\\diagup");
f(C, j, S, "╲", "\\diagdown");
f(C, j, S, "□", "\\square");
f(C, j, S, "□", "\\Box");
f(C, j, S, "◊", "\\Diamond");
f(C, j, S, "¥", "\\yen", !0);
f(le, j, S, "¥", "\\yen", !0);
f(C, j, S, "✓", "\\checkmark", !0);
f(le, j, S, "✓", "\\checkmark");
f(C, j, S, "ℶ", "\\beth", !0);
f(C, j, S, "ℸ", "\\daleth", !0);
f(C, j, S, "ℷ", "\\gimel", !0);
f(C, j, S, "ϝ", "\\digamma", !0);
f(C, j, S, "ϰ", "\\varkappa");
f(C, j, fs, "┌", "\\@ulcorner", !0);
f(C, j, vn, "┐", "\\@urcorner", !0);
f(C, j, fs, "└", "\\@llcorner", !0);
f(C, j, vn, "┘", "\\@lrcorner", !0);
f(C, j, k, "≦", "\\leqq", !0);
f(C, j, k, "⩽", "\\leqslant", !0);
f(C, j, k, "⪕", "\\eqslantless", !0);
f(C, j, k, "≲", "\\lesssim", !0);
f(C, j, k, "⪅", "\\lessapprox", !0);
f(C, j, k, "≊", "\\approxeq", !0);
f(C, j, ye, "⋖", "\\lessdot");
f(C, j, k, "⋘", "\\lll", !0);
f(C, j, k, "≶", "\\lessgtr", !0);
f(C, j, k, "⋚", "\\lesseqgtr", !0);
f(C, j, k, "⪋", "\\lesseqqgtr", !0);
f(C, j, k, "≑", "\\doteqdot");
f(C, j, k, "≓", "\\risingdotseq", !0);
f(C, j, k, "≒", "\\fallingdotseq", !0);
f(C, j, k, "∽", "\\backsim", !0);
f(C, j, k, "⋍", "\\backsimeq", !0);
f(C, j, k, "⫅", "\\subseteqq", !0);
f(C, j, k, "⋐", "\\Subset", !0);
f(C, j, k, "⊏", "\\sqsubset", !0);
f(C, j, k, "≼", "\\preccurlyeq", !0);
f(C, j, k, "⋞", "\\curlyeqprec", !0);
f(C, j, k, "≾", "\\precsim", !0);
f(C, j, k, "⪷", "\\precapprox", !0);
f(C, j, k, "⊲", "\\vartriangleleft");
f(C, j, k, "⊴", "\\trianglelefteq");
f(C, j, k, "⊨", "\\vDash", !0);
f(C, j, k, "⊪", "\\Vvdash", !0);
f(C, j, k, "⌣", "\\smallsmile");
f(C, j, k, "⌢", "\\smallfrown");
f(C, j, k, "≏", "\\bumpeq", !0);
f(C, j, k, "≎", "\\Bumpeq", !0);
f(C, j, k, "≧", "\\geqq", !0);
f(C, j, k, "⩾", "\\geqslant", !0);
f(C, j, k, "⪖", "\\eqslantgtr", !0);
f(C, j, k, "≳", "\\gtrsim", !0);
f(C, j, k, "⪆", "\\gtrapprox", !0);
f(C, j, ye, "⋗", "\\gtrdot");
f(C, j, k, "⋙", "\\ggg", !0);
f(C, j, k, "≷", "\\gtrless", !0);
f(C, j, k, "⋛", "\\gtreqless", !0);
f(C, j, k, "⪌", "\\gtreqqless", !0);
f(C, j, k, "≖", "\\eqcirc", !0);
f(C, j, k, "≗", "\\circeq", !0);
f(C, j, k, "≜", "\\triangleq", !0);
f(C, j, k, "∼", "\\thicksim");
f(C, j, k, "≈", "\\thickapprox");
f(C, j, k, "⫆", "\\supseteqq", !0);
f(C, j, k, "⋑", "\\Supset", !0);
f(C, j, k, "⊐", "\\sqsupset", !0);
f(C, j, k, "≽", "\\succcurlyeq", !0);
f(C, j, k, "⋟", "\\curlyeqsucc", !0);
f(C, j, k, "≿", "\\succsim", !0);
f(C, j, k, "⪸", "\\succapprox", !0);
f(C, j, k, "⊳", "\\vartriangleright");
f(C, j, k, "⊵", "\\trianglerighteq");
f(C, j, k, "⊩", "\\Vdash", !0);
f(C, j, k, "∣", "\\shortmid");
f(C, j, k, "∥", "\\shortparallel");
f(C, j, k, "≬", "\\between", !0);
f(C, j, k, "⋔", "\\pitchfork", !0);
f(C, j, k, "∝", "\\varpropto");
f(C, j, k, "◀", "\\blacktriangleleft");
f(C, j, k, "∴", "\\therefore", !0);
f(C, j, k, "∍", "\\backepsilon");
f(C, j, k, "▶", "\\blacktriangleright");
f(C, j, k, "∵", "\\because", !0);
f(C, j, k, "⋘", "\\llless");
f(C, j, k, "⋙", "\\gggtr");
f(C, j, ye, "⊲", "\\lhd");
f(C, j, ye, "⊳", "\\rhd");
f(C, j, k, "≂", "\\eqsim", !0);
f(C, D, k, "⋈", "\\Join");
f(C, j, k, "≑", "\\Doteq", !0);
f(C, j, ye, "∔", "\\dotplus", !0);
f(C, j, ye, "∖", "\\smallsetminus");
f(C, j, ye, "⋒", "\\Cap", !0);
f(C, j, ye, "⋓", "\\Cup", !0);
f(C, j, ye, "⩞", "\\doublebarwedge", !0);
f(C, j, ye, "⊟", "\\boxminus", !0);
f(C, j, ye, "⊞", "\\boxplus", !0);
f(C, j, ye, "⋇", "\\divideontimes", !0);
f(C, j, ye, "⋉", "\\ltimes", !0);
f(C, j, ye, "⋊", "\\rtimes", !0);
f(C, j, ye, "⋋", "\\leftthreetimes", !0);
f(C, j, ye, "⋌", "\\rightthreetimes", !0);
f(C, j, ye, "⋏", "\\curlywedge", !0);
f(C, j, ye, "⋎", "\\curlyvee", !0);
f(C, j, ye, "⊝", "\\circleddash", !0);
f(C, j, ye, "⊛", "\\circledast", !0);
f(C, j, ye, "⋅", "\\centerdot");
f(C, j, ye, "⊺", "\\intercal", !0);
f(C, j, ye, "⋒", "\\doublecap");
f(C, j, ye, "⋓", "\\doublecup");
f(C, j, ye, "⊠", "\\boxtimes", !0);
f(C, j, k, "⇢", "\\dashrightarrow", !0);
f(C, j, k, "⇠", "\\dashleftarrow", !0);
f(C, j, k, "⇇", "\\leftleftarrows", !0);
f(C, j, k, "⇆", "\\leftrightarrows", !0);
f(C, j, k, "⇚", "\\Lleftarrow", !0);
f(C, j, k, "↞", "\\twoheadleftarrow", !0);
f(C, j, k, "↢", "\\leftarrowtail", !0);
f(C, j, k, "↫", "\\looparrowleft", !0);
f(C, j, k, "⇋", "\\leftrightharpoons", !0);
f(C, j, k, "↶", "\\curvearrowleft", !0);
f(C, j, k, "↺", "\\circlearrowleft", !0);
f(C, j, k, "↰", "\\Lsh", !0);
f(C, j, k, "⇈", "\\upuparrows", !0);
f(C, j, k, "↿", "\\upharpoonleft", !0);
f(C, j, k, "⇃", "\\downharpoonleft", !0);
f(C, D, k, "⊶", "\\origof", !0);
f(C, D, k, "⊷", "\\imageof", !0);
f(C, j, k, "⊸", "\\multimap", !0);
f(C, j, k, "↭", "\\leftrightsquigarrow", !0);
f(C, j, k, "⇉", "\\rightrightarrows", !0);
f(C, j, k, "⇄", "\\rightleftarrows", !0);
f(C, j, k, "↠", "\\twoheadrightarrow", !0);
f(C, j, k, "↣", "\\rightarrowtail", !0);
f(C, j, k, "↬", "\\looparrowright", !0);
f(C, j, k, "↷", "\\curvearrowright", !0);
f(C, j, k, "↻", "\\circlearrowright", !0);
f(C, j, k, "↱", "\\Rsh", !0);
f(C, j, k, "⇊", "\\downdownarrows", !0);
f(C, j, k, "↾", "\\upharpoonright", !0);
f(C, j, k, "⇂", "\\downharpoonright", !0);
f(C, j, k, "⇝", "\\rightsquigarrow", !0);
f(C, j, k, "⇝", "\\leadsto");
f(C, j, k, "⇛", "\\Rrightarrow", !0);
f(C, j, k, "↾", "\\restriction");
f(C, D, S, "‘", "`");
f(C, D, S, "$", "\\$");
f(le, D, S, "$", "\\$");
f(le, D, S, "$", "\\textdollar");
f(C, D, S, "%", "\\%");
f(le, D, S, "%", "\\%");
f(C, D, S, "_", "\\_");
f(le, D, S, "_", "\\_");
f(le, D, S, "_", "\\textunderscore");
f(C, D, S, "∠", "\\angle", !0);
f(C, D, S, "∞", "\\infty", !0);
f(C, D, S, "′", "\\prime");
f(C, D, S, "△", "\\triangle");
f(C, D, S, "Γ", "\\Gamma", !0);
f(C, D, S, "Δ", "\\Delta", !0);
f(C, D, S, "Θ", "\\Theta", !0);
f(C, D, S, "Λ", "\\Lambda", !0);
f(C, D, S, "Ξ", "\\Xi", !0);
f(C, D, S, "Π", "\\Pi", !0);
f(C, D, S, "Σ", "\\Sigma", !0);
f(C, D, S, "Υ", "\\Upsilon", !0);
f(C, D, S, "Φ", "\\Phi", !0);
f(C, D, S, "Ψ", "\\Psi", !0);
f(C, D, S, "Ω", "\\Omega", !0);
f(C, D, S, "A", "Α");
f(C, D, S, "B", "Β");
f(C, D, S, "E", "Ε");
f(C, D, S, "Z", "Ζ");
f(C, D, S, "H", "Η");
f(C, D, S, "I", "Ι");
f(C, D, S, "K", "Κ");
f(C, D, S, "M", "Μ");
f(C, D, S, "N", "Ν");
f(C, D, S, "O", "Ο");
f(C, D, S, "P", "Ρ");
f(C, D, S, "T", "Τ");
f(C, D, S, "X", "Χ");
f(C, D, S, "¬", "\\neg", !0);
f(C, D, S, "¬", "\\lnot");
f(C, D, S, "⊤", "\\top");
f(C, D, S, "⊥", "\\bot");
f(C, D, S, "∅", "\\emptyset");
f(C, j, S, "∅", "\\varnothing");
f(C, D, Te, "α", "\\alpha", !0);
f(C, D, Te, "β", "\\beta", !0);
f(C, D, Te, "γ", "\\gamma", !0);
f(C, D, Te, "δ", "\\delta", !0);
f(C, D, Te, "ϵ", "\\epsilon", !0);
f(C, D, Te, "ζ", "\\zeta", !0);
f(C, D, Te, "η", "\\eta", !0);
f(C, D, Te, "θ", "\\theta", !0);
f(C, D, Te, "ι", "\\iota", !0);
f(C, D, Te, "κ", "\\kappa", !0);
f(C, D, Te, "λ", "\\lambda", !0);
f(C, D, Te, "μ", "\\mu", !0);
f(C, D, Te, "ν", "\\nu", !0);
f(C, D, Te, "ξ", "\\xi", !0);
f(C, D, Te, "ο", "\\omicron", !0);
f(C, D, Te, "π", "\\pi", !0);
f(C, D, Te, "ρ", "\\rho", !0);
f(C, D, Te, "σ", "\\sigma", !0);
f(C, D, Te, "τ", "\\tau", !0);
f(C, D, Te, "υ", "\\upsilon", !0);
f(C, D, Te, "ϕ", "\\phi", !0);
f(C, D, Te, "χ", "\\chi", !0);
f(C, D, Te, "ψ", "\\psi", !0);
f(C, D, Te, "ω", "\\omega", !0);
f(C, D, Te, "ε", "\\varepsilon", !0);
f(C, D, Te, "ϑ", "\\vartheta", !0);
f(C, D, Te, "ϖ", "\\varpi", !0);
f(C, D, Te, "ϱ", "\\varrho", !0);
f(C, D, Te, "ς", "\\varsigma", !0);
f(C, D, Te, "φ", "\\varphi", !0);
f(C, D, ye, "∗", "*", !0);
f(C, D, ye, "+", "+");
f(C, D, ye, "−", "-", !0);
f(C, D, ye, "⋅", "\\cdot", !0);
f(C, D, ye, "∘", "\\circ", !0);
f(C, D, ye, "÷", "\\div", !0);
f(C, D, ye, "±", "\\pm", !0);
f(C, D, ye, "×", "\\times", !0);
f(C, D, ye, "∩", "\\cap", !0);
f(C, D, ye, "∪", "\\cup", !0);
f(C, D, ye, "∖", "\\setminus", !0);
f(C, D, ye, "∧", "\\land");
f(C, D, ye, "∨", "\\lor");
f(C, D, ye, "∧", "\\wedge", !0);
f(C, D, ye, "∨", "\\vee", !0);
f(C, D, S, "√", "\\surd");
f(C, D, fs, "⟨", "\\langle", !0);
f(C, D, fs, "∣", "\\lvert");
f(C, D, fs, "∥", "\\lVert");
f(C, D, vn, "?", "?");
f(C, D, vn, "!", "!");
f(C, D, vn, "⟩", "\\rangle", !0);
f(C, D, vn, "∣", "\\rvert");
f(C, D, vn, "∥", "\\rVert");
f(C, D, k, "=", "=");
f(C, D, k, ":", ":");
f(C, D, k, "≈", "\\approx", !0);
f(C, D, k, "≅", "\\cong", !0);
f(C, D, k, "≥", "\\ge");
f(C, D, k, "≥", "\\geq", !0);
f(C, D, k, "←", "\\gets");
f(C, D, k, ">", "\\gt", !0);
f(C, D, k, "∈", "\\in", !0);
f(C, D, k, "", "\\@not");
f(C, D, k, "⊂", "\\subset", !0);
f(C, D, k, "⊃", "\\supset", !0);
f(C, D, k, "⊆", "\\subseteq", !0);
f(C, D, k, "⊇", "\\supseteq", !0);
f(C, j, k, "⊈", "\\nsubseteq", !0);
f(C, j, k, "⊉", "\\nsupseteq", !0);
f(C, D, k, "⊨", "\\models");
f(C, D, k, "←", "\\leftarrow", !0);
f(C, D, k, "≤", "\\le");
f(C, D, k, "≤", "\\leq", !0);
f(C, D, k, "<", "\\lt", !0);
f(C, D, k, "→", "\\rightarrow", !0);
f(C, D, k, "→", "\\to");
f(C, j, k, "≱", "\\ngeq", !0);
f(C, j, k, "≰", "\\nleq", !0);
f(C, D, so, " ", "\\ ");
f(C, D, so, " ", "\\space");
f(C, D, so, " ", "\\nobreakspace");
f(le, D, so, " ", "\\ ");
f(le, D, so, " ", " ");
f(le, D, so, " ", "\\space");
f(le, D, so, " ", "\\nobreakspace");
f(C, D, so, null, "\\nobreak");
f(C, D, so, null, "\\allowbreak");
f(C, D, ef, ",", ",");
f(C, D, ef, ";", ";");
f(C, j, ye, "⊼", "\\barwedge", !0);
f(C, j, ye, "⊻", "\\veebar", !0);
f(C, D, ye, "⊙", "\\odot", !0);
f(C, D, ye, "⊕", "\\oplus", !0);
f(C, D, ye, "⊗", "\\otimes", !0);
f(C, D, S, "∂", "\\partial", !0);
f(C, D, ye, "⊘", "\\oslash", !0);
f(C, j, ye, "⊚", "\\circledcirc", !0);
f(C, j, ye, "⊡", "\\boxdot", !0);
f(C, D, ye, "△", "\\bigtriangleup");
f(C, D, ye, "▽", "\\bigtriangledown");
f(C, D, ye, "†", "\\dagger");
f(C, D, ye, "⋄", "\\diamond");
f(C, D, ye, "⋆", "\\star");
f(C, D, ye, "◃", "\\triangleleft");
f(C, D, ye, "▹", "\\triangleright");
f(C, D, fs, "{", "\\{");
f(le, D, S, "{", "\\{");
f(le, D, S, "{", "\\textbraceleft");
f(C, D, vn, "}", "\\}");
f(le, D, S, "}", "\\}");
f(le, D, S, "}", "\\textbraceright");
f(C, D, fs, "{", "\\lbrace");
f(C, D, vn, "}", "\\rbrace");
f(C, D, fs, "[", "\\lbrack", !0);
f(le, D, S, "[", "\\lbrack", !0);
f(C, D, vn, "]", "\\rbrack", !0);
f(le, D, S, "]", "\\rbrack", !0);
f(C, D, fs, "(", "\\lparen", !0);
f(C, D, vn, ")", "\\rparen", !0);
f(le, D, S, "<", "\\textless", !0);
f(le, D, S, ">", "\\textgreater", !0);
f(C, D, fs, "⌊", "\\lfloor", !0);
f(C, D, vn, "⌋", "\\rfloor", !0);
f(C, D, fs, "⌈", "\\lceil", !0);
f(C, D, vn, "⌉", "\\rceil", !0);
f(C, D, S, "\\", "\\backslash");
f(C, D, S, "∣", "|");
f(C, D, S, "∣", "\\vert");
f(le, D, S, "|", "\\textbar", !0);
f(C, D, S, "∥", "\\|");
f(C, D, S, "∥", "\\Vert");
f(le, D, S, "∥", "\\textbardbl");
f(le, D, S, "~", "\\textasciitilde");
f(le, D, S, "\\", "\\textbackslash");
f(le, D, S, "^", "\\textasciicircum");
f(C, D, k, "↑", "\\uparrow", !0);
f(C, D, k, "⇑", "\\Uparrow", !0);
f(C, D, k, "↓", "\\downarrow", !0);
f(C, D, k, "⇓", "\\Downarrow", !0);
f(C, D, k, "↕", "\\updownarrow", !0);
f(C, D, k, "⇕", "\\Updownarrow", !0);
f(C, D, YA, "∐", "\\coprod");
f(C, D, YA, "⋁", "\\bigvee");
f(C, D, YA, "⋀", "\\bigwedge");
f(C, D, YA, "⨄", "\\biguplus");
f(C, D, YA, "⋂", "\\bigcap");
f(C, D, YA, "⋃", "\\bigcup");
f(C, D, YA, "∫", "\\int");
f(C, D, YA, "∫", "\\intop");
f(C, D, YA, "∬", "\\iint");
f(C, D, YA, "∭", "\\iiint");
f(C, D, YA, "∏", "\\prod");
f(C, D, YA, "∑", "\\sum");
f(C, D, YA, "⨂", "\\bigotimes");
f(C, D, YA, "⨁", "\\bigoplus");
f(C, D, YA, "⨀", "\\bigodot");
f(C, D, YA, "∮", "\\oint");
f(C, D, YA, "∯", "\\oiint");
f(C, D, YA, "∰", "\\oiiint");
f(C, D, YA, "⨆", "\\bigsqcup");
f(C, D, YA, "∫", "\\smallint");
f(le, D, Kl, "…", "\\textellipsis");
f(C, D, Kl, "…", "\\mathellipsis");
f(le, D, Kl, "…", "\\ldots", !0);
f(C, D, Kl, "…", "\\ldots", !0);
f(C, D, Kl, "⋯", "\\@cdots", !0);
f(C, D, Kl, "⋱", "\\ddots", !0);
f(C, D, S, "⋮", "\\varvdots");
f(le, D, S, "⋮", "\\varvdots");
f(C, D, _t, "ˊ", "\\acute");
f(C, D, _t, "ˋ", "\\grave");
f(C, D, _t, "¨", "\\ddot");
f(C, D, _t, "~", "\\tilde");
f(C, D, _t, "ˉ", "\\bar");
f(C, D, _t, "˘", "\\breve");
f(C, D, _t, "ˇ", "\\check");
f(C, D, _t, "^", "\\hat");
f(C, D, _t, "⃗", "\\vec");
f(C, D, _t, "˙", "\\dot");
f(C, D, _t, "˚", "\\mathring");
f(C, D, Te, "", "\\@imath");
f(C, D, Te, "", "\\@jmath");
f(C, D, S, "ı", "ı");
f(C, D, S, "ȷ", "ȷ");
f(le, D, S, "ı", "\\i", !0);
f(le, D, S, "ȷ", "\\j", !0);
f(le, D, S, "ß", "\\ss", !0);
f(le, D, S, "æ", "\\ae", !0);
f(le, D, S, "œ", "\\oe", !0);
f(le, D, S, "ø", "\\o", !0);
f(le, D, S, "Æ", "\\AE", !0);
f(le, D, S, "Œ", "\\OE", !0);
f(le, D, S, "Ø", "\\O", !0);
f(le, D, _t, "ˊ", "\\'");
f(le, D, _t, "ˋ", "\\`");
f(le, D, _t, "ˆ", "\\^");
f(le, D, _t, "˜", "\\~");
f(le, D, _t, "ˉ", "\\=");
f(le, D, _t, "˘", "\\u");
f(le, D, _t, "˙", "\\.");
f(le, D, _t, "¸", "\\c");
f(le, D, _t, "˚", "\\r");
f(le, D, _t, "ˇ", "\\v");
f(le, D, _t, "¨", '\\"');
f(le, D, _t, "˝", "\\H");
f(le, D, _t, "◯", "\\textcircled");
var Gb = {
  "--": !0,
  "---": !0,
  "``": !0,
  "''": !0
};
f(le, D, S, "–", "--", !0);
f(le, D, S, "–", "\\textendash");
f(le, D, S, "—", "---", !0);
f(le, D, S, "—", "\\textemdash");
f(le, D, S, "‘", "`", !0);
f(le, D, S, "‘", "\\textquoteleft");
f(le, D, S, "’", "'", !0);
f(le, D, S, "’", "\\textquoteright");
f(le, D, S, "“", "``", !0);
f(le, D, S, "“", "\\textquotedblleft");
f(le, D, S, "”", "''", !0);
f(le, D, S, "”", "\\textquotedblright");
f(C, D, S, "°", "\\degree", !0);
f(le, D, S, "°", "\\degree");
f(le, D, S, "°", "\\textdegree", !0);
f(C, D, S, "£", "\\pounds");
f(C, D, S, "£", "\\mathsterling", !0);
f(le, D, S, "£", "\\pounds");
f(le, D, S, "£", "\\textsterling", !0);
f(C, j, S, "✠", "\\maltese");
f(le, j, S, "✠", "\\maltese");
var zF = '0123456789/@."';
for (var sI = 0; sI < zF.length; sI++) {
  var UF = zF.charAt(sI);
  f(C, D, S, UF, UF);
}
var bF = '0123456789!@*()-=+";:?/.,';
for (var rI = 0; rI < bF.length; rI++) {
  var vF = bF.charAt(rI);
  f(le, D, S, vF, vF);
}
var Sd = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz";
for (var iI = 0; iI < Sd.length; iI++) {
  var M0 = Sd.charAt(iI);
  f(C, D, Te, M0, M0), f(le, D, S, M0, M0);
}
f(C, j, S, "C", "ℂ");
f(le, j, S, "C", "ℂ");
f(C, j, S, "H", "ℍ");
f(le, j, S, "H", "ℍ");
f(C, j, S, "N", "ℕ");
f(le, j, S, "N", "ℕ");
f(C, j, S, "P", "ℙ");
f(le, j, S, "P", "ℙ");
f(C, j, S, "Q", "ℚ");
f(le, j, S, "Q", "ℚ");
f(C, j, S, "R", "ℝ");
f(le, j, S, "R", "ℝ");
f(C, j, S, "Z", "ℤ");
f(le, j, S, "Z", "ℤ");
f(C, D, Te, "h", "ℎ");
f(le, D, Te, "h", "ℎ");
var Ze = "";
for (var fn = 0; fn < Sd.length; fn++) {
  var aA = Sd.charAt(fn);
  Ze = String.fromCharCode(55349, 56320 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56372 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56424 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56580 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56684 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56736 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56788 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56840 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56944 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), fn < 26 && (Ze = String.fromCharCode(55349, 56632 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze), Ze = String.fromCharCode(55349, 56476 + fn), f(C, D, Te, aA, Ze), f(le, D, S, aA, Ze));
}
Ze = "𝕜";
f(C, D, Te, "k", Ze);
f(le, D, S, "k", Ze);
for (var Ya = 0; Ya < 10; Ya++) {
  var ho = Ya.toString();
  Ze = String.fromCharCode(55349, 57294 + Ya), f(C, D, Te, ho, Ze), f(le, D, S, ho, Ze), Ze = String.fromCharCode(55349, 57314 + Ya), f(C, D, Te, ho, Ze), f(le, D, S, ho, Ze), Ze = String.fromCharCode(55349, 57324 + Ya), f(C, D, Te, ho, Ze), f(le, D, S, ho, Ze), Ze = String.fromCharCode(55349, 57334 + Ya), f(C, D, Te, ho, Ze), f(le, D, S, ho, Ze);
}
var DE = "ÐÞþ";
for (var oI = 0; oI < DE.length; oI++) {
  var p0 = DE.charAt(oI);
  f(C, D, Te, p0, p0), f(le, D, S, p0, p0);
}
var m0 = [
  ["mathbf", "textbf", "Main-Bold"],
  // A-Z bold upright
  ["mathbf", "textbf", "Main-Bold"],
  // a-z bold upright
  ["mathnormal", "textit", "Math-Italic"],
  // A-Z italic
  ["mathnormal", "textit", "Math-Italic"],
  // a-z italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // A-Z bold italic
  ["boldsymbol", "boldsymbol", "Main-BoldItalic"],
  // a-z bold italic
  // Map fancy A-Z letters to script, not calligraphic.
  // This aligns with unicode-math and math fonts (except Cambria Math).
  ["mathscr", "textscr", "Script-Regular"],
  // A-Z script
  ["", "", ""],
  // a-z script.  No font
  ["", "", ""],
  // A-Z bold script. No font
  ["", "", ""],
  // a-z bold script. No font
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // A-Z Fraktur
  ["mathfrak", "textfrak", "Fraktur-Regular"],
  // a-z Fraktur
  ["mathbb", "textbb", "AMS-Regular"],
  // A-Z double-struck
  ["mathbb", "textbb", "AMS-Regular"],
  // k double-struck
  // Note that we are using a bold font, but font metrics for regular Fraktur.
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // A-Z bold Fraktur
  ["mathboldfrak", "textboldfrak", "Fraktur-Regular"],
  // a-z bold Fraktur
  ["mathsf", "textsf", "SansSerif-Regular"],
  // A-Z sans-serif
  ["mathsf", "textsf", "SansSerif-Regular"],
  // a-z sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // A-Z bold sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // a-z bold sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // A-Z italic sans-serif
  ["mathitsf", "textitsf", "SansSerif-Italic"],
  // a-z italic sans-serif
  ["", "", ""],
  // A-Z bold italic sans. No font
  ["", "", ""],
  // a-z bold italic sans. No font
  ["mathtt", "texttt", "Typewriter-Regular"],
  // A-Z monospace
  ["mathtt", "texttt", "Typewriter-Regular"]
  // a-z monospace
], jF = [
  ["mathbf", "textbf", "Main-Bold"],
  // 0-9 bold
  ["", "", ""],
  // 0-9 double-struck. No KaTeX font.
  ["mathsf", "textsf", "SansSerif-Regular"],
  // 0-9 sans-serif
  ["mathboldsf", "textboldsf", "SansSerif-Bold"],
  // 0-9 bold sans-serif
  ["mathtt", "texttt", "Typewriter-Regular"]
  // 0-9 monospace
], H$ = function(e, A) {
  var n = e.charCodeAt(0), s = e.charCodeAt(1), r = (n - 55296) * 1024 + (s - 56320) + 65536, i = A === "math" ? 0 : 1;
  if (119808 <= r && r < 120484) {
    var o = Math.floor((r - 119808) / 26);
    return [m0[o][2], m0[o][i]];
  } else if (120782 <= r && r <= 120831) {
    var a = Math.floor((r - 120782) / 10);
    return [jF[a][2], jF[a][i]];
  } else {
    if (r === 120485 || r === 120486)
      return [m0[0][2], m0[0][i]];
    if (120486 < r && r < 120782)
      return ["", ""];
    throw new de("Unsupported character: " + e);
  }
}, tf = function(e, A, n) {
  return Ot[n][e] && Ot[n][e].replace && (e = Ot[n][e].replace), {
    value: e,
    metrics: cm(e, A, n)
  };
}, Vs = function(e, A, n, s, r) {
  var i = tf(e, A, n), o = i.metrics;
  e = i.value;
  var a;
  if (o) {
    var c = o.italic;
    (n === "text" || s && s.font === "mathit") && (c = 0), a = new Ss(e, o.height, o.depth, c, o.skew, o.width, r);
  } else
    typeof console < "u" && console.warn("No character metrics " + ("for '" + e + "' in style '" + A + "' and mode '" + n + "'")), a = new Ss(e, 0, 0, 0, 0, 0, r);
  if (s) {
    a.maxFontSize = s.sizeMultiplier, s.style.isTight() && a.classes.push("mtight");
    var l = s.getColor();
    l && (a.style.color = l);
  }
  return a;
}, k$ = function(e, A, n, s) {
  return s === void 0 && (s = []), n.font === "boldsymbol" && tf(e, "Main-Bold", A).metrics ? Vs(e, "Main-Bold", A, n, s.concat(["mathbf"])) : e === "\\" || Ot[A][e].font === "main" ? Vs(e, "Main-Regular", A, n, s) : Vs(e, "AMS-Regular", A, n, s.concat(["amsrm"]));
}, R$ = function(e, A, n, s, r) {
  return r !== "textord" && tf(e, "Math-BoldItalic", A).metrics ? {
    fontName: "Math-BoldItalic",
    fontClass: "boldsymbol"
  } : {
    fontName: "Main-Bold",
    fontClass: "mathbf"
  };
}, L$ = function(e, A, n) {
  var s = e.mode, r = e.text, i = ["mord"], o = s === "math" || s === "text" && A.font, a = o ? A.font : A.fontFamily, c = "", l = "";
  if (r.charCodeAt(0) === 55349 && ([c, l] = H$(r, s)), c.length > 0)
    return Vs(r, c, s, A, i.concat(l));
  if (a) {
    var B, g;
    if (a === "boldsymbol") {
      var h = R$(r, s, A, i, n);
      B = h.fontName, g = [h.fontClass];
    } else o ? (B = bb[a].fontName, g = [a]) : (B = Y0(a, A.fontWeight, A.fontShape), g = [a, A.fontWeight, A.fontShape]);
    if (tf(r, B, s).metrics)
      return Vs(r, B, s, A, i.concat(g));
    if (Gb.hasOwnProperty(r) && B.slice(0, 10) === "Typewriter") {
      for (var u = [], d = 0; d < r.length; d++)
        u.push(Vs(r[d], B, s, A, i.concat(g)));
      return Ub(u);
    }
  }
  if (n === "mathord")
    return Vs(r, "Math-Italic", s, A, i.concat(["mathnormal"]));
  if (n === "textord") {
    var w = Ot[s][r] && Ot[s][r].font;
    if (w === "ams") {
      var Q = Y0("amsrm", A.fontWeight, A.fontShape);
      return Vs(r, Q, s, A, i.concat("amsrm", A.fontWeight, A.fontShape));
    } else if (w === "main" || !w) {
      var p = Y0("textrm", A.fontWeight, A.fontShape);
      return Vs(r, p, s, A, i.concat(A.fontWeight, A.fontShape));
    } else {
      var M = Y0(w, A.fontWeight, A.fontShape);
      return Vs(r, M, s, A, i.concat(M, A.fontWeight, A.fontShape));
    }
  } else
    throw new Error("unexpected type: " + n + " in makeOrd");
}, S$ = (t, e) => {
  if (na(t.classes) !== na(e.classes) || t.skew !== e.skew || t.maxFontSize !== e.maxFontSize)
    return !1;
  if (t.classes.length === 1) {
    var A = t.classes[0];
    if (A === "mbin" || A === "mord")
      return !1;
  }
  for (var n in t.style)
    if (t.style.hasOwnProperty(n) && t.style[n] !== e.style[n])
      return !1;
  for (var s in e.style)
    if (e.style.hasOwnProperty(s) && t.style[s] !== e.style[s])
      return !1;
  return !0;
}, T$ = (t) => {
  for (var e = 0; e < t.length - 1; e++) {
    var A = t[e], n = t[e + 1];
    A instanceof Ss && n instanceof Ss && S$(A, n) && (A.text += n.text, A.height = Math.max(A.height, n.height), A.depth = Math.max(A.depth, n.depth), A.italic = n.italic, t.splice(e + 1, 1), e--);
  }
  return t;
}, Bm = function(e) {
  for (var A = 0, n = 0, s = 0, r = 0; r < e.children.length; r++) {
    var i = e.children[r];
    i.height > A && (A = i.height), i.depth > n && (n = i.depth), i.maxFontSize > s && (s = i.maxFontSize);
  }
  e.height = A, e.depth = n, e.maxFontSize = s;
}, Wn = function(e, A, n, s) {
  var r = new mh(e, A, n, s);
  return Bm(r), r;
}, zb = (t, e, A, n) => new mh(t, e, A, n), J$ = function(e, A, n) {
  var s = Wn([e], [], A);
  return s.height = Math.max(n || A.fontMetrics().defaultRuleThickness, A.minRuleThickness), s.style.borderBottomWidth = Ie(s.height), s.maxFontSize = 1, s;
}, W$ = function(e, A, n, s) {
  var r = new lm(e, A, n, s);
  return Bm(r), r;
}, Ub = function(e) {
  var A = new ph(e);
  return Bm(A), A;
}, O$ = function(e, A) {
  return e instanceof ph ? Wn([], [e], A) : e;
}, P$ = function(e) {
  if (e.positionType === "individualShift") {
    for (var A = e.children, n = [A[0]], s = -A[0].shift - A[0].elem.depth, r = s, i = 1; i < A.length; i++) {
      var o = -A[i].shift - r - A[i].elem.depth, a = o - (A[i - 1].elem.height + A[i - 1].elem.depth);
      r = r + o, n.push({
        type: "kern",
        size: a
      }), n.push(A[i]);
    }
    return {
      children: n,
      depth: s
    };
  }
  var c;
  if (e.positionType === "top") {
    for (var l = e.positionData, B = 0; B < e.children.length; B++) {
      var g = e.children[B];
      l -= g.type === "kern" ? g.size : g.elem.height + g.elem.depth;
    }
    c = l;
  } else if (e.positionType === "bottom")
    c = -e.positionData;
  else {
    var h = e.children[0];
    if (h.type !== "elem")
      throw new Error('First child must have type "elem".');
    if (e.positionType === "shift")
      c = -h.elem.depth - e.positionData;
    else if (e.positionType === "firstBaseline")
      c = -h.elem.depth;
    else
      throw new Error("Invalid positionType " + e.positionType + ".");
  }
  return {
    children: e.children,
    depth: c
  };
}, K$ = function(e, A) {
  for (var {
    children: n,
    depth: s
  } = P$(e), r = 0, i = 0; i < n.length; i++) {
    var o = n[i];
    if (o.type === "elem") {
      var a = o.elem;
      r = Math.max(r, a.maxFontSize, a.height);
    }
  }
  r += 2;
  var c = Wn(["pstrut"], []);
  c.style.height = Ie(r);
  for (var l = [], B = s, g = s, h = s, u = 0; u < n.length; u++) {
    var d = n[u];
    if (d.type === "kern")
      h += d.size;
    else {
      var w = d.elem, Q = d.wrapperClasses || [], p = d.wrapperStyle || {}, M = Wn(Q, [c, w], void 0, p);
      M.style.top = Ie(-r - h - w.depth), d.marginLeft && (M.style.marginLeft = d.marginLeft), d.marginRight && (M.style.marginRight = d.marginRight), l.push(M), h += w.height + w.depth;
    }
    B = Math.min(B, h), g = Math.max(g, h);
  }
  var I = Wn(["vlist"], l);
  I.style.height = Ie(g);
  var N;
  if (B < 0) {
    var m = Wn([], []), E = Wn(["vlist"], [m]);
    E.style.height = Ie(-B);
    var G = Wn(["vlist-s"], [new Ss("​")]);
    N = [Wn(["vlist-r"], [I, G]), Wn(["vlist-r"], [E])];
  } else
    N = [Wn(["vlist-r"], [I])];
  var Y = Wn(["vlist-t"], N);
  return N.length === 2 && Y.classes.push("vlist-t2"), Y.height = g, Y.depth = -B, Y;
}, V$ = (t, e) => {
  var A = Wn(["mspace"], [], e), n = nA(t, e);
  return A.style.marginRight = Ie(n), A;
}, Y0 = function(e, A, n) {
  var s = "";
  switch (e) {
    case "amsrm":
      s = "AMS";
      break;
    case "textrm":
      s = "Main";
      break;
    case "textsf":
      s = "SansSerif";
      break;
    case "texttt":
      s = "Typewriter";
      break;
    default:
      s = e;
  }
  var r;
  return A === "textbf" && n === "textit" ? r = "BoldItalic" : A === "textbf" ? r = "Bold" : A === "textit" ? r = "Italic" : r = "Regular", s + "-" + r;
}, bb = {
  // styles
  mathbf: {
    variant: "bold",
    fontName: "Main-Bold"
  },
  mathrm: {
    variant: "normal",
    fontName: "Main-Regular"
  },
  textit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathit: {
    variant: "italic",
    fontName: "Main-Italic"
  },
  mathnormal: {
    variant: "italic",
    fontName: "Math-Italic"
  },
  mathsfit: {
    variant: "sans-serif-italic",
    fontName: "SansSerif-Italic"
  },
  // "boldsymbol" is missing because they require the use of multiple fonts:
  // Math-BoldItalic and Main-Bold.  This is handled by a special case in
  // makeOrd which ends up calling boldsymbol.
  // families
  mathbb: {
    variant: "double-struck",
    fontName: "AMS-Regular"
  },
  mathcal: {
    variant: "script",
    fontName: "Caligraphic-Regular"
  },
  mathfrak: {
    variant: "fraktur",
    fontName: "Fraktur-Regular"
  },
  mathscr: {
    variant: "script",
    fontName: "Script-Regular"
  },
  mathsf: {
    variant: "sans-serif",
    fontName: "SansSerif-Regular"
  },
  mathtt: {
    variant: "monospace",
    fontName: "Typewriter-Regular"
  }
}, vb = {
  //   path, width, height
  vec: ["vec", 0.471, 0.714],
  // values from the font glyph
  oiintSize1: ["oiintSize1", 0.957, 0.499],
  // oval to overlay the integrand
  oiintSize2: ["oiintSize2", 1.472, 0.659],
  oiiintSize1: ["oiiintSize1", 1.304, 0.499],
  oiiintSize2: ["oiiintSize2", 1.98, 0.659]
}, X$ = function(e, A) {
  var [n, s, r] = vb[e], i = new sa(n), o = new Ti([i], {
    width: Ie(s),
    height: Ie(r),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + Ie(s),
    viewBox: "0 0 " + 1e3 * s + " " + 1e3 * r,
    preserveAspectRatio: "xMinYMin"
  }), a = zb(["overlay"], [o], A);
  return a.height = r, a.style.height = Ie(r), a.style.width = Ie(s), a;
}, O = {
  fontMap: bb,
  makeSymbol: Vs,
  mathsym: k$,
  makeSpan: Wn,
  makeSvgSpan: zb,
  makeLineSpan: J$,
  makeAnchor: W$,
  makeFragment: Ub,
  wrapFragment: O$,
  makeVList: K$,
  makeOrd: L$,
  makeGlue: V$,
  staticSvg: X$,
  svgData: vb,
  tryCombineChars: T$
}, AA = {
  number: 3,
  unit: "mu"
}, ya = {
  number: 4,
  unit: "mu"
}, hi = {
  number: 5,
  unit: "mu"
}, Z$ = {
  mord: {
    mop: AA,
    mbin: ya,
    mrel: hi,
    minner: AA
  },
  mop: {
    mord: AA,
    mop: AA,
    mrel: hi,
    minner: AA
  },
  mbin: {
    mord: ya,
    mop: ya,
    mopen: ya,
    minner: ya
  },
  mrel: {
    mord: hi,
    mop: hi,
    mopen: hi,
    minner: hi
  },
  mopen: {},
  mclose: {
    mop: AA,
    mbin: ya,
    mrel: hi,
    minner: AA
  },
  mpunct: {
    mord: AA,
    mop: AA,
    mrel: hi,
    mopen: AA,
    mclose: AA,
    mpunct: AA,
    minner: AA
  },
  minner: {
    mord: AA,
    mop: AA,
    mbin: ya,
    mrel: hi,
    mopen: AA,
    mpunct: AA,
    minner: AA
  }
}, q$ = {
  mord: {
    mop: AA
  },
  mop: {
    mord: AA,
    mop: AA
  },
  mbin: {},
  mrel: {},
  mopen: {},
  mclose: {
    mop: AA
  },
  mpunct: {},
  minner: {
    mop: AA
  }
}, jb = {}, Td = {}, Jd = {};
function Ye(t) {
  for (var {
    type: e,
    names: A,
    props: n,
    handler: s,
    htmlBuilder: r,
    mathmlBuilder: i
  } = t, o = {
    type: e,
    numArgs: n.numArgs,
    argTypes: n.argTypes,
    allowedInArgument: !!n.allowedInArgument,
    allowedInText: !!n.allowedInText,
    allowedInMath: n.allowedInMath === void 0 ? !0 : n.allowedInMath,
    numOptionalArgs: n.numOptionalArgs || 0,
    infix: !!n.infix,
    primitive: !!n.primitive,
    handler: s
  }, a = 0; a < A.length; ++a)
    jb[A[a]] = o;
  e && (r && (Td[e] = r), i && (Jd[e] = i));
}
function gc(t) {
  var {
    type: e,
    htmlBuilder: A,
    mathmlBuilder: n
  } = t;
  Ye({
    type: e,
    names: [],
    props: {
      numArgs: 0
    },
    handler() {
      throw new Error("Should never be called.");
    },
    htmlBuilder: A,
    mathmlBuilder: n
  });
}
var Wd = function(e) {
  return e.type === "ordgroup" && e.body.length === 1 ? e.body[0] : e;
}, dA = function(e) {
  return e.type === "ordgroup" ? e.body : [e];
}, Ji = O.makeSpan, _$ = ["leftmost", "mbin", "mopen", "mrel", "mop", "mpunct"], $$ = ["rightmost", "mrel", "mclose", "mpunct"], eee = {
  display: Je.DISPLAY,
  text: Je.TEXT,
  script: Je.SCRIPT,
  scriptscript: Je.SCRIPTSCRIPT
}, tee = {
  mord: "mord",
  mop: "mop",
  mbin: "mbin",
  mrel: "mrel",
  mopen: "mopen",
  mclose: "mclose",
  mpunct: "mpunct",
  minner: "minner"
}, yA = function(e, A, n, s) {
  s === void 0 && (s = [null, null]);
  for (var r = [], i = 0; i < e.length; i++) {
    var o = Ft(e[i], A);
    if (o instanceof ph) {
      var a = o.children;
      r.push(...a);
    } else
      r.push(o);
  }
  if (O.tryCombineChars(r), !n)
    return r;
  var c = A;
  if (e.length === 1) {
    var l = e[0];
    l.type === "sizing" ? c = A.havingSize(l.size) : l.type === "styling" && (c = A.havingStyle(eee[l.style]));
  }
  var B = Ji([s[0] || "leftmost"], [], A), g = Ji([s[1] || "rightmost"], [], A), h = n === "root";
  return HF(r, (u, d) => {
    var w = d.classes[0], Q = u.classes[0];
    w === "mbin" && $$.includes(Q) ? d.classes[0] = "mord" : Q === "mbin" && _$.includes(w) && (u.classes[0] = "mord");
  }, {
    node: B
  }, g, h), HF(r, (u, d) => {
    var w = xE(d), Q = xE(u), p = w && Q ? u.hasClass("mtight") ? q$[w][Q] : Z$[w][Q] : null;
    if (p)
      return O.makeGlue(p, c);
  }, {
    node: B
  }, g, h), r;
}, HF = function t(e, A, n, s, r) {
  s && e.push(s);
  for (var i = 0; i < e.length; i++) {
    var o = e[i], a = Hb(o);
    if (a) {
      t(a.children, A, n, null, r);
      continue;
    }
    var c = !o.hasClass("mspace");
    if (c) {
      var l = A(o, n.node);
      l && (n.insertAfter ? n.insertAfter(l) : (e.unshift(l), i++));
    }
    c ? n.node = o : r && o.hasClass("newline") && (n.node = Ji(["leftmost"])), n.insertAfter = /* @__PURE__ */ ((B) => (g) => {
      e.splice(B + 1, 0, g), i++;
    })(i);
  }
  s && e.pop();
}, Hb = function(e) {
  return e instanceof ph || e instanceof lm || e instanceof mh && e.hasClass("enclosing") ? e : null;
}, Aee = function t(e, A) {
  var n = Hb(e);
  if (n) {
    var s = n.children;
    if (s.length) {
      if (A === "right")
        return t(s[s.length - 1], "right");
      if (A === "left")
        return t(s[0], "left");
    }
  }
  return e;
}, xE = function(e, A) {
  return e ? (A && (e = Aee(e, A)), tee[e.classes[0]] || null) : null;
}, Zg = function(e, A) {
  var n = ["nulldelimiter"].concat(e.baseSizingClasses());
  return Ji(A.concat(n));
}, Ft = function(e, A, n) {
  if (!e)
    return Ji();
  if (Td[e.type]) {
    var s = Td[e.type](e, A);
    if (n && A.size !== n.size) {
      s = Ji(A.sizingClasses(n), [s], A);
      var r = A.sizeMultiplier / n.sizeMultiplier;
      s.height *= r, s.depth *= r;
    }
    return s;
  } else
    throw new de("Got group of unknown type: '" + e.type + "'");
};
function y0(t, e) {
  var A = Ji(["base"], t, e), n = Ji(["strut"]);
  return n.style.height = Ie(A.height + A.depth), A.depth && (n.style.verticalAlign = Ie(-A.depth)), A.children.unshift(n), A;
}
function GE(t, e) {
  var A = null;
  t.length === 1 && t[0].type === "tag" && (A = t[0].tag, t = t[0].body);
  var n = yA(t, e, "root"), s;
  n.length === 2 && n[1].hasClass("tag") && (s = n.pop());
  for (var r = [], i = [], o = 0; o < n.length; o++)
    if (i.push(n[o]), n[o].hasClass("mbin") || n[o].hasClass("mrel") || n[o].hasClass("allowbreak")) {
      for (var a = !1; o < n.length - 1 && n[o + 1].hasClass("mspace") && !n[o + 1].hasClass("newline"); )
        o++, i.push(n[o]), n[o].hasClass("nobreak") && (a = !0);
      a || (r.push(y0(i, e)), i = []);
    } else n[o].hasClass("newline") && (i.pop(), i.length > 0 && (r.push(y0(i, e)), i = []), r.push(n[o]));
  i.length > 0 && r.push(y0(i, e));
  var c;
  A ? (c = y0(yA(A, e, !0)), c.classes = ["tag"], r.push(c)) : s && r.push(s);
  var l = Ji(["katex-html"], r);
  if (l.setAttribute("aria-hidden", "true"), c) {
    var B = c.children[0];
    B.style.height = Ie(l.height + l.depth), l.depth && (B.style.verticalAlign = Ie(-l.depth));
  }
  return l;
}
function kb(t) {
  return new ph(t);
}
class Bs {
  constructor(e, A, n) {
    this.type = void 0, this.attributes = void 0, this.children = void 0, this.classes = void 0, this.type = e, this.attributes = {}, this.children = A || [], this.classes = n || [];
  }
  /**
   * Sets an attribute on a MathML node. MathML depends on attributes to convey a
   * semantic content, so this is used heavily.
   */
  setAttribute(e, A) {
    this.attributes[e] = A;
  }
  /**
   * Gets an attribute on a MathML node.
   */
  getAttribute(e) {
    return this.attributes[e];
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    var e = document.createElementNS("http://www.w3.org/1998/Math/MathML", this.type);
    for (var A in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, A) && e.setAttribute(A, this.attributes[A]);
    this.classes.length > 0 && (e.className = na(this.classes));
    for (var n = 0; n < this.children.length; n++)
      if (this.children[n] instanceof xr && this.children[n + 1] instanceof xr) {
        for (var s = this.children[n].toText() + this.children[++n].toText(); this.children[n + 1] instanceof xr; )
          s += this.children[++n].toText();
        e.appendChild(new xr(s).toNode());
      } else
        e.appendChild(this.children[n].toNode());
    return e;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    var e = "<" + this.type;
    for (var A in this.attributes)
      Object.prototype.hasOwnProperty.call(this.attributes, A) && (e += " " + A + '="', e += Dt.escape(this.attributes[A]), e += '"');
    this.classes.length > 0 && (e += ' class ="' + Dt.escape(na(this.classes)) + '"'), e += ">";
    for (var n = 0; n < this.children.length; n++)
      e += this.children[n].toMarkup();
    return e += "</" + this.type + ">", e;
  }
  /**
   * Converts the math node into a string, similar to innerText, but escaped.
   */
  toText() {
    return this.children.map((e) => e.toText()).join("");
  }
}
class xr {
  constructor(e) {
    this.text = void 0, this.text = e;
  }
  /**
   * Converts the text node into a DOM text node.
   */
  toNode() {
    return document.createTextNode(this.text);
  }
  /**
   * Converts the text node into escaped HTML markup
   * (representing the text itself).
   */
  toMarkup() {
    return Dt.escape(this.toText());
  }
  /**
   * Converts the text node into a string
   * (representing the text itself).
   */
  toText() {
    return this.text;
  }
}
class nee {
  /**
   * Create a Space node with width given in CSS ems.
   */
  constructor(e) {
    this.width = void 0, this.character = void 0, this.width = e, e >= 0.05555 && e <= 0.05556 ? this.character = " " : e >= 0.1666 && e <= 0.1667 ? this.character = " " : e >= 0.2222 && e <= 0.2223 ? this.character = " " : e >= 0.2777 && e <= 0.2778 ? this.character = "  " : e >= -0.05556 && e <= -0.05555 ? this.character = " ⁣" : e >= -0.1667 && e <= -0.1666 ? this.character = " ⁣" : e >= -0.2223 && e <= -0.2222 ? this.character = " ⁣" : e >= -0.2778 && e <= -0.2777 ? this.character = " ⁣" : this.character = null;
  }
  /**
   * Converts the math node into a MathML-namespaced DOM element.
   */
  toNode() {
    if (this.character)
      return document.createTextNode(this.character);
    var e = document.createElementNS("http://www.w3.org/1998/Math/MathML", "mspace");
    return e.setAttribute("width", Ie(this.width)), e;
  }
  /**
   * Converts the math node into an HTML markup string.
   */
  toMarkup() {
    return this.character ? "<mtext>" + this.character + "</mtext>" : '<mspace width="' + Ie(this.width) + '"/>';
  }
  /**
   * Converts the math node into a string, similar to innerText.
   */
  toText() {
    return this.character ? this.character : " ";
  }
}
var ge = {
  MathNode: Bs,
  TextNode: xr,
  SpaceNode: nee,
  newDocumentFragment: kb
}, Ts = function(e, A, n) {
  return Ot[A][e] && Ot[A][e].replace && e.charCodeAt(0) !== 55349 && !(Gb.hasOwnProperty(e) && n && (n.fontFamily && n.fontFamily.slice(4, 6) === "tt" || n.font && n.font.slice(4, 6) === "tt")) && (e = Ot[A][e].replace), new ge.TextNode(e);
}, gm = function(e) {
  return e.length === 1 ? e[0] : new ge.MathNode("mrow", e);
}, hm = function(e, A) {
  if (A.fontFamily === "texttt")
    return "monospace";
  if (A.fontFamily === "textsf")
    return A.fontShape === "textit" && A.fontWeight === "textbf" ? "sans-serif-bold-italic" : A.fontShape === "textit" ? "sans-serif-italic" : A.fontWeight === "textbf" ? "bold-sans-serif" : "sans-serif";
  if (A.fontShape === "textit" && A.fontWeight === "textbf")
    return "bold-italic";
  if (A.fontShape === "textit")
    return "italic";
  if (A.fontWeight === "textbf")
    return "bold";
  var n = A.font;
  if (!n || n === "mathnormal")
    return null;
  var s = e.mode;
  if (n === "mathit")
    return "italic";
  if (n === "boldsymbol")
    return e.type === "textord" ? "bold" : "bold-italic";
  if (n === "mathbf")
    return "bold";
  if (n === "mathbb")
    return "double-struck";
  if (n === "mathsfit")
    return "sans-serif-italic";
  if (n === "mathfrak")
    return "fraktur";
  if (n === "mathscr" || n === "mathcal")
    return "script";
  if (n === "mathsf")
    return "sans-serif";
  if (n === "mathtt")
    return "monospace";
  var r = e.text;
  if (["\\imath", "\\jmath"].includes(r))
    return null;
  Ot[s][r] && Ot[s][r].replace && (r = Ot[s][r].replace);
  var i = O.fontMap[n].fontName;
  return cm(r, i, s) ? O.fontMap[n].variant : null;
};
function aI(t) {
  if (!t)
    return !1;
  if (t.type === "mi" && t.children.length === 1) {
    var e = t.children[0];
    return e instanceof xr && e.text === ".";
  } else if (t.type === "mo" && t.children.length === 1 && t.getAttribute("separator") === "true" && t.getAttribute("lspace") === "0em" && t.getAttribute("rspace") === "0em") {
    var A = t.children[0];
    return A instanceof xr && A.text === ",";
  } else
    return !1;
}
var es = function(e, A, n) {
  if (e.length === 1) {
    var s = Tt(e[0], A);
    return n && s instanceof Bs && s.type === "mo" && (s.setAttribute("lspace", "0em"), s.setAttribute("rspace", "0em")), [s];
  }
  for (var r = [], i, o = 0; o < e.length; o++) {
    var a = Tt(e[o], A);
    if (a instanceof Bs && i instanceof Bs) {
      if (a.type === "mtext" && i.type === "mtext" && a.getAttribute("mathvariant") === i.getAttribute("mathvariant")) {
        i.children.push(...a.children);
        continue;
      } else if (a.type === "mn" && i.type === "mn") {
        i.children.push(...a.children);
        continue;
      } else if (aI(a) && i.type === "mn") {
        i.children.push(...a.children);
        continue;
      } else if (a.type === "mn" && aI(i))
        a.children = [...i.children, ...a.children], r.pop();
      else if ((a.type === "msup" || a.type === "msub") && a.children.length >= 1 && (i.type === "mn" || aI(i))) {
        var c = a.children[0];
        c instanceof Bs && c.type === "mn" && (c.children = [...i.children, ...c.children], r.pop());
      } else if (i.type === "mi" && i.children.length === 1) {
        var l = i.children[0];
        if (l instanceof xr && l.text === "̸" && (a.type === "mo" || a.type === "mi" || a.type === "mn")) {
          var B = a.children[0];
          B instanceof xr && B.text.length > 0 && (B.text = B.text.slice(0, 1) + "̸" + B.text.slice(1), r.pop());
        }
      }
    }
    r.push(a), i = a;
  }
  return r;
}, ra = function(e, A, n) {
  return gm(es(e, A, n));
}, Tt = function(e, A) {
  if (!e)
    return new ge.MathNode("mrow");
  if (Jd[e.type]) {
    var n = Jd[e.type](e, A);
    return n;
  } else
    throw new de("Got group of unknown type: '" + e.type + "'");
};
function kF(t, e, A, n, s) {
  var r = es(t, A), i;
  r.length === 1 && r[0] instanceof Bs && ["mrow", "mtable"].includes(r[0].type) ? i = r[0] : i = new ge.MathNode("mrow", r);
  var o = new ge.MathNode("annotation", [new ge.TextNode(e)]);
  o.setAttribute("encoding", "application/x-tex");
  var a = new ge.MathNode("semantics", [i, o]), c = new ge.MathNode("math", [a]);
  c.setAttribute("xmlns", "http://www.w3.org/1998/Math/MathML"), n && c.setAttribute("display", "block");
  var l = s ? "katex" : "katex-mathml";
  return O.makeSpan([l], [c]);
}
var Rb = function(e) {
  return new Mi({
    style: e.displayMode ? Je.DISPLAY : Je.TEXT,
    maxSize: e.maxSize,
    minRuleThickness: e.minRuleThickness
  });
}, Lb = function(e, A) {
  if (A.displayMode) {
    var n = ["katex-display"];
    A.leqno && n.push("leqno"), A.fleqn && n.push("fleqn"), e = O.makeSpan(n, [e]);
  }
  return e;
}, see = function(e, A, n) {
  var s = Rb(n), r;
  if (n.output === "mathml")
    return kF(e, A, s, n.displayMode, !0);
  if (n.output === "html") {
    var i = GE(e, s);
    r = O.makeSpan(["katex"], [i]);
  } else {
    var o = kF(e, A, s, n.displayMode, !1), a = GE(e, s);
    r = O.makeSpan(["katex"], [o, a]);
  }
  return Lb(r, n);
}, ree = function(e, A, n) {
  var s = Rb(n), r = GE(e, s), i = O.makeSpan(["katex"], [r]);
  return Lb(i, n);
}, iee = {
  widehat: "^",
  widecheck: "ˇ",
  widetilde: "~",
  utilde: "~",
  overleftarrow: "←",
  underleftarrow: "←",
  xleftarrow: "←",
  overrightarrow: "→",
  underrightarrow: "→",
  xrightarrow: "→",
  underbrace: "⏟",
  overbrace: "⏞",
  overgroup: "⏠",
  undergroup: "⏡",
  overleftrightarrow: "↔",
  underleftrightarrow: "↔",
  xleftrightarrow: "↔",
  Overrightarrow: "⇒",
  xRightarrow: "⇒",
  overleftharpoon: "↼",
  xleftharpoonup: "↼",
  overrightharpoon: "⇀",
  xrightharpoonup: "⇀",
  xLeftarrow: "⇐",
  xLeftrightarrow: "⇔",
  xhookleftarrow: "↩",
  xhookrightarrow: "↪",
  xmapsto: "↦",
  xrightharpoondown: "⇁",
  xleftharpoondown: "↽",
  xrightleftharpoons: "⇌",
  xleftrightharpoons: "⇋",
  xtwoheadleftarrow: "↞",
  xtwoheadrightarrow: "↠",
  xlongequal: "=",
  xtofrom: "⇄",
  xrightleftarrows: "⇄",
  xrightequilibrium: "⇌",
  // Not a perfect match.
  xleftequilibrium: "⇋",
  // None better available.
  "\\cdrightarrow": "→",
  "\\cdleftarrow": "←",
  "\\cdlongequal": "="
}, oee = function(e) {
  var A = new ge.MathNode("mo", [new ge.TextNode(iee[e.replace(/^\\/, "")])]);
  return A.setAttribute("stretchy", "true"), A;
}, aee = {
  //   path(s), minWidth, height, align
  overrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  overleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  underrightarrow: [["rightarrow"], 0.888, 522, "xMaxYMin"],
  underleftarrow: [["leftarrow"], 0.888, 522, "xMinYMin"],
  xrightarrow: [["rightarrow"], 1.469, 522, "xMaxYMin"],
  "\\cdrightarrow": [["rightarrow"], 3, 522, "xMaxYMin"],
  // CD minwwidth2.5pc
  xleftarrow: [["leftarrow"], 1.469, 522, "xMinYMin"],
  "\\cdleftarrow": [["leftarrow"], 3, 522, "xMinYMin"],
  Overrightarrow: [["doublerightarrow"], 0.888, 560, "xMaxYMin"],
  xRightarrow: [["doublerightarrow"], 1.526, 560, "xMaxYMin"],
  xLeftarrow: [["doubleleftarrow"], 1.526, 560, "xMinYMin"],
  overleftharpoon: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoonup: [["leftharpoon"], 0.888, 522, "xMinYMin"],
  xleftharpoondown: [["leftharpoondown"], 0.888, 522, "xMinYMin"],
  overrightharpoon: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoonup: [["rightharpoon"], 0.888, 522, "xMaxYMin"],
  xrightharpoondown: [["rightharpoondown"], 0.888, 522, "xMaxYMin"],
  xlongequal: [["longequal"], 0.888, 334, "xMinYMin"],
  "\\cdlongequal": [["longequal"], 3, 334, "xMinYMin"],
  xtwoheadleftarrow: [["twoheadleftarrow"], 0.888, 334, "xMinYMin"],
  xtwoheadrightarrow: [["twoheadrightarrow"], 0.888, 334, "xMaxYMin"],
  overleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  overbrace: [["leftbrace", "midbrace", "rightbrace"], 1.6, 548],
  underbrace: [["leftbraceunder", "midbraceunder", "rightbraceunder"], 1.6, 548],
  underleftrightarrow: [["leftarrow", "rightarrow"], 0.888, 522],
  xleftrightarrow: [["leftarrow", "rightarrow"], 1.75, 522],
  xLeftrightarrow: [["doubleleftarrow", "doublerightarrow"], 1.75, 560],
  xrightleftharpoons: [["leftharpoondownplus", "rightharpoonplus"], 1.75, 716],
  xleftrightharpoons: [["leftharpoonplus", "rightharpoondownplus"], 1.75, 716],
  xhookleftarrow: [["leftarrow", "righthook"], 1.08, 522],
  xhookrightarrow: [["lefthook", "rightarrow"], 1.08, 522],
  overlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  underlinesegment: [["leftlinesegment", "rightlinesegment"], 0.888, 522],
  overgroup: [["leftgroup", "rightgroup"], 0.888, 342],
  undergroup: [["leftgroupunder", "rightgroupunder"], 0.888, 342],
  xmapsto: [["leftmapsto", "rightarrow"], 1.5, 522],
  xtofrom: [["leftToFrom", "rightToFrom"], 1.75, 528],
  // The next three arrows are from the mhchem package.
  // In mhchem.sty, min-length is 2.0em. But these arrows might appear in the
  // document as \xrightarrow or \xrightleftharpoons. Those have
  // min-length = 1.75em, so we set min-length on these next three to match.
  xrightleftarrows: [["baraboveleftarrow", "rightarrowabovebar"], 1.75, 901],
  xrightequilibrium: [["baraboveshortleftharpoon", "rightharpoonaboveshortbar"], 1.75, 716],
  xleftequilibrium: [["shortbaraboveleftharpoon", "shortrightharpoonabovebar"], 1.75, 716]
}, cee = function(e) {
  return e.type === "ordgroup" ? e.body.length : 1;
}, lee = function(e, A) {
  function n() {
    var o = 4e5, a = e.label.slice(1);
    if (["widehat", "widecheck", "widetilde", "utilde"].includes(a)) {
      var c = e, l = cee(c.base), B, g, h;
      if (l > 5)
        a === "widehat" || a === "widecheck" ? (B = 420, o = 2364, h = 0.42, g = a + "4") : (B = 312, o = 2340, h = 0.34, g = "tilde4");
      else {
        var u = [1, 1, 2, 2, 3, 3][l];
        a === "widehat" || a === "widecheck" ? (o = [0, 1062, 2364, 2364, 2364][u], B = [0, 239, 300, 360, 420][u], h = [0, 0.24, 0.3, 0.3, 0.36, 0.42][u], g = a + u) : (o = [0, 600, 1033, 2339, 2340][u], B = [0, 260, 286, 306, 312][u], h = [0, 0.26, 0.286, 0.3, 0.306, 0.34][u], g = "tilde" + u);
      }
      var d = new sa(g), w = new Ti([d], {
        width: "100%",
        height: Ie(h),
        viewBox: "0 0 " + o + " " + B,
        preserveAspectRatio: "none"
      });
      return {
        span: O.makeSvgSpan([], [w], A),
        minWidth: 0,
        height: h
      };
    } else {
      var Q = [], p = aee[a], [M, I, N] = p, m = N / 1e3, E = M.length, G, Y;
      if (E === 1) {
        var U = p[3];
        G = ["hide-tail"], Y = [U];
      } else if (E === 2)
        G = ["halfarrow-left", "halfarrow-right"], Y = ["xMinYMin", "xMaxYMin"];
      else if (E === 3)
        G = ["brace-left", "brace-center", "brace-right"], Y = ["xMinYMin", "xMidYMin", "xMaxYMin"];
      else
        throw new Error(`Correct katexImagesData or update code here to support
                    ` + E + " children.");
      for (var v = 0; v < E; v++) {
        var b = new sa(M[v]), W = new Ti([b], {
          width: "400em",
          height: Ie(m),
          viewBox: "0 0 " + o + " " + N,
          preserveAspectRatio: Y[v] + " slice"
        }), q = O.makeSvgSpan([G[v]], [W], A);
        if (E === 1)
          return {
            span: q,
            minWidth: I,
            height: m
          };
        q.style.height = Ie(m), Q.push(q);
      }
      return {
        span: O.makeSpan(["stretchy"], Q, A),
        minWidth: I,
        height: m
      };
    }
  }
  var {
    span: s,
    minWidth: r,
    height: i
  } = n();
  return s.height = i, s.style.height = Ie(i), r > 0 && (s.style.minWidth = Ie(r)), s;
}, Bee = function(e, A, n, s, r) {
  var i, o = e.height + e.depth + n + s;
  if (/fbox|color|angl/.test(A)) {
    if (i = O.makeSpan(["stretchy", A], [], r), A === "fbox") {
      var a = r.color && r.getColor();
      a && (i.style.borderColor = a);
    }
  } else {
    var c = [];
    /^[bx]cancel$/.test(A) && c.push(new NE({
      x1: "0",
      y1: "0",
      x2: "100%",
      y2: "100%",
      "stroke-width": "0.046em"
    })), /^x?cancel$/.test(A) && c.push(new NE({
      x1: "0",
      y1: "100%",
      x2: "100%",
      y2: "0",
      "stroke-width": "0.046em"
    }));
    var l = new Ti(c, {
      width: "100%",
      height: Ie(o)
    });
    i = O.makeSvgSpan([], [l], r);
  }
  return i.height = o, i.style.height = Ie(o), i;
}, Wi = {
  encloseSpan: Bee,
  mathMLnode: oee,
  svgSpan: lee
};
function it(t, e) {
  if (!t || t.type !== e)
    throw new Error("Expected node of type " + e + ", but got " + (t ? "node of type " + t.type : String(t)));
  return t;
}
function um(t) {
  var e = Af(t);
  if (!e)
    throw new Error("Expected node of symbol group type, but got " + (t ? "node of type " + t.type : String(t)));
  return e;
}
function Af(t) {
  return t && (t.type === "atom" || j$.hasOwnProperty(t.type)) ? t : null;
}
var dm = (t, e) => {
  var A, n, s;
  t && t.type === "supsub" ? (n = it(t.base, "accent"), A = n.base, t.base = A, s = b$(Ft(t, e)), t.base = n) : (n = it(t, "accent"), A = n.base);
  var r = Ft(A, e.havingCrampedStyle()), i = n.isShifty && Dt.isCharacterBox(A), o = 0;
  if (i) {
    var a = Dt.getBaseElem(A), c = Ft(a, e.havingCrampedStyle());
    o = GF(c).skew;
  }
  var l = n.label === "\\c", B = l ? r.height + r.depth : Math.min(r.height, e.fontMetrics().xHeight), g;
  if (n.isStretchy)
    g = Wi.svgSpan(n, e), g = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: r
      }, {
        type: "elem",
        elem: g,
        wrapperClasses: ["svg-align"],
        wrapperStyle: o > 0 ? {
          width: "calc(100% - " + Ie(2 * o) + ")",
          marginLeft: Ie(2 * o)
        } : void 0
      }]
    }, e);
  else {
    var h, u;
    n.label === "\\vec" ? (h = O.staticSvg("vec", e), u = O.svgData.vec[1]) : (h = O.makeOrd({
      mode: n.mode,
      text: n.label
    }, e, "textord"), h = GF(h), h.italic = 0, u = h.width, l && (B += h.depth)), g = O.makeSpan(["accent-body"], [h]);
    var d = n.label === "\\textcircled";
    d && (g.classes.push("accent-full"), B = r.height);
    var w = o;
    d || (w -= u / 2), g.style.left = Ie(w), n.label === "\\textcircled" && (g.style.top = ".2em"), g = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: r
      }, {
        type: "kern",
        size: -B
      }, {
        type: "elem",
        elem: g
      }]
    }, e);
  }
  var Q = O.makeSpan(["mord", "accent"], [g], e);
  return s ? (s.children[0] = Q, s.height = Math.max(Q.height, s.height), s.classes[0] = "mord", s) : Q;
}, Sb = (t, e) => {
  var A = t.isStretchy ? Wi.mathMLnode(t.label) : new ge.MathNode("mo", [Ts(t.label, t.mode)]), n = new ge.MathNode("mover", [Tt(t.base, e), A]);
  return n.setAttribute("accent", "true"), n;
}, gee = new RegExp(["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring"].map((t) => "\\" + t).join("|"));
Ye({
  type: "accent",
  names: ["\\acute", "\\grave", "\\ddot", "\\tilde", "\\bar", "\\breve", "\\check", "\\hat", "\\vec", "\\dot", "\\mathring", "\\widecheck", "\\widehat", "\\widetilde", "\\overrightarrow", "\\overleftarrow", "\\Overrightarrow", "\\overleftrightarrow", "\\overgroup", "\\overlinesegment", "\\overleftharpoon", "\\overrightharpoon"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var A = Wd(e[0]), n = !gee.test(t.funcName), s = !n || t.funcName === "\\widehat" || t.funcName === "\\widetilde" || t.funcName === "\\widecheck";
    return {
      type: "accent",
      mode: t.parser.mode,
      label: t.funcName,
      isStretchy: n,
      isShifty: s,
      base: A
    };
  },
  htmlBuilder: dm,
  mathmlBuilder: Sb
});
Ye({
  type: "accent",
  names: ["\\'", "\\`", "\\^", "\\~", "\\=", "\\u", "\\.", '\\"', "\\c", "\\r", "\\H", "\\v", "\\textcircled"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    // unless in strict mode
    argTypes: ["primitive"]
  },
  handler: (t, e) => {
    var A = e[0], n = t.parser.mode;
    return n === "math" && (t.parser.settings.reportNonstrict("mathVsTextAccents", "LaTeX's accent " + t.funcName + " works only in text mode"), n = "text"), {
      type: "accent",
      mode: n,
      label: t.funcName,
      isStretchy: !1,
      isShifty: !0,
      base: A
    };
  },
  htmlBuilder: dm,
  mathmlBuilder: Sb
});
Ye({
  type: "accentUnder",
  names: ["\\underleftarrow", "\\underrightarrow", "\\underleftrightarrow", "\\undergroup", "\\underlinesegment", "\\utilde"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    return {
      type: "accentUnder",
      mode: A.mode,
      label: n,
      base: s
    };
  },
  htmlBuilder: (t, e) => {
    var A = Ft(t.base, e), n = Wi.svgSpan(t, e), s = t.label === "\\utilde" ? 0.12 : 0, r = O.makeVList({
      positionType: "top",
      positionData: A.height,
      children: [{
        type: "elem",
        elem: n,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: s
      }, {
        type: "elem",
        elem: A
      }]
    }, e);
    return O.makeSpan(["mord", "accentunder"], [r], e);
  },
  mathmlBuilder: (t, e) => {
    var A = Wi.mathMLnode(t.label), n = new ge.MathNode("munder", [Tt(t.base, e), A]);
    return n.setAttribute("accentunder", "true"), n;
  }
});
var F0 = (t) => {
  var e = new ge.MathNode("mpadded", t ? [t] : []);
  return e.setAttribute("width", "+0.6em"), e.setAttribute("lspace", "0.3em"), e;
};
Ye({
  type: "xArrow",
  names: [
    "\\xleftarrow",
    "\\xrightarrow",
    "\\xLeftarrow",
    "\\xRightarrow",
    "\\xleftrightarrow",
    "\\xLeftrightarrow",
    "\\xhookleftarrow",
    "\\xhookrightarrow",
    "\\xmapsto",
    "\\xrightharpoondown",
    "\\xrightharpoonup",
    "\\xleftharpoondown",
    "\\xleftharpoonup",
    "\\xrightleftharpoons",
    "\\xleftrightharpoons",
    "\\xlongequal",
    "\\xtwoheadrightarrow",
    "\\xtwoheadleftarrow",
    "\\xtofrom",
    // The next 3 functions are here to support the mhchem extension.
    // Direct use of these functions is discouraged and may break someday.
    "\\xrightleftarrows",
    "\\xrightequilibrium",
    "\\xleftequilibrium",
    // The next 3 functions are here only to support the {CD} environment.
    "\\\\cdrightarrow",
    "\\\\cdleftarrow",
    "\\\\cdlongequal"
  ],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(t, e, A) {
    var {
      parser: n,
      funcName: s
    } = t;
    return {
      type: "xArrow",
      mode: n.mode,
      label: s,
      body: e[0],
      below: A[0]
    };
  },
  // Flow is unable to correctly infer the type of `group`, even though it's
  // unambiguously determined from the passed-in `type` above.
  htmlBuilder(t, e) {
    var A = e.style, n = e.havingStyle(A.sup()), s = O.wrapFragment(Ft(t.body, n, e), e), r = t.label.slice(0, 2) === "\\x" ? "x" : "cd";
    s.classes.push(r + "-arrow-pad");
    var i;
    t.below && (n = e.havingStyle(A.sub()), i = O.wrapFragment(Ft(t.below, n, e), e), i.classes.push(r + "-arrow-pad"));
    var o = Wi.svgSpan(t, e), a = -e.fontMetrics().axisHeight + 0.5 * o.height, c = -e.fontMetrics().axisHeight - 0.5 * o.height - 0.111;
    (s.depth > 0.25 || t.label === "\\xleftequilibrium") && (c -= s.depth);
    var l;
    if (i) {
      var B = -e.fontMetrics().axisHeight + i.height + 0.5 * o.height + 0.111;
      l = O.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: s,
          shift: c
        }, {
          type: "elem",
          elem: o,
          shift: a
        }, {
          type: "elem",
          elem: i,
          shift: B
        }]
      }, e);
    } else
      l = O.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: s,
          shift: c
        }, {
          type: "elem",
          elem: o,
          shift: a
        }]
      }, e);
    return l.children[0].children[0].children[1].classes.push("svg-align"), O.makeSpan(["mrel", "x-arrow"], [l], e);
  },
  mathmlBuilder(t, e) {
    var A = Wi.mathMLnode(t.label);
    A.setAttribute("minsize", t.label.charAt(0) === "x" ? "1.75em" : "3.0em");
    var n;
    if (t.body) {
      var s = F0(Tt(t.body, e));
      if (t.below) {
        var r = F0(Tt(t.below, e));
        n = new ge.MathNode("munderover", [A, r, s]);
      } else
        n = new ge.MathNode("mover", [A, s]);
    } else if (t.below) {
      var i = F0(Tt(t.below, e));
      n = new ge.MathNode("munder", [A, i]);
    } else
      n = F0(), n = new ge.MathNode("mover", [A, n]);
    return n;
  }
});
var hee = O.makeSpan;
function Tb(t, e) {
  var A = yA(t.body, e, !0);
  return hee([t.mclass], A, e);
}
function Jb(t, e) {
  var A, n = es(t.body, e);
  return t.mclass === "minner" ? A = new ge.MathNode("mpadded", n) : t.mclass === "mord" ? t.isCharacterBox ? (A = n[0], A.type = "mi") : A = new ge.MathNode("mi", n) : (t.isCharacterBox ? (A = n[0], A.type = "mo") : A = new ge.MathNode("mo", n), t.mclass === "mbin" ? (A.attributes.lspace = "0.22em", A.attributes.rspace = "0.22em") : t.mclass === "mpunct" ? (A.attributes.lspace = "0em", A.attributes.rspace = "0.17em") : t.mclass === "mopen" || t.mclass === "mclose" ? (A.attributes.lspace = "0em", A.attributes.rspace = "0em") : t.mclass === "minner" && (A.attributes.lspace = "0.0556em", A.attributes.width = "+0.1111em")), A;
}
Ye({
  type: "mclass",
  names: ["\\mathord", "\\mathbin", "\\mathrel", "\\mathopen", "\\mathclose", "\\mathpunct", "\\mathinner"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    return {
      type: "mclass",
      mode: A.mode,
      mclass: "m" + n.slice(5),
      // TODO(kevinb): don't prefix with 'm'
      body: dA(s),
      isCharacterBox: Dt.isCharacterBox(s)
    };
  },
  htmlBuilder: Tb,
  mathmlBuilder: Jb
});
var nf = (t) => {
  var e = t.type === "ordgroup" && t.body.length ? t.body[0] : t;
  return e.type === "atom" && (e.family === "bin" || e.family === "rel") ? "m" + e.family : "mord";
};
Ye({
  type: "mclass",
  names: ["\\@binrel"],
  props: {
    numArgs: 2
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "mclass",
      mode: A.mode,
      mclass: nf(e[0]),
      body: dA(e[1]),
      isCharacterBox: Dt.isCharacterBox(e[1])
    };
  }
});
Ye({
  type: "mclass",
  names: ["\\stackrel", "\\overset", "\\underset"],
  props: {
    numArgs: 2
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t, s = e[1], r = e[0], i;
    n !== "\\stackrel" ? i = nf(s) : i = "mrel";
    var o = {
      type: "op",
      mode: s.mode,
      limits: !0,
      alwaysHandleSupSub: !0,
      parentIsSupSub: !1,
      symbol: !1,
      suppressBaseShift: n !== "\\stackrel",
      body: dA(s)
    }, a = {
      type: "supsub",
      mode: r.mode,
      base: o,
      sup: n === "\\underset" ? null : r,
      sub: n === "\\underset" ? r : null
    };
    return {
      type: "mclass",
      mode: A.mode,
      mclass: i,
      body: [a],
      isCharacterBox: Dt.isCharacterBox(a)
    };
  },
  htmlBuilder: Tb,
  mathmlBuilder: Jb
});
Ye({
  type: "pmb",
  names: ["\\pmb"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "pmb",
      mode: A.mode,
      mclass: nf(e[0]),
      body: dA(e[0])
    };
  },
  htmlBuilder(t, e) {
    var A = yA(t.body, e, !0), n = O.makeSpan([t.mclass], A, e);
    return n.style.textShadow = "0.02em 0.01em 0.04px", n;
  },
  mathmlBuilder(t, e) {
    var A = es(t.body, e), n = new ge.MathNode("mstyle", A);
    return n.setAttribute("style", "text-shadow: 0.02em 0.01em 0.04px"), n;
  }
});
var uee = {
  ">": "\\\\cdrightarrow",
  "<": "\\\\cdleftarrow",
  "=": "\\\\cdlongequal",
  A: "\\uparrow",
  V: "\\downarrow",
  "|": "\\Vert",
  ".": "no arrow"
}, RF = () => ({
  type: "styling",
  body: [],
  mode: "math",
  style: "display"
}), LF = (t) => t.type === "textord" && t.text === "@", dee = (t, e) => (t.type === "mathord" || t.type === "atom") && t.text === e;
function wee(t, e, A) {
  var n = uee[t];
  switch (n) {
    case "\\\\cdrightarrow":
    case "\\\\cdleftarrow":
      return A.callFunction(n, [e[0]], [e[1]]);
    case "\\uparrow":
    case "\\downarrow": {
      var s = A.callFunction("\\\\cdleft", [e[0]], []), r = {
        type: "atom",
        text: n,
        mode: "math",
        family: "rel"
      }, i = A.callFunction("\\Big", [r], []), o = A.callFunction("\\\\cdright", [e[1]], []), a = {
        type: "ordgroup",
        mode: "math",
        body: [s, i, o]
      };
      return A.callFunction("\\\\cdparent", [a], []);
    }
    case "\\\\cdlongequal":
      return A.callFunction("\\\\cdlongequal", [], []);
    case "\\Vert": {
      var c = {
        type: "textord",
        text: "\\Vert",
        mode: "math"
      };
      return A.callFunction("\\Big", [c], []);
    }
    default:
      return {
        type: "textord",
        text: " ",
        mode: "math"
      };
  }
}
function fee(t) {
  var e = [];
  for (t.gullet.beginGroup(), t.gullet.macros.set("\\cr", "\\\\\\relax"), t.gullet.beginGroup(); ; ) {
    e.push(t.parseExpression(!1, "\\\\")), t.gullet.endGroup(), t.gullet.beginGroup();
    var A = t.fetch().text;
    if (A === "&" || A === "\\\\")
      t.consume();
    else if (A === "\\end") {
      e[e.length - 1].length === 0 && e.pop();
      break;
    } else
      throw new de("Expected \\\\ or \\cr or \\end", t.nextToken);
  }
  for (var n = [], s = [n], r = 0; r < e.length; r++) {
    for (var i = e[r], o = RF(), a = 0; a < i.length; a++)
      if (!LF(i[a]))
        o.body.push(i[a]);
      else {
        n.push(o), a += 1;
        var c = um(i[a]).text, l = new Array(2);
        if (l[0] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, l[1] = {
          type: "ordgroup",
          mode: "math",
          body: []
        }, !("=|.".indexOf(c) > -1)) if ("<>AV".indexOf(c) > -1)
          for (var B = 0; B < 2; B++) {
            for (var g = !0, h = a + 1; h < i.length; h++) {
              if (dee(i[h], c)) {
                g = !1, a = h;
                break;
              }
              if (LF(i[h]))
                throw new de("Missing a " + c + " character to complete a CD arrow.", i[h]);
              l[B].body.push(i[h]);
            }
            if (g)
              throw new de("Missing a " + c + " character to complete a CD arrow.", i[a]);
          }
        else
          throw new de('Expected one of "<>AV=|." after @', i[a]);
        var u = wee(c, l, t), d = {
          type: "styling",
          body: [u],
          mode: "math",
          style: "display"
          // CD is always displaystyle.
        };
        n.push(d), o = RF();
      }
    r % 2 === 0 ? n.push(o) : n.shift(), n = [], s.push(n);
  }
  t.gullet.endGroup(), t.gullet.endGroup();
  var w = new Array(s[0].length).fill({
    type: "align",
    align: "c",
    pregap: 0.25,
    // CD package sets \enskip between columns.
    postgap: 0.25
    // So pre and post each get half an \enskip, i.e. 0.25em.
  });
  return {
    type: "array",
    mode: "math",
    body: s,
    arraystretch: 1,
    addJot: !0,
    rowGaps: [null],
    cols: w,
    colSeparationType: "CD",
    hLinesBeforeRow: new Array(s.length + 1).fill([])
  };
}
Ye({
  type: "cdlabel",
  names: ["\\\\cdleft", "\\\\cdright"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t;
    return {
      type: "cdlabel",
      mode: A.mode,
      side: n.slice(4),
      label: e[0]
    };
  },
  htmlBuilder(t, e) {
    var A = e.havingStyle(e.style.sup()), n = O.wrapFragment(Ft(t.label, A, e), e);
    return n.classes.push("cd-label-" + t.side), n.style.bottom = Ie(0.8 - n.depth), n.height = 0, n.depth = 0, n;
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mrow", [Tt(t.label, e)]);
    return A = new ge.MathNode("mpadded", [A]), A.setAttribute("width", "0"), t.side === "left" && A.setAttribute("lspace", "-1width"), A.setAttribute("voffset", "0.7em"), A = new ge.MathNode("mstyle", [A]), A.setAttribute("displaystyle", "false"), A.setAttribute("scriptlevel", "1"), A;
  }
});
Ye({
  type: "cdlabelparent",
  names: ["\\\\cdparent"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "cdlabelparent",
      mode: A.mode,
      fragment: e[0]
    };
  },
  htmlBuilder(t, e) {
    var A = O.wrapFragment(Ft(t.fragment, e), e);
    return A.classes.push("cd-vert-arrow"), A;
  },
  mathmlBuilder(t, e) {
    return new ge.MathNode("mrow", [Tt(t.fragment, e)]);
  }
});
Ye({
  type: "textord",
  names: ["\\@char"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(t, e) {
    for (var {
      parser: A
    } = t, n = it(e[0], "ordgroup"), s = n.body, r = "", i = 0; i < s.length; i++) {
      var o = it(s[i], "textord");
      r += o.text;
    }
    var a = parseInt(r), c;
    if (isNaN(a))
      throw new de("\\@char has non-numeric argument " + r);
    if (a < 0 || a >= 1114111)
      throw new de("\\@char with invalid code point " + r);
    return a <= 65535 ? c = String.fromCharCode(a) : (a -= 65536, c = String.fromCharCode((a >> 10) + 55296, (a & 1023) + 56320)), {
      type: "textord",
      mode: A.mode,
      text: c
    };
  }
});
var Wb = (t, e) => {
  var A = yA(t.body, e.withColor(t.color), !1);
  return O.makeFragment(A);
}, Ob = (t, e) => {
  var A = es(t.body, e.withColor(t.color)), n = new ge.MathNode("mstyle", A);
  return n.setAttribute("mathcolor", t.color), n;
};
Ye({
  type: "color",
  names: ["\\textcolor"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "original"]
  },
  handler(t, e) {
    var {
      parser: A
    } = t, n = it(e[0], "color-token").color, s = e[1];
    return {
      type: "color",
      mode: A.mode,
      color: n,
      body: dA(s)
    };
  },
  htmlBuilder: Wb,
  mathmlBuilder: Ob
});
Ye({
  type: "color",
  names: ["\\color"],
  props: {
    numArgs: 1,
    allowedInText: !0,
    argTypes: ["color"]
  },
  handler(t, e) {
    var {
      parser: A,
      breakOnTokenText: n
    } = t, s = it(e[0], "color-token").color;
    A.gullet.macros.set("\\current@color", s);
    var r = A.parseExpression(!0, n);
    return {
      type: "color",
      mode: A.mode,
      color: s,
      body: r
    };
  },
  htmlBuilder: Wb,
  mathmlBuilder: Ob
});
Ye({
  type: "cr",
  names: ["\\\\"],
  props: {
    numArgs: 0,
    numOptionalArgs: 0,
    allowedInText: !0
  },
  handler(t, e, A) {
    var {
      parser: n
    } = t, s = n.gullet.future().text === "[" ? n.parseSizeGroup(!0) : null, r = !n.settings.displayMode || !n.settings.useStrictBehavior("newLineInDisplayMode", "In LaTeX, \\\\ or \\newline does nothing in display mode");
    return {
      type: "cr",
      mode: n.mode,
      newLine: r,
      size: s && it(s, "size").value
    };
  },
  // The following builders are called only at the top level,
  // not within tabular/array environments.
  htmlBuilder(t, e) {
    var A = O.makeSpan(["mspace"], [], e);
    return t.newLine && (A.classes.push("newline"), t.size && (A.style.marginTop = Ie(nA(t.size, e)))), A;
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mspace");
    return t.newLine && (A.setAttribute("linebreak", "newline"), t.size && A.setAttribute("height", Ie(nA(t.size, e)))), A;
  }
});
var zE = {
  "\\global": "\\global",
  "\\long": "\\\\globallong",
  "\\\\globallong": "\\\\globallong",
  "\\def": "\\gdef",
  "\\gdef": "\\gdef",
  "\\edef": "\\xdef",
  "\\xdef": "\\xdef",
  "\\let": "\\\\globallet",
  "\\futurelet": "\\\\globalfuture"
}, Pb = (t) => {
  var e = t.text;
  if (/^(?:[\\{}$&#^_]|EOF)$/.test(e))
    throw new de("Expected a control sequence", t);
  return e;
}, Qee = (t) => {
  var e = t.gullet.popToken();
  return e.text === "=" && (e = t.gullet.popToken(), e.text === " " && (e = t.gullet.popToken())), e;
}, Kb = (t, e, A, n) => {
  var s = t.gullet.macros.get(A.text);
  s == null && (A.noexpand = !0, s = {
    tokens: [A],
    numArgs: 0,
    // reproduce the same behavior in expansion
    unexpandable: !t.gullet.isExpandable(A.text)
  }), t.gullet.macros.set(e, s, n);
};
Ye({
  type: "internal",
  names: [
    "\\global",
    "\\long",
    "\\\\globallong"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t;
    e.consumeSpaces();
    var n = e.fetch();
    if (zE[n.text])
      return (A === "\\global" || A === "\\\\globallong") && (n.text = zE[n.text]), it(e.parseFunction(), "internal");
    throw new de("Invalid token after macro prefix", n);
  }
});
Ye({
  type: "internal",
  names: ["\\def", "\\gdef", "\\edef", "\\xdef"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t, n = e.gullet.popToken(), s = n.text;
    if (/^(?:[\\{}$&#^_]|EOF)$/.test(s))
      throw new de("Expected a control sequence", n);
    for (var r = 0, i, o = [[]]; e.gullet.future().text !== "{"; )
      if (n = e.gullet.popToken(), n.text === "#") {
        if (e.gullet.future().text === "{") {
          i = e.gullet.future(), o[r].push("{");
          break;
        }
        if (n = e.gullet.popToken(), !/^[1-9]$/.test(n.text))
          throw new de('Invalid argument number "' + n.text + '"');
        if (parseInt(n.text) !== r + 1)
          throw new de('Argument number "' + n.text + '" out of order');
        r++, o.push([]);
      } else {
        if (n.text === "EOF")
          throw new de("Expected a macro definition");
        o[r].push(n.text);
      }
    var {
      tokens: a
    } = e.gullet.consumeArg();
    return i && a.unshift(i), (A === "\\edef" || A === "\\xdef") && (a = e.gullet.expandTokens(a), a.reverse()), e.gullet.macros.set(s, {
      tokens: a,
      numArgs: r,
      delimiters: o
    }, A === zE[A]), {
      type: "internal",
      mode: e.mode
    };
  }
});
Ye({
  type: "internal",
  names: [
    "\\let",
    "\\\\globallet"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t, n = Pb(e.gullet.popToken());
    e.gullet.consumeSpaces();
    var s = Qee(e);
    return Kb(e, n, s, A === "\\\\globallet"), {
      type: "internal",
      mode: e.mode
    };
  }
});
Ye({
  type: "internal",
  names: [
    "\\futurelet",
    "\\\\globalfuture"
    // can’t be entered directly
  ],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t, n = Pb(e.gullet.popToken()), s = e.gullet.popToken(), r = e.gullet.popToken();
    return Kb(e, n, r, A === "\\\\globalfuture"), e.gullet.pushToken(r), e.gullet.pushToken(s), {
      type: "internal",
      mode: e.mode
    };
  }
});
var YB = function(e, A, n) {
  var s = Ot.math[e] && Ot.math[e].replace, r = cm(s || e, A, n);
  if (!r)
    throw new Error("Unsupported symbol " + e + " and font size " + A + ".");
  return r;
}, wm = function(e, A, n, s) {
  var r = n.havingBaseStyle(A), i = O.makeSpan(s.concat(r.sizingClasses(n)), [e], n), o = r.sizeMultiplier / n.sizeMultiplier;
  return i.height *= o, i.depth *= o, i.maxFontSize = r.sizeMultiplier, i;
}, Vb = function(e, A, n) {
  var s = A.havingBaseStyle(n), r = (1 - A.sizeMultiplier / s.sizeMultiplier) * A.fontMetrics().axisHeight;
  e.classes.push("delimcenter"), e.style.top = Ie(r), e.height -= r, e.depth += r;
}, Iee = function(e, A, n, s, r, i) {
  var o = O.makeSymbol(e, "Main-Regular", r, s), a = wm(o, A, s, i);
  return n && Vb(a, s, A), a;
}, Cee = function(e, A, n, s) {
  return O.makeSymbol(e, "Size" + A + "-Regular", n, s);
}, Xb = function(e, A, n, s, r, i) {
  var o = Cee(e, A, r, s), a = wm(O.makeSpan(["delimsizing", "size" + A], [o], s), Je.TEXT, s, i);
  return n && Vb(a, s, Je.TEXT), a;
}, cI = function(e, A, n) {
  var s;
  A === "Size1-Regular" ? s = "delim-size1" : s = "delim-size4";
  var r = O.makeSpan(["delimsizinginner", s], [O.makeSpan([], [O.makeSymbol(e, A, n)])]);
  return {
    type: "elem",
    elem: r
  };
}, lI = function(e, A, n) {
  var s = Dr["Size4-Regular"][e.charCodeAt(0)] ? Dr["Size4-Regular"][e.charCodeAt(0)][4] : Dr["Size1-Regular"][e.charCodeAt(0)][4], r = new sa("inner", Y$(e, Math.round(1e3 * A))), i = new Ti([r], {
    width: Ie(s),
    height: Ie(A),
    // Override CSS rule `.katex svg { width: 100% }`
    style: "width:" + Ie(s),
    viewBox: "0 0 " + 1e3 * s + " " + Math.round(1e3 * A),
    preserveAspectRatio: "xMinYMin"
  }), o = O.makeSvgSpan([], [i], n);
  return o.height = A, o.style.height = Ie(A), o.style.width = Ie(s), {
    type: "elem",
    elem: o
  };
}, UE = 8e-3, N0 = {
  type: "kern",
  size: -1 * UE
}, Eee = ["|", "\\lvert", "\\rvert", "\\vert"], Mee = ["\\|", "\\lVert", "\\rVert", "\\Vert"], Zb = function(e, A, n, s, r, i) {
  var o, a, c, l, B = "", g = 0;
  o = c = l = e, a = null;
  var h = "Size1-Regular";
  e === "\\uparrow" ? c = l = "⏐" : e === "\\Uparrow" ? c = l = "‖" : e === "\\downarrow" ? o = c = "⏐" : e === "\\Downarrow" ? o = c = "‖" : e === "\\updownarrow" ? (o = "\\uparrow", c = "⏐", l = "\\downarrow") : e === "\\Updownarrow" ? (o = "\\Uparrow", c = "‖", l = "\\Downarrow") : Eee.includes(e) ? (c = "∣", B = "vert", g = 333) : Mee.includes(e) ? (c = "∥", B = "doublevert", g = 556) : e === "[" || e === "\\lbrack" ? (o = "⎡", c = "⎢", l = "⎣", h = "Size4-Regular", B = "lbrack", g = 667) : e === "]" || e === "\\rbrack" ? (o = "⎤", c = "⎥", l = "⎦", h = "Size4-Regular", B = "rbrack", g = 667) : e === "\\lfloor" || e === "⌊" ? (c = o = "⎢", l = "⎣", h = "Size4-Regular", B = "lfloor", g = 667) : e === "\\lceil" || e === "⌈" ? (o = "⎡", c = l = "⎢", h = "Size4-Regular", B = "lceil", g = 667) : e === "\\rfloor" || e === "⌋" ? (c = o = "⎥", l = "⎦", h = "Size4-Regular", B = "rfloor", g = 667) : e === "\\rceil" || e === "⌉" ? (o = "⎤", c = l = "⎥", h = "Size4-Regular", B = "rceil", g = 667) : e === "(" || e === "\\lparen" ? (o = "⎛", c = "⎜", l = "⎝", h = "Size4-Regular", B = "lparen", g = 875) : e === ")" || e === "\\rparen" ? (o = "⎞", c = "⎟", l = "⎠", h = "Size4-Regular", B = "rparen", g = 875) : e === "\\{" || e === "\\lbrace" ? (o = "⎧", a = "⎨", l = "⎩", c = "⎪", h = "Size4-Regular") : e === "\\}" || e === "\\rbrace" ? (o = "⎫", a = "⎬", l = "⎭", c = "⎪", h = "Size4-Regular") : e === "\\lgroup" || e === "⟮" ? (o = "⎧", l = "⎩", c = "⎪", h = "Size4-Regular") : e === "\\rgroup" || e === "⟯" ? (o = "⎫", l = "⎭", c = "⎪", h = "Size4-Regular") : e === "\\lmoustache" || e === "⎰" ? (o = "⎧", l = "⎭", c = "⎪", h = "Size4-Regular") : (e === "\\rmoustache" || e === "⎱") && (o = "⎫", l = "⎩", c = "⎪", h = "Size4-Regular");
  var u = YB(o, h, r), d = u.height + u.depth, w = YB(c, h, r), Q = w.height + w.depth, p = YB(l, h, r), M = p.height + p.depth, I = 0, N = 1;
  if (a !== null) {
    var m = YB(a, h, r);
    I = m.height + m.depth, N = 2;
  }
  var E = d + M + I, G = Math.max(0, Math.ceil((A - E) / (N * Q))), Y = E + G * N * Q, U = s.fontMetrics().axisHeight;
  n && (U *= s.sizeMultiplier);
  var v = Y / 2 - U, b = [];
  if (B.length > 0) {
    var W = Y - d - M, q = Math.round(Y * 1e3), ne = y$(B, Math.round(W * 1e3)), V = new sa(B, ne), se = (g / 1e3).toFixed(3) + "em", te = (q / 1e3).toFixed(3) + "em", be = new Ti([V], {
      width: se,
      height: te,
      viewBox: "0 0 " + g + " " + q
    }), Oe = O.makeSvgSpan([], [be], s);
    Oe.height = q / 1e3, Oe.style.width = se, Oe.style.height = te, b.push({
      type: "elem",
      elem: Oe
    });
  } else {
    if (b.push(cI(l, h, r)), b.push(N0), a === null) {
      var ke = Y - d - M + 2 * UE;
      b.push(lI(c, ke, s));
    } else {
      var Se = (Y - d - M - I) / 2 + 2 * UE;
      b.push(lI(c, Se, s)), b.push(N0), b.push(cI(a, h, r)), b.push(N0), b.push(lI(c, Se, s));
    }
    b.push(N0), b.push(cI(o, h, r));
  }
  var dt = s.havingBaseStyle(Je.TEXT), st = O.makeVList({
    positionType: "bottom",
    positionData: v,
    children: b
  }, dt);
  return wm(O.makeSpan(["delimsizing", "mult"], [st], dt), Je.TEXT, s, i);
}, BI = 80, gI = 0.08, hI = function(e, A, n, s, r) {
  var i = m$(e, s, n), o = new sa(e, i), a = new Ti([o], {
    // Note: 1000:1 ratio of viewBox to document em width.
    width: "400em",
    height: Ie(A),
    viewBox: "0 0 400000 " + n,
    preserveAspectRatio: "xMinYMin slice"
  });
  return O.makeSvgSpan(["hide-tail"], [a], r);
}, pee = function(e, A) {
  var n = A.havingBaseSizing(), s = ev("\\surd", e * n.sizeMultiplier, $b, n), r = n.sizeMultiplier, i = Math.max(0, A.minRuleThickness - A.fontMetrics().sqrtRuleThickness), o, a = 0, c = 0, l = 0, B;
  return s.type === "small" ? (l = 1e3 + 1e3 * i + BI, e < 1 ? r = 1 : e < 1.4 && (r = 0.7), a = (1 + i + gI) / r, c = (1 + i) / r, o = hI("sqrtMain", a, l, i, A), o.style.minWidth = "0.853em", B = 0.833 / r) : s.type === "large" ? (l = (1e3 + BI) * eg[s.size], c = (eg[s.size] + i) / r, a = (eg[s.size] + i + gI) / r, o = hI("sqrtSize" + s.size, a, l, i, A), o.style.minWidth = "1.02em", B = 1 / r) : (a = e + i + gI, c = e + i, l = Math.floor(1e3 * e + i) + BI, o = hI("sqrtTall", a, l, i, A), o.style.minWidth = "0.742em", B = 1.056), o.height = c, o.style.height = Ie(a), {
    span: o,
    advanceWidth: B,
    // Calculate the actual line width.
    // This actually should depend on the chosen font -- e.g. \boldmath
    // should use the thicker surd symbols from e.g. KaTeX_Main-Bold, and
    // have thicker rules.
    ruleWidth: (A.fontMetrics().sqrtRuleThickness + i) * r
  };
}, qb = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "\\surd"], mee = ["\\uparrow", "\\downarrow", "\\updownarrow", "\\Uparrow", "\\Downarrow", "\\Updownarrow", "|", "\\|", "\\vert", "\\Vert", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱"], _b = ["<", ">", "\\langle", "\\rangle", "/", "\\backslash", "\\lt", "\\gt"], eg = [0, 1.2, 1.8, 2.4, 3], Yee = function(e, A, n, s, r) {
  if (e === "<" || e === "\\lt" || e === "⟨" ? e = "\\langle" : (e === ">" || e === "\\gt" || e === "⟩") && (e = "\\rangle"), qb.includes(e) || _b.includes(e))
    return Xb(e, A, !1, n, s, r);
  if (mee.includes(e))
    return Zb(e, eg[A], !1, n, s, r);
  throw new de("Illegal delimiter: '" + e + "'");
}, yee = [{
  type: "small",
  style: Je.SCRIPTSCRIPT
}, {
  type: "small",
  style: Je.SCRIPT
}, {
  type: "small",
  style: Je.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}], Fee = [{
  type: "small",
  style: Je.SCRIPTSCRIPT
}, {
  type: "small",
  style: Je.SCRIPT
}, {
  type: "small",
  style: Je.TEXT
}, {
  type: "stack"
}], $b = [{
  type: "small",
  style: Je.SCRIPTSCRIPT
}, {
  type: "small",
  style: Je.SCRIPT
}, {
  type: "small",
  style: Je.TEXT
}, {
  type: "large",
  size: 1
}, {
  type: "large",
  size: 2
}, {
  type: "large",
  size: 3
}, {
  type: "large",
  size: 4
}, {
  type: "stack"
}], Nee = function(e) {
  if (e.type === "small")
    return "Main-Regular";
  if (e.type === "large")
    return "Size" + e.size + "-Regular";
  if (e.type === "stack")
    return "Size4-Regular";
  throw new Error("Add support for delim type '" + e.type + "' here.");
}, ev = function(e, A, n, s) {
  for (var r = Math.min(2, 3 - s.style.size), i = r; i < n.length && n[i].type !== "stack"; i++) {
    var o = YB(e, Nee(n[i]), "math"), a = o.height + o.depth;
    if (n[i].type === "small") {
      var c = s.havingBaseStyle(n[i].style);
      a *= c.sizeMultiplier;
    }
    if (a > A)
      return n[i];
  }
  return n[n.length - 1];
}, tv = function(e, A, n, s, r, i) {
  e === "<" || e === "\\lt" || e === "⟨" ? e = "\\langle" : (e === ">" || e === "\\gt" || e === "⟩") && (e = "\\rangle");
  var o;
  _b.includes(e) ? o = yee : qb.includes(e) ? o = $b : o = Fee;
  var a = ev(e, A, o, s);
  return a.type === "small" ? Iee(e, a.style, n, s, r, i) : a.type === "large" ? Xb(e, a.size, n, s, r, i) : Zb(e, A, n, s, r, i);
}, Dee = function(e, A, n, s, r, i) {
  var o = s.fontMetrics().axisHeight * s.sizeMultiplier, a = 901, c = 5 / s.fontMetrics().ptPerEm, l = Math.max(A - o, n + o), B = Math.max(
    // In real TeX, calculations are done using integral values which are
    // 65536 per pt, or 655360 per em. So, the division here truncates in
    // TeX but doesn't here, producing different results. If we wanted to
    // exactly match TeX's calculation, we could do
    //   Math.floor(655360 * maxDistFromAxis / 500) *
    //    delimiterFactor / 655360
    // (To see the difference, compare
    //    x^{x^{\left(\rule{0.1em}{0.68em}\right)}}
    // in TeX and KaTeX)
    l / 500 * a,
    2 * l - c
  );
  return tv(e, B, !0, s, r, i);
}, Hi = {
  sqrtImage: pee,
  sizedDelim: Yee,
  sizeToMaxHeight: eg,
  customSizedDelim: tv,
  leftRightDelim: Dee
}, SF = {
  "\\bigl": {
    mclass: "mopen",
    size: 1
  },
  "\\Bigl": {
    mclass: "mopen",
    size: 2
  },
  "\\biggl": {
    mclass: "mopen",
    size: 3
  },
  "\\Biggl": {
    mclass: "mopen",
    size: 4
  },
  "\\bigr": {
    mclass: "mclose",
    size: 1
  },
  "\\Bigr": {
    mclass: "mclose",
    size: 2
  },
  "\\biggr": {
    mclass: "mclose",
    size: 3
  },
  "\\Biggr": {
    mclass: "mclose",
    size: 4
  },
  "\\bigm": {
    mclass: "mrel",
    size: 1
  },
  "\\Bigm": {
    mclass: "mrel",
    size: 2
  },
  "\\biggm": {
    mclass: "mrel",
    size: 3
  },
  "\\Biggm": {
    mclass: "mrel",
    size: 4
  },
  "\\big": {
    mclass: "mord",
    size: 1
  },
  "\\Big": {
    mclass: "mord",
    size: 2
  },
  "\\bigg": {
    mclass: "mord",
    size: 3
  },
  "\\Bigg": {
    mclass: "mord",
    size: 4
  }
}, xee = ["(", "\\lparen", ")", "\\rparen", "[", "\\lbrack", "]", "\\rbrack", "\\{", "\\lbrace", "\\}", "\\rbrace", "\\lfloor", "\\rfloor", "⌊", "⌋", "\\lceil", "\\rceil", "⌈", "⌉", "<", ">", "\\langle", "⟨", "\\rangle", "⟩", "\\lt", "\\gt", "\\lvert", "\\rvert", "\\lVert", "\\rVert", "\\lgroup", "\\rgroup", "⟮", "⟯", "\\lmoustache", "\\rmoustache", "⎰", "⎱", "/", "\\backslash", "|", "\\vert", "\\|", "\\Vert", "\\uparrow", "\\Uparrow", "\\downarrow", "\\Downarrow", "\\updownarrow", "\\Updownarrow", "."];
function sf(t, e) {
  var A = Af(t);
  if (A && xee.includes(A.text))
    return A;
  throw A ? new de("Invalid delimiter '" + A.text + "' after '" + e.funcName + "'", t) : new de("Invalid delimiter type '" + t.type + "'", t);
}
Ye({
  type: "delimsizing",
  names: ["\\bigl", "\\Bigl", "\\biggl", "\\Biggl", "\\bigr", "\\Bigr", "\\biggr", "\\Biggr", "\\bigm", "\\Bigm", "\\biggm", "\\Biggm", "\\big", "\\Big", "\\bigg", "\\Bigg"],
  props: {
    numArgs: 1,
    argTypes: ["primitive"]
  },
  handler: (t, e) => {
    var A = sf(e[0], t);
    return {
      type: "delimsizing",
      mode: t.parser.mode,
      size: SF[t.funcName].size,
      mclass: SF[t.funcName].mclass,
      delim: A.text
    };
  },
  htmlBuilder: (t, e) => t.delim === "." ? O.makeSpan([t.mclass]) : Hi.sizedDelim(t.delim, t.size, e, t.mode, [t.mclass]),
  mathmlBuilder: (t) => {
    var e = [];
    t.delim !== "." && e.push(Ts(t.delim, t.mode));
    var A = new ge.MathNode("mo", e);
    t.mclass === "mopen" || t.mclass === "mclose" ? A.setAttribute("fence", "true") : A.setAttribute("fence", "false"), A.setAttribute("stretchy", "true");
    var n = Ie(Hi.sizeToMaxHeight[t.size]);
    return A.setAttribute("minsize", n), A.setAttribute("maxsize", n), A;
  }
});
function TF(t) {
  if (!t.body)
    throw new Error("Bug: The leftright ParseNode wasn't fully parsed.");
}
Ye({
  type: "leftright-right",
  names: ["\\right"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var A = t.parser.gullet.macros.get("\\current@color");
    if (A && typeof A != "string")
      throw new de("\\current@color set to non-string in \\right");
    return {
      type: "leftright-right",
      mode: t.parser.mode,
      delim: sf(e[0], t).text,
      color: A
      // undefined if not set via \color
    };
  }
});
Ye({
  type: "leftright",
  names: ["\\left"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var A = sf(e[0], t), n = t.parser;
    ++n.leftrightDepth;
    var s = n.parseExpression(!1);
    --n.leftrightDepth, n.expect("\\right", !1);
    var r = it(n.parseFunction(), "leftright-right");
    return {
      type: "leftright",
      mode: n.mode,
      body: s,
      left: A.text,
      right: r.delim,
      rightColor: r.color
    };
  },
  htmlBuilder: (t, e) => {
    TF(t);
    for (var A = yA(t.body, e, !0, ["mopen", "mclose"]), n = 0, s = 0, r = !1, i = 0; i < A.length; i++)
      A[i].isMiddle ? r = !0 : (n = Math.max(A[i].height, n), s = Math.max(A[i].depth, s));
    n *= e.sizeMultiplier, s *= e.sizeMultiplier;
    var o;
    if (t.left === "." ? o = Zg(e, ["mopen"]) : o = Hi.leftRightDelim(t.left, n, s, e, t.mode, ["mopen"]), A.unshift(o), r)
      for (var a = 1; a < A.length; a++) {
        var c = A[a], l = c.isMiddle;
        l && (A[a] = Hi.leftRightDelim(l.delim, n, s, l.options, t.mode, []));
      }
    var B;
    if (t.right === ".")
      B = Zg(e, ["mclose"]);
    else {
      var g = t.rightColor ? e.withColor(t.rightColor) : e;
      B = Hi.leftRightDelim(t.right, n, s, g, t.mode, ["mclose"]);
    }
    return A.push(B), O.makeSpan(["minner"], A, e);
  },
  mathmlBuilder: (t, e) => {
    TF(t);
    var A = es(t.body, e);
    if (t.left !== ".") {
      var n = new ge.MathNode("mo", [Ts(t.left, t.mode)]);
      n.setAttribute("fence", "true"), A.unshift(n);
    }
    if (t.right !== ".") {
      var s = new ge.MathNode("mo", [Ts(t.right, t.mode)]);
      s.setAttribute("fence", "true"), t.rightColor && s.setAttribute("mathcolor", t.rightColor), A.push(s);
    }
    return gm(A);
  }
});
Ye({
  type: "middle",
  names: ["\\middle"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var A = sf(e[0], t);
    if (!t.parser.leftrightDepth)
      throw new de("\\middle without preceding \\left", A);
    return {
      type: "middle",
      mode: t.parser.mode,
      delim: A.text
    };
  },
  htmlBuilder: (t, e) => {
    var A;
    if (t.delim === ".")
      A = Zg(e, []);
    else {
      A = Hi.sizedDelim(t.delim, 1, e, t.mode, []);
      var n = {
        delim: t.delim,
        options: e
      };
      A.isMiddle = n;
    }
    return A;
  },
  mathmlBuilder: (t, e) => {
    var A = t.delim === "\\vert" || t.delim === "|" ? Ts("|", "text") : Ts(t.delim, t.mode), n = new ge.MathNode("mo", [A]);
    return n.setAttribute("fence", "true"), n.setAttribute("lspace", "0.05em"), n.setAttribute("rspace", "0.05em"), n;
  }
});
var fm = (t, e) => {
  var A = O.wrapFragment(Ft(t.body, e), e), n = t.label.slice(1), s = e.sizeMultiplier, r, i = 0, o = Dt.isCharacterBox(t.body);
  if (n === "sout")
    r = O.makeSpan(["stretchy", "sout"]), r.height = e.fontMetrics().defaultRuleThickness / s, i = -0.5 * e.fontMetrics().xHeight;
  else if (n === "phase") {
    var a = nA({
      number: 0.6,
      unit: "pt"
    }, e), c = nA({
      number: 0.35,
      unit: "ex"
    }, e), l = e.havingBaseSizing();
    s = s / l.sizeMultiplier;
    var B = A.height + A.depth + a + c;
    A.style.paddingLeft = Ie(B / 2 + a);
    var g = Math.floor(1e3 * B * s), h = M$(g), u = new Ti([new sa("phase", h)], {
      width: "400em",
      height: Ie(g / 1e3),
      viewBox: "0 0 400000 " + g,
      preserveAspectRatio: "xMinYMin slice"
    });
    r = O.makeSvgSpan(["hide-tail"], [u], e), r.style.height = Ie(B), i = A.depth + a + c;
  } else {
    /cancel/.test(n) ? o || A.classes.push("cancel-pad") : n === "angl" ? A.classes.push("anglpad") : A.classes.push("boxpad");
    var d = 0, w = 0, Q = 0;
    /box/.test(n) ? (Q = Math.max(
      e.fontMetrics().fboxrule,
      // default
      e.minRuleThickness
      // User override.
    ), d = e.fontMetrics().fboxsep + (n === "colorbox" ? 0 : Q), w = d) : n === "angl" ? (Q = Math.max(e.fontMetrics().defaultRuleThickness, e.minRuleThickness), d = 4 * Q, w = Math.max(0, 0.25 - A.depth)) : (d = o ? 0.2 : 0, w = d), r = Wi.encloseSpan(A, n, d, w, e), /fbox|boxed|fcolorbox/.test(n) ? (r.style.borderStyle = "solid", r.style.borderWidth = Ie(Q)) : n === "angl" && Q !== 0.049 && (r.style.borderTopWidth = Ie(Q), r.style.borderRightWidth = Ie(Q)), i = A.depth + w, t.backgroundColor && (r.style.backgroundColor = t.backgroundColor, t.borderColor && (r.style.borderColor = t.borderColor));
  }
  var p;
  if (t.backgroundColor)
    p = O.makeVList({
      positionType: "individualShift",
      children: [
        // Put the color background behind inner;
        {
          type: "elem",
          elem: r,
          shift: i
        },
        {
          type: "elem",
          elem: A,
          shift: 0
        }
      ]
    }, e);
  else {
    var M = /cancel|phase/.test(n) ? ["svg-align"] : [];
    p = O.makeVList({
      positionType: "individualShift",
      children: [
        // Write the \cancel stroke on top of inner.
        {
          type: "elem",
          elem: A,
          shift: 0
        },
        {
          type: "elem",
          elem: r,
          shift: i,
          wrapperClasses: M
        }
      ]
    }, e);
  }
  return /cancel/.test(n) && (p.height = A.height, p.depth = A.depth), /cancel/.test(n) && !o ? O.makeSpan(["mord", "cancel-lap"], [p], e) : O.makeSpan(["mord"], [p], e);
}, Qm = (t, e) => {
  var A = 0, n = new ge.MathNode(t.label.indexOf("colorbox") > -1 ? "mpadded" : "menclose", [Tt(t.body, e)]);
  switch (t.label) {
    case "\\cancel":
      n.setAttribute("notation", "updiagonalstrike");
      break;
    case "\\bcancel":
      n.setAttribute("notation", "downdiagonalstrike");
      break;
    case "\\phase":
      n.setAttribute("notation", "phasorangle");
      break;
    case "\\sout":
      n.setAttribute("notation", "horizontalstrike");
      break;
    case "\\fbox":
      n.setAttribute("notation", "box");
      break;
    case "\\angl":
      n.setAttribute("notation", "actuarial");
      break;
    case "\\fcolorbox":
    case "\\colorbox":
      if (A = e.fontMetrics().fboxsep * e.fontMetrics().ptPerEm, n.setAttribute("width", "+" + 2 * A + "pt"), n.setAttribute("height", "+" + 2 * A + "pt"), n.setAttribute("lspace", A + "pt"), n.setAttribute("voffset", A + "pt"), t.label === "\\fcolorbox") {
        var s = Math.max(
          e.fontMetrics().fboxrule,
          // default
          e.minRuleThickness
          // user override
        );
        n.setAttribute("style", "border: " + s + "em solid " + String(t.borderColor));
      }
      break;
    case "\\xcancel":
      n.setAttribute("notation", "updiagonalstrike downdiagonalstrike");
      break;
  }
  return t.backgroundColor && n.setAttribute("mathbackground", t.backgroundColor), n;
};
Ye({
  type: "enclose",
  names: ["\\colorbox"],
  props: {
    numArgs: 2,
    allowedInText: !0,
    argTypes: ["color", "text"]
  },
  handler(t, e, A) {
    var {
      parser: n,
      funcName: s
    } = t, r = it(e[0], "color-token").color, i = e[1];
    return {
      type: "enclose",
      mode: n.mode,
      label: s,
      backgroundColor: r,
      body: i
    };
  },
  htmlBuilder: fm,
  mathmlBuilder: Qm
});
Ye({
  type: "enclose",
  names: ["\\fcolorbox"],
  props: {
    numArgs: 3,
    allowedInText: !0,
    argTypes: ["color", "color", "text"]
  },
  handler(t, e, A) {
    var {
      parser: n,
      funcName: s
    } = t, r = it(e[0], "color-token").color, i = it(e[1], "color-token").color, o = e[2];
    return {
      type: "enclose",
      mode: n.mode,
      label: s,
      backgroundColor: i,
      borderColor: r,
      body: o
    };
  },
  htmlBuilder: fm,
  mathmlBuilder: Qm
});
Ye({
  type: "enclose",
  names: ["\\fbox"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "enclose",
      mode: A.mode,
      label: "\\fbox",
      body: e[0]
    };
  }
});
Ye({
  type: "enclose",
  names: ["\\cancel", "\\bcancel", "\\xcancel", "\\sout", "\\phase"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    return {
      type: "enclose",
      mode: A.mode,
      label: n,
      body: s
    };
  },
  htmlBuilder: fm,
  mathmlBuilder: Qm
});
Ye({
  type: "enclose",
  names: ["\\angl"],
  props: {
    numArgs: 1,
    argTypes: ["hbox"],
    allowedInText: !1
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "enclose",
      mode: A.mode,
      label: "\\angl",
      body: e[0]
    };
  }
});
var Av = {};
function ei(t) {
  for (var {
    type: e,
    names: A,
    props: n,
    handler: s,
    htmlBuilder: r,
    mathmlBuilder: i
  } = t, o = {
    type: e,
    numArgs: n.numArgs || 0,
    allowedInText: !1,
    numOptionalArgs: 0,
    handler: s
  }, a = 0; a < A.length; ++a)
    Av[A[a]] = o;
  r && (Td[e] = r), i && (Jd[e] = i);
}
var nv = {};
function z(t, e) {
  nv[t] = e;
}
function JF(t) {
  var e = [];
  t.consumeSpaces();
  var A = t.fetch().text;
  for (A === "\\relax" && (t.consume(), t.consumeSpaces(), A = t.fetch().text); A === "\\hline" || A === "\\hdashline"; )
    t.consume(), e.push(A === "\\hdashline"), t.consumeSpaces(), A = t.fetch().text;
  return e;
}
var rf = (t) => {
  var e = t.parser.settings;
  if (!e.displayMode)
    throw new de("{" + t.envName + "} can be used only in display mode.");
};
function Im(t) {
  if (t.indexOf("ed") === -1)
    return t.indexOf("*") === -1;
}
function ca(t, e, A) {
  var {
    hskipBeforeAndAfter: n,
    addJot: s,
    cols: r,
    arraystretch: i,
    colSeparationType: o,
    autoTag: a,
    singleRow: c,
    emptySingleRow: l,
    maxNumCols: B,
    leqno: g
  } = e;
  if (t.gullet.beginGroup(), c || t.gullet.macros.set("\\cr", "\\\\\\relax"), !i) {
    var h = t.gullet.expandMacroAsText("\\arraystretch");
    if (h == null)
      i = 1;
    else if (i = parseFloat(h), !i || i < 0)
      throw new de("Invalid \\arraystretch: " + h);
  }
  t.gullet.beginGroup();
  var u = [], d = [u], w = [], Q = [], p = a != null ? [] : void 0;
  function M() {
    a && t.gullet.macros.set("\\@eqnsw", "1", !0);
  }
  function I() {
    p && (t.gullet.macros.get("\\df@tag") ? (p.push(t.subparse([new ds("\\df@tag")])), t.gullet.macros.set("\\df@tag", void 0, !0)) : p.push(!!a && t.gullet.macros.get("\\@eqnsw") === "1"));
  }
  for (M(), Q.push(JF(t)); ; ) {
    var N = t.parseExpression(!1, c ? "\\end" : "\\\\");
    t.gullet.endGroup(), t.gullet.beginGroup(), N = {
      type: "ordgroup",
      mode: t.mode,
      body: N
    }, A && (N = {
      type: "styling",
      mode: t.mode,
      style: A,
      body: [N]
    }), u.push(N);
    var m = t.fetch().text;
    if (m === "&") {
      if (B && u.length === B) {
        if (c || o)
          throw new de("Too many tab characters: &", t.nextToken);
        t.settings.reportNonstrict("textEnv", "Too few columns specified in the {array} column argument.");
      }
      t.consume();
    } else if (m === "\\end") {
      I(), u.length === 1 && N.type === "styling" && N.body[0].body.length === 0 && (d.length > 1 || !l) && d.pop(), Q.length < d.length + 1 && Q.push([]);
      break;
    } else if (m === "\\\\") {
      t.consume();
      var E = void 0;
      t.gullet.future().text !== " " && (E = t.parseSizeGroup(!0)), w.push(E ? E.value : null), I(), Q.push(JF(t)), u = [], d.push(u), M();
    } else
      throw new de("Expected & or \\\\ or \\cr or \\end", t.nextToken);
  }
  return t.gullet.endGroup(), t.gullet.endGroup(), {
    type: "array",
    mode: t.mode,
    addJot: s,
    arraystretch: i,
    body: d,
    cols: r,
    rowGaps: w,
    hskipBeforeAndAfter: n,
    hLinesBeforeRow: Q,
    colSeparationType: o,
    tags: p,
    leqno: g
  };
}
function Cm(t) {
  return t.slice(0, 1) === "d" ? "display" : "text";
}
var ti = function(e, A) {
  var n, s, r = e.body.length, i = e.hLinesBeforeRow, o = 0, a = new Array(r), c = [], l = Math.max(
    // From LaTeX \showthe\arrayrulewidth. Equals 0.04 em.
    A.fontMetrics().arrayRuleWidth,
    A.minRuleThickness
    // User override.
  ), B = 1 / A.fontMetrics().ptPerEm, g = 5 * B;
  if (e.colSeparationType && e.colSeparationType === "small") {
    var h = A.havingStyle(Je.SCRIPT).sizeMultiplier;
    g = 0.2778 * (h / A.sizeMultiplier);
  }
  var u = e.colSeparationType === "CD" ? nA({
    number: 3,
    unit: "ex"
  }, A) : 12 * B, d = 3 * B, w = e.arraystretch * u, Q = 0.7 * w, p = 0.3 * w, M = 0;
  function I(ae) {
    for (var Be = 0; Be < ae.length; ++Be)
      Be > 0 && (M += 0.25), c.push({
        pos: M,
        isDashed: ae[Be]
      });
  }
  for (I(i[0]), n = 0; n < e.body.length; ++n) {
    var N = e.body[n], m = Q, E = p;
    o < N.length && (o = N.length);
    var G = new Array(N.length);
    for (s = 0; s < N.length; ++s) {
      var Y = Ft(N[s], A);
      E < Y.depth && (E = Y.depth), m < Y.height && (m = Y.height), G[s] = Y;
    }
    var U = e.rowGaps[n], v = 0;
    U && (v = nA(U, A), v > 0 && (v += p, E < v && (E = v), v = 0)), e.addJot && (E += d), G.height = m, G.depth = E, M += m, G.pos = M, M += E + v, a[n] = G, I(i[n + 1]);
  }
  var b = M / 2 + A.fontMetrics().axisHeight, W = e.cols || [], q = [], ne, V, se = [];
  if (e.tags && e.tags.some((ae) => ae))
    for (n = 0; n < r; ++n) {
      var te = a[n], be = te.pos - b, Oe = e.tags[n], ke = void 0;
      Oe === !0 ? ke = O.makeSpan(["eqn-num"], [], A) : Oe === !1 ? ke = O.makeSpan([], [], A) : ke = O.makeSpan([], yA(Oe, A, !0), A), ke.depth = te.depth, ke.height = te.height, se.push({
        type: "elem",
        elem: ke,
        shift: be
      });
    }
  for (
    s = 0, V = 0;
    // Continue while either there are more columns or more column
    // descriptions, so trailing separators don't get lost.
    s < o || V < W.length;
    ++s, ++V
  ) {
    for (var Se = W[V] || {}, dt = !0; Se.type === "separator"; ) {
      if (dt || (ne = O.makeSpan(["arraycolsep"], []), ne.style.width = Ie(A.fontMetrics().doubleRuleSep), q.push(ne)), Se.separator === "|" || Se.separator === ":") {
        var st = Se.separator === "|" ? "solid" : "dashed", We = O.makeSpan(["vertical-separator"], [], A);
        We.style.height = Ie(M), We.style.borderRightWidth = Ie(l), We.style.borderRightStyle = st, We.style.margin = "0 " + Ie(-l / 2);
        var pt = M - b;
        pt && (We.style.verticalAlign = Ie(-pt)), q.push(We);
      } else
        throw new de("Invalid separator type: " + Se.separator);
      V++, Se = W[V] || {}, dt = !1;
    }
    if (!(s >= o)) {
      var xt = void 0;
      (s > 0 || e.hskipBeforeAndAfter) && (xt = Dt.deflt(Se.pregap, g), xt !== 0 && (ne = O.makeSpan(["arraycolsep"], []), ne.style.width = Ie(xt), q.push(ne)));
      var mt = [];
      for (n = 0; n < r; ++n) {
        var $t = a[n], Ut = $t[s];
        if (Ut) {
          var RA = $t.pos - b;
          Ut.depth = $t.depth, Ut.height = $t.height, mt.push({
            type: "elem",
            elem: Ut,
            shift: RA
          });
        }
      }
      mt = O.makeVList({
        positionType: "individualShift",
        children: mt
      }, A), mt = O.makeSpan(["col-align-" + (Se.align || "c")], [mt]), q.push(mt), (s < o - 1 || e.hskipBeforeAndAfter) && (xt = Dt.deflt(Se.postgap, g), xt !== 0 && (ne = O.makeSpan(["arraycolsep"], []), ne.style.width = Ie(xt), q.push(ne)));
    }
  }
  if (a = O.makeSpan(["mtable"], q), c.length > 0) {
    for (var H = O.makeLineSpan("hline", A, l), L = O.makeLineSpan("hdashline", A, l), _ = [{
      type: "elem",
      elem: a,
      shift: 0
    }]; c.length > 0; ) {
      var R = c.pop(), P = R.pos - b;
      R.isDashed ? _.push({
        type: "elem",
        elem: L,
        shift: P
      }) : _.push({
        type: "elem",
        elem: H,
        shift: P
      });
    }
    a = O.makeVList({
      positionType: "individualShift",
      children: _
    }, A);
  }
  if (se.length === 0)
    return O.makeSpan(["mord"], [a], A);
  var X = O.makeVList({
    positionType: "individualShift",
    children: se
  }, A);
  return X = O.makeSpan(["tag"], [X], A), O.makeFragment([a, X]);
}, Gee = {
  c: "center ",
  l: "left ",
  r: "right "
}, Ai = function(e, A) {
  for (var n = [], s = new ge.MathNode("mtd", [], ["mtr-glue"]), r = new ge.MathNode("mtd", [], ["mml-eqn-num"]), i = 0; i < e.body.length; i++) {
    for (var o = e.body[i], a = [], c = 0; c < o.length; c++)
      a.push(new ge.MathNode("mtd", [Tt(o[c], A)]));
    e.tags && e.tags[i] && (a.unshift(s), a.push(s), e.leqno ? a.unshift(r) : a.push(r)), n.push(new ge.MathNode("mtr", a));
  }
  var l = new ge.MathNode("mtable", n), B = e.arraystretch === 0.5 ? 0.1 : 0.16 + e.arraystretch - 1 + (e.addJot ? 0.09 : 0);
  l.setAttribute("rowspacing", Ie(B));
  var g = "", h = "";
  if (e.cols && e.cols.length > 0) {
    var u = e.cols, d = "", w = !1, Q = 0, p = u.length;
    u[0].type === "separator" && (g += "top ", Q = 1), u[u.length - 1].type === "separator" && (g += "bottom ", p -= 1);
    for (var M = Q; M < p; M++)
      u[M].type === "align" ? (h += Gee[u[M].align], w && (d += "none "), w = !0) : u[M].type === "separator" && w && (d += u[M].separator === "|" ? "solid " : "dashed ", w = !1);
    l.setAttribute("columnalign", h.trim()), /[sd]/.test(d) && l.setAttribute("columnlines", d.trim());
  }
  if (e.colSeparationType === "align") {
    for (var I = e.cols || [], N = "", m = 1; m < I.length; m++)
      N += m % 2 ? "0em " : "1em ";
    l.setAttribute("columnspacing", N.trim());
  } else e.colSeparationType === "alignat" || e.colSeparationType === "gather" ? l.setAttribute("columnspacing", "0em") : e.colSeparationType === "small" ? l.setAttribute("columnspacing", "0.2778em") : e.colSeparationType === "CD" ? l.setAttribute("columnspacing", "0.5em") : l.setAttribute("columnspacing", "1em");
  var E = "", G = e.hLinesBeforeRow;
  g += G[0].length > 0 ? "left " : "", g += G[G.length - 1].length > 0 ? "right " : "";
  for (var Y = 1; Y < G.length - 1; Y++)
    E += G[Y].length === 0 ? "none " : G[Y][0] ? "dashed " : "solid ";
  return /[sd]/.test(E) && l.setAttribute("rowlines", E.trim()), g !== "" && (l = new ge.MathNode("menclose", [l]), l.setAttribute("notation", g.trim())), e.arraystretch && e.arraystretch < 1 && (l = new ge.MathNode("mstyle", [l]), l.setAttribute("scriptlevel", "1")), l;
}, sv = function(e, A) {
  e.envName.indexOf("ed") === -1 && rf(e);
  var n = [], s = e.envName.indexOf("at") > -1 ? "alignat" : "align", r = e.envName === "split", i = ca(e.parser, {
    cols: n,
    addJot: !0,
    autoTag: r ? void 0 : Im(e.envName),
    emptySingleRow: !0,
    colSeparationType: s,
    maxNumCols: r ? 2 : void 0,
    leqno: e.parser.settings.leqno
  }, "display"), o, a = 0, c = {
    type: "ordgroup",
    mode: e.mode,
    body: []
  };
  if (A[0] && A[0].type === "ordgroup") {
    for (var l = "", B = 0; B < A[0].body.length; B++) {
      var g = it(A[0].body[B], "textord");
      l += g.text;
    }
    o = Number(l), a = o * 2;
  }
  var h = !a;
  i.body.forEach(function(Q) {
    for (var p = 1; p < Q.length; p += 2) {
      var M = it(Q[p], "styling"), I = it(M.body[0], "ordgroup");
      I.body.unshift(c);
    }
    if (h)
      a < Q.length && (a = Q.length);
    else {
      var N = Q.length / 2;
      if (o < N)
        throw new de("Too many math in a row: " + ("expected " + o + ", but got " + N), Q[0]);
    }
  });
  for (var u = 0; u < a; ++u) {
    var d = "r", w = 0;
    u % 2 === 1 ? d = "l" : u > 0 && h && (w = 1), n[u] = {
      type: "align",
      align: d,
      pregap: w,
      postgap: 0
    };
  }
  return i.colSeparationType = h ? "align" : "alignat", i;
};
ei({
  type: "array",
  names: ["array", "darray"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var A = Af(e[0]), n = A ? [e[0]] : it(e[0], "ordgroup").body, s = n.map(function(i) {
      var o = um(i), a = o.text;
      if ("lcr".indexOf(a) !== -1)
        return {
          type: "align",
          align: a
        };
      if (a === "|")
        return {
          type: "separator",
          separator: "|"
        };
      if (a === ":")
        return {
          type: "separator",
          separator: ":"
        };
      throw new de("Unknown column alignment: " + a, i);
    }), r = {
      cols: s,
      hskipBeforeAndAfter: !0,
      // \@preamble in lttab.dtx
      maxNumCols: s.length
    };
    return ca(t.parser, r, Cm(t.envName));
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["matrix", "pmatrix", "bmatrix", "Bmatrix", "vmatrix", "Vmatrix", "matrix*", "pmatrix*", "bmatrix*", "Bmatrix*", "vmatrix*", "Vmatrix*"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var e = {
      matrix: null,
      pmatrix: ["(", ")"],
      bmatrix: ["[", "]"],
      Bmatrix: ["\\{", "\\}"],
      vmatrix: ["|", "|"],
      Vmatrix: ["\\Vert", "\\Vert"]
    }[t.envName.replace("*", "")], A = "c", n = {
      hskipBeforeAndAfter: !1,
      cols: [{
        type: "align",
        align: A
      }]
    };
    if (t.envName.charAt(t.envName.length - 1) === "*") {
      var s = t.parser;
      if (s.consumeSpaces(), s.fetch().text === "[") {
        if (s.consume(), s.consumeSpaces(), A = s.fetch().text, "lcr".indexOf(A) === -1)
          throw new de("Expected l or c or r", s.nextToken);
        s.consume(), s.consumeSpaces(), s.expect("]"), s.consume(), n.cols = [{
          type: "align",
          align: A
        }];
      }
    }
    var r = ca(t.parser, n, Cm(t.envName)), i = Math.max(0, ...r.body.map((o) => o.length));
    return r.cols = new Array(i).fill({
      type: "align",
      align: A
    }), e ? {
      type: "leftright",
      mode: t.mode,
      body: [r],
      left: e[0],
      right: e[1],
      rightColor: void 0
      // \right uninfluenced by \color in array
    } : r;
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["smallmatrix"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var e = {
      arraystretch: 0.5
    }, A = ca(t.parser, e, "script");
    return A.colSeparationType = "small", A;
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["subarray"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var A = Af(e[0]), n = A ? [e[0]] : it(e[0], "ordgroup").body, s = n.map(function(i) {
      var o = um(i), a = o.text;
      if ("lc".indexOf(a) !== -1)
        return {
          type: "align",
          align: a
        };
      throw new de("Unknown column alignment: " + a, i);
    });
    if (s.length > 1)
      throw new de("{subarray} can contain only one column");
    var r = {
      cols: s,
      hskipBeforeAndAfter: !1,
      arraystretch: 0.5
    };
    if (r = ca(t.parser, r, "script"), r.body.length > 0 && r.body[0].length > 1)
      throw new de("{subarray} can contain only one column");
    return r;
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["cases", "dcases", "rcases", "drcases"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var e = {
      arraystretch: 1.2,
      cols: [{
        type: "align",
        align: "l",
        pregap: 0,
        // TODO(kevinb) get the current style.
        // For now we use the metrics for TEXT style which is what we were
        // doing before.  Before attempting to get the current style we
        // should look at TeX's behavior especially for \over and matrices.
        postgap: 1
        /* 1em quad */
      }, {
        type: "align",
        align: "l",
        pregap: 0,
        postgap: 0
      }]
    }, A = ca(t.parser, e, Cm(t.envName));
    return {
      type: "leftright",
      mode: t.mode,
      body: [A],
      left: t.envName.indexOf("r") > -1 ? "." : "\\{",
      right: t.envName.indexOf("r") > -1 ? "\\}" : ".",
      rightColor: void 0
    };
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["align", "align*", "aligned", "split"],
  props: {
    numArgs: 0
  },
  handler: sv,
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["gathered", "gather", "gather*"],
  props: {
    numArgs: 0
  },
  handler(t) {
    ["gather", "gather*"].includes(t.envName) && rf(t);
    var e = {
      cols: [{
        type: "align",
        align: "c"
      }],
      addJot: !0,
      colSeparationType: "gather",
      autoTag: Im(t.envName),
      emptySingleRow: !0,
      leqno: t.parser.settings.leqno
    };
    return ca(t.parser, e, "display");
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["alignat", "alignat*", "alignedat"],
  props: {
    numArgs: 1
  },
  handler: sv,
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["equation", "equation*"],
  props: {
    numArgs: 0
  },
  handler(t) {
    rf(t);
    var e = {
      autoTag: Im(t.envName),
      emptySingleRow: !0,
      singleRow: !0,
      maxNumCols: 1,
      leqno: t.parser.settings.leqno
    };
    return ca(t.parser, e, "display");
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
ei({
  type: "array",
  names: ["CD"],
  props: {
    numArgs: 0
  },
  handler(t) {
    return rf(t), fee(t.parser);
  },
  htmlBuilder: ti,
  mathmlBuilder: Ai
});
z("\\nonumber", "\\gdef\\@eqnsw{0}");
z("\\notag", "\\nonumber");
Ye({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\hline", "\\hdashline"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !0
  },
  handler(t, e) {
    throw new de(t.funcName + " valid only within array environment");
  }
});
var WF = Av;
Ye({
  type: "environment",
  names: ["\\begin", "\\end"],
  props: {
    numArgs: 1,
    argTypes: ["text"]
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    if (s.type !== "ordgroup")
      throw new de("Invalid environment name", s);
    for (var r = "", i = 0; i < s.body.length; ++i)
      r += it(s.body[i], "textord").text;
    if (n === "\\begin") {
      if (!WF.hasOwnProperty(r))
        throw new de("No such environment: " + r, s);
      var o = WF[r], {
        args: a,
        optArgs: c
      } = A.parseArguments("\\begin{" + r + "}", o), l = {
        mode: A.mode,
        envName: r,
        parser: A
      }, B = o.handler(l, a, c);
      A.expect("\\end", !1);
      var g = A.nextToken, h = it(A.parseFunction(), "environment");
      if (h.name !== r)
        throw new de("Mismatch: \\begin{" + r + "} matched by \\end{" + h.name + "}", g);
      return B;
    }
    return {
      type: "environment",
      mode: A.mode,
      name: r,
      nameGroup: s
    };
  }
});
var rv = (t, e) => {
  var A = t.font, n = e.withFont(A);
  return Ft(t.body, n);
}, iv = (t, e) => {
  var A = t.font, n = e.withFont(A);
  return Tt(t.body, n);
}, OF = {
  "\\Bbb": "\\mathbb",
  "\\bold": "\\mathbf",
  "\\frak": "\\mathfrak",
  "\\bm": "\\boldsymbol"
};
Ye({
  type: "font",
  names: [
    // styles, except \boldsymbol defined below
    "\\mathrm",
    "\\mathit",
    "\\mathbf",
    "\\mathnormal",
    "\\mathsfit",
    // families
    "\\mathbb",
    "\\mathcal",
    "\\mathfrak",
    "\\mathscr",
    "\\mathsf",
    "\\mathtt",
    // aliases, except \bm defined below
    "\\Bbb",
    "\\bold",
    "\\frak"
  ],
  props: {
    numArgs: 1,
    allowedInArgument: !0
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = Wd(e[0]), r = n;
    return r in OF && (r = OF[r]), {
      type: "font",
      mode: A.mode,
      font: r.slice(1),
      body: s
    };
  },
  htmlBuilder: rv,
  mathmlBuilder: iv
});
Ye({
  type: "mclass",
  names: ["\\boldsymbol", "\\bm"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = e[0], s = Dt.isCharacterBox(n);
    return {
      type: "mclass",
      mode: A.mode,
      mclass: nf(n),
      body: [{
        type: "font",
        mode: A.mode,
        font: "boldsymbol",
        body: n
      }],
      isCharacterBox: s
    };
  }
});
Ye({
  type: "font",
  names: ["\\rm", "\\sf", "\\tt", "\\bf", "\\it", "\\cal"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n,
      breakOnTokenText: s
    } = t, {
      mode: r
    } = A, i = A.parseExpression(!0, s), o = "math" + n.slice(1);
    return {
      type: "font",
      mode: r,
      font: o,
      body: {
        type: "ordgroup",
        mode: A.mode,
        body: i
      }
    };
  },
  htmlBuilder: rv,
  mathmlBuilder: iv
});
var ov = (t, e) => {
  var A = e;
  return t === "display" ? A = A.id >= Je.SCRIPT.id ? A.text() : Je.DISPLAY : t === "text" && A.size === Je.DISPLAY.size ? A = Je.TEXT : t === "script" ? A = Je.SCRIPT : t === "scriptscript" && (A = Je.SCRIPTSCRIPT), A;
}, Em = (t, e) => {
  var A = ov(t.size, e.style), n = A.fracNum(), s = A.fracDen(), r;
  r = e.havingStyle(n);
  var i = Ft(t.numer, r, e);
  if (t.continued) {
    var o = 8.5 / e.fontMetrics().ptPerEm, a = 3.5 / e.fontMetrics().ptPerEm;
    i.height = i.height < o ? o : i.height, i.depth = i.depth < a ? a : i.depth;
  }
  r = e.havingStyle(s);
  var c = Ft(t.denom, r, e), l, B, g;
  t.hasBarLine ? (t.barSize ? (B = nA(t.barSize, e), l = O.makeLineSpan("frac-line", e, B)) : l = O.makeLineSpan("frac-line", e), B = l.height, g = l.height) : (l = null, B = 0, g = e.fontMetrics().defaultRuleThickness);
  var h, u, d;
  A.size === Je.DISPLAY.size || t.size === "display" ? (h = e.fontMetrics().num1, B > 0 ? u = 3 * g : u = 7 * g, d = e.fontMetrics().denom1) : (B > 0 ? (h = e.fontMetrics().num2, u = g) : (h = e.fontMetrics().num3, u = 3 * g), d = e.fontMetrics().denom2);
  var w;
  if (l) {
    var p = e.fontMetrics().axisHeight;
    h - i.depth - (p + 0.5 * B) < u && (h += u - (h - i.depth - (p + 0.5 * B))), p - 0.5 * B - (c.height - d) < u && (d += u - (p - 0.5 * B - (c.height - d)));
    var M = -(p - 0.5 * B);
    w = O.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: c,
        shift: d
      }, {
        type: "elem",
        elem: l,
        shift: M
      }, {
        type: "elem",
        elem: i,
        shift: -h
      }]
    }, e);
  } else {
    var Q = h - i.depth - (c.height - d);
    Q < u && (h += 0.5 * (u - Q), d += 0.5 * (u - Q)), w = O.makeVList({
      positionType: "individualShift",
      children: [{
        type: "elem",
        elem: c,
        shift: d
      }, {
        type: "elem",
        elem: i,
        shift: -h
      }]
    }, e);
  }
  r = e.havingStyle(A), w.height *= r.sizeMultiplier / e.sizeMultiplier, w.depth *= r.sizeMultiplier / e.sizeMultiplier;
  var I;
  A.size === Je.DISPLAY.size ? I = e.fontMetrics().delim1 : A.size === Je.SCRIPTSCRIPT.size ? I = e.havingStyle(Je.SCRIPT).fontMetrics().delim2 : I = e.fontMetrics().delim2;
  var N, m;
  return t.leftDelim == null ? N = Zg(e, ["mopen"]) : N = Hi.customSizedDelim(t.leftDelim, I, !0, e.havingStyle(A), t.mode, ["mopen"]), t.continued ? m = O.makeSpan([]) : t.rightDelim == null ? m = Zg(e, ["mclose"]) : m = Hi.customSizedDelim(t.rightDelim, I, !0, e.havingStyle(A), t.mode, ["mclose"]), O.makeSpan(["mord"].concat(r.sizingClasses(e)), [N, O.makeSpan(["mfrac"], [w]), m], e);
}, Mm = (t, e) => {
  var A = new ge.MathNode("mfrac", [Tt(t.numer, e), Tt(t.denom, e)]);
  if (!t.hasBarLine)
    A.setAttribute("linethickness", "0px");
  else if (t.barSize) {
    var n = nA(t.barSize, e);
    A.setAttribute("linethickness", Ie(n));
  }
  var s = ov(t.size, e.style);
  if (s.size !== e.style.size) {
    A = new ge.MathNode("mstyle", [A]);
    var r = s.size === Je.DISPLAY.size ? "true" : "false";
    A.setAttribute("displaystyle", r), A.setAttribute("scriptlevel", "0");
  }
  if (t.leftDelim != null || t.rightDelim != null) {
    var i = [];
    if (t.leftDelim != null) {
      var o = new ge.MathNode("mo", [new ge.TextNode(t.leftDelim.replace("\\", ""))]);
      o.setAttribute("fence", "true"), i.push(o);
    }
    if (i.push(A), t.rightDelim != null) {
      var a = new ge.MathNode("mo", [new ge.TextNode(t.rightDelim.replace("\\", ""))]);
      a.setAttribute("fence", "true"), i.push(a);
    }
    return gm(i);
  }
  return A;
};
Ye({
  type: "genfrac",
  names: [
    "\\dfrac",
    "\\frac",
    "\\tfrac",
    "\\dbinom",
    "\\binom",
    "\\tbinom",
    "\\\\atopfrac",
    // can’t be entered directly
    "\\\\bracefrac",
    "\\\\brackfrac"
    // ditto
  ],
  props: {
    numArgs: 2,
    allowedInArgument: !0
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0], r = e[1], i, o = null, a = null, c = "auto";
    switch (n) {
      case "\\dfrac":
      case "\\frac":
      case "\\tfrac":
        i = !0;
        break;
      case "\\\\atopfrac":
        i = !1;
        break;
      case "\\dbinom":
      case "\\binom":
      case "\\tbinom":
        i = !1, o = "(", a = ")";
        break;
      case "\\\\bracefrac":
        i = !1, o = "\\{", a = "\\}";
        break;
      case "\\\\brackfrac":
        i = !1, o = "[", a = "]";
        break;
      default:
        throw new Error("Unrecognized genfrac command");
    }
    switch (n) {
      case "\\dfrac":
      case "\\dbinom":
        c = "display";
        break;
      case "\\tfrac":
      case "\\tbinom":
        c = "text";
        break;
    }
    return {
      type: "genfrac",
      mode: A.mode,
      continued: !1,
      numer: s,
      denom: r,
      hasBarLine: i,
      leftDelim: o,
      rightDelim: a,
      size: c,
      barSize: null
    };
  },
  htmlBuilder: Em,
  mathmlBuilder: Mm
});
Ye({
  type: "genfrac",
  names: ["\\cfrac"],
  props: {
    numArgs: 2
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0], r = e[1];
    return {
      type: "genfrac",
      mode: A.mode,
      continued: !0,
      numer: s,
      denom: r,
      hasBarLine: !0,
      leftDelim: null,
      rightDelim: null,
      size: "display",
      barSize: null
    };
  }
});
Ye({
  type: "infix",
  names: ["\\over", "\\choose", "\\atop", "\\brace", "\\brack"],
  props: {
    numArgs: 0,
    infix: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A,
      token: n
    } = t, s;
    switch (A) {
      case "\\over":
        s = "\\frac";
        break;
      case "\\choose":
        s = "\\binom";
        break;
      case "\\atop":
        s = "\\\\atopfrac";
        break;
      case "\\brace":
        s = "\\\\bracefrac";
        break;
      case "\\brack":
        s = "\\\\brackfrac";
        break;
      default:
        throw new Error("Unrecognized infix genfrac command");
    }
    return {
      type: "infix",
      mode: e.mode,
      replaceWith: s,
      token: n
    };
  }
});
var PF = ["display", "text", "script", "scriptscript"], KF = function(e) {
  var A = null;
  return e.length > 0 && (A = e, A = A === "." ? null : A), A;
};
Ye({
  type: "genfrac",
  names: ["\\genfrac"],
  props: {
    numArgs: 6,
    allowedInArgument: !0,
    argTypes: ["math", "math", "size", "text", "math", "math"]
  },
  handler(t, e) {
    var {
      parser: A
    } = t, n = e[4], s = e[5], r = Wd(e[0]), i = r.type === "atom" && r.family === "open" ? KF(r.text) : null, o = Wd(e[1]), a = o.type === "atom" && o.family === "close" ? KF(o.text) : null, c = it(e[2], "size"), l, B = null;
    c.isBlank ? l = !0 : (B = c.value, l = B.number > 0);
    var g = "auto", h = e[3];
    if (h.type === "ordgroup") {
      if (h.body.length > 0) {
        var u = it(h.body[0], "textord");
        g = PF[Number(u.text)];
      }
    } else
      h = it(h, "textord"), g = PF[Number(h.text)];
    return {
      type: "genfrac",
      mode: A.mode,
      numer: n,
      denom: s,
      continued: !1,
      hasBarLine: l,
      barSize: B,
      leftDelim: i,
      rightDelim: a,
      size: g
    };
  },
  htmlBuilder: Em,
  mathmlBuilder: Mm
});
Ye({
  type: "infix",
  names: ["\\above"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    infix: !0
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n,
      token: s
    } = t;
    return {
      type: "infix",
      mode: A.mode,
      replaceWith: "\\\\abovefrac",
      size: it(e[0], "size").value,
      token: s
    };
  }
});
Ye({
  type: "genfrac",
  names: ["\\\\abovefrac"],
  props: {
    numArgs: 3,
    argTypes: ["math", "size", "math"]
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0], r = o$(it(e[1], "infix").size), i = e[2], o = r.number > 0;
    return {
      type: "genfrac",
      mode: A.mode,
      numer: s,
      denom: i,
      continued: !1,
      hasBarLine: o,
      barSize: r,
      leftDelim: null,
      rightDelim: null,
      size: "auto"
    };
  },
  htmlBuilder: Em,
  mathmlBuilder: Mm
});
var av = (t, e) => {
  var A = e.style, n, s;
  t.type === "supsub" ? (n = t.sup ? Ft(t.sup, e.havingStyle(A.sup()), e) : Ft(t.sub, e.havingStyle(A.sub()), e), s = it(t.base, "horizBrace")) : s = it(t, "horizBrace");
  var r = Ft(s.base, e.havingBaseStyle(Je.DISPLAY)), i = Wi.svgSpan(s, e), o;
  if (s.isOver ? (o = O.makeVList({
    positionType: "firstBaseline",
    children: [{
      type: "elem",
      elem: r
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: i
    }]
  }, e), o.children[0].children[0].children[1].classes.push("svg-align")) : (o = O.makeVList({
    positionType: "bottom",
    positionData: r.depth + 0.1 + i.height,
    children: [{
      type: "elem",
      elem: i
    }, {
      type: "kern",
      size: 0.1
    }, {
      type: "elem",
      elem: r
    }]
  }, e), o.children[0].children[0].children[0].classes.push("svg-align")), n) {
    var a = O.makeSpan(["mord", s.isOver ? "mover" : "munder"], [o], e);
    s.isOver ? o = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: a
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: n
      }]
    }, e) : o = O.makeVList({
      positionType: "bottom",
      positionData: a.depth + 0.2 + n.height + n.depth,
      children: [{
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: 0.2
      }, {
        type: "elem",
        elem: a
      }]
    }, e);
  }
  return O.makeSpan(["mord", s.isOver ? "mover" : "munder"], [o], e);
}, zee = (t, e) => {
  var A = Wi.mathMLnode(t.label);
  return new ge.MathNode(t.isOver ? "mover" : "munder", [Tt(t.base, e), A]);
};
Ye({
  type: "horizBrace",
  names: ["\\overbrace", "\\underbrace"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t;
    return {
      type: "horizBrace",
      mode: A.mode,
      label: n,
      isOver: /^\\over/.test(n),
      base: e[0]
    };
  },
  htmlBuilder: av,
  mathmlBuilder: zee
});
Ye({
  type: "href",
  names: ["\\href"],
  props: {
    numArgs: 2,
    argTypes: ["url", "original"],
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = e[1], s = it(e[0], "url").url;
    return A.settings.isTrusted({
      command: "\\href",
      url: s
    }) ? {
      type: "href",
      mode: A.mode,
      href: s,
      body: dA(n)
    } : A.formatUnsupportedCmd("\\href");
  },
  htmlBuilder: (t, e) => {
    var A = yA(t.body, e, !1);
    return O.makeAnchor(t.href, [], A, e);
  },
  mathmlBuilder: (t, e) => {
    var A = ra(t.body, e);
    return A instanceof Bs || (A = new Bs("mrow", [A])), A.setAttribute("href", t.href), A;
  }
});
Ye({
  type: "href",
  names: ["\\url"],
  props: {
    numArgs: 1,
    argTypes: ["url"],
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = it(e[0], "url").url;
    if (!A.settings.isTrusted({
      command: "\\url",
      url: n
    }))
      return A.formatUnsupportedCmd("\\url");
    for (var s = [], r = 0; r < n.length; r++) {
      var i = n[r];
      i === "~" && (i = "\\textasciitilde"), s.push({
        type: "textord",
        mode: "text",
        text: i
      });
    }
    var o = {
      type: "text",
      mode: A.mode,
      font: "\\texttt",
      body: s
    };
    return {
      type: "href",
      mode: A.mode,
      href: n,
      body: dA(o)
    };
  }
});
Ye({
  type: "hbox",
  names: ["\\hbox"],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInText: !0,
    primitive: !0
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "hbox",
      mode: A.mode,
      body: dA(e[0])
    };
  },
  htmlBuilder(t, e) {
    var A = yA(t.body, e, !1);
    return O.makeFragment(A);
  },
  mathmlBuilder(t, e) {
    return new ge.MathNode("mrow", es(t.body, e));
  }
});
Ye({
  type: "html",
  names: ["\\htmlClass", "\\htmlId", "\\htmlStyle", "\\htmlData"],
  props: {
    numArgs: 2,
    argTypes: ["raw", "original"],
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n,
      token: s
    } = t, r = it(e[0], "raw").string, i = e[1];
    A.settings.strict && A.settings.reportNonstrict("htmlExtension", "HTML extension is disabled on strict mode");
    var o, a = {};
    switch (n) {
      case "\\htmlClass":
        a.class = r, o = {
          command: "\\htmlClass",
          class: r
        };
        break;
      case "\\htmlId":
        a.id = r, o = {
          command: "\\htmlId",
          id: r
        };
        break;
      case "\\htmlStyle":
        a.style = r, o = {
          command: "\\htmlStyle",
          style: r
        };
        break;
      case "\\htmlData": {
        for (var c = r.split(","), l = 0; l < c.length; l++) {
          var B = c[l], g = B.indexOf("=");
          if (g < 0)
            throw new de("\\htmlData key/value '" + B + "' missing equals sign");
          var h = B.slice(0, g), u = B.slice(g + 1);
          a["data-" + h.trim()] = u;
        }
        o = {
          command: "\\htmlData",
          attributes: a
        };
        break;
      }
      default:
        throw new Error("Unrecognized html command");
    }
    return A.settings.isTrusted(o) ? {
      type: "html",
      mode: A.mode,
      attributes: a,
      body: dA(i)
    } : A.formatUnsupportedCmd(n);
  },
  htmlBuilder: (t, e) => {
    var A = yA(t.body, e, !1), n = ["enclosing"];
    t.attributes.class && n.push(...t.attributes.class.trim().split(/\s+/));
    var s = O.makeSpan(n, A, e);
    for (var r in t.attributes)
      r !== "class" && t.attributes.hasOwnProperty(r) && s.setAttribute(r, t.attributes[r]);
    return s;
  },
  mathmlBuilder: (t, e) => ra(t.body, e)
});
Ye({
  type: "htmlmathml",
  names: ["\\html@mathml"],
  props: {
    numArgs: 2,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t;
    return {
      type: "htmlmathml",
      mode: A.mode,
      html: dA(e[0]),
      mathml: dA(e[1])
    };
  },
  htmlBuilder: (t, e) => {
    var A = yA(t.html, e, !1);
    return O.makeFragment(A);
  },
  mathmlBuilder: (t, e) => ra(t.mathml, e)
});
var uI = function(e) {
  if (/^[-+]? *(\d+(\.\d*)?|\.\d+)$/.test(e))
    return {
      number: +e,
      unit: "bp"
    };
  var A = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(e);
  if (!A)
    throw new de("Invalid size: '" + e + "' in \\includegraphics");
  var n = {
    number: +(A[1] + A[2]),
    // sign + magnitude, cast to number
    unit: A[3]
  };
  if (!Fb(n))
    throw new de("Invalid unit: '" + n.unit + "' in \\includegraphics.");
  return n;
};
Ye({
  type: "includegraphics",
  names: ["\\includegraphics"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    argTypes: ["raw", "url"],
    allowedInText: !1
  },
  handler: (t, e, A) => {
    var {
      parser: n
    } = t, s = {
      number: 0,
      unit: "em"
    }, r = {
      number: 0.9,
      unit: "em"
    }, i = {
      number: 0,
      unit: "em"
    }, o = "";
    if (A[0])
      for (var a = it(A[0], "raw").string, c = a.split(","), l = 0; l < c.length; l++) {
        var B = c[l].split("=");
        if (B.length === 2) {
          var g = B[1].trim();
          switch (B[0].trim()) {
            case "alt":
              o = g;
              break;
            case "width":
              s = uI(g);
              break;
            case "height":
              r = uI(g);
              break;
            case "totalheight":
              i = uI(g);
              break;
            default:
              throw new de("Invalid key: '" + B[0] + "' in \\includegraphics.");
          }
        }
      }
    var h = it(e[0], "url").url;
    return o === "" && (o = h, o = o.replace(/^.*[\\/]/, ""), o = o.substring(0, o.lastIndexOf("."))), n.settings.isTrusted({
      command: "\\includegraphics",
      url: h
    }) ? {
      type: "includegraphics",
      mode: n.mode,
      alt: o,
      width: s,
      height: r,
      totalheight: i,
      src: h
    } : n.formatUnsupportedCmd("\\includegraphics");
  },
  htmlBuilder: (t, e) => {
    var A = nA(t.height, e), n = 0;
    t.totalheight.number > 0 && (n = nA(t.totalheight, e) - A);
    var s = 0;
    t.width.number > 0 && (s = nA(t.width, e));
    var r = {
      height: Ie(A + n)
    };
    s > 0 && (r.width = Ie(s)), n > 0 && (r.verticalAlign = Ie(-n));
    var i = new z$(t.src, t.alt, r);
    return i.height = A, i.depth = n, i;
  },
  mathmlBuilder: (t, e) => {
    var A = new ge.MathNode("mglyph", []);
    A.setAttribute("alt", t.alt);
    var n = nA(t.height, e), s = 0;
    if (t.totalheight.number > 0 && (s = nA(t.totalheight, e) - n, A.setAttribute("valign", Ie(-s))), A.setAttribute("height", Ie(n + s)), t.width.number > 0) {
      var r = nA(t.width, e);
      A.setAttribute("width", Ie(r));
    }
    return A.setAttribute("src", t.src), A;
  }
});
Ye({
  type: "kern",
  names: ["\\kern", "\\mkern", "\\hskip", "\\mskip"],
  props: {
    numArgs: 1,
    argTypes: ["size"],
    primitive: !0,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t, s = it(e[0], "size");
    if (A.settings.strict) {
      var r = n[1] === "m", i = s.value.unit === "mu";
      r ? (i || A.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + n + " supports only mu units, " + ("not " + s.value.unit + " units")), A.mode !== "math" && A.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + n + " works only in math mode")) : i && A.settings.reportNonstrict("mathVsTextUnits", "LaTeX's " + n + " doesn't support mu units");
    }
    return {
      type: "kern",
      mode: A.mode,
      dimension: s.value
    };
  },
  htmlBuilder(t, e) {
    return O.makeGlue(t.dimension, e);
  },
  mathmlBuilder(t, e) {
    var A = nA(t.dimension, e);
    return new ge.SpaceNode(A);
  }
});
Ye({
  type: "lap",
  names: ["\\mathllap", "\\mathrlap", "\\mathclap"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    return {
      type: "lap",
      mode: A.mode,
      alignment: n.slice(5),
      body: s
    };
  },
  htmlBuilder: (t, e) => {
    var A;
    t.alignment === "clap" ? (A = O.makeSpan([], [Ft(t.body, e)]), A = O.makeSpan(["inner"], [A], e)) : A = O.makeSpan(["inner"], [Ft(t.body, e)]);
    var n = O.makeSpan(["fix"], []), s = O.makeSpan([t.alignment], [A, n], e), r = O.makeSpan(["strut"]);
    return r.style.height = Ie(s.height + s.depth), s.depth && (r.style.verticalAlign = Ie(-s.depth)), s.children.unshift(r), s = O.makeSpan(["thinbox"], [s], e), O.makeSpan(["mord", "vbox"], [s], e);
  },
  mathmlBuilder: (t, e) => {
    var A = new ge.MathNode("mpadded", [Tt(t.body, e)]);
    if (t.alignment !== "rlap") {
      var n = t.alignment === "llap" ? "-1" : "-0.5";
      A.setAttribute("lspace", n + "width");
    }
    return A.setAttribute("width", "0px"), A;
  }
});
Ye({
  type: "styling",
  names: ["\\(", "$"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(t, e) {
    var {
      funcName: A,
      parser: n
    } = t, s = n.mode;
    n.switchMode("math");
    var r = A === "\\(" ? "\\)" : "$", i = n.parseExpression(!1, r);
    return n.expect(r), n.switchMode(s), {
      type: "styling",
      mode: n.mode,
      style: "text",
      body: i
    };
  }
});
Ye({
  type: "text",
  // Doesn't matter what this is.
  names: ["\\)", "\\]"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInMath: !1
  },
  handler(t, e) {
    throw new de("Mismatched " + t.funcName);
  }
});
var VF = (t, e) => {
  switch (e.style.size) {
    case Je.DISPLAY.size:
      return t.display;
    case Je.TEXT.size:
      return t.text;
    case Je.SCRIPT.size:
      return t.script;
    case Je.SCRIPTSCRIPT.size:
      return t.scriptscript;
    default:
      return t.text;
  }
};
Ye({
  type: "mathchoice",
  names: ["\\mathchoice"],
  props: {
    numArgs: 4,
    primitive: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t;
    return {
      type: "mathchoice",
      mode: A.mode,
      display: dA(e[0]),
      text: dA(e[1]),
      script: dA(e[2]),
      scriptscript: dA(e[3])
    };
  },
  htmlBuilder: (t, e) => {
    var A = VF(t, e), n = yA(A, e, !1);
    return O.makeFragment(n);
  },
  mathmlBuilder: (t, e) => {
    var A = VF(t, e);
    return ra(A, e);
  }
});
var cv = (t, e, A, n, s, r, i) => {
  t = O.makeSpan([], [t]);
  var o = A && Dt.isCharacterBox(A), a, c;
  if (e) {
    var l = Ft(e, n.havingStyle(s.sup()), n);
    c = {
      elem: l,
      kern: Math.max(n.fontMetrics().bigOpSpacing1, n.fontMetrics().bigOpSpacing3 - l.depth)
    };
  }
  if (A) {
    var B = Ft(A, n.havingStyle(s.sub()), n);
    a = {
      elem: B,
      kern: Math.max(n.fontMetrics().bigOpSpacing2, n.fontMetrics().bigOpSpacing4 - B.height)
    };
  }
  var g;
  if (c && a) {
    var h = n.fontMetrics().bigOpSpacing5 + a.elem.height + a.elem.depth + a.kern + t.depth + i;
    g = O.makeVList({
      positionType: "bottom",
      positionData: h,
      children: [{
        type: "kern",
        size: n.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: a.elem,
        marginLeft: Ie(-r)
      }, {
        type: "kern",
        size: a.kern
      }, {
        type: "elem",
        elem: t
      }, {
        type: "kern",
        size: c.kern
      }, {
        type: "elem",
        elem: c.elem,
        marginLeft: Ie(r)
      }, {
        type: "kern",
        size: n.fontMetrics().bigOpSpacing5
      }]
    }, n);
  } else if (a) {
    var u = t.height - i;
    g = O.makeVList({
      positionType: "top",
      positionData: u,
      children: [{
        type: "kern",
        size: n.fontMetrics().bigOpSpacing5
      }, {
        type: "elem",
        elem: a.elem,
        marginLeft: Ie(-r)
      }, {
        type: "kern",
        size: a.kern
      }, {
        type: "elem",
        elem: t
      }]
    }, n);
  } else if (c) {
    var d = t.depth + i;
    g = O.makeVList({
      positionType: "bottom",
      positionData: d,
      children: [{
        type: "elem",
        elem: t
      }, {
        type: "kern",
        size: c.kern
      }, {
        type: "elem",
        elem: c.elem,
        marginLeft: Ie(r)
      }, {
        type: "kern",
        size: n.fontMetrics().bigOpSpacing5
      }]
    }, n);
  } else
    return t;
  var w = [g];
  if (a && r !== 0 && !o) {
    var Q = O.makeSpan(["mspace"], [], n);
    Q.style.marginRight = Ie(r), w.unshift(Q);
  }
  return O.makeSpan(["mop", "op-limits"], w, n);
}, lv = ["\\smallint"], Vl = (t, e) => {
  var A, n, s = !1, r;
  t.type === "supsub" ? (A = t.sup, n = t.sub, r = it(t.base, "op"), s = !0) : r = it(t, "op");
  var i = e.style, o = !1;
  i.size === Je.DISPLAY.size && r.symbol && !lv.includes(r.name) && (o = !0);
  var a;
  if (r.symbol) {
    var c = o ? "Size2-Regular" : "Size1-Regular", l = "";
    if ((r.name === "\\oiint" || r.name === "\\oiiint") && (l = r.name.slice(1), r.name = l === "oiint" ? "\\iint" : "\\iiint"), a = O.makeSymbol(r.name, c, "math", e, ["mop", "op-symbol", o ? "large-op" : "small-op"]), l.length > 0) {
      var B = a.italic, g = O.staticSvg(l + "Size" + (o ? "2" : "1"), e);
      a = O.makeVList({
        positionType: "individualShift",
        children: [{
          type: "elem",
          elem: a,
          shift: 0
        }, {
          type: "elem",
          elem: g,
          shift: o ? 0.08 : 0
        }]
      }, e), r.name = "\\" + l, a.classes.unshift("mop"), a.italic = B;
    }
  } else if (r.body) {
    var h = yA(r.body, e, !0);
    h.length === 1 && h[0] instanceof Ss ? (a = h[0], a.classes[0] = "mop") : a = O.makeSpan(["mop"], h, e);
  } else {
    for (var u = [], d = 1; d < r.name.length; d++)
      u.push(O.mathsym(r.name[d], r.mode, e));
    a = O.makeSpan(["mop"], u, e);
  }
  var w = 0, Q = 0;
  return (a instanceof Ss || r.name === "\\oiint" || r.name === "\\oiiint") && !r.suppressBaseShift && (w = (a.height - a.depth) / 2 - e.fontMetrics().axisHeight, Q = a.italic), s ? cv(a, A, n, e, i, Q, w) : (w && (a.style.position = "relative", a.style.top = Ie(w)), a);
}, Yh = (t, e) => {
  var A;
  if (t.symbol)
    A = new Bs("mo", [Ts(t.name, t.mode)]), lv.includes(t.name) && A.setAttribute("largeop", "false");
  else if (t.body)
    A = new Bs("mo", es(t.body, e));
  else {
    A = new Bs("mi", [new xr(t.name.slice(1))]);
    var n = new Bs("mo", [Ts("⁡", "text")]);
    t.parentIsSupSub ? A = new Bs("mrow", [A, n]) : A = kb([A, n]);
  }
  return A;
}, Uee = {
  "∏": "\\prod",
  "∐": "\\coprod",
  "∑": "\\sum",
  "⋀": "\\bigwedge",
  "⋁": "\\bigvee",
  "⋂": "\\bigcap",
  "⋃": "\\bigcup",
  "⨀": "\\bigodot",
  "⨁": "\\bigoplus",
  "⨂": "\\bigotimes",
  "⨄": "\\biguplus",
  "⨆": "\\bigsqcup"
};
Ye({
  type: "op",
  names: ["\\coprod", "\\bigvee", "\\bigwedge", "\\biguplus", "\\bigcap", "\\bigcup", "\\intop", "\\prod", "\\sum", "\\bigotimes", "\\bigoplus", "\\bigodot", "\\bigsqcup", "\\smallint", "∏", "∐", "∑", "⋀", "⋁", "⋂", "⋃", "⨀", "⨁", "⨂", "⨄", "⨆"],
  props: {
    numArgs: 0
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = n;
    return s.length === 1 && (s = Uee[s]), {
      type: "op",
      mode: A.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !0,
      name: s
    };
  },
  htmlBuilder: Vl,
  mathmlBuilder: Yh
});
Ye({
  type: "op",
  names: ["\\mathop"],
  props: {
    numArgs: 1,
    primitive: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = e[0];
    return {
      type: "op",
      mode: A.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      body: dA(n)
    };
  },
  htmlBuilder: Vl,
  mathmlBuilder: Yh
});
var bee = {
  "∫": "\\int",
  "∬": "\\iint",
  "∭": "\\iiint",
  "∮": "\\oint",
  "∯": "\\oiint",
  "∰": "\\oiiint"
};
Ye({
  type: "op",
  names: ["\\arcsin", "\\arccos", "\\arctan", "\\arctg", "\\arcctg", "\\arg", "\\ch", "\\cos", "\\cosec", "\\cosh", "\\cot", "\\cotg", "\\coth", "\\csc", "\\ctg", "\\cth", "\\deg", "\\dim", "\\exp", "\\hom", "\\ker", "\\lg", "\\ln", "\\log", "\\sec", "\\sin", "\\sinh", "\\sh", "\\tan", "\\tanh", "\\tg", "\\th"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t;
    return {
      type: "op",
      mode: e.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !1,
      name: A
    };
  },
  htmlBuilder: Vl,
  mathmlBuilder: Yh
});
Ye({
  type: "op",
  names: ["\\det", "\\gcd", "\\inf", "\\lim", "\\max", "\\min", "\\Pr", "\\sup"],
  props: {
    numArgs: 0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t;
    return {
      type: "op",
      mode: e.mode,
      limits: !0,
      parentIsSupSub: !1,
      symbol: !1,
      name: A
    };
  },
  htmlBuilder: Vl,
  mathmlBuilder: Yh
});
Ye({
  type: "op",
  names: ["\\int", "\\iint", "\\iiint", "\\oint", "\\oiint", "\\oiiint", "∫", "∬", "∭", "∮", "∯", "∰"],
  props: {
    numArgs: 0,
    allowedInArgument: !0
  },
  handler(t) {
    var {
      parser: e,
      funcName: A
    } = t, n = A;
    return n.length === 1 && (n = bee[n]), {
      type: "op",
      mode: e.mode,
      limits: !1,
      parentIsSupSub: !1,
      symbol: !0,
      name: n
    };
  },
  htmlBuilder: Vl,
  mathmlBuilder: Yh
});
var Bv = (t, e) => {
  var A, n, s = !1, r;
  t.type === "supsub" ? (A = t.sup, n = t.sub, r = it(t.base, "operatorname"), s = !0) : r = it(t, "operatorname");
  var i;
  if (r.body.length > 0) {
    for (var o = r.body.map((B) => {
      var g = B.text;
      return typeof g == "string" ? {
        type: "textord",
        mode: B.mode,
        text: g
      } : B;
    }), a = yA(o, e.withFont("mathrm"), !0), c = 0; c < a.length; c++) {
      var l = a[c];
      l instanceof Ss && (l.text = l.text.replace(/\u2212/, "-").replace(/\u2217/, "*"));
    }
    i = O.makeSpan(["mop"], a, e);
  } else
    i = O.makeSpan(["mop"], [], e);
  return s ? cv(i, A, n, e, e.style, 0, 0) : i;
}, vee = (t, e) => {
  for (var A = es(t.body, e.withFont("mathrm")), n = !0, s = 0; s < A.length; s++) {
    var r = A[s];
    if (!(r instanceof ge.SpaceNode)) if (r instanceof ge.MathNode)
      switch (r.type) {
        case "mi":
        case "mn":
        case "ms":
        case "mspace":
        case "mtext":
          break;
        // Do nothing yet.
        case "mo": {
          var i = r.children[0];
          r.children.length === 1 && i instanceof ge.TextNode ? i.text = i.text.replace(/\u2212/, "-").replace(/\u2217/, "*") : n = !1;
          break;
        }
        default:
          n = !1;
      }
    else
      n = !1;
  }
  if (n) {
    var o = A.map((l) => l.toText()).join("");
    A = [new ge.TextNode(o)];
  }
  var a = new ge.MathNode("mi", A);
  a.setAttribute("mathvariant", "normal");
  var c = new ge.MathNode("mo", [Ts("⁡", "text")]);
  return t.parentIsSupSub ? new ge.MathNode("mrow", [a, c]) : ge.newDocumentFragment([a, c]);
};
Ye({
  type: "operatorname",
  names: ["\\operatorname@", "\\operatornamewithlimits"],
  props: {
    numArgs: 1
  },
  handler: (t, e) => {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    return {
      type: "operatorname",
      mode: A.mode,
      body: dA(s),
      alwaysHandleSupSub: n === "\\operatornamewithlimits",
      limits: !1,
      parentIsSupSub: !1
    };
  },
  htmlBuilder: Bv,
  mathmlBuilder: vee
});
z("\\operatorname", "\\@ifstar\\operatornamewithlimits\\operatorname@");
gc({
  type: "ordgroup",
  htmlBuilder(t, e) {
    return t.semisimple ? O.makeFragment(yA(t.body, e, !1)) : O.makeSpan(["mord"], yA(t.body, e, !0), e);
  },
  mathmlBuilder(t, e) {
    return ra(t.body, e, !0);
  }
});
Ye({
  type: "overline",
  names: ["\\overline"],
  props: {
    numArgs: 1
  },
  handler(t, e) {
    var {
      parser: A
    } = t, n = e[0];
    return {
      type: "overline",
      mode: A.mode,
      body: n
    };
  },
  htmlBuilder(t, e) {
    var A = Ft(t.body, e.havingCrampedStyle()), n = O.makeLineSpan("overline-line", e), s = e.fontMetrics().defaultRuleThickness, r = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: A
      }, {
        type: "kern",
        size: 3 * s
      }, {
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: s
      }]
    }, e);
    return O.makeSpan(["mord", "overline"], [r], e);
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mo", [new ge.TextNode("‾")]);
    A.setAttribute("stretchy", "true");
    var n = new ge.MathNode("mover", [Tt(t.body, e), A]);
    return n.setAttribute("accent", "true"), n;
  }
});
Ye({
  type: "phantom",
  names: ["\\phantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = e[0];
    return {
      type: "phantom",
      mode: A.mode,
      body: dA(n)
    };
  },
  htmlBuilder: (t, e) => {
    var A = yA(t.body, e.withPhantom(), !1);
    return O.makeFragment(A);
  },
  mathmlBuilder: (t, e) => {
    var A = es(t.body, e);
    return new ge.MathNode("mphantom", A);
  }
});
Ye({
  type: "hphantom",
  names: ["\\hphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = e[0];
    return {
      type: "hphantom",
      mode: A.mode,
      body: n
    };
  },
  htmlBuilder: (t, e) => {
    var A = O.makeSpan([], [Ft(t.body, e.withPhantom())]);
    if (A.height = 0, A.depth = 0, A.children)
      for (var n = 0; n < A.children.length; n++)
        A.children[n].height = 0, A.children[n].depth = 0;
    return A = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: A
      }]
    }, e), O.makeSpan(["mord"], [A], e);
  },
  mathmlBuilder: (t, e) => {
    var A = es(dA(t.body), e), n = new ge.MathNode("mphantom", A), s = new ge.MathNode("mpadded", [n]);
    return s.setAttribute("height", "0px"), s.setAttribute("depth", "0px"), s;
  }
});
Ye({
  type: "vphantom",
  names: ["\\vphantom"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      parser: A
    } = t, n = e[0];
    return {
      type: "vphantom",
      mode: A.mode,
      body: n
    };
  },
  htmlBuilder: (t, e) => {
    var A = O.makeSpan(["inner"], [Ft(t.body, e.withPhantom())]), n = O.makeSpan(["fix"], []);
    return O.makeSpan(["mord", "rlap"], [A, n], e);
  },
  mathmlBuilder: (t, e) => {
    var A = es(dA(t.body), e), n = new ge.MathNode("mphantom", A), s = new ge.MathNode("mpadded", [n]);
    return s.setAttribute("width", "0px"), s;
  }
});
Ye({
  type: "raisebox",
  names: ["\\raisebox"],
  props: {
    numArgs: 2,
    argTypes: ["size", "hbox"],
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: A
    } = t, n = it(e[0], "size").value, s = e[1];
    return {
      type: "raisebox",
      mode: A.mode,
      dy: n,
      body: s
    };
  },
  htmlBuilder(t, e) {
    var A = Ft(t.body, e), n = nA(t.dy, e);
    return O.makeVList({
      positionType: "shift",
      positionData: -n,
      children: [{
        type: "elem",
        elem: A
      }]
    }, e);
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mpadded", [Tt(t.body, e)]), n = t.dy.number + t.dy.unit;
    return A.setAttribute("voffset", n), A;
  }
});
Ye({
  type: "internal",
  names: ["\\relax"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    allowedInArgument: !0
  },
  handler(t) {
    var {
      parser: e
    } = t;
    return {
      type: "internal",
      mode: e.mode
    };
  }
});
Ye({
  type: "rule",
  names: ["\\rule"],
  props: {
    numArgs: 2,
    numOptionalArgs: 1,
    allowedInText: !0,
    allowedInMath: !0,
    argTypes: ["size", "size", "size"]
  },
  handler(t, e, A) {
    var {
      parser: n
    } = t, s = A[0], r = it(e[0], "size"), i = it(e[1], "size");
    return {
      type: "rule",
      mode: n.mode,
      shift: s && it(s, "size").value,
      width: r.value,
      height: i.value
    };
  },
  htmlBuilder(t, e) {
    var A = O.makeSpan(["mord", "rule"], [], e), n = nA(t.width, e), s = nA(t.height, e), r = t.shift ? nA(t.shift, e) : 0;
    return A.style.borderRightWidth = Ie(n), A.style.borderTopWidth = Ie(s), A.style.bottom = Ie(r), A.width = n, A.height = s + r, A.depth = -r, A.maxFontSize = s * 1.125 * e.sizeMultiplier, A;
  },
  mathmlBuilder(t, e) {
    var A = nA(t.width, e), n = nA(t.height, e), s = t.shift ? nA(t.shift, e) : 0, r = e.color && e.getColor() || "black", i = new ge.MathNode("mspace");
    i.setAttribute("mathbackground", r), i.setAttribute("width", Ie(A)), i.setAttribute("height", Ie(n));
    var o = new ge.MathNode("mpadded", [i]);
    return s >= 0 ? o.setAttribute("height", Ie(s)) : (o.setAttribute("height", Ie(s)), o.setAttribute("depth", Ie(-s))), o.setAttribute("voffset", Ie(s)), o;
  }
});
function gv(t, e, A) {
  for (var n = yA(t, e, !1), s = e.sizeMultiplier / A.sizeMultiplier, r = 0; r < n.length; r++) {
    var i = n[r].classes.indexOf("sizing");
    i < 0 ? Array.prototype.push.apply(n[r].classes, e.sizingClasses(A)) : n[r].classes[i + 1] === "reset-size" + e.size && (n[r].classes[i + 1] = "reset-size" + A.size), n[r].height *= s, n[r].depth *= s;
  }
  return O.makeFragment(n);
}
var XF = ["\\tiny", "\\sixptsize", "\\scriptsize", "\\footnotesize", "\\small", "\\normalsize", "\\large", "\\Large", "\\LARGE", "\\huge", "\\Huge"], jee = (t, e) => {
  var A = e.havingSize(t.size);
  return gv(t.body, A, e);
};
Ye({
  type: "sizing",
  names: XF,
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler: (t, e) => {
    var {
      breakOnTokenText: A,
      funcName: n,
      parser: s
    } = t, r = s.parseExpression(!1, A);
    return {
      type: "sizing",
      mode: s.mode,
      // Figure out what size to use based on the list of functions above
      size: XF.indexOf(n) + 1,
      body: r
    };
  },
  htmlBuilder: jee,
  mathmlBuilder: (t, e) => {
    var A = e.havingSize(t.size), n = es(t.body, A), s = new ge.MathNode("mstyle", n);
    return s.setAttribute("mathsize", Ie(A.sizeMultiplier)), s;
  }
});
Ye({
  type: "smash",
  names: ["\\smash"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1,
    allowedInText: !0
  },
  handler: (t, e, A) => {
    var {
      parser: n
    } = t, s = !1, r = !1, i = A[0] && it(A[0], "ordgroup");
    if (i)
      for (var o = "", a = 0; a < i.body.length; ++a) {
        var c = i.body[a];
        if (o = c.text, o === "t")
          s = !0;
        else if (o === "b")
          r = !0;
        else {
          s = !1, r = !1;
          break;
        }
      }
    else
      s = !0, r = !0;
    var l = e[0];
    return {
      type: "smash",
      mode: n.mode,
      body: l,
      smashHeight: s,
      smashDepth: r
    };
  },
  htmlBuilder: (t, e) => {
    var A = O.makeSpan([], [Ft(t.body, e)]);
    if (!t.smashHeight && !t.smashDepth)
      return A;
    if (t.smashHeight && (A.height = 0, A.children))
      for (var n = 0; n < A.children.length; n++)
        A.children[n].height = 0;
    if (t.smashDepth && (A.depth = 0, A.children))
      for (var s = 0; s < A.children.length; s++)
        A.children[s].depth = 0;
    var r = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: A
      }]
    }, e);
    return O.makeSpan(["mord"], [r], e);
  },
  mathmlBuilder: (t, e) => {
    var A = new ge.MathNode("mpadded", [Tt(t.body, e)]);
    return t.smashHeight && A.setAttribute("height", "0px"), t.smashDepth && A.setAttribute("depth", "0px"), A;
  }
});
Ye({
  type: "sqrt",
  names: ["\\sqrt"],
  props: {
    numArgs: 1,
    numOptionalArgs: 1
  },
  handler(t, e, A) {
    var {
      parser: n
    } = t, s = A[0], r = e[0];
    return {
      type: "sqrt",
      mode: n.mode,
      body: r,
      index: s
    };
  },
  htmlBuilder(t, e) {
    var A = Ft(t.body, e.havingCrampedStyle());
    A.height === 0 && (A.height = e.fontMetrics().xHeight), A = O.wrapFragment(A, e);
    var n = e.fontMetrics(), s = n.defaultRuleThickness, r = s;
    e.style.id < Je.TEXT.id && (r = e.fontMetrics().xHeight);
    var i = s + r / 4, o = A.height + A.depth + i + s, {
      span: a,
      ruleWidth: c,
      advanceWidth: l
    } = Hi.sqrtImage(o, e), B = a.height - c;
    B > A.height + A.depth + i && (i = (i + B - A.height - A.depth) / 2);
    var g = a.height - A.height - i - c;
    A.style.paddingLeft = Ie(l);
    var h = O.makeVList({
      positionType: "firstBaseline",
      children: [{
        type: "elem",
        elem: A,
        wrapperClasses: ["svg-align"]
      }, {
        type: "kern",
        size: -(A.height + g)
      }, {
        type: "elem",
        elem: a
      }, {
        type: "kern",
        size: c
      }]
    }, e);
    if (t.index) {
      var u = e.havingStyle(Je.SCRIPTSCRIPT), d = Ft(t.index, u, e), w = 0.6 * (h.height - h.depth), Q = O.makeVList({
        positionType: "shift",
        positionData: -w,
        children: [{
          type: "elem",
          elem: d
        }]
      }, e), p = O.makeSpan(["root"], [Q]);
      return O.makeSpan(["mord", "sqrt"], [p, h], e);
    } else
      return O.makeSpan(["mord", "sqrt"], [h], e);
  },
  mathmlBuilder(t, e) {
    var {
      body: A,
      index: n
    } = t;
    return n ? new ge.MathNode("mroot", [Tt(A, e), Tt(n, e)]) : new ge.MathNode("msqrt", [Tt(A, e)]);
  }
});
var ZF = {
  display: Je.DISPLAY,
  text: Je.TEXT,
  script: Je.SCRIPT,
  scriptscript: Je.SCRIPTSCRIPT
};
Ye({
  type: "styling",
  names: ["\\displaystyle", "\\textstyle", "\\scriptstyle", "\\scriptscriptstyle"],
  props: {
    numArgs: 0,
    allowedInText: !0,
    primitive: !0
  },
  handler(t, e) {
    var {
      breakOnTokenText: A,
      funcName: n,
      parser: s
    } = t, r = s.parseExpression(!0, A), i = n.slice(1, n.length - 5);
    return {
      type: "styling",
      mode: s.mode,
      // Figure out what style to use by pulling out the style from
      // the function name
      style: i,
      body: r
    };
  },
  htmlBuilder(t, e) {
    var A = ZF[t.style], n = e.havingStyle(A).withFont("");
    return gv(t.body, n, e);
  },
  mathmlBuilder(t, e) {
    var A = ZF[t.style], n = e.havingStyle(A), s = es(t.body, n), r = new ge.MathNode("mstyle", s), i = {
      display: ["0", "true"],
      text: ["0", "false"],
      script: ["1", "false"],
      scriptscript: ["2", "false"]
    }, o = i[t.style];
    return r.setAttribute("scriptlevel", o[0]), r.setAttribute("displaystyle", o[1]), r;
  }
});
var Hee = function(e, A) {
  var n = e.base;
  if (n)
    if (n.type === "op") {
      var s = n.limits && (A.style.size === Je.DISPLAY.size || n.alwaysHandleSupSub);
      return s ? Vl : null;
    } else if (n.type === "operatorname") {
      var r = n.alwaysHandleSupSub && (A.style.size === Je.DISPLAY.size || n.limits);
      return r ? Bv : null;
    } else {
      if (n.type === "accent")
        return Dt.isCharacterBox(n.base) ? dm : null;
      if (n.type === "horizBrace") {
        var i = !e.sub;
        return i === n.isOver ? av : null;
      } else
        return null;
    }
  else return null;
};
gc({
  type: "supsub",
  htmlBuilder(t, e) {
    var A = Hee(t, e);
    if (A)
      return A(t, e);
    var {
      base: n,
      sup: s,
      sub: r
    } = t, i = Ft(n, e), o, a, c = e.fontMetrics(), l = 0, B = 0, g = n && Dt.isCharacterBox(n);
    if (s) {
      var h = e.havingStyle(e.style.sup());
      o = Ft(s, h, e), g || (l = i.height - h.fontMetrics().supDrop * h.sizeMultiplier / e.sizeMultiplier);
    }
    if (r) {
      var u = e.havingStyle(e.style.sub());
      a = Ft(r, u, e), g || (B = i.depth + u.fontMetrics().subDrop * u.sizeMultiplier / e.sizeMultiplier);
    }
    var d;
    e.style === Je.DISPLAY ? d = c.sup1 : e.style.cramped ? d = c.sup3 : d = c.sup2;
    var w = e.sizeMultiplier, Q = Ie(0.5 / c.ptPerEm / w), p = null;
    if (a) {
      var M = t.base && t.base.type === "op" && t.base.name && (t.base.name === "\\oiint" || t.base.name === "\\oiiint");
      (i instanceof Ss || M) && (p = Ie(-i.italic));
    }
    var I;
    if (o && a) {
      l = Math.max(l, d, o.depth + 0.25 * c.xHeight), B = Math.max(B, c.sub2);
      var N = c.defaultRuleThickness, m = 4 * N;
      if (l - o.depth - (a.height - B) < m) {
        B = m - (l - o.depth) + a.height;
        var E = 0.8 * c.xHeight - (l - o.depth);
        E > 0 && (l += E, B -= E);
      }
      var G = [{
        type: "elem",
        elem: a,
        shift: B,
        marginRight: Q,
        marginLeft: p
      }, {
        type: "elem",
        elem: o,
        shift: -l,
        marginRight: Q
      }];
      I = O.makeVList({
        positionType: "individualShift",
        children: G
      }, e);
    } else if (a) {
      B = Math.max(B, c.sub1, a.height - 0.8 * c.xHeight);
      var Y = [{
        type: "elem",
        elem: a,
        marginLeft: p,
        marginRight: Q
      }];
      I = O.makeVList({
        positionType: "shift",
        positionData: B,
        children: Y
      }, e);
    } else if (o)
      l = Math.max(l, d, o.depth + 0.25 * c.xHeight), I = O.makeVList({
        positionType: "shift",
        positionData: -l,
        children: [{
          type: "elem",
          elem: o,
          marginRight: Q
        }]
      }, e);
    else
      throw new Error("supsub must have either sup or sub.");
    var U = xE(i, "right") || "mord";
    return O.makeSpan([U], [i, O.makeSpan(["msupsub"], [I])], e);
  },
  mathmlBuilder(t, e) {
    var A = !1, n, s;
    t.base && t.base.type === "horizBrace" && (s = !!t.sup, s === t.base.isOver && (A = !0, n = t.base.isOver)), t.base && (t.base.type === "op" || t.base.type === "operatorname") && (t.base.parentIsSupSub = !0);
    var r = [Tt(t.base, e)];
    t.sub && r.push(Tt(t.sub, e)), t.sup && r.push(Tt(t.sup, e));
    var i;
    if (A)
      i = n ? "mover" : "munder";
    else if (t.sub)
      if (t.sup) {
        var c = t.base;
        c && c.type === "op" && c.limits && e.style === Je.DISPLAY || c && c.type === "operatorname" && c.alwaysHandleSupSub && (e.style === Je.DISPLAY || c.limits) ? i = "munderover" : i = "msubsup";
      } else {
        var a = t.base;
        a && a.type === "op" && a.limits && (e.style === Je.DISPLAY || a.alwaysHandleSupSub) || a && a.type === "operatorname" && a.alwaysHandleSupSub && (a.limits || e.style === Je.DISPLAY) ? i = "munder" : i = "msub";
      }
    else {
      var o = t.base;
      o && o.type === "op" && o.limits && (e.style === Je.DISPLAY || o.alwaysHandleSupSub) || o && o.type === "operatorname" && o.alwaysHandleSupSub && (o.limits || e.style === Je.DISPLAY) ? i = "mover" : i = "msup";
    }
    return new ge.MathNode(i, r);
  }
});
gc({
  type: "atom",
  htmlBuilder(t, e) {
    return O.mathsym(t.text, t.mode, e, ["m" + t.family]);
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mo", [Ts(t.text, t.mode)]);
    if (t.family === "bin") {
      var n = hm(t, e);
      n === "bold-italic" && A.setAttribute("mathvariant", n);
    } else t.family === "punct" ? A.setAttribute("separator", "true") : (t.family === "open" || t.family === "close") && A.setAttribute("stretchy", "false");
    return A;
  }
});
var hv = {
  mi: "italic",
  mn: "normal",
  mtext: "normal"
};
gc({
  type: "mathord",
  htmlBuilder(t, e) {
    return O.makeOrd(t, e, "mathord");
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mi", [Ts(t.text, t.mode, e)]), n = hm(t, e) || "italic";
    return n !== hv[A.type] && A.setAttribute("mathvariant", n), A;
  }
});
gc({
  type: "textord",
  htmlBuilder(t, e) {
    return O.makeOrd(t, e, "textord");
  },
  mathmlBuilder(t, e) {
    var A = Ts(t.text, t.mode, e), n = hm(t, e) || "normal", s;
    return t.mode === "text" ? s = new ge.MathNode("mtext", [A]) : /[0-9]/.test(t.text) ? s = new ge.MathNode("mn", [A]) : t.text === "\\prime" ? s = new ge.MathNode("mo", [A]) : s = new ge.MathNode("mi", [A]), n !== hv[s.type] && s.setAttribute("mathvariant", n), s;
  }
});
var dI = {
  "\\nobreak": "nobreak",
  "\\allowbreak": "allowbreak"
}, wI = {
  " ": {},
  "\\ ": {},
  "~": {
    className: "nobreak"
  },
  "\\space": {},
  "\\nobreakspace": {
    className: "nobreak"
  }
};
gc({
  type: "spacing",
  htmlBuilder(t, e) {
    if (wI.hasOwnProperty(t.text)) {
      var A = wI[t.text].className || "";
      if (t.mode === "text") {
        var n = O.makeOrd(t, e, "textord");
        return n.classes.push(A), n;
      } else
        return O.makeSpan(["mspace", A], [O.mathsym(t.text, t.mode, e)], e);
    } else {
      if (dI.hasOwnProperty(t.text))
        return O.makeSpan(["mspace", dI[t.text]], [], e);
      throw new de('Unknown type of space "' + t.text + '"');
    }
  },
  mathmlBuilder(t, e) {
    var A;
    if (wI.hasOwnProperty(t.text))
      A = new ge.MathNode("mtext", [new ge.TextNode(" ")]);
    else {
      if (dI.hasOwnProperty(t.text))
        return new ge.MathNode("mspace");
      throw new de('Unknown type of space "' + t.text + '"');
    }
    return A;
  }
});
var qF = () => {
  var t = new ge.MathNode("mtd", []);
  return t.setAttribute("width", "50%"), t;
};
gc({
  type: "tag",
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mtable", [new ge.MathNode("mtr", [qF(), new ge.MathNode("mtd", [ra(t.body, e)]), qF(), new ge.MathNode("mtd", [ra(t.tag, e)])])]);
    return A.setAttribute("width", "100%"), A;
  }
});
var _F = {
  "\\text": void 0,
  "\\textrm": "textrm",
  "\\textsf": "textsf",
  "\\texttt": "texttt",
  "\\textnormal": "textrm"
}, $F = {
  "\\textbf": "textbf",
  "\\textmd": "textmd"
}, kee = {
  "\\textit": "textit",
  "\\textup": "textup"
}, eN = (t, e) => {
  var A = t.font;
  if (A) {
    if (_F[A])
      return e.withTextFontFamily(_F[A]);
    if ($F[A])
      return e.withTextFontWeight($F[A]);
    if (A === "\\emph")
      return e.fontShape === "textit" ? e.withTextFontShape("textup") : e.withTextFontShape("textit");
  } else return e;
  return e.withTextFontShape(kee[A]);
};
Ye({
  type: "text",
  names: [
    // Font families
    "\\text",
    "\\textrm",
    "\\textsf",
    "\\texttt",
    "\\textnormal",
    // Font weights
    "\\textbf",
    "\\textmd",
    // Font Shapes
    "\\textit",
    "\\textup",
    "\\emph"
  ],
  props: {
    numArgs: 1,
    argTypes: ["text"],
    allowedInArgument: !0,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: A,
      funcName: n
    } = t, s = e[0];
    return {
      type: "text",
      mode: A.mode,
      body: dA(s),
      font: n
    };
  },
  htmlBuilder(t, e) {
    var A = eN(t, e), n = yA(t.body, A, !0);
    return O.makeSpan(["mord", "text"], n, A);
  },
  mathmlBuilder(t, e) {
    var A = eN(t, e);
    return ra(t.body, A);
  }
});
Ye({
  type: "underline",
  names: ["\\underline"],
  props: {
    numArgs: 1,
    allowedInText: !0
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "underline",
      mode: A.mode,
      body: e[0]
    };
  },
  htmlBuilder(t, e) {
    var A = Ft(t.body, e), n = O.makeLineSpan("underline-line", e), s = e.fontMetrics().defaultRuleThickness, r = O.makeVList({
      positionType: "top",
      positionData: A.height,
      children: [{
        type: "kern",
        size: s
      }, {
        type: "elem",
        elem: n
      }, {
        type: "kern",
        size: 3 * s
      }, {
        type: "elem",
        elem: A
      }]
    }, e);
    return O.makeSpan(["mord", "underline"], [r], e);
  },
  mathmlBuilder(t, e) {
    var A = new ge.MathNode("mo", [new ge.TextNode("‾")]);
    A.setAttribute("stretchy", "true");
    var n = new ge.MathNode("munder", [Tt(t.body, e), A]);
    return n.setAttribute("accentunder", "true"), n;
  }
});
Ye({
  type: "vcenter",
  names: ["\\vcenter"],
  props: {
    numArgs: 1,
    argTypes: ["original"],
    // In LaTeX, \vcenter can act only on a box.
    allowedInText: !1
  },
  handler(t, e) {
    var {
      parser: A
    } = t;
    return {
      type: "vcenter",
      mode: A.mode,
      body: e[0]
    };
  },
  htmlBuilder(t, e) {
    var A = Ft(t.body, e), n = e.fontMetrics().axisHeight, s = 0.5 * (A.height - n - (A.depth + n));
    return O.makeVList({
      positionType: "shift",
      positionData: s,
      children: [{
        type: "elem",
        elem: A
      }]
    }, e);
  },
  mathmlBuilder(t, e) {
    return new ge.MathNode("mpadded", [Tt(t.body, e)], ["vcenter"]);
  }
});
Ye({
  type: "verb",
  names: ["\\verb"],
  props: {
    numArgs: 0,
    allowedInText: !0
  },
  handler(t, e, A) {
    throw new de("\\verb ended by end of line instead of matching delimiter");
  },
  htmlBuilder(t, e) {
    for (var A = tN(t), n = [], s = e.havingStyle(e.style.text()), r = 0; r < A.length; r++) {
      var i = A[r];
      i === "~" && (i = "\\textasciitilde"), n.push(O.makeSymbol(i, "Typewriter-Regular", t.mode, s, ["mord", "texttt"]));
    }
    return O.makeSpan(["mord", "text"].concat(s.sizingClasses(e)), O.tryCombineChars(n), s);
  },
  mathmlBuilder(t, e) {
    var A = new ge.TextNode(tN(t)), n = new ge.MathNode("mtext", [A]);
    return n.setAttribute("mathvariant", "monospace"), n;
  }
});
var tN = (t) => t.body.replace(/ /g, t.star ? "␣" : " "), ko = jb, uv = `[ \r
	]`, Ree = "\\\\[a-zA-Z@]+", Lee = "\\\\[^\uD800-\uDFFF]", See = "(" + Ree + ")" + uv + "*", Tee = `\\\\(
|[ \r	]+
?)[ \r	]*`, bE = "[̀-ͯ]", Jee = new RegExp(bE + "+$"), Wee = "(" + uv + "+)|" + // whitespace
(Tee + "|") + // \whitespace
"([!-\\[\\]-‧‪-퟿豈-￿]" + // single codepoint
(bE + "*") + // ...plus accents
"|[\uD800-\uDBFF][\uDC00-\uDFFF]" + // surrogate pair
(bE + "*") + // ...plus accents
"|\\\\verb\\*([^]).*?\\4|\\\\verb([^*a-zA-Z]).*?\\5" + // \verb unstarred
("|" + See) + // \macroName + spaces
("|" + Lee + ")");
class AN {
  // Category codes. The lexer only supports comment characters (14) for now.
  // MacroExpander additionally distinguishes active (13).
  constructor(e, A) {
    this.input = void 0, this.settings = void 0, this.tokenRegex = void 0, this.catcodes = void 0, this.input = e, this.settings = A, this.tokenRegex = new RegExp(Wee, "g"), this.catcodes = {
      "%": 14,
      // comment character
      "~": 13
      // active character
    };
  }
  setCatcode(e, A) {
    this.catcodes[e] = A;
  }
  /**
   * This function lexes a single token.
   */
  lex() {
    var e = this.input, A = this.tokenRegex.lastIndex;
    if (A === e.length)
      return new ds("EOF", new On(this, A, A));
    var n = this.tokenRegex.exec(e);
    if (n === null || n.index !== A)
      throw new de("Unexpected character: '" + e[A] + "'", new ds(e[A], new On(this, A, A + 1)));
    var s = n[6] || n[3] || (n[2] ? "\\ " : " ");
    if (this.catcodes[s] === 14) {
      var r = e.indexOf(`
`, this.tokenRegex.lastIndex);
      return r === -1 ? (this.tokenRegex.lastIndex = e.length, this.settings.reportNonstrict("commentAtEnd", "% comment has no terminating newline; LaTeX would fail because of commenting the end of math mode (e.g. $)")) : this.tokenRegex.lastIndex = r + 1, this.lex();
    }
    return new ds(s, new On(this, A, this.tokenRegex.lastIndex));
  }
}
class Oee {
  /**
   * Both arguments are optional.  The first argument is an object of
   * built-in mappings which never change.  The second argument is an object
   * of initial (global-level) mappings, which will constantly change
   * according to any global/top-level `set`s done.
   */
  constructor(e, A) {
    e === void 0 && (e = {}), A === void 0 && (A = {}), this.current = void 0, this.builtins = void 0, this.undefStack = void 0, this.current = A, this.builtins = e, this.undefStack = [];
  }
  /**
   * Start a new nested group, affecting future local `set`s.
   */
  beginGroup() {
    this.undefStack.push({});
  }
  /**
   * End current nested group, restoring values before the group began.
   */
  endGroup() {
    if (this.undefStack.length === 0)
      throw new de("Unbalanced namespace destruction: attempt to pop global namespace; please report this as a bug");
    var e = this.undefStack.pop();
    for (var A in e)
      e.hasOwnProperty(A) && (e[A] == null ? delete this.current[A] : this.current[A] = e[A]);
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    for (; this.undefStack.length > 0; )
      this.endGroup();
  }
  /**
   * Detect whether `name` has a definition.  Equivalent to
   * `get(name) != null`.
   */
  has(e) {
    return this.current.hasOwnProperty(e) || this.builtins.hasOwnProperty(e);
  }
  /**
   * Get the current value of a name, or `undefined` if there is no value.
   *
   * Note: Do not use `if (namespace.get(...))` to detect whether a macro
   * is defined, as the definition may be the empty string which evaluates
   * to `false` in JavaScript.  Use `if (namespace.get(...) != null)` or
   * `if (namespace.has(...))`.
   */
  get(e) {
    return this.current.hasOwnProperty(e) ? this.current[e] : this.builtins[e];
  }
  /**
   * Set the current value of a name, and optionally set it globally too.
   * Local set() sets the current value and (when appropriate) adds an undo
   * operation to the undo stack.  Global set() may change the undo
   * operation at every level, so takes time linear in their number.
   * A value of undefined means to delete existing definitions.
   */
  set(e, A, n) {
    if (n === void 0 && (n = !1), n) {
      for (var s = 0; s < this.undefStack.length; s++)
        delete this.undefStack[s][e];
      this.undefStack.length > 0 && (this.undefStack[this.undefStack.length - 1][e] = A);
    } else {
      var r = this.undefStack[this.undefStack.length - 1];
      r && !r.hasOwnProperty(e) && (r[e] = this.current[e]);
    }
    A == null ? delete this.current[e] : this.current[e] = A;
  }
}
var Pee = nv;
z("\\noexpand", function(t) {
  var e = t.popToken();
  return t.isExpandable(e.text) && (e.noexpand = !0, e.treatAsRelax = !0), {
    tokens: [e],
    numArgs: 0
  };
});
z("\\expandafter", function(t) {
  var e = t.popToken();
  return t.expandOnce(!0), {
    tokens: [e],
    numArgs: 0
  };
});
z("\\@firstoftwo", function(t) {
  var e = t.consumeArgs(2);
  return {
    tokens: e[0],
    numArgs: 0
  };
});
z("\\@secondoftwo", function(t) {
  var e = t.consumeArgs(2);
  return {
    tokens: e[1],
    numArgs: 0
  };
});
z("\\@ifnextchar", function(t) {
  var e = t.consumeArgs(3);
  t.consumeSpaces();
  var A = t.future();
  return e[0].length === 1 && e[0][0].text === A.text ? {
    tokens: e[1],
    numArgs: 0
  } : {
    tokens: e[2],
    numArgs: 0
  };
});
z("\\@ifstar", "\\@ifnextchar *{\\@firstoftwo{#1}}");
z("\\TextOrMath", function(t) {
  var e = t.consumeArgs(2);
  return t.mode === "text" ? {
    tokens: e[0],
    numArgs: 0
  } : {
    tokens: e[1],
    numArgs: 0
  };
});
var nN = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  7: 7,
  8: 8,
  9: 9,
  a: 10,
  A: 10,
  b: 11,
  B: 11,
  c: 12,
  C: 12,
  d: 13,
  D: 13,
  e: 14,
  E: 14,
  f: 15,
  F: 15
};
z("\\char", function(t) {
  var e = t.popToken(), A, n = "";
  if (e.text === "'")
    A = 8, e = t.popToken();
  else if (e.text === '"')
    A = 16, e = t.popToken();
  else if (e.text === "`")
    if (e = t.popToken(), e.text[0] === "\\")
      n = e.text.charCodeAt(1);
    else {
      if (e.text === "EOF")
        throw new de("\\char` missing argument");
      n = e.text.charCodeAt(0);
    }
  else
    A = 10;
  if (A) {
    if (n = nN[e.text], n == null || n >= A)
      throw new de("Invalid base-" + A + " digit " + e.text);
    for (var s; (s = nN[t.future().text]) != null && s < A; )
      n *= A, n += s, t.popToken();
  }
  return "\\@char{" + n + "}";
});
var pm = (t, e, A, n) => {
  var s = t.consumeArg().tokens;
  if (s.length !== 1)
    throw new de("\\newcommand's first argument must be a macro name");
  var r = s[0].text, i = t.isDefined(r);
  if (i && !e)
    throw new de("\\newcommand{" + r + "} attempting to redefine " + (r + "; use \\renewcommand"));
  if (!i && !A)
    throw new de("\\renewcommand{" + r + "} when command " + r + " does not yet exist; use \\newcommand");
  var o = 0;
  if (s = t.consumeArg().tokens, s.length === 1 && s[0].text === "[") {
    for (var a = "", c = t.expandNextToken(); c.text !== "]" && c.text !== "EOF"; )
      a += c.text, c = t.expandNextToken();
    if (!a.match(/^\s*[0-9]+\s*$/))
      throw new de("Invalid number of arguments: " + a);
    o = parseInt(a), s = t.consumeArg().tokens;
  }
  return i && n || t.macros.set(r, {
    tokens: s,
    numArgs: o
  }), "";
};
z("\\newcommand", (t) => pm(t, !1, !0, !1));
z("\\renewcommand", (t) => pm(t, !0, !1, !1));
z("\\providecommand", (t) => pm(t, !0, !0, !0));
z("\\message", (t) => {
  var e = t.consumeArgs(1)[0];
  return console.log(e.reverse().map((A) => A.text).join("")), "";
});
z("\\errmessage", (t) => {
  var e = t.consumeArgs(1)[0];
  return console.error(e.reverse().map((A) => A.text).join("")), "";
});
z("\\show", (t) => {
  var e = t.popToken(), A = e.text;
  return console.log(e, t.macros.get(A), ko[A], Ot.math[A], Ot.text[A]), "";
});
z("\\bgroup", "{");
z("\\egroup", "}");
z("~", "\\nobreakspace");
z("\\lq", "`");
z("\\rq", "'");
z("\\aa", "\\r a");
z("\\AA", "\\r A");
z("\\textcopyright", "\\html@mathml{\\textcircled{c}}{\\char`©}");
z("\\copyright", "\\TextOrMath{\\textcopyright}{\\text{\\textcopyright}}");
z("\\textregistered", "\\html@mathml{\\textcircled{\\scriptsize R}}{\\char`®}");
z("ℬ", "\\mathscr{B}");
z("ℰ", "\\mathscr{E}");
z("ℱ", "\\mathscr{F}");
z("ℋ", "\\mathscr{H}");
z("ℐ", "\\mathscr{I}");
z("ℒ", "\\mathscr{L}");
z("ℳ", "\\mathscr{M}");
z("ℛ", "\\mathscr{R}");
z("ℭ", "\\mathfrak{C}");
z("ℌ", "\\mathfrak{H}");
z("ℨ", "\\mathfrak{Z}");
z("\\Bbbk", "\\Bbb{k}");
z("·", "\\cdotp");
z("\\llap", "\\mathllap{\\textrm{#1}}");
z("\\rlap", "\\mathrlap{\\textrm{#1}}");
z("\\clap", "\\mathclap{\\textrm{#1}}");
z("\\mathstrut", "\\vphantom{(}");
z("\\underbar", "\\underline{\\text{#1}}");
z("\\not", '\\html@mathml{\\mathrel{\\mathrlap\\@not}}{\\char"338}');
z("\\neq", "\\html@mathml{\\mathrel{\\not=}}{\\mathrel{\\char`≠}}");
z("\\ne", "\\neq");
z("≠", "\\neq");
z("\\notin", "\\html@mathml{\\mathrel{{\\in}\\mathllap{/\\mskip1mu}}}{\\mathrel{\\char`∉}}");
z("∉", "\\notin");
z("≘", "\\html@mathml{\\mathrel{=\\kern{-1em}\\raisebox{0.4em}{$\\scriptsize\\frown$}}}{\\mathrel{\\char`≘}}");
z("≙", "\\html@mathml{\\stackrel{\\tiny\\wedge}{=}}{\\mathrel{\\char`≘}}");
z("≚", "\\html@mathml{\\stackrel{\\tiny\\vee}{=}}{\\mathrel{\\char`≚}}");
z("≛", "\\html@mathml{\\stackrel{\\scriptsize\\star}{=}}{\\mathrel{\\char`≛}}");
z("≝", "\\html@mathml{\\stackrel{\\tiny\\mathrm{def}}{=}}{\\mathrel{\\char`≝}}");
z("≞", "\\html@mathml{\\stackrel{\\tiny\\mathrm{m}}{=}}{\\mathrel{\\char`≞}}");
z("≟", "\\html@mathml{\\stackrel{\\tiny?}{=}}{\\mathrel{\\char`≟}}");
z("⟂", "\\perp");
z("‼", "\\mathclose{!\\mkern-0.8mu!}");
z("∌", "\\notni");
z("⌜", "\\ulcorner");
z("⌝", "\\urcorner");
z("⌞", "\\llcorner");
z("⌟", "\\lrcorner");
z("©", "\\copyright");
z("®", "\\textregistered");
z("️", "\\textregistered");
z("\\ulcorner", '\\html@mathml{\\@ulcorner}{\\mathop{\\char"231c}}');
z("\\urcorner", '\\html@mathml{\\@urcorner}{\\mathop{\\char"231d}}');
z("\\llcorner", '\\html@mathml{\\@llcorner}{\\mathop{\\char"231e}}');
z("\\lrcorner", '\\html@mathml{\\@lrcorner}{\\mathop{\\char"231f}}');
z("\\vdots", "{\\varvdots\\rule{0pt}{15pt}}");
z("⋮", "\\vdots");
z("\\varGamma", "\\mathit{\\Gamma}");
z("\\varDelta", "\\mathit{\\Delta}");
z("\\varTheta", "\\mathit{\\Theta}");
z("\\varLambda", "\\mathit{\\Lambda}");
z("\\varXi", "\\mathit{\\Xi}");
z("\\varPi", "\\mathit{\\Pi}");
z("\\varSigma", "\\mathit{\\Sigma}");
z("\\varUpsilon", "\\mathit{\\Upsilon}");
z("\\varPhi", "\\mathit{\\Phi}");
z("\\varPsi", "\\mathit{\\Psi}");
z("\\varOmega", "\\mathit{\\Omega}");
z("\\substack", "\\begin{subarray}{c}#1\\end{subarray}");
z("\\colon", "\\nobreak\\mskip2mu\\mathpunct{}\\mathchoice{\\mkern-3mu}{\\mkern-3mu}{}{}{:}\\mskip6mu\\relax");
z("\\boxed", "\\fbox{$\\displaystyle{#1}$}");
z("\\iff", "\\DOTSB\\;\\Longleftrightarrow\\;");
z("\\implies", "\\DOTSB\\;\\Longrightarrow\\;");
z("\\impliedby", "\\DOTSB\\;\\Longleftarrow\\;");
z("\\dddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ...}}{#1}}");
z("\\ddddot", "{\\overset{\\raisebox{-0.1ex}{\\normalsize ....}}{#1}}");
var sN = {
  ",": "\\dotsc",
  "\\not": "\\dotsb",
  // \keybin@ checks for the following:
  "+": "\\dotsb",
  "=": "\\dotsb",
  "<": "\\dotsb",
  ">": "\\dotsb",
  "-": "\\dotsb",
  "*": "\\dotsb",
  ":": "\\dotsb",
  // Symbols whose definition starts with \DOTSB:
  "\\DOTSB": "\\dotsb",
  "\\coprod": "\\dotsb",
  "\\bigvee": "\\dotsb",
  "\\bigwedge": "\\dotsb",
  "\\biguplus": "\\dotsb",
  "\\bigcap": "\\dotsb",
  "\\bigcup": "\\dotsb",
  "\\prod": "\\dotsb",
  "\\sum": "\\dotsb",
  "\\bigotimes": "\\dotsb",
  "\\bigoplus": "\\dotsb",
  "\\bigodot": "\\dotsb",
  "\\bigsqcup": "\\dotsb",
  "\\And": "\\dotsb",
  "\\longrightarrow": "\\dotsb",
  "\\Longrightarrow": "\\dotsb",
  "\\longleftarrow": "\\dotsb",
  "\\Longleftarrow": "\\dotsb",
  "\\longleftrightarrow": "\\dotsb",
  "\\Longleftrightarrow": "\\dotsb",
  "\\mapsto": "\\dotsb",
  "\\longmapsto": "\\dotsb",
  "\\hookrightarrow": "\\dotsb",
  "\\doteq": "\\dotsb",
  // Symbols whose definition starts with \mathbin:
  "\\mathbin": "\\dotsb",
  // Symbols whose definition starts with \mathrel:
  "\\mathrel": "\\dotsb",
  "\\relbar": "\\dotsb",
  "\\Relbar": "\\dotsb",
  "\\xrightarrow": "\\dotsb",
  "\\xleftarrow": "\\dotsb",
  // Symbols whose definition starts with \DOTSI:
  "\\DOTSI": "\\dotsi",
  "\\int": "\\dotsi",
  "\\oint": "\\dotsi",
  "\\iint": "\\dotsi",
  "\\iiint": "\\dotsi",
  "\\iiiint": "\\dotsi",
  "\\idotsint": "\\dotsi",
  // Symbols whose definition starts with \DOTSX:
  "\\DOTSX": "\\dotsx"
};
z("\\dots", function(t) {
  var e = "\\dotso", A = t.expandAfterFuture().text;
  return A in sN ? e = sN[A] : (A.slice(0, 4) === "\\not" || A in Ot.math && ["bin", "rel"].includes(Ot.math[A].group)) && (e = "\\dotsb"), e;
});
var mm = {
  // \rightdelim@ checks for the following:
  ")": !0,
  "]": !0,
  "\\rbrack": !0,
  "\\}": !0,
  "\\rbrace": !0,
  "\\rangle": !0,
  "\\rceil": !0,
  "\\rfloor": !0,
  "\\rgroup": !0,
  "\\rmoustache": !0,
  "\\right": !0,
  "\\bigr": !0,
  "\\biggr": !0,
  "\\Bigr": !0,
  "\\Biggr": !0,
  // \extra@ also tests for the following:
  $: !0,
  // \extrap@ checks for the following:
  ";": !0,
  ".": !0,
  ",": !0
};
z("\\dotso", function(t) {
  var e = t.future().text;
  return e in mm ? "\\ldots\\," : "\\ldots";
});
z("\\dotsc", function(t) {
  var e = t.future().text;
  return e in mm && e !== "," ? "\\ldots\\," : "\\ldots";
});
z("\\cdots", function(t) {
  var e = t.future().text;
  return e in mm ? "\\@cdots\\," : "\\@cdots";
});
z("\\dotsb", "\\cdots");
z("\\dotsm", "\\cdots");
z("\\dotsi", "\\!\\cdots");
z("\\dotsx", "\\ldots\\,");
z("\\DOTSI", "\\relax");
z("\\DOTSB", "\\relax");
z("\\DOTSX", "\\relax");
z("\\tmspace", "\\TextOrMath{\\kern#1#3}{\\mskip#1#2}\\relax");
z("\\,", "\\tmspace+{3mu}{.1667em}");
z("\\thinspace", "\\,");
z("\\>", "\\mskip{4mu}");
z("\\:", "\\tmspace+{4mu}{.2222em}");
z("\\medspace", "\\:");
z("\\;", "\\tmspace+{5mu}{.2777em}");
z("\\thickspace", "\\;");
z("\\!", "\\tmspace-{3mu}{.1667em}");
z("\\negthinspace", "\\!");
z("\\negmedspace", "\\tmspace-{4mu}{.2222em}");
z("\\negthickspace", "\\tmspace-{5mu}{.277em}");
z("\\enspace", "\\kern.5em ");
z("\\enskip", "\\hskip.5em\\relax");
z("\\quad", "\\hskip1em\\relax");
z("\\qquad", "\\hskip2em\\relax");
z("\\tag", "\\@ifstar\\tag@literal\\tag@paren");
z("\\tag@paren", "\\tag@literal{({#1})}");
z("\\tag@literal", (t) => {
  if (t.macros.get("\\df@tag"))
    throw new de("Multiple \\tag");
  return "\\gdef\\df@tag{\\text{#1}}";
});
z("\\bmod", "\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}\\mathbin{\\rm mod}\\mathchoice{\\mskip1mu}{\\mskip1mu}{\\mskip5mu}{\\mskip5mu}");
z("\\pod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern8mu}{\\mkern8mu}{\\mkern8mu}(#1)");
z("\\pmod", "\\pod{{\\rm mod}\\mkern6mu#1}");
z("\\mod", "\\allowbreak\\mathchoice{\\mkern18mu}{\\mkern12mu}{\\mkern12mu}{\\mkern12mu}{\\rm mod}\\,\\,#1");
z("\\newline", "\\\\\\relax");
z("\\TeX", "\\textrm{\\html@mathml{T\\kern-.1667em\\raisebox{-.5ex}{E}\\kern-.125emX}{TeX}}");
var dv = Ie(Dr["Main-Regular"][84][1] - 0.7 * Dr["Main-Regular"][65][1]);
z("\\LaTeX", "\\textrm{\\html@mathml{" + ("L\\kern-.36em\\raisebox{" + dv + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{LaTeX}}");
z("\\KaTeX", "\\textrm{\\html@mathml{" + ("K\\kern-.17em\\raisebox{" + dv + "}{\\scriptstyle A}") + "\\kern-.15em\\TeX}{KaTeX}}");
z("\\hspace", "\\@ifstar\\@hspacer\\@hspace");
z("\\@hspace", "\\hskip #1\\relax");
z("\\@hspacer", "\\rule{0pt}{0pt}\\hskip #1\\relax");
z("\\ordinarycolon", ":");
z("\\vcentcolon", "\\mathrel{\\mathop\\ordinarycolon}");
z("\\dblcolon", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-.9mu}\\vcentcolon}}{\\mathop{\\char"2237}}');
z("\\coloneqq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2254}}');
z("\\Coloneqq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}=}}{\\mathop{\\char"2237\\char"3d}}');
z("\\coloneq", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"3a\\char"2212}}');
z("\\Coloneq", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\mathrel{-}}}{\\mathop{\\char"2237\\char"2212}}');
z("\\eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2255}}');
z("\\Eqqcolon", '\\html@mathml{\\mathrel{=\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"3d\\char"2237}}');
z("\\eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\vcentcolon}}{\\mathop{\\char"2239}}');
z("\\Eqcolon", '\\html@mathml{\\mathrel{\\mathrel{-}\\mathrel{\\mkern-1.2mu}\\dblcolon}}{\\mathop{\\char"2212\\char"2237}}');
z("\\colonapprox", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"3a\\char"2248}}');
z("\\Colonapprox", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\approx}}{\\mathop{\\char"2237\\char"2248}}');
z("\\colonsim", '\\html@mathml{\\mathrel{\\vcentcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"3a\\char"223c}}');
z("\\Colonsim", '\\html@mathml{\\mathrel{\\dblcolon\\mathrel{\\mkern-1.2mu}\\sim}}{\\mathop{\\char"2237\\char"223c}}');
z("∷", "\\dblcolon");
z("∹", "\\eqcolon");
z("≔", "\\coloneqq");
z("≕", "\\eqqcolon");
z("⩴", "\\Coloneqq");
z("\\ratio", "\\vcentcolon");
z("\\coloncolon", "\\dblcolon");
z("\\colonequals", "\\coloneqq");
z("\\coloncolonequals", "\\Coloneqq");
z("\\equalscolon", "\\eqqcolon");
z("\\equalscoloncolon", "\\Eqqcolon");
z("\\colonminus", "\\coloneq");
z("\\coloncolonminus", "\\Coloneq");
z("\\minuscolon", "\\eqcolon");
z("\\minuscoloncolon", "\\Eqcolon");
z("\\coloncolonapprox", "\\Colonapprox");
z("\\coloncolonsim", "\\Colonsim");
z("\\simcolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
z("\\simcoloncolon", "\\mathrel{\\sim\\mathrel{\\mkern-1.2mu}\\dblcolon}");
z("\\approxcolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\vcentcolon}");
z("\\approxcoloncolon", "\\mathrel{\\approx\\mathrel{\\mkern-1.2mu}\\dblcolon}");
z("\\notni", "\\html@mathml{\\not\\ni}{\\mathrel{\\char`∌}}");
z("\\limsup", "\\DOTSB\\operatorname*{lim\\,sup}");
z("\\liminf", "\\DOTSB\\operatorname*{lim\\,inf}");
z("\\injlim", "\\DOTSB\\operatorname*{inj\\,lim}");
z("\\projlim", "\\DOTSB\\operatorname*{proj\\,lim}");
z("\\varlimsup", "\\DOTSB\\operatorname*{\\overline{lim}}");
z("\\varliminf", "\\DOTSB\\operatorname*{\\underline{lim}}");
z("\\varinjlim", "\\DOTSB\\operatorname*{\\underrightarrow{lim}}");
z("\\varprojlim", "\\DOTSB\\operatorname*{\\underleftarrow{lim}}");
z("\\gvertneqq", "\\html@mathml{\\@gvertneqq}{≩}");
z("\\lvertneqq", "\\html@mathml{\\@lvertneqq}{≨}");
z("\\ngeqq", "\\html@mathml{\\@ngeqq}{≱}");
z("\\ngeqslant", "\\html@mathml{\\@ngeqslant}{≱}");
z("\\nleqq", "\\html@mathml{\\@nleqq}{≰}");
z("\\nleqslant", "\\html@mathml{\\@nleqslant}{≰}");
z("\\nshortmid", "\\html@mathml{\\@nshortmid}{∤}");
z("\\nshortparallel", "\\html@mathml{\\@nshortparallel}{∦}");
z("\\nsubseteqq", "\\html@mathml{\\@nsubseteqq}{⊈}");
z("\\nsupseteqq", "\\html@mathml{\\@nsupseteqq}{⊉}");
z("\\varsubsetneq", "\\html@mathml{\\@varsubsetneq}{⊊}");
z("\\varsubsetneqq", "\\html@mathml{\\@varsubsetneqq}{⫋}");
z("\\varsupsetneq", "\\html@mathml{\\@varsupsetneq}{⊋}");
z("\\varsupsetneqq", "\\html@mathml{\\@varsupsetneqq}{⫌}");
z("\\imath", "\\html@mathml{\\@imath}{ı}");
z("\\jmath", "\\html@mathml{\\@jmath}{ȷ}");
z("\\llbracket", "\\html@mathml{\\mathopen{[\\mkern-3.2mu[}}{\\mathopen{\\char`⟦}}");
z("\\rrbracket", "\\html@mathml{\\mathclose{]\\mkern-3.2mu]}}{\\mathclose{\\char`⟧}}");
z("⟦", "\\llbracket");
z("⟧", "\\rrbracket");
z("\\lBrace", "\\html@mathml{\\mathopen{\\{\\mkern-3.2mu[}}{\\mathopen{\\char`⦃}}");
z("\\rBrace", "\\html@mathml{\\mathclose{]\\mkern-3.2mu\\}}}{\\mathclose{\\char`⦄}}");
z("⦃", "\\lBrace");
z("⦄", "\\rBrace");
z("\\minuso", "\\mathbin{\\html@mathml{{\\mathrlap{\\mathchoice{\\kern{0.145em}}{\\kern{0.145em}}{\\kern{0.1015em}}{\\kern{0.0725em}}\\circ}{-}}}{\\char`⦵}}");
z("⦵", "\\minuso");
z("\\darr", "\\downarrow");
z("\\dArr", "\\Downarrow");
z("\\Darr", "\\Downarrow");
z("\\lang", "\\langle");
z("\\rang", "\\rangle");
z("\\uarr", "\\uparrow");
z("\\uArr", "\\Uparrow");
z("\\Uarr", "\\Uparrow");
z("\\N", "\\mathbb{N}");
z("\\R", "\\mathbb{R}");
z("\\Z", "\\mathbb{Z}");
z("\\alef", "\\aleph");
z("\\alefsym", "\\aleph");
z("\\Alpha", "\\mathrm{A}");
z("\\Beta", "\\mathrm{B}");
z("\\bull", "\\bullet");
z("\\Chi", "\\mathrm{X}");
z("\\clubs", "\\clubsuit");
z("\\cnums", "\\mathbb{C}");
z("\\Complex", "\\mathbb{C}");
z("\\Dagger", "\\ddagger");
z("\\diamonds", "\\diamondsuit");
z("\\empty", "\\emptyset");
z("\\Epsilon", "\\mathrm{E}");
z("\\Eta", "\\mathrm{H}");
z("\\exist", "\\exists");
z("\\harr", "\\leftrightarrow");
z("\\hArr", "\\Leftrightarrow");
z("\\Harr", "\\Leftrightarrow");
z("\\hearts", "\\heartsuit");
z("\\image", "\\Im");
z("\\infin", "\\infty");
z("\\Iota", "\\mathrm{I}");
z("\\isin", "\\in");
z("\\Kappa", "\\mathrm{K}");
z("\\larr", "\\leftarrow");
z("\\lArr", "\\Leftarrow");
z("\\Larr", "\\Leftarrow");
z("\\lrarr", "\\leftrightarrow");
z("\\lrArr", "\\Leftrightarrow");
z("\\Lrarr", "\\Leftrightarrow");
z("\\Mu", "\\mathrm{M}");
z("\\natnums", "\\mathbb{N}");
z("\\Nu", "\\mathrm{N}");
z("\\Omicron", "\\mathrm{O}");
z("\\plusmn", "\\pm");
z("\\rarr", "\\rightarrow");
z("\\rArr", "\\Rightarrow");
z("\\Rarr", "\\Rightarrow");
z("\\real", "\\Re");
z("\\reals", "\\mathbb{R}");
z("\\Reals", "\\mathbb{R}");
z("\\Rho", "\\mathrm{P}");
z("\\sdot", "\\cdot");
z("\\sect", "\\S");
z("\\spades", "\\spadesuit");
z("\\sub", "\\subset");
z("\\sube", "\\subseteq");
z("\\supe", "\\supseteq");
z("\\Tau", "\\mathrm{T}");
z("\\thetasym", "\\vartheta");
z("\\weierp", "\\wp");
z("\\Zeta", "\\mathrm{Z}");
z("\\argmin", "\\DOTSB\\operatorname*{arg\\,min}");
z("\\argmax", "\\DOTSB\\operatorname*{arg\\,max}");
z("\\plim", "\\DOTSB\\mathop{\\operatorname{plim}}\\limits");
z("\\bra", "\\mathinner{\\langle{#1}|}");
z("\\ket", "\\mathinner{|{#1}\\rangle}");
z("\\braket", "\\mathinner{\\langle{#1}\\rangle}");
z("\\Bra", "\\left\\langle#1\\right|");
z("\\Ket", "\\left|#1\\right\\rangle");
var wv = (t) => (e) => {
  var A = e.consumeArg().tokens, n = e.consumeArg().tokens, s = e.consumeArg().tokens, r = e.consumeArg().tokens, i = e.macros.get("|"), o = e.macros.get("\\|");
  e.macros.beginGroup();
  var a = (B) => (g) => {
    t && (g.macros.set("|", i), s.length && g.macros.set("\\|", o));
    var h = B;
    if (!B && s.length) {
      var u = g.future();
      u.text === "|" && (g.popToken(), h = !0);
    }
    return {
      tokens: h ? s : n,
      numArgs: 0
    };
  };
  e.macros.set("|", a(!1)), s.length && e.macros.set("\\|", a(!0));
  var c = e.consumeArg().tokens, l = e.expandTokens([
    ...r,
    ...c,
    ...A
    // reversed
  ]);
  return e.macros.endGroup(), {
    tokens: l.reverse(),
    numArgs: 0
  };
};
z("\\bra@ket", wv(!1));
z("\\bra@set", wv(!0));
z("\\Braket", "\\bra@ket{\\left\\langle}{\\,\\middle\\vert\\,}{\\,\\middle\\vert\\,}{\\right\\rangle}");
z("\\Set", "\\bra@set{\\left\\{\\:}{\\;\\middle\\vert\\;}{\\;\\middle\\Vert\\;}{\\:\\right\\}}");
z("\\set", "\\bra@set{\\{\\,}{\\mid}{}{\\,\\}}");
z("\\angln", "{\\angl n}");
z("\\blue", "\\textcolor{##6495ed}{#1}");
z("\\orange", "\\textcolor{##ffa500}{#1}");
z("\\pink", "\\textcolor{##ff00af}{#1}");
z("\\red", "\\textcolor{##df0030}{#1}");
z("\\green", "\\textcolor{##28ae7b}{#1}");
z("\\gray", "\\textcolor{gray}{#1}");
z("\\purple", "\\textcolor{##9d38bd}{#1}");
z("\\blueA", "\\textcolor{##ccfaff}{#1}");
z("\\blueB", "\\textcolor{##80f6ff}{#1}");
z("\\blueC", "\\textcolor{##63d9ea}{#1}");
z("\\blueD", "\\textcolor{##11accd}{#1}");
z("\\blueE", "\\textcolor{##0c7f99}{#1}");
z("\\tealA", "\\textcolor{##94fff5}{#1}");
z("\\tealB", "\\textcolor{##26edd5}{#1}");
z("\\tealC", "\\textcolor{##01d1c1}{#1}");
z("\\tealD", "\\textcolor{##01a995}{#1}");
z("\\tealE", "\\textcolor{##208170}{#1}");
z("\\greenA", "\\textcolor{##b6ffb0}{#1}");
z("\\greenB", "\\textcolor{##8af281}{#1}");
z("\\greenC", "\\textcolor{##74cf70}{#1}");
z("\\greenD", "\\textcolor{##1fab54}{#1}");
z("\\greenE", "\\textcolor{##0d923f}{#1}");
z("\\goldA", "\\textcolor{##ffd0a9}{#1}");
z("\\goldB", "\\textcolor{##ffbb71}{#1}");
z("\\goldC", "\\textcolor{##ff9c39}{#1}");
z("\\goldD", "\\textcolor{##e07d10}{#1}");
z("\\goldE", "\\textcolor{##a75a05}{#1}");
z("\\redA", "\\textcolor{##fca9a9}{#1}");
z("\\redB", "\\textcolor{##ff8482}{#1}");
z("\\redC", "\\textcolor{##f9685d}{#1}");
z("\\redD", "\\textcolor{##e84d39}{#1}");
z("\\redE", "\\textcolor{##bc2612}{#1}");
z("\\maroonA", "\\textcolor{##ffbde0}{#1}");
z("\\maroonB", "\\textcolor{##ff92c6}{#1}");
z("\\maroonC", "\\textcolor{##ed5fa6}{#1}");
z("\\maroonD", "\\textcolor{##ca337c}{#1}");
z("\\maroonE", "\\textcolor{##9e034e}{#1}");
z("\\purpleA", "\\textcolor{##ddd7ff}{#1}");
z("\\purpleB", "\\textcolor{##c6b9fc}{#1}");
z("\\purpleC", "\\textcolor{##aa87ff}{#1}");
z("\\purpleD", "\\textcolor{##7854ab}{#1}");
z("\\purpleE", "\\textcolor{##543b78}{#1}");
z("\\mintA", "\\textcolor{##f5f9e8}{#1}");
z("\\mintB", "\\textcolor{##edf2df}{#1}");
z("\\mintC", "\\textcolor{##e0e5cc}{#1}");
z("\\grayA", "\\textcolor{##f6f7f7}{#1}");
z("\\grayB", "\\textcolor{##f0f1f2}{#1}");
z("\\grayC", "\\textcolor{##e3e5e6}{#1}");
z("\\grayD", "\\textcolor{##d6d8da}{#1}");
z("\\grayE", "\\textcolor{##babec2}{#1}");
z("\\grayF", "\\textcolor{##888d93}{#1}");
z("\\grayG", "\\textcolor{##626569}{#1}");
z("\\grayH", "\\textcolor{##3b3e40}{#1}");
z("\\grayI", "\\textcolor{##21242c}{#1}");
z("\\kaBlue", "\\textcolor{##314453}{#1}");
z("\\kaGreen", "\\textcolor{##71B307}{#1}");
var fv = {
  "^": !0,
  // Parser.js
  _: !0,
  // Parser.js
  "\\limits": !0,
  // Parser.js
  "\\nolimits": !0
  // Parser.js
};
class Kee {
  constructor(e, A, n) {
    this.settings = void 0, this.expansionCount = void 0, this.lexer = void 0, this.macros = void 0, this.stack = void 0, this.mode = void 0, this.settings = A, this.expansionCount = 0, this.feed(e), this.macros = new Oee(Pee, A.macros), this.mode = n, this.stack = [];
  }
  /**
   * Feed a new input string to the same MacroExpander
   * (with existing macros etc.).
   */
  feed(e) {
    this.lexer = new AN(e, this.settings);
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(e) {
    this.mode = e;
  }
  /**
   * Start a new group nesting within all namespaces.
   */
  beginGroup() {
    this.macros.beginGroup();
  }
  /**
   * End current group nesting within all namespaces.
   */
  endGroup() {
    this.macros.endGroup();
  }
  /**
   * Ends all currently nested groups (if any), restoring values before the
   * groups began.  Useful in case of an error in the middle of parsing.
   */
  endGroups() {
    this.macros.endGroups();
  }
  /**
   * Returns the topmost token on the stack, without expanding it.
   * Similar in behavior to TeX's `\futurelet`.
   */
  future() {
    return this.stack.length === 0 && this.pushToken(this.lexer.lex()), this.stack[this.stack.length - 1];
  }
  /**
   * Remove and return the next unexpanded token.
   */
  popToken() {
    return this.future(), this.stack.pop();
  }
  /**
   * Add a given token to the token stack.  In particular, this get be used
   * to put back a token returned from one of the other methods.
   */
  pushToken(e) {
    this.stack.push(e);
  }
  /**
   * Append an array of tokens to the token stack.
   */
  pushTokens(e) {
    this.stack.push(...e);
  }
  /**
   * Find an macro argument without expanding tokens and append the array of
   * tokens to the token stack. Uses Token as a container for the result.
   */
  scanArgument(e) {
    var A, n, s;
    if (e) {
      if (this.consumeSpaces(), this.future().text !== "[")
        return null;
      A = this.popToken(), {
        tokens: s,
        end: n
      } = this.consumeArg(["]"]);
    } else
      ({
        tokens: s,
        start: A,
        end: n
      } = this.consumeArg());
    return this.pushToken(new ds("EOF", n.loc)), this.pushTokens(s), new ds("", On.range(A, n));
  }
  /**
   * Consume all following space tokens, without expansion.
   */
  consumeSpaces() {
    for (; ; ) {
      var e = this.future();
      if (e.text === " ")
        this.stack.pop();
      else
        break;
    }
  }
  /**
   * Consume an argument from the token stream, and return the resulting array
   * of tokens and start/end token.
   */
  consumeArg(e) {
    var A = [], n = e && e.length > 0;
    n || this.consumeSpaces();
    var s = this.future(), r, i = 0, o = 0;
    do {
      if (r = this.popToken(), A.push(r), r.text === "{")
        ++i;
      else if (r.text === "}") {
        if (--i, i === -1)
          throw new de("Extra }", r);
      } else if (r.text === "EOF")
        throw new de("Unexpected end of input in a macro argument, expected '" + (e && n ? e[o] : "}") + "'", r);
      if (e && n)
        if ((i === 0 || i === 1 && e[o] === "{") && r.text === e[o]) {
          if (++o, o === e.length) {
            A.splice(-o, o);
            break;
          }
        } else
          o = 0;
    } while (i !== 0 || n);
    return s.text === "{" && A[A.length - 1].text === "}" && (A.pop(), A.shift()), A.reverse(), {
      tokens: A,
      start: s,
      end: r
    };
  }
  /**
   * Consume the specified number of (delimited) arguments from the token
   * stream and return the resulting array of arguments.
   */
  consumeArgs(e, A) {
    if (A) {
      if (A.length !== e + 1)
        throw new de("The length of delimiters doesn't match the number of args!");
      for (var n = A[0], s = 0; s < n.length; s++) {
        var r = this.popToken();
        if (n[s] !== r.text)
          throw new de("Use of the macro doesn't match its definition", r);
      }
    }
    for (var i = [], o = 0; o < e; o++)
      i.push(this.consumeArg(A && A[o + 1]).tokens);
    return i;
  }
  /**
   * Increment `expansionCount` by the specified amount.
   * Throw an error if it exceeds `maxExpand`.
   */
  countExpansion(e) {
    if (this.expansionCount += e, this.expansionCount > this.settings.maxExpand)
      throw new de("Too many expansions: infinite loop or need to increase maxExpand setting");
  }
  /**
   * Expand the next token only once if possible.
   *
   * If the token is expanded, the resulting tokens will be pushed onto
   * the stack in reverse order, and the number of such tokens will be
   * returned.  This number might be zero or positive.
   *
   * If not, the return value is `false`, and the next token remains at the
   * top of the stack.
   *
   * In either case, the next token will be on the top of the stack,
   * or the stack will be empty (in case of empty expansion
   * and no other tokens).
   *
   * Used to implement `expandAfterFuture` and `expandNextToken`.
   *
   * If expandableOnly, only expandable tokens are expanded and
   * an undefined control sequence results in an error.
   */
  expandOnce(e) {
    var A = this.popToken(), n = A.text, s = A.noexpand ? null : this._getExpansion(n);
    if (s == null || e && s.unexpandable) {
      if (e && s == null && n[0] === "\\" && !this.isDefined(n))
        throw new de("Undefined control sequence: " + n);
      return this.pushToken(A), !1;
    }
    this.countExpansion(1);
    var r = s.tokens, i = this.consumeArgs(s.numArgs, s.delimiters);
    if (s.numArgs) {
      r = r.slice();
      for (var o = r.length - 1; o >= 0; --o) {
        var a = r[o];
        if (a.text === "#") {
          if (o === 0)
            throw new de("Incomplete placeholder at end of macro body", a);
          if (a = r[--o], a.text === "#")
            r.splice(o + 1, 1);
          else if (/^[1-9]$/.test(a.text))
            r.splice(o, 2, ...i[+a.text - 1]);
          else
            throw new de("Not a valid argument number", a);
        }
      }
    }
    return this.pushTokens(r), r.length;
  }
  /**
   * Expand the next token only once (if possible), and return the resulting
   * top token on the stack (without removing anything from the stack).
   * Similar in behavior to TeX's `\expandafter\futurelet`.
   * Equivalent to expandOnce() followed by future().
   */
  expandAfterFuture() {
    return this.expandOnce(), this.future();
  }
  /**
   * Recursively expand first token, then return first non-expandable token.
   */
  expandNextToken() {
    for (; ; )
      if (this.expandOnce() === !1) {
        var e = this.stack.pop();
        return e.treatAsRelax && (e.text = "\\relax"), e;
      }
    throw new Error();
  }
  /**
   * Fully expand the given macro name and return the resulting list of
   * tokens, or return `undefined` if no such macro is defined.
   */
  expandMacro(e) {
    return this.macros.has(e) ? this.expandTokens([new ds(e)]) : void 0;
  }
  /**
   * Fully expand the given token stream and return the resulting list of
   * tokens.  Note that the input tokens are in reverse order, but the
   * output tokens are in forward order.
   */
  expandTokens(e) {
    var A = [], n = this.stack.length;
    for (this.pushTokens(e); this.stack.length > n; )
      if (this.expandOnce(!0) === !1) {
        var s = this.stack.pop();
        s.treatAsRelax && (s.noexpand = !1, s.treatAsRelax = !1), A.push(s);
      }
    return this.countExpansion(A.length), A;
  }
  /**
   * Fully expand the given macro name and return the result as a string,
   * or return `undefined` if no such macro is defined.
   */
  expandMacroAsText(e) {
    var A = this.expandMacro(e);
    return A && A.map((n) => n.text).join("");
  }
  /**
   * Returns the expanded macro as a reversed array of tokens and a macro
   * argument count.  Or returns `null` if no such macro.
   */
  _getExpansion(e) {
    var A = this.macros.get(e);
    if (A == null)
      return A;
    if (e.length === 1) {
      var n = this.lexer.catcodes[e];
      if (n != null && n !== 13)
        return;
    }
    var s = typeof A == "function" ? A(this) : A;
    if (typeof s == "string") {
      var r = 0;
      if (s.indexOf("#") !== -1)
        for (var i = s.replace(/##/g, ""); i.indexOf("#" + (r + 1)) !== -1; )
          ++r;
      for (var o = new AN(s, this.settings), a = [], c = o.lex(); c.text !== "EOF"; )
        a.push(c), c = o.lex();
      a.reverse();
      var l = {
        tokens: a,
        numArgs: r
      };
      return l;
    }
    return s;
  }
  /**
   * Determine whether a command is currently "defined" (has some
   * functionality), meaning that it's a macro (in the current group),
   * a function, a symbol, or one of the special commands listed in
   * `implicitCommands`.
   */
  isDefined(e) {
    return this.macros.has(e) || ko.hasOwnProperty(e) || Ot.math.hasOwnProperty(e) || Ot.text.hasOwnProperty(e) || fv.hasOwnProperty(e);
  }
  /**
   * Determine whether a command is expandable.
   */
  isExpandable(e) {
    var A = this.macros.get(e);
    return A != null ? typeof A == "string" || typeof A == "function" || !A.unexpandable : ko.hasOwnProperty(e) && !ko[e].primitive;
  }
}
var rN = /^[₊₋₌₍₎₀₁₂₃₄₅₆₇₈₉ₐₑₕᵢⱼₖₗₘₙₒₚᵣₛₜᵤᵥₓᵦᵧᵨᵩᵪ]/, D0 = Object.freeze({
  "₊": "+",
  "₋": "-",
  "₌": "=",
  "₍": "(",
  "₎": ")",
  "₀": "0",
  "₁": "1",
  "₂": "2",
  "₃": "3",
  "₄": "4",
  "₅": "5",
  "₆": "6",
  "₇": "7",
  "₈": "8",
  "₉": "9",
  "ₐ": "a",
  "ₑ": "e",
  "ₕ": "h",
  "ᵢ": "i",
  "ⱼ": "j",
  "ₖ": "k",
  "ₗ": "l",
  "ₘ": "m",
  "ₙ": "n",
  "ₒ": "o",
  "ₚ": "p",
  "ᵣ": "r",
  "ₛ": "s",
  "ₜ": "t",
  "ᵤ": "u",
  "ᵥ": "v",
  "ₓ": "x",
  "ᵦ": "β",
  "ᵧ": "γ",
  "ᵨ": "ρ",
  "ᵩ": "ϕ",
  "ᵪ": "χ",
  "⁺": "+",
  "⁻": "-",
  "⁼": "=",
  "⁽": "(",
  "⁾": ")",
  "⁰": "0",
  "¹": "1",
  "²": "2",
  "³": "3",
  "⁴": "4",
  "⁵": "5",
  "⁶": "6",
  "⁷": "7",
  "⁸": "8",
  "⁹": "9",
  "ᴬ": "A",
  "ᴮ": "B",
  "ᴰ": "D",
  "ᴱ": "E",
  "ᴳ": "G",
  "ᴴ": "H",
  "ᴵ": "I",
  "ᴶ": "J",
  "ᴷ": "K",
  "ᴸ": "L",
  "ᴹ": "M",
  "ᴺ": "N",
  "ᴼ": "O",
  "ᴾ": "P",
  "ᴿ": "R",
  "ᵀ": "T",
  "ᵁ": "U",
  "ⱽ": "V",
  "ᵂ": "W",
  "ᵃ": "a",
  "ᵇ": "b",
  "ᶜ": "c",
  "ᵈ": "d",
  "ᵉ": "e",
  "ᶠ": "f",
  "ᵍ": "g",
  ʰ: "h",
  "ⁱ": "i",
  ʲ: "j",
  "ᵏ": "k",
  ˡ: "l",
  "ᵐ": "m",
  ⁿ: "n",
  "ᵒ": "o",
  "ᵖ": "p",
  ʳ: "r",
  ˢ: "s",
  "ᵗ": "t",
  "ᵘ": "u",
  "ᵛ": "v",
  ʷ: "w",
  ˣ: "x",
  ʸ: "y",
  "ᶻ": "z",
  "ᵝ": "β",
  "ᵞ": "γ",
  "ᵟ": "δ",
  "ᵠ": "ϕ",
  "ᵡ": "χ",
  "ᶿ": "θ"
}), fI = {
  "́": {
    text: "\\'",
    math: "\\acute"
  },
  "̀": {
    text: "\\`",
    math: "\\grave"
  },
  "̈": {
    text: '\\"',
    math: "\\ddot"
  },
  "̃": {
    text: "\\~",
    math: "\\tilde"
  },
  "̄": {
    text: "\\=",
    math: "\\bar"
  },
  "̆": {
    text: "\\u",
    math: "\\breve"
  },
  "̌": {
    text: "\\v",
    math: "\\check"
  },
  "̂": {
    text: "\\^",
    math: "\\hat"
  },
  "̇": {
    text: "\\.",
    math: "\\dot"
  },
  "̊": {
    text: "\\r",
    math: "\\mathring"
  },
  "̋": {
    text: "\\H"
  },
  "̧": {
    text: "\\c"
  }
}, iN = {
  á: "á",
  à: "à",
  ä: "ä",
  ǟ: "ǟ",
  ã: "ã",
  ā: "ā",
  ă: "ă",
  ắ: "ắ",
  ằ: "ằ",
  ẵ: "ẵ",
  ǎ: "ǎ",
  â: "â",
  ấ: "ấ",
  ầ: "ầ",
  ẫ: "ẫ",
  ȧ: "ȧ",
  ǡ: "ǡ",
  å: "å",
  ǻ: "ǻ",
  ḃ: "ḃ",
  ć: "ć",
  ḉ: "ḉ",
  č: "č",
  ĉ: "ĉ",
  ċ: "ċ",
  ç: "ç",
  ď: "ď",
  ḋ: "ḋ",
  ḑ: "ḑ",
  é: "é",
  è: "è",
  ë: "ë",
  ẽ: "ẽ",
  ē: "ē",
  ḗ: "ḗ",
  ḕ: "ḕ",
  ĕ: "ĕ",
  ḝ: "ḝ",
  ě: "ě",
  ê: "ê",
  ế: "ế",
  ề: "ề",
  ễ: "ễ",
  ė: "ė",
  ȩ: "ȩ",
  ḟ: "ḟ",
  ǵ: "ǵ",
  ḡ: "ḡ",
  ğ: "ğ",
  ǧ: "ǧ",
  ĝ: "ĝ",
  ġ: "ġ",
  ģ: "ģ",
  ḧ: "ḧ",
  ȟ: "ȟ",
  ĥ: "ĥ",
  ḣ: "ḣ",
  ḩ: "ḩ",
  í: "í",
  ì: "ì",
  ï: "ï",
  ḯ: "ḯ",
  ĩ: "ĩ",
  ī: "ī",
  ĭ: "ĭ",
  ǐ: "ǐ",
  î: "î",
  ǰ: "ǰ",
  ĵ: "ĵ",
  ḱ: "ḱ",
  ǩ: "ǩ",
  ķ: "ķ",
  ĺ: "ĺ",
  ľ: "ľ",
  ļ: "ļ",
  ḿ: "ḿ",
  ṁ: "ṁ",
  ń: "ń",
  ǹ: "ǹ",
  ñ: "ñ",
  ň: "ň",
  ṅ: "ṅ",
  ņ: "ņ",
  ó: "ó",
  ò: "ò",
  ö: "ö",
  ȫ: "ȫ",
  õ: "õ",
  ṍ: "ṍ",
  ṏ: "ṏ",
  ȭ: "ȭ",
  ō: "ō",
  ṓ: "ṓ",
  ṑ: "ṑ",
  ŏ: "ŏ",
  ǒ: "ǒ",
  ô: "ô",
  ố: "ố",
  ồ: "ồ",
  ỗ: "ỗ",
  ȯ: "ȯ",
  ȱ: "ȱ",
  ő: "ő",
  ṕ: "ṕ",
  ṗ: "ṗ",
  ŕ: "ŕ",
  ř: "ř",
  ṙ: "ṙ",
  ŗ: "ŗ",
  ś: "ś",
  ṥ: "ṥ",
  š: "š",
  ṧ: "ṧ",
  ŝ: "ŝ",
  ṡ: "ṡ",
  ş: "ş",
  ẗ: "ẗ",
  ť: "ť",
  ṫ: "ṫ",
  ţ: "ţ",
  ú: "ú",
  ù: "ù",
  ü: "ü",
  ǘ: "ǘ",
  ǜ: "ǜ",
  ǖ: "ǖ",
  ǚ: "ǚ",
  ũ: "ũ",
  ṹ: "ṹ",
  ū: "ū",
  ṻ: "ṻ",
  ŭ: "ŭ",
  ǔ: "ǔ",
  û: "û",
  ů: "ů",
  ű: "ű",
  ṽ: "ṽ",
  ẃ: "ẃ",
  ẁ: "ẁ",
  ẅ: "ẅ",
  ŵ: "ŵ",
  ẇ: "ẇ",
  ẘ: "ẘ",
  ẍ: "ẍ",
  ẋ: "ẋ",
  ý: "ý",
  ỳ: "ỳ",
  ÿ: "ÿ",
  ỹ: "ỹ",
  ȳ: "ȳ",
  ŷ: "ŷ",
  ẏ: "ẏ",
  ẙ: "ẙ",
  ź: "ź",
  ž: "ž",
  ẑ: "ẑ",
  ż: "ż",
  Á: "Á",
  À: "À",
  Ä: "Ä",
  Ǟ: "Ǟ",
  Ã: "Ã",
  Ā: "Ā",
  Ă: "Ă",
  Ắ: "Ắ",
  Ằ: "Ằ",
  Ẵ: "Ẵ",
  Ǎ: "Ǎ",
  Â: "Â",
  Ấ: "Ấ",
  Ầ: "Ầ",
  Ẫ: "Ẫ",
  Ȧ: "Ȧ",
  Ǡ: "Ǡ",
  Å: "Å",
  Ǻ: "Ǻ",
  Ḃ: "Ḃ",
  Ć: "Ć",
  Ḉ: "Ḉ",
  Č: "Č",
  Ĉ: "Ĉ",
  Ċ: "Ċ",
  Ç: "Ç",
  Ď: "Ď",
  Ḋ: "Ḋ",
  Ḑ: "Ḑ",
  É: "É",
  È: "È",
  Ë: "Ë",
  Ẽ: "Ẽ",
  Ē: "Ē",
  Ḗ: "Ḗ",
  Ḕ: "Ḕ",
  Ĕ: "Ĕ",
  Ḝ: "Ḝ",
  Ě: "Ě",
  Ê: "Ê",
  Ế: "Ế",
  Ề: "Ề",
  Ễ: "Ễ",
  Ė: "Ė",
  Ȩ: "Ȩ",
  Ḟ: "Ḟ",
  Ǵ: "Ǵ",
  Ḡ: "Ḡ",
  Ğ: "Ğ",
  Ǧ: "Ǧ",
  Ĝ: "Ĝ",
  Ġ: "Ġ",
  Ģ: "Ģ",
  Ḧ: "Ḧ",
  Ȟ: "Ȟ",
  Ĥ: "Ĥ",
  Ḣ: "Ḣ",
  Ḩ: "Ḩ",
  Í: "Í",
  Ì: "Ì",
  Ï: "Ï",
  Ḯ: "Ḯ",
  Ĩ: "Ĩ",
  Ī: "Ī",
  Ĭ: "Ĭ",
  Ǐ: "Ǐ",
  Î: "Î",
  İ: "İ",
  Ĵ: "Ĵ",
  Ḱ: "Ḱ",
  Ǩ: "Ǩ",
  Ķ: "Ķ",
  Ĺ: "Ĺ",
  Ľ: "Ľ",
  Ļ: "Ļ",
  Ḿ: "Ḿ",
  Ṁ: "Ṁ",
  Ń: "Ń",
  Ǹ: "Ǹ",
  Ñ: "Ñ",
  Ň: "Ň",
  Ṅ: "Ṅ",
  Ņ: "Ņ",
  Ó: "Ó",
  Ò: "Ò",
  Ö: "Ö",
  Ȫ: "Ȫ",
  Õ: "Õ",
  Ṍ: "Ṍ",
  Ṏ: "Ṏ",
  Ȭ: "Ȭ",
  Ō: "Ō",
  Ṓ: "Ṓ",
  Ṑ: "Ṑ",
  Ŏ: "Ŏ",
  Ǒ: "Ǒ",
  Ô: "Ô",
  Ố: "Ố",
  Ồ: "Ồ",
  Ỗ: "Ỗ",
  Ȯ: "Ȯ",
  Ȱ: "Ȱ",
  Ő: "Ő",
  Ṕ: "Ṕ",
  Ṗ: "Ṗ",
  Ŕ: "Ŕ",
  Ř: "Ř",
  Ṙ: "Ṙ",
  Ŗ: "Ŗ",
  Ś: "Ś",
  Ṥ: "Ṥ",
  Š: "Š",
  Ṧ: "Ṧ",
  Ŝ: "Ŝ",
  Ṡ: "Ṡ",
  Ş: "Ş",
  Ť: "Ť",
  Ṫ: "Ṫ",
  Ţ: "Ţ",
  Ú: "Ú",
  Ù: "Ù",
  Ü: "Ü",
  Ǘ: "Ǘ",
  Ǜ: "Ǜ",
  Ǖ: "Ǖ",
  Ǚ: "Ǚ",
  Ũ: "Ũ",
  Ṹ: "Ṹ",
  Ū: "Ū",
  Ṻ: "Ṻ",
  Ŭ: "Ŭ",
  Ǔ: "Ǔ",
  Û: "Û",
  Ů: "Ů",
  Ű: "Ű",
  Ṽ: "Ṽ",
  Ẃ: "Ẃ",
  Ẁ: "Ẁ",
  Ẅ: "Ẅ",
  Ŵ: "Ŵ",
  Ẇ: "Ẇ",
  Ẍ: "Ẍ",
  Ẋ: "Ẋ",
  Ý: "Ý",
  Ỳ: "Ỳ",
  Ÿ: "Ÿ",
  Ỹ: "Ỹ",
  Ȳ: "Ȳ",
  Ŷ: "Ŷ",
  Ẏ: "Ẏ",
  Ź: "Ź",
  Ž: "Ž",
  Ẑ: "Ẑ",
  Ż: "Ż",
  ά: "ά",
  ὰ: "ὰ",
  ᾱ: "ᾱ",
  ᾰ: "ᾰ",
  έ: "έ",
  ὲ: "ὲ",
  ή: "ή",
  ὴ: "ὴ",
  ί: "ί",
  ὶ: "ὶ",
  ϊ: "ϊ",
  ΐ: "ΐ",
  ῒ: "ῒ",
  ῑ: "ῑ",
  ῐ: "ῐ",
  ό: "ό",
  ὸ: "ὸ",
  ύ: "ύ",
  ὺ: "ὺ",
  ϋ: "ϋ",
  ΰ: "ΰ",
  ῢ: "ῢ",
  ῡ: "ῡ",
  ῠ: "ῠ",
  ώ: "ώ",
  ὼ: "ὼ",
  Ύ: "Ύ",
  Ὺ: "Ὺ",
  Ϋ: "Ϋ",
  Ῡ: "Ῡ",
  Ῠ: "Ῠ",
  Ώ: "Ώ",
  Ὼ: "Ὼ"
};
class of {
  constructor(e, A) {
    this.mode = void 0, this.gullet = void 0, this.settings = void 0, this.leftrightDepth = void 0, this.nextToken = void 0, this.mode = "math", this.gullet = new Kee(e, A, this.mode), this.settings = A, this.leftrightDepth = 0;
  }
  /**
   * Checks a result to make sure it has the right type, and throws an
   * appropriate error otherwise.
   */
  expect(e, A) {
    if (A === void 0 && (A = !0), this.fetch().text !== e)
      throw new de("Expected '" + e + "', got '" + this.fetch().text + "'", this.fetch());
    A && this.consume();
  }
  /**
   * Discards the current lookahead token, considering it consumed.
   */
  consume() {
    this.nextToken = null;
  }
  /**
   * Return the current lookahead token, or if there isn't one (at the
   * beginning, or if the previous lookahead token was consume()d),
   * fetch the next token as the new lookahead token and return it.
   */
  fetch() {
    return this.nextToken == null && (this.nextToken = this.gullet.expandNextToken()), this.nextToken;
  }
  /**
   * Switches between "text" and "math" modes.
   */
  switchMode(e) {
    this.mode = e, this.gullet.switchMode(e);
  }
  /**
   * Main parsing function, which parses an entire input.
   */
  parse() {
    this.settings.globalGroup || this.gullet.beginGroup(), this.settings.colorIsTextColor && this.gullet.macros.set("\\color", "\\textcolor");
    try {
      var e = this.parseExpression(!1);
      return this.expect("EOF"), this.settings.globalGroup || this.gullet.endGroup(), e;
    } finally {
      this.gullet.endGroups();
    }
  }
  /**
   * Fully parse a separate sequence of tokens as a separate job.
   * Tokens should be specified in reverse order, as in a MacroDefinition.
   */
  subparse(e) {
    var A = this.nextToken;
    this.consume(), this.gullet.pushToken(new ds("}")), this.gullet.pushTokens(e);
    var n = this.parseExpression(!1);
    return this.expect("}"), this.nextToken = A, n;
  }
  /**
   * Parses an "expression", which is a list of atoms.
   *
   * `breakOnInfix`: Should the parsing stop when we hit infix nodes? This
   *                 happens when functions have higher precedence than infix
   *                 nodes in implicit parses.
   *
   * `breakOnTokenText`: The text of the token that the expression should end
   *                     with, or `null` if something else should end the
   *                     expression.
   */
  parseExpression(e, A) {
    for (var n = []; ; ) {
      this.mode === "math" && this.consumeSpaces();
      var s = this.fetch();
      if (of.endOfExpression.indexOf(s.text) !== -1 || A && s.text === A || e && ko[s.text] && ko[s.text].infix)
        break;
      var r = this.parseAtom(A);
      if (r) {
        if (r.type === "internal")
          continue;
      } else break;
      n.push(r);
    }
    return this.mode === "text" && this.formLigatures(n), this.handleInfixNodes(n);
  }
  /**
   * Rewrites infix operators such as \over with corresponding commands such
   * as \frac.
   *
   * There can only be one infix operator per group.  If there's more than one
   * then the expression is ambiguous.  This can be resolved by adding {}.
   */
  handleInfixNodes(e) {
    for (var A = -1, n, s = 0; s < e.length; s++)
      if (e[s].type === "infix") {
        if (A !== -1)
          throw new de("only one infix operator per group", e[s].token);
        A = s, n = e[s].replaceWith;
      }
    if (A !== -1 && n) {
      var r, i, o = e.slice(0, A), a = e.slice(A + 1);
      o.length === 1 && o[0].type === "ordgroup" ? r = o[0] : r = {
        type: "ordgroup",
        mode: this.mode,
        body: o
      }, a.length === 1 && a[0].type === "ordgroup" ? i = a[0] : i = {
        type: "ordgroup",
        mode: this.mode,
        body: a
      };
      var c;
      return n === "\\\\abovefrac" ? c = this.callFunction(n, [r, e[A], i], []) : c = this.callFunction(n, [r, i], []), [c];
    } else
      return e;
  }
  /**
   * Handle a subscript or superscript with nice errors.
   */
  handleSupSubscript(e) {
    var A = this.fetch(), n = A.text;
    this.consume(), this.consumeSpaces();
    var s;
    do {
      var r;
      s = this.parseGroup(e);
    } while (((r = s) == null ? void 0 : r.type) === "internal");
    if (!s)
      throw new de("Expected group after '" + n + "'", A);
    return s;
  }
  /**
   * Converts the textual input of an unsupported command into a text node
   * contained within a color node whose color is determined by errorColor
   */
  formatUnsupportedCmd(e) {
    for (var A = [], n = 0; n < e.length; n++)
      A.push({
        type: "textord",
        mode: "text",
        text: e[n]
      });
    var s = {
      type: "text",
      mode: this.mode,
      body: A
    }, r = {
      type: "color",
      mode: this.mode,
      color: this.settings.errorColor,
      body: [s]
    };
    return r;
  }
  /**
   * Parses a group with optional super/subscripts.
   */
  parseAtom(e) {
    var A = this.parseGroup("atom", e);
    if ((A == null ? void 0 : A.type) === "internal" || this.mode === "text")
      return A;
    for (var n, s; ; ) {
      this.consumeSpaces();
      var r = this.fetch();
      if (r.text === "\\limits" || r.text === "\\nolimits") {
        if (A && A.type === "op") {
          var i = r.text === "\\limits";
          A.limits = i, A.alwaysHandleSupSub = !0;
        } else if (A && A.type === "operatorname")
          A.alwaysHandleSupSub && (A.limits = r.text === "\\limits");
        else
          throw new de("Limit controls must follow a math operator", r);
        this.consume();
      } else if (r.text === "^") {
        if (n)
          throw new de("Double superscript", r);
        n = this.handleSupSubscript("superscript");
      } else if (r.text === "_") {
        if (s)
          throw new de("Double subscript", r);
        s = this.handleSupSubscript("subscript");
      } else if (r.text === "'") {
        if (n)
          throw new de("Double superscript", r);
        var o = {
          type: "textord",
          mode: this.mode,
          text: "\\prime"
        }, a = [o];
        for (this.consume(); this.fetch().text === "'"; )
          a.push(o), this.consume();
        this.fetch().text === "^" && a.push(this.handleSupSubscript("superscript")), n = {
          type: "ordgroup",
          mode: this.mode,
          body: a
        };
      } else if (D0[r.text]) {
        var c = rN.test(r.text), l = [];
        for (l.push(new ds(D0[r.text])), this.consume(); ; ) {
          var B = this.fetch().text;
          if (!D0[B] || rN.test(B) !== c)
            break;
          l.unshift(new ds(D0[B])), this.consume();
        }
        var g = this.subparse(l);
        c ? s = {
          type: "ordgroup",
          mode: "math",
          body: g
        } : n = {
          type: "ordgroup",
          mode: "math",
          body: g
        };
      } else
        break;
    }
    return n || s ? {
      type: "supsub",
      mode: this.mode,
      base: A,
      sup: n,
      sub: s
    } : A;
  }
  /**
   * Parses an entire function, including its base and all of its arguments.
   */
  parseFunction(e, A) {
    var n = this.fetch(), s = n.text, r = ko[s];
    if (!r)
      return null;
    if (this.consume(), A && A !== "atom" && !r.allowedInArgument)
      throw new de("Got function '" + s + "' with no arguments" + (A ? " as " + A : ""), n);
    if (this.mode === "text" && !r.allowedInText)
      throw new de("Can't use function '" + s + "' in text mode", n);
    if (this.mode === "math" && r.allowedInMath === !1)
      throw new de("Can't use function '" + s + "' in math mode", n);
    var {
      args: i,
      optArgs: o
    } = this.parseArguments(s, r);
    return this.callFunction(s, i, o, n, e);
  }
  /**
   * Call a function handler with a suitable context and arguments.
   */
  callFunction(e, A, n, s, r) {
    var i = {
      funcName: e,
      parser: this,
      token: s,
      breakOnTokenText: r
    }, o = ko[e];
    if (o && o.handler)
      return o.handler(i, A, n);
    throw new de("No function handler for " + e);
  }
  /**
   * Parses the arguments of a function or environment
   */
  parseArguments(e, A) {
    var n = A.numArgs + A.numOptionalArgs;
    if (n === 0)
      return {
        args: [],
        optArgs: []
      };
    for (var s = [], r = [], i = 0; i < n; i++) {
      var o = A.argTypes && A.argTypes[i], a = i < A.numOptionalArgs;
      (A.primitive && o == null || // \sqrt expands into primitive if optional argument doesn't exist
      A.type === "sqrt" && i === 1 && r[0] == null) && (o = "primitive");
      var c = this.parseGroupOfType("argument to '" + e + "'", o, a);
      if (a)
        r.push(c);
      else if (c != null)
        s.push(c);
      else
        throw new de("Null argument, please report this as a bug");
    }
    return {
      args: s,
      optArgs: r
    };
  }
  /**
   * Parses a group when the mode is changing.
   */
  parseGroupOfType(e, A, n) {
    switch (A) {
      case "color":
        return this.parseColorGroup(n);
      case "size":
        return this.parseSizeGroup(n);
      case "url":
        return this.parseUrlGroup(n);
      case "math":
      case "text":
        return this.parseArgumentGroup(n, A);
      case "hbox": {
        var s = this.parseArgumentGroup(n, "text");
        return s != null ? {
          type: "styling",
          mode: s.mode,
          body: [s],
          style: "text"
          // simulate \textstyle
        } : null;
      }
      case "raw": {
        var r = this.parseStringGroup("raw", n);
        return r != null ? {
          type: "raw",
          mode: "text",
          string: r.text
        } : null;
      }
      case "primitive": {
        if (n)
          throw new de("A primitive argument cannot be optional");
        var i = this.parseGroup(e);
        if (i == null)
          throw new de("Expected group as " + e, this.fetch());
        return i;
      }
      case "original":
      case null:
      case void 0:
        return this.parseArgumentGroup(n);
      default:
        throw new de("Unknown group type as " + e, this.fetch());
    }
  }
  /**
   * Discard any space tokens, fetching the next non-space token.
   */
  consumeSpaces() {
    for (; this.fetch().text === " "; )
      this.consume();
  }
  /**
   * Parses a group, essentially returning the string formed by the
   * brace-enclosed tokens plus some position information.
   */
  parseStringGroup(e, A) {
    var n = this.gullet.scanArgument(A);
    if (n == null)
      return null;
    for (var s = "", r; (r = this.fetch()).text !== "EOF"; )
      s += r.text, this.consume();
    return this.consume(), n.text = s, n;
  }
  /**
   * Parses a regex-delimited group: the largest sequence of tokens
   * whose concatenated strings match `regex`. Returns the string
   * formed by the tokens plus some position information.
   */
  parseRegexGroup(e, A) {
    for (var n = this.fetch(), s = n, r = "", i; (i = this.fetch()).text !== "EOF" && e.test(r + i.text); )
      s = i, r += s.text, this.consume();
    if (r === "")
      throw new de("Invalid " + A + ": '" + n.text + "'", n);
    return n.range(s, r);
  }
  /**
   * Parses a color description.
   */
  parseColorGroup(e) {
    var A = this.parseStringGroup("color", e);
    if (A == null)
      return null;
    var n = /^(#[a-f0-9]{3,4}|#[a-f0-9]{6}|#[a-f0-9]{8}|[a-f0-9]{6}|[a-z]+)$/i.exec(A.text);
    if (!n)
      throw new de("Invalid color: '" + A.text + "'", A);
    var s = n[0];
    return /^[0-9a-f]{6}$/i.test(s) && (s = "#" + s), {
      type: "color-token",
      mode: this.mode,
      color: s
    };
  }
  /**
   * Parses a size specification, consisting of magnitude and unit.
   */
  parseSizeGroup(e) {
    var A, n = !1;
    if (this.gullet.consumeSpaces(), !e && this.gullet.future().text !== "{" ? A = this.parseRegexGroup(/^[-+]? *(?:$|\d+|\d+\.\d*|\.\d*) *[a-z]{0,2} *$/, "size") : A = this.parseStringGroup("size", e), !A)
      return null;
    !e && A.text.length === 0 && (A.text = "0pt", n = !0);
    var s = /([-+]?) *(\d+(?:\.\d*)?|\.\d+) *([a-z]{2})/.exec(A.text);
    if (!s)
      throw new de("Invalid size: '" + A.text + "'", A);
    var r = {
      number: +(s[1] + s[2]),
      // sign + magnitude, cast to number
      unit: s[3]
    };
    if (!Fb(r))
      throw new de("Invalid unit: '" + r.unit + "'", A);
    return {
      type: "size",
      mode: this.mode,
      value: r,
      isBlank: n
    };
  }
  /**
   * Parses an URL, checking escaped letters and allowed protocols,
   * and setting the catcode of % as an active character (as in \hyperref).
   */
  parseUrlGroup(e) {
    this.gullet.lexer.setCatcode("%", 13), this.gullet.lexer.setCatcode("~", 12);
    var A = this.parseStringGroup("url", e);
    if (this.gullet.lexer.setCatcode("%", 14), this.gullet.lexer.setCatcode("~", 13), A == null)
      return null;
    var n = A.text.replace(/\\([#$%&~_^{}])/g, "$1");
    return {
      type: "url",
      mode: this.mode,
      url: n
    };
  }
  /**
   * Parses an argument with the mode specified.
   */
  parseArgumentGroup(e, A) {
    var n = this.gullet.scanArgument(e);
    if (n == null)
      return null;
    var s = this.mode;
    A && this.switchMode(A), this.gullet.beginGroup();
    var r = this.parseExpression(!1, "EOF");
    this.expect("EOF"), this.gullet.endGroup();
    var i = {
      type: "ordgroup",
      mode: this.mode,
      loc: n.loc,
      body: r
    };
    return A && this.switchMode(s), i;
  }
  /**
   * Parses an ordinary group, which is either a single nucleus (like "x")
   * or an expression in braces (like "{x+y}") or an implicit group, a group
   * that starts at the current position, and ends right before a higher explicit
   * group ends, or at EOF.
   */
  parseGroup(e, A) {
    var n = this.fetch(), s = n.text, r;
    if (s === "{" || s === "\\begingroup") {
      this.consume();
      var i = s === "{" ? "}" : "\\endgroup";
      this.gullet.beginGroup();
      var o = this.parseExpression(!1, i), a = this.fetch();
      this.expect(i), this.gullet.endGroup(), r = {
        type: "ordgroup",
        mode: this.mode,
        loc: On.range(n, a),
        body: o,
        // A group formed by \begingroup...\endgroup is a semi-simple group
        // which doesn't affect spacing in math mode, i.e., is transparent.
        // https://tex.stackexchange.com/questions/1930/when-should-one-
        // use-begingroup-instead-of-bgroup
        semisimple: s === "\\begingroup" || void 0
      };
    } else if (r = this.parseFunction(A, e) || this.parseSymbol(), r == null && s[0] === "\\" && !fv.hasOwnProperty(s)) {
      if (this.settings.throwOnError)
        throw new de("Undefined control sequence: " + s, n);
      r = this.formatUnsupportedCmd(s), this.consume();
    }
    return r;
  }
  /**
   * Form ligature-like combinations of characters for text mode.
   * This includes inputs like "--", "---", "``" and "''".
   * The result will simply replace multiple textord nodes with a single
   * character in each value by a single textord node having multiple
   * characters in its value.  The representation is still ASCII source.
   * The group will be modified in place.
   */
  formLigatures(e) {
    for (var A = e.length - 1, n = 0; n < A; ++n) {
      var s = e[n], r = s.text;
      r === "-" && e[n + 1].text === "-" && (n + 1 < A && e[n + 2].text === "-" ? (e.splice(n, 3, {
        type: "textord",
        mode: "text",
        loc: On.range(s, e[n + 2]),
        text: "---"
      }), A -= 2) : (e.splice(n, 2, {
        type: "textord",
        mode: "text",
        loc: On.range(s, e[n + 1]),
        text: "--"
      }), A -= 1)), (r === "'" || r === "`") && e[n + 1].text === r && (e.splice(n, 2, {
        type: "textord",
        mode: "text",
        loc: On.range(s, e[n + 1]),
        text: r + r
      }), A -= 1);
    }
  }
  /**
   * Parse a single symbol out of the string. Here, we handle single character
   * symbols and special functions like \verb.
   */
  parseSymbol() {
    var e = this.fetch(), A = e.text;
    if (/^\\verb[^a-zA-Z]/.test(A)) {
      this.consume();
      var n = A.slice(5), s = n.charAt(0) === "*";
      if (s && (n = n.slice(1)), n.length < 2 || n.charAt(0) !== n.slice(-1))
        throw new de(`\\verb assertion failed --
                    please report what input caused this bug`);
      return n = n.slice(1, -1), {
        type: "verb",
        mode: "text",
        body: n,
        star: s
      };
    }
    iN.hasOwnProperty(A[0]) && !Ot[this.mode][A[0]] && (this.settings.strict && this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Accented Unicode text character "' + A[0] + '" used in math mode', e), A = iN[A[0]] + A.slice(1));
    var r = Jee.exec(A);
    r && (A = A.substring(0, r.index), A === "i" ? A = "ı" : A === "j" && (A = "ȷ"));
    var i;
    if (Ot[this.mode][A]) {
      this.settings.strict && this.mode === "math" && DE.indexOf(A) >= 0 && this.settings.reportNonstrict("unicodeTextInMathMode", 'Latin-1/Unicode text character "' + A[0] + '" used in math mode', e);
      var o = Ot[this.mode][A].group, a = On.range(e), c;
      if (v$.hasOwnProperty(o)) {
        var l = o;
        c = {
          type: "atom",
          mode: this.mode,
          family: l,
          loc: a,
          text: A
        };
      } else
        c = {
          type: o,
          mode: this.mode,
          loc: a,
          text: A
        };
      i = c;
    } else if (A.charCodeAt(0) >= 128)
      this.settings.strict && (yb(A.charCodeAt(0)) ? this.mode === "math" && this.settings.reportNonstrict("unicodeTextInMathMode", 'Unicode text character "' + A[0] + '" used in math mode', e) : this.settings.reportNonstrict("unknownSymbol", 'Unrecognized Unicode character "' + A[0] + '"' + (" (" + A.charCodeAt(0) + ")"), e)), i = {
        type: "textord",
        mode: "text",
        loc: On.range(e),
        text: A
      };
    else
      return null;
    if (this.consume(), r)
      for (var B = 0; B < r[0].length; B++) {
        var g = r[0][B];
        if (!fI[g])
          throw new de("Unknown accent ' " + g + "'", e);
        var h = fI[g][this.mode] || fI[g].text;
        if (!h)
          throw new de("Accent " + g + " unsupported in " + this.mode + " mode", e);
        i = {
          type: "accent",
          mode: this.mode,
          loc: On.range(e),
          label: h,
          isStretchy: !1,
          isShifty: !0,
          // $FlowFixMe
          base: i
        };
      }
    return i;
  }
}
of.endOfExpression = ["}", "\\endgroup", "\\end", "\\right", "&"];
var Ym = function(e, A) {
  if (!(typeof e == "string" || e instanceof String))
    throw new TypeError("KaTeX can only parse string typed expression");
  var n = new of(e, A);
  delete n.gullet.macros.current["\\df@tag"];
  var s = n.parse();
  if (delete n.gullet.macros.current["\\current@color"], delete n.gullet.macros.current["\\color"], n.gullet.macros.get("\\df@tag")) {
    if (!A.displayMode)
      throw new de("\\tag works only in display equations");
    s = [{
      type: "tag",
      mode: "text",
      body: s,
      tag: n.subparse([new ds("\\df@tag")])
    }];
  }
  return s;
}, Qv = function(e, A, n) {
  A.textContent = "";
  var s = ym(e, n).toNode();
  A.appendChild(s);
};
typeof document < "u" && document.compatMode !== "CSS1Compat" && (typeof console < "u" && console.warn("Warning: KaTeX doesn't work in quirks mode. Make sure your website has a suitable doctype."), Qv = function() {
  throw new de("KaTeX doesn't work in quirks mode.");
});
var Vee = function(e, A) {
  var n = ym(e, A).toMarkup();
  return n;
}, Xee = function(e, A) {
  var n = new om(A);
  return Ym(e, n);
}, Iv = function(e, A, n) {
  if (n.throwOnError || !(e instanceof de))
    throw e;
  var s = O.makeSpan(["katex-error"], [new Ss(A)]);
  return s.setAttribute("title", e.toString()), s.setAttribute("style", "color:" + n.errorColor), s;
}, ym = function(e, A) {
  var n = new om(A);
  try {
    var s = Ym(e, n);
    return see(s, e, n);
  } catch (r) {
    return Iv(r, e, n);
  }
}, Zee = function(e, A) {
  var n = new om(A);
  try {
    var s = Ym(e, n);
    return ree(s, e, n);
  } catch (r) {
    return Iv(r, e, n);
  }
}, qee = "0.16.28", _ee = {
  Span: mh,
  Anchor: lm,
  SymbolNode: Ss,
  SvgNode: Ti,
  PathNode: sa,
  LineNode: NE
}, Cv = {
  /**
   * Current KaTeX version
   */
  version: qee,
  /**
   * Renders the given LaTeX into an HTML+MathML combination, and adds
   * it as a child to the specified DOM node.
   */
  render: Qv,
  /**
   * Renders the given LaTeX into an HTML+MathML combination string,
   * for sending to the client.
   */
  renderToString: Vee,
  /**
   * KaTeX error, usually during parsing.
   */
  ParseError: de,
  /**
   * The schema of Settings
   */
  SETTINGS_SCHEMA: lu,
  /**
   * Parses the given LaTeX into KaTeX's internal parse tree structure,
   * without rendering to HTML or MathML.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __parse: Xee,
  /**
   * Renders the given LaTeX into an HTML+MathML internal DOM tree
   * representation, without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToDomTree: ym,
  /**
   * Renders the given LaTeX into an HTML internal DOM tree representation,
   * without MathML and without flattening that representation to a string.
   *
   * NOTE: This method is not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __renderToHTMLTree: Zee,
  /**
   * extends internal font metrics object with a new object
   * each key in the new object represents a font name
  */
  __setFontMetrics: F$,
  /**
   * adds a new symbol to builtin symbols table
   */
  __defineSymbol: f,
  /**
   * adds a new function to builtin function list,
   * which directly produce parse tree elements
   * and have their own html/mathml builders
   */
  __defineFunction: Ye,
  /**
   * adds a new macro to builtin macro list
   */
  __defineMacro: z,
  /**
   * Expose the dom tree node types, which can be useful for type checking nodes.
   *
   * NOTE: These methods are not currently recommended for public use.
   * The internal tree representation is unstable and is very likely
   * to change. Use at your own risk.
   */
  __domTree: _ee
}, $ee = Zt.create({
  name: "blockMath",
  group: "block",
  atom: !0,
  addOptions() {
    return {
      onClick: void 0,
      katexOptions: void 0
    };
  },
  addAttributes() {
    return {
      latex: {
        default: "",
        parseHTML: (t) => t.getAttribute("data-latex"),
        renderHTML: (t) => ({
          "data-latex": t.latex
        })
      }
    };
  },
  addCommands() {
    return {
      insertBlockMath: (t) => ({ commands: e, editor: A }) => {
        const { latex: n, pos: s } = t;
        return n ? e.insertContentAt(s ?? A.state.selection.from, {
          type: this.name,
          attrs: { latex: n }
        }) : !1;
      },
      deleteBlockMath: (t) => ({ editor: e, tr: A }) => {
        var n;
        const s = (n = t == null ? void 0 : t.pos) != null ? n : e.state.selection.$from.pos, r = e.state.doc.nodeAt(s);
        return !r || r.type.name !== this.name ? !1 : (A.delete(s, s + r.nodeSize), !0);
      },
      updateBlockMath: (t) => ({ editor: e, tr: A }) => {
        const n = t == null ? void 0 : t.latex;
        let s = t == null ? void 0 : t.pos;
        s === void 0 && (s = e.state.selection.$from.pos);
        const r = e.state.doc.nodeAt(s);
        return !r || r.type.name !== this.name ? !1 : (A.setNodeMarkup(s, this.type, {
          ...r.attrs,
          latex: n || r.attrs.latex
        }), !0);
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'div[data-type="block-math"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["div", Ct(t, { "data-type": "block-math" })];
  },
  parseMarkdown: (t) => ({
    type: "blockMath",
    attrs: {
      latex: t.latex
    }
  }),
  renderMarkdown: (t) => {
    var e;
    return ["$$", ((e = t.attrs) == null ? void 0 : e.latex) || "", "$$"].join(`
`);
  },
  markdownTokenizer: {
    name: "blockMath",
    level: "block",
    start: (t) => t.indexOf("$$"),
    tokenize: (t) => {
      const e = t.match(/^\$\$([^$]+)\$\$/);
      if (!e)
        return;
      const [A, n] = e;
      return {
        type: "blockMath",
        raw: A,
        latex: n.trim()
      };
    }
  },
  addInputRules() {
    return [
      new Sl({
        find: /^\$\$\$([^$]+)\$\$\$$/,
        handler: ({ state: t, range: e, match: A }) => {
          const [, n] = A, { tr: s } = t, r = e.from, i = e.to;
          s.replaceWith(r, i, this.type.create({ latex: n }));
        }
      })
    ];
  },
  addNodeView() {
    const { katexOptions: t } = this.options;
    return ({ node: e, getPos: A }) => {
      const n = document.createElement("div"), s = document.createElement("div");
      n.className = "tiptap-mathematics-render", this.editor.isEditable && n.classList.add("tiptap-mathematics-render--editable"), s.className = "block-math-inner", n.dataset.type = "block-math", n.setAttribute("data-latex", e.attrs.latex), n.appendChild(s);
      function r() {
        try {
          Cv.render(e.attrs.latex, s, t), n.classList.remove("block-math-error");
        } catch {
          n.textContent = e.attrs.latex, n.classList.add("block-math-error");
        }
      }
      const i = (o) => {
        o.preventDefault(), o.stopPropagation();
        const a = A();
        a != null && this.options.onClick && this.options.onClick(e, a);
      };
      return this.options.onClick && n.addEventListener("click", i), r(), {
        dom: n,
        destroy() {
          n.removeEventListener("click", i);
        }
      };
    };
  }
}), ete = Zt.create({
  name: "inlineMath",
  group: "inline",
  inline: !0,
  atom: !0,
  addOptions() {
    return {
      onClick: void 0,
      katexOptions: void 0
    };
  },
  addAttributes() {
    return {
      latex: {
        default: "",
        parseHTML: (t) => t.getAttribute("data-latex"),
        renderHTML: (t) => ({
          "data-latex": t.latex
        })
      }
    };
  },
  addCommands() {
    return {
      insertInlineMath: (t) => ({ editor: e, tr: A }) => {
        var n;
        const s = t.latex, r = (n = t == null ? void 0 : t.pos) != null ? n : e.state.selection.from;
        return s ? (A.replaceWith(r, r, this.type.create({ latex: s })), !0) : !1;
      },
      deleteInlineMath: (t) => ({ editor: e, tr: A }) => {
        var n;
        const s = (n = t == null ? void 0 : t.pos) != null ? n : e.state.selection.$from.pos, r = e.state.doc.nodeAt(s);
        return !r || r.type.name !== this.name ? !1 : (A.delete(s, s + r.nodeSize), !0);
      },
      updateInlineMath: (t) => ({ editor: e, tr: A }) => {
        const n = t == null ? void 0 : t.latex;
        let s = t == null ? void 0 : t.pos;
        s === void 0 && (s = e.state.selection.$from.pos);
        const r = e.state.doc.nodeAt(s);
        return !r || r.type.name !== this.name ? !1 : (A.setNodeMarkup(s, this.type, { ...r.attrs, latex: n }), !0);
      }
    };
  },
  parseHTML() {
    return [
      {
        tag: 'span[data-type="inline-math"]'
      }
    ];
  },
  renderHTML({ HTMLAttributes: t }) {
    return ["span", Ct(t, { "data-type": "inline-math" })];
  },
  parseMarkdown: (t) => ({
    type: "inlineMath",
    attrs: {
      latex: t.latex
    }
  }),
  renderMarkdown: (t) => {
    var e;
    return `$${((e = t.attrs) == null ? void 0 : e.latex) || ""}$`;
  },
  markdownTokenizer: {
    name: "inlineMath",
    level: "inline",
    start: (t) => t.indexOf("$"),
    tokenize: (t) => {
      const e = t.match(/^\$([^$]+)\$(?!\$)/);
      if (!e)
        return;
      const [A, n] = e;
      return {
        type: "inlineMath",
        raw: A,
        latex: n.trim()
      };
    }
  },
  addInputRules() {
    return [
      new Sl({
        find: /(^|[^$])(\$\$([^$\n]+?)\$\$)(?!\$)/,
        handler: ({ state: t, range: e, match: A }) => {
          const n = A[3], { tr: s } = t, r = e.from, i = e.to;
          s.replaceWith(r, i, this.type.create({ latex: n }));
        }
      })
    ];
  },
  addNodeView() {
    const { katexOptions: t } = this.options;
    return ({ node: e, getPos: A }) => {
      const n = document.createElement("span");
      n.className = "tiptap-mathematics-render", this.editor.isEditable && n.classList.add("tiptap-mathematics-render--editable"), n.dataset.type = "inline-math", n.setAttribute("data-latex", e.attrs.latex);
      function s() {
        try {
          Cv.render(e.attrs.latex, n, t), n.classList.remove("inline-math-error");
        } catch {
          n.textContent = e.attrs.latex, n.classList.add("inline-math-error");
        }
      }
      const r = (i) => {
        i.preventDefault(), i.stopPropagation();
        const o = A();
        o != null && this.options.onClick && this.options.onClick(e, o);
      };
      return this.options.onClick && n.addEventListener("click", r), s(), {
        dom: n,
        destroy() {
          n.removeEventListener("click", r);
        }
      };
    };
  }
}), tte = tt.create({
  name: "Mathematics",
  addOptions() {
    return {
      inlineOptions: void 0,
      blockOptions: void 0,
      katexOptions: void 0
    };
  },
  addExtensions() {
    return [
      $ee.configure({ ...this.options.blockOptions, katexOptions: this.options.katexOptions }),
      ete.configure({ ...this.options.inlineOptions, katexOptions: this.options.katexOptions })
    ];
  }
}), Ate = tte, oN = (t) => Array.from(t.entries()).map(([e, A]) => ({
  clientId: e,
  ...A.user
})), aN = () => null, nte = tt.create({
  name: "collaborationCaret",
  priority: 999,
  addOptions() {
    return {
      provider: null,
      user: {
        name: null,
        color: null
      },
      render: (t) => {
        const e = document.createElement("span");
        e.classList.add("collaboration-carets__caret"), e.setAttribute("style", `border-color: ${t.color}`);
        const A = document.createElement("div");
        return A.classList.add("collaboration-carets__label"), A.setAttribute("style", `background-color: ${t.color}`), A.insertBefore(document.createTextNode(t.name), null), e.insertBefore(A, null), e;
      },
      selectionRender: Qb,
      onUpdate: aN
    };
  },
  onCreate() {
    if (this.options.onUpdate !== aN && console.warn(
      '[tiptap warn]: DEPRECATED: The "onUpdate" option is deprecated. Please use `editor.storage.collaborationCaret.users` instead. Read more: https://tiptap.dev/api/extensions/collaboration-caret'
    ), !this.options.provider)
      throw new Error('The "provider" option is required for the CollaborationCaret extension');
  },
  addStorage() {
    return {
      users: []
    };
  },
  addCommands() {
    return {
      updateUser: (t) => () => (this.options.provider.awareness.setLocalStateField("user", t), !0),
      user: (t) => ({ editor: e }) => (console.warn(
        '[tiptap warn]: DEPRECATED: The "user" command is deprecated. Please use "updateUser" instead. Read more: https://tiptap.dev/api/extensions/collaboration-caret'
      ), e.commands.updateUser(t))
    };
  },
  addProseMirrorPlugins() {
    return [
      C_(
        (this.options.provider.awareness.setLocalStateField("user", this.options.user), this.storage.users = oN(this.options.provider.awareness.states), this.options.provider.awareness.on("update", () => {
          this.storage.users = oN(this.options.provider.awareness.states);
        }), this.options.provider.awareness),
        {
          cursorBuilder: this.options.render,
          selectionBuilder: this.options.selectionRender
        }
      )
    ];
  }
}), ste = nte, cN = Zt.create({ name: "blockThread", group: "block", content() {
  return this.options.useLegacyWrapping ? "block+" : "block";
}, addOptions() {
  return { provider: null, useLegacyWrapping: !1 };
}, addAttributes() {
  return { "data-thread-id": { default: "" } };
}, parseHTML() {
  return [{ tag: "div[data-block-thread]" }];
}, renderHTML({ HTMLAttributes: t }) {
  return ["div", { ...t, "data-block-thread": "" }, 0];
} }), En = { THREAD_CREATED: "comments:threadCreated", THREAD_UPDATED: "comments:threadUpdated", THREAD_RESOLVED: "comments:threadResolved", THREAD_UNRESOLVED: "comments:threadUnresolved", THREAD_DELETED: "comments:threadDeleted", THREAD_REMOVED_FROM_DOCUMENT: "comments:threadRemovedFromDocument", COMMENT_CREATED: "comments:commentCreated", COMMENT_UPDATED: "comments:commentUpdated", COMMENT_DELETED: "comments:commentDeleted", THREAD_SELECTED: "comments:threadSelected", THREAD_UNSELECTED: "comments:threadUnselected", THREAD_HOVERED: "comments:threadHovered", THREAD_UNHOVERED: "comments:threadUnhovered" };
function lN(t, e) {
  let A = [];
  t.hasAttribute("data-thread-id") && A.push(t.getAttribute("data-thread-id"));
  let n = t.parentElement;
  for (; n !== e && n; ) n != null && n.hasAttribute("data-thread-id") && A.push(n.getAttribute("data-thread-id")), n = n.parentElement;
  return A;
}
function rte(t, e, A) {
  let n = t.state.doc.resolve(e), s = null, r = n.depth;
  for (; r > 0; ) {
    let i = n.node(r);
    if (i.type.name === A) {
      s = i;
      break;
    }
    r -= 1;
  }
  return s;
}
var ite = (t, e, A) => {
  function n(i, o) {
    return o ? "selected" : i ? "hovered" : "default";
  }
  function s(i, o, a, c) {
    let l = [A.classes.thread];
    return c && l.push(c), i ? l.push(A.classes.resolved) : l.push(A.classes.unresolved), o && l.push(A.classes.hover), a && l.push(A.classes.selected), l.join(" ");
  }
  function r(i, o, a) {
    var c;
    let l = [], B = (c = A.provider) == null ? void 0 : c.getThreads();
    return i.descendants((g, h) => {
      var u;
      let d = g.type.name === A.blockThreadTypeName, w = g.marks.some((b) => b.type.name === A.inlineThreadTypeName);
      if (!d && !w) return;
      if (g.type.name === "blockThread") {
        let b = g.attrs["data-thread-id"], W = !!(B != null && B.some((Oe) => Oe.id === b && Oe.resolvedAt)), q = !!(B != null && B.every((Oe) => Oe.id === b && Oe.resolvedAt)), ne = o.includes(b), V = a === b, se = s(W, ne, V, A.classes.block), te = { "data-status": W ? "closed" : "open", "data-status-all": q ? "closed" : "open", "data-state": n(ne, V), "data-type": "block", class: se }, be = Wt.node(h, h + g.nodeSize, te);
        l.push(be);
        return;
      }
      let Q = g.marks.filter((b) => b.type.name === A.inlineThreadTypeName).map((b) => b.attrs["data-thread-id"]);
      if (Q.length === 0) return;
      let p = [], M = [];
      for (let b of Q) (u = B == null ? void 0 : B.find((W) => W.id === b)) != null && u.resolvedAt ? M.push(b) : p.push(b);
      let I = p.length > 0 ? p : M;
      if (I.length === 0) return;
      let N = p.length === 0, m = N, E = I.some((b) => o.includes(b)), G = I.some((b) => a === b), Y = s(N, E, G, A.classes.inline), U = { "data-status": N ? "closed" : "open", "data-status-all": m ? "closed" : "open", "data-state": n(E, G), "data-type": "inline", class: Y }, v = Wt.inline(h, h + g.nodeSize, U);
      l.push(v);
    }), It.create(i, [...l]);
  }
  return new ct({ key: new Bt(`${e}__classes`), state: { init(i, { doc: o }) {
    return { decorations: r(o, [], void 0), hovered: [], selectedThreadId: void 0 };
  }, apply(i, o) {
    let a = i.docChanged || i.getMeta("threadUpdate");
    if (i.getMeta("threadMouseOver") !== void 0 && (i.getMeta("threadMouseOver").forEach((c) => {
      o.hovered.includes(c) || o.hovered.push(c);
    }), a = !0), i.getMeta("threadMouseOut") !== void 0) {
      let c = i.getMeta("threadMouseOut");
      c === null ? o.hovered = [] : o.hovered = o.hovered.filter((l) => !c.includes(l)), a = !0;
    }
    if (i.getMeta("threadSelect") !== void 0) {
      let c = i.getMeta("threadSelect") !== !1 ? i.getMeta("threadSelect") || o.selectedThreadId : void 0;
      o.selectedThreadId = c, a = !0;
    }
    return a ? { decorations: r(i.doc, o.hovered, o.selectedThreadId), hovered: o.hovered, selectedThreadId: o.selectedThreadId } : o;
  } }, props: { decorations(i) {
    var o;
    return (o = this.getState(i)) == null ? void 0 : o.decorations;
  }, handleDOMEvents: { mouseover(i, o) {
    var a, c;
    let { target: l } = o;
    if (!l) return;
    let B = l.closest("[data-thread-id]");
    if (!B) return;
    let g = lN(B, t.view.dom);
    if (g.length > 0) {
      i.dispatch(i.state.tr.setMeta("threadMouseOver", g));
      let h = ((c = (a = A.provider) == null ? void 0 : a.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : c.filter((u) => g.includes(u.id))) || [];
      t.emit(En.THREAD_HOVERED, { threadIds: g, threads: h });
    }
  }, mouseout(i, o) {
    let { target: a } = o;
    if (!a) return;
    let c = a.closest("[data-thread-id]");
    if (!c) return;
    let l = lN(c, t.view.dom);
    l.length > 0 && (i.dispatch(i.state.tr.setMeta("threadMouseOut", l)), t.emit(En.THREAD_UNHOVERED, { threadIds: l }));
  } }, handleClick(i, o) {
    var a;
    if (o > i.state.doc.content.size || o < 0) return;
    let c = Math.max(0, o - 1), l = Math.min(i.state.doc.content.size - 1, o + 1), B = i.state.doc.nodeAt(o) || i.state.doc.nodeAt(c) || i.state.doc.nodeAt(l), g = rte(t, o, A.blockThreadTypeName);
    if (!B) {
      i.dispatch(i.state.tr.setMeta("threadSelect", void 0));
      return;
    }
    let h = B.marks.some((N) => N.type.name === A.inlineThreadTypeName), u = i.state.doc.resolve(o), d = B.type.name === A.blockThreadTypeName || u.parent.type.name === A.blockThreadTypeName;
    if (!h && !d && !g) {
      A.onClickThread && A.onClickThread(null);
      return;
    }
    let w = g || u.parent, Q = h ? B.marks.filter((N) => N.type.name === A.inlineThreadTypeName).map((N) => N.attrs["data-thread-id"]) : [B.attrs["data-thread-id"] || w.attrs["data-thread-id"]], p = (a = A.provider) == null ? void 0 : a.getThreads(), M = Q.filter((N) => {
      let m = p == null ? void 0 : p.find((E) => E.id === N);
      return !(m != null && m.resolvedAt);
    }), I = M.length > 0 ? M.at(-1) : Q.at(-1);
    A.onClickThread && I && A.onClickThread(I);
  } } });
}, ote = (t, e, A) => new ct({ key: new Bt(`${e}__paste`), appendTransaction(n, s, r) {
  if (!n.some((B) => B.getMeta("uiEvent") === "paste" || B.getMeta("uiEvent") === "drop")) return null;
  let i = [], o = [];
  if (s.doc.descendants((B) => (B.marks.forEach((g) => {
    g.type.name === A.inlineThreadTypeName && i.push(g);
  }), B.type.name === A.blockThreadTypeName && o.push(B), !0)), !i.length && !o.length) return null;
  let a = r.tr, c = [], l = [];
  return r.doc.descendants((B) => (B.marks.forEach((g) => {
    g.type.name === A.inlineThreadTypeName && c.push(g);
  }), B.type.name === A.blockThreadTypeName && l.push(B), !0)), !c.length && !l.length ? null : (r.doc.descendants((B, g) => {
    B.marks.forEach((h) => {
      var u;
      if (h.type.name !== A.inlineThreadTypeName) return;
      let d = (u = A.provider) == null ? void 0 : u.getThreads().some((p) => p.id === h.attrs["data-thread-id"]), w = !!i.find((p) => {
        var M, I;
        return ((M = p.attrs["data-thread-id"]) == null ? void 0 : M.toString()) === ((I = h.attrs["data-thread-id"]) == null ? void 0 : I.toString());
      }), Q = c.filter((p) => {
        var M, I;
        return ((M = p.attrs["data-thread-id"]) == null ? void 0 : M.toString()) === ((I = h.attrs["data-thread-id"]) == null ? void 0 : I.toString());
      }).length > 1;
      (w && Q && !i.find((p) => p === h) || !d) && (a = a.removeMark(g, g + B.nodeSize, h.type));
    });
  }), a);
} }), ate = (t, e, A) => new ct({ key: new Bt("commentsTrackedChangesIntegration"), appendTransaction: (n, s, r) => {
  var i;
  if (!n.some((E) => E.docChanged) || !A.provider) return null;
  let o = "suggestion", a = (E) => {
    if (E.length === 0) return [];
    let G = [...E].sort((U, v) => U.from - v.from), Y = [G[0]];
    return G.slice(1).forEach((U) => {
      let v = Y[Y.length - 1];
      U.from <= v.to ? v.to = Math.max(v.to, U.to) : Y.push(U);
    }), Y;
  }, c = (E, G) => {
    if (E.length !== G.length) return !1;
    for (let Y = 0; Y < E.length; Y += 1) if (E[Y].from !== G[Y].from || E[Y].to !== G[Y].to) return !1;
    return !0;
  }, l = (E) => E === "replaceDeletion" || E === "replaceInsertion" ? "replace" : E, B = (E) => {
    let G = /* @__PURE__ */ new Map();
    E.forEach((U) => {
      let v = G.get(U.id);
      v ? (v.types.add(U.type), v.parts.push({ from: U.from, to: U.to, text: U.text })) : G.set(U.id, { id: U.id, types: /* @__PURE__ */ new Set([U.type]), userId: U.userId, createdAt: U.createdAt, parts: [{ from: U.from, to: U.to, text: U.text }], isNode: U.isNode, userMetadata: U.userMetadata });
    });
    let Y = /* @__PURE__ */ new Map();
    return G.forEach((U, v) => {
      let b = [...U.parts].sort((te, be) => te.from - be.from), W = a(b.map((te) => ({ from: te.from, to: te.to }))), q = Math.min(...W.map((te) => te.from)), ne = Math.max(...W.map((te) => te.to)), V = b.map((te) => te.text).join(""), se = [...U.types].some((te) => te === "replaceDeletion" || te === "replaceInsertion") ? "replace" : l([...U.types][0]);
      Y.set(v, { id: U.id, type: se, userId: U.userId, createdAt: U.createdAt, from: q, to: ne, text: V, isNode: U.isNode, userMetadata: U.userMetadata, ranges: W });
    }), Y;
  }, g = (E, G, Y) => {
    let U = r.schema.nodes[A.blockThreadTypeName];
    if (!U) return !1;
    let v = E.doc.nodeAt(G);
    if (!v || !v.type.isBlock) return !1;
    let b = E.doc.resolve(G), W = E.doc.resolve(G + v.nodeSize), q = b.blockRange(W);
    if (!q) return !1;
    let ne = Mw(q, U, { "data-thread-id": Y });
    return ne ? (E.wrap(q, ne), !0) : !1;
  }, h = !1;
  if (r.doc.descendants((E) => {
    if (h) return !1;
    if (E.isText && E.marks.some((G) => G.type.name === o) || E.isAtom && E.attrs.suggestionId) return h = !0, !1;
  }), !h) return null;
  let u = [];
  s.doc.descendants((E, G) => {
    if (E.isText) {
      let Y = E.marks.find((U) => U.type.name === o);
      Y && u.push({ id: Y.attrs.id, type: Y.attrs.type, userId: Y.attrs.userId, createdAt: Y.attrs.createdAt, from: G, to: G + E.nodeSize, text: E.text || "", isNode: !1, userMetadata: Y.attrs.userMetadata || null });
    }
    E.isAtom && E.attrs.suggestionId && u.push({ id: E.attrs.suggestionId, type: E.attrs.suggestionType, userId: E.attrs.suggestionUserId, createdAt: E.attrs.suggestionCreatedAt, from: G, to: G + E.nodeSize, text: `[${E.type.name}]`, isNode: !0, userMetadata: E.attrs.suggestionUserMetadata || null });
  });
  let d = B(u), w = [];
  r.doc.descendants((E, G) => {
    if (E.isText) {
      let Y = E.marks.find((U) => U.type.name === o);
      Y && w.push({ id: Y.attrs.id, type: Y.attrs.type, userId: Y.attrs.userId, createdAt: Y.attrs.createdAt, from: G, to: G + E.nodeSize, text: E.text || "", isNode: !1, userMetadata: Y.attrs.userMetadata || null });
    }
    E.isAtom && E.attrs.suggestionId && w.push({ id: E.attrs.suggestionId, type: E.attrs.suggestionType, userId: E.attrs.suggestionUserId, createdAt: E.attrs.suggestionCreatedAt, from: G, to: G + E.nodeSize, text: `[${E.type.name}]`, isNode: !0, userMetadata: E.attrs.suggestionUserMetadata || null });
  });
  let Q = B(w), p = [], M = [];
  if (Q.forEach((E, G) => {
    let Y = d.get(G);
    Y ? c(Y.ranges, E.ranges) || M.push(G) : p.push(G);
  }), p.length === 0 && M.length === 0) return null;
  let I = /* @__PURE__ */ new Map();
  (((i = A.provider) == null ? void 0 : i.getThreads({ types: ["unarchived", "archived"] })) || []).forEach((E) => {
    var G;
    (G = E.data) != null && G.suggestionId && I.set(E.data.suggestionId, E);
  });
  let N = r.tr, m = !1;
  return p.forEach((E) => {
    var G, Y, U;
    let v = Q.get(E);
    if (!v) return;
    let b = I.get(E);
    if (b) {
      if (b.deletedAt && ((G = A.provider) == null || G.restoreThread(b.id)), v.isNode) {
        let ne = v.ranges[0].from;
        g(N, ne, b.id) && (m = !0);
      } else {
        let ne = r.schema.marks[A.inlineThreadTypeName];
        if (ne) {
          let V = ne.create({ "data-thread-id": b.id });
          v.ranges.forEach((se) => {
            N.addMark(se.from, se.to, V);
          }), m = !0;
        }
      }
      return;
    }
    let W = v.userMetadata, q = (Y = A.provider) == null ? void 0 : Y.createThread({ data: { suggestionId: E, source: "suggestion", suggestionType: v.type, suggestionText: v.text, suggestionUserMetadata: W } });
    if (q) {
      (U = A.provider) == null || U.addComment(q.id, { content: "", data: { userName: (W == null ? void 0 : W.name) || v.userId, userId: v.userId, avatarUrl: (W == null ? void 0 : W.avatarUrl) || null } });
      let ne = "inline";
      if (v.isNode) {
        let V = v.ranges[0].from;
        g(N, V, q.id) && (m = !0, ne = "block");
      } else {
        let V = r.schema.marks[A.inlineThreadTypeName];
        if (V) {
          let se = V.create({ "data-thread-id": q.id });
          v.ranges.forEach((te) => {
            N.addMark(te.from, te.to, se);
          }), m = !0;
        }
      }
      t.emit(En.THREAD_CREATED, { threadId: q.id, thread: q, position: { from: v.from, to: v.to }, threadType: ne });
    }
  }), M.forEach((E) => {
    let G = Q.get(E);
    if (!G) return;
    let Y = I.get(E);
    if (Y && !Y.deletedAt) if (G.isNode) {
      let U = G.ranges[0].from;
      N.doc.nodeAt(U) && (N.doc.resolve(U).parent.type.name === A.blockThreadTypeName || g(N, U, Y.id) && (m = !0));
    } else {
      let U = r.schema.marks[A.inlineThreadTypeName];
      if (U) {
        let v = U.create({ "data-thread-id": Y.id });
        G.ranges.forEach((b) => {
          N.addMark(b.from, b.to, v);
        }), m = !0;
      }
    }
  }), m ? N : null;
} }), cte = (t) => {
  let { blockThreads: e, blockThreadTypeName: A, editor: n, inlineThreads: s, threads: r } = t, i = !1, { tr: o } = n.state;
  e.forEach(({ pos: a, node: c }) => {
    let l = c.attrs["data-thread-id"];
    if (r.find((w) => w.id === l)) return;
    i = !0, o = o.setMeta("addToHistory", !1);
    let B = o.mapping.map(a), g = o.doc.nodeAt(B);
    if (!g || g.type.name !== A) return;
    let h = o.doc.resolve(B + 1), u = o.doc.resolve(B + g.nodeSize - 1), d = h.blockRange(u);
    d && (o = o.lift(d, u.depth - 1));
  }), s.forEach(({ pos: a, node: c, mark: l }) => {
    let B = l.attrs["data-thread-id"];
    if (r.find((u) => u.id === B)) return;
    i = !0, o = o.setMeta("addToHistory", !1);
    let g = o.mapping.map(a), h = o.mapping.map(a + c.nodeSize);
    o = o.removeMark(g, h, l.type);
  }), i && n.view.dispatch(o);
}, lte = (t) => {
  let { blockThreads: e, inlineThreads: A, provider: n, threads: s, deletedThreads: r } = t, i = [];
  e.forEach(({ id: c }) => {
    i.push(c);
  }), A.forEach(({ id: c }) => {
    i.push(c);
  });
  let o = r.filter((c) => i.includes(c.id)), a = s.filter((c) => {
    var l;
    let B = i.includes(c.id), g = o.includes(c), h = !!((l = c.data) != null && l.source) && c.data.source !== "suggestion";
    return !B && !g && !h;
  });
  o.forEach((c) => {
    n.restoreThread(c.id);
  }), a.forEach((c) => {
    n.deleteThread(c.id);
  });
}, Bte = (t, { blockTypeName: e = "blockThread", markTypeName: A = "inlineThread" }) => {
  let n = [];
  return t.state.doc.descendants((s, r) => {
    let i = s.marks.some((o) => o.type.name === A);
    if (!(s.type.name !== e && !i)) {
      if (s.attrs["data-thread-id"]) {
        let o = s.attrs["data-thread-id"];
        n.push({ pos: r, thread: o, node: s });
        return;
      }
      i && s.marks.forEach((o) => {
        if (o.type.name === A) {
          let a = o.attrs["data-thread-id"];
          n.push({ pos: r, thread: a, node: s, mark: o });
        }
      });
    }
  }), n;
};
function gte(t, e, A) {
  let n = t.extensionManager.extensions.find((o) => o.name === "comments");
  if (!n || !n.options.provider) return !1;
  let s = n.options.provider.getThreads({ types: ["unarchived", "archived"] }), r = s == null ? void 0 : s.find((o) => o.id === e);
  if (!r) return !1;
  let i = { ...r.data || {}, ...A };
  return t.commands.updateThread({ id: e, data: i });
}
function oB(t, e, A) {
  let n = t.extensionManager.extensions.find((r) => r.name === "comments");
  if (!n || !n.options.provider) return null;
  let s = n.options.provider.getThreads({ types: ["unarchived", "archived"] });
  return s && s.find((r) => r.data && r.data[e] === A) || null;
}
var hte = tt.create({ name: "comments", onTransaction() {
  !this.options.provider || !this.options.provider.isSynced || !this.options.provider.synced || (this.storage.debounceTimer && clearTimeout(this.storage.debounceTimer), this.storage.debounceTimer = window.setTimeout(() => {
    var t, e;
    let A = this.editor;
    if (!this.options.provider) return;
    let n = Bte(A, { blockTypeName: this.options.blockThreadTypeName, markTypeName: this.options.inlineThreadTypeName }), s = n.filter((a) => !a.mark).map((a) => ({ pos: a.pos, node: a.node, id: a.thread })), r = n.filter((a) => a.mark !== void 0).map((a) => ({ pos: a.pos, node: a.node, mark: a.mark, id: a.thread })), i = ((t = this.options.provider) == null ? void 0 : t.getThreads({ types: ["unarchived"] })) || [], o = ((e = this.options.provider) == null ? void 0 : e.getThreads({ types: ["archived"] })) || [];
    this.options.deleteUnreferencedThreads && lte({ provider: this.options.provider, blockThreads: s, inlineThreads: r, threads: i, deletedThreads: o }), cte({ blockThreads: s, inlineThreads: r, blockThreadTypeName: this.options.blockThreadTypeName, editor: A, threads: [...i, ...o] });
  }, 350));
}, addOptions() {
  return { provider: null, blockThreadTypeName: "blockThread", inlineThreadTypeName: "inlineThread", onClickThread: void 0, deleteUnreferencedThreads: !0, classes: { block: "tiptap-thread--block", hover: "tiptap-thread--hovered", inline: "tiptap-thread--inline", resolved: "tiptap-thread--resolved", selected: "tiptap-thread--selected", thread: "tiptap-thread", unresolved: "tiptap-thread--unresolved" } };
}, addStorage() {
  return { focusedThreads: [], debounceTimer: void 0, preventLoopSuggestionIds: /* @__PURE__ */ new Set(), suggestionCreatedHandler: void 0, suggestionAcceptedHandler: void 0, suggestionRejectedHandler: void 0, suggestionRemovedHandler: void 0, suggestionRangeChangedHandler: void 0 };
}, onCreate() {
  let t = (r) => {
    var i, o;
    let { suggestion: a, reason: c } = r, l = oB(this.editor, "suggestionId", a.id);
    if (l && typeof c == "string" && c.length > 0 && ((i = l.data) == null ? void 0 : i.suggestionReason) !== c && ((o = this.options.provider) == null || o.updateThread(l.id, { data: { ...l.data || {}, suggestionReason: c } })), l && !l.deletedAt && l.resolvedAt) {
      if (this.storage.preventLoopSuggestionIds || (this.storage.preventLoopSuggestionIds = /* @__PURE__ */ new Set()), this.storage.preventLoopSuggestionIds.has(a.id)) return;
      this.storage.preventLoopSuggestionIds.add(a.id);
      try {
        setTimeout(() => {
          this.editor.commands.unresolveThread({ id: l.id });
        }, 0);
      } finally {
        setTimeout(() => {
          var B;
          return (B = this.storage.preventLoopSuggestionIds) == null ? void 0 : B.delete(a.id);
        }, 0);
      }
    }
  }, e = (r) => {
    var i;
    let { suggestionId: o } = r;
    if (!((i = this.storage.preventLoopSuggestionIds) != null && i.has(o))) {
      this.storage.preventLoopSuggestionIds || (this.storage.preventLoopSuggestionIds = /* @__PURE__ */ new Set()), this.storage.preventLoopSuggestionIds.add(o);
      try {
        let a = oB(this.editor, "suggestionId", o);
        a && !a.resolvedAt && setTimeout(() => {
          this.editor.commands.resolveThread({ id: a.id }), this.editor.commands.removeThread({ id: a.id, deleteThread: !1 });
        }, 0);
      } finally {
        setTimeout(() => {
          var a;
          return (a = this.storage.preventLoopSuggestionIds) == null ? void 0 : a.delete(o);
        }, 0);
      }
    }
  }, A = (r) => {
    var i;
    let { suggestionId: o } = r;
    if (!((i = this.storage.preventLoopSuggestionIds) != null && i.has(o))) {
      this.storage.preventLoopSuggestionIds || (this.storage.preventLoopSuggestionIds = /* @__PURE__ */ new Set()), this.storage.preventLoopSuggestionIds.add(o);
      try {
        let a = oB(this.editor, "suggestionId", o);
        a && setTimeout(() => {
          this.editor.commands.removeThread({ id: a.id, deleteThread: !0 });
        }, 0);
      } finally {
        setTimeout(() => {
          var a;
          return (a = this.storage.preventLoopSuggestionIds) == null ? void 0 : a.delete(o);
        }, 0);
      }
    }
  }, n = (r) => {
    var i;
    let { suggestionId: o } = r;
    if (!((i = this.storage.preventLoopSuggestionIds) != null && i.has(o))) {
      this.storage.preventLoopSuggestionIds || (this.storage.preventLoopSuggestionIds = /* @__PURE__ */ new Set()), this.storage.preventLoopSuggestionIds.add(o);
      try {
        let a = oB(this.editor, "suggestionId", o);
        a && !a.deletedAt && setTimeout(() => {
          var c;
          this.editor.commands.removeThread({ id: a.id, deleteThread: !1 }), (c = this.options.provider) == null || c.deleteThread(a.id);
        }, 0);
      } finally {
        setTimeout(() => {
          var a;
          return (a = this.storage.preventLoopSuggestionIds) == null ? void 0 : a.delete(o);
        }, 0);
      }
    }
  }, s = (r) => {
    let { suggestion: i } = r, o = oB(this.editor, "suggestionId", i.id);
    o && !o.deletedAt && gte(this.editor, o.id, { suggestionText: i.text });
  };
  this.storage.suggestionCreatedHandler = t, this.storage.suggestionAcceptedHandler = e, this.storage.suggestionRejectedHandler = A, this.storage.suggestionRemovedHandler = n, this.storage.suggestionRangeChangedHandler = s, this.editor.on("trackedChanges:suggestionCreated", t), this.editor.on("trackedChanges:suggestionAccepted", e), this.editor.on("trackedChanges:suggestionRejected", A), this.editor.on("trackedChanges:suggestionRemoved", n), this.editor.on("trackedChanges:suggestionRangeChanged", s);
}, onDestroy() {
  this.storage.suggestionCreatedHandler && this.editor.off("trackedChanges:suggestionCreated", this.storage.suggestionCreatedHandler), this.storage.suggestionAcceptedHandler && this.editor.off("trackedChanges:suggestionAccepted", this.storage.suggestionAcceptedHandler), this.storage.suggestionRejectedHandler && this.editor.off("trackedChanges:suggestionRejected", this.storage.suggestionRejectedHandler), this.storage.suggestionRemovedHandler && this.editor.off("trackedChanges:suggestionRemoved", this.storage.suggestionRemovedHandler), this.storage.suggestionRangeChangedHandler && this.editor.off("trackedChanges:suggestionRangeChanged", this.storage.suggestionRangeChangedHandler);
}, addCommands() {
  return { setThread: ({ content: t, data: e, commentData: A }) => ({ chain: n, state: s, editor: r }) => {
    if (this.options.provider === null) return !1;
    let { selection: i } = s, o = i instanceof Ue, a = this.options.provider.createThread({ data: e });
    if (!a) return !1;
    if (this.options.provider.addComment(a.id, { content: t, data: A }), o) return n().setNodeSelection(i.from).wrapIn(this.options.blockThreadTypeName, { "data-thread-id": a.id }).run(), r.emit(En.THREAD_CREATED, { threadId: a.id, thread: a, position: { from: i.from, to: i.from }, threadType: "block" }), !0;
    if (this.options.useLegacyWrapping) {
      console.warn("useLegacyWrapping is deprecated and will be removed in the future. Please update your code.");
      let c = 0;
      s.doc.nodesBetween(i.from, i.to, (h, u) => {
        let d = s.doc.resolve(u + 1);
        !h.isText && !h.isInline && d.depth >= i.$from.depth && (c += 1);
      });
      let l = i.$from.start(), B = i.$to.end(), g = this.editor.can().chain().setTextSelection({ from: l, to: B }).wrapIn(this.options.blockThreadTypeName, { "data-thread-id": a.id }).setTextSelection(B).run();
      if (c > 1 && g) return n().setTextSelection({ from: l, to: B }).wrapIn(this.options.blockThreadTypeName, { "data-thread-id": a.id }).setTextSelection(B).run(), !0;
    } else s.doc.nodesBetween(i.from, i.to, (c, l) => {
      c.type.isBlock && !c.isTextblock && c.childCount === 0 && n().command((B) => {
        let { state: g, dispatch: h } = B, u = g.schema.nodes[this.options.blockThreadTypeName];
        if (!u) return !1;
        let d = u.create({ "data-thread-id": a.id }, c);
        return s.tr.replaceWith(l, l + 1, d), h && h(s.tr), !0;
      });
    });
    return n().focus().setMark(this.options.inlineThreadTypeName, { "data-thread-id": a.id }).run(), r.emit(En.THREAD_CREATED, { threadId: a.id, thread: a, position: { from: i.from, to: i.to }, threadType: "inline" }), !0;
  }, removeThread: (t = {}) => ({ tr: e, state: A, editor: n }) => {
    var s, r, i;
    let { selection: o } = A, { id: a } = t, c = a;
    if (!c) {
      let h = o.$from.marksAcross(o.$to);
      h == null || h.forEach((u) => {
        u.type.name === this.options.inlineThreadTypeName && !c && (c = u.attrs["data-thread-id"]);
      }), c || A.doc.nodesBetween(o.from, o.to, (u) => (u.type.name === this.options.blockThreadTypeName && !c && (c = u.attrs["data-thread-id"]), !0));
    }
    if (!c) return !1;
    let l = [], B = [];
    A.doc.descendants((h, u) => {
      h.type.name === this.options.blockThreadTypeName && h.attrs["data-thread-id"] === c && B.push({ node: h, from: u, to: u + h.nodeSize }), h.marks.forEach((d) => {
        d.type.name === this.options.inlineThreadTypeName && d.attrs["data-thread-id"] === c && l.push({ node: h, mark: d, from: u, to: u + h.nodeSize });
      });
    }), l.forEach((h) => {
      let u = e.mapping.map(h.from), d = e.mapping.map(h.to), w = h.mark.removeFromSet(h.node.marks);
      e.removeMark(u, d, A.schema.marks[this.options.inlineThreadTypeName]), w.forEach((Q) => {
        e.addMark(u, d, Q);
      });
    }), B.forEach((h) => {
      let u = e.mapping.map(h.from), d = e.mapping.map(h.to);
      e.doc.nodesBetween(u, d, (w, Q) => {
        if (w.type.name === this.options.blockThreadTypeName && w.attrs["data-thread-id"] === c) {
          let p = e.doc.resolve(Q + 1), M = e.doc.resolve(Q + w.nodeSize - 1), I = new Ql(p, M, p.depth), N = cc(I);
          if (N === null || p.node().type.name !== this.options.blockThreadTypeName) return !1;
          e.lift(I, N);
        }
      });
    });
    let g = (r = (s = this.options.provider) == null ? void 0 : s.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : r.find((h) => h.id === c);
    return t.deleteThread ? ((i = this.options.provider) == null || i.deleteThread(c), g && n.emit(En.THREAD_DELETED, { threadId: c, thread: g, deletedBy: void 0, soft: !1 })) : g && n.emit(En.THREAD_REMOVED_FROM_DOCUMENT, { threadId: c, thread: g, removedBy: "command", canRestore: !0 }), !0;
  }, selectThread: ({ id: t = null, selectAround: e = !1, focus: A = !0, scrollIntoView: n = !1, updateSelection: s = !0, triggerClick: r = !1 }) => ({ chain: i, state: o }) => {
    var a, c;
    let l = { node: null, from: 0 }, B = { node: null, from: 0, to: 0 }, g = () => {
      t && r && this.options.onClickThread && this.options.onClickThread(t);
    }, h = i();
    t && (h.setMeta("threadSelect", t), g());
    let u = t ? (c = (a = this.options.provider) == null ? void 0 : a.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : c.find((d) => d.id === t) : null;
    return this.editor.emit(En.THREAD_SELECTED, { threadId: t, thread: u || null }), s ? (o.doc.descendants((d, w) => {
      B.node || (d.type.name === this.options.blockThreadTypeName && d.attrs["data-thread-id"] === t && (B = { node: d, from: w, to: w + d.nodeSize }), !l.node && d.marks.some((Q) => Q.type.name === this.options.inlineThreadTypeName && Q.attrs["data-thread-id"] === t) && (l = { node: d, from: w, to: w + d.nodeSize }));
    }), B.node ? e ? (h.setTextSelection({ from: B.from, to: B.to }), n && !A && h.scrollIntoView(), A && h.focus(void 0, { scrollIntoView: n }), g(), h.run()) : (n && !A && h.setTextSelection(B.from).scrollIntoView(), A && h.focus(B.from, { scrollIntoView: n }), g(), h.run()) : l.node ? e ? (h.setTextSelection(l.from), n && !A && h.scrollIntoView(), A && h.focus(void 0, { scrollIntoView: n }), g(), h.run()) : (n && !A && h.setTextSelection(l.from).scrollIntoView(), A && h.focus(l.from, { scrollIntoView: n }), g(), h.run()) : !1) : h.run();
  }, unselectThread: () => ({ tr: t, editor: e }) => (t.setMeta("threadSelect", !1), e.emit(En.THREAD_UNSELECTED, { threadId: null }), !0), updateThread: (t) => ({ editor: e }) => {
    var A;
    let { id: n, data: s } = t;
    if (!this.options.provider || !n || !s) return !1;
    this.options.provider.updateThread(n, { data: s });
    let r = (A = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : A.find((i) => i.id === n);
    return r && e.emit(En.THREAD_UPDATED, { threadId: n, thread: r, changes: { data: s }, updatedBy: void 0 }), !0;
  }, createComment: (t) => ({ editor: e }) => {
    var A;
    let { threadId: n, content: s, data: r } = t;
    if (!this.options.provider || !n || !s) return !1;
    let i = this.options.provider.addComment(n, { content: s, data: r }), o = (A = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : A.find((a) => a.id === n);
    return i && o && e.emit(En.COMMENT_CREATED, { threadId: n, commentId: i.id, comment: i, thread: o }), !0;
  }, updateComment: (t) => ({ editor: e }) => {
    var A, n;
    let { id: s, threadId: r, content: i, data: o } = t;
    if (!this.options.provider || !r || !s || !i && !o) return !1;
    let a = (A = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : A.find((g) => g.id === r), c = a == null ? void 0 : a.comments.find((g) => g.id === s);
    this.options.provider.updateComment(r, s, { content: i, data: o });
    let l = (n = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : n.find((g) => g.id === r), B = l == null ? void 0 : l.comments.find((g) => g.id === s);
    return B && l && e.emit(En.COMMENT_UPDATED, { threadId: r, commentId: s, comment: B, oldContent: c == null ? void 0 : c.content, newContent: i, dataChanges: o }), !0;
  }, removeComment: (t) => ({ editor: e }) => {
    var A;
    let { threadId: n, id: s } = t;
    if (!this.options.provider || !n || !s) return !1;
    let r = (A = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : A.find((o) => o.id === n), i = r == null ? void 0 : r.comments.find((o) => o.id === s);
    return this.options.provider.deleteComment(n, s, { deleteContent: t.deleteContent, deleteThread: t.deleteThread }), i && e.emit(En.COMMENT_DELETED, { threadId: n, commentId: s, comment: i, deletedBy: void 0 }), !0;
  }, resolveThread: (t) => ({ tr: e, editor: A }) => {
    var n;
    let { id: s } = t;
    if (!this.options.provider || !s) return !1;
    let r = (/* @__PURE__ */ new Date()).toISOString();
    this.options.provider.updateThread(s, { resolvedAt: r }), e.setMeta("threadUpdate", s);
    let i = (n = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : n.find((o) => o.id === s);
    return i && A.emit(En.THREAD_RESOLVED, { threadId: s, thread: i, resolvedBy: void 0, resolvedAt: r }), !0;
  }, unresolveThread: (t) => ({ tr: e, editor: A }) => {
    var n;
    let { id: s } = t;
    if (!this.options.provider || !s) return !1;
    this.options.provider.updateThread(s, { resolvedAt: null }), e.setMeta("threadUpdate", s);
    let r = (n = this.options.provider.getThreads({ types: ["unarchived", "archived"] })) == null ? void 0 : n.find((i) => i.id === s);
    return r && A.emit(En.THREAD_UNRESOLVED, { threadId: s, thread: r, unresolvedBy: void 0 }), !0;
  } };
}, onSelectionUpdate() {
  let { from: t } = this.editor.state.selection, e = /* @__PURE__ */ new Set();
  this.editor.state.doc.nodesBetween(t, Math.min(t + 1, this.editor.state.doc.nodeSize - 2), (A) => (A.type.name === this.options.blockThreadTypeName && e.add(A.attrs["data-thread-id"]), A.marks.forEach((n) => {
    n.type.name === this.options.inlineThreadTypeName && e.add(n.attrs["data-thread-id"]);
  }), !0)), this.storage.focusedThreads = Array.from(e);
}, addProseMirrorPlugins() {
  return [ote(this.editor, this.name, this.options), ite(this.editor, this.name, this.options), ate(this.editor, this.name, this.options)];
} }), BN = qr.create({ name: "inlineThread", excludes: "", inclusive: !1, keepOnSplit: !0, addAttributes() {
  return { "data-thread-id": { default: "" } };
}, parseHTML() {
  return [{ tag: "span[data-inline-thread]" }];
}, renderHTML({ HTMLAttributes: t }) {
  return ["span", { ...t, "data-inline-thread": "" }, 0];
} }), ute = tt.create({ name: "threadsKit", addExtensions() {
  let t = [hte.configure(this.options)];
  return t.push(this.options.blockThreadTypeName ? cN.extend({ name: this.options.blockThreadTypeName }).configure({ provider: this.options.provider, useLegacyWrapping: this.options.useLegacyWrapping }) : cN.configure({ provider: this.options.provider, useLegacyWrapping: this.options.useLegacyWrapping })), t.push(this.options.inlineThreadTypeName ? BN.extend({ name: this.options.inlineThreadTypeName }).configure({ provider: this.options.provider }) : BN.configure({ provider: this.options.provider })), t;
} });
const dte = Math.floor, wte = (t, e) => t < e ? t : e, fte = (t, e) => t > e ? t : e, Ev = 128, gu = 127, Qte = Number.MAX_SAFE_INTEGER, Ite = (t) => {
  const e = unescape(encodeURIComponent(t)), A = e.length, n = new Uint8Array(A);
  for (let s = 0; s < A; s++)
    n[s] = /** @type {number} */
    e.codePointAt(s);
  return n;
}, qg = (
  /** @type {TextEncoder} */
  typeof TextEncoder < "u" ? new TextEncoder() : null
), Cte = (t) => qg.encode(t), Ete = qg ? Cte : Ite;
let tg = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
tg && tg.decode(new Uint8Array()).length === 1 && (tg = null);
const Od = (t, e) => {
  const A = t.cbuf.length;
  t.cpos === A && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(A * 2), t.cpos = 0), t.cbuf[t.cpos++] = e;
}, af = (t, e) => {
  for (; e > gu; )
    Od(t, Ev | gu & e), e = dte(e / 128);
  Od(t, gu & e);
}, vE = new Uint8Array(3e4), Mte = vE.length / 3, pte = (t, e) => {
  if (e.length < Mte) {
    const A = qg.encodeInto(e, vE).written || 0;
    af(t, A);
    for (let n = 0; n < A; n++)
      Od(t, vE[n]);
  } else
    Fte(t, Ete(e));
}, mte = (t, e) => {
  const A = unescape(encodeURIComponent(e)), n = A.length;
  af(t, n);
  for (let s = 0; s < n; s++)
    Od(
      t,
      /** @type {number} */
      A.codePointAt(s)
    );
}, Yte = qg && /** @type {any} */
qg.encodeInto ? pte : mte, yte = (t, e) => {
  const A = t.cbuf.length, n = t.cpos, s = wte(A - n, e.length), r = e.length - s;
  t.cbuf.set(e.subarray(0, s), n), t.cpos += s, r > 0 && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(fte(A * 2, r)), t.cbuf.set(e.subarray(s)), t.cpos = r);
}, Fte = (t, e) => {
  af(t, e.byteLength), yte(t, e);
}, Mv = (t) => new Error(t), Nte = Mv("Unexpected end of array"), Dte = Mv("Integer out of Range"), xte = (t, e) => {
  const A = new Uint8Array(t.arr.buffer, t.pos + t.arr.byteOffset, e);
  return t.pos += e, A;
}, Gte = (t) => xte(t, Fm(t)), gN = (t) => t.arr[t.pos++], Fm = (t) => {
  let e = 0, A = 1;
  const n = t.arr.length;
  for (; t.pos < n; ) {
    const s = t.arr[t.pos++];
    if (e = e + (s & gu) * A, A *= 128, s < Ev)
      return e;
    if (e > Qte)
      throw Dte;
  }
  throw Nte;
}, zte = (t) => {
  let e = Fm(t);
  if (e === 0)
    return "";
  {
    let A = String.fromCodePoint(gN(t));
    if (--e < 100)
      for (; e--; )
        A += String.fromCodePoint(gN(t));
    else
      for (; e > 0; ) {
        const n = e < 1e4 ? e : 1e4, s = t.arr.subarray(t.pos, t.pos + n);
        t.pos += n, A += String.fromCodePoint.apply(
          null,
          /** @type {any} */
          s
        ), e -= n;
      }
    return decodeURIComponent(escape(A));
  }
}, Ute = (t) => (
  /** @type any */
  tg.decode(Gte(t))
), hN = tg ? Ute : zte;
var ul;
(function(t) {
  t[t.Token = 0] = "Token", t[t.PermissionDenied = 1] = "PermissionDenied", t[t.Authenticated = 2] = "Authenticated";
})(ul || (ul = {}));
const bte = (t, e) => {
  af(t, ul.Token), Yte(t, e);
}, vte = (t, e, A, n) => {
  switch (Fm(t)) {
    case ul.Token: {
      e();
      break;
    }
    case ul.PermissionDenied: {
      A(hN(t));
      break;
    }
    case ul.Authenticated: {
      n(hN(t));
      break;
    }
  }
}, uN = (t) => Array.from(t.entries()).map(([e, A]) => ({
  clientId: e,
  ...A
}));
var jE;
(function(t) {
  t[t.Connecting = 0] = "Connecting", t[t.Open = 1] = "Open", t[t.Closing = 2] = "Closing", t[t.Closed = 3] = "Closed";
})(jE || (jE = {}));
function jte(t) {
  return t || (t = {}), {
    delay: t.delay === void 0 ? 200 : t.delay,
    initialDelay: t.initialDelay === void 0 ? 0 : t.initialDelay,
    minDelay: t.minDelay === void 0 ? 0 : t.minDelay,
    maxDelay: t.maxDelay === void 0 ? 0 : t.maxDelay,
    factor: t.factor === void 0 ? 0 : t.factor,
    maxAttempts: t.maxAttempts === void 0 ? 3 : t.maxAttempts,
    timeout: t.timeout === void 0 ? 0 : t.timeout,
    jitter: t.jitter === !0,
    initialJitter: t.initialJitter === !0,
    handleError: t.handleError === void 0 ? null : t.handleError,
    handleTimeout: t.handleTimeout === void 0 ? null : t.handleTimeout,
    beforeAttempt: t.beforeAttempt === void 0 ? null : t.beforeAttempt,
    calculateDelay: t.calculateDelay === void 0 ? null : t.calculateDelay
  };
}
async function QI(t) {
  return new Promise((e) => setTimeout(e, t));
}
function Hte(t, e) {
  let A = e.delay;
  if (A === 0)
    return 0;
  if (e.factor && (A *= Math.pow(e.factor, t.attemptNum - 1), e.maxDelay !== 0 && (A = Math.min(A, e.maxDelay))), e.jitter) {
    const n = Math.ceil(e.minDelay), s = Math.floor(A);
    A = Math.floor(Math.random() * (s - n + 1)) + n;
  }
  return Math.round(A);
}
async function kte(t, e) {
  const A = jte(e);
  for (const o of [
    "delay",
    "initialDelay",
    "minDelay",
    "maxDelay",
    "maxAttempts",
    "timeout"
  ]) {
    const a = A[o];
    if (!Number.isInteger(a) || a < 0)
      throw new Error(`Value for ${o} must be an integer greater than or equal to 0`);
  }
  if (A.factor.constructor !== Number || A.factor < 0)
    throw new Error("Value for factor must be a number greater than or equal to 0");
  if (A.delay < A.minDelay)
    throw new Error(`delay cannot be less than minDelay (delay: ${A.delay}, minDelay: ${A.minDelay}`);
  const n = {
    attemptNum: 0,
    attemptsRemaining: A.maxAttempts ? A.maxAttempts : -1,
    aborted: !1,
    abort() {
      n.aborted = !0;
    }
  }, s = A.calculateDelay || Hte;
  async function r() {
    if (A.beforeAttempt && A.beforeAttempt(n, A), n.aborted) {
      const a = new Error("Attempt aborted");
      throw a.code = "ATTEMPT_ABORTED", a;
    }
    const o = async (a) => {
      if (A.handleError && await A.handleError(a, n, A), n.aborted || n.attemptsRemaining === 0)
        throw a;
      n.attemptNum++;
      const c = s(n, A);
      return c && await QI(c), r();
    };
    return n.attemptsRemaining > 0 && n.attemptsRemaining--, A.timeout ? new Promise((a, c) => {
      const l = setTimeout(() => {
        if (A.handleTimeout)
          try {
            a(A.handleTimeout(n, A));
          } catch (B) {
            c(B);
          }
        else {
          const B = new Error(`Retry timeout (attemptNum: ${n.attemptNum}, timeout: ${A.timeout})`);
          B.code = "ATTEMPT_TIMEOUT", c(B);
        }
      }, A.timeout);
      t(n, A).then((B) => {
        clearTimeout(l), a(B);
      }).catch((B) => {
        clearTimeout(l), o(B).then(a).catch(c);
      });
    }) : t(n, A).catch(o);
  }
  const i = A.calculateDelay ? A.calculateDelay(n, A) : A.initialDelay;
  if (i && await QI(i), n.attemptNum < 1 && A.initialJitter) {
    const o = s(n, A);
    o && await QI(o);
  }
  return r();
}
const pv = Math.floor, Rte = (t, e) => t < e ? t : e, Lte = (t, e) => t > e ? t : e, Ste = 64, Pd = 128, Tte = 63, Ag = 127, mv = Number.MAX_SAFE_INTEGER, Jte = () => /* @__PURE__ */ new Set(), Wte = Array.from, Ote = (t) => {
  const e = unescape(encodeURIComponent(t)), A = e.length, n = new Uint8Array(A);
  for (let s = 0; s < A; s++)
    n[s] = /** @type {number} */
    e.codePointAt(s);
  return n;
}, _g = (
  /** @type {TextEncoder} */
  typeof TextEncoder < "u" ? new TextEncoder() : null
), Pte = (t) => _g.encode(t), Kte = _g ? Pte : Ote;
let ng = typeof TextDecoder > "u" ? null : new TextDecoder("utf-8", { fatal: !0, ignoreBOM: !0 });
ng && ng.decode(new Uint8Array()).length === 1 && (ng = null);
class Vte {
  constructor() {
    this.cpos = 0, this.cbuf = new Uint8Array(100), this.bufs = [];
  }
}
const Nm = () => new Vte(), Yv = (t) => {
  let e = t.cpos;
  for (let A = 0; A < t.bufs.length; A++)
    e += t.bufs[A].length;
  return e;
}, Dm = (t) => {
  const e = new Uint8Array(Yv(t));
  let A = 0;
  for (let n = 0; n < t.bufs.length; n++) {
    const s = t.bufs[n];
    e.set(s, A), A += s.length;
  }
  return e.set(new Uint8Array(t.cbuf.buffer, 0, t.cpos), A), e;
}, Kd = (t, e) => {
  const A = t.cbuf.length;
  t.cpos === A && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(A * 2), t.cpos = 0), t.cbuf[t.cpos++] = e;
}, an = (t, e) => {
  for (; e > Ag; )
    Kd(t, Pd | Ag & e), e = pv(e / 128);
  Kd(t, Ag & e);
}, HE = new Uint8Array(3e4), Xte = HE.length / 3, Zte = (t, e) => {
  if (e.length < Xte) {
    const A = _g.encodeInto(e, HE).written || 0;
    an(t, A);
    for (let n = 0; n < A; n++)
      Kd(t, HE[n]);
  } else
    Xl(t, Kte(e));
}, qte = (t, e) => {
  const A = unescape(encodeURIComponent(e)), n = A.length;
  an(t, n);
  for (let s = 0; s < n; s++)
    Kd(
      t,
      /** @type {number} */
      A.codePointAt(s)
    );
}, Oi = _g && /** @type {any} */
_g.encodeInto ? Zte : qte, _te = (t, e) => {
  const A = t.cbuf.length, n = t.cpos, s = Rte(A - n, e.length), r = e.length - s;
  t.cbuf.set(e.subarray(0, s), n), t.cpos += s, r > 0 && (t.bufs.push(t.cbuf), t.cbuf = new Uint8Array(Lte(A * 2, r)), t.cbuf.set(e.subarray(s)), t.cpos = r);
}, Xl = (t, e) => {
  an(t, e.byteLength), _te(t, e);
}, yv = (t) => new Error(t), Fv = yv("Unexpected end of array"), Nv = yv("Integer out of Range");
class $te {
  /**
   * @param {Uint8Array} uint8Array Binary data to decode
   */
  constructor(e) {
    this.arr = e, this.pos = 0;
  }
}
const Dv = (t) => new $te(t), eAe = (t, e) => {
  const A = new Uint8Array(t.arr.buffer, t.pos + t.arr.byteOffset, e);
  return t.pos += e, A;
}, cf = (t) => eAe(t, Pa(t)), dN = (t) => t.arr[t.pos++], Pa = (t) => {
  let e = 0, A = 1;
  const n = t.arr.length;
  for (; t.pos < n; ) {
    const s = t.arr[t.pos++];
    if (e = e + (s & Ag) * A, A *= 128, s < Pd)
      return e;
    if (e > mv)
      throw Nv;
  }
  throw Fv;
}, tAe = (t) => {
  let e = t.arr[t.pos++], A = e & Tte, n = 64;
  const s = (e & Ste) > 0 ? -1 : 1;
  if ((e & Pd) === 0)
    return s * A;
  const r = t.arr.length;
  for (; t.pos < r; ) {
    if (e = t.arr[t.pos++], A = A + (e & Ag) * n, n *= 128, e < Pd)
      return s * A;
    if (A > mv)
      throw Nv;
  }
  throw Fv;
}, AAe = (t) => {
  let e = Pa(t);
  if (e === 0)
    return "";
  {
    let A = String.fromCodePoint(dN(t));
    if (--e < 100)
      for (; e--; )
        A += String.fromCodePoint(dN(t));
    else
      for (; e > 0; ) {
        const n = e < 1e4 ? e : 1e4, s = t.arr.subarray(t.pos, t.pos + n);
        t.pos += n, A += String.fromCodePoint.apply(
          null,
          /** @type {any} */
          s
        ), e -= n;
      }
    return decodeURIComponent(escape(A));
  }
}, nAe = (t) => (
  /** @type any */
  ng.decode(cf(t))
), $g = ng ? nAe : AAe, sAe = (t) => {
  const e = t.pos, A = $g(t);
  return t.pos = e, A;
}, bl = Date.now, II = () => /* @__PURE__ */ new Map(), rAe = (t, e, A) => {
  let n = t.get(e);
  return n === void 0 && t.set(e, n = A()), n;
};
class iAe {
  constructor() {
    this._observers = II();
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  on(e, A) {
    rAe(this._observers, e, Jte).add(A);
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  once(e, A) {
    const n = (...s) => {
      this.off(e, n), A(...s);
    };
    this.on(e, n);
  }
  /**
   * @param {N} name
   * @param {function} f
   */
  off(e, A) {
    const n = this._observers.get(e);
    n !== void 0 && (n.delete(A), n.size === 0 && this._observers.delete(e));
  }
  /**
   * Emit a named event. All registered event listeners that listen to the
   * specified name will receive the event.
   *
   * @todo This should catch exceptions
   *
   * @param {N} name The event name.
   * @param {Array<any>} args The arguments that are applied to the event listener.
   */
  emit(e, A) {
    return Wte((this._observers.get(e) || II()).values()).forEach((n) => n(...A));
  }
  destroy() {
    this._observers = II();
  }
}
const oAe = Object.keys, wN = (t) => oAe(t).length, aAe = (t, e) => Object.prototype.hasOwnProperty.call(t, e), cAe = (t, e) => t === e, sg = (t, e) => {
  if (t == null || e == null)
    return cAe(t, e);
  if (t.constructor !== e.constructor)
    return !1;
  if (t === e)
    return !0;
  switch (t.constructor) {
    case ArrayBuffer:
      t = new Uint8Array(t), e = new Uint8Array(e);
    // eslint-disable-next-line no-fallthrough
    case Uint8Array: {
      if (t.byteLength !== e.byteLength)
        return !1;
      for (let A = 0; A < t.length; A++)
        if (t[A] !== e[A])
          return !1;
      break;
    }
    case Set: {
      if (t.size !== e.size)
        return !1;
      for (const A of t)
        if (!e.has(A))
          return !1;
      break;
    }
    case Map: {
      if (t.size !== e.size)
        return !1;
      for (const A of t.keys())
        if (!e.has(A) || !sg(t.get(A), e.get(A)))
          return !1;
      break;
    }
    case Object:
      if (wN(t) !== wN(e))
        return !1;
      for (const A in t)
        if (!aAe(t, A) || !sg(t[A], e[A]))
          return !1;
      break;
    case Array:
      if (t.length !== e.length)
        return !1;
      for (let A = 0; A < t.length; A++)
        if (!sg(t[A], e[A]))
          return !1;
      break;
    default:
      return !1;
  }
  return !0;
}, CI = 3e4;
class lAe extends iAe {
  /**
   * @param {Y.Doc} doc
   */
  constructor(e) {
    super(), this.doc = e, this.clientID = e.clientID, this.states = /* @__PURE__ */ new Map(), this.meta = /* @__PURE__ */ new Map(), this._checkInterval = /** @type {any} */
    setInterval(() => {
      const A = bl();
      this.getLocalState() !== null && CI / 2 <= A - /** @type {{lastUpdated:number}} */
      this.meta.get(this.clientID).lastUpdated && this.setLocalState(this.getLocalState());
      const n = [];
      this.meta.forEach((s, r) => {
        r !== this.clientID && CI <= A - s.lastUpdated && this.states.has(r) && n.push(r);
      }), n.length > 0 && hu(this, n, "timeout");
    }, pv(CI / 10)), e.on("destroy", () => {
      this.destroy();
    }), this.setLocalState({});
  }
  destroy() {
    this.emit("destroy", [this]), this.setLocalState(null), super.destroy(), clearInterval(this._checkInterval);
  }
  /**
   * @return {Object<string,any>|null}
   */
  getLocalState() {
    return this.states.get(this.clientID) || null;
  }
  /**
   * @param {Object<string,any>|null} state
   */
  setLocalState(e) {
    const A = this.clientID, n = this.meta.get(A), s = n === void 0 ? 0 : n.clock + 1, r = this.states.get(A);
    e === null ? this.states.delete(A) : this.states.set(A, e), this.meta.set(A, {
      clock: s,
      lastUpdated: bl()
    });
    const i = [], o = [], a = [], c = [];
    e === null ? c.push(A) : r == null ? e != null && i.push(A) : (o.push(A), sg(r, e) || a.push(A)), (i.length > 0 || a.length > 0 || c.length > 0) && this.emit("change", [{ added: i, updated: a, removed: c }, "local"]), this.emit("update", [{ added: i, updated: o, removed: c }, "local"]);
  }
  /**
   * @param {string} field
   * @param {any} value
   */
  setLocalStateField(e, A) {
    const n = this.getLocalState();
    n !== null && this.setLocalState({
      ...n,
      [e]: A
    });
  }
  /**
   * @return {Map<number,Object<string,any>>}
   */
  getStates() {
    return this.states;
  }
}
const hu = (t, e, A) => {
  const n = [];
  for (let s = 0; s < e.length; s++) {
    const r = e[s];
    if (t.states.has(r)) {
      if (t.states.delete(r), r === t.clientID) {
        const i = (
          /** @type {MetaClientState} */
          t.meta.get(r)
        );
        t.meta.set(r, {
          clock: i.clock + 1,
          lastUpdated: bl()
        });
      }
      n.push(r);
    }
  }
  n.length > 0 && (t.emit("change", [{ added: [], updated: [], removed: n }, A]), t.emit("update", [{ added: [], updated: [], removed: n }, A]));
}, kE = (t, e, A = t.states) => {
  const n = e.length, s = Nm();
  an(s, n);
  for (let r = 0; r < n; r++) {
    const i = e[r], o = A.get(i) || null, a = (
      /** @type {MetaClientState} */
      t.meta.get(i).clock
    );
    an(s, i), an(s, a), Oi(s, JSON.stringify(o));
  }
  return Dm(s);
}, BAe = (t, e, A) => {
  const n = Dv(e), s = bl(), r = [], i = [], o = [], a = [], c = Pa(n);
  for (let l = 0; l < c; l++) {
    const B = Pa(n);
    let g = Pa(n);
    const h = JSON.parse($g(n)), u = t.meta.get(B), d = t.states.get(B), w = u === void 0 ? 0 : u.clock;
    (w < g || w === g && h === null && t.states.has(B)) && (h === null ? B === t.clientID && t.getLocalState() != null ? g++ : t.states.delete(B) : t.states.set(B, h), t.meta.set(B, {
      clock: g,
      lastUpdated: s
    }), u === void 0 && h !== null ? r.push(B) : u !== void 0 && h === null ? a.push(B) : h !== null && (sg(h, d) || o.push(B), i.push(B)));
  }
  (r.length > 0 || o.length > 0 || a.length > 0) && t.emit("change", [{
    added: r,
    updated: o,
    removed: a
  }, A]), (r.length > 0 || i.length > 0 || a.length > 0) && t.emit("update", [{
    added: r,
    updated: i,
    removed: a
  }, A]);
};
class xv {
  constructor() {
    this.callbacks = {};
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  on(e, A) {
    return this.callbacks[e] || (this.callbacks[e] = []), this.callbacks[e].push(A), this;
  }
  emit(e, ...A) {
    const n = this.callbacks[e];
    return n && n.forEach((s) => s.apply(this, A)), this;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  off(e, A) {
    const n = this.callbacks[e];
    return n && (A ? this.callbacks[e] = n.filter((s) => s !== A) : delete this.callbacks[e]), this;
  }
  removeAllListeners() {
    this.callbacks = {};
  }
}
class RE {
  constructor(e) {
    this.data = e, this.encoder = Nm(), this.decoder = Dv(new Uint8Array(this.data));
  }
  peekVarString() {
    return sAe(this.decoder);
  }
  readVarUint() {
    return Pa(this.decoder);
  }
  readVarString() {
    return $g(this.decoder);
  }
  readVarUint8Array() {
    return cf(this.decoder);
  }
  writeVarUint(e) {
    return an(this.encoder, e);
  }
  writeVarString(e) {
    return Oi(this.encoder, e);
  }
  writeVarUint8Array(e) {
    return Xl(this.encoder, e);
  }
  length() {
    return Yv(this.encoder);
  }
}
var OA;
(function(t) {
  t[t.Sync = 0] = "Sync", t[t.Awareness = 1] = "Awareness", t[t.Auth = 2] = "Auth", t[t.QueryAwareness = 3] = "QueryAwareness", t[t.Stateless = 5] = "Stateless", t[t.CLOSE = 7] = "CLOSE", t[t.SyncStatus = 8] = "SyncStatus";
})(OA || (OA = {}));
var Cn;
(function(t) {
  t.Connecting = "connecting", t.Connected = "connected", t.Disconnected = "disconnected";
})(Cn || (Cn = {}));
class hc {
  constructor() {
    this.encoder = Nm();
  }
  get(e) {
    return e.encoder;
  }
  toUint8Array() {
    return Dm(this.encoder);
  }
}
class gAe extends hc {
  constructor() {
    super(...arguments), this.type = OA.CLOSE, this.description = "Ask the server to close the connection";
  }
  get(e) {
    return Oi(this.encoder, e.documentName), an(this.encoder, this.type), this.encoder;
  }
}
class Gv extends xv {
  constructor(e) {
    super(), this.messageQueue = [], this.configuration = {
      url: "",
      autoConnect: !0,
      preserveTrailingSlash: !1,
      // @ts-ignore
      document: void 0,
      WebSocketPolyfill: void 0,
      // TODO: this should depend on awareness.outdatedTime
      messageReconnectTimeout: 3e4,
      // 1 second
      delay: 1e3,
      // instant
      initialDelay: 0,
      // double the delay each time
      factor: 2,
      // unlimited retries
      maxAttempts: 0,
      // wait at least 1 second
      minDelay: 1e3,
      // at least every 30 seconds
      maxDelay: 3e4,
      // randomize
      jitter: !0,
      // retry forever
      timeout: 0,
      onOpen: () => null,
      onConnect: () => null,
      onMessage: () => null,
      onOutgoingMessage: () => null,
      onStatus: () => null,
      onDisconnect: () => null,
      onClose: () => null,
      onDestroy: () => null,
      onAwarenessUpdate: () => null,
      onAwarenessChange: () => null,
      handleTimeout: null,
      providerMap: /* @__PURE__ */ new Map()
    }, this.webSocket = null, this.webSocketHandlers = {}, this.shouldConnect = !0, this.status = Cn.Disconnected, this.lastMessageReceived = 0, this.identifier = 0, this.intervals = {
      connectionChecker: null
    }, this.connectionAttempt = null, this.receivedOnOpenPayload = void 0, this.closeTries = 0, this.setConfiguration(e), this.configuration.WebSocketPolyfill = e.WebSocketPolyfill ? e.WebSocketPolyfill : WebSocket, this.on("open", this.configuration.onOpen), this.on("open", this.onOpen.bind(this)), this.on("connect", this.configuration.onConnect), this.on("message", this.configuration.onMessage), this.on("outgoingMessage", this.configuration.onOutgoingMessage), this.on("status", this.configuration.onStatus), this.on("disconnect", this.configuration.onDisconnect), this.on("close", this.configuration.onClose), this.on("destroy", this.configuration.onDestroy), this.on("awarenessUpdate", this.configuration.onAwarenessUpdate), this.on("awarenessChange", this.configuration.onAwarenessChange), this.on("close", this.onClose.bind(this)), this.on("message", this.onMessage.bind(this)), this.intervals.connectionChecker = setInterval(this.checkConnection.bind(this), this.configuration.messageReconnectTimeout / 10), this.shouldConnect && this.connect();
  }
  async onOpen(e) {
    this.status = Cn.Connected, this.emit("status", { status: Cn.Connected }), this.cancelWebsocketRetry = void 0, this.receivedOnOpenPayload = e;
  }
  attach(e) {
    this.configuration.providerMap.set(e.configuration.name, e), this.status === Cn.Disconnected && this.shouldConnect && this.connect(), this.receivedOnOpenPayload && this.status === Cn.Connected && e.onOpen(this.receivedOnOpenPayload);
  }
  detach(e) {
    this.configuration.providerMap.has(e.configuration.name) && (e.send(gAe, {
      documentName: e.configuration.name
    }), this.configuration.providerMap.delete(e.configuration.name));
  }
  setConfiguration(e = {}) {
    this.configuration = { ...this.configuration, ...e }, this.configuration.autoConnect || (this.shouldConnect = !1);
  }
  async connect() {
    if (this.status === Cn.Connected)
      return;
    this.cancelWebsocketRetry && (this.cancelWebsocketRetry(), this.cancelWebsocketRetry = void 0), this.receivedOnOpenPayload = void 0, this.shouldConnect = !0;
    const e = () => {
      let s = !1;
      return {
        retryPromise: kte(this.createWebSocketConnection.bind(this), {
          delay: this.configuration.delay,
          initialDelay: this.configuration.initialDelay,
          factor: this.configuration.factor,
          maxAttempts: this.configuration.maxAttempts,
          minDelay: this.configuration.minDelay,
          maxDelay: this.configuration.maxDelay,
          jitter: this.configuration.jitter,
          timeout: this.configuration.timeout,
          handleTimeout: this.configuration.handleTimeout,
          beforeAttempt: (i) => {
            (!this.shouldConnect || s) && i.abort();
          }
        }).catch((i) => {
          if (i && i.code !== "ATTEMPT_ABORTED")
            throw i;
        }),
        cancelFunc: () => {
          s = !0;
        }
      };
    }, { retryPromise: A, cancelFunc: n } = e();
    return this.cancelWebsocketRetry = n, A;
  }
  // eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
  attachWebSocketListeners(e, A) {
    const { identifier: n } = e, s = (c) => this.emit("message", c), r = (c) => this.emit("close", { event: c }), i = (c) => this.emit("open", c), o = (c) => {
      A(c);
    };
    this.webSocketHandlers[n] = {
      message: s,
      close: r,
      open: i,
      error: o
    };
    const a = this.webSocketHandlers[e.identifier];
    Object.keys(a).forEach((c) => {
      e.addEventListener(c, a[c]);
    });
  }
  cleanupWebSocket() {
    if (!this.webSocket)
      return;
    const { identifier: e } = this.webSocket, A = this.webSocketHandlers[e];
    Object.keys(A).forEach((n) => {
      var s;
      (s = this.webSocket) === null || s === void 0 || s.removeEventListener(n, A[n]), delete this.webSocketHandlers[e];
    }), this.webSocket.close(), this.webSocket = null;
  }
  createWebSocketConnection() {
    return new Promise((e, A) => {
      this.webSocket && (this.messageQueue = [], this.cleanupWebSocket()), this.lastMessageReceived = 0, this.identifier += 1;
      const n = new this.configuration.WebSocketPolyfill(this.url);
      n.binaryType = "arraybuffer", n.identifier = this.identifier, this.attachWebSocketListeners(n, A), this.webSocket = n, this.status = Cn.Connecting, this.emit("status", { status: Cn.Connecting }), this.connectionAttempt = {
        resolve: e,
        reject: A
      };
    });
  }
  onMessage(e) {
    var A;
    this.resolveConnectionAttempt(), this.lastMessageReceived = bl();
    const s = new RE(e.data).peekVarString();
    (A = this.configuration.providerMap.get(s)) === null || A === void 0 || A.onMessage(e);
  }
  resolveConnectionAttempt() {
    this.connectionAttempt && (this.connectionAttempt.resolve(), this.connectionAttempt = null, this.status = Cn.Connected, this.emit("status", { status: Cn.Connected }), this.emit("connect"), this.messageQueue.forEach((e) => this.send(e)), this.messageQueue = []);
  }
  stopConnectionAttempt() {
    this.connectionAttempt = null;
  }
  rejectConnectionAttempt() {
    var e;
    (e = this.connectionAttempt) === null || e === void 0 || e.reject(), this.connectionAttempt = null;
  }
  checkConnection() {
    var e;
    this.status === Cn.Connected && this.lastMessageReceived && (this.configuration.messageReconnectTimeout >= bl() - this.lastMessageReceived || (this.closeTries += 1, this.closeTries > 2 ? (this.onClose({
      event: {
        code: 4408,
        reason: "forced"
      }
    }), this.closeTries = 0) : ((e = this.webSocket) === null || e === void 0 || e.close(), this.messageQueue = [])));
  }
  get serverUrl() {
    if (this.configuration.preserveTrailingSlash)
      return this.configuration.url;
    let e = this.configuration.url;
    for (; e[e.length - 1] === "/"; )
      e = e.slice(0, e.length - 1);
    return e;
  }
  get url() {
    return this.serverUrl;
  }
  disconnect() {
    if (this.shouldConnect = !1, this.webSocket !== null)
      try {
        this.webSocket.close(), this.messageQueue = [];
      } catch (e) {
        console.error(e);
      }
  }
  send(e) {
    var A;
    ((A = this.webSocket) === null || A === void 0 ? void 0 : A.readyState) === jE.Open ? this.webSocket.send(e) : this.messageQueue.push(e);
  }
  onClose({ event: e }) {
    this.closeTries = 0, this.cleanupWebSocket(), this.connectionAttempt && this.rejectConnectionAttempt(), this.status = Cn.Disconnected, this.emit("status", { status: Cn.Disconnected }), this.emit("disconnect", { event: e }), !this.cancelWebsocketRetry && this.shouldConnect && setTimeout(() => {
      this.connect();
    }, this.configuration.delay);
  }
  destroy() {
    this.emit("destroy"), clearInterval(this.intervals.connectionChecker), this.stopConnectionAttempt(), this.disconnect(), this.removeAllListeners(), this.cleanupWebSocket();
  }
}
const zv = 0, xm = 1, Uv = 2, hAe = (t, e) => {
  an(t, zv);
  const A = zZ(e);
  Xl(t, A);
}, uAe = (t, e, A) => {
  an(t, xm), Xl(t, NZ(e, A));
}, dAe = (t, e, A) => uAe(e, A, cf(t)), bv = (t, e, A) => {
  try {
    YZ(e, cf(t), A);
  } catch (n) {
    console.error("Caught error while handling a Yjs update", n);
  }
}, wAe = (t, e) => {
  an(t, Uv), Xl(t, e);
}, fAe = bv, QAe = (t, e, A, n) => {
  const s = Pa(t);
  switch (s) {
    case zv:
      dAe(t, e, A);
      break;
    case xm:
      bv(t, A, n);
      break;
    case Uv:
      fAe(t, A, n);
      break;
    default:
      throw new Error("Unknown message type");
  }
  return s;
};
class IAe {
  constructor(e) {
    this.message = e;
  }
  apply(e, A) {
    const { message: n } = this, s = n.readVarUint(), r = n.length();
    switch (s) {
      case OA.Sync:
        this.applySyncMessage(e, A);
        break;
      case OA.Awareness:
        this.applyAwarenessMessage(e);
        break;
      case OA.Auth:
        this.applyAuthMessage(e);
        break;
      case OA.QueryAwareness:
        this.applyQueryAwarenessMessage(e);
        break;
      case OA.Stateless:
        e.receiveStateless($g(n.decoder));
        break;
      case OA.SyncStatus:
        this.applySyncStatusMessage(e, tAe(n.decoder) === 1);
        break;
      case OA.CLOSE:
        const i = {
          code: 1e3,
          reason: $g(n.decoder),
          // @ts-ignore
          target: e.configuration.websocketProvider.webSocket,
          type: "close"
        };
        e.onClose(), e.configuration.onClose({ event: i }), e.forwardClose({ event: i });
        break;
      default:
        throw new Error(`Can’t apply message of unknown type: ${s}`);
    }
    n.length() > r + 1 && e.send(hc, { encoder: n.encoder });
  }
  applySyncMessage(e, A) {
    const { message: n } = this;
    n.writeVarUint(OA.Sync);
    const s = QAe(n.decoder, n.encoder, e.document, e);
    A && s === xm && (e.synced = !0);
  }
  applySyncStatusMessage(e, A) {
    A && e.decrementUnsyncedChanges();
  }
  applyAwarenessMessage(e) {
    if (!e.awareness)
      return;
    const { message: A } = this;
    BAe(e.awareness, A.readVarUint8Array(), e);
  }
  applyAuthMessage(e) {
    const { message: A } = this;
    vte(A.decoder, e.sendToken.bind(e), e.permissionDeniedHandler.bind(e), e.authenticatedHandler.bind(e));
  }
  applyQueryAwarenessMessage(e) {
    if (!e.awareness)
      return;
    const { message: A } = this;
    A.writeVarUint(OA.Awareness), A.writeVarUint8Array(kE(e.awareness, Array.from(e.awareness.getStates().keys())));
  }
}
class CAe {
  constructor(e, A = {}) {
    this.message = new e(), this.encoder = this.message.get(A);
  }
  create() {
    return Dm(this.encoder);
  }
  send(e) {
    e == null || e.send(this.create());
  }
}
class EAe extends hc {
  constructor() {
    super(...arguments), this.type = OA.Auth, this.description = "Authentication";
  }
  get(e) {
    if (typeof e.token > "u")
      throw new Error("The authentication message requires `token` as an argument.");
    return Oi(this.encoder, e.documentName), an(this.encoder, this.type), bte(this.encoder, e.token), this.encoder;
  }
}
class fN extends hc {
  constructor() {
    super(...arguments), this.type = OA.Awareness, this.description = "Awareness states update";
  }
  get(e) {
    if (typeof e.awareness > "u")
      throw new Error("The awareness message requires awareness as an argument");
    if (typeof e.clients > "u")
      throw new Error("The awareness message requires clients as an argument");
    Oi(this.encoder, e.documentName), an(this.encoder, this.type);
    let A;
    return e.states === void 0 ? A = kE(e.awareness, e.clients) : A = kE(e.awareness, e.clients, e.states), Xl(this.encoder, A), this.encoder;
  }
}
class MAe extends hc {
  constructor() {
    super(...arguments), this.type = OA.Stateless, this.description = "A stateless message";
  }
  get(e) {
    var A;
    return Oi(this.encoder, e.documentName), an(this.encoder, this.type), Oi(this.encoder, (A = e.payload) !== null && A !== void 0 ? A : ""), this.encoder;
  }
}
class QN extends hc {
  constructor() {
    super(...arguments), this.type = OA.Sync, this.description = "First sync step";
  }
  get(e) {
    if (typeof e.document > "u")
      throw new Error("The sync step one message requires document as an argument");
    return Oi(this.encoder, e.documentName), an(this.encoder, this.type), hAe(this.encoder, e.document), this.encoder;
  }
}
class pAe extends hc {
  constructor() {
    super(...arguments), this.type = OA.Sync, this.description = "A document update";
  }
  get(e) {
    return Oi(this.encoder, e.documentName), an(this.encoder, this.type), wAe(this.encoder, e.update), this.encoder;
  }
}
class mAe extends Error {
  constructor() {
    super(...arguments), this.code = 1001;
  }
}
class vv extends xv {
  constructor(e) {
    var A, n, s;
    super(), this.configuration = {
      name: "",
      // @ts-ignore
      document: void 0,
      // @ts-ignore
      awareness: void 0,
      token: null,
      forceSyncInterval: !1,
      onAuthenticated: () => null,
      onAuthenticationFailed: () => null,
      onOpen: () => null,
      onConnect: () => null,
      onMessage: () => null,
      onOutgoingMessage: () => null,
      onSynced: () => null,
      onStatus: () => null,
      onDisconnect: () => null,
      onClose: () => null,
      onDestroy: () => null,
      onAwarenessUpdate: () => null,
      onAwarenessChange: () => null,
      onStateless: () => null,
      onUnsyncedChanges: () => null
    }, this.isSynced = !1, this.unsyncedChanges = 0, this.isAuthenticated = !1, this.authorizedScope = void 0, this.manageSocket = !1, this._isAttached = !1, this.intervals = {
      forceSync: null
    }, this.boundDocumentUpdateHandler = this.documentUpdateHandler.bind(this), this.boundAwarenessUpdateHandler = this.awarenessUpdateHandler.bind(this), this.boundPageHide = this.pageHide.bind(this), this.boundOnOpen = this.onOpen.bind(this), this.boundOnClose = this.onClose.bind(this), this.forwardConnect = () => this.emit("connect"), this.forwardStatus = (r) => this.emit("status", r), this.forwardClose = (r) => this.emit("close", r), this.forwardDisconnect = (r) => this.emit("disconnect", r), this.forwardDestroy = () => this.emit("destroy"), this.setConfiguration(e), this.configuration.document = e.document ? e.document : new no(), this.configuration.awareness = e.awareness !== void 0 ? e.awareness : new lAe(this.document), this.on("open", this.configuration.onOpen), this.on("message", this.configuration.onMessage), this.on("outgoingMessage", this.configuration.onOutgoingMessage), this.on("synced", this.configuration.onSynced), this.on("destroy", this.configuration.onDestroy), this.on("awarenessUpdate", this.configuration.onAwarenessUpdate), this.on("awarenessChange", this.configuration.onAwarenessChange), this.on("stateless", this.configuration.onStateless), this.on("unsyncedChanges", this.configuration.onUnsyncedChanges), this.on("authenticated", this.configuration.onAuthenticated), this.on("authenticationFailed", this.configuration.onAuthenticationFailed), (A = this.awareness) === null || A === void 0 || A.on("update", () => {
      this.emit("awarenessUpdate", {
        states: uN(this.awareness.getStates())
      });
    }), (n = this.awareness) === null || n === void 0 || n.on("change", () => {
      this.emit("awarenessChange", {
        states: uN(this.awareness.getStates())
      });
    }), this.document.on("update", this.boundDocumentUpdateHandler), (s = this.awareness) === null || s === void 0 || s.on("update", this.boundAwarenessUpdateHandler), this.registerEventListeners(), this.configuration.forceSyncInterval && typeof this.configuration.forceSyncInterval == "number" && (this.intervals.forceSync = setInterval(this.forceSync.bind(this), this.configuration.forceSyncInterval)), this.manageSocket && this.attach();
  }
  setConfiguration(e = {}) {
    e.websocketProvider || (this.manageSocket = !0, this.configuration.websocketProvider = new Gv(e)), this.configuration = { ...this.configuration, ...e };
  }
  get document() {
    return this.configuration.document;
  }
  get isAttached() {
    return this._isAttached;
  }
  get awareness() {
    return this.configuration.awareness;
  }
  get hasUnsyncedChanges() {
    return this.unsyncedChanges > 0;
  }
  resetUnsyncedChanges() {
    this.unsyncedChanges = 1, this.emit("unsyncedChanges", { number: this.unsyncedChanges });
  }
  incrementUnsyncedChanges() {
    this.unsyncedChanges += 1, this.emit("unsyncedChanges", { number: this.unsyncedChanges });
  }
  decrementUnsyncedChanges() {
    this.unsyncedChanges > 0 && (this.unsyncedChanges -= 1), this.unsyncedChanges === 0 && (this.synced = !0), this.emit("unsyncedChanges", { number: this.unsyncedChanges });
  }
  forceSync() {
    this.resetUnsyncedChanges(), this.send(QN, {
      document: this.document,
      documentName: this.configuration.name
    });
  }
  pageHide() {
    this.awareness && hu(this.awareness, [this.document.clientID], "page hide");
  }
  registerEventListeners() {
    typeof window > "u" || !("addEventListener" in window) || window.addEventListener("pagehide", this.boundPageHide);
  }
  sendStateless(e) {
    this.send(MAe, {
      documentName: this.configuration.name,
      payload: e
    });
  }
  async sendToken() {
    let e;
    try {
      e = await this.getToken();
    } catch (A) {
      this.permissionDeniedHandler(`Failed to get token during sendToken(): ${A}`);
      return;
    }
    this.send(EAe, {
      token: e ?? "",
      documentName: this.configuration.name
    });
  }
  documentUpdateHandler(e, A) {
    A !== this && (this.incrementUnsyncedChanges(), this.send(pAe, { update: e, documentName: this.configuration.name }));
  }
  awarenessUpdateHandler({ added: e, updated: A, removed: n }, s) {
    const r = e.concat(A).concat(n);
    this.send(fN, {
      awareness: this.awareness,
      clients: r,
      documentName: this.configuration.name
    });
  }
  /**
   * Indicates whether a first handshake with the server has been established
   *
   * Note: this does not mean all updates from the client have been persisted to the backend. For this,
   * use `hasUnsyncedChanges`.
   */
  get synced() {
    return this.isSynced;
  }
  set synced(e) {
    this.isSynced !== e && (this.isSynced = e, e && this.emit("synced", { state: e }));
  }
  receiveStateless(e) {
    this.emit("stateless", { payload: e });
  }
  // not needed, but provides backward compatibility with e.g. lexical/yjs
  async connect() {
    if (this.manageSocket)
      return this.configuration.websocketProvider.connect();
    console.warn("HocuspocusProvider::connect() is deprecated and does not do anything. Please connect/disconnect on the websocketProvider, or attach/deattach providers.");
  }
  disconnect() {
    if (this.manageSocket)
      return this.configuration.websocketProvider.disconnect();
    console.warn("HocuspocusProvider::disconnect() is deprecated and does not do anything. Please connect/disconnect on the websocketProvider, or attach/deattach providers.");
  }
  async onOpen(e) {
    this.isAuthenticated = !1, this.emit("open", { event: e }), await this.sendToken(), this.startSync();
  }
  async getToken() {
    return typeof this.configuration.token == "function" ? await this.configuration.token() : this.configuration.token;
  }
  startSync() {
    this.resetUnsyncedChanges(), this.send(QN, {
      document: this.document,
      documentName: this.configuration.name
    }), this.awareness && this.awareness.getLocalState() !== null && this.send(fN, {
      awareness: this.awareness,
      clients: [this.document.clientID],
      documentName: this.configuration.name
    });
  }
  send(e, A) {
    if (!this._isAttached)
      return;
    const n = new CAe(e, A);
    this.emit("outgoingMessage", { message: n.message }), n.send(this.configuration.websocketProvider);
  }
  onMessage(e) {
    const A = new RE(e.data), n = A.readVarString();
    A.writeVarString(n), this.emit("message", { event: e, message: new RE(e.data) }), new IAe(A).apply(this, !0);
  }
  onClose() {
    this.isAuthenticated = !1, this.synced = !1, this.awareness && hu(this.awareness, Array.from(this.awareness.getStates().keys()).filter((e) => e !== this.document.clientID), this);
  }
  destroy() {
    this.emit("destroy"), this.intervals.forceSync && clearInterval(this.intervals.forceSync), this.awareness && (hu(this.awareness, [this.document.clientID], "provider destroy"), this.awareness.off("update", this.boundAwarenessUpdateHandler), this.awareness.destroy()), this.document.off("update", this.boundDocumentUpdateHandler), this.removeAllListeners(), this.detach(), this.manageSocket && this.configuration.websocketProvider.destroy(), !(typeof window > "u" || !("removeEventListener" in window)) && window.removeEventListener("pagehide", this.boundPageHide);
  }
  detach() {
    this.configuration.websocketProvider.off("connect", this.configuration.onConnect), this.configuration.websocketProvider.off("connect", this.forwardConnect), this.configuration.websocketProvider.off("status", this.forwardStatus), this.configuration.websocketProvider.off("status", this.configuration.onStatus), this.configuration.websocketProvider.off("open", this.boundOnOpen), this.configuration.websocketProvider.off("close", this.boundOnClose), this.configuration.websocketProvider.off("close", this.configuration.onClose), this.configuration.websocketProvider.off("close", this.forwardClose), this.configuration.websocketProvider.off("disconnect", this.configuration.onDisconnect), this.configuration.websocketProvider.off("disconnect", this.forwardDisconnect), this.configuration.websocketProvider.off("destroy", this.configuration.onDestroy), this.configuration.websocketProvider.off("destroy", this.forwardDestroy), this.configuration.websocketProvider.detach(this), this._isAttached = !1;
  }
  attach() {
    this._isAttached || (this.configuration.websocketProvider.on("connect", this.configuration.onConnect), this.configuration.websocketProvider.on("connect", this.forwardConnect), this.configuration.websocketProvider.on("status", this.configuration.onStatus), this.configuration.websocketProvider.on("status", this.forwardStatus), this.configuration.websocketProvider.on("open", this.boundOnOpen), this.configuration.websocketProvider.on("close", this.boundOnClose), this.configuration.websocketProvider.on("close", this.configuration.onClose), this.configuration.websocketProvider.on("close", this.forwardClose), this.configuration.websocketProvider.on("disconnect", this.configuration.onDisconnect), this.configuration.websocketProvider.on("disconnect", this.forwardDisconnect), this.configuration.websocketProvider.on("destroy", this.configuration.onDestroy), this.configuration.websocketProvider.on("destroy", this.forwardDestroy), this.configuration.websocketProvider.attach(this), this._isAttached = !0);
  }
  permissionDeniedHandler(e) {
    this.emit("authenticationFailed", { reason: e }), this.isAuthenticated = !1;
  }
  authenticatedHandler(e) {
    this.isAuthenticated = !0, this.authorizedScope = e, this.emit("authenticated", { scope: e });
  }
  setAwarenessField(e, A) {
    if (!this.awareness)
      throw new mAe(`Cannot set awareness field "${e}" to ${JSON.stringify(A)}. You have disabled Awareness for this provider by explicitly passing awareness: null in the provider configuration.`);
    this.awareness.setLocalStateField(e, A);
  }
}
var YAe = class jv extends Gv {
  constructor(e) {
    var A;
    if (Array.isArray(e.baseUrl)) throw new Error("TiptapCollabProviderWebsocket does not support multiple baseUrls");
    let n = (A = e.baseUrl) != null ? A : `wss://${e.appId}.collab.tiptap.cloud`;
    e.shardKey && (n += n.includes("?") ? "&" : "?", n += `shard=${e.shardKey}`), n += n.includes("?") ? "&" : "?", n += "__version=3.6.1", super({ ...e, url: n });
  }
  static async createCluster(e, A) {
    var n;
    if (!Array.isArray(A.baseUrl)) throw new Error("Cluster requires baseUrl to be an array of nodes");
    let s = "", r = [], i = 0;
    for (; s === "" && i < A.baseUrl.length; ) {
      if (!A.baseUrl[i]) {
        i += 1;
        continue;
      }
      try {
        let l = await fetch(`${A.baseUrl[i].replace("ws://", "http://").replace("wss://", "https://")}/publicapi/cluster/node/${e}`);
        if (l.ok) {
          let B = await l.json();
          s = B.primaryNode, r = B.alternativeNodes;
        } else console.error(l.status), console.error(await l.text());
      } catch {
      }
      i += 1;
    }
    s === "" && (s = A.baseUrl[0]);
    let o = [], a, c = new jv({ ...A, baseUrl: s, onDestroy() {
      a && clearInterval(a);
    } });
    return a = setInterval(() => {
      if (c.status !== "connected") {
        c.disconnect(), o.push(c.configuration.url);
        let l = r.find((B) => !o.includes(B));
        if (!l) {
          console.error("all nodes appear dead, retrying all."), o.splice(0, o.length);
          return;
        }
        console.log(`Primary node went down, switching to ${l}`), c.configuration.url = l, c.shouldConnect = !0, c.connect();
      } else o.splice(0, o.length);
    }, ((n = A.failOverIfNoConnectionAfterSeconds) != null ? n : 5) * 1e3), c;
  }
}, yAe = { deleteContent: !1, deleteThread: !1 }, FAe = { types: ["unarchived"] }, NAe = { deleteComments: !1, force: !1 }, DAe = class extends vv {
  constructor(t) {
    let e = !t.websocketProvider;
    t.websocketProvider || (t.websocketProvider = new YAe({ appId: t.appId, baseUrl: t.baseUrl })), t.token || (t.token = "notoken"), super(t), this.tiptapCollabConfigurationPrefix = "__tiptapcollab__", this._versionsVersion = 1, this._versions = [], this._versionCallbacks = /* @__PURE__ */ new Set(), this.boundLastSavedHandler = this.lastSavedHandler.bind(this), this.on("stateless", this.boundLastSavedHandler), e && (this.manageSocket = !0, this.attach()), t.user && (this.userData = new bZ(this.document, this.document.getMap("__tiptapcollab__users")), this.userData.setUserMapping(this.document, this.document.clientID, t.user)), this.on("stateless", (A) => {
      try {
        let n = JSON.parse(A.payload);
        n.event === "version.created" ? this._versionsVersion === 2 ? (this._versions = [...this._versions, { version: n.version, name: n.name, date: n.date, meta: n.meta }], this._notifyVersionCallbacks()) : this.listVersions() : n.event === "versions.list" && (this._versions = n.versions, this._notifyVersionCallbacks());
      } catch {
      }
    }), this.on("synced", () => {
      this.document.getMap("__tiptapcollab__config").get("versionsV1Migrated") === 1 && (this._versionsVersion = 2), this.listVersions();
    });
  }
  _notifyVersionCallbacks() {
    this._versionCallbacks.forEach((t) => {
      t(this._versions);
    });
  }
  listVersions() {
    return new Promise((t) => {
      if (this._versionsVersion === 1) {
        this._versions = this.document.getArray("__tiptapcollab__versions").toArray(), t(this._versions), this._notifyVersionCallbacks();
        return;
      }
      let e = (A) => {
        try {
          let n = JSON.parse(A.payload);
          n.event === "versions.list" && (this.off("stateless", e), t(n.versions));
        } catch {
        }
      };
      this.on("stateless", e), this.sendStateless(JSON.stringify({ action: "versions.list" }));
    });
  }
  lastSavedHandler(t) {
    try {
      let e = JSON.parse(t.payload);
      e.event === "document.saved" && (this.lastSaved = new Date(e.date), this.emit("saved", this.lastSaved));
    } catch {
    }
  }
  createVersion(t, e = !1, A) {
    return A && this._versionsVersion === 1 && console.warn("Version metadata is not supported by the server version. You may want to upgrade your collaboration server."), this.sendStateless(JSON.stringify({ action: "version.create", name: t, force: e, meta: A }));
  }
  revertToVersion(t, e) {
    var A;
    return this.sendStateless(JSON.stringify({ action: "document.revert", version: t, fields: (A = e == null ? void 0 : e.fields) != null ? A : ["default"], ...e != null && e.currentVersionName || (e == null ? void 0 : e.currentVersionName) === !1 ? { currentVersionName: e.currentVersionName } : {}, ...e != null && e.newVersionName || (e == null ? void 0 : e.newVersionName) === !1 ? { newVersionName: e.newVersionName } : {} }));
  }
  previewVersion(t) {
    return this.sendStateless(JSON.stringify({ action: "version.preview", version: t }));
  }
  getVersions() {
    return this._versions;
  }
  watchVersions(t) {
    this._versionCallbacks.add(t);
  }
  unwatchVersions(t) {
    this._versionCallbacks.delete(t);
  }
  isAutoVersioning() {
    return this.isSynced ? !!this.configuration.document.getMap(`${this.tiptapCollabConfigurationPrefix}config`).get("autoVersioning") : !1;
  }
  getAutoVersioningInterval() {
    if (this.isSynced) return this.configuration.document.getMap(`${this.tiptapCollabConfigurationPrefix}config`).get("intervalSeconds");
  }
  setAutoVersioningInterval(t) {
    if (this.getAutoVersioningInterval() === t) return t;
    if (!this.isSynced) this.once("synced", () => this.setAutoVersioningInterval(t));
    else return this.configuration.document.getMap(`${this.tiptapCollabConfigurationPrefix}config`).set("intervalSeconds", t);
    return t;
  }
  enableAutoVersioning() {
    if (!this.isSynced) this.once("synced", this.enableAutoVersioning);
    else if (!this.isAutoVersioning()) return this.configuration.document.getMap(`${this.tiptapCollabConfigurationPrefix}config`).set("autoVersioning", 1);
    return 1;
  }
  disableAutoVersioning() {
    if (!this.isSynced) this.once("synced", this.disableAutoVersioning);
    else if (this.isAutoVersioning()) return this.configuration.document.getMap(`${this.tiptapCollabConfigurationPrefix}config`).set("autoVersioning", 0);
    return 0;
  }
  getLastSaved() {
    if (this.lastSaved) return this.lastSaved;
    if (!this.isSynced) return null;
    let t = this.configuration.document.getMap(`${this.tiptapCollabConfigurationPrefix}config`).get("lastSaved");
    return t ? new Date(t) : null;
  }
  getYThreads() {
    return this.configuration.document.getArray(`${this.tiptapCollabConfigurationPrefix}threads`);
  }
  getThreads(t) {
    let { types: e } = { ...FAe, ...t }, A = this.getYThreads().toJSON();
    return e != null && e.includes("archived") && e != null && e.includes("unarchived") ? A : A.filter((n) => !!(e != null && e.includes("archived") && n.deletedAt || e != null && e.includes("unarchived") && !n.deletedAt));
  }
  getThreadIndex(t) {
    let e = null, A = 0;
    for (let n of this.getThreads({ types: ["archived", "unarchived"] })) {
      if (n.id === t) {
        e = A;
        break;
      }
      A += 1;
    }
    return e;
  }
  getThread(t) {
    let e = this.getThreadIndex(t);
    return e === null ? null : this.getYThreads().get(e).toJSON();
  }
  getYThread(t) {
    let e = this.getThreadIndex(t);
    return e === null ? null : this.getYThreads().get(e);
  }
  createThread(t) {
    let e = {};
    return this.document.transact(() => {
      let A = new jr();
      A.set("id", dE()), A.set("createdAt", (/* @__PURE__ */ new Date()).toISOString()), A.set("comments", new Ds()), A.set("deletedComments", new Ds()), A.set("deletedAt", null), this.getYThreads().push([A]), e = this.updateThread(String(A.get("id")), t);
    }), e;
  }
  updateThread(t, e) {
    let A = {};
    return this.document.transact(() => {
      let n = this.getYThread(t);
      if (n === null) return null;
      n.set("updatedAt", (/* @__PURE__ */ new Date()).toISOString()), e.data && n.set("data", e.data), (e.resolvedAt || e.resolvedAt === null) && n.set("resolvedAt", e.resolvedAt), A = n.toJSON();
    }), A;
  }
  deleteThread(t, e) {
    let { deleteComments: A, force: n } = { ...NAe, ...e }, s = this.getThreadIndex(t);
    if (s === null) return null;
    if (n) {
      this.getYThreads().delete(s, 1);
      return;
    }
    let r = this.getYThreads().get(s);
    return r.set("deletedAt", (/* @__PURE__ */ new Date()).toISOString()), A && (r.set("comments", new Ds()), r.set("deletedComments", new Ds())), r.toJSON();
  }
  restoreThread(t) {
    let e = this.getThreadIndex(t);
    if (e === null) return null;
    let A = this.getYThreads().get(e);
    return A.set("deletedAt", null), A.toJSON();
  }
  getThreadComments(t, e) {
    var A, n, s;
    if (this.getThreadIndex(t) === null) return null;
    let r = e ? [...((n = this.getThread(t)) == null ? void 0 : n.comments) || [], ...((s = this.getThread(t)) == null ? void 0 : s.deletedComments) || []].sort((i, o) => i.createdAt.localeCompare(o.createdAt)) : (A = this.getThread(t)) == null ? void 0 : A.comments;
    return r ?? [];
  }
  getThreadComment(t, e, A) {
    var n;
    if (this.getThreadIndex(t) === null) return null;
    let s = this.getThreadComments(t, A);
    return (n = s == null ? void 0 : s.find((r) => r.id === e)) != null ? n : null;
  }
  addComment(t, e) {
    let A = {};
    return this.document.transact(() => {
      let n = this.getYThread(t);
      if (n === null) return null;
      let s = new jr();
      s.set("id", dE()), s.set("createdAt", (/* @__PURE__ */ new Date()).toISOString()), n.get("comments").push([s]), this.updateComment(t, String(s.get("id")), e), A = n.toJSON();
    }), A;
  }
  updateComment(t, e, A) {
    let n = {};
    return this.document.transact(() => {
      let s = this.getYThread(t);
      if (s === null) return null;
      let r = null;
      for (let i of s.get("comments")) if (i.get("id") === e) {
        r = i;
        break;
      }
      if (r === null) return null;
      r.set("updatedAt", (/* @__PURE__ */ new Date()).toISOString()), A.data && r.set("data", A.data), A.content && r.set("content", A.content), n = s.toJSON();
    }), n;
  }
  deleteComment(t, e, A) {
    let { deleteContent: n, deleteThread: s } = { ...yAe, ...A }, r = this.getYThread(t);
    if (r === null) return null;
    let i = 0;
    for (let c of r.get("comments")) {
      if (c.get("id") === e) break;
      i += 1;
    }
    if (i === 0 && (s || this.configuration.deleteThreadOnFirstCommentDelete)) {
      this.deleteThread(t);
      return;
    }
    let o = r.get("comments").get(i), a = new jr();
    return a.set("id", o.get("id")), a.set("createdAt", o.get("createdAt")), a.set("updatedAt", (/* @__PURE__ */ new Date()).toISOString()), a.set("deletedAt", (/* @__PURE__ */ new Date()).toISOString()), a.set("data", o.get("data")), a.set("content", n ? null : o.get("content")), r.get("deletedComments").push([a]), r.get("comments").delete(i), r.toJSON();
  }
  watchThreads(t) {
    this.getYThreads().observeDeep(t);
  }
  unwatchThreads(t) {
    this.getYThreads().unobserveDeep(t);
  }
  async acquireLock(t, e) {
    return new Promise((A) => {
      let n = (s) => {
        var r, i;
        let o = JSON.parse(s.payload), a = (i = (r = o.event) == null ? void 0 : r.split(".")) != null ? i : [];
        a.length && a[0] === "mutex" && (this.off("stateless", n), A(o.event === "mutex.granted"));
      };
      this.on("stateless", n), this.sendStateless(JSON.stringify({ action: "mutex.request", key: t, timeout: e }));
    });
  }
  async releaseLock(t) {
    this.sendStateless(JSON.stringify({ action: "mutex.release", key: t }));
  }
  once(t, e) {
    let A = (...n) => {
      this.off(t, A), e.bind(this)(...n);
    };
    return this.on(t, A), () => this.off(t, A);
  }
  destroy() {
    this.off("stateless", this.boundLastSavedHandler), super.destroy();
  }
  setFieldType(t, e) {
    if (!this.isSynced) this.once("synced", () => {
      this.setFieldType(t, e);
    });
    else {
      let A = this.document.getMap(`${this.tiptapCollabConfigurationPrefix}typemap`);
      A.get(t) !== e && A.set(t, e);
    }
  }
  getVersionsVersion() {
    return this._versionsVersion;
  }
};
const EI = '@font-face{font-display:block;font-family:KaTeX_AMS;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Caligraphic;font-style:normal;font-weight:700;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,d09GRgABAAAAAB4kAA4AAAAAMFAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAAUQAAAAFQAAABgRoFyK2NtYXAAABSUAAAANAAAAEQAiwEsY3Z0IAAAHBQAAAAaAAAALAqfANNmcGdtAAAUyAAABrsAAA4MYi77e2dhc3AAAB4cAAAACAAAAAgAAAAQZ2x5ZgAAAUQAABHGAAAZlq7j6P1oZWFkAAATbAAAADYAAAA2ZFFDiWhoZWEAABQgAAAAHwAAACQI0wOvaG10eAAAE6QAAAB8AAAAfFjZA25sb2NhAAATLAAAAEAAAABAWGZe0m1heHAAABMMAAAAHwAAACAAyQ6WbmFtZQAAHDAAAAGjAAAEnmUdgC1wb3N0AAAd1AAAAEgAAABoOcqzP3ByZXAAABuEAAAAjQAAAKdkQq2ceNpleAV820i3vWdGmhEzWaZYMoZjGcLcQNukKbdfucvMvPsxMzMzM9MfHjMzMzNj3siy4+6+3y2ORvnNOffcc+8oBVONVCr1o9BOoRRJpSI90quRHjbefnOjAe3/+osG+BLdU93/GfRb8G9Sq6m9FPe13bVcCjZG3KDSarY77U7DdZyo0Yn/2YlazU6bLrUjumpbhuu4ybOI/o9gGkG1UqmGVUxogPYcbFWqzUq1RfDra0tpXeZVlql6LBy55c2PsTlGWMxBEUk8tFVdIjzjjaZFbSx3KCjOKLyH3/QmXrw0XwGekTnyPJEBQD0xNTfmL+kScMwsEF/0rV/kJIG36xjwKPvC//4/m8dcWXIBx2dyZkEBoXZzCUjK43UPjHPspZdxJVb135gCqdr+38A/gP8vdVMKf2VIBI0R0KDnX4QxyshxEzDEdfqocEhxVSkhXahRo9WshAFdTBiiQRcCgjFJgq4nfAXxmwlnbTDvipAh6K5nNLOWn43K0yLfXm9Y2TtezjnbjRwE9mhLXJp+8Z3HuGHilLNK8YWBPLGbaV7LZiPTrZaz0rhfcxFy6r47Kb2KN+D/MQqbgMHoggqBml9oNcoFzJg7M1uLvnNKARmZIKTao6h0//oGNtSKQsSRtJApluzyl++/+1xBy0KDs3Zu//RnPMk2snmyjkiK8mPt/yU8C/9vapryY/GUn3JjwERCAw23K4Iu7Bhmj4gwiLfZVqIMWM+Y9dmr14lxx6NI3X7dXzJ+Xi1htiQaq74DeJ/A6k2LWxpcmVhemJr6jim64+UFHrz47rz12G3/x4aQGOOmaR5W3KJF9Ik0VkubZ5+0zLtmai0qbpiyUin0CPx8aiK1QtU71y7G6o0qXdaXYHykIEnMQSoSATsRc4AJNMtBJaza8cETrd+lImF6iOHPy6By0sAMo64VXKicbp5/Cqz76U0IorHO/Z/+NeE8HP7v/2R1yHnXePbbjx5NS0TExK5w0Pq93xR507Bk7FYNJEweT49xABi/duz45e17JQBe8QUDAPJnv2vBI9G5Mcp6ef9v4UPw/6ROUtYL3AHrifz6rPdkGAu1W4Vuf0erScmvUl0m5DtR/+UkbIuu0LdgmMk137grBmO5hxj/USaD2Nn5sVetYw54S3YdQX65hkVP1PzqTNqzzd1hh+GnfDW/M1rkwJmZeis/8R1dyzV3REAK53XtrlPIQLA0t7w4sUIA4LW6zIXTBCpsgbEoE141S89jYM4IeRYyjcoYw49N+tkJiljb/330YZq7PYq4IcR1GFTD+LQHJde1mzxDcfYsKMQDCSbF2tdgTMwIJPT1YsIKfJfBfkuISoW7mqzmKK1AAMyxkMUMCwnIhCzM1U+WmXcqU64gS3p1dhf9+3+asgO51YLBC1dHzgFkVoCtUEybQNLc+6YnNjCAYlngvTYEAMU/hmXGLnz1y5piC5xo+F6AAGCgJmHGGWcRy7CEkY7dhQVD82txZTX23wA/QHN8liJeH4oRN8dhv2R6PksR2xZdeI7z0OUeDZ0DDmISop4bDzQep1nVAtc+MbWV4U9vB7nFrLhdzGT5ob3ZQztidXPVJoJhdjzJmlks4mKJHbln/NK9SH3i+q0PigJ3Judx1qg957lGjgDYUAwMi5P3hkNHb9bLl3PjUGfvzN798tFIAiJCmFdNMwsZHrHF84pffORyxrj+0dYMBmlrSLdHx52coZhFB3Wd5WfRl2nG74kzHmvcDPpybnSzRogVRV0WDgRs05V2b6XXY2KxJ/6KSSyYPlXNngeF/ebVdaVm15ZieoapDD57N3TrU5AlHrnnXnTIl7cynjiyrap1QcWsvuY7aHbviaI6AohPIKdYJ69KQxmZlbTxqo20YsadmVHnSnzGh4xCwGi7ndG2wf8xeOfYrRwoBenq1sUsEH+5ZtcNJnv7n++dHK4BSNzACqNZhnPHoYSu3JZGLADly8tDoi4VNVw/fnwLAp43p0QIgCSvHGVEOJKtZ0aoavb/iBrdn1PWNilrk/IBa91oNNqNRhT1qoCECRnEjUnsM9jjrFsxUVJGSbua9iBRy1tHnwZ2aXQ2+xWFk9u5jUO6YGdGV/nbbuVHIx/KV2eckR/4A0ZyMyVjZXp2pDLGj5w7xY/nDfAPOsM51lS+iIDAEdkKCMhm23d/aU8AfB0ZiKscihs3ZCTNzohk9/+8cUES7BpPqBZa+69Hn6Kotimq+QpF1bEGRdA7JSY3encSB2AHcUOhdKX0o8y5BU9vDAk1sHxRiOZnih0qHX3Vd9ns5uk7JjvwJS9WOKmRVkSHhLXqsG4sPnn22HRxhxaGNhG5L2AdpjGH1RXrnewfXROImlnSBTfQWWNveqOgMF20RpGDAJDCpUufXSrcNT+s5GYsP5NVx+K+VN//G7RKKz1IXad9aanucvBZar9huhhMDC2CQTdpCRwalQPn789dFiZU3u1KNaEgNvuDOYzGdXeSfzlv2gJLoJNdy4vixlAGb45mWH8EfjqDzDde9LHiFCojh0UIuezWG87NQ4Mtm9npvGhA1ZRKDw2XiTF51FN1M/QVIjZ4mKfTAV5DPGI44/otr/zqCcsdgxqnfObzt11RZPe/X2YTfv4EZFW7vfixBc42sV/c22sIQNam60hQBUwlsBEWVCEfve5qjhoutgIDpUDME/wbOmtsUBUYKaoCNyHjILqTRperfperhIlj0iBRDN4duEVCXEjwksMIeUW0XEWdPNp84yZjD09h/nTZQRmfyJJirtR8F+ennz5WlfH5igO112zy4cypxyc0eVTXCTEc0SpdaE+95cLSHoZwsp6W020NmYw/JMmZax+/eUwClgSAP6shbuaiBGQTchmKqLL/M+w2zfx1iuiSHuu6mbRq5wBS1OjlrLeQVCrsT02dwbg18P8WHtRyN6q9LZVYJqMOy7klWcjML9sM4A4FCs8sbocQ3VZ59Q/PQsTZWM0SRoJ+PZ0xrekxxzF5E4dEcMCfb4jLSl3mORYbk0MToywubWysUU9vcYxVOU4cBmDr7R/4qM+447z2tx/fOBO84P9NAwhLurn83791uD2ckxxgyLaVdTGBSjA199SnGOZ3FvmmNMQDiLzF7Xterzsvf98HAw7kdC72tD/d/xnmONpKnaEsHS3FLMXQBwTlkesk0Wm2+pWfNMYQ97NfbZJEF8+hJOg7wURQVwW9OGcAXp0rEA5DBs5eqPm+AsDMZrU4tleveSUDy4eo8UrBcksCAJCNUGSw0h5eOs2g4srcpqgExZxnSOJrAsm7/Svf9mQ7hJiVmc//2NmxcR1AAH7vN5+K1gtaOdzgEVsX2ezdP/NzowBAANOTCJlre4/9pqB9+DNvt5Bt5TILhhRPA0vUIx6E/6frgHOAcgB6Ou6GdTBFt1vdGwd51gVj4CMD4Q+mQ/BBLHhInl0amePBxdlTWf+215zctWRNT9uCNBalAV+YesuO4eW1I6eGy688++hjeePcEzrWMu+8owi/B3VMcoX83O7NjMK8eG2EtT7/CHvmfkFw82OmNIxMFuVHj94iI0Z76punjrx4dB4q953OD7XbVz7V1OO5fP97aJe6+2RqM57LG5kU7NW2YbbD/z2TdxrdouhXcZiIHdBat63u5r424in30672hAtB5cSzR/NaLf/YI61Fzv/hh9ebEqdHnL4OvrX8gAwBkIelodIL2yUZQGXNYKvABWXjueO5PlRd8TIX3+Cr6egZyanAe4YYwEnsgx/GBuTGCh2sq2SYZu7x/XvRq2jmrtHMzbrPndX7lk3ru+HcaPUHPn3DlXmg3j4XSfRSnkyGbtSA076b31ufzNnaxvl09MonXgUBi1Wm5p26rTx26cIzaOvWVZ9FkNsOJRXYd07OcUEoHH76/MRovcjw7RyX33/iGA8evrzQbh0V4PF10vptQ3OyHmGgfO1Ia+6ps7sSANh64ZXjh8/vbDeRneMQ509BTmDRbscXAOCqWV4AOubMKgeB+NjxO4l85XE/c/u8pqwfY5Pb49+gX+rNeIUUOMh6KwyS0n3uZawRJX7YZ4S4zqCn9QtiQNOAqoEgqEr6P/k7WfFxkwUae8rkn6UOVO6kN3YvhyWNg/Lw9DWZSAWXqQ1x3Gh1fNSDODP7+kWbL2fsoK5rKq/ZiJKGvWcKRmvmUQdAeyfU1XVdx2kgAlsAnMk/Wz6CYeT0nC3OTq3VsWDMj+MjIixUDIQ1d3IayeXM2p7n8ATqBFsxf6RTKE0YBoOs//vjF7NOlbKXprfAn6PKukjZ24unIrPhJgTYVp+TBHMSrcH8fFA+lJ3eju4ElbyYEPzsjxntn/ChoPoEQVKeOTk7FiiiOXTXRrkkQqIcnT53ubk6TQARNopZRmatqfH0FNZU1XcmHq/lLu7d9uKVYqdWVcqnXBBoimRqDJEV7HkVXcx7Vj49UnZzuSrlSXXqR7NjfDjECp7pjEOdMVhXxqwscVrgO6amaMOTlZH5+2stSQtykZ/bznDdXvod9BX4s6llysaYduPk22kP0d+dg0sBDkJC0QZBbB2DuSreatA/w94KXnCRdevcmnoe3HSezxeoS8L63CHIIAAxa6aH1JumIuiFAjHWAg/ygXUfK/8RxwIkdPIW+Gkd8ztLoQIBwCaGRiac4gAAP/AT3N6Gw7llZHL61jr4OpBlScO8WRMw7XX/vP+nCNGKOEVRzBCKwkhQDNx+YPXxL/r7xj7g3jARJC92HyQz/eCzS60xs7MLjYUcP9RReN/ytMrud2eZtCiqWxm3SIzxssoSrxb3/4XVcBWx/kn8lifUprtkmRN1lWiqBWtGNqBK7lQ3va3nt4JC2zfc5h/dzy9mMm5Vd7fU1oveurCkiZLdbfj5Ipi2nNb1k+yLbSQVLo4vdO65OGEblpDqavkrCFPcTYp7GPey17u203B7h6dtq7ceNW5wxVasYVitNNLzAWcfjzZsSrXxtpN1BaFm4MX9mJtZ56f2b9s1iMEw1q0e3DGtSQ6yS2f+3+KlhnL/nVEZk0yIwty8Ie7N50s/8stnxsX2yPkTo4Db0JMzfon5Oj3jZXrGNRifsT+t0ZPYi7BnxfH5uldUJzn7c47eiQ48nkZSmTQlMEHSHd+0eKWS3qlN1S/rDEREwo9eHSaHSxIQARGYS0UGqo+2FYJA6LuhSaSJBhSnjn1yXZLpY2WuioHyvl+aEAhrAf2WTImT4BWvk138rfa4P64gTiGve/c6AgZwW4gAoDrCr/2xj41X3Ja1OcEbgqXiNo/gkVlN27n23q9vE8zgkR//oRem//vf/jAiTFnBRz4MCmtGN3PTKYBeTVm5L55M4syBXoYaURd+jLbdZ6Yr1wPztukzp2/dNzS47q/qwdfBZHt4w8ecdrVnanEFA95ZHqnMcaLkWTkRKNvndRwBbqecG7H1YP2deWDgbMCToOhBLzoilkukaoocDxkA8O4jAS7YVnGUmHymbJtDOz+nYEAw5g3R5/kKnNS9WUUGjOEvoJcyYHhGI4wmyxh5U0U/nfWy02d1Fn4GDNcZx7S9KRFAqWJNHKf1LE6u5wljMZBWS1GEoefm0/7yI4SFzMq2XdJFbFH+SvsXUa73ZWuSPfCtqNH34agxaPL9W+tBB0xI65o0XT5wfSrGpCKqBG97zu7zPOtSe8zkASzLd4yL04Eg5m0kRMs8VMZeef+rL3cktbUlMlVLYcVcrsghv8lmXcrtSnRaqMARQ3MPs+7Dlz5wMuAq6r2PFPhcxVMyswJYnODdysR7PvDia6sKWhy3SLBIy98AOM8YKsuaGki9+BaJ+LFWxlMpdJpivYtiPeHHWqmE3b4z8Ku4dm7s5sRtNKIe3P6NLfni7kaDbz8JC7SMaPRdPxx8/4zi/8N7X3jYTeuM0Cnqhof0hasPpHP/N12yNeRkTt3iIEZki7wMSZQnkIx57Ok35GbdXwhrDhEuFFzkvPGEvFT/q1w7K0lpSQ7f/JL0xITOchWLrK6kF9s6XGR5KzMsEqBhrtPYEVkG6lLh8hUHAEwkyFkhYACzc78LAIJhLtvRWHH3GRXG+0RN8e+/zwFExoKWYaA3P23+D7kx2bUAAHjaY2BkYGCQZyhgYGIAAjApwdALJKX4eEACABdRAW4AAAAAEgASABIAEgCLARsBcQHWAk8CyANIA+METgS9BVEFugZNBs8HPQesCDoI2QlgCcMKPwqRCxwLvAwyDMsMywABAAAAAQAA+awoxV8PPPUADwPoAAAAAAAAAAAAAAAAAAAAAP/l/1wFSQNIAAAACAACAAAAAAAAAPoAMgAAAAABTQAAAPoAAAOZACcC7AAoAmUAFAN8ABQCXwAlAy4AEAKqADID2wAUAoL/5QMLADUDZwApAxQAKQViACYDqf/oA4oAPwMqABQDqwB4A94AFAK4ABkChAAmAsv/9gLhABkEkQAZAzEAOAL3ACQDMgAuAPoAAHjaY2BkYGD2+B/DEMWa9P/pv4usnkARVCAPAJ6yBooAeNpjYGIWZ9rDwMrAwNQFpBkYeiA04wMGQ0YmBiDgYICABgaG9wIMb94yQEFAmmsKgwODAsMCZoX/FgxRzB4MSxQYGPrjmEGyTOuAhAIDIwDfxA9YeNpjYGBgAmJmIBYBkoxgmoXBAEhzACFIToEhimHB//9gliOI9f/x/8P/64BqoQAA6/MLsXjarFbXettMDh2quVeVFKaAmcjrNYeK090Lx7Q23fX7yK2kJed+9yrPwH0ZUOl3+2gLkJJ7+ZtVMIMywDnA0EKhAMW+7wUAb36I0e03WNr9q4/PTJwOwo8Q7/uYq0c/+0W/aLXkgWlZKAIUWm50hCF06DpoKITwo4M5JS1pOZhX0P6cr1SFq7GsIQzdJFfRblLPa8zpvU+Aw5IWOmpjYetTJ5fL0TFoHd6xWNsZrRruHaCldDtlo0w2iWLLPww6NYM9HSwozNtY1T7nw5rWXQcT2oD/28LC1F8708aI9loeljzfwnw92PmbT85m7ANubZFqjbxxjldzQQBJ5k0VTZOquwOcZfssedKpPhAbcQQ4uOWHpAG2DfLqBa9ehGYYBIFJbOGwbqHY8VG8YWeL9uYbvMere2+iH+OixR4/iuIgCNpRgIYdBF0EAbQJj3QDB4sKqIJCPSJMfXrLxz7pYr90qQMUEjpYSukmJqCd9B24wEaGa2bl8zf5eS0szlhk1BBDTLmS2WKdGNr2wy0z2gl8GVgB4NquTzaTeOmV4mCfwgFtd0Qua3M/baUrAYV0I8wdfESjRQmwb8bBAQVc7SjBKogD4BNwLQzYJdxIqx1UnYFRoT13xjoanCF1epCGs1MMW5KeoIfgxTKCdpdsYXJDEExcOyKMWiujjSzFyCXh+JCiBEVdFDSqUkCfR4ZF3qMsprSCGRriMZXkch62ow0HxxW5AuCYfs0H0II6hOO826HdeNqvCUWrlBQgDlqUGSd0CHEIOEG0OTip3uz5SaG9ETzEkUP5ycGyerPtv9nNlKZF+nKqr6hETOp9P5mcpBZGLk7YAUPK1d1kjL/G6QuNmgRCsuUnTB/hdeMYOO34jCUprLc2MzuF0CfVBISkSfU3SXu6WZe0MBGiLIkvjWKlYxhG2q2qEonIeXs+TkoXPByVLo5IYsqF8PvNm4aYEGXhui4zUCGbESWVfhv/a5sPiK4aYazaDt5QicHyJvHN8pZK8ixvq6TA0lRJkeUdlZRY3lVJH8t7KulneV8lAyxtJXv8YykkpiU00PgH3xYH1Qlj7cj478zonDBOHRn/kxlBCRyzL8VJoL5mUBnnSXwW4QOq6wHhYykJH8uHhI9lnfCxnCJ8LP9E+FhOEz6WfyZ8LGcIH8uGgqV0YB8pSnszBM0laG4pSWzwzM4qfGTjI7qPjxVAEy7ppozmJD/Yr/QwGf2TXouT0ZLHE4ePZ5KiUfX82SBF+TSj50qfZwqep5U/V6Lr453PiYZNtVysF7Uvgv82VuRc8syoMtYXxAc0L6kfhY7mHHypGjeWHJy7zhUN3SL3eWqRqNWhAU0Ukm/LqzhuyqaMwD8gPtCQbmfOMKoVYnhBUVl4g9wKdXqnbsmwcHFI24dxQwIsxXTm4mk3aGTnYUm6PW/AkJ8pa9v+5wIUwfxcmCreDlxXAg5qiGUaITdDLOmz1zUEoif7r1TQYVtiUUdtMhd0ZNI65Cfd2ZhIAnlPyU3qsaQMm4STRJolhIuSSM4iyRKSxGI9os9ZJzqRi6hzEXn67j5Jj3MFDi71uADSFqe6XMglomm5ZyLMqX1TNjkpd3GlZ0vBZEyj2PMbsCQtkzQ9JR161Aos1Wn36uRvl6yJF017t1uSR371RCW6166Qf+Cchdxr8ZqS0GAWN/GG9rfMncCHpaCRzBoV28H1U9Ydc+uU1b0w9qoIrXDBvirhhsJFO6baeMYI1KWu1NAGzlKEx5DT+ZzKmI9wWLoZdB5QCUvQkHPd8zdVMliouxTyW0a6+UdNMWOKCN2SpEfViXmxgm6dTZWIBbvHyl9ot2hbssuLnDtNwSuioJpd+47gG15u4Au65a8v0b+h44xKGV/S+q3CeRLvmEWP6IbNWEY9tt4rHmj8f891kRY7FARQ+NYTdAlMmRFWgLu7Nm6Nuzbuvpi2DVKnKmT233wn7gPKoagQQqdiWCFgJCpIAKMKAWM0XYpxGjBBAyZpwFRUDCG0qaZVYkpFRfFpMyoxzdIJmqMzzdOZFuhMi6yzQ7GkELDMOsGKQsAqTbdijQakacA6DdhgfaFdtakS0xbrM22rxLRDJ2iXzrRHZ9qnMx3oMa5PTuChjXLNyiNni/KYg26jVh2dRHmJm1PozZk1EjfnOnNDstQLRj5HBvocl9DzK11OHFxDD26gB7faNibLu2Pk+T30/AF6/qhzxsET9OAZevCibVOyvFdGnr9Bz9+h5x86Zxx8Qg++oAffUaHSvmxzJVWFf3/+duhPkz4GU601ubJ07m/1cOb3ZV37A0STAUQAeNo1ybENwjAQheF3iQEDKAUtLRIoU0TRdVQgCqdOBmAEGiQ3MIsPN44nYCvAWFz1vf9wCHidjBA9OkejhkZ/EczaJwh1gl8pWmSti590G8sGhOXX8zYie0QJsGzJHo1rrEl7YNmnHTRyAHcb2aUU9RWkGtuf/490vlJU1YHeN6fuUoD9ZJiC+QOZiyrSAAAAeNpjwAYmAGEqQyrT/v/vmUQZGGA0AF26B3cAAHjaYmBg4GQoYmBmYGThBLIXATGEzcigBORB2EwMHAxHIGwg6cNwBspmYdBhlICyWRmcGF2gbDYkcV6mIsY2KJuPwYT5B6BVslBxLoyB6MGhT3HRX9bd3d0FXeru/vZ7gNq6EtLMFyYzl6RsUaREW9c0SVLUCPhLlH/WScaNBUYQMWEGbBOnilwKvq5kpu0UrHGG7RwgZpTQh8oTTPeU5+0dyQmjKhuywsRUzDt/JL4W3/PAljiHelREJSfScjd1ysnftRaoYaUiJ45OjDJuXTQ/VhrpaX2FeyuvgltBf30mGDWXRDUj4UzdWsQ5Cp09NJDFvDnFvy9eYfgLd1CHZZoYvvKEqamfsbYY7explX+/eK+njtkOKzzIeeI8TEhmmprMgEsZVbNCg7j8oHfVgFPCTsc/dclRVUNyfFF9onIlSoiasiuo1mGogduTVe0418UxcUXs14mcdrPH1jOd5D5RPn6i4BVe/WeYT77sqW9AmIaZth8m4q+9gf2E0dGNXyC2t6iWtzJK4jGjqpo39F0Tj5pq9TY+xpnzx9+ZeQQfALh4AHjabMEFAYRAAACwvbd4dwMOt3QEhwJslsA4COYcsLC0cnVz9/D08vbx9fMXiSWCVCZXKFVqjVanXyx300rzMg0MHA0AXdgI8AABAAH//wAP) format("woff"),url(data:font/ttf;base64,AAEAAAAOAIAAAwBgT1MvMkaBcisAABu8AAAAYGNtYXAAiwEsAAAcHAAAAERjdnQgCp8A0wAAKxQAAAAsZnBnbWIu+3sAABxgAAAODGdhc3AAAAAQAAAwSAAAAAhnbHlmruPo/QAAAOwAABmWaGVhZGRRQ4kAABrkAAAANmhoZWEI0wOvAAAbmAAAACRobXR4WNkDbgAAGxwAAAB8bG9jYVhmXtIAABqkAAAAQG1heHAAyQ6WAAAahAAAACBuYW1lZR2ALQAAK0AAAASecG9zdDnKsz8AAC/gAAAAaHByZXBkQq2cAAAqbAAAAKcAAgAyAAAAyAIVAAMABwAAMxEzESczESMylmQyMgIV/esyAbEAAgAn/88D3QLvAEIAUAAItU5DHQACMisXIiY1NDY3NjcyFxYWMzI3Njc2NzczNTQ3NjY3MjYzMhcWFRQSFxYXFjMyNzY3MxYVFAcGBwYHIicmJicjJwYHBgcGATY7AjUmJzQmJzUHBo4oPxkRDQkPBQQnGAUCK2WSdwUdBAo+HQILAwwJAhUPEQwHCQQYLBkLEC0dRSIhOQ4JGAaRkQkLXTwmARgSG0taCwQBAQ9SMTstGj8RDAEWExwBC4G51AgMCgkVKQYBCQMcgP6/R08XDQwXAQgJGx0THw4BIxBkJAEMDngpGAEuCAVdhQgkBQ8akAABACj/7wLjAsEAYwAGsyALATIrATIVFAc+Ajc2NzYzFhcWFRQHBgcHFxYWFRQHBgcGBwYjIicmJyY1NDc2NzMWMzI1NCYjIgYjIjU0Njc2NzY3NjU0JiIHBgYHBgcGBwYHIjU0NzY3Njc3IgcGIyI1NDc2Njc2ATwXCwIEBwNrfRATKB46MyU4Cwk2RDIUHGmGCBZJMh0CARUsNQs/OIJqTwgqBxYlHA4hgCINL04bNGEcHDMTFyclHAwuGigXAwMWKRoXMAyJCRICvxIfRwEEBgNbDwIBDx49NTIlHwYEE005SD4aFlQOARsNBwMDDxUsAyRwREYGEg8mDgcLKxkKGyEkFSWycGxYHxAcAhIIFE1oqqsYDBUSHB4HRAMHAAABABT/7AJXAsAAOAAGsxQJATIrJTIVFAcGBwYHBiMiJjU0NzY3Njc2FzIXFhUUBwYGBwYGIyI1Njc2NzY1NCMiBwYHBhUUFxYzMjc2AikbEyk6YGIHEml2Aw9JjewEGh4PJAYFJAsSQhoWAQkaBwInYz5IEAJBL0A9MTG7EwsXLiU9CQGCbB4Ud2e/FQICBxIuExMTSg4XIRQHES8ZBg8kR1d6FBNrOSg1MgAAAgAUAAADdQKuAC8AQQAItTs2IQACMiszJjU0NzY2PwI2NzY1IgYGBwYHBgYjIjU0NzY2NzY3MjYzMhYzBBUUBwYHBgcGIwE0JSImIycVBgcGFTMyNzY3NmsPAwo4IAQJWQ0BJlMSBgQED0MfFwIOVTRZewFEGhlHAgEzLTdwqtkKWQIq/vwFEQIIGGEJBbp2TBkMBwsGBxUmCAIU4dwLCRMSFA0GFycSAwowURktCAEBEtlPUV5JbgwBAYevEgEBB+ngFAJLM1gtAAEAJf/wAnMCvwBTAAazHwgBMislMhUUBwYGBwYjIicmNTQ3Njc2NyYnJjU0NzY2NzYzNjMyFxYXFAcGBgcGIyI1NDY1NCcmIyIHBhUUFxYWMzIVFAcGBgcGBwYHBgcGFRQWMzI2NzYCIxsdNJBOCyItHXMEGnYEGwMFOjwtiUQGCAEYPxUpAwIJQCgGCxgLEBonORkYFRNOKhYECTEaDx5NLCEIAVY5KTUeL7sREB00TQsBBx9ZERBrVAMSAwIkO0A+L0EHAQEJECkNCCM4BwIOBR8EFAYHFRgnHBUUFxIGCBIjCQUCBDImLQQJLTAaHC8AAQAQ/+IDogKuAFAABrMyCgEyKwEiJyMHBgcGBgcGIyInJicmNzY2NzIeBBcWFzI3Njc2NzcjBgYjIiY1NDc2NzY3NjMWFxYWFRQHBgYHBicmNTQrAgcHBgchFhcUBwYGApkSBbkKMyQfazQFEBYONSIKAQRPIwUGBAUCBwEbIwUCHSlTJQSYDjEXCg0MESc6TgP6/BMNFgIIQh8SCQpgK1gBAxMmARUOAQkQRwEMEBdvOC9GBgECCyUKCRg2AgEBAwIHARsFBC1btLIQDhUKCAsSGhgiAwEBBAIQDAYEFi4FAwUEBQcEDE9rBgoSEBooAAABADL/jwKfAr8AVwAGs0QgATIrATQuAiMiBwYHBhUUFjMyNzY3NjY3MhUUBgcGBgcGBwYjIicmJyY1NDc2NjcyFxYXMjc2NzcGBiMiJjU0NzY2NzY3MzYzMhcWFRQHBgcGBiMiNTQ3Njc2Ag8QIhcVUjFIGwlVSSIdPhwLSSEbHAkgUDpFTQsnR0IVBwoSEzcYDBQ5PiEGISQFK20uXW4DD3liZnILCghWHRgIFCwVOxgXEh0HAQIyDhIGAiEwbiMgTGQRJV4dLgIRBWocbIYsMwwBCwMDBgkPExMcAgQJAwUhWQ4aIXVeGxJipDU5BgEZFCARFSwuFh0SDhMhFgMAAQAU/9ADsgKuAG0ABrMyCAEyKxMiNTQ3NjY3NjMyFhcUBwYHBxQzMzc2NzY2MzIVFAcGBgcGFRQzMzY2NzY2MzIVBgcGByInJjU0NjU2NzciBwYGByMHBgcGBwYHBiMiJzQ3Njc2NTQjIyY1NDY3NjcyNTY3Njc0NjU0IyIGBwYGKhYONaxsAhcpMQIFBxgHbW4DRRoNSBsYCytJDw8pCg8GBRFDGhYDOlB5IQ8rAQcaBwIIDhRTYAwgGw0FDBAuJxUDECEbFzk5DzskCRsaAgQOBwEsNjYbEEkBvxIJFk9mCAEkIhknSFwcAQvWKBUpEgQcaOpQUyooAQIHFyIUIzM6BAgXLgIMA19nGQMFAQElXkAgCxEMIRAGKVFRSAIBCQkTMQsCAQEMDUFMBAsCKxwpGysAAAH/5QAAAuoCrgBHAAazMA0BMisTIjU0NzY3Njc2NzIyNjIyMzMWFRQHBgYHByMGBwYHBgcHFzM3NjcyFRQHBgYHBgYHIicmNTQ3Njc2MzM2NzY3NyMiBwYGBwY4GAIHDyVITHwBFSQsOhyzDggNNh1GRREKFRssQglnZgksMxoCDWA5FivD4wQMFxskEkE4OismLQkrWFQJLh4SAfMRBAgWFDEeIQMBCggHDRQiBwEcHDZssVAKAQkpAxIDCCZFCwQBAQIEDBAVGwsHTr+QPQwKFSgJBwABADX/jgOpAq4ASQAGszwmATIrNxQGFRQWMzI3Njc2Njc2NzcjIgYHBgcGBwYGIyI1NDc2NzY3Njc2MzMWFRQHBgYHBgcGBwYHBgcGBwYHBiMiJyYnJjU0Njc2MzLIBFg9GBEyIAooAUBcCjM8OSE3FQYHEUIaFwUcR1VpMDcCg4IOCAwyGQ4LFgcjKCcqERI+eldPOCFNFQcKEC8zF38FFgQyOwYPQRSYBeVhCgcPGz8RChciEQUSUDhGHw4EAQoIBw0SIQgCAQEHH11drD8fazwqDh05FBobHA8tAAACACn/7wNCAr8AIgBiAAi1PykXCAIyKxMiNTQ3NjY3NjMyFxYWFRQHBgcGBwYGByI1NDc2NzY3NQcGATIVFAcGBiMiJyYnJicmJicmNTQ3Njc2NzY3MjYzMhcWFAYHIyY1NiYnBwYGBwYHFRQXFhcWFxYzMjc2NzY3NmIXMAmGCRMVCgUHAhYcQx4LC0YgGwZHLBsFGisCqhsDE5BcGgYOFh8mK0oLAgIIHEiPWDwCEgUlExw4HgsSAg8TDCRzKiUHEjBMGA8REyMaDgcLMgkCHhIcHgZDAwkDBAgSYmWItFIUFy0CEAgOq65nXw4NF/6FFQcJPFICBQ8VNj6lPQgVEwYaIVBQMgoBDRA4KQMKDwoGAgQMRiMfDwoeM41gHQoNDAYUIhIDAAEAKf/vAu8CwABGAAazEgABMisXIjU0NzY3Njc2NzY3Njc2Njc2FzIWFRQHBgYjIjU0NjU0JiMjIgcGBwYHBgcHMxYXFhcXNjYzMhUUBwYGBwYjIicmJyMHBj8WBAoeDgsUFw4PMEw0kEcEFSoxBglVJRYDGxoHDQwOE0EoGhcGHjh8TycNBlkmFgIQi0cJIzlUeC8QDSwREQcHEhYLFCRbNjGTWz9QBgICMCkZDRk2EAMTBBogDA0bYaZkLQwBFAwBARo6EAMIOVwMAQ0TAggbAAEAJv/PBUkCvwBiAAazXREBMis3NDYzMhcWFxY3Njc2NzY3NjYzMhYXFhcWMzI2NzY3Njc2NzIVFAcGAhUUFxYzMjc2NzIVFAcGBwYHBiMjIicmJyY1NDc2NQYHBgYHBgYHIicmJyYnJicnBwYHBgcGIyYmJyYmLBYFCBckDQobPEAVBAEIRSIOCQQ+SSMCA2cmisY6AgMIFQYPHAcEDAIaKRkbExQ4LRYWEwkTBiMHChYB6kYLQA4pDQkIBQYSMCAvLAUGJEZGQxMTHDUIBBQmUQcWBAEGFJafpBoEFy4JEPCmRlYif8E4AQICJBETQP7dSjYqHQwWARINFRQcFwYHAg4iMTt7qQQE3z4JNAwgCQECAxg+SW2OERaGnaAiCAEdEQgAAAH/6P/PBFEDSABWAAazTCQBMis3FjMyNzY3Njc2NzY2MzIeAxcWFxYXFhcWNzQ1Njc2NzY3NjMyFRQGBwYjBgcGBwYHBgcHJzQHFAcGBiMiJyYnJicmJycHBgcGBwYjIicmNTQ2NzYzLyIpDwoRITsSAQkPOx8HCAYCBAI6WygaGg4BATlHJyEtUCkoGCQSBg1FMQsCDCJANQwBAQEHRiMLBAYONio/VQQDIUE7RwsOIiEdGBIMC4siDBhos7oYDRUjAgYFDQSuyVctLhEBAgEB4dx7M0QfECUjRgkDBSkLBRxsz9EsAQECAQIZMAMDE0NQd9wKEKKrlhQDFRQdGz0SDAAAAQA//+8DcgK/AEkABrM7AQEyKwE2MzIVFAcGBwYHBgcUBhUUFxYzMjc2NjU1NCYjIgcGBwYHBgcGByI1NDc2NzY2NzYzMhcWFhQHBgYHBiMiJyYmJyY1NDc2Njc2AaAGChgDDTo/KzsJAVw6VBwaZ4tTThQNEBEZFQoMLTMZAQkfMZNNEhgeEEtUKiWIV3Z3HhJYeREGEBuYaSECvQIRBgcdHx47TmQEDgSCQysFFK51BVZwCgoXHi0TDCoDEwUDHixMZQ0DBBB7uFRLgiw8Ag5vVR4gNjZfqTQRAAIAFP+9A04CrgAwAEcACLU7MhsAAjIrFyI1NDcSEzYjIgYGBwYHBgYjIjU0NzY2NzY3NzIzMhYXFhUUBwYGBwYjIwcGBgcGBgEmIyMVFAYGBwYHNzY3Njc2NzY1NCcmqhcQeRcCASZSEgYEBA9DHxcCDlU0WXsoKB53dTU+CBrGdEQ0DAgRMwgRRAG5QHENAgEBDSoMICSANiQNAQIOQxIFJwEXASUSExIUDQYXJxIDCjBRGS0IAREgJ0EYG1yPGg8ZM30MFiYCbSAEAQgMBXKiBhICCC0fNwYRDwcqAAEAeP9uA4kCvwBhAAazOhcBMislMhUUBwYGBwYjIicmJjU0NzY3NjczMjYyFjMyFxYWFRQHBgcGBxYXFjMyNzY3NjY3MxYVFAcGBwYHBiMiJyYnJicmJyI1NDc2Njc2NzY3Njc2NTQmIyIHBgYHBhUUFhczMgI4GhceUEQwHRUQRlkZM4h5iQIBBQYPBCgYVGclLV1bfQNIZkIaBQMCCEkjDA8BFWowOwgiIwpKfFkvLCkhBAk2HQge/3lPCQF0Xj02NUwKAlFEBzXeEhAWHBgHBAINYUs1O3tXTgwBAQYUgF9RSllNSTQDFR0IAwgaMQIICgUDTjcaCgEBCCccCQoBEQYIEycIAgELd1FqBw1feBobaDwQDkRPBQAAAQAU/+8D1QKuAG0ABrMfAAEyKxciNTQ3EhM1IyIGIwYHBgcGBwYGIyI1NDc2Njc2NzI2MjMzMhYXFhcWFRQHBgcGBwcXFhcWFxYXFjMyNzYzMhUUBwYHBgYjIicmJyYnJicmJyYnIjU0NzY2NzY3Njc2NTQnJiMjFQYHBgcGBwYGuxwLeBMFARAFVBMJBgQED0MfFwIOVTRZewMlNxlGTl4jJBAIAg0qOGENBwwfFwQoIAgILCcuLBgCBhs6jj4VCSUbFSIpERAPCRAVAwk2HQYYfR8SNTl2FgECFU0jEQ9EEREGGQELARUKAQgTCRQNBhcnEgMKMFEZLQgBChISHREdFQs6MUMpBgoSPC4GSwsCHyYSAwYQFzA4Aw0lG0NQGBYJBwIRBwYUJwgCAQc3HyQvEhIEAxTAylwcFicAAQAZ//AC0QK/AFwABrNQJgEyKxMyFxQHBgcGBhUUFxYXFjMyNzY3NjU0JyYnJicmJyY1NTQ3NjY3NjMyFhYXFhUUBwYGByI1NDY1NCcmJyYjIgYHBhUUFxYXFhcWFxYVFAYHBiMiJyYnJjU0NzY3NssaAgoPGgcDAgclOVM6LSIOCxMga0YlJAsCBw5MOFheNEI4BwEHCkYhHAQNBRQxLhkxBhAPDxoWL3goHVxQZ4JBITcoJw4lVBcBIhAODBMQBAcNDgYYGCYRCx4YFB4ZKyUXHR0nCBMJDxYpTBwtCSMgBQoYExYuAhEEEgUXDQYFDQwIECIaFhMQDhAqMCYrPHAoNQwQIh0zGh1JGwgAAQAm/7sDswLQAEAABrMtEAEyKxMiNTQ3Njc2Nzc2IDc3Njc2MzIVBgcGByIGIiMHIyIGIiIjIwcGBwYHBgcGBgciNTY3NjcSNTY3IwYHBgcGBgcGPRcDFGY7Qw9ZAWNZCR4fBgoYAik7RQIEAwECBgUTGSAPYzEzAhgjCgcSQyIYAgkiFG8FDeUIBQEDCjceFAHOEQYJTT8jDgIBAQYTBgISGyMxCAEBAcPLCFBGFggXJQMTCBFIRAG2AQ0NDBAGCRMoCgYAAf/2/+gDAwKuAFQABrM5BwEyKxIiNTQ3Njc2MzIVFAcGBwYHBhUUFxYzMjc2Njc2Njc3NjYzMhUUBwYHBgcGBxQXNzY3MhUUBwYHBgciNTQ3NjcGBwYHBiInJjU0NzY3Njc2NTQjIgcoMjlNTgISPR0JIDcOCRoUGBAmTrw6BBkLCw9IGxchBxIuJQ8FBxgoGRsTFD1CI0IDBRpTBpN5DzQXPxQTLykPBxAPFAIoEhwiLQgBNydHGEh+NSIfNhoSFzTlcAk+GxsXJxEXSA81gZQ9PxALDBUBEg0VFB4hATgUFjViUwWCFQMMH1wuPTdtXC8VEhQKAAABABn/swMGAq4ANAAGsyoGATIrEyI1NDY3NjMWFxYXFhcXNzY3Njc2NSYmJyI1NDY3NjMzMhYVFAcGBwYHBiMiNTY1NCcCJyYyGTwiCBVRM0YVCAEBEpVTKQ4DAzQiGBgSDAsIOUQJMf9nThIHEgQEFGYYAk0TFDAIAgU/VsE+XTIOcGozJQYHGyMDIx08EgtQPB4kx9ZWLgs2K1lSLAEIRhEAAAEAGf+xBLYCrgBeAAazQwIBMisTNDYzMhcWFxYVFAcVPgI3Njc2NTQmNTQ2NzMyFhcUFhYXFhcWFzc2NzY3NjUmJiciNTQ2NzczFhYVFAcGBwYHBgcGJyYnJicmIyIHAgcGBwYjIjU0NzY1ECcmIyImGU0oMSleEQQCAwcMBnZgKgdKJAwBCwEHCgRdIQQCD3Y2DgcDASMaFyMTBwwvMgILMU+oRAwNBwoEDjsnBgEOndUvCgcFFAERZRskCAwCXxg3HD7dNi4aLg4DCA4HjZpEAwESARc1AwcBAQ8WCtnmGgYSh2ccFQgKGCACJCFJCQMCSzoQEE1hnLZJBwYEBivKxYAZ/vnkMwcEJQ4GS6IBH0MSCgAAAQA4AAEDigKuAG8ABrM7BgEyKwEiNTQ2NzYzMjMXFhcWFxYWFRQ2Njc2NTQmNTQ3NjYzMhYVFAcGBwYHBxUWFhUWFjMyNzYzMhUGBwYHBiMiJyYnJiYnJiYnJyIHBgcGFRQXFhUUBwYHBiMjIiY1NDc2NzY3NjYnNCcmJyYnJiMjBwYBCRZAKyY7CAsMGBQdCwEOSVkRBjMBCE0lHSsVESJEmB4BEgYcIgkHIiEYAhgzSwslJAcnEwsICQIEAQEGTnUiBh8VFCEsBxMJGyUVEyBN0Q4GAQcGBgkSCxoJCSYCMBEYOg4NAQQSGj0DhAQBKjkQBwQQDQ0GAxgxIRoZHBgcOFcRBQKrASopBBYTFRgxCwECDCYUL1ETKAoLMEQeBwQUBAIQDxQhCwIjGBceGRpAdQcFAgRBSRUkEQsGFAABACT/XAMdAq4AUAAGszAFATIrEyI1NDc2MzIXFhcWFxYVFDMyNjc2NzY1NCYjIiY1NDY3NjMyFhcWFRQHBgcGBwYHBiMiJicmNTQ2MzIXFhcWMzI3Njc+Ajc1NCcCJyYnBwZJGBZOWhgUXTYtEwkBAiUNaS4LOCIKCx4VAwozQAkCDi2IcIpeNwwPNUgLBCcUDgULHR0hCAMaNAUcFwYBCUEzVQomAisSEBdKBRd0XZ9TIggmD251HwkdJhgOGzoKAT4vCRcmL5ufgmFCDgM+LhQHIj4XJxESAQYeBBIPBQUTEAEAgmUMBxoAAAEALgAAA1UCrgBrAAazUhoBMisBJiMjIgYHBgYHBgciNTQ3Njc2NzMyFjMyNzYzMhUUBwYHBxcyMjMWFxYVFAcGBiMiJyYnIwcGBwcXFhYXMzY3NjYzMhUUBwYGBwYjIiYjIgciByI1NDc2NzY3NyMnJjU0NzY2NzYzMzc2NzcCboBKFxkRBAo3IRESGAMRPWBxGR3AGSQVEAMWG1RlFgMECwUhCQ0CBzMeBwIHLRgFVY8dOhfTIygWBwpbHxcDFpBSDT8p7R02HAwMGQwNI5KDGS8vEQUIJhQHQkEZPjYRAj4FCRQbKgsHARAGCDcyTQsFBAIRDB9eXxYBAQYHDAIIFCMBBAEETXAXAQEDAiMdHDcQBQtOfQ8CBQQCEQsQDhpwbxYBBw0GChAbBAIYPDgTAAAAAQAAAB8AcAACAAAAAAACAAAAGACNAAAAGg4MAAAAAAAAABIAEgASABIAiwEbAXEB1gJPAsgDSAPjBE4EvQVRBboGTQbPBz0HrAg6CNkJYAnDCj8KkQscC7wMMgzLDMsAAQAAAAEAAPmsKMVfDzz1AA8D6AAAAAAAAAAAAAAAAAAAAAD/5f9cBUkDSAAAAAgAAgAAAAAAAAD6ADIAAAAAAU0AAAD6AAADmQAnAuwAKAJlABQDfAAUAl8AJQMuABACqgAyA9sAFAKC/+UDCwA1A2cAKQMUACkFYgAmA6n/6AOKAD8DKgAUA6sAeAPeABQCuAAZAoQAJgLL//YC4QAZBJEAGQMxADgC9wAkAzIALgD6AAAAAQAAA0j/XABaBWL/5f7RBUkAAQAAAAAAAAAAAAAAAAAAAB8AAgMXArwABQAAAooCvAAAAIwCigK8AAAB4AAxAQIAAAAACAAAAAAAAACAAADvEADs7QAAAAAAAAAAUGZFZABAACAAoAMg/zgAWgNIAKQgAACPXgMAAAAAAq4AAAAgAAEAAAACAAAAAwAAABQAAwABAAAAFAAEADAAAAAIAAgAAgAAACAAWgCg//8AAAAgAEEAoP///+P/w/9+AAEAAAAAAAAAALAALCCwAFVYRVkgIEu4AA5RS7AGU1pYsDQbsChZYGYgilVYsAIlYbkIAAgAY2MjYhshIbAAWbAAQyNEsgABAENgQi2wASywIGBmLbACLCMhIyEtsAMsIGSzAxQVAEJDsBNDIGBgQrECFENCsSUDQ7ACQ1R4ILAMI7ACQ0NhZLAEUHiyAgICQ2BCsCFlHCGwAkNDsg4VAUIcILACQyNCshMBE0NgQiOwAFBYZVmyFgECQ2BCLbAELLADK7AVQ1gjISMhsBZDQyOwAFBYZVkbIGQgsMBQsAQmWrIoAQ1DRWNFsAZFWCGwAyVZUltYISMhG4pYILBQUFghsEBZGyCwOFBYIbA4WVkgsQENQ0VjRWFksChQWCGxAQ1DRWNFILAwUFghsDBZGyCwwFBYIGYgiophILAKUFhgGyCwIFBYIbAKYBsgsDZQWCGwNmAbYFlZWRuwAiWwDENjsABSWLAAS7AKUFghsAxDG0uwHlBYIbAeS2G4EABjsAxDY7gFAGJZWWRhWbABK1lZI7AAUFhlWVkgZLAWQyNCWS2wBSwgRSCwBCVhZCCwB0NQWLAHI0KwCCNCGyEhWbABYC2wBiwjISMhsAMrIGSxB2JCILAII0KwBkVYG7EBDUNFY7EBDUOwAWBFY7AFKiEgsAhDIIogirABK7EwBSWwBCZRWGBQG2FSWVgjWSFZILBAU1iwASsbIbBAWSOwAFBYZVktsAcssAlDK7IAAgBDYEItsAgssAkjQiMgsAAjQmGwAmJmsAFjsAFgsAcqLbAJLCAgRSCwDkNjuAQAYiCwAFBYsEBgWWawAWNgRLABYC2wCiyyCQ4AQ0VCKiGyAAEAQ2BCLbALLLAAQyNEsgABAENgQi2wDCwgIEUgsAErI7AAQ7AEJWAgRYojYSBkILAgUFghsAAbsDBQWLAgG7BAWVkjsABQWGVZsAMlI2FERLABYC2wDSwgIEUgsAErI7AAQ7AEJWAgRYojYSBksCRQWLAAG7BAWSOwAFBYZVmwAyUjYUREsAFgLbAOLCCwACNCsw0MAANFUFghGyMhWSohLbAPLLECAkWwZGFELbAQLLABYCAgsA9DSrAAUFggsA8jQlmwEENKsABSWCCwECNCWS2wESwgsBBiZrABYyC4BABjiiNhsBFDYCCKYCCwESNCIy2wEixLVFixBGREWSSwDWUjeC2wEyxLUVhLU1ixBGREWRshWSSwE2UjeC2wFCyxABJDVVixEhJDsAFhQrARK1mwAEOwAiVCsQ8CJUKxEAIlQrABFiMgsAMlUFixAQBDYLAEJUKKiiCKI2GwECohI7ABYSCKI2GwECohG7EBAENgsAIlQrACJWGwECohWbAPQ0ewEENHYLACYiCwAFBYsEBgWWawAWMgsA5DY7gEAGIgsABQWLBAYFlmsAFjYLEAABMjRLABQ7AAPrIBAQFDYEItsBUsALEAAkVUWLASI0IgRbAOI0KwDSOwAWBCIGC3GBgBABEAEwBCQkKKYCCwFCNCsAFhsRQIK7CLKxsiWS2wFiyxABUrLbAXLLEBFSstsBgssQIVKy2wGSyxAxUrLbAaLLEEFSstsBsssQUVKy2wHCyxBhUrLbAdLLEHFSstsB4ssQgVKy2wHyyxCRUrLbArLCMgsBBiZrABY7AGYEtUWCMgLrABXRshIVktsCwsIyCwEGJmsAFjsBZgS1RYIyAusAFxGyEhWS2wLSwjILAQYmawAWOwJmBLVFgjIC6wAXIbISFZLbAgLACwDyuxAAJFVFiwEiNCIEWwDiNCsA0jsAFgQiBgsAFhtRgYAQARAEJCimCxFAgrsIsrGyJZLbAhLLEAICstsCIssQEgKy2wIyyxAiArLbAkLLEDICstsCUssQQgKy2wJiyxBSArLbAnLLEGICstsCgssQcgKy2wKSyxCCArLbAqLLEJICstsC4sIDywAWAtsC8sIGCwGGAgQyOwAWBDsAIlYbABYLAuKiEtsDAssC8rsC8qLbAxLCAgRyAgsA5DY7gEAGIgsABQWLBAYFlmsAFjYCNhOCMgilVYIEcgILAOQ2O4BABiILAAUFiwQGBZZrABY2AjYTgbIVktsDIsALEAAkVUWLEOBkVCsAEWsDEqsQUBFUVYMFkbIlktsDMsALAPK7EAAkVUWLEOBkVCsAEWsDEqsQUBFUVYMFkbIlktsDQsIDWwAWAtsDUsALEOBkVCsAFFY7gEAGIgsABQWLBAYFlmsAFjsAErsA5DY7gEAGIgsABQWLBAYFlmsAFjsAErsAAWtAAAAAAARD4jOLE0ARUqIS2wNiwgPCBHILAOQ2O4BABiILAAUFiwQGBZZrABY2CwAENhOC2wNywuFzwtsDgsIDwgRyCwDkNjuAQAYiCwAFBYsEBgWWawAWNgsABDYbABQ2M4LbA5LLECABYlIC4gR7AAI0KwAiVJiopHI0cjYSBYYhshWbABI0KyOAEBFRQqLbA6LLAAFrAXI0KwBCWwBCVHI0cjYbEMAEKwC0MrZYouIyAgPIo4LbA7LLAAFrAXI0KwBCWwBCUgLkcjRyNhILAGI0KxDABCsAtDKyCwYFBYILBAUVizBCAFIBuzBCYFGllCQiMgsApDIIojRyNHI2EjRmCwBkOwAmIgsABQWLBAYFlmsAFjYCCwASsgiophILAEQ2BkI7AFQ2FkUFiwBENhG7AFQ2BZsAMlsAJiILAAUFiwQGBZZrABY2EjICCwBCYjRmE4GyOwCkNGsAIlsApDRyNHI2FgILAGQ7ACYiCwAFBYsEBgWWawAWNgIyCwASsjsAZDYLABK7AFJWGwBSWwAmIgsABQWLBAYFlmsAFjsAQmYSCwBCVgZCOwAyVgZFBYIRsjIVkjICCwBCYjRmE4WS2wPCywABawFyNCICAgsAUmIC5HI0cjYSM8OC2wPSywABawFyNCILAKI0IgICBGI0ewASsjYTgtsD4ssAAWsBcjQrADJbACJUcjRyNhsABUWC4gPCMhG7ACJbACJUcjRyNhILAFJbAEJUcjRyNhsAYlsAUlSbACJWG5CAAIAGNjIyBYYhshWWO4BABiILAAUFiwQGBZZrABY2AjLiMgIDyKOCMhWS2wPyywABawFyNCILAKQyAuRyNHI2EgYLAgYGawAmIgsABQWLBAYFlmsAFjIyAgPIo4LbBALCMgLkawAiVGsBdDWFAbUllYIDxZLrEwARQrLbBBLCMgLkawAiVGsBdDWFIbUFlYIDxZLrEwARQrLbBCLCMgLkawAiVGsBdDWFAbUllYIDxZIyAuRrACJUawF0NYUhtQWVggPFkusTABFCstsEMssDorIyAuRrACJUawF0NYUBtSWVggPFkusTABFCstsEQssDsriiAgPLAGI0KKOCMgLkawAiVGsBdDWFAbUllYIDxZLrEwARQrsAZDLrAwKy2wRSywABawBCWwBCYgICBGI0dhsAwjQi5HI0cjYbALQysjIDwgLiM4sTABFCstsEYssQoEJUKwABawBCWwBCUgLkcjRyNhILAGI0KxDABCsAtDKyCwYFBYILBAUVizBCAFIBuzBCYFGllCQiMgR7AGQ7ACYiCwAFBYsEBgWWawAWNgILABKyCKimEgsARDYGQjsAVDYWRQWLAEQ2EbsAVDYFmwAyWwAmIgsABQWLBAYFlmsAFjYbACJUZhOCMgPCM4GyEgIEYjR7ABKyNhOCFZsTABFCstsEcssQA6Ky6xMAEUKy2wSCyxADsrISMgIDywBiNCIzixMAEUK7AGQy6wMCstsEkssAAVIEewACNCsgABARUUEy6wNiotsEossAAVIEewACNCsgABARUUEy6wNiotsEsssQABFBOwNyotsEwssDkqLbBNLLAAFkUjIC4gRoojYTixMAEUKy2wTiywCiNCsE0rLbBPLLIAAEYrLbBQLLIAAUYrLbBRLLIBAEYrLbBSLLIBAUYrLbBTLLIAAEcrLbBULLIAAUcrLbBVLLIBAEcrLbBWLLIBAUcrLbBXLLMAAABDKy2wWCyzAAEAQystsFksswEAAEMrLbBaLLMBAQBDKy2wWyyzAAABQystsFwsswABAUMrLbBdLLMBAAFDKy2wXiyzAQEBQystsF8ssgAARSstsGAssgABRSstsGEssgEARSstsGIssgEBRSstsGMssgAASCstsGQssgABSCstsGUssgEASCstsGYssgEBSCstsGcsswAAAEQrLbBoLLMAAQBEKy2waSyzAQAARCstsGosswEBAEQrLbBrLLMAAAFEKy2wbCyzAAEBRCstsG0sswEAAUQrLbBuLLMBAQFEKy2wbyyxADwrLrEwARQrLbBwLLEAPCuwQCstsHEssQA8K7BBKy2wciywABaxADwrsEIrLbBzLLEBPCuwQCstsHQssQE8K7BBKy2wdSywABaxATwrsEIrLbB2LLEAPSsusTABFCstsHcssQA9K7BAKy2weCyxAD0rsEErLbB5LLEAPSuwQistsHossQE9K7BAKy2weyyxAT0rsEErLbB8LLEBPSuwQistsH0ssQA+Ky6xMAEUKy2wfiyxAD4rsEArLbB/LLEAPiuwQSstsIAssQA+K7BCKy2wgSyxAT4rsEArLbCCLLEBPiuwQSstsIMssQE+K7BCKy2whCyxAD8rLrEwARQrLbCFLLEAPyuwQCstsIYssQA/K7BBKy2whyyxAD8rsEIrLbCILLEBPyuwQCstsIkssQE/K7BBKy2wiiyxAT8rsEIrLbCLLLILAANFUFiwBhuyBAIDRVgjIRshWVlCK7AIZbADJFB4sQUBFUVYMFktAEu4AMhSWLEBAY5ZsAG5CAAIAGNwsQAHQrIAAQAqsQAHQrMMBAEKKrEAB0KzEgIBCiqxAAhCugNAAAEACyqxAAlCugBAAAEACyq5AAMAAESxJAGIUViwQIhYuQADAGREsSgBiFFYuAgAiFi5AAMAAERZG7EnAYhRWLoIgAABBECIY1RYuQADAABEWVlZWVmzDgQBDiq4Af+FsASNsQIARLMFZAYAREQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAkACQAGUAZQK//+8CFQAAAr//7wIVAAAAAAAJAHIAAwABBAkAAACiAAAAAwABBAkAAQAiAKIAAwABBAkAAgAIAMQAAwABBAkAAwBMAMwAAwABBAkABAAsARgAAwABBAkABQBCAUQAAwABBAkABgAsARgAAwABBAkADQJyAYYAAwABBAkADgA0A/gAQwBvAHAAeQByAGkAZwBoAHQAIAAoAGMAKQAgADIAMAAwADkALQAyADAAMQAwACAARABlAHMAaQBnAG4AIABTAGMAaQBlAG4AYwBlACwAIABJAG4AYwAuAAoAQwBvAHAAeQByAGkAZwBoAHQAIAAoAGMAKQAgADIAMAAxADQALQAyADAAMQA4ACAASwBoAGEAbgAgAEEAYwBhAGQAZQBtAHkASwBhAFQAZQBYAF8AQwBhAGwAaQBnAHIAYQBwAGgAaQBjAEIAbwBsAGQARgBvAG4AdABGAG8AcgBnAGUAIAAyAC4AMAAgADoAIABLAGEAVABlAFgAXwBDAGEAbABpAGcAcgBhAHAAaABpAGMALQBCAG8AbABkAEsAYQBUAGUAWABfAEMAYQBsAGkAZwByAGEAcABoAGkAYwAtAEIAbwBsAGQAVgBlAHIAcwBpAG8AbgAgADEALgAxADsAIAB0AHQAZgBhAHUAdABvAGgAaQBuAHQAIAAoAHYAMQAuADgALgAzACkAQwBvAHAAeQByAGkAZwBoAHQAIAAoAGMAKQAgADIAMAAwADkALQAyADAAMQAwACwAIABEAGUAcwBpAGcAbgAgAFMAYwBpAGUAbgBjAGUALAAgAEkAbgBjAC4AIAAoADwAdwB3AHcALgBtAGEAdABoAGoAYQB4AC4AbwByAGcAPgApAAoAQwBvAHAAeQByAGkAZwBoAHQAIAAoAGMAKQAgADIAMAAxADQALQAyADAAMQA4ACAASwBoAGEAbgAgAEEAYwBhAGQAZQBtAHkAIAAoADwAdwB3AHcALgBrAGgAYQBuAGEAYwBhAGQAZQBtAHkALgBvAHIAZwA+ACkALAAKAHcAaQB0AGgAIABSAGUAcwBlAHIAdgBlAGQAIABGAG8AbgB0ACAATgBhAG0AZQAgAEsAYQBUAGUAWABfAEMAYQBsAGkAZwByAGEAcABoAGkAYwAuAAoACgBUAGgAaQBzACAARgBvAG4AdAAgAFMAbwBmAHQAdwBhAHIAZQAgAGkAcwAgAGwAaQBjAGUAbgBzAGUAZAAgAHUAbgBkAGUAcgAgAHQAaABlACAAUwBJAEwAIABPAHAAZQBuACAARgBvAG4AdAAgAEwAaQBjAGUAbgBzAGUALAAgAFYAZQByAHMAaQBvAG4AIAAxAC4AMQAuAAoAVABoAGkAcwAgAGwAaQBjAGUAbgBzAGUAIABhAHYAYQBpAGwAYQBiAGwAZQAgAHcAaQB0AGgAIABhACAARgBBAFEAIABhAHQAOgAKAGgAdAB0AHAAOgAvAC8AcwBjAHIAaQBwAHQAcwAuAHMAaQBsAC4AbwByAGcALwBPAEYATABoAHQAdABwADoALwAvAHMAYwByAGkAcAB0AHMALgBzAGkAbAAuAG8AcgBnAC8ATwBGAEwAAAACAAAAAAAA/4MAMgAAAAAAAAAAAAAAAAAAAAAAAAAAAB8AAAABAAIAAwAkACUAJgAnACgAKQAqACsALAAtAC4ALwAwADEAMgAzADQANQA2ADcAOAA5ADoAOwA8AD0BAgd1bmkwMEEwAAEAAf//AA8=) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Caligraphic;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Fraktur;font-style:normal;font-weight:700;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Fraktur;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Main;font-style:normal;font-weight:700;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Main;font-style:italic;font-weight:700;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Main;font-style:italic;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Main;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Math;font-style:italic;font-weight:700;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Math;font-style:italic;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_SansSerif;font-style:normal;font-weight:700;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,AAEAAAAOAIAAAwBgT1MvMkbfkbwAAEkoAAAAYGNtYXB7wyGGAABJiAAAAQxjdnQgAwsZ2AAAWVQAAABaZnBnbWIu/XwAAEqUAAAODGdhc3AAAAAQAABfsAAAAAhnbHlmOPPo9wAAAOwAAETcaGVhZGMnQtkAAEbgAAAANmhoZWEHTwOgAABJBAAAACRobXR4EqEcXAAARxgAAAHqbG9jYSh+OoEAAEXoAAAA+G1heHABLg6aAABFyAAAACBuYW1lY0t+hwAAWbAAAASOcG9zdN0D+vwAAF5AAAABb3ByZXBlwgKGAABYoAAAALIAAgAyAAAAyAIVAAMABwAAMxEzESczESMylmQyMgIV/esyAbEAAgBuAAABAAK2ABEAJQAItR0TBgACMisTFhcCBwYGIiYnJicmNTQ3NjMDNjIXFhcWFAcGBwYjJyYnJzQ3NvkFAgwFAw5ODgMDBwYFA0EwBFYEEwUCAgYSBSwrFQYBAgUCtgcG/jMHBQEBBQTpyRIUAwL92gICBRIGVAYTBAIBCBMrKwYTAAACACUBugGkArYAGAAxAAi1JRwMAwIyKxM2MzYzMxYXFQcGBwYjIicmNTQ3NzQjJyc3NjM2MzMWFxUHBgcGIyInJjU0Nzc0IycnJgMEAUFBAwQnJgMCHB8DAhITDw8G7QMEAUFBAwQnJgMCHB8DAhITDw8GAq8GAQQDgzc4AQIGAgMCLi0CAQaEBgEEA4M3OAECBgIDAi4tAgEGAAACAD3/PgNXArYAaABzAAi1cGoiAAIyKxciJjU0NzY2Nzc0IycmNTQ3NzM/AjUjJyY1NDc3Mzc2NzYzMhYVFAcGBgcHFDMzNzY3NjMyFhUUBwYGBwcUMzMXFhUUBwcjBwYHFTMXFhUUBwcjBwYHBiMiJjU0NzY2Nzc0IyMHBgcGATUjIgcGBhQzNzfhEhgiCBIFBE9PIRsGW1wUFXBwIRsG+iUlAwoaEhkiBxMEBUlJICoFDxQSGCIHEwUET1AFGyBcXBQUAeEFGyB9fSEqBQ8UEhgiCBIEBUlIISoFDwEySEkBASdJSBTCGhEHdhk+Dw8CAQseHQoDAUZIAwELHh0KA4GCBRcaEQd1GEEODwJykwcTGhEHdRhBDg8CAwodHA0BRkgBAwMKHRwNAXKTBxMaEQd2GT4PDwJykwcTAgIDAQOMAgFGAAMAMf/IAegC7gBGAFIAVwAKt1dTUEgwDAMyKxMmJjU0NzY3NjMzNTYzMhUVFxYXFhcUBwcGIyInJiciJiMnFRYXFhcWFRQHBxUUBwYjIiYnNSMmJyYnNDY3NjMyFxYXFjMzETQjIgcGFRQXFjMyEzY1NCfnS18zHikeDwMFIy8FRDwSAQkICAMGDC4wAgYCAiAOHxhFmhAaBQ8UEwIHW0MQARIBAwgFCjZEDAECAQcNERMOBAFXJiYBIA9zTmM1Hw0KCiYnCAEJJQsFBTAyCAolCQEBmQoGEBZDZL0dAwkeCAESFAoQLAsEBGcCBgkvEAIBnT4NESAeEw7+phQ3Lx0AAAUAPf/IA8YC7gAKABwAMABBAE8AD0AMSkM/NSYdFw8IAQUyKwEUIyI1NDcyNjMyBxUUFhYzMjc2NTQnJiMiBgYVEyImNTQ3NgA3NjMyFhUUBwYABwYlNDcyNjMyFxYVFAcGBwYjIhMmIgcGFRQXFjI3NjU0Aaaztp0CEAW14gQVFQkHIiIHCRUVBC8SGAYCAh8GDBIRGQoE/eIFCwFcnQESBEIsRiANGSxAtuIMQgcFBQdCDAUCJMnKuBAByhMgIh0EEF9eEAQeIiD9khkRCwkEAtAHDBcSDw0G/TMFCMm4EAEdLX9YLxYQHQEMMCERQEERITASMTAAAwAv/+oDAQLMAEYAWABlAAq3YVtPRykAAzIrATIWFRQHBgcHFBcWFxc2Nzc2MzIXFhYXFAcGBwYzFhcWMzI3NhcVBgcGIyInJicnBwYHIiYnJjU0NzY3PgI3JyY1NDY3NhciBhUUFxYVFjc2NzY1NCYnJgMmJwYVFBYXFjMyNzcBW0lqDh95EiMkLQlmLQYCCAEwJw4BDDBkCwEBHhMfOiwLDAYLOzQYEEhHBRBXXU9sEQY1DyQHEAkEBh9jSRAIHSgSBgEHLxYTFQ8GG0AlHhUQCAkjMwwCzGNKGSBATw0FLS4tCFiWEgYNCgUGCCGOZwwBCwUUBQlrBgMQAgonAggqA0c9ExpHMg8WBQoGAg1QTVVyCQJXNCc2NxABAwYhIR8gHC4IA/4OQzwWOx4vBQIOAwABAFABugDiArYAGAAGswwDATIrEzYzNjMzFhcVBwYHBiMiJyY1NDc3NCMnJ1EDBAFBQQMEJyYDAhwfAwISEw8PBgKvBgEEA4M3OAECBgIDAi4tAgEGAAEAT/8HAW4C7gAbAAazDgIBMisFFAcjJyYnJjQ3Njc2MzYzMxYVFAcGBwYVEBcWAW4HSQmcIggIIpwJAQEkIwcLXxYIfQvuBAcHhO4xkjHwggcBCQMFDnXDPWD+xZoOAAEAPf8GAVwC7gAbAAazDQEBMisTNjMzFxYXFhQHBg8CIiYnJjU0NzYRECcmNTRDAyQjCZwiCAginAkjHQsDAg17ew0C7AIIhO4xkjHuhAcBAgQEAgURmAE6ATibEQMHAAEAQwElAeIC7gBMAAazKAIBMisTNDYzMhYVFRQGFTY3NjY3MhYVFAciBgcXFhUUBiMmJicnFBYVFRQHBiMiJyY3NDY1BgcGBgciJjU0NzI2NycmNTQ2MxYWFxcnJiYnJtciFhgnGhQYJRELHCUYAXIBdBglHAsRJSwaJggNJxEGAhoUGCURCxwlGAFyAXQYJRwLESUsAQIHAw0CvhMdHBQFAXQBExYiDQEmHB8NJAElDR8cJgENIikBdAEGHw0CHg0JAXQBExYiDQEmHB8NJAElDR8cJgENIikHCB0NOgAAAQA9/4sDGgJpACIABrMZBwEyKzc0NyE1NDc2MzIXFhUVIRcWFRQHByMVFAcGIyInJjU1IycmPSEBJAIIHx4LAgEkBRsgkpICCx0eCgKSkiH6GhCQkQYeHgaRkAMKHRwNAZCRBh4eBpGQAQwAAQBQ/5YA4gCSABgABrMMAwEyKzc2MzYzMxYXFQcGBwYjIicmNTQ3NzQjJydRAwQBQUEDBCcmAwIcHwMCEhMPDwaLBgEEA4M3OAECBgIDAi4tAgEGAAABAAwAugExAREAEQAGsw0DATIrNzQ3NjMyFhcWFRQHBgYjIicmDBoEdF0eBxERBx1ddAUa5iIHAgEEDBobDAQBAgcAAAEAUAAAAOIAkgAQAAazBgABMis3FhcVDwIiJicmNTc2MzYz2wMEBANBNBEDAgEDBAFBkgQDhAMDAQEFA0FBBgEAAAEAPf8GAegC7gATAAazCQABMisXIiY1NDc2ADc2MzIWFRQHBgAHBmYSFwECAVcCChoSGQEF/qsEDPoaEQYDBgOTBBcaEQUDEPxxBBIAAAIAK//qAfoCywAZADUACLUpGwwAAjIrATIeAxUUBhUGBwYjIicmJzQmNTQ2NzY2FyYjIgcGBwYVFBYVFhYXFjMyNzY2NzQ2NTQnJgEIPlg1HQoBBCM3iYg3IwQBGCEXWHQUIykUCwQCAQIOFBMZGBMUDgIBAgUCyyU9ZGZIEDEFeURqakR5BTEQa4cyJCxyHC4XRyBmF0QIVkEUExMUQVYIRBdlIlUAAAEATAABAdkCzAAjAAazGwIBMislFAchJiY1NTY3MzU0IwYjIiYnNDc2NzY3Njc2MzIXFhERMxYB2Rv+uBAJBxNbAhw+FhICFwUWYzIPCQQHLAYCVBsrHwsHDhYSEQjy8gsSFiELAgEEMQ4BARkG/tX+1RAAAQAsAAAB7gLMADoABrMvEgEyKwE0JiMiBwYHBiMiJyYnJicmNzYzMhcWFhUUBwYHBgcGFTMyNjMyFxYXFhUUBwYHBiMnJicnNTY3Njc2AVM2KwoGQRkFCgUWCAQgAgQIP44wLkFOMBlBKgRvhBxCBh8GEwUCAgYSBb+9EwgBBJxEHBwB3ThEAQtWERwJBScEBw58EBp1S0Q9HzgkBGQEAQIFEgYeHwYTBAIBBhUdIAikSC8yAAABAC7/6gH3AswAOQAGsxoPATIrATQmIyIHBgcGIicmNTY3NjMyFhUUBxcWFRQGIyInJic0Njc2MzIXFhcyNjU0Ji8DNTYzNjYzNjYBPhkkFQY7IgsMGxoBC01wZm1iDHR+dGxUFgEPAQQFBA9GWDYnGCYvKgYEBAE6AR0lAhsoIAEMKg0mJQYFCk1aWmM9BSh7cXU4DwQDVQQHCjQDNT48OwgCAQZJBgEGB0AAAgAfAAACBgK2ADAANwAItTMxIgoCMislFAYjIxUUBwYHBiMiJyYnJjU1IyInJicmNTQ3Ejc2NzMyNjIyMzIXFhcWFhUVMzIWJzUnBgcHFwIGFSQaAgUTBCcoBBMFAnV1BRMFAgLaCwYKBAMMEBMKQwgGBwQBGiQV2AE8TA5LwiMTNjcGEgUCAgUSBjc2AgUSBiUmBQGmCwcCAQUDCQcwps8TE6egnJAaAQABACX/6gHuArYAOAAGsx8GATIrEyYnETY3NiAXFhcWFRQHBgcGIyMVFDM2NzYzMhcWFRQjIicmNTQ3NjMyFxYWMzI2NTQnJiMiBwYHbRYECBEEAToFEwUCAgUTBWRjAgYWBhlfNTr9YkMnIBYGCQYQQi46IgcLITUfCRABGggUAWQUBwECBRIFGxwFEgUCRUQEAwE1OnX0QSUOAzYiDyUuPU5UFh85EQcAAAIALv/qAfcCzQAmADkACLUxKAoAAjIrBSIuAjU0NzY3NhcyFxUGByInJiMiBgcVNzYzMhcWFhUUBwYHBgYDJiMiBwYGFRQXFjM2NzY1NCcmARdEXzIUBiDkBBU9GwcEBQkfIzlEBwciSk0uJBsPChghTycFFQwLGhoIDjogDhQEBhY3aHhPRin7EQICG1wGAQUSSmkLCTgtJllPSywiHSkjAaQBBQ1PMUIkQAEQF2hAMC0AAAEALv/1AfcCtwArAAazGQABMisXIyImNTQ3NjY3NjcjIgYjIicmJyY0NzY3NjMyFjMyFxYXFhUUBgcGAxQGI9YMKBsBB2ZZEgGKHkQHIAYTBQICBRMEMApiKsYFEgYCAwm/CBUlCxAhEQuI+WQUAQECBRIGPgYSBQIBAgQTBRsZDgrv/tEnEgADAC7/6gH3AssAHgAuAEAACrc2LykiFAIDMisTNDYzMhcWFRQHBgcGFxYXFhcWFRQjIjU0NzY2JyYmJTQmJyIHBgYVFBYzMjc2NQMyNjc0JyYmIyIHBhUeBD1nYy0LqUMSDQIFAgMsGSTk5WoGAwEuNQEbGicbDhQOGS41CgZGMRgCBwQlGzkKBwECCA8bAgZgZQEVsFgnCgQBAgEBER4uSuLifygCAgEPSEspHwIFBiUuOiogDjP+VS4/SBUTFikVSBsbIA0KAAIALv/qAfcCzAAtAEAACLU4LwkBAjIrEzYzMhMWFRQHBiMiJyYnJjc2NzYzMhcWMzI3Njc3IgcGIyInJiYnJjU0NjY1NgUmIyIHBhUUFxYXMjc2NTQnJiZzPGXIFwRvRF1EMA8SBgUjCwMEBQckLD0fFAYDAQQpRy0jIjQKCAEBCgEDERc5DAcNDSMVDDQBAgwClTf+/DY84lczHQsNBwhCCwMHIC0eRigHOhARSSwkSwkXDwRXCxEvHVJtFxkDBht4Fgw2LQAAAgBQAAAA4gHKAA0AHgAItRQOCQICMisTBgcjJyc0Njc2MzMWFwMWFxUPAiImJyY1NzYzNjPiAwSEBgEBBQNBQQMEBwMEBANBNBEDAgEDBAFBAT8CBAZBNRADAgQD/s8EA4QDAwEBBQNBQQYBAAACAFD/lgDiAcoADQAmAAi1GhEJAgIyKxMGByMnJzQ2NzYzMxYXAzYzNjMzFhcVBwYHBiMiJyY1NDc3NCMnJ+IDBIQGAQEFA0FBAwSRAwQBQUEDBCcmAwIcHwMCEhMPDwYBPwIEBkE1EAMCBAP+yAYBBAODNzgBAgYCAwIuLQIBBgAAAgA9AF4DGgGXAAwAGgAItRMNBAACMisTJjQ3NiEhHgIVFAcFJjU0Njc2ISEXFhUUB14hHgUBTQFNCwoLIP1kIRINBQFNAUwFGyABRAw8CQIGCBELHA3mDB0PFgMCAwodHA0AAAIAPQAAAckCwQAmADoACLUyKBwPAjIrATQmIyIHBiMiJyYmNTQ3NjMyFhUUBwYHBgcUBgYjIiYnNTY3Njc2AzYyFxYXFhQHBgcGIycmJyc0NzYBMhQhUS8NCAUEAiAbSVNnbjRREgIBBg4nKAwGAQcVSRJtBFYEEwUCAgYSBSwrFQYBAgUCLyQXNRIEAlgDCA4nR1NMKD5JCyUiCgECBigyGlNSE/6NAgIFEgZUBhMEAgEIEysrBhMAAAIAPf/1Ap8CwAAvAEMACLU8MQ0HAjIrJRYVFQcGBwYjIiY1ECUzMhcWFxYXFhUUBwYjIjU0NzYzMhcXJicmIyIRFBYzMjc3AyYjIgcGBwYUFxYXFjM3NjU0JyYCmAcIR2IdK7G4AUYXMgtpKxgMDwEZvtgmM4EgBgoTIggW4W16ST0OagoGGBgXBwEBCScNEiAyMgprCQQFCEITB7awAVAVAQ9CIzI5bjoMuOdgOE8BAhwMAv7yhYoaBQF/AhQYNApOCkYSCAgSd3IXBgAAAgAqAAACsgK2ACQAMgAItTAqCwECMisBNjIXFhcWEhUUBwYjIicmJyYnJyEUBgcGBwYHIiYnJjU0Ejc2EyYnJjUnBwYHBgcHMzIBIwSOBBcKA9USAzQ1BRYLBBAQ/vciAgoSBi0mDwYJ1AQLukkTBAICCB4HKAtiYgK0AgIFFAT9jQkUBQICBRMHMDECYwISBgIBAgUHDQoCcgQU/jnaTQ4GCAwoXhZ8IAADAFwAAQKfArYAGAAlADQACrcyJh0bBgADMis3JicRNjc2MxYXFhYVFAYHFxYVFAcGBwYjEyYnIxUzMjc2NjU0JgMzMj4DNzQmJyYnIxV3FAcGFAOXniJQYEw8DpkqLWAgrnAHSEQzRBktNTN3BSoqORwWAjY4B05LAQQXAn8SCAEBBQtYTD1LDQMghEwwNg4EAk4BAb0DBzQrJiT+HgIJEyQbNjkKAQHYAAEAPf/1AocCwAAuAAazBQABMisFIiY1ECUzMhYXFhcUDwIGIyInJicmIyIGFBYzMjY3PgI3NzYWFxYWFQYHBgYBp7S2AU4VQkszGgELDAMFAwUJMC4YKW1fYm48Qy0DBgQCAgQLAQEJARI4TAu1sQFTEgsRCQcHPUAEAwgqCwd68HsVIQIEAwECAgUEA2YEBQofEwACAFwAAQLcArYAFAAiAAi1GRcIAAIyKzcmJxE2NzMyNjIyMzIXBBEUBgcGIxMmJyMRMzY3Njc2NTQmdxQHBhQGBxccJRK9FAEejI4Qnn8IS0ZHUhx4EgRLAQQXAn8SCAECG/69nagPAQJOAQH+FAEGF4QoLnNyAAABAFwAAAJTArMAPQAGsxgQATIrJTI2MzIWMjMWFxYVFAcGBwYjJyYnETY3NiAXFhcWFRQHBgciBiIjIiYmIiMnIxUzMhcWFxYVFAcGBwYjIxUBFQX0EggLBQESBgICBhIF394TCAYUAwGsBRMFAgIGEgEFDAkGO01KGRoHhIUFEwUCAgUTBYWEegMBBhIGIB8GEwQCAQYVAnwSCAECBRIFHR4FEgYBAQEBowIFEgUZGAUSBQK1AAEAXAAAAjQCswAsAAazHxcBMisBJyMVMzIXFhcWFRQHBgcGIyMVFAcGBwYjJyYnETY3NiAXFhcWFRQHBgciBiICAP4FdXUFEwUCAgUTBXV1AgYSBTQzEwgGFAMBnAUTBQICBhIBBQwCPAOvAgUSBRkYBRIFAoKCBhMEAgEGFQJ8EggBAgUSBR0eBRIGAQABAD3/9QKTAsEAMQAGsy8CATIrNhA2MzIXFhcUBgYPAgYjIicmJiMiBhQWMzI3MjU1Iy8CNDc2NjMzFhcRBwYHBiMiPbm0cWAOAQMFAwwDBAUEECVHOW1iY20wGwIlJQYBAgMZV2wDBAMCBWt2s6kBZLQuCAUBECIRQAQDDyQgfO58CDQzAQYuLwMFAQQD/vACAwIxAAABAFwAAAK+ArYALgAGsxwDATIrEzY3NjMyFxYXFhUVITU0NzY3NjIXFhcWEAcGBwYiJyYnJjU1IRUUBwYHBiMnJidcBhQCNDIFEwUCAR8CBRMEZgQTBQICBRMEZgQTBQL+4QIGEgU0MxMIApsSCAECBRIGfHx8fAYSBQICBRIG/YgGEgUCAgUSBoqJiYoGEwQCAQYVAAABAFUAAAD2ArYAEgAGsw4DATIrEzY3NjMyFxYXFhAHBgcGIycmJ1UGFAI0MgUTBQICBhIFNDMTCAKbEggBAgUSBv2IBhMEAgEGFQAAAQAu/+oBqwK2ACEABrMMAQEyKwE2MzIXFhcWERAHBgYjIicmJzQ3Njc2FxYzMjY3NhEQNzYBJgQxMgQTBQIBCWRRYk0OAQoKAwsMIEMeKgQBAgUCtAICBRIG/vj+9QdGTSgGBQg2OwMLEjcXFAUBBwEFBhIAAAEAXAAAAr0CtgA3AAazGQIBMislFAcjIicmJwIiBwcVFAcGBwYjJyYnETY3NjMyFxYXFhUXNz4CNzY3NjMzFhUUBw4DBwcBFgK9Ejk4BggL1AIvMAIGEgUsKhMIBhQCKyoFEgYCAZEiTCgBCw8EPDoOAgE2TUscGwELAxcQBwICCQEmLy5cWwYTBAIBBhUCfxIIAQIFEAiGiY8iSScBCAMBDgkBBgI2S0obG/6MBQAAAQBcAAACFgK2ABsABrMRCQEyKyUyFhcVFAcGBwYjJyYnETY3NjMyFxYXFhERNzYB6hQPCQIFEwXBvxMIBhQCNDIFEwUCGYR3ChAeHwYTBQIBBhUCfxIIAQIFEgb+7v7vAQIAAAEAXAAAA3YCtgBEAAazIQMBMisTNjc2MzIXFhcWExYVFDI1NDc2NzY3NjMyFxYXFhAHBgcGIicmJyYREQcGAwYHBgcGIicmJyYnJicnIhUQBwYHBiMnJidcBhQDR0wNEQcJZEkCR18QCBANTUYFEwUCAgUTBE4EEwUCAhKGHQEIEA5ODhEHDFdGCgEBAgYSBSgnEwgCmxIIAQYHERD+9cIWAwMTwf4hEAgGAgUSBv2IBhIFAgIFEgYBBgEGC0j+qUwBEAgGBgcRFuu6MwL//voGEwQCAQYVAAEAXAAAAr4CtgAzAAazHQMBMisTNjc2MzIXFhcWEhcXMhEQNzY3NjIXFhcWEAcGBwYjIiYnJicuAicnIhEQBwYHBiMnJidcBhQDQFgGFg4J4QUIAgIFEwROBBMFAgIFEwVLPhgJDwgHd3ABCAICBhIFKCcTCAKbEggBAgMUDf4gDRQBAgEGBhIFAgIFEgb9iAYSBQICBAcMCf3zAhT+/f76BhMEAgEGFQAAAgA+/+oC2wLMABMAKgAItSAVDgQCMisTECUyNjMzMhYXFhUUBwYhIiYnJiUmIyIGBwYVFBcWFxYzMjY3Njc0NjU0PgEsAhgGBpOlDwQJMv7shKEaDwH6EZtDVAwKDxUsKTUpRhInBAEBVgFhFAGXix81Ry73cm04sL5LPytcYjRHHBsiHTltBSUMNAACAFwAAAKBArYAFwAlAAi1HRkTAwIyKxM2NzYzFhcWFRQHBgcjFRQHBgcGIycmJwEmKwIVMzI3NjY1NCZcBhQDlp0is7kZXlQCBhIFNDMTCAFdHzkrPDtWGiQeEwKbEggBAQUgurcdBAFvbwYTBAIBBhUCJRD2CAo1MTAwAAACAD7/lgLcAswAIwBLAAi1MCURBAIyKxMQJTI2MyARFAcGBwcXFhUUByMiJyYnNCYmJycHIgYjIiYnJiUmIyIHBhUUFxYWFxYzMyY1JjU0NzcyMjMzMjIeBBcXFjc2NTQ+ASwCGAYBUkwUHAdLAxJEQwUHCwgMBhcEBycIhKEaDwHsJX5hLB4FDEE9Dw8COQMRCQkdDSYHCQkDCAMMAxYGFBUBVgFhFAH+iKtbGRMFZgQGEAcCAQkBChQIJAECcm04/HFXPIJHJUhQCwNZAQQGDwcBAwEIBA8FHQIwOHVrAAIAXAAAAo4CtgAwADwACLU4Nh4FAjIrEzY3MzI2MjIzMhcWFxYVFAcGBwceAxcWFRQHBgYjJyYnJicnIxUUBwYHBiMnJicANCYnJicjFTM2NzZcBhQGBxUaIhGtFqQnDmgWEgQqQhsSBQMIBhEuOAoHA1BOXQIGEgUzMRMIAYskLwZMSEdMBy4CmxIIAQIQayUncy8IBgFLdS8gCgQHDAYFAQEDBwSRkIiJBhMEAgEGFQGgYCwHAQHKAQEHAAABADH/6gIlAswARAAGszESATIrJTI1NCcmJyYnJiYnJicmNTQ3NjMyFhcWFxQGBg8CBiMjJyYmIyIVFBcWFhcWFhUUBiMiJyYnJic0NjY/AjYyFxYXFgEwaAENKgo9MiwdVQsBOTx/OlIzEQEDBQMMAwQFBA4iRTVoPgR0BUdafHUoI1dNEwEDBQMMAwUICjxLI2ZWEQQpEgUOCw8SOl8FDmY0OxQZBwcBECIRQAQDDiQeSzMVARwCFnpIb3MGDSwLBQEQIhFABAMJORMJAAEAKAAAArQCsAAsAAazGAEBMisTNiEgFxYXFhUUBwYjIiYjIicjERAHBgcGIycmJwMRIwYjIgYjIicmJyY1NzZDAwEoAScFEwUCAggiAysVTB4cAgYSBTQzEwgBHB5MFSsDFQsIAgIBBgKvAQIFEgUdHgUZAQL+8v7xBhMEAgEGFQEQARACAQkGCwYeHhIAAAEAXP/qAqACtgAqAAazJQMBMisTNjc2MzIXFhcWFRYXFhYzMjc2NzQ3Njc2MzIXFhcWFRYVFQYHBiMiJyY1XAYUAjQyBRIGAgEBCDs+chIEAQIGEgUsMwgFBQYBAQEh/vYnBgKbEggBAgUQCOnxBDowWRfw6AgQBQIGAwYHExVNe+gK1LwdbAABABsAAQLBArYAIwAGsxwBATIrEzYzMhcWFxYXFhcXNhM2NzY3NjMyFxYVFAIHBgcjJicmAjU0LAQ1NgQXDANOVQoEAmFPAQwXBS4tAxLiAgsZlRoLAuICtAICBRYF2/ItDBcBGNsCFQUCAgUUB/2KAhMICBMCAnYHFAAAAQAYAAAD9gK2AEoABrMJAAEyKwEWFxQCAgcGBwYjIicmJyYnAicmFQYHBgcGBwYjIicmJyYCNTQ3NjMyFxYXFhcSFRQ3NhM2NzY3NjMyFxYXFhcSFxU2EzY3Njc2MwPiEwFLVwcLFAY9QwsMCAQyRwcBDUIwBgwVAzs6BhQLAqcUAzMiAxUMBDBNAwhLKAQLFAY7PwsMCQQzRwYXWRAFChcEJgK2ChAH/uT+vx4TBQIGBg4IwgENMwQBSPy+CxQFAQIFEwYCdQQUCAEBBRQIuP7WIgoTPwEglw0TBQIGBQ8Ixv70MAZzAVE/DRQFAQAAAQAlAAACtgK2AEUABrMtDAEyKzcTNCYmJyY1NDczMjYyMjMyMjMXFhcXNjc2NzY3NjMzFhUUBw4CFBIXFhUUByMnJiYnLgQnJwcGBgcGBwYHIyY1NCfsbG4CAg8EBQ4RFQoPIgsLDQeARSkKAwsHBkA/EgQDZ2P6AgERRkYOCE4PFxIMCAICCQkoEEoHBQuGDyABUQGPkwMGAg8HAQEEB7JkPA8DCQECCwsHBQaRiwL+sQQCBAwLAQUIdRYiGxEMAgIPDj0acwcEBAsLAwABABgAAALEArYAMgAGsyQBATIrEzYzFhcWFxYXFhUXNjU2NzY2NzY3NjcyFxYVFAcGDwIVBgcHIiYnJicmNTUnJicmNTQnAz8+BxcRC28lAQEBGhZqBgwbBzU2AxAECHt/AQkRMy0RCAcDAoGBAgICtQEBAgYTDKk8BQIBAgUrIp4GDwkCAQEEEwYGDbS7fn0UBgECCAcJBXt8vr0EAwcQAAABAD0AAAJoArYANAAGsycKATIrAQQjIyImNTc2NzYzMhcWFhcWFRQHBgYHByQzMjIzFxYXFhUUBwYHBiMiJyYmJyY1NDc+AgGb/v0VDhoPAQYUA+3sBQgPAgECAa1WVwETGAgNAwQUBgICBRMF9vcFCA8CAQICrqwCSAMZIhsSCAECAQ8IAxMgBgP0e3oEAQUTBh0eBRIFAgIBDwgDFCMGBPbyAAEAT/8GAT4C7gAdAAazFAEBMisTNjMyFxYVFAcGIyMRMzIXFhUUBwYjIicmJyYQNzZpBFleCRERCCYfHyYIEREJXlgFEwUCAgUC7AIFDBobDAX8xgUMGhsMBQIFEgYDqgYSAAABABj/BgEHAu4AHAAGsw0DATIrEzQ3NjIXFhcWEAcGBwYjIicmNTQ3NjMzESMiJyYYGgSyBRMFAgIFEwVZXQkREQgmHx8hBBoCwiMHAgIFEgb8VgYSBQIFDBobDAUDOgIHAAEAaQIZAbwCtgAYAAazDAQBMisBIgYjBiMnJjc2Njc2MzIXFhYXFgcHIicmARMBVgEBJCMKBQNoAgI2NQIBZQYGCiMkAVICY0kBAQoHBoIBAgEBfwgJCgEBRAAAAQAA/5ICJf/pABEABrMNAwEyKxU0NzYzMhYXFhUUBwYGIyInJhoE9MM4BxERBzfD9AUaQiIHAgEEDBsaDAQBAgcAAgAf//UB2AHbADAAPwAItT01JhMCMisBNCYjIgcGIwYnJjU0NjQ+Ajc2MzIXFhUUBwYHBiMiLgI1NQYGIyImNTQ2NzY3Mwc2PQIHBgcGFRQXFjMyAUEbJ1Q/CwMKAwkBAwIFAk9ivhMBAgUTBCwZFBcGGFUrPVA8LENpDgsLDW8TAiQGDTUBNS4nPgsCCFMKAwUCAwECASaGCZeWBhIFAgIIFBIRICxbQSs7DhYGoBQdFyECCTsICjASAwACADb/9gILArYAGwAoAAi1JR0NAAIyKwUiJwYHBiMnJicRNjc2MzIXFhcWFRc3NjMyFRQlFjMyNzY1NCcmIyIHAUE/NgcTBS8tEwgGFAItKwUSBgIBCT1TqP7BHyc9FRANEzwgLAorGgUCAQYVAn8SCAECBRAId3oGKO3xdR8pH1JRICcaAAEAJf/1AckB2wAuAAazLAQBMis3NDcyNjMyFxYXFxQHBgYHBicmJiMiDgMVFBYXFjMzMjc2NzYXFhYVBgcGIyIlzwIXB0kzKwUDCAcDBgUQHzMrGSMTCwMRHhETCktBDAEMAgEIARJLWuzo4BIBFBMFBgYqJgsDAg0bEw8XKSgePkIOCC8IAQIKA1gEBQgiAAIAJf/1AfsCtgAiADEACLUnIxMBAjIrJQYjIicmNTQ3NjMyFxc1NDc2NzYyFxYXFhAHBgcGIyInJjUnMjc1JiMiBwYHBhUVFBYBZD1GWS80Uis9RTkKAgYSBFgEEwUCAgUTBC0uBBpSLCYeKC8YDwUGIygzNzt8njgcJAd4dQgQBQICBRIG/YgGEgUCAgcbKCb1FxgQFxZEGkE+AAIAHv/2AeAB2gAhACsACLUqJB4CAjIrNzQ3MzIXFhUUBwYjIxUUFhcWMzI3Njc2FxYWFQYHBiMiJiUmJiMiBwYHFTMe1xErCKcaBYqKGRIcK1JHBgUMAgEHARBQWn2DAUMFJi4dGBoKsufkDwEXviYGAgMkQQ4UNQQDAgoDUwMFByV5tTItExY8BAAAAQAdAAABfQLBADgABrMwCwEyKxM2NjczNTQ3NjcyNjIWMzIXFhcVFAcGIyYnJiMiBwYHFTMyFxYVFAcGIyMVFAcGBwYjJyYnJzUjIh0CEBQLBh2MAQgGDwQqIwwFAgUIAwodKi0LAgEeIwoREQohHQIGEgUtLBMIAQkoAaEVEgIsOhluCQEBCQMFMTIDBgIIHR8GPj0FDBobDAWqqgYTBAIBBhWrrAAAAwAR/zICFgHVADsARgBYAAq3VUpBPCwBAzIrEzQzMhc3NjMWFxYXFhUGByInJicWFRQHBiMiJwYVFBcWMxYXFhYXFhUUBgcGIyInJjU0NjcnJjU0NycmFjI2NTQmIyIGFRQDFBYWMzI3NjU0JyYnJiciBwYj0Fg2DDQ7BwMEBgYCCQMKFz4cQDRfRjUCJgZbZghLTA0GbFMSMXRDSiMeBg0UBymmVhcZLyYWKyw3KFgeFgYMOAdXUgUYASypIAYaAQMEJCEGBwIDCgkmQFkrIxcMBCkNAgEBCC8wEhdBQwcCHiJKJzsMCxodIyEILBkrNjknLTM2/sweIQkZERoMDBoIAQECBwAAAQA1AAAB/AK2ADEABrMqDAEyKxM2MzIWFxYVFAcGBwYjIicmJyY1JicmJiMiBgcGFRQHBgcGIycmJxE2NzYzMhcWFxYVyD9iRkcFAQIFEwQuLQQSBgIBAQYXGSk0BAECBhIFLy0TCAYUAi0rBRMFAgGGTzc/CZ2aBhIFAgIFEAibnwUSDTQmBYF+BhMEAgEGFQJ/EggBAgUSBokAAgAuAAAA0AK3ABoALQAItSkeDgACMisTHgUUFhQVFAcGByMmJyY1NzY3MzI2MwM2NzYzMhcWFxYQBwYHBiMnJie1AgoCBwEDAgMEFG0UBAIBCw8ICBsNSwYUAi0rBRMFAgIGEgUtLBMIArcBBwEGAggFCwwIHQkMCgoMBSMiFQMB/vgSCAECBRIG/nQGEwQCAQYVAAL/uf8zAOgCtwATADcACLUuIAsBAjIrEzYyFxYXFhQHBgcGIicmJyY0NzYDFjMyNzY2NTQ3Njc2MzIXFhcXFhUUFRUGBwYjIicmNTQ2NzZgBGYEEwUCAgUTBGYEEwUCAgV2KhsnCwUBAgUTBCwxCAUFAQYBAROFST4OEgEDArUCAgUSBT4FEgUCAgUSBT4FEvz8FRQIOsf3BhIFAgYDBgIGRRQhgvUJhiAHBwNBAgUAAQA/AAAB8AK2ADcABrMhAwEyKxM2NzYzMhcWFxYVFzc3Njc2MzIXFhUUBwcUFhYXFhUUBwciIiMjIicmJycGBgcVFAcGBwYjJyYnPwYUAiUkBBIGAgE7QgwNBzk3BgoDnk9YCAIQCAkZCyEaDgJAPgYXBgIGEgUkIhMIApsSCAECBRAIp6s6PggDAgMFDQcEmwFreAsDBhEFAQsBV1QFFgY8OwYTBAIBBhUAAAEANgAAAMkCtgASAAazDgMBMisTNjc2MzIXFhcWEAcGBwYjJyYnNgYUAi0rBRMFAgIGEgUtLBMIApsSCAECBRIG/YgGEwQCAQYVAAABADUAAAMvAdUARwAGsxEGATIrEzYzMhcXNjMyFhcWFRQHBgcGIycmJycmJyYjIgcGBwYVFAcGBwYjJyYnJyYnJiMiBwYHBhUUBwYHBiMnJicRNjczMhcWFxYVxTtubRkDO2hIRgYBAgYSBS8tEwgBAQEJKzAcFQMBAgYSBS8tEwgBAQEJKzAcFQMBAgYSBS8tEwgFFiosBRIGAgGCUksIVDdAB56aBhMEAgEGFZ6fBR8iGh4FgX4GEwQCAQYVnp8FHyIaHgWBfgYTBAIBBhUBmRALAgQTBRkAAAEANQAAAfwB1AA0AAazGg0BMisTNjczMhcWFxYVFTY3NjMyFhcWFxYVFAcGBwYjIicmJyY1JicmJiMiBgcGFRQHBgcGIycmJzUFFiosBRIGAhgOMUIvNhUfBAECBRMELi0EEgYCAQEGFxkpNAQBAgYSBS8tEwgBtRALAgQTBRkXHQsqDBMdOQmdmgYSBQICBRAIm58FEg00JgWBfgYTBAIBBhUAAgAg//UCBgHaAAsAHwAItRoRBQACMisFIjU0NjczMhcWFRQnNC4DIyIHBhUUFhcWMzI3NjYBEvJqbxEtCcaXAgoVJRs/DwoMEBUsKxUQDAvsd3oIARjg7PQkJywVDjEeSzs3DxUVDzcAAAIANv8+AgsB1gAgAC0ACLUmIRgIAjIrBSInFRQHBgcGIycmJxE2NzMyFxYXNzY3NhcyFxYVFAcGAyIHFRcWMzI3NjU0JgFDRTICBhIFLy0TCAUWLC0FFQYJO0wEE0knKpgcPSUpBhwkMRoXJgssYmIGEwQCAQYVAlUQCwIGHgYmBAICODqDxx4FAYMY9QUaKCVNRU0AAAIAJf8+AfsB1QAmADQACLUsJxgEAjIrNzQ3MjYzMhcXNTQ3NjMyFxYXFhEQBwYHBiMiJyYnJjU1BwYjIicmEwYVFBcWMzI3NS4CIyWzAgsEQzEKEQgxKwUTBQICBRMELS4EEgYCCDZELilm61QUFC8uJg0PHRXs1xEBLwkMGwwFAgUSBv7T/tQGEgUCAgUQCGRnBywTMAE/DIdHJykr0BIQDQAAAQA2AAABZAHVACQABrMgEAEyKxM2NzMyFxYXFhUVNzY2NzI2MzIXFQYHBgYHBhUUBwYHBiMnJic2BRYpKwUSBgIHE0AmAQwDBgoJCjZMBQECBhIFLSwTCAG1EAsCBBMFHRwKHy0FAQdmBgEDOSkFbWsGEwQCAQYVAAABAB7/9gGMAdoAOAAGsyoNATIrNzI1NCcmJicmJjU0NzYzMhYXFhcUBwYGBwYnJiYjIgYVFBcWFxYWFRQHBiMiJyYnNDY3NjMyFxYW2kEmA1QFMUMmKVc7QSsIAggHAwYFDh83Kx4bIQdMN0pyFipcTxABEgEDCAYEIUFSLBwMARECD0s0QyYpDBQDBwYqJgsDAgsaFQ8WGwoEDQ5UN38WBSkIBQRnAgYGIyQAAQAU//YBdQJNADgABrMxDAEyKxMiJjU2NjMzNTc2NzYzMhcWFxYVFTMyFxYVFAcGIyMVFBcWFjM2NzYXFhcWFA4CBwYjIiYnJjU1QhoUAhIZEgEGFAIqKAUTBQIxOAgREQg4MQgFDA8mHgoECAkJAwMJA0xZMzAHBAFzFRkXEjQ0EggBAgUSBjIyBQwaGwwFaIAdEAwDGQcBAiUfBgUCBAIlODUfgHEAAQA0//UB/AHKADIABrMQBgEyKyEiJic1BwYjJiYnJjU3Njc2MzIXFhcWFRYXFjMyNzY/AjQ3Njc2MzIXFhcWEAcGBwYjAZgaFQEINmM/RgoEAQYUAi4tBRIGAgEECCoVBzQQAgECBhIELS4EEwUCAgUTBCwSGQ8JPAIqLxStnhIIAQIFEAilrwkMAg46CoyJCBAFAgIFEgb+dAYSBQIAAAEAGgAAAdkBygAsAAazIgQBMisTNDY3NjMyFxYXFxYXFz4CNzY3NjMzMhYXFhUUBgcHBgcGIyInJicnLgMaDAYEJScEFQwXFhYXCyogBQoXBSkQEA0GAj0fHwsXBD4/BBcLDQwkJRkBswcNAQICBRRHR0hII4ZoDBUFAgUKBgIJy2FiFQUCAgUVKClzdlcAAAEAGAAAAs8BygA7AAazCAABMisBFhcUAgcGBwYjIicmJyYnJic1BwYHBgcGBwYjIicmJyYCNTQ3NjMyFhcTNjY3NjMyFxYTNDY2NzY3NjMCuxMBagMKFQY9QgwNBwYYHAQBAx4YBAgXBikqBhUKA2oUAyAsIAhGCD4ECzIxDQRLJicCChgEJQHKChAG/ncGFAUCBgUPDGFqOQoNLnleBhUFAgIFFAYBiAUTCAEMG/72IusJGxsI/uwBjYoEFQUBAAEAGAAAAeEBygBAAAazDQABMisBFhUUBwYVFxYWFxYHBiMjIicmJicnBw4DBwYHBgcHIicmNTQ3PgInNCYmJyY1NDc2MzMyFx4CFzc2NzYzAbgRBJEoKFICCQ0KDSYvCAkPJSwCAgkKDQcmCAcKMTIDDwEBUU4BSksCAg4DMB8bDQILKRpJAQcKNwHKCwwFB7kBMTJmAw4NBgMDFDlEAwMNEBULPgsHAwEBAxIFAgRoZAEBWl4EAwYPBgELAQ82IGQDBAYAAAEAHf8zAdkBygA0AAazCgABMisBFhUUBgYHBgYHBiMiJyY1NDYXFjMyNzY3NycmNTQ3NjMWFxYXFhcWFRQVMjc2NzY3Njc2MwHGE01UARROMBAaSAUKDwceJicVCQsJXV0RAyoqBRULECslAQEENg0DChgEJgHKChIE7f4DM0cLBA9dBQkFBhUeDCMc1NcIDQkBAQIHERhxYScGAQw1qycGFAUBAAABAB8AAAG6AcoAJgAGsxwJATIrAQYjIicmNTQ3NiAXFhcWFRQHBgIVNjMyFhUUBwYjIicmNTQ3Njc2AQyjDRcGERsDAUwFBwcMBgHksg0bFBoFr64FGgUCD0oBeAIGCh0cCgECAQcKGRUHAv7aAQITGiQHAgIIJRUJAhNhAAABAFoAxgHJAVgAIgAGswQAATIrARYXFAYjIicmJyYjIgcGBwciJicmNzY2MzIXFhcWMzI3NjcBwgYBPzIODh8lHA4XBAEGIx0LAwQEBjstGBYXHBwOFwQBBgFYCAY2TgMIHBQqCgYBAgQIFC1DCAkWFCoJCAAAAgBbAlMBywK3ABUAKwAItScaDAECMisTNjMzFhcUFhUUBgcHIiYnJicmNDc2FzQ2NzYzMhcWFxYVFAcGBwYGIycmJnMFMjEWBAELEDEpEAcJBAICBswLDwQwLwYRBgIDBAgHESkwEAwCtQINDwEQBRcTBwECBQYJBDAEDywWFgYBAgUQCBMWBggHBQIBBRQAAgC5AhoBrwK2ABIAHQAItRsVDAECMisTNjMyFjMyFxYVFAcGIyInJjU0FjQmIyIGFRQWMzK8ElgDDQQyGyhRCCI0Hyi4HSAfHhwhIwJ8OgEOEyw+DwEOEy0LIzAODxcYDwABANYCGQHKArYAEwAGswkBATIrATYzMxYHBgYHBiMiJicmNjY3MjYBOgFEQwgCAZ0DASIcCwMEDFECAQMCtQENBAKIAQEBBQcSeAIDAAABAIv/QAE+/+gAEwAGsw8EATIrFzQ2NzYzMhcWFRQHBgcGByMnJyaLXQUDIiMDBh8HCg8GNDMEA7QGjwUCAgQHA0kRFyMEAQMEAAEANgAAAMkBygASAAazDgMBMisTNjc2MzIXFhcWEAcGBwYjJyYnNgYUAi0rBRMFAgIGEgUtLBMIAa8SCAECBRIG/nQGEwQCAQYVAAAB/7n/MwDoAcoAJQAGsw8BATIrEzYzMhcWFxcWFRQVFQYHBiMiJyY1NDc2NjcyFxYzMjc2NjU0NzZuBCwxCAUFAQYBAROFST4ODAkGBgUGHR8jCgUBAgUByAIGAwYCBkUUIYL1CYYgBwcDIRsLAQQSFAg7x/cGEgABAGkCGQG8ArYAGAAGswwEATIrASIGIwYjJyY3NjY3NjMyFxYWFxYHByInJgETAVYBASQjCgUDaAICNjUCAWUGBgojJAFSAmNJAQEKBwaCAQIBAX8ICQoBAUQAAAEAZwH0AbsCkQAfAAazDAQBMisBMjYzNjMzFgcGBgcGIyInJiYnJjczMjI2OgIWMjMzARIBVgEBJCMJBQZlAQI1NgICaAMHDQIDBwkKCgoJBwICAkdJAQ0HCH8BAQECggYLBgEBAAEATAIwAdkClAAQAAazBgABMisBFhcVDwIjJicmNTc2MzYzAdIDBAQDvm1XAgIBAwQBvwKUBANWAwMBAgQDKioGAQAAAQBQAigB1gK2ABsABrMFAAEyKwEyFRQHBiMiJyY1NDMyFxYVFhcWMzI3Njc0NzYBqytRJ0tNJVEnFg0JARATTEsTEAEJDAK2JUcXCwsXRScJCQUEAgQEAgQFCQkAAAEASAJUAOoCtwAaAAazDwABMisTHgcUFhUUBwYHIyYnJjU0NzY3NjPPAgcCBgIEAQIBAwYSbBMGAgIGEAU1ArcBBQIEAgUEBgcJBRIJEAYHDwYWFQUPBgIAAAIA8wIaAekCtgASAB0ACLUbFQwBAjIrEzYzMhYzMhcWFRQHBiMiJyY1NBY0JiMiBhUUFjMy9hJYAw0EMhsoUQgiNB8ouB0gHx4cISMCfDoBDhMsPg8BDhMtCyMwDg8XGA8AAQBaAiQByQK2ACIABrMEAAEyKwEWFxQGIyInJicmIyIHBgcHIiYnJjc2NjMyFxYXFjMyNzY3AcIGAT8yDg4fJRwOFwQBBiMdCwMEBAY7LRgWFxwcDhcEAQYCtggGNk4DCBwUKgoGAQIECBQuQggJFhQqCQgAAAIAbgIZAcgCtgATACcACLUkGhAGAjIrEzQ2NTY3NjMzFhUUBwYPAiInJjc0NjU2NzYzMxYVFAcGDwIiJyZuDgEGAURDBicpAgIjJAMFtw4BBgFEQwYnKQICIyQDBQIkDHwCBAMBCAQGQkUBAgECAwYMfAIEAwEIBAZCRQECAQIDAAABAFwAAAIWArMAHgAGsxoDATIrEzY3NiAXFhcWFRQHBgYjIiYjIicjERAHBgcGIycmJ1wGFAMBfgUTBQICBRIUAy4YUyomAgYSBTQzEwgCmBIIAQIFEgUdHgUOCwEC/vD+8AYTBAIBBhUAAgA8AAADWAK2ACEALgAItSciEAECMisBNjMyFhcWFxYAFxQHIyIiBioGJiIjIyY1NgA1NhcOAgcUMzI1JicmJwF9BUg6FgsPCwEBFgISDAspNkRIU05TSEQ2KQsMEgIBFw9bBk1bBbSzATpVGgK0AgIFBxEF/ZYNFQUBAQUVCwJvAhiFDrDMDAEBAYS9PwAAAwA+/+oDGQLMAAcAGAAvAAq3JRoPCAUBAzIrExAhIBEQISAlMjY1NCYnJiMiBwYHBhUUFgM2MhcWFxYVFAcGBwYjIicmJyY1NDc2PgFrAXD+k/6SAW5zX1BrCBBXNB8RF1wEBOwFEwUCAgUTBXV2BRMFAgIFAVQBeP6J/pVbhYOKkgsBLhwsOmyKigFfAgIFEgYqKwYSBQICBRIGKyoGEgAAAQApAAACdgK2ACwABrMQAQEyKwE3OgMWMxYXFhIVFAcGBiMiJyYnJicCJxUGBwYHBgYHBiMiJicmNTQSNzYBBwsMIh4iFgEZCgO5CQYRKzUDGAoELVEKBjRGCwIOBQswJA4GCbkDCgK1AQEFFQf9kwsOBwUCAQUVB5sBF1cJOrr9FgUOAgYCBQcOCwJtBxUAAwAuAAACrgKwAB4ANgBUAAq3SjcsIBAAAzIrASImIgYjIyInJicmNTc2NzYhIBcWFxYVFAcGByIiBgU2MzIXFhcWFRQHBgcGIyImJyYnJjU3NgMyFjMyNjMyFjIzFhcWFRQHBgcGISUmJyc0NzY3NgJzFdBAzxYNEAwJAQIBBhQDARwBGwUTBQICBhIBBQz+GQPW1QUTBQICBRMF1aoyBwUFBwEGFRbGIyDXFgkNBQESBgICBhIF/t3+3hUGAQIFEwgCKQICCQkIBiYmEggBAgUSBiQlBhIGAYIBAgUSBiMkBhIFAgEFAwYJLSUS/ugCAgEGEgYkJQYTBAIBCBMlJgYTBQIAAAEAXAAAAr4CswAgAAazDgMBMisTNjc2IBcWFxYREAcGBwYiJyYnJhERIREQBwYHBiMnJidcBhQDAiYFEwUCAgUTBGYEEwUC/uECBhIFNDMTCAKYEggBAgUSBv7F/sYGEgUCAgUSBgEUARP+7f7sBhMEAgEGFQABAD0AAALcArYAOAAGsyMPATIrJSQzMhYyMxYXFhUUBwYHBiElJjU0Nz4CNS4CJyY1NzY3NiAXFhcWFRQHBgciIgYjJRcWFRQGBwFCAUUZCxAGARIGAgIGEgX+zf7PGwMCd3QOflwCBwEGFAMCYgUTBQICBhIBBhEM/pC8CBRGfAMBBhIGICEGEwQCAQccCQYFjYkCEIlmAwkkHBIIAQIFEgUdHgUSBgEDzwkPCxtTAAEAPgAAAxkCywBAAAazLQcBMisTJiY1NDc2NzMyFxYXFhc2NzY3NjYzMhcWFRQGByMmJyYmIyIHBgcGFRQHBgcGIycmJycmNTQmJjUmJyYjIgcGB1gPCycxWQ4ZEEUjEgwCAxIoFS0kZTwnCw9hGgEBHhUZESMEAQIGEgU0MxMIAQEBAQk4AwozAwEaAggHDhM1JzQLAg9JIjMCD0sqFhM/JzUTDgcOFRMUESN1DsO5BhMEAgEGFcxwYQEGCQN4DQEnFQ4AAAMAPgAAAtwCtgA6AEgAUgAKt01MPDshAQMyKwE2MzIXFhcWFRUzMhYWMxYXFhUUBwYHIgYGIyMVFAcGBwYjJyYnJzUjJiYjJicmNTQ3NjcyNjczNTc2AhAjIgcGBhUUFxYXFhc3JicnETY2NzY0AVoCMS8FEwUCAwEEBwLSHAI6PXkCBwQBAwIGEgUxMBMIAQQCCgLSHAE5PXkCCgIEAQYHAQQSKSMTFi8IAf4NTAcsLgYBArUBAgUSBiYmAQEZsBAVX0FADgEBJiYGEwQCAQYVJygBARmxCBxiPkAOAQEoKBL+GAEsBxBCPT8jJQwCAcNUEwL+1A0vLglGAAEAPQAAAxoCtgBQAAazPhcBMisBMzIWFRQHBgcGBwYHBgcGByMVFAcGBwYjJyYnJzUnJicmJyYnJicmNTY2NzMyFxYXFhcWFxYXFjMyNTc2NzYzMhcWFxYVFzc2NzY3Njc2NzYCxBcjHBoIAwYBAQYcmwomBgIGEgUxMBMIAQ/FHAQBAQYDCBoBDA8xOgwjCgcBAQUOLBEHAQEGFAIxLwUSBgIBBjwPBQEBBwwvBAJyDx0hCQEOF0o/IqkqBAcnJwYTBAIBBhUoKQIjwx85SRcOAQojEw8HBhI4IFRLHE0fDufnEggBAgUQCOPnAxxeGUtUIEQLAQAAAQAxAAAC6ALMAFEABrMmDgEyKwEiBhUUFxYXFhcWFRQHBiMnJicnNDc2NzYzMhYzMyYnJicmNTQ3NiEyFxYWFRQHBgcGBzMyNjMyFxYXFhUUBwYHBiMnJicmNTQ3Njc2NzY1NCYBjFlUCQorJg0OGgV6eBMIAQIFEwYTBCgRUBQ0JQ45AyABLJBSNDofFTg3EVARKAQTBhMFAgIGEgV6eBEIAhYLHzQHAlMCdU1UJCMqXVQuMCshBgIBBhUfIAYTBQIBJkQwFVdQFBPVMB5qQz09KklJIQECBRIGHh8GEwQCAQYOBhI0PyBGbjYKIVVLAAABAAAA8AIlAUcAEQAGsw0DATIrETQ3NjMyFhcWFRQHBgYjIicmGgT0wzgHEREHN8P0BRoBHCIHAgEEDBsaDAQBAgcAAAEAAADwBEsBRwAOAAazCgMBMisRNDc2IBcWFRQHBiEgJyYaBAQOBRoaBf35/foFGgEcIgcCAgciIwcCAgcAAQBRAbsA4gK2ABYABrMGAAEyKxMnNTc2NzYzMhcWFRQHBxQzMxYXFQYHVwYmJwICHB8DAhITDw8DBAMEAbsGhDc3AQIGAgMCLi0CBAOEAgQAAAEAUAG6AOICtgAYAAazDAMBMisTNjM2MzMWFxUHBgcGIyInJjU0Nzc0IycnUQMEAUFBAwQnJgMCHB8DAhITDw8GAq8GAQQDgzc4AQIGAgMCLi0CAQYAAgCKAbsCCAK2ABYALQAItR0XBgACMisTJzU3Njc2MzIXFhUUBwcUMzMWFxUGBzMnNTc2NzYzMhcWFRQHBxQzMxYXFQYHkAYmJwICHB8DAhITDw8DBAMEaQYmJwICHB8DAhITDw8DBAMEAbsGhDc3AQIGAgMCLi0CBAOEAgQGhDc3AQIGAgMCLi0CBAOEAgQAAgAlAboBpAK2ABgAMQAItSUcDAMCMisTNjM2MzMWFxUHBgcGIyInJjU0Nzc0IycnNzYzNjMzFhcVBwYHBiMiJyY1NDc3NCMnJyYDBAFBQQMEJyYDAhwfAwISEw8PBu0DBAFBQQMEJyYDAhwfAwISEw8PBgKvBgEEA4M3OAECBgIDAi4tAgEGhAYBBAODNzgBAgYCAwIuLQIBBgAAAQAAAHsAdAAFAAAAAAACAAAAGACNAAAAIA4MAAAAAAAAABIAEgASABIAVQCjAUYBxwJDAt0DCAM4A2gD2AQOBDkEWwR8BKME9wUxBYwF4gY3BowG5gcqB44H8ggpCGoInAj5CWAJtQoKClQKkArrCzILfQvIC+4MKQyBDLMNHw10DboN+Q5pDsgPLw93D7sP+RBxENgRKRF7Ea0R3hIMEi0SixLOExYTZBOqE/4UghTQFRoVchXIFe4WWxatFuIXLRd/F7wYEhhmGLYY/hleGcEaFBpTGo4ajhrWGwcbLhtTG3kbtRvjHBYcOBxnHJQcxR0AHUEddh2+Hg8eVx7aHxUfbR/QIE4gyiFDIWUhhCGtIdgiICJuAAEAAAABAACoidghXw889QAPA+gAAAAAAAAAAAAAAAAAAAAA/7n/BgRLAu4AAAAIAAIAAAAAAAAA+gAyAAAAAAFNAAAA+gAAAW8AbgIuACUDlQA9AiYAMQQFAD0DPwAvATIAUAGsAE8BrAA9AiYAQwNYAD0BMgBQAW8ADAEyAFACJgA9AiYAKwImAEwCJgAsAiYALgImAB8CJgAlAiYALgImAC4CJgAuAiYALgEyAFABMgBQA1gAPQIHAD0C3QA9At0AKgLdAFwCvwA9AxoAXAKCAFwCYwBcAt0APQMaAFwBSwBVAgcALgL8AFwCRQBcA9IAXAMaAFwDGgA+Ar8AXAMaAD4CvwBcAmMAMQLdACgC/ABcAt0AGwQPABgC3QAlAt0AGAKgAD0BVwBPAVcAGAImAGkCJgAAAg0AHwIxADYB6QAlAjEAJQH/AB4BUAAdAiYAEQIxADUBAAAuAR7/uQITAD8BAAA2A2MANQIxADUCJgAgAjEANgIxACUBdAA2AaYAHgGUABQCMQA0AfQAGgLoABgB9AAYAfQAHQHcAB8CJgBaAPoAAAImAFsCaQC5AiYA1gHpAIsBAAA2AR7/uQImAGkCJgBnAiYATAImAFABMgBIAt0A8wImAFoCJgBuAkUAXAOVADwDWAA+AqAAKQLdAC4DGgBcAxoAPQNYAD4DGgA+A1gAPQMaADECJgAABEwAAAEyAFEBMgBQAi4AigAlAAAAAQAAAu7/BgBaBEz/uf/TBEsAAQAAAAAAAAAAAAAAAAAAAHoAAgG7ArwABQAAAooCvAAAAIwCigK8AAAB4AAxAQIAAAAACAAAAAAAAACAAADvEADs7QAAAAAAAAAAUGZFZABAACAgHQMg/zgAWgLuAPogAACPXgMAAAHKArYAAAAgAAEAAAACAAAAAwAAABQAAwABAAAAFAAEAPgAAAA6ACAABAAaADsAPQBbAF8AegB+AKAAqACwALQAuAExAjcCxwLJAtoC3QOUA5gDmwOeA6ADowOmA6kgFCAZIB3//wAAACAAPQA/AF0AYQB+AKAAqACwALQAuAExAjcCxgLJAtgC3AOTA5gDmwOeA6ADowOlA6ggEyAYIBz////j/+L/4f/g/9//3P+7/7T/rf+q/6f/L/4q/Zz9m/2N/Yz81/zU/NL80PzP/M38zPzL4GLgX+BdAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAsAAsILAAVVhFWSAgS7gADlFLsAZTWliwNBuwKFlgZiCKVViwAiVhuQgACABjYyNiGyEhsABZsABDI0SyAAEAQ2BCLbABLLAgYGYtsAIsIyEjIS2wAywgZLMDFBUAQkOwE0MgYGBCsQIUQ0KxJQNDsAJDVHggsAwjsAJDQ2FksARQeLICAgJDYEKwIWUcIbACQ0OyDhUBQhwgsAJDI0KyEwETQ2BCI7AAUFhlWbIWAQJDYEItsAQssAMrsBVDWCMhIyGwFkNDI7AAUFhlWRsgZCCwwFCwBCZasigBDUNFY0WwBkVYIbADJVlSW1ghIyEbilggsFBQWCGwQFkbILA4UFghsDhZWSCxAQ1DRWNFYWSwKFBYIbEBDUNFY0UgsDBQWCGwMFkbILDAUFggZiCKimEgsApQWGAbILAgUFghsApgGyCwNlBYIbA2YBtgWVlZG7ACJbAMQ2OwAFJYsABLsApQWCGwDEMbS7AeUFghsB5LYbgQAGOwDENjuAUAYllZZGFZsAErWVkjsABQWGVZWSBksBZDI0JZLbAFLCBFILAEJWFkILAHQ1BYsAcjQrAII0IbISFZsAFgLbAGLCMhIyGwAysgZLEHYkIgsAgjQrAGRVgbsQENQ0VjsQENQ7ACYEVjsAUqISCwCEMgiiCKsAErsTAFJbAEJlFYYFAbYVJZWCNZIVkgsEBTWLABKxshsEBZI7AAUFhlWS2wByywCUMrsgACAENgQi2wCCywCSNCIyCwACNCYbACYmawAWOwAWCwByotsAksICBFILAOQ2O4BABiILAAUFiwQGBZZrABY2BEsAFgLbAKLLIJDgBDRUIqIbIAAQBDYEItsAsssABDI0SyAAEAQ2BCLbAMLCAgRSCwASsjsABDsAQlYCBFiiNhIGQgsCBQWCGwABuwMFBYsCAbsEBZWSOwAFBYZVmwAyUjYUREsAFgLbANLCAgRSCwASsjsABDsAQlYCBFiiNhIGSwJFBYsAAbsEBZI7AAUFhlWbADJSNhRESwAWAtsA4sILAAI0KzDQwAA0VQWCEbIyFZKiEtsA8ssQICRbBkYUQtsBAssAFgICCwD0NKsABQWCCwDyNCWbAQQ0qwAFJYILAQI0JZLbARLCCwEGJmsAFjILgEAGOKI2GwEUNgIIpgILARI0IjLbASLEtUWLEEZERZJLANZSN4LbATLEtRWEtTWLEEZERZGyFZJLATZSN4LbAULLEAEkNVWLESEkOwAWFCsBErWbAAQ7ACJUKxDwIlQrEQAiVCsAEWIyCwAyVQWLEBAENgsAQlQoqKIIojYbAQKiEjsAFhIIojYbAQKiEbsQEAQ2CwAiVCsAIlYbAQKiFZsA9DR7AQQ0dgsAJiILAAUFiwQGBZZrABYyCwDkNjuAQAYiCwAFBYsEBgWWawAWNgsQAAEyNEsAFDsAA+sgEBAUNgQi2wFSwAsQACRVRYsBIjQiBFsA4jQrANI7ACYEIgYLcYGAEAEQATAEJCQopgILAUI0KwAWGxFAgrsIsrGyJZLbAWLLEAFSstsBcssQEVKy2wGCyxAhUrLbAZLLEDFSstsBossQQVKy2wGyyxBRUrLbAcLLEGFSstsB0ssQcVKy2wHiyxCBUrLbAfLLEJFSstsCssIyCwEGJmsAFjsAZgS1RYIyAusAFdGyEhWS2wLCwjILAQYmawAWOwFmBLVFgjIC6wAXEbISFZLbAtLCMgsBBiZrABY7AmYEtUWCMgLrABchshIVktsCAsALAPK7EAAkVUWLASI0IgRbAOI0KwDSOwAmBCIGCwAWG1GBgBABEAQkKKYLEUCCuwiysbIlktsCEssQAgKy2wIiyxASArLbAjLLECICstsCQssQMgKy2wJSyxBCArLbAmLLEFICstsCcssQYgKy2wKCyxByArLbApLLEIICstsCossQkgKy2wLiwgPLABYC2wLywgYLAYYCBDI7ABYEOwAiVhsAFgsC4qIS2wMCywLyuwLyotsDEsICBHICCwDkNjuAQAYiCwAFBYsEBgWWawAWNgI2E4IyCKVVggRyAgsA5DY7gEAGIgsABQWLBAYFlmsAFjYCNhOBshWS2wMiwAsQACRVRYsQ4GRUKwARawMSqxBQEVRVgwWRsiWS2wMywAsA8rsQACRVRYsQ4GRUKwARawMSqxBQEVRVgwWRsiWS2wNCwgNbABYC2wNSwAsQ4GRUKwAUVjuAQAYiCwAFBYsEBgWWawAWOwASuwDkNjuAQAYiCwAFBYsEBgWWawAWOwASuwABa0AAAAAABEPiM4sTQBFSohLbA2LCA8IEcgsA5DY7gEAGIgsABQWLBAYFlmsAFjYLAAQ2E4LbA3LC4XPC2wOCwgPCBHILAOQ2O4BABiILAAUFiwQGBZZrABY2CwAENhsAFDYzgtsDkssQIAFiUgLiBHsAAjQrACJUmKikcjRyNhIFhiGyFZsAEjQrI4AQEVFCotsDossAAWsBcjQrAEJbAEJUcjRyNhsQwAQrALQytlii4jICA8ijgtsDsssAAWsBcjQrAEJbAEJSAuRyNHI2EgsAYjQrEMAEKwC0MrILBgUFggsEBRWLMEIAUgG7MEJgUaWUJCIyCwCkMgiiNHI0cjYSNGYLAGQ7ACYiCwAFBYsEBgWWawAWNgILABKyCKimEgsARDYGQjsAVDYWRQWLAEQ2EbsAVDYFmwAyWwAmIgsABQWLBAYFlmsAFjYSMgILAEJiNGYTgbI7AKQ0awAiWwCkNHI0cjYWAgsAZDsAJiILAAUFiwQGBZZrABY2AjILABKyOwBkNgsAErsAUlYbAFJbACYiCwAFBYsEBgWWawAWOwBCZhILAEJWBkI7ADJWBkUFghGyMhWSMgILAEJiNGYThZLbA8LLAAFrAXI0IgICCwBSYgLkcjRyNhIzw4LbA9LLAAFrAXI0IgsAojQiAgIEYjR7ABKyNhOC2wPiywABawFyNCsAMlsAIlRyNHI2GwAFRYLiA8IyEbsAIlsAIlRyNHI2EgsAUlsAQlRyNHI2GwBiWwBSVJsAIlYbkIAAgAY2MjIFhiGyFZY7gEAGIgsABQWLBAYFlmsAFjYCMuIyAgPIo4IyFZLbA/LLAAFrAXI0IgsApDIC5HI0cjYSBgsCBgZrACYiCwAFBYsEBgWWawAWMjICA8ijgtsEAsIyAuRrACJUawF0NYUBtSWVggPFkusTABFCstsEEsIyAuRrACJUawF0NYUhtQWVggPFkusTABFCstsEIsIyAuRrACJUawF0NYUBtSWVggPFkjIC5GsAIlRrAXQ1hSG1BZWCA8WS6xMAEUKy2wQyywOisjIC5GsAIlRrAXQ1hQG1JZWCA8WS6xMAEUKy2wRCywOyuKICA8sAYjQoo4IyAuRrACJUawF0NYUBtSWVggPFkusTABFCuwBkMusDArLbBFLLAAFrAEJbAEJiAgIEYjR2GwDCNCLkcjRyNhsAtDKyMgPCAuIzixMAEUKy2wRiyxCgQlQrAAFrAEJbAEJSAuRyNHI2EgsAYjQrEMAEKwC0MrILBgUFggsEBRWLMEIAUgG7MEJgUaWUJCIyBHsAZDsAJiILAAUFiwQGBZZrABY2AgsAErIIqKYSCwBENgZCOwBUNhZFBYsARDYRuwBUNgWbADJbACYiCwAFBYsEBgWWawAWNhsAIlRmE4IyA8IzgbISAgRiNHsAErI2E4IVmxMAEUKy2wRyyxADorLrEwARQrLbBILLEAOyshIyAgPLAGI0IjOLEwARQrsAZDLrAwKy2wSSywABUgR7AAI0KyAAEBFRQTLrA2Ki2wSiywABUgR7AAI0KyAAEBFRQTLrA2Ki2wSyyxAAEUE7A3Ki2wTCywOSotsE0ssAAWRSMgLiBGiiNhOLEwARQrLbBOLLAKI0KwTSstsE8ssgAARistsFAssgABRistsFEssgEARistsFIssgEBRistsFMssgAARystsFQssgABRystsFUssgEARystsFYssgEBRystsFcsswAAAEMrLbBYLLMAAQBDKy2wWSyzAQAAQystsFosswEBAEMrLbBbLLMAAAFDKy2wXCyzAAEBQystsF0sswEAAUMrLbBeLLMBAQFDKy2wXyyyAABFKy2wYCyyAAFFKy2wYSyyAQBFKy2wYiyyAQFFKy2wYyyyAABIKy2wZCyyAAFIKy2wZSyyAQBIKy2wZiyyAQFIKy2wZyyzAAAARCstsGgsswABAEQrLbBpLLMBAABEKy2waiyzAQEARCstsGssswAAAUQrLbBsLLMAAQFEKy2wbSyzAQABRCstsG4sswEBAUQrLbBvLLEAPCsusTABFCstsHAssQA8K7BAKy2wcSyxADwrsEErLbByLLAAFrEAPCuwQistsHMssQE8K7BAKy2wdCyxATwrsEErLbB1LLAAFrEBPCuwQistsHYssQA9Ky6xMAEUKy2wdyyxAD0rsEArLbB4LLEAPSuwQSstsHkssQA9K7BCKy2weiyxAT0rsEArLbB7LLEBPSuwQSstsHwssQE9K7BCKy2wfSyxAD4rLrEwARQrLbB+LLEAPiuwQCstsH8ssQA+K7BBKy2wgCyxAD4rsEIrLbCBLLEBPiuwQCstsIIssQE+K7BBKy2wgyyxAT4rsEIrLbCELLEAPysusTABFCstsIUssQA/K7BAKy2whiyxAD8rsEErLbCHLLEAPyuwQistsIgssQE/K7BAKy2wiSyxAT8rsEErLbCKLLEBPyuwQistsIsssgsAA0VQWLAGG7IEAgNFWCMhGyFZWUIrsAhlsAMkUHixBQEVRVgwWS0AS7gAyFJYsQEBjlmwAbkIAAgAY3CxAAdCsygAAgAqsQAHQrUbCA8EAgoqsQAHQrUlBhUCAgoqsQAJQrsHAAQAAAIACyqxAAtCuwBAAEAAAgALKrkAAwAARLEkAYhRWLBAiFi5AAMAZESxKAGIUVi4CACIWLkAAwAARFkbsScBiFFYugiAAAEEQIhjVFi5AAMAAERZWVlZWbUdCBEEAg4quAH/hbAEjbECAESzBWQGAEREAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAYABgAGAAYArMAAAIVAAACzP/qAhUAAACXAJcAWgBaArYAAAK2AcoAAP8+AhUAAALB/+oCwQHa//b/MwIVAAAAAAAAAAkAcgADAAEECQAAAKIAAAADAAEECQABAB4AogADAAEECQACAAgAwAADAAEECQADAEgAyAADAAEECQAEACgBEAADAAEECQAFAEIBOAADAAEECQAGACgBEAADAAEECQANAm4BegADAAEECQAOADQD6ABDAG8AcAB5AHIAaQBnAGgAdAAgACgAYwApACAAMgAwADAAOQAtADIAMAAxADAAIABEAGUAcwBpAGcAbgAgAFMAYwBpAGUAbgBjAGUALAAgAEkAbgBjAC4ACgBDAG8AcAB5AHIAaQBnAGgAdAAgACgAYwApACAAMgAwADEANAAtADIAMAAxADgAIABLAGgAYQBuACAAQQBjAGEAZABlAG0AeQBLAGEAVABlAFgAXwBTAGEAbgBzAFMAZQByAGkAZgBCAG8AbABkAEYAbwBuAHQARgBvAHIAZwBlACAAMgAuADAAIAA6ACAASwBhAFQAZQBYAF8AUwBhAG4AcwBTAGUAcgBpAGYALQBCAG8AbABkAEsAYQBUAGUAWABfAFMAYQBuAHMAUwBlAHIAaQBmAC0AQgBvAGwAZABWAGUAcgBzAGkAbwBuACAAMQAuADEAOwAgAHQAdABmAGEAdQB0AG8AaABpAG4AdAAgACgAdgAxAC4AOAAuADMAKQBDAG8AcAB5AHIAaQBnAGgAdAAgACgAYwApACAAMgAwADAAOQAtADIAMAAxADAALAAgAEQAZQBzAGkAZwBuACAAUwBjAGkAZQBuAGMAZQAsACAASQBuAGMALgAgACgAPAB3AHcAdwAuAG0AYQB0AGgAagBhAHgALgBvAHIAZwA+ACkACgBDAG8AcAB5AHIAaQBnAGgAdAAgACgAYwApACAAMgAwADEANAAtADIAMAAxADgAIABLAGgAYQBuACAAQQBjAGEAZABlAG0AeQAgACgAPAB3AHcAdwAuAGsAaABhAG4AYQBjAGEAZABlAG0AeQAuAG8AcgBnAD4AKQAsAAoAdwBpAHQAaAAgAFIAZQBzAGUAcgB2AGUAZAAgAEYAbwBuAHQAIABOAGEAbQBlACAASwBhAFQAZQBYAF8AUwBhAG4AcwBTAGUAcgBpAGYALgAKAAoAVABoAGkAcwAgAEYAbwBuAHQAIABTAG8AZgB0AHcAYQByAGUAIABpAHMAIABsAGkAYwBlAG4AcwBlAGQAIAB1AG4AZABlAHIAIAB0AGgAZQAgAFMASQBMACAATwBwAGUAbgAgAEYAbwBuAHQAIABMAGkAYwBlAG4AcwBlACwAIABWAGUAcgBzAGkAbwBuACAAMQAuADEALgAKAFQAaABpAHMAIABsAGkAYwBlAG4AcwBlACAAYQB2AGEAaQBsAGEAYgBsAGUAIAB3AGkAdABoACAAYQAgAEYAQQBRACAAYQB0ADoACgBoAHQAdABwADoALwAvAHMAYwByAGkAcAB0AHMALgBzAGkAbAAuAG8AcgBnAC8ATwBGAEwAaAB0AHQAcAA6AC8ALwBzAGMAcgBpAHAAdABzAC4AcwBpAGwALgBvAHIAZwAvAE8ARgBMAAAAAgAAAAAAAP+DADIAAAAAAAAAAAAAAAAAAAAAAAAAAAB7AAAAAQACAAMABAAFAAYABwAIAAkACgALAAwADQAOAA8AEAARABIAEwAUABUAFgAXABgAGQAaABsAHAAdAB4AIAAiACMAJAAlACYAJwAoACkAKgArACwALQAuAC8AMAAxADIAMwA0ADUANgA3ADgAOQA6ADsAPAA9AD4AQABBAEIARABFAEYARwBIAEkASgBLAEwATQBOAE8AUABRAFIAUwBUAFUAVgBXAFgAWQBaAFsAXABdAGEBAgCOAIMAjQDeANcBAwDYAOEBBADbANwA3QDZAN8BBQEGAQcBCAEJAQoBCwEMAQ0BDgEPALIAswC2ALcAtAC1B3VuaTAwQTAHdW5pMDIzNwd1bmkwMkM5BUdhbW1hB3VuaTAzOTQFVGhldGEGTGFtYmRhAlhpAlBpBVNpZ21hB1Vwc2lsb24DUGhpA1BzaQd1bmkwM0E5AAABAAH//wAP) format("truetype")}@font-face{font-display:block;font-family:KaTeX_SansSerif;font-style:italic;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_SansSerif;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Script;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Size1;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Size2;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Size3;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Size4;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,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) format("woff"),url(data:font/ttf;base64,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) format("truetype")}@font-face{font-display:block;font-family:KaTeX_Typewriter;font-style:normal;font-weight:400;src:url(data:font/woff2;base64,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) format("woff2"),url(data:font/woff;base64,d09GRgABAAAAAD6cAA4AAAAAa6QAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAABPUy8yAAAzTAAAAFMAAABgRUuNwWNtYXAAADOgAAAAmgAAANyCRhu6Y3Z0IAAAO5AAAAA6AAAAWgJkF35mcGdtAAA0PAAABrwAAA4MYi79fGdhc3AAAD6UAAAACAAAAAgAAAAQZ2x5ZgAAAUQAAC/DAABRfFrBpzRoZWFkAAAyMAAAADYAAAA2YThCtmhoZWEAADMsAAAAHwAAACQFKAEZaG10eAAAMmgAAADCAAABDBReDwBsb2NhAAAxKAAAAQYAAAEGN/Ej4m1heHAAADEIAAAAIAAAACABNQ6ibmFtZQAAO8wAAAGiAAAEqGXfg0Bwb3N0AAA9cAAAASQAAAGkriEISnByZXAAADr4AAAAmAAAALJlwgKGeNrdfAWAHMeVdr/qrqpmhmHcnVmGweUVrmgFlgwRs+LEDPEf22HmYwodhnOxwzm+4EGY6ZiZw9bqr+qhleRjPlsadVfXdL/36r2vvnr1egQk1ARB+FUUCKJABaHu1J1q3SnXfvBCrYaCy39eg7ezPp8QBNiC7hRMISXI7/YtFaHauNto1cPQp5SQUqVa9cIw8Em5VGk2Wp8opqI8JsSZsglpJfKFVDJfRJlaAfK173/UlKn16Mafo1wyVcgn0wWBPeEh2A/fi+4SXGGYPSEXaPwJXqNVYzdlD6DsxtVKpVppX9/0UG4sT4koy74nyyKhb7/mHK36mXRgnDuepLJMk8fPmtec8+cPMQ3/FJ0X7hAeZs9/4K4bU+z57caK2K43W61mo1xlerVb9Xqrzf6vRZFPAr97Vq+FndNaxEWj5YDEF3OUC1ouByai3DDVRrtx9RlTYJg3xf35g4YQFXVYA2diIhmR6WlJUpEyoUhWo84P1cDwkZXOkESqXAJnfAIoIqKEIEGmp4CqYtzBrjcGx3MkgjxrcPjfjxCVijKI4osBgR6mKMoPr2HP06078OZDJCd9s9tNQhgRTKSkjBBsXSOsS/pW2HxIP454V/7BvGjhytvgM+g9wrrwBOGcoL731IkD+7dlxNo4dL2jXWXeEkRRGFuL0I6VStVqk12oVBr1eIDDKIrPY7NzM8fm598J+CdplLkLBH4U1qNGpcqt327BZzKpMGNKziwB9dh42JrYKipykKOguV57pR7mrKguasnMTOsm0UCFvKhkPFkRHyrKfweJaZm2QvWnZqpA/UX4cDqXjXyHFjV08oQY7KlM7KqPGpAuqXKYySAkezffmw/toE3h0wgb0YHJIy2gYOJsmrggq8W0dyJ1xxulkmvYkyn9I8WaceaMlhOwUL7y08zX3sN8vSA0hDXhJsHaot+wd9v8WDETmhjHjt+udbT1u47erpQrHX3bzB3F2JAtIXY+bj+BEhYa/HTzdxrVSrlECTcSs065OgSamA6Gh3OynguGT0mAkGmxv7YZAECIVN9iBxt/Jipvrg6JciYYGSpQPeOPPNEEIBQhSgEMNDO9XwEUVndN71bFaOR+GYleaVLln7nLpwMTIwl9EHv8AF9eIe7zZ/cqEFT2Tu3WkV/ZO2JCShlRUuAIzF8yV74Gf8awZa9wTLiV+cvFkzcfmEMiN0KsTddJwog7AdOI6dVkmvJLcXTxi1w/ZhVuC656tRpHGO/IvxMboloql2L78YgVK9US6VmzfWap7YbZUiko2/osjXKiCiAh2ZxrEdclyZRdS1N5qKTpQ76FW3bwJEOrL1WXTDVQhjJi9H1JUUQZA+nKlAypShJFopFSvUIGPrHzuGrurTVnC2VnaI/ROkRzAAQ7nk5FOkfF8RfN6spoxs67/oG03NC15sxEMTtTdcsZfdehBQMmldRUQ5kZkjYenZ9NSuHossVgoCyA8Ajk4STDq5RA3qkjYGjctxa3QC9smiVmiI8XUrqVLizPWqqaDQpjIlAUIadWwNrK+OqlrAIZjTnptnET2J1fz+L33cw7C+zONrA7Y79c6kViF+/iIekaMArh3RVLMpJHTh6rzKQ1yaogyXlphLLjF6xmFmF/5Zduf9WDs0M+RlmJqNqpX/CTR3bfu0UV2NNuYU+7xJ6WY09zJGCjzp/DNemNPB/JRvzcJnPnOwylaola5siJ9dndnh24ivGcDBkfQw/LmppDUsAe9op7ds/qbqjJx3+yMH7+6E38OTuEY/CrSBbuZM9pC9xeHLSp7xM/4NjR4nr1ZpYoh+qdyaw6hcol1sEP/YD5Vg+3G61Gk80Jpc4s1LU178sO2W3492usQ6PSaFaara8VIgQAaGJWUomdsKSzMKsnLbAiW5H12bLIL0aWHV7VSzwjXt8LyZ6ZzcqOoYkiJJm+kRtoqAkpYiq670YSyYYgiprhyNms5fnXdg5VaKLH7WxyK1WEG+CPkSfkmZVcPvbDHWDmDhDPfs0YYYJ+8MGo6wQGHDpEoogcOgRG4LjsJJFgJ7elUocPI9qg6PDhVOqnkFyTEXvGW688Bc4KLxOS7BkGZs8ocgN2jE+6cdvxszYoxepwbrSx1lSIlkHIBKPoY3O4mK8uTm455oppzVEBawmc5dLPgwWfg5sEyu5MOjHRLjI5i/NZOJPLbfwYJBqKWov97v0CwDqTQmN9Zd633ROBCfD+SrowVs0XhtdyI5VCvjLMv7HAUJvPax77hsI9KHocDD5l+wjBXqqGZoBg4z2ydiQwJRmjd5hBYIoyvnzACjjfGLvydfg9dIfgM5vL704HOnC+w43bA30ec9wwESFBF8BZBLC28ltGJ1NkfuLEXYfJGGlPnVh7UXv70NiCgue3rtZNA92QAW361E88+A4b4oOzP6xoLzh0Yc9h0H/k6P7nmXwUzjP9P8D4VpVpkzJ53DG7N+MZJLZ9yORwuoSm2B17NuVS8mLXJKZvSisVzZBcSZVbTeKGG5+NXNJsgSiNwhtVwwxshKyDgYQQws7lb4g0k9IUhnjv/2UkxmPVEAC+xFB/kT1/iHae33k8Z1PdOIxZEWvtzwLFAR3gtmCITrmxnpTI7qwPVcX1+wJ1yGvOPXzxkjujUISIufFiQ0HSJ6Ol0Dm2vZ1DWhp+KJds7XON9dVscbmVa0ydwaC5rkLNwhA2CDZdG5Ofdlvj+fL8zinsuIkMk3eCzVK/zeS9gcmbVbryxqDBp+n+HNU97M0+Xc/gg9cdu1J1swa8IcZRrsXTo6x00yqRUeKBGR/p89oYmdUBGQ/e+IT7FZQNg4IydNOxIWXHNB4tY0/BZrHpLziZlXYWmKp5+MVCqjEnA+B9hYLubp+QE3hkjrgJecfx7XM6iRifUf2hXV5iegkDollfISKS1ByzTdEFAHCVIMd8MysA/DW6W5gV2sw3mQoC58Id08eOUI5ds91yY9ev17uu0iG7PRemVYdD6Z8z+xOFVEae+1wbI6C/LRk6CtURi06M8el1bGKkwq6L4Q8Vn1s8B7H5FSyeAGLgZEqDs1gDam28SpRbsnhCxGycMsrfQ6vxiTpwP2Jx9CU2D66zcVnM8Diu9SzNDMvM3WMB9QXUqtW6pJxR9Fp7wC5IjG+9MPaZ+F+bu3l2WLfXR6juuliTAIiFJTvI5IacVwFFGIkA4TOeDur4QrXUXAP1aSdeMK3nwiAvIxuXt26fn96qiLMqRlSVXvsaycQAGEkiwbLEtHorDiz/4jaT7Lt0KjuTy4SuJiFbCpj1J7ueVhd2MesvNcZjZOiDE1en6/s8QmjQ0aMHG13mFwNHiVAGHDE36rpf5T1bdy+uZxK6NESyiuVPrbsKaFv2u3Z7pK6jTH6ynco79PzpvT9YPygmMrMKc/Oo7ITBMNo+vtBKZMCoYItIBGsHWkNYkkeROlLf5oZTK/lJk4D5huecevln5qfGploGcqPhZr4aBjaPHzZOv4PuE8bZOEUd9OzSiTK3eX+guDLFgS58gg7Ix8ZI6v4R+Y8UOelLGkaIlpkN9zsiwnbBezUBqtYmJn/51TVZcxUZYR1PTEqBrctUs1SrkPi5vyW6DAXONieZHL+N7mByNIUdjG0ut+pTyavZJumGci+WS5VezMbLTfYx3KiUGDaFtZZYi6OYjUYM0gsPHBiSd59ZnUAiG+rpVQWQ8cAbHzAQqNvriJNKfXQKdqyd273+hPWnzu/H2tr0/AGlDB/bcha0Y4sT2y0AhJC7dYS4kbzj2LEdcsRiZJvHwxNRb7U41KhVRmq1jR/bNqU7wzM7pkJvF/Oaqa7XTAjbmNfMTyUN5jUQ4xAXf7A0oF0fuRae2iJ3qViLnsvw5QO8aOHc+FympkMiu/XC4bn9yDk4PZcpHqpmslEiQ7ThWmmPWyuOVFL7FGXUC9Jj2y0ZkA7ibDJd206Ts8vZ3QsH3hOEz1iftBnbHY+yuVC1tEzzToCiWTmYD/xRWanmzMBStvC5MZ6b4RE2N0c822DK3VxAf352Hm+u7v0LT+pM2pWNx/qzNxIeYazjhvieZXbPyL7unt7AHtw6Pco5uH+7PZytVuerac00VbPoUGnwpPdqC/nq0vSBdtW0Uip1iqYIMSMR2vA5NBlzHQtxPtUJ4aGYTg31mQPGIXwuNIhMNt4iaZoER7Asm6GONr4EY/oxyxfFL0paThO/KEq+Zero539R51pVhA/CH8OPC7LgM61MhcRadVlPJeqmLPgjKll4QS61cV8qm01IH/lwKgfPSDEupCg/oaSSClh+Ut0kb4LJqwkcTUtc0OHhLq8NpRjlJUqOG4GGYGTjC5pnypTATZKuSxtvIbTt5zQmnmbZHhdaz+jSF0WRybrCDPIJ9CRhTGjyWWXS7Y/AwC1pl2L3VhqdCZJdZkHIu4adw5U7b7i3NVpVvYMeAtmOQlPB0UOWglB4aWdEs1PZZxVTLOvUyMFfLm2ZLM7OFGVtfEnJ5yyZmrmyf3JVNrCNhyPTCPK5jUvJQpyM4pkohlTfht9lcjZj/N2xMCNxOTcH0GByj9hBHPpxyPR79EB4qDcRdXqwDhMveiIxouCFSyOz9b2mevNqxjVpMnPkycd2y0FrWE+Hkmc09liRiZ/4UriznMaqKafy5bSUkDJQe/hRjcX0lQeWRg40iyMHH1J97H7XyRufb6GSiqhv6A1dBO1tR25eU5Fk7BgdZ/8ijWuVEQD+hvG9ZWGdabVrS4Mg5o1ddy938a3NsKxapiQg9Vq9i399pGBsx+3kvtgFN4x8ka3FY2X9WpPpCR9JOq508ECIiOZZlH43pSAizdMICg4elFwn6UF7XsQumcO+JM634a0A6YR0t5RIr9thWkY0Z0ka5UBXyOcLCAHVJCsrIzkd2ggeA0m2eArCkjceewwQ/BwFmnnJw0xD9eEXc2x3mI6/x7jApLAg7GPYvm21Nh0K4lXcxenNNPwsjGa6MM8Rv0s6qVjhLKbVodseh/yY1fAW1lbt8JkgigKiYqQY8NKX67Q0Zzm1Ma2+R7W2T2pJumPbygotTVQW0UwR79m5S7FaBojZcp/fwEdFrEq2y3mBiJTJXLE0uuZi9eZ2NjW+qCDko3cCUurF3NTGj40sYPgYsJ7qDEeVEYb1f8CwvsGilPIoxaU+wvMsSd8NuzBf7SM7g/UuyhECyduf//QTtrxSVzHzMjOUEZJsPykrXr7dnNyzPLM6ueiHCVe6X/vggw+/S0cVQhVX9fCx41inCtXSleXJXU+7Z21+25RrWOH6bczPbAHgD9kYZIQR5mdDRTvmjkyIvvG7ebw+afYasYWdOhO8EtrU831XtkN45jOU7dNru2a2qnesz5P6TKO5tAdoLqFx22mJHAVA1uqJl7z45iUTwcTRF6iw0QTzIW4hj0nxdXQ+ZuvbKfD47RNA9uBBhDabbGi72DZo7zX33b2z9mD9+lp4IQvqTGVkJvqkIyKENYlZjqLffoqbcImGey3KU77GjsgQb+KrkT0h0UiUSETEQctMBYPip2IdI5ka+dK77MgV2dnL4hYlsj86Ns4ORd72ImwQOWsbhGsfr2BDpuOfMR33cOb7b9Uxh7jvl69SLeSqZSsjs4nPblbt9x+8RrUH11RCFOPjXKVEKpV4PJV+6VqVfplIlsG8/mpdKsyj/4bnAHlOoJd36NOu2K9r1/p1dTO2dldYZaYuzw2GsVadyQRur25de0qk6+HFLbY8P01AVo2Bt8tINNOzMl7avzjrh+OpMJs1FMV4c2h7OjWDyMhU7ztZX5iv33S3goYly+4FgEzdYm4etJffdPDZSbU+VQTARkWnRtK30SOmrAkQR8NjbIxOML2YT16PRJ24yKHupMEHagBQm9qdQWKgvHkhFgzaOTBhRfaCwJMdH994hI2OGDd8gN1F4VD1pn5T3CKylvhL1O/2YS1MCc+ROgglJ/MU8QGzCGt45zvZdyWevOw3bTRZE7HYePa+9bGP9Vr4uO5m+n+I6T/Cs3t9/a/VHgd+X0euyWlDdcny6uoycQPpDa9HiogB9VqYhMR00nIsXzpHARFEiErSMpOGtbg6jZkX58PsyTWe36BxLmiwBESdB7JnPf5SvcVio/rroSTqdhCmjfsUShw5TAB2Tq2sHdVQJgpyUnFkJYOhVkP5JQqEWBpDpk++sWVMLUyPETuZzUaKaY4qM6//BDB5XL6mZvIc4lnV2BLXGyLsieWvoq6d+rJSGuZRd0auxN4xjQgNuhExGjkcNz3qRLC+L7Bl14ejtzimS9Z2ceHZAO9cK48dcD3shM8yFMMrLWVaaQ60wSZMzcqgp9jJvfuH4J67sekzo3Y1O3p0df/LAJCWyChsrANLXLpzdq10f/wtpl+SGf1PuvbOAPRyWZ2BvRZKKbN5vNUzCAROMyfwk57IUwLl4a/yNdwQ1mPQ/NRdC+MEU1GkSiGZLChURBSdRaLc4kM+Nk54N6wTDpEASKJyQaYUPkrZAdaZbOwvEphsNzHZxkgvxxyT707wRLVBarsbZE7MNfsLpTZToRpT1A7ykCC4toNTC20ft5Z9IlVGAeZCjDVtpUlcO7Ss0Halbdslfgy0OEz0JZ0MFylsvoAiZAVZinSdPvNlvgRS+md26yolzKkDC2002dW0jFB89nufoWN3PVtJJJRn3zVGP/N7m6/BR5nOPhuPb3bzIm3vH0GeTt7AjSLn8UGHf3b0RdXqJgga76EG6+n4DO5DFaUf1kSGPApGsvnqGGd4B1klqZyUUGj4kM4vPz7EINZj38ZrpjX44PUQgxzWESf9LXB2VttY6sMLEubYWv5z6A4WW2OMaxTDXg61Xrt66Y4rg+2eQTqkWrk0fNHctSs1NZXY9ZxdiSmo62Oj6xMEaTSdTSQaNUXDGK0XtXDyL/9qMtD1YPKv/jLn6WjysH/+oclchkiZkcmH7itOCChmHL/D7D0lLDJZWg2/x3uusni9VmvVmHi1Xs4wtnMvimMmVO1yz9EBUwhlOV0YdbPbxmG9XkXaLdvIzm2JiDrh29qjZHlpaZmMtmEwoyY5N6LbGlscc8vNCrxS5EELPzW2pDJuBqAuxbZ7ILZdSdjDs0xlHzF5MQcXvjsbf04hJnHPmrFPRGG10UvShCGfk1cQNyTrXaIm6tkXPmJsoRRlsrWtiaXAMNBU19CBWc3lfr5qoUJOgkDVkKjrCElulLk/Ms34KDf5gKYgihYWAGtjqZO7dvzlZDwCidcujDuLi2+HA9SSQIQRz8f2vpWl9cxKXdMic33LyoHUal2L18X2la8hNUbb00y7m47Me+j6COgr0t+HZofd//mGUA+yulm3akw4Ns+4Xn+w4vTaNRPwbU9NTa+ZNGRzFWBIqDE22VgChFVGCG00Wz3pIBDNaTw51pt9G/LE+PiEnJlQaP36mVhfGfczU+WcRwEwSua85QUl7SSxJoki9ae23io32/KICr/cCxLkIfglQLgYWN5QLc67s3nxS2wdeDPDhZUkxwWma7zQjoexZ5Soi4UxEvQXEf0dv87uXK8GIzCl2EL9LNOL6MvHEqMjtiE9W5pfX29NH5nRLIOQJEUIYbkmKzRxotpWka141sFdcnuHeGIbdc4vSCBLii6HMhKJkkzIyhsvebkLOU1COTBvXr6xkS/SEkE+fj0mkqJQ1fAOVfKylghNTXUd0Tu+ddcpBSoSQi5RJQ8fHqkwFFH4DJUSAP6O+cQ8R8QU07wVo3a5v1sep7T/UQrt9LnysxVj552IdnORIJuEhNnK6Gzic5vp8p0ddvzbhlfR2WRUyhs0zkwurzjS1Rx5o9nlxFiAK5eZ59pMyrUeT4ABW6Hd7UZu6mvJI78esJAMO3mG2Cm7ndgRfLtHYciuVr6w514KMbDA8aP8Ao0SwEw/lSUFkp2SJYivYspCqDv9v+URunrO1+88Qh95SwdguhceTY3da4mlWT75zJbs4g89yi4bJsF8FXblW/Atpss2pstkms+7PpMzhyJe29Fqthh6tMul7qwjdoh9WUT9WVYU2dWBml+2IgsZDp4XAcR5yTWQFVqy+UqKKULE8NzVVURNvIJNilZXPM8gKIT962wY0HJk4fZe72vjKouUsX9w981jK/J0KjFvUyxJpxtXNi5jEyPEPkAEoLpkcSUli/OHK9+K+cMtnMUTPial3vTJ6ZhISH+rgUtbJv0sazmOKrHcx5qAWyDg8RO0+wDDzcFPmvD0lOOSZxA3J5czMrFQEGBdFpUKQEURZR0HAbKInCnLuUDawsiwkwoMz2ASexbW13RseSJg1oIiK2LcjTGHsrhx+fNNqgDCBh17dFgGufK2MWpgBAptfh6YjZmerGNkSTvfd9s+3V09uc8IAmPfyVVX33fb+3ZKzAKZLns9yiwQCrBpZuM6VKsDb4zHseSHHEHanXVlX29K/TxiJ/2UU5sZp8pXcGEns0drfNILo4UmhWYrCjiM7t/Pxzcrp01TM5NKQTH3rxPXTUe12dUtUcgOpQMHwhwLes9z3bJEXFMxupPhw3cb4q23dsAzHmrmXU22Us22xLJjyLHWt94qPfQ04GQS0RzfZD9YZf8dBEC275hEiLkUxH68d6D9YAnGVLgmFktBPD/UuIKNcqUTgT22yKuWNk0h7+gxqfAoa6B2CAf2K5QUFInsRmu64hosCl+tqw5lNz0aXseg3jTz/lk2vXfjsSSBqv1YIIrhK1Ncfh6H1HRYmM6+f+ZNfeYEwgzT6HeZRqtMo9wmjYR2+x/Dw5zU2eKmm8l87Oi7TAUBjGH9tzaDIsZeslQeD96HNEQAwcYXsP7Xm3MhwELWxhh+kbhXgyOioqzJ7NLGNuJOTPQyIDvXsEGY7F9gFSO/j94T1yjIXHaWhHVsLtKg4q67HfmXNkXYwHfd1duxc8mhG244RNzwsOTDbXC7ZEmovy2XoeLl72KOoF67268j6Geqhai3DSdUKwueHWgU9iLkm5Eqb7wHEPo+vtF/+QC7nxEGFnoH5nPPKJO5xe4W8n2AjszXLf4ih9AtUU9Cn0ntStg5zHfN0T0izWQpUuzLoy63wRn4NXgrG78Cv193tRVGOdTLPnMOx8CUVHs5lMuiTHfbVQ9URVFNDebm4C7QTH4mvgSdRTAkByoQW7UdTAnk87BCKHbYOUG7OuvpH4fPXfnjQW1FeE1txc2d0goQHoWLcAq9ScjyXA7vCbG9+iHTZ75Bja/AYEs5YWnpwo5MSpJ1y+jVJ5Xhtak81lbHT+7IaAgsU+2WKBUFJMxc+TbS4b3CfJyj37ZYJCjekd9M6TiobMrXV6rdUp0VxM3d2yPmJQ1Rk38Gfmdl8IwwF+RvmpcXb5FhlOSo4kpDEyO2SEFdPrj92Pie/RNjFp4sKyUGNpJo/oL87PmgVZncpjBl82HWz4O61sB33YFBVr20jGRLlIEM3bJUbuZdScTJEQoQ0vRzh8Rh08mNlDOEc1aJ7Tv8BRvTMWGO6dSc9ATEM7vVXjSKTnnAWbl+/aN4yEmb7wnHLJbrAcPbG2IcjjpmwxlFsLLIA09p765Pz4VMmXzmyNrO+dKCKdnTY42DZCKkMiJxCRjQXFYGHnSnT7OHT+xPVzLSlrHq1G8u3jKcpg9PNI9wn9jGJP4MvE+YZiOt9vPQ8SDHa+tePXCzWupn6uqb83hQPvbC5twtEkXu3BY/4LvnKqSVyKxvObel7hIr8CRPnSLPOHNo6zYNQPeCbJjPBRgAaQcWVg83LAVRX/NPMPvlmU/IzH6V2H710aKJulU9bHrdbDqn3t/XaHb5XbsrWLvZSyrm775lpab0DKfKq2G4siq5SmtrtdjaduPO+o4hUQZnWXc0PLP1S0efVyAv6pnN2UBGMqMgOVLomJ28fffCLbuJJz615oogHxI6/gufYpYbEWpM1snRXLxybfc2XXiGJOLD2AXazSUlrCWqdKWk31RVctNZCqr+yh8RrWNLi34MsK4WHJ/b91DK3DZXfqsyPEwSs9WUBu8FdOstVHdMCur08pyGRVH21GBs9obtpdGVOzLOm8anFKimSmxsywLAu9GT4vqcSSVGmDgJwkevP7LVTuDE89nVKbziVXm+cVCMO4l1amUydLKBm0Vq04TtW3muZ+v2xQWe1Nv4JVNxycJiu0VceKmjybmqOz4nJrwoyIS2hMekXDaumdz4006SjxguTwJGoiyIQvZKGi7DzzKmuV84y3Z+nnBw38663N/Vj9qbyifKhAndPanGLtmKarUYLPqVszE5iT+rfLO/3N3tp4M1UD+JsHRhz2TFUKbGy9NpP22JCCTqR+f2jQ4rkmtRDFbe353acvDWXcniM3cOz2PJ8UgEuD4yPDN7YBbku0spK8q19rXOKMgOwN1xyqMkVcj62RQFkMtT287YWJWdNCAASd+xtLKuSdsr01vrkpwdToxplbGRmVqlOjPzN0CtKBv5xeEMwZGb4DEqCRBHxQ42jsMa8Iho169BEp8p0z3xg6ATHQOGw5WMvc1CvWtStLIJUpC5zVQyFyIMLEh+sbM95ocgZvLtYYMi3vrpqJLW4KMDXDl7uoLQUe9w1nuIh0pvV+zu+3EmMekm1FOneDPlscJzyJ9AFwQt3lGqRNft3IuddVy3QjGGxoEb/nopEZZLUbL4HMV46batYQhnTzsiWl6Kne71IZqOcvkgzOc34riIgC7FWxive13HzWgcrRl4KpNAjZFlZohyCSCWoCMAkySIOtHaanaxpr+O7IVvXDvSaAGOJQqTpR+PsnIxRacNDHv3hKEoaqbnJ/QnMvGwe2Z/bcGmkInlGyvkL780HxJAVsNq/dTHQM52Nlr+6O+DbXtRmLbMZIGPtiEAfIeN9hE22nvyvZVKn5dTzj7DKOqcddh5uxqTcNoP4lL1Gm7SdY0oYJQePL5CeeKTOCcPikV3zVlStyzGZ28NLU+f0ZIcqYoFzssvPVFiEV4o8jMka9J8i2iSCIsrcD5ensSUnDmEs905ZNzUPaM53wFYNUuyXCysxrwcya1uut/ChgSipEmPPrq0wPStM32/wvQtMn2D6/bAOkv2zsZd10XqAzO70vcrlIQbzw8xVb+PjUC8e6XYG4hT6YwiZzl9Zk4rM8te+QcBUALeFa+AUjjOm4R9G7Jbd4hWbChurn5RFguZQTz1WAfHkH/8wvMjO3hZZCccx8VONDpCDFwvziXJ6PJwGFEAh13/f4aSoYgoTrEqXd+wjsyQW5IngyOes09rInHyU3g0GdWk5z4zvsxirized3HUsOZHyMmjj9fWww+m9wrTO1K7FubRFdX/NYjR7KIOQw4WeQBLq7cP8AKr1+NFjDDwYia4HOCxq5FCUq9HihzDlwh4tDbY3PolNreGwhCL1nzSuLqytpfTib0c97A9RsD7tx+YHbnooeTsk21zsXHIQUiHbbvbzd1rc9mWmYUHV4P6A7a7MHXWQ6XGJXvIXr84f/jG9vKpYjTR4XBl+At4tzAhLLBnt6dLKhpYLGBz+WYRuI2Caw2Er2JxHXMp7RedcjljWzqfzuEpZbOFfmAThYvNRX1Myse2dhjbTSrKHz/RN9DXgH7/JgaHhNKVMioyecfirHV7MoE7nKld69AmjnGD4s5+EXij1KvT9rskpdnkuVFCSnccRKa0sym7icAiHRj4SgcFkLyw4+AdBhw51LTkpZwC+ZuV1t4vHn9QgVGiua5qXf7MINxPnyLjdxyQUytHkLHsZKOZs/QAR7iEAPDHTOI688eKxv0xh31mWyZon5VwytznJV0A6E96n0SdteCOs6sJkgm8lATjQbWGYcsqcYONX42ic7OzUQSPAAEsEqoQd8e4qTNy6olY83ZPkq0rDIl4eKV0iID/w3c6mdf9OrwvrjhYtIHX1vAw6C3AuEHjhPnmPez+FvYgqRp0L7H2XuK1h78hSE8rRrvXgpP56i0ooyymFaCq3d3IjlwAz5tt5lNGYvpM7rCDsHV6965pGURRn2B9qJIMZEKjtcXI0TVdLuwZz4+wq8xjVA/XZrFOGb2WNUv3DcWmtpJblR1Z9afqaYxJ4OHlpsuMIdnb+W4f0/aX0Ziw0EPD4T696icnY77YJftcsX7lrR91nQZ+KGmf374wXCYwO01cUIyzQG3f5qTi0X6R7ROeAHRhUQNFfo8RbD06XF4h99wuyllHk2t1Q+FsYnZ2c23tk+/AWw+6VObodeU7SGZVf22OXgqXs0P8q/287mYmFAWxZIM5vC96iGRO/w2szG5jwIX67EcSQV7Zl4xbeKwyyVfDSkZBxMGp3Vb1yc/qch5Jk171ytyslj16G/BYZGIzjmFwj77yGPwDk7HJMw1xxjeM7RSnEGmpVK52tmSuzffGGbZBhve3wjCVarSQ4quqqaq+glqNVDLy8ZEjce7XCyYng8Rk4MeJXXiEgwK87vWSiwGwK73+dUAZqUDdtO5LX7qy/6WDTK7NZHyMyXiWybiLQH+t3ecMQWynVrvz/6AgmdedNGOm3OUV3SilPiEDJGb3oiTgLYRryxsqrdAOpBtvIDF2SDgPIIYykiLPpboskQQ7z9AYYMjr4z3WTBYRXfZCdiMlBICETIN0wiWWlaFw3gl4mjMmEqnCzwYYtMKhlCiboqTT4MYhGSEiTrx5ROz04VuuDsDr3ihpRETUSZ5LUCpK2UuGKYOi3XTz6wA4GsWV8l27jMarpKjd4GC+ORnFVCuFceIzGlCGWjNmXeEmFsADpt3i7YPd2H5G9dP1GZpzyQ1HenHBzTIzC7lUu1SI6+ffHBqeNmHSfB5TzwzebCiEqNtazShdYz06pWpHDnOqxuxxbscOEMuMg23Ofm3dikZKu6FbYy9nfRvBNl+dmQFkBTE5MCyJ7NkDuaFt/eq1bl6VWyN1JRN7Mt9n39pZa/Ds6HVVLpTFWS8F3uiyzJ61GBqiuFP/paCAGTCMd9n+or7dTqeiCHq1LdR1EVKknUTUtgeebIdvHFgnkQL8EjSyOwjLM9kwyLlIRLSRlJIAL3h0vBOV/U1mAEIi9WdKWJv/deDbpepmuyB742Z8MSnXK1E2HYiYPWNJWecalwSArzKN+eqq2M+j8reGW73C9usTqTjwTaYjiTOpm3nJnCkDMDGjy+GnlE3bS9hLFYcmgp9HisgaAAgqbmi/rygJt5dKxWZAKZaY7tFfhkGmUwM/M8OTqVgkRKOqKlKx+FdauqjGiNloYoNwDWosz/lV9J44E1zlkY27NaFM6mnU5ML3JzGuFC8S5R+1fuhTymWnsRZRCG9Lux4ujGRv8xGI1j6phVSMEFZRS9pnieC/ks89sqLImTstQNqILI9oCAy+cqUIJHunevESzisggqhi18EqOwAlTy5eOk5BUUYUJX/xPJlKYJKYlM9dKDAd/oBlV0eZDgrTgfZrTxw+f/4BfyFNUiZ09OpU6vI48ZKs/2xX512s/1A/e8pdks/Dtf6GsIn4JOzTGIn7O1E1XibLTdCxS3PwUs9OqVjNLqwoAPohMZtCrsjUTmXFAyYA8m/LjGQMyhW/3RK54pLENBet2zPMGgS9iymvTI6UXlgaVhACkrUpUx0hZYg1qTttnhdXAl9W0vjCOXkyQZCYmCLnL0ppRfYDhfB3KYX74d2AhTLfp+rZoVuYzA+CWI8O5SjHQrPx/LSKyxlDsmZsQ1JNA6Kt42Op+FyXNH6+DCIa9cZt0zS1aKvYP1wUkHArovA6tjLWhSzjj0lfuaqmmz+kSyY7pdvsvHJrJvLxcDak7Y9GNsIAeiI3R8MsaoYJ0Ep+aspJihy+w6n0f8kT3g1/D7eg2wRDSLAneOa1T2B2imqdN26IH767VqgmnFphJHJusBMJ006l0FSmmHDcTDHpaLap23bK5pH1qisT8A6hFr/xkopz/lNo88tr1SlxsLrOo8HK4B0qJQo1h1byw8MpVZMJiDb2LNkG0OYCGYV3ZeY/h7Fl+DJFAFR2bA+BSPViWbQwEtVQk9xxO+nIO3WpV4X3CYZSGS5JjMv/VMZk9+MnSir/SHpEgE5+hN1/kueYklzTf01C5MK/JA1y/F+S/fiv3xU5B++HN6Ot8fsSTj/iuqv/zSVIrXtVha4sLS1Rg0qGpTzXfSG2dNRWE1EUyWJODbE0OSXiUMnx++5h8+gH2X1NvtsidCrWqoNJ9IyuAquBeJ1CaAj/gE2nSBDFtpbh+y8fYDU+P4zOD95T9UqDJUjvvao/sDxLeTEoohvqirh3N/zhkO1RMgooYWtsDMKI3el+dqe97E4uZ6YYNv8sQZ/s3++aIIs/iNn91N17xQDNW6EE45h69lAUdqp7D8I34RfR+dj/cMxwaxyKxlHHNt1q8FqHPMIPV1B5+Lhnrq4mXc9PE9FwX+kaDEoJOl8adl018JKuKVoSktgfXRT/FbtT/3nRfgt8Bt6Nzv9HYy86+/jY+394FutVks4wvdJdva6vxunTj8etI/30pzaX4nx1uMyXCZduTtPrqkivqcSJ2T/C15SQMr8px78Pcxfzmirzm3LWFrnf1GsxQY9Cl5u6wA3oxvszzcpsTIvqTLw/wdiiWaQSCuIbbLRxCtlvEJUmiEy5ndI3YWQLuhOASkSSLn/cUmUAWbVQXbLukyzAovXo3yroZV8UxE31juPCQbbLsWUq7+sgPn7NY68ij/8UAd/yjJNytLd7U+vVvwa9l0RKvZ3Sa6sik/3ivKlGdTIpi/zw3djzfUVBipwIDJmaQULunFjXVUwqg+K8UB+amEgd4CV7bzAUYCZGiFL29Qum3DuRTeYDOb6uYtbeznzA3VxvUmu2XDdeYXacwnWDsJtRKXdRjsVubIEq14iboDvjNHhtiePC3LwouxjbNBdIaGEOXFt2wh+LFJr0dFdqAjQlV/eSVAm7VSQIAICNIQaTShvf2dgAFFdUKhlPlQFB47DznSoBMrzhHG4Aind9VYGNV5Fp8efxju5e4SIbrxP7mpOGIPKaLtEPfb/3mn+zWeTGv/5lZbFTjxm38DmaXetFQplHAQ1Za/HqF+S7Uxt8WpRFLCLKq+02+m/OitQgOEgPV6ajXVHFkRCSnEr0kk2H90cOlPpvz583iQjERucRQVgimqay6JdlxZZlu7PKYEtwU4SNd3iarOMTWJc1D+PNJz8JZqDxF+x5hGH2eJ2UhiRDFja9H7H9X/p+xOO/B+Fsbr+mDPO3f+vf89LD9W84sC6DNq7DCNPhD5gOy0yHWrwH8Y8XEcbwTGl9U1avM2rxmHHPHUEBJn6mXJ0KP7IZw75RKGxHBD/jrxEdrPs27gkR+sEfQWg1LV9dU9ho3C4Z+pdKOZPG672HmOGVQMboMSx9g6NshUn9R+jOWOqq1p3bOSD0fwilB67xRjOhQWcUyt1ERbPCt8r5JY44laVJpTmtAoZoT33NwV7SQsj2FV7IBC2+zfJLfJelieQh4uJABLtmw1/Nrsk7liWfXFhvJBRkRIW8aB0vP/KTm/dffvIR6anMDvpsZBg8pkaZ3L/PrH1QOCXczmLqwpkTN8wQFlNut7q6v9UV1CO+q9svNykxl2GN/a0vrkS5zPSr9GKGcxveWI2a/X3eeApnNog3SWMQfWnIBihRtC7Eu165HEIIo7nTBkLGqXl2iNBSfOWjoWIssjMJzccXT8+zQ4Ry2UXkzSsKdeZUCV1gf5G74FInfo2ktyN2CkBeHlEsWx5dlgFO9ffGHJPya0tjsm0po0v8GvzRQlLVdFVNqeK94sJi0jfYMffMYZ4rZ7Y6ycZ4Z8DHmI2vHwZhrBVzx0F8dTOznSIInrIb/PhUr5TxWgfowFUnXcf67x8qEqZKwpEgnQpDOHOKD3s6DaKbcBEixaFIVgxeuu0XDioYbfYKrBws+BxnHR1Z8NVcCaXVyZqtvuIVHa7fcQh4xStUe3ZKTaNSDmTFd21s+SuVHb54ZrPHnBH9HZWVpEix7QcWt0NBAPgL5uvHmR0KCK75Zan+z4xsaip39vP6a7XNxc85FPX7xJy8xpC5n+wfeebxZHrPRUkeT6uq7w05Co2DeM8ekyCb8UZV2TKrG83dqqioGde2u1dtAkhJln1PVdOzGOD7jz4bW/fdkIga51ZyzLLaUPwDJTzAsS45+V1TEzurQ7n2PgWtzhhObqi6c3J8R9HhHYg9XMH+kMaMnlu5Z5kK/xVVWf+pv0n1WTgA84wPBOzOZn8EuyJ3OQ/789lsmLclQsQOgeOpL7QUZrOyoZ85nugQjMTxG4X49yieAr8jfFOYEgQcT5vV5hJqsZLwHjLXQp/PrayRtbV54jre7ITfkY2N/2cRAEAiKIamSCDCFhARUhIKwvCAI1Hzzbe4yUDXsAQIFEXyCkN/9EduwtdkzLmwgqQJpyj8f5syDjQAAAEAAACCAHwABQAAAAAAAgAAABgAjQAAACAODAAAAAAAAAASABIAEgASAEMAgwEoAbkCQALbAwgDPwNzBAYEOARlBHsElAS7BPsFOwWTBgkGXwbIBzMHdwfjCEkIcwiuCN4JBgk0CYgJ8wplCtkLJwtqC9wMQgyuDS4Naw2zDiMOcQ7rD10Pow/7EGoQ9xF0EccSLRKRExITkRP6FFgUixSyFNoVExUoFVoVxBYdFmQWuhcLF2IX7xhQGJEY5hleGZMaDxpoGqYa/htXG6McGhxuHMAdEh2eHiUenh7/H2EfeR/lIB4gTyBPIIAgrCDxISEhZSGeIcoh6CINIjEiYiJ3IqMi3CNII5Mj1SRKJK0lPiWgJfsmVybtJ3En8yglKFIoeyi+AAAAAQAAAAEAAJq59PJfDzz1AA8D6AAAAAAAAAAAAAAAAAAAAAD/9P8bAiECtgAAAAgAAgAAAAAAAHjaHcszQjUAAADg72H7kW3btq3xjRkHaOoq7S1ZB3jtGSfoCC1Z3/55UQ+BKYL/cGFDoXYFMu3bEjGo2I42Ue3KLWpUKUujKpWqVIva16ZYm26VMsUpFStBsmKxRrWJl+avRK0StIrVKP3zXYK/MiWq9aBdmTltDtQK65ejVoEsYaNq/dPw+SSsUVi+VKPShKWKlSVdvnqP6kSsYc2pzd81Z8GYM+tmtDkVUSdNgVbZ8sQqVaxMkVwH9t2q/AKRqCRgAAB42mNgZGBg2vZfmiGKiff/l/9vmBSBIqiABQCcQwZDAHjaY2Bi4mWcwMDKwMDUxbSHgYGhB0IzPmAwZGRiQAINDAzvBRjevIXxA9JcUxgcGBRUlJkV/lswRDFtY3iqwMDQH8cM1L2eKRmoRIGBEQDRyg/SAHjaVEo1YoJRDM6fdO5S32pr3Y7XO9TdXXGfcFlxl2vkER4O0c8AAPWS3ml9jc6fgKj+67Co0SQcwgN8gAlcxhYeYAQTmMcSndAFXdMdPdAzvdHn4sLi9uqKCAAsjuXDGMMsFul4JP9KH4vz3bw0JCA+scuf7De31LN6UmfqlKtc4gLnOMtpTnFrVx6kPfC7Ewd0HUkAALb9QmgAAHjarFbXettMDh2quVeVFKaAmcjrNYeK090Lx7Q23fX7yK2kJed+9yrPwH0ZUOl3+2gLkJJ7+ZtVMIMywDnA0EKhAMW+7wUAb36I0e03WNr9q4/PTJwOwo8Q7/uYq0c/+0W/aLXkgWlZKAIUWm50hCF06DpoKITwo4M5JS1pOZhX0P6cr1SFq7GsIQzdJFfRblLPa8zpvU+Aw5IWOmpjYetTJ5fL0TFoHd6xWNsZrRruHaCldDtlo0w2iWLLPww6NYM9HSwozNtY1T7nw5rWXQcT2oD/28LC1F8708aI9loeljzfwnw92PmbT85m7ANubZFqjbxxjldzQQBJ5k0VTZOquwOcZfssedKpPhAbcQQ4uOWHpAG2DfLqBa9ehGYYBIFJbOGwbqHY8VG8YWeL9uYbvMere2+iH+OixR4/iuIgCNpRgIYdBF0EAbQJj3QDB4sKqIJCPSJMfXrLxz7pYr90qQMUEjpYSukmJqCd9B24wEaGa2bl8zfmQq+FxRmLjBpiiClXMlusE0PbfrhlRjuBLwMrAFzb9clmEi+9UhzsUzig7Y7IZW3up610JaCQboS5g49otKgQ7JtxcEABVztKsAriAPgEXAsDdgk30moHVWdgVGjPnbGOBmdInR6k4ewUw5akJ+gheLGMoN0lW5jcEAQT144Io9bKaCNLMXJJOD6kKEFRFwWNqhTQ55FhkfcoiymtYIaGeEwluZyH7WjDwXFFrgA4pl/zAbSgDuE473ZoN572a0LRKiUFiIMWZcYJHUIcAk4QbQ5Oqjd7flJobwQPceRQfnKwrN5s+292M6Vpkb6c6isqEZN6308mJzUakYsTdsCQcnU3GeOvcfpCoyaBkGz5CdNHeN04Bk47PmNJCuutzcxOIfRJNQEhaVL9TdKebtYlLUyEKEviS6NY6RiGkXarqkQict6ej5PSBQ9HpYsjkkbOhfD7zZuGmBBl4bouM1AhmxEllX4b/2ubD4iuGmGs2g7eUInB8ibxzfKWSvIsb6ukwNJUSZHlHZWUWN5VSR/LeyrpZ3lfJQMsbSV7/GMpJKYlNND4B98WB9UJY+3I+O/M6JwwTh0Z/5MZQQkcsy/FSaC+ZlAZ50l8FuEDqusB4WMpCR/Lh4SPZZ3wsZwifCz/RPhYThM+ln8mfCxnCB/LhoKldGAfKUp7MwQtaau5pSSxwTM7q/CRjY/oPj5WAE24pJsympP8YL/Sw2T0T3otTkZLHk8cPp5JikbV82eDFOXTjJ4rfZ4peJ5W/lyJro93PicaNtVysV7Uvgj+21iRc8kzo8pYXxAf0LykfhQ6mnPwpWrcWHJw7jpXNHSL3OepRaJWhwY0UUi+La/iuCmbMgL/gPhAQ7qdOcOoVojhBUVl4Q1yK9Tpnbolw8LFIW0fxg0JsBTTmYun3aCRnYcl6fa8AUN+pqxt+58LUATzc2GqeDtwXQk4qCGWaYTcDLGkz17XEIie7L9SQYdtiUUdtclc0JFJ65CfdGdjIgnkPSU3qceSMmwSThJplhAuSiI5iyRLSBKL9Yg+Z53oRC6izkXk6bv7JD3ORYOw1OMCSFuc6nIhl4im5Z6JMKf2TdnkpNzFlZ4tBZMxjWLPb8CStEzS9JR06FErsFSn3auTv12yJl407d1uSR751ROV6F67Qv6BcxZyr8VrSkKDWdzEG9rfMncCH5aCRjJrVOjerp+y7phbp6zuhbFXRWiFC/ZVCTcULtox1cYzRqAudaWGNnCWIjyGnM7nVMZ8hMPSzaDzgEpYgoac656/qZLBQt2lkN8y0s0/aooZU0ToliQ9qk7MixV062yqRCzYPVb+QrtF25JdXuTcaQpeEQXV7Np3BN/wcgNf0C1/fYn+DR1nVMr4ktZvFc6TeMcsekQ3bMYy6rH1XvFA4/97rou02KEggMK3nqBLYMqMsALc3bVxa9y1cffFtG2QOlUhs//mO3EfUA5FhRA6FcMKASNRQQIYVQgYo+lSjNOACRowSQOmomIIoU01rRJTKiqKT5tRiWmWTtAcnWmezrRAZ1pknR2KJYWAZdYJVhQCVmm6FWs0IE0D1mnABusL7apNlZi2WJ9pWyWmHTpBu3SmPTrTPp3pQI9xfXICD22Ua1YeOVuUxxx0G7Xq6CTKS9ycQm/OrJG4OdeZG5KlXjDyOTLQ57iEnl/pcuLgGnpwAz241bYxWd4dI8/voecP0PNHnTMOnqAHz9CDF22bkuW9MvL8DXr+Dj3/0Dnj4BN68AU9+I4KlfZlmyupKvz787dDf5r0MZhqrcmVpXN/q4czvy/r2h9jTAFHeNpi8N7BcAJQozQcOBCG0TfWGpfFaZk0Ef0FxDjPFJAOYqOWMXsLRh+fmn2Doo4DnQpEiFCHBoSq9Q8axRg57+I9S8sp/uFf6QRL1UgAi2tIuTKlGqF87ZgFYABifFPrRl8vr/sx14jxH3NfRCqADN6Nv1gKxTEotrxW27kRl/MpPrL0XdGnzgudPRg0iMVpPAi5AKHCK5B42mPADSQgkCmZgZFJlIGBKe//NxDNEAKEPgw+YPFkxvUMjP+VwfIp/78ypTDu+P/rvwyIDwBTtg3zAAB42mJgYOBkKGJgZmBk4QSyFwExhM3IoADkQdhMDHwMhyBsIBnAcAHKZmEwYFSAslkZnBgDoGw2JHFepgLGSVA2H4MJCxOgVbJQkRiAgejgsF9R9Nzd3d0PPdZd639/j7B2roQ00zCdhEm1o7oaiplaVF4FeUwaVFpD1GlNEksaMzRFOtpVVq5xa7zdwCzSqVGzGqVzZHhcia+U0ZvtKi/SO4GTNNUtWEllUKzy/Qn4FvyoJ2qsBjg0VU9Z6jXPvHxVlORtn6k1eVZb9LM2bdx2Xya/Uht7qfdj/r11ccj2cDSlcXIF5BE5OD61rgKMWtuTwFiL5IyGfniR0R/cBB2tKrQYx9ukPPRL1Ejjbb/WNfSPt3s5sdxmJfs5LyaPKgGzaHs55qxrfgY8M3Ta1wWdo1Cl+/VF+ReJW3PcfaFxA8qBQrscWm1GhYp3sNz2XF81KmpgdjPuDb6eUi9sYu2F8ukLBW7wwX8x/mKzl3MdJRWQRfuzUjzp9bmTtIlbujLsaRktLkU0wBOEixo+8O6Bx0m0un5PsPm+Tn/zzTPxdLtOAAB42mzB02EkABQAwHlr62zbe1Zs22wl+5/yYlaSNJAZCeCipekqWwgJSSlpGVk5eQVFJWUVVTV1Dddcd8NNt9x2x1333PfAQ4889sRTzzz3wkuvvPbGW++898FHn3z2RdNX33z3w0+//PbHX//816Zdh05duvXo1affgEFDho0YNWbchElTps2YNWfegkVLlq1YtWbdhs1IRNK2lhO7kbLnPNKRiaxDR47tO41c5KMQxShFOSpRjVrUo+Fy2xi2MwozirCX5mUaGJi7QWhHAzBtZGwOoZ0tobQjlHZidU/MzU0E84wtTVhDMlJLEtl8EnOTUhKZIjKZAjJZgzPTgQpCC4ozc/LzmAMyMpkDijMhGhwt2XIz80pLUkFcIxMjYwAA/0ToAAEAAf//AA8=) format("woff"),url(data:font/ttf;base64,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) format("truetype")}.katex{font: 1.21em KaTeX_Main,Times New Roman,serif;line-height:1.2;text-indent:0;text-rendering:auto}.katex *{-ms-high-contrast-adjust:none!important;border-color:currentColor}.katex .katex-version:after{content:"0.16.28"}.katex .katex-mathml{clip:rect(1px,1px,1px,1px);border:0;height:1px;overflow:hidden;padding:0;position:absolute;width:1px}.katex .katex-html>.newline{display:block}.katex .base{position:relative;white-space:nowrap;width:-webkit-min-content;width:-moz-min-content;width:min-content}.katex .base,.katex .strut{display:inline-block}.katex .textbf{font-weight:700}.katex .textit{font-style:italic}.katex .textrm{font-family:KaTeX_Main}.katex .textsf{font-family:KaTeX_SansSerif}.katex .texttt{font-family:KaTeX_Typewriter}.katex .mathnormal{font-family:KaTeX_Math;font-style:italic}.katex .mathit{font-family:KaTeX_Main;font-style:italic}.katex .mathrm{font-style:normal}.katex .mathbf{font-family:KaTeX_Main;font-weight:700}.katex .boldsymbol{font-family:KaTeX_Math;font-style:italic;font-weight:700}.katex .amsrm,.katex .mathbb,.katex .textbb{font-family:KaTeX_AMS}.katex .mathcal{font-family:KaTeX_Caligraphic}.katex .mathfrak,.katex .textfrak{font-family:KaTeX_Fraktur}.katex .mathboldfrak,.katex .textboldfrak{font-family:KaTeX_Fraktur;font-weight:700}.katex .mathtt{font-family:KaTeX_Typewriter}.katex .mathscr,.katex .textscr{font-family:KaTeX_Script}.katex .mathsf,.katex .textsf{font-family:KaTeX_SansSerif}.katex .mathboldsf,.katex .textboldsf{font-family:KaTeX_SansSerif;font-weight:700}.katex .mathitsf,.katex .mathsfit,.katex .textitsf{font-family:KaTeX_SansSerif;font-style:italic}.katex .mainrm{font-family:KaTeX_Main;font-style:normal}.katex .vlist-t{border-collapse:collapse;display:inline-table;table-layout:fixed}.katex .vlist-r{display:table-row}.katex .vlist{display:table-cell;position:relative;vertical-align:bottom}.katex .vlist>span{display:block;height:0;position:relative}.katex .vlist>span>span{display:inline-block}.katex .vlist>span>.pstrut{overflow:hidden;width:0}.katex .vlist-t2{margin-right:-2px}.katex .vlist-s{display:table-cell;font-size:1px;min-width:2px;vertical-align:bottom;width:2px}.katex .vbox{align-items:baseline;display:inline-flex;flex-direction:column}.katex .hbox{width:100%}.katex .hbox,.katex .thinbox{display:inline-flex;flex-direction:row}.katex .thinbox{max-width:0;width:0}.katex .msupsub{text-align:left}.katex .mfrac>span>span{text-align:center}.katex .mfrac .frac-line{border-bottom-style:solid;display:inline-block;width:100%}.katex .hdashline,.katex .hline,.katex .mfrac .frac-line,.katex .overline .overline-line,.katex .rule,.katex .underline .underline-line{min-height:1px}.katex .mspace{display:inline-block}.katex .clap,.katex .llap,.katex .rlap{position:relative;width:0}.katex .clap>.inner,.katex .llap>.inner,.katex .rlap>.inner{position:absolute}.katex .clap>.fix,.katex .llap>.fix,.katex .rlap>.fix{display:inline-block}.katex .llap>.inner{right:0}.katex .clap>.inner,.katex .rlap>.inner{left:0}.katex .clap>.inner>span{margin-left:-50%;margin-right:50%}.katex .rule{border:0 solid;display:inline-block;position:relative}.katex .hline,.katex .overline .overline-line,.katex .underline .underline-line{border-bottom-style:solid;display:inline-block;width:100%}.katex .hdashline{border-bottom-style:dashed;display:inline-block;width:100%}.katex .sqrt>.root{margin-left:.2777777778em;margin-right:-.5555555556em}.katex .fontsize-ensurer.reset-size1.size1,.katex .sizing.reset-size1.size1{font-size:1em}.katex .fontsize-ensurer.reset-size1.size2,.katex .sizing.reset-size1.size2{font-size:1.2em}.katex .fontsize-ensurer.reset-size1.size3,.katex .sizing.reset-size1.size3{font-size:1.4em}.katex .fontsize-ensurer.reset-size1.size4,.katex .sizing.reset-size1.size4{font-size:1.6em}.katex .fontsize-ensurer.reset-size1.size5,.katex .sizing.reset-size1.size5{font-size:1.8em}.katex .fontsize-ensurer.reset-size1.size6,.katex .sizing.reset-size1.size6{font-size:2em}.katex .fontsize-ensurer.reset-size1.size7,.katex .sizing.reset-size1.size7{font-size:2.4em}.katex .fontsize-ensurer.reset-size1.size8,.katex .sizing.reset-size1.size8{font-size:2.88em}.katex .fontsize-ensurer.reset-size1.size9,.katex .sizing.reset-size1.size9{font-size:3.456em}.katex .fontsize-ensurer.reset-size1.size10,.katex .sizing.reset-size1.size10{font-size:4.148em}.katex .fontsize-ensurer.reset-size1.size11,.katex .sizing.reset-size1.size11{font-size:4.976em}.katex .fontsize-ensurer.reset-size2.size1,.katex .sizing.reset-size2.size1{font-size:.8333333333em}.katex .fontsize-ensurer.reset-size2.size2,.katex .sizing.reset-size2.size2{font-size:1em}.katex .fontsize-ensurer.reset-size2.size3,.katex .sizing.reset-size2.size3{font-size:1.1666666667em}.katex .fontsize-ensurer.reset-size2.size4,.katex .sizing.reset-size2.size4{font-size:1.3333333333em}.katex .fontsize-ensurer.reset-size2.size5,.katex .sizing.reset-size2.size5{font-size:1.5em}.katex .fontsize-ensurer.reset-size2.size6,.katex .sizing.reset-size2.size6{font-size:1.6666666667em}.katex .fontsize-ensurer.reset-size2.size7,.katex .sizing.reset-size2.size7{font-size:2em}.katex .fontsize-ensurer.reset-size2.size8,.katex .sizing.reset-size2.size8{font-size:2.4em}.katex .fontsize-ensurer.reset-size2.size9,.katex .sizing.reset-size2.size9{font-size:2.88em}.katex .fontsize-ensurer.reset-size2.size10,.katex .sizing.reset-size2.size10{font-size:3.4566666667em}.katex .fontsize-ensurer.reset-size2.size11,.katex .sizing.reset-size2.size11{font-size:4.1466666667em}.katex .fontsize-ensurer.reset-size3.size1,.katex .sizing.reset-size3.size1{font-size:.7142857143em}.katex .fontsize-ensurer.reset-size3.size2,.katex .sizing.reset-size3.size2{font-size:.8571428571em}.katex .fontsize-ensurer.reset-size3.size3,.katex .sizing.reset-size3.size3{font-size:1em}.katex .fontsize-ensurer.reset-size3.size4,.katex .sizing.reset-size3.size4{font-size:1.1428571429em}.katex .fontsize-ensurer.reset-size3.size5,.katex .sizing.reset-size3.size5{font-size:1.2857142857em}.katex .fontsize-ensurer.reset-size3.size6,.katex .sizing.reset-size3.size6{font-size:1.4285714286em}.katex .fontsize-ensurer.reset-size3.size7,.katex .sizing.reset-size3.size7{font-size:1.7142857143em}.katex .fontsize-ensurer.reset-size3.size8,.katex .sizing.reset-size3.size8{font-size:2.0571428571em}.katex .fontsize-ensurer.reset-size3.size9,.katex .sizing.reset-size3.size9{font-size:2.4685714286em}.katex .fontsize-ensurer.reset-size3.size10,.katex .sizing.reset-size3.size10{font-size:2.9628571429em}.katex .fontsize-ensurer.reset-size3.size11,.katex .sizing.reset-size3.size11{font-size:3.5542857143em}.katex .fontsize-ensurer.reset-size4.size1,.katex .sizing.reset-size4.size1{font-size:.625em}.katex .fontsize-ensurer.reset-size4.size2,.katex .sizing.reset-size4.size2{font-size:.75em}.katex .fontsize-ensurer.reset-size4.size3,.katex .sizing.reset-size4.size3{font-size:.875em}.katex .fontsize-ensurer.reset-size4.size4,.katex .sizing.reset-size4.size4{font-size:1em}.katex .fontsize-ensurer.reset-size4.size5,.katex .sizing.reset-size4.size5{font-size:1.125em}.katex .fontsize-ensurer.reset-size4.size6,.katex .sizing.reset-size4.size6{font-size:1.25em}.katex .fontsize-ensurer.reset-size4.size7,.katex .sizing.reset-size4.size7{font-size:1.5em}.katex .fontsize-ensurer.reset-size4.size8,.katex .sizing.reset-size4.size8{font-size:1.8em}.katex .fontsize-ensurer.reset-size4.size9,.katex .sizing.reset-size4.size9{font-size:2.16em}.katex .fontsize-ensurer.reset-size4.size10,.katex .sizing.reset-size4.size10{font-size:2.5925em}.katex .fontsize-ensurer.reset-size4.size11,.katex .sizing.reset-size4.size11{font-size:3.11em}.katex .fontsize-ensurer.reset-size5.size1,.katex .sizing.reset-size5.size1{font-size:.5555555556em}.katex .fontsize-ensurer.reset-size5.size2,.katex .sizing.reset-size5.size2{font-size:.6666666667em}.katex .fontsize-ensurer.reset-size5.size3,.katex .sizing.reset-size5.size3{font-size:.7777777778em}.katex .fontsize-ensurer.reset-size5.size4,.katex .sizing.reset-size5.size4{font-size:.8888888889em}.katex .fontsize-ensurer.reset-size5.size5,.katex .sizing.reset-size5.size5{font-size:1em}.katex .fontsize-ensurer.reset-size5.size6,.katex .sizing.reset-size5.size6{font-size:1.1111111111em}.katex .fontsize-ensurer.reset-size5.size7,.katex .sizing.reset-size5.size7{font-size:1.3333333333em}.katex .fontsize-ensurer.reset-size5.size8,.katex .sizing.reset-size5.size8{font-size:1.6em}.katex .fontsize-ensurer.reset-size5.size9,.katex .sizing.reset-size5.size9{font-size:1.92em}.katex .fontsize-ensurer.reset-size5.size10,.katex .sizing.reset-size5.size10{font-size:2.3044444444em}.katex .fontsize-ensurer.reset-size5.size11,.katex .sizing.reset-size5.size11{font-size:2.7644444444em}.katex .fontsize-ensurer.reset-size6.size1,.katex .sizing.reset-size6.size1{font-size:.5em}.katex .fontsize-ensurer.reset-size6.size2,.katex .sizing.reset-size6.size2{font-size:.6em}.katex .fontsize-ensurer.reset-size6.size3,.katex .sizing.reset-size6.size3{font-size:.7em}.katex .fontsize-ensurer.reset-size6.size4,.katex .sizing.reset-size6.size4{font-size:.8em}.katex .fontsize-ensurer.reset-size6.size5,.katex .sizing.reset-size6.size5{font-size:.9em}.katex .fontsize-ensurer.reset-size6.size6,.katex .sizing.reset-size6.size6{font-size:1em}.katex .fontsize-ensurer.reset-size6.size7,.katex .sizing.reset-size6.size7{font-size:1.2em}.katex .fontsize-ensurer.reset-size6.size8,.katex .sizing.reset-size6.size8{font-size:1.44em}.katex .fontsize-ensurer.reset-size6.size9,.katex .sizing.reset-size6.size9{font-size:1.728em}.katex .fontsize-ensurer.reset-size6.size10,.katex .sizing.reset-size6.size10{font-size:2.074em}.katex .fontsize-ensurer.reset-size6.size11,.katex .sizing.reset-size6.size11{font-size:2.488em}.katex .fontsize-ensurer.reset-size7.size1,.katex .sizing.reset-size7.size1{font-size:.4166666667em}.katex .fontsize-ensurer.reset-size7.size2,.katex .sizing.reset-size7.size2{font-size:.5em}.katex .fontsize-ensurer.reset-size7.size3,.katex .sizing.reset-size7.size3{font-size:.5833333333em}.katex .fontsize-ensurer.reset-size7.size4,.katex .sizing.reset-size7.size4{font-size:.6666666667em}.katex .fontsize-ensurer.reset-size7.size5,.katex .sizing.reset-size7.size5{font-size:.75em}.katex .fontsize-ensurer.reset-size7.size6,.katex .sizing.reset-size7.size6{font-size:.8333333333em}.katex .fontsize-ensurer.reset-size7.size7,.katex .sizing.reset-size7.size7{font-size:1em}.katex .fontsize-ensurer.reset-size7.size8,.katex .sizing.reset-size7.size8{font-size:1.2em}.katex .fontsize-ensurer.reset-size7.size9,.katex .sizing.reset-size7.size9{font-size:1.44em}.katex .fontsize-ensurer.reset-size7.size10,.katex .sizing.reset-size7.size10{font-size:1.7283333333em}.katex .fontsize-ensurer.reset-size7.size11,.katex .sizing.reset-size7.size11{font-size:2.0733333333em}.katex .fontsize-ensurer.reset-size8.size1,.katex .sizing.reset-size8.size1{font-size:.3472222222em}.katex .fontsize-ensurer.reset-size8.size2,.katex .sizing.reset-size8.size2{font-size:.4166666667em}.katex .fontsize-ensurer.reset-size8.size3,.katex .sizing.reset-size8.size3{font-size:.4861111111em}.katex .fontsize-ensurer.reset-size8.size4,.katex .sizing.reset-size8.size4{font-size:.5555555556em}.katex .fontsize-ensurer.reset-size8.size5,.katex .sizing.reset-size8.size5{font-size:.625em}.katex .fontsize-ensurer.reset-size8.size6,.katex .sizing.reset-size8.size6{font-size:.6944444444em}.katex .fontsize-ensurer.reset-size8.size7,.katex .sizing.reset-size8.size7{font-size:.8333333333em}.katex .fontsize-ensurer.reset-size8.size8,.katex .sizing.reset-size8.size8{font-size:1em}.katex .fontsize-ensurer.reset-size8.size9,.katex .sizing.reset-size8.size9{font-size:1.2em}.katex .fontsize-ensurer.reset-size8.size10,.katex .sizing.reset-size8.size10{font-size:1.4402777778em}.katex .fontsize-ensurer.reset-size8.size11,.katex .sizing.reset-size8.size11{font-size:1.7277777778em}.katex .fontsize-ensurer.reset-size9.size1,.katex .sizing.reset-size9.size1{font-size:.2893518519em}.katex .fontsize-ensurer.reset-size9.size2,.katex .sizing.reset-size9.size2{font-size:.3472222222em}.katex .fontsize-ensurer.reset-size9.size3,.katex .sizing.reset-size9.size3{font-size:.4050925926em}.katex .fontsize-ensurer.reset-size9.size4,.katex .sizing.reset-size9.size4{font-size:.462962963em}.katex .fontsize-ensurer.reset-size9.size5,.katex .sizing.reset-size9.size5{font-size:.5208333333em}.katex .fontsize-ensurer.reset-size9.size6,.katex .sizing.reset-size9.size6{font-size:.5787037037em}.katex .fontsize-ensurer.reset-size9.size7,.katex .sizing.reset-size9.size7{font-size:.6944444444em}.katex .fontsize-ensurer.reset-size9.size8,.katex .sizing.reset-size9.size8{font-size:.8333333333em}.katex .fontsize-ensurer.reset-size9.size9,.katex .sizing.reset-size9.size9{font-size:1em}.katex .fontsize-ensurer.reset-size9.size10,.katex .sizing.reset-size9.size10{font-size:1.2002314815em}.katex .fontsize-ensurer.reset-size9.size11,.katex .sizing.reset-size9.size11{font-size:1.4398148148em}.katex .fontsize-ensurer.reset-size10.size1,.katex .sizing.reset-size10.size1{font-size:.2410800386em}.katex .fontsize-ensurer.reset-size10.size2,.katex .sizing.reset-size10.size2{font-size:.2892960463em}.katex .fontsize-ensurer.reset-size10.size3,.katex .sizing.reset-size10.size3{font-size:.337512054em}.katex .fontsize-ensurer.reset-size10.size4,.katex .sizing.reset-size10.size4{font-size:.3857280617em}.katex .fontsize-ensurer.reset-size10.size5,.katex .sizing.reset-size10.size5{font-size:.4339440694em}.katex .fontsize-ensurer.reset-size10.size6,.katex .sizing.reset-size10.size6{font-size:.4821600771em}.katex .fontsize-ensurer.reset-size10.size7,.katex .sizing.reset-size10.size7{font-size:.5785920926em}.katex .fontsize-ensurer.reset-size10.size8,.katex .sizing.reset-size10.size8{font-size:.6943105111em}.katex .fontsize-ensurer.reset-size10.size9,.katex .sizing.reset-size10.size9{font-size:.8331726133em}.katex .fontsize-ensurer.reset-size10.size10,.katex .sizing.reset-size10.size10{font-size:1em}.katex .fontsize-ensurer.reset-size10.size11,.katex .sizing.reset-size10.size11{font-size:1.1996142719em}.katex .fontsize-ensurer.reset-size11.size1,.katex .sizing.reset-size11.size1{font-size:.2009646302em}.katex .fontsize-ensurer.reset-size11.size2,.katex .sizing.reset-size11.size2{font-size:.2411575563em}.katex .fontsize-ensurer.reset-size11.size3,.katex .sizing.reset-size11.size3{font-size:.2813504823em}.katex .fontsize-ensurer.reset-size11.size4,.katex .sizing.reset-size11.size4{font-size:.3215434084em}.katex .fontsize-ensurer.reset-size11.size5,.katex .sizing.reset-size11.size5{font-size:.3617363344em}.katex .fontsize-ensurer.reset-size11.size6,.katex .sizing.reset-size11.size6{font-size:.4019292605em}.katex .fontsize-ensurer.reset-size11.size7,.katex .sizing.reset-size11.size7{font-size:.4823151125em}.katex .fontsize-ensurer.reset-size11.size8,.katex .sizing.reset-size11.size8{font-size:.578778135em}.katex .fontsize-ensurer.reset-size11.size9,.katex .sizing.reset-size11.size9{font-size:.6945337621em}.katex .fontsize-ensurer.reset-size11.size10,.katex .sizing.reset-size11.size10{font-size:.8336012862em}.katex .fontsize-ensurer.reset-size11.size11,.katex .sizing.reset-size11.size11{font-size:1em}.katex .delimsizing.size1{font-family:KaTeX_Size1}.katex .delimsizing.size2{font-family:KaTeX_Size2}.katex .delimsizing.size3{font-family:KaTeX_Size3}.katex .delimsizing.size4{font-family:KaTeX_Size4}.katex .delimsizing.mult .delim-size1>span{font-family:KaTeX_Size1}.katex .delimsizing.mult .delim-size4>span{font-family:KaTeX_Size4}.katex .nulldelimiter{display:inline-block;width:.12em}.katex .delimcenter,.katex .op-symbol{position:relative}.katex .op-symbol.small-op{font-family:KaTeX_Size1}.katex .op-symbol.large-op{font-family:KaTeX_Size2}.katex .accent>.vlist-t,.katex .op-limits>.vlist-t{text-align:center}.katex .accent .accent-body{position:relative}.katex .accent .accent-body:not(.accent-full){width:0}.katex .overlay{display:block}.katex .mtable .vertical-separator{display:inline-block;min-width:1px}.katex .mtable .arraycolsep{display:inline-block}.katex .mtable .col-align-c>.vlist-t{text-align:center}.katex .mtable .col-align-l>.vlist-t{text-align:left}.katex .mtable .col-align-r>.vlist-t{text-align:right}.katex .svg-align{text-align:left}.katex svg{fill:currentColor;stroke:currentColor;fill-rule:nonzero;fill-opacity:1;stroke-width:1;stroke-linecap:butt;stroke-linejoin:miter;stroke-miterlimit:4;stroke-dasharray:none;stroke-dashoffset:0;stroke-opacity:1;display:block;height:inherit;position:absolute;width:100%}.katex svg path{stroke:none}.katex img{border-style:none;max-height:none;max-width:none;min-height:0;min-width:0}.katex .stretchy{display:block;overflow:hidden;position:relative;width:100%}.katex .stretchy:after,.katex .stretchy:before{content:""}.katex .hide-tail{overflow:hidden;position:relative;width:100%}.katex .halfarrow-left{left:0;overflow:hidden;position:absolute;width:50.2%}.katex .halfarrow-right{overflow:hidden;position:absolute;right:0;width:50.2%}.katex .brace-left{left:0;overflow:hidden;position:absolute;width:25.1%}.katex .brace-center{left:25%;overflow:hidden;position:absolute;width:50%}.katex .brace-right{overflow:hidden;position:absolute;right:0;width:25.1%}.katex .x-arrow-pad{padding:0 .5em}.katex .cd-arrow-pad{padding:0 .55556em 0 .27778em}.katex .mover,.katex .munder,.katex .x-arrow{text-align:center}.katex .boxpad{padding:0 .3em}.katex .fbox,.katex .fcolorbox{border:.04em solid;box-sizing:border-box}.katex .cancel-pad{padding:0 .2em}.katex .cancel-lap{margin-left:-.2em;margin-right:-.2em}.katex .sout{border-bottom-style:solid;border-bottom-width:.08em}.katex .angl{border-right:.049em solid;border-top:.049em solid;box-sizing:border-box;margin-right:.03889em}.katex .anglpad{padding:0 .03889em}.katex .eqn-num:before{content:"(" counter(katexEqnNo) ")";counter-increment:katexEqnNo}.katex .mml-eqn-num:before{content:"(" counter(mmlEqnNo) ")";counter-increment:mmlEqnNo}.katex .mtr-glue{width:50%}.katex .cd-vert-arrow{display:inline-block;position:relative}.katex .cd-label-left{display:inline-block;position:absolute;right:calc(50% + .3em);text-align:left}.katex .cd-label-right{display:inline-block;left:calc(50% + .3em);position:absolute;text-align:right}.katex-display{display:block;margin:1em 0;text-align:center}.katex-display>.katex{display:block;text-align:center;white-space:nowrap}.katex-display>.katex>.katex-html{display:block;position:relative}.katex-display>.katex>.katex-html>.tag{position:absolute;right:0}.katex-display.leqno>.katex>.katex-html>.tag{left:0;right:auto}.katex-display.fleqn>.katex{padding-left:2em;text-align:left}body{counter-reset:katexEqnNo mmlEqnNo}', xAe = ".custom-floating-menu{position:absolute;z-index:50}.editor-toolbar{display:flex;align-items:center;flex-wrap:wrap;gap:2px;padding:6px 8px;border-bottom:1px solid #e2e8f0;background:#fafafa;flex-shrink:0;z-index:10}.toolbar-group{display:flex;align-items:center;gap:2px}.toolbar-divider{width:1px;height:20px;background:#e5e7eb;margin:0 6px;flex-shrink:0}.toolbar-btn{display:inline-flex;align-items:center;justify-content:center;min-width:28px;height:28px;padding:0 6px;border:1px solid transparent;border-radius:6px;background:transparent;color:#4b5563;font-size:13px;font-weight:600;line-height:1;cursor:pointer;transition:background-color .12s,color .12s}.toolbar-btn:hover{background:#f3f4f6;color:#111827}.toolbar-btn.is-active{background:#e0e7ff;color:#4338ca}.toolbar-btn:disabled{opacity:.4;cursor:not-allowed}.toolbar-btn:focus-visible{outline:2px solid #6366f1;outline-offset:1px}.toolbar-btn svg{display:block}.toolbar-glyph{font-family:Georgia,Times New Roman,serif;font-size:14px;line-height:1}.toolbar-glyph-italic{font-style:italic}.toolbar-glyph-underline{text-decoration:underline}.toolbar-glyph-strike{text-decoration:line-through}.toolbar-select{height:28px;border:1px solid #e2e8f0;border-radius:6px;background:#fff;color:#374151;font-size:12px;padding:0 4px;cursor:pointer}.toolbar-select:focus-visible{outline:2px solid #6366f1;outline-offset:1px}.toolbar-clear-btn{border:none;background:transparent;color:#6b7280;font-size:11px;font-weight:600;padding:4px 8px;border-radius:999px;cursor:pointer;white-space:nowrap}.toolbar-clear-btn:hover{background:#f3f4f6;color:#374151}.is-dark .toolbar-clear-btn{color:#9ca3af}.is-dark .toolbar-clear-btn:hover{background:#374151;color:#f9fafb}.is-dark .editor-toolbar{background:#1f2937;border-bottom-color:#374151}.is-dark .toolbar-divider{background:#374151}.is-dark .toolbar-btn{color:#d1d5db}.is-dark .toolbar-btn:hover{background:#374151;color:#f9fafb}.is-dark .toolbar-btn.is-active{background:#3730a3;color:#e0e7ff}.is-dark .toolbar-select{background:#1f2937;border-color:#374151;color:#d1d5db}.editor-toolbar .table-icon-button{width:28px;height:28px}";
var MI = class extends Error {
  constructor(t) {
    super(t), this.name = "ImageUploadConfigValidationError";
  }
};
function IN(t) {
  try {
    let e = new URL(t);
    return e.protocol === "http:" || e.protocol === "https:";
  } catch {
    return !1;
  }
}
function GAe(t) {
  let { imageUploadCallbackUrl: e, imageUploadConfig: A } = t;
  if (A && e && console.warn("[extension-import-docx] Both `imageUploadConfig` and `imageUploadCallbackUrl` were provided. `imageUploadConfig` takes precedence. Remove `imageUploadCallbackUrl` to silence this warning."), A) {
    if (typeof A.url != "string" || A.url.trim() === "") throw new MI("[extension-import-docx] `imageUploadConfig.url` must be a non-empty string.");
    if (!IN(A.url)) throw new MI(`[extension-import-docx] \`imageUploadConfig.url\` must be a valid HTTP or HTTPS URL. Received: "${A.url}"`);
    return A;
  }
  if (e) {
    if (!IN(e)) throw new MI(`[extension-import-docx] \`imageUploadCallbackUrl\` must be a valid HTTP or HTTPS URL. Received: "${e}"`);
    return { url: e };
  }
}
function Hv({ json: t, validMarks: e, validNodes: A, options: n, rewrittenContent: s = [] }) {
  return t.marks && Array.isArray(t.marks) && (t.marks = t.marks.filter((r) => {
    let i = typeof r == "string" ? r : r.type;
    return e.has(i) ? !0 : (s.push({ original: JSON.parse(JSON.stringify(t)), unsupported: i }), !1);
  })), t.content && Array.isArray(t.content) && (t.content = t.content.map((r) => Hv({ json: r, validMarks: e, validNodes: A, options: n, rewrittenContent: s }).json).filter((r) => r != null)), t.type && !A.has(t.type) ? t.content && Array.isArray(t.content) ? (s.push({ original: JSON.parse(JSON.stringify(t)), unsupported: t.type }), t.type = "paragraph", { json: t, rewrittenContent: s }) : { json: null, rewrittenContent: s } : { json: t, rewrittenContent: s };
}
function zAe(t, e, A) {
  return Hv({ json: t, validNodes: new Set(Object.keys(e.nodes)), validMarks: new Set(Object.keys(e.marks)), options: A });
}
var CN = "https://api.tiptap.dev/v2/convert", UAe = tt.create({ name: "import-docx", addOptions() {
  return { endpoint: CN, token: "", appId: "", imageUploadCallbackUrl: void 0, imageUploadConfig: void 0, verbose: 0 };
}, addCommands() {
  return { importDocx: (t) => () => {
    let { file: e } = t, { onImport: A } = t, n = `${this.options.endpoint || CN}/import/docx`, s = new FormData();
    s.append("file", e);
    let r = GAe({ imageUploadCallbackUrl: this.options.imageUploadCallbackUrl, imageUploadConfig: this.options.imageUploadConfig });
    r && s.append("imageUploadConfig", JSON.stringify(r)), this.options.prosemirrorNodes && s.append("prosemirrorNodes", JSON.stringify(this.options.prosemirrorNodes)), this.options.prosemirrorMarks && s.append("prosemirrorMarks", JSON.stringify(this.options.prosemirrorMarks)), this.options.verbose && s.append("verbose", this.options.verbose.toString());
    let i = new URL(n);
    return fetch(i.href, { method: "POST", body: s, headers: { Authorization: `Bearer ${this.options.token}`, "X-App-Id": this.options.appId, "X-Tiptap-Extension": "import-docx" } }).then((o) => {
      if (!o.ok) throw new Error(o.statusText);
      return o.json();
    }).then((o) => {
      var a, c, l, B, g, h, u, d;
      let w = { header: (a = o.data.header) != null ? a : null, footer: (c = o.data.footer) != null ? c : null, headerFirstPage: (l = o.data.headerFirstPage) != null ? l : null, footerFirstPage: (B = o.data.footerFirstPage) != null ? B : null, headerOdd: (g = o.data.headerOdd) != null ? g : null, footerOdd: (h = o.data.footerOdd) != null ? h : null, headerEven: (u = o.data.headerEven) != null ? u : null, footerEven: (d = o.data.footerEven) != null ? d : null }, Q = (M) => {
        this.editor.extensionManager.extensions.some((I) => I.name === "pages") && (M.header && this.editor.commands.setHeader(M.header), M.footer && this.editor.commands.setFooter(M.footer), (M.headerFirstPage || M.footerFirstPage) && (this.editor.commands.setDifferentFirstPage(!0), M.headerFirstPage && this.editor.commands.setHeaderFirstPage(M.headerFirstPage), M.footerFirstPage && this.editor.commands.setFooterFirstPage(M.footerFirstPage)), (M.headerOdd || M.headerEven || M.footerOdd || M.footerEven) && (this.editor.commands.setDifferentOddEven(!0), M.headerOdd && this.editor.commands.setHeaderOdd(M.headerOdd), M.headerEven && this.editor.commands.setHeaderEven(M.headerEven), M.footerOdd && this.editor.commands.setFooterOdd(M.footerOdd), M.footerEven && this.editor.commands.setFooterEven(M.footerEven)));
      }, p = (M = o.data.content) => {
        try {
          let { json: I, rewrittenContent: N } = zAe(M, this.editor.schema);
          N.length, this.editor.commands.setContent(I), Q(w);
        } catch (I) {
          throw console.error(I), I;
        }
      };
      return A ? A({ content: o.data.content, logs: o.logs, error: null, setEditorContent: p, ...w }) : p();
    }).catch((o) => {
      let a = o instanceof Error ? o : new Error(String(o));
      if (A) A({ content: null, error: a });
      else throw a;
    }), !0;
  } };
} }), bAe = (t, e) => () => (e || (t((e = { exports: {} }).exports, e, e.exports), t = null), e.exports);
function eh(t) {
  "@babel/helpers - typeof";
  return eh = typeof Symbol == "function" && typeof Symbol.iterator == "symbol" ? function(e) {
    return typeof e;
  } : function(e) {
    return e && typeof Symbol == "function" && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
  }, eh(t);
}
function vAe(t, e) {
  if (eh(t) != "object" || !t) return t;
  var A = t[Symbol.toPrimitive];
  if (A !== void 0) {
    var n = A.call(t, e);
    if (eh(n) != "object") return n;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (e === "string" ? String : Number)(t);
}
function jAe(t) {
  var e = vAe(t, "string");
  return eh(e) == "symbol" ? e : e + "";
}
function T(t, e, A) {
  return (e = jAe(e)) in t ? Object.defineProperty(t, e, {
    value: A,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = A, t;
}
var yh = class {
  /**
  * Creates a new BaseXmlComponent with the specified XML element name.
  *
  * @param rootKey - The XML element name (e.g., "w:p", "w:r", "w:t")
  */
  constructor(t) {
    T(
      this,
      /** The XML element name for this component (e.g., "w:p" for paragraph). */
      "rootKey",
      void 0
    ), this.rootKey = t;
  }
  /**
  * The components written in this one's place, one after another, when it can't be written as a single element,
  * such as a run with another run in its children. Undefined when it is written as itself.
  *
  * @internal
  */
  get writtenAs() {
  }
}, kv = (t) => t instanceof yh || typeof t == "object" && t !== null && typeof t.prepForXml == "function", lf = (t) => kv(t) ? t.rootKey : void 0, HAe = Object.seal({}), Z = class extends yh {
  /**
  * Creates a new XmlComponent.
  *
  * @param rootKey - The XML element name (e.g., "w:p", "w:r", "w:t")
  */
  constructor(t) {
    super(t), T(
      this,
      /**
      * Array of child components, text nodes, and attributes.
      *
      * This array forms the content of the XML element. It can contain other
      * XmlComponents, string values (text nodes), or attribute components.
      */
      "root",
      void 0
    ), this.root = new Array();
  }
  /**
  * Prepares this component and its children for XML serialization.
  *
  * This method is called by the Formatter to convert the component tree into
  * an object structure compatible with the xml library (https://www.npmjs.com/package/xml).
  * It recursively processes all children and handles special cases like
  * attribute-only elements and empty elements.
  *
  * The method can be overridden by subclasses to customize XML representation
  * or execute side effects during serialization (e.g., creating relationships).
  *
  * @param context - The serialization context containing document state
  * @returns The XML-serializable object, or undefined to exclude from output
  *
  * @example
  * ```typescript
  * // Override to add custom serialization logic
  * prepForXml(context: IContext): IXmlableObject | undefined {
  *   // Custom logic here
  *   return super.prepForXml(context);
  * }
  * ```
  */
  prepForXml(t) {
    var e;
    t.stack.push(this);
    const A = this.root.flatMap((n) => {
      if (kv(n)) {
        const s = n.writtenAs;
        return s ? s.map((r) => r.prepForXml(t)) : n.prepForXml(t);
      }
      return n;
    }).filter((n) => n !== void 0);
    return t.stack.pop(), { [this.rootKey]: A.length ? A.length === 1 && (!((e = A[0]) === null || e === void 0) && e._attr) ? A[0] : A : HAe };
  }
  /**
  * Adds a child element to this component.
  *
  * @deprecated Do not use this method. It is only used internally by the library. It will be removed in a future version.
  * @param child - The child component or text string to add
  * @returns This component (for chaining)
  */
  addChildElement(t) {
    return this.root.push(t), this;
  }
}, ro = class extends Z {
  constructor(t, e) {
    super(t), T(this, "includeIfEmpty", void 0), this.includeIfEmpty = e;
  }
  /**
  * Prepares the component for XML serialization, excluding it if empty.
  *
  * @param context - The serialization context
  * @returns The XML-serializable object, or undefined if empty
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    return this.includeIfEmpty || e && (typeof e[this.rootKey] != "object" || Object.keys(e[this.rootKey]).length) ? e : void 0;
  }
};
function EN(t, e) {
  var A = Object.keys(t);
  if (Object.getOwnPropertySymbols) {
    var n = Object.getOwnPropertySymbols(t);
    e && (n = n.filter(function(s) {
      return Object.getOwnPropertyDescriptor(t, s).enumerable;
    })), A.push.apply(A, n);
  }
  return A;
}
function oe(t) {
  for (var e = 1; e < arguments.length; e++) {
    var A = arguments[e] != null ? arguments[e] : {};
    e % 2 ? EN(Object(A), !0).forEach(function(n) {
      T(t, n, A[n]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t, Object.getOwnPropertyDescriptors(A)) : EN(Object(A)).forEach(function(n) {
      Object.defineProperty(t, n, Object.getOwnPropertyDescriptor(A, n));
    });
  }
  return t;
}
var Le = class extends yh {
  /**
  * Creates a new attribute component.
  *
  * @param root - The attribute data object
  */
  constructor(t) {
    super("_attr"), T(this, "root", void 0), T(
      this,
      /** Optional mapping from property names to XML attribute names. */
      "xmlKeys",
      void 0
    ), this.root = t;
  }
  /**
  * Converts the attribute data to an XML-serializable object.
  *
  * This method transforms the property names using xmlKeys (if defined)
  * and filters out undefined values.
  *
  * @param _ - Context (unused for attributes)
  * @returns Object with _attr key containing the mapped attributes
  */
  prepForXml(t) {
    const e = {};
    return Object.entries(this.root).forEach(([A, n]) => {
      if (n !== void 0) {
        const s = this.xmlKeys && this.xmlKeys[A] || A;
        e[s] = n;
      }
    }), { _attr: e };
  }
}, Gm = class extends yh {
  /**
  * Creates a new NextAttributeComponent.
  *
  * @param root - Attribute payload with explicit key-value mappings
  */
  constructor(t) {
    super("_attr"), T(this, "root", void 0), this.root = t;
  }
  /**
  * Converts the attribute payload to an XML-serializable object.
  *
  * Extracts the key and value from each property and filters out
  * undefined values.
  *
  * @param _ - Context (unused for attributes)
  * @returns Object with _attr key containing the attributes
  */
  prepForXml(t) {
    return { _attr: Object.values(this.root).filter(({ value: e }) => e !== void 0).reduce((e, { key: A, value: n }) => oe(oe({}, e), {}, { [A]: n }), {}) };
  }
}, jn = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      val: "w:val",
      color: "w:color",
      fill: "w:fill",
      space: "w:space",
      sz: "w:sz",
      type: "w:type",
      rsidR: "w:rsidR",
      rsidRPr: "w:rsidRPr",
      rsidSect: "w:rsidSect",
      w: "w:w",
      h: "w:h",
      top: "w:top",
      right: "w:right",
      bottom: "w:bottom",
      left: "w:left",
      header: "w:header",
      footer: "w:footer",
      gutter: "w:gutter",
      linePitch: "w:linePitch",
      pos: "w:pos"
    });
  }
};
function kAe(t, e) {
  if (t == null) return {};
  var A = {};
  for (var n in t) if ({}.hasOwnProperty.call(t, n)) {
    if (e.includes(n)) continue;
    A[n] = t[n];
  }
  return A;
}
function zm(t, e) {
  if (t == null) return {};
  var A, n, s = kAe(t, e);
  if (Object.getOwnPropertySymbols) {
    var r = Object.getOwnPropertySymbols(t);
    for (n = 0; n < r.length; n++) A = r[n], e.includes(A) || {}.propertyIsEnumerable.call(t, A) && (s[A] = t[A]);
  }
  return s;
}
var RAe = ["elements"], LAe = /* @__PURE__ */ new Map([
  ["amp", "&"],
  ["lt", "<"],
  ["gt", ">"],
  ["quot", '"'],
  ["apos", "'"]
]), SAe = /&([^;]*);?/g, Rv = (t) => t.indexOf("&") === -1 ? t : t.replace(SAe, (e, A) => {
  if (!e.endsWith(";")) throw new Error(`Invalid XML: "&" that starts no entity, in "${t}"`);
  const n = LAe.get(A);
  if (n !== void 0) return n;
  const s = /^#x[0-9a-f]+$/i.test(A) ? parseInt(A.slice(2), 16) : /^#[0-9]+$/.test(A) ? parseInt(A.slice(1), 10) : NaN;
  if (!(s > 0 && s <= 1114111)) throw new Error(`Invalid XML: unknown entity "${e}"`);
  return String.fromCodePoint(s);
}), uu = (t) => t === " " || t === `
` || t === "	" || t === "\r", TAe = /([\w:-]+)\s*=\s*(?:"([^"]*)"|'([^']*)')/g, JAe = (t) => Object.fromEntries([...t.matchAll(TAe)].map(([, e, A, n]) => [e, A ?? n])), Lv = (t, { keepWhitespaceText: e = !1 } = {}) => {
  const A = {}, n = [];
  let s = t.charCodeAt(0) === 65279 ? 1 : 0;
  for (; s < t.length && uu(t[s]); ) s++;
  const r = (B) => {
    var g;
    const h = n.length === 0 ? A : n[n.length - 1];
    ((g = h.elements) !== null && g !== void 0 ? g : h.elements = []).push(B);
  }, i = (B) => {
    if (B.trim() === "") {
      B !== "" && e && r({
        type: "text",
        text: B
      });
      return;
    }
    if (n.length === 0) throw new Error(`Invalid XML: text outside of the root element, "${B.trim()}"`);
    r({
      type: "text",
      text: Rv(B)
    });
  }, o = (B, g, h) => {
    const u = t.indexOf(B, g);
    if (u === -1) throw new Error(`Invalid XML: ${h} that isn't closed`);
    return u;
  };
  for (; s < t.length; ) {
    const B = t.indexOf("<", s);
    if (i(t.slice(s, B === -1 ? t.length : B)), B === -1) break;
    if (t.startsWith("<?", B)) {
      const g = o("?>", B + 2, "processing instruction"), h = t.slice(B + 2, g), u = h.search(/\s/), d = u === -1 ? h : h.slice(0, u), w = u === -1 ? "" : h.slice(u).trimStart();
      if (d.toLowerCase() === "xml") {
        const Q = JAe(w);
        A.declaration = Object.keys(Q).length > 0 ? { attributes: Q } : {};
      } else r({
        type: "instruction",
        name: d,
        instruction: w
      });
      s = g + 2;
    } else if (t.startsWith("<!--", B)) {
      const g = o("-->", B + 4, "comment"), h = t.slice(B + 4, g);
      h !== "" && r({
        type: "comment",
        comment: h
      }), s = g + 3;
    } else if (t.startsWith("<![CDATA[", B)) {
      const g = o("]]>", B + 9, "CDATA section"), h = t.slice(B + 9, g);
      h !== "" && r({
        type: "cdata",
        cdata: h
      }), s = g + 3;
    } else if (t.startsWith("<!DOCTYPE", B)) {
      let g = B + 9, h, u = !1;
      for (; g < t.length; g++) {
        const d = t[g];
        if (h !== void 0) h = d === h ? void 0 : h;
        else if (d === '"' || d === "'") h = d;
        else if (d === "[") u = !0;
        else if (d === "]") u = !1;
        else if (d === ">" && !u) break;
      }
      if (g === t.length) throw new Error("Invalid XML: DOCTYPE that isn't closed");
      r({
        type: "doctype",
        doctype: t.slice(B + 9, g).replace(/^ /, "")
      }), s = g + 1;
    } else if (t.startsWith("</", B)) {
      const g = o(">", B + 2, "closing tag"), h = t.slice(B + 2, g).trimEnd(), u = n.pop();
      if ((u == null ? void 0 : u.name) !== h) {
        var a;
        throw new Error(`Invalid XML: closing tag </${h}> doesn't match <${(a = u == null ? void 0 : u.name) !== null && a !== void 0 ? a : ""}>`);
      }
      s = g + 1;
    } else s = WAe(t, B + 1, (g, h) => {
      r(g), h || n.push(g);
    });
  }
  if (n.length > 0) throw new Error(`Invalid XML: <${n[n.length - 1].name}> isn't closed`);
  const { elements: c } = A, l = zm(A, RAe);
  return c === void 0 ? l : oe(oe({}, l), {}, { elements: c });
}, WAe = (t, e, A) => {
  let n = e;
  for (; n < t.length && !uu(t[n]) && t[n] !== "/" && t[n] !== ">"; ) n++;
  const s = t.slice(e, n);
  if (s === "") throw new Error("Invalid XML: tag without a name");
  const r = [];
  let i = n;
  for (; ; ) {
    for (; i < t.length && uu(t[i]); ) i++;
    if (i >= t.length) throw new Error(`Invalid XML: <${s}> that isn't closed`);
    if (t[i] === ">" || t.startsWith("/>", i)) {
      const g = t[i] === "/";
      return A(oe({
        type: "element",
        name: s
      }, r.length > 0 ? { attributes: Object.fromEntries(r) } : {}), g), i + (g ? 2 : 1);
    }
    const o = t.indexOf("=", i), a = t.slice(i, o === -1 ? t.length : o).trimEnd();
    if (o === -1 || a === "" || /[\s/>]/.test(a)) throw new Error(`Invalid XML: attribute of <${s}> without a value`);
    let c = o + 1;
    for (; c < t.length && uu(t[c]); ) c++;
    const l = t[c];
    if (l !== '"' && l !== "'") throw new Error(`Invalid XML: value of ${a} on <${s}> isn't quoted`);
    const B = t.indexOf(l, c + 1);
    if (B === -1) throw new Error(`Invalid XML: value of ${a} on <${s}> isn't closed`);
    r.some(([g]) => g === a) || r.push([a, Rv(t.slice(c + 1, B))]), i = B + 1;
  }
}, OAe = /* @__PURE__ */ new Map([
  ["&", "&amp;"],
  ['"', "&quot;"],
  ["'", "&apos;"],
  ["<", "&lt;"],
  [">", "&gt;"]
]), LE = (t) => t.replace(/[&"'<>\x00-\x08\x0B\x0C\x0E-\x1F]/g, (e) => {
  var A;
  return (A = OAe.get(e)) !== null && A !== void 0 ? A : "";
}), pI = (t) => typeof t == "string" ? LE(t) : t, Sv = (t, e, A) => {
  const n = Object.keys(t)[0], s = n === void 0 ? void 0 : t[n], r = [], i = [], o = (a) => {
    for (const [c, l] of Object.entries(a)) r.push(`${c}="${String(pI(l))}"`);
  };
  if (typeof s == "object") {
    if (s !== null) {
      const { _attr: a, _cdata: c } = s;
      if (a && o(a), c && i.push(`<![CDATA[${c.replace(/\]\]>/g, "]]]]><![CDATA[>")}]]>`), Array.isArray(s)) {
        let l = !1;
        i.push("");
        for (const B of s) typeof B == "object" ? Object.keys(B)[0] === "_attr" ? o(B._attr) : i.push(Sv(B, e, A + 1)) : (i.pop(), l = !0, i.push(pI(B)));
        l || i.push("");
      }
    }
  } else i.push(pI(s));
  return {
    name: n,
    attributes: r,
    content: i,
    indents: A > 1 ? e.repeat(A - 1) : ""
  };
}, Tv = (t, e, A) => {
  if (typeof t != "object") return String(t);
  const { name: n, attributes: s, content: r, indents: i } = t, { length: o } = r, a = i + (n ? `<${n}` : "") + (s.length > 0 ? ` ${s.join(" ")}` : "") + (o > 0 ? n ? ">" : "" : "/>") + (e && o > 1 ? `
` : "");
  return o === 0 ? a + (e ? `
` : "") : a + r.map((c) => c === void 0 ? "" : Tv(c, e, !1)).join("") + (o > 1 ? i : "") + (n ? `</${n}>` : "") + (e && !A ? `
` : "");
}, yt = (t, { indent: e = "", declaration: A } = {}) => {
  const n = Array.isArray(t) ? t : [t], s = e ? 1 : 0, r = A != null && A.standalone ? ` standalone="${LE(A.standalone)}"` : "";
  return (A === void 0 ? "" : `<?xml version="1.0" encoding="${LE(A.encoding || "UTF-8")}"${r}?>${e ? `
` : ""}`) + n.map((i, o) => Tv(Sv(i, e, s), e, o === n.length - 1)).join("");
}, Um = (t) => {
  switch (t.type) {
    case void 0:
    case "element":
      const e = new KAe(t.name, t.attributes), A = t.elements || [];
      for (const n of A) {
        const s = Um(n);
        s !== void 0 && e.push(s);
      }
      return e;
    case "text":
      return t.text;
    default:
      return;
  }
}, PAe = class extends Le {
}, KAe = class extends Z {
  /**
  * Parses an XML string and converts it to an ImportedXmlComponent tree.
  *
  * This static method is the primary way to import external XML content.
  * It parses the XML string into an {@link XmlElement} tree,
  * then converts that into a tree of XmlComponent objects.
  *
  * The component is for the parsed document, with the XML's element in it, and is written as that element, with no
  * element of its own around it.
  *
  * @param importedContent - The XML content as a string
  * @returns An ImportedXmlComponent representing the parsed XML
  *
  * @example
  * ```typescript
  * const xml = '<w:p><w:r><w:t>Hello</w:t></w:r></w:p>';
  * const component = ImportedXmlComponent.fromXmlString(xml);
  * ```
  */
  static fromXmlString(t) {
    return Um(Lv(t));
  }
  /**
  * Creates an ImportedXmlComponent.
  *
  * @param rootKey - The XML element name
  * @param _attr - Optional attributes for the root element
  */
  constructor(t, e) {
    super(t), e && this.root.push(new PAe(e));
  }
  /**
  * Adds a child component or text to this element.
  *
  * @param xmlComponent - The child component or text string to add
  */
  push(t) {
    this.root.push(t);
  }
  /**
  * A component of no element, such as the one {@link fromXmlString} gives for the parsed document, is written as the
  * elements in it. Written as itself, it would be an `<undefined>` element, which Word can't open.
  *
  * The component itself is still returned, rather than its element, because code written for earlier versions takes
  * the element from its children.
  *
  * @internal
  */
  get writtenAs() {
    return this.rootKey === void 0 ? this.root.filter((t) => typeof t != "string") : void 0;
  }
  /**
  * Prepares this element for XML serialization. A component of no element written by itself, rather than among a
  * parent's children, such as by the formatter or by an earlier copy of docx, is written as the one element in it.
  *
  * @param context - The serialization context
  * @returns The XML-serializable object
  */
  prepForXml(t) {
    const e = this.writtenAs;
    return (e == null ? void 0 : e.length) === 1 ? e[0].prepForXml(t) : super.prepForXml(t);
  }
}, VAe = class extends Z {
  /**
  * Creates an ImportedRootElementAttributes component.
  *
  * @param _attr - The attributes object to pass through
  */
  constructor(t) {
    super(""), T(this, "_attr", void 0), this._attr = t;
  }
  /**
  * Prepares the attributes for XML serialization.
  *
  * @param _ - Context (unused)
  * @returns Object with _attr key containing the raw attributes
  */
  prepForXml(t) {
    return { _attr: this._attr };
  }
}, Jv = class extends Z {
  /**
  * Creates a new InitializableXmlComponent.
  *
  * @param rootKey - The XML element name
  * @param initComponent - Optional component to copy children from
  */
  constructor(t, e) {
    super(t), e && (this.root = e.root);
  }
}, hA = (t) => {
  if (!Number.isFinite(t)) throw new Error(`Invalid value '${t}' specified. Must be an integer.`);
  return Math.floor(t);
}, Bf = (t) => {
  const e = hA(t);
  if (e < 0) throw new Error(`Invalid value '${t}' specified. Must be a positive integer.`);
  return e;
}, Wv = (t, e) => {
  const A = e * 2;
  if (t.length !== A || isNaN(+`0x${t}`)) throw new Error(`Invalid hex value '${t}'. Expected ${A} digit hex value`);
  return t;
}, MN = (t) => Wv(t, 1), bm = (t) => {
  const e = t.slice(-2), A = t.substring(0, t.length - 2);
  return `${Number(A)}${e}`;
}, XAe = {
  in: 1440,
  cm: 1440 / 2.54,
  mm: 1440 / 25.4,
  pt: 20,
  pc: 240,
  pi: 240
}, xo = (t) => {
  if (typeof t == "number") return t;
  const e = t.slice(-2), A = Number(t.substring(0, t.length - 2)), n = XAe[e];
  if (n === void 0 || Number.isNaN(A)) throw new Error(`Invalid universal measure '${t}'. Expected a number followed by mm, cm, in, pt, pc or pi.`);
  return A * n;
}, Ov = (t) => {
  const e = bm(t);
  if (parseFloat(e) < 0) throw new Error(`Invalid value '${e}' specified. Expected a positive number.`);
  return e;
}, Pv = (t) => t === "auto" ? t : Wv(t.charAt(0) === "#" ? t.substring(1) : t, 3), Gr = (t) => typeof t == "string" ? bm(t) : hA(t), ZAe = (t) => typeof t == "string" ? Ov(t) : Bf(t), UA = (t) => typeof t == "string" ? Ov(t) : Bf(t), qAe = (t) => {
  const e = t.substring(0, t.length - 1);
  return `${Number(e)}%`;
}, Kv = (t) => typeof t == "number" ? hA(t) : t.slice(-1) === "%" ? qAe(t) : bm(t), _Ae = Bf, $Ae = Bf, ene = (t) => t.toISOString(), ce = class extends Z {
  /**
  * Creates an OnOffElement.
  *
  * @param name - The XML element name (e.g., "w:b", "w:i")
  * @param val - The boolean value (defaults to true)
  */
  constructor(t, e = !0) {
    super(t), e !== !0 && this.root.push(new jn({ val: e }));
  }
}, mI = class extends Z {
  /**
  * Creates an HpsMeasureElement.
  *
  * @param name - The XML element name
  * @param val - The measurement value (number in half-points or string with units)
  */
  constructor(t, e) {
    super(t), this.root.push(new jn({ val: ZAe(e) }));
  }
}, Vv = class extends Z {
}, Oo = class extends Z {
  /**
  * Creates a StringValueElement.
  *
  * @param name - The XML element name
  * @param val - The string value
  */
  constructor(t, e) {
    super(t), this.root.push(new jn({ val: e }));
  }
}, aB = (t, e) => new K({
  name: t,
  attributes: { value: {
    key: "w:val",
    value: e
  } }
}), rg = class extends Z {
  /**
  * Creates a NumberValueElement.
  *
  * @param name - The XML element name
  * @param val - The numeric value
  */
  constructor(t, e) {
    super(t), this.root.push(new jn({ val: e }));
  }
}, Fa = class extends Z {
  /**
  * Creates a StringContainer.
  *
  * @param name - The XML element name
  * @param val - The text content
  */
  constructor(t, e) {
    super(t), this.root.push(e);
  }
}, K = class extends Z {
  /**
  * Creates a BuilderElement with the specified configuration.
  *
  * @param config - Element configuration
  * @param config.name - The XML element name
  * @param config.attributes - Optional attributes with explicit key-value pairs
  * @param config.children - Optional child elements
  */
  constructor({ name: t, attributes: e, children: A }) {
    super(t), e && this.root.push(new Gm(e)), A && this.root.push(...A);
  }
}, bt = {
  /** Align Start: the left in a left-to-right paragraph, and the right in a `bidirectional` (right-to-left) paragraph */
  START: "start",
  /** Align Center */
  CENTER: "center",
  /** Align End: the right in a left-to-right paragraph, and the left in a `bidirectional` (right-to-left) paragraph */
  END: "end",
  /** Align Left: a paragraph stays on the left of the page even when it is `bidirectional` (right-to-left) */
  LEFT: "left",
  /** Align Right: a paragraph stays on the right of the page even when it is `bidirectional` (right-to-left) */
  RIGHT: "right",
  /** Justified */
  JUSTIFIED: "both"
}, Xv = (t) => new K({
  name: "w:jc",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), vm = {
  dark1: "dk1",
  light1: "lt1",
  dark2: "dk2",
  light2: "lt2",
  accent1: "accent1",
  accent2: "accent2",
  accent3: "accent3",
  accent4: "accent4",
  accent5: "accent5",
  accent6: "accent6",
  hyperlink: "hlink",
  followedHyperlink: "folHlink"
}, Zv = {
  dark2: "44546A",
  light2: "E7E6E6",
  accent1: "4472C4",
  accent2: "ED7D31",
  accent3: "A5A5A5",
  accent4: "FFC000",
  accent5: "5B9BD5",
  accent6: "70AD47",
  hyperlink: "0563C1",
  followedHyperlink: "954F72"
}, qv = {
  dark1: {
    value: "windowText",
    lastColor: "000000"
  },
  light1: {
    value: "window",
    lastColor: "FFFFFF"
  }
}, _v = (t, e) => {
  if (e === "auto") throw new Error(`Invalid theme color ${t} 'auto'. Expected 6 digit hex value`);
  return Pv(e);
}, $v = (t = {}) => Object.fromEntries(Object.keys(vm).map((e) => {
  const A = t[e], n = e === "dark1" || e === "light1" ? qv[e].lastColor : Zv[e];
  return [e, A === void 0 ? n : _v(e, A)];
})), tne = (t, e) => new K({
  name: "a:srgbClr",
  attributes: { value: {
    key: "val",
    value: _v(t, e)
  } }
}), Ane = (t, e) => {
  const A = e[t], n = t === "dark1" || t === "light1" ? qv[t] : void 0;
  return new K({
    name: `a:${vm[t]}`,
    children: [A === void 0 && n ? new K({
      name: "a:sysClr",
      attributes: {
        value: {
          key: "val",
          value: n.value
        },
        lastColor: {
          key: "lastClr",
          value: n.lastColor
        }
      }
    }) : tne(t, A ?? Zv[t])]
  });
}, nne = (t, e = {}) => new K({
  name: "a:clrScheme",
  attributes: { name: {
    key: "name",
    value: t
  } },
  children: Object.keys(vm).map((A) => Ane(A, e))
}), pN = /* @__PURE__ */ new Set([
  "dark1",
  "light1",
  "dark2",
  "light2",
  "accent1",
  "accent2",
  "accent3",
  "accent4",
  "accent5",
  "accent6",
  "hyperlink",
  "followedHyperlink"
]), sne = /* @__PURE__ */ new Map([
  ["dk1", "dark1"],
  ["lt1", "light1"],
  ["dk2", "dark2"],
  ["lt2", "light2"],
  ["hlink", "hyperlink"],
  ["folHlink", "followedHyperlink"],
  ["text1", "dark1"],
  ["background1", "light1"],
  ["text2", "dark2"],
  ["background2", "light2"]
]), mN = (t, e) => {
  if (!(t >= 0 && t <= 100)) throw new Error(`Invalid ${e} ${t}. Expected a number from 0 to 100`);
  return Math.round(255 * (1 - t / 100));
}, rne = ({ theme: t, lighter: e, darker: A }) => {
  if (!pN.has(t)) {
    const r = sne.get(t);
    throw new Error(`Invalid theme color "${t}". ${r ? `Did you mean "${r}"?` : `Expected one of ${[...pN].join(", ")}`}`);
  }
  if (e !== void 0 && A !== void 0) throw new Error("Invalid theme color. Expected lighter or darker, not both");
  const n = e === void 0 ? void 0 : mN(e, "lighter"), s = A === void 0 ? void 0 : mN(A, "darker");
  return {
    tint: n === 255 ? void 0 : n,
    shade: s === 255 ? void 0 : s
  };
}, ine = (t) => {
  const [e, A, n] = [
    0,
    2,
    4
  ].map((a) => parseInt(t.slice(a, a + 2), 16) / 255), s = Math.max(e, A, n), r = Math.min(e, A, n), i = (s + r) / 2, o = s - r;
  return o === 0 ? {
    hue: 0,
    saturation: 0,
    lightness: i
  } : {
    hue: (s === e ? ((A - n) / o + 6) % 6 : s === A ? (n - e) / o + 2 : (e - A) / o + 4) * 60,
    saturation: o / (1 - Math.abs(2 * i - 1)),
    lightness: i
  };
}, one = ({ hue: t, saturation: e, lightness: A }) => {
  const n = (1 - Math.abs(2 * A - 1)) * e, s = n * (1 - Math.abs(t / 60 % 2 - 1)), [r, i, o] = t < 60 ? [
    n,
    s,
    0
  ] : t < 120 ? [
    s,
    n,
    0
  ] : t < 180 ? [
    0,
    n,
    s
  ] : t < 240 ? [
    0,
    s,
    n
  ] : t < 300 ? [
    s,
    0,
    n
  ] : [
    n,
    0,
    s
  ], a = A - n / 2;
  return [
    r,
    i,
    o
  ].map((c) => Math.floor((c + a) * 255 + 1e-9).toString(16).padStart(2, "0")).join("").toUpperCase();
}, ane = (t, { tint: e, shade: A }) => {
  if (e === void 0 && A === void 0) return t;
  const n = ine(t), s = e === void 0 ? n.lightness * A / 255 : n.lightness * e / 255 + (1 - e / 255);
  return one(oe(oe({}, n), {}, { lightness: s }));
}, YN = (t) => t === void 0 ? void 0 : t.toString(16).padStart(2, "0").toUpperCase(), cne = (t) => typeof t == "string" ? {
  type: "hex",
  value: Pv(t)
} : {
  type: "theme",
  color: t,
  change: rne(t)
}, lne = (t, e) => t.type === "hex" ? { color: t.value } : {
  color: ane(e[t.color.theme], t.change),
  theme: t.color.theme,
  tint: YN(t.change.tint),
  shade: YN(t.change.shade)
}, Bne = $v(), jm = class extends yh {
  /**
  * @throws If a color isn't valid
  */
  constructor(t) {
    super("_attr"), T(this, "attributes", void 0), this.attributes = t.map((e) => "keys" in e ? {
      keys: e.keys,
      color: e.color === void 0 ? void 0 : cne(e.color)
    } : e);
  }
  prepForXml(t) {
    var e, A;
    const n = (e = (A = t.file) === null || A === void 0 || (A = A.Theme) === null || A === void 0 ? void 0 : A.Colors) !== null && e !== void 0 ? e : Bne, s = this.attributes.flatMap((r) => {
      if (!("keys" in r)) return [[r.key, r.value]];
      if (r.color === void 0) return [];
      const { keys: i } = r, o = lne(r.color, n);
      return [
        [i.color, o.color],
        [i.theme, o.theme],
        [i.tint, o.tint],
        [i.shade, o.shade]
      ];
    });
    return { _attr: Object.fromEntries(s.filter(([, r]) => r !== void 0)) };
  }
}, gne = class extends Z {
  constructor(t, e) {
    super(t), this.root.push(new jm(e));
  }
}, Hm = (t, e) => new gne(t, e), Fh = {
  color: "w:color",
  theme: "w:themeColor",
  tint: "w:themeTint",
  shade: "w:themeShade"
}, IA = (t, { color: e, size: A, space: n, style: s }) => Hm(t, [
  {
    key: "w:val",
    value: s
  },
  {
    keys: Fh,
    color: e
  },
  {
    key: "w:sz",
    value: A === void 0 ? void 0 : _Ae(A)
  },
  {
    key: "w:space",
    value: n === void 0 ? void 0 : $Ae(n)
  }
]), gf = {
  /** a single line */
  SINGLE: "single",
  /** no border */
  NONE: "none"
}, hne = class extends ro {
  constructor(t) {
    super("w:pBdr"), t.top && this.root.push(IA("w:top", t.top)), t.left && this.root.push(IA("w:left", t.left)), t.bottom && this.root.push(IA("w:bottom", t.bottom)), t.right && this.root.push(IA("w:right", t.right)), t.between && this.root.push(IA("w:between", t.between));
  }
}, une = class extends Z {
  constructor() {
    super("w:pBdr");
    const t = IA("w:bottom", {
      color: "auto",
      space: 1,
      style: gf.SINGLE,
      size: 6
    });
    this.root.push(t);
  }
}, dne = ({ start: t, end: e, left: A, right: n, hanging: s, firstLine: r, firstLineChars: i }) => new K({
  name: "w:ind",
  attributes: {
    start: {
      key: "w:start",
      value: t === void 0 ? void 0 : Gr(t)
    },
    end: {
      key: "w:end",
      value: e === void 0 ? void 0 : Gr(e)
    },
    left: {
      key: "w:left",
      value: A === void 0 ? void 0 : Gr(A)
    },
    right: {
      key: "w:right",
      value: n === void 0 ? void 0 : Gr(n)
    },
    hanging: {
      key: "w:hanging",
      value: s === void 0 ? void 0 : UA(s)
    },
    firstLine: {
      key: "w:firstLine",
      value: r === void 0 ? void 0 : UA(r)
    },
    firstLineChars: {
      key: "w:firstLineChars",
      value: i === void 0 ? void 0 : hA(i)
    }
  }
}), wne = () => new K({ name: "w:br" }), hf = {
  BEGIN: "begin",
  END: "end",
  SEPARATE: "separate"
}, km = (t, e, A) => new K({
  name: "w:fldChar",
  attributes: {
    type: {
      key: "w:fldCharType",
      value: t
    },
    dirty: {
      key: "w:dirty",
      value: e
    },
    locked: {
      key: "w:fldLock",
      value: A
    }
  }
}), yB = (t, e) => km(hf.BEGIN, t, e), ej = /* @__PURE__ */ new WeakSet(), fne = class extends K {
  constructor() {
    super({
      name: "w:fldChar",
      attributes: {
        type: {
          key: "w:fldCharType",
          value: hf.BEGIN
        },
        dirty: {
          key: "w:dirty",
          value: !0
        }
      }
    });
  }
  prepForXml(t) {
    const e = super.prepForXml(t);
    return ej.add(e), e;
  }
}, tj = () => new fne(), Qne = (t) => typeof t == "object" && t !== null && ej.has(t), Zc = (t) => km(hf.SEPARATE, t), qc = (t) => km(hf.END, t), Pi = {
  DEFAULT: "default",
  PRESERVE: "preserve"
}, Ki = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { space: "xml:space" });
  }
}, Ine = class extends Z {
  constructor() {
    super("w:instrText"), this.root.push(new Ki({ space: Pi.PRESERVE })), this.root.push("PAGE");
  }
}, Cne = class extends Z {
  constructor() {
    super("w:instrText"), this.root.push(new Ki({ space: Pi.PRESERVE })), this.root.push("NUMPAGES");
  }
}, Ene = class extends Z {
  constructor() {
    super("w:instrText"), this.root.push(new Ki({ space: Pi.PRESERVE })), this.root.push("SECTIONPAGES");
  }
}, Mne = class extends Z {
  constructor() {
    super("w:instrText"), this.root.push(new Ki({ space: Pi.PRESERVE })), this.root.push("SECTION");
  }
}, uf = ({ fill: t, color: e, type: A }) => Hm("w:shd", [
  {
    keys: {
      color: "w:fill",
      theme: "w:themeFill",
      tint: "w:themeFillTint",
      shade: "w:themeFillShade"
    },
    color: t
  },
  {
    keys: Fh,
    color: e
  },
  {
    key: "w:val",
    value: A ?? th.CLEAR
  }
]), th = {
  /** Clear shading - no pattern, fill color only */
  CLEAR: "clear"
}, Qs = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      id: "w:id",
      author: "w:author",
      date: "w:date"
    });
  }
}, pne = class extends Z {
  constructor(t) {
    super("w:del"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    }));
  }
}, mne = class extends Z {
  constructor(t) {
    super("w:ins"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    }));
  }
}, Yne = ({ twoLinesInOne: t, brackets: e, horizontalInVertical: A, fitToLine: n, group: s }) => new K({
  name: "w:eastAsianLayout",
  attributes: {
    id: {
      key: "w:id",
      value: s === void 0 ? void 0 : hA(s)
    },
    combine: {
      key: "w:combine",
      value: t
    },
    combineBrackets: {
      key: "w:combineBrackets",
      value: e
    },
    vert: {
      key: "w:vert",
      value: A
    },
    vertCompress: {
      key: "w:vertCompress",
      value: n
    }
  }
}), yne = {
  /** Dot emphasis mark */
  DOT: "dot"
}, Fne = (t = yne.DOT) => new K({
  name: "w:em",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), Nne = "57X6y3wQZNzYjJB2L_10pxbackgroundhimselfUTF-8DEMOGRAPHICSVqvt4KW9", Dne = (t, e = 21) => (A = e) => {
  let n = "", s = A | 0;
  for (; s-- > 0; ) n += t[Math.random() * t.length | 0];
  return n;
}, xne = (t = 21) => {
  let e = "", A = t | 0;
  for (; A-- > 0; ) e += Nne[Math.random() * 64 | 0];
  return e;
}, Aj = (t) => {
  const e = new Int32Array(Math.ceil((t.length + 9) / 64) * 16);
  for (let A = 0; A < t.length; A++) e[A >> 2] |= t[A] << 24 - (A & 3) * 8;
  return e[t.length >> 2] |= 128 << 24 - (t.length & 3) * 8, e[e.length - 2] = Math.floor(t.length / 536870912), e[e.length - 1] = t.length * 8, e;
}, nj = (t) => {
  const e = new Uint8Array(t.length * 4);
  for (let A = 0; A < e.length; A++) e[A] = t[A >> 2] >>> 24 - (A & 3) * 8;
  return e;
}, YI = (t, e) => t << e | t >>> 32 - e, Cr = (t, e) => t >>> e | t << 32 - e, Gne = [
  1732584193,
  4023233417,
  2562383102,
  271733878,
  3285377520
], zne = Int32Array.of(1518500249, 1859775393, 2400959708, 3395469782), Une = /* @__PURE__ */ new Int32Array(80), bne = (t) => {
  const e = Aj(t), A = Une;
  let [n, s, r, i, o] = Gne;
  for (let a = 0; a < e.length; a += 16) {
    A.set(e.subarray(a, a + 16));
    for (let u = 16; u < 80; u++) A[u] = YI(A[u - 3] ^ A[u - 8] ^ A[u - 14] ^ A[u - 16], 1);
    let [c, l, B, g, h] = [
      n,
      s,
      r,
      i,
      o
    ];
    for (let u = 0; u < 80; u++) {
      const d = u < 20 ? l & B | ~l & g : u >= 40 && u < 60 ? l & B | l & g | B & g : l ^ B ^ g, w = YI(c, 5) + d + h + zne[Math.floor(u / 20)] + A[u] | 0;
      h = g, g = B, B = YI(l, 30), l = c, c = w;
    }
    [n, s, r, i, o] = [
      n + c | 0,
      s + l | 0,
      r + B | 0,
      i + g | 0,
      o + h | 0
    ];
  }
  return nj([
    n,
    s,
    r,
    i,
    o
  ]);
}, vne = Int32Array.of(1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298), jne = [
  1779033703,
  3144134277,
  1013904242,
  2773480762,
  1359893119,
  2600822924,
  528734635,
  1541459225
], Hne = /* @__PURE__ */ new Int32Array(64), yN = (t) => {
  const e = Aj(t), A = Hne;
  let [n, s, r, i, o, a, c, l] = jne;
  for (let B = 0; B < e.length; B += 16) {
    A.set(e.subarray(B, B + 16));
    for (let I = 16; I < 64; I++) {
      const N = A[I - 15], m = A[I - 2];
      A[I] = A[I - 16] + (Cr(N, 7) ^ Cr(N, 18) ^ N >>> 3) + A[I - 7] + (Cr(m, 17) ^ Cr(m, 19) ^ m >>> 10);
    }
    let [g, h, u, d, w, Q, p, M] = [
      n,
      s,
      r,
      i,
      o,
      a,
      c,
      l
    ];
    for (let I = 0; I < 64; I++) {
      const N = M + (Cr(w, 6) ^ Cr(w, 11) ^ Cr(w, 25)) + (w & Q ^ ~w & p) + vne[I] + A[I] | 0, m = (Cr(g, 2) ^ Cr(g, 13) ^ Cr(g, 22)) + (g & h ^ g & u ^ h & u) | 0;
      M = p, p = Q, Q = w, w = d + N | 0, d = u, u = h, h = g, g = N + m | 0;
    }
    [n, s, r, i, o, a, c, l] = [
      n + g | 0,
      s + h | 0,
      r + u | 0,
      i + d | 0,
      o + w | 0,
      a + Q | 0,
      c + p | 0,
      l + M | 0
    ];
  }
  return nj([
    n,
    s,
    r,
    i,
    o,
    a,
    c,
    l
  ]);
}, pn = (t) => Math.floor(t * 72 * 20), Zl = (t = 0) => {
  let e = t;
  return () => ++e;
}, kne = () => Zl(), Rne = () => Zl(1), Lne = () => Zl(), Sne = Lne(), Tne = () => Zl(), sj = Tne(), Jne = Zl(), Wne = () => -Jne(), Rm = () => xne().toLowerCase(), rj = (t) => Array.from(bne(typeof t == "string" ? oj(t) : ArrayBuffer.isView(t) ? t : new Uint8Array(t)), (e) => e.toString(16).padStart(2, "0")).join(""), cB = (t) => Dne("1234567890abcdef", t)(), ij = () => `${cB(8)}-${cB(4)}-${cB(4)}-${cB(4)}-${cB(12)}`, oj = (t) => new Uint8Array(new TextEncoder().encode(t)), One = ({ width: t, group: e }) => new K({
  name: "w:fitText",
  attributes: {
    val: {
      key: "w:val",
      value: Math.round(xo(UA(t)))
    },
    id: {
      key: "w:id",
      value: e === void 0 ? Wne() : hA(e)
    }
  }
}), Pne = class extends Z {
  constructor(t) {
    super("w:spacing"), this.root.push(new jn({ val: Gr(t) }));
  }
}, Kne = class extends Z {
  constructor(t) {
    super("w:color"), this.root.push(new jm([{
      keys: oe(oe({}, Fh), {}, { color: "w:val" }),
      color: t
    }]));
  }
}, Vne = class extends Z {
  constructor(t) {
    super("w:highlight"), this.root.push(new jn({ val: t }));
  }
}, Xne = (t) => new K({
  name: "w:lang",
  attributes: {
    value: {
      key: "w:val",
      value: t.value
    },
    eastAsia: {
      key: "w:eastAsia",
      value: t.eastAsia
    },
    bidirectional: {
      key: "w:bidi",
      value: t.bidirectional
    }
  }
}), yI = (t, e) => {
  if (typeof t == "string") {
    const n = t;
    return new K({
      name: "w:rFonts",
      attributes: {
        ascii: {
          key: "w:ascii",
          value: n
        },
        cs: {
          key: "w:cs",
          value: n
        },
        eastAsia: {
          key: "w:eastAsia",
          value: n
        },
        hAnsi: {
          key: "w:hAnsi",
          value: n
        },
        hint: {
          key: "w:hint",
          value: e
        }
      }
    });
  }
  if ("theme" in t) {
    const n = t.theme === "headings" ? "major" : "minor";
    return new K({
      name: "w:rFonts",
      attributes: {
        ascii: {
          key: "w:asciiTheme",
          value: `${n}HAnsi`
        },
        eastAsia: {
          key: "w:eastAsiaTheme",
          value: `${n}EastAsia`
        },
        hAnsi: {
          key: "w:hAnsiTheme",
          value: `${n}HAnsi`
        },
        cs: {
          key: "w:cstheme",
          value: `${n}Bidi`
        }
      }
    });
  }
  const A = t;
  return new K({
    name: "w:rFonts",
    attributes: {
      ascii: {
        key: "w:ascii",
        value: A.ascii
      },
      cs: {
        key: "w:cs",
        value: A.cs
      },
      eastAsia: {
        key: "w:eastAsia",
        value: A.eastAsia
      },
      hAnsi: {
        key: "w:hAnsi",
        value: A.hAnsi
      },
      hint: {
        key: "w:hint",
        value: A.hint
      }
    }
  });
}, aj = (t) => new K({
  name: "w:vertAlign",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), Zne = () => aj("superscript"), qne = () => aj("subscript"), df = {
  /** Single underline */
  SINGLE: "single"
}, _ne = (t = df.SINGLE, e) => Hm("w:u", [{
  key: "w:val",
  value: t
}, {
  keys: Fh,
  color: e
}]), $ne = {
  /** Black highlight */
  BLACK: "black",
  /** Blue highlight */
  BLUE: "blue",
  /** Cyan highlight */
  CYAN: "cyan",
  /** Dark blue highlight */
  DARK_BLUE: "darkBlue",
  /** Dark cyan highlight */
  DARK_CYAN: "darkCyan",
  /** Dark gray highlight */
  DARK_GRAY: "darkGray",
  /** Dark green highlight */
  DARK_GREEN: "darkGreen",
  /** Dark magenta highlight */
  DARK_MAGENTA: "darkMagenta",
  /** Dark red highlight */
  DARK_RED: "darkRed",
  /** Dark yellow highlight */
  DARK_YELLOW: "darkYellow",
  /** Green highlight */
  GREEN: "green",
  /** Light gray highlight */
  LIGHT_GRAY: "lightGray",
  /** Magenta highlight */
  MAGENTA: "magenta",
  /** No highlight */
  NONE: "none",
  /** Red highlight */
  RED: "red",
  /** White highlight */
  WHITE: "white",
  /** Yellow highlight */
  YELLOW: "yellow"
}, la = class extends ro {
  constructor(t) {
    if (super("w:rPr"), !t) return;
    if (t.style && this.push(new Oo("w:rStyle", t.style)), t.font && (typeof t.font == "string" ? this.push(yI(t.font)) : "name" in t.font ? this.push(yI(t.font.name, t.font.hint)) : this.push(yI(t.font))), t.bold !== void 0 && this.push(new ce("w:b", t.bold)), t.boldComplexScript === void 0 && t.bold !== void 0 || t.boldComplexScript) {
      var e;
      this.push(new ce("w:bCs", (e = t.boldComplexScript) !== null && e !== void 0 ? e : t.bold));
    }
    if (t.italics !== void 0 && this.push(new ce("w:i", t.italics)), t.italicsComplexScript === void 0 && t.italics !== void 0 || t.italicsComplexScript) {
      var A;
      this.push(new ce("w:iCs", (A = t.italicsComplexScript) !== null && A !== void 0 ? A : t.italics));
    }
    t.smallCaps !== void 0 ? this.push(new ce("w:smallCaps", t.smallCaps)) : t.allCaps !== void 0 && this.push(new ce("w:caps", t.allCaps)), t.strike !== void 0 && this.push(new ce("w:strike", t.strike)), t.doubleStrike !== void 0 && this.push(new ce("w:dstrike", t.doubleStrike)), t.emboss !== void 0 && this.push(new ce("w:emboss", t.emboss)), t.imprint !== void 0 && this.push(new ce("w:imprint", t.imprint)), t.noProof !== void 0 && this.push(new ce("w:noProof", t.noProof)), t.snapToGrid !== void 0 && this.push(new ce("w:snapToGrid", t.snapToGrid)), t.vanish !== void 0 && this.push(new ce("w:vanish", t.vanish)), t.color && this.push(new Kne(t.color)), t.characterSpacing && this.push(new Pne(t.characterSpacing)), t.scale !== void 0 && this.push(new rg("w:w", t.scale)), t.kern && this.push(new mI("w:kern", t.kern)), t.position && this.push(new Oo("w:position", t.position)), t.size !== void 0 && this.push(new mI("w:sz", t.size));
    const n = t.sizeComplexScript === void 0 || t.sizeComplexScript === !0 ? t.size : t.sizeComplexScript;
    n && this.push(new mI("w:szCs", n)), t.highlight && this.push(new Vne(t.highlight)), t.underline && this.push(_ne(t.underline.type, t.underline.color)), t.effect && this.push(new Oo("w:effect", t.effect)), t.border && this.push(IA("w:bdr", t.border)), t.shading && this.push(uf(t.shading)), t.fitText && this.push(One(t.fitText)), t.subScript && this.push(qne()), t.superScript && this.push(Zne()), t.rightToLeft !== void 0 && this.push(new ce("w:rtl", t.rightToLeft)), t.emphasisMark && this.push(Fne(t.emphasisMark.type)), t.language && this.push(Xne(t.language)), t.eastAsianLayout && this.push(Yne(t.eastAsianLayout)), t.specVanish !== void 0 && this.push(new ce("w:specVanish", t.specVanish)), t.math !== void 0 && this.push(new ce("w:oMath", t.math)), t.revision && this.push(new tse(t.revision));
  }
  push(t) {
    this.root.push(t);
  }
}, ese = class extends la {
  constructor(t) {
    super(t), t != null && t.insertion && this.push(new mne(t.insertion)), t != null && t.deletion && this.push(new pne(t.deletion));
  }
}, tse = class extends Z {
  constructor(t) {
    super("w:rPrChange"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    })), this.addChildElement(new la(t));
  }
}, FN = class extends Z {
  constructor(t) {
    if (super("w:t"), typeof t == "string")
      this.root.push(new Ki({ space: Pi.PRESERVE })), this.root.push(t);
    else {
      var e;
      this.root.push(new Ki({ space: (e = t.space) !== null && e !== void 0 ? e : Pi.DEFAULT })), this.root.push(t.text);
    }
  }
}, _c = {
  /** Inserts the current page number */
  CURRENT: "CURRENT",
  /** Inserts the total number of pages in the document */
  TOTAL_PAGES: "TOTAL_PAGES",
  /** Inserts the total number of pages in the current section */
  TOTAL_PAGES_IN_SECTION: "TOTAL_PAGES_IN_SECTION",
  /** Inserts the current section number */
  CURRENT_SECTION: "SECTION"
}, Ase = (t) => {
  switch (t) {
    case _c.CURRENT:
      return [
        yB(),
        new Ine(),
        Zc(),
        qc()
      ];
    case _c.TOTAL_PAGES:
      return [
        yB(),
        new Cne(),
        Zc(),
        qc()
      ];
    case _c.TOTAL_PAGES_IN_SECTION:
      return [
        yB(),
        new Ene(),
        Zc(),
        qc()
      ];
    case _c.CURRENT_SECTION:
      return [
        yB(),
        new Mne(),
        Zc(),
        qc()
      ];
    default:
      return;
  }
}, Or = class SE extends Z {
  constructor(e) {
    if (super("w:r"), T(this, "properties", void 0), T(this, "following", []), this.properties = new la(e), this.root.push(this.properties), e.break) for (let A = 0; A < e.break; A++) this.root.push(wne());
    if (e.children) for (const [A, n] of e.children.entries()) {
      if (lf(n) === "w:r") {
        const s = e.children.slice(A + 1);
        this.following = [n, ...s.length > 0 ? [new SE(oe(oe({}, e), {}, {
          break: void 0,
          children: s
        }))] : []];
        break;
      }
      if (typeof n == "string") {
        const s = Ase(n);
        if (s) {
          const r = e.children.slice(A + 1), i = (c) => new SE(oe(oe({}, e), {}, {
            break: void 0,
            children: c
          })), o = this.root.length === 1;
          o && this.root.push(s[0]);
          const a = o ? s.slice(1) : s;
          this.following = [...a.map((c) => i([c])), ...r.length > 0 ? [i(r)] : []];
          break;
        }
        this.root.push(new FN(n));
        continue;
      }
      this.root.push(n);
    }
    else e.text !== void 0 && this.root.push(new FN(e.text));
  }
  get writtenAs() {
    return this.following.length > 0 ? [this, ...this.following.flatMap((e) => {
      var A;
      return (A = e.writtenAs) !== null && A !== void 0 ? A : e;
    })] : void 0;
  }
}, nr = class extends Or {
  constructor(t) {
    super(typeof t == "string" ? { text: t } : t);
  }
}, nse = (t) => {
  const e = t.indexOf(";base64,"), A = e === -1 ? 0 : e + 8;
  return new Uint8Array(atob(t.substring(A)).split("").map((n) => n.charCodeAt(0)));
}, cj = (t) => typeof t == "string" ? nse(t) : t, sse = [
  ["png", [
    137,
    80,
    78,
    71,
    13,
    10,
    26,
    10
  ]],
  ["jpg", [
    255,
    216,
    255
  ]],
  ["gif", [
    71,
    73,
    70,
    56,
    55,
    97
  ]],
  ["gif", [
    71,
    73,
    70,
    56,
    57,
    97
  ]],
  ["bmp", [66, 77]]
], rse = ({ type: t, data: e }, A) => {
  if (t !== void 0) return t;
  const n = cj(e), s = ArrayBuffer.isView(n) ? new Uint8Array(n.buffer, n.byteOffset, n.byteLength) : new Uint8Array(n), r = sse.find(([, i]) => i.every((o, a) => s[a] === o));
  if (r === void 0) throw new Error(`${A}: type isn't given, and data isn't a PNG, JPEG, GIF or BMP file to read it from. Give its type`);
  return r[0];
}, ise = {
  /**
  * ## Page Edge
  *
  * Specifies that the horizontal positioning shall be relative to the edge of the page.
  */
  PAGE: "page"
}, ose = {
  /**
  * ## Page Edge
  *
  * Specifies that the vertical positioning shall be relative to the edge of the page.
  */
  PAGE: "page"
}, ase = () => new K({
  name: "wp:simplePos",
  attributes: {
    x: {
      key: "x",
      value: 0
    },
    y: {
      key: "y",
      value: 0
    }
  }
}), lj = (t) => new K({
  name: "wp:align",
  children: [t]
}), Bj = (t) => new K({
  name: "wp:posOffset",
  children: [t.toString()]
}), cse = ({ relative: t, align: e, offset: A }) => new K({
  name: "wp:positionH",
  attributes: { relativeFrom: {
    key: "relativeFrom",
    value: t ?? ise.PAGE
  } },
  children: [(() => {
    if (e) return lj(e);
    if (A !== void 0) return Bj(A);
    throw new Error("There is no configuration provided for floating position (Align or offset)");
  })()]
}), lse = ({ relative: t, align: e, offset: A }) => new K({
  name: "wp:positionV",
  attributes: { relativeFrom: {
    key: "relativeFrom",
    value: t ?? ose.PAGE
  } },
  children: [(() => {
    if (e) return lj(e);
    if (A !== void 0) return Bj(A);
    throw new Error("There is no configuration provided for floating position (Align or offset)");
  })()]
}), Bse = (t = {}) => {
  var e, A, n, s;
  return new K({
    name: "wps:bodyPr",
    attributes: {
      lIns: {
        key: "lIns",
        value: (e = t.margins) === null || e === void 0 ? void 0 : e.left
      },
      rIns: {
        key: "rIns",
        value: (A = t.margins) === null || A === void 0 ? void 0 : A.right
      },
      tIns: {
        key: "tIns",
        value: (n = t.margins) === null || n === void 0 ? void 0 : n.top
      },
      bIns: {
        key: "bIns",
        value: (s = t.margins) === null || s === void 0 ? void 0 : s.bottom
      },
      anchor: {
        key: "anchor",
        value: t.verticalAnchor
      }
    },
    children: [...t.noAutoFit ? [new ce("a:noAutofit", t.noAutoFit)] : []]
  });
}, gse = (t = { txBox: "1" }) => new K({
  name: "wps:cNvSpPr",
  attributes: { txBox: {
    key: "txBox",
    value: t.txBox
  } }
}), hse = (t) => new K({
  name: "w:txbxContent",
  children: [...t]
}), use = (t) => new K({
  name: "wps:txbx",
  children: [hse(t)]
}), dse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      cx: "cx",
      cy: "cy"
    });
  }
}, gj = class extends Z {
  constructor(t, e) {
    super("a:ext"), T(this, "attributes", void 0), this.attributes = new dse({
      cx: t,
      cy: e
    }), this.root.push(this.attributes);
  }
}, wse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      x: "x",
      y: "y"
    });
  }
}, hj = class extends Z {
  constructor(t, e) {
    super("a:off"), this.root.push(new wse({
      x: t ?? 0,
      y: e ?? 0
    }));
  }
}, fse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      flipVertical: "flipV",
      flipHorizontal: "flipH",
      rotation: "rot"
    });
  }
}, Qse = class extends Z {
  constructor(t) {
    var e, A, n, s;
    super("a:xfrm"), T(this, "extents", void 0), T(this, "offset", void 0), this.root.push(new fse({
      flipVertical: (e = t.flip) === null || e === void 0 ? void 0 : e.vertical,
      flipHorizontal: (A = t.flip) === null || A === void 0 ? void 0 : A.horizontal,
      rotation: t.rotation
    })), this.offset = new hj((n = t.offset) === null || n === void 0 || (n = n.emus) === null || n === void 0 ? void 0 : n.x, (s = t.offset) === null || s === void 0 || (s = s.emus) === null || s === void 0 ? void 0 : s.y), this.extents = new gj(t.emus.x, t.emus.y), this.root.push(this.offset), this.root.push(this.extents);
  }
}, uj = () => new K({ name: "a:noFill" }), Ise = (t) => new K({
  name: "a:srgbClr",
  attributes: { value: {
    key: "val",
    value: t.value
  } }
}), Cse = (t) => new K({
  name: "a:schemeClr",
  attributes: { value: {
    key: "val",
    value: t.value
  } }
}), TE = (t) => new K({
  name: "a:solidFill",
  children: [t.type === "rgb" ? Ise(t) : Cse(t)]
}), Ese = {
  /** Round cap style */
  ROUND: "rnd",
  /** Square cap style */
  SQUARE: "sq",
  /** Flat cap style */
  FLAT: "flat"
}, Mse = {
  /** Single line */
  SINGLE: "sng",
  /** Double line */
  DOUBLE: "dbl",
  /** Thick-thin double line */
  THICK_THIN: "thickThin",
  /** Thin-thick double line */
  THIN_THICK: "thinThick",
  /** Triple line */
  TRI: "tri"
}, pse = {
  /** Center alignment */
  CENTER: "ctr",
  /** Inset alignment */
  INSET: "in"
}, mse = (t) => new K({
  name: "a:ln",
  attributes: {
    width: {
      key: "w",
      value: t.width
    },
    cap: {
      key: "cap",
      value: t.cap === void 0 ? void 0 : Ese[t.cap]
    },
    compoundLine: {
      key: "cmpd",
      value: t.compoundLine === void 0 ? void 0 : Mse[t.compoundLine]
    },
    align: {
      key: "algn",
      value: t.align === void 0 ? void 0 : pse[t.align]
    }
  },
  children: [t.type === "noFill" ? uj() : t.solidFillType === "rgb" ? TE({
    type: "rgb",
    value: t.value
  }) : TE({
    type: "scheme",
    value: t.value
  })]
}), Yse = class extends Z {
  constructor() {
    super("a:avLst");
  }
}, yse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { prst: "prst" });
  }
}, Fse = class extends Z {
  constructor() {
    super("a:prstGeom"), this.root.push(new yse({ prst: "rect" })), this.root.push(new Yse());
  }
}, Nse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { bwMode: "bwMode" });
  }
}, dj = class extends Z {
  constructor({ element: t, outline: e, solidFill: A, transform: n }) {
    super(`${t}:spPr`), T(this, "form", void 0), this.root.push(new Nse({ bwMode: "auto" })), this.form = new Qse(n), this.root.push(this.form), this.root.push(new Fse()), A ? this.root.push(TE(A)) : e && this.root.push(uj()), e && this.root.push(mse(e));
  }
}, NN = (t) => new K({
  name: "wps:wsp",
  children: [
    gse(t.nonVisualProperties),
    new dj({
      element: "wps",
      transform: t.transformation,
      outline: t.outline,
      solidFill: t.solidFill
    }),
    use(t.children),
    Bse(t.bodyProperties)
  ]
}), x0 = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { uri: "uri" });
  }
}, Dse = (t) => new K({
  name: "asvg:svgBlip",
  attributes: {
    asvg: {
      key: "xmlns:asvg",
      value: "http://schemas.microsoft.com/office/drawing/2016/SVG/main"
    },
    embed: {
      key: "r:embed",
      value: `rId{${t.fileName}}`
    }
  }
}), xse = (t) => new K({
  name: "a:ext",
  attributes: { uri: {
    key: "uri",
    value: "{96DAC541-7B7A-43D3-8B79-37D633B846F1}"
  } },
  children: [Dse(t)]
}), Gse = (t) => new K({
  name: "a:extLst",
  children: [xse(t)]
}), zse = (t) => new K({
  name: "a:blip",
  attributes: {
    embed: {
      key: "r:embed",
      value: `rId{${t.type === "svg" ? t.fallback.fileName : t.fileName}}`
    },
    cstate: {
      key: "cstate",
      value: "none"
    }
  },
  children: t.type === "svg" ? [Gse(t)] : []
}), Use = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      left: "l",
      top: "t",
      right: "r",
      bottom: "b"
    });
  }
}, G0 = (t, e) => {
  if (t !== void 0) {
    if (!(t >= 0 && t <= 100)) throw new Error(`Invalid crop ${e} ${t}. Expected a number from 0 to 100`);
    return Math.round(t * 1e3);
  }
}, bse = class extends Z {
  constructor(t) {
    super("a:srcRect"), t && this.root.push(new Use({
      left: G0(t.left, "left"),
      top: G0(t.top, "top"),
      right: G0(t.right, "right"),
      bottom: G0(t.bottom, "bottom")
    }));
  }
}, vse = class extends Z {
  constructor() {
    super("a:fillRect");
  }
}, jse = class extends Z {
  constructor() {
    super("a:stretch"), this.root.push(new vse());
  }
}, Hse = class extends Z {
  constructor(t, e) {
    super("pic:blipFill"), this.root.push(zse(t)), this.root.push(new bse(e)), this.root.push(new jse());
  }
}, kse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      noChangeAspect: "noChangeAspect",
      noChangeArrowheads: "noChangeArrowheads"
    });
  }
}, Rse = class extends Z {
  constructor() {
    super("a:picLocks"), this.root.push(new kse({
      noChangeAspect: 1,
      noChangeArrowheads: 1
    }));
  }
}, Lse = class extends Z {
  constructor() {
    super("pic:cNvPicPr"), this.root.push(new Rse());
  }
}, Sse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      id: "id",
      name: "name",
      descr: "descr"
    });
  }
}, Tse = class extends Z {
  constructor() {
    super("pic:cNvPr"), this.root.push(new Sse({
      id: 0,
      name: "",
      descr: ""
    }));
  }
  prepForXml(t) {
    for (let A = t.stack.length - 1; A >= 0; A--) {
      const n = t.stack[A];
      if (n instanceof ff) {
        this.root.push(n.createDrawingClick(t, !1));
        break;
      }
    }
    const e = super.prepForXml(t);
    return this.root.splice(1), e;
  }
}, Jse = class extends Z {
  constructor() {
    super("pic:nvPicPr"), this.root.push(new Tse()), this.root.push(new Lse());
  }
}, Wse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { xmlns: "xmlns:pic" });
  }
}, DN = class extends Z {
  constructor({ mediaData: t, transform: e, outline: A, solidFill: n, crop: s }) {
    super("pic:pic"), this.root.push(new Wse({ xmlns: "http://schemas.openxmlformats.org/drawingml/2006/picture" })), this.root.push(new Jse()), this.root.push(new Hse(t, s)), this.root.push(new dj({
      element: "pic",
      transform: e,
      outline: A,
      solidFill: n
    }));
  }
}, Ose = (t) => {
  var e, A, n, s;
  return new K({
    name: "a:xfrm",
    attributes: {
      flipVertical: {
        key: "flipV",
        value: (e = t.flip) === null || e === void 0 ? void 0 : e.vertical
      },
      flipHorizontal: {
        key: "flipH",
        value: (A = t.flip) === null || A === void 0 ? void 0 : A.horizontal
      },
      rotation: {
        key: "rot",
        value: t.rotation
      }
    },
    children: [
      new hj((n = t.offset) === null || n === void 0 || (n = n.emus) === null || n === void 0 ? void 0 : n.x, (s = t.offset) === null || s === void 0 || (s = s.emus) === null || s === void 0 ? void 0 : s.y),
      new gj(t.emus.x, t.emus.y),
      new K({
        name: "a:chOff",
        attributes: {
          x: {
            key: "x",
            value: 0
          },
          y: {
            key: "y",
            value: 0
          }
        }
      }),
      new K({
        name: "a:chExt",
        attributes: {
          x: {
            key: "cx",
            value: t.emus.x
          },
          y: {
            key: "cy",
            value: t.emus.y
          }
        }
      })
    ]
  });
}, Pse = () => new K({ name: "wpg:cNvGrpSpPr" }), Kse = (t) => new K({
  name: "wpg:wgp",
  children: [
    Pse(),
    new K({
      name: "wpg:grpSpPr",
      children: [Ose(t.transformation)]
    }),
    ...t.children
  ]
}), Vse = class extends Z {
  constructor({ mediaData: t, transform: e, outline: A, solidFill: n, crop: s }) {
    if (super("a:graphicData"), t.type === "graphic")
      this.root.push(new x0({ uri: t.uri })), this.root.push(t.content);
    else if (t.type === "wps") {
      this.root.push(new x0({ uri: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape" }));
      const r = NN(oe(oe({}, t.data), {}, {
        transformation: e,
        outline: A,
        solidFill: n
      }));
      this.root.push(r);
    } else if (t.type === "wpg") {
      this.root.push(new x0({ uri: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup" }));
      const r = Kse({
        children: t.children.map((i) => i.type === "wps" ? NN(oe(oe({}, i.data), {}, {
          transformation: i.transformation,
          outline: i.outline,
          solidFill: i.solidFill
        })) : new DN({
          mediaData: i,
          transform: i.transformation,
          outline: i.outline,
          solidFill: i.solidFill
        })),
        transformation: e
      });
      this.root.push(r);
    } else {
      this.root.push(new x0({ uri: "http://schemas.openxmlformats.org/drawingml/2006/picture" }));
      const r = new DN({
        mediaData: t,
        transform: e,
        outline: A,
        solidFill: n,
        crop: s
      });
      this.root.push(r);
    }
  }
}, Xse = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { a: "xmlns:a" });
  }
}, wj = class extends Z {
  constructor({ mediaData: t, transform: e, outline: A, solidFill: n, crop: s }) {
    super("a:graphic"), T(this, "data", void 0), this.root.push(new Xse({ a: "http://schemas.openxmlformats.org/drawingml/2006/main" })), this.data = new Vse({
      mediaData: t,
      transform: e,
      outline: A,
      solidFill: n,
      crop: s
    }), this.root.push(this.data);
  }
}, lB = {
  /** Text doesn't wrap around the drawing. It is drawn in front of or behind the text */
  NONE: 0,
  /** Text wraps around the drawing's box */
  SQUARE: 1,
  /** Text wraps closely around the drawing's outline */
  TIGHT: 2,
  /** Text sits above and below the drawing, not beside it */
  TOP_AND_BOTTOM: 3,
  /** Text wraps closely around the drawing's outline, and fills any open space inside it */
  THROUGH: 4
}, fj = {
  /** Text wraps on both sides of the drawing */
  BOTH_SIDES: "bothSides"
}, xN = () => new K({ name: "wp:wrapNone" }), Zse = (t, e = {
  top: 0,
  bottom: 0,
  left: 0,
  right: 0
}) => new K({
  name: "wp:wrapSquare",
  attributes: {
    wrapText: {
      key: "wrapText",
      value: t.side || fj.BOTH_SIDES
    },
    distT: {
      key: "distT",
      value: e.top
    },
    distB: {
      key: "distB",
      value: e.bottom
    },
    distL: {
      key: "distL",
      value: e.left
    },
    distR: {
      key: "distR",
      value: e.right
    }
  }
}), z0 = 21600, BB = (t, { x: e, y: A }) => new K({
  name: t,
  attributes: {
    x: {
      key: "x",
      value: e
    },
    y: {
      key: "y",
      value: A
    }
  }
}), qse = () => new K({
  name: "wp:wrapPolygon",
  attributes: { edited: {
    key: "edited",
    value: !1
  } },
  children: [
    BB("wp:start", {
      x: 0,
      y: 0
    }),
    BB("wp:lineTo", {
      x: 0,
      y: z0
    }),
    BB("wp:lineTo", {
      x: z0,
      y: z0
    }),
    BB("wp:lineTo", {
      x: z0,
      y: 0
    }),
    BB("wp:lineTo", {
      x: 0,
      y: 0
    })
  ]
}), Qj = (t, e = {}, A) => {
  var n;
  return new K({
    name: t,
    attributes: {
      wrapText: {
        key: "wrapText",
        value: (n = A == null ? void 0 : A.side) !== null && n !== void 0 ? n : fj.BOTH_SIDES
      },
      distL: {
        key: "distL",
        value: e.left
      },
      distR: {
        key: "distR",
        value: e.right
      }
    },
    children: [qse()]
  });
}, _se = (t, e) => Qj("wp:wrapTight", t, e), $se = (t, e) => Qj("wp:wrapThrough", t, e), ere = (t = {
  top: 0,
  bottom: 0
}) => new K({
  name: "wp:wrapTopAndBottom",
  attributes: {
    distT: {
      key: "distT",
      value: t.top
    },
    distB: {
      key: "distB",
      value: t.bottom
    }
  }
}), Ij = {
  /** Target is external to the package (e.g., hyperlink to a URL) */
  EXTERNAL: "External"
}, tre = (t, e, A, n) => new K({
  name: "Relationship",
  attributes: {
    id: {
      key: "Id",
      value: t
    },
    type: {
      key: "Type",
      value: e
    },
    target: {
      key: "Target",
      value: A
    },
    targetMode: {
      key: "TargetMode",
      value: n
    }
  }
}), Cj = (t, e) => new K({
  name: "a:hlinkClick",
  attributes: oe(oe({}, e ? { xmlns: {
    key: "xmlns:a",
    value: "http://schemas.openxmlformats.org/drawingml/2006/main"
  } } : {}), {}, { id: {
    key: "r:id",
    value: `rId${t}`
  } })
}), Are = "{C183D7F6-B498-43B3-948B-1728B52AA6E4}", nre = (t) => new K({
  name: "a:extLst",
  attributes: { namespace: {
    key: "xmlns:a",
    value: "http://schemas.openxmlformats.org/drawingml/2006/main"
  } },
  children: [new K({
    name: "a:ext",
    attributes: { uri: {
      key: "uri",
      value: Are
    } },
    children: [new K({
      name: "adec:decorative",
      attributes: {
        namespace: {
          key: "xmlns:adec",
          value: "http://schemas.microsoft.com/office/drawing/2017/decorative"
        },
        value: {
          key: "val",
          value: 1
        }
      }
    })]
  })]
}), Ej = class {
  constructor(t) {
    T(this, "link", void 0), T(this, "linkId", Rm()), T(this, "addedTo", /* @__PURE__ */ new WeakSet()), this.link = t;
  }
  createClick(t) {
    return Cj(this.linkId, t);
  }
  addRelationship(t) {
    const e = t.viewWrapper.Relationships;
    this.addedTo.has(e) || (this.addedTo.add(e), e.addRelationship(this.linkId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", this.link, Ij.EXTERNAL));
  }
}, Mj = class extends Z {
  constructor({ name: t = "", description: e, title: A, id: n } = {}, { link: s, decorative: r } = {}) {
    super("wp:docPr"), T(this, "link", void 0), T(this, "decorative", void 0);
    const i = {
      id: {
        key: "id",
        value: n ?? Sne()
      },
      name: {
        key: "name",
        value: t
      }
    };
    e && (i.description = {
      key: "descr",
      value: e
    }), A && (i.title = {
      key: "title",
      value: A
    }), this.root.push(new Gm(i)), this.link = s === void 0 ? void 0 : new Ej(s), this.decorative = r;
  }
  prepForXml(t) {
    if (this.link)
      this.link.addRelationship(t), this.root.push(this.link.createClick(!0));
    else for (let A = t.stack.length - 1; A >= 0; A--) {
      const n = t.stack[A];
      if (n instanceof ff) {
        this.root.push(n.createDrawingClick(t, !0));
        break;
      }
    }
    this.decorative && this.root.push(nre());
    const e = super.prepForXml(t);
    return this.root.splice(1), e;
  }
}, pj = ({ top: t, right: e, bottom: A, left: n }) => new K({
  name: "wp:effectExtent",
  attributes: {
    top: {
      key: "t",
      value: t
    },
    right: {
      key: "r",
      value: e
    },
    bottom: {
      key: "b",
      value: A
    },
    left: {
      key: "l",
      value: n
    }
  }
}), FI = 2147483647, GN = 9525, zN = (t, e) => {
  if (e !== void 0 && e > FI) throw new Error(`Invalid drawing ${t} ${e} EMUs (${Math.round(e / GN)} pixels). Word won't open a drawing with a ${t} over ${FI} EMUs (${Math.floor(FI / GN)} pixels). Sizes such as an ImageRun's transformation are in pixels, not EMUs`);
  return e;
}, mj = ({ x: t, y: e }) => new K({
  name: "wp:extent",
  attributes: {
    x: {
      key: "cx",
      value: zN("width", t)
    },
    y: {
      key: "cy",
      value: zN("height", e)
    }
  }
}), sre = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      xmlns: "xmlns:a",
      noChangeAspect: "noChangeAspect"
    });
  }
}, rre = class extends Z {
  constructor() {
    super("a:graphicFrameLocks"), this.root.push(new sre({
      xmlns: "http://schemas.openxmlformats.org/drawingml/2006/main",
      noChangeAspect: 1
    }));
  }
}, Yj = (t = !0) => new K({
  name: "wp:cNvGraphicFramePr",
  children: t ? [new rre()] : []
}), ire = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      distT: "distT",
      distB: "distB",
      distL: "distL",
      distR: "distR",
      allowOverlap: "allowOverlap",
      behindDoc: "behindDoc",
      layoutInCell: "layoutInCell",
      locked: "locked",
      relativeHeight: "relativeHeight",
      simplePos: "simplePos"
    });
  }
}, ore = class extends Z {
  constructor({ mediaData: t, transform: e, drawingOptions: A }) {
    var n;
    super("wp:anchor");
    const s = oe({
      allowOverlap: !0,
      behindDocument: !1,
      lockAnchor: !1,
      layoutInCell: !0,
      verticalPosition: {},
      horizontalPosition: {}
    }, A.floating);
    if (this.root.push(new ire({
      distT: s.margins && s.margins.top || 0,
      distB: s.margins && s.margins.bottom || 0,
      distL: s.margins && s.margins.left || 0,
      distR: s.margins && s.margins.right || 0,
      simplePos: "0",
      allowOverlap: s.allowOverlap === !0 ? "1" : "0",
      behindDoc: s.behindDocument === !0 ? "1" : "0",
      locked: s.lockAnchor === !0 ? "1" : "0",
      layoutInCell: s.layoutInCell === !0 ? "1" : "0",
      relativeHeight: s.zIndex ? s.zIndex : e.emus.y
    })), this.root.push(ase()), this.root.push(cse(s.horizontalPosition)), this.root.push(lse(s.verticalPosition)), this.root.push(mj({
      x: e.emus.x,
      y: e.emus.y
    })), this.root.push(pj((n = A.effectExtent) !== null && n !== void 0 ? n : {
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    })), A.floating !== void 0 && A.floating.wrap !== void 0) switch (A.floating.wrap.type) {
      case lB.SQUARE:
        this.root.push(Zse(A.floating.wrap, A.floating.margins));
        break;
      case lB.TIGHT:
        this.root.push(_se(A.floating.margins, A.floating.wrap));
        break;
      case lB.THROUGH:
        this.root.push($se(A.floating.margins, A.floating.wrap));
        break;
      case lB.TOP_AND_BOTTOM:
        this.root.push(ere(A.floating.margins));
        break;
      case lB.NONE:
      default:
        this.root.push(xN());
    }
    else this.root.push(xN());
    this.root.push(new Mj(A.docProperties, {
      link: A.link,
      decorative: A.decorative
    })), this.root.push(Yj(t.type !== "graphic" || t.lockAspectRatio !== !1)), this.root.push(new wj({
      mediaData: t,
      transform: e,
      outline: A.outline,
      solidFill: A.solidFill,
      crop: A.crop
    }));
  }
}, are = ({ mediaData: t, transform: e, docProperties: A, outline: n, solidFill: s, crop: r, effectExtent: i, link: o, decorative: a }) => {
  var c, l, B, g;
  return new K({
    name: "wp:inline",
    attributes: {
      distanceTop: {
        key: "distT",
        value: 0
      },
      distanceBottom: {
        key: "distB",
        value: 0
      },
      distanceLeft: {
        key: "distL",
        value: 0
      },
      distanceRight: {
        key: "distR",
        value: 0
      }
    },
    children: [
      mj({
        x: e.emus.x,
        y: e.emus.y
      }),
      pj(i ?? (n ? {
        top: ((c = n.width) !== null && c !== void 0 ? c : 9525) * 2,
        right: ((l = n.width) !== null && l !== void 0 ? l : 9525) * 2,
        bottom: ((B = n.width) !== null && B !== void 0 ? B : 9525) * 2,
        left: ((g = n.width) !== null && g !== void 0 ? g : 9525) * 2
      } : {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      })),
      new Mj(A, {
        link: o,
        decorative: a
      }),
      Yj(t.type !== "graphic" || t.lockAspectRatio !== !1),
      new wj({
        mediaData: t,
        transform: e,
        outline: n,
        solidFill: s,
        crop: r
      })
    ]
  });
}, cre = class extends Z {
  constructor(t, e = {}) {
    super("w:drawing"), e.floating ? this.root.push(new ore({
      mediaData: t,
      transform: t.transformation,
      drawingOptions: e
    })) : this.root.push(are({
      mediaData: t,
      transform: t.transformation,
      docProperties: e.docProperties,
      outline: e.outline,
      solidFill: e.solidFill,
      crop: e.crop,
      effectExtent: e.effectExtent,
      link: e.link,
      decorative: e.decorative
    }));
  }
}, yj = (t, e) => ({
  data: cj(t.data),
  fileName: e,
  transformation: {
    pixels: {
      x: Math.round(t.transformation.width),
      y: Math.round(t.transformation.height)
    },
    emus: {
      x: Math.round(t.transformation.width * 9525),
      y: Math.round(t.transformation.height * 9525)
    },
    flip: t.transformation.flip,
    rotation: t.transformation.rotation ? t.transformation.rotation * 6e4 : void 0
  }
}), UN = (t, e, A) => {
  const n = rse(t, A);
  return oe({ type: n }, yj(oe(oe({}, t), {}, { transformation: e }), `${rj(t.data)}.${n}`));
}, lre = ({ id: t, author: e, date: A }, n) => new K({
  name: "w:del",
  attributes: {
    id: {
      key: "w:id",
      value: t
    },
    author: {
      key: "w:author",
      value: e
    },
    date: {
      key: "w:date",
      value: A
    }
  },
  children: [n]
}), Bre = class extends Z {
  constructor(t) {
    var e;
    const A = t.type === "svg" ? oe(oe({ type: t.type }, yj(t, `${rj(t.data)}.svg`)), {}, { fallback: UN(t.fallback, t.transformation, "ImageRun fallback") }) : UN(t, t.transformation, "ImageRun"), n = new cre(A, {
      floating: t.floating,
      docProperties: t.altText,
      outline: t.outline,
      solidFill: t.solidFill,
      crop: t.crop,
      link: t.link,
      decorative: t.decorative
    }), s = new la(t.run), r = (e = t.insertion) !== null && e !== void 0 ? e : t.deletion, i = t.insertion ? "w:ins" : t.deletion ? "w:del" : "w:r";
    if (super(i), T(this, "imageData", void 0), r) {
      this.root.push(new Qs({
        id: r.id,
        author: r.author,
        date: r.date
      }));
      const o = new K({
        name: "w:r",
        children: [s, n]
      });
      this.addChildElement(t.insertion && t.deletion ? lre(t.deletion, o) : o);
    } else
      this.root.push(s), this.root.push(n);
    this.imageData = A;
  }
  prepForXml(t) {
    return t.file.Media.addImage(this.imageData.fileName, this.imageData), this.imageData.type === "svg" && t.file.Media.addImage(this.imageData.fallback.fileName, this.imageData.fallback), super.prepForXml(t);
  }
}, gre = 32767, hre = 780, ure = [
  [1e3, "M"],
  [900, "CM"],
  [500, "D"],
  [400, "CD"],
  [100, "C"],
  [90, "XC"],
  [50, "L"],
  [40, "XL"],
  [10, "X"],
  [9, "IX"],
  [5, "V"],
  [4, "IV"],
  [1, "I"]
], dre = (t) => t <= gre ? ure.reduce(({ rest: e, text: A }, [n, s]) => ({
  rest: e % n,
  text: A + s.repeat(Math.floor(e / n))
}), {
  rest: t,
  text: ""
}).text : void 0, wre = (t) => t === 0 ? "" : t <= hre ? String.fromCharCode(65 + (t - 1) % 26).repeat(Math.ceil(t / 26)) : void 0, fre = (t) => {
  var e;
  return `${t}${t % 100 >= 11 && t % 100 <= 13 ? "th" : (e = [
    "th",
    "st",
    "nd",
    "rd"
  ][t % 10]) !== null && e !== void 0 ? e : "th"}`;
}, Lm = (t) => {
  const e = t.charAt(0) !== t.charAt(0).toUpperCase(), A = (n) => (s) => {
    var r;
    return e ? (r = n(s)) === null || r === void 0 ? void 0 : r.toLowerCase() : n(s);
  };
  switch (t.toLowerCase()) {
    case "arabic":
      return String;
    case "roman":
      return A(dre);
    case "alphabetic":
      return A(wre);
    case "ordinal":
      return (n) => n > 0 ? fre(n) : void 0;
    case "arabicdash":
      return (n) => `- ${n} -`;
    default:
      return;
  }
}, Fj = /* @__PURE__ */ new Set([
  "mergeformat",
  "charformat",
  "mergeformatinet"
]), Nj = /* @__PURE__ */ new Set([
  "upper",
  "lower",
  "firstcap",
  "caps"
]), Qre = (t) => /^[#0,]*[#0][#0,]*$/.test(t), Ire = (t, e) => {
  const A = [...e].filter((r) => r === "0").length, n = A + [...e].filter((r) => r === "#").length, s = String(t).padStart(A, "0");
  if (!(s.length < n || A === 0 && t === 0))
    return e.includes(",") ? s.replace(/\B(?=(\d{3})+$)/g, ",") : s;
}, Cre = (t, e) => {
  switch (e) {
    case "upper":
      return t.toUpperCase();
    case "lower":
      return t.toLowerCase();
    case "firstcap":
      return t.charAt(0).toUpperCase() + t.slice(1);
    default:
      return t;
  }
}, Ere = (t) => {
  var e;
  const A = new RegExp("^\\s*(PAGEREF|NUMPAGES|SECTIONPAGES)\\b(.*)$", "is").exec(t), n = (A == null ? void 0 : A[1].toUpperCase()) === "PAGEREF" ? new RegExp('^\\s*("?)([^\\s"\\\\]+)\\1(.*)$', "s").exec(A[2]) : void 0;
  if (!A || A[1].toUpperCase() === "PAGEREF" && !n) return;
  const s = (e = (n ? n[3] : A[2]).match(/"[^"]*"|\S+/g)) !== null && e !== void 0 ? e : [];
  let r, i;
  const o = [];
  let a = !1, c = !0;
  for (let h = 0; h < s.length; h++) {
    const u = s[h], d = () => {
      var w;
      return (u.length > 2 ? u.slice(2) : (w = s[++h]) !== null && w !== void 0 ? w : "").replace(/^"(.*)"$/, "$1");
    };
    if (/^\\p$/i.test(u)) a = !0;
    else if (u.startsWith("\\#")) {
      var l;
      const w = d();
      c && (c = i === void 0 && Qre(w)), (l = i) !== null && l !== void 0 || (i = w);
    } else if (u.startsWith("\\*")) {
      const w = d(), Q = w.toLowerCase();
      if (Nj.has(Q)) o.push(Q);
      else if (w !== "" && !Fj.has(Q)) {
        var B;
        c && (c = r === void 0 && Lm(w) !== void 0), (B = r) !== null && B !== void 0 || (r = w);
      }
    }
  }
  const g = oe(oe(oe(oe({}, r === void 0 ? {} : { numberFormat: r }), i === void 0 ? {} : { picture: i }), o.length === 0 ? {} : { capitals: o[0] }), {}, { written: c && o.length <= 1 && o[0] !== "caps" && (r === void 0 || i === void 0) });
  return oe(n ? {
    type: "pageReference",
    bookmark: n[2],
    relative: a
  } : {
    type: "pageCount",
    scope: A[1].toUpperCase() === "NUMPAGES" ? "document" : "section"
  }, g);
}, Mre = (t) => new RegExp("^\\s*TOC\\b.*\\\\s\\b", "is").test(t), Dj = (t, { enclosing: e, within: A, inTextBox: n }, { estimate: s, sectionPageCount: r, blank: i, relativeTo: o }) => {
  const a = Ere(t);
  if (a === void 0) return;
  const { bookmarks: c, pageCount: l, bookmarkPageNumbers: B } = s, { numberFormat: g, picture: h, capitals: u, written: d } = a, w = g !== void 0 || h !== void 0, Q = (I) => I === void 0 ? void 0 : h === void 0 ? Lm(g ?? "arabic")(I) : Ire(I, h), p = a.type === "pageReference" && a.relative && A === "counted" && !n ? o == null ? void 0 : o(a.bookmark) : void 0;
  let M;
  return d ? a.type === "pageCount" ? M = Q(a.scope === "document" ? l : r) : e.some(Mre) ? M = void 0 : w ? M = Q(B == null ? void 0 : B.get(a.bookmark)) : M = a.relative ? p : c.get(a.bookmark) : M = void 0, M === void 0 ? i ? "" : void 0 : Cre(M, u);
}, pre = (t, e) => t === "mc:Fallback" || e === "fallback" ? "fallback" : t === "w:del" || t === "w:moveFrom" ? "deleted" : e, Ah = (t, e, A, n, s = "counted", r = !1) => {
  for (let c = 0; c < e.length; c++) {
    const l = e[c], B = t.nameOf(l);
    if (B === void 0) continue;
    const g = A[A.length - 1];
    if (B === "w:fldChar") {
      const h = t.attributeOf(l, "w:fldCharType");
      h === "begin" ? A.push({
        begin: l,
        instruction: "",
        inResult: !1
      }) : h === "separate" && g ? (t.writeClean(g.begin, g.instruction), g.inResult = !0, g.result = n.resultOf(g.instruction, {
        within: s,
        enclosing: A.slice(0, -1).map((u) => u.instruction),
        inTextBox: r
      }), g.result !== void 0 && (e.splice(c + 1, 0, t.textElement(g.result)), c++)) : h === "end" && A.pop();
    } else if (B === "w:instrText" && g && !g.inResult) g.instruction += t.textOf(l);
    else if ((B === "w:t" || B === "w:tab" || B === "w:br" || B === "w:cr") && (g == null ? void 0 : g.result) !== void 0)
      e.splice(c, 1), c--;
    else if (B === "w:fldSimple") {
      const h = n.resultOf(String(t.attributeOf(l, "w:instr")), {
        within: s,
        enclosing: A.map((u) => u.instruction),
        inTextBox: r
      });
      if (h === void 0) {
        var i;
        Ah(t, (i = t.contentOf(l)) !== null && i !== void 0 ? i : [], [], n, s, r);
      } else t.setSimpleFieldResult(l, h);
    } else {
      var o;
      if (B === "w:p") {
        var a;
        (a = n.beforeParagraph) === null || a === void 0 || a.call(n, l);
      }
      Ah(t, (o = t.contentOf(l)) !== null && o !== void 0 ? o : [], A, n, pre(B, s), r || B === "w:txbxContent"), B === "w:p" && n.afterParagraph(l);
    }
  }
}, xj = (t, e) => e.flatMap((A) => {
  var n;
  const s = t.nameOf(A);
  return s === void 0 ? [] : s === "w:sectPr" ? [A] : xj(t, (n = t.contentOf(A)) !== null && n !== void 0 ? n : []);
}), mre = (t, e) => {
  var A;
  return ((A = t.contentOf(e)) !== null && A !== void 0 ? A : []).some((n) => {
    var s;
    return t.nameOf(n) === "w:pPr" && ((s = t.contentOf(n)) !== null && s !== void 0 ? s : []).some((r) => t.nameOf(r) === "w:sectPr");
  });
}, Yre = (t, e, A) => {
  const n = xj(t, [e]).reduce((s, r) => {
    var i, o;
    const a = ((i = t.contentOf(r)) !== null && i !== void 0 ? i : []).flatMap((c) => {
      const l = t.nameOf(c);
      return l === "w:headerReference" || l === "w:footerReference" ? [[`${l} ${String(t.attributeOf(c, "w:type"))}`, String(t.attributeOf(c, "r:id"))]] : [];
    });
    return [...s, new Map([...(o = s[s.length - 1]) !== null && o !== void 0 ? o : [], ...a])];
  }, []).reduce((s, r, i) => {
    for (const a of r.values()) {
      var o;
      s.set(a, [...(o = s.get(a)) !== null && o !== void 0 ? o : [], A[i]]);
    }
    return s;
  }, /* @__PURE__ */ new Map());
  return new Map([...n].flatMap(([s, [r, ...i]]) => r !== void 0 && i.every((o) => o === r) ? [[s, r]] : []));
}, yre = (t, e, A, { blank: n }) => {
  const { sectionPageCounts: s = [], relativePositions: r } = A;
  let i = 0;
  const o = /* @__PURE__ */ new Map(), a = (c) => {
    var l, B;
    const g = (l = o.get(c)) !== null && l !== void 0 ? l : 0;
    return o.set(c, g + 1), r == null || (B = r.get(c)) === null || B === void 0 ? void 0 : B[g];
  };
  return Ah(t, [e], [], {
    resultOf: (c, l) => Dj(c, l, {
      estimate: A,
      sectionPageCount: s[i],
      blank: n,
      relativeTo: a
    }),
    afterParagraph: (c) => {
      i += mre(t, c) ? 1 : 0;
    }
  }), Yre(t, e, s);
}, Fre = (t, e, A, { blank: n, sectionPageCount: s, notes: r = !1 }) => {
  const i = (o) => {
    const a = A.bookmarks.get(o);
    return a === void 0 ? void 0 : `on page ${a}`;
  };
  Ah(t, [e], [], {
    resultOf: (o, a) => Dj(o, a, oe({
      estimate: A,
      sectionPageCount: s,
      blank: n
    }, r ? { relativeTo: i } : {})),
    afterParagraph: () => {
    }
  });
}, Nre = (t, e, { beforeParagraph: A, resultOf: n }) => Ah(t, [e], [], {
  resultOf: (s, { within: r }) => n(s, r),
  beforeParagraph: A,
  afterParagraph: () => {
  }
}), Dre = class extends Z {
  constructor(t = {}) {
    super("w:instrText"), T(this, "properties", void 0), this.properties = t, this.root.push(new Ki({ space: Pi.PRESERVE }));
    let e = "TOC";
    if (this.properties.captionLabel && (e = `${e} \\a "${this.properties.captionLabel}"`), this.properties.entriesFromBookmark && (e = `${e} \\b "${this.properties.entriesFromBookmark}"`), this.properties.captionLabelIncludingNumbers && (e = `${e} \\c "${this.properties.captionLabelIncludingNumbers}"`), this.properties.sequenceAndPageNumbersSeparator && (e = `${e} \\d "${this.properties.sequenceAndPageNumbersSeparator}"`), this.properties.tcFieldIdentifier && (e = `${e} \\f "${this.properties.tcFieldIdentifier}"`), this.properties.hyperlink && (e = `${e} \\h`), this.properties.tcFieldLevelRange && (e = `${e} \\l "${this.properties.tcFieldLevelRange}"`), this.properties.pageNumbersEntryLevelsRange && (e = `${e} \\n "${this.properties.pageNumbersEntryLevelsRange}"`), this.properties.headingStyleRange && (e = `${e} \\o "${this.properties.headingStyleRange}"`), this.properties.entryAndPageNumberSeparator && (e = `${e} \\p "${this.properties.entryAndPageNumberSeparator}"`), this.properties.seqFieldIdentifierForPrefix && (e = `${e} \\s "${this.properties.seqFieldIdentifierForPrefix}"`), this.properties.stylesWithLevels && this.properties.stylesWithLevels.length) {
      const A = this.properties.stylesWithLevels.map((n) => `${n.styleName},${n.level}`).join(",");
      e = `${e} \\t "${A}"`;
    }
    this.properties.useAppliedParagraphOutlineLevel && (e = `${e} \\u`), this.properties.preserveTabInEntries && (e = `${e} \\w`), this.properties.preserveNewLineInEntries && (e = `${e} \\x`), this.properties.hideTabAndPageNumbersInWebView && (e = `${e} \\z`), this.root.push(e);
  }
}, xre = class extends Z {
  constructor() {
    super("w:sdtContent");
  }
}, Gre = (t) => t === void 0 ? tj() : yB(t), Gj = /* @__PURE__ */ new WeakMap(), zre = class {
  constructor() {
    T(this, "ids", []);
  }
  get(t) {
    var e, A;
    return (A = (e = this.ids)[t]) !== null && A !== void 0 || (e[t] = sj()), this.ids[t];
  }
}, Pr = (t) => typeof t == "object" && t !== null ? Object.keys(t)[0] : void 0, Kr = (t) => {
  const e = Pr(t), A = e === void 0 ? void 0 : t[e];
  return Array.isArray(A) ? A : A === void 0 ? [] : [A];
}, _s = (t, e) => Kr(t).find((A) => Pr(A) === e), Gs = (t, e) => {
  var A;
  return (A = _s(t, "_attr")) === null || A === void 0 || (A = A._attr) === null || A === void 0 ? void 0 : A[e];
}, Sm = (t, e) => {
  const A = Gs(t, e);
  return A === void 0 ? void 0 : Number(A);
}, Ure = /* @__PURE__ */ new Set([
  "w:tbl",
  "w:tr",
  "w:tc",
  "w:sdt",
  "w:sdtContent",
  "w:customXml"
]), zj = (t) => t.flatMap((e) => {
  const A = Pr(e);
  return A === "w:p" || Gj.has(e) ? [e] : A !== void 0 && Ure.has(A) ? zj(Kr(e)) : [];
}), bre = /* @__PURE__ */ new Set([
  "w:r",
  "w:hyperlink",
  "w:ins",
  "w:moveTo",
  "w:smartTag",
  "w:customXml",
  "w:sdt",
  "w:sdtContent",
  "w:fldSimple",
  "w:dir",
  "w:bdo"
]), vre = (t) => {
  switch (Pr(t)) {
    case "w:t":
      return Kr(t).filter((e) => typeof e == "string").join("");
    case "w:tab":
      return "	";
    case "w:br":
      return [void 0, "textWrapping"].includes(Gs(t, "w:type")) ? `
` : "";
    case "w:cr":
      return `
`;
    case "w:noBreakHyphen":
      return "-";
    default:
      return "";
  }
}, jre = (t) => {
  const e = [], A = (n) => {
    const s = Pr(n);
    if (s !== void 0 && bre.has(s)) return Kr(n).map(A).join("");
    if (s === "w:fldChar") {
      const r = Gs(n, "w:fldCharType");
      return r === "begin" ? e.push(!1) : r === "separate" ? e[e.length - 1] = !0 : e.pop(), "";
    }
    return e.every(Boolean) ? vre(n) : "";
  };
  return Kr(t).map(A).join("");
}, Uj = (t) => {
  const e = Pr(t);
  return e === "w:bookmarkStart" ? [{
    start: !0,
    id: Gs(t, "w:id"),
    name: Gs(t, "w:name")
  }] : e === "w:bookmarkEnd" ? [{
    start: !1,
    id: Gs(t, "w:id")
  }] : e === void 0 || e === "_attr" ? [] : Kr(t).flatMap(Uj);
}, Hre = (t) => {
  const e = /* @__PURE__ */ new Map();
  return t.map((A) => {
    const n = Uj(A), s = /* @__PURE__ */ new Set([...e.values(), ...n.flatMap((r) => r.start ? [r.name] : [])]);
    for (const r of n) r.start ? e.set(r.id, r.name) : e.delete(r.id);
    return s;
  });
}, kre = (t, e) => {
  const A = e ? Hre(t) : [];
  return t.map((n, s) => {
    var r;
    const i = _s(n, "w:pPr");
    return {
      element: n,
      styleId: Gs(_s(i, "w:pStyle"), "w:val"),
      outlineLevel: Sm(_s(i, "w:outlineLvl"), "w:val"),
      text: jre(n),
      bookmarks: (r = A[s]) !== null && r !== void 0 ? r : /* @__PURE__ */ new Set()
    };
  });
}, bj = (t) => {
  var e;
  const A = (e = t.file) === null || e === void 0 || (e = e.Styles) === null || e === void 0 ? void 0 : e.prepForXml(t);
  return new Map(Kr(A).filter((n) => Pr(n) === "w:style" && ["paragraph", void 0].includes(Gs(n, "w:type"))).map((n) => [Gs(n, "w:styleId"), {
    name: Gs(_s(n, "w:name"), "w:val"),
    basedOn: Gs(_s(n, "w:basedOn"), "w:val"),
    outlineLevel: Sm(_s(_s(n, "w:pPr"), "w:outlineLvl"), "w:val")
  }]));
}, vj = (t) => {
  const e = /^\s*(\d+)\s*-\s*(\d+)\s*$/.exec(t);
  return e ? [Number(e[1]), Number(e[2])] : void 0;
}, JE = (t, [e, A]) => t >= e && t <= A, Tm = (t, e) => {
  var A, n;
  if (t === void 0) return;
  const s = /^heading ?([1-9])$/i.exec((A = (n = e.get(t)) === null || n === void 0 ? void 0 : n.name) !== null && A !== void 0 ? A : t);
  return s ? Number(s[1]) : void 0;
}, jj = (t, e, A = 0) => {
  var n;
  if (t === void 0 || A > e.size) return;
  const s = e.get(t), r = Tm(t, e);
  return (n = s == null ? void 0 : s.outlineLevel) !== null && n !== void 0 ? n : r === void 0 ? jj(s == null ? void 0 : s.basedOn, e, A + 1) : r - 1;
}, Rre = (t) => {
  const e = bj(t);
  return (A) => {
    const n = _s(A, "w:pPr"), s = Gs(_s(n, "w:pStyle"), "w:val"), r = Tm(s, e), i = Hj({
      styleId: s,
      outlineLevel: Sm(_s(n, "w:outlineLvl"), "w:val")
    }, e), o = i === void 0 || i >= 9 ? void 0 : i + 1;
    return r !== void 0 && (o === void 0 || o === r) ? r : o === void 0 ? void 0 : "unclear";
  };
}, Hj = (t, e) => {
  var A;
  return (A = t.outlineLevel) !== null && A !== void 0 ? A : jj(t.styleId, e);
}, Lre = (t, e, A) => {
  var n;
  const { entriesFromBookmark: s, headingStyleRange: r, stylesWithLevels: i = [], useAppliedParagraphOutlineLevel: o } = t;
  if (e.text.trim() === "" || s && !e.bookmarks.has(s)) return;
  const a = [e.styleId, e.styleId === void 0 || (n = A.get(e.styleId)) === null || n === void 0 ? void 0 : n.name].filter((u) => u !== void 0).map((u) => u.toLowerCase()), c = i.find((u) => a.includes(u.styleName.toLowerCase()));
  if (c) return c.level;
  const l = !!r || i.length > 0 || !!o || !!t.tcFieldIdentifier || !!t.tcFieldLevelRange || !!t.captionLabel || !!t.captionLabelIncludingNumbers, B = r ? vj(r) : l ? void 0 : [1, 9], g = Tm(e.styleId, A);
  if (B && g !== void 0 && JE(g, B)) return g;
  const h = o ? Hj(e, A) : void 0;
  return h !== void 0 && JE(h + 1, B ?? [1, 9]) ? h + 1 : void 0;
}, Sre = (t, e) => {
  const A = e.preserveTabInEntries ? t : t.replace(/\t/g, " ");
  return (e.preserveNewLineInEntries ? A.split(`
`) : [A.replace(/\n/g, " ")]).map((n, s) => new nr({
    break: s > 0 ? 1 : void 0,
    children: n.split("	").flatMap((r, i) => [...i > 0 ? [new Wm()] : [], ...r === "" ? [] : [r]])
  }));
}, Tre = ({ text: t, separator: e }) => e === "tab" ? [new nr(t), new nr({ children: [new Wm()] })] : [new nr(`${t} `)], Jre = (t, e) => {
  const A = 240 * (t - 1) + e + 240;
  return A <= 1920 ? Math.ceil(A / 240) * 240 : Math.round(A);
}, Wre = (t, e) => {
  var A, n;
  return (A = (n = [...e].find(([, s]) => {
    var r;
    return ((r = s.name) === null || r === void 0 ? void 0 : r.toLowerCase()) === `toc ${t}`;
  })) === null || n === void 0 ? void 0 : n[0]) !== null && A !== void 0 ? A : `TOC${t}`;
}, Ore = ({ properties: t, beginDirty: e, textWidth: A, tabLeader: n }, s, r, i) => {
  var o;
  const a = t.pageNumbersEntryLevelsRange ? (o = vj(t.pageNumbersEntryLevelsRange)) !== null && o !== void 0 ? o : [1, 9] : void 0, c = new xre();
  return s.forEach((l, B) => {
    var g;
    const h = a === void 0 || !JE(l.level, a), u = [
      ...l.listNumber ? Tre(l.listNumber) : [],
      ...Sre(l.title, t),
      ...h ? [new nr({ children: [t.entryAndPageNumberSeparator || new Wm()] }), new zie(l.bookmark, { hyperlink: t.hyperlink })] : []
    ];
    c.addChildElement(new gA({
      style: Wre(l.level, r),
      tabStops: [...((g = l.listNumber) === null || g === void 0 ? void 0 : g.separator) === "tab" ? [{
        type: "left",
        position: Jre(l.level, l.listNumber.width)
      }] : [], {
        type: "right",
        position: A,
        leader: n
      }],
      children: [...B === 0 ? [new Or({ children: [
        Gre(e),
        new Dre(t),
        Zc()
      ] })] : [], ...t.hyperlink ? [new Yie({
        anchor: l.bookmark,
        children: u
      })] : u]
    }));
  }), c.addChildElement(new gA({ children: [new Or({ children: [qc()] })] })), c.prepForXml(i);
}, Pre = (t, e, A, n) => {
  const s = Kr(t), r = s.findIndex((i) => Pr(i) === "w:pPr") + 1;
  t["w:p"] = [
    ...s.slice(0, r),
    new Tj(e, A).prepForXml(n),
    ...s.slice(r),
    new Jj(A).prepForXml(n)
  ];
}, Kre = (t, e, A, n) => {
  const s = zj(Kr(t)), r = s.flatMap((l) => {
    const B = Gj.get(l);
    return B ? [[l, B]] : [];
  });
  if (r.length === 0) return;
  const i = bj(e), o = r.some(([, { properties: l }]) => !!l.entriesFromBookmark), a = kre(s.filter((l) => Pr(l) === "w:p"), o).map((l) => ({
    paragraph: l,
    levels: r.map(([, { properties: B }]) => Lre(B, l, i))
  })).filter(({ levels: l }) => l.some((B) => B !== void 0)).map((l, B) => oe(oe({}, l), {}, { id: A.get(B) }));
  for (const { paragraph: l, id: B } of a) Pre(l.element, `_Toc${B}`, B, e);
  const c = a.length > 0 ? n == null ? void 0 : n(t) : void 0;
  r.forEach(([l, B], g) => {
    const h = a.flatMap(({ paragraph: u, levels: d, id: w }) => {
      const Q = d[g], p = c == null ? void 0 : c.get(`_Toc${w}`);
      return Q === void 0 ? [] : [oe({
        title: u.text,
        level: Q,
        bookmark: `_Toc${w}`
      }, p ? { listNumber: p } : {})];
    });
    h.length !== 0 && (l["w:sdt"] = Kr(l).map((u) => Pr(u) === "w:sdtContent" ? Ore(B, h, i, e) : u));
  });
}, Vre = new RegExp("^\\p{L}[\\p{L}\\p{N}_]*$", "u"), Xre = (t) => {
  var e, A;
  let n, s = !1, r, i = !1, o = !1;
  for (let B = 0; B < t.length; B++) {
    var a, c;
    const g = t[B], h = (a = t[B + 1]) !== null && a !== void 0 ? a : "";
    let u;
    if (B === 0 && !g.startsWith("\\")) u = { type: "bookmark" };
    else if (g === "\\c" || g === "\\n") u = { type: g === "\\c" ? "repeat" : "next" };
    else if ((g === "\\r" || g === "\\s") && /^\d+$/.test(h))
      B++, u = g === "\\r" ? {
        type: "reset",
        to: Number(h)
      } : {
        type: "heading",
        level: Number(h)
      };
    else if (g === "\\h") s = !0;
    else if (g === "\\#" && B + 1 < t.length)
      B++, o = !0;
    else if (g === "\\*" && B + 1 < t.length) {
      const d = t[++B];
      if (Nj.has(d.toLowerCase())) i = !0;
      else if (!Fj.has(d.toLowerCase())) {
        if (r !== void 0) return;
        r = d;
      }
    } else return;
    if (u && n) return;
    n = (c = u) !== null && c !== void 0 ? c : n;
  }
  if ((n == null ? void 0 : n.type) === "bookmark" && t.length > 1) return;
  const l = !o && !(i && r !== void 0 && r.toLowerCase() !== "arabic");
  return {
    step: (e = n) !== null && e !== void 0 ? e : { type: "next" },
    hidden: s && r === void 0,
    format: l ? (A = r) !== null && A !== void 0 ? A : "ARABIC" : ""
  };
}, Jm = (t) => {
  var e;
  const A = new RegExp("^\\s*SEQ\\b(.*)$", "is").exec(t);
  if (!A) return;
  const [n, ...s] = (e = A[1].match(/"[^"]*"|\S+/g)) !== null && e !== void 0 ? e : [];
  if (n === void 0) return {};
  const r = n.replace(/^"(.*)"$/, "$1");
  return Vre.test(r) ? {
    identifier: r,
    sequence: Xre(s)
  } : { identifier: r };
}, Zre = (t) => Jm(t) !== void 0, WE = (t) => typeof t != "object" || t === null ? [] : Array.isArray(t) ? t.flatMap(WE) : Object.entries(t).flatMap(([e, A]) => [...(e === "w:instrText" && Array.isArray(A) ? A : e === "_attr" ? [A["w:instr"]] : []).flatMap((n) => {
  const s = typeof n == "string" ? Jm(n) : void 0;
  return (s == null ? void 0 : s.identifier) === void 0 ? [] : [s.identifier.toLowerCase()];
}), ...WE(A)]), qre = (t) => {
  var e;
  const A = (e = t.file) === null || e === void 0 ? void 0 : e.Comments;
  if (!A) return /* @__PURE__ */ new Set();
  const n = {
    View: A,
    Relationships: A.Relationships
  };
  return new Set(WE(A.prepForXml(oe(oe({}, t), {}, {
    viewWrapper: n,
    stack: []
  }))));
}, _re = (t) => {
  const e = Rre(t), A = /* @__PURE__ */ new Map(), n = /* @__PURE__ */ new Map(), s = [];
  let r = -1, i = -1, o;
  const a = (c, l) => {
    var B;
    const g = Math.max(-1, ...s.slice(1, l + 1).filter((d) => d !== void 0)), h = ((B = n.get(c)) !== null && B !== void 0 ? B : []).filter((d) => d.paragraph >= g), u = h.every(({ step: d }) => (d == null ? void 0 : d.type) === "next" || (d == null ? void 0 : d.type) === "heading" && d.level === l);
    return r > g || !u ? void 0 : h.length + 1;
  };
  return {
    startParagraph: (c) => {
      i++;
      const l = e(c);
      l === "unclear" ? r = i : l !== void 0 && (s[l] = i);
    },
    numberOf: (c, l) => {
      var B, g, h;
      const { identifier: u, sequence: d } = Jm(c);
      if (u === void 0 || l === "fallback") return;
      (B = o) !== null && B !== void 0 || (o = qre(t));
      const w = u.toLowerCase();
      if ((d == null ? void 0 : d.step.type) === "bookmark" && l === "counted" && !o.has(w)) return;
      const Q = A.has(w) ? A.get(w) : 0, p = o.has(w) || l === "deleted" || d == null ? void 0 : d.step, M = (p == null ? void 0 : p.type) === "reset" ? p.to : (p == null ? void 0 : p.type) === "repeat" ? Q : (p == null ? void 0 : p.type) === "heading" ? a(w, p.level) : (p == null ? void 0 : p.type) === "next" && Q !== void 0 ? Q + 1 : void 0;
      return A.set(w, M), n.set(w, [...(g = n.get(w)) !== null && g !== void 0 ? g : [], oe({ paragraph: i }, M === void 0 ? {} : { step: p })]), M === void 0 || d === void 0 ? void 0 : d.hidden ? "" : (h = Lm(d.format)) === null || h === void 0 ? void 0 : h(M);
    }
  };
}, NI = (t) => {
  const e = typeof t == "object" && t !== null && !Array.isArray(t) ? Object.keys(t)[0] : void 0;
  return e === "_attr" ? void 0 : e;
}, bN = (t) => ({ "w:t": [{ _attr: { "xml:space": "preserve" } }, t] }), wf = {
  nameOf: NI,
  contentOf: (t) => {
    const e = t[NI(t)];
    return Array.isArray(e) ? e : void 0;
  },
  attributeOf: (t, e) => {
    var A;
    const n = t[NI(t)], s = Array.isArray(n) ? n.find((r) => typeof r == "object" && r !== null && "_attr" in r) : n;
    return s == null || (A = s._attr) === null || A === void 0 ? void 0 : A[e];
  },
  textOf: (t) => wf.contentOf(t).filter((e) => typeof e == "string").join(""),
  textElement: bN,
  writeClean: (t) => {
    if (Qne(t)) {
      const e = t["w:fldChar"]._attr;
      t["w:fldChar"] = { _attr: Object.fromEntries(Object.entries(e).filter(([A]) => A !== "w:dirty")) };
    }
  },
  setSimpleFieldResult: (t, e) => {
    const A = t["w:fldSimple"];
    t["w:fldSimple"] = [...(Array.isArray(A) ? A : [A]).filter((n) => typeof n == "object" && n !== null && "_attr" in n), { "w:r": [bN(e)] }];
  }
}, kj = /* @__PURE__ */ new WeakMap(), $re = (t, e) => {
  const { startParagraph: A, numberOf: n } = _re(e);
  Nre(wf, t, {
    beforeParagraph: (s) => A(s),
    resultOf: (s, r) => Zre(s) ? n(s, r) : void 0
  });
}, eie = (t, e, A) => {
  const n = A(t, e), s = yre(wf, t, n, { blank: !1 });
  e.file && kj.set(e.file, {
    estimate: n,
    partPageCounts: s
  });
}, Nh = (t, e, A) => {
  const n = e.file && kj.get(e.file);
  if (!t || !n) return;
  const s = A === void 0 ? void 0 : n.partPageCounts.get(`rId${A}`), r = "w:footnotes" in t || "w:endnotes" in t;
  Fre(wf, t, n.estimate, {
    blank: !1,
    sectionPageCount: s,
    notes: r
  });
}, tie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { xmlns: "xmlns" });
  }
}, zA = class Rj extends Z {
  constructor() {
    super("Relationships"), this.root.push(new tie({ xmlns: "http://schemas.openxmlformats.org/package/2006/relationships" }));
  }
  /**
  * Creates a new relationship to another part in the package.
  *
  * @param id - Unique identifier for this relationship (will be prefixed with "rId")
  * @param type - Relationship type URI (e.g., image, header, hyperlink)
  * @param target - Path to the target part
  * @param targetMode - Optional mode indicating if target is external
  */
  addRelationship(e, A, n, s) {
    this.root.push(tre(`rId${e}`, A, n, s));
  }
  /**
  * Creates a copy of the relationships given. Relationships added to the copy aren't added to them, so the compiler
  * adds the ones it writes for a part, such as to its images, to a copy, and packing a document again doesn't add
  * them a second time.
  *
  * Static, as `IContext` is public and has `Relationships`, so a new instance member would change the public API.
  *
  * @param relationships - The relationships to copy
  */
  static copy(e) {
    const A = new Rj();
    return A.root.push(...e.root.slice(1)), A;
  }
  /**
  * Gets the count of relationships in this collection.
  * Excludes the attributes element from the count.
  */
  get RelationshipCount() {
    return this.root.length - 1;
  }
}, Aie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      id: "w:id",
      initials: "w:initials",
      author: "w:author",
      date: "w:date"
    });
  }
}, nie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      "xmlns:wpc": "xmlns:wpc",
      "xmlns:cx": "xmlns:cx",
      "xmlns:cx1": "xmlns:cx1",
      "xmlns:cx2": "xmlns:cx2",
      "xmlns:cx3": "xmlns:cx3",
      "xmlns:cx4": "xmlns:cx4",
      "xmlns:cx5": "xmlns:cx5",
      "xmlns:cx6": "xmlns:cx6",
      "xmlns:cx7": "xmlns:cx7",
      "xmlns:cx8": "xmlns:cx8",
      "xmlns:mc": "xmlns:mc",
      "xmlns:aink": "xmlns:aink",
      "xmlns:am3d": "xmlns:am3d",
      "xmlns:o": "xmlns:o",
      "xmlns:r": "xmlns:r",
      "xmlns:m": "xmlns:m",
      "xmlns:v": "xmlns:v",
      "xmlns:wp14": "xmlns:wp14",
      "xmlns:wp": "xmlns:wp",
      "xmlns:w10": "xmlns:w10",
      "xmlns:w": "xmlns:w",
      "xmlns:w14": "xmlns:w14",
      "xmlns:w15": "xmlns:w15",
      "xmlns:w16cex": "xmlns:w16cex",
      "xmlns:w16cid": "xmlns:w16cid",
      "xmlns:w16": "xmlns:w16",
      "xmlns:w16sdtdh": "xmlns:w16sdtdh",
      "xmlns:w16se": "xmlns:w16se",
      "xmlns:wpg": "xmlns:wpg",
      "xmlns:wpi": "xmlns:wpi",
      "xmlns:wne": "xmlns:wne",
      "xmlns:wps": "xmlns:wps",
      "mc:Ignorable": "mc:Ignorable"
    });
  }
}, vN = class extends Z {
  constructor({ id: t, initials: e, author: A, date: n = /* @__PURE__ */ new Date(), children: s }, r) {
    super("w:comment"), T(this, "paraId", void 0), this.paraId = r, this.root.push(new Aie({
      id: t,
      initials: e,
      author: A,
      date: n.toISOString()
    }));
    for (const i of s) this.root.push(i);
  }
  /**
  * Serializes this comment to XML, injecting w14:paraId and w14:textId into the last
  * paragraph when threading is active. These attributes link the comment to its
  * corresponding w15:commentEx entry in commentsExtended.xml.
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    if (!e || !this.paraId) return e;
    const A = e["w:comment"];
    if (!Array.isArray(A)) return e;
    for (let n = A.length - 1; n >= 0; n--) {
      const s = A[n];
      if (s && typeof s == "object" && "w:p" in s) {
        const r = s["w:p"];
        Array.isArray(r) && r.unshift({ _attr: {
          "w14:paraId": this.paraId,
          "w14:textId": this.paraId
        } });
        break;
      }
    }
    return e;
  }
}, sie = (t) => (t + 1).toString(16).toUpperCase().padStart(8, "0"), rie = class extends Z {
  constructor({ children: t }) {
    super("w:comments"), T(this, "relationships", void 0), T(this, "threadData", void 0), T(this, "commentIdsData", void 0), T(this, "isEmpty", void 0), this.isEmpty = t.length === 0, this.root.push(new nie({
      "xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      "xmlns:cx": "http://schemas.microsoft.com/office/drawing/2014/chartex",
      "xmlns:cx1": "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
      "xmlns:cx2": "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
      "xmlns:cx3": "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
      "xmlns:cx4": "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
      "xmlns:cx5": "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
      "xmlns:cx6": "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
      "xmlns:cx7": "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
      "xmlns:cx8": "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
      "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
      "xmlns:aink": "http://schemas.microsoft.com/office/drawing/2016/ink",
      "xmlns:am3d": "http://schemas.microsoft.com/office/drawing/2017/model3d",
      "xmlns:o": "urn:schemas-microsoft-com:office:office",
      "xmlns:r": "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
      "xmlns:m": "http://schemas.openxmlformats.org/officeDocument/2006/math",
      "xmlns:v": "urn:schemas-microsoft-com:vml",
      "xmlns:wp14": "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
      "xmlns:wp": "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
      "xmlns:w10": "urn:schemas-microsoft-com:office:word",
      "xmlns:w": "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
      "xmlns:w14": "http://schemas.microsoft.com/office/word/2010/wordml",
      "xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
      "xmlns:w16cex": "http://schemas.microsoft.com/office/word/2018/wordml/cex",
      "xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
      "xmlns:w16": "http://schemas.microsoft.com/office/word/2018/wordml",
      "xmlns:w16sdtdh": "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
      "xmlns:w16se": "http://schemas.microsoft.com/office/word/2015/wordml/symex",
      "xmlns:wpg": "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
      "xmlns:wpi": "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
      "xmlns:wne": "http://schemas.microsoft.com/office/word/2006/wordml",
      "xmlns:wps": "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
      "mc:Ignorable": "w14 w15 wp14"
    }));
    const e = t.some((n) => n.parentId !== void 0), A = t.some((n) => n.durableId !== void 0);
    if (e || A) {
      const n = new Map(t.map((s) => [s.id, sie(s.id)]));
      for (const s of t) this.root.push(new vN(s, n.get(s.id)));
      e && (this.threadData = t.map((s) => ({
        paraId: n.get(s.id),
        parentParaId: s.parentId !== void 0 ? n.get(s.parentId) : void 0,
        done: s.resolved
      }))), A && (this.commentIdsData = t.map((s) => {
        var r;
        return {
          paraId: n.get(s.id),
          durableId: (r = s.durableId) !== null && r !== void 0 ? r : n.get(s.id)
        };
      }));
    } else for (const n of t) this.root.push(new vN(n));
    this.relationships = new zA();
  }
  get Relationships() {
    return this.relationships;
  }
  /** Thread data for commentsExtended.xml, or undefined when no comments use parentId. */
  get ThreadData() {
    return this.threadData;
  }
  /** Comment id data for commentsIds.xml, or undefined when no comments carry a durableId. */
  get CommentIdsData() {
    return this.commentIdsData;
  }
  /** Whether there are no comments, in which case the document has no comments.xml part. */
  get IsEmpty() {
    return this.isEmpty;
  }
  /**
  * Formats the comments, with the page numbers worked out for their document written into their fields, when the
  * document's body is written with an estimate of its pages.
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    return Nh(e, t), e;
  }
}, iie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      "xmlns:wpc": "xmlns:wpc",
      "xmlns:mc": "xmlns:mc",
      "xmlns:w15": "xmlns:w15",
      "mc:Ignorable": "mc:Ignorable"
    });
  }
}, oie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      paraId: "w15:paraId",
      paraIdParent: "w15:paraIdParent",
      done: "w15:done"
    });
  }
}, aie = class extends Z {
  constructor(t) {
    super("w15:commentEx"), this.root.push(new oie({
      paraId: t.paraId,
      paraIdParent: t.parentParaId,
      done: t.done !== void 0 ? t.done ? "1" : "0" : void 0
    }));
  }
}, cie = class extends Z {
  constructor(t) {
    super("w15:commentsEx"), this.root.push(new iie({
      "xmlns:wpc": "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
      "xmlns:w15": "http://schemas.microsoft.com/office/word/2012/wordml",
      "mc:Ignorable": "w15"
    }));
    for (const e of t) this.root.push(new aie(e));
  }
}, lie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      paraId: "w16cid:paraId",
      durableId: "w16cid:durableId"
    });
  }
}, Bie = class extends Z {
  constructor(t) {
    super("w16cid:commentId"), this.root.push(new lie({
      paraId: t.paraId,
      durableId: t.durableId
    }));
  }
}, gie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      "xmlns:w16cid": "xmlns:w16cid",
      "xmlns:mc": "xmlns:mc",
      "mc:Ignorable": "mc:Ignorable"
    });
  }
}, hie = class extends Z {
  constructor(t) {
    super("w16cid:commentsIds"), this.root.push(new gie({
      "xmlns:w16cid": "http://schemas.microsoft.com/office/word/2016/wordml/cid",
      "xmlns:mc": "http://schemas.openxmlformats.org/markup-compatibility/2006",
      "mc:Ignorable": "w16cid"
    }));
    for (const e of t) this.root.push(new Bie(e));
  }
}, uie = class extends Vv {
  constructor() {
    super("w:endnoteRef");
  }
}, Wm = class extends Vv {
  constructor() {
    super("w:tab");
  }
}, die = {
  /** Page break - text continues at the beginning of the next page */
  PAGE: "page"
}, wie = class extends Z {
  constructor(t) {
    super("w:br"), this.root.push(new jn({ type: t }));
  }
}, fie = class extends Or {
  constructor() {
    super({}), this.root.push(new wie(die.PAGE));
  }
}, Qie = class extends Z {
  constructor() {
    super("w:pageBreakBefore");
  }
}, vl = {
  /** Line spacing is automatically determined based on content */
  AUTO: "auto"
}, Iie = ({ after: t, before: e, line: A, lineRule: n, beforeAutoSpacing: s, afterAutoSpacing: r }) => new K({
  name: "w:spacing",
  attributes: {
    after: {
      key: "w:after",
      value: t
    },
    before: {
      key: "w:before",
      value: e
    },
    line: {
      key: "w:line",
      value: A
    },
    lineRule: {
      key: "w:lineRule",
      value: n
    },
    beforeAutoSpacing: {
      key: "w:beforeAutospacing",
      value: s
    },
    afterAutoSpacing: {
      key: "w:afterAutospacing",
      value: r
    }
  }
}), zc = {
  /** Heading 1 style */
  HEADING_1: "Heading1",
  /** Heading 2 style */
  HEADING_2: "Heading2",
  /** Heading 3 style */
  HEADING_3: "Heading3",
  /** Heading 4 style */
  HEADING_4: "Heading4",
  /** Heading 5 style */
  HEADING_5: "Heading5",
  /** Heading 6 style */
  HEADING_6: "Heading6"
}, FB = (t) => new K({
  name: "w:pStyle",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), jN = {
  /** Left-aligned tab stop */
  LEFT: "left",
  /** Right-aligned tab stop */
  RIGHT: "right"
}, Cie = ({ type: t, position: e, leader: A }) => new K({
  name: "w:tab",
  attributes: {
    val: {
      key: "w:val",
      value: t
    },
    pos: {
      key: "w:pos",
      value: Gr(e)
    },
    leader: {
      key: "w:leader",
      value: A
    }
  }
}), Eie = (t) => new K({
  name: "w:tabs",
  children: t.map((e) => Cie(e))
}), U0 = class extends Z {
  constructor(t, e) {
    super("w:numPr"), this.root.push(new Mie(e)), this.root.push(new pie(t));
  }
}, Mie = class extends Z {
  constructor(t) {
    if (super("w:ilvl"), t > 9) throw new Error("Level cannot be greater than 9. Read more here: https://answers.microsoft.com/en-us/msoffice/forum/all/does-word-support-more-than-9-list-levels/d130fdcd-1781-446d-8c84-c6c79124e4d7");
    this.root.push(new jn({ val: t }));
  }
}, pie = class extends Z {
  constructor(t) {
    super("w:numId"), this.root.push(new jn({ val: typeof t == "string" ? `{${t}}` : t }));
  }
}, Lj = class extends Z {
  constructor(...t) {
    super(...t), T(
      this,
      /** Marker property identifying this as a FileChild */
      "fileChild",
      Symbol()
    );
  }
}, mie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      id: "r:id",
      history: "w:history",
      anchor: "w:anchor"
    });
  }
}, ff = class extends Z {
  /**
  * @param children - Inline content of the hyperlink
  * @param relationshipId - Id of the external relationship, without the rId prefix
  * @param anchor - Bookmark name or external URL fragment
  * @param externalLink - The full address of an external hyperlink, so the relationship id is kept alongside its anchor
  */
  constructor(t, e, A, n) {
    super("w:hyperlink"), T(this, "linkId", void 0), T(this, "drawingLink", void 0), this.linkId = e, this.drawingLink = A && n !== void 0 ? new Ej(n) : void 0;
    const s = new mie({
      history: 1,
      anchor: A || void 0,
      id: !A || n !== void 0 ? `rId${this.linkId}` : void 0
    });
    this.root.push(s), t.forEach((r) => {
      this.root.push(r);
    });
  }
  /**
  * Creates the `a:hlinkClick` of a picture in the hyperlink, which links to the same address.
  *
  * The hyperlink decides which relationship its pictures use, rather than the pictures reading `linkId`, because only it
  * knows whether that relationship has lost the fragment to `w:anchor`. The picture's relationship is added as the
  * picture is written, through the context's relationships, so it lands in the part the picture is in, both when
  * packing and when patching.
  *
  * @param context - The context the picture is written in, whose relationships get the picture's link if it has its own
  * @param declareNamespace - Declares the DrawingML namespace, for elements outside `a:graphic` such as `wp:docPr`
  */
  createDrawingClick(t, e) {
    return this.drawingLink ? (this.drawingLink.addRelationship(t), this.drawingLink.createClick(e)) : Cj(this.linkId, e);
  }
}, Yie = class extends ff {
  constructor(t) {
    super(t.children, Rm(), t.anchor);
  }
}, yie = class extends Z {
  constructor(t) {
    super("w:externalHyperlink"), T(this, "options", void 0), this.options = t;
  }
}, Fie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      id: "w:id",
      name: "w:name"
    });
  }
}, Nie = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { id: "w:id" });
  }
}, Die = class Sj {
  constructor(e) {
    T(this, "start", void 0), T(this, "children", void 0), T(this, "end", void 0);
    const A = sj();
    this.start = new Tj(e.id, A), this.children = e.children, this.end = new Jj(A);
  }
  /**
  * The components written in this bookmark's place: its start, its children and its end. A bookmark in its
  * children is written the same way, so one bookmark can hold another.
  *
  * @internal
  */
  get writtenAs() {
    return [
      this.start,
      ...this.children.flatMap((e) => e instanceof Sj ? e.writtenAs : [e]),
      this.end
    ];
  }
}, Tj = class extends Z {
  constructor(t, e) {
    super("w:bookmarkStart");
    const A = new Fie({
      name: t,
      id: e
    });
    this.root.push(A);
  }
}, Jj = class extends Z {
  constructor(t) {
    super("w:bookmarkEnd");
    const e = new Nie({ id: t });
    this.root.push(e);
  }
}, xie = (t) => new K({
  name: "w:outlineLvl",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), Gie = class extends Z {
  constructor(t, e = {}) {
    super("w:instrText"), this.root.push(new Ki({ space: Pi.PRESERVE }));
    let A = `PAGEREF ${t}`;
    e.hyperlink && (A = `${A} \\h`), e.useRelativePosition && (A = `${A} \\p`), this.root.push(A);
  }
}, zie = class extends Or {
  constructor(t, e = {}) {
    super({ children: [
      tj(),
      new Gie(t, e),
      Zc(),
      qc()
    ] });
  }
}, Uie = 255, bie = (t) => {
  const e = t.indexOf("#"), A = t.length - e - 1;
  return e > 0 && A > 0 && A <= Uie ? {
    target: t.slice(0, e),
    anchor: t.slice(e + 1)
  } : { target: t };
}, Vd = (t, e, A) => A === void 0 ? `${t}-${e}` : `${t}-restart ${A}`, b0 = ({ id: t, fontKey: e, subsetted: A }, n) => new K({
  name: n,
  attributes: oe({ id: {
    key: "r:id",
    value: t
  } }, e ? { fontKey: {
    key: "w:fontKey",
    value: `{${e.toUpperCase()}}`
  } } : {}),
  children: [...A ? [new ce("w:subsetted", A)] : []]
}), vie = ({ name: t, altName: e, panose1: A, charset: n, family: s, notTrueType: r, pitch: i, sig: o, embedRegular: a, embedBold: c, embedItalic: l, embedBoldItalic: B }) => new K({
  name: "w:font",
  attributes: { name: {
    key: "w:name",
    value: t
  } },
  children: [
    ...e ? [aB("w:altName", e)] : [],
    ...A ? [aB("w:panose1", A)] : [],
    ...n ? [aB("w:charset", n)] : [],
    aB("w:family", s),
    ...r ? [new ce("w:notTrueType", r)] : [],
    aB("w:pitch", i),
    ...o ? [new K({
      name: "w:sig",
      attributes: {
        usb0: {
          key: "w:usb0",
          value: o.usb0
        },
        usb1: {
          key: "w:usb1",
          value: o.usb1
        },
        usb2: {
          key: "w:usb2",
          value: o.usb2
        },
        usb3: {
          key: "w:usb3",
          value: o.usb3
        },
        csb0: {
          key: "w:csb0",
          value: o.csb0
        },
        csb1: {
          key: "w:csb1",
          value: o.csb1
        }
      }
    })] : [],
    ...a ? [b0(a, "w:embedRegular")] : [],
    ...c ? [b0(c, "w:embedBold")] : [],
    ...l ? [b0(l, "w:embedItalic")] : [],
    ...B ? [b0(B, "w:embedBoldItalic")] : []
  ]
}), jie = ({ name: t, characterSet: e, embedRegular: A, embedBold: n, embedItalic: s, embedBoldItalic: r }) => vie({
  name: t,
  sig: {
    usb0: "E0002AFF",
    usb1: "C000247B",
    usb2: "00000009",
    usb3: "00000000",
    csb0: "000001FF",
    csb1: "00000000"
  },
  charset: e,
  family: "auto",
  pitch: "variable",
  embedRegular: A,
  embedBold: n,
  embedItalic: s,
  embedBoldItalic: r
}), Hie = (t) => new K({
  name: "w:fonts",
  attributes: {
    mc: {
      key: "xmlns:mc",
      value: "http://schemas.openxmlformats.org/markup-compatibility/2006"
    },
    r: {
      key: "xmlns:r",
      value: "http://schemas.openxmlformats.org/officeDocument/2006/relationships"
    },
    w: {
      key: "xmlns:w",
      value: "http://schemas.openxmlformats.org/wordprocessingml/2006/main"
    },
    w14: {
      key: "xmlns:w14",
      value: "http://schemas.microsoft.com/office/word/2010/wordml"
    },
    w15: {
      key: "xmlns:w15",
      value: "http://schemas.microsoft.com/office/word/2012/wordml"
    },
    w16cex: {
      key: "xmlns:w16cex",
      value: "http://schemas.microsoft.com/office/word/2018/wordml/cex"
    },
    w16cid: {
      key: "xmlns:w16cid",
      value: "http://schemas.microsoft.com/office/word/2016/wordml/cid"
    },
    w16: {
      key: "xmlns:w16",
      value: "http://schemas.microsoft.com/office/word/2018/wordml"
    },
    w16sdtdh: {
      key: "xmlns:w16sdtdh",
      value: "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash"
    },
    w16se: {
      key: "xmlns:w16se",
      value: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
    },
    Ignorable: {
      key: "mc:Ignorable",
      value: "w14 w15 w16se w16cid w16 w16cex w16sdtdh"
    }
  },
  children: t.map(jie)
}), kie = [
  {
    option: "data",
    element: "embedRegular",
    bold: !1,
    italic: !1
  },
  {
    option: "bold",
    element: "embedBold",
    bold: !0,
    italic: !1
  },
  {
    option: "italic",
    element: "embedItalic",
    bold: !1,
    italic: !0
  },
  {
    option: "boldItalic",
    element: "embedBoldItalic",
    bold: !0,
    italic: !0
  }
], Wj = class {
  constructor(t) {
    T(this, "options", void 0), T(this, "fontTable", void 0), T(this, "relationships", void 0), T(
      this,
      /** @deprecated Use `files`, which has the file and key of each face a font embeds, not only the regular face's key */
      "fontOptionsWithKey",
      []
    ), T(
      this,
      /** The files of the faces the fonts embed, in order: the Nth is `fonts/font<N>.odttf`, with the relationship `rId<N>` */
      "files",
      []
    ), this.options = t;
    const e = t.map((A) => kie.flatMap(({ option: n, element: s, bold: r, italic: i }) => {
      const o = A[n];
      return o ? [{
        element: s,
        file: {
          name: A.name,
          data: o,
          bold: r,
          italic: i,
          fontKey: ij()
        }
      }] : [];
    }));
    this.files = e.flatMap((A) => A.map(({ file: n }) => n)), this.fontOptionsWithKey = t.map((A, n) => oe(oe({}, A), {}, { fontKey: e[n][0].file.fontKey })), this.fontTable = Hie(t.map((A, n) => oe({
      name: A.name,
      characterSet: A.characterSet
    }, Object.fromEntries(e[n].map(({ element: s, file: r }) => [s, {
      id: `rId${this.files.indexOf(r) + 1}`,
      fontKey: r.fontKey
    }]))))), this.relationships = new zA();
    for (let A = 0; A < this.files.length; A++) this.relationships.addRelationship(A + 1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/font", `fonts/font${A + 1}.odttf`);
  }
  get View() {
    return this.fontTable;
  }
  get Relationships() {
    return this.relationships;
  }
}, Rie = () => new K({
  name: "w:wordWrap",
  attributes: { val: {
    key: "w:val",
    value: 0
  } }
}), Lie = (t) => {
  var e, A;
  return new K({
    name: "w:framePr",
    attributes: {
      anchorLock: {
        key: "w:anchorLock",
        value: t.anchorLock
      },
      dropCap: {
        key: "w:dropCap",
        value: t.dropCap
      },
      width: {
        key: "w:w",
        value: t.width
      },
      height: {
        key: "w:h",
        value: t.height
      },
      x: {
        key: "w:x",
        value: t.position ? t.position.x : void 0
      },
      y: {
        key: "w:y",
        value: t.position ? t.position.y : void 0
      },
      anchorHorizontal: {
        key: "w:hAnchor",
        value: t.anchor.horizontal
      },
      anchorVertical: {
        key: "w:vAnchor",
        value: t.anchor.vertical
      },
      spaceHorizontal: {
        key: "w:hSpace",
        value: (e = t.space) === null || e === void 0 ? void 0 : e.horizontal
      },
      spaceVertical: {
        key: "w:vSpace",
        value: (A = t.space) === null || A === void 0 ? void 0 : A.vertical
      },
      rule: {
        key: "w:hRule",
        value: t.rule
      },
      alignmentX: {
        key: "w:xAlign",
        value: t.alignment ? t.alignment.x : void 0
      },
      alignmentY: {
        key: "w:yAlign",
        value: t.alignment ? t.alignment.y : void 0
      },
      lines: {
        key: "w:lines",
        value: t.lines
      },
      wrap: {
        key: "w:wrap",
        value: t.wrap
      }
    }
  });
}, DI = /* @__PURE__ */ new WeakMap(), Sie = Zl(), Tie = {
  left: "right",
  right: "left"
}, jl = class extends ro {
  /**
  * Creates paragraph properties.
  *
  * @param options - The paragraph formatting to emit
  * @param config - Controls how the element is assembled; see {@link IParagraphPropertiesConfig}
  */
  constructor(t, { implicitListParagraphStyle: e = !0, inListOrder: A = !0 } = {}) {
    if (super("w:pPr", t == null ? void 0 : t.includeIfEmpty), T(this, "numbering", void 0), T(
      this,
      /** The paragraph's `w:numPr`, which is written again with its list's id each time the paragraph is written */
      "numberProperties",
      void 0
    ), !t) return this;
    if (t.heading && this.push(FB(t.heading)), e && (t.bullet && this.push(FB("ListParagraph")), t.numbering && !t.numbering.custom && !t.style && !t.heading && this.push(FB("ListParagraph"))), t.style && this.push(FB(t.style)), t.keepNext !== void 0 && this.push(new ce("w:keepNext", t.keepNext)), t.keepLines !== void 0 && this.push(new ce("w:keepLines", t.keepLines)), t.pageBreakBefore && this.push(new Qie()), t.frame && this.push(Lie(t.frame)), t.widowControl !== void 0 && this.push(new ce("w:widowControl", t.widowControl)), t.bullet && this.push(new U0(1, t.bullet.level)), t.numbering) {
      const { reference: s, instance: r, level: i, restart: o } = t.numbering, a = typeof s == "string" ? s : s.reference, c = new U0(Vd(a, r ?? 0), i);
      this.numbering = {
        reference: a,
        level: i,
        instance: r,
        restartedListId: o && A && r === void 0 ? Sie() : void 0,
        definition: typeof s == "string" ? void 0 : s
      }, this.numberProperties = c, this.push(c);
    } else t.numbering === !1 && this.push(new U0(0, 0));
    t.border && this.push(new hne(t.border)), t.thematicBreak && this.push(new une()), t.shading && this.push(uf(t.shading)), t.wordWrap && this.push(Rie()), t.overflowPunctuation && this.push(new ce("w:overflowPunct", t.overflowPunctuation));
    const n = [
      ...t.rightTabStop !== void 0 ? [{
        type: jN.RIGHT,
        position: t.rightTabStop
      }] : [],
      ...t.tabStops ? t.tabStops : [],
      ...t.leftTabStop !== void 0 ? [{
        type: jN.LEFT,
        position: t.leftTabStop
      }] : []
    ];
    n.length > 0 && this.push(Eie(n)), t.bidirectional !== void 0 && this.push(new ce("w:bidi", t.bidirectional)), t.spacing && this.push(Iie(t.spacing)), t.indent && this.push(dne(t.indent)), t.contextualSpacing !== void 0 && this.push(new ce("w:contextualSpacing", t.contextualSpacing)), t.alignment && this.push(Xv(t.bidirectional && Tie[t.alignment] || t.alignment)), t.outlineLevel !== void 0 && this.push(xie(t.outlineLevel)), t.suppressLineNumbers !== void 0 && this.push(new ce("w:suppressLineNumbers", t.suppressLineNumbers)), t.autoSpaceEastAsianText !== void 0 && this.push(new ce("w:autoSpaceDN", t.autoSpaceEastAsianText)), t.run && this.push(new ese(t.run)), t.revision && this.push(new HN(t.revision));
  }
  /**
  * Adds a property element to the paragraph properties.
  *
  * @param item - The XML component to add to the paragraph properties
  */
  push(t) {
    this.root.push(t);
  }
  /**
  * Adds the section properties (`w:sectPr`) of the section this paragraph ends.
  *
  * They go after the paragraph's run properties and before its revision (`w:pPrChange`),
  * the order CT_PPr gives them.
  *
  * @param sectionProperties - The properties of the section the paragraph ends
  */
  addSectionProperties(t) {
    const e = this.root.findIndex((A) => A instanceof HN);
    if (e === -1) {
      this.root.push(t);
      return;
    }
    this.root.splice(e, 0, t);
  }
  /**
  * Removes the section properties added with {@link addSectionProperties}.
  *
  * @param sectionProperties - The properties of the section to remove
  */
  removeSectionProperties(t) {
    const e = this.root.indexOf(t);
    e !== -1 && this.root.splice(e, 1);
  }
  /**
  * Prepares the paragraph properties for XML serialization.
  *
  * This method works out which list instance a numbered paragraph is in, from where it is in its part when it
  * leaves out `instance`, and creates the concrete numbering instance for it before the properties are converted to XML.
  *
  * @param context - The XML context containing document and file information
  * @returns The prepared XML object, or undefined if the component should be ignored
  */
  prepForXml(t) {
    var e;
    if (this.numbering) {
      var A, n;
      const { reference: i, level: o, instance: a = 0, definition: c } = this.numbering, l = this.numbering.instance === void 0 ? (A = this.numbering.restartedListId) !== null && A !== void 0 ? A : (n = DI.get(t)) === null || n === void 0 ? void 0 : n.get(i) : void 0;
      t.viewWrapper instanceof Wj || t.file.Numbering.createConcreteNumberingInstance(i, a, c, l);
      const B = new U0(Vd(i, a, l), o);
      this.root.splice(this.root.indexOf(this.numberProperties), 1, B), this.numberProperties = B;
    }
    const s = super.prepForXml(t);
    if (((e = this.numbering) === null || e === void 0 ? void 0 : e.restartedListId) !== void 0) {
      var r;
      DI.set(t, new Map([...(r = DI.get(t)) !== null && r !== void 0 ? r : [], [this.numbering.reference, this.numbering.restartedListId]]));
    }
    return s;
  }
}, HN = class extends Z {
  constructor(t) {
    super("w:pPrChange"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    })), this.root.push(new jl(oe(oe({}, t), {}, { includeIfEmpty: !0 }), { inListOrder: !1 }));
  }
}, gA = class Oj extends Lj {
  constructor(e) {
    if (super("w:p"), T(
      this,
      /** The options the paragraph was made with. A paragraph made from a string has it as its `text` */
      "options",
      void 0
    ), T(this, "properties", void 0), T(this, "alignment", void 0), this.options = typeof e == "string" ? { text: e } : e, typeof e == "string")
      return this.alignment = {}, this.properties = new jl({}), this.root.push(this.properties), this.root.push(new nr(e)), this;
    if (this.alignment = {
      alignment: e.alignment,
      bidirectional: e.bidirectional
    }, this.properties = new jl(e), this.root.push(this.properties), e.text && this.root.push(new nr(e.text)), e.children) for (const A of e.children) {
      if (A instanceof Die) {
        this.root.push(...A.writtenAs);
        continue;
      }
      this.root.push(A);
    }
  }
  prepForXml(e) {
    for (const A of this.root) if (lf(A) === "w:externalHyperlink") {
      const n = this.root.indexOf(A), { options: s } = A, { target: r, anchor: i } = bie(s.link), o = new ff(s.children, Rm(), i, s.link);
      e.viewWrapper.Relationships.addRelationship(o.linkId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/hyperlink", r, Ij.EXTERNAL), this.root[n] = o;
    }
    return super.prepForXml(e);
  }
  /**
  * Ends a section at this paragraph by adding the section's properties to the paragraph's properties,
  * as Word does with the last paragraph of each section but the last.
  *
  * The body adds them only while it is written and removes them afterwards with
  * {@link removeSectionProperties}, so the same paragraph can be used in other documents.
  *
  * @internal
  * @param sectionProperties - The properties of the section the paragraph ends
  */
  addSectionProperties(e) {
    this.properties.addSectionProperties(e);
  }
  /**
  * Removes the section properties added with {@link addSectionProperties}.
  *
  * @internal
  * @param sectionProperties - The properties of the section to remove
  */
  removeSectionProperties(e) {
    this.properties.removeSectionProperties(e);
  }
  /**
  * The paragraph's alignment and direction, which a table gives the empty paragraphs of the cells it adds below a
  * cell merged down rows (`rowSpan`), so that the merged cell is aligned as one.
  *
  * @internal
  */
  get Alignment() {
    return this.alignment;
  }
  /**
  * Makes a new paragraph with the paragraph's options and these, which take the place of its own, such as to indent
  * the paragraphs a parser made. The paragraph itself is left as it is, and the new one has the same children.
  *
  * Each option given replaces the paragraph's whole option: to keep the rest of its spacing, give
  * `spacing: { ...paragraph.options.spacing, before: 240 }`. An option given as `undefined` is removed.
  *
  * @example
  * ```typescript
  * const indented = paragraphs.map((paragraph) => paragraph.with({ indent: { left: 720, right: 720 } }));
  * ```
  */
  with(e) {
    return new Oj(oe(oe({}, this.options), e));
  }
  addRunToFront(e) {
    return this.root.splice(1, 0, e), this;
  }
}, Xd = class extends Z {
  constructor(t) {
    super("m:oMath");
    for (const e of t.children) this.root.push(e);
  }
}, Jie = class extends Z {
  constructor(t) {
    super("m:t"), /^[\s\u200B]|[\s\u200B]$/.test(t) && this.root.push(new Ki({ space: Pi.PRESERVE })), this.root.push(t);
  }
}, Wie = [
  "text",
  "normalText",
  "script",
  "literal"
], xI = {
  plain: "p",
  bold: "b",
  italic: "i",
  boldItalic: "bi"
}, GI = {
  roman: "roman",
  script: "script",
  fraktur: "fraktur",
  doubleStruck: "double-struck",
  sansSerif: "sans-serif",
  monospace: "monospace"
}, v0 = (t, e) => new K({
  name: t,
  attributes: { value: {
    key: "m:val",
    value: e
  } }
}), TA = class extends Z {
  constructor(t) {
    var e;
    super("m:r");
    const A = typeof t == "string" ? { text: t } : t, { text: n, normalText: s, script: r, literal: i } = A, o = (e = zm(A, Wie).style) !== null && e !== void 0 ? e : r === void 0 || r === "roman" ? void 0 : "plain";
    if (s && (o !== void 0 || r !== void 0)) throw new Error("MathRun: normalText can't be given with style or script, which are for math. Give one or the other");
    if (o !== void 0 && !Object.keys(xI).includes(o)) throw new Error(`MathRun: style is "${o}", which isn't one of ${Object.keys(xI).join(", ")}`);
    if (r !== void 0 && !Object.keys(GI).includes(r)) throw new Error(`MathRun: script is "${r}", which isn't one of ${Object.keys(GI).join(", ")}`);
    const a = [
      ...i ? [v0("m:lit", 1)] : [],
      ...s ? [v0("m:nor", 1)] : [],
      ...r === void 0 ? [] : [v0("m:scr", GI[r])],
      ...o === void 0 ? [] : [v0("m:sty", xI[o])]
    ];
    a.length > 0 && this.root.push(new K({
      name: "m:rPr",
      children: a
    })), this.root.push(new Jie(n));
  }
}, Oie = class extends Z {
  constructor(t) {
    super("m:den");
    for (const e of t) this.root.push(e);
  }
}, Pie = class extends Z {
  constructor(t) {
    super("m:num");
    for (const e of t) this.root.push(e);
  }
}, zI = {
  stacked: "bar",
  skewed: "skw",
  linear: "lin",
  noBar: "noBar"
}, kN = class extends Z {
  constructor(t) {
    if (super("m:f"), t.type !== void 0) {
      if (!Object.keys(zI).includes(t.type)) throw new Error(`MathFraction: type is "${t.type}", which isn't one of ${Object.keys(zI).join(", ")}`);
      this.root.push(new K({
        name: "m:fPr",
        children: [new K({
          name: "m:type",
          attributes: { value: {
            key: "m:val",
            value: zI[t.type]
          } }
        })]
      }));
    }
    this.root.push(new Pie(t.numerator)), this.root.push(new Oie(t.denominator));
  }
}, Qf = ({ children: t }) => new K({
  name: "m:e",
  children: t
}), Pj = ({ children: t }) => new K({
  name: "m:sub",
  children: t
}), Kj = ({ children: t }) => new K({
  name: "m:sup",
  children: t
}), Kie = () => new K({ name: "m:sSupPr" }), Vie = class extends Z {
  constructor(t) {
    super("m:sSup"), this.root.push(Kie()), this.root.push(Qf({ children: t.children })), this.root.push(Kj({ children: t.superScript }));
  }
}, Xie = () => new K({ name: "m:sSubPr" }), Zie = class extends Z {
  constructor(t) {
    super("m:sSub"), this.root.push(Xie()), this.root.push(Qf({ children: t.children })), this.root.push(Pj({ children: t.subScript }));
  }
}, qie = () => new K({ name: "m:sSubSupPr" }), _ie = class extends Z {
  constructor(t) {
    super("m:sSubSup"), this.root.push(qie()), this.root.push(Qf({ children: t.children })), this.root.push(Pj({ children: t.subScript })), this.root.push(Kj({ children: t.superScript }));
  }
}, $ie = class extends Z {
  constructor(t) {
    if (super("m:deg"), t) for (const e of t) this.root.push(e);
  }
}, eoe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { hide: "m:val" });
  }
}, toe = class extends Z {
  constructor() {
    super("m:degHide"), this.root.push(new eoe({ hide: 1 }));
  }
}, Aoe = class extends Z {
  constructor(t) {
    super("m:radPr"), t || this.root.push(new toe());
  }
}, RN = class extends Z {
  constructor(t) {
    super("m:rad"), this.root.push(new Aoe(!!t.degree)), this.root.push(new $ie(t.degree)), this.root.push(Qf({ children: t.children }));
  }
}, noe = {
  TOP: "top",
  CENTER: "center",
  BOTTOM: "bottom"
};
oe(oe({}, noe), {}, { BOTH: "both" });
var Vj = (t) => new K({
  name: "w:vAlign",
  attributes: { verticalAlign: {
    key: "w:val",
    value: t
  } }
}), soe = ({ space: t, count: e, separate: A, equalWidth: n, children: s }) => new K({
  name: "w:cols",
  attributes: {
    space: {
      key: "w:space",
      value: t === void 0 ? void 0 : UA(t)
    },
    count: {
      key: "w:num",
      value: e === void 0 ? void 0 : hA(e)
    },
    separate: {
      key: "w:sep",
      value: A
    },
    equalWidth: {
      key: "w:equalWidth",
      value: n
    }
  },
  children: !n && s ? s : void 0
}), roe = ({ type: t, linePitch: e, charSpace: A }) => new K({
  name: "w:docGrid",
  attributes: {
    type: {
      key: "w:type",
      value: t
    },
    linePitch: {
      key: "w:linePitch",
      value: hA(e)
    },
    charSpace: {
      key: "w:charSpace",
      value: A ? hA(A) : void 0
    }
  }
}), dl = {
  /** Specifies that this header or footer shall appear on every page in this section which is not overridden with a specific `even` or `first` page header/footer. In a section with all three types specified, this type shall be used on all odd numbered pages (counting from the `first` page in the section, not the section numbering). */
  DEFAULT: "default",
  /** Specifies that this header or footer shall appear on the first page in this section. The appearance of this header or footer is contingent on the setting of the `titlePg` element (§2.10.6). */
  FIRST: "first",
  /** Specifies that this header or footer shall appear on all even numbered pages in this section (counting from the first page in the section, not the section numbering). The appearance of this header or footer is contingent on the setting of the `evenAndOddHeaders` element (§2.10.1). */
  EVEN: "even"
}, LN = {
  HEADER: "w:headerReference",
  FOOTER: "w:footerReference"
}, UI = (t, e) => new K({
  name: t,
  attributes: {
    type: {
      key: "w:type",
      value: e.type || dl.DEFAULT
    },
    id: {
      key: "r:id",
      value: `rId${e.id}`
    }
  }
}), ioe = ({ countBy: t, start: e, restart: A, distance: n }) => new K({
  name: "w:lnNumType",
  attributes: {
    countBy: {
      key: "w:countBy",
      value: t === void 0 ? void 0 : hA(t)
    },
    start: {
      key: "w:start",
      value: e === void 0 ? void 0 : hA(e)
    },
    restart: {
      key: "w:restart",
      value: A
    },
    distance: {
      key: "w:distance",
      value: n === void 0 ? void 0 : UA(n)
    }
  }
}), Xj = ({ name: t, position: e, numberFormat: A, start: n, restart: s }) => new K({
  name: t,
  children: [
    ...e === void 0 ? [] : [new K({
      name: "w:pos",
      attributes: { val: {
        key: "w:val",
        value: e
      } }
    })],
    ...A ? [new K({
      name: "w:numFmt",
      attributes: {
        val: {
          key: "w:val",
          value: A.type
        },
        format: {
          key: "w:format",
          value: A.format
        }
      }
    })] : [],
    ...n === void 0 ? [] : [new K({
      name: "w:numStart",
      attributes: { val: {
        key: "w:val",
        value: hA(n)
      } }
    })],
    ...s === void 0 ? [] : [new K({
      name: "w:numRestart",
      attributes: { val: {
        key: "w:val",
        value: s
      } }
    })]
  ]
}), ooe = (t) => Xj(oe({ name: "w:footnotePr" }, t)), aoe = (t) => Xj(oe({ name: "w:endnotePr" }, t)), SN = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      display: "w:display",
      offsetFrom: "w:offsetFrom",
      zOrder: "w:zOrder"
    });
  }
}, coe = class extends ro {
  constructor(t) {
    if (super("w:pgBorders"), !t) return this;
    t.pageBorders ? this.root.push(new SN({
      display: t.pageBorders.display,
      offsetFrom: t.pageBorders.offsetFrom,
      zOrder: t.pageBorders.zOrder
    })) : this.root.push(new SN({})), t.pageBorderTop && this.root.push(IA("w:top", t.pageBorderTop)), t.pageBorderLeft && this.root.push(IA("w:left", t.pageBorderLeft)), t.pageBorderBottom && this.root.push(IA("w:bottom", t.pageBorderBottom)), t.pageBorderRight && this.root.push(IA("w:right", t.pageBorderRight));
  }
}, loe = (t, e, A, n, s, r, i) => new K({
  name: "w:pgMar",
  attributes: {
    top: {
      key: "w:top",
      value: Gr(t)
    },
    right: {
      key: "w:right",
      value: UA(e)
    },
    bottom: {
      key: "w:bottom",
      value: Gr(A)
    },
    left: {
      key: "w:left",
      value: UA(n)
    },
    header: {
      key: "w:header",
      value: UA(s)
    },
    footer: {
      key: "w:footer",
      value: UA(r)
    },
    gutter: {
      key: "w:gutter",
      value: UA(i)
    }
  }
}), Boe = {
  /** En dash separator (–), written as `enDash` */
  EN_DASH: "endash"
}, goe = ({ start: t, formatType: e, separator: A, chapterHeadingLevel: n }) => new K({
  name: "w:pgNumType",
  attributes: {
    start: {
      key: "w:start",
      value: t === void 0 ? void 0 : hA(t)
    },
    formatType: {
      key: "w:fmt",
      value: e
    },
    separator: {
      key: "w:chapSep",
      value: A === Boe.EN_DASH ? "enDash" : A
    },
    chapterHeadingLevel: {
      key: "w:chapStyle",
      value: n === void 0 ? void 0 : hA(n)
    }
  }
}), Zd = {
  /**
  * ## Portrait Mode
  *
  * Specifies that pages in this section shall be printed in portrait mode.
  */
  PORTRAIT: "portrait",
  /**
  * ## Landscape Mode
  *
  * Specifies that pages in this section shall be printed in landscape mode, which prints the page contents with a 90 degree rotation with respect to the normal page orientation.
  */
  LANDSCAPE: "landscape"
}, hoe = ({ width: t, height: e, orientation: A, code: n }) => {
  const s = UA(t), r = UA(e);
  return new K({
    name: "w:pgSz",
    attributes: {
      width: {
        key: "w:w",
        value: A === Zd.LANDSCAPE ? r : s
      },
      height: {
        key: "w:h",
        value: A === Zd.LANDSCAPE ? s : r
      },
      orientation: {
        key: "w:orient",
        value: A
      },
      code: {
        key: "w:code",
        value: n
      }
    }
  });
}, uoe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { val: "w:val" });
  }
}, doe = class extends Z {
  constructor(t) {
    super("w:textDirection"), this.root.push(new uoe({ val: t }));
  }
}, woe = (t) => new K({
  name: "w:type",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), mr = {
  /** Top margin: 1440 twips (1 inch) */
  TOP: 1440,
  /** Right margin: 1440 twips (1 inch) */
  RIGHT: 1440,
  /** Bottom margin: 1440 twips (1 inch) */
  BOTTOM: 1440,
  /** Left margin: 1440 twips (1 inch) */
  LEFT: 1440,
  /** Header margin from top: 708 twips (0.5 inches) */
  HEADER: 708,
  /** Footer margin from bottom: 708 twips (0.5 inches) */
  FOOTER: 708,
  /** Gutter margin for binding: 0 twips */
  GUTTER: 0
}, du = {
  /** Page width: 11906 twips (8.27 inches, 210mm) */
  WIDTH: 11906,
  /** Page height: 16838 twips (11.69 inches, 297mm) */
  HEIGHT: 16838,
  /** Page orientation: portrait */
  ORIENTATION: Zd.PORTRAIT
}, OE = class Zj extends Z {
  constructor({ page: { size: { width: e = du.WIDTH, height: A = du.HEIGHT, orientation: n = du.ORIENTATION, code: s } = {}, margin: { top: r = mr.TOP, right: i = mr.RIGHT, bottom: o = mr.BOTTOM, left: a = mr.LEFT, header: c = mr.HEADER, footer: l = mr.FOOTER, gutter: B = mr.GUTTER } = {}, pageNumbers: g = {}, borders: h, textDirection: u } = {}, grid: { linePitch: d = 360, charSpace: w, type: Q } = {}, headerWrapperGroup: p = {}, footerWrapperGroup: M = {}, lineNumbers: I, titlePage: N, verticalAlign: m, column: E, type: G, footnoteProperties: Y, endnoteProperties: U, revision: v } = {}) {
    super("w:sectPr"), T(
      this,
      /**
      * Width, in twips, available to block-level content in this section.
      *
      * This is the page width (accounting for orientation) minus the left and right
      * margins and the gutter. When the section is laid out in several columns, it is
      * the width of a single column. Percentage table widths are resolved against it.
      */
      "availableTextWidth",
      void 0
    ), this.availableTextWidth = Zj.calculateAvailableTextWidth({
      pageWidth: n === Zd.LANDSCAPE ? A : e,
      left: a,
      right: i,
      gutter: B,
      column: E
    }), this.addHeaderFooterGroup(LN.HEADER, p), this.addHeaderFooterGroup(LN.FOOTER, M), Y && this.root.push(ooe(Y)), U && this.root.push(aoe(U)), G && this.root.push(woe(G)), this.root.push(hoe({
      width: e,
      height: A,
      orientation: n,
      code: s
    })), this.root.push(loe(r, i, o, a, c, l, B)), h && this.root.push(new coe(h)), I && this.root.push(ioe(I)), this.root.push(goe(g)), E && this.root.push(soe(E)), m && this.root.push(Vj(m)), N !== void 0 && this.root.push(new ce("w:titlePg", N)), u && this.root.push(new doe(u)), this.root.push(roe({
      linePitch: d,
      charSpace: w,
      type: Q
    })), v && this.root.push(new foe(v));
  }
  /**
  * Width, in twips, available to block-level content (paragraphs and tables) in this section.
  *
  * Page width minus the left and right margins and the gutter, divided among the
  * section's columns when there is more than one. Tables use this to resolve
  * percentage widths into the absolute twip grid that Google Docs, Apple Pages and
  * other consumers lay tables out from.
  *
  * @example
  * ```typescript
  * // A4 portrait with 1 inch margins
  * new SectionProperties().AvailableTextWidth; // 11906 - 1440 - 1440 = 9026
  * ```
  */
  get AvailableTextWidth() {
    return this.availableTextWidth;
  }
  static calculateAvailableTextWidth({ pageWidth: e, left: A, right: n, gutter: s, column: r }) {
    var i, o;
    const a = xo(e) - xo(A) - xo(n) - xo(s), c = (i = r == null ? void 0 : r.count) !== null && i !== void 0 ? i : 1;
    return c <= 1 ? a : (a - xo((o = r == null ? void 0 : r.space) !== null && o !== void 0 ? o : 720) * (c - 1)) / c;
  }
  addHeaderFooterGroup(e, A) {
    A.default && this.root.push(UI(e, {
      type: dl.DEFAULT,
      id: A.default.View.ReferenceId
    })), A.first && this.root.push(UI(e, {
      type: dl.FIRST,
      id: A.first.View.ReferenceId
    })), A.even && this.root.push(UI(e, {
      type: dl.EVEN,
      id: A.even.View.ReferenceId
    }));
  }
}, foe = class extends Z {
  constructor(t) {
    super("w:sectPrChange"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    })), this.root.push(new OE(t));
  }
}, qj = class extends Z {
  constructor({ pageNumbers: t } = {}) {
    super("w:body"), T(this, "sections", []), T(
      this,
      /**
      * Section properties that were moved into a paragraph at the end of their section
      * by {@link addSection}, keyed by that paragraph. Used to find the section that
      * governs a given child of the body, and to write each section's properties into
      * its paragraph while the body is written.
      */
      "sectionParagraphs",
      /* @__PURE__ */ new Map()
    ), T(this, "headingBookmarkIds", new zre()), T(this, "pageNumbers", void 0), this.pageNumbers = t;
  }
  /**
  * Finds the section properties that govern a top-level child of the body.
  *
  * A section's properties are stored after its content (either in the closing
  * paragraph of the section or, for the last section, at the end of the body), so
  * the governing section is the first one found at or after the child. When no
  * child is given (or it is not a direct child of the body), the first section is
  * returned.
  *
  * @param child - A direct child of the body (paragraph, table, etc.)
  * @returns The governing section properties, or undefined if the body has no sections
  */
  getSectionPropertiesFor(t) {
    const e = t ? Math.max(this.root.indexOf(t), 0) : 0;
    for (let A = e; A < this.root.length; A++) {
      const n = this.root[A];
      if (n instanceof OE) return n;
      const s = this.sectionParagraphs.get(n);
      if (s) return s;
    }
    return this.sections[this.sections.length - 1];
  }
  /**
  * Adds new section properties to the document body.
  *
  * Creates a new section by moving the previous section's properties into the last
  * paragraph of that section, and then adding the new section as the current section.
  * When that section doesn't end with a paragraph of its own (it ends with a table, or
  * it is empty), an empty paragraph is added to hold its properties.
  *
  * According to the OOXML specification:
  * - Section properties for all sections except the last must be stored in a paragraph's
  *   properties (pPr/sectPr) at the end of each section
  * - The last section's properties are stored as a direct child of the body element (w:body/w:sectPr)
  *
  * @param options - Section properties configuration (page size, margins, headers, footers, etc.)
  */
  addSection(t) {
    const e = this.sections.pop(), A = this.lastParagraphOfSection();
    if (e && A) this.sectionParagraphs.set(A, e);
    else {
      const n = this.createSectionParagraph();
      this.root.push(n), e && this.sectionParagraphs.set(n, e);
    }
    this.sections.push(new OE(t));
  }
  /**
  * Prepares the body element for XML serialization.
  *
  * Ensures that the last section's properties are placed as a direct child of the body
  * element, as required by the OOXML specification. Once the body is written, its tables
  * of contents are filled in from its headings, and, when the body has a page number
  * estimator, its page references are given their page numbers. Its SEQ fields are given
  * their numbers after the tables of contents are filled in, as Word leaves a heading's SEQ
  * number out of its entry.
  *
  * @param context - The XML serialization context
  * @returns The prepared XML object or undefined
  */
  prepForXml(t) {
    var e;
    this.sections.length === 1 && (this.root.splice(0, 1), this.root.push(this.sections.pop()));
    for (const [s, r] of this.sectionParagraphs) s.addSectionProperties(r);
    let A;
    try {
      A = super.prepForXml(t);
    } finally {
      for (const [s, r] of this.sectionParagraphs) s.removeSectionProperties(r);
    }
    const n = (e = this.pageNumbers) === null || e === void 0 ? void 0 : e.listNumbers;
    return Kre(A, t, this.headingBookmarkIds, n && ((s) => n(s, t))), this.pageNumbers && ($re(A, t), eie(A, t, this.pageNumbers)), A;
  }
  /**
  * Adds a block-level component to the body.
  *
  * This method is used internally by the Document class to add paragraphs,
  * tables, and other block-level elements to the document body.
  *
  * @param component - The XML component to add (paragraph, table, etc.)
  */
  push(t) {
    const e = t instanceof gA ? this.sectionParagraphs.get(t) : void 0;
    if (e) {
      const A = this.createSectionParagraph();
      this.root.splice(this.root.indexOf(t) + 1, 0, A), this.sectionParagraphs.delete(t), this.sectionParagraphs.set(A, e);
    }
    this.root.push(t);
  }
  /**
  * The paragraph the current section ends with, which can hold its properties.
  *
  * There is none when the section ends with something other than a paragraph, or is empty:
  * its last child is then the placeholder at the start of the body (removed when the body is
  * written) or the paragraph that ends the section before, which has properties of its own.
  */
  lastParagraphOfSection() {
    const t = this.root[this.root.length - 1];
    return t instanceof gA && t !== this.root[0] && !this.sectionParagraphs.has(t) && this.root.indexOf(t) === this.root.length - 1 ? t : void 0;
  }
  /**
  * An empty paragraph to end a section that has no paragraph of its own to end it. The section's
  * properties are written into it with the others, when the body is written.
  */
  createSectionParagraph() {
    return new gA({});
  }
}, zs = {
  /** Auto. */
  AUTO: "auto",
  /** Value is in twentieths of a point */
  DXA: "dxa",
  /** Value is in percentage. */
  PERCENTAGE: "pct"
}, nh = (t, { type: e = zs.AUTO, size: A }) => {
  let n = A;
  return e === zs.PERCENTAGE && typeof A == "number" && (n = Math.round(A * 50)), new K({
    name: t,
    attributes: {
      type: {
        key: "w:type",
        value: e
      },
      size: {
        key: "w:w",
        value: Kv(n)
      }
    }
  });
}, bI = du.WIDTH - mr.LEFT - mr.RIGHT - mr.GUTTER, _j = (t) => t.options.columnSpan || 1, Om = (t, e) => {
  if (!t) return;
  const { type: A = zs.AUTO, size: n } = t;
  if (A !== zs.PERCENTAGE && A !== zs.DXA) return;
  const s = typeof n == "number" ? A === zs.PERCENTAGE ? n / 100 * e : n : n.endsWith("%") ? Number(n.slice(0, -1)) / 100 * e : xo(n);
  return s > 0 ? s : void 0;
}, Qoe = (t, e) => {
  var A;
  return (A = Om(t, e)) !== null && A !== void 0 ? A : e;
}, Ioe = (t) => Math.max(0, ...t.map((e) => e.cells.reduce((A, n) => A + _j(n), 0))), TN = ({ rows: t, width: e, availableWidth: A }) => {
  const n = Ioe(t);
  if (n === 0) return [];
  const s = Qoe(e, A), r = Array.from({ length: n }, () => {
  }), i = [];
  for (const l of t) {
    let B = 0;
    for (const g of l.cells) {
      const h = _j(g), u = Om(g.options.width, s);
      if (u !== void 0)
        if (h === 1) {
          var o, a;
          (a = r[o = B]) !== null && a !== void 0 || (r[o] = u);
        } else i.push({
          start: B,
          span: h,
          width: u
        });
      B += h;
    }
  }
  for (const { start: l, span: B, width: g } of i) {
    const h = Array.from({ length: B }, (w, Q) => l + Q).filter((w) => w < n), u = h.filter((w) => r[w] === void 0), d = g - h.reduce((w, Q) => {
      var p;
      return w + ((p = r[Q]) !== null && p !== void 0 ? p : 0);
    }, 0);
    if (u.length > 0 && d > 0) for (const w of u) r[w] = d / u.length;
  }
  const c = r.flatMap((l, B) => l === void 0 ? [B] : []);
  if (c.length > 0) {
    const l = s - r.reduce((g, h) => g + (h ?? 0), 0), B = l > 0 ? l / c.length : s / n;
    for (const g of c) r[g] = B;
  }
  return r.map((l) => Math.round(l));
}, Coe = (t) => new K({
  name: "w:gridCol",
  attributes: t !== void 0 ? { width: {
    key: "w:w",
    value: UA(t)
  } } : void 0
}), wu = class extends Z {
  constructor(t, e) {
    super("w:tblGrid");
    for (const A of t) this.root.push(Coe(A));
    e && this.root.push(new Moe(e));
  }
}, Eoe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { id: "w:id" });
  }
}, Moe = class extends Z {
  constructor(t) {
    super("w:tblGridChange"), this.root.push(new Eoe({ id: t.id })), this.root.push(new wu(t.columnWidths));
  }
}, poe = class extends Z {
  constructor(t) {
    super("w:ins"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    }));
  }
}, moe = class extends Z {
  constructor(t) {
    super("w:del"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    }));
  }
}, Yoe = class extends Z {
  constructor(t) {
    super("w:cellIns"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    }));
  }
}, yoe = class extends Z {
  constructor(t) {
    super("w:cellDel"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    }));
  }
}, Foe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      id: "w:id",
      author: "w:author",
      date: "w:date",
      verticalMerge: "w:vMerge",
      verticalMergeOriginal: "w:vMergeOrig"
    });
  }
}, Noe = class extends Z {
  constructor(t) {
    super("w:cellMerge"), this.root.push(new Foe(t));
  }
}, $j = ({ marginUnitType: t = zs.DXA, top: e, left: A, bottom: n, right: s }) => [
  {
    name: "w:top",
    size: e
  },
  {
    name: "w:left",
    size: A
  },
  {
    name: "w:bottom",
    size: n
  },
  {
    name: "w:right",
    size: s
  }
].filter((r) => r.size !== void 0).map(({ name: r, size: i }) => nh(r, {
  type: t,
  size: i
})), Doe = (t) => {
  const e = $j(t);
  if (e.length !== 0)
    return new K({
      name: "w:tblCellMar",
      children: e
    });
}, xoe = (t) => {
  const e = $j(t);
  if (e.length !== 0)
    return new K({
      name: "w:tcMar",
      children: e
    });
}, Goe = class extends ro {
  constructor(t) {
    super("w:tcBorders"), t.top && this.root.push(IA("w:top", t.top)), t.start && this.root.push(IA("w:start", t.start)), t.left && this.root.push(IA("w:left", t.left)), t.bottom && this.root.push(IA("w:bottom", t.bottom)), t.end && this.root.push(IA("w:end", t.end)), t.right && this.root.push(IA("w:right", t.right)), t.diagonalDown && this.root.push(IA("w:tl2br", t.diagonalDown)), t.diagonalUp && this.root.push(IA("w:tr2bl", t.diagonalUp));
  }
}, zoe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { val: "w:val" });
  }
}, Uoe = class extends Z {
  constructor(t) {
    super("w:gridSpan"), this.root.push(new zoe({ val: hA(t) }));
  }
}, eH = {
  /**
  * Cell that is merged with upper one.
  * This cell continues a vertical merge started by a cell above it.
  */
  CONTINUE: "continue",
  /**
  * Cell that is starting the vertical merge.
  * This cell begins a new vertical merge region.
  */
  RESTART: "restart"
}, boe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { val: "w:val" });
  }
}, JN = class extends Z {
  constructor(t) {
    super("w:vMerge"), this.root.push(new boe({ val: t }));
  }
}, voe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { val: "w:val" });
  }
}, joe = class extends Z {
  constructor(t) {
    super("w:textDirection"), this.root.push(new voe({ val: t }));
  }
}, tH = class extends ro {
  constructor(t) {
    if (super("w:tcPr", t.includeIfEmpty), T(this, "hasWidth", void 0), T(this, "hasColumnWidth", !1), this.hasWidth = t.width !== void 0, t.width && this.root.push(nh("w:tcW", t.width)), t.columnSpan && this.root.push(new Uoe(t.columnSpan)), t.verticalMerge ? this.root.push(new JN(t.verticalMerge)) : t.rowSpan && t.rowSpan > 1 && this.root.push(new JN(eH.RESTART)), t.borders && this.root.push(new Goe(t.borders)), t.shading && this.root.push(uf(t.shading)), t.margins) {
      const e = xoe(t.margins);
      e && this.root.push(e);
    }
    t.textDirection && this.root.push(new joe(t.textDirection)), t.verticalAlign && this.root.push(Vj(t.verticalAlign)), t.insertion && this.root.push(new Yoe(t.insertion)), t.deletion && this.root.push(new yoe(t.deletion)), t.cellMerge && this.root.push(new Noe(t.cellMerge)), t.revision && this.root.push(new Hoe(t.revision));
  }
  /**
  * Gives a cell without a width of its own the width of the table's columns it spans, in twips.
  *
  * @internal
  */
  setColumnWidth(t) {
    this.hasWidth || (this.root.splice(0, this.hasColumnWidth ? 1 : 0, nh("w:tcW", {
      size: t,
      type: zs.DXA
    })), this.hasColumnWidth = !0);
  }
}, Hoe = class extends Z {
  constructor(t) {
    super("w:tcPrChange"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    })), this.root.push(new tH(oe(oe({}, t), {}, { includeIfEmpty: !0 })));
  }
}, PE = class extends Z {
  constructor(t) {
    super("w:tc"), T(
      this,
      /**
      * The options the cell was created with.
      *
      * Its borders and shading are declared with hex colors, as they were before they took colors of the document's
      * theme, so that code reading them still compiles. A cell given a theme color has it here as it was given.
      */
      "options",
      void 0
    ), T(this, "properties", void 0), this.options = t, this.properties = new tH(t), this.root.push(this.properties);
    for (const e of t.children) this.root.push(e);
  }
  /**
  * Gives the cell, unless it has a width of its own, the width of the table's columns it spans, in twips.
  *
  * @internal
  */
  setColumnWidth(t) {
    this.properties.setColumnWidth(t);
  }
  prepForXml(t) {
    return lf(this.root[this.root.length - 1]) !== "w:p" && this.root.push(new gA({})), super.prepForXml(t);
  }
}, KE = (t, e) => e ? new ce(t) : new Oo(t, "off"), Uc = {
  style: gf.NONE,
  size: 0,
  color: "auto"
}, koe = {
  style: gf.SINGLE,
  size: 4,
  color: "auto"
}, AH = class extends ro {
  constructor(t, { fillMissingSides: e = !0 } = {}) {
    super("w:tblBorders");
    const A = [
      ["w:top", t.top],
      ["w:left", t.left],
      ["w:bottom", t.bottom],
      ["w:right", t.right],
      ["w:insideH", t.insideHorizontal],
      ["w:insideV", t.insideVertical]
    ];
    for (const [n, s] of A) {
      const r = s ?? (e ? koe : void 0);
      r && this.root.push(IA(n, r));
    }
  }
};
T(AH, "NONE", {
  top: Uc,
  bottom: Uc,
  left: Uc,
  right: Uc,
  insideHorizontal: Uc,
  insideVertical: Uc
});
var vI = {
  CENTER: "center",
  LEFT: "left",
  RIGHT: "right"
}, Roe = {
  /**
  * In line with the text, with no text beside it. Word places a floating table lined up inline at the top of the
  * paragraph after it, with text beside it, so the table is written in line with the text instead.
  */
  INLINE: "inline"
}, Loe = ({ horizontalAnchor: t, verticalAnchor: e, absoluteHorizontalPosition: A, relativeHorizontalPosition: n, absoluteVerticalPosition: s, relativeVerticalPosition: r, bottomFromText: i, topFromText: o, leftFromText: a, rightFromText: c }) => new K({
  name: "w:tblpPr",
  attributes: {
    leftFromText: {
      key: "w:leftFromText",
      value: a === void 0 ? void 0 : UA(a)
    },
    rightFromText: {
      key: "w:rightFromText",
      value: c === void 0 ? void 0 : UA(c)
    },
    topFromText: {
      key: "w:topFromText",
      value: o === void 0 ? void 0 : UA(o)
    },
    bottomFromText: {
      key: "w:bottomFromText",
      value: i === void 0 ? void 0 : UA(i)
    },
    absoluteHorizontalPosition: {
      key: "w:tblpX",
      value: A === void 0 ? void 0 : Gr(A)
    },
    absoluteVerticalPosition: {
      key: "w:tblpY",
      value: s === void 0 ? void 0 : Gr(s)
    },
    horizontalAnchor: {
      key: "w:horzAnchor",
      value: t
    },
    relativeHorizontalPosition: {
      key: "w:tblpXSpec",
      value: n
    },
    relativeVerticalPosition: {
      key: "w:tblpYSpec",
      value: r
    },
    verticalAnchor: {
      key: "w:vertAnchor",
      value: e
    }
  }
}), Soe = {
  /** Fixed layout - column widths are fixed as specified */
  FIXED: "fixed"
}, Toe = (t) => new K({
  name: "w:tblLayout",
  attributes: { type: {
    key: "w:type",
    value: t
  } }
}), Joe = {
  /** Value is in twentieths of a point */
  DXA: "dxa"
}, nH = ({ type: t = Joe.DXA, value: e }) => new K({
  name: "w:tblCellSpacing",
  attributes: {
    type: {
      key: "w:type",
      value: t
    },
    value: {
      key: "w:w",
      value: Kv(e)
    }
  }
}), Woe = ({ firstRow: t, lastRow: e, firstColumn: A, lastColumn: n, noHBand: s, noVBand: r }) => new K({
  name: "w:tblLook",
  attributes: {
    firstRow: {
      key: "w:firstRow",
      value: t
    },
    lastRow: {
      key: "w:lastRow",
      value: e
    },
    firstColumn: {
      key: "w:firstColumn",
      value: A
    },
    lastColumn: {
      key: "w:lastColumn",
      value: n
    },
    noHBand: {
      key: "w:noHBand",
      value: s
    },
    noVBand: {
      key: "w:noVBand",
      value: r
    }
  }
}), Ooe = (t) => new K({
  name: "w:tblOverlap",
  attributes: { val: {
    key: "w:val",
    value: t
  } }
}), Poe = {
  [vI.LEFT]: bt.LEFT,
  [vI.CENTER]: bt.CENTER,
  [vI.RIGHT]: bt.RIGHT
}, Pm = class extends ro {
  constructor(t) {
    var e, A, n;
    super("w:tblPr", t.includeIfEmpty), t.style && this.root.push(new Oo("w:tblStyle", t.style));
    const s = ((e = t.float) === null || e === void 0 ? void 0 : e.relativeVerticalPosition) === Roe.INLINE, r = s ? void 0 : t.float;
    r && this.root.push(Loe(r)), r != null && r.overlap && this.root.push(Ooe(r.overlap)), t.visuallyRightToLeft !== void 0 && this.root.push(KE("w:bidiVisual", t.visuallyRightToLeft)), t.width && this.root.push(nh("w:tblW", t.width));
    const i = (A = t.alignment) !== null && A !== void 0 ? A : s && (!((n = t.float) === null || n === void 0) && n.relativeHorizontalPosition) ? Poe[t.float.relativeHorizontalPosition] : void 0;
    if (i && this.root.push(Xv(i)), t.cellSpacing && this.root.push(nH(t.cellSpacing)), t.indent && this.root.push(nh("w:tblInd", t.indent)), t.borders && this.root.push(new AH(t.borders, { fillMissingSides: !t.style })), t.shading && this.root.push(uf(t.shading)), t.layout && this.root.push(Toe(t.layout)), t.cellMargin) {
      const o = Doe(t.cellMargin);
      o && this.root.push(o);
    }
    t.tableLook && this.root.push(Woe(t.tableLook)), t.revision && this.root.push(new Koe(t.revision));
  }
}, Koe = class extends Z {
  constructor(t) {
    super("w:tblPrChange"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    })), this.root.push(new Pm(oe(oe({}, t), {}, { includeIfEmpty: !0 })));
  }
}, Voe = (t, e) => new K({
  name: "w:trHeight",
  attributes: {
    value: {
      key: "w:val",
      value: UA(t)
    },
    rule: {
      key: "w:hRule",
      value: e
    }
  }
}), sH = class extends ro {
  constructor(t) {
    super("w:trPr", t.includeIfEmpty), t.cantSplit !== void 0 && this.root.push(KE("w:cantSplit", t.cantSplit)), t.tableHeader !== void 0 && this.root.push(KE("w:tblHeader", t.tableHeader)), t.height && this.root.push(Voe(t.height.value, t.height.rule)), t.cellSpacing && this.root.push(nH(t.cellSpacing)), t.insertion && this.root.push(new poe(t.insertion)), t.deletion && this.root.push(new moe(t.deletion)), t.revision && this.root.push(new Xoe(t.revision));
  }
}, Xoe = class extends Z {
  constructor(t) {
    super("w:trPrChange"), this.root.push(new Qs({
      id: t.id,
      author: t.author,
      date: t.date
    })), this.root.push(new sH(oe(oe({}, t), {}, { includeIfEmpty: !0 })));
  }
}, qd = (t, e) => {
  const A = t[e];
  return Array.isArray(A) ? A : [];
}, ig = (t) => Object.keys(t)[0], Zoe = (t, e) => {
  const A = qd(t, "w:p"), n = A.find((o) => ig(o) === "w:pPr");
  if (!n) return { "w:p": [{ "w:pPr": [e] }, ...A] };
  const s = qd(n, "w:pPr");
  if (s.some((o) => ig(o) === "w:keepNext")) return t;
  const r = s.filter((o) => ig(o) === "w:pStyle").length, i = { "w:pPr": [
    ...s.slice(0, r),
    e,
    ...s.slice(r)
  ] };
  return { "w:p": A.map((o) => o === n ? i : o) };
}, rH = class extends Z {
  constructor(t) {
    super("w:tr"), T(this, "options", void 0), this.options = t, this.root.push(new sH(t));
    for (const e of t.children) this.root.push(e);
  }
  prepForXml(t) {
    if (this.cells.length === 0) return;
    const e = super.prepForXml(t);
    if (!e || this.options.keepNext === void 0) return e;
    const A = new ce("w:keepNext", this.options.keepNext).prepForXml(t);
    return { "w:tr": qd(e, "w:tr").map((n) => ig(n) === "w:tc" ? { "w:tc": qd(n, "w:tc").map((s) => ig(s) === "w:p" ? Zoe(s, A) : s) } : n) };
  }
  get CellCount() {
    return this.options.children.length;
  }
  get cells() {
    return this.root.filter((t) => lf(t) === "w:tc");
  }
  addCellToIndex(t, e) {
    this.root.splice(e + 1, 0, t);
  }
  addCellToColumnIndex(t, e) {
    const A = this.columnIndexToRootIndex(e, !0);
    this.addCellToIndex(t, A - 1);
  }
  rootIndexToColumnIndex(t) {
    if (t < 1 || t >= this.root.length) throw new Error(`cell 'rootIndex' should between 1 to ${this.root.length - 1}`);
    let e = 0;
    for (let A = 1; A < t; A++) {
      const n = this.root[A];
      e += n.options.columnSpan || 1;
    }
    return e;
  }
  columnIndexToRootIndex(t, e = !1) {
    if (t < 0) throw new Error("cell 'columnIndex' should not less than zero");
    let A = 0, n = 1;
    for (; A <= t; ) {
      if (n >= this.root.length) {
        if (e) return this.root.length;
        throw new Error(`cell 'columnIndex' should not great than ${A - 1}`);
      }
      const s = this.root[n];
      n += 1, A += s && s.options.columnSpan || 1;
    }
    return n - 1;
  }
}, Km = class iH extends Lj {
  constructor({ rows: e, width: A, columnWidths: n, columnWidthsRevision: s, margins: r, indent: i, float: o, layout: a, style: c, borders: l, alignment: B, visuallyRightToLeft: g, tableLook: h, cellSpacing: u, revision: d }) {
    super("w:tbl"), T(this, "rows", void 0), T(this, "width", void 0), T(this, "columnWidths", void 0), T(this, "columnWidthsRevision", void 0), T(
      this,
      /**
      * Grid column widths in twips: the explicit `columnWidths`, or the widths derived
      * from the table and cell widths (re-resolved against the actual page or parent
      * cell every time the table is serialized).
      */
      "resolvedColumnWidths",
      void 0
    ), this.rows = e, this.width = A ?? { size: 100 }, this.columnWidths = n, this.columnWidthsRevision = s, e.forEach((w, Q) => {
      if (Q === e.length - 1) return;
      let p = 0;
      w.cells.forEach((M) => {
        if (M.options.rowSpan && M.options.rowSpan > 1) {
          const I = M.options.children[M.options.children.length - 1], N = new PE({
            rowSpan: M.options.rowSpan - 1,
            columnSpan: M.options.columnSpan,
            width: M.options.width,
            borders: M.options.borders,
            shading: M.options.shading,
            margins: M.options.margins,
            textDirection: M.options.textDirection,
            verticalAlign: M.options.verticalAlign,
            children: I instanceof gA ? [new gA(I.Alignment)] : [],
            verticalMerge: eH.CONTINUE
          });
          e[Q + 1].addCellToColumnIndex(N, p);
        }
        p += M.options.columnSpan || 1;
      });
    }), this.setCellWidths(bI), this.resolvedColumnWidths = n ?? TN({
      rows: e,
      width: this.width,
      availableWidth: bI
    }), this.root.push(new Pm({
      borders: c ? l : l ?? {},
      width: this.width,
      indent: i,
      float: o,
      layout: a,
      style: c,
      alignment: B,
      cellMargin: r,
      visuallyRightToLeft: g,
      tableLook: h,
      cellSpacing: u,
      revision: d
    })), this.root.push(new wu(this.resolvedColumnWidths, s));
    for (const w of e) this.root.push(w);
  }
  /**
  * Widths of the grid columns in twips, as they will be written to `w:tblGrid`.
  *
  * These are the explicit `columnWidths` when given, otherwise the widths derived
  * from the table and cell widths. Derived widths are resolved against the page (or
  * the parent cell for nested tables) during serialization, so before that they
  * reflect the default page size.
  */
  get ColumnWidths() {
    return this.resolvedColumnWidths;
  }
  /**
  * Width in twips, according to the grid, of a cell in one of this table's rows.
  *
  * Used by nested tables to resolve their own widths against the cell they sit in.
  *
  * @param row - A row of this table
  * @param cell - A cell of that row
  * @returns The summed width of the grid columns the cell spans, or undefined if the cell cannot be located on the grid
  */
  getCellWidth(e, A) {
    const { cells: n } = e, s = n.indexOf(A);
    if (s === -1) return;
    const r = n.slice(0, s).reduce((o, a) => o + (a.options.columnSpan || 1), 0), i = this.resolvedColumnWidths.slice(r, r + (A.options.columnSpan || 1));
    return i.length === 0 ? void 0 : i.reduce((o, a) => o + a, 0);
  }
  /**
  * Resolves derived grid column widths against the width actually available to the
  * table (the section's text width, or the parent cell for nested tables) before
  * serializing.
  */
  prepForXml(e) {
    if (this.setCellWidths(this.resolveAvailableWidth(e)), this.columnWidths === void 0) {
      this.resolvedColumnWidths = TN({
        rows: this.rows,
        width: this.width,
        availableWidth: this.resolveAvailableWidth(e)
      });
      const A = this.root.findIndex((n) => n instanceof wu);
      this.root[A] = new wu(this.resolvedColumnWidths, this.columnWidthsRevision);
    }
    return super.prepForXml(e);
  }
  /**
  * Gives each cell without a width of its own the width of the `columnWidths` it spans, as Word sizes the columns of
  * cells without a width to their content, whatever the grid says. When the table's width is wider than the columns
  * add up to, they are scaled up to fill it, as Word and LibreOffice lay them out, so columns given as proportions
  * keep them.
  */
  setCellWidths(e) {
    var A;
    if (this.columnWidths === void 0) return;
    const n = this.columnWidths.reduce((i, o) => i + o, 0), s = (A = Om(this.width, e)) !== null && A !== void 0 ? A : 0, r = n > 0 && s > n ? s / n : 1;
    for (const i of this.rows) {
      let o = 0;
      for (const a of i.cells) {
        const c = a.options.columnSpan || 1, l = this.columnWidths.slice(o, o + c), B = Math.round(l.reduce((g, h) => g + h, 0) * r);
        l.length === c && B > 0 && a.setColumnWidth(B), o += c;
      }
    }
  }
  /**
  * Finds the width in twips available to this table from the serialization context:
  * the parent cell for a nested table, otherwise the text width of the section the
  * table belongs to (the first section for headers, footers and other parts). Falls
  * back to the default page when the context carries no document.
  */
  resolveAvailableWidth(e) {
    var A, n, s;
    const { stack: r } = e, i = r[r.length - 1], o = r[r.length - 2], a = r[r.length - 3];
    if (i instanceof PE && o instanceof rH && a instanceof iH) {
      const g = a.getCellWidth(o, i);
      if (g !== void 0) return g;
    }
    const c = r.findIndex((g) => g instanceof qj), l = (A = e.file) === null || A === void 0 || (A = A.Document) === null || A === void 0 ? void 0 : A.View.Body, B = c >= 0 ? r[c].getSectionPropertiesFor((n = r[c + 1]) !== null && n !== void 0 ? n : this) : l == null ? void 0 : l.getSectionPropertiesFor();
    return (s = B == null ? void 0 : B.AvailableTextWidth) !== null && s !== void 0 ? s : bI;
  }
}, qoe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      xmlns: "xmlns",
      vt: "xmlns:vt"
    });
  }
}, _oe = class extends Z {
  constructor() {
    super("Properties"), this.root.push(new qoe({
      xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/extended-properties",
      vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
    }));
  }
}, $oe = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { xmlns: "xmlns" });
  }
}, ui = (t, e) => new K({
  name: "Default",
  attributes: {
    contentType: {
      key: "ContentType",
      value: t
    },
    extension: {
      key: "Extension",
      value: e
    }
  }
}), DA = (t, e) => new K({
  name: "Override",
  attributes: {
    contentType: {
      key: "ContentType",
      value: t
    },
    partName: {
      key: "PartName",
      value: e
    }
  }
}), eae = class extends Z {
  /**
  * @param options.macros - Whether the document has VBA macros, which makes its main part a macro-enabled document
  * and adds the VBA project (word/vbaProject.bin)
  */
  constructor({ macros: t = !1 } = {}) {
    super("Types"), this.root.push(new $oe({ xmlns: "http://schemas.openxmlformats.org/package/2006/content-types" })), this.root.push(ui("image/png", "png")), this.root.push(ui("image/jpeg", "jpeg")), this.root.push(ui("image/jpeg", "jpg")), this.root.push(ui("image/bmp", "bmp")), this.root.push(ui("image/gif", "gif")), this.root.push(ui("image/svg+xml", "svg")), this.root.push(ui("application/vnd.openxmlformats-package.relationships+xml", "rels")), this.root.push(ui("application/xml", "xml")), this.root.push(ui("application/vnd.openxmlformats-officedocument.obfuscatedFont", "odttf")), this.root.push(DA(t ? "application/vnd.ms-word.document.macroEnabled.main+xml" : "application/vnd.openxmlformats-officedocument.wordprocessingml.document.main+xml", "/word/document.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.styles+xml", "/word/styles.xml")), this.root.push(DA("application/vnd.openxmlformats-package.core-properties+xml", "/docProps/core.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.custom-properties+xml", "/docProps/custom.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.extended-properties+xml", "/docProps/app.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.numbering+xml", "/word/numbering.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.footnotes+xml", "/word/footnotes.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.endnotes+xml", "/word/endnotes.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.settings+xml", "/word/settings.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.fontTable+xml", "/word/fontTable.xml")), this.root.push(DA("application/vnd.openxmlformats-officedocument.theme+xml", "/word/theme/theme1.xml")), t && this.root.push(DA("application/vnd.ms-office.vbaProject", "/word/vbaProject.bin"));
  }
  /**
  * Registers the comments part in the content types.
  */
  addComments() {
    this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.comments+xml", "/word/comments.xml"));
  }
  /**
  * Registers the commentsExtended part in the content types.
  */
  addCommentsExtended() {
    this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.commentsExtended+xml", "/word/commentsExtended.xml"));
  }
  /**
  * Registers the commentsIds part in the content types.
  */
  addCommentsIds() {
    this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.commentsIds+xml", "/word/commentsIds.xml"));
  }
  /**
  * Registers a footer part in the content types.
  *
  * @param index - Footer index number (e.g., 1 for footer1.xml)
  */
  addFooter(t) {
    this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.footer+xml", `/word/footer${t}.xml`));
  }
  /**
  * Registers a part by its name, such as a chart or an embedded workbook that a drawing adds to the package.
  *
  * @param contentType - The part's content type
  * @param partName - The part's name, from the root of the package, such as "/word/charts/chart1.xml"
  */
  addOverride(t, e) {
    this.root.push(DA(t, e));
  }
  /**
  * Registers a header part in the content types.
  *
  * @param index - Header index number (e.g., 1 for header1.xml)
  */
  addHeader(t) {
    this.root.push(DA("application/vnd.openxmlformats-officedocument.wordprocessingml.header+xml", `/word/header${t}.xml`));
  }
}, WN = {
  wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
  mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
  o: "urn:schemas-microsoft-com:office:office",
  r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
  m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
  v: "urn:schemas-microsoft-com:vml",
  wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
  wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
  w10: "urn:schemas-microsoft-com:office:word",
  w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
  w14: "http://schemas.microsoft.com/office/word/2010/wordml",
  w15: "http://schemas.microsoft.com/office/word/2012/wordml",
  wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
  wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
  wne: "http://schemas.microsoft.com/office/word/2006/wordml",
  wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
  cp: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties",
  dc: "http://purl.org/dc/elements/1.1/",
  dcterms: "http://purl.org/dc/terms/",
  dcmitype: "http://purl.org/dc/dcmitype/",
  xsi: "http://www.w3.org/2001/XMLSchema-instance",
  cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
  cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
  cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
  cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
  cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
  cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
  cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
  cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
  cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
  aink: "http://schemas.microsoft.com/office/drawing/2016/ink",
  am3d: "http://schemas.microsoft.com/office/drawing/2017/model3d",
  w16cex: "http://schemas.microsoft.com/office/word/2018/wordml/cex",
  w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
  w16: "http://schemas.microsoft.com/office/word/2018/wordml",
  w16sdtdh: "http://schemas.microsoft.com/office/word/2020/wordml/sdtdatahash",
  w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
}, If = class extends Le {
  constructor(t, e) {
    super(oe({ Ignorable: e }, Object.fromEntries(t.map((A) => [A, WN[A]])))), T(this, "xmlKeys", oe({ Ignorable: "mc:Ignorable" }, Object.fromEntries(Object.keys(WN).map((A) => [A, `xmlns:${A}`]))));
  }
}, tae = class extends Z {
  constructor(t) {
    super("cp:coreProperties"), this.root.push(new If([
      "cp",
      "dc",
      "dcterms",
      "dcmitype",
      "xsi"
    ])), t.title && this.root.push(new Fa("dc:title", t.title)), t.subject && this.root.push(new Fa("dc:subject", t.subject)), t.creator && this.root.push(new Fa("dc:creator", t.creator)), t.keywords && this.root.push(new Fa("cp:keywords", t.keywords)), t.description && this.root.push(new Fa("dc:description", t.description)), t.lastModifiedBy && this.root.push(new Fa("cp:lastModifiedBy", t.lastModifiedBy)), t.revision && this.root.push(new Fa("cp:revision", String(t.revision))), this.root.push(new ON("dcterms:created")), this.root.push(new ON("dcterms:modified"));
  }
}, Aae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { type: "xsi:type" });
  }
}, ON = class extends Z {
  constructor(t) {
    super(t), this.root.push(new Aae({ type: "dcterms:W3CDTF" })), this.root.push(ene(/* @__PURE__ */ new Date()));
  }
}, nae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      xmlns: "xmlns",
      vt: "xmlns:vt"
    });
  }
}, sae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      formatId: "fmtid",
      pid: "pid",
      name: "name"
    });
  }
}, rae = class extends Z {
  constructor(t, e) {
    super("property"), this.root.push(new sae({
      formatId: "{D5CDD505-2E9C-101B-9397-08002B2CF9AE}",
      pid: t.toString(),
      name: e.name
    })), this.root.push(new iae(e.value));
  }
}, iae = class extends Z {
  constructor(t) {
    super("vt:lpwstr"), this.root.push(t);
  }
}, oae = class extends Z {
  constructor(t) {
    super("Properties"), T(this, "nextId", void 0), T(this, "properties", []), this.root.push(new nae({
      xmlns: "http://schemas.openxmlformats.org/officeDocument/2006/custom-properties",
      vt: "http://schemas.openxmlformats.org/officeDocument/2006/docPropsVTypes"
    })), this.nextId = 2;
    for (const e of t) this.addCustomProperty(e);
  }
  prepForXml(t) {
    return this.root.splice(1, this.root.length - 1, ...this.properties), super.prepForXml(t);
  }
  addCustomProperty(t) {
    this.properties.push(new rae(this.nextId++, t));
  }
}, aae = (t) => new K({
  name: "ds:datastoreItem",
  attributes: {
    itemId: {
      key: "ds:itemID",
      value: t
    },
    namespace: {
      key: "xmlns:ds",
      value: "http://schemas.openxmlformats.org/officeDocument/2006/customXml"
    }
  },
  children: [new K({
    name: "ds:schemaRefs",
    children: [new K({
      name: "ds:schemaRef",
      attributes: { uri: {
        key: "ds:uri",
        value: "http://schemas.openxmlformats.org/officeDocument/2006/bibliography"
      } }
    })]
  })]
}), cae = {
  new: "wne:eventDocNew",
  open: "wne:eventDocOpen",
  close: "wne:eventDocClose",
  sync: "wne:eventDocSync",
  xmlAfterInsert: "wne:eventDocXmlAfterInsert",
  xmlBeforeDelete: "wne:eventDocXmlBeforeDelete",
  contentControlAfterAdd: "wne:eventDocContentControlAfterInsert",
  contentControlBeforeDelete: "wne:eventDocContentControlBeforeDelete",
  contentControlOnExit: "wne:eventDocContentControlOnExit",
  contentControlOnEnter: "wne:eventDocContentControlOnEnter",
  contentControlBeforeStoreUpdate: "wne:eventDocStoreUpdate",
  contentControlBeforeContentUpdate: "wne:eventDocContentControlContentUpdate",
  buildingBlockInsert: "wne:eventDocBuildingBlockAfterInsert"
}, lae = (t) => new K({
  name: "wne:vbaSuppData",
  attributes: { namespace: {
    key: "xmlns:wne",
    value: "http://schemas.microsoft.com/office/word/2006/wordml"
  } },
  children: [new K({
    name: "wne:docEvents",
    children: Object.entries(cae).filter(([e]) => t.includes(e)).map(([, e]) => new K({ name: e }))
  })]
}), Bae = class extends Z {
  /**
  * @throws If a color isn't valid, or `color` is a theme color and `themeColor`, `themeShade` or `themeTint` is given
  */
  constructor({ color: t, themeColor: e, themeShade: A, themeTint: n }) {
    if (super("w:background"), typeof t == "object" && (e !== void 0 || A !== void 0 || n !== void 0)) throw new Error("Invalid background. Expected a theme color in color, or themeColor, themeShade and themeTint, not both");
    this.root.push(new jm([
      {
        keys: Fh,
        color: t
      },
      {
        key: "w:themeColor",
        value: e
      },
      {
        key: "w:themeShade",
        value: A === void 0 ? void 0 : MN(A)
      },
      {
        key: "w:themeTint",
        value: n === void 0 ? void 0 : MN(n)
      }
    ]));
  }
}, gae = class extends Z {
  constructor(t) {
    super("w:document"), T(this, "body", void 0), this.root.push(new If([
      "wpc",
      "mc",
      "o",
      "r",
      "m",
      "v",
      "wp14",
      "wp",
      "w10",
      "w",
      "w14",
      "w15",
      "wpg",
      "wpi",
      "wne",
      "wps",
      "cx",
      "cx1",
      "cx2",
      "cx3",
      "cx4",
      "cx5",
      "cx6",
      "cx7",
      "cx8",
      "aink",
      "am3d",
      "w16cex",
      "w16cid",
      "w16",
      "w16sdtdh",
      "w16se"
    ], "w14 w15 wp14")), this.body = new qj({ pageNumbers: t.pageNumbers }), t.background && this.root.push(new Bae(t.background)), this.root.push(this.body);
  }
  /**
  * Adds a block-level element to the document body.
  *
  * @param item - The element to add (paragraph, table, table of contents, hyperlink, or any other file child)
  * @returns The Document instance for method chaining
  */
  add(t) {
    return this.body.push(t), this;
  }
  /**
  * Gets the document body element.
  *
  * @returns The Body instance containing all document content
  */
  get Body() {
    return this.body;
  }
}, hae = class {
  constructor(t) {
    T(this, "document", void 0), T(this, "relationships", void 0), this.document = new gae(t), this.relationships = new zA();
  }
  get View() {
    return this.document;
  }
  get Relationships() {
    return this.relationships;
  }
}, uae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      wpc: "xmlns:wpc",
      mc: "xmlns:mc",
      o: "xmlns:o",
      r: "xmlns:r",
      m: "xmlns:m",
      v: "xmlns:v",
      wp14: "xmlns:wp14",
      wp: "xmlns:wp",
      w10: "xmlns:w10",
      w: "xmlns:w",
      w14: "xmlns:w14",
      w15: "xmlns:w15",
      wpg: "xmlns:wpg",
      wpi: "xmlns:wpi",
      wne: "xmlns:wne",
      wps: "xmlns:wps",
      Ignorable: "mc:Ignorable"
    });
  }
}, oH = class extends Z {
  constructor(t, e) {
    super("w:p"), T(this, "paragraph", void 0), T(this, "mark", void 0), this.paragraph = t, this.mark = e;
  }
  prepForXml(t) {
    const e = this.paragraph.prepForXml(t)["w:p"], A = Array.isArray(e) ? e : [], n = A.length > 0 && "w:pPr" in A[0] ? 1 : 0;
    return { "w:p": [
      ...A.slice(0, n),
      this.mark.prepForXml(t),
      ...A.slice(n)
    ] };
  }
}, dae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      type: "w:type",
      id: "w:id"
    });
  }
}, wae = class extends Or {
  constructor() {
    super({ style: "EndnoteReference" }), this.root.push(new uie());
  }
}, PN = {
  SEPARATOR: "separator",
  CONTINUATION_SEPARATOR: "continuationSeparator"
}, jI = class extends Z {
  constructor(t) {
    super("w:endnote"), this.root.push(new dae({
      type: t.type,
      id: t.id
    }));
    for (const [e, A] of t.children.entries()) this.root.push(e === 0 ? new oH(A, new wae()) : A);
  }
}, fae = class extends Z {
  constructor() {
    super("w:continuationSeparator");
  }
}, aH = class extends Or {
  constructor() {
    super({}), this.root.push(new fae());
  }
}, Qae = class extends Z {
  constructor() {
    super("w:separator");
  }
}, cH = class extends Or {
  constructor() {
    super({}), this.root.push(new Qae());
  }
}, Iae = class extends Z {
  constructor() {
    super("w:endnotes"), T(this, "ownNotes", /* @__PURE__ */ new Map()), T(this, "highestId", 0), this.root.push(new uae({
      wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
      o: "urn:schemas-microsoft-com:office:office",
      r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
      m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
      v: "urn:schemas-microsoft-com:vml",
      wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
      wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
      w10: "urn:schemas-microsoft-com:office:word",
      w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
      w14: "http://schemas.microsoft.com/office/word/2010/wordml",
      w15: "http://schemas.microsoft.com/office/word/2012/wordml",
      wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
      wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
      wne: "http://schemas.microsoft.com/office/word/2006/wordml",
      wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
      Ignorable: "w14 w15 wp14"
    }));
    const t = new jI({
      id: -1,
      type: PN.SEPARATOR,
      children: [new gA({
        spacing: {
          after: 0,
          line: 240,
          lineRule: vl.AUTO
        },
        children: [new cH()]
      })]
    });
    this.root.push(t);
    const e = new jI({
      id: 0,
      type: PN.CONTINUATION_SEPARATOR,
      children: [new gA({
        spacing: {
          after: 0,
          line: 240,
          lineRule: vl.AUTO
        },
        children: [new aH()]
      })]
    });
    this.root.push(e);
  }
  createEndnote(t, e) {
    const A = new jI({
      id: t,
      children: e
    });
    this.root.push(A), Number.isFinite(t) && (this.highestId = Math.max(this.highestId, Math.floor(t)));
  }
  /**
  * The id of the endnote that a reference run brings with it, which is added to the endnotes the first time the run
  * is written, with an id no other endnote has. Word has endnotes only in a document's body, so a run written
  * anywhere else, such as in a header, has none, and its endnote isn't added.
  *
  * @internal
  * @param reference - The run, which has the same endnote each time it is written
  * @param endnote - The endnote's content
  * @param context - The context the run is written in
  * @returns The endnote's id, or undefined outside the document's body
  */
  idOf(t, e, A) {
    if (A.viewWrapper !== A.file.Document) return;
    const n = this.ownNotes.get(t);
    if (n !== void 0) return n;
    const s = this.highestId + 1;
    return this.createEndnote(s, e.children), this.ownNotes.set(t, s), s;
  }
  /**
  * Formats the endnotes, with the page numbers worked out for their document written into their fields, when the
  * document's body is written with an estimate of its pages.
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    return Nh(e, t), e;
  }
}, Cae = class {
  constructor() {
    T(this, "endnotes", void 0), T(this, "relationships", void 0), this.endnotes = new Iae(), this.relationships = new zA();
  }
  get View() {
    return this.endnotes;
  }
  get Relationships() {
    return this.relationships;
  }
}, Eae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      wpc: "xmlns:wpc",
      mc: "xmlns:mc",
      o: "xmlns:o",
      r: "xmlns:r",
      m: "xmlns:m",
      v: "xmlns:v",
      wp14: "xmlns:wp14",
      wp: "xmlns:wp",
      w10: "xmlns:w10",
      w: "xmlns:w",
      w14: "xmlns:w14",
      w15: "xmlns:w15",
      wpg: "xmlns:wpg",
      wpi: "xmlns:wpi",
      wne: "xmlns:wne",
      wps: "xmlns:wps",
      cp: "xmlns:cp",
      dc: "xmlns:dc",
      dcterms: "xmlns:dcterms",
      dcmitype: "xmlns:dcmitype",
      xsi: "xmlns:xsi",
      type: "xsi:type"
    });
  }
}, Mae = class extends Jv {
  constructor(t, e) {
    super("w:ftr", e), T(this, "refId", void 0), this.refId = t, e || this.root.push(new Eae({
      wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
      o: "urn:schemas-microsoft-com:office:office",
      r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
      m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
      v: "urn:schemas-microsoft-com:vml",
      wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
      wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
      w10: "urn:schemas-microsoft-com:office:word",
      w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
      w14: "http://schemas.microsoft.com/office/word/2010/wordml",
      w15: "http://schemas.microsoft.com/office/word/2012/wordml",
      wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
      wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
      wne: "http://schemas.microsoft.com/office/word/2006/wordml",
      wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape"
    }));
  }
  get ReferenceId() {
    return this.refId;
  }
  add(t) {
    this.root.push(t);
  }
  /**
  * Formats the footer, with the page numbers worked out for its document written into its fields, when the document's
  * body is written with an estimate of its pages.
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    return Nh(e, t, this.refId), e;
  }
}, pae = class {
  constructor(t, e, A) {
    T(this, "media", void 0), T(this, "footer", void 0), T(this, "relationships", void 0), this.media = t, this.footer = new Mae(e, A), this.relationships = new zA();
  }
  add(t) {
    this.footer.add(t);
  }
  addChildElement(t) {
    this.footer.addChildElement(t);
  }
  get View() {
    return this.footer;
  }
  get Relationships() {
    return this.relationships;
  }
  get Media() {
    return this.media;
  }
}, mae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      type: "w:type",
      id: "w:id"
    });
  }
}, Yae = class extends Z {
  constructor() {
    super("w:footnoteRef");
  }
}, yae = class extends Or {
  constructor() {
    super({ style: "FootnoteReference" }), this.root.push(new Yae());
  }
}, KN = {
  /** Separator line between body text and footnotes */
  SEPERATOR: "separator",
  /** Continuation separator for footnotes spanning pages */
  CONTINUATION_SEPERATOR: "continuationSeparator"
}, HI = class extends Z {
  constructor(t) {
    super("w:footnote"), this.root.push(new mae({
      type: t.type,
      id: t.id
    }));
    for (const [e, A] of t.children.entries()) this.root.push(e === 0 ? new oH(A, new yae()) : A);
  }
}, Fae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      wpc: "xmlns:wpc",
      mc: "xmlns:mc",
      o: "xmlns:o",
      r: "xmlns:r",
      m: "xmlns:m",
      v: "xmlns:v",
      wp14: "xmlns:wp14",
      wp: "xmlns:wp",
      w10: "xmlns:w10",
      w: "xmlns:w",
      w14: "xmlns:w14",
      w15: "xmlns:w15",
      wpg: "xmlns:wpg",
      wpi: "xmlns:wpi",
      wne: "xmlns:wne",
      wps: "xmlns:wps",
      Ignorable: "mc:Ignorable"
    });
  }
}, Nae = class extends Z {
  constructor() {
    super("w:footnotes"), T(this, "ownNotes", /* @__PURE__ */ new Map()), T(this, "highestId", 0), this.root.push(new Fae({
      wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
      o: "urn:schemas-microsoft-com:office:office",
      r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
      m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
      v: "urn:schemas-microsoft-com:vml",
      wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
      wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
      w10: "urn:schemas-microsoft-com:office:word",
      w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
      w14: "http://schemas.microsoft.com/office/word/2010/wordml",
      w15: "http://schemas.microsoft.com/office/word/2012/wordml",
      wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
      wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
      wne: "http://schemas.microsoft.com/office/word/2006/wordml",
      wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
      Ignorable: "w14 w15 wp14"
    }));
    const t = new HI({
      id: -1,
      type: KN.SEPERATOR,
      children: [new gA({
        spacing: {
          after: 0,
          line: 240,
          lineRule: vl.AUTO
        },
        children: [new cH()]
      })]
    });
    this.root.push(t);
    const e = new HI({
      id: 0,
      type: KN.CONTINUATION_SEPERATOR,
      children: [new gA({
        spacing: {
          after: 0,
          line: 240,
          lineRule: vl.AUTO
        },
        children: [new aH()]
      })]
    });
    this.root.push(e);
  }
  /**
  * Creates and adds a new footnote to the collection.
  *
  * @param id - Unique numeric identifier for the footnote
  * @param paragraph - Array of paragraphs that make up the footnote content
  */
  createFootNote(t, e) {
    const A = new HI({
      id: t,
      children: e
    });
    this.root.push(A), Number.isFinite(t) && (this.highestId = Math.max(this.highestId, Math.floor(t)));
  }
  /**
  * The id of the footnote that a reference run brings with it, which is added to the footnotes the first time the
  * run is written, with an id no other footnote has. Word has footnotes only in a document's body, so a run written
  * anywhere else, such as in a header, has none, and its footnote isn't added.
  *
  * @internal
  * @param reference - The run, which has the same footnote each time it is written
  * @param footnote - The footnote's content
  * @param context - The context the run is written in
  * @returns The footnote's id, or undefined outside the document's body
  */
  idOf(t, e, A) {
    if (A.viewWrapper !== A.file.Document) return;
    const n = this.ownNotes.get(t);
    if (n !== void 0) return n;
    const s = this.highestId + 1;
    return this.createFootNote(s, e.children), this.ownNotes.set(t, s), s;
  }
  /**
  * Formats the footnotes, with the page numbers worked out for their document written into their fields, when the
  * document's body is written with an estimate of its pages.
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    return Nh(e, t), e;
  }
}, Dae = class {
  constructor() {
    T(this, "footnotess", void 0), T(this, "relationships", void 0), this.footnotess = new Nae(), this.relationships = new zA();
  }
  get View() {
    return this.footnotess;
  }
  get Relationships() {
    return this.relationships;
  }
}, xae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      wpc: "xmlns:wpc",
      mc: "xmlns:mc",
      o: "xmlns:o",
      r: "xmlns:r",
      m: "xmlns:m",
      v: "xmlns:v",
      wp14: "xmlns:wp14",
      wp: "xmlns:wp",
      w10: "xmlns:w10",
      w: "xmlns:w",
      w14: "xmlns:w14",
      w15: "xmlns:w15",
      wpg: "xmlns:wpg",
      wpi: "xmlns:wpi",
      wne: "xmlns:wne",
      wps: "xmlns:wps",
      cp: "xmlns:cp",
      dc: "xmlns:dc",
      dcterms: "xmlns:dcterms",
      dcmitype: "xmlns:dcmitype",
      xsi: "xmlns:xsi",
      type: "xsi:type",
      cx: "xmlns:cx",
      cx1: "xmlns:cx1",
      cx2: "xmlns:cx2",
      cx3: "xmlns:cx3",
      cx4: "xmlns:cx4",
      cx5: "xmlns:cx5",
      cx6: "xmlns:cx6",
      cx7: "xmlns:cx7",
      cx8: "xmlns:cx8",
      w16cid: "xmlns:w16cid",
      w16se: "xmlns:w16se"
    });
  }
}, Gae = class extends Jv {
  constructor(t, e) {
    super("w:hdr", e), T(this, "refId", void 0), this.refId = t, e || this.root.push(new xae({
      wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
      o: "urn:schemas-microsoft-com:office:office",
      r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
      m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
      v: "urn:schemas-microsoft-com:vml",
      wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
      wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
      w10: "urn:schemas-microsoft-com:office:word",
      w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
      w14: "http://schemas.microsoft.com/office/word/2010/wordml",
      w15: "http://schemas.microsoft.com/office/word/2012/wordml",
      wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
      wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
      wne: "http://schemas.microsoft.com/office/word/2006/wordml",
      wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
      cx: "http://schemas.microsoft.com/office/drawing/2014/chartex",
      cx1: "http://schemas.microsoft.com/office/drawing/2015/9/8/chartex",
      cx2: "http://schemas.microsoft.com/office/drawing/2015/10/21/chartex",
      cx3: "http://schemas.microsoft.com/office/drawing/2016/5/9/chartex",
      cx4: "http://schemas.microsoft.com/office/drawing/2016/5/10/chartex",
      cx5: "http://schemas.microsoft.com/office/drawing/2016/5/11/chartex",
      cx6: "http://schemas.microsoft.com/office/drawing/2016/5/12/chartex",
      cx7: "http://schemas.microsoft.com/office/drawing/2016/5/13/chartex",
      cx8: "http://schemas.microsoft.com/office/drawing/2016/5/14/chartex",
      w16cid: "http://schemas.microsoft.com/office/word/2016/wordml/cid",
      w16se: "http://schemas.microsoft.com/office/word/2015/wordml/symex"
    }));
  }
  get ReferenceId() {
    return this.refId;
  }
  add(t) {
    this.root.push(t);
  }
  /**
  * Formats the header, with the page numbers worked out for its document written into its fields, when the document's
  * body is written with an estimate of its pages.
  */
  prepForXml(t) {
    const e = super.prepForXml(t);
    return Nh(e, t, this.refId), e;
  }
}, zae = class {
  constructor(t, e, A) {
    T(this, "media", void 0), T(this, "header", void 0), T(this, "relationships", void 0), this.media = t, this.header = new Gae(e, A), this.relationships = new zA();
  }
  add(t) {
    return this.header.add(t), this;
  }
  addChildElement(t) {
    this.header.addChildElement(t);
  }
  get View() {
    return this.header;
  }
  get Relationships() {
    return this.relationships;
  }
  get Media() {
    return this.media;
  }
}, Uae = () => {
  const t = /* @__PURE__ */ new Map();
  return (e) => {
    var A;
    const n = ((A = t.get(e)) !== null && A !== void 0 ? A : 0) + 1;
    return t.set(e, n), `media/image${n}.${e}`;
  };
}, bae = class {
  /**
  * @param takePath - Gives each image its path under word/, by its extension, so that it doesn't take the path of
  * another part of the package, such as a template's image. Default numbers them by type, media/image1.png,
  * media/image2.png and so on
  */
  constructor(t = Uae()) {
    T(this, "map", /* @__PURE__ */ new Map()), T(this, "takePath", void 0), this.takePath = t;
  }
  /**
  * Adds an image to the media collection, once: an image added again under the same key, such as one used in the
  * body and in a header, keeps the file name it was given the first time.
  *
  * @param key - Unique identifier for this image, which the XML refers to it by until it is packed
  * @param mediaData - Complete image data including type, transformation, and raw data
  */
  addImage(t, e) {
    if (this.map.has(t)) return;
    const A = this.takePath(e.type);
    this.map.set(t, oe(oe({}, e), {}, { fileName: A.slice(A.lastIndexOf("/") + 1) }));
  }
  /**
  * Gets all images as an array, in the order they were added, each with the file name it is written with.
  *
  * @returns Read-only array of all media data in the collection
  */
  get Array() {
    return Array.from(this.map.values());
  }
  /**
  * Gets all images with the keys they were added under, in the order they were added.
  *
  * @returns Read-only array of each image's key and media data, whose file name is the one it is written with
  */
  get Entries() {
    return Array.from(this.map.entries());
  }
}, Ht = {
  /** Decimal numbering (1, 2, 3...). */
  DECIMAL: "decimal",
  /** Bullet points. */
  BULLET: "bullet"
}, vae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      ilvl: "w:ilvl",
      tentative: "w:tentative"
    });
  }
}, jae = class extends Z {
  constructor(t) {
    super("w:numFmt"), this.root.push(new jn({ val: t }));
  }
}, Hae = class extends Z {
  constructor(t) {
    super("w:lvlText"), this.root.push(new jn({ val: t }));
  }
}, kae = (t) => {
  switch (t) {
    case bt.CENTER:
      return "center";
    case bt.END:
    case bt.RIGHT:
      return "right";
    default:
      return "left";
  }
}, Rae = class extends Z {
  constructor(t) {
    super("w:lvlJc"), this.root.push(new jn({ val: kae(t) }));
  }
}, Lae = class extends Z {
  constructor(t) {
    super("w:suff"), this.root.push(new jn({ val: t }));
  }
}, Sae = class extends Z {
  constructor() {
    super("w:isLgl");
  }
}, Tae = class extends Z {
  /**
  * Creates a new numbering level.
  *
  * @param options - Level configuration options
  * @throws Error if level is greater than 9 (Word limitation)
  */
  constructor({ level: t, format: e, text: A, alignment: n = bt.START, start: s = 1, style: r, suffix: i, isLegalNumberingStyle: o }) {
    if (super("w:lvl"), T(this, "paragraphProperties", void 0), T(this, "runProperties", void 0), this.root.push(new rg("w:start", hA(s))), e && this.root.push(new jae(e)), r != null && r.style && this.root.push(FB(r.style)), o && this.root.push(new Sae()), i && this.root.push(new Lae(i)), A && this.root.push(new Hae(A)), this.root.push(new Rae(n)), this.paragraphProperties = new jl(r && r.paragraph, {
      implicitListParagraphStyle: !1,
      inListOrder: !1
    }), this.runProperties = new la((r == null ? void 0 : r.run) && oe(oe({}, r.run), {}, {
      highlight: void 0,
      math: void 0,
      revision: void 0
    })), this.root.push(this.paragraphProperties), this.root.push(this.runProperties), t > 9) throw new Error("Level cannot be greater than 9. Read more here: https://answers.microsoft.com/en-us/msoffice/forum/all/does-word-support-more-than-9-list-levels/d130fdcd-1781-446d-8c84-c6c79124e4d7");
    this.root.push(new vae({
      ilvl: hA(t),
      tentative: 1
    }));
  }
}, Jae = class extends Tae {
}, Wae = class extends Z {
  /**
  * Creates a new multi-level type specification.
  *
  * @param value - The multi-level type: "singleLevel", "multilevel", or "hybridMultilevel"
  */
  constructor(t) {
    super("w:multiLevelType"), this.root.push(new jn({ val: t }));
  }
}, Oae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      abstractNumId: "w:abstractNumId",
      restartNumberingAfterBreak: "w15:restartNumberingAfterBreak"
    });
  }
}, kI = class extends Z {
  /**
  * Creates a new abstract numbering definition.
  *
  * @param id - Unique identifier for this abstract numbering definition
  * @param levelOptions - Array of level definitions (up to 9 levels)
  */
  constructor(t, e) {
    super("w:abstractNum"), T(
      this,
      /** The unique identifier for this abstract numbering definition. */
      "id",
      void 0
    ), this.root.push(new Oae({
      abstractNumId: hA(t),
      restartNumberingAfterBreak: 0
    })), this.root.push(new Wae("hybridMultilevel")), this.id = t;
    for (const A of e) this.root.push(new Jae(A));
  }
}, Pae = class extends Z {
  constructor(t) {
    super("w:abstractNumId"), this.root.push(new jn({ val: t }));
  }
}, Kae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { numId: "w:numId" });
  }
}, VN = class extends Z {
  /**
  * Creates a new concrete numbering instance.
  *
  * @param options - Configuration options for the numbering instance
  */
  constructor(t) {
    if (super("w:num"), T(
      this,
      /** The unique identifier for this numbering instance. */
      "numId",
      void 0
    ), T(
      this,
      /** The reference name for this numbering instance. */
      "reference",
      void 0
    ), T(
      this,
      /** The instance number for tracking multiple uses. */
      "instance",
      void 0
    ), T(
      this,
      /** For a list a paragraph restarts, the id of that restart, as {@link IConcreteNumberingOptions.restartedListId} describes. */
      "restartedListId",
      void 0
    ), this.numId = t.numId, this.reference = t.reference, this.instance = t.instance, this.restartedListId = t.restartedListId, this.root.push(new Kae({ numId: hA(t.numId) })), this.root.push(new Pae(hA(t.abstractNumId))), t.overrideLevels && t.overrideLevels.length) for (const e of t.overrideLevels) this.root.push(new Xae(e.num, e.start));
  }
}, Vae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { ilvl: "w:ilvl" });
  }
}, Xae = class extends Z {
  /**
  * Creates a new level override.
  *
  * @param levelNum - The level number to override (0-8)
  * @param start - Optional starting number for the level
  */
  constructor(t, e) {
    super("w:lvlOverride"), this.root.push(new Vae({ ilvl: t })), e !== void 0 && this.root.push(new qae(e));
  }
}, Zae = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { val: "w:val" });
  }
}, qae = class extends Z {
  /**
  * Creates a new start override.
  *
  * @param start - The starting number
  */
  constructor(t) {
    super("w:startOverride"), this.root.push(new Zae({ val: t }));
  }
}, _ae = class extends Z {
  /**
  * Creates a new numbering definition collection.
  *
  * Initializes the numbering with a default bullet list configuration and
  * any custom numbering configurations provided in the options.
  *
  * @param options - Configuration options for numbering definitions
  */
  constructor(t) {
    super("w:numbering"), T(this, "abstractNumberingMap", /* @__PURE__ */ new Map()), T(this, "concreteNumberingMap", /* @__PURE__ */ new Map()), T(this, "referenceConfigMap", /* @__PURE__ */ new Map()), T(this, "abstractNumUniqueNumericId", kne()), T(this, "concreteNumUniqueNumericId", Rne()), this.root.push(new If([
      "wpc",
      "mc",
      "o",
      "r",
      "m",
      "v",
      "wp14",
      "wp",
      "w10",
      "w",
      "w14",
      "w15",
      "wpg",
      "wpi",
      "wne",
      "wps"
    ], "w14 w15 wp14"));
    const e = new kI(this.abstractNumUniqueNumericId(), [
      {
        level: 0,
        format: Ht.BULLET,
        text: "●",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: pn(0.5),
          hanging: pn(0.25)
        } } }
      },
      {
        level: 1,
        format: Ht.BULLET,
        text: "○",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: pn(1),
          hanging: pn(0.25)
        } } }
      },
      {
        level: 2,
        format: Ht.BULLET,
        text: "■",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 2160,
          hanging: pn(0.25)
        } } }
      },
      {
        level: 3,
        format: Ht.BULLET,
        text: "●",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 2880,
          hanging: pn(0.25)
        } } }
      },
      {
        level: 4,
        format: Ht.BULLET,
        text: "○",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 3600,
          hanging: pn(0.25)
        } } }
      },
      {
        level: 5,
        format: Ht.BULLET,
        text: "■",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 4320,
          hanging: pn(0.25)
        } } }
      },
      {
        level: 6,
        format: Ht.BULLET,
        text: "●",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 5040,
          hanging: pn(0.25)
        } } }
      },
      {
        level: 7,
        format: Ht.BULLET,
        text: "●",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 5760,
          hanging: pn(0.25)
        } } }
      },
      {
        level: 8,
        format: Ht.BULLET,
        text: "●",
        alignment: bt.LEFT,
        style: { paragraph: { indent: {
          left: 6480,
          hanging: pn(0.25)
        } } }
      }
    ]);
    this.concreteNumberingMap.set("default-bullet-numbering", new VN({
      numId: 1,
      abstractNumId: e.id,
      reference: "default-bullet-numbering",
      instance: 0,
      overrideLevels: [{
        num: 0,
        start: 1
      }]
    })), this.abstractNumberingMap.set("default-bullet-numbering", e);
    for (const A of t.config)
      this.abstractNumberingMap.set(A.reference, new kI(this.abstractNumUniqueNumericId(), A.levels)), this.referenceConfigMap.set(A.reference, A.levels);
  }
  /**
  * Prepares the numbering definitions for XML serialization.
  *
  * Adds all abstract and concrete numbering definitions to the XML tree.
  *
  * @param context - The XML context
  * @returns The prepared XML object
  */
  prepForXml(t) {
    return this.root.splice(1, this.root.length - 1, ...this.abstractNumberingMap.values(), ...this.concreteNumberingMap.values()), super.prepForXml(t);
  }
  /**
  * Creates a concrete numbering instance from an abstract numbering definition.
  *
  * This method creates a new concrete numbering instance that references an
  * abstract numbering definition. It's used internally when paragraphs reference
  * numbering configurations.
  *
  * @param reference - The reference name of the abstract numbering definition
  * @param instance - The instance number for this concrete numbering
  * @param definition - The list's definition, for a list a paragraph gives its own definition of. It is added with
  * its reference, unless the numbering already has a list with that reference, such as one of the document's
  * `numbering` option, which is kept
  * @param restartedListId - For a list a paragraph starts again with `restart`, the id of that restart. The list is
  * then that restart's own, not the `instance`'s
  */
  createConcreteNumberingInstance(t, e, A, n) {
    var s;
    A && !this.abstractNumberingMap.has(A.reference) && (this.abstractNumberingMap.set(A.reference, new kI(this.abstractNumUniqueNumericId(), A.levels)), this.referenceConfigMap.set(A.reference, A.levels));
    const r = this.abstractNumberingMap.get(t);
    if (!r) return;
    const i = Vd(t, e, n);
    if (this.concreteNumberingMap.has(i)) return;
    const o = (s = this.referenceConfigMap.get(t)) !== null && s !== void 0 ? s : [{ level: 0 }], a = {
      numId: this.concreteNumUniqueNumericId(),
      abstractNumId: r.id,
      reference: t,
      instance: e,
      restartedListId: n,
      overrideLevels: o.map(({ level: c, start: l = 1 }) => ({
        num: c,
        start: hA(l)
      }))
    };
    this.concreteNumberingMap.set(i, new VN(a));
  }
  /**
  * Gets all concrete numbering instances.
  *
  * @returns An array of all concrete numbering instances
  */
  get ConcreteNumbering() {
    return Array.from(this.concreteNumberingMap.values());
  }
  /**
  * Gets all reference configurations.
  *
  * @returns An array of all numbering reference configurations
  */
  get ReferenceConfig() {
    return Array.from(this.referenceConfigMap.values());
  }
}, $ae = class {
  /**
  * @param contentTypes - Where each part's content type is added
  * @param existingPaths - The paths under word/ of the parts the package already has, such as a template's charts
  * and images, which new parts don't take
  */
  constructor(t, e = /* @__PURE__ */ new Set()) {
    T(this, "contentTypes", void 0), T(this, "paths", /* @__PURE__ */ new Map()), T(this, "taken", void 0), T(this, "folders", /* @__PURE__ */ new WeakMap()), this.contentTypes = t, this.taken = new Set(e);
  }
  /**
  * Adds a part, and its content type, once.
  *
  * @returns The part's path under word/, such as "charts/chart1.xml"
  */
  add(t) {
    const e = this.paths.get(t);
    if (e !== void 0) return e;
    const { folder: A, name: n, extension: s, contentType: r } = t.options, i = this.takePath(A, n, s);
    return this.paths.set(t, i), this.contentTypes.addOverride(r, `/word/${i}`), i;
  }
  /**
  * Takes the lowest-numbered path in a folder that nothing has yet, so that nothing else is written there: the
  * package's own parts, the parts added, and the document's images, which `Media` names with this, as Word names
  * them: media/image1.png, media/image2.png and so on.
  *
  * @param folder - The folder under word/, such as "media"
  * @param name - The start of the file name, such as "image"
  * @param extension - The file name's extension, such as "png"
  * @returns The path under word/, such as "media/image1.png"
  */
  takePath(t, e, A) {
    let n = 1;
    for (; this.taken.has(`${t}/${e}${n}.${A}`); ) n++;
    const s = `${t}/${e}${n}.${A}`;
    return this.taken.add(s), s;
  }
  /**
  * Each part added, with its path under word/, in the order they were added.
  *
  * A part related as an OLE object is listed too, though the parts are typed as they were before a part could be:
  * `File`, whose type is public, has these parts, and the compiler only writes their content.
  */
  get Array() {
    return [...this.paths].map(([t, e]) => ({
      part: t,
      path: e
    }));
  }
  /**
  * Creates the relationships of a part whose XML is being written, so the parts its XML refers to are found from its
  * folder.
  *
  * @param path - The part's path under word/
  */
  createRelationships(t) {
    const e = new zA();
    return this.folders.set(e, t.slice(0, t.indexOf("/"))), e;
  }
  /**
  * The target of a relationship to a part, relative to the part the relationships are from. The document, headers,
  * footers, footnotes, endnotes and comments are all in word/.
  *
  * @param path - The part's path under word/
  */
  getTarget(t, e) {
    const A = this.folders.get(t);
    return A === void 0 ? e : e.startsWith(`${A}/`) ? e.slice(A.length + 1) : `../${e}`;
  }
}, ece = (t) => new K({
  name: "w:compatSetting",
  attributes: {
    version: {
      key: "w:val",
      value: t
    },
    name: {
      key: "w:name",
      value: "compatibilityMode"
    },
    uri: {
      key: "w:uri",
      value: "http://schemas.microsoft.com/office/word"
    }
  }
}), tce = class extends Z {
  constructor(t) {
    super("w:compat"), t.useSingleBorderforContiguousCells && this.root.push(new ce("w:useSingleBorderforContiguousCells", t.useSingleBorderforContiguousCells)), t.wordPerfectJustification && this.root.push(new ce("w:wpJustification", t.wordPerfectJustification)), t.noTabStopForHangingIndent && this.root.push(new ce("w:noTabHangInd", t.noTabStopForHangingIndent)), t.noLeading && this.root.push(new ce("w:noLeading", t.noLeading)), t.spaceForUnderline && this.root.push(new ce("w:spaceForUL", t.spaceForUnderline)), t.noColumnBalance && this.root.push(new ce("w:noColumnBalance", t.noColumnBalance)), t.balanceSingleByteDoubleByteWidth && this.root.push(new ce("w:balanceSingleByteDoubleByteWidth", t.balanceSingleByteDoubleByteWidth)), t.noExtraLineSpacing && this.root.push(new ce("w:noExtraLineSpacing", t.noExtraLineSpacing)), t.doNotLeaveBackslashAlone && this.root.push(new ce("w:doNotLeaveBackslashAlone", t.doNotLeaveBackslashAlone)), t.underlineTrailingSpaces && this.root.push(new ce("w:ulTrailSpace", t.underlineTrailingSpaces)), t.doNotExpandShiftReturn && this.root.push(new ce("w:doNotExpandShiftReturn", t.doNotExpandShiftReturn)), t.spacingInWholePoints && this.root.push(new ce("w:spacingInWholePoints", t.spacingInWholePoints)), t.lineWrapLikeWord6 && this.root.push(new ce("w:lineWrapLikeWord6", t.lineWrapLikeWord6)), t.printBodyTextBeforeHeader && this.root.push(new ce("w:printBodyTextBeforeHeader", t.printBodyTextBeforeHeader)), t.printColorsBlack && this.root.push(new ce("w:printColBlack", t.printColorsBlack)), t.spaceWidth && this.root.push(new ce("w:wpSpaceWidth", t.spaceWidth)), t.showBreaksInFrames && this.root.push(new ce("w:showBreaksInFrames", t.showBreaksInFrames)), t.subFontBySize && this.root.push(new ce("w:subFontBySize", t.subFontBySize)), t.suppressBottomSpacing && this.root.push(new ce("w:suppressBottomSpacing", t.suppressBottomSpacing)), t.suppressTopSpacing && this.root.push(new ce("w:suppressTopSpacing", t.suppressTopSpacing)), t.suppressSpacingAtTopOfPage && this.root.push(new ce("w:suppressSpacingAtTopOfPage", t.suppressSpacingAtTopOfPage)), t.suppressTopSpacingWP && this.root.push(new ce("w:suppressTopSpacingWP", t.suppressTopSpacingWP)), t.suppressSpBfAfterPgBrk && this.root.push(new ce("w:suppressSpBfAfterPgBrk", t.suppressSpBfAfterPgBrk)), t.swapBordersFacingPages && this.root.push(new ce("w:swapBordersFacingPages", t.swapBordersFacingPages)), t.convertMailMergeEsc && this.root.push(new ce("w:convMailMergeEsc", t.convertMailMergeEsc)), t.truncateFontHeightsLikeWP6 && this.root.push(new ce("w:truncateFontHeightsLikeWP6", t.truncateFontHeightsLikeWP6)), t.macWordSmallCaps && this.root.push(new ce("w:mwSmallCaps", t.macWordSmallCaps)), t.usePrinterMetrics && this.root.push(new ce("w:usePrinterMetrics", t.usePrinterMetrics)), t.doNotSuppressParagraphBorders && this.root.push(new ce("w:doNotSuppressParagraphBorders", t.doNotSuppressParagraphBorders)), t.wrapTrailSpaces && this.root.push(new ce("w:wrapTrailSpaces", t.wrapTrailSpaces)), t.footnoteLayoutLikeWW8 && this.root.push(new ce("w:footnoteLayoutLikeWW8", t.footnoteLayoutLikeWW8)), t.shapeLayoutLikeWW8 && this.root.push(new ce("w:shapeLayoutLikeWW8", t.shapeLayoutLikeWW8)), t.alignTablesRowByRow && this.root.push(new ce("w:alignTablesRowByRow", t.alignTablesRowByRow)), t.forgetLastTabAlignment && this.root.push(new ce("w:forgetLastTabAlignment", t.forgetLastTabAlignment)), t.adjustLineHeightInTable && this.root.push(new ce("w:adjustLineHeightInTable", t.adjustLineHeightInTable)), t.autoSpaceLikeWord95 && this.root.push(new ce("w:autoSpaceLikeWord95", t.autoSpaceLikeWord95)), t.noSpaceRaiseLower && this.root.push(new ce("w:noSpaceRaiseLower", t.noSpaceRaiseLower)), t.doNotUseHTMLParagraphAutoSpacing && this.root.push(new ce("w:doNotUseHTMLParagraphAutoSpacing", t.doNotUseHTMLParagraphAutoSpacing)), t.layoutRawTableWidth && this.root.push(new ce("w:layoutRawTableWidth", t.layoutRawTableWidth)), t.layoutTableRowsApart && this.root.push(new ce("w:layoutTableRowsApart", t.layoutTableRowsApart)), t.useWord97LineBreakRules && this.root.push(new ce("w:useWord97LineBreakRules", t.useWord97LineBreakRules)), t.doNotBreakWrappedTables && this.root.push(new ce("w:doNotBreakWrappedTables", t.doNotBreakWrappedTables)), t.doNotSnapToGridInCell && this.root.push(new ce("w:doNotSnapToGridInCell", t.doNotSnapToGridInCell)), t.selectFieldWithFirstOrLastCharacter && this.root.push(new ce("w:selectFldWithFirstOrLastChar", t.selectFieldWithFirstOrLastCharacter)), t.applyBreakingRules && this.root.push(new ce("w:applyBreakingRules", t.applyBreakingRules)), t.doNotWrapTextWithPunctuation && this.root.push(new ce("w:doNotWrapTextWithPunct", t.doNotWrapTextWithPunctuation)), t.doNotUseEastAsianBreakRules && this.root.push(new ce("w:doNotUseEastAsianBreakRules", t.doNotUseEastAsianBreakRules)), t.useWord2002TableStyleRules && this.root.push(new ce("w:useWord2002TableStyleRules", t.useWord2002TableStyleRules)), t.growAutofit && this.root.push(new ce("w:growAutofit", t.growAutofit)), t.useFELayout && this.root.push(new ce("w:useFELayout", t.useFELayout)), t.useNormalStyleForList && this.root.push(new ce("w:useNormalStyleForList", t.useNormalStyleForList)), t.doNotUseIndentAsNumberingTabStop && this.root.push(new ce("w:doNotUseIndentAsNumberingTabStop", t.doNotUseIndentAsNumberingTabStop)), t.useAlternateEastAsianLineBreakRules && this.root.push(new ce("w:useAltKinsokuLineBreakRules", t.useAlternateEastAsianLineBreakRules)), t.allowSpaceOfSameStyleInTable && this.root.push(new ce("w:allowSpaceOfSameStyleInTable", t.allowSpaceOfSameStyleInTable)), t.doNotSuppressIndentation && this.root.push(new ce("w:doNotSuppressIndentation", t.doNotSuppressIndentation)), t.doNotAutofitConstrainedTables && this.root.push(new ce("w:doNotAutofitConstrainedTables", t.doNotAutofitConstrainedTables)), t.autofitToFirstFixedWidthCell && this.root.push(new ce("w:autofitToFirstFixedWidthCell", t.autofitToFirstFixedWidthCell)), t.underlineTabInNumberingList && this.root.push(new ce("w:underlineTabInNumList", t.underlineTabInNumberingList)), t.displayHangulFixedWidth && this.root.push(new ce("w:displayHangulFixedWidth", t.displayHangulFixedWidth)), t.splitPgBreakAndParaMark && this.root.push(new ce("w:splitPgBreakAndParaMark", t.splitPgBreakAndParaMark)), t.doNotVerticallyAlignCellWithSp && this.root.push(new ce("w:doNotVertAlignCellWithSp", t.doNotVerticallyAlignCellWithSp)), t.doNotBreakConstrainedForcedTable && this.root.push(new ce("w:doNotBreakConstrainedForcedTable", t.doNotBreakConstrainedForcedTable)), t.ignoreVerticalAlignmentInTextboxes && this.root.push(new ce("w:doNotVertAlignInTxbx", t.ignoreVerticalAlignmentInTextboxes)), t.useAnsiKerningPairs && this.root.push(new ce("w:useAnsiKerningPairs", t.useAnsiKerningPairs)), t.cachedColumnBalance && this.root.push(new ce("w:cachedColBalance", t.cachedColumnBalance)), t.version && this.root.push(ece(t.version));
  }
}, XN = 1e5, ZN = 15, Ace = [
  57840,
  7439,
  52380,
  33984,
  4364,
  3600,
  61902,
  12606,
  6258,
  57657,
  54287,
  34041,
  10252,
  43370,
  20163
], nce = [
  [
    44796,
    19929,
    39858,
    10053,
    20106,
    40212,
    10761
  ],
  [
    31585,
    63170,
    64933,
    60267,
    50935,
    40399,
    11199
  ],
  [
    17763,
    35526,
    1453,
    2906,
    5812,
    11624,
    23248
  ],
  [
    885,
    1770,
    3540,
    7080,
    14160,
    28320,
    56640
  ],
  [
    55369,
    41139,
    20807,
    41614,
    21821,
    43642,
    17621
  ],
  [
    28485,
    56970,
    44341,
    19019,
    38038,
    14605,
    29210
  ],
  [
    60195,
    50791,
    40175,
    10751,
    21502,
    43004,
    24537
  ],
  [
    18387,
    36774,
    3949,
    7898,
    15796,
    31592,
    63184
  ],
  [
    47201,
    24803,
    49606,
    37805,
    14203,
    28406,
    56812
  ],
  [
    17824,
    35648,
    1697,
    3394,
    6788,
    13576,
    27152
  ],
  [
    43601,
    17539,
    35078,
    557,
    1114,
    2228,
    4456
  ],
  [
    30388,
    60776,
    51953,
    34243,
    7079,
    14158,
    28316
  ],
  [
    14128,
    28256,
    56512,
    43425,
    17251,
    34502,
    7597
  ],
  [
    13105,
    26210,
    52420,
    35241,
    883,
    1766,
    3532
  ],
  [
    4129,
    8258,
    16516,
    33032,
    4657,
    9314,
    18628
  ]
], qN = (t) => t >> 14 & 1 | t << 1 & 32767, sce = (t) => {
  const e = t.slice(0, ZN).split("").map((s) => {
    const r = s.charCodeAt(0);
    return (r & 255) !== 0 ? r & 255 : r >> 8 & 255;
  }), A = e.reduce((s, r, i) => nce[ZN - e.length + i].reduce((o, a, c) => r >> c & 1 ? o ^ a : o, s), Ace[e.length - 1]), n = (qN(e.reduceRight((s, r) => qN(s) ^ r, 0)) ^ e.length ^ 52811) & 65535;
  return [
    n & 255,
    n >> 8,
    A & 255,
    A >> 8
  ].map((s) => s.toString(16).toUpperCase().padStart(2, "0")).join("");
}, rce = (t, e, A) => {
  const n = [...sce(t)].flatMap((o) => [o.charCodeAt(0), 0]);
  let s = yN(Uint8Array.from([...e, ...n]));
  const r = new Uint8Array(s.length + 4), i = new DataView(r.buffer);
  for (let o = 0; o < A; o++)
    r.set(s), i.setUint32(s.length, o, !0), s = yN(r);
  return Array.from(s);
}, ice = (t) => {
  var e;
  const A = new Uint8Array(t);
  return typeof ((e = globalThis.crypto) === null || e === void 0 ? void 0 : e.getRandomValues) == "function" ? (globalThis.crypto.getRandomValues(A), [...A]) : [...A].map(() => Math.floor(Math.random() * 256));
}, _N = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      edit: "w:edit",
      enforcement: "w:enforcement",
      cryptProviderType: "w:cryptProviderType",
      cryptAlgorithmClass: "w:cryptAlgorithmClass",
      cryptAlgorithmType: "w:cryptAlgorithmType",
      cryptAlgorithmSid: "w:cryptAlgorithmSid",
      cryptSpinCount: "w:cryptSpinCount",
      hash: "w:hash",
      salt: "w:salt"
    });
  }
}, $N = (t) => btoa(String.fromCharCode(...t)), oce = class extends Z {
  constructor({ type: t, password: e }) {
    if (super("w:documentProtection"), e === void 0 || e === "") {
      this.root.push(new _N({
        edit: t,
        enforcement: !0
      }));
      return;
    }
    const A = ice(16);
    this.root.push(new _N({
      edit: t,
      enforcement: !0,
      cryptProviderType: "rsaAES",
      cryptAlgorithmClass: "hash",
      cryptAlgorithmType: "typeAny",
      cryptAlgorithmSid: 12,
      cryptSpinCount: XN,
      hash: $N(rce(e, A, XN)),
      salt: $N(A)
    }));
  }
}, ace = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      wpc: "xmlns:wpc",
      mc: "xmlns:mc",
      o: "xmlns:o",
      r: "xmlns:r",
      m: "xmlns:m",
      v: "xmlns:v",
      wp14: "xmlns:wp14",
      wp: "xmlns:wp",
      w10: "xmlns:w10",
      w: "xmlns:w",
      w14: "xmlns:w14",
      w15: "xmlns:w15",
      wpg: "xmlns:wpg",
      wpi: "xmlns:wpi",
      wne: "xmlns:wne",
      wps: "xmlns:wps",
      Ignorable: "mc:Ignorable"
    });
  }
}, cce = class extends Z {
  constructor(t) {
    var e, A, n, s, r, i, o, a, c;
    super("w:settings"), this.root.push(new ace({
      wpc: "http://schemas.microsoft.com/office/word/2010/wordprocessingCanvas",
      mc: "http://schemas.openxmlformats.org/markup-compatibility/2006",
      o: "urn:schemas-microsoft-com:office:office",
      r: "http://schemas.openxmlformats.org/officeDocument/2006/relationships",
      m: "http://schemas.openxmlformats.org/officeDocument/2006/math",
      v: "urn:schemas-microsoft-com:vml",
      wp14: "http://schemas.microsoft.com/office/word/2010/wordprocessingDrawing",
      wp: "http://schemas.openxmlformats.org/drawingml/2006/wordprocessingDrawing",
      w10: "urn:schemas-microsoft-com:office:word",
      w: "http://schemas.openxmlformats.org/wordprocessingml/2006/main",
      w14: "http://schemas.microsoft.com/office/word/2010/wordml",
      w15: "http://schemas.microsoft.com/office/word/2012/wordml",
      wpg: "http://schemas.microsoft.com/office/word/2010/wordprocessingGroup",
      wpi: "http://schemas.microsoft.com/office/word/2010/wordprocessingInk",
      wne: "http://schemas.microsoft.com/office/word/2006/wordml",
      wps: "http://schemas.microsoft.com/office/word/2010/wordprocessingShape",
      Ignorable: "w14 w15 wp14"
    })), this.root.push(new ce("w:displayBackgroundShape", !0)), t.embedFonts !== void 0 && this.root.push(new ce("w:embedTrueTypeFonts", t.embedFonts)), t.trackRevisions !== void 0 && this.root.push(new ce("w:trackRevisions", t.trackRevisions)), t.protection !== void 0 && this.root.push(new oce(t.protection)), this.root.push(new rg("w:defaultTabStop", (e = t.defaultTabStop) !== null && e !== void 0 ? e : 720)), ((A = t.hyphenation) === null || A === void 0 ? void 0 : A.autoHyphenation) !== void 0 && this.root.push(new ce("w:autoHyphenation", t.hyphenation.autoHyphenation)), ((n = t.hyphenation) === null || n === void 0 ? void 0 : n.consecutiveHyphenLimit) !== void 0 && this.root.push(new rg("w:consecutiveHyphenLimit", t.hyphenation.consecutiveHyphenLimit)), ((s = t.hyphenation) === null || s === void 0 ? void 0 : s.hyphenationZone) !== void 0 && this.root.push(new rg("w:hyphenationZone", t.hyphenation.hyphenationZone)), ((r = t.hyphenation) === null || r === void 0 ? void 0 : r.doNotHyphenateCaps) !== void 0 && this.root.push(new ce("w:doNotHyphenateCaps", t.hyphenation.doNotHyphenateCaps)), t.evenAndOddHeaders !== void 0 && this.root.push(new ce("w:evenAndOddHeaders", t.evenAndOddHeaders)), t.updateFields !== void 0 && this.root.push(new ce("w:updateFields", t.updateFields)), this.root.push(new tce(oe(oe({}, (i = t.compatibility) !== null && i !== void 0 ? i : {}), {}, { version: (o = (a = (c = t.compatibility) === null || c === void 0 ? void 0 : c.version) !== null && a !== void 0 ? a : t.compatibilityModeVersion) !== null && o !== void 0 ? o : 15 })));
  }
}, lH = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", { val: "w:val" });
  }
}, lce = class extends Z {
  constructor(t) {
    super("w:name"), this.root.push(new lH({ val: t }));
  }
}, Bce = class extends Z {
  constructor(t) {
    super("w:uiPriority"), this.root.push(new lH({ val: hA(t) }));
  }
}, gce = class extends Le {
  constructor(...t) {
    super(...t), T(this, "xmlKeys", {
      type: "w:type",
      styleId: "w:styleId",
      default: "w:default",
      customStyle: "w:customStyle"
    });
  }
}, Vm = class extends Z {
  constructor(t, e) {
    super("w:style"), this.root.push(new gce(t)), e.name && this.root.push(new lce(e.name)), e.basedOn && e.basedOn !== t.styleId && this.root.push(new Oo("w:basedOn", e.basedOn)), e.next && this.root.push(new Oo("w:next", e.next)), e.link && this.root.push(new Oo("w:link", e.link)), e.uiPriority !== void 0 && this.root.push(new Bce(e.uiPriority)), e.semiHidden !== void 0 && this.root.push(new ce("w:semiHidden", e.semiHidden)), e.unhideWhenUsed !== void 0 && this.root.push(new ce("w:unhideWhenUsed", e.unhideWhenUsed)), e.quickFormat !== void 0 && this.root.push(new ce("w:qFormat", e.quickFormat));
  }
}, io = class extends Vm {
  constructor(t) {
    super({
      type: "paragraph",
      styleId: t.id
    }, t), T(this, "paragraphProperties", void 0), T(this, "runProperties", void 0), this.paragraphProperties = new jl(t.paragraph, {
      implicitListParagraphStyle: !1,
      inListOrder: !1
    }), this.runProperties = new la(t.run), this.root.push(this.paragraphProperties), this.root.push(this.runProperties);
  }
}, uc = class extends Vm {
  constructor(t) {
    super({
      type: "character",
      styleId: t.id
    }, oe({
      uiPriority: 99,
      unhideWhenUsed: !0
    }, t)), T(this, "runProperties", void 0), this.runProperties = new la(t.run), this.root.push(this.runProperties);
  }
}, Ba = class extends io {
  constructor(t) {
    super(oe({
      basedOn: "Normal",
      next: "Normal",
      quickFormat: !0
    }, t));
  }
}, hce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Title",
      name: "Title"
    }, t));
  }
}, uce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Heading1",
      name: "Heading 1"
    }, t));
  }
}, dce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Heading2",
      name: "Heading 2"
    }, t));
  }
}, wce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Heading3",
      name: "Heading 3"
    }, t));
  }
}, fce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Heading4",
      name: "Heading 4"
    }, t));
  }
}, Qce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Heading5",
      name: "Heading 5"
    }, t));
  }
}, Ice = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Heading6",
      name: "Heading 6"
    }, t));
  }
}, Cce = class extends Ba {
  constructor(t) {
    super(oe({
      id: "Strong",
      name: "Strong"
    }, t));
  }
}, Ece = class extends io {
  constructor(t) {
    super(oe({
      id: "ListParagraph",
      name: "List Paragraph",
      basedOn: "Normal",
      quickFormat: !0
    }, t));
  }
}, Mce = class extends io {
  constructor(t) {
    super(oe({
      id: "Caption",
      name: "caption",
      basedOn: "Normal",
      next: "Normal",
      uiPriority: 35,
      semiHidden: !0,
      unhideWhenUsed: !0,
      quickFormat: !0,
      paragraph: { spacing: { after: 200 } },
      run: {
        italics: !0,
        color: { theme: "dark2" },
        size: 18
      }
    }, t));
  }
}, pce = class extends io {
  constructor(t) {
    super(oe({
      id: "Bibliography",
      name: "Bibliography",
      basedOn: "Normal",
      next: "Normal",
      uiPriority: 37,
      unhideWhenUsed: !0
    }, t));
  }
}, BH = /* @__PURE__ */ new WeakSet(), eD = (t) => BH.has(t), di = class extends io {
  /**
  * @param level - The level of the entries, 1 to 9
  * @param levelIndent - How much more each level is indented than the level above, in twips
  */
  constructor(t, e) {
    super({
      id: `TOC${t}`,
      name: `toc ${t}`,
      basedOn: "Normal",
      next: "Normal",
      uiPriority: 39,
      semiHidden: !0,
      unhideWhenUsed: !0,
      paragraph: oe({ spacing: { after: 100 } }, t > 1 ? { indent: { left: (t - 1) * e } } : {})
    });
  }
  prepForXml(t) {
    const e = super.prepForXml(t);
    return BH.add(e), e;
  }
}, mce = class extends io {
  constructor(t) {
    super(oe({
      id: "FootnoteText",
      name: "footnote text",
      link: "FootnoteTextChar",
      basedOn: "Normal",
      uiPriority: 99,
      semiHidden: !0,
      unhideWhenUsed: !0,
      paragraph: { spacing: {
        after: 0,
        line: 240,
        lineRule: vl.AUTO
      } },
      run: { size: 20 }
    }, t));
  }
}, Yce = class extends uc {
  constructor(t) {
    super(oe({
      id: "FootnoteReference",
      name: "footnote reference",
      basedOn: "DefaultParagraphFont",
      semiHidden: !0,
      run: { superScript: !0 }
    }, t));
  }
}, yce = class extends uc {
  constructor(t) {
    super(oe({
      id: "FootnoteTextChar",
      name: "Footnote Text Char",
      basedOn: "DefaultParagraphFont",
      link: "FootnoteText",
      semiHidden: !0,
      run: { size: 20 }
    }, t));
  }
}, Fce = class extends io {
  constructor(t) {
    super(oe({
      id: "EndnoteText",
      name: "endnote text",
      link: "EndnoteTextChar",
      basedOn: "Normal",
      uiPriority: 99,
      semiHidden: !0,
      unhideWhenUsed: !0,
      paragraph: { spacing: {
        after: 0,
        line: 240,
        lineRule: vl.AUTO
      } },
      run: { size: 20 }
    }, t));
  }
}, Nce = class extends uc {
  constructor(t) {
    super(oe({
      id: "EndnoteReference",
      name: "endnote reference",
      basedOn: "DefaultParagraphFont",
      semiHidden: !0,
      run: { superScript: !0 }
    }, t));
  }
}, Dce = class extends uc {
  constructor(t) {
    super(oe({
      id: "EndnoteTextChar",
      name: "Endnote Text Char",
      basedOn: "DefaultParagraphFont",
      link: "EndnoteText",
      semiHidden: !0,
      run: { size: 20 }
    }, t));
  }
}, xce = class extends uc {
  constructor(t) {
    super(oe({
      id: "Hyperlink",
      name: "Hyperlink",
      basedOn: "DefaultParagraphFont",
      run: {
        color: "0563C1",
        underline: { type: df.SINGLE }
      }
    }, t));
  }
}, Gce = class extends uc {
  constructor(t) {
    super(oe({
      id: "LineNumber",
      name: "line number",
      basedOn: "DefaultParagraphFont",
      semiHidden: !0
    }, t));
  }
}, zce = class extends Vm {
  constructor() {
    super({
      type: "table",
      styleId: "TableNormal",
      default: !0
    }, {
      name: "Normal Table",
      uiPriority: 99,
      semiHidden: !0,
      unhideWhenUsed: !0
    }), this.root.push(new Pm({
      indent: {
        size: 0,
        type: zs.DXA
      },
      cellMargin: {
        top: 0,
        left: 108,
        bottom: 0,
        right: 108
      }
    }));
  }
}, og = (t) => typeof t == "object" ? Object.keys(t)[0] : void 0, Xm = (t) => {
  var e;
  return (e = [t["w:style"]].flat().find((A) => A._attr)) === null || e === void 0 ? void 0 : e._attr;
}, tD = (t) => {
  var e;
  return (e = Xm(t)) === null || e === void 0 ? void 0 : e["w:styleId"];
}, AD = (t) => {
  var e;
  const A = (e = [t["w:style"]].flat().find((n) => og(n) === "w:name")) === null || e === void 0 || (e = e["w:name"]) === null || e === void 0 || (e = e._attr) === null || e === void 0 ? void 0 : e["w:val"];
  return A === void 0 ? void 0 : String(A).toLowerCase();
}, VE = (t) => {
  var e, A;
  return og(t) === "w:style" && ((e = (A = Xm(t)) === null || A === void 0 ? void 0 : A["w:type"]) !== null && e !== void 0 ? e : "paragraph") === "paragraph";
}, Uce = (t) => {
  const e = VE(t) ? Xm(t) : void 0;
  return (e == null ? void 0 : e["w:default"]) !== void 0 && ![
    "0",
    "false",
    "off"
  ].includes(String(e["w:default"]));
}, bce = (t) => ({ "w:style": [t["w:style"]].flat().map((e) => e._attr ? { _attr: oe(oe({}, e._attr), {}, { "w:default": "1" }) } : e) }), RI = class extends Z {
  constructor(t) {
    if (super("w:styles"), t.initialStyles && this.root.push(t.initialStyles), t.importedStyles) for (const e of t.importedStyles) this.root.push(e);
    if (t.paragraphStyles) for (const e of t.paragraphStyles) this.root.push(new io(e));
    if (t.characterStyles) for (const e of t.characterStyles) this.root.push(new uc(e));
  }
  /**
  * Writes the styles in the schema's order: the document defaults, the latent styles, then the styles. A style id
  * can only be used once, so a style replaces an earlier one with its id. That way external styles replace docx's
  * default styles, and paragraph and character styles replace the default and imported ones. docx's TOC 1 to TOC 9
  * styles are also replaced by a paragraph style with their name, such as a template's in another language, with an id
  * of its own. Of several document defaults, or several latent styles, the last is kept. Normal is marked as the
  * default paragraph style when no style is.
  */
  prepForXml(t) {
    const e = super.prepForXml(t), A = e["w:styles"];
    if (!Array.isArray(A)) return e;
    const n = (c) => A.filter((l) => og(l) === c), s = A.map((c) => og(c) === "w:style" ? tD(c) : void 0), r = A.filter((c, l) => ![
      "_attr",
      "w:docDefaults",
      "w:latentStyles"
    ].includes(og(c)) && (s[l] === void 0 || s.lastIndexOf(s[l]) === l)), i = new Set(r.filter((c) => VE(c) && !eD(c)).map(AD)), o = r.filter((c) => !eD(c) || !i.has(AD(c))), a = o.some(Uce) ? o : o.map((c) => VE(c) && tD(c) === "Normal" ? bce(c) : c);
    return { "w:styles": [
      ...n("_attr"),
      ...n("w:docDefaults").slice(-1),
      ...n("w:latentStyles").slice(-1),
      ...a
    ] };
  }
}, vce = class extends Z {
  constructor(t) {
    super("w:pPrDefault"), this.root.push(new jl(t, {
      implicitListParagraphStyle: !1,
      inListOrder: !1
    }));
  }
}, jce = class extends Z {
  constructor(t) {
    super("w:rPrDefault"), this.root.push(new la(t));
  }
}, Hce = class extends Z {
  constructor(t) {
    super("w:docDefaults"), T(this, "runPropertiesDefaults", void 0), T(this, "paragraphPropertiesDefaults", void 0), this.runPropertiesDefaults = new jce(t.run), this.paragraphPropertiesDefaults = new vce(t.paragraph), this.root.push(this.runPropertiesDefaults), this.root.push(this.paragraphPropertiesDefaults);
  }
}, kce = class {
  /**
  * Creates new Styles based on the given XML data.
  *
  * Parses the styles XML and converts them to XmlComponent instances.
  *
  * Example content from styles.xml:
  * ```xml
  * <?xml version="1.0"?>
  * <w:styles xmlns:mc="some schema" ...>
  *   <w:style w:type="paragraph" w:styleId="Heading1">
  *     <w:name w:val="heading 1"/>
  *     ...
  *   </w:style>
  *   <w:style w:type="paragraph" w:styleId="Heading2">
  *     <w:name w:val="heading 2"/>
  *     ...
  *   </w:style>
  *   <w:docDefaults>...</w:docDefaults>
  * </w:styles>
  * ```
  *
  * @param xmlData - XML string containing styles data from styles.xml
  * @returns Styles object containing all parsed styles
  * @throws Error if styles element cannot be found in the XML
  */
  newInstance(t) {
    const e = Lv(t);
    let A;
    for (const s of e.elements || []) s.name === "w:styles" && (A = s);
    if (A === void 0) throw new Error("can not find styles element");
    const n = A.elements || [];
    return {
      initialStyles: new VAe(A.attributes),
      importedStyles: n.map((s) => Um(s))
    };
  }
}, Rce = (t) => {
  var e;
  const A = (e = t.document) === null || e === void 0 || (e = e.run) === null || e === void 0 ? void 0 : e.size;
  return A === void 0 ? 200 : Math.round(typeof A == "number" ? A * 10 : xo(A));
}, Lce = (t) => ({
  tableOfContents1: new di(1, t),
  tableOfContents2: new di(2, t),
  tableOfContents3: new di(3, t),
  tableOfContents4: new di(4, t),
  tableOfContents5: new di(5, t),
  tableOfContents6: new di(6, t),
  tableOfContents7: new di(7, t),
  tableOfContents8: new di(8, t),
  tableOfContents9: new di(9, t)
}), gH = (t = {}) => {
  var e;
  return oe(oe({
    normal: new io({
      id: "Normal",
      name: "Normal",
      quickFormat: !0
    }),
    normalTable: new zce(),
    document: new Hce((e = t.document) !== null && e !== void 0 ? e : {}),
    title: new hce(oe({ run: { size: 56 } }, t.title)),
    heading1: new uce(oe({ run: {
      color: "2E74B5",
      size: 32
    } }, t.heading1)),
    heading2: new dce(oe({ run: {
      color: "2E74B5",
      size: 26
    } }, t.heading2)),
    heading3: new wce(oe({ run: {
      color: "1F4D78",
      size: 24
    } }, t.heading3)),
    heading4: new fce(oe({ run: {
      color: "2E74B5",
      italics: !0
    } }, t.heading4)),
    heading5: new Qce(oe({ run: { color: "2E74B5" } }, t.heading5)),
    heading6: new Ice(oe({ run: { color: "1F4D78" } }, t.heading6)),
    strong: new Cce(oe({ run: { bold: !0 } }, t.strong)),
    listParagraph: new Ece(t.listParagraph || {}),
    caption: new Mce(t.caption || {}),
    bibliography: new pce(t.bibliography || {})
  }, Lce(Rce(t))), {}, {
    hyperlink: new xce(t.hyperlink || {}),
    footnoteReference: new Yce(t.footnoteReference || {}),
    footnoteText: new mce(t.footnoteText || {}),
    footnoteTextChar: new yce(t.footnoteTextChar || {}),
    endnoteReference: new Nce(t.endnoteReference || {}),
    endnoteText: new Fce(t.endnoteText || {}),
    endnoteTextChar: new Dce(t.endnoteTextChar || {}),
    lineNumber: new Gce(t.lineNumber || {})
  });
}, nD = class {
  newInstance(t = {}) {
    return {
      initialStyles: new If([
        "mc",
        "r",
        "w",
        "w14",
        "w15"
      ], "w14 w15"),
      importedStyles: Object.values(gH(t))
    };
  }
}, hH = {
  headings: {
    latin: "Calibri Light",
    panose: "020F0302020204030204"
  },
  body: {
    latin: "Calibri",
    panose: "020F0502020204030204"
  }
}, Sce = [
  [
    "Jpan",
    "游ゴシック Light",
    "游明朝"
  ],
  ["Hang", "맑은 고딕"],
  [
    "Hans",
    "等线 Light",
    "等线"
  ],
  ["Hant", "新細明體"],
  [
    "Arab",
    "Times New Roman",
    "Arial"
  ],
  [
    "Hebr",
    "Times New Roman",
    "Arial"
  ],
  [
    "Thai",
    "Angsana New",
    "Cordia New"
  ],
  ["Ethi", "Nyala"],
  ["Beng", "Vrinda"],
  ["Gujr", "Shruti"],
  [
    "Khmr",
    "MoolBoran",
    "DaunPenh"
  ],
  ["Knda", "Tunga"],
  ["Guru", "Raavi"],
  ["Cans", "Euphemia"],
  ["Cher", "Plantagenet Cherokee"],
  ["Yiii", "Microsoft Yi Baiti"],
  ["Tibt", "Microsoft Himalaya"],
  ["Thaa", "MV Boli"],
  ["Deva", "Mangal"],
  ["Telu", "Gautami"],
  ["Taml", "Latha"],
  ["Syrc", "Estrangelo Edessa"],
  ["Orya", "Kalinga"],
  ["Mlym", "Kartika"],
  ["Laoo", "DokChampa"],
  ["Sinh", "Iskoola Pota"],
  ["Mong", "Mongolian Baiti"],
  [
    "Viet",
    "Times New Roman",
    "Arial"
  ],
  ["Uigh", "Microsoft Uighur"],
  ["Geor", "Sylfaen"],
  ["Armn", "Arial"],
  ["Bugi", "Leelawadee UI"],
  ["Bopo", "Microsoft JhengHei"],
  ["Java", "Javanese Text"],
  ["Lisu", "Segoe UI"],
  ["Mymr", "Myanmar Text"],
  ["Nkoo", "Ebrima"],
  ["Olck", "Nirmala UI"],
  ["Osma", "Ebrima"],
  ["Phag", "Phagspa"],
  ["Syrn", "Estrangelo Edessa"],
  ["Syrj", "Estrangelo Edessa"],
  ["Syre", "Estrangelo Edessa"],
  ["Sora", "Nirmala UI"],
  ["Tale", "Microsoft Tai Le"],
  ["Talu", "Microsoft New Tai Lue"],
  ["Tfng", "Ebrima"]
], LI = (t, e, A) => new K({
  name: t,
  attributes: {
    typeface: {
      key: "typeface",
      value: e
    },
    panose: {
      key: "panose",
      value: A
    }
  }
}), Tce = (t, e) => {
  const A = e[t], n = typeof A == "string" ? A : A == null ? void 0 : A.latin;
  return n ?? hH[t].latin;
}, Jce = (t, e = {}) => {
  const A = Sce.map(([s, r, i = r]) => {
    var o;
    return [s, (o = e[s]) !== null && o !== void 0 ? o : t === "headings" ? r : i];
  }), n = new Set(A.map(([s]) => s));
  return [...A, ...Object.entries(e).filter(([s]) => !n.has(s))];
}, sD = (t, e) => {
  const A = e[t], { eastAsia: n = "", complexScript: s = "", scripts: r } = typeof A == "object" ? A : {}, i = Tce(t, e), o = hH[t];
  return new K({
    name: t === "headings" ? "a:majorFont" : "a:minorFont",
    children: [
      LI("a:latin", i, i === o.latin ? o.panose : void 0),
      LI("a:ea", n),
      LI("a:cs", s),
      ...Jce(t, r).map(([a, c]) => new K({
        name: "a:font",
        attributes: {
          script: {
            key: "script",
            value: a
          },
          typeface: {
            key: "typeface",
            value: c
          }
        }
      }))
    ]
  });
}, Wce = (t, e = {}) => new K({
  name: "a:fontScheme",
  attributes: { name: {
    key: "name",
    value: t
  } },
  children: [sD("headings", e), sD("body", e)]
}), uH = (t = []) => new K({
  name: "a:schemeClr",
  attributes: { value: {
    key: "val",
    value: "phClr"
  } },
  children: t.map(([e, A]) => new K({
    name: `a:${e}`,
    attributes: { value: {
      key: "val",
      value: A
    } }
  }))
}), fu = (t) => new K({
  name: "a:solidFill",
  children: [uH(t)]
}), SI = (t) => new K({
  name: "a:gradFill",
  attributes: { rotateWithShape: {
    key: "rotWithShape",
    value: !0
  } },
  children: [new K({
    name: "a:gsLst",
    children: t.map((e, A) => new K({
      name: "a:gs",
      attributes: { position: {
        key: "pos",
        value: A * 5e4
      } },
      children: [uH(e)]
    }))
  }), new K({
    name: "a:lin",
    attributes: {
      angle: {
        key: "ang",
        value: 54e5
      },
      scaled: {
        key: "scaled",
        value: !1
      }
    }
  })]
}), TI = (t) => new K({
  name: "a:ln",
  attributes: {
    width: {
      key: "w",
      value: t
    },
    cap: {
      key: "cap",
      value: "flat"
    },
    compound: {
      key: "cmpd",
      value: "sng"
    },
    alignment: {
      key: "algn",
      value: "ctr"
    }
  },
  children: [
    fu(),
    new K({
      name: "a:prstDash",
      attributes: { value: {
        key: "val",
        value: "solid"
      } }
    }),
    new K({
      name: "a:miter",
      attributes: { limit: {
        key: "lim",
        value: 8e5
      } }
    })
  ]
}), JI = (t) => new K({
  name: "a:effectStyle",
  children: [new K({
    name: "a:effectLst",
    children: t
  })]
}), Oce = () => new K({
  name: "a:outerShdw",
  attributes: {
    blurRadius: {
      key: "blurRad",
      value: 57150
    },
    distance: {
      key: "dist",
      value: 19050
    },
    direction: {
      key: "dir",
      value: 54e5
    },
    alignment: {
      key: "algn",
      value: "ctr"
    },
    rotateWithShape: {
      key: "rotWithShape",
      value: !1
    }
  },
  children: [new K({
    name: "a:srgbClr",
    attributes: { value: {
      key: "val",
      value: "000000"
    } },
    children: [new K({
      name: "a:alpha",
      attributes: { value: {
        key: "val",
        value: 63e3
      } }
    })]
  })]
}), Pce = () => new K({
  name: "a:fmtScheme",
  attributes: { name: {
    key: "name",
    value: "Office"
  } },
  children: [
    new K({
      name: "a:fillStyleLst",
      children: [
        fu(),
        SI([
          [
            ["lumMod", 11e4],
            ["satMod", 105e3],
            ["tint", 67e3]
          ],
          [
            ["lumMod", 105e3],
            ["satMod", 103e3],
            ["tint", 73e3]
          ],
          [
            ["lumMod", 105e3],
            ["satMod", 109e3],
            ["tint", 81e3]
          ]
        ]),
        SI([
          [
            ["satMod", 103e3],
            ["lumMod", 102e3],
            ["tint", 94e3]
          ],
          [
            ["satMod", 11e4],
            ["lumMod", 1e5],
            ["shade", 1e5]
          ],
          [
            ["lumMod", 99e3],
            ["satMod", 12e4],
            ["shade", 78e3]
          ]
        ])
      ]
    }),
    new K({
      name: "a:lnStyleLst",
      children: [
        TI(6350),
        TI(12700),
        TI(19050)
      ]
    }),
    new K({
      name: "a:effectStyleLst",
      children: [
        JI([]),
        JI([]),
        JI([Oce()])
      ]
    }),
    new K({
      name: "a:bgFillStyleLst",
      children: [
        fu(),
        fu([["tint", 95e3], ["satMod", 17e4]]),
        SI([
          [
            ["tint", 93e3],
            ["satMod", 15e4],
            ["shade", 98e3],
            ["lumMod", 102e3]
          ],
          [
            ["tint", 98e3],
            ["satMod", 13e4],
            ["shade", 9e4],
            ["lumMod", 103e3]
          ],
          [["shade", 63e3], ["satMod", 12e4]]
        ])
      ]
    })
  ]
}), Kce = class extends Z {
  constructor({ name: t = "Office Theme", colors: e, fonts: A } = {}) {
    super("a:theme"), T(this, "colors", void 0), this.colors = $v(e), this.root.push(new Gm({
      namespace: {
        key: "xmlns:a",
        value: "http://schemas.openxmlformats.org/drawingml/2006/main"
      },
      name: {
        key: "name",
        value: t
      }
    })), this.root.push(new K({
      name: "a:themeElements",
      children: [
        nne(e ? t : "Office", e),
        Wce(A ? t : "Office", A),
        Pce()
      ]
    })), this.root.push(new K({ name: "a:objectDefaults" })), this.root.push(new K({ name: "a:extraClrSchemeLst" }));
  }
  /**
  * The hex color of each of the theme's colors. The system's window text and window colors are black and white.
  */
  get Colors() {
    return this.colors;
  }
}, zn = Uint8Array, hs = Uint16Array, Zm = Int32Array, qm = new zn([
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  0,
  1,
  1,
  1,
  1,
  2,
  2,
  2,
  2,
  3,
  3,
  3,
  3,
  4,
  4,
  4,
  4,
  5,
  5,
  5,
  5,
  0,
  0,
  0,
  0
]), _m = new zn([
  0,
  0,
  0,
  0,
  1,
  1,
  2,
  2,
  3,
  3,
  4,
  4,
  5,
  5,
  6,
  6,
  7,
  7,
  8,
  8,
  9,
  9,
  10,
  10,
  11,
  11,
  12,
  12,
  13,
  13,
  0,
  0
]), rD = new zn([
  16,
  17,
  18,
  0,
  8,
  7,
  9,
  6,
  10,
  5,
  11,
  4,
  12,
  3,
  13,
  2,
  14,
  1,
  15
]), dH = function(t, e) {
  for (var A = new hs(31), n = 0; n < 31; ++n) A[n] = e += 1 << t[n - 1];
  for (var s = new Zm(A[30]), n = 1; n < 30; ++n) for (var r = A[n]; r < A[n + 1]; ++r) s[r] = r - A[n] << 5 | n;
  return {
    b: A,
    r: s
  };
}, wH = dH(qm, 2), Vce = wH.b, XE = wH.r;
Vce[28] = 258, XE[258] = 28;
var Xce = dH(_m, 0), iD = Xce.r, ZE = new hs(32768);
for (var Xt = 0; Xt < 32768; ++Xt) {
  var uo = (Xt & 43690) >> 1 | (Xt & 21845) << 1;
  uo = (uo & 52428) >> 2 | (uo & 13107) << 2, uo = (uo & 61680) >> 4 | (uo & 3855) << 4, ZE[Xt] = ((uo & 65280) >> 8 | (uo & 255) << 8) >> 1;
}
var ag = (function(t, e, A) {
  for (var n = t.length, s = 0, r = new hs(e); s < n; ++s) t[s] && ++r[t[s] - 1];
  var i = new hs(e);
  for (s = 1; s < e; ++s) i[s] = i[s - 1] + r[s - 1] << 1;
  var o;
  if (A) {
    o = new hs(1 << e);
    var a = 15 - e;
    for (s = 0; s < n; ++s) if (t[s])
      for (var c = s << 4 | t[s], l = e - t[s], B = i[t[s] - 1]++ << l, g = B | (1 << l) - 1; B <= g; ++B) o[ZE[B] >> a] = c;
  } else
    for (o = new hs(n), s = 0; s < n; ++s) t[s] && (o[s] = ZE[i[t[s] - 1]++] >> 15 - t[s]);
  return o;
}), rc = new zn(288);
for (var Xt = 0; Xt < 144; ++Xt) rc[Xt] = 8;
for (var Xt = 144; Xt < 256; ++Xt) rc[Xt] = 9;
for (var Xt = 256; Xt < 280; ++Xt) rc[Xt] = 7;
for (var Xt = 280; Xt < 288; ++Xt) rc[Xt] = 8;
var _d = new zn(32);
for (var Xt = 0; Xt < 32; ++Xt) _d[Xt] = 5;
var Zce = /* @__PURE__ */ ag(rc, 9, 0), qce = /* @__PURE__ */ ag(_d, 5, 0), fH = function(t) {
  return (t + 7) / 8 | 0;
}, QH = function(t, e, A) {
  return (A == null || A > t.length) && (A = t.length), new zn(t.subarray(e, A));
}, _ce = [
  "unexpected EOF",
  "invalid block type",
  "invalid length/literal",
  "invalid distance",
  "stream finished",
  "no stream handler",
  ,
  "no callback",
  "invalid UTF-8 data",
  "extra field too long",
  "date not in range 1980-2099",
  "filename too long",
  "stream finishing",
  "invalid zip data"
], Cf = function(t, e, A) {
  var n = new Error(e || _ce[t]);
  if (n.code = t, Error.captureStackTrace && Error.captureStackTrace(n, Cf), !A) throw n;
  return n;
}, wi = function(t, e, A) {
  A <<= e & 7;
  var n = e / 8 | 0;
  t[n] |= A, t[n + 1] |= A >> 8;
}, gB = function(t, e, A) {
  A <<= e & 7;
  var n = e / 8 | 0;
  t[n] |= A, t[n + 1] |= A >> 8, t[n + 2] |= A >> 16;
}, WI = function(t, e) {
  for (var A = [], n = 0; n < t.length; ++n) t[n] && A.push({
    s: n,
    f: t[n]
  });
  var s = A.length, r = A.slice();
  if (!s) return {
    t: CH,
    l: 0
  };
  if (s == 1) {
    var i = new zn(A[0].s + 1);
    return i[A[0].s] = 1, {
      t: i,
      l: 1
    };
  }
  A.sort(function(N, m) {
    return N.f - m.f;
  }), A.push({
    s: -1,
    f: 25001
  });
  var o = A[0], a = A[1], c = 0, l = 1, B = 2;
  for (A[0] = {
    s: -1,
    f: o.f + a.f,
    l: o,
    r: a
  }; l != s - 1; )
    o = A[A[c].f < A[B].f ? c++ : B++], a = A[c != l && A[c].f < A[B].f ? c++ : B++], A[l++] = {
      s: -1,
      f: o.f + a.f,
      l: o,
      r: a
    };
  for (var g = r[0].s, n = 1; n < s; ++n) r[n].s > g && (g = r[n].s);
  var h = new hs(g + 1), u = qE(A[l - 1], h, 0);
  if (u > e) {
    var n = 0, d = 0, w = u - e, Q = 1 << w;
    for (r.sort(function(m, E) {
      return h[E.s] - h[m.s] || m.f - E.f;
    }); n < s; ++n) {
      var p = r[n].s;
      if (h[p] > e)
        d += Q - (1 << u - h[p]), h[p] = e;
      else break;
    }
    for (d >>= w; d > 0; ) {
      var M = r[n].s;
      h[M] < e ? d -= 1 << e - h[M]++ - 1 : ++n;
    }
    for (; n >= 0 && d; --n) {
      var I = r[n].s;
      h[I] == e && (--h[I], ++d);
    }
    u = e;
  }
  return {
    t: new zn(h),
    l: u
  };
}, qE = function(t, e, A) {
  return t.s == -1 ? Math.max(qE(t.l, e, A + 1), qE(t.r, e, A + 1)) : e[t.s] = A;
}, oD = function(t) {
  for (var e = t.length; e && !t[--e]; ) ;
  for (var A = new hs(++e), n = 0, s = t[0], r = 1, i = function(a) {
    A[n++] = a;
  }, o = 1; o <= e; ++o) if (t[o] == s && o != e) ++r;
  else {
    if (!s && r > 2) {
      for (; r > 138; r -= 138) i(32754);
      r > 2 && (i(r > 10 ? r - 11 << 5 | 28690 : r - 3 << 5 | 12305), r = 0);
    } else if (r > 3) {
      for (i(s), --r; r > 6; r -= 6) i(8304);
      r > 2 && (i(r - 3 << 5 | 8208), r = 0);
    }
    for (; r--; ) i(s);
    r = 1, s = t[o];
  }
  return {
    c: A.subarray(0, n),
    n: e
  };
}, hB = function(t, e) {
  for (var A = 0, n = 0; n < e.length; ++n) A += t[n] * e[n];
  return A;
}, IH = function(t, e, A) {
  var n = A.length, s = fH(e + 2);
  t[s] = n & 255, t[s + 1] = n >> 8, t[s + 2] = t[s] ^ 255, t[s + 3] = t[s + 1] ^ 255;
  for (var r = 0; r < n; ++r) t[s + r + 4] = A[r];
  return (s + 4 + n) * 8;
}, aD = function(t, e, A, n, s, r, i, o, a, c, l) {
  wi(e, l++, A), ++s[256];
  for (var B = WI(s, 15), g = B.t, h = B.l, u = WI(r, 15), d = u.t, w = u.l, Q = oD(g), p = Q.c, M = Q.n, I = oD(d), N = I.c, m = I.n, E = new hs(19), G = 0; G < p.length; ++G) ++E[p[G] & 31];
  for (var G = 0; G < N.length; ++G) ++E[N[G] & 31];
  for (var Y = WI(E, 7), U = Y.t, v = Y.l, b = 19; b > 4 && !U[rD[b - 1]]; --b) ;
  var W = c + 5 << 3, q = hB(s, rc) + hB(r, _d) + i, ne = hB(s, g) + hB(r, d) + i + 14 + 3 * b + hB(E, U) + 2 * E[16] + 3 * E[17] + 7 * E[18];
  if (a >= 0 && W <= q && W <= ne) return IH(e, l, t.subarray(a, a + c));
  var V, se, te, be;
  if (wi(e, l, 1 + (ne < q)), l += 2, ne < q) {
    V = ag(g, h, 0), se = g, te = ag(d, w, 0), be = d;
    var Oe = ag(U, v, 0);
    wi(e, l, M - 257), wi(e, l + 5, m - 1), wi(e, l + 10, b - 4), l += 14;
    for (var G = 0; G < b; ++G) wi(e, l + 3 * G, U[rD[G]]);
    l += 3 * b;
    for (var ke = [p, N], Se = 0; Se < 2; ++Se)
      for (var dt = ke[Se], G = 0; G < dt.length; ++G) {
        var st = dt[G] & 31;
        wi(e, l, Oe[st]), l += U[st], st > 15 && (wi(e, l, dt[G] >> 5 & 127), l += dt[G] >> 12);
      }
  } else V = Zce, se = rc, te = qce, be = _d;
  for (var G = 0; G < o; ++G) {
    var We = n[G];
    if (We > 255) {
      var st = We >> 18 & 31;
      gB(e, l, V[st + 257]), l += se[st + 257], st > 7 && (wi(e, l, We >> 23 & 31), l += qm[st]);
      var pt = We & 31;
      gB(e, l, te[pt]), l += be[pt], pt > 3 && (gB(e, l, We >> 5 & 8191), l += _m[pt]);
    } else gB(e, l, V[We]), l += se[We];
  }
  return gB(e, l, V[256]), l + se[256];
}, $ce = /* @__PURE__ */ new Zm([
  65540,
  131080,
  131088,
  131104,
  262176,
  1048704,
  1048832,
  2114560,
  2117632
]), CH = /* @__PURE__ */ new zn(0), ele = function(t, e, A, n, s, r) {
  var i = r.z || t.length, o = new zn(n + i + 5 * (1 + Math.ceil(i / 7e3)) + s), a = o.subarray(n, o.length - s), c = r.l, l = (r.r || 0) & 7;
  if (e) {
    l && (a[0] = r.r >> 3);
    for (var B = $ce[e - 1], g = B >> 13, h = B & 8191, u = (1 << A) - 1, d = r.p || new hs(32768), w = r.h || new hs(u + 1), Q = Math.ceil(A / 3), p = 2 * Q, M = function(L) {
      return (t[L] ^ t[L + 1] << Q ^ t[L + 2] << p) & u;
    }, I = new Zm(25e3), N = new hs(288), m = new hs(32), E = 0, G = 0, Y = r.i || 0, U = 0, v = r.w || 0, b = 0; Y + 2 < i; ++Y) {
      var W = M(Y), q = Y & 32767, ne = w[W];
      if (d[q] = ne, w[W] = q, v <= Y) {
        var V = i - Y;
        if ((E > 7e3 || U > 24576) && (V > 423 || !c)) {
          l = aD(t, a, 0, I, N, m, G, U, b, Y - b, l), U = E = G = 0, b = Y;
          for (var se = 0; se < 286; ++se) N[se] = 0;
          for (var se = 0; se < 30; ++se) m[se] = 0;
        }
        var te = 2, be = 0, Oe = h, ke = q - ne & 32767;
        if (V > 2 && W == M(Y - ke))
          for (var Se = Math.min(g, V) - 1, dt = Math.min(32767, Y), st = Math.min(258, V); ke <= dt && --Oe && q != ne; ) {
            if (t[Y + te] == t[Y + te - ke]) {
              for (var We = 0; We < st && t[Y + We] == t[Y + We - ke]; ++We) ;
              if (We > te) {
                if (te = We, be = ke, We > Se) break;
                for (var pt = Math.min(ke, We - 2), xt = 0, se = 0; se < pt; ++se) {
                  var mt = Y - ke + se & 32767, $t = mt - d[mt] & 32767;
                  $t > xt && (xt = $t, ne = mt);
                }
              }
            }
            q = ne, ne = d[q], ke += q - ne & 32767;
          }
        if (be) {
          I[U++] = 268435456 | XE[te] << 18 | iD[be];
          var Ut = XE[te] & 31, RA = iD[be] & 31;
          G += qm[Ut] + _m[RA], ++N[257 + Ut], ++m[RA], v = Y + te, ++E;
        } else
          I[U++] = t[Y], ++N[t[Y]];
      }
    }
    for (Y = Math.max(Y, v); Y < i; ++Y)
      I[U++] = t[Y], ++N[t[Y]];
    l = aD(t, a, c, I, N, m, G, U, b, Y - b, l), c || (r.r = l & 7 | a[l / 8 | 0] << 3, l -= 7, r.h = w, r.p = d, r.i = Y, r.w = v);
  } else {
    for (var Y = r.w || 0; Y < i + c; Y += 65535) {
      var H = Y + 65535;
      H >= i && (a[l / 8 | 0] = c, H = i), l = IH(a, l + 1, t.subarray(Y, H));
    }
    r.i = i;
  }
  return QH(o, 0, n + fH(l) + s);
}, tle = /* @__PURE__ */ (function() {
  for (var t = /* @__PURE__ */ new Int32Array(256), e = 0; e < 256; ++e) {
    for (var A = e, n = 9; --n; ) A = (A & 1 && -306674912) ^ A >>> 1;
    t[e] = A;
  }
  return t;
})(), Ale = function() {
  var t = -1;
  return {
    p: function(e) {
      for (var A = t, n = 0; n < e.length; ++n) A = tle[A & 255 ^ e[n]] ^ A >>> 8;
      t = A;
    },
    d: function() {
      return ~t;
    }
  };
}, nle = function(t, e, A, n, s) {
  if (!s && (s = { l: 1 }, e.dictionary)) {
    var r = e.dictionary.subarray(-32768), i = new zn(r.length + t.length);
    i.set(r), i.set(t, r.length), t = i, s.w = r.length;
  }
  return ele(t, e.level == null ? 6 : e.level, e.mem == null ? s.l ? Math.ceil(Math.max(8, Math.min(13, Math.log(t.length))) * 1.5) : 20 : 12 + e.mem, A, n, s);
}, EH = function(t, e) {
  var A = {};
  for (var n in t) A[n] = t[n];
  for (var n in e) A[n] = e[n];
  return A;
}, WA = function(t, e, A) {
  for (; A; ++e) t[e] = A, A >>>= 8;
};
function sle(t, e) {
  return nle(t, e || {}, 0, 0);
}
var MH = function(t, e, A, n) {
  for (var s in t) {
    var r = t[s], i = e + s, o = n;
    Array.isArray(r) && (o = EH(n, r[1]), r = r[0]), ArrayBuffer.isView(r) ? A[i] = [r, o] : (A[i += "/"] = [new zn(0), o], MH(r, i, A, n));
  }
}, cD = typeof TextEncoder < "u" && /* @__PURE__ */ new TextEncoder(), rle = typeof TextDecoder < "u" && /* @__PURE__ */ new TextDecoder();
try {
  rle.decode(CH, { stream: !0 });
} catch {
}
function lD(t, e) {
  var A;
  if (cD) return cD.encode(t);
  for (var n = t.length, s = new zn(t.length + (t.length >> 1)), r = 0, i = function(c) {
    s[r++] = c;
  }, A = 0; A < n; ++A) {
    if (r + 5 > s.length) {
      var o = new zn(r + 8 + (n - A << 1));
      o.set(s), s = o;
    }
    var a = t.charCodeAt(A);
    a < 128 || e ? i(a) : a < 2048 ? (i(192 | a >> 6), i(128 | a & 63)) : a > 55295 && a < 57344 ? (a = 65536 + (a & 1047552) | t.charCodeAt(++A) & 1023, i(240 | a >> 18), i(128 | a >> 12 & 63), i(128 | a >> 6 & 63), i(128 | a & 63)) : (i(224 | a >> 12), i(128 | a >> 6 & 63), i(128 | a & 63));
  }
  return QH(s, 0, r);
}
var _E = function(t) {
  var e = 0;
  if (t) for (var A in t) {
    var n = t[A].length;
    n > 65535 && Cf(9), e += n + 4;
  }
  return e;
}, BD = function(t, e, A, n, s, r, i, o) {
  var a = n.length, c = A.extra, l = o && o.length, B = _E(c);
  WA(t, e, i != null ? 33639248 : 67324752), e += 4, i != null && (t[e++] = 20, t[e++] = A.os), t[e] = 20, e += 2, t[e++] = A.flag << 1 | (r < 0 && 8), t[e++] = s && 8, t[e++] = A.compression & 255, t[e++] = A.compression >> 8;
  var g = new Date(A.mtime == null ? Date.now() : A.mtime), h = g.getFullYear() - 1980;
  if ((h < 0 || h > 119) && Cf(10), WA(t, e, h << 25 | g.getMonth() + 1 << 21 | g.getDate() << 16 | g.getHours() << 11 | g.getMinutes() << 5 | g.getSeconds() >> 1), e += 4, r != -1 && (WA(t, e, A.crc), WA(t, e + 4, r < 0 ? -r - 2 : r), WA(t, e + 8, A.size)), WA(t, e + 12, a), WA(t, e + 14, B), e += 16, i != null && (WA(t, e, l), WA(t, e + 6, A.attrs), WA(t, e + 10, i), e += 14), t.set(n, e), e += a, B) for (var u in c) {
    var d = c[u], w = d.length;
    WA(t, e, +u), WA(t, e + 2, w), t.set(d, e + 4), e += 4 + w;
  }
  return l && (t.set(o, e), e += l), e;
}, ile = function(t, e, A, n, s) {
  WA(t, e, 101010256), WA(t, e + 8, A), WA(t, e + 10, A), WA(t, e + 12, n), WA(t, e + 16, s);
};
function ole(t, e) {
  e || (e = {});
  var A = {}, n = [];
  MH(t, "", A, e);
  var s = 0, r = 0;
  for (var i in A) {
    var o = A[i], a = o[0], c = o[1], l = c.level == 0 ? 0 : 8, B = lD(i), g = B.length, h = c.comment, u = h && lD(h), d = u && u.length, w = _E(c.extra);
    g > 65535 && Cf(11);
    var Q = l ? sle(a, c) : a, p = Q.length, M = Ale();
    M.p(a), n.push(EH(c, {
      size: a.length,
      crc: M.d(),
      c: Q,
      f: B,
      m: u,
      u: g != i.length || u && h.length != d,
      o: s,
      compression: l
    })), s += 30 + g + w + p, r += 76 + 2 * (g + w) + (d || 0) + p;
  }
  for (var I = new zn(r + 22), N = s, m = r - s, E = 0; E < n.length; ++E) {
    var B = n[E];
    BD(I, B.o, B, B.f, B.u, B.c.length);
    var G = 30 + B.f.length + _E(B.extra);
    I.set(B.c, B.o + G), BD(I, s, B, B.f, B.u, B.c.length, B.o, B.m), s += 16 + G + (B.m ? B.m.length : 0);
  }
  return ile(I, s, n.length, m, N), I;
}
var ale = (t) => typeof t == "string" ? oj(t) : ArrayBuffer.isView(t) ? new Uint8Array(t.buffer, t.byteOffset, t.byteLength) : new Uint8Array(t), $E = (t) => ole(Object.fromEntries([...t].map(([e, A]) => [e, ale(A)]))), OI = (t) => {
  let e = "";
  for (let A = 0; A < t.length; A += 32768) e += String.fromCharCode(...t.subarray(A, A + 32768));
  return e;
}, Qu = (t) => /* @__PURE__ */ new Error(`${t} is not supported by this platform`), gD = {
  uint8array: (t) => t,
  arraybuffer: (t) => t.buffer.slice(t.byteOffset, t.byteOffset + t.byteLength),
  array: (t) => Array.from(t),
  string: OI,
  binarystring: OI,
  base64: (t) => btoa(OI(t)),
  blob: (t, e) => {
    if (typeof Blob > "u") throw Qu("blob");
    return new Blob([t], { type: e });
  },
  nodebuffer: (t) => {
    if (typeof Buffer > "u") throw Qu("nodebuffer");
    return Buffer.from(t.buffer, t.byteOffset, t.byteLength);
  },
  text: () => {
    throw Qu("text");
  }
}, hD = (t, e, A) => {
  const n = Object.prototype.hasOwnProperty.call(gD, e.toLowerCase()) ? gD[e.toLowerCase()] : void 0;
  if (n === void 0) throw Qu(e);
  return n(t, A);
}, cle = [
  208,
  207,
  17,
  224,
  161,
  177,
  26,
  225
], lle = class {
  constructor(t) {
    var e, A, n, s, r, i, o, a, c, l, B, g, h, u;
    if (T(this, "currentRelationshipId", 1), T(this, "documentWrapper", void 0), T(this, "headers", []), T(this, "footers", []), T(this, "coreProperties", void 0), T(this, "numbering", void 0), T(this, "media", void 0), T(this, "fileRelationships", void 0), T(this, "footnotesWrapper", void 0), T(this, "endnotesWrapper", void 0), T(this, "settings", void 0), T(this, "contentTypes", void 0), T(this, "customProperties", void 0), T(this, "appProperties", void 0), T(this, "styles", void 0), T(this, "comments", void 0), T(
      this,
      /** Extended comment data for reply threading and resolved state (word/commentsExtended.xml). */
      "commentsExtended",
      void 0
    ), T(
      this,
      /** Durable comment id mapping (word/commentsIds.xml). */
      "commentsIds",
      void 0
    ), T(this, "fontWrapper", void 0), T(this, "theme", void 0), T(this, "packageParts", void 0), T(this, "macros", void 0), T(this, "bibliography", void 0), t.macros !== void 0) {
      const { project: M, events: I = [] } = t.macros, N = M instanceof Uint8Array ? M : new Uint8Array(M);
      if (!cle.every((E, G) => N[G] === E)) throw new Error("macros.project isn't a VBA project. Use createMacros from docx/macros, or the word/vbaProject.bin in a .docm rather than the .docm itself");
      const m = new zA();
      I.length > 0 && m.addRelationship(1, "http://schemas.microsoft.com/office/2006/relationships/wordVbaData", "vbaData.xml"), this.macros = {
        project: N,
        events: I.length > 0 ? lae(I) : void 0,
        relationships: m
      };
    }
    if (this.coreProperties = new tae(oe(oe({}, t), {}, {
      creator: (e = t.creator) !== null && e !== void 0 ? e : "Un-named",
      revision: (A = t.revision) !== null && A !== void 0 ? A : 1,
      lastModifiedBy: (n = t.lastModifiedBy) !== null && n !== void 0 ? n : "Un-named"
    })), this.numbering = new _ae(t.numbering ? t.numbering : { config: [] }), this.comments = new rie((s = t.comments) !== null && s !== void 0 ? s : { children: [] }), this.comments.ThreadData && (this.commentsExtended = new cie(this.comments.ThreadData)), this.comments.CommentIdsData && (this.commentsIds = new hie(this.comments.CommentIdsData)), this.fileRelationships = new zA(), this.customProperties = new oae((r = t.customProperties) !== null && r !== void 0 ? r : []), this.appProperties = new _oe(), this.footnotesWrapper = new Dae(), this.endnotesWrapper = new Cae(), this.contentTypes = new eae({ macros: this.macros !== void 0 }), ((i = this.macros) === null || i === void 0 ? void 0 : i.events) !== void 0 && this.contentTypes.addOverride("application/vnd.ms-word.vbaData+xml", "/word/vbaData.xml"), t.bibliography !== void 0) {
      const M = new zA();
      M.addRelationship(1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXmlProps", "itemProps1.xml"), this.bibliography = {
        sources: t.bibliography.sources,
        properties: aae(`{${ij().toUpperCase()}}`),
        relationships: M
      }, this.contentTypes.addOverride("application/vnd.openxmlformats-officedocument.customXmlProperties+xml", "/customXml/itemProps1.xml");
    }
    if (this.packageParts = new $ae(this.contentTypes), this.documentWrapper = new hae({
      background: t.background,
      pageNumbers: t.pageNumbers
    }), this.settings = new cce({
      compatibilityModeVersion: t.compatabilityModeVersion,
      compatibility: t.compatibility,
      evenAndOddHeaders: !!t.evenAndOddHeaderAndFooters,
      trackRevisions: (o = t.features) === null || o === void 0 ? void 0 : o.trackRevisions,
      updateFields: (a = t.features) === null || a === void 0 ? void 0 : a.updateFields,
      embedFonts: !((c = t.fonts) === null || c === void 0) && c.length ? !0 : void 0,
      defaultTabStop: t.defaultTabStop,
      protection: t.protection,
      hyphenation: {
        autoHyphenation: (l = t.hyphenation) === null || l === void 0 ? void 0 : l.autoHyphenation,
        hyphenationZone: (B = t.hyphenation) === null || B === void 0 ? void 0 : B.hyphenationZone,
        consecutiveHyphenLimit: (g = t.hyphenation) === null || g === void 0 ? void 0 : g.consecutiveHyphenLimit,
        doNotHyphenateCaps: (h = t.hyphenation) === null || h === void 0 ? void 0 : h.doNotHyphenateCaps
      }
    }), this.media = new bae((M) => this.packageParts.takePath("media", "image", M)), t.externalStyles !== void 0) {
      var d, w, Q, p;
      const M = (d = (w = t.styles) === null || w === void 0 ? void 0 : w.default) !== null && d !== void 0 ? d : {}, I = Object.entries(gH(M)), N = ([E]) => M[E] !== void 0, m = new kce().newInstance(t.externalStyles);
      this.styles = new RI(oe(oe({}, m), {}, {
        paragraphStyles: (Q = t.styles) === null || Q === void 0 ? void 0 : Q.paragraphStyles,
        characterStyles: (p = t.styles) === null || p === void 0 ? void 0 : p.characterStyles,
        importedStyles: [
          ...I.filter((E) => !N(E)).map(([, E]) => E),
          ...m.importedStyles,
          ...I.filter(N).map(([, E]) => E)
        ]
      }));
    } else if (t.styles) {
      const M = new nD().newInstance(t.styles.default);
      this.styles = new RI(oe(oe({}, M), t.styles));
    } else {
      const M = new nD();
      this.styles = new RI(M.newInstance());
    }
    this.addDefaultRelationships();
    for (const M of t.sections) this.addSection(M);
    if (t.footnotes) for (const M in t.footnotes) this.footnotesWrapper.View.createFootNote(parseFloat(M), t.footnotes[M].children);
    if (t.endnotes) for (const M in t.endnotes) this.endnotesWrapper.View.createEndnote(parseFloat(M), t.endnotes[M].children);
    this.fontWrapper = new Wj((u = t.fonts) !== null && u !== void 0 ? u : []), this.theme = new Kce(t.theme), this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/theme", "theme/theme1.xml"), this.macros !== void 0 && this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.microsoft.com/office/2006/relationships/vbaProject", "vbaProject.bin"), this.bibliography !== void 0 && this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/customXml", "../customXml/item1.xml");
  }
  addSection({ headers: t = {}, footers: e = {}, children: A, properties: n }) {
    this.documentWrapper.View.Body.addSection(oe(oe({}, n), {}, {
      headerWrapperGroup: {
        default: t.default ? this.createHeader(t.default) : void 0,
        first: t.first ? this.createHeader(t.first) : void 0,
        even: t.even ? this.createHeader(t.even) : void 0
      },
      footerWrapperGroup: {
        default: e.default ? this.createFooter(e.default) : void 0,
        first: e.first ? this.createFooter(e.first) : void 0,
        even: e.even ? this.createFooter(e.even) : void 0
      }
    }));
    for (const s of A) this.documentWrapper.View.add(s);
  }
  createHeader(t) {
    const e = new zae(this.media, this.currentRelationshipId++);
    for (const A of t.options.children) e.add(A);
    return this.addHeaderToDocument(e), e;
  }
  createFooter(t) {
    const e = new pae(this.media, this.currentRelationshipId++);
    for (const A of t.options.children) e.add(A);
    return this.addFooterToDocument(e), e;
  }
  addHeaderToDocument(t, e = dl.DEFAULT) {
    this.headers.push({
      header: t,
      type: e
    }), this.documentWrapper.Relationships.addRelationship(t.View.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/header", `header${this.headers.length}.xml`), this.contentTypes.addHeader(this.headers.length);
  }
  addFooterToDocument(t, e = dl.DEFAULT) {
    this.footers.push({
      footer: t,
      type: e
    }), this.documentWrapper.Relationships.addRelationship(t.View.ReferenceId, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footer", `footer${this.footers.length}.xml`), this.contentTypes.addFooter(this.footers.length);
  }
  addDefaultRelationships() {
    this.fileRelationships.addRelationship(1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/officeDocument", "word/document.xml"), this.fileRelationships.addRelationship(2, "http://schemas.openxmlformats.org/package/2006/relationships/metadata/core-properties", "docProps/core.xml"), this.fileRelationships.addRelationship(3, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/extended-properties", "docProps/app.xml"), this.fileRelationships.addRelationship(4, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/custom-properties", "docProps/custom.xml"), this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/styles", "styles.xml"), this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/numbering", "numbering.xml"), this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/footnotes", "footnotes.xml"), this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/endnotes", "endnotes.xml"), this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/settings", "settings.xml"), this.comments.IsEmpty || (this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/comments", "comments.xml"), this.contentTypes.addComments()), this.commentsExtended && (this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.microsoft.com/office/2011/relationships/commentsExtended", "commentsExtended.xml"), this.contentTypes.addCommentsExtended()), this.commentsIds && (this.documentWrapper.Relationships.addRelationship(this.currentRelationshipId++, "http://schemas.microsoft.com/office/2016/09/relationships/commentsIds", "commentsIds.xml"), this.contentTypes.addCommentsIds());
  }
  get Document() {
    return this.documentWrapper;
  }
  get Styles() {
    return this.styles;
  }
  get CoreProperties() {
    return this.coreProperties;
  }
  get Numbering() {
    return this.numbering;
  }
  get Media() {
    return this.media;
  }
  get FileRelationships() {
    return this.fileRelationships;
  }
  get Headers() {
    return this.headers.map((t) => t.header);
  }
  get Footers() {
    return this.footers.map((t) => t.footer);
  }
  get ContentTypes() {
    return this.contentTypes;
  }
  get CustomProperties() {
    return this.customProperties;
  }
  get AppProperties() {
    return this.appProperties;
  }
  get FootNotes() {
    return this.footnotesWrapper;
  }
  get Endnotes() {
    return this.endnotesWrapper;
  }
  get Settings() {
    return this.settings;
  }
  get Comments() {
    return this.comments;
  }
  /** Extended comments part for reply threading. Undefined when no comment threads exist. */
  get CommentsExtended() {
    return this.commentsExtended;
  }
  /** Durable comment id part. Undefined when no comment carries a durableId. */
  get CommentsIds() {
    return this.commentsIds;
  }
  get FontTable() {
    return this.fontWrapper;
  }
  /** The document's theme (word/theme/theme1.xml). */
  get Theme() {
    return this.theme;
  }
  /** The parts that drawings, such as charts, add to the package when it is written. */
  get PackageParts() {
    return this.packageParts;
  }
  /**
  * The document's macros, when it has any: its VBA project (word/vbaProject.bin), the events of the document it
  * handles (word/vbaData.xml), and the project's relationships, to the events.
  */
  get Macros() {
    return this.macros;
  }
  /**
  * The document's sources, when it has a bibliography: the part they're in (customXml/item1.xml), its properties
  * (customXml/itemProps1.xml), and its relationships, to its properties.
  */
  get Bibliography() {
    return this.bibliography;
  }
}, bc = class {
  constructor(t = { children: [] }) {
    T(this, "options", void 0), this.options = t;
  }
}, vc = class {
  constructor(t = { children: [] }) {
    T(this, "options", void 0), this.options = t;
  }
}, uB = 0, PI = 32, Ble = 32, gle = (t, e) => {
  const A = e.replace(/-/g, "");
  if (A.length !== Ble) throw new Error(`Error: Cannot extract GUID from font filename: ${e}`);
  const n = A.replace(/(..)/g, "$1 ").trim().split(" ").map((i) => parseInt(i, 16));
  n.reverse();
  const s = t.slice(uB, PI).map((i, o) => i ^ n[o % n.length]), r = new Uint8Array(uB + s.length + Math.max(0, t.length - PI));
  return r.set(t.slice(0, uB)), r.set(s, uB), r.set(t.slice(PI), uB + s.length), r;
}, pH = class {
  /**
  * Formats an XML component into a serializable object.
  *
  * @param input - The XML component to format
  * @param context - The context containing file state and relationships
  * @returns A serializable XML object structure
  * @throws Error if the component cannot be formatted correctly
  */
  format(t, e = { stack: [] }) {
    const A = t.prepForXml(e);
    if (A) return A;
    throw Error("XMLComponent did not format correctly");
  }
}, mH = /\{([^{}]+)\}/g, YH = (t, e) => e.size === 0 ? t : t.replace(mH, (A, n) => {
  var s;
  return (s = e.get(n)) !== null && s !== void 0 ? s : A;
}), hle = (t) => new Set(Array.from(t.matchAll(mH), ([, e]) => e)), ule = class {
  /**
  * Replaces image placeholder tokens with relationship IDs.
  *
  * @param xmlData - The XML string containing image placeholders
  * @param images - The images the XML refers to, in the order their relationships are numbered
  * @param offset - Starting offset for relationship IDs
  * @returns XML string with placeholders replaced by relationship IDs
  */
  replace(t, e, A) {
    return YH(t, new Map(e.map((n, s) => [n.key, (A + s).toString()])));
  }
  /**
  * Finds the images referenced in the XML content.
  *
  * @param xmlData - The XML string to search for image references
  * @param media - The media collection to search within
  * @returns The images found in the XML, in the order they were added to the media
  */
  getMediaData(t, e) {
    const A = hle(t);
    return e.Entries.filter(([n]) => A.has(n)).map(([n, { fileName: s }]) => ({
      key: n,
      fileName: s
    }));
  }
}, dle = class {
  /**
  * Replaces numbering placeholder tokens with actual numbering IDs.
  *
  * Placeholder format: {reference-instance} where reference identifies the
  * numbering definition and instance is the specific usage.
  *
  * @param xmlData - The XML string containing numbering placeholders
  * @param concreteNumberings - Array of concrete numbering instances to replace
  * @returns XML string with placeholders replaced by numbering IDs
  */
  replace(t, e) {
    return YH(t, new Map(e.map(({ reference: A, instance: n, restartedListId: s, numId: r }) => [Vd(A, n, s), r.toString()])));
  }
}, wle = new pH(), KI = (t, e, A, n, s = !0) => yt(wle.format(e, {
  viewWrapper: {
    View: e,
    Relationships: n
  },
  file: t,
  stack: []
}), {
  indent: A,
  declaration: s ? {
    standalone: "yes",
    encoding: "UTF-8"
  } : { encoding: "UTF-8" }
}), fle = (t, e, A, n) => {
  const { content: s } = e.options;
  if (s instanceof Uint8Array) return [{
    data: s,
    path: `word/${A}`
  }];
  if ("files" in s) return [{
    data: $E(s.files.map(({ path: c, content: l }) => [c, l instanceof Uint8Array ? l : KI(t, l, n, new zA())])),
    path: `word/${A}`
  }];
  const r = t.PackageParts.createRelationships(A), i = KI(t, s, n, r), o = A.slice(0, A.lastIndexOf("/")), a = A.slice(A.lastIndexOf("/") + 1);
  return [{
    data: i,
    path: `word/${A}`
  }, ...r.RelationshipCount > 0 ? [{
    data: KI(t, r, n, r, !1),
    path: `word/${o}/_rels/${a}.rels`
  }] : []];
}, yH = (t, e, A = 0) => {
  const n = t.PackageParts.Array.slice(A);
  return n.length === 0 ? [] : [...n.flatMap(({ part: s, path: r }) => fle(t, s, r, e)), ...yH(t, e, A + n.length)];
}, Qle = ["PackageParts"], Ile = class {
  /**
  * Creates a new Compiler instance.
  *
  * Initializes the formatter and replacer utilities used during compilation.
  */
  constructor() {
    T(this, "formatter", void 0), T(this, "imageReplacer", void 0), T(this, "numberingReplacer", void 0), this.formatter = new pH(), this.imageReplacer = new ule(), this.numberingReplacer = new dle();
  }
  /**
  * Compiles a File object into the files of the complete OOXML package, which the Packer zips.
  *
  * This method orchestrates the entire compilation process:
  * - Converts all document components to XML
  * - Manages image and numbering placeholder replacements
  * - Creates relationship files
  * - Packages fonts and media files
  *
  * @param file - The document to compile
  * @param prettifyXml - Optional XML formatting style
  * @param overrides - Optional custom XML file overrides
  * @returns The package's files by their paths, in the order they are zipped
  */
  compile(t, e, A = []) {
    const n = this.xmlifyFile(t, e), { PackageParts: s } = n, r = zm(n, Qle), i = Object.values(r).flatMap((o) => Array.isArray(o) ? o : [o]);
    return new Map([
      ...i.map(({ path: o, data: a }) => [o, a]),
      ...s.map(({ path: o, data: a }) => [o, a]),
      ...A.map(({ path: o, data: a }) => [o, a]),
      ...t.Macros === void 0 ? [] : [["word/vbaProject.bin", t.Macros.project]],
      ...t.Media.Array.map((o) => [`word/media/${o.fileName}`, o.data]),
      ...t.FontTable.files.map(({ data: o, fontKey: a }, c) => [`word/fonts/font${c + 1}.odttf`, gle(o, a)])
    ]);
  }
  xmlifyFile(t, e) {
    var A;
    const n = yt(this.formatter.format(t.Document.View, {
      viewWrapper: t.Document,
      file: t,
      stack: []
    }), {
      indent: e,
      declaration: {
        standalone: "yes",
        encoding: "UTF-8"
      }
    }), s = yt(this.formatter.format(t.Comments, {
      viewWrapper: {
        View: t.Comments,
        Relationships: t.Comments.Relationships
      },
      file: t,
      stack: []
    }), {
      indent: e,
      declaration: {
        standalone: "yes",
        encoding: "UTF-8"
      }
    }), r = yt(this.formatter.format(t.FootNotes.View, {
      viewWrapper: t.FootNotes,
      file: t,
      stack: []
    }), {
      indent: e,
      declaration: {
        standalone: "yes",
        encoding: "UTF-8"
      }
    }), i = yt(this.formatter.format(t.Endnotes.View, {
      viewWrapper: t.Endnotes,
      file: t,
      stack: []
    }), {
      indent: e,
      declaration: { encoding: "UTF-8" }
    }), o = t.Document.Relationships.RelationshipCount + 1, a = t.Comments.Relationships.RelationshipCount + 1, c = t.FootNotes.Relationships.RelationshipCount + 1, l = t.Endnotes.Relationships.RelationshipCount + 1, B = this.imageReplacer.getMediaData(n, t.Media), g = this.imageReplacer.getMediaData(s, t.Media), h = this.imageReplacer.getMediaData(r, t.Media), u = this.imageReplacer.getMediaData(i, t.Media);
    return oe(oe(oe(oe(oe(oe({
      Relationships: {
        data: (() => {
          const d = zA.copy(t.Document.Relationships);
          return B.forEach((w, Q) => {
            d.addRelationship(o + Q, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${w.fileName}`);
          }), d.addRelationship(d.RelationshipCount + 1, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/fontTable", "fontTable.xml"), yt(this.formatter.format(d, {
            viewWrapper: t.Document,
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: { encoding: "UTF-8" }
          });
        })(),
        path: "word/_rels/document.xml.rels"
      },
      Document: {
        data: (() => {
          const d = this.imageReplacer.replace(n, B, o);
          return this.numberingReplacer.replace(d, t.Numbering.ConcreteNumbering);
        })(),
        path: "word/document.xml"
      },
      Styles: {
        data: (() => {
          const d = yt(this.formatter.format(t.Styles, {
            viewWrapper: t.Document,
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: {
              standalone: "yes",
              encoding: "UTF-8"
            }
          });
          return this.numberingReplacer.replace(d, t.Numbering.ConcreteNumbering);
        })(),
        path: "word/styles.xml"
      },
      Properties: {
        data: yt(this.formatter.format(t.CoreProperties, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "docProps/core.xml"
      },
      FileRelationships: {
        data: yt(this.formatter.format(t.FileRelationships, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }),
        path: "_rels/.rels"
      },
      HeaderRelationships: t.Headers.map((d, w) => {
        const Q = yt(this.formatter.format(d.View, {
          viewWrapper: d,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }), p = this.imageReplacer.getMediaData(Q, t.Media), M = zA.copy(d.Relationships);
        return p.forEach((I, N) => {
          M.addRelationship(N, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${I.fileName}`);
        }), {
          data: yt(this.formatter.format(M, {
            viewWrapper: d,
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: { encoding: "UTF-8" }
          }),
          path: `word/_rels/header${w + 1}.xml.rels`
        };
      }),
      FooterRelationships: t.Footers.map((d, w) => {
        const Q = yt(this.formatter.format(d.View, {
          viewWrapper: d,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }), p = this.imageReplacer.getMediaData(Q, t.Media), M = zA.copy(d.Relationships);
        return p.forEach((I, N) => {
          M.addRelationship(N, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${I.fileName}`);
        }), {
          data: yt(this.formatter.format(M, {
            viewWrapper: d,
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: { encoding: "UTF-8" }
          }),
          path: `word/_rels/footer${w + 1}.xml.rels`
        };
      }),
      Headers: t.Headers.map((d, w) => {
        const Q = yt(this.formatter.format(d.View, {
          viewWrapper: d,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }), p = this.imageReplacer.getMediaData(Q, t.Media), M = this.imageReplacer.replace(Q, p, 0);
        return {
          data: this.numberingReplacer.replace(M, t.Numbering.ConcreteNumbering),
          path: `word/header${w + 1}.xml`
        };
      }),
      Footers: t.Footers.map((d, w) => {
        const Q = yt(this.formatter.format(d.View, {
          viewWrapper: d,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }), p = this.imageReplacer.getMediaData(Q, t.Media), M = this.imageReplacer.replace(Q, p, 0);
        return {
          data: this.numberingReplacer.replace(M, t.Numbering.ConcreteNumbering),
          path: `word/footer${w + 1}.xml`
        };
      }),
      CustomProperties: {
        data: yt(this.formatter.format(t.CustomProperties, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "docProps/custom.xml"
      },
      AppProperties: {
        data: yt(this.formatter.format(t.AppProperties, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "docProps/app.xml"
      },
      FootNotes: {
        data: (() => {
          const d = this.imageReplacer.replace(r, h, c);
          return this.numberingReplacer.replace(d, t.Numbering.ConcreteNumbering);
        })(),
        path: "word/footnotes.xml"
      },
      FootNotesRelationships: {
        data: (() => {
          const d = zA.copy(t.FootNotes.Relationships);
          return h.forEach((w, Q) => {
            d.addRelationship(c + Q, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${w.fileName}`);
          }), yt(this.formatter.format(d, {
            viewWrapper: t.FootNotes,
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: { encoding: "UTF-8" }
          });
        })(),
        path: "word/_rels/footnotes.xml.rels"
      },
      Endnotes: {
        data: (() => {
          const d = this.imageReplacer.replace(i, u, l);
          return this.numberingReplacer.replace(d, t.Numbering.ConcreteNumbering);
        })(),
        path: "word/endnotes.xml"
      },
      EndnotesRelationships: {
        data: (() => {
          const d = zA.copy(t.Endnotes.Relationships);
          return u.forEach((w, Q) => {
            d.addRelationship(l + Q, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${w.fileName}`);
          }), yt(this.formatter.format(d, {
            viewWrapper: t.Endnotes,
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: { encoding: "UTF-8" }
          });
        })(),
        path: "word/_rels/endnotes.xml.rels"
      },
      Settings: {
        data: yt(this.formatter.format(t.Settings, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "word/settings.xml"
      }
    }, t.Comments.IsEmpty ? {} : {
      Comments: {
        data: (() => {
          const d = this.imageReplacer.replace(s, g, a);
          return this.numberingReplacer.replace(d, t.Numbering.ConcreteNumbering);
        })(),
        path: "word/comments.xml"
      },
      CommentsRelationships: {
        data: (() => {
          const d = zA.copy(t.Comments.Relationships);
          return g.forEach((w, Q) => {
            d.addRelationship(a + Q, "http://schemas.openxmlformats.org/officeDocument/2006/relationships/image", `media/${w.fileName}`);
          }), yt(this.formatter.format(d, {
            viewWrapper: {
              View: t.Comments,
              Relationships: t.Comments.Relationships
            },
            file: t,
            stack: []
          }), {
            indent: e,
            declaration: { encoding: "UTF-8" }
          });
        })(),
        path: "word/_rels/comments.xml.rels"
      }
    }), t.CommentsExtended ? { CommentsExtended: {
      data: yt(this.formatter.format(t.CommentsExtended, {
        viewWrapper: {
          View: t.CommentsExtended,
          Relationships: t.Comments.Relationships
        },
        file: t,
        stack: []
      }), {
        indent: e,
        declaration: {
          standalone: "yes",
          encoding: "UTF-8"
        }
      }),
      path: "word/commentsExtended.xml"
    } } : {}), t.CommentsIds ? { CommentsIds: {
      data: yt(this.formatter.format(t.CommentsIds, {
        viewWrapper: {
          View: t.CommentsIds,
          Relationships: t.Comments.Relationships
        },
        file: t,
        stack: []
      }), {
        indent: e,
        declaration: {
          standalone: "yes",
          encoding: "UTF-8"
        }
      }),
      path: "word/commentsIds.xml"
    } } : {}), {}, {
      FontTable: {
        data: yt(this.formatter.format(t.FontTable.View, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "word/fontTable.xml"
      },
      FontTableRelationships: {
        data: yt(this.formatter.format(t.FontTable.Relationships, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }),
        path: "word/_rels/fontTable.xml.rels"
      },
      Theme: {
        data: yt(this.formatter.format(t.Theme, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "word/theme/theme1.xml"
      }
    }, !((A = t.Macros) === null || A === void 0) && A.events ? {
      MacroEvents: {
        data: yt(this.formatter.format(t.Macros.events, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "word/vbaData.xml"
      },
      MacroRelationships: {
        data: yt(this.formatter.format(t.Macros.relationships, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }),
        path: "word/_rels/vbaProject.bin.rels"
      }
    } : {}), t.Bibliography ? {
      BibliographySources: {
        data: yt(this.formatter.format(t.Bibliography.sources, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "customXml/item1.xml"
      },
      BibliographySourcesProperties: {
        data: yt(this.formatter.format(t.Bibliography.properties, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "no",
            encoding: "UTF-8"
          }
        }),
        path: "customXml/itemProps1.xml"
      },
      BibliographySourcesRelationships: {
        data: yt(this.formatter.format(t.Bibliography.relationships, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "customXml/_rels/item1.xml.rels"
      }
    } : {}), {}, {
      PackageParts: yH(t, e),
      Numbering: {
        data: yt(this.formatter.format(t.Numbering, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: {
            standalone: "yes",
            encoding: "UTF-8"
          }
        }),
        path: "word/numbering.xml"
      },
      ContentTypes: {
        data: yt(this.formatter.format(t.ContentTypes, {
          viewWrapper: t.Document,
          file: t,
          stack: []
        }), {
          indent: e,
          declaration: { encoding: "UTF-8" }
        }),
        path: "[Content_Types].xml"
      }
    });
  }
}, uD = (/* @__PURE__ */ bAe(((t, e) => {
  var A = typeof Reflect == "object" ? Reflect : null, n = A && typeof A.apply == "function" ? A.apply : function(E, G, Y) {
    return Function.prototype.apply.call(E, G, Y);
  }, s;
  A && typeof A.ownKeys == "function" ? s = A.ownKeys : Object.getOwnPropertySymbols ? s = function(E) {
    return Object.getOwnPropertyNames(E).concat(Object.getOwnPropertySymbols(E));
  } : s = function(E) {
    return Object.getOwnPropertyNames(E);
  };
  function r(m) {
    console && console.warn && console.warn(m);
  }
  var i = Number.isNaN || function(E) {
    return E !== E;
  };
  function o() {
    o.init.call(this);
  }
  e.exports = o, e.exports.once = M, o.EventEmitter = o, o.prototype._events = void 0, o.prototype._eventsCount = 0, o.prototype._maxListeners = void 0;
  var a = 10;
  function c(m) {
    if (typeof m != "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof m);
  }
  Object.defineProperty(o, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return a;
    },
    set: function(m) {
      if (typeof m != "number" || m < 0 || i(m)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + m + ".");
      a = m;
    }
  }), o.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, o.prototype.setMaxListeners = function(E) {
    if (typeof E != "number" || E < 0 || i(E)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + E + ".");
    return this._maxListeners = E, this;
  };
  function l(m) {
    return m._maxListeners === void 0 ? o.defaultMaxListeners : m._maxListeners;
  }
  o.prototype.getMaxListeners = function() {
    return l(this);
  }, o.prototype.emit = function(E) {
    for (var G = [], Y = 1; Y < arguments.length; Y++) G.push(arguments[Y]);
    var U = E === "error", v = this._events;
    if (v !== void 0) U = U && v.error === void 0;
    else if (!U) return !1;
    if (U) {
      var b;
      if (G.length > 0 && (b = G[0]), b instanceof Error) throw b;
      var W = /* @__PURE__ */ new Error("Unhandled error." + (b ? " (" + b.message + ")" : ""));
      throw W.context = b, W;
    }
    var q = v[E];
    if (q === void 0) return !1;
    if (typeof q == "function") n(q, this, G);
    else
      for (var ne = q.length, V = w(q, ne), Y = 0; Y < ne; ++Y) n(V[Y], this, G);
    return !0;
  };
  function B(m, E, G, Y) {
    var U, v, b;
    if (c(G), v = m._events, v === void 0 ? (v = m._events = /* @__PURE__ */ Object.create(null), m._eventsCount = 0) : (v.newListener !== void 0 && (m.emit("newListener", E, G.listener ? G.listener : G), v = m._events), b = v[E]), b === void 0)
      b = v[E] = G, ++m._eventsCount;
    else if (typeof b == "function" ? b = v[E] = Y ? [G, b] : [b, G] : Y ? b.unshift(G) : b.push(G), U = l(m), U > 0 && b.length > U && !b.warned) {
      b.warned = !0;
      var W = /* @__PURE__ */ new Error("Possible EventEmitter memory leak detected. " + b.length + " " + String(E) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      W.name = "MaxListenersExceededWarning", W.emitter = m, W.type = E, W.count = b.length, r(W);
    }
    return m;
  }
  o.prototype.addListener = function(E, G) {
    return B(this, E, G, !1);
  }, o.prototype.on = o.prototype.addListener, o.prototype.prependListener = function(E, G) {
    return B(this, E, G, !0);
  };
  function g() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function h(m, E, G) {
    var Y = {
      fired: !1,
      wrapFn: void 0,
      target: m,
      type: E,
      listener: G
    }, U = g.bind(Y);
    return U.listener = G, Y.wrapFn = U, U;
  }
  o.prototype.once = function(E, G) {
    return c(G), this.on(E, h(this, E, G)), this;
  }, o.prototype.prependOnceListener = function(E, G) {
    return c(G), this.prependListener(E, h(this, E, G)), this;
  }, o.prototype.removeListener = function(E, G) {
    var Y, U, v, b, W;
    if (c(G), U = this._events, U === void 0) return this;
    if (Y = U[E], Y === void 0) return this;
    if (Y === G || Y.listener === G)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete U[E], U.removeListener && this.emit("removeListener", E, Y.listener || G));
    else if (typeof Y != "function") {
      for (v = -1, b = Y.length - 1; b >= 0; b--) if (Y[b] === G || Y[b].listener === G) {
        W = Y[b].listener, v = b;
        break;
      }
      if (v < 0) return this;
      v === 0 ? Y.shift() : Q(Y, v), Y.length === 1 && (U[E] = Y[0]), U.removeListener !== void 0 && this.emit("removeListener", E, W || G);
    }
    return this;
  }, o.prototype.off = o.prototype.removeListener, o.prototype.removeAllListeners = function(E) {
    var G, Y = this._events, U;
    if (Y === void 0) return this;
    if (Y.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : Y[E] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete Y[E]), this;
    if (arguments.length === 0) {
      var v = Object.keys(Y), b;
      for (U = 0; U < v.length; ++U)
        b = v[U], b !== "removeListener" && this.removeAllListeners(b);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if (G = Y[E], typeof G == "function") this.removeListener(E, G);
    else if (G !== void 0) for (U = G.length - 1; U >= 0; U--) this.removeListener(E, G[U]);
    return this;
  };
  function u(m, E, G) {
    var Y = m._events;
    if (Y === void 0) return [];
    var U = Y[E];
    return U === void 0 ? [] : typeof U == "function" ? G ? [U.listener || U] : [U] : G ? p(U) : w(U, U.length);
  }
  o.prototype.listeners = function(E) {
    return u(this, E, !0);
  }, o.prototype.rawListeners = function(E) {
    return u(this, E, !1);
  }, o.listenerCount = function(m, E) {
    return typeof m.listenerCount == "function" ? m.listenerCount(E) : d.call(m, E);
  }, o.prototype.listenerCount = d;
  function d(m) {
    var E = this._events;
    if (E !== void 0) {
      var G = E[m];
      if (typeof G == "function") return 1;
      if (G !== void 0) return G.length;
    }
    return 0;
  }
  o.prototype.eventNames = function() {
    return this._eventsCount > 0 ? s(this._events) : [];
  };
  function w(m, E) {
    for (var G = new Array(E), Y = 0; Y < E; ++Y) G[Y] = m[Y];
    return G;
  }
  function Q(m, E) {
    for (; E + 1 < m.length; E++) m[E] = m[E + 1];
    m.pop();
  }
  function p(m) {
    for (var E = new Array(m.length), G = 0; G < E.length; ++G) E[G] = m[G].listener || m[G];
    return E;
  }
  function M(m, E) {
    return new Promise(function(G, Y) {
      function U(b) {
        m.removeListener(E, v), Y(b);
      }
      function v() {
        typeof m.removeListener == "function" && m.removeListener("error", U), G([].slice.call(arguments));
      }
      N(m, E, v, { once: !0 }), E !== "error" && I(m, U, { once: !0 });
    });
  }
  function I(m, E, G) {
    typeof m.on == "function" && N(m, "error", E, G);
  }
  function N(m, E, G, Y) {
    if (typeof m.on == "function")
      Y.once ? m.once(E, G) : m.on(E, G);
    else if (typeof m.addEventListener == "function") m.addEventListener(E, function U(v) {
      Y.once && m.removeEventListener(E, U), G(v);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof m);
  }
})))();
/**
* @license MIT
* Adapted from stream-browserify 3.0.0's base Stream and pipe implementation (MIT).
* Copyright Joyent, Inc. and other Node contributors.
* Copyright (c) James Halliday
*
* Permission is hereby granted, free of charge, to any person obtaining a
* copy of this software and associated documentation files (the
* "Software"), to deal in the Software without restriction, including
* without limitation the rights to use, copy, modify, merge, publish,
* distribute, sublicense, and/or sell copies of the Software, and to permit
* persons to whom the Software is furnished to do so, subject to the
* following conditions:
*
* The above copyright notice and this permission notice shall be included
* in all copies or substantial portions of the Software.
*
* THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
* OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
* MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
* NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
* DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
* OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
* USE OR OTHER DEALINGS IN THE SOFTWARE.
*/
var Cle = class extends uD.EventEmitter {
  pipe(t, e) {
    const A = this, n = t, s = (B) => {
      n.writable && n.write(B) === !1 && A.pause && A.pause();
    };
    A.on("data", s);
    const r = () => {
      A.readable && A.resume && A.resume();
    };
    n.on("drain", r), !n._isStdio && (!e || e.end !== !1) && (A.on("end", o), A.on("close", a));
    let i = !1;
    function o() {
      i || (i = !0, n.end());
    }
    function a() {
      i || (i = !0, typeof n.destroy == "function" && n.destroy());
    }
    function c(B) {
      if (l(), uD.EventEmitter.listenerCount(this, "error") === 0) throw B;
    }
    A.on("error", c), n.on("error", c);
    function l() {
      A.removeListener("data", s), n.removeListener("drain", r), A.removeListener("end", o), A.removeListener("close", a), A.removeListener("error", c), n.removeListener("error", c), A.removeListener("end", l), A.removeListener("close", l), n.removeListener("close", l);
    }
    return A.on("end", l), A.on("close", l), n.on("close", l), n.emit("pipe", A), n;
  }
};
function dD(t, e, A, n, s, r, i) {
  try {
    var o = t[r](i), a = o.value;
  } catch (c) {
    A(c);
    return;
  }
  o.done ? e(a) : Promise.resolve(a).then(n, s);
}
function Ele(t) {
  return function() {
    var e = this, A = arguments;
    return new Promise(function(n, s) {
      var r = t.apply(e, A);
      function i(a) {
        dD(r, n, s, i, o, "next", a);
      }
      function o(a) {
        dD(r, n, s, i, o, "throw", a);
      }
      i(void 0);
    });
  };
}
var Mle = {
  /** Indent with 2 spaces */
  WITH_2_BLANKS: "  "
}, wD = (t) => t === !0 ? Mle.WITH_2_BLANKS : t === !1 ? void 0 : t, fD = (t) => t.Macros === void 0 ? "application/vnd.openxmlformats-officedocument.wordprocessingml.document" : "application/vnd.ms-word.document.macroEnabled.12", Wc = class Oc {
  /**
  * Exports a document to the specified output format.
  *
  * @param file - The document to export
  * @param type - The output format type (e.g., "nodebuffer", "blob", "string")
  * @param prettify - Whether to prettify the XML output (boolean or PrettifyType)
  * @param overrides - Optional array of file overrides for custom XML content
  * @returns A promise resolving to the exported document in the specified format
  */
  static pack(e, A, n) {
    var s = this;
    return Ele(function* (r, i, o, a = []) {
      return hD($E(s.compiler.compile(r, wD(o), a)), i, fD(r));
    }).apply(this, arguments);
  }
  /**
  * Exports a document to a string representation.
  *
  * @param file - The document to export
  * @param prettify - Whether to prettify the XML output
  * @param overrides - Optional array of file overrides
  * @returns A promise resolving to the document as a string
  */
  static toString(e, A, n = []) {
    return Oc.pack(e, "string", A, n);
  }
  /**
  * Exports a document to a Node.js Buffer.
  *
  * @param file - The document to export
  * @param prettify - Whether to prettify the XML output
  * @param overrides - Optional array of file overrides
  * @returns A promise resolving to the document as a Buffer
  */
  static toBuffer(e, A, n = []) {
    return Oc.pack(e, "nodebuffer", A, n);
  }
  /**
  * Exports a document to a base64-encoded string.
  *
  * @param file - The document to export
  * @param prettify - Whether to prettify the XML output
  * @param overrides - Optional array of file overrides
  * @returns A promise resolving to the document as a base64 string
  */
  static toBase64String(e, A, n = []) {
    return Oc.pack(e, "base64", A, n);
  }
  /**
  * Exports a document to a Blob (for browser environments).
  *
  * @param file - The document to export
  * @param prettify - Whether to prettify the XML output
  * @param overrides - Optional array of file overrides
  * @returns A promise resolving to the document as a Blob
  */
  static toBlob(e, A, n = []) {
    return Oc.pack(e, "blob", A, n);
  }
  /**
  * Exports a document to an ArrayBuffer.
  *
  * @param file - The document to export
  * @param prettify - Whether to prettify the XML output
  * @param overrides - Optional array of file overrides
  * @returns A promise resolving to the document as an ArrayBuffer
  */
  static toArrayBuffer(e, A, n = []) {
    return Oc.pack(e, "arraybuffer", A, n);
  }
  /**
  * Exports a document to a Node.js Stream.
  *
  * The stream gives the document as one Node.js Buffer, then ends. Where there's no Buffer, as in a browser, it
  * emits an `error` event instead, so use `toBlob` there.
  *
  * @param file - The document to export
  * @param prettify - Whether to prettify the XML output
  * @param overrides - Optional array of file overrides
  * @returns A readable stream containing the document data
  */
  static toStream(e, A, n = []) {
    const s = new Cle(), r = this.compiler.compile(e, wD(A), n);
    return new Promise((i) => setTimeout(i)).then(() => hD($E(r), "nodebuffer", fD(e))).then((i) => {
      s.emit("data", i), s.emit("end");
    }, (i) => s.emit("error", i)), s;
  }
};
T(Wc, "compiler", new Ile());
function $A(t) {
  return t * 240;
}
var FH = { black: "000000", blue: "0000FF", brown: "A52A2A", cyan: "00FFFF", gray: "808080", green: "00FF00", indigo: "4B0082", lime: "00FF00", magenta: "FF00FF", maroon: "800000", navy: "000080", olive: "808000", orange: "FFA500", pink: "FFC0CB", purple: "800080", red: "FF0000", teal: "008080", violet: "9400D3", white: "FFFFFF", yellow: "FFFF00" }, ple = /* @__PURE__ */ new Set(["auto", "transparent", "inherit", "initial", "unset", "currentcolor"]), QD = /^[0-9A-Fa-f]{6}$/;
function ID(t) {
  return t[0] + t[0] + t[1] + t[1] + t[2] + t[2];
}
function VI(t) {
  return Math.max(0, Math.min(255, Math.round(t))).toString(16).padStart(2, "0").toUpperCase();
}
function cg(t) {
  let e = t.trim();
  if (e === "") return null;
  let A = e.toLowerCase();
  if (ple.has(A)) return null;
  if (e.startsWith("#")) {
    let s = e.slice(1).toUpperCase();
    return s.length === 6 && QD.test(s) ? s : s.length === 3 && /^[0-9A-F]{3}$/.test(s) ? ID(s) : s.length === 8 && /^[0-9A-F]{8}$/.test(s) ? s.slice(0, 6) : s.length === 4 && /^[0-9A-F]{4}$/.test(s) ? ID(s.slice(0, 3)) : null;
  }
  if (A.startsWith("rgb")) {
    let s = e.match(/rgba?\(\s*([\d.]+)\s*,\s*([\d.]+)\s*,\s*([\d.]+)/);
    if (!s) return null;
    let r = parseFloat(s[1]), i = parseFloat(s[2]), o = parseFloat(s[3]);
    return Number.isNaN(r) || Number.isNaN(i) || Number.isNaN(o) ? null : VI(r) + VI(i) + VI(o);
  }
  let n = FH[A];
  return n !== void 0 ? n : QD.test(e) ? e.toUpperCase() : null;
}
function CD(t) {
  return t * 0.75;
}
function Es(t) {
  return t * 2;
}
function fA(t) {
  return t * 20;
}
var mle = /^(-?\d*\.?\d+)\s*(px|pt|rem|em|%)?\s*$/;
function NH(t) {
  let e = t.trim().match(mle);
  if (!e) return null;
  let A = parseFloat(e[1]);
  return Number.isNaN(A) ? null : [A, e[2] || ""];
}
function Ef(t, e) {
  let A = NH(t);
  if (!A) return null;
  let [n, s] = A;
  switch (s) {
    case "px":
      return CD(n);
    case "pt":
      return n;
    case "rem":
    case "em":
      return CD(n * e);
    default:
      return null;
  }
}
function Yle(t) {
  let e = cg(t);
  return e ? { run: { color: e } } : null;
}
function yle(t) {
  let e = cg(t);
  return e ? { run: { shading: { type: th.CLEAR, fill: e } } } : null;
}
function Fle(t, e) {
  let A = Ef(t, e);
  return A === null ? null : { run: { size: Es(A) } };
}
function Nle(t) {
  let e = t.split(",")[0].trim().replace(/^["']|["']$/g, "");
  return e ? { run: { font: e } } : null;
}
function Dle(t) {
  let e = t.trim().toLowerCase(), A = parseInt(e, 10);
  return e === "bold" || e === "bolder" || !Number.isNaN(A) && A >= 600 ? { run: { bold: !0 } } : e === "normal" || e === "lighter" || !Number.isNaN(A) && A < 600 ? { run: { bold: !1 } } : null;
}
function xle(t) {
  let e = t.trim().toLowerCase();
  return e === "italic" || e === "oblique" ? { run: { italics: !0 } } : e === "normal" ? { run: { italics: !1 } } : null;
}
function Gle(t, e) {
  let A = t.trim().toLowerCase();
  if (A === "normal") return { paragraph: { spacing: { line: $A(1.15) } } };
  let n = NH(A);
  if (!n) return null;
  let [s, r] = n, i;
  switch (r) {
    case "":
      i = s;
      break;
    case "%":
      i = s / 100;
      break;
    case "em":
      i = s;
      break;
    case "px":
      i = s / e;
      break;
    default:
      return null;
  }
  return { paragraph: { spacing: { line: $A(i) } } };
}
var zle = { left: bt.LEFT, center: bt.CENTER, right: bt.RIGHT, justify: bt.JUSTIFIED };
function Ule(t) {
  let e = t.trim().toLowerCase(), A = zle[e];
  return A === void 0 ? null : { paragraph: { alignment: A } };
}
function ble(t, e) {
  let A = Ef(t, e);
  return A === null ? null : { paragraph: { spacing: { before: fA(A) } } };
}
function vle(t, e) {
  let A = Ef(t, e);
  return A === null ? null : { paragraph: { spacing: { after: fA(A) } } };
}
function jle(t) {
  let e = t.trim().toLowerCase(), A = {}, n = !1;
  return e.includes("underline") && (A.underline = { type: df.SINGLE }, n = !0), e.includes("line-through") && (A.strike = !0, n = !0), n ? { run: A } : null;
}
function Hle(t, e) {
  let A = t.trim().toLowerCase();
  if (A === "normal") return { run: { characterSpacing: 0 } };
  let n = Ef(A, e);
  return n === null ? null : { run: { characterSpacing: fA(n) } };
}
function kle(t) {
  return t.replace(/[A-Z]/g, (e) => `-${e.toLowerCase()}`);
}
function Rle(t, e, A) {
  switch (t) {
    case "color":
      return Yle(e);
    case "background-color":
      return yle(e);
    case "font-size":
      return Fle(e, A);
    case "font-family":
      return Nle(e);
    case "font-weight":
      return Dle(e);
    case "font-style":
      return xle(e);
    case "line-height":
      return Gle(e, A);
    case "text-align":
      return Ule(e);
    case "margin-top":
      return ble(e, A);
    case "margin-bottom":
      return vle(e, A);
    case "text-decoration":
      return jle(e);
    case "letter-spacing":
      return Hle(e, A);
    default:
      return null;
  }
}
var eM = /* @__PURE__ */ new Set(["color", "background-color", "font-size", "font-family", "font-weight", "font-style", "line-height", "text-align", "margin-top", "margin-bottom", "text-decoration", "letter-spacing"]), tM = { p: { id: "Normal", name: "Normal", isCharacterStyle: !1 }, h1: { id: "Heading1", name: "Heading 1", isCharacterStyle: !1 }, h2: { id: "Heading2", name: "Heading 2", isCharacterStyle: !1 }, h3: { id: "Heading3", name: "Heading 3", isCharacterStyle: !1 }, h4: { id: "Heading4", name: "Heading 4", isCharacterStyle: !1 }, h5: { id: "Heading5", name: "Heading 5", isCharacterStyle: !1 }, h6: { id: "Heading6", name: "Heading 6", isCharacterStyle: !1 }, blockquote: { id: "Quote", name: "Quote", isCharacterStyle: !1 }, a: { id: "Hyperlink", name: "Hyperlink", isCharacterStyle: !0 }, code: { id: "Code", name: "Code", isCharacterStyle: !0 }, "ul li": { id: "ListParagraph", name: "List Paragraph", isCharacterStyle: !1 }, "ol li": { id: "ListParagraph", name: "List Paragraph", isCharacterStyle: !1 }, strong: { id: "Strong", name: "Strong", isCharacterStyle: !0 }, em: { id: "Emphasis", name: "Emphasis", isCharacterStyle: !0 }, u: { id: "UnderlineStyle", name: "Underline", isCharacterStyle: !0 }, s: { id: "Strikethrough", name: "Strikethrough", isCharacterStyle: !0 } }, Lle = new Set(Object.keys(tM)), Sle = ".tiptap";
function Tle(t, e) {
  let A = t.trim();
  return A.startsWith(e) && A.slice(e.length).trim() || null;
}
function Jle(t) {
  let e = {};
  for (let A of eM) {
    let n = t.getPropertyValue(A).trim();
    n && (e[A] = n);
  }
  return e;
}
function Wle(t) {
  var e;
  if (typeof document > "u") return {};
  let A = (e = void 0) != null ? e : Sle, n = {};
  for (let s of Array.from(document.styleSheets)) {
    let r;
    try {
      r = s.cssRules;
    } catch {
      continue;
    }
    if (r) for (let i of Array.from(r)) {
      if (!(i instanceof CSSStyleRule)) continue;
      let o = Tle(i.selectorText, A);
      if (!o || !Lle.has(o)) continue;
      let a = o, c = Jle(i.style);
      Object.keys(c).length !== 0 && (n[a] = { ...n[a], ...c });
    }
  }
  return n;
}
function DH(t, e) {
  e.run && (t.run = { ...t.run, ...e.run }), e.paragraph && (t.paragraph || (t.paragraph = {}), e.paragraph.alignment && (t.paragraph.alignment = e.paragraph.alignment), e.paragraph.spacing && (t.paragraph.spacing = { ...t.paragraph.spacing, ...e.paragraph.spacing }));
}
function Ole(t, e, A) {
  let n = {};
  for (let [s, r] of Object.entries(t)) {
    if (r === void 0 || r === "") continue;
    let i = kle(s);
    if (!eM.has(i)) {
      console.warn(`[css-styles] Unsupported CSS property "${i}" on selector "${A}". Supported properties: ${Array.from(eM).join(", ")}`);
      continue;
    }
    let o = Rle(i, r, e);
    if (!o) {
      console.warn(`[css-styles] Could not convert CSS property "${i}: ${r}" on selector "${A}"`);
      continue;
    }
    DH(n, o);
  }
  return n;
}
function Ple(t, e) {
  let A = /* @__PURE__ */ new Map();
  for (let [r, i] of Object.entries(t)) {
    if (!i) continue;
    let o = tM[r];
    if (!o) {
      console.warn(`[css-styles] Unknown CSS selector "${r}". Supported selectors: ${Object.keys(tM).join(", ")}`);
      continue;
    }
    let a = Ole(i, e, r);
    if (!a.run && !a.paragraph) continue;
    let c = A.get(o.id);
    c ? DH(c.fragment, a) : A.set(o.id, { id: o.id, name: o.name, isCharacterStyle: o.isCharacterStyle, fragment: { ...a } });
  }
  let n = [], s = [];
  for (let r of A.values()) if (r.isCharacterStyle) {
    let i = r.fragment.run && Object.keys(r.fragment.run).length > 0;
    s.push({ id: r.id, name: r.name, basedOn: "DefaultParagraphFont", quickFormat: !0, ...i ? { run: r.fragment.run } : {} });
  } else {
    let i = r.fragment.run && Object.keys(r.fragment.run).length > 0, o = r.fragment.paragraph && Object.keys(r.fragment.paragraph).length > 0;
    n.push({ id: r.id, name: r.name, basedOn: "Normal", quickFormat: !0, ...i ? { run: r.fragment.run } : {}, ...o ? { paragraph: r.fragment.paragraph } : {} });
  }
  return { ...n.length > 0 ? { paragraphStyles: n } : {}, ...s.length > 0 ? { characterStyles: s } : {} };
}
function Kle(t) {
  if (!t) return {};
  let { styles: e, extractFromDocument: A, baseFontSize: n = 16 } = t;
  if (!e && !A) return {};
  let s = {};
  if (A && (s = { ...Wle() }), e) for (let [r, i] of Object.entries(e)) {
    if (!i) continue;
    let o = s[r];
    s[r] = o ? { ...o, ...i } : i;
  }
  return Ple(s, n);
}
var Vle = { default: { document: { run: { font: "Arial", size: Es(11), sizeComplexScript: Es(11), language: { value: "en-US", eastAsia: "en-US", bidirectional: "ar-SA" } }, paragraph: { spacing: { after: fA(10), line: $A(1.15) } } } }, characterStyles: [{ id: "Code", name: "Code", basedOn: "DefaultParagraphFont", run: { font: "Courier New", shading: { type: th.CLEAR, fill: "F0F0F0" } } }], paragraphStyles: [{ id: "Normal", name: "Normal", run: { font: "Arial", size: Es(11) }, paragraph: { spacing: { before: 0, after: fA(10), line: $A(1.15) } } }, { id: "ListParagraph", name: "List Paragraph", basedOn: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(11) }, paragraph: { spacing: { before: 0, after: fA(2), line: $A(1) } } }, { id: "Heading1", name: "Heading 1", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(16), bold: !0, color: "2E74B5" }, paragraph: { spacing: { before: fA(12), after: fA(6), line: $A(1.15) } } }, { id: "Heading2", name: "Heading 2", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(14), bold: !0, color: "2E74B5" }, paragraph: { spacing: { before: fA(12), after: fA(6), line: $A(1.15) } } }, { id: "Heading3", name: "Heading 3", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(13), bold: !0, color: "2E74B5" }, paragraph: { spacing: { before: fA(12), after: fA(6), line: $A(1.15) } } }, { id: "Heading4", name: "Heading 4", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(12), bold: !0, color: "2E74B5" }, paragraph: { spacing: { before: fA(12), after: fA(6), line: $A(1.15) } } }, { id: "Heading5", name: "Heading 5", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(11), bold: !0, color: "2E74B5" }, paragraph: { spacing: { before: fA(12), after: fA(6), line: $A(1.15) } } }, { id: "Title", name: "Title", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(22), bold: !0, color: "000000" }, paragraph: { alignment: bt.CENTER, spacing: { before: 0, after: 0, line: $A(1.15) } } }, { id: "Subtitle", name: "Subtitle", basedOn: "Normal", next: "Normal", quickFormat: !0, run: { font: "Arial", size: Es(16), italics: !0, color: "666666" }, paragraph: { alignment: bt.CENTER, spacing: { before: 0, after: 0, line: $A(1.15) } } }, { id: "Quote", name: "Quote", basedOn: "Normal", quickFormat: !0, run: { font: "Arial", italics: !0 }, paragraph: { alignment: bt.CENTER, spacing: { before: fA(10), after: fA(10), line: $A(1.15) } } }, { id: "IntenseQuote", name: "Intense Quote", basedOn: "Normal", quickFormat: !0, run: { font: "Arial", italics: !0, color: "444444" }, paragraph: { alignment: bt.CENTER, spacing: { before: fA(10), after: fA(10), line: $A(1.15) } } }, { id: "NoSpacing", name: "No Spacing", basedOn: "Normal", quickFormat: !0, paragraph: { spacing: { before: 0, after: 0, line: $A(1) } } }, { id: "Hyperlink", name: "Hyperlink", basedOn: "Normal", run: { color: "0563C1", underline: { type: "single" } } }] }, Xle = { width: 800, height: 400 };
async function Zle(t) {
  let e = new TextDecoder("utf-8").decode(t.subarray(0, 100)), A = "image/png";
  return e.includes("<svg") ? A = "image/svg+xml" : e.startsWith("PNG") ? A = "image/png" : e.startsWith("ÿØ") && (A = "image/jpeg"), new Promise((n, s) => {
    let r = new Blob([t], { type: A }), i = URL.createObjectURL(r), o = new Image();
    o.onload = () => {
      URL.revokeObjectURL(i), n({ width: o.naturalWidth, height: o.naturalHeight });
    }, o.onerror = (a) => {
      URL.revokeObjectURL(i), s(a);
    }, o.src = i;
  });
}
async function qle(t) {
  try {
    let { imageSize: e } = await import("./index-DF7guPit.js"), A = e(t);
    if (A.width && A.height) return { width: A.width, height: A.height };
  } catch (e) {
    console.warn("Error getting server-side image dimensions:", e);
  }
  return Xle;
}
var ED = ["png", "jpg", "jpeg", "gif", "bmp", "svg"];
function _le(t, e) {
  let A = e.get("content-type");
  if (A) {
    if (A.includes("png")) return "png";
    if (A.includes("jpeg") || A.includes("jpg")) return "jpg";
    if (A.includes("gif")) return "gif";
    if (A.includes("bmp")) return "bmp";
    if (A.includes("svg")) return "svg";
  }
  if (A === "binary/octet-stream") {
    let n = new URL(t), s = n.pathname.substring(n.pathname.lastIndexOf("/") + 1), r = s.substring(s.lastIndexOf(".") + 1).toLowerCase();
    if (ED.includes(r)) return r;
  }
  throw new Error(`Unsupported image type [${A}]. Only ${ED.join(", ")} are supported.`);
}
function jc(t) {
  return t * 0.75;
}
async function $le(t) {
  try {
    return typeof window < "u" ? await Zle(t) : await qle(t);
  } catch (e) {
    return console.warn("Could not determine image dimensions, using defaults:", e), { width: 800, height: 400 };
  }
}
async function AM({ node: t, imageOverrides: e }) {
  var A, n, s, r;
  let i = (A = t.attrs) == null ? void 0 : A.src;
  if (!i) throw new Error("Image node missing src attribute.");
  let o = await fetch(i);
  if (!o.ok) throw new Error(`Failed to fetch image from ${i}: ${o.statusText}`);
  let a = await o.arrayBuffer(), c = typeof Buffer < "u" && typeof Buffer.from == "function" ? Buffer.from(a) : new Uint8Array(a), l = _le(i, o.headers), B = { width: 800, height: 400 };
  try {
    B = await $le(c);
  } catch (I) {
    console.warn("Could not determine intrinsic dimensions, using defaults.", I);
  }
  let g = ((n = t.attrs) == null ? void 0 : n.width) != null ? Number(t.attrs.width) : null, h = ((s = t.attrs) == null ? void 0 : s.height) != null ? Number(t.attrs.height) : null, u = g !== null && !Number.isNaN(g) && g > 0 ? g : null, d = h !== null && !Number.isNaN(h) && h > 0 ? h : null, w, Q;
  if (u !== null && d !== null) w = jc(u), Q = jc(d);
  else if (u !== null) {
    let I = B.height / B.width;
    w = jc(u), Q = w * I;
  } else if (d !== null) {
    let I = B.width / B.height;
    Q = jc(d), w = Q * I;
  } else w = jc(B.width), Q = jc(B.height);
  let p = (r = t.attrs) != null && r.alt ? { name: t.attrs.alt, description: t.attrs.alt } : void 0, M;
  return l === "svg" ? M = { data: c, transformation: { width: w, height: Q }, altText: p, type: l, ...e, fallback: { type: "jpg", data: "" } } : M = { data: c, transformation: { width: w, height: Q }, altText: p, type: l, ...e }, new Bre(M);
}
async function eBe({ node: t, imageOverrides: e }) {
  let A = await AM({ node: t, imageOverrides: e });
  return new gA({ children: [A] });
}
var tBe = (t) => {
  let { columnCount: e, columnAlignment: A = "center" } = t, n = new K({ name: "m:mcPr", children: [new K({ name: "m:count", attributes: { val: { key: "m:val", value: e.toString() } } }), new K({ name: "m:mcJc", attributes: { val: { key: "m:val", value: A } } })] }), s = new K({ name: "m:mc", children: [n] }), r = new K({ name: "m:mcs", children: [s] }), i = new K({ name: "w:rPr", children: [new K({ name: "w:rFonts", attributes: { ascii: { key: "w:ascii", value: "Cambria Math" }, hAnsi: { key: "w:hAnsi", value: "Cambria Math" } } }), new K({ name: "w:i" })] }), o = new K({ name: "m:ctrlPr", children: [i] });
  return new K({ name: "m:mPr", children: [r, o] });
}, ABe = (t) => new K({ name: "m:e", children: t }), nBe = (t) => {
  let e = t.cells.map((A) => ABe(A));
  return new K({ name: "m:mr", children: e });
}, sBe = (t) => {
  let { rows: e, columnCount: A, columnAlignment: n } = t, s = tBe({ columnCount: A, columnAlignment: n }), r = e.map((i) => nBe(i));
  return new K({ name: "m:m", children: [s, ...r] });
}, rBe = { "\\sin": "sin", "\\cos": "cos", "\\tan": "tan", "\\sec": "sec", "\\csc": "csc", "\\cot": "cot", "\\sinh": "sinh", "\\cosh": "cosh", "\\tanh": "tanh", "\\sech": "sech", "\\csch": "csch", "\\coth": "coth", "\\arcsin": "arcsin", "\\arccos": "arccos", "\\arctan": "arctan", "\\arcsec": "arcsec", "\\arccsc": "arccsc", "\\arccot": "arccot", "\\log": "log", "\\ln": "ln", "\\sum": "∑", "\\int": "∫", "\\oint": "∮", "\\iint": "∬", "\\iiint": "∭", "\\prod": "∏", "\\coprod": "∐", "\\lim": "lim", "\\limsup": "lim sup", "\\liminf": "lim inf", "\\max": "max", "\\min": "min", "\\sup": "sup", "\\inf": "inf", "\\arg": "arg", "\\ker": "ker", "\\dim": "dim", "\\hom": "hom", "\\det": "det", "\\exp": "exp", "\\deg": "deg", "\\gcd": "gcd", "\\lcm": "lcm", "\\alpha": "α", "\\beta": "β", "\\gamma": "γ", "\\delta": "δ", "\\epsilon": "ε", "\\varepsilon": "ε", "\\zeta": "ζ", "\\eta": "η", "\\theta": "θ", "\\vartheta": "ϑ", "\\iota": "ι", "\\kappa": "κ", "\\lambda": "λ", "\\mu": "μ", "\\nu": "ν", "\\xi": "ξ", "\\omicron": "ο", "\\pi": "π", "\\varpi": "ϖ", "\\rho": "ρ", "\\varrho": "ϱ", "\\sigma": "σ", "\\varsigma": "ς", "\\tau": "τ", "\\upsilon": "υ", "\\phi": "φ", "\\varphi": "φ", "\\chi": "χ", "\\psi": "ψ", "\\omega": "ω", "\\Alpha": "Α", "\\Beta": "Β", "\\Gamma": "Γ", "\\Delta": "Δ", "\\Epsilon": "Ε", "\\Zeta": "Ζ", "\\Eta": "Η", "\\Theta": "Θ", "\\Iota": "Ι", "\\Kappa": "Κ", "\\Lambda": "Λ", "\\Mu": "Μ", "\\Nu": "Ν", "\\Xi": "Ξ", "\\Omicron": "Ο", "\\Pi": "Π", "\\Rho": "Ρ", "\\Sigma": "Σ", "\\Tau": "Τ", "\\Upsilon": "Υ", "\\Phi": "Φ", "\\Chi": "Χ", "\\Psi": "Ψ", "\\Omega": "Ω", "\\infty": "∞", "\\pm": "±", "\\mp": "∓", "\\cdot": "⋅", "\\times": "×", "\\div": "÷", "\\setminus": "∖", "\\backslash": "∖", "\\partial": "∂", "\\nabla": "∇", "\\triangle": "△", "\\square": "□", "\\blacksquare": "■", "\\diamond": "◊", "\\blackdiamond": "◆", "\\emptyset": "∅", "\\varnothing": "∅", "\\leq": "≤", "\\le": "≤", "\\geq": "≥", "\\ge": "≥", "\\neq": "≠", "\\ne": "≠", "\\ll": "≪", "\\gg": "≫", "\\lll": "⋘", "\\ggg": "⋙", "\\approx": "≈", "\\simeq": "≃", "\\cong": "≅", "\\equiv": "≡", "\\sim": "∼", "\\propto": "∝", "\\prec": "≺", "\\succ": "≻", "\\preceq": "⪯", "\\succeq": "⪰", "\\parallel": "∥", "\\perp": "⊥", "\\mid": "∣", "\\nmid": "∤", "\\sub": "⊂", "\\cup": "∪", "\\cap": "∩", "\\subset": "⊂", "\\supset": "⊃", "\\subseteq": "⊆", "\\supseteq": "⊇", "\\subsetneq": "⊊", "\\supsetneq": "⊋", "\\in": "∈", "\\notin": "∉", "\\ni": "∋", "\\owns": "∋", "\\notni": "∌", "\\sqsubset": "⊏", "\\sqsupset": "⊐", "\\sqsubseteq": "⊑", "\\sqsupseteq": "⊒", "\\bigcup": "⋃", "\\bigcap": "⋂", "\\bigsqcup": "⊔", "\\exists": "∃", "\\forall": "∀", "\\neg": "¬", "\\land": "∧", "\\lor": "∨", "\\lnot": "¬", "\\top": "⊤", "\\bot": "⊥", "\\vdash": "⊢", "\\models": "⊨", "\\leftarrow": "←", "\\gets": "←", "\\rightarrow": "→", "\\to": "→", "\\leftrightarrow": "↔", "\\uparrow": "↑", "\\downarrow": "↓", "\\updownarrow": "↕", "\\Leftarrow": "⇐", "\\Rightarrow": "⇒", "\\implies": "⇒", "\\Leftrightarrow": "⇔", "\\iff": "⇔", "\\Uparrow": "⇑", "\\Downarrow": "⇓", "\\Updownarrow": "⇕", "\\mapsto": "↦", "\\longmapsto": "⟼", "\\hookleftarrow": "↩", "\\hookrightarrow": "↪", "\\leftharpoonup": "↼", "\\rightharpoonup": "⇀", "\\leftharpoondown": "↽", "\\rightharpoondown": "⇁", "\\rightleftharpoons": "⇌", "\\overleftarrow": "←", "\\overrightarrow": "→", "\\overleftrightarrow": "↔", "\\from": "←", "\\ast": "∗", "\\star": "⋆", "\\circ": "∘", "\\bullet": "•", "\\dot": "˙", "\\ddot": "¨", "\\tilde": "~", "\\bar": "¯", "\\hat": "^", "\\check": "ˇ", "\\acute": "´", "\\grave": "`", "\\overline": "¯", "\\underline": "¯", "\\overbrace": "⏞", "\\underbrace": "⏟", "\\sqrt": "√", "\\mathbb{N}": "ℕ", "\\mathbb{Z}": "ℤ", "\\mathbb{Q}": "ℚ", "\\mathbb{R}": "ℝ", "\\mathbb{C}": "ℂ", "\\mathbb{H}": "ℍ", "\\mathbb{P}": "ℙ", "\\mathbb{E}": "E", "\\lfloor": "⌊", "\\rfloor": "⌋", "\\lceil": "⌈", "\\rceil": "⌉", "\\langle": "⟨", "\\rangle": "⟩", "\\lbrace": "{", "\\rbrace": "}", "\\lvert": "|", "\\rvert": "|", "\\lVert": "‖", "\\rVert": "‖", "\\angle": "∠", "\\measuredangle": "∡", "\\sphericalangle": "∢", "\\therefore": "∴", "\\because": "∵", "\\QED": "∎", "\\boxtimes": "⊠", "\\boxplus": "⊞", "\\boxminus": "⊟", "\\boxdot": "⊡", "\\bmod": "mod", "\\pmod": "mod", "\\mod": "mod", "\\Re": "ℜ", "\\Im": "ℑ", "\\wp": "℘", "\\ell": "ℓ", "\\hbar": "ℏ", "\\mho": "℧", "\\Finv": "Ⅎ", "\\Game": "⅁", "\\Bbbk": "𝕜", "\\vec": "⃗", "\\mathring": "˚" };
function Tn(t) {
  let e = [], A = t.trim().replace(/\\\\/g, "\\");
  for (; A.length > 0; ) {
    let n = !1, s = A.match(/^\\sqrt\[([^\]]*)\]\{([^}]*)\}/);
    if (s) {
      let r = s[1], i = s[2], o = Tn(r), a = Tn(i);
      e.push(new RN({ children: a, degree: o })), A = A.slice(s[0].length), n = !0;
    }
    if (!n && (s = A.match(/^\\sqrt\{([^}]*)\}/), s)) {
      let r = s[1], i = Tn(r);
      e.push(new RN({ children: i })), A = A.slice(s[0].length), n = !0;
    }
    if (!n && (s = A.match(/^\\frac\{([^}]*)\}\{([^}]*)\}/), s)) {
      let r = Tn(s[1]), i = Tn(s[2]);
      e.push(new kN({ numerator: r, denominator: i })), A = A.slice(s[0].length), n = !0;
    }
    if (!n && (s = A.match(/^\\binom\{([^}]*)\}\{([^}]*)\}/), s)) {
      let r = Tn(s[1]), i = Tn(s[2]);
      e.push(new TA("(")), e.push(new kN({ numerator: r, denominator: i })), e.push(new TA(")")), A = A.slice(s[0].length), n = !0;
    }
    if (!n) {
      for (let [r, i] of Object.entries(rBe)) if (A.startsWith(r)) {
        e.push(new TA(i)), A = A.slice(r.length), n = !0;
        break;
      }
    }
    if (!n && (s = A.match(/^_(\{[^}]*\}|.)\^(\{[^}]*\}|.)/) || A.match(/^\^(\{[^}]*\}|.)_(\{[^}]*\}|.)/), s)) {
      e.length === 0 && e.push(new TA(""));
      let r = e.pop(), i, o;
      A.startsWith("_") ? (i = s[1].startsWith("{") ? s[1].slice(1, -1) : s[1], o = s[2].startsWith("{") ? s[2].slice(1, -1) : s[2]) : (o = s[1].startsWith("{") ? s[1].slice(1, -1) : s[1], i = s[2].startsWith("{") ? s[2].slice(1, -1) : s[2]);
      let a = Tn(i), c = Tn(o);
      e.push(new _ie({ children: [r], subScript: a, superScript: c })), A = A.slice(s[0].length), n = !0;
    }
    if (!n && (s = A.match(/^\^(\{[^}]*\}|.)/), s)) {
      e.length === 0 && e.push(new TA(""));
      let r = e.pop(), i = s[1].startsWith("{") ? s[1].slice(1, -1) : s[1], o = Tn(i);
      e.push(new Vie({ children: [r], superScript: o })), A = A.slice(s[0].length), n = !0;
    }
    if (!n && (s = A.match(/^_(\{[^}]*\}|.)/), s)) {
      e.length === 0 && e.push(new TA(""));
      let r = e.pop(), i = s[1].startsWith("{") ? s[1].slice(1, -1) : s[1], o = Tn(i);
      e.push(new Zie({ children: [r], subScript: o })), A = A.slice(s[0].length), n = !0;
    }
    if (n || (s = A.match(/^\\(left|right)(.?)/), s && (s[2] && s[2] !== "\\" && s[2] !== "." && e.push(new TA(s[2])), A = A.slice(s[0].length), n = !0)), !n && (s = A.match(/^\\begin\{matrix\}([\s\S]*?)\\end\{matrix\}/), s)) {
      let r = s[1].split(/\\\\|\\(?=[0-9&])/).filter((a) => a.trim()).map((a) => ({ cells: a.split("&").map((c) => c.trim()).map((c) => c ? Tn(c) : [new TA("")]) })), i = r.length > 0 ? r[0].cells.length : 1, o = sBe({ rows: r, columnCount: i, columnAlignment: "center" });
      e.push(o), A = A.slice(s[0].length), n = !0;
    }
    n || (s = A.match(/^\\begin\{[^}]*\}/), s && (A = A.slice(s[0].length), n = !0)), n || (s = A.match(/^\\end\{[^}]*\}/), s && (A = A.slice(s[0].length), n = !0)), n || (s = A.match(/^\\text\{([^}]*)\}/), s && (e.push(new TA(s[1])), A = A.slice(s[0].length), n = !0)), !n && (A.startsWith("&") || A.startsWith("\\\\")) && (A.startsWith("&") ? (e.push(new TA(" ")), A = A.slice(1)) : (e.push(new TA(" ")), A = A.slice(2)), n = !0), n || (s = A.match(/^\\([a-zA-Z]+)/), s && (e.push(new TA(s[1])), A = A.slice(s[0].length), n = !0)), n || (s = A.match(/^[^\\^_]+/), s && (e.push(new TA(s[0])), A = A.slice(s[0].length), n = !0)), n || (e.push(new TA(A.charAt(0))), A = A.slice(1), n = !0);
  }
  return e.length > 0 ? e : [new TA(t)];
}
function MD(t) {
  var e;
  if (!((e = t.attrs) != null && e.latex)) return null;
  let A = t.attrs.latex;
  try {
    let n = Tn(A);
    return new Xd({ children: n });
  } catch {
    return new Xd({ children: [new TA(A)] });
  }
}
function iBe(t) {
  return t * 0.75 * 2;
}
function oBe(t) {
  let e = t.replace(/"/g, "").split(",").find((A) => A.trim().length > 0);
  return e ? e.trim() : t;
}
function aBe(t) {
  return Object.values($ne).includes(t);
}
function pD(t, e) {
  let A = {}, n = !1, s = {};
  t.marks && t.marks.forEach((a) => {
    var c, l;
    switch (a.type) {
      case "bold":
        A.bold = !0;
        break;
      case "italic":
        A.italics = !0;
        break;
      case "underline":
        A.underline = { type: df.SINGLE };
        break;
      case "strike":
        A.strike = !0;
        break;
      case "code":
        A.style = "Code";
        break;
      case "textStyle":
        if (a.attrs) {
          if (a.attrs.color && a.attrs.color !== "") {
            let B = cg(a.attrs.color);
            B !== null ? A.color = B : console.warn(`[convertTextNode] Unrecognized color: "${a.attrs.color}". Supported formats: #RRGGBB, #RGB, rgb(r,g,b), rgba(r,g,b,a), and named colors: ${new Intl.ListFormat("en", { style: "long", type: "conjunction" }).format(Object.keys(FH))}. This color will be ignored.`);
          }
          if (a.attrs.fontFamily && (A.font = oBe(a.attrs.fontFamily)), a.attrs.fontSize) {
            let B = parseInt(a.attrs.fontSize, 10);
            Number.isNaN(B) ? console.warn(`[convertTextNode] Invalid fontSize: ${a.attrs.fontSize}. Expected a valid number. This value will be ignored.`) : A.size = iBe(B);
          }
          if (a.attrs.backgroundColor && a.attrs.backgroundColor !== "" && !A.shading) {
            let B = cg(a.attrs.backgroundColor);
            B !== null ? A.shading = { type: th.CLEAR, fill: B } : console.warn(`[convertTextNode] Unrecognized backgroundColor: "${a.attrs.backgroundColor}". Supported formats: #RRGGBB, #RGB, rgb(r,g,b), rgba(r,g,b,a), and named colors. This value will be ignored.`);
          }
        }
        break;
      case "highlight":
        if (!((c = a.attrs) != null && c.color)) {
          A.highlight = "yellow";
          break;
        }
        if (aBe(a.attrs.color)) {
          A.highlight = a.attrs.color;
          break;
        }
        {
          let B = cg(a.attrs.color);
          B !== null ? A.shading = { type: th.CLEAR, fill: B } : A.highlight = "yellow";
        }
        break;
      case "link":
        n = !0, A.style = "Hyperlink", s.href = (l = a.attrs) == null ? void 0 : l.href;
        break;
    }
  });
  let r = t.text || "", i = cBe(r), o = new nr(i ? { ...e, ...A, children: i } : { ...e, text: r, ...A });
  return n && s ? new yie({ link: s.href, children: [o] }) : o;
}
function cBe(t) {
  if (!t.includes("{page}") && !t.includes("{total}")) return null;
  let e = [], A = /\{page\}|\{total\}/g, n = 0, s = A.exec(t);
  for (; s !== null; ) s.index > n && e.push(t.slice(n, s.index)), e.push(s[0] === "{page}" ? _c.CURRENT : _c.TOTAL_PAGES), n = A.lastIndex, s = A.exec(t);
  return n < t.length && e.push(t.slice(n)), e;
}
async function sh({ node: t, customNodes: e, options: A, list: n, paragraphOverrides: s, textRunOverrides: r, imageOverrides: i }) {
  var o, a, c, l, B, g, h;
  if (A != null && A.style) {
    let I = (await Promise.all((t.content || []).map(async (N) => N.type === "inlineMath" ? MD(N) : N.type === "hardBreak" ? new nr({ text: "", break: 1 }) : N.type === "image" ? AM({ node: N, imageOverrides: i }) : pD(N, r)))).filter((N) => N !== null);
    return new gA({ ...s, children: I, style: A.style });
  }
  let u = bt.LEFT;
  if ((o = t.attrs) != null && o.textAlign) switch (t.attrs.textAlign) {
    case "center":
      u = bt.CENTER;
      break;
    case "right":
      u = bt.RIGHT;
      break;
    case "justify":
      u = bt.JUSTIFIED;
      break;
    default:
      u = bt.LEFT;
  }
  let d = 1, w = (c = (a = t.marks) == null ? void 0 : a.filter((I) => I.type === "textStyle")) != null ? c : [];
  w.length > 0 && (l = w[0].attrs) != null && l.lineHeight && (d = w[0].attrs.lineHeight);
  let Q = { paragraphs: [], currentRuns: [] }, p = await (t.content || []).reduce(async (I, N) => {
    let m = await I, E = e.find((Y) => Y.type === N.type);
    if (E) {
      let Y = E.render(N);
      if (Y === null) return m;
      if (Y instanceof nr) return m.currentRuns.push(Y), m;
    }
    if (N.type === "inlineMath") {
      let Y = MD(N);
      return Y && m.currentRuns.push(Y), m;
    }
    if (N.type === "hardBreak") return m.currentRuns.push(new nr({ text: "", break: 1 })), m;
    if (N.type === "image") {
      let Y = await AM({ node: N, imageOverrides: i });
      return m.currentRuns.push(Y), m;
    }
    let G = pD(N, r);
    return G && m.currentRuns.push(G), m;
  }, Promise.resolve(Q));
  if (p.currentRuns.length === 0 && p.paragraphs.length === 0) return [];
  let M;
  if ((B = t.attrs) != null && B.level) switch (t.attrs.level) {
    case 1:
      M = zc.HEADING_1;
      break;
    case 2:
      M = zc.HEADING_2;
      break;
    case 3:
      M = zc.HEADING_3;
      break;
    case 4:
      M = zc.HEADING_4;
      break;
    case 5:
      M = zc.HEADING_5;
      break;
    case 6:
      M = zc.HEADING_6;
      break;
    default:
      M = void 0;
  }
  return p.paragraphs.push(new gA({ ...s, children: p.currentRuns, alignment: u, spacing: { line: $A(d) }, ...(n == null ? void 0 : n.type) === "bullet" && { numbering: { reference: "bullet-list", level: (g = n.level) != null ? g : 0 } }, ...(n == null ? void 0 : n.type) === "ordered" && { numbering: { reference: "ordered-list", level: (h = n.level) != null ? h : 0, instance: n.orderedListInstanceId } }, ...M && { heading: M } })), p.paragraphs.length === 1 ? p.paragraphs[0] : p.paragraphs;
}
async function lBe({ node: t, customNodes: e, paragraphOverrides: A, textRunOverrides: n, imageOverrides: s }) {
  return sh({ node: t, customNodes: e, paragraphOverrides: A, textRunOverrides: n, imageOverrides: s });
}
var BBe = () => new K({ name: "v:rect", attributes: { style: { key: "style", value: "width:0.0pt;height:.05pt;mso-width-percent:0;mso-height-percent:0;mso-width-percent:0;mso-height-percent:0" }, hr: { key: "o:hr", value: "t" }, hrstd: { key: "o:hrstd", value: "t" }, hralign: { key: "o:hralign", value: "center" }, fillcolor: { key: "fillcolor", value: "#A0A0A0" }, stroked: { key: "stroked", value: "f" } } }), gBe = (t) => new K({ name: "w:pict", children: t }), hBe = () => new gA({ children: [new Or({ children: [gBe([BBe()])] })], style: "horizontalRule" }), nM = /* @__PURE__ */ new Set();
function uBe() {
  let t;
  do
    t = Math.floor(Math.random() * 1e6) + 1;
  while (nM.has(t));
  return nM.add(t), t;
}
function dBe() {
  nM.clear();
}
async function xH({ node: t, customNodes: e, level: A = 0, paragraphOverrides: n, textRunOverrides: s, imageOverrides: r }) {
  let i = uBe(), o = t.content || [];
  return (await Promise.all(o.map((a) => $m({ item: a, listType: "ordered", level: A, orderedListInstanceId: i, customNodes: e, paragraphOverrides: n, textRunOverrides: s, imageOverrides: r })))).flat().filter((a) => a !== null);
}
async function $m({ item: t, listType: e, level: A = 0, orderedListInstanceId: n, customNodes: s, paragraphOverrides: r, textRunOverrides: i, imageOverrides: o }) {
  if (!t.content) return [];
  let a = [], c = t.content;
  for (let l = 0, B = c.length; l < B; l++) {
    let g = c[l];
    if (g.type === "paragraph") {
      let h = await sh({ node: g, customNodes: s, list: { type: e, level: A, orderedListInstanceId: n }, paragraphOverrides: r, textRunOverrides: i, imageOverrides: o });
      Array.isArray(h) ? a.push(...h) : a.push(h);
    } else if (g.type === "bulletList") a.push(...await GH({ node: g, customNodes: s, level: A + 1, paragraphOverrides: r, textRunOverrides: i, imageOverrides: o }));
    else if (g.type === "orderedList") a.push(...await xH({ node: g, level: A + 1, customNodes: s, paragraphOverrides: r, textRunOverrides: i, imageOverrides: o }));
    else {
      let h = await sh({ node: g, customNodes: s, paragraphOverrides: r, textRunOverrides: i, imageOverrides: o });
      Array.isArray(h) ? a.push(...h) : a.push(h);
    }
  }
  return a;
}
async function GH({ node: t, customNodes: e, level: A = 0, paragraphOverrides: n, textRunOverrides: s, imageOverrides: r }) {
  let i = t.content || [];
  return (await Promise.all(i.map((o) => $m({ item: o, listType: "bullet", level: A, customNodes: e, paragraphOverrides: n, textRunOverrides: s, imageOverrides: r })))).flat().filter((o) => o !== null);
}
function wBe({ node: t }) {
  var e;
  if (!((e = t.attrs) != null && e.latex)) return null;
  let A = t.attrs.latex;
  try {
    let n = Tn(A);
    return new gA({ children: [new Xd({ children: n })] });
  } catch {
    return new gA({ children: [new Xd({ children: [new TA(A)] })] });
  }
}
var fBe = () => new gA({ children: [new fie()] });
async function QBe({ node: t, customNodes: e, paragraphOverrides: A, textRunOverrides: n, imageOverrides: s }) {
  return t.content ? (await Promise.all(t.content.map((r) => sh({ node: r, customNodes: e, options: { style: "Quote" }, paragraphOverrides: A, textRunOverrides: n, imageOverrides: s })))).flatMap((r) => Array.isArray(r) ? r : [r]) : [];
}
var zH = { cm: 566.9291338582677, mm: 56.69291338582678, in: 1440, pt: 20, pc: 240, px: 15 };
function IBe(t) {
  return t in zH;
}
function pi(t) {
  if (typeof t == "number") return Math.round(t);
  let e = t.match(/^(-?\d+(?:\.\d+)?)(cm|mm|in|pt|pc|px)$/);
  if (!e) throw new TypeError(`[universalMeasureToTwips] Unrecognized measure: "${t}". Expected a number followed by a unit (cm, mm, in, pt, pc, px).`);
  let A = parseFloat(e[1]), n = e[2];
  if (!IBe(n)) throw new TypeError(`[universalMeasureToTwips] Unsupported unit: "${n}". Expected one of: cm, mm, in, pt, pc, px.`);
  return Math.round(A * zH[n]);
}
async function CBe({ node: t, customNodes: e, columnWidthPercentage: A, columnWidthTwips: n, totalColumns: s, pageSize: r, pageMargins: i, tableOverrides: o, tableCellOverrides: a, paragraphOverrides: c, textRunOverrides: l, imageOverrides: B }) {
  var g, h, u;
  let d = (t.content || []).map((G) => Mf({ node: G, customNodes: e, pageSize: r, pageMargins: i, tableOverrides: o, tableCellOverrides: a, paragraphOverrides: c, textRunOverrides: l, imageOverrides: B })), w = await Promise.all(d), Q = [];
  for (let G of w) Array.isArray(G) ? Q.push(...G) : (G instanceof gA || G instanceof Km) && Q.push(G);
  Q.length === 0 && Q.push(new gA({ children: [] }));
  let p = (g = t.attrs) != null && g.colspan ? Number(t.attrs.colspan) : 1, M = (u = (h = t.attrs) == null ? void 0 : h.colwidth) != null ? u : null, I = M && M.length > 0 ? M.reduce((G, Y) => G + Math.round(Y * 15), 0) : null, N = n !== void 0, m;
  I !== null ? m = I : N ? m = n * p : A ? m = A * p : m = 100 / s * p;
  let E = { ...a, children: Q, width: { size: m, type: I !== null || N ? zs.DXA : zs.PERCENTAGE } };
  return t.attrs && (t.attrs.colspan && Number(t.attrs.colspan) > 1 && (E.columnSpan = Number(t.attrs.colspan)), t.attrs.rowspan && Number(t.attrs.rowspan) > 1 && (E.rowSpan = Number(t.attrs.rowspan))), new PE(E);
}
function EBe(t) {
  let e = (t.content || []).map((A) => (A.content || []).reduce((n, s) => {
    var r;
    let i = (r = s.attrs) != null && r.colspan ? Number(s.attrs.colspan) : 1;
    return n + Math.max(1, i);
  }, 0));
  return Math.max(...e, 0) || 1;
}
async function MBe({ node: t, customNodes: e, pageSize: A, pageMargins: n, tableOverrides: s, tableCellOverrides: r, paragraphOverrides: i, textRunOverrides: o, imageOverrides: a }) {
  let c = EBe(t), l = pi((A == null ? void 0 : A.width) || "21.0cm"), B = pi((n == null ? void 0 : n.left) || "3.17cm"), g = pi((n == null ? void 0 : n.right) || "3.17cm"), h = l - B - g, u = 100 / c, d = Math.floor(h / c), w = await Promise.all((t.content || []).map(async (p) => {
    let M = await Promise.all((p.content || []).map(async (I) => CBe({ node: I, customNodes: e, columnWidthPercentage: u, columnWidthTwips: d, totalColumns: c, pageSize: A, pageMargins: n, tableOverrides: s, tableCellOverrides: r, paragraphOverrides: i, textRunOverrides: o, imageOverrides: a })));
    return new rH({ children: M });
  })), Q = { style: gf.SINGLE, size: 4, color: "auto" };
  return new Km({ width: { size: h, type: zs.DXA }, layout: Soe.FIXED, columnWidths: Array(c).fill(d), margins: { top: pn(0.08), bottom: pn(0.08), left: pn(0.08), right: pn(0.08) }, borders: { top: Q, bottom: Q, left: Q, right: Q, insideHorizontal: Q, insideVertical: Q }, ...s, rows: w });
}
async function Mf({ node: t, customNodes: e = [], pageSize: A, pageMargins: n, tableOverrides: s, paragraphOverrides: r, textRunOverrides: i, tableCellOverrides: o, imageOverrides: a }) {
  switch (t.type) {
    case "paragraph":
      return sh({ node: t, customNodes: e, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "bulletList":
      return GH({ node: t, customNodes: e, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "orderedList":
      return xH({ node: t, customNodes: e, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "listItem":
      return $m({ item: t, listType: "bullet", customNodes: e, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "table":
      return MBe({ node: t, customNodes: e, pageSize: A, pageMargins: n, tableOverrides: s, tableCellOverrides: o, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "image":
      return [await eBe({ node: t, imageOverrides: a })];
    case "heading":
      return lBe({ node: t, customNodes: e, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "blockquote":
      return QBe({ node: t, customNodes: e, paragraphOverrides: r, textRunOverrides: i, imageOverrides: a });
    case "horizontalRule":
      return hBe();
    case "pageBreak":
      return fBe();
    case "blockMath":
      return wBe({ node: t });
    default: {
      if (e) {
        let c = e.find((l) => l.type === t.type);
        return c ? c.render(t) : (console.error(`Custom node "${t.type}" not found`), []);
      }
      return [];
    }
  }
}
function $d(t, e) {
  return typeof t != "object" || t === null ? e : (typeof e != "object" || e === null || Object.keys(e).forEach((A) => {
    let n = e[A], s = t[A];
    if (Array.isArray(n) && !Array.isArray(s)) t[A] = [...n];
    else if (Array.isArray(n) && Array.isArray(s)) {
      let r = [...s];
      n.forEach((i) => {
        if (i && typeof i == "object" && i.id) {
          let o = r.findIndex((a) => a.id === i.id);
          o !== -1 ? r[o] = $d(r[o], i) : r.push(i);
        } else r.push(i);
      }), t[A] = r;
    } else typeof n == "object" ? t[A] = $d(typeof s == "object" && s !== null ? s : {}, n) : t[A] = n;
  }), t);
}
async function pBe({ node: t, customNodes: e = [], styleOverrides: A, pageSize: n, pageMargins: s, tableOverrides: r, paragraphOverrides: i, textRunOverrides: o, tableCellOverrides: a, imageOverrides: c, headers: l, footers: B }) {
  let g = $d(structuredClone(Vle), A), h = (t.content || []).map((Q) => Mf({ node: Q, customNodes: e, pageSize: n, pageMargins: s, tableOverrides: r, paragraphOverrides: i, textRunOverrides: o, tableCellOverrides: a, imageOverrides: c })), u = (await Promise.all(h)).flatMap((Q) => Array.isArray(Q) ? Q : Q instanceof gA || Q instanceof Km ? [Q] : []), d = { default: (l == null ? void 0 : l.default) instanceof Function ? await l.default() : l == null ? void 0 : l.default, first: (l == null ? void 0 : l.first) instanceof Function ? await l.first() : l == null ? void 0 : l.first, even: (l == null ? void 0 : l.even) instanceof Function ? await l.even() : l == null ? void 0 : l.even }, w = { default: (B == null ? void 0 : B.default) instanceof Function ? await B.default() : B == null ? void 0 : B.default, first: (B == null ? void 0 : B.first) instanceof Function ? await B.first() : B == null ? void 0 : B.first, even: (B == null ? void 0 : B.even) instanceof Function ? await B.even() : B == null ? void 0 : B.even };
  return dBe(), new lle({ numbering: { config: [{ reference: "bullet-list", levels: [{ level: 0, format: Ht.BULLET, text: "•", alignment: "left", style: { paragraph: { indent: { left: 720, hanging: 360 } }, run: { font: "Symbol" } } }, { level: 1, format: Ht.BULLET, text: "o", alignment: "left", style: { paragraph: { indent: { left: 1140, hanging: 360 } }, run: { font: "Courier New" } } }, { level: 2, format: Ht.BULLET, text: "", alignment: "left", style: { paragraph: { indent: { left: 1440, hanging: 360 } }, run: { font: "Wingdings" } } }, { level: 3, format: Ht.BULLET, text: "•", alignment: "left", style: { paragraph: { indent: { left: 1740, hanging: 360 } }, run: { font: "Symbol" } } }, { level: 4, format: Ht.BULLET, text: "o", alignment: "left", style: { paragraph: { indent: { left: 2040, hanging: 360 } }, run: { font: "Courier New" } } }, { level: 5, format: Ht.BULLET, text: "", alignment: "left", style: { paragraph: { indent: { left: 2340, hanging: 360 } }, run: { font: "Wingdings" } } }, { level: 6, format: Ht.BULLET, text: "•", alignment: "left", style: { paragraph: { indent: { left: 2640, hanging: 360 } }, run: { font: "Symbol" } } }, { level: 7, format: Ht.BULLET, text: "o", alignment: "left", style: { paragraph: { indent: { left: 2940, hanging: 360 } }, run: { font: "Courier New" } } }, { level: 8, format: Ht.BULLET, text: "", alignment: "left", style: { paragraph: { indent: { left: 3240, hanging: 360 } }, run: { font: "Wingdings" } } }] }, { reference: "ordered-list", levels: [{ level: 0, format: Ht.DECIMAL, text: "%1.", alignment: "left", style: { paragraph: { indent: { left: 720, hanging: 360 } } } }, { level: 1, format: Ht.DECIMAL, text: "%2.", alignment: "left", style: { paragraph: { indent: { left: 1140, hanging: 360 } } } }, { level: 2, format: Ht.DECIMAL, text: "%3.", alignment: "left", style: { paragraph: { indent: { left: 1440, hanging: 360 } } } }, { level: 3, format: Ht.DECIMAL, text: "%4.", alignment: "left", style: { paragraph: { indent: { left: 1740, hanging: 360 } } } }, { level: 4, format: Ht.DECIMAL, text: "%5.", alignment: "left", style: { paragraph: { indent: { left: 2040, hanging: 360 } } } }, { level: 5, format: Ht.DECIMAL, text: "%6.", alignment: "left", style: { paragraph: { indent: { left: 2340, hanging: 360 } } } }, { level: 6, format: Ht.DECIMAL, text: "%7.", alignment: "left", style: { paragraph: { indent: { left: 2640, hanging: 360 } } } }, { level: 7, format: Ht.DECIMAL, text: "%8.", alignment: "left", style: { paragraph: { indent: { left: 2940, hanging: 360 } } } }, { level: 8, format: Ht.DECIMAL, text: "%9.", alignment: "left", style: { paragraph: { indent: { left: 3240, hanging: 360 } } } }] }] }, evenAndOddHeaderAndFooters: !!(l != null && l.evenAndOddHeaders) || !!(B != null && B.evenAndOddFooters), sections: [{ properties: { page: { size: { width: pi((n == null ? void 0 : n.width) || "21.0cm"), height: pi((n == null ? void 0 : n.height) || "29.7cm") }, margin: { top: pi((s == null ? void 0 : s.top) || "2.54cm"), bottom: pi((s == null ? void 0 : s.bottom) || "2.54cm"), left: pi((s == null ? void 0 : s.left) || "3.17cm"), right: pi((s == null ? void 0 : s.right) || "3.17cm") } }, titlePage: !!(l != null && l.differentFirstPage) || !!(B != null && B.differentFirstPage) }, headers: d, footers: w, children: u }], styles: g });
}
var mBe = async ({ document: t, exportType: e, customNodes: A, styleOverrides: n, cssStyles: s, pageSize: r, pageMargins: i, tableOverrides: o, paragraphOverrides: a, textRunOverrides: c, tableCellOverrides: l, imageOverrides: B, headers: g = void 0, footers: h = void 0 }) => {
  let u = Kle(s), d = Object.keys(u).length > 0 ? $d(u, n ?? {}) : n, w = await pBe({ node: t, styleOverrides: d, customNodes: A, headers: g, footers: h, pageSize: r, pageMargins: i, tableOverrides: o, paragraphOverrides: a, textRunOverrides: c, tableCellOverrides: l, imageOverrides: B });
  if (!w) throw new Error("Failed to convert document");
  let Q;
  try {
    switch (e) {
      case "buffer":
        Q = await Wc.toBuffer(w);
        break;
      case "string":
        Q = await Wc.toString(w);
        break;
      case "base64":
        Q = await Wc.toBase64String(w);
        break;
      case "blob":
        Q = await Wc.toBlob(w);
        break;
      case "stream":
        Q = Wc.toStream(w);
        break;
      default:
        throw new Error("Invalid export type");
    }
  } catch (p) {
    throw new Error(`Failed to export document: ${p.message}`);
  }
  return Q;
};
function YBe(t) {
  var e, A, n, s, r, i, o, a;
  let c = Reflect.get(t, "pages");
  if (!c || typeof c != "object") return null;
  let l = Reflect.get(c, "differentOddEven"), B = Reflect.get(c, "differentFirstPage");
  return typeof l != "boolean" || typeof B != "boolean" ? null : { headerJSON: (e = Reflect.get(c, "headerJSON")) != null ? e : null, headerEvenJSON: (A = Reflect.get(c, "headerEvenJSON")) != null ? A : null, headerOddJSON: (n = Reflect.get(c, "headerOddJSON")) != null ? n : null, headerFirstPageJSON: (s = Reflect.get(c, "headerFirstPageJSON")) != null ? s : null, footerJSON: (r = Reflect.get(c, "footerJSON")) != null ? r : null, footerEvenJSON: (i = Reflect.get(c, "footerEvenJSON")) != null ? i : null, footerOddJSON: (o = Reflect.get(c, "footerOddJSON")) != null ? o : null, footerFirstPageJSON: (a = Reflect.get(c, "footerFirstPageJSON")) != null ? a : null, differentOddEven: l, differentFirstPage: B };
}
var yBe = tt.create({ name: "export-docx", addOptions() {
  return { styleOverrides: {}, customNodes: [], exportType: "blob", cssStyles: void 0, headers: void 0, footers: void 0, pageSize: void 0, pageMargins: void 0, tableOverrides: void 0, paragraphOverrides: void 0, textRunOverrides: void 0, tableCellOverrides: void 0, imageOverrides: void 0, onCompleteExport: () => {
    throw new Error("The [exportDocx] extension requires an [onCompleteExport] callback function to handle the exported DOCX file");
  } };
}, addCommands() {
  return { exportDocx: (t) => ({ editor: e }) => ((async () => {
    var A, n, s, r, i, o, a, c, l, B, g, h, u;
    let d = e.extensionManager.extensions.find((v) => v.name === "pages") ? YBe(e.storage) : null, w = e.getJSON(), Q = d ? d.headerJSON : null, p = d ? d.headerEvenJSON : null, M = d ? d.headerOddJSON : null, I = d ? d.headerFirstPageJSON : null, N = d ? d.footerJSON : null, m = d ? d.footerEvenJSON : null, E = d ? d.footerOddJSON : null, G = d ? d.footerFirstPageJSON : null, Y = { document: w, styleOverrides: (A = t == null ? void 0 : t.styleOverrides) != null ? A : this.options.styleOverrides, cssStyles: (n = t == null ? void 0 : t.cssStyles) != null ? n : this.options.cssStyles, customNodes: (s = t == null ? void 0 : t.customNodes) != null ? s : this.options.customNodes, exportType: (r = t == null ? void 0 : t.exportType) != null ? r : this.options.exportType, pageSize: (i = t == null ? void 0 : t.pageSize) != null ? i : this.options.pageSize, pageMargins: (o = t == null ? void 0 : t.pageMargins) != null ? o : this.options.pageMargins, tableOverrides: (a = t == null ? void 0 : t.tableOverrides) != null ? a : this.options.tableOverrides, paragraphOverrides: (c = t == null ? void 0 : t.paragraphOverrides) != null ? c : this.options.paragraphOverrides, textRunOverrides: (l = t == null ? void 0 : t.textRunOverrides) != null ? l : this.options.textRunOverrides, tableCellOverrides: (B = t == null ? void 0 : t.tableCellOverrides) != null ? B : this.options.tableCellOverrides, imageOverrides: (g = t == null ? void 0 : t.imageOverrides) != null ? g : this.options.imageOverrides };
    !(t != null && t.headers) && d ? (Y.headers = {}, Y.headers.default = () => ZI({ node: d.differentOddEven ? M : Q }), Y.headers.evenAndOddHeaders = d.differentOddEven, Y.headers.differentFirstPage = d.differentFirstPage, Y.headers.even = d.differentOddEven ? () => ZI({ node: p }) : void 0, Y.headers.first = d.differentFirstPage ? () => ZI({ node: I }) : void 0) : Y.headers = (h = t == null ? void 0 : t.headers) != null ? h : this.options.headers, !(t != null && t.footers) && d ? (Y.footers = {}, Y.footers.default = () => XI({ node: d.differentOddEven ? E : N }), Y.footers.evenAndOddFooters = d.differentOddEven, Y.footers.differentFirstPage = d.differentFirstPage, Y.footers.even = d.differentOddEven ? () => XI({ node: m }) : void 0, Y.footers.first = d.differentFirstPage ? () => XI({ node: G }) : void 0) : Y.footers = (u = t == null ? void 0 : t.footers) != null ? u : this.options.footers;
    let U = await mBe(Y);
    t != null && t.onCompleteExport ? t.onCompleteExport(U) : this.options.onCompleteExport(U);
  })(), !0) };
} });
async function XI({ node: t }) {
  var e;
  if (!t) return new vc({ children: [] });
  let A = t.type === "doc" ? (e = t.content) == null ? void 0 : e[0] : t;
  if (!A) return console.warn("Footer node must have a content"), new vc({ children: [] });
  if (A.type !== "paragraph" && A.type !== "table") return console.warn("Footer node must be a paragraph or table"), new vc({ children: [] });
  let n = await Mf({ node: A, customNodes: [] });
  return n ? Array.isArray(n) ? new vc({ children: n }) : new vc({ children: [n] }) : (console.warn("Failed to convert Footer node"), new vc({ children: [] }));
}
async function ZI({ node: t }) {
  var e;
  if (!t) return new bc({ children: [] });
  let A = t.type === "doc" ? (e = t.content) == null ? void 0 : e[0] : t;
  if (!A) return console.warn("Header node must have a content"), new bc({ children: [] });
  if (A.type !== "paragraph" && A.type !== "table") return console.warn("Header node must be a paragraph or table"), new bc({ children: [] });
  let n = await Mf({ node: A, customNodes: [] });
  return n ? Array.isArray(n) ? new bc({ children: n }) : new bc({ children: [n] }) : (console.warn("Failed to convert Header node"), new bc({ children: [] }));
}
var LA = [];
for (var qI = 0; qI < 256; ++qI)
  LA.push((qI + 256).toString(16).slice(1));
function FBe(t, e = 0) {
  return (LA[t[e + 0]] + LA[t[e + 1]] + LA[t[e + 2]] + LA[t[e + 3]] + "-" + LA[t[e + 4]] + LA[t[e + 5]] + "-" + LA[t[e + 6]] + LA[t[e + 7]] + "-" + LA[t[e + 8]] + LA[t[e + 9]] + "-" + LA[t[e + 10]] + LA[t[e + 11]] + LA[t[e + 12]] + LA[t[e + 13]] + LA[t[e + 14]] + LA[t[e + 15]]).toLowerCase();
}
var j0, NBe = new Uint8Array(16);
function DBe() {
  if (!j0 && (j0 = typeof crypto < "u" && crypto.getRandomValues && crypto.getRandomValues.bind(crypto), !j0))
    throw new Error("crypto.getRandomValues() not supported. See https://github.com/uuidjs/uuid#getrandomvalues-not-supported");
  return j0(NBe);
}
var xBe = typeof crypto < "u" && crypto.randomUUID && crypto.randomUUID.bind(crypto);
const mD = {
  randomUUID: xBe
};
function sM(t, e, A) {
  if (mD.randomUUID && !t)
    return mD.randomUUID();
  t = t || {};
  var n = t.random || (t.rng || DBe)();
  return n[6] = n[6] & 15 | 64, n[8] = n[8] & 63 | 128, FBe(n);
}
var GBe = ({
  getId: t,
  anchorTypes: e = ["heading"]
}) => new ct({
  key: new Bt("tableOfContent"),
  appendTransaction(A, n, s) {
    if (typeof window > "u")
      return null;
    if (A.some((o) => o.getMeta("composition")))
      return;
    const r = s.tr;
    let i = !1;
    if (A.some((o) => o.docChanged)) {
      const o = [];
      s.doc.descendants((a, c) => {
        const l = a.attrs["data-toc-id"];
        if (!(!e.includes(a.type.name) || a.textContent.length === 0)) {
          if (l == null || o.includes(l)) {
            let B = "";
            t ? B = t(a.textContent) : B = sM(), r.setNodeMarkup(c, void 0, {
              ...a.attrs,
              "data-toc-id": B,
              id: B
            }), i = !0;
          }
          o.push(l);
        }
      });
    }
    return i ? r : null;
  }
}), _I = (t, e) => {
  let A = 1;
  const n = e.at(-1), s = [...e].reverse().find((i) => i.originalLevel <= t.node.attrs.level), r = (s == null ? void 0 : s.level) || 1;
  return t.node.attrs.level > ((n == null ? void 0 : n.originalLevel) || 1) ? A = ((n == null ? void 0 : n.level) || 1) + 1 : t.node.attrs.level < ((n == null ? void 0 : n.originalLevel) || 1) ? A = r : A = (n == null ? void 0 : n.level) || 1, A;
}, $I = (t, e) => {
  const A = e.at(-1);
  return A ? ((A == null ? void 0 : A.itemIndex) || 1) + 1 : 1;
}, zBe = (t, e, A) => {
  var n, s;
  const r = A || t.node.attrs.level || 1;
  let i = 1;
  const o = e.filter((a) => a.level <= r);
  return ((n = o.at(-1)) == null ? void 0 : n.level) === r ? i = (((s = o.at(-1)) == null ? void 0 : s.itemIndex) || 1) + 1 : i = 1, i;
}, UH = (t, e) => {
  const { editor: A } = e, n = [], s = [];
  let r = null;
  if (A.isDestroyed)
    return t;
  if (A.state.doc.descendants((i, o) => {
    var a;
    (a = e.anchorTypes) != null && a.includes(i.type.name) && n.push({ node: i, pos: o });
  }), n.forEach((i) => {
    const o = A.view.domAtPos(i.pos + 1).node;
    e.storage.scrollPosition >= o.offsetTop && (r = i.node.attrs["data-toc-id"], s.push(i.node.attrs["data-toc-id"]));
  }), t = t.map((i) => ({
    ...i,
    isActive: i.id === r,
    isScrolledOver: s.includes(i.id)
  })), e.onUpdate) {
    const i = e.storage.content.length === 0;
    e.onUpdate(t, i);
  }
  return t;
}, eC = (t) => {
  const { editor: e, onUpdate: A } = t;
  if (e.isDestroyed)
    return;
  const n = [];
  let s = [];
  const r = [];
  if (e.state.doc.descendants((i, o) => {
    var a;
    (a = t.anchorTypes) != null && a.includes(i.type.name) && n.push({ node: i, pos: o });
  }), n.forEach((i, o) => {
    if (i.node.textContent.length === 0)
      return;
    const a = e.view.domAtPos(i.pos + 1).node, c = t.storage.scrollPosition >= a.offsetTop;
    r.push(a);
    const l = i.node.attrs.level, B = n[o - 1], g = t.getLevelFn(i, s), h = t.getIndexFn(i, s, g);
    if (!B) {
      s = [
        ...s,
        {
          itemIndex: h,
          id: i.node.attrs["data-toc-id"],
          originalLevel: l,
          level: g,
          textContent: i.node.textContent,
          pos: i.pos,
          editor: e,
          isActive: !1,
          isScrolledOver: c,
          node: i.node,
          dom: a
        }
      ];
      return;
    }
    s = [
      ...s,
      {
        itemIndex: h,
        id: i.node.attrs["data-toc-id"],
        originalLevel: l,
        level: g,
        textContent: i.node.textContent,
        pos: i.pos,
        editor: e,
        isActive: !1,
        isScrolledOver: !1,
        node: i.node,
        dom: a
      }
    ];
  }), s = UH(s, t), A) {
    const i = t.storage.content.length === 0;
    A(s, i);
  }
  t.storage.anchors = r, t.storage.content = s, e.state.tr.setMeta("toc", s), e.view.dispatch(e.state.tr);
}, UBe = tt.create({
  name: "tableOfContents",
  addStorage() {
    return {
      content: [],
      anchors: [],
      scrollHandler: () => null,
      scrollPosition: 0
    };
  },
  addGlobalAttributes() {
    return [
      {
        types: this.options.anchorTypes || ["headline"],
        attributes: {
          id: {
            default: null,
            renderHTML: (t) => ({
              id: t.id
            }),
            parseHTML: (t) => t.id || null
          },
          "data-toc-id": {
            default: null,
            renderHTML: (t) => ({
              "data-toc-id": t["data-toc-id"]
            }),
            parseHTML: (t) => t.dataset.tocId || null
          }
        }
      }
    ];
  },
  addOptions() {
    return {
      // eslint-disable-next-line
      onUpdate: () => {
      },
      // eslint-disable-next-line
      getId: (e) => sM(),
      scrollParent: typeof window < "u" ? () => window : void 0,
      anchorTypes: ["heading"]
    };
  },
  addCommands() {
    return {
      updateTableOfContents: () => ({ dispatch: t }) => {
        var e;
        return t && eC({
          editor: this.editor,
          storage: this.storage,
          onUpdate: (e = this.options.onUpdate) == null ? void 0 : e.bind(this),
          getIndexFn: this.options.getIndex || $I,
          getLevelFn: this.options.getLevel || _I,
          anchorTypes: this.options.anchorTypes
        }), !0;
      }
    };
  },
  onTransaction({ transaction: t }) {
    var e;
    t.docChanged && !t.getMeta("toc") && eC({
      editor: this.editor,
      storage: this.storage,
      onUpdate: (e = this.options.onUpdate) == null ? void 0 : e.bind(this),
      getIndexFn: this.options.getIndex || $I,
      getLevelFn: this.options.getLevel || _I,
      anchorTypes: this.options.anchorTypes
    });
  },
  onCreate() {
    var t;
    if (typeof window > "u" || !this.editor.view)
      return;
    const { tr: e } = this.editor.state, A = [];
    if (this.options.scrollParent && typeof this.options.scrollParent != "function" && console.warn(
      "[Tiptap Table of Contents Deprecation Notice]: The 'scrollParent' option must now be provided as a callback function that returns the 'scrollParent' element. The ability to pass this option directly will be deprecated in future releases."
    ), this.editor.state.doc.descendants((s, r) => {
      var i;
      const o = s.attrs["data-toc-id"];
      if (!(!((i = this.options.anchorTypes) != null && i.includes(s.type.name)) || s.textContent.length === 0)) {
        if (o == null || A.includes(o)) {
          let c = "";
          this.options.getId ? c = this.options.getId(s.textContent) : c = sM(), e.setNodeMarkup(r, void 0, {
            ...s.attrs,
            "data-toc-id": c,
            id: c
          });
        }
        A.push(o);
      }
    }), this.editor.view.dispatch(e), eC({
      editor: this.editor,
      storage: this.storage,
      onUpdate: (t = this.options.onUpdate) == null ? void 0 : t.bind(this),
      getIndexFn: this.options.getIndex || $I,
      getLevelFn: this.options.getLevel || _I,
      anchorTypes: this.options.anchorTypes
    }), this.storage.scrollHandler = () => {
      var s;
      if (!this.options.scrollParent)
        return;
      const r = typeof this.options.scrollParent == "function" ? this.options.scrollParent() : this.options.scrollParent, i = r instanceof HTMLElement ? r.scrollTop : r.scrollY;
      this.storage.scrollPosition = i || 0;
      const o = UH(this.storage.content, {
        editor: this.editor,
        anchorTypes: this.options.anchorTypes,
        storage: this.storage,
        onUpdate: (s = this.options.onUpdate) == null ? void 0 : s.bind(this)
      });
      this.storage.content = o;
    }, !this.options.scrollParent)
      return;
    const n = typeof this.options.scrollParent == "function" ? this.options.scrollParent() : this.options.scrollParent;
    n && n.addEventListener("scroll", this.storage.scrollHandler);
  },
  onDestroy() {
    if (!this.options.scrollParent)
      return;
    const t = typeof this.options.scrollParent == "function" ? this.options.scrollParent() : this.options.scrollParent;
    t && t.removeEventListener("scroll", this.storage.scrollHandler);
  },
  addProseMirrorPlugins() {
    return [GBe({ getId: this.options.getId, anchorTypes: this.options.anchorTypes })];
  }
}), bBe = UBe, _n = "top", Js = "bottom", Ws = "right", $n = "left", eY = "auto", Dh = [_n, Js, Ws, $n], Hl = "start", rh = "end", vBe = "clippingParents", bH = "viewport", dB = "popper", jBe = "reference", YD = /* @__PURE__ */ Dh.reduce(function(t, e) {
  return t.concat([e + "-" + Hl, e + "-" + rh]);
}, []), vH = /* @__PURE__ */ [].concat(Dh, [eY]).reduce(function(t, e) {
  return t.concat([e, e + "-" + Hl, e + "-" + rh]);
}, []), HBe = "beforeRead", kBe = "read", RBe = "afterRead", LBe = "beforeMain", SBe = "main", TBe = "afterMain", JBe = "beforeWrite", WBe = "write", OBe = "afterWrite", PBe = [HBe, kBe, RBe, LBe, SBe, TBe, JBe, WBe, OBe];
function Vr(t) {
  return t ? (t.nodeName || "").toLowerCase() : null;
}
function ws(t) {
  if (t == null)
    return window;
  if (t.toString() !== "[object Window]") {
    var e = t.ownerDocument;
    return e && e.defaultView || window;
  }
  return t;
}
function ic(t) {
  var e = ws(t).Element;
  return t instanceof e || t instanceof Element;
}
function Rs(t) {
  var e = ws(t).HTMLElement;
  return t instanceof e || t instanceof HTMLElement;
}
function tY(t) {
  if (typeof ShadowRoot > "u")
    return !1;
  var e = ws(t).ShadowRoot;
  return t instanceof e || t instanceof ShadowRoot;
}
function KBe(t) {
  var e = t.state;
  Object.keys(e.elements).forEach(function(A) {
    var n = e.styles[A] || {}, s = e.attributes[A] || {}, r = e.elements[A];
    !Rs(r) || !Vr(r) || (Object.assign(r.style, n), Object.keys(s).forEach(function(i) {
      var o = s[i];
      o === !1 ? r.removeAttribute(i) : r.setAttribute(i, o === !0 ? "" : o);
    }));
  });
}
function VBe(t) {
  var e = t.state, A = {
    popper: {
      position: e.options.strategy,
      left: "0",
      top: "0",
      margin: "0"
    },
    arrow: {
      position: "absolute"
    },
    reference: {}
  };
  return Object.assign(e.elements.popper.style, A.popper), e.styles = A, e.elements.arrow && Object.assign(e.elements.arrow.style, A.arrow), function() {
    Object.keys(e.elements).forEach(function(n) {
      var s = e.elements[n], r = e.attributes[n] || {}, i = Object.keys(e.styles.hasOwnProperty(n) ? e.styles[n] : A[n]), o = i.reduce(function(a, c) {
        return a[c] = "", a;
      }, {});
      !Rs(s) || !Vr(s) || (Object.assign(s.style, o), Object.keys(r).forEach(function(a) {
        s.removeAttribute(a);
      }));
    });
  };
}
const jH = {
  name: "applyStyles",
  enabled: !0,
  phase: "write",
  fn: KBe,
  effect: VBe,
  requires: ["computeStyles"]
};
function kr(t) {
  return t.split("-")[0];
}
var Ka = Math.max, ew = Math.min, kl = Math.round;
function rM() {
  var t = navigator.userAgentData;
  return t != null && t.brands && Array.isArray(t.brands) ? t.brands.map(function(e) {
    return e.brand + "/" + e.version;
  }).join(" ") : navigator.userAgent;
}
function HH() {
  return !/^((?!chrome|android).)*safari/i.test(rM());
}
function Rl(t, e, A) {
  e === void 0 && (e = !1), A === void 0 && (A = !1);
  var n = t.getBoundingClientRect(), s = 1, r = 1;
  e && Rs(t) && (s = t.offsetWidth > 0 && kl(n.width) / t.offsetWidth || 1, r = t.offsetHeight > 0 && kl(n.height) / t.offsetHeight || 1);
  var i = ic(t) ? ws(t) : window, o = i.visualViewport, a = !HH() && A, c = (n.left + (a && o ? o.offsetLeft : 0)) / s, l = (n.top + (a && o ? o.offsetTop : 0)) / r, B = n.width / s, g = n.height / r;
  return {
    width: B,
    height: g,
    top: l,
    right: c + B,
    bottom: l + g,
    left: c,
    x: c,
    y: l
  };
}
function AY(t) {
  var e = Rl(t), A = t.offsetWidth, n = t.offsetHeight;
  return Math.abs(e.width - A) <= 1 && (A = e.width), Math.abs(e.height - n) <= 1 && (n = e.height), {
    x: t.offsetLeft,
    y: t.offsetTop,
    width: A,
    height: n
  };
}
function kH(t, e) {
  var A = e.getRootNode && e.getRootNode();
  if (t.contains(e))
    return !0;
  if (A && tY(A)) {
    var n = e;
    do {
      if (n && t.isSameNode(n))
        return !0;
      n = n.parentNode || n.host;
    } while (n);
  }
  return !1;
}
function Vi(t) {
  return ws(t).getComputedStyle(t);
}
function XBe(t) {
  return ["table", "td", "th"].indexOf(Vr(t)) >= 0;
}
function ga(t) {
  return ((ic(t) ? t.ownerDocument : (
    // $FlowFixMe[prop-missing]
    t.document
  )) || window.document).documentElement;
}
function pf(t) {
  return Vr(t) === "html" ? t : (
    // this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    t.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    t.parentNode || // DOM Element detected
    (tY(t) ? t.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    ga(t)
  );
}
function yD(t) {
  return !Rs(t) || // https://github.com/popperjs/popper-core/issues/837
  Vi(t).position === "fixed" ? null : t.offsetParent;
}
function ZBe(t) {
  var e = /firefox/i.test(rM()), A = /Trident/i.test(rM());
  if (A && Rs(t)) {
    var n = Vi(t);
    if (n.position === "fixed")
      return null;
  }
  var s = pf(t);
  for (tY(s) && (s = s.host); Rs(s) && ["html", "body"].indexOf(Vr(s)) < 0; ) {
    var r = Vi(s);
    if (r.transform !== "none" || r.perspective !== "none" || r.contain === "paint" || ["transform", "perspective"].indexOf(r.willChange) !== -1 || e && r.willChange === "filter" || e && r.filter && r.filter !== "none")
      return s;
    s = s.parentNode;
  }
  return null;
}
function xh(t) {
  for (var e = ws(t), A = yD(t); A && XBe(A) && Vi(A).position === "static"; )
    A = yD(A);
  return A && (Vr(A) === "html" || Vr(A) === "body" && Vi(A).position === "static") ? e : A || ZBe(t) || e;
}
function nY(t) {
  return ["top", "bottom"].indexOf(t) >= 0 ? "x" : "y";
}
function lg(t, e, A) {
  return Ka(t, ew(e, A));
}
function qBe(t, e, A) {
  var n = lg(t, e, A);
  return n > A ? A : n;
}
function RH() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}
function LH(t) {
  return Object.assign({}, RH(), t);
}
function SH(t, e) {
  return e.reduce(function(A, n) {
    return A[n] = t, A;
  }, {});
}
var _Be = function(e, A) {
  return e = typeof e == "function" ? e(Object.assign({}, A.rects, {
    placement: A.placement
  })) : e, LH(typeof e != "number" ? e : SH(e, Dh));
};
function $Be(t) {
  var e, A = t.state, n = t.name, s = t.options, r = A.elements.arrow, i = A.modifiersData.popperOffsets, o = kr(A.placement), a = nY(o), c = [$n, Ws].indexOf(o) >= 0, l = c ? "height" : "width";
  if (!(!r || !i)) {
    var B = _Be(s.padding, A), g = AY(r), h = a === "y" ? _n : $n, u = a === "y" ? Js : Ws, d = A.rects.reference[l] + A.rects.reference[a] - i[a] - A.rects.popper[l], w = i[a] - A.rects.reference[a], Q = xh(r), p = Q ? a === "y" ? Q.clientHeight || 0 : Q.clientWidth || 0 : 0, M = d / 2 - w / 2, I = B[h], N = p - g[l] - B[u], m = p / 2 - g[l] / 2 + M, E = lg(I, m, N), G = a;
    A.modifiersData[n] = (e = {}, e[G] = E, e.centerOffset = E - m, e);
  }
}
function ege(t) {
  var e = t.state, A = t.options, n = A.element, s = n === void 0 ? "[data-popper-arrow]" : n;
  s != null && (typeof s == "string" && (s = e.elements.popper.querySelector(s), !s) || kH(e.elements.popper, s) && (e.elements.arrow = s));
}
const tge = {
  name: "arrow",
  enabled: !0,
  phase: "main",
  fn: $Be,
  effect: ege,
  requires: ["popperOffsets"],
  requiresIfExists: ["preventOverflow"]
};
function Ll(t) {
  return t.split("-")[1];
}
var Age = {
  top: "auto",
  right: "auto",
  bottom: "auto",
  left: "auto"
};
function nge(t, e) {
  var A = t.x, n = t.y, s = e.devicePixelRatio || 1;
  return {
    x: kl(A * s) / s || 0,
    y: kl(n * s) / s || 0
  };
}
function FD(t) {
  var e, A = t.popper, n = t.popperRect, s = t.placement, r = t.variation, i = t.offsets, o = t.position, a = t.gpuAcceleration, c = t.adaptive, l = t.roundOffsets, B = t.isFixed, g = i.x, h = g === void 0 ? 0 : g, u = i.y, d = u === void 0 ? 0 : u, w = typeof l == "function" ? l({
    x: h,
    y: d
  }) : {
    x: h,
    y: d
  };
  h = w.x, d = w.y;
  var Q = i.hasOwnProperty("x"), p = i.hasOwnProperty("y"), M = $n, I = _n, N = window;
  if (c) {
    var m = xh(A), E = "clientHeight", G = "clientWidth";
    if (m === ws(A) && (m = ga(A), Vi(m).position !== "static" && o === "absolute" && (E = "scrollHeight", G = "scrollWidth")), m = m, s === _n || (s === $n || s === Ws) && r === rh) {
      I = Js;
      var Y = B && m === N && N.visualViewport ? N.visualViewport.height : (
        // $FlowFixMe[prop-missing]
        m[E]
      );
      d -= Y - n.height, d *= a ? 1 : -1;
    }
    if (s === $n || (s === _n || s === Js) && r === rh) {
      M = Ws;
      var U = B && m === N && N.visualViewport ? N.visualViewport.width : (
        // $FlowFixMe[prop-missing]
        m[G]
      );
      h -= U - n.width, h *= a ? 1 : -1;
    }
  }
  var v = Object.assign({
    position: o
  }, c && Age), b = l === !0 ? nge({
    x: h,
    y: d
  }, ws(A)) : {
    x: h,
    y: d
  };
  if (h = b.x, d = b.y, a) {
    var W;
    return Object.assign({}, v, (W = {}, W[I] = p ? "0" : "", W[M] = Q ? "0" : "", W.transform = (N.devicePixelRatio || 1) <= 1 ? "translate(" + h + "px, " + d + "px)" : "translate3d(" + h + "px, " + d + "px, 0)", W));
  }
  return Object.assign({}, v, (e = {}, e[I] = p ? d + "px" : "", e[M] = Q ? h + "px" : "", e.transform = "", e));
}
function sge(t) {
  var e = t.state, A = t.options, n = A.gpuAcceleration, s = n === void 0 ? !0 : n, r = A.adaptive, i = r === void 0 ? !0 : r, o = A.roundOffsets, a = o === void 0 ? !0 : o, c = {
    placement: kr(e.placement),
    variation: Ll(e.placement),
    popper: e.elements.popper,
    popperRect: e.rects.popper,
    gpuAcceleration: s,
    isFixed: e.options.strategy === "fixed"
  };
  e.modifiersData.popperOffsets != null && (e.styles.popper = Object.assign({}, e.styles.popper, FD(Object.assign({}, c, {
    offsets: e.modifiersData.popperOffsets,
    position: e.options.strategy,
    adaptive: i,
    roundOffsets: a
  })))), e.modifiersData.arrow != null && (e.styles.arrow = Object.assign({}, e.styles.arrow, FD(Object.assign({}, c, {
    offsets: e.modifiersData.arrow,
    position: "absolute",
    adaptive: !1,
    roundOffsets: a
  })))), e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-placement": e.placement
  });
}
const rge = {
  name: "computeStyles",
  enabled: !0,
  phase: "beforeWrite",
  fn: sge,
  data: {}
};
var H0 = {
  passive: !0
};
function ige(t) {
  var e = t.state, A = t.instance, n = t.options, s = n.scroll, r = s === void 0 ? !0 : s, i = n.resize, o = i === void 0 ? !0 : i, a = ws(e.elements.popper), c = [].concat(e.scrollParents.reference, e.scrollParents.popper);
  return r && c.forEach(function(l) {
    l.addEventListener("scroll", A.update, H0);
  }), o && a.addEventListener("resize", A.update, H0), function() {
    r && c.forEach(function(l) {
      l.removeEventListener("scroll", A.update, H0);
    }), o && a.removeEventListener("resize", A.update, H0);
  };
}
const oge = {
  name: "eventListeners",
  enabled: !0,
  phase: "write",
  fn: function() {
  },
  effect: ige,
  data: {}
};
var age = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
function Iu(t) {
  return t.replace(/left|right|bottom|top/g, function(e) {
    return age[e];
  });
}
var cge = {
  start: "end",
  end: "start"
};
function ND(t) {
  return t.replace(/start|end/g, function(e) {
    return cge[e];
  });
}
function sY(t) {
  var e = ws(t), A = e.pageXOffset, n = e.pageYOffset;
  return {
    scrollLeft: A,
    scrollTop: n
  };
}
function rY(t) {
  return Rl(ga(t)).left + sY(t).scrollLeft;
}
function lge(t, e) {
  var A = ws(t), n = ga(t), s = A.visualViewport, r = n.clientWidth, i = n.clientHeight, o = 0, a = 0;
  if (s) {
    r = s.width, i = s.height;
    var c = HH();
    (c || !c && e === "fixed") && (o = s.offsetLeft, a = s.offsetTop);
  }
  return {
    width: r,
    height: i,
    x: o + rY(t),
    y: a
  };
}
function Bge(t) {
  var e, A = ga(t), n = sY(t), s = (e = t.ownerDocument) == null ? void 0 : e.body, r = Ka(A.scrollWidth, A.clientWidth, s ? s.scrollWidth : 0, s ? s.clientWidth : 0), i = Ka(A.scrollHeight, A.clientHeight, s ? s.scrollHeight : 0, s ? s.clientHeight : 0), o = -n.scrollLeft + rY(t), a = -n.scrollTop;
  return Vi(s || A).direction === "rtl" && (o += Ka(A.clientWidth, s ? s.clientWidth : 0) - r), {
    width: r,
    height: i,
    x: o,
    y: a
  };
}
function iY(t) {
  var e = Vi(t), A = e.overflow, n = e.overflowX, s = e.overflowY;
  return /auto|scroll|overlay|hidden/.test(A + s + n);
}
function TH(t) {
  return ["html", "body", "#document"].indexOf(Vr(t)) >= 0 ? t.ownerDocument.body : Rs(t) && iY(t) ? t : TH(pf(t));
}
function Bg(t, e) {
  var A;
  e === void 0 && (e = []);
  var n = TH(t), s = n === ((A = t.ownerDocument) == null ? void 0 : A.body), r = ws(n), i = s ? [r].concat(r.visualViewport || [], iY(n) ? n : []) : n, o = e.concat(i);
  return s ? o : (
    // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
    o.concat(Bg(pf(i)))
  );
}
function iM(t) {
  return Object.assign({}, t, {
    left: t.x,
    top: t.y,
    right: t.x + t.width,
    bottom: t.y + t.height
  });
}
function gge(t, e) {
  var A = Rl(t, !1, e === "fixed");
  return A.top = A.top + t.clientTop, A.left = A.left + t.clientLeft, A.bottom = A.top + t.clientHeight, A.right = A.left + t.clientWidth, A.width = t.clientWidth, A.height = t.clientHeight, A.x = A.left, A.y = A.top, A;
}
function DD(t, e, A) {
  return e === bH ? iM(lge(t, A)) : ic(e) ? gge(e, A) : iM(Bge(ga(t)));
}
function hge(t) {
  var e = Bg(pf(t)), A = ["absolute", "fixed"].indexOf(Vi(t).position) >= 0, n = A && Rs(t) ? xh(t) : t;
  return ic(n) ? e.filter(function(s) {
    return ic(s) && kH(s, n) && Vr(s) !== "body";
  }) : [];
}
function uge(t, e, A, n) {
  var s = e === "clippingParents" ? hge(t) : [].concat(e), r = [].concat(s, [A]), i = r[0], o = r.reduce(function(a, c) {
    var l = DD(t, c, n);
    return a.top = Ka(l.top, a.top), a.right = ew(l.right, a.right), a.bottom = ew(l.bottom, a.bottom), a.left = Ka(l.left, a.left), a;
  }, DD(t, i, n));
  return o.width = o.right - o.left, o.height = o.bottom - o.top, o.x = o.left, o.y = o.top, o;
}
function JH(t) {
  var e = t.reference, A = t.element, n = t.placement, s = n ? kr(n) : null, r = n ? Ll(n) : null, i = e.x + e.width / 2 - A.width / 2, o = e.y + e.height / 2 - A.height / 2, a;
  switch (s) {
    case _n:
      a = {
        x: i,
        y: e.y - A.height
      };
      break;
    case Js:
      a = {
        x: i,
        y: e.y + e.height
      };
      break;
    case Ws:
      a = {
        x: e.x + e.width,
        y: o
      };
      break;
    case $n:
      a = {
        x: e.x - A.width,
        y: o
      };
      break;
    default:
      a = {
        x: e.x,
        y: e.y
      };
  }
  var c = s ? nY(s) : null;
  if (c != null) {
    var l = c === "y" ? "height" : "width";
    switch (r) {
      case Hl:
        a[c] = a[c] - (e[l] / 2 - A[l] / 2);
        break;
      case rh:
        a[c] = a[c] + (e[l] / 2 - A[l] / 2);
        break;
    }
  }
  return a;
}
function ih(t, e) {
  e === void 0 && (e = {});
  var A = e, n = A.placement, s = n === void 0 ? t.placement : n, r = A.strategy, i = r === void 0 ? t.strategy : r, o = A.boundary, a = o === void 0 ? vBe : o, c = A.rootBoundary, l = c === void 0 ? bH : c, B = A.elementContext, g = B === void 0 ? dB : B, h = A.altBoundary, u = h === void 0 ? !1 : h, d = A.padding, w = d === void 0 ? 0 : d, Q = LH(typeof w != "number" ? w : SH(w, Dh)), p = g === dB ? jBe : dB, M = t.rects.popper, I = t.elements[u ? p : g], N = uge(ic(I) ? I : I.contextElement || ga(t.elements.popper), a, l, i), m = Rl(t.elements.reference), E = JH({
    reference: m,
    element: M,
    placement: s
  }), G = iM(Object.assign({}, M, E)), Y = g === dB ? G : m, U = {
    top: N.top - Y.top + Q.top,
    bottom: Y.bottom - N.bottom + Q.bottom,
    left: N.left - Y.left + Q.left,
    right: Y.right - N.right + Q.right
  }, v = t.modifiersData.offset;
  if (g === dB && v) {
    var b = v[s];
    Object.keys(U).forEach(function(W) {
      var q = [Ws, Js].indexOf(W) >= 0 ? 1 : -1, ne = [_n, Js].indexOf(W) >= 0 ? "y" : "x";
      U[W] += b[ne] * q;
    });
  }
  return U;
}
function dge(t, e) {
  e === void 0 && (e = {});
  var A = e, n = A.placement, s = A.boundary, r = A.rootBoundary, i = A.padding, o = A.flipVariations, a = A.allowedAutoPlacements, c = a === void 0 ? vH : a, l = Ll(n), B = l ? o ? YD : YD.filter(function(u) {
    return Ll(u) === l;
  }) : Dh, g = B.filter(function(u) {
    return c.indexOf(u) >= 0;
  });
  g.length === 0 && (g = B);
  var h = g.reduce(function(u, d) {
    return u[d] = ih(t, {
      placement: d,
      boundary: s,
      rootBoundary: r,
      padding: i
    })[kr(d)], u;
  }, {});
  return Object.keys(h).sort(function(u, d) {
    return h[u] - h[d];
  });
}
function wge(t) {
  if (kr(t) === eY)
    return [];
  var e = Iu(t);
  return [ND(t), e, ND(e)];
}
function fge(t) {
  var e = t.state, A = t.options, n = t.name;
  if (!e.modifiersData[n]._skip) {
    for (var s = A.mainAxis, r = s === void 0 ? !0 : s, i = A.altAxis, o = i === void 0 ? !0 : i, a = A.fallbackPlacements, c = A.padding, l = A.boundary, B = A.rootBoundary, g = A.altBoundary, h = A.flipVariations, u = h === void 0 ? !0 : h, d = A.allowedAutoPlacements, w = e.options.placement, Q = kr(w), p = Q === w, M = a || (p || !u ? [Iu(w)] : wge(w)), I = [w].concat(M).reduce(function(st, We) {
      return st.concat(kr(We) === eY ? dge(e, {
        placement: We,
        boundary: l,
        rootBoundary: B,
        padding: c,
        flipVariations: u,
        allowedAutoPlacements: d
      }) : We);
    }, []), N = e.rects.reference, m = e.rects.popper, E = /* @__PURE__ */ new Map(), G = !0, Y = I[0], U = 0; U < I.length; U++) {
      var v = I[U], b = kr(v), W = Ll(v) === Hl, q = [_n, Js].indexOf(b) >= 0, ne = q ? "width" : "height", V = ih(e, {
        placement: v,
        boundary: l,
        rootBoundary: B,
        altBoundary: g,
        padding: c
      }), se = q ? W ? Ws : $n : W ? Js : _n;
      N[ne] > m[ne] && (se = Iu(se));
      var te = Iu(se), be = [];
      if (r && be.push(V[b] <= 0), o && be.push(V[se] <= 0, V[te] <= 0), be.every(function(st) {
        return st;
      })) {
        Y = v, G = !1;
        break;
      }
      E.set(v, be);
    }
    if (G)
      for (var Oe = u ? 3 : 1, ke = function(We) {
        var pt = I.find(function(xt) {
          var mt = E.get(xt);
          if (mt)
            return mt.slice(0, We).every(function($t) {
              return $t;
            });
        });
        if (pt)
          return Y = pt, "break";
      }, Se = Oe; Se > 0; Se--) {
        var dt = ke(Se);
        if (dt === "break") break;
      }
    e.placement !== Y && (e.modifiersData[n]._skip = !0, e.placement = Y, e.reset = !0);
  }
}
const Qge = {
  name: "flip",
  enabled: !0,
  phase: "main",
  fn: fge,
  requiresIfExists: ["offset"],
  data: {
    _skip: !1
  }
};
function xD(t, e, A) {
  return A === void 0 && (A = {
    x: 0,
    y: 0
  }), {
    top: t.top - e.height - A.y,
    right: t.right - e.width + A.x,
    bottom: t.bottom - e.height + A.y,
    left: t.left - e.width - A.x
  };
}
function GD(t) {
  return [_n, Ws, Js, $n].some(function(e) {
    return t[e] >= 0;
  });
}
function Ige(t) {
  var e = t.state, A = t.name, n = e.rects.reference, s = e.rects.popper, r = e.modifiersData.preventOverflow, i = ih(e, {
    elementContext: "reference"
  }), o = ih(e, {
    altBoundary: !0
  }), a = xD(i, n), c = xD(o, s, r), l = GD(a), B = GD(c);
  e.modifiersData[A] = {
    referenceClippingOffsets: a,
    popperEscapeOffsets: c,
    isReferenceHidden: l,
    hasPopperEscaped: B
  }, e.attributes.popper = Object.assign({}, e.attributes.popper, {
    "data-popper-reference-hidden": l,
    "data-popper-escaped": B
  });
}
const Cge = {
  name: "hide",
  enabled: !0,
  phase: "main",
  requiresIfExists: ["preventOverflow"],
  fn: Ige
};
function Ege(t, e, A) {
  var n = kr(t), s = [$n, _n].indexOf(n) >= 0 ? -1 : 1, r = typeof A == "function" ? A(Object.assign({}, e, {
    placement: t
  })) : A, i = r[0], o = r[1];
  return i = i || 0, o = (o || 0) * s, [$n, Ws].indexOf(n) >= 0 ? {
    x: o,
    y: i
  } : {
    x: i,
    y: o
  };
}
function Mge(t) {
  var e = t.state, A = t.options, n = t.name, s = A.offset, r = s === void 0 ? [0, 0] : s, i = vH.reduce(function(l, B) {
    return l[B] = Ege(B, e.rects, r), l;
  }, {}), o = i[e.placement], a = o.x, c = o.y;
  e.modifiersData.popperOffsets != null && (e.modifiersData.popperOffsets.x += a, e.modifiersData.popperOffsets.y += c), e.modifiersData[n] = i;
}
const pge = {
  name: "offset",
  enabled: !0,
  phase: "main",
  requires: ["popperOffsets"],
  fn: Mge
};
function mge(t) {
  var e = t.state, A = t.name;
  e.modifiersData[A] = JH({
    reference: e.rects.reference,
    element: e.rects.popper,
    placement: e.placement
  });
}
const Yge = {
  name: "popperOffsets",
  enabled: !0,
  phase: "read",
  fn: mge,
  data: {}
};
function yge(t) {
  return t === "x" ? "y" : "x";
}
function Fge(t) {
  var e = t.state, A = t.options, n = t.name, s = A.mainAxis, r = s === void 0 ? !0 : s, i = A.altAxis, o = i === void 0 ? !1 : i, a = A.boundary, c = A.rootBoundary, l = A.altBoundary, B = A.padding, g = A.tether, h = g === void 0 ? !0 : g, u = A.tetherOffset, d = u === void 0 ? 0 : u, w = ih(e, {
    boundary: a,
    rootBoundary: c,
    padding: B,
    altBoundary: l
  }), Q = kr(e.placement), p = Ll(e.placement), M = !p, I = nY(Q), N = yge(I), m = e.modifiersData.popperOffsets, E = e.rects.reference, G = e.rects.popper, Y = typeof d == "function" ? d(Object.assign({}, e.rects, {
    placement: e.placement
  })) : d, U = typeof Y == "number" ? {
    mainAxis: Y,
    altAxis: Y
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, Y), v = e.modifiersData.offset ? e.modifiersData.offset[e.placement] : null, b = {
    x: 0,
    y: 0
  };
  if (m) {
    if (r) {
      var W, q = I === "y" ? _n : $n, ne = I === "y" ? Js : Ws, V = I === "y" ? "height" : "width", se = m[I], te = se + w[q], be = se - w[ne], Oe = h ? -G[V] / 2 : 0, ke = p === Hl ? E[V] : G[V], Se = p === Hl ? -G[V] : -E[V], dt = e.elements.arrow, st = h && dt ? AY(dt) : {
        width: 0,
        height: 0
      }, We = e.modifiersData["arrow#persistent"] ? e.modifiersData["arrow#persistent"].padding : RH(), pt = We[q], xt = We[ne], mt = lg(0, E[V], st[V]), $t = M ? E[V] / 2 - Oe - mt - pt - U.mainAxis : ke - mt - pt - U.mainAxis, Ut = M ? -E[V] / 2 + Oe + mt + xt + U.mainAxis : Se + mt + xt + U.mainAxis, RA = e.elements.arrow && xh(e.elements.arrow), H = RA ? I === "y" ? RA.clientTop || 0 : RA.clientLeft || 0 : 0, L = (W = v == null ? void 0 : v[I]) != null ? W : 0, _ = se + $t - L - H, R = se + Ut - L, P = lg(h ? ew(te, _) : te, se, h ? Ka(be, R) : be);
      m[I] = P, b[I] = P - se;
    }
    if (o) {
      var X, ae = I === "x" ? _n : $n, Be = I === "x" ? Js : Ws, he = m[N], ie = N === "y" ? "height" : "width", ze = he + w[ae], Me = he - w[Be], xe = [_n, $n].indexOf(Q) !== -1, Ne = (X = v == null ? void 0 : v[N]) != null ? X : 0, Xe = xe ? ze : he - E[ie] - G[ie] - Ne + U.altAxis, Yt = xe ? he + E[ie] + G[ie] - Ne - U.altAxis : Me, gt = h && xe ? qBe(Xe, he, Yt) : lg(h ? Xe : ze, he, h ? Yt : Me);
      m[N] = gt, b[N] = gt - he;
    }
    e.modifiersData[n] = b;
  }
}
const Nge = {
  name: "preventOverflow",
  enabled: !0,
  phase: "main",
  fn: Fge,
  requiresIfExists: ["offset"]
};
function Dge(t) {
  return {
    scrollLeft: t.scrollLeft,
    scrollTop: t.scrollTop
  };
}
function xge(t) {
  return t === ws(t) || !Rs(t) ? sY(t) : Dge(t);
}
function Gge(t) {
  var e = t.getBoundingClientRect(), A = kl(e.width) / t.offsetWidth || 1, n = kl(e.height) / t.offsetHeight || 1;
  return A !== 1 || n !== 1;
}
function zge(t, e, A) {
  A === void 0 && (A = !1);
  var n = Rs(e), s = Rs(e) && Gge(e), r = ga(e), i = Rl(t, s, A), o = {
    scrollLeft: 0,
    scrollTop: 0
  }, a = {
    x: 0,
    y: 0
  };
  return (n || !n && !A) && ((Vr(e) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
  iY(r)) && (o = xge(e)), Rs(e) ? (a = Rl(e, !0), a.x += e.clientLeft, a.y += e.clientTop) : r && (a.x = rY(r))), {
    x: i.left + o.scrollLeft - a.x,
    y: i.top + o.scrollTop - a.y,
    width: i.width,
    height: i.height
  };
}
function Uge(t) {
  var e = /* @__PURE__ */ new Map(), A = /* @__PURE__ */ new Set(), n = [];
  t.forEach(function(r) {
    e.set(r.name, r);
  });
  function s(r) {
    A.add(r.name);
    var i = [].concat(r.requires || [], r.requiresIfExists || []);
    i.forEach(function(o) {
      if (!A.has(o)) {
        var a = e.get(o);
        a && s(a);
      }
    }), n.push(r);
  }
  return t.forEach(function(r) {
    A.has(r.name) || s(r);
  }), n;
}
function bge(t) {
  var e = Uge(t);
  return PBe.reduce(function(A, n) {
    return A.concat(e.filter(function(s) {
      return s.phase === n;
    }));
  }, []);
}
function vge(t) {
  var e;
  return function() {
    return e || (e = new Promise(function(A) {
      Promise.resolve().then(function() {
        e = void 0, A(t());
      });
    })), e;
  };
}
function jge(t) {
  var e = t.reduce(function(A, n) {
    var s = A[n.name];
    return A[n.name] = s ? Object.assign({}, s, n, {
      options: Object.assign({}, s.options, n.options),
      data: Object.assign({}, s.data, n.data)
    }) : n, A;
  }, {});
  return Object.keys(e).map(function(A) {
    return e[A];
  });
}
var zD = {
  placement: "bottom",
  modifiers: [],
  strategy: "absolute"
};
function UD() {
  for (var t = arguments.length, e = new Array(t), A = 0; A < t; A++)
    e[A] = arguments[A];
  return !e.some(function(n) {
    return !(n && typeof n.getBoundingClientRect == "function");
  });
}
function Hge(t) {
  t === void 0 && (t = {});
  var e = t, A = e.defaultModifiers, n = A === void 0 ? [] : A, s = e.defaultOptions, r = s === void 0 ? zD : s;
  return function(o, a, c) {
    c === void 0 && (c = r);
    var l = {
      placement: "bottom",
      orderedModifiers: [],
      options: Object.assign({}, zD, r),
      modifiersData: {},
      elements: {
        reference: o,
        popper: a
      },
      attributes: {},
      styles: {}
    }, B = [], g = !1, h = {
      state: l,
      setOptions: function(Q) {
        var p = typeof Q == "function" ? Q(l.options) : Q;
        d(), l.options = Object.assign({}, r, l.options, p), l.scrollParents = {
          reference: ic(o) ? Bg(o) : o.contextElement ? Bg(o.contextElement) : [],
          popper: Bg(a)
        };
        var M = bge(jge([].concat(n, l.options.modifiers)));
        return l.orderedModifiers = M.filter(function(I) {
          return I.enabled;
        }), u(), h.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function() {
        if (!g) {
          var Q = l.elements, p = Q.reference, M = Q.popper;
          if (UD(p, M)) {
            l.rects = {
              reference: zge(p, xh(M), l.options.strategy === "fixed"),
              popper: AY(M)
            }, l.reset = !1, l.placement = l.options.placement, l.orderedModifiers.forEach(function(U) {
              return l.modifiersData[U.name] = Object.assign({}, U.data);
            });
            for (var I = 0; I < l.orderedModifiers.length; I++) {
              if (l.reset === !0) {
                l.reset = !1, I = -1;
                continue;
              }
              var N = l.orderedModifiers[I], m = N.fn, E = N.options, G = E === void 0 ? {} : E, Y = N.name;
              typeof m == "function" && (l = m({
                state: l,
                options: G,
                name: Y,
                instance: h
              }) || l);
            }
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: vge(function() {
        return new Promise(function(w) {
          h.forceUpdate(), w(l);
        });
      }),
      destroy: function() {
        d(), g = !0;
      }
    };
    if (!UD(o, a))
      return h;
    h.setOptions(c).then(function(w) {
      !g && c.onFirstUpdate && c.onFirstUpdate(w);
    });
    function u() {
      l.orderedModifiers.forEach(function(w) {
        var Q = w.name, p = w.options, M = p === void 0 ? {} : p, I = w.effect;
        if (typeof I == "function") {
          var N = I({
            state: l,
            name: Q,
            instance: h,
            options: M
          }), m = function() {
          };
          B.push(N || m);
        }
      });
    }
    function d() {
      B.forEach(function(w) {
        return w();
      }), B = [];
    }
    return h;
  };
}
var kge = [oge, Yge, rge, jH, pge, Qge, Nge, tge, Cge], Rge = /* @__PURE__ */ Hge({
  defaultModifiers: kge
}), Lge = "tippy-box", WH = "tippy-content", Sge = "tippy-backdrop", OH = "tippy-arrow", PH = "tippy-svg-arrow", xa = {
  passive: !0,
  capture: !0
}, KH = function() {
  return document.body;
};
function tC(t, e, A) {
  if (Array.isArray(t)) {
    var n = t[e];
    return n ?? (Array.isArray(A) ? A[e] : A);
  }
  return t;
}
function oY(t, e) {
  var A = {}.toString.call(t);
  return A.indexOf("[object") === 0 && A.indexOf(e + "]") > -1;
}
function VH(t, e) {
  return typeof t == "function" ? t.apply(void 0, e) : t;
}
function bD(t, e) {
  if (e === 0)
    return t;
  var A;
  return function(n) {
    clearTimeout(A), A = setTimeout(function() {
      t(n);
    }, e);
  };
}
function Tge(t) {
  return t.split(/\s+/).filter(Boolean);
}
function Pc(t) {
  return [].concat(t);
}
function vD(t, e) {
  t.indexOf(e) === -1 && t.push(e);
}
function Jge(t) {
  return t.filter(function(e, A) {
    return t.indexOf(e) === A;
  });
}
function Wge(t) {
  return t.split("-")[0];
}
function tw(t) {
  return [].slice.call(t);
}
function jD(t) {
  return Object.keys(t).reduce(function(e, A) {
    return t[A] !== void 0 && (e[A] = t[A]), e;
  }, {});
}
function gg() {
  return document.createElement("div");
}
function mf(t) {
  return ["Element", "Fragment"].some(function(e) {
    return oY(t, e);
  });
}
function Oge(t) {
  return oY(t, "NodeList");
}
function Pge(t) {
  return oY(t, "MouseEvent");
}
function Kge(t) {
  return !!(t && t._tippy && t._tippy.reference === t);
}
function Vge(t) {
  return mf(t) ? [t] : Oge(t) ? tw(t) : Array.isArray(t) ? t : tw(document.querySelectorAll(t));
}
function AC(t, e) {
  t.forEach(function(A) {
    A && (A.style.transitionDuration = e + "ms");
  });
}
function HD(t, e) {
  t.forEach(function(A) {
    A && A.setAttribute("data-state", e);
  });
}
function Xge(t) {
  var e, A = Pc(t), n = A[0];
  return n != null && (e = n.ownerDocument) != null && e.body ? n.ownerDocument : document;
}
function Zge(t, e) {
  var A = e.clientX, n = e.clientY;
  return t.every(function(s) {
    var r = s.popperRect, i = s.popperState, o = s.props, a = o.interactiveBorder, c = Wge(i.placement), l = i.modifiersData.offset;
    if (!l)
      return !0;
    var B = c === "bottom" ? l.top.y : 0, g = c === "top" ? l.bottom.y : 0, h = c === "right" ? l.left.x : 0, u = c === "left" ? l.right.x : 0, d = r.top - n + B > a, w = n - r.bottom - g > a, Q = r.left - A + h > a, p = A - r.right - u > a;
    return d || w || Q || p;
  });
}
function nC(t, e, A) {
  var n = e + "EventListener";
  ["transitionend", "webkitTransitionEnd"].forEach(function(s) {
    t[n](s, A);
  });
}
function kD(t, e) {
  for (var A = e; A; ) {
    var n;
    if (t.contains(A))
      return !0;
    A = A.getRootNode == null || (n = A.getRootNode()) == null ? void 0 : n.host;
  }
  return !1;
}
var Fr = {
  isTouch: !1
}, RD = 0;
function qge() {
  Fr.isTouch || (Fr.isTouch = !0, window.performance && document.addEventListener("mousemove", XH));
}
function XH() {
  var t = performance.now();
  t - RD < 20 && (Fr.isTouch = !1, document.removeEventListener("mousemove", XH)), RD = t;
}
function _ge() {
  var t = document.activeElement;
  if (Kge(t)) {
    var e = t._tippy;
    t.blur && !e.state.isVisible && t.blur();
  }
}
function $ge() {
  document.addEventListener("touchstart", qge, xa), window.addEventListener("blur", _ge);
}
var ehe = typeof window < "u" && typeof document < "u", the = ehe ? (
  // @ts-ignore
  !!window.msCrypto
) : !1, Ahe = {
  animateFill: !1,
  followCursor: !1,
  inlinePositioning: !1,
  sticky: !1
}, nhe = {
  allowHTML: !1,
  animation: "fade",
  arrow: !0,
  content: "",
  inertia: !1,
  maxWidth: 350,
  role: "tooltip",
  theme: "",
  zIndex: 9999
}, $s = Object.assign({
  appendTo: KH,
  aria: {
    content: "auto",
    expanded: "auto"
  },
  delay: 0,
  duration: [300, 250],
  getReferenceClientRect: null,
  hideOnClick: !0,
  ignoreAttributes: !1,
  interactive: !1,
  interactiveBorder: 2,
  interactiveDebounce: 0,
  moveTransition: "",
  offset: [0, 10],
  onAfterUpdate: function() {
  },
  onBeforeUpdate: function() {
  },
  onCreate: function() {
  },
  onDestroy: function() {
  },
  onHidden: function() {
  },
  onHide: function() {
  },
  onMount: function() {
  },
  onShow: function() {
  },
  onShown: function() {
  },
  onTrigger: function() {
  },
  onUntrigger: function() {
  },
  onClickOutside: function() {
  },
  placement: "top",
  plugins: [],
  popperOptions: {},
  render: null,
  showOnCreate: !1,
  touch: !0,
  trigger: "mouseenter focus",
  triggerTarget: null
}, Ahe, nhe), she = Object.keys($s), rhe = function(e) {
  var A = Object.keys(e);
  A.forEach(function(n) {
    $s[n] = e[n];
  });
};
function ZH(t) {
  var e = t.plugins || [], A = e.reduce(function(n, s) {
    var r = s.name, i = s.defaultValue;
    if (r) {
      var o;
      n[r] = t[r] !== void 0 ? t[r] : (o = $s[r]) != null ? o : i;
    }
    return n;
  }, {});
  return Object.assign({}, t, A);
}
function ihe(t, e) {
  var A = e ? Object.keys(ZH(Object.assign({}, $s, {
    plugins: e
  }))) : she, n = A.reduce(function(s, r) {
    var i = (t.getAttribute("data-tippy-" + r) || "").trim();
    if (!i)
      return s;
    if (r === "content")
      s[r] = i;
    else
      try {
        s[r] = JSON.parse(i);
      } catch {
        s[r] = i;
      }
    return s;
  }, {});
  return n;
}
function LD(t, e) {
  var A = Object.assign({}, e, {
    content: VH(e.content, [t])
  }, e.ignoreAttributes ? {} : ihe(t, e.plugins));
  return A.aria = Object.assign({}, $s.aria, A.aria), A.aria = {
    expanded: A.aria.expanded === "auto" ? e.interactive : A.aria.expanded,
    content: A.aria.content === "auto" ? e.interactive ? null : "describedby" : A.aria.content
  }, A;
}
var ohe = function() {
  return "innerHTML";
};
function oM(t, e) {
  t[ohe()] = e;
}
function SD(t) {
  var e = gg();
  return t === !0 ? e.className = OH : (e.className = PH, mf(t) ? e.appendChild(t) : oM(e, t)), e;
}
function TD(t, e) {
  mf(e.content) ? (oM(t, ""), t.appendChild(e.content)) : typeof e.content != "function" && (e.allowHTML ? oM(t, e.content) : t.textContent = e.content);
}
function aM(t) {
  var e = t.firstElementChild, A = tw(e.children);
  return {
    box: e,
    content: A.find(function(n) {
      return n.classList.contains(WH);
    }),
    arrow: A.find(function(n) {
      return n.classList.contains(OH) || n.classList.contains(PH);
    }),
    backdrop: A.find(function(n) {
      return n.classList.contains(Sge);
    })
  };
}
function qH(t) {
  var e = gg(), A = gg();
  A.className = Lge, A.setAttribute("data-state", "hidden"), A.setAttribute("tabindex", "-1");
  var n = gg();
  n.className = WH, n.setAttribute("data-state", "hidden"), TD(n, t.props), e.appendChild(A), A.appendChild(n), s(t.props, t.props);
  function s(r, i) {
    var o = aM(e), a = o.box, c = o.content, l = o.arrow;
    i.theme ? a.setAttribute("data-theme", i.theme) : a.removeAttribute("data-theme"), typeof i.animation == "string" ? a.setAttribute("data-animation", i.animation) : a.removeAttribute("data-animation"), i.inertia ? a.setAttribute("data-inertia", "") : a.removeAttribute("data-inertia"), a.style.maxWidth = typeof i.maxWidth == "number" ? i.maxWidth + "px" : i.maxWidth, i.role ? a.setAttribute("role", i.role) : a.removeAttribute("role"), (r.content !== i.content || r.allowHTML !== i.allowHTML) && TD(c, t.props), i.arrow ? l ? r.arrow !== i.arrow && (a.removeChild(l), a.appendChild(SD(i.arrow))) : a.appendChild(SD(i.arrow)) : l && a.removeChild(l);
  }
  return {
    popper: e,
    onUpdate: s
  };
}
qH.$$tippy = !0;
var ahe = 1, k0 = [], sC = [];
function che(t, e) {
  var A = LD(t, Object.assign({}, $s, ZH(jD(e)))), n, s, r, i = !1, o = !1, a = !1, c = !1, l, B, g, h = [], u = bD(_, A.interactiveDebounce), d, w = ahe++, Q = null, p = Jge(A.plugins), M = {
    // Is the instance currently enabled?
    isEnabled: !0,
    // Is the tippy currently showing and not transitioning out?
    isVisible: !1,
    // Has the instance been destroyed?
    isDestroyed: !1,
    // Is the tippy currently mounted to the DOM?
    isMounted: !1,
    // Has the tippy finished transitioning in?
    isShown: !1
  }, I = {
    // properties
    id: w,
    reference: t,
    popper: gg(),
    popperInstance: Q,
    props: A,
    state: M,
    plugins: p,
    // methods
    clearDelayTimeouts: Xe,
    setProps: Yt,
    setContent: gt,
    show: FA,
    hide: NA,
    hideWithInteractivity: hn,
    enable: xe,
    disable: Ne,
    unmount: un,
    destroy: ni
  };
  if (!A.render)
    return I;
  var N = A.render(I), m = N.popper, E = N.onUpdate;
  m.setAttribute("data-tippy-root", ""), m.id = "tippy-" + I.id, I.popper = m, t._tippy = I, m._tippy = I;
  var G = p.map(function($) {
    return $.fn(I);
  }), Y = t.hasAttribute("aria-expanded");
  return RA(), Oe(), se(), te("onCreate", [I]), A.showOnCreate && ze(), m.addEventListener("mouseenter", function() {
    I.props.interactive && I.state.isVisible && I.clearDelayTimeouts();
  }), m.addEventListener("mouseleave", function() {
    I.props.interactive && I.props.trigger.indexOf("mouseenter") >= 0 && q().addEventListener("mousemove", u);
  }), I;
  function U() {
    var $ = I.props.touch;
    return Array.isArray($) ? $ : [$, 0];
  }
  function v() {
    return U()[0] === "hold";
  }
  function b() {
    var $;
    return !!(($ = I.props.render) != null && $.$$tippy);
  }
  function W() {
    return d || t;
  }
  function q() {
    var $ = W().parentNode;
    return $ ? Xge($) : document;
  }
  function ne() {
    return aM(m);
  }
  function V($) {
    return I.state.isMounted && !I.state.isVisible || Fr.isTouch || l && l.type === "focus" ? 0 : tC(I.props.delay, $ ? 0 : 1, $s.delay);
  }
  function se($) {
    $ === void 0 && ($ = !1), m.style.pointerEvents = I.props.interactive && !$ ? "" : "none", m.style.zIndex = "" + I.props.zIndex;
  }
  function te($, pe, ve) {
    if (ve === void 0 && (ve = !0), G.forEach(function(ot) {
      ot[$] && ot[$].apply(ot, pe);
    }), ve) {
      var lt;
      (lt = I.props)[$].apply(lt, pe);
    }
  }
  function be() {
    var $ = I.props.aria;
    if ($.content) {
      var pe = "aria-" + $.content, ve = m.id, lt = Pc(I.props.triggerTarget || t);
      lt.forEach(function(ot) {
        var iA = ot.getAttribute(pe);
        if (I.state.isVisible)
          ot.setAttribute(pe, iA ? iA + " " + ve : ve);
        else {
          var qA = iA && iA.replace(ve, "").trim();
          qA ? ot.setAttribute(pe, qA) : ot.removeAttribute(pe);
        }
      });
    }
  }
  function Oe() {
    if (!(Y || !I.props.aria.expanded)) {
      var $ = Pc(I.props.triggerTarget || t);
      $.forEach(function(pe) {
        I.props.interactive ? pe.setAttribute("aria-expanded", I.state.isVisible && pe === W() ? "true" : "false") : pe.removeAttribute("aria-expanded");
      });
    }
  }
  function ke() {
    q().removeEventListener("mousemove", u), k0 = k0.filter(function($) {
      return $ !== u;
    });
  }
  function Se($) {
    if (!(Fr.isTouch && (a || $.type === "mousedown"))) {
      var pe = $.composedPath && $.composedPath()[0] || $.target;
      if (!(I.props.interactive && kD(m, pe))) {
        if (Pc(I.props.triggerTarget || t).some(function(ve) {
          return kD(ve, pe);
        })) {
          if (Fr.isTouch || I.state.isVisible && I.props.trigger.indexOf("click") >= 0)
            return;
        } else
          te("onClickOutside", [I, $]);
        I.props.hideOnClick === !0 && (I.clearDelayTimeouts(), I.hide(), o = !0, setTimeout(function() {
          o = !1;
        }), I.state.isMounted || pt());
      }
    }
  }
  function dt() {
    a = !0;
  }
  function st() {
    a = !1;
  }
  function We() {
    var $ = q();
    $.addEventListener("mousedown", Se, !0), $.addEventListener("touchend", Se, xa), $.addEventListener("touchstart", st, xa), $.addEventListener("touchmove", dt, xa);
  }
  function pt() {
    var $ = q();
    $.removeEventListener("mousedown", Se, !0), $.removeEventListener("touchend", Se, xa), $.removeEventListener("touchstart", st, xa), $.removeEventListener("touchmove", dt, xa);
  }
  function xt($, pe) {
    $t($, function() {
      !I.state.isVisible && m.parentNode && m.parentNode.contains(m) && pe();
    });
  }
  function mt($, pe) {
    $t($, pe);
  }
  function $t($, pe) {
    var ve = ne().box;
    function lt(ot) {
      ot.target === ve && (nC(ve, "remove", lt), pe());
    }
    if ($ === 0)
      return pe();
    nC(ve, "remove", B), nC(ve, "add", lt), B = lt;
  }
  function Ut($, pe, ve) {
    ve === void 0 && (ve = !1);
    var lt = Pc(I.props.triggerTarget || t);
    lt.forEach(function(ot) {
      ot.addEventListener($, pe, ve), h.push({
        node: ot,
        eventType: $,
        handler: pe,
        options: ve
      });
    });
  }
  function RA() {
    v() && (Ut("touchstart", L, {
      passive: !0
    }), Ut("touchend", R, {
      passive: !0
    })), Tge(I.props.trigger).forEach(function($) {
      if ($ !== "manual")
        switch (Ut($, L), $) {
          case "mouseenter":
            Ut("mouseleave", R);
            break;
          case "focus":
            Ut(the ? "focusout" : "blur", P);
            break;
          case "focusin":
            Ut("focusout", P);
            break;
        }
    });
  }
  function H() {
    h.forEach(function($) {
      var pe = $.node, ve = $.eventType, lt = $.handler, ot = $.options;
      pe.removeEventListener(ve, lt, ot);
    }), h = [];
  }
  function L($) {
    var pe, ve = !1;
    if (!(!I.state.isEnabled || X($) || o)) {
      var lt = ((pe = l) == null ? void 0 : pe.type) === "focus";
      l = $, d = $.currentTarget, Oe(), !I.state.isVisible && Pge($) && k0.forEach(function(ot) {
        return ot($);
      }), $.type === "click" && (I.props.trigger.indexOf("mouseenter") < 0 || i) && I.props.hideOnClick !== !1 && I.state.isVisible ? ve = !0 : ze($), $.type === "click" && (i = !ve), ve && !lt && Me($);
    }
  }
  function _($) {
    var pe = $.target, ve = W().contains(pe) || m.contains(pe);
    if (!($.type === "mousemove" && ve)) {
      var lt = ie().concat(m).map(function(ot) {
        var iA, qA = ot._tippy, oo = (iA = qA.popperInstance) == null ? void 0 : iA.state;
        return oo ? {
          popperRect: ot.getBoundingClientRect(),
          popperState: oo,
          props: A
        } : null;
      }).filter(Boolean);
      Zge(lt, $) && (ke(), Me($));
    }
  }
  function R($) {
    var pe = X($) || I.props.trigger.indexOf("click") >= 0 && i;
    if (!pe) {
      if (I.props.interactive) {
        I.hideWithInteractivity($);
        return;
      }
      Me($);
    }
  }
  function P($) {
    I.props.trigger.indexOf("focusin") < 0 && $.target !== W() || I.props.interactive && $.relatedTarget && m.contains($.relatedTarget) || Me($);
  }
  function X($) {
    return Fr.isTouch ? v() !== $.type.indexOf("touch") >= 0 : !1;
  }
  function ae() {
    Be();
    var $ = I.props, pe = $.popperOptions, ve = $.placement, lt = $.offset, ot = $.getReferenceClientRect, iA = $.moveTransition, qA = b() ? aM(m).arrow : null, oo = ot ? {
      getBoundingClientRect: ot,
      contextElement: ot.contextElement || W()
    } : t, wc = {
      name: "$$tippy",
      enabled: !0,
      phase: "beforeWrite",
      requires: ["computeStyles"],
      fn: function(ur) {
        var dr = ur.state;
        if (b()) {
          var yf = ne(), ql = yf.box;
          ["placement", "reference-hidden", "escaped"].forEach(function(wr) {
            wr === "placement" ? ql.setAttribute("data-placement", dr.placement) : dr.attributes.popper["data-popper-" + wr] ? ql.setAttribute("data-" + wr, "") : ql.removeAttribute("data-" + wr);
          }), dr.attributes.popper = {};
        }
      }
    }, ts = [{
      name: "offset",
      options: {
        offset: lt
      }
    }, {
      name: "preventOverflow",
      options: {
        padding: {
          top: 2,
          bottom: 2,
          left: 5,
          right: 5
        }
      }
    }, {
      name: "flip",
      options: {
        padding: 5
      }
    }, {
      name: "computeStyles",
      options: {
        adaptive: !iA
      }
    }, wc];
    b() && qA && ts.push({
      name: "arrow",
      options: {
        element: qA,
        padding: 3
      }
    }), ts.push.apply(ts, (pe == null ? void 0 : pe.modifiers) || []), I.popperInstance = Rge(oo, m, Object.assign({}, pe, {
      placement: ve,
      onFirstUpdate: g,
      modifiers: ts
    }));
  }
  function Be() {
    I.popperInstance && (I.popperInstance.destroy(), I.popperInstance = null);
  }
  function he() {
    var $ = I.props.appendTo, pe, ve = W();
    I.props.interactive && $ === KH || $ === "parent" ? pe = ve.parentNode : pe = VH($, [ve]), pe.contains(m) || pe.appendChild(m), I.state.isMounted = !0, ae();
  }
  function ie() {
    return tw(m.querySelectorAll("[data-tippy-root]"));
  }
  function ze($) {
    I.clearDelayTimeouts(), $ && te("onTrigger", [I, $]), We();
    var pe = V(!0), ve = U(), lt = ve[0], ot = ve[1];
    Fr.isTouch && lt === "hold" && ot && (pe = ot), pe ? n = setTimeout(function() {
      I.show();
    }, pe) : I.show();
  }
  function Me($) {
    if (I.clearDelayTimeouts(), te("onUntrigger", [I, $]), !I.state.isVisible) {
      pt();
      return;
    }
    if (!(I.props.trigger.indexOf("mouseenter") >= 0 && I.props.trigger.indexOf("click") >= 0 && ["mouseleave", "mousemove"].indexOf($.type) >= 0 && i)) {
      var pe = V(!1);
      pe ? s = setTimeout(function() {
        I.state.isVisible && I.hide();
      }, pe) : r = requestAnimationFrame(function() {
        I.hide();
      });
    }
  }
  function xe() {
    I.state.isEnabled = !0;
  }
  function Ne() {
    I.hide(), I.state.isEnabled = !1;
  }
  function Xe() {
    clearTimeout(n), clearTimeout(s), cancelAnimationFrame(r);
  }
  function Yt($) {
    if (!I.state.isDestroyed) {
      te("onBeforeUpdate", [I, $]), H();
      var pe = I.props, ve = LD(t, Object.assign({}, pe, jD($), {
        ignoreAttributes: !0
      }));
      I.props = ve, RA(), pe.interactiveDebounce !== ve.interactiveDebounce && (ke(), u = bD(_, ve.interactiveDebounce)), pe.triggerTarget && !ve.triggerTarget ? Pc(pe.triggerTarget).forEach(function(lt) {
        lt.removeAttribute("aria-expanded");
      }) : ve.triggerTarget && t.removeAttribute("aria-expanded"), Oe(), se(), E && E(pe, ve), I.popperInstance && (ae(), ie().forEach(function(lt) {
        requestAnimationFrame(lt._tippy.popperInstance.forceUpdate);
      })), te("onAfterUpdate", [I, $]);
    }
  }
  function gt($) {
    I.setProps({
      content: $
    });
  }
  function FA() {
    var $ = I.state.isVisible, pe = I.state.isDestroyed, ve = !I.state.isEnabled, lt = Fr.isTouch && !I.props.touch, ot = tC(I.props.duration, 0, $s.duration);
    if (!($ || pe || ve || lt) && !W().hasAttribute("disabled") && (te("onShow", [I], !1), I.props.onShow(I) !== !1)) {
      if (I.state.isVisible = !0, b() && (m.style.visibility = "visible"), se(), We(), I.state.isMounted || (m.style.transition = "none"), b()) {
        var iA = ne(), qA = iA.box, oo = iA.content;
        AC([qA, oo], 0);
      }
      g = function() {
        var ts;
        if (!(!I.state.isVisible || c)) {
          if (c = !0, m.offsetHeight, m.style.transition = I.props.moveTransition, b() && I.props.animation) {
            var si = ne(), ur = si.box, dr = si.content;
            AC([ur, dr], ot), HD([ur, dr], "visible");
          }
          be(), Oe(), vD(sC, I), (ts = I.popperInstance) == null || ts.forceUpdate(), te("onMount", [I]), I.props.animation && b() && mt(ot, function() {
            I.state.isShown = !0, te("onShown", [I]);
          });
        }
      }, he();
    }
  }
  function NA() {
    var $ = !I.state.isVisible, pe = I.state.isDestroyed, ve = !I.state.isEnabled, lt = tC(I.props.duration, 1, $s.duration);
    if (!($ || pe || ve) && (te("onHide", [I], !1), I.props.onHide(I) !== !1)) {
      if (I.state.isVisible = !1, I.state.isShown = !1, c = !1, i = !1, b() && (m.style.visibility = "hidden"), ke(), pt(), se(!0), b()) {
        var ot = ne(), iA = ot.box, qA = ot.content;
        I.props.animation && (AC([iA, qA], lt), HD([iA, qA], "hidden"));
      }
      be(), Oe(), I.props.animation ? b() && xt(lt, I.unmount) : I.unmount();
    }
  }
  function hn($) {
    q().addEventListener("mousemove", u), vD(k0, u), u($);
  }
  function un() {
    I.state.isVisible && I.hide(), I.state.isMounted && (Be(), ie().forEach(function($) {
      $._tippy.unmount();
    }), m.parentNode && m.parentNode.removeChild(m), sC = sC.filter(function($) {
      return $ !== I;
    }), I.state.isMounted = !1, te("onHidden", [I]));
  }
  function ni() {
    I.state.isDestroyed || (I.clearDelayTimeouts(), I.unmount(), H(), delete t._tippy, I.state.isDestroyed = !0, te("onDestroy", [I]));
  }
}
function dc(t, e) {
  e === void 0 && (e = {});
  var A = $s.plugins.concat(e.plugins || []);
  $ge();
  var n = Object.assign({}, e, {
    plugins: A
  }), s = Vge(t), r = s.reduce(function(i, o) {
    var a = o && che(o, n);
    return a && i.push(a), i;
  }, []);
  return mf(t) ? r[0] : r;
}
dc.defaultProps = $s;
dc.setDefaultProps = rhe;
dc.currentInput = Fr;
Object.assign({}, jH, {
  effect: function(e) {
    var A = e.state, n = {
      popper: {
        position: A.options.strategy,
        left: "0",
        top: "0",
        margin: "0"
      },
      arrow: {
        position: "absolute"
      },
      reference: {}
    };
    Object.assign(A.elements.popper.style, n.popper), A.styles = n, A.elements.arrow && Object.assign(A.elements.arrow.style, n.arrow);
  }
});
dc.setDefaultProps({
  render: qH
});
function _H(t) {
  var n;
  if (!(t != null && t.state))
    return;
  try {
    const { exitSuggestion: s } = require("@tiptap/suggestion");
    s(t);
    return;
  } catch {
  }
  const e = t.state.plugins.find(
    (s) => {
      var r, i;
      return ((i = (r = s.spec) == null ? void 0 : r.key) == null ? void 0 : i.key) === "suggestion";
    }
  ), A = (n = e == null ? void 0 : e.spec) == null ? void 0 : n.key;
  A && t.dispatch(t.state.tr.setMeta(A, { exit: !0 }));
}
const lhe = /^\/\w*$/, Xi = /* @__PURE__ */ new Set(), oc = /* @__PURE__ */ new Map();
function Yf(t) {
  return lhe.test(t) ? t.slice(1) : null;
}
function $H(t) {
  var A;
  if (!t.startsWith("/"))
    return null;
  const e = Yf(t);
  return e !== null ? e : ((A = t.slice(1).match(/^\w*/)) == null ? void 0 : A[0]) ?? "";
}
function aY(t, e) {
  var i, o;
  if (!((i = t == null ? void 0 : t.selection) != null && i.$from))
    return;
  const A = t.selection.$from, n = A.parent.textContent, s = A.start(), r = Yf(n);
  if (r === null) {
    n.startsWith("/") || Aw(s);
    return;
  }
  if ((o = e == null ? void 0 : e.selection) != null && o.$from) {
    const a = e.selection.$from.parent.textContent;
    if (n.length < a.length) {
      const c = $H(a);
      c !== null ? lY(s, c) : r === "" ? oc.set(s, "") : Xi.has(s) && oc.set(s, r);
    } else if (n.length > a.length) {
      Aw(s);
      return;
    }
  }
  Xi.has(s);
}
function e8({ state: t }) {
  var i;
  if (!((i = t == null ? void 0 : t.selection) != null && i.$from))
    return !0;
  const e = t.selection.$from, A = e.parent.textContent, n = e.start(), s = Yf(A);
  if (s === null)
    return !A.startsWith("/");
  if (s === "")
    return !Xi.has(n);
  if (!Xi.has(n))
    return !0;
  const r = oc.get(n);
  return r === void 0 ? !1 : s.length > r.length || !r.startsWith(s);
}
function cY({ state: t, range: e }) {
  const A = t.doc.resolve(e.from), n = A.parent.textContent, s = A.start(), r = Yf(n);
  if (aY(t), r === null)
    return !1;
  if (!Xi.has(s))
    return !0;
  if (r === "")
    return !Xi.has(s);
  const i = oc.get(s);
  return i === void 0 ? !1 : r.length > i.length ? (Aw(s), !0) : i.startsWith(r) && r.length <= i.length ? !1 : (Aw(s), !0);
}
function t8(t) {
  var r;
  if (!((r = t == null ? void 0 : t.selection) != null && r.$from))
    return;
  const e = t.selection.$from, A = e.parent.textContent, n = e.start(), s = $H(A);
  s !== null && lY(n, s);
}
function JD(t) {
  var n;
  const e = (n = t == null ? void 0 : t.editor) == null ? void 0 : n.state, A = t == null ? void 0 : t.range;
  return !e || !A ? !0 : cY({ state: e, range: A });
}
function lY(t, e) {
  Xi.add(t), typeof e == "string" && oc.set(t, e);
}
function Aw(t) {
  Xi.delete(t), oc.delete(t);
}
function Bhe() {
  Xi.clear(), oc.clear();
}
function ghe(t, e) {
  const A = e.toLowerCase();
  return A ? t.filter(
    (n) => n.title.toLowerCase().startsWith(A)
  ) : t;
}
function hhe(t, e) {
  return `
        <div class="slash-menu-container">
          <div class="slash-menu-list">
            ${t.map((n, s) => {
    const r = n.stub ? " slash-menu-item--stub" : "";
    return `
              <button class="slash-menu-item${s === e ? " is-selected" : ""}${r}" data-index="${s}" data-item-title="${n.title}" type="button">
                <div class="slash-menu-icon-wrapper">
                  <span class="default-icon">${n.icon || n.title.charAt(0)}</span>
                </div>
                <div class="slash-menu-text">
                  <div class="slash-menu-label">${n.title}</div>
                </div>
              </button>
            `;
  }).join("")}
          </div>
        </div>
      `;
}
function WD(t) {
  const e = document.querySelector(".slash-command-suggestion");
  e && (t.length === 0 ? e.setAttribute("data-empty", "true") : e.removeAttribute("data-empty"));
}
function A8() {
  const t = document.querySelector(".slash-command-suggestion");
  t && t.removeAttribute("data-empty");
}
function n8() {
  if (typeof document > "u")
    return;
  const t = (e) => {
    var A, n;
    e && ((n = (A = e._tippy) == null ? void 0 : A.destroy) == null || n.call(A), e.remove());
  };
  document.querySelectorAll(".slash-commands-menu").forEach((e) => {
    t(e.closest("[data-tippy-root]"));
  }), document.querySelectorAll("[data-tippy-root]").forEach((e) => {
    (e.querySelector(".slash-menu-container, .slash-commands-menu") || e.querySelector('.tippy-box[data-theme="slash-menu"]')) && t(e);
  });
}
function uhe(t) {
  t && _H(t), n8(), A8();
}
function dhe(t) {
  uhe(t), Bhe();
}
function whe(t, e) {
  t.dataset.bound !== "true" && (t.dataset.bound = "true", t.addEventListener("mousedown", (A) => {
    const n = A.target.closest(".slash-menu-item");
    if (!n || !t.contains(n))
      return;
    A.preventDefault(), A.stopPropagation();
    const s = n.dataset.itemTitle, { displayItems: r, command: i } = e(), o = r.find((a) => a.title === s);
    o && i && i(o);
  }), t.addEventListener("mouseover", (A) => {
    const n = A.target.closest(".slash-menu-item");
    if (!n || !t.contains(n))
      return;
    const s = Number(n.dataset.index);
    Number.isNaN(s) || e().updateSelection(s);
  }));
}
function fhe() {
  let t, e, A = 0, n = null, s = [], r = null, i = null, o = [];
  const a = (M) => {
    if (!(M != null && M.length))
      return;
    const I = new Map(
      o.map((N) => [N.title, N])
    );
    M.forEach((N) => {
      I.set(N.title, N);
    }), o = Array.from(I.values());
  }, c = (M) => {
    n != null && n.command && n.command(M);
  }, l = () => ({
    displayItems: s,
    command: c,
    updateSelection: B
  }), B = (M) => {
    if (!t)
      return;
    t.querySelectorAll(".slash-menu-item").forEach((N) => {
      Number(N.dataset.index) === M ? (N.classList.add("is-selected"), typeof N.scrollIntoView == "function" && N.scrollIntoView({ block: "nearest", behavior: "smooth" })) : N.classList.remove("is-selected");
    }), A = M;
  }, g = () => {
    t && (t.innerHTML = hhe(s, A));
  }, h = (M, I) => M != null && M.length ? ghe(M, I || "") : [], u = (M) => typeof M.text == "string" && M.text.startsWith("/") ? M.text.slice(1) : M.query || "", d = () => {
    e == null || e.destroy(), e = null, t == null || t.remove(), t = null, n8();
  }, w = (M) => {
    if (e || !t)
      return;
    const I = M.clientRect || (n == null ? void 0 : n.clientRect);
    typeof I == "function" && (e = dc(document.body, {
      getReferenceClientRect: I,
      appendTo: () => document.body,
      content: t,
      showOnCreate: !0,
      interactive: !0,
      trigger: "manual",
      placement: "bottom-start",
      theme: "slash-menu",
      arrow: !1,
      offset: [0, 8],
      maxWidth: "none",
      popperOptions: {
        strategy: "fixed"
      },
      onMount(N) {
        N.popper.style.zIndex = "50";
      }
    })[0]);
  }, Q = (M) => {
    n = M, a(M.items);
    const I = u(M);
    if (s = h(o, I), i !== I && (A = 0, i = I), A >= s.length && (A = 0), g(), B(A), w(M), !!e) {
      if (!s.length) {
        e.hide();
        return;
      }
      e.show(), e.setProps({
        getReferenceClientRect: M.clientRect || n.clientRect
      });
    }
  }, p = (M) => {
    var N, m;
    if (t)
      return !0;
    if (!((N = M.items) != null && N.length) && !o.length)
      return !1;
    t = document.createElement("div"), t.className = "slash-commands-menu", whe(t, l);
    const I = (m = M.editor) == null ? void 0 : m.state;
    return I && M.range && (r = I.doc.resolve(M.range.from).start()), !0;
  };
  return {
    onStart(M) {
      var N, m;
      if (!JD(M))
        return d(), !1;
      if (WD(u(M)), d(), i = null, o = [], a(M.items), !((N = M.items) != null && N.length) && !o.length)
        return !1;
      const I = (m = M.editor) == null ? void 0 : m.state;
      return I && M.range && (r = I.doc.resolve(M.range.from).start()), p(M) ? (n = M, w(M), Q(M), s.length > 0) : !1;
    },
    onUpdate(M) {
      if (!JD(M)) {
        d();
        return;
      }
      WD(u(M)), a(M.items), p(M) && Q(M);
    },
    onKeyDown(M) {
      var I;
      if (M.event.key === "Backspace") {
        const N = r;
        return d(), (I = M.view) != null && I.state ? t8(M.view.state) : N !== null && lY(N), M.view && _H(M.view), window.setTimeout(() => {
          var m;
          !((m = M.view) != null && m.state) || N === null || aY(M.view.state);
        }, 0), !1;
      }
      if (!s.length)
        return !1;
      if (M.event.key === "ArrowUp") {
        const N = (A - 1 + s.length) % s.length;
        return B(N), !0;
      }
      if (M.event.key === "ArrowDown") {
        const N = (A + 1) % s.length;
        return B(N), !0;
      }
      if (M.event.key === "Enter") {
        const N = s[A];
        return N && c(N), !0;
      }
      return M.event.key === "Escape" ? (d(), !0) : !1;
    },
    onExit() {
      A8(), d(), n = null, s = [], A = 0, i = null, o = [], r = null;
    }
  };
}
function s8() {
  return new ct({
    key: new Bt("slashDismissSync"),
    props: {
      handleKeyDown(t, e) {
        return e.key !== "Backspace" || t8(t.state), !1;
      }
    },
    appendTransaction(t, e, A) {
      return t.some((n) => n.docChanged) && aY(A, e), null;
    }
  });
}
function Qhe(t) {
  return typeof window < "u" && typeof window.__exiqIsEmptyLineSlashAllowed == "function" ? window.__exiqIsEmptyLineSlashAllowed(t) : cY(t);
}
function Ihe() {
  return typeof window < "u" && typeof window.__exiqCreateSlashDismissSyncPlugin == "function" ? window.__exiqCreateSlashDismissSyncPlugin() : s8();
}
function Che(t) {
  return typeof window < "u" && typeof window.__exiqShouldResetSlashDismissed == "function" ? window.__exiqShouldResetSlashDismissed(t) : e8(t);
}
tt.create({
  name: "slashCommand",
  addOptions() {
    return {
      suggestion: {
        char: "/",
        allow: Qhe,
        command: ({ editor: t, range: e, props: A }) => {
          A.command({ editor: t, range: e });
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      Ihe(),
      Oz({
        editor: this.editor,
        decorationClass: "slash-command-suggestion",
        shouldResetDismissed: Che,
        ...this.options.suggestion
      })
    ];
  }
});
function r8(t) {
  if (!t)
    return "";
  const [e, A, n] = t.split("-").map(Number);
  if (!e || !A || !n)
    return t;
  const s = new Date(e, A - 1, n);
  return Number.isNaN(s.getTime()) ? t : s.toLocaleDateString("en-US", {
    year: "numeric",
    month: "long",
    day: "numeric"
  });
}
function i8(t) {
  return {
    isoDate: t,
    label: r8(t)
  };
}
function Ehe(t) {
  if (t == null || t === "") return null;
  if (typeof t == "string") {
    if (/^\d{4}-\d{2}-\d{2}$/.test(t)) return t;
    if (/^\d{4}-\d{2}-\d{2}T/.test(t)) return t.slice(0, 10);
  }
  const e = t instanceof Date ? t : new Date(t);
  if (Number.isNaN(e.getTime())) return null;
  const A = e.getFullYear(), n = String(e.getMonth() + 1).padStart(2, "0"), s = String(e.getDate()).padStart(2, "0");
  return `${A}-${n}-${s}`;
}
const o8 = /^(https?:\/\/|mailto:|tel:)/i;
function Mhe(t) {
  if (!t)
    return !1;
  const e = t.split(":")[0];
  return e === "localhost" || /^\d{1,3}(\.\d{1,3}){3}$/.test(e) ? !0 : e.includes(".") && /^[\w.-]+$/.test(e);
}
function phe(t) {
  return /^mailto:[^\s@]+@[^\s@]+\.[^\s@]+/i.test(t);
}
function mhe(t) {
  return /^tel:[+\d\s().-]+$/i.test(t.trim());
}
function Yhe(t) {
  try {
    const e = new URL(t);
    return e.protocol !== "http:" && e.protocol !== "https:" ? !1 : Mhe(e.hostname);
  } catch {
    return !1;
  }
}
function a8(t) {
  const e = (t || "").trim();
  if (!e)
    return null;
  if (/^mailto:/i.test(e))
    return phe(e) ? e : null;
  if (/^tel:/i.test(e))
    return mhe(e) ? e : null;
  const A = o8.test(e) ? e : `https://${e}`;
  return Yhe(A) ? A : null;
}
function yhe(t) {
  const e = (t || "").trim();
  return o8.test(e) ? e : null;
}
function Fhe(t, e) {
  t.preventDefault(), t.stopImmediatePropagation();
  const A = yhe(e == null ? void 0 : e.getAttribute("href"));
  A && window.open(A, "_blank", "noopener,noreferrer");
}
function OD(t, e, A, n) {
  return typeof DOMRect < "u" ? new DOMRect(t, e, A, n) : {
    x: t,
    y: e,
    width: A,
    height: n,
    left: t,
    top: e,
    right: t + A,
    bottom: e + n
  };
}
function Nhe(t) {
  const e = t == null ? void 0 : t.view;
  if (!e || typeof e.coordsAtPos != "function")
    return OD(0, 0, 1, 1);
  const { from: A, to: n } = t.state.selection, s = e.coordsAtPos(A), r = e.coordsAtPos(n);
  return OD(
    s.left,
    Math.min(s.top, r.top),
    Math.max(r.right - s.left, 1),
    Math.max(s.bottom, r.bottom) - Math.min(s.top, r.top)
  );
}
function BY(t, e, A = {}) {
  const n = a8(e);
  if (!t || !n)
    return !1;
  const { empty: s } = t.state.selection;
  if (s) {
    const r = A.displayText || n;
    return t.chain().focus().insertContent([
      {
        type: "text",
        text: r,
        marks: [{ type: "link", attrs: { href: n } }]
      },
      { type: "text", text: " " }
    ]).run(), !0;
  }
  return t.chain().focus().extendMarkRange("link").setLink({ href: n }).run(), !0;
}
function gY(t) {
  return t ? (t.chain().focus().extendMarkRange("link").unsetLink().run(), !0) : !1;
}
function Dhe(t, e) {
  if (!(t instanceof Element) || !e)
    return null;
  const A = t.closest("a.editor-link, a.tiptap-link, a[href]");
  return !(A instanceof HTMLAnchorElement) || !e.contains(A) ? null : A;
}
function xhe(t, e) {
  if (!(t != null && t.view) || !e)
    return !1;
  try {
    const A = t.view.posAtDOM(e, 0);
    return typeof A != "number" ? !1 : (t.chain().focus().setTextSelection(A).extendMarkRange("link").run(), t.isActive("link"));
  } catch {
    return !1;
  }
}
const cM = "100000", PD = "exiq-link-input-popup-styles", KD = `
  .slash-link-input-popup {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 8px;
    background: #fff;
    border: 1px solid #eaecf0;
    border-radius: 8px;
    box-shadow: 0 8px 16px rgba(16, 24, 40, 0.12);
  }
  .slash-link-input-popup .link-input-form {
    display: flex;
    align-items: center;
    gap: 8px;
    margin: 0;
  }
  .slash-link-input-popup .link-input {
    width: 240px;
    min-height: 36px;
    padding: 8px 10px;
    border: 1px solid #2563eb;
    border-radius: 8px;
    font: inherit;
    box-sizing: border-box;
    outline: none;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.12);
    transition: border-color 0.15s ease, box-shadow 0.15s ease;
  }
  .slash-link-input-popup .link-input:focus {
    border-color: #1d4ed8;
    box-shadow: 0 0 0 3px rgba(37, 99, 235, 0.2);
  }
  .slash-link-input-popup .link-input--invalid {
    border-color: #dc2626;
    box-shadow: 0 0 0 3px rgba(220, 38, 38, 0.12);
  }
  .slash-link-input-popup .link-input-error {
    margin: 0;
    font-size: 12px;
    line-height: 1.4;
    color: #dc2626;
    white-space: nowrap;
  }
  .slash-link-input-popup .link-action-btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border: 0;
    border-radius: 8px;
    background: #f2f4f7;
    cursor: pointer;
  }
  [data-tippy-root]:has(.slash-link-input-popup) {
    z-index: ${cM} !important;
  }
`;
function Ghe() {
  if (typeof document > "u")
    return;
  let t = document.getElementById(PD);
  t || (t = document.createElement("style"), t.id = PD, document.head.appendChild(t)), t.textContent !== KD && (t.textContent = KD);
}
function VD() {
  typeof document > "u" || document.querySelectorAll(".slash-link-input-popup").forEach((t) => {
    var e;
    (e = t.closest("[data-tippy-root]")) == null || e.remove();
  });
}
function XD(t) {
  t && window.requestAnimationFrame(() => {
    t.focus({ preventScroll: !0 }), t.select();
  });
}
function zhe(t, e, A = {}) {
  if (!(t != null && t.view))
    return null;
  Ghe(), VD();
  let n = null, s = !1;
  const r = document.createElement("div");
  r.className = "link-input-popup slash-link-input-popup", r.dataset.exiqManagedLinkPopup = "true", r.innerHTML = `
    <form class="link-input-form" novalidate>
      <input
        type="text"
        inputmode="url"
        class="link-input"
        placeholder="Paste a link..."
        aria-label="Link URL"
        aria-describedby="exiq-link-input-error"
        autocomplete="off"
      />
      <button type="submit" class="link-action-btn" aria-label="Apply link">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
          <path d="M2.5 8H13.5M13.5 8L9 3.5M13.5 8L9 12.5" stroke="#6b7280" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
        </svg>
      </button>
      <p id="exiq-link-input-error" class="link-input-error" hidden>Enter a valid link (e.g. example.com)</p>
    </form>
  `;
  const i = r.querySelector("form"), o = r.querySelector("input"), a = r.querySelector(".link-input-error");
  r.addEventListener("mousedown", (h) => {
    h.preventDefault();
  });
  const c = () => {
    var h, u;
    s || (s = !0, n && !((h = n.state) != null && h.isDestroyed) && (n.hide(), n.destroy()), n = null, VD(), (u = A.onClose) == null || u.call(A));
  }, l = () => {
    o.classList.remove("link-input--invalid"), o.removeAttribute("aria-invalid"), a.hidden = !0;
  }, B = () => {
    o.classList.add("link-input--invalid"), o.setAttribute("aria-invalid", "true"), a.hidden = !1, XD(o);
  };
  A.initialUrl && (o.value = A.initialUrl), o.addEventListener("input", l);
  const g = () => {
    if (s)
      return;
    const h = o.value.trim();
    if (!h) {
      if (l(), A.allowUnset)
        try {
          typeof A.onSave == "function" ? A.onSave(null) : gY(t);
        } finally {
          c();
        }
      else
        c();
      return;
    }
    const u = a8(h);
    if (!u) {
      B();
      return;
    }
    l();
    try {
      typeof A.onSave == "function" ? A.onSave(u) : BY(t, u, { displayText: "link" });
    } finally {
      c();
    }
  };
  return i.addEventListener("submit", (h) => {
    h.preventDefault(), h.stopPropagation(), g();
  }), o.addEventListener("keydown", (h) => {
    h.key === "Escape" && (h.preventDefault(), h.stopPropagation(), c());
  }), n = dc(document.body, {
    getReferenceClientRect: e,
    appendTo: () => document.body,
    content: r,
    showOnCreate: !0,
    interactive: !0,
    trigger: "manual",
    placement: "bottom-start",
    theme: "slash-menu",
    arrow: !1,
    offset: [0, 8],
    maxWidth: "none",
    popperOptions: {
      strategy: "fixed"
    },
    onClickOutside() {
      c();
    },
    onMount(h) {
      h.popper.style.zIndex = cM;
      const u = h.popper.closest("[data-tippy-root]");
      u && (u.style.zIndex = cM), XD(o);
    }
  })[0], n;
}
function Uhe(t) {
  return typeof window < "u" && typeof window.__exiqIsEmptyLineSlashAllowed == "function" ? window.__exiqIsEmptyLineSlashAllowed(t) : cY(t);
}
function bhe() {
  return typeof window < "u" && typeof window.__exiqCreateSlashDismissSyncPlugin == "function" ? window.__exiqCreateSlashDismissSyncPlugin() : s8();
}
function vhe(t) {
  return typeof window < "u" && typeof window.__exiqShouldResetSlashDismissed == "function" ? window.__exiqShouldResetSlashDismissed(t) : e8(t);
}
const jhe = tt.create({
  name: "slashCommand",
  addOptions() {
    return {
      suggestion: {
        char: "/",
        allow: Uhe,
        command: ({ editor: t, range: e, props: A }) => {
          A.command({ editor: t, range: e });
        }
      }
    };
  },
  addProseMirrorPlugins() {
    return [
      bhe(),
      Oz({
        editor: this.editor,
        decorationClass: "slash-command-suggestion",
        shouldResetDismissed: vhe,
        render: () => ({
          onStart: (t) => {
            const e = document.querySelector(".slash-command-suggestion");
            e && (t.query.length === 0 ? e.setAttribute("data-empty", "true") : e.removeAttribute("data-empty"));
          },
          onUpdate: (t) => {
            const e = document.querySelector(".slash-command-suggestion");
            e && (t.query.length === 0 ? e.setAttribute("data-empty", "true") : e.removeAttribute("data-empty"));
          },
          onExit: () => {
            const t = document.querySelector(".slash-command-suggestion");
            t && t.removeAttribute("data-empty");
          }
        }),
        ...this.options.suggestion
      })
    ];
  }
});
function Hhe() {
  return typeof window < "u" && typeof window.__exiqRenderSlashMenuItems == "function" ? window.__exiqRenderSlashMenuItems() : fhe();
}
const khe = ({ query: t }) => [
  {
    title: "Text",
    description: "Just start writing with plain text.",
    icon: "T",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setNode("paragraph").run();
    }
  },
  {
    title: "Heading 1",
    description: "Big section heading.",
    icon: "H1",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setNode("heading", { level: 1 }).run();
    }
  },
  {
    title: "Heading 2",
    description: "Medium section heading.",
    icon: "H2",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setNode("heading", { level: 2 }).run();
    }
  },
  {
    title: "Heading 3",
    description: "Small section heading.",
    icon: "H3",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setNode("heading", { level: 3 }).run();
    }
  },
  {
    title: "Bullet List",
    description: "Create a simple bulleted list.",
    icon: "•",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).toggleBulletList().run();
    }
  },
  {
    title: "Numbered List",
    description: "Create a list with numbering.",
    icon: "1.",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).toggleOrderedList().run();
    }
  },
  {
    title: "Task List",
    description: "Track tasks with a checklist.",
    icon: "☑",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).toggleTaskList().run();
    }
  },
  {
    title: "Quote",
    description: "Capture a quotation.",
    icon: '"',
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).toggleBlockquote().run();
    }
  },
  {
    title: "Divider",
    description: "Visually divide blocks.",
    icon: "—",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setHorizontalRule().run();
    }
  },
  {
    title: "Table",
    description: "Insert a table.",
    icon: "⊞",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).insertTable({ rows: 3, cols: 3, withHeaderRow: !0 }).run();
    }
  },
  {
    title: "Bold",
    description: "Make text bold.",
    icon: "B",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setMark("bold").run();
    }
  },
  {
    title: "Italic",
    description: "Make text italic.",
    icon: "I",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setMark("italic").run();
    }
  },
  {
    title: "Underline",
    description: "Underline text.",
    icon: "U",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setMark("underline").run();
    }
  },
  {
    title: "Strikethrough",
    description: "Strike through text.",
    icon: "S",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setMark("strike").run();
    }
  },
  {
    title: "Code",
    description: "Inline code snippet.",
    icon: "<>",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setMark("code").run();
    }
  },
  {
    title: "Highlight",
    description: "Highlight text.",
    icon: "⚠",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).setMark("highlight").run();
    }
  },
  {
    title: "Link",
    description: "Create a hyperlink.",
    icon: "🔗",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).run();
      const n = e.getAttributes("link").href || "";
      window.setTimeout(() => {
        e.view.dom.dispatchEvent(new CustomEvent("open-link-modal", {
          bubbles: !0,
          composed: !0,
          detail: {
            editor: e,
            initialUrl: n,
            allowUnset: !0,
            onSave: (s) => {
              if (s) {
                BY(e, s, { displayText: "link" });
                return;
              }
              gY(e);
            }
          }
        }));
      }, 0);
    }
  },
  {
    title: "Image",
    description: "Insert an image by URL.",
    icon: "🖼️",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).run(), e.view.dom.dispatchEvent(new CustomEvent("open-image-modal", {
        bubbles: !0,
        detail: {
          onSave: (n) => {
            e.chain().focus().setImage({ src: n }).run();
          }
        }
      }));
    }
  },
  {
    title: "YouTube",
    description: "Embed a YouTube video by URL.",
    icon: "▶️",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).run(), e.view.dom.dispatchEvent(new CustomEvent("open-youtube-modal", {
        bubbles: !0,
        detail: {
          onSave: (n) => {
            e.chain().focus().setYoutubeVideo({ src: n }).run();
          }
        }
      }));
    }
  },
  {
    title: "Date",
    description: "Insert a date.",
    icon: "📅",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).run(), window.setTimeout(() => {
        e.view.dom.dispatchEvent(new CustomEvent("open-date-modal", {
          bubbles: !0,
          composed: !0,
          detail: {
            onSave: (n) => {
              e.chain().focus().insertContent({
                type: "date",
                attrs: i8(n)
              }).run();
            }
          }
        }));
      }, 0);
    }
  },
  {
    title: "Equation",
    description: "Insert a math equation centered on its own line.",
    icon: "∑",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).run(), e.view.dom.dispatchEvent(new CustomEvent("open-math-modal", {
        bubbles: !0,
        composed: !0,
        detail: {
          initialValue: "",
          onSave: (n) => {
            e.chain().focus().insertContent({
              type: "blockMath",
              attrs: { latex: n }
            }).run();
          }
        }
      }));
    }
  },
  {
    title: "Math Formula",
    description: "Insert a math formula inside a paragraph.",
    icon: "√",
    command: ({ editor: e, range: A }) => {
      e.chain().focus().deleteRange(A).run(), e.view.dom.dispatchEvent(new CustomEvent("open-math-modal", {
        bubbles: !0,
        composed: !0,
        detail: {
          initialValue: "",
          onSave: (n) => {
            e.chain().focus().insertContent({
              type: "inlineMath",
              attrs: { latex: n }
            }).run();
          }
        }
      }));
    }
  }
].filter((e) => e.title.toLowerCase().startsWith(t.toLowerCase())), Rhe = "link-button-paragraph", Lhe = (t) => {
  if (t.type.name !== "paragraph" || t.childCount === 0) return !1;
  let e = null;
  for (let A = 0; A < t.childCount; A += 1) {
    const n = t.child(A), s = n.isText ? n.marks.find((r) => r.type.name === "link") : void 0;
    if (!s || e && !e.eq(s)) return !1;
    e = s;
  }
  return !0;
}, ZD = (t) => {
  const e = [];
  return t.descendants((A, n) => A.type.name !== "paragraph" ? !0 : (Lhe(A) && e.push(Wt.node(n, n + A.nodeSize, { class: Rhe })), !1)), It.create(t, e);
}, qD = new Bt("linkButtonParagraph"), She = tt.create({
  name: "linkButtonParagraph",
  addProseMirrorPlugins() {
    return [
      new ct({
        key: qD,
        state: {
          init: (t, e) => ZD(e.doc),
          apply: (t, e) => t.docChanged ? ZD(t.doc) : e
        },
        props: {
          decorations: (t) => qD.getState(t)
        }
      })
    ];
  }
}), _D = [
  { id: "erick-kish", label: "Erick Kish" },
  { id: "tanya", label: "Tanya" },
  { id: "vicky", label: "Vicky" },
  { id: "ahsan", label: "Ahsan" },
  { id: "dan", label: "Dan" },
  { id: "tauseef", label: "Tauseef" },
  { id: "ajay", label: "Ajay" }
], The = ({ query: t }) => {
  const e = t.trim().toLowerCase();
  return e ? _D.filter((A) => A.label.toLowerCase().includes(e)) : _D;
}, Jhe = () => {
  let t, e, A = 0;
  const n = (i, o) => {
    if (!t) return;
    t.querySelectorAll(".mention-menu-item").forEach((c, l) => {
      l === i ? (c.classList.add("is-selected"), c.scrollIntoView({ block: "nearest" })) : c.classList.remove("is-selected");
    }), A = i;
  }, s = (i) => {
    if (!i.length) {
      t.innerHTML = '<div class="mention-menu-empty">No matches</div>';
      return;
    }
    const o = i.map((a, c) => `
          <button class="mention-menu-item ${c === A ? "is-selected" : ""}" data-index="${c}" type="button">
            <span class="mention-menu-label">${a.label}</span>
          </button>
        `).join("");
    t.innerHTML = `
      <div class="mention-menu-list">
        ${o}
      </div>
    `;
  }, r = (i, o) => {
    t.querySelectorAll(".mention-menu-item").forEach((a, c) => {
      a.addEventListener("click", (l) => {
        l.preventDefault(), l.stopPropagation(), o.command(i[c]);
      }), a.addEventListener("mouseenter", () => {
        n(c);
      });
    });
  };
  return {
    onStart: (i) => (t = document.createElement("div"), t.className = "mention-menu", A = 0, s(i.items), r(i.items, i), e = dc("body", {
      getReferenceClientRect: i.clientRect,
      appendTo: () => document.body,
      content: t,
      showOnCreate: !0,
      interactive: !0,
      trigger: "manual",
      placement: "bottom-start",
      theme: "mention-menu",
      arrow: !1,
      offset: [0, 8],
      maxWidth: "none",
      onMount(o) {
        o.popper.style.zIndex = "999999";
      }
    })[0], !0),
    onUpdate(i) {
      !e || !t || (s(i.items), r(i.items, i), A >= i.items.length && (A = 0, n(0, i.items)), e.setProps({
        getReferenceClientRect: i.clientRect
      }));
    },
    onKeyDown(i) {
      const o = i.items;
      if (!o.length) return !1;
      if (i.event.key === "ArrowUp") {
        const a = (A - 1 + o.length) % o.length;
        return n(a), !0;
      }
      if (i.event.key === "ArrowDown") {
        const a = (A + 1) % o.length;
        return n(a), !0;
      }
      if (i.event.key === "Enter") {
        const a = o[A];
        return a && i.command(a), !0;
      }
      return i.event.key === "Escape" ? (e == null || e.hide(), !0) : !1;
    },
    onExit() {
      e == null || e.destroy(), t == null || t.remove(), e = null, t = null, A = 0;
    }
  };
}, Whe = Zt.create({
  name: "date",
  group: "inline",
  inline: !0,
  atom: !0,
  addAttributes() {
    return {
      isoDate: {
        default: null,
        parseHTML: (t) => t.getAttribute("data-iso-date"),
        renderHTML: (t) => t.isoDate ? {
          "data-iso-date": t.isoDate
        } : {}
      },
      label: {
        default: null,
        parseHTML: (t) => {
          var e;
          return ((e = t.textContent) == null ? void 0 : e.trim()) || null;
        }
      }
    };
  },
  parseHTML() {
    return [{ tag: "span[data-date-node]" }];
  },
  renderHTML({ node: t, HTMLAttributes: e }) {
    const A = t.attrs.label || r8(t.attrs.isoDate) || "Date";
    return [
      "span",
      Ct(e, {
        "data-date-node": "",
        class: "tiptap-date"
      }),
      A
    ];
  },
  addCommands() {
    return {
      insertDate: (t) => ({ chain: e }) => e().insertContent({
        type: this.name,
        attrs: i8(t.isoDate)
      }).run()
    };
  }
}), Ohe = {
  name: "MyButton",
  props: {
    label: {
      type: String,
      required: !1,
      default: ""
    },
    type: {
      type: String,
      default() {
        return "button";
      }
    },
    fontSize: {
      type: String
    },
    primary: {
      type: Boolean,
      default: !1
    },
    secondary: {
      type: Boolean,
      default: !1
    },
    tertiary: {
      type: Boolean,
      default: !1
    },
    size: {
      type: String,
      validator: function(t) {
        return ["small", "normal", "medium", "large", "x-large", "hug"].indexOf(t) !== -1;
      }
    },
    fullwidth: {
      type: [String, Boolean],
      validator: function(t) {
        return typeof t == "boolean" ? !0 : ["default", "hover", "active", "disable"].indexOf(t) !== -1;
      }
    },
    normal: {
      type: String,
      validator: function(t) {
        return ["normal-default", "normal-hover", "normal-active", "normal-disable"].indexOf(t) !== -1;
      }
    },
    outline: {
      type: String,
      validator: function(t) {
        return ["outline-default", "outline-hover", "outline-active", "outline-disable"].indexOf(t) !== -1;
      }
    },
    variantTypes: {
      type: String,
      validator: function(t) {
        return ["default", "hover", "active", "disable"].indexOf(t) !== -1;
      }
    },
    icon: {
      type: String,
      default: null
    },
    rightIcon: {
      type: String,
      default: null
    },
    backgroundColor: {
      type: String
    },
    plusIcon: {
      type: String,
      default: null
    },
    destructive: {
      type: Boolean,
      default: !1
    },
    termination: {
      type: Boolean,
      default: !1
    },
    general: {
      type: Boolean,
      default: !1
    },
    buttonWidth: {
      validator: function(t) {
        return ["full", "auto"].indexOf(t) !== -1;
      }
    },
    loading: {
      type: String,
      validator: function(t) {
        return t === null || ["left", "right"].indexOf(t) !== -1;
      },
      default: null,
      required: !1
    },
    iconHorizontalMargin: {
      type: Boolean,
      default: !1
    },
    must: {
      type: Boolean,
      default: !1
    },
    submitOnEnter: {
      type: Boolean,
      default: !1
    },
    disabled: {
      type: Boolean,
      default: !1
    }
  },
  mounted() {
    var t;
    this.submitOnEnter && (this.enterScope = this.$el.closest('[role="dialog"], form') || this.$el.parentElement, (t = this.enterScope) == null || t.addEventListener("keydown", this.handleEnterKey));
  },
  beforeDestroy() {
    var t;
    (t = this.enterScope) == null || t.removeEventListener("keydown", this.handleEnterKey), this.enterScope = null;
  },
  computed: {
    fullwidthValue() {
      const t = this.fullwidth;
      return t === !0 ? "default" : t === !1 ? "disable" : t;
    },
    classes() {
      return {
        "storybook-button": !0,
        "storybook-button--primary": this.primary,
        "storybook-button--secondary": this.secondary && !this.size && !this.fullwidth,
        "storybook-button--tertiary": this.tertiary && !this.size && !this.fullwidth,
        [`storybook-button--btn-${this.size}`]: !0,
        [`storybook-button--${this.size}`]: !0,
        [`storybook-button--btn-${this.fullwidthValue}`]: this.fullwidth && !this.secondary && !this.tertiary,
        [`storybook-button--${this.fullwidthValue}`]: this.fullwidth && !this.secondary && !this.tertiary,
        [`storybook-button--btn-${this.fullwidthValue}-${this.size}`]: this.fullwidth && this.size,
        [`storybook-button--btn-${this.normal}`]: this.normal && !this.size,
        [`storybook-button--btn-${this.normal}-icon`]: this.normal && (this.icon || this.rightIcon) && !this.size,
        [`storybook-button--${this.normal}`]: !0,
        [`storybook-button--btn-${this.outline}`]: this.outline && !this.icon && !this.size,
        [`storybook-button--btn-${this.outline}-icon`]: this.outline && (this.icon || this.rightIcon) && !this.size,
        [`storybook-button--${this.outline}`]: !0,
        "storybook-button--secondary-size": this.secondary && this.size,
        "storybook-button--tertiary-size": this.tertiary && this.size,
        [`storybook-button--secondary-size-${this.variantTypes}`]: this.variantTypes && this.secondary && this.size,
        [`storybook-button--tertiary-size-${this.variantTypes}`]: this.variantTypes && this.tertiary && this.size,
        [`storybook-button--secondary-${this.fullwidthValue}`]: this.fullwidth && this.secondary,
        [`storybook-button--btn-secondary-${this.fullwidthValue}`]: this.fullwidth && this.secondary,
        [`storybook-button--tertiary-${this.fullwidthValue}`]: this.fullwidth && this.tertiary,
        [`storybook-button--btn-tertiary-${this.fullwidthValue}`]: this.fullwidth && this.tertiary,
        [`storybook-plus-button-${this.variantTypes}`]: !0,
        [`storybook-button--${this.variantTypes}-${this.size}`]: !0,
        "storybook-button--primary-destructive": !this.fullwidth && this.destructive && !this.size,
        "storybook-button--secondary-destructive": this.secondary && !this.size && !this.fullwidth && this.destructive,
        "storybook-button--tertiary-destructive": this.tertiary && !this.size && !this.fullwidth && this.destructive,
        [`storybook-button--btn-${this.size}-destructive`]: this.destructive,
        [`storybook-button--${this.fullwidthValue}-destructive`]: this.fullwidth && !this.secondary && !this.tertiary && this.destructive,
        [`storybook-button--${this.normal}-destructive`]: this.destructive,
        [`storybook-button--btn-${this.normal}-destructive`]: this.normal && !this.size && this.destructive,
        [`storybook-button--btn-${this.normal}-icon-destructive`]: this.normal && (this.icon || this.rightIcon) && !this.size && this.destructive,
        "storybook-button--secondary-size-destructive": this.secondary && this.size && this.destructive,
        "storybook-button--tertiary-size-destructive": this.tertiary && this.size && this.destructive,
        [`storybook-button--secondary-size-${this.variantTypes}-destructive`]: this.variantTypes && this.secondary && this.size && this.destructive,
        [`storybook-button--tertiary-size-${this.variantTypes}-destructive`]: this.variantTypes && this.tertiary && this.size && this.destructive,
        [`storybook-button--secondary-${this.fullwidthValue}-destructive`]: this.fullwidth && this.secondary && this.destructive,
        [`storybook-button--btn-secondary-${this.fullwidthValue}-destructive`]: this.fullwidth && this.secondary && this.destructive,
        [`storybook-button--tertiary-${this.fullwidthValue}-destructive`]: this.fullwidth && this.tertiary && this.destructive,
        [`storybook-button--btn-tertiary-${this.fullwidthValue}-destructive`]: this.fullwidth && this.tertiary && this.destructive,
        "storybook-button--primary-termination": !this.fullwidth && this.termination && !this.size,
        [`storybook-button--btn-${this.size}-termination`]: this.termination,
        [`storybook-button--${this.fullwidthValue}-termination`]: this.fullwidth && !this.secondary && !this.tertiary && this.termination,
        [`storybook-button--${this.normal}-termination`]: this.termination,
        [`storybook-button--btn-${this.normal}-termination`]: this.normal && !this.size && this.termination,
        [`storybook-button--btn-${this.normal}-icon-termination`]: this.normal && (this.icon || this.rightIcon) && !this.size && this.termination,
        [`storybook-button--btn-${this.normal}-icon-termination`]: this.normal && (this.icon || this.rightIcon) && !this.size && this.termination,
        "storybook-button--general": this.general,
        "storybook-button--full": this.loading && this.buttonWidth && this.loading.length > 0 && this.buttonWidth == "full",
        "storybook-button--width-auto": this.buttonWidth === "auto",
        "storybook-button--loader": this.loading && this.loading.length > 0
      };
    },
    style() {
      const t = !!this.label, e = this.plusIcon && !t, A = this.buttonWidth === "auto";
      return {
        backgroundColor: this.backgroundColor,
        fontSize: this.fontSize + "px",
        paddingLeft: !this.fullwidth && this.size !== "small" && !e ? parseInt(this.fontSize || 18) + "px" : "",
        paddingRight: !this.fullwidth && this.size !== "small" && !e ? parseInt(this.fontSize || 18) + "px" : "",
        paddingTop: !this.fullwidth && this.size !== "small" && !e ? parseInt(this.fontSize || 12) - 6 + "px" : "",
        paddingBottom: !this.fullwidth && this.size !== "small" && !e ? parseInt(this.fontSize || 12) - 6 + "px" : "",
        position: this.fullwidth && this.fontSize ? "absolute" : "",
        top: this.fullwidth && this.fontSize ? parseInt(this.fontSize) + "px" : "",
        bottom: this.fullwidth && this.fontSize ? parseInt(this.fontSize) + "px" : "",
        cursor: this.loading ? "not-allowed !important" : "",
        width: A ? "fit-content" : t && this.size !== "small" ? this.fullwidth ? "100%" : "fit-content" : "",
        borderRadius: "8px"
      };
    }
  },
  methods: {
    handleEnterKey(t) {
      var A;
      if (t.key !== "Enter" || t.repeat || t.isComposing || t.defaultPrevented || this.disabled || this.loading || this.$el.disabled) return;
      const e = t.target;
      (A = e.closest) != null && A.call(e, 'button, a, textarea, [role="button"], [aria-expanded="true"]') || (t.preventDefault(), this.$emit("onClick"));
    },
    onClick() {
      !this.disabled && !this.loading && this.$emit("onClick");
    }
  }
}, Phe = ["type", "disabled"], Khe = ["src"], Vhe = ["src"], Xhe = { key: 2 }, Zhe = ["src"], qhe = { key: 5 };
function _he(t, e, A, n, s, r) {
  var a, c;
  const i = tr("v-icon"), o = lk("ripple");
  return Go((ee(), Ae("button", {
    ref: "myButton",
    type: A.type,
    class: De(r.classes),
    onClick: e[0] || (e[0] = (...l) => r.onClick && r.onClick(...l)),
    style: ia(r.style),
    disabled: !!(A.disabled || A.fullwidth === "disable" || A.normal === "normal-disable" || A.outline === "outline-disable" || A.loading)
  }, [
    A.icon ? (ee(), Ae("img", {
      key: 0,
      src: require(`@components/assets/${A.icon}`),
      alt: "icon",
      class: De({
        "mx-1": A.iconHorizontalMargin
      })
    }, null, 10, Khe)) : je("", !0),
    A.plusIcon ? (ee(), Ae("img", {
      key: 1,
      src: require(`@components/assets/${A.plusIcon}`),
      alt: "icon",
      class: De(["plus-icon", {
        "plus-icon": A.size === "large" || A.size === "x-large",
        "plus-icon-invert": A.variantTypes === "active" || A.variantTypes === "disable",
        "plus-icon-small": A.size === "small"
      }])
    }, null, 10, Vhe)) : je("", !0),
    ((a = A.loading) == null ? void 0 : a.length) > 0 && A.loading == "left" ? (ee(), Ae("span", Xhe, [
      rt(i, null, {
        default: Ur(() => [...e[1] || (e[1] = [
          as("$ex-white-spinner", -1)
        ])]),
        _: 1
      })
    ])) : je("", !0),
    A.label ? (ee(), Ae("span", {
      key: 3,
      style: { margin: "0px 12px" },
      class: De({
        "label-highlight": A.must,
        "": !A.must && A.icon
      })
    }, Mt(A.label), 3)) : je("", !0),
    A.rightIcon ? (ee(), Ae("img", {
      key: 4,
      src: require(`@components/assets/${A.rightIcon}`),
      alt: "icon",
      class: De(["right-arrow-icon", { rightIcon: A.rightIcon }])
    }, null, 10, Zhe)) : je("", !0),
    ((c = A.loading) == null ? void 0 : c.length) > 0 && A.loading == "right" ? (ee(), Ae("span", qhe, [
      rt(i, null, {
        default: Ur(() => [...e[2] || (e[2] = [
          as("$ex-white-spinner", -1)
        ])]),
        _: 1
      })
    ])) : je("", !0)
  ], 14, Phe)), [
    [o]
  ]);
}
const Hc = /* @__PURE__ */ ZA(Ohe, [["render", _he]]), $D = 10001, e3 = "data-body-portal-dropdown", $he = 2, e0e = 240;
function t0e({
  getAnchor: t,
  getDropdown: e,
  getContainer: A = null,
  onClose: n,
  gap: s = $he,
  flipThreshold: r = e0e,
  closeOnOutsideClick: i = !0,
  closeOnEscape: o = !0
}) {
  const a = /* @__PURE__ */ me({
    position: "fixed",
    zIndex: $D,
    top: "0px",
    left: "0px"
  });
  let c = !1, l = null, B = null;
  const g = () => {
    typeof n == "function" && n();
  }, h = (v) => {
    var q, ne;
    if (!(v instanceof Node)) return !1;
    const b = (A || t)(), W = e();
    return !!((q = b == null ? void 0 : b.contains) != null && q.call(b, v) || (ne = W == null ? void 0 : W.contains) != null && ne.call(W, v));
  }, u = () => {
    var V;
    const v = t();
    if (!v) return;
    const b = v.getBoundingClientRect(), W = window.innerHeight - b.bottom, q = (((V = e()) == null ? void 0 : V.offsetHeight) || r) + s, ne = W < q && b.top > W;
    a.value = {
      position: "fixed",
      zIndex: $D,
      left: `${Math.round(b.left)}px`,
      width: `${Math.round(b.width)}px`,
      top: ne ? "" : `${Math.round(b.bottom + s)}px`,
      bottom: ne ? `${Math.round(window.innerHeight - b.top + s)}px` : ""
    };
  }, d = (v) => {
    v.stopPropagation();
  }, w = () => {
    const v = e();
    v && (l = v, v.setAttribute(e3, ""), v.addEventListener("focusin", d), v.parentNode !== document.body && document.body.appendChild(v));
  }, Q = (v) => {
    var b, W;
    (v == null ? void 0 : v.target) instanceof Node && ((W = (b = e()) == null ? void 0 : b.contains) != null && W.call(b, v.target)) || u();
  }, p = (v) => {
    const b = t();
    (v == null ? void 0 : v.target) instanceof Node && b && v.target.contains(b) && u();
  }, M = (v) => {
    h(v.target) || g();
  }, I = (v) => {
    v.key === "Escape" && (v.stopPropagation(), g());
  }, N = () => {
    const v = t();
    typeof ResizeObserver > "u" || !v || (B == null || B.disconnect(), B = new ResizeObserver(() => {
      const b = v.getBoundingClientRect();
      !b.width && !b.height ? g() : u();
    }), B.observe(v));
  }, m = () => {
    window.removeEventListener("scroll", Q, !0), window.removeEventListener("resize", u), window.removeEventListener("transitionend", p, !0), window.removeEventListener("animationend", p, !0), document.removeEventListener("click", M, !0), document.removeEventListener("keydown", I, !0), B == null || B.disconnect(), B = null, l == null || l.removeEventListener("focusin", d);
  }, E = () => {
    const v = l;
    l = null, v && (v.removeAttribute(e3), v.parentNode === document.body && document.body.removeChild(v));
  }, G = () => {
    c || (c = !0, window.addEventListener("scroll", Q, !0), window.addEventListener("resize", u), window.addEventListener("transitionend", p, !0), window.addEventListener("animationend", p, !0), i && document.addEventListener("click", M, !0), o && document.addEventListener("keydown", I, !0), Yn(() => {
      c && (w(), u(), N(), Yn(() => c && u()));
    }));
  }, Y = () => {
    c = !1, m(), E();
  }, U = Y;
  return bn() && Zr(U), { dropdownStyle: a, attach: G, detach: Y, destroy: U, updatePosition: u, isInside: h };
}
const A0e = ["disabled"], n0e = ["src"], s0e = { key: 1 }, r0e = { class: "date-picker-modal" }, i0e = { class: "date-picker-header" }, o0e = ["src"], a0e = { class: "month-year" }, c0e = ["src"], l0e = { class: "date-picker-search-bar" }, B0e = { class: "date-picker-calendar" }, g0e = { class: "date-picker-weekdays" }, h0e = { class: "date-picker-days" }, u0e = ["onClick"], d0e = {
  key: 0,
  class: "dot"
}, w0e = { class: "date-picker-actions" }, f0e = { class: "date-picker-header" }, Q0e = ["src"], I0e = { class: "month-year" }, C0e = ["src"], E0e = { class: "date-picker-search-bar" }, M0e = { class: "date-picker-calendar" }, p0e = { class: "date-picker-weekdays" }, m0e = { class: "date-picker-days" }, Y0e = ["onClick"], y0e = {
  key: 0,
  class: "dot"
}, F0e = { class: "date-picker-actions" }, N0e = "300px", D0e = {
  __name: "DatePicker",
  props: {
    value: {
      type: String,
      default: null
    },
    modal: {
      type: Boolean,
      default: !1
    },
    isDisableDatepicker: {
      type: Boolean,
      default: !1
    },
    isDatePickerOpen: {
      type: Boolean,
      default: !1
    },
    /** Opens the calendar immediately (e.g. editor slash → Date). No API loader on Apply. */
    autoOpen: {
      type: Boolean,
      default: !1
    },
    minDate: {
      type: String,
      default: null
    },
    /** Inclusive upper bound (YYYY-MM-DD). Omit to leave future dates selectable. */
    maxDate: {
      type: String,
      default: null
    },
    /** YYYY-MM-DD strings or (date: Date) => boolean. Applied in addition to min/max. */
    disabledDates: {
      type: [Array, Function],
      default: null
    },
    changeBadgeIndicator: {
      type: Boolean,
      default: !1
    },
    isDirty: {
      type: Boolean,
      default: !1
    },
    customCalendarIcon: {
      type: Boolean,
      default: !1
    },
    dataPickerPlaceHolder: {
      type: String,
      default: "Select date"
    },
    showClearIcon: {
      type: Boolean,
      default: !1
    },
    /** Custom format for displayed date. e.g. 'dd-MMM-yyyy' for 1-Jan-2026 */
    dateFormat: {
      type: String,
      default: null
    }
  },
  emits: ["onApplyDate", "onClose", "onClearSelection"],
  setup(t, { emit: e }) {
    const A = t;
    function n(R) {
      if (R == null || R === "") return null;
      if (R instanceof Date)
        return Number.isNaN(R.getTime()) ? null : new Date(R.getFullYear(), R.getMonth(), R.getDate());
      if (typeof R == "string" && /^\d{4}-\d{2}-\d{2}$/.test(R)) {
        const X = Number(R.slice(0, 4)), ae = Number(R.slice(5, 7)) - 1, Be = Number(R.slice(8, 10));
        return new Date(X, ae, Be);
      }
      const P = new Date(R);
      return Number.isNaN(P.getTime()) ? null : new Date(
        P.getFullYear(),
        P.getMonth(),
        P.getDate()
      );
    }
    const s = e, r = bn(), { proxy: i } = r, o = Fe(
      () => {
        var R;
        return !!(A.isDatePickerOpen && !A.autoOpen && ((R = i == null ? void 0 : i.$loader) != null && R.isAppLoading));
      }
    ), a = /* @__PURE__ */ me(!1), c = /* @__PURE__ */ me(null), l = /* @__PURE__ */ me(null), B = /* @__PURE__ */ me(null), g = /* @__PURE__ */ me(null), h = /* @__PURE__ */ me(null), u = /* @__PURE__ */ me(null), d = /* @__PURE__ */ me((/* @__PURE__ */ new Date()).getMonth()), w = /* @__PURE__ */ me((/* @__PURE__ */ new Date()).getFullYear()), Q = ["Mo", "Tu", "We", "Th", "Fr", "Sa", "Su"], p = () => {
      a.value = !a.value, h.value && (d.value = h.value.getMonth(), w.value = h.value.getFullYear(), u.value = h.value);
    }, M = () => {
      a.value = !1, u.value = null, s("onClose");
    }, { dropdownStyle: I, attach: N, detach: m } = t0e({
      getAnchor: () => g.value || B.value,
      getDropdown: () => l.value,
      getContainer: () => B.value,
      onClose: M
    }), E = Fe(() => ({
      ...I.value,
      width: N0e
    })), G = () => {
      if (A.modal && L(), A.autoOpen && A.modal) {
        a.value = !1, u.value = null, s("onClose");
        return;
      }
      M();
    }, Y = () => {
      h.value = null, u.value = null, s("onClearSelection"), s("onApplyDate", null);
    }, U = Fe(() => {
      const R = (A == null ? void 0 : A.value) || h.value;
      if (!R) return null;
      const P = n(R) || new Date(R);
      if (A.dateFormat === "dd-MMM-yyyy") {
        const X = P.getDate(), ae = P.toLocaleDateString("en-US", { month: "short" }), Be = P.getFullYear();
        return `${X}-${ae}-${Be}`;
      }
      return P.toLocaleDateString("en-US", {
        month: "short",
        day: "numeric",
        year: "numeric"
      });
    }), v = Fe(
      () => new Date(w.value, d.value).toLocaleDateString("en-US", {
        month: "long",
        year: "numeric"
      })
    ), b = Fe(() => {
      const R = [], P = new Date(w.value, d.value, 1).getDay(), X = new Date(
        w.value,
        d.value + 1,
        0
      ).getDate();
      for (let ae = 0; ae < (P === 0 ? 6 : P - 1); ae++)
        R.push("");
      for (let ae = 1; ae <= X; ae++)
        R.push(ae);
      return R;
    }), W = (R) => {
      const P = /* @__PURE__ */ new Date();
      return R && P.getDate() === R && P.getMonth() === d.value && P.getFullYear() === w.value;
    };
    function q(R) {
      const P = R.getFullYear(), X = String(R.getMonth() + 1).padStart(2, "0"), ae = String(R.getDate()).padStart(2, "0");
      return `${P}-${X}-${ae}`;
    }
    function ne(R) {
      if (!A.disabledDates || !R) return !1;
      const P = new Date(R.getFullYear(), R.getMonth(), R.getDate());
      return typeof A.disabledDates == "function" ? !!A.disabledDates(P) : Array.isArray(A.disabledDates) ? A.disabledDates.includes(q(P)) : !1;
    }
    function V(R) {
      if (!R) return !1;
      const P = new Date(R.getFullYear(), R.getMonth(), R.getDate()), X = n(A.minDate), ae = n(A.maxDate);
      return !!(X && P < X || ae && P > ae);
    }
    function se(R) {
      if (!R) return !1;
      const P = new Date(R.getFullYear(), R.getMonth(), R.getDate());
      return V(P) || ne(P);
    }
    const te = Fe(() => {
      const R = /* @__PURE__ */ new Date();
      return R.setHours(0, 0, 0, 0), V(R);
    }), be = Fe(() => u.value ? se(new Date(u.value)) : !1), Oe = Fe(() => {
      const R = n(A.minDate);
      if (!R) return !1;
      const P = new Date(w.value, d.value, 1), X = new Date(R.getFullYear(), R.getMonth(), 1);
      return P <= X;
    }), ke = Fe(() => {
      const R = n(A.maxDate);
      if (!R) return !1;
      const P = new Date(w.value, d.value, 1), X = new Date(R.getFullYear(), R.getMonth(), 1);
      return P >= X;
    });
    CA(
      () => A.value,
      (R) => {
        if (R) {
          const P = n(R);
          P && (h.value = P, u.value = P, d.value = P.getMonth(), w.value = P.getFullYear());
        } else
          h.value = null, u.value = null;
      }
    );
    const Se = (R) => R && u.value && u.value.getDate() === R && u.value.getMonth() === d.value && u.value.getFullYear() === w.value, dt = (R) => {
      !R || mt(R) || (u.value = new Date(w.value, d.value, R));
    }, st = () => {
      const R = /* @__PURE__ */ new Date();
      d.value = R.getMonth(), w.value = R.getFullYear(), u.value = R;
    }, We = () => {
      d.value === 0 ? (d.value = 11, w.value -= 1) : d.value -= 1;
    }, pt = () => {
      d.value === 11 ? (d.value = 0, w.value += 1) : d.value += 1;
    }, xt = () => {
      h.value = u.value;
      const R = i == null ? void 0 : i.$loader, P = (A == null ? void 0 : A.isDatePickerOpen) && !(A != null && A.autoOpen);
      P && R && R.setAppLoading(!0), s("onApplyDate", u.value), P && R && R.setAppLoading(!1), G();
    };
    if (A.value) {
      const R = n(A.value);
      R && (h.value = R, u.value = R, d.value = R.getMonth(), w.value = R.getFullYear());
    }
    const mt = (R) => R ? se(
      new Date(w.value, d.value, R)
    ) : !1, $t = () => {
      Oe.value || We();
    }, Ut = () => {
      ke.value || pt();
    }, RA = () => !!(A != null && A.isDatePickerOpen || A != null && A.autoOpen), H = () => {
      A.modal && Yn(() => {
        const R = c.value;
        R && R.parentNode !== document.body && document.body.appendChild(R);
      });
    }, L = () => {
      const R = c.value;
      (R == null ? void 0 : R.parentNode) === document.body && document.body.removeChild(R);
    };
    Xr(() => {
      A.modal && RA() && document.addEventListener("keydown", _, !0), a.value && (H(), A.modal || N());
    }), Zr(() => {
      document.removeEventListener("keydown", _, !0), L();
    }), CA(a, (R) => {
      R ? (H(), A.modal || N()) : m();
    }), CA(
      () => [A == null ? void 0 : A.isDatePickerOpen, A == null ? void 0 : A.autoOpen],
      (R, P) => {
        const [X, ae] = R || [], [Be, he] = P || [], ie = !!(X || ae), ze = !!(Be || he);
        if (ie) {
          a.value = !0;
          return;
        }
        ze && !ie && (a.value = !1);
      },
      { immediate: !0 }
    );
    const _ = (R) => {
      R.key !== "Escape" || !a.value || !A.modal || (R.preventDefault(), R.stopPropagation(), G());
    };
    return (R, P) => (ee(), Ae("div", {
      ref_key: "containerRef",
      ref: B,
      class: "date-picker-container"
    }, [
      !t.isDatePickerOpen && !t.autoOpen ? (ee(), Ae("button", {
        key: 0,
        ref_key: "displayButtonRef",
        ref: g,
        class: De(["date-picker-display", [
          {
            "date-picker-display-open": a.value,
            "disabled-picker": t.isDisableDatepicker,
            "date-picker-display-dirty": t.isDirty
          }
        ]]),
        onClick: p,
        disabled: t.isDisableDatepicker
      }, [
        rt(CC, {
          name: t.customCalendarIcon ? "calendar_icon" : t.changeBadgeIndicator ? "badge_has_expire" : "badge_indicator"
        }, null, 8, ["name"]),
        F("span", null, Mt(U.value || t.dataPickerPlaceHolder), 1),
        t.showClearIcon && U.value ? (ee(), Ae("img", {
          key: 0,
          class: "append-icon-hover",
          onClick: tA(Y, ["stop"]),
          src: require("@components/assets/x-circle.svg"),
          alt: "icon"
        }, null, 8, n0e)) : je("", !0)
      ], 10, A0e)) : je("", !0),
      a.value ? (ee(), Ae("div", s0e, [
        t.modal ? (ee(), Ae("div", {
          key: 0,
          ref_key: "modalOverlayRef",
          ref: c,
          class: "date-picker-modal-overlay date-picker-modal-overlay--programmatic",
          onClick: tA(G, ["self"])
        }, [
          F("div", r0e, [
            F("div", i0e, [
              F("div", {
                class: De(["date-picker-icon", { "disabled-icon": Oe.value }])
              }, [
                F("img", {
                  src: require("@components/assets/left-icon-dark.svg"),
                  alt: "",
                  class: De(["nav-btn", { "disabled-btn": Oe.value }]),
                  onClick: $t
                }, null, 10, o0e)
              ], 2),
              F("span", a0e, Mt(v.value), 1),
              F("div", {
                class: De(["date-picker-icon", { "disabled-icon": ke.value }])
              }, [
                F("img", {
                  src: require("@components/assets/right-icon-dark.svg"),
                  alt: "",
                  class: De(["nav-btn", { "disabled-btn": ke.value }]),
                  onClick: Ut
                }, null, 10, c0e)
              ], 2)
            ]),
            F("div", l0e, [
              rt(Hc, {
                class: "mr-2",
                outline: "outline-hover",
                label: "Today",
                onOnClick: st,
                size: "normal",
                fullwidth: "default",
                normal: te.value ? "normal-disable" : "normal-hover"
              }, null, 8, ["normal"])
            ]),
            F("div", B0e, [
              F("div", g0e, [
                (ee(), Ae(ft, null, Ns(Q, (X) => F("span", {
                  key: X,
                  class: "weekday"
                }, Mt(X), 1)), 64))
              ]),
              F("div", h0e, [
                (ee(!0), Ae(ft, null, Ns(b.value, (X, ae) => (ee(), Ae("span", {
                  key: ae,
                  class: De([
                    "day",
                    {
                      today: W(X),
                      selected: Se(X),
                      "disabled-picker": mt(X)
                    }
                  ]),
                  onClick: (Be) => dt(X)
                }, [
                  W(X) ? (ee(), Ae("span", d0e)) : je("", !0),
                  as(" " + Mt(X), 1)
                ], 10, u0e))), 128))
              ])
            ]),
            P[0] || (P[0] = F("hr", { class: "hr mt-4" }, null, -1)),
            F("div", w0e, [
              rt(Hc, {
                outline: "outline-hover",
                label: "Cancel",
                onOnClick: G,
                size: "normal",
                fullwidth: "default"
              }),
              rt(Hc, {
                normal: !u.value || be.value ? "normal-disable" : "normal-hover",
                disabled: !u.value || be.value,
                label: "Apply",
                onOnClick: xt,
                size: "normal",
                fullwidth: "default",
                loading: o.value ? "left" : null
              }, null, 8, ["normal", "disabled", "loading"])
            ])
          ])
        ], 512)) : (ee(), Ae("div", {
          key: 1,
          ref_key: "dropdownRef",
          ref: l,
          class: "date-picker-dropdown",
          style: ia(E.value)
        }, [
          F("div", f0e, [
            F("div", {
              class: De(["date-picker-icon", { "disabled-icon": Oe.value }])
            }, [
              F("img", {
                src: require("@components/assets/left-icon-dark.svg"),
                alt: "",
                class: De(["nav-btn", { "disabled-btn": Oe.value }]),
                onClick: $t
              }, null, 10, Q0e)
            ], 2),
            F("span", I0e, Mt(v.value), 1),
            F("div", {
              class: De(["date-picker-icon", { "disabled-icon": ke.value }])
            }, [
              F("img", {
                src: require("@components/assets/right-icon-dark.svg"),
                alt: "",
                class: De(["nav-btn", { "disabled-btn": ke.value }]),
                onClick: Ut
              }, null, 10, C0e)
            ], 2)
          ]),
          F("div", E0e, [
            rt(Hc, {
              class: "mr-2",
              outline: "outline-hover",
              label: "Today",
              onOnClick: st,
              size: "normal",
              fullwidth: "default"
            })
          ]),
          F("div", M0e, [
            F("div", p0e, [
              (ee(), Ae(ft, null, Ns(Q, (X) => F("span", {
                key: X,
                class: "weekday"
              }, Mt(X), 1)), 64))
            ]),
            F("div", m0e, [
              (ee(!0), Ae(ft, null, Ns(b.value, (X, ae) => (ee(), Ae("span", {
                key: ae,
                class: De([
                  "day",
                  { today: W(X), selected: Se(X) }
                ]),
                onClick: (Be) => dt(X)
              }, [
                W(X) ? (ee(), Ae("span", y0e)) : je("", !0),
                as(" " + Mt(X), 1)
              ], 10, Y0e))), 128))
            ])
          ]),
          P[1] || (P[1] = F("hr", { class: "hr mt-4" }, null, -1)),
          F("div", F0e, [
            rt(Hc, {
              outline: "outline-hover",
              label: "Cancel",
              onOnClick: M,
              size: "normal",
              fullwidth: "default"
            }),
            rt(Hc, {
              normal: !u.value || be.value ? "normal-disable" : "normal-hover",
              disabled: !u.value || be.value,
              label: "Apply",
              onOnClick: xt,
              size: "normal",
              fullwidth: "default"
            }, null, 8, ["normal", "disabled"])
          ])
        ], 4))
      ])) : je("", !0)
    ], 512));
  }
}, x0e = /* @__PURE__ */ ZA(D0e, [["__scopeId", "data-v-c4b4fd3d"]]), G0e = Zt.create({
  name: "imageUploadPlaceholder",
  group: "inline",
  inline: !0,
  atom: !0,
  addAttributes() {
    return {
      id: { default: null }
    };
  },
  parseHTML() {
    return [{ tag: "span[data-image-upload-placeholder]" }];
  },
  renderHTML({ HTMLAttributes: t }) {
    return [
      "span",
      Ct(t, { "data-image-upload-placeholder": "" })
    ];
  },
  addNodeView() {
    return ({ node: t }) => {
      const e = document.createElement("span");
      return e.className = "image-upload-placeholder", e.dataset.placeholderId = t.attrs.id, e.innerHTML = `
        <span class="image-upload-placeholder-inner">
          <span class="image-upload-placeholder-spinner"></span>
          <span class="image-upload-placeholder-label">Uploading...</span>
        </span>`, { dom: e };
    };
  }
}), lM = [
  "image/png",
  "image/jpeg",
  "image/gif",
  "image/webp"
];
function c8(t, e) {
  const A = Math.random().toString(36).slice(2, 10);
  return t == null || t.chain().insertContentAt(e, {
    type: "imageUploadPlaceholder",
    attrs: { id: A }
  }).run(), A;
}
function nw(t, e, A) {
  const n = t == null ? void 0 : t.state;
  if (!n)
    return;
  let s = !1;
  n.doc.descendants((r, i) => {
    if (s)
      return !1;
    if (r.type.name === "imageUploadPlaceholder" && r.attrs.id === e) {
      s = !0;
      const o = t.chain();
      A ? o.deleteRange({ from: i, to: i + r.nodeSize }).insertContentAt(i, { type: "image", attrs: { src: A } }).run() : o.deleteRange({ from: i, to: i + r.nodeSize }).run();
    }
  });
}
function z0e(t, e, A) {
  var s;
  const n = t == null ? void 0 : t.view;
  return n ? ((s = n.posAtCoords({ left: e, top: A })) == null ? void 0 : s.pos) ?? n.state.doc.content.size : 0;
}
function U0e(t) {
  return t ? Array.from(t).filter((e) => lM.includes(e.type)) : [];
}
function t3({
  editor: t,
  files: e,
  clientX: A,
  clientY: n,
  uploadFile: s,
  onError: r
}) {
  if (!(t != null && t.view))
    return;
  const i = U0e(e);
  if (!i.length)
    return;
  const o = z0e(t, A, n);
  i.forEach((a) => {
    const c = c8(t, o);
    s(a).then((l) => nw(t, c, l)).catch((l) => {
      nw(t, c, null), r == null || r(l);
    });
  });
}
const b0e = {
  key: 0,
  class: "drop-overlay"
}, v0e = { class: "editor-wrapper" }, j0e = {
  key: 0,
  class: "editor-toolbar",
  role: "toolbar",
  "aria-label": "Formatting toolbar"
}, H0e = { class: "toolbar-group" }, k0e = ["disabled"], R0e = ["disabled"], L0e = { class: "toolbar-group" }, S0e = ["value"], T0e = { class: "toolbar-group" }, J0e = ["aria-pressed"], W0e = ["aria-pressed"], O0e = ["aria-pressed"], P0e = ["aria-pressed"], K0e = { class: "toolbar-group" }, V0e = ["aria-pressed"], X0e = ["aria-pressed"], Z0e = ["aria-pressed"], q0e = { class: "toolbar-group" }, _0e = ["aria-pressed"], $0e = ["aria-pressed"], eue = { class: "toolbar-group" }, tue = ["aria-pressed"], Aue = { class: "toolbar-group" }, nue = { class: "color-dropdown" }, sue = { class: "color-dropdown-menu" }, rue = { class: "color-dropdown" }, iue = { class: "color-dropdown-menu" }, oue = { class: "toolbar-group" }, aue = ["aria-pressed"], cue = ["aria-pressed"], lue = ["aria-pressed"], Bue = ["aria-pressed"], gue = {
  key: 0,
  class: "toolbar-divider"
}, hue = {
  key: 1,
  class: "toolbar-group table-actions"
}, uue = {
  key: 2,
  class: "toolbar-group task-actions"
}, due = { class: "inline-bubble-inner" }, wue = { class: "color-dropdown" }, fue = { class: "color-dropdown-menu" }, Que = { class: "color-dropdown" }, Iue = { class: "color-dropdown-menu" }, Cue = { class: "editor-body" }, Eue = {
  key: 0,
  class: "toc-panel"
}, Mue = { class: "toc-panel-header" }, pue = {
  class: "toc-nav",
  "aria-label": "Table of contents"
}, mue = ["onClick"], Yue = { class: "toc-item-text" }, yue = { class: "editor-top-right-actions" }, Fue = {
  key: 1,
  class: "export-docx-loading"
}, Nue = ["title"], Due = {
  key: 1,
  class: "import-docx-loading"
}, xue = ["title"], Gue = {
  key: 0,
  class: "comments-badge"
}, zue = { class: "character-count-words" }, Uue = {
  key: 0,
  class: "comments-sidebar"
}, bue = { class: "comments-sidebar-header" }, vue = { class: "comments-sidebar-tabs" }, jue = { class: "comments-sidebar-actions" }, Hue = ["disabled"], kue = { class: "comments-new-composer-header" }, Rue = { class: "comments-comment-author" }, Lue = ["onKeydown"], Sue = { class: "comments-reply-footer" }, Tue = { style: { display: "flex", gap: "6px" } }, Jue = ["disabled"], Wue = {
  key: 0,
  class: "comments-list"
}, Oue = ["onClick"], Pue = { class: "comments-thread-header" }, Kue = { class: "comments-thread-actions" }, Vue = ["onClick"], Xue = ["onClick"], Zue = ["onClick"], que = {
  key: 0,
  class: "comments-resolved-hint"
}, _ue = { class: "comments-comment-list" }, $ue = { class: "comments-comment-meta" }, ede = { class: "comments-comment-author" }, tde = { class: "comments-comment-time" }, Ade = {
  key: 0,
  class: "comments-comment-deleted"
}, nde = {
  key: 1,
  class: "comments-comment-text"
}, sde = ["onClick"], rde = ["value", "onInput", "onKeydown"], ide = { class: "comments-reply-footer" }, ode = ["disabled", "onClick"], ade = {
  key: 1,
  class: "comments-empty"
}, cde = { class: "math-modal" }, lde = { class: "math-modal-body" }, Bde = ["onKeydown"], gde = { class: "math-modal" }, hde = { class: "image-modal-tabs" }, ude = { class: "math-modal-body" }, dde = ["disabled"], wde = {
  key: 0,
  style: { color: "#ef4444", "font-size": "13px", "margin-top": "8px" }
}, fde = {
  key: 1,
  style: { "font-size": "13px", "margin-top": "8px", color: "#6b7280" }
}, Qde = ["onKeydown"], Ide = { class: "math-modal-footer" }, Cde = { class: "math-modal" }, Ede = { class: "math-modal-body" }, Mde = ["onKeydown"], pde = {
  key: 3,
  class: "notion-editor-date-picker-host"
}, mde = {
  key: 1,
  class: "debug-status"
}, Yde = /* @__PURE__ */ Un({
  __name: "NotionEditor.ce",
  props: {
    content: { type: null },
    value: { type: null },
    placeholder: { type: String },
    darkMode: { type: Boolean },
    readonly: { type: Boolean },
    linkButton: { type: Boolean },
    characterLimit: { type: Number },
    showCharacterCount: { type: Boolean },
    showTableOfContents: { type: Boolean },
    collaborationEnabled: { type: Boolean },
    collaborationServerUrl: { type: String },
    collaborationTenantId: { type: String },
    collaborationDocumentId: { type: String },
    collaborationRoom: { type: String },
    collaborationField: { type: String },
    collaborationUserName: { type: String },
    collaborationUserColor: { type: String },
    collaborationToken: { type: String },
    collaborationAllowSlashCommand: { type: Boolean },
    imageUploadUrl: { type: String },
    commentsEnabled: { type: Boolean },
    convertAppId: { type: String },
    convertToken: { type: String },
    convertTokenUrl: { type: String },
    exportDocxEnabled: { type: String }
  },
  emits: ["editor-change", "update:content", "input", "exiq-focus", "exiq-blur", "collab-status", "collab-users-change", "collab-error", "image-upload-error"],
  setup(t, { emit: e }) {
    const A = t, n = e, s = /* @__PURE__ */ me(null), r = /* @__PURE__ */ me(null), i = /* @__PURE__ */ qf(null), o = /* @__PURE__ */ qf(null), a = /* @__PURE__ */ qf(null), c = /* @__PURE__ */ me("[]");
    let l = null;
    const B = (y) => y === !0 || y === "true" || y === "", g = (y) => typeof y == "string" ? y.trim() : "", h = Fe(() => B(A.collaborationEnabled)), u = Fe(() => g(A.collaborationServerUrl)), d = Fe(() => {
      const y = g(A.collaborationTenantId), x = g(A.collaborationDocumentId);
      return y && x ? `${y}/${x}` : g(A.collaborationRoom) || "storybook/collab-demo";
    }), w = Fe(() => g(A.collaborationField) || "prosemirror"), Q = Fe(() => g(A.collaborationToken)), p = Fe(() => B(A.collaborationAllowSlashCommand)), M = Fe(() => B(A.commentsEnabled)), I = /* @__PURE__ */ me(!1), N = new Bt("pendingCommentHighlight"), m = Fe(() => g(A.convertAppId)), E = Fe(() => g(A.convertToken)), G = Fe(() => g(A.convertTokenUrl)), Y = /* @__PURE__ */ me(""), U = /* @__PURE__ */ me(!1), v = /* @__PURE__ */ me(null), b = /* @__PURE__ */ me(null), W = Fe(() => !!m.value && (!!E.value || !!G.value)), q = Fe(() => B(A.exportDocxEnabled)), ne = /* @__PURE__ */ me(!1), V = /* @__PURE__ */ me(null);
    function se() {
      s.value && (ne.value = !0, V.value = null, s.value.chain().exportDocx({
        onCompleteExport: (y) => {
          try {
            const x = URL.createObjectURL(y), J = document.createElement("a");
            J.href = x, J.download = "document.docx", document.body.appendChild(J), J.click(), document.body.removeChild(J), URL.revokeObjectURL(x);
          } catch (x) {
            V.value = x.message ?? String(x);
          } finally {
            ne.value = !1;
          }
        }
      }).run());
    }
    async function te() {
      if (E.value) return E.value;
      if (Y.value) return Y.value;
      const y = G.value;
      if (!y) throw new Error("No convert token or token URL provided");
      const x = await fetch(y, {
        method: "POST",
        headers: { "Content-Type": "application/json", "x-internal-api-key": "change_me_to_a_random_secret" }
      });
      if (!x.ok) throw new Error(`Convert token request failed: ${x.status}`);
      const J = await x.json();
      return Y.value = J.token, J.token;
    }
    function be() {
      var y;
      (y = b.value) == null || y.click();
    }
    async function Oe(y) {
      var fe;
      const x = (fe = y.target.files) == null ? void 0 : fe[0];
      if (y.target.value = "", !x || !s.value) return;
      U.value = !0, v.value = null;
      let J;
      try {
        J = await te();
      } catch (we) {
        v.value = we.message, U.value = !1;
        return;
      }
      s.value.chain().importDocx({
        file: x,
        appId: m.value,
        token: J,
        imageUploadConfig: Ec.value ? { url: Ec.value } : void 0,
        onImport(we) {
          if (we.error) {
            v.value = we.error.message ?? String(we.error), U.value = !1;
            return;
          }
          we.setEditorContent(), U.value = !1;
        }
      }).run();
    }
    const ke = /* @__PURE__ */ me(!1), Se = /* @__PURE__ */ me([]), dt = /* @__PURE__ */ me(null), st = /* @__PURE__ */ me({}), We = Fe(() => Se.value.filter(
      (y) => ke.value ? !!y.resolvedAt : !y.resolvedAt
    )), pt = () => {
      const y = a.value;
      !y || typeof y.getThreads != "function" || (Se.value = y.getThreads() ?? []);
    }, xt = /* @__PURE__ */ me(!1), mt = /* @__PURE__ */ me(""), $t = /* @__PURE__ */ me(null), Ut = () => {
      !s.value || s.value.state.selection.empty || (xt.value = !0, Yn(() => {
        var y;
        (y = $t.value) == null || y.focus();
      }));
    }, RA = () => {
      var J;
      const y = mt.value.trim();
      if (!y) return;
      const x = xe.value.name;
      (J = s.value) == null || J.chain().focus().setThread({
        content: y,
        commentData: { userName: x }
      }).run(), s.value && s.value.view.dispatch(
        s.value.state.tr.setMeta(N, { active: !1, from: 0, to: 0 })
      ), xt.value = !1, mt.value = "";
    }, H = () => {
      xt.value = !1, mt.value = "", $() && s.value.view.dispatch(
        s.value.state.tr.setMeta(N, { active: !1, from: 0, to: 0 })
      );
    }, L = () => {
      if (!s.value || s.value.state.selection.empty) return;
      const { from: y, to: x } = s.value.state.selection;
      s.value.view.dispatch(
        s.value.state.tr.setMeta(N, { active: !0, from: y, to: x })
      ), I.value ? Ut() : (I.value = !0, Yn(() => Ut()));
    }, _ = (y) => {
      var x;
      (x = s.value) == null || x.commands.resolveThread({ id: y });
    }, R = (y) => {
      var x;
      (x = s.value) == null || x.commands.unresolveThread({ id: y });
    }, P = (y) => {
      var J;
      const x = a.value;
      x && (x.deleteThread(y), (J = s.value) == null || J.commands.removeThread({ id: y }), dt.value === y && (dt.value = null));
    }, X = (y) => {
      var x;
      dt.value = y, (x = s.value) == null || x.chain().selectThread({ id: y }).run();
    }, ae = (y) => {
      var fe;
      const x = (fe = st.value[y]) == null ? void 0 : fe.trim();
      if (!x) return;
      const J = a.value;
      J && (J.addComment(y, {
        content: x,
        createdAt: Date.now(),
        updatedAt: Date.now(),
        data: { userName: xe.value.name }
      }), st.value = { ...st.value, [y]: "" });
    }, Be = (y, x) => {
      const J = a.value;
      J && J.deleteComment(y, x, { deleteContent: !0 });
    }, he = (y) => {
      const x = a.value;
      return !x || typeof x.getThreadComments != "function" ? [] : x.getThreadComments(y, !0) ?? [];
    }, ie = ["#3b82f6", "#06b6d4", "#10b981", "#f59e0b", "#ef4444", "#8b5cf6"], ze = `User-${Math.floor(Math.random() * 1e4)}`, Me = ie[Math.floor(Math.random() * ie.length)], xe = Fe(() => ({
      name: g(A.collaborationUserName) || ze,
      color: g(A.collaborationUserColor) || Me
    })), Ne = Fe(() => h.value && !!i.value && !!o.value && !!a.value), Xe = (y, x = {}) => {
      n("collab-status", {
        status: y,
        room: d.value,
        serverUrl: u.value,
        ...x
      });
    }, Yt = (y) => {
      const x = y.map((fe) => ({ ...fe })).sort((fe, we) => fe.clientId - we.clientId);
      let J = "[]";
      try {
        J = JSON.stringify(x);
      } catch {
        J = "[]";
      }
      J !== c.value && (c.value = J, n("collab-users-change", { users: x }));
    }, gt = () => {
      var y, x;
      if (c.value = "[]", n("collab-users-change", { users: [] }), l && ((y = a.value) != null && y.awareness))
        try {
          a.value.awareness.off("update", l);
        } catch {
        }
      l = null;
      try {
        const J = a.value;
        typeof (J == null ? void 0 : J.unwatchThreads) == "function" && J.unwatchThreads(pt), J == null || J.destroy();
      } catch {
      }
      a.value = null, o.value = null;
      try {
        (x = i.value) == null || x.destroy();
      } catch {
      }
      i.value = null;
    }, FA = () => {
      if (gt(), !h.value) {
        Xe("disabled");
        return;
      }
      try {
        const y = new no(), x = y.getXmlFragment(w.value), fe = u.value.replace(/^https:\/\//, "wss://").replace(/^http:\/\//, "ws://"), we = M.value ? new DAe({
          baseUrl: fe,
          name: d.value,
          document: y,
          token: Q.value || void 0,
          connect: !1
        }) : new vv({
          url: fe,
          name: d.value,
          document: y,
          token: Q.value || void 0,
          autoConnect: !1
        });
        l = () => {
          if (!we.awareness) return;
          const nt = Array.from(we.awareness.states.entries()).map(([ht, dn]) => ({
            clientId: ht,
            ...(dn == null ? void 0 : dn.user) ?? {}
          }));
          Yt(nt);
        }, we.awareness.on("update", l), we.on("status", ({ status: nt }) => {
          Xe(nt);
        }), we.on("synced", ({ state: nt }) => {
          Xe(nt ? "connected" : "connecting", { synced: nt }), pt();
        }), we.on("disconnect", () => {
          Xe("disconnected");
        }), typeof we.watchThreads == "function" && we.watchThreads(pt), we.on("authenticationFailed", ({ reason: nt }) => {
          Xe("disconnected"), n("collab-error", { message: `Authentication failed: ${nt}` });
        }), i.value = y, o.value = x, a.value = we, Xe("connecting");
      } catch (y) {
        const x = y instanceof Error ? y.message : "Failed to initialize collaboration resources";
        n("collab-error", { message: x }), gt(), Xe("disconnected");
      }
    }, NA = () => {
      if (!(!a.value || !Ne.value))
        try {
          a.value.connect(), Xe("connecting");
        } catch (y) {
          const x = y instanceof Error ? y.message : "Failed to connect collaboration provider";
          n("collab-error", { message: x });
        }
    }, hn = () => {
      var x, J;
      if (!s.value || !Ne.value) return;
      const y = ((J = (x = s.value.storage) == null ? void 0 : x.collaborationCaret) == null ? void 0 : J.users) ?? [];
      Yt(y);
    }, un = (y) => {
      if (typeof y == "number" && Number.isFinite(y) && y > 0)
        return y;
      if (typeof y == "string") {
        const x = Number(y);
        if (Number.isFinite(x) && x > 0)
          return x;
      }
      return null;
    }, ni = (y, x) => {
      const J = un(x.width), fe = un(x.height);
      if (J) {
        const we = Math.round(J);
        y.style.width = `${we}px`, y.setAttribute("width", String(we));
      } else
        y.style.removeProperty("width"), y.removeAttribute("width");
      if (fe) {
        const we = Math.round(fe);
        y.style.height = `${we}px`, y.setAttribute("height", String(we));
      } else
        y.style.removeProperty("height"), y.removeAttribute("height");
    }, $ = () => !!s.value && !s.value.isDestroyed;
    let pe = !1;
    const ve = () => {
      var y, x;
      if ($())
        try {
          const J = s.value.view;
          if (typeof J.nodeDOM != "function") return;
          const fe = (x = (y = s.value) == null ? void 0 : y.state) == null ? void 0 : x.doc;
          if (!fe || typeof fe.descendants != "function") return;
          fe.descendants((we, nt) => {
            var Rn;
            if (((Rn = we == null ? void 0 : we.type) == null ? void 0 : Rn.name) !== "image") return;
            const ht = J.nodeDOM(nt);
            if (!(ht instanceof HTMLElement)) return;
            const dn = ht instanceof HTMLImageElement ? ht : ht.querySelector("img");
            dn instanceof HTMLImageElement && ni(dn, we.attrs ?? {});
          });
        } catch {
        }
    };
    let lt = null;
    const ot = () => {
      pe || lt !== null || (lt = requestAnimationFrame(() => {
        lt = null, ve();
      }));
    };
    let iA = null, qA = !1, oo = 0, wc = "", ts = null, si = null, ur = null;
    const dr = (y) => {
      var nt, ht, dn, Rn, wn, Qe, Ge, _e, Kt, ii, Ln, Os;
      if (!y) return !1;
      const x = (dn = (ht = (nt = y == null ? void 0 : y.$anchor) == null ? void 0 : nt.parent) == null ? void 0 : ht.type) == null ? void 0 : dn.name, J = (Qe = (wn = (Rn = y == null ? void 0 : y.$head) == null ? void 0 : Rn.parent) == null ? void 0 : wn.type) == null ? void 0 : Qe.name;
      if (x === "tableCell" || x === "tableHeader" || J === "tableCell" || J === "tableHeader") return !0;
      const fe = (Kt = (_e = (Ge = y == null ? void 0 : y.$anchorCell) == null ? void 0 : Ge.nodeAfter) == null ? void 0 : _e.type) == null ? void 0 : Kt.name, we = (Os = (Ln = (ii = y == null ? void 0 : y.$headCell) == null ? void 0 : ii.nodeAfter) == null ? void 0 : Ln.type) == null ? void 0 : Os.name;
      return fe === "tableCell" || fe === "tableHeader" || we === "tableCell" || we === "tableHeader";
    }, yf = (y) => {
      var x, J, fe, we, nt;
      return [
        (y == null ? void 0 : y.jsonID) ?? ((x = y == null ? void 0 : y.constructor) == null ? void 0 : x.name) ?? "",
        (y == null ? void 0 : y.anchor) ?? -1,
        (y == null ? void 0 : y.head) ?? -1,
        (y == null ? void 0 : y.from) ?? -1,
        (y == null ? void 0 : y.to) ?? -1,
        y != null && y.empty ? 1 : 0,
        ((J = y == null ? void 0 : y.$anchor) == null ? void 0 : J.parentOffset) ?? -1,
        ((fe = y == null ? void 0 : y.$head) == null ? void 0 : fe.parentOffset) ?? -1,
        ((we = y == null ? void 0 : y.$anchorCell) == null ? void 0 : we.pos) ?? -1,
        ((nt = y == null ? void 0 : y.$headCell) == null ? void 0 : nt.pos) ?? -1
      ].join(":");
    }, ql = (y = !1) => {
      var Ge, _e, Kt;
      if (!Ne.value || !$() || !((Ge = a.value) != null && Ge.awareness)) return;
      const x = s.value, J = a.value.awareness;
      if (!x.isFocused) return;
      const fe = vt.getState(x.state);
      if (!(fe != null && fe.type) || !((_e = fe == null ? void 0 : fe.binding) != null && _e.mapping)) return;
      const we = (Kt = x.state) == null ? void 0 : Kt.selection;
      if (!we) return;
      const nt = yf(we), ht = Aa(
        we.anchor,
        fe.type,
        fe.binding.mapping
      ), dn = Aa(
        we.head,
        fe.type,
        fe.binding.mapping
      ), Rn = J.getLocalState() || {}, wn = Rn == null ? void 0 : Rn.cursor;
      let Qe = !0;
      if (wn != null && wn.anchor && (wn != null && wn.head))
        try {
          Qe = !Gd(
            Oa(wn.anchor),
            ht
          ) || !Gd(
            Oa(wn.head),
            dn
          );
        } catch {
          Qe = !0;
        }
      !y && !Qe && nt === wc || (J.setLocalState({
        ...Rn,
        cursor: {
          anchor: ht,
          head: dn
        },
        cursorRefreshNonce: y || Qe || nt !== wc ? ++oo : Rn.cursorRefreshNonce
      }), wc = nt);
    }, wr = (y = !1) => {
      pe || (y && (qA = !0), iA === null && (iA = requestAnimationFrame(() => {
        iA = null;
        const x = qA;
        qA = !1, ql(x);
      })));
    }, fc = Fe(() => B(A.readonly)), Gh = Fe(() => B(A.darkMode)), l8 = Fe(() => B(A.linkButton)), Ff = /* @__PURE__ */ me(!1), Nf = /* @__PURE__ */ me(!1), Df = Fe(() => B(A.showTableOfContents)), zh = /* @__PURE__ */ me(!0), Uh = /* @__PURE__ */ me(
      []
    ), B8 = (y) => {
      var J;
      const x = (J = r.value) == null ? void 0 : J.querySelector(`[data-toc-id="${y}"]`);
      x && x.scrollIntoView({ behavior: "smooth", block: "start" });
    }, bh = /* @__PURE__ */ me(!1);
    let ri = null;
    const g8 = () => {
      ri && (clearTimeout(ri), ri = null), bh.value = !0, wr(!0), n("exiq-focus");
    }, h8 = () => {
      ri = setTimeout(() => {
        bh.value = !1, ri = null;
      }, 150), n("exiq-blur");
    }, hY = () => {
      ri && clearTimeout(ri), bh.value = !1;
    }, u8 = ({ editor: y }) => !fc.value && bh.value && !y.state.selection.empty, d8 = () => {
      var y, x, J;
      return r.value ?? ((J = (x = (y = s.value) == null ? void 0 : y.view) == null ? void 0 : x.dom) == null ? void 0 : J.parentElement) ?? document.body;
    }, uY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("underline")) ?? !1;
    }), dY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("bulletList")) ?? !1;
    }), wY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("orderedList")) ?? !1;
    }), fY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("taskList")) ?? !1;
    }), QY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("blockquote")) ?? !1;
    }), IY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("codeBlock")) ?? !1;
    }), CY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive({ textAlign: "left" })) ?? !1;
    }), EY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive({ textAlign: "center" })) ?? !1;
    }), MY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive({ textAlign: "right" })) ?? !1;
    }), pY = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive({ textAlign: "justify" })) ?? !1;
    }), w8 = Fe(() => {
      var y, x, J, fe;
      return !!((fe = (J = (x = (y = s.value) == null ? void 0 : y.can) == null ? void 0 : x.call(y)) == null ? void 0 : J.undo) != null && fe.call(J));
    }), f8 = Fe(() => {
      var y, x, J, fe;
      return !!((fe = (J = (x = (y = s.value) == null ? void 0 : y.can) == null ? void 0 : x.call(y)) == null ? void 0 : J.redo) != null && fe.call(J));
    }), mY = /* @__PURE__ */ me("paragraph"), Q8 = (y) => y ? y.isActive("heading", { level: 1 }) ? "heading1" : y.isActive("heading", { level: 2 }) ? "heading2" : y.isActive("heading", { level: 3 }) ? "heading3" : "paragraph" : "paragraph", I8 = (y) => {
      var J, fe;
      const x = y.target.value;
      if (x === "paragraph")
        (J = s.value) == null || J.chain().focus().setParagraph().run();
      else {
        const we = Number(x.replace("heading", ""));
        (fe = s.value) == null || fe.chain().focus().setHeading({ level: we }).run();
      }
    }, C8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleUnderline().run();
    }, E8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleBulletList().run();
    }, M8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleOrderedList().run();
    }, p8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleTaskList().run();
    }, m8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleBlockquote().run();
    }, Y8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleCodeBlock().run();
    }, vh = (y) => {
      var x;
      return (x = s.value) == null ? void 0 : x.chain().focus().setTextAlign(y).run();
    }, y8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().undo().run();
    }, F8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().redo().run();
    }, N8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().insertTable({ rows: 3, cols: 3, withHeaderRow: !0 }).run();
    }, D8 = () => {
      jY((y) => {
        var x;
        (x = s.value) == null || x.chain().focus().setImage({ src: y }).run();
      });
    }, x8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().addRowBefore().run();
    }, G8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().addRowAfter().run();
    }, z8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().addColumnBefore().run();
    }, U8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().addColumnAfter().run();
    }, b8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().deleteRow().run();
    }, v8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().deleteColumn().run();
    }, j8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().mergeCells().run();
    }, H8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().splitCell().run();
    }, k8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleHeaderCell().run();
    }, R8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().sinkListItem("taskItem").run();
    }, L8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().liftListItem("taskItem").run();
    }, S8 = () => {
      var fe;
      const { state: y } = s.value, { from: x } = y.selection, J = y.doc.resolve(x);
      for (let we = J.depth; we > 0; we--) {
        const nt = J.node(we);
        if (nt.type.name === "taskItem") {
          const ht = nt.attrs.checked;
          (fe = s.value) == null || fe.chain().focus().updateAttributes("taskItem", { checked: !ht }).run();
          return;
        }
      }
    }, T8 = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().deleteTable().run();
    }, Hn = (y) => {
      var x;
      return (x = s.value) == null ? void 0 : x.chain().focus().setBackgroundColor(y).run();
    }, YY = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().unsetBackgroundColor().run();
    }, kn = (y) => {
      var x;
      return (x = s.value) == null ? void 0 : x.chain().focus().setColor(y).run();
    }, yY = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().unsetColor().run();
    }, FY = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleBold().run();
    }, NY = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleItalic().run();
    }, DY = () => {
      var y;
      return (y = s.value) == null ? void 0 : y.chain().focus().toggleStrike().run();
    }, xY = (y = {}) => {
      if ($()) {
        if (typeof window < "u" && typeof window.__exiqOpenEditorLinkPopup == "function") {
          window.__exiqOpenEditorLinkPopup(s.value, {
            initialUrl: y.initialUrl ?? s.value.getAttributes("link").href ?? "",
            allowUnset: y.allowUnset ?? !0,
            onSave: y.onSave
          });
          return;
        }
        zhe(
          s.value,
          () => Nhe(s.value),
          {
            initialUrl: y.initialUrl ?? s.value.getAttributes("link").href ?? "",
            allowUnset: y.allowUnset ?? !0,
            onSave: y.onSave
          }
        );
      }
    }, xf = () => {
      $() && xY({
        onSave: (y) => {
          if (s.value) {
            if (y) {
              BY(s.value, y, { displayText: "link" });
              return;
            }
            gY(s.value);
          }
        }
      });
    }, J8 = (y) => {
      if (y.button !== 0 || !$()) return;
      const x = Dhe(y.target, s.value.view.dom);
      if (x) {
        if (fc.value) {
          Fhe(y, x);
          return;
        }
        y.preventDefault(), xhe(s.value, x), xf();
      }
    }, Gf = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("bold")) ?? !1;
    }), zf = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("italic")) ?? !1;
    }), Uf = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("strike")) ?? !1;
    }), bf = Fe(() => {
      var y;
      return ((y = s.value) == null ? void 0 : y.isActive("link")) ?? !1;
    }), jh = Fe(() => B(A.showCharacterCount)), Qc = Fe(() => {
      const y = Number(A.characterLimit);
      return !isNaN(y) && y > 0;
    }), GY = Fe(() => {
      const y = Number(A.characterLimit);
      return !isNaN(y) && y > 0 ? y : 0;
    }), Hh = /* @__PURE__ */ me(0), vf = /* @__PURE__ */ me(0), zY = (y) => {
      if (y == null) return "";
      if (typeof y == "string") return y;
      try {
        return JSON.stringify(y);
      } catch {
        return "";
      }
    }, UY = (y) => y != null && typeof y == "object" && !Array.isArray(y), bY = (y, x) => {
      if (UY(y)) return y;
      if (UY(x)) return x;
      if (typeof y == "string") {
        const J = y.trim();
        if (J === "[object Object]") return { type: "doc", content: [] };
        if (J !== "") return y;
      }
      if (typeof x == "string") {
        const J = x.trim();
        if (J === "[object Object]") return { type: "doc", content: [] };
        if (J !== "") return x;
      }
      return "";
    }, jf = /* @__PURE__ */ me(!1), Ic = /* @__PURE__ */ me(""), Hf = /* @__PURE__ */ me(null);
    let kh = null;
    const kf = (y, x) => {
      Ic.value = y || "", kh = x, jf.value = !0, Yn(() => {
        Hf.value && Hf.value.focus();
      });
    }, Rh = () => {
      var y;
      jf.value = !1, Ic.value = "", kh = null, (y = s.value) == null || y.commands.focus();
    }, vY = () => {
      kh && Ic.value.trim() && kh(Ic.value.trim()), Rh();
    }, Rf = (y) => new Promise((x, J) => {
      if (Ec.value) {
        const fe = new FormData();
        fe.append("file", y), fetch(Ec.value, { method: "POST", body: fe }).then(async (we) => {
          if (!we.ok) throw new Error(`Upload failed: ${we.status} ${we.statusText}`);
          const nt = await we.json(), ht = nt.url ?? nt.src ?? nt.location;
          if (!ht) throw new Error("Server response did not include an image URL");
          x(ht);
        }).catch(J);
      } else {
        const fe = new FileReader();
        fe.onload = (we) => {
          var nt;
          return x((nt = we.target) == null ? void 0 : nt.result);
        }, fe.onerror = () => J(new Error("Failed to read file")), fe.readAsDataURL(y);
      }
    }), Lf = (y) => {
      const x = y instanceof Error ? y.message : "Image upload failed";
      n("image-upload-error", { message: x });
    }, W8 = (y) => {
      var fe;
      if (wa.value = !1, !((fe = y.dataTransfer) != null && fe.types.includes("Files")))
        return;
      y.preventDefault();
      const x = s.value;
      if (!(x != null && x.view))
        return;
      const J = y.target;
      J instanceof Node && x.view.dom.contains(J) || t3({
        editor: x,
        files: y.dataTransfer.files,
        clientX: y.clientX,
        clientY: y.clientY,
        uploadFile: Rf,
        onError: Lf
      });
    }, Sf = /* @__PURE__ */ me(!1), ha = /* @__PURE__ */ me("url"), Cc = /* @__PURE__ */ me(""), O8 = /* @__PURE__ */ me(null), Tf = /* @__PURE__ */ me(null), ua = /* @__PURE__ */ me(!1), da = /* @__PURE__ */ me("");
    let ao = null;
    const Ec = Fe(() => g(A.imageUploadUrl)), jY = (y) => {
      Cc.value = "", da.value = "", ua.value = !1, ha.value = "file", ao = y, Sf.value = !0;
    }, Mc = () => {
      var y;
      Sf.value = !1, Cc.value = "", da.value = "", ua.value = !1, ao = null, (y = s.value) == null || y.commands.focus();
    }, HY = () => {
      ao && Cc.value.trim() && ao(Cc.value.trim()), Mc();
    }, P8 = async (y) => {
      var J;
      const x = (J = y.target.files) == null ? void 0 : J[0];
      if (x) {
        if (da.value = "", ua.value = !0, !Ec.value) {
          const fe = new FileReader();
          fe.onload = (we) => {
            var ht;
            const nt = (ht = we.target) == null ? void 0 : ht.result;
            ao && ao(nt), Mc();
          }, fe.onerror = () => {
            da.value = "Failed to read file", ua.value = !1;
          }, fe.readAsDataURL(x);
          return;
        }
        try {
          const fe = new FormData();
          fe.append("file", x);
          const we = await fetch(Ec.value, {
            method: "POST",
            body: fe
          });
          if (!we.ok)
            throw new Error(`Upload failed: ${we.status} ${we.statusText}`);
          const nt = await we.json(), ht = nt.url ?? nt.src ?? nt.location;
          if (!ht)
            throw new Error("Server response did not include an image URL");
          ao && ao(ht), Mc();
        } catch (fe) {
          const we = fe instanceof Error ? fe.message : "Image upload failed";
          da.value = we, n("image-upload-error", { message: we });
        } finally {
          ua.value = !1, Tf.value && (Tf.value.value = "");
        }
      }
    }, Jf = /* @__PURE__ */ me(!1), pc = /* @__PURE__ */ me(""), Wf = /* @__PURE__ */ me(null);
    let Lh = null;
    const K8 = (y) => {
      pc.value = "", Lh = y, Jf.value = !0, Yn(() => {
        Wf.value && Wf.value.focus();
      });
    }, Sh = () => {
      var y;
      Jf.value = !1, pc.value = "", Lh = null, (y = s.value) == null || y.commands.focus();
    }, kY = () => {
      Lh && pc.value.trim() && Lh(pc.value.trim()), Sh();
    }, V8 = () => {
      const y = /* @__PURE__ */ new Date(), x = y.getFullYear(), J = String(y.getMonth() + 1).padStart(2, "0"), fe = String(y.getDate()).padStart(2, "0");
      return `${x}-${J}-${fe}`;
    }, Th = /* @__PURE__ */ me(!1), Of = /* @__PURE__ */ me("");
    let Jh = null;
    const X8 = () => {
      var J, fe;
      const y = bn(), x = (fe = (J = y == null ? void 0 : y.appContext) == null ? void 0 : J.config) == null ? void 0 : fe.globalProperties;
      !x || x.$loader || (x.$loader = {
        setAppLoading: () => {
        },
        isAppLoading: !1
      });
    }, Z8 = (y) => {
      X8(), Of.value = V8(), Jh = y, Th.value = !0;
    }, RY = () => {
      var y;
      Th.value = !1, Of.value = "", Jh = null, (y = s.value) == null || y.commands.focus();
    }, q8 = (y) => {
      const x = Ehe(y);
      Jh && x && Jh(x), RY();
    }, _8 = () => {
      if (typeof ShadowRoot > "u") return;
      const y = ShadowRoot.prototype;
      if (typeof y.createRange != "function")
        try {
          Object.defineProperty(y, "createRange", {
            configurable: !0,
            value: () => document.createRange()
          });
        } catch {
          try {
            y.createRange = () => document.createRange();
          } catch {
          }
        }
    }, LY = (y) => {
      if (!y || y === document) return;
      const x = y;
      if (typeof x.createRange != "function")
        try {
          x.createRange = () => document.createRange();
        } catch {
        }
    }, wa = /* @__PURE__ */ me(!1);
    let fa = null;
    const SY = (y) => {
      var x;
      (x = y.dataTransfer) != null && x.types.includes("Files") && (y.preventDefault(), fa && (clearTimeout(fa), fa = null), wa.value = !0);
    }, TY = (y) => {
      var x;
      (x = y.dataTransfer) != null && x.types.includes("Files") && (y.preventDefault(), y.dataTransfer && (y.dataTransfer.dropEffect = "copy"), fa && (clearTimeout(fa), fa = null), wa.value = !0);
    };
    let _l = null, $l = null;
    return Xr(() => {
      var x, J, fe, we, nt;
      (x = r.value) == null || x.addEventListener("dragenter", SY), (J = r.value) == null || J.addEventListener("dragover", TY), (fe = r.value) == null || fe.addEventListener("dragleave", () => {
        fa = setTimeout(() => {
          wa.value = !1;
        }, 80);
      }), (we = r.value) == null || we.addEventListener("drop", W8), _8();
      const y = (nt = r.value) == null ? void 0 : nt.getRootNode();
      if (LY(y), y && "adoptedStyleSheets" in y)
        try {
          const ht = new CSSStyleSheet();
          ht.replaceSync(EI), y.adoptedStyleSheets = [
            ...y.adoptedStyleSheets,
            ht
          ];
        } catch {
          const ht = document.createElement("style");
          ht.textContent = EI, y.appendChild(ht);
        }
      else if (y && y !== document) {
        const ht = document.createElement("style");
        ht.textContent = EI, y.appendChild(ht);
      }
      if (y && y !== document) {
        const ht = document.createElement("style");
        ht.textContent = xAe, y.appendChild(ht);
      }
      Gh.value && document.body.classList.add("is-dark"), window.addEventListener("blur", hY), Yn(() => {
        FA();
        const ht = tt.create({
          name: "clearMarksOnEnter",
          addKeyboardShortcuts() {
            return {
              Enter: () => {
                const { state: Qe } = this.editor, { selection: Ge } = Qe, { $from: _e, empty: Kt } = Ge;
                if (!(Kt && _e.parent.content.size === _e.parentOffset))
                  return !1;
                if (_e.parent.type.name === "heading")
                  return this.editor.chain().splitBlock().setParagraph().unsetAllMarks().run();
                const Ln = Qe.tr.split(_e.pos);
                return Ln.setStoredMarks([]), this.editor.view.dispatch(Ln), !0;
              }
            };
          }
        }), dn = {
          link: !1,
          underline: !1,
          heading: {
            levels: [1, 2, 3, 4, 5, 6]
          }
        };
        Ne.value && (dn.undoRedo = !1);
        const Rn = [
          ...Ne.value ? [] : [ht],
          // Disable from StarterKit everything we configure ourselves,
          // to avoid the "Duplicate extension names" warning.
          kK.configure(dn),
          LK.configure({
            types: ["heading", "paragraph"]
          }),
          ...Ne.value ? [
            x_.configure({
              fragment: o.value,
              provider: a.value
            }),
            ste.configure({
              provider: a.value,
              user: xe.value
            }),
            ...M.value ? [
              ute.configure({
                provider: a.value
              }),
              tt.create({
                name: "pendingCommentHighlight",
                addProseMirrorPlugins() {
                  return [new ct({
                    key: N,
                    state: {
                      init: () => ({ active: !1, from: 0, to: 0 }),
                      apply(Qe, Ge) {
                        const _e = Qe.getMeta(N);
                        return _e !== void 0 ? _e : Ge.active && Qe.docChanged ? { active: !0, from: Qe.mapping.map(Ge.from), to: Qe.mapping.map(Ge.to) } : Ge;
                      }
                    },
                    props: {
                      decorations(Qe) {
                        const Ge = N.getState(Qe);
                        return !(Ge != null && Ge.active) || Ge.from >= Ge.to ? It.empty : It.create(Qe.doc, [
                          Wt.inline(Ge.from, Ge.to, { class: "comment-pending-highlight" })
                        ]);
                      }
                    }
                  })];
                }
              })
            ] : []
          ] : [],
          ...Ne.value ? [] : [
            $_.configure({
              render: () => {
                const Qe = document.createElement("div");
                return Qe.classList.add("custom-drag-handle"), Object.assign(Qe.style, {
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  width: "24px",
                  height: "24px",
                  color: "#9ca3af",
                  cursor: "grab",
                  borderRadius: "4px",
                  opacity: "0.5",
                  transition: "background-color 0.2s, color 0.2s"
                }), Qe.addEventListener("mouseenter", () => {
                  Qe.style.backgroundColor = Gh.value ? "#374151" : "#f3f4f6", Qe.style.color = Gh.value ? "#d1d5db" : "#4b5563", Qe.style.opacity = "1";
                }), Qe.addEventListener("mouseleave", () => {
                  Qe.style.backgroundColor = "transparent", Qe.style.color = "#9ca3af", Qe.style.opacity = "0.5";
                }), Qe.addEventListener("mousedown", () => {
                  Qe.style.cursor = "grabbing";
                }), Qe.addEventListener("mouseup", () => {
                  Qe.style.cursor = "grab";
                }), Qe.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="12" r="1"/><circle cx="9" cy="5" r="1"/><circle cx="9" cy="19" r="1"/><circle cx="15" cy="12" r="1"/><circle cx="15" cy="5" r="1"/><circle cx="15" cy="19" r="1"/></svg>', Qe;
              },
              nested: !0
            })
          ],
          SK.configure({
            placeholder: A.placeholder || 'Escribe "/" para comandos...',
            showOnlyWhenEditable: !1
          }),
          XP.configure({
            openOnClick: !1,
            enableClickSelection: !0,
            HTMLAttributes: {
              class: "editor-link",
              target: "_blank",
              rel: "noopener noreferrer"
            }
          }),
          She,
          JK,
          TK.configure({ nested: !0 }),
          Jz.configure({
            resizable: !0,
            HTMLAttributes: {
              class: "editor-table"
            }
          }),
          Tz,
          Sz,
          Lz,
          Uz,
          tV.configure({
            multicolor: !0
          }),
          Xz,
          qz.configure({
            types: ["textStyle"]
          }),
          Zz.configure({
            types: ["textStyle"]
          }),
          nV.configure({
            inline: !0,
            allowBase64: !0,
            resize: {
              enabled: !0,
              directions: ["top", "bottom", "left", "right"],
              minWidth: 50,
              minHeight: 50,
              alwaysPreserveAspectRatio: !0
            }
          }),
          G0e,
          Whe,
          ...q.value ? [
            yBe.configure()
          ] : [],
          ...W.value ? [
            UAe.configure({
              appId: m.value,
              token: Y.value || E.value
            })
          ] : [],
          ...Ne.value ? [] : [
            oV.configure({
              HTMLAttributes: {
                class: "editor-mention"
              },
              suggestion: {
                char: "@",
                items: The,
                render: Jhe,
                command: ({ editor: Qe, range: Ge, props: _e }) => {
                  Qe.chain().focus().insertContentAt(Ge, [
                    { type: "mention", attrs: _e },
                    { type: "text", text: " " }
                  ]).run();
                }
              }
            })
          ],
          BV.configure({
            inline: !1,
            width: 640,
            height: 480,
            controls: !0,
            allowFullscreen: !0,
            nocookie: !1
          }),
          Ate.configure({
            inlineOptions: {
              onClick: (Qe, Ge) => {
                kf(Qe.attrs.latex, (_e) => {
                  var Kt;
                  (Kt = s.value) == null || Kt.chain().setNodeSelection(Ge).updateInlineMath({ latex: _e }).focus().run();
                });
              }
            },
            blockOptions: {
              onClick: (Qe, Ge) => {
                kf(Qe.attrs.latex, (_e) => {
                  var Kt;
                  (Kt = s.value) == null || Kt.chain().setNodeSelection(Ge).updateBlockMath({ latex: _e }).focus().run();
                });
              }
            },
            katexOptions: {
              throwOnError: !1,
              output: "html"
            }
          }),
          ...Df.value ? [
            bBe.configure({
              getIndex: zBe,
              scrollParent: () => {
                var Qe;
                return ((Qe = r.value) == null ? void 0 : Qe.querySelector(".editor-content-area")) ?? window;
              },
              onUpdate: (Qe) => {
                Uh.value = Qe.map((Ge) => ({
                  id: Ge.id,
                  textContent: Ge.textContent,
                  level: Ge.level,
                  originalLevel: Ge.originalLevel,
                  itemIndex: Ge.itemIndex,
                  isActive: Ge.isActive,
                  isScrolledOver: Ge.isScrolledOver
                }));
              }
            })
          ] : [],
          ...!Ne.value || p.value ? [
            jhe.configure({
              suggestion: {
                items: khe,
                render: Hhe
              }
            })
          ] : []
        ];
        (jh.value || Qc.value) && Rn.push(
          fV.configure({
            limit: Qc.value ? A.characterLimit : null
          })
        ), s.value = new $J({
          content: Ne.value ? void 0 : bY(A.content, A.value),
          extensions: Rn,
          editable: !fc.value,
          onUpdate: ({ editor: Qe }) => {
            const Ge = Qe.getHTML(), _e = Qe.getJSON();
            n("editor-change", { html: Ge, json: _e }), n("update:content", _e), n("input", _e), ot(), hn(), (jh.value || Qc.value) && (Hh.value = Qe.storage.characterCount.characters(), vf.value = Qe.storage.characterCount.words());
          },
          onFocus: () => g8(),
          onBlur: () => h8()
        }), $() && LY(s.value.view.root), ot();
        const wn = () => {
          var Ge, _e, Kt, ii;
          Ff.value = ((Ge = s.value) == null ? void 0 : Ge.isActive("table")) ?? !1, Nf.value = ((_e = s.value) == null ? void 0 : _e.isActive("taskItem")) ?? !1, mY.value = Q8(s.value), ot();
          const Qe = dr((ii = (Kt = s.value) == null ? void 0 : Kt.state) == null ? void 0 : ii.selection);
          wr(Qe), hn();
        };
        (jh.value || Qc.value) && (Hh.value = s.value.storage.characterCount.characters(), vf.value = s.value.storage.characterCount.words()), s.value.on("selectionUpdate", wn), s.value.on("transaction", wn), wn(), s.value.view.dom.addEventListener("open-math-modal", ((Qe) => {
          const { initialValue: Ge, onSave: _e } = Qe.detail;
          kf(Ge, _e);
        })), s.value.view.dom.addEventListener("open-image-modal", ((Qe) => {
          const { onSave: Ge } = Qe.detail;
          jY(Ge);
        })), s.value.view.dom.addEventListener("open-youtube-modal", ((Qe) => {
          const { onSave: Ge } = Qe.detail;
          K8(Ge);
        })), s.value.view.dom.addEventListener("open-date-modal", ((Qe) => {
          const { onSave: Ge } = Qe.detail;
          Z8(Ge);
        })), s.value.view.dom.addEventListener("open-link-modal", ((Qe) => {
          const { onSave: Ge, initialUrl: _e, allowUnset: Kt } = Qe.detail || {};
          typeof Ge == "function" && xY({ initialUrl: _e, allowUnset: Kt, onSave: Ge });
        })), s.value.view.dom.addEventListener("click", J8, !0), _l = (Qe) => {
          if (!Qe.dataTransfer) return;
          if (!Array.from(Qe.dataTransfer.files).filter((Kt) => lM.includes(Kt.type)).length) {
            wa.value = !1;
            return;
          }
          Qe.preventDefault(), Qe.stopPropagation(), wa.value = !1;
          const _e = s.value;
          _e && t3({
            editor: _e,
            files: Qe.dataTransfer.files,
            clientX: Qe.clientX,
            clientY: Qe.clientY,
            uploadFile: Rf,
            onError: Lf
          });
        }, $l = (Qe) => {
          var ii;
          if (console.log("[NotionEditor] paste event fired", Qe), !Qe.clipboardData) {
            console.log("[NotionEditor] paste: no clipboardData, bailing");
            return;
          }
          console.log("[NotionEditor] paste: clipboardData.types =", Array.from(Qe.clipboardData.types)), console.log("[NotionEditor] paste: clipboardData.files.length =", Qe.clipboardData.files.length), console.log("[NotionEditor] paste: clipboardData.items =", Array.from(Qe.clipboardData.items).map((Ln) => `kind=${Ln.kind} type=${Ln.type}`));
          const Ge = [], _e = Array.from(Qe.clipboardData.items);
          for (const Ln of _e)
            if (Ln.kind === "file" && lM.includes(Ln.type)) {
              const Os = Ln.getAsFile();
              console.log("[NotionEditor] paste: matched image item, getAsFile() =", Os), Os && Ge.push(Os);
            }
          if (console.log("[NotionEditor] paste: final files to insert =", Ge), !Ge.length) {
            console.log("[NotionEditor] paste: no image files found — not intercepting");
            return;
          }
          Qe.preventDefault(), Qe.stopPropagation();
          const Kt = ((ii = s.value) == null ? void 0 : ii.state.selection.anchor) ?? 0;
          Ge.forEach((Ln) => {
            const Os = s.value;
            if (!Os) return;
            const JY = c8(Os, Kt);
            Rf(Ln).then((eB) => {
              console.log("[NotionEditor] paste: inserting image src =", eB.slice(0, 60)), nw(Os, JY, eB);
            }).catch((eB) => {
              console.error("[NotionEditor] paste: upload error", eB), nw(Os, JY, null), Lf(eB);
            });
          });
        }, s.value.view.dom.addEventListener("drop", _l), s.value.view.dom.addEventListener("paste", $l), ts = () => {
          wr(!0), requestAnimationFrame(() => {
            var Ge, _e;
            dr((_e = (Ge = s.value) == null ? void 0 : Ge.state) == null ? void 0 : _e.selection) && wr(!0);
          });
        }, si = () => {
          var Ge, _e;
          const Qe = dr((_e = (Ge = s.value) == null ? void 0 : Ge.state) == null ? void 0 : _e.selection);
          wr(Qe);
        }, s.value.view.dom.addEventListener("mouseup", ts), s.value.view.dom.addEventListener("keyup", si), ur = (Qe) => {
          if (!M.value) return;
          const _e = Qe.target.closest("[data-thread-id]");
          if (!_e) return;
          const Kt = _e.dataset.threadId;
          Kt && (I.value || (I.value = !0), Yn(() => X(Kt)));
        }, s.value.view.dom.addEventListener("click", ur), NA();
      });
    }), CA([() => A.content, () => A.value], ([y, x]) => {
      if (!s.value || Ne.value) return;
      const J = bY(y, x), fe = zY(J), we = zY(s.value.getJSON());
      fe && fe !== we && s.value.commands.setContent(J, { emitUpdate: !1 }), !fe && we && s.value.commands.setContent("", { emitUpdate: !1 });
    }), CA(fc, (y) => {
      if (s.value) {
        s.value.setEditable(!y);
        const { state: x, view: J } = s.value;
        J.dispatch(x.tr.setMeta("addToHistory", !1));
      }
    }), CA(Gh, (y) => {
      y ? document.body.classList.add("is-dark") : document.body.classList.remove("is-dark");
    }), CA(xe, (y) => {
      if (!s.value || !Ne.value) return;
      const x = s.value.commands;
      typeof x.updateUser == "function" && x.updateUser(y);
    }, { deep: !0 }), Zr(() => {
      var x, J, fe, we;
      pe = !0, (x = r.value) == null || x.removeEventListener("dragenter", SY), (J = r.value) == null || J.removeEventListener("dragover", TY), ri && clearTimeout(ri), iA !== null && (cancelAnimationFrame(iA), iA = null), lt !== null && (cancelAnimationFrame(lt), lt = null), window.removeEventListener("blur", hY);
      let y = null;
      try {
        y = $() ? s.value.view.dom : null;
      } catch {
      }
      y && (_l && y.removeEventListener("drop", _l), $l && y.removeEventListener("paste", $l), ts && y.removeEventListener("mouseup", ts), si && y.removeEventListener("keyup", si), ur && y.removeEventListener("click", ur)), _l = null, $l = null, ts = null, si = null, ur = null, gt(), dhe((fe = s.value) == null ? void 0 : fe.view), (we = s.value) == null || we.destroy(), document.body.classList.remove("is-dark");
    }), (y, x) => (ee(), Ae("div", {
      class: De(["notion-editor-container", { "is-dark": t.darkMode, "has-link-button": l8.value }]),
      ref_key: "containerEl",
      ref: r
    }, [
      wa.value ? (ee(), Ae("div", b0e, [...x[46] || (x[46] = [
        fr('<div class="drop-overlay-inner" data-v-1527930a><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" data-v-1527930a></path><polyline points="17 8 12 3 7 8" data-v-1527930a></polyline><line x1="12" y1="3" x2="12" y2="15" data-v-1527930a></line></svg><span data-v-1527930a>Drop to upload image</span></div>', 1)
      ])])) : je("", !0),
      F("div", v0e, [
        s.value && !fc.value ? (ee(), Ae("div", j0e, [
          F("div", H0e, [
            F("button", {
              type: "button",
              class: "toolbar-btn",
              title: "Undo",
              "aria-label": "Undo",
              disabled: !w8.value,
              onClick: y8
            }, [...x[47] || (x[47] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M9 14 4 9l5-5" }),
                F("path", { d: "M4 9h10a6 6 0 0 1 6 6v0a6 6 0 0 1-6 6H11" })
              ], -1)
            ])], 8, k0e),
            F("button", {
              type: "button",
              class: "toolbar-btn",
              title: "Redo",
              "aria-label": "Redo",
              disabled: !f8.value,
              onClick: F8
            }, [...x[48] || (x[48] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "m15 14 5-5-5-5" }),
                F("path", { d: "M20 9H9a6 6 0 0 0-6 6v0a6 6 0 0 0 6 6h4" })
              ], -1)
            ])], 8, R0e)
          ]),
          x[81] || (x[81] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", L0e, [
            F("select", {
              class: "toolbar-select",
              value: mY.value,
              "aria-label": "Block type",
              onChange: I8
            }, [...x[49] || (x[49] = [
              F("option", { value: "paragraph" }, "Paragraph", -1),
              F("option", { value: "heading1" }, "Heading 1", -1),
              F("option", { value: "heading2" }, "Heading 2", -1),
              F("option", { value: "heading3" }, "Heading 3", -1)
            ])], 40, S0e)
          ]),
          x[82] || (x[82] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", T0e, [
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": Gf.value }]),
              title: "Bold",
              "aria-label": "Bold",
              "aria-pressed": Gf.value,
              onClick: FY
            }, [...x[50] || (x[50] = [
              F("span", { class: "toolbar-glyph" }, "B", -1)
            ])], 10, J0e),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": zf.value }]),
              title: "Italic",
              "aria-label": "Italic",
              "aria-pressed": zf.value,
              onClick: NY
            }, [...x[51] || (x[51] = [
              F("span", { class: "toolbar-glyph toolbar-glyph-italic" }, "I", -1)
            ])], 10, W0e),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": uY.value }]),
              title: "Underline",
              "aria-label": "Underline",
              "aria-pressed": uY.value,
              onClick: C8
            }, [...x[52] || (x[52] = [
              F("span", { class: "toolbar-glyph toolbar-glyph-underline" }, "U", -1)
            ])], 10, O0e),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": Uf.value }]),
              title: "Strikethrough",
              "aria-label": "Strikethrough",
              "aria-pressed": Uf.value,
              onClick: DY
            }, [...x[53] || (x[53] = [
              F("span", { class: "toolbar-glyph toolbar-glyph-strike" }, "S", -1)
            ])], 10, P0e)
          ]),
          x[83] || (x[83] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", K0e, [
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": dY.value }]),
              title: "Bullet list",
              "aria-label": "Bullet list",
              "aria-pressed": dY.value,
              onClick: E8
            }, [...x[54] || (x[54] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><line x1="9" y1="6" x2="21" y2="6" data-v-1527930a></line><line x1="9" y1="12" x2="21" y2="12" data-v-1527930a></line><line x1="9" y1="18" x2="21" y2="18" data-v-1527930a></line><circle cx="4" cy="6" r="1" data-v-1527930a></circle><circle cx="4" cy="12" r="1" data-v-1527930a></circle><circle cx="4" cy="18" r="1" data-v-1527930a></circle></svg>', 1)
            ])], 10, V0e),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": wY.value }]),
              title: "Numbered list",
              "aria-label": "Numbered list",
              "aria-pressed": wY.value,
              onClick: M8
            }, [...x[55] || (x[55] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><line x1="10" y1="6" x2="21" y2="6" data-v-1527930a></line><line x1="10" y1="12" x2="21" y2="12" data-v-1527930a></line><line x1="10" y1="18" x2="21" y2="18" data-v-1527930a></line><path d="M4 6h1v4" data-v-1527930a></path><path d="M4 10h2" data-v-1527930a></path><path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1" data-v-1527930a></path></svg>', 1)
            ])], 10, X0e),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": fY.value }]),
              title: "Task list",
              "aria-label": "Task list",
              "aria-pressed": fY.value,
              onClick: p8
            }, [...x[56] || (x[56] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("rect", {
                  x: "3",
                  y: "3",
                  width: "18",
                  height: "18",
                  rx: "3"
                }),
                F("polyline", { points: "7 12 10 15 17 8" })
              ], -1)
            ])], 10, Z0e)
          ]),
          x[84] || (x[84] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", q0e, [
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": QY.value }]),
              title: "Quote",
              "aria-label": "Quote",
              "aria-pressed": QY.value,
              onClick: m8
            }, [...x[57] || (x[57] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M3 21c3-1 4-4 4-8V6H3v7h3" }),
                F("path", { d: "M13 21c3-1 4-4 4-8V6h-4v7h3" })
              ], -1)
            ])], 10, _0e),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": IY.value }]),
              title: "Code block",
              "aria-label": "Code block",
              "aria-pressed": IY.value,
              onClick: Y8
            }, [...x[58] || (x[58] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("polyline", { points: "16 18 22 12 16 6" }),
                F("polyline", { points: "8 6 2 12 8 18" })
              ], -1)
            ])], 10, $0e)
          ]),
          x[85] || (x[85] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", eue, [
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": bf.value }]),
              title: "Add link",
              "aria-label": "Add link",
              "aria-pressed": bf.value,
              onClick: xf
            }, [...x[59] || (x[59] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71" }),
                F("path", { d: "M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71" })
              ], -1)
            ])], 10, tue),
            F("button", {
              type: "button",
              class: "toolbar-btn",
              title: "Insert image",
              "aria-label": "Insert image",
              onClick: D8
            }, [...x[60] || (x[60] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("rect", {
                  x: "3",
                  y: "3",
                  width: "18",
                  height: "18",
                  rx: "2",
                  ry: "2"
                }),
                F("circle", {
                  cx: "8.5",
                  cy: "8.5",
                  r: "1.5"
                }),
                F("polyline", { points: "21 15 16 10 5 21" })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "toolbar-btn",
              title: "Insert table",
              "aria-label": "Insert table",
              onClick: N8
            }, [...x[61] || (x[61] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><rect x="3" y="3" width="18" height="18" rx="2" data-v-1527930a></rect><line x1="3" y1="9" x2="21" y2="9" data-v-1527930a></line><line x1="3" y1="15" x2="21" y2="15" data-v-1527930a></line><line x1="9" y1="3" x2="9" y2="21" data-v-1527930a></line><line x1="15" y1="3" x2="15" y2="21" data-v-1527930a></line></svg>', 1)
            ])])
          ]),
          x[86] || (x[86] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", Aue, [
            F("div", nue, [
              x[62] || (x[62] = F("button", {
                type: "button",
                class: "toolbar-btn toolbar-btn-icon",
                "aria-label": "Text color"
              }, [
                F("span", { class: "color-icon color-icon-text" }, "A"),
                F("span", {
                  class: "color-caret",
                  "aria-hidden": "true"
                }, "▾")
              ], -1)),
              F("div", sue, [
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[0] || (x[0] = (J) => kn("#a5b4fc"))
                }, "Purple"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[1] || (x[1] = (J) => kn("#fecaca"))
                }, "Red"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[2] || (x[2] = (J) => kn("#fdba74"))
                }, "Orange"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[3] || (x[3] = (J) => kn("#fde047"))
                }, "Yellow"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[4] || (x[4] = (J) => kn("#93c5fd"))
                }, "Blue"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[5] || (x[5] = (J) => kn("#5eead4"))
                }, "Teal"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[6] || (x[6] = (J) => kn("#86efac"))
                }, "Green"),
                F("button", {
                  type: "button",
                  class: "toolbar-clear-btn",
                  onClick: yY
                }, "Clear")
              ])
            ]),
            F("div", rue, [
              x[63] || (x[63] = F("button", {
                type: "button",
                class: "toolbar-btn toolbar-btn-icon",
                "aria-label": "Background color"
              }, [
                F("span", { class: "color-icon color-icon-bg" }, "A"),
                F("span", {
                  class: "color-caret",
                  "aria-hidden": "true"
                }, "▾")
              ], -1)),
              F("div", iue, [
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[7] || (x[7] = (J) => Hn("#a5b4fc"))
                }, "Purple"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[8] || (x[8] = (J) => Hn("#fecaca"))
                }, "Red"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[9] || (x[9] = (J) => Hn("#fdba74"))
                }, "Orange"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[10] || (x[10] = (J) => Hn("#fde047"))
                }, "Yellow"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[11] || (x[11] = (J) => Hn("#93c5fd"))
                }, "Blue"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[12] || (x[12] = (J) => Hn("#5eead4"))
                }, "Teal"),
                F("button", {
                  type: "button",
                  class: "inline-bubble-chip",
                  onClick: x[13] || (x[13] = (J) => Hn("#86efac"))
                }, "Green"),
                F("button", {
                  type: "button",
                  class: "toolbar-clear-btn",
                  onClick: YY
                }, "Clear")
              ])
            ])
          ]),
          x[87] || (x[87] = F("span", { class: "toolbar-divider" }, null, -1)),
          F("div", oue, [
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": CY.value }]),
              title: "Align left",
              "aria-label": "Align left",
              "aria-pressed": CY.value,
              onClick: x[14] || (x[14] = (J) => vh("left"))
            }, [...x[64] || (x[64] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("line", {
                  x1: "3",
                  y1: "6",
                  x2: "21",
                  y2: "6"
                }),
                F("line", {
                  x1: "3",
                  y1: "12",
                  x2: "13",
                  y2: "12"
                }),
                F("line", {
                  x1: "3",
                  y1: "18",
                  x2: "18",
                  y2: "18"
                })
              ], -1)
            ])], 10, aue),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": EY.value }]),
              title: "Align center",
              "aria-label": "Align center",
              "aria-pressed": EY.value,
              onClick: x[15] || (x[15] = (J) => vh("center"))
            }, [...x[65] || (x[65] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("line", {
                  x1: "3",
                  y1: "6",
                  x2: "21",
                  y2: "6"
                }),
                F("line", {
                  x1: "6",
                  y1: "12",
                  x2: "18",
                  y2: "12"
                }),
                F("line", {
                  x1: "4",
                  y1: "18",
                  x2: "20",
                  y2: "18"
                })
              ], -1)
            ])], 10, cue),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": MY.value }]),
              title: "Align right",
              "aria-label": "Align right",
              "aria-pressed": MY.value,
              onClick: x[16] || (x[16] = (J) => vh("right"))
            }, [...x[66] || (x[66] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("line", {
                  x1: "3",
                  y1: "6",
                  x2: "21",
                  y2: "6"
                }),
                F("line", {
                  x1: "11",
                  y1: "12",
                  x2: "21",
                  y2: "12"
                }),
                F("line", {
                  x1: "6",
                  y1: "18",
                  x2: "21",
                  y2: "18"
                })
              ], -1)
            ])], 10, lue),
            F("button", {
              type: "button",
              class: De(["toolbar-btn", { "is-active": pY.value }]),
              title: "Justify",
              "aria-label": "Justify",
              "aria-pressed": pY.value,
              onClick: x[17] || (x[17] = (J) => vh("justify"))
            }, [...x[67] || (x[67] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("line", {
                  x1: "3",
                  y1: "6",
                  x2: "21",
                  y2: "6"
                }),
                F("line", {
                  x1: "3",
                  y1: "12",
                  x2: "21",
                  y2: "12"
                }),
                F("line", {
                  x1: "3",
                  y1: "18",
                  x2: "21",
                  y2: "18"
                })
              ], -1)
            ])], 10, Bue)
          ]),
          Ff.value || Nf.value ? (ee(), Ae("span", gue)) : je("", !0),
          Ff.value ? (ee(), Ae("div", hue, [
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Add row above",
              "aria-label": "Add row above",
              onClick: x8
            }, [...x[68] || (x[68] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18" }),
                F("line", {
                  x1: "12",
                  y1: "8",
                  x2: "12",
                  y2: "2"
                }),
                F("polyline", { points: "9 5 12 2 15 5" })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Add row below",
              "aria-label": "Add row below",
              onClick: G8
            }, [...x[69] || (x[69] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M9 3H5a2 2 0 0 0-2 2v4m6-6h10a2 2 0 0 1 2 2v4M9 3v18m0 0h10a2 2 0 0 0 2-2v-4M9 21H5a2 2 0 0 1-2-2v-4m0 0h18" }),
                F("line", {
                  x1: "12",
                  y1: "16",
                  x2: "12",
                  y2: "22"
                }),
                F("polyline", { points: "9 19 12 22 15 19" })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Add column left",
              "aria-label": "Add column left",
              onClick: z8
            }, [...x[70] || (x[70] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><path d="M12 3v18M3 9h18M3 15h18" data-v-1527930a></path><rect x="3" y="3" width="18" height="18" rx="2" data-v-1527930a></rect><line x1="7" y1="12" x2="1" y2="12" data-v-1527930a></line><polyline points="4 9 1 12 4 15" data-v-1527930a></polyline></svg>', 1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Add column right",
              "aria-label": "Add column right",
              onClick: U8
            }, [...x[71] || (x[71] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><path d="M12 3v18M3 9h18M3 15h18" data-v-1527930a></path><rect x="3" y="3" width="18" height="18" rx="2" data-v-1527930a></rect><line x1="17" y1="12" x2="23" y2="12" data-v-1527930a></line><polyline points="20 9 23 12 20 15" data-v-1527930a></polyline></svg>', 1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button is-danger",
              title: "Delete row",
              "aria-label": "Delete row",
              onClick: b8
            }, [...x[72] || (x[72] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M3 6h18M3 12h18M3 18h18" }),
                F("line", {
                  x1: "10",
                  y1: "10",
                  x2: "14",
                  y2: "14"
                }),
                F("line", {
                  x1: "14",
                  y1: "10",
                  x2: "10",
                  y2: "14"
                })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button is-danger",
              title: "Delete column",
              "aria-label": "Delete column",
              onClick: v8
            }, [...x[73] || (x[73] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M6 3v18M12 3v18M18 3v18" }),
                F("line", {
                  x1: "10",
                  y1: "10",
                  x2: "14",
                  y2: "14"
                }),
                F("line", {
                  x1: "14",
                  y1: "10",
                  x2: "10",
                  y2: "14"
                })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Merge selected cells",
              "aria-label": "Merge selected cells",
              onClick: j8
            }, [...x[74] || (x[74] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><rect x="2" y="5" width="7" height="14" rx="1" data-v-1527930a></rect><rect x="15" y="5" width="7" height="14" rx="1" data-v-1527930a></rect><line x1="9" y1="12" x2="15" y2="12" data-v-1527930a></line><polyline points="12 9 15 12 12 15" data-v-1527930a></polyline><polyline points="12 9 9 12 12 15" data-v-1527930a></polyline></svg>', 1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Split cell",
              "aria-label": "Split cell",
              onClick: H8
            }, [...x[75] || (x[75] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><rect x="2" y="5" width="20" height="14" rx="1" data-v-1527930a></rect><line x1="12" y1="5" x2="12" y2="19" stroke-dasharray="3 2" data-v-1527930a></line><polyline points="8 9 5 12 8 15" data-v-1527930a></polyline><polyline points="16 9 19 12 16 15" data-v-1527930a></polyline></svg>', 1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Toggle header cell",
              "aria-label": "Toggle header cell",
              onClick: k8
            }, [...x[76] || (x[76] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><rect x="3" y="3" width="18" height="18" rx="2" data-v-1527930a></rect><rect x="3" y="3" width="18" height="7" rx="2" fill="currentColor" fill-opacity="0.2" data-v-1527930a></rect><line x1="3" y1="10" x2="21" y2="10" data-v-1527930a></line><line x1="3" y1="16" x2="21" y2="16" data-v-1527930a></line><line x1="9" y1="10" x2="9" y2="21" data-v-1527930a></line><line x1="15" y1="10" x2="15" y2="21" data-v-1527930a></line></svg>', 1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button is-danger",
              title: "Delete table",
              "aria-label": "Delete table",
              onClick: T8
            }, [...x[77] || (x[77] = [
              fr('<svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" data-v-1527930a><polyline points="3 6 5 6 21 6" data-v-1527930a></polyline><path d="M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6" data-v-1527930a></path><path d="M10 11v6M14 11v6" data-v-1527930a></path><path d="M9 6V4a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v2" data-v-1527930a></path></svg>', 1)
            ])])
          ])) : je("", !0),
          Nf.value ? (ee(), Ae("div", uue, [
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Unindent task",
              "aria-label": "Unindent task",
              onClick: L8
            }, [...x[78] || (x[78] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("polyline", { points: "15 18 9 12 15 6" }),
                F("line", {
                  x1: "20",
                  y1: "12",
                  x2: "9",
                  y2: "12"
                }),
                F("line", {
                  x1: "3",
                  y1: "6",
                  x2: "3",
                  y2: "18"
                })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Indent task",
              "aria-label": "Indent task",
              onClick: R8
            }, [...x[79] || (x[79] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("polyline", { points: "9 18 15 12 9 6" }),
                F("line", {
                  x1: "4",
                  y1: "12",
                  x2: "15",
                  y2: "12"
                }),
                F("line", {
                  x1: "21",
                  y1: "6",
                  x2: "21",
                  y2: "18"
                })
              ], -1)
            ])]),
            F("button", {
              type: "button",
              class: "table-icon-button",
              title: "Toggle checked",
              "aria-label": "Toggle checked",
              onClick: S8
            }, [...x[80] || (x[80] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "15",
                height: "15",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("rect", {
                  x: "3",
                  y: "3",
                  width: "18",
                  height: "18",
                  rx: "3"
                }),
                F("polyline", { points: "7 12 10 15 17 8" })
              ], -1)
            ])])
          ])) : je("", !0)
        ])) : je("", !0),
        s.value && !fc.value ? (ee(), Lo(bs(AP), {
          key: 1,
          editor: s.value,
          "should-show": u8,
          "append-to": d8,
          options: { placement: "top", offset: 8 },
          class: "inline-bubble custom-floating-menu"
        }, {
          default: Ur(() => [
            F("div", due, [
              F("button", {
                type: "button",
                class: De(["inline-bubble-button", { "is-active": Gf.value }]),
                onClick: FY
              }, "Bold", 2),
              F("button", {
                type: "button",
                class: De(["inline-bubble-button", { "is-active": zf.value }]),
                onClick: NY
              }, "Italic", 2),
              F("button", {
                type: "button",
                class: De(["inline-bubble-button", { "is-active": Uf.value }]),
                onClick: DY
              }, "Strike", 2),
              x[91] || (x[91] = F("span", { class: "inline-bubble-divider" }, null, -1)),
              F("button", {
                type: "button",
                class: De(["inline-bubble-button", { "is-active": bf.value }]),
                onMousedown: tA(xf, ["prevent"])
              }, "Link", 34),
              x[92] || (x[92] = F("span", { class: "inline-bubble-divider" }, null, -1)),
              F("div", wue, [
                x[88] || (x[88] = F("button", {
                  type: "button",
                  class: "inline-bubble-button inline-bubble-button-icon",
                  "aria-label": "Text color"
                }, [
                  F("span", { class: "color-icon color-icon-text" }, "A"),
                  F("span", {
                    class: "color-caret",
                    "aria-hidden": "true"
                  }, "▾")
                ], -1)),
                F("div", fue, [
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[18] || (x[18] = (J) => kn("#a5b4fc"))
                  }, "Purple"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[19] || (x[19] = (J) => kn("#fecaca"))
                  }, "Red"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[20] || (x[20] = (J) => kn("#fdba74"))
                  }, "Orange"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[21] || (x[21] = (J) => kn("#fde047"))
                  }, "Yellow"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[22] || (x[22] = (J) => kn("#93c5fd"))
                  }, "Blue"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[23] || (x[23] = (J) => kn("#5eead4"))
                  }, "Teal"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[24] || (x[24] = (J) => kn("#86efac"))
                  }, "Green"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-button is-muted",
                    onClick: yY
                  }, "Clear")
                ])
              ]),
              F("div", Que, [
                x[89] || (x[89] = F("button", {
                  type: "button",
                  class: "inline-bubble-button inline-bubble-button-icon",
                  "aria-label": "Background color"
                }, [
                  F("span", { class: "color-icon color-icon-bg" }, "A"),
                  F("span", {
                    class: "color-caret",
                    "aria-hidden": "true"
                  }, "▾")
                ], -1)),
                F("div", Iue, [
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[25] || (x[25] = (J) => Hn("#a5b4fc"))
                  }, "Purple"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[26] || (x[26] = (J) => Hn("#fecaca"))
                  }, "Red"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[27] || (x[27] = (J) => Hn("#fdba74"))
                  }, "Orange"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[28] || (x[28] = (J) => Hn("#fde047"))
                  }, "Yellow"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[29] || (x[29] = (J) => Hn("#93c5fd"))
                  }, "Blue"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[30] || (x[30] = (J) => Hn("#5eead4"))
                  }, "Teal"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-chip",
                    onClick: x[31] || (x[31] = (J) => Hn("#86efac"))
                  }, "Green"),
                  F("button", {
                    type: "button",
                    class: "inline-bubble-button is-muted",
                    onClick: YY
                  }, "Clear")
                ])
              ]),
              Ne.value && M.value ? (ee(), Ae(ft, { key: 0 }, [
                x[90] || (x[90] = F("span", { class: "inline-bubble-divider" }, null, -1)),
                F("button", {
                  type: "button",
                  class: "inline-bubble-button",
                  title: "Add comment",
                  onMousedown: tA(L, ["prevent"])
                }, "Comment", 32)
              ], 64)) : je("", !0)
            ])
          ]),
          _: 1
        }, 8, ["editor"])) : je("", !0),
        F("div", Cue, [
          rt(g2, { name: "toc-slide" }, {
            default: Ur(() => [
              Df.value && zh.value && Uh.value.length > 0 ? (ee(), Ae("div", Eue, [
                F("div", Mue, [
                  x[94] || (x[94] = F("span", { class: "toc-panel-title" }, "Contents", -1)),
                  F("button", {
                    type: "button",
                    class: "toc-close-btn",
                    title: "Hide table of contents",
                    "aria-label": "Hide table of contents",
                    onClick: x[32] || (x[32] = (J) => zh.value = !1)
                  }, [...x[93] || (x[93] = [
                    F("svg", {
                      xmlns: "http://www.w3.org/2000/svg",
                      width: "14",
                      height: "14",
                      viewBox: "0 0 24 24",
                      fill: "none",
                      stroke: "currentColor",
                      "stroke-width": "2",
                      "stroke-linecap": "round",
                      "stroke-linejoin": "round"
                    }, [
                      F("line", {
                        x1: "18",
                        y1: "6",
                        x2: "6",
                        y2: "18"
                      }),
                      F("line", {
                        x1: "6",
                        y1: "6",
                        x2: "18",
                        y2: "18"
                      })
                    ], -1)
                  ])])
                ]),
                F("nav", pue, [
                  (ee(!0), Ae(ft, null, Ns(Uh.value, (J) => (ee(), Ae("button", {
                    key: J.id,
                    type: "button",
                    class: De(["toc-item", {
                      "is-active": J.isActive,
                      "is-scrolled-over": J.isScrolledOver,
                      [`toc-level-${J.level}`]: !0
                    }]),
                    style: ia({ paddingLeft: `${(J.level - 1) * 12 + 10}px` }),
                    onClick: (fe) => B8(J.id)
                  }, [
                    x[95] || (x[95] = F("span", { class: "toc-item-dot" }, null, -1)),
                    F("span", Yue, Mt(J.textContent), 1)
                  ], 14, mue))), 128))
                ])
              ])) : je("", !0)
            ]),
            _: 1
          }),
          Df.value && !zh.value && Uh.value.length > 0 ? (ee(), Ae("button", {
            key: 0,
            type: "button",
            class: "toc-reopen-btn",
            title: "Show table of contents",
            "aria-label": "Show table of contents",
            onClick: x[33] || (x[33] = (J) => zh.value = !0)
          }, [...x[96] || (x[96] = [
            F("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "14",
              height: "14",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              F("line", {
                x1: "3",
                y1: "6",
                x2: "21",
                y2: "6"
              }),
              F("line", {
                x1: "3",
                y1: "12",
                x2: "15",
                y2: "12"
              }),
              F("line", {
                x1: "3",
                y1: "18",
                x2: "18",
                y2: "18"
              })
            ], -1)
          ])])) : je("", !0),
          s.value ? (ee(), Lo(bs(eW), {
            key: 1,
            editor: s.value,
            class: "editor-content-area"
          }, null, 8, ["editor"])) : je("", !0)
        ]),
        F("div", yue, [
          q.value ? (ee(), Ae(ft, { key: 0 }, [
            ne.value ? (ee(), Ae("span", Fue, [...x[98] || (x[98] = [
              F("svg", {
                class: "import-spin",
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
              ], -1),
              as(" Exporting… ", -1)
            ])])) : (ee(), Ae("button", {
              key: 0,
              type: "button",
              class: "export-docx-btn",
              title: "Export DOCX",
              onClick: se
            }, [...x[97] || (x[97] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                F("polyline", { points: "17 8 12 3 7 8" }),
                F("line", {
                  x1: "12",
                  y1: "3",
                  x2: "12",
                  y2: "15"
                })
              ], -1),
              F("span", null, "Export DOCX", -1)
            ])])),
            V.value ? (ee(), Ae("span", {
              key: 2,
              class: "export-docx-error",
              title: V.value
            }, "⚠", 8, Nue)) : je("", !0)
          ], 64)) : je("", !0),
          W.value ? (ee(), Ae(ft, { key: 1 }, [
            U.value ? (ee(), Ae("span", Due, [...x[100] || (x[100] = [
              F("svg", {
                class: "import-spin",
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M21 12a9 9 0 1 1-6.219-8.56" })
              ], -1),
              as(" Importing… ", -1)
            ])])) : (ee(), Ae("button", {
              key: 0,
              type: "button",
              class: "import-docx-btn",
              title: "Import DOCX",
              onClick: be
            }, [...x[99] || (x[99] = [
              F("svg", {
                xmlns: "http://www.w3.org/2000/svg",
                width: "14",
                height: "14",
                viewBox: "0 0 24 24",
                fill: "none",
                stroke: "currentColor",
                "stroke-width": "2",
                "stroke-linecap": "round",
                "stroke-linejoin": "round"
              }, [
                F("path", { d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" }),
                F("polyline", { points: "7 10 12 15 17 10" }),
                F("line", {
                  x1: "12",
                  y1: "15",
                  x2: "12",
                  y2: "3"
                })
              ], -1),
              F("span", null, "Import DOCX", -1)
            ])])),
            v.value ? (ee(), Ae("span", {
              key: 2,
              class: "import-docx-error",
              title: v.value
            }, "⚠", 8, xue)) : je("", !0)
          ], 64)) : je("", !0),
          Ne.value && M.value && !I.value ? (ee(), Ae("button", {
            key: 2,
            type: "button",
            class: "comments-toggle-btn",
            title: "Show comments",
            onClick: x[34] || (x[34] = (J) => I.value = !0)
          }, [
            x[101] || (x[101] = F("svg", {
              xmlns: "http://www.w3.org/2000/svg",
              width: "15",
              height: "15",
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "2",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }, [
              F("path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" })
            ], -1)),
            We.value.length > 0 ? (ee(), Ae("span", Gue, Mt(We.value.length), 1)) : je("", !0)
          ])) : je("", !0)
        ]),
        F("input", {
          ref_key: "importFileRef",
          ref: b,
          type: "file",
          accept: ".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          style: { display: "none" },
          onChange: Oe
        }, null, 544),
        s.value && jh.value ? (ee(), Ae("div", {
          key: 2,
          class: De(["character-count", { "is-over-limit": Qc.value && Hh.value >= GY.value }])
        }, [
          F("span", null, [
            as(Mt(Hh.value) + " ", 1),
            Qc.value ? (ee(), Ae(ft, { key: 0 }, [
              as("/ " + Mt(GY.value), 1)
            ], 64)) : je("", !0),
            x[102] || (x[102] = as(" characters", -1))
          ]),
          F("span", zue, Mt(vf.value) + " words", 1)
        ], 2)) : je("", !0)
      ]),
      rt(g2, { name: "comments-slide" }, {
        default: Ur(() => [
          Ne.value && M.value && I.value ? (ee(), Ae("div", Uue, [
            F("div", bue, [
              x[103] || (x[103] = F("span", { class: "comments-sidebar-title" }, "Comments", -1)),
              F("div", vue, [
                F("button", {
                  type: "button",
                  class: De(["comments-tab-btn", { active: !ke.value }]),
                  onClick: x[35] || (x[35] = (J) => ke.value = !1)
                }, "Open", 2),
                F("button", {
                  type: "button",
                  class: De(["comments-tab-btn", { active: ke.value }]),
                  onClick: x[36] || (x[36] = (J) => ke.value = !0)
                }, "Resolved", 2)
              ]),
              F("button", {
                type: "button",
                class: "comments-sidebar-close",
                onClick: x[37] || (x[37] = (J) => I.value = !1)
              }, "×")
            ]),
            F("div", jue, [
              xt.value ? (ee(), Ae("div", {
                key: 1,
                class: "comments-new-composer",
                onClick: x[39] || (x[39] = tA(() => {
                }, ["stop"]))
              }, [
                F("div", kue, [
                  F("span", Rue, Mt(xe.value.name), 1)
                ]),
                Go(F("textarea", {
                  ref_key: "newCommentInputRef",
                  ref: $t,
                  class: "comments-reply-input",
                  placeholder: "Write a comment...",
                  "onUpdate:modelValue": x[38] || (x[38] = (J) => mt.value = J),
                  onKeydown: [
                    Yc(tA(RA, ["ctrl", "prevent"]), ["enter"]),
                    Yc(tA(H, ["prevent"]), ["escape"])
                  ]
                }, null, 40, Lue), [
                  [Zh, mt.value]
                ]),
                F("div", Sue, [
                  x[104] || (x[104] = F("span", { class: "comments-reply-hint" }, "Ctrl+Enter to send", -1)),
                  F("div", Tue, [
                    F("button", {
                      type: "button",
                      class: "comments-reply-cancel",
                      onClick: tA(H, ["stop"])
                    }, "Cancel"),
                    F("button", {
                      type: "button",
                      class: "comments-reply-submit",
                      disabled: !mt.value.trim(),
                      onClick: tA(RA, ["stop"])
                    }, "Add", 8, Jue)
                  ])
                ])
              ])) : (ee(), Ae("button", {
                key: 0,
                type: "button",
                class: "comments-add-btn",
                disabled: !s.value || s.value.state.selection.empty,
                onClick: Ut
              }, "+ Add comment on selection", 8, Hue))
            ]),
            We.value.length > 0 ? (ee(), Ae("div", Wue, [
              (ee(!0), Ae(ft, null, Ns(We.value, (J) => {
                var fe;
                return ee(), Ae("div", {
                  key: J.id,
                  class: De(["comments-thread", { "is-selected": dt.value === J.id }]),
                  onClick: (we) => X(J.id)
                }, [
                  F("div", Pue, [
                    F("div", Kue, [
                      J.resolvedAt ? (ee(), Ae("button", {
                        key: 1,
                        type: "button",
                        class: "comments-action-btn",
                        onClick: tA((we) => R(J.id), ["stop"]),
                        title: "Reopen"
                      }, "⟲", 8, Xue)) : (ee(), Ae("button", {
                        key: 0,
                        type: "button",
                        class: "comments-action-btn",
                        onClick: tA((we) => _(J.id), ["stop"]),
                        title: "Resolve"
                      }, "✓", 8, Vue)),
                      F("button", {
                        type: "button",
                        class: "comments-action-btn is-danger",
                        onClick: tA((we) => P(J.id), ["stop"]),
                        title: "Delete"
                      }, "×", 8, Zue)
                    ])
                  ]),
                  J.resolvedAt ? (ee(), Ae("div", que, " Resolved " + Mt(new Date(J.resolvedAt).toLocaleDateString()), 1)) : je("", !0),
                  F("div", _ue, [
                    (ee(!0), Ae(ft, null, Ns(he(J.id), (we) => {
                      var nt;
                      return ee(), Ae("div", {
                        key: we.id,
                        class: De(["comments-comment", { "is-deleted": !!we.deletedAt }])
                      }, [
                        F("div", $ue, [
                          F("span", ede, Mt(((nt = we.data) == null ? void 0 : nt.userName) ?? "Unknown"), 1),
                          F("span", tde, Mt(new Date(we.createdAt).toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })), 1)
                        ]),
                        we.deletedAt ? (ee(), Ae("p", Ade, "Comment deleted")) : (ee(), Ae("p", nde, Mt(we.content), 1)),
                        we.deletedAt ? je("", !0) : (ee(), Ae("button", {
                          key: 2,
                          type: "button",
                          class: "comments-delete-comment",
                          onClick: tA((ht) => Be(J.id, we.id), ["stop"]),
                          title: "Delete comment"
                        }, "×", 8, sde))
                      ], 2);
                    }), 128))
                  ]),
                  dt.value === J.id && !J.resolvedAt ? (ee(), Ae("div", {
                    key: 1,
                    class: "comments-reply",
                    onClick: x[40] || (x[40] = tA(() => {
                    }, ["stop"]))
                  }, [
                    F("textarea", {
                      class: "comments-reply-input",
                      placeholder: "Reply...",
                      value: st.value[J.id] || "",
                      onInput: (we) => st.value = { ...st.value, [J.id]: we.target.value },
                      onKeydown: Yc(tA((we) => ae(J.id), ["ctrl", "prevent"]), ["enter"])
                    }, null, 40, rde),
                    F("div", ide, [
                      x[105] || (x[105] = F("span", { class: "comments-reply-hint" }, "Ctrl+Enter to send", -1)),
                      F("button", {
                        type: "button",
                        class: "comments-reply-submit",
                        disabled: !((fe = st.value[J.id]) != null && fe.trim()),
                        onClick: tA((we) => ae(J.id), ["stop"])
                      }, "Send", 8, ode)
                    ])
                  ])) : je("", !0)
                ], 10, Oue);
              }), 128))
            ])) : (ee(), Ae("div", ade, Mt(ke.value ? "No resolved comments." : "No open comments."), 1))
          ])) : je("", !0)
        ]),
        _: 1
      }),
      (ee(), Lo(j3, { to: "body" }, [
        jf.value ? (ee(), Ae("div", {
          key: 0,
          class: "math-modal-overlay",
          onMousedown: tA(Rh, ["self"])
        }, [
          F("div", cde, [
            F("div", { class: "math-modal-header" }, [
              x[106] || (x[106] = F("h3", null, "Enter LaTeX formula", -1)),
              F("button", {
                class: "math-modal-close",
                onClick: Rh
              }, "×")
            ]),
            F("div", lde, [
              Go(F("textarea", {
                "onUpdate:modelValue": x[41] || (x[41] = (J) => Ic.value = J),
                placeholder: "e.g. E = mc^2",
                ref_key: "mathInputRef",
                ref: Hf,
                onKeydown: Yc(tA(vY, ["prevent"]), ["enter"])
              }, null, 40, Bde), [
                [Zh, Ic.value]
              ])
            ]),
            F("div", { class: "math-modal-footer" }, [
              F("button", {
                class: "math-btn-cancel",
                onClick: Rh
              }, "Cancel"),
              F("button", {
                class: "math-btn-submit",
                onClick: vY
              }, "Insert")
            ])
          ])
        ], 32)) : je("", !0),
        Sf.value ? (ee(), Ae("div", {
          key: 1,
          class: "math-modal-overlay",
          onMousedown: tA(Mc, ["self"])
        }, [
          F("div", gde, [
            F("div", { class: "math-modal-header" }, [
              x[107] || (x[107] = F("h3", null, "Insert image", -1)),
              F("button", {
                class: "math-modal-close",
                onClick: Mc
              }, "×")
            ]),
            F("div", hde, [
              F("button", {
                class: De(["image-tab-btn", { active: ha.value === "file" }]),
                onClick: x[42] || (x[42] = (J) => ha.value = "file")
              }, "From computer", 2),
              F("button", {
                class: De(["image-tab-btn", { active: ha.value === "url" }]),
                onClick: x[43] || (x[43] = (J) => ha.value = "url")
              }, "From URL", 2)
            ]),
            F("div", ude, [
              ha.value === "file" ? (ee(), Ae(ft, { key: 0 }, [
                F("input", {
                  type: "file",
                  accept: "image/*",
                  ref_key: "imageFileInputRef",
                  ref: Tf,
                  disabled: ua.value,
                  onChange: P8,
                  style: { display: "block", width: "100%" }
                }, null, 40, dde),
                da.value ? (ee(), Ae("p", wde, Mt(da.value), 1)) : je("", !0),
                ua.value ? (ee(), Ae("p", fde, "Uploading...")) : je("", !0)
              ], 64)) : Go((ee(), Ae("input", {
                key: 1,
                type: "text",
                "onUpdate:modelValue": x[44] || (x[44] = (J) => Cc.value = J),
                placeholder: "https://example.com/image.png",
                ref_key: "imageInputRef",
                ref: O8,
                onKeydown: Yc(tA(HY, ["prevent"]), ["enter"])
              }, null, 40, Qde)), [
                [Zh, Cc.value]
              ])
            ]),
            F("div", Ide, [
              F("button", {
                class: "math-btn-cancel",
                onClick: Mc
              }, "Cancel"),
              ha.value === "url" ? (ee(), Ae("button", {
                key: 0,
                class: "math-btn-submit",
                onClick: HY
              }, "Insert")) : je("", !0)
            ])
          ])
        ], 32)) : je("", !0),
        Jf.value ? (ee(), Ae("div", {
          key: 2,
          class: "math-modal-overlay",
          onMousedown: tA(Sh, ["self"])
        }, [
          F("div", Cde, [
            F("div", { class: "math-modal-header" }, [
              x[108] || (x[108] = F("h3", null, "Enter YouTube URL", -1)),
              F("button", {
                class: "math-modal-close",
                onClick: Sh
              }, "×")
            ]),
            F("div", Ede, [
              Go(F("input", {
                type: "text",
                "onUpdate:modelValue": x[45] || (x[45] = (J) => pc.value = J),
                placeholder: "https://www.youtube.com/watch?v=...",
                ref_key: "youtubeInputRef",
                ref: Wf,
                onKeydown: Yc(tA(kY, ["prevent"]), ["enter"])
              }, null, 40, Mde), [
                [Zh, pc.value]
              ])
            ]),
            F("div", { class: "math-modal-footer" }, [
              F("button", {
                class: "math-btn-cancel",
                onClick: Sh
              }, "Cancel"),
              F("button", {
                class: "math-btn-submit",
                onClick: kY
              }, "Embed")
            ])
          ])
        ], 32)) : je("", !0),
        Th.value ? (ee(), Ae("div", pde, [
          rt(x0e, {
            value: Of.value,
            modal: !0,
            autoOpen: Th.value,
            customCalendarIcon: !0,
            dataPickerPlaceHolder: "Select date",
            onOnApplyDate: q8,
            onOnClose: RY
          }, null, 8, ["value", "autoOpen"])
        ])) : je("", !0)
      ])),
      s.value ? je("", !0) : (ee(), Ae("div", mde, "Inicializando editor..."))
    ], 2));
  }
}), yde = `[data-v-1527930a]:host{display:block;width:100%}.notion-editor-container[data-v-1527930a]{border:1px solid #e2e8f0;border-radius:8px;background:#fff;min-height:200px;display:flex;flex-direction:column;font-family:-apple-system,BlinkMacSystemFont,Segoe UI,Roboto,Helvetica Neue,Arial,sans-serif;position:relative}.notion-editor-container.is-dark[data-v-1527930a]{background:#1a202c;border-color:#2d3748;color:#fff}.debug-status[data-v-1527930a]{padding:20px;color:#666;font-style:italic}.editor-wrapper[data-v-1527930a]{display:flex;flex-direction:column;flex:1;position:relative}.editor-content-area[data-v-1527930a]{flex:1;min-width:0;padding:16px 16px 16px 40px;cursor:text;overflow-y:auto}.editor-body[data-v-1527930a]{display:flex;flex-direction:row;flex:1 1 0%;align-self:stretch;height:100%;min-height:0;overflow:hidden;position:relative}.toc-panel[data-v-1527930a]{width:200px;flex-shrink:0;overflow-y:auto;border-right:1px solid #e5e7eb;background:#fafafa;padding:8px 0}.is-dark .toc-panel[data-v-1527930a]{border-right-color:#374151;background:#111827}.toc-panel-header[data-v-1527930a]{display:flex;align-items:center;justify-content:space-between;padding:6px 12px 10px}.toc-panel-title[data-v-1527930a]{font-size:11px;font-weight:600;letter-spacing:.06em;text-transform:uppercase;color:#9ca3af}.is-dark .toc-panel-title[data-v-1527930a]{color:#6b7280}.toc-close-btn[data-v-1527930a]{display:flex;align-items:center;justify-content:center;width:20px;height:20px;border:none;background:transparent;color:#9ca3af;border-radius:4px;cursor:pointer;padding:0;transition:background .1s,color .1s}.toc-close-btn[data-v-1527930a]:hover{background:#f3f4f6;color:#374151}.is-dark .toc-close-btn[data-v-1527930a]:hover{background:#1f2937;color:#d1d5db}.toc-nav[data-v-1527930a]{display:flex;flex-direction:column}.toc-item[data-v-1527930a]{display:flex;align-items:center;gap:6px;width:100%;border:none;background:transparent;text-align:left;cursor:pointer;padding-top:4px;padding-bottom:4px;padding-right:10px;color:#374151;transition:background .1s,color .1s;border-radius:0}.toc-item[data-v-1527930a]:hover{background:#f3f4f6;color:#111827}.toc-item.is-active[data-v-1527930a]{color:#2563eb}.toc-item.is-scrolled-over[data-v-1527930a]{color:#9ca3af}.is-dark .toc-item[data-v-1527930a]{color:#d1d5db}.is-dark .toc-item[data-v-1527930a]:hover{background:#1f2937;color:#f9fafb}.is-dark .toc-item.is-active[data-v-1527930a]{color:#60a5fa}.is-dark .toc-item.is-scrolled-over[data-v-1527930a]{color:#6b7280}.toc-item-dot[data-v-1527930a]{display:inline-block;width:5px;height:5px;border-radius:50%;background:currentColor;flex-shrink:0;opacity:.4;transition:opacity .1s}.toc-item.is-active .toc-item-dot[data-v-1527930a]{opacity:1}.toc-item-text[data-v-1527930a]{font-size:12px;line-height:1.4;overflow:hidden;text-overflow:ellipsis;white-space:nowrap}.toc-level-1 .toc-item-text[data-v-1527930a]{font-weight:600}.toc-level-2 .toc-item-text[data-v-1527930a]{font-weight:500}.toc-level-3 .toc-item-text[data-v-1527930a]{font-weight:400}.toc-level-4 .toc-item-text[data-v-1527930a],.toc-level-5 .toc-item-text[data-v-1527930a],.toc-level-6 .toc-item-text[data-v-1527930a]{font-weight:400;font-size:11px}.toc-reopen-btn[data-v-1527930a]{display:flex;align-items:flex-start;justify-content:center;padding-top:12px;width:22px;flex-shrink:0;border:none;border-right:1px solid #e5e7eb;background:#fafafa;color:#9ca3af;cursor:pointer;transition:background .1s,color .1s}.toc-reopen-btn[data-v-1527930a]:hover{background:#f3f4f6;color:#374151}.is-dark .toc-reopen-btn[data-v-1527930a]{border-right-color:#374151;background:#111827;color:#6b7280}.is-dark .toc-reopen-btn[data-v-1527930a]:hover{background:#1f2937;color:#d1d5db}.toc-slide-enter-active[data-v-1527930a],.toc-slide-leave-active[data-v-1527930a]{transition:width .2s ease,opacity .2s ease;overflow:hidden}.toc-slide-enter-from[data-v-1527930a],.toc-slide-leave-to[data-v-1527930a]{width:0!important;opacity:0}.editor-content-area[data-v-1527930a] .ProseMirror{min-height:150px;outline:none;white-space:pre-wrap;word-wrap:break-word}[data-v-1527930a]:host ::slotted(.custom-drag-handle),.custom-drag-handle[data-v-1527930a],.editor-content-area[data-v-1527930a] .custom-drag-handle{display:flex;align-items:center;justify-content:center;width:24px;height:24px;color:#9ca3af;cursor:grab;border-radius:4px;transition:background-color .2s,color .2s;opacity:.5}[data-v-1527930a]:host ::slotted(.custom-drag-handle:hover),.custom-drag-handle[data-v-1527930a]:hover,.editor-content-area[data-v-1527930a] .custom-drag-handle:hover{background-color:#f3f4f6;color:#4b5563;opacity:1}.is-dark .custom-drag-handle[data-v-1527930a]:hover,.is-dark .editor-content-area[data-v-1527930a] .custom-drag-handle:hover{background-color:#374151;color:#d1d5db}[data-v-1527930a]:host ::slotted(.custom-drag-handle:active),.custom-drag-handle[data-v-1527930a]:active,.editor-content-area[data-v-1527930a] .custom-drag-handle:active{cursor:grabbing}.editor-content-area[data-v-1527930a] .ProseMirror-selectednode,.editor-content-area[data-v-1527930a] .ProseMirror-selectednoderange{position:relative}.editor-content-area[data-v-1527930a] .ProseMirror-selectednode:before,.editor-content-area[data-v-1527930a] .ProseMirror-selectednoderange:before{content:"";position:absolute;top:-.25rem;right:-.25rem;bottom:-.25rem;left:-.25rem;background-color:#3b82f626;border-radius:.2rem;pointer-events:none;z-index:-1}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror-selectednode:before,.is-dark .editor-content-area[data-v-1527930a] .ProseMirror-selectednoderange:before{background-color:#60a5fa33}.editor-content-area[data-v-1527930a] .tiptap-thread--inline:not(.tiptap-thread--resolved){background-color:#caa21e2e;border-radius:2px;cursor:pointer}.editor-content-area[data-v-1527930a] .tiptap-thread--inline.tiptap-thread--selected:not(.tiptap-thread--resolved){background-color:#caa21e61}.editor-content-area[data-v-1527930a] .tiptap-thread--inline.tiptap-thread--resolved{background-color:transparent;cursor:default}.editor-content-area[data-v-1527930a] .comment-pending-highlight{background-color:#caa21e4d;border-radius:2px}.is-dark .editor-content-area[data-v-1527930a] .tiptap-thread--inline:not(.tiptap-thread--resolved){background-color:#caa21e38}.is-dark .editor-content-area[data-v-1527930a] .tiptap-thread--inline.tiptap-thread--selected:not(.tiptap-thread--resolved){background-color:#caa21e6b}.is-dark .editor-content-area[data-v-1527930a] .comment-pending-highlight{background-color:#caa21e59}.editor-content-area[data-v-1527930a] .tiptap-mathematics-render{cursor:pointer;padding:.1em .2em;border-radius:.25rem;transition:background-color .2s;display:inline-block}.editor-content-area[data-v-1527930a] .tiptap-mathematics-render:hover{background-color:#0000000d}.is-dark .editor-content-area[data-v-1527930a] .tiptap-mathematics-render:hover{background-color:#ffffff1a}.editor-content-area[data-v-1527930a] .tiptap-mathematics-render[data-type=block-math]{display:block;text-align:center;margin:1em 0;padding:.5em;overflow-x:auto;max-width:100%}.editor-content-area[data-v-1527930a] .block-math-inner{overflow-x:auto;max-width:100%}.editor-content-area[data-v-1527930a] .ProseMirror p{margin:.5em 0}.editor-content-area[data-v-1527930a] .ProseMirror h1{font-size:2em;font-weight:700;margin:.67em 0}.editor-content-area[data-v-1527930a] .ProseMirror h2{font-size:1.5em;font-weight:700;margin:.75em 0}.editor-content-area[data-v-1527930a] .ProseMirror h3{font-size:1.17em;font-weight:700;margin:.83em 0}.editor-content-area[data-v-1527930a] .ProseMirror ul,.editor-content-area[data-v-1527930a] .ProseMirror ol{padding-left:2em;margin:.2em 0}.editor-content-area[data-v-1527930a] .ProseMirror blockquote{border-left:3px solid #e2e8f0;padding-left:1em;margin:1em 0;color:#6b7280}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror blockquote{border-left-color:#4b5563;color:#9ca3af}.editor-content-area[data-v-1527930a] .ProseMirror span.tiptap-date{display:inline-flex;align-items:center;padding:0 6px;border-radius:4px;background:#f1f5f9;color:#334155;font-size:.95em;line-height:1.6;white-space:nowrap}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror span.tiptap-date{background:#374151;color:#e5e7eb}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList]{list-style:none;padding-left:.5rem;margin:.5em 0}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li{display:flex;align-items:flex-start;gap:.5em;margin:.25em 0}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>label{display:flex;align-items:center;flex-shrink:0;margin-top:.3em;cursor:pointer;-webkit-user-select:none;user-select:none}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>label input[type=checkbox]{width:16px;height:16px;cursor:pointer;border:2px solid #d1d5db;border-radius:4px;-webkit-appearance:none;-moz-appearance:none;appearance:none;background-color:#fff;transition:all .15s ease;flex-shrink:0;margin:0}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>label input[type=checkbox]{background-color:#374151;border-color:#4b5563}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>label input[type=checkbox]:checked{background-color:#3b82f6;border-color:#3b82f6;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='white'%3E%3Cpath d='M12.207 4.793a1 1 0 010 1.414l-5 5a1 1 0 01-1.414 0l-2-2a1 1 0 011.414-1.414L6.5 9.086l4.293-4.293a1 1 0 011.414 0z'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:center;background-size:11px}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>label input[type=checkbox]:hover{border-color:#3b82f6}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>div{flex:1;min-width:0;word-wrap:break-word}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li>div>p{margin-top:3px;margin-bottom:0}.editor-content-area[data-v-1527930a] .ProseMirror ul[data-type=taskList] li[data-checked=true]>div{text-decoration:line-through;opacity:.6}.editor-content-area[data-v-1527930a] .ProseMirror p.is-editor-empty:first-child:before{content:attr(data-placeholder);float:left;color:#adb5bd;pointer-events:none;height:0}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror p.is-editor-empty:first-child:before{color:#6b7280}.editor-content-area[data-v-1527930a] .ProseMirror{position:relative;z-index:1}.editor-content-area[data-v-1527930a] .slash-command-suggestion{color:inherit}.editor-content-area[data-v-1527930a] .slash-command-suggestion[data-empty=true]:after{content:"Filter...";color:#9ca3af;pointer-events:none}.is-dark .editor-content-area[data-v-1527930a] .slash-command-suggestion[data-empty=true]:after{color:#6b7280}.editor-content-area[data-v-1527930a] .ProseMirror>*{position:relative}.editor-content-area[data-v-1527930a] .ProseMirror strong{font-weight:700}.editor-content-area[data-v-1527930a] .ProseMirror em{font-style:italic}.editor-content-area[data-v-1527930a] .ProseMirror u{text-decoration:underline}.editor-content-area[data-v-1527930a] .ProseMirror s{text-decoration:line-through}.editor-content-area[data-v-1527930a] .ProseMirror code{background-color:#f3f4f6;padding:.2em .4em;border-radius:3px;font-family:Monaco,Courier New,monospace;font-size:.9em}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror code{background-color:#374151}.editor-content-area[data-v-1527930a] .ProseMirror mark{background-color:#fef08a;padding:.1em 0;border-radius:2px}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror mark{background-color:#854d0e}.editor-content-area[data-v-1527930a] .ProseMirror .youtube{margin:1em 0;max-width:100%}.editor-content-area[data-v-1527930a] .ProseMirror .youtube iframe{max-width:100%}.editor-content-area[data-v-1527930a] .ProseMirror a{color:#3b82f6;text-decoration:underline;cursor:pointer}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror a{color:#60a5fa}.has-link-button .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a{display:inline-flex;align-items:center;gap:8px;padding:10px 16px;border-radius:8px;background-color:#7f56d9;color:#fff;font-family:Inter,-apple-system,Segoe UI,Roboto,sans-serif;font-size:14px;font-weight:600;line-height:20px;text-decoration:none}.has-link-button .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a:before{content:"";flex:none;width:20px;height:20px;background-color:currentColor;-webkit-mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 7h3a5 5 0 0 1 0 10h-3m-6 0H6A5 5 0 0 1 6 7h3'/%3E%3Cpath d='M8 12h8'/%3E%3C/svg%3E") center / contain no-repeat;mask:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='black' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M15 7h3a5 5 0 0 1 0 10h-3m-6 0H6A5 5 0 0 1 6 7h3'/%3E%3Cpath d='M8 12h8'/%3E%3C/svg%3E") center / contain no-repeat}.has-link-button .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a:hover{background-color:#6941c6}.has-link-button .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a:focus-visible{outline:2px solid #7f56d9;outline-offset:2px}.has-link-button.is-dark .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a{background-color:#7f56d9;color:#fff}.has-link-button.is-dark .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a:hover{background-color:#6941c6}.has-link-button.is-dark .editor-content-area[data-v-1527930a] .ProseMirror p.link-button-paragraph>a:focus-visible{outline-color:#9e77ed}.editor-content-area[data-v-1527930a] .ProseMirror .editor-mention{background:#e0f2fe;color:#0369a1;border-radius:4px;padding:0 4px;font-weight:500}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror .editor-mention{background:#0f172a;color:#93c5fd}.editor-content-area[data-v-1527930a] .collaboration-carets__selection{border-radius:3px;opacity:.28}.editor-content-area[data-v-1527930a] .collaboration-carets__caret{position:relative;border-left:1px solid;border-right:1px solid;margin-left:-1px;margin-right:-1px;pointer-events:none}.editor-content-area[data-v-1527930a] .collaboration-carets__label{position:absolute;top:-1.35em;left:-1px;color:#fff;font-size:11px;font-weight:600;line-height:1;border-radius:4px 4px 4px 0;padding:3px 6px;white-space:nowrap;-webkit-user-select:none;user-select:none}.table-icon-button[data-v-1527930a]{display:inline-flex;align-items:center;justify-content:center;width:30px;height:30px;border:none;background:transparent;color:#374151;border-radius:6px;cursor:pointer;transition:background .12s,color .12s;flex-shrink:0}.table-icon-button[data-v-1527930a]:hover{background:#f3f4f6;color:#111827}.table-icon-button.is-danger[data-v-1527930a]{color:#b91c1c}.table-icon-button.is-danger[data-v-1527930a]:hover{background:#fee2e2;color:#991b1b}.is-dark .table-icon-button[data-v-1527930a]{color:#d1d5db}.is-dark .table-icon-button[data-v-1527930a]:hover{background:#374151;color:#f9fafb}.is-dark .table-icon-button.is-danger[data-v-1527930a]{color:#fca5a5}.is-dark .table-icon-button.is-danger[data-v-1527930a]:hover{background:#7f1d1d;color:#fecaca}.inline-bubble-inner[data-v-1527930a]{display:flex;flex-wrap:wrap;gap:4px;background:#fff;border:1px solid #e5e7eb;border-radius:999px;padding:4px 6px;box-shadow:0 10px 15px -3px #0000001a,0 4px 6px -2px #0000000d}.inline-bubble-button[data-v-1527930a]{border:none;background:#f3f4f6;color:#111827;border-radius:999px;padding:4px 8px;font-size:11px;cursor:pointer}.inline-bubble-button[data-v-1527930a]:hover{background:#e5e7eb}.inline-bubble-button.is-active[data-v-1527930a]{background:#111827;color:#fff}.inline-bubble-button.is-muted[data-v-1527930a]{background:transparent;color:#6b7280}.inline-bubble-button.is-muted[data-v-1527930a]:hover{background:#f3f4f6;color:#374151}.inline-bubble-button-icon[data-v-1527930a]{display:inline-flex;align-items:center;gap:6px;padding:4px 10px}.color-icon[data-v-1527930a]{position:relative;display:inline-flex;align-items:center;justify-content:center;width:20px;height:20px;border-radius:6px;font-weight:700;font-size:12px;background:#fff;border:1px solid #e5e7eb}.color-icon-text[data-v-1527930a]:after{content:"";position:absolute;left:3px;right:3px;bottom:2px;height:3px;background:#2563eb;border-radius:3px}.color-icon-bg[data-v-1527930a]:after{content:"";position:absolute;left:3px;right:3px;bottom:2px;height:6px;background:#fde047;border-radius:3px}.color-caret[data-v-1527930a]{font-size:10px;line-height:1}.inline-bubble-chip[data-v-1527930a]{border:none;background:#f3f4f6;color:#111827;border-radius:999px;padding:4px 8px;font-size:11px;cursor:pointer}.inline-bubble-chip[data-v-1527930a]:hover{background:#e5e7eb}.inline-bubble-divider[data-v-1527930a]{width:1px;background:#e5e7eb;margin:0 1px}.color-dropdown[data-v-1527930a]{position:relative}.color-dropdown-menu[data-v-1527930a]{position:absolute;top:100%;left:0;display:none;flex-wrap:wrap;gap:4px;background:#fff;border:1px solid #e5e7eb;border-radius:10px;padding:6px;min-width:160px;box-shadow:0 12px 20px -6px #0003;z-index:5}.color-dropdown:hover .color-dropdown-menu[data-v-1527930a],.color-dropdown:focus-within .color-dropdown-menu[data-v-1527930a]{display:flex}.character-count[data-v-1527930a]{position:absolute;bottom:0;right:0;display:inline-flex;gap:8px;align-items:center;font-size:12px;color:#6b7280;padding:4px 10px 6px;pointer-events:none}.character-count.is-over-limit[data-v-1527930a]{color:#ef4444}.character-count-words[data-v-1527930a],.is-dark .character-count[data-v-1527930a]{color:#9ca3af}.is-dark .character-count.is-over-limit[data-v-1527930a]{color:#f87171}.is-dark .character-count-words[data-v-1527930a]{color:#6b7280}.is-dark .inline-bubble-inner[data-v-1527930a]{background:#1f2937;border-color:#374151;box-shadow:0 10px 15px -3px #0000004d,0 4px 6px -2px #0003}.is-dark .inline-bubble-button[data-v-1527930a],.is-dark .inline-bubble-chip[data-v-1527930a]{background:#374151;color:#f9fafb}.is-dark .inline-bubble-button[data-v-1527930a]:hover,.is-dark .inline-bubble-chip[data-v-1527930a]:hover{background:#4b5563}.is-dark .inline-bubble-button.is-active[data-v-1527930a]{background:#f9fafb;color:#111827}.is-dark .inline-bubble-button.is-muted[data-v-1527930a]{background:transparent;color:#9ca3af}.is-dark .inline-bubble-button.is-muted[data-v-1527930a]:hover{background:#374151;color:#f9fafb}.is-dark .color-icon[data-v-1527930a]{background:#111827;border-color:#374151;color:#f9fafb}.is-dark .inline-bubble-divider[data-v-1527930a]{background:#4b5563}.is-dark .color-dropdown-menu[data-v-1527930a]{background:#1f2937;border-color:#374151;box-shadow:0 12px 20px -6px #0006}.editor-content-area[data-v-1527930a] .ProseMirror hr{border:none;border-top:2px solid #e5e7eb;margin:2em 0}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror hr{border-top-color:#4b5563}.editor-content-area[data-v-1527930a] .ProseMirror table{border-collapse:collapse;table-layout:fixed;width:100%;margin:1em 0;overflow:hidden}.editor-content-area[data-v-1527930a] .ProseMirror td,.editor-content-area[data-v-1527930a] .ProseMirror th{min-width:1em;border:2px solid #e5e7eb;padding:8px 12px;vertical-align:top;box-sizing:border-box;position:relative}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror td,.is-dark .editor-content-area[data-v-1527930a] .ProseMirror th{border-color:#4b5563}.editor-content-area[data-v-1527930a] .ProseMirror th{font-weight:700;text-align:left;background-color:#f9fafb}.is-dark .editor-content-area[data-v-1527930a] .ProseMirror th{background-color:#374151}.editor-content-area[data-v-1527930a] .ProseMirror .selectedCell:after{z-index:2;position:absolute;content:"";left:0;right:0;top:0;bottom:0;background:#3b82f61a;pointer-events:none}.editor-content-area[data-v-1527930a] .ProseMirror .column-resize-handle{position:absolute;right:-2px;top:0;bottom:-2px;width:4px;background-color:#3b82f6;pointer-events:none}.editor-content-area[data-v-1527930a] .ProseMirror.resize-cursor{cursor:ew-resize;cursor:col-resize}.editor-content-area[data-v-1527930a] [data-resize-container]{align-items:flex-start}.editor-content-area[data-v-1527930a] [data-resize-wrapper]{display:inline-block;max-width:100%}.editor-content-area[data-v-1527930a] [data-resize-handle]{background:#3b82f659;border-radius:4px;z-index:3}.editor-content-area[data-v-1527930a] [data-resize-handle=top],.editor-content-area[data-v-1527930a] [data-resize-handle=bottom]{height:6px;left:0;right:0;cursor:row-resize}.editor-content-area[data-v-1527930a] [data-resize-handle=left],.editor-content-area[data-v-1527930a] [data-resize-handle=right]{width:6px;top:0;bottom:0;cursor:col-resize}.is-dark .editor-content-area[data-v-1527930a] [data-resize-handle]{background:#60a5fa66}.editor-content-area[data-v-1527930a] .katex-display{overflow-x:auto;overflow-y:hidden;max-width:100%}.editor-content-area[data-v-1527930a] .katex{font-size:1.1em}.math-modal-overlay[data-v-1527930a]{position:fixed;top:0;right:0;bottom:0;left:0;background:#00000080;display:flex;align-items:center;justify-content:center;z-index:10000;-webkit-backdrop-filter:blur(2px);backdrop-filter:blur(2px);padding:16px}.math-modal[data-v-1527930a]{background:#fff;border-radius:8px;width:400px;max-width:90%;box-shadow:0 20px 25px -5px #0000001a,0 10px 10px -5px #0000000a;display:flex;flex-direction:column;overflow:hidden;border:1px solid #e5e7eb}.is-dark .math-modal[data-v-1527930a]{background:#1f2937;border-color:#374151;box-shadow:0 20px 25px -5px #00000080}.image-modal-tabs[data-v-1527930a]{display:flex;border-bottom:1px solid #e5e7eb}.image-tab-btn[data-v-1527930a]{flex:1;padding:8px 12px;background:none;border:none;border-bottom:2px solid transparent;cursor:pointer;font-size:13px;color:#6b7280;transition:color .15s,border-color .15s}.image-tab-btn.active[data-v-1527930a]{color:#111827;border-bottom-color:#3b82f6;font-weight:500}.is-dark .image-modal-tabs[data-v-1527930a]{border-bottom-color:#374151}.is-dark .image-tab-btn[data-v-1527930a]{color:#9ca3af}.is-dark .image-tab-btn.active[data-v-1527930a]{color:#f9fafb;border-bottom-color:#60a5fa}.editor-top-right-actions[data-v-1527930a]{position:absolute;top:10px;right:12px;z-index:30;display:flex;align-items:center;gap:6px}.comments-toggle-btn[data-v-1527930a]{display:flex;align-items:center;gap:4px;padding:6px 10px;background:#fff;border:1px solid #e5e7eb;border-radius:6px;font-size:13px;color:#374151;cursor:pointer;transition:background .15s,border-color .15s,color .15s}.comments-toggle-btn[data-v-1527930a]:hover{background:#f3f4f6;border-color:#d1d5db}.comments-toggle-btn.is-active[data-v-1527930a]{background:#eff6ff;border-color:#93c5fd;color:#1d4ed8}.is-dark .comments-reply-cancel[data-v-1527930a]{border-color:#4b5563;color:#9ca3af}.is-dark .comments-reply-cancel[data-v-1527930a]:hover{background:#4b5563;color:#f9fafb}.comments-badge[data-v-1527930a]{display:inline-flex;align-items:center;justify-content:center;min-width:16px;height:16px;padding:0 4px;background:#3b82f6;color:#fff;border-radius:99px;font-size:10px;font-weight:600}.is-dark .comments-toggle-btn[data-v-1527930a]:hover{background:#374151}.is-dark .comments-toggle-btn.is-active[data-v-1527930a]{background:#1e3a5f;border-color:#3b82f6;color:#93c5fd}.comments-sidebar[data-v-1527930a]{position:absolute;top:0;right:0;width:300px;height:100%;background:#fff;border-left:1px solid #e5e7eb;display:flex;flex-direction:column;z-index:9;overflow:hidden}.comments-slide-enter-active[data-v-1527930a],.comments-slide-leave-active[data-v-1527930a]{transition:transform .2s ease,opacity .2s ease}.comments-slide-enter-from[data-v-1527930a],.comments-slide-leave-to[data-v-1527930a]{transform:translate(100%);opacity:0}.comments-sidebar-header[data-v-1527930a]{display:flex;align-items:center;gap:8px;padding:12px 12px 10px;border-bottom:1px solid #e5e7eb;flex-shrink:0}.comments-sidebar-title[data-v-1527930a]{font-size:13px;font-weight:600;color:#111827;flex:1}.comments-sidebar-tabs[data-v-1527930a]{display:flex;gap:2px}.comments-tab-btn[data-v-1527930a]{padding:3px 8px;font-size:12px;border:1px solid transparent;border-radius:4px;background:none;color:#6b7280;cursor:pointer}.comments-tab-btn.active[data-v-1527930a]{background:#eff6ff;border-color:#93c5fd;color:#1d4ed8;font-weight:500}.comments-sidebar-close[data-v-1527930a]{background:transparent;border:none;font-size:18px;color:#9ca3af;cursor:pointer;padding:0 2px;line-height:1}.comments-sidebar-close[data-v-1527930a]:hover{color:#374151}.comments-sidebar-actions[data-v-1527930a]{padding:8px 12px;border-bottom:1px solid #f3f4f6;flex-shrink:0}.comments-add-btn[data-v-1527930a]{width:100%;padding:6px 10px;background:#f9fafb;border:1px dashed #d1d5db;border-radius:6px;font-size:12px;color:#374151;cursor:pointer;text-align:left;transition:background .15s}.comments-add-btn[data-v-1527930a]:hover:not(:disabled){background:#eff6ff;border-color:#93c5fd;color:#1d4ed8}.comments-add-btn[data-v-1527930a]:disabled{opacity:.4;cursor:default}.comments-new-composer[data-v-1527930a]{background:#f9fafb;border:1px solid #d1d5db;border-radius:6px;padding:8px 10px}.comments-new-composer-header[data-v-1527930a]{margin-bottom:6px}.comments-reply-cancel[data-v-1527930a]{padding:3px 10px;font-size:12px;background:transparent;color:#6b7280;border:1px solid #d1d5db;border-radius:4px;cursor:pointer}.comments-reply-cancel[data-v-1527930a]:hover{background:#f3f4f6;color:#374151}.is-dark .comments-new-composer[data-v-1527930a]{background:#374151;border-color:#4b5563}.comments-list[data-v-1527930a]{overflow-y:auto;flex:1;padding:8px 0}.comments-thread[data-v-1527930a]{margin:0 8px 8px;border:1px solid #e5e7eb;border-radius:8px;background:#fff;cursor:pointer;transition:border-color .15s,box-shadow .15s;overflow:hidden}.comments-thread[data-v-1527930a]:hover{border-color:#d1d5db}.comments-thread.is-selected[data-v-1527930a]{border-color:#3b82f6;box-shadow:0 0 0 2px #dbeafe}.comments-thread-header[data-v-1527930a]{display:flex;justify-content:flex-end;padding:6px 8px 0}.comments-thread-actions[data-v-1527930a]{display:flex;gap:2px}.comments-action-btn[data-v-1527930a]{padding:2px 6px;font-size:12px;border-radius:4px;border:1px solid #e5e7eb;background:#f9fafb;color:#374151;cursor:pointer}.comments-action-btn[data-v-1527930a]:hover{background:#f3f4f6}.comments-action-btn.is-danger[data-v-1527930a]{color:#ef4444}.comments-action-btn.is-danger[data-v-1527930a]:hover{background:#fef2f2;border-color:#fca5a5}.comments-resolved-hint[data-v-1527930a]{font-size:11px;color:#6b7280;padding:2px 10px 4px;background:#fefce8;border-top:1px solid #fef08a}.comments-comment-list[data-v-1527930a]{padding:6px 10px}.comments-comment[data-v-1527930a]{position:relative;padding:4px 0}.comments-comment[data-v-1527930a]:not(:first-child){border-top:1px solid #f3f4f6;padding-top:6px;margin-top:4px}.comments-comment.is-deleted[data-v-1527930a]{opacity:.5}.comments-comment-meta[data-v-1527930a]{display:flex;gap:6px;align-items:baseline;margin-bottom:2px}.comments-comment-author[data-v-1527930a]{font-size:12px;font-weight:600;color:#111827}.comments-comment-time[data-v-1527930a]{font-size:11px;color:#9ca3af}.comments-comment-text[data-v-1527930a]{font-size:12px;color:#374151;margin:0;line-height:1.5;padding-right:18px}.comments-comment-deleted[data-v-1527930a]{font-size:12px;color:#9ca3af;margin:0;font-style:italic}.comments-delete-comment[data-v-1527930a]{position:absolute;top:4px;right:0;background:transparent;border:none;font-size:14px;color:#d1d5db;cursor:pointer;line-height:1;padding:0}.comments-delete-comment[data-v-1527930a]:hover{color:#ef4444}.comments-reply[data-v-1527930a]{padding:6px 10px;border-top:1px solid #f3f4f6}.comments-reply-input[data-v-1527930a]{width:100%;min-height:52px;resize:none;font-size:12px;border:1px solid #d1d5db;border-radius:4px;padding:6px 8px;line-height:1.4;box-sizing:border-box;font-family:inherit}.comments-reply-input[data-v-1527930a]:focus{outline:none;border-color:#3b82f6}.comments-reply-footer[data-v-1527930a]{display:flex;justify-content:space-between;align-items:center;margin-top:4px}.comments-reply-hint[data-v-1527930a]{font-size:10px;color:#9ca3af}.comments-reply-submit[data-v-1527930a]{padding:3px 10px;font-size:12px;background:#3b82f6;color:#fff;border:none;border-radius:4px;cursor:pointer}.comments-reply-submit[data-v-1527930a]:hover:not(:disabled){background:#2563eb}.comments-reply-submit[data-v-1527930a]:disabled{opacity:.4;cursor:default}.comments-empty[data-v-1527930a]{padding:24px 16px;font-size:13px;color:#9ca3af;text-align:center}.is-dark .comments-sidebar[data-v-1527930a]{background:#1f2937;border-color:#374151}.is-dark .comments-sidebar-header[data-v-1527930a]{border-color:#374151}.is-dark .comments-sidebar-title[data-v-1527930a]{color:#f9fafb}.is-dark .comments-tab-btn[data-v-1527930a]{color:#9ca3af}.is-dark .comments-tab-btn.active[data-v-1527930a]{background:#1e3a5f;border-color:#3b82f6;color:#93c5fd}.is-dark .comments-thread[data-v-1527930a]{background:#111827;border-color:#374151}.is-dark .comments-thread[data-v-1527930a]:hover{border-color:#4b5563}.is-dark .comments-thread.is-selected[data-v-1527930a]{border-color:#3b82f6;box-shadow:0 0 0 2px #1e3a5f}.is-dark .comments-comment-author[data-v-1527930a]{color:#f9fafb}.is-dark .comments-comment-text[data-v-1527930a]{color:#d1d5db}.is-dark .comments-add-btn[data-v-1527930a]{background:#374151;border-color:#4b5563;color:#d1d5db}.is-dark .comments-reply-input[data-v-1527930a]{background:#374151;border-color:#4b5563;color:#f9fafb}.tiptap-thread--inline[data-v-1527930a]:not(.tiptap-thread--resolved){border-bottom:2px dashed #f59e0b;transition:background .15s;cursor:pointer}.tiptap-thread--inline.tiptap-thread--resolved[data-v-1527930a]{border-bottom:none;background:transparent;cursor:default}.tiptap-thread--inline[data-v-1527930a]:not(.tiptap-thread--resolved):hover,.tiptap-thread--inline.tiptap-thread--selected[data-v-1527930a]:not(.tiptap-thread--resolved),.tiptap-thread--inline.tiptap-thread--hovered[data-v-1527930a]:not(.tiptap-thread--resolved){background:#fef9c3}.is-dark .tiptap-thread--inline[data-v-1527930a]:not(.tiptap-thread--resolved):hover,.is-dark .tiptap-thread--inline.tiptap-thread--selected[data-v-1527930a]:not(.tiptap-thread--resolved){background:#422006}.math-modal-header[data-v-1527930a]{display:flex;align-items:center;justify-content:space-between;padding:12px 16px;border-bottom:1px solid #e5e7eb}.is-dark .math-modal-header[data-v-1527930a]{border-bottom-color:#374151}.math-modal-header h3[data-v-1527930a]{margin:0;font-size:14px;font-weight:600;color:#111827}.is-dark .math-modal-header h3[data-v-1527930a]{color:#f9fafb}.math-modal-close[data-v-1527930a]{background:transparent;border:none;font-size:20px;line-height:1;color:#6b7280;cursor:pointer;padding:0;display:flex;align-items:center;justify-content:center;width:24px;height:24px;border-radius:4px}.math-modal-close[data-v-1527930a]:hover{background:#f3f4f6;color:#111827}.is-dark .math-modal-close[data-v-1527930a]{color:#9ca3af}.is-dark .math-modal-close[data-v-1527930a]:hover{background:#374151;color:#f9fafb}.math-modal-body[data-v-1527930a]{padding:16px}.math-modal-body textarea[data-v-1527930a],.math-modal-body input[type=text][data-v-1527930a],.math-modal-body input[type=date][data-v-1527930a]{width:100%;padding:12px;border:1px solid #d1d5db;border-radius:6px;font-family:ui-monospace,SFMono-Regular,Menlo,Monaco,Consolas,Liberation Mono,Courier New,monospace;font-size:14px;color:#111827;background:#fff;box-sizing:border-box}.math-modal-body input[type=date][data-v-1527930a]{font-family:inherit;min-height:42px}.math-modal-body textarea[data-v-1527930a]{height:100px;resize:vertical}.math-modal-body textarea[data-v-1527930a]:focus,.math-modal-body input[type=text][data-v-1527930a]:focus,.math-modal-body input[type=date][data-v-1527930a]:focus{outline:none;border-color:#3b82f6;box-shadow:0 0 0 2px #3b82f633}.is-dark .math-modal-body textarea[data-v-1527930a],.is-dark .math-modal-body input[type=text][data-v-1527930a],.is-dark .math-modal-body input[type=date][data-v-1527930a]{background:#111827;border-color:#4b5563;color:#f9fafb}.is-dark .math-modal-body textarea[data-v-1527930a]:focus,.is-dark .math-modal-body input[type=text][data-v-1527930a]:focus,.is-dark .math-modal-body input[type=date][data-v-1527930a]:focus{border-color:#60a5fa;box-shadow:0 0 0 2px #60a5fa33}.math-modal-footer[data-v-1527930a]{display:flex;justify-content:flex-end;gap:8px;padding:12px 16px;background:#f9fafb;border-top:1px solid #e5e7eb}.is-dark .math-modal-footer[data-v-1527930a]{background:#111827;border-top-color:#374151}.math-btn-cancel[data-v-1527930a],.math-btn-submit[data-v-1527930a]{padding:6px 12px;font-size:14px;font-weight:500;border-radius:6px;cursor:pointer;transition:all .2s}.math-btn-cancel[data-v-1527930a]{background:transparent;border:1px solid #d1d5db;color:#374151}.math-btn-cancel[data-v-1527930a]:hover{background:#f3f4f6}.is-dark .math-btn-cancel[data-v-1527930a]{border-color:#4b5563;color:#d1d5db}.is-dark .math-btn-cancel[data-v-1527930a]:hover{background:#374151;color:#f9fafb}.math-btn-submit[data-v-1527930a]{background:#3b82f6;border:1px solid #3b82f6;color:#fff}.math-btn-submit[data-v-1527930a]:hover,.is-dark .math-btn-submit[data-v-1527930a]{background:#2563eb;border-color:#2563eb}.is-dark .math-btn-submit[data-v-1527930a]:hover{background:#1d4ed8;border-color:#1d4ed8}.drop-overlay[data-v-1527930a]{position:absolute;top:0;right:0;bottom:0;left:0;border-radius:8px;background:#eff6ffe0;border:2px dashed #3b82f6;z-index:100;display:flex;align-items:center;justify-content:center;pointer-events:none;-webkit-backdrop-filter:blur(1px);backdrop-filter:blur(1px)}.drop-overlay-inner[data-v-1527930a]{display:flex;flex-direction:column;align-items:center;gap:10px;color:#3b82f6;font-size:14px;font-weight:500}.drop-overlay-inner svg[data-v-1527930a]{opacity:.9}.is-dark .drop-overlay[data-v-1527930a]{background:#1e3a5fe0;border-color:#60a5fa}.is-dark .drop-overlay-inner[data-v-1527930a]{color:#93c5fd}.image-upload-placeholder[data-v-1527930a]{display:inline-flex;width:100px;height:100px;border:2px dashed #93c5fd;border-radius:8px;background:#eff6ff;margin:2px 4px;vertical-align:middle;box-sizing:border-box}.image-upload-placeholder-inner[data-v-1527930a]{display:inline-flex;flex-direction:column;align-items:center;justify-content:center;gap:8px;width:100%;height:100%}.image-upload-placeholder-label[data-v-1527930a]{font-size:13px;color:#3b82f6}.image-upload-placeholder-spinner[data-v-1527930a]{width:18px;height:18px;border:2px solid #bfdbfe;border-top-color:#3b82f6;border-radius:50%;animation:img-upload-spin-1527930a .7s linear infinite;flex-shrink:0}@keyframes img-upload-spin-1527930a{to{transform:rotate(360deg)}}.is-dark .image-upload-placeholder[data-v-1527930a]{background:#1e3a5f;border-color:#3b82f6}.is-dark .image-upload-placeholder-label[data-v-1527930a]{color:#93c5fd}.is-dark .image-upload-placeholder-spinner[data-v-1527930a]{border-color:#1e3a5f;border-top-color:#93c5fd}.export-docx-btn[data-v-1527930a]{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;background:#f0fdf4;border:1px solid #86efac;border-radius:6px;color:#15803d;font-size:12px;font-weight:500;cursor:pointer;transition:background .15s,border-color .15s;white-space:nowrap}.export-docx-btn[data-v-1527930a]:hover{background:#dcfce7;border-color:#4ade80}.export-docx-loading[data-v-1527930a]{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;background:#eff6ff;border:1px solid #93c5fd;border-radius:6px;color:#1d4ed8;font-size:12px;font-weight:500;white-space:nowrap}.export-docx-error[data-v-1527930a]{display:inline-flex;align-items:center;padding:5px 8px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;color:#b91c1c;font-size:13px;cursor:help}.import-docx-btn[data-v-1527930a]{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;background:#eff6ff;border:1px solid #93c5fd;border-radius:6px;color:#1d4ed8;font-size:12px;font-weight:500;cursor:pointer;transition:background .15s,border-color .15s;white-space:nowrap}.import-docx-btn[data-v-1527930a]:hover{background:#dbeafe;border-color:#3b82f6}.import-docx-loading[data-v-1527930a]{display:inline-flex;align-items:center;gap:6px;padding:5px 10px;background:#f0fdf4;border:1px solid #86efac;border-radius:6px;color:#15803d;font-size:12px;font-weight:500;white-space:nowrap}.import-docx-error[data-v-1527930a]{display:inline-flex;align-items:center;padding:5px 8px;background:#fef2f2;border:1px solid #fca5a5;border-radius:6px;color:#b91c1c;font-size:13px;cursor:help}@keyframes import-spin-1527930a{to{transform:rotate(360deg)}}.import-spin[data-v-1527930a]{animation:import-spin-1527930a .7s linear infinite}.is-dark .editor-top-right-actions .export-docx-btn[data-v-1527930a]{background:#052e16;border-color:#166534;color:#4ade80}.is-dark .editor-top-right-actions .export-docx-btn[data-v-1527930a]:hover{background:#14532d}.is-dark .export-docx-loading[data-v-1527930a]{background:#1e3a5f;border-color:#3b82f6;color:#93c5fd}.is-dark .export-docx-error[data-v-1527930a]{background:#450a0a;border-color:#991b1b;color:#fca5a5}.is-dark .editor-top-right-actions .import-docx-btn[data-v-1527930a]{background:#1e3a5f;border-color:#3b82f6;color:#93c5fd}.is-dark .editor-top-right-actions .import-docx-btn[data-v-1527930a]:hover{background:#1e40af}.is-dark .import-docx-loading[data-v-1527930a]{background:#052e16;border-color:#166534;color:#4ade80}.is-dark .import-docx-error[data-v-1527930a]{background:#450a0a;border-color:#991b1b;color:#fca5a5}.is-dark .comments-toggle-btn[data-v-1527930a]{background:#1f2937;border-color:#374151;color:#d1d5db}`, Fde = /* @__PURE__ */ ZA(Yde, [["styles", [yde]], ["__scopeId", "data-v-1527930a"]]), Nde = "data:image/svg+xml,%3csvg%20width='360'%20height='62'%20viewBox='0%200%20360%2062'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3crect%20width='360'%20height='61.8261'%20transform='translate(0%200.0869141)'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M65.6527%2010.6669L77.7909%2032.1625L73.6402%2034.5108L61.502%2013.0152L65.6527%2010.6669Z'%20fill='url(%23paint0_linear_1292_14058)'/%3e%3cpath%20d='M72.4475%2011.841C72.4475%2016.7446%2068.4762%2020.7197%2063.5773%2020.7197C58.6784%2020.7197%2054.707%2016.7446%2054.707%2011.841C54.707%206.9375%2058.6784%202.9624%2063.5773%202.9624C68.4762%202.9624%2072.4475%206.9375%2072.4475%2011.841Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M63.5773%2015.3507C65.5138%2015.3507%2067.0837%2013.7794%2067.0837%2011.841C67.0837%209.90269%2065.5138%208.33134%2063.5773%208.33134C61.6408%208.33134%2060.0709%209.90269%2060.0709%2011.841C60.0709%2013.7794%2061.6408%2015.3507%2063.5773%2015.3507ZM63.5773%2020.7197C68.4762%2020.7197%2072.4475%2016.7446%2072.4475%2011.841C72.4475%206.9375%2068.4762%202.9624%2063.5773%202.9624C58.6784%202.9624%2054.707%206.9375%2054.707%2011.841C54.707%2016.7446%2058.6784%2020.7197%2063.5773%2020.7197Z'%20fill='%233B3B3B'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M93.3632%2022.771L73.7553%2032.1169L75.8052%2036.4257L95.4131%2027.0798L93.3632%2022.771Z'%20fill='url(%23paint1_linear_1292_14058)'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M57.483%2050.2383L76.624%2036.6867L73.8707%2032.7904L54.7297%2046.342L57.483%2050.2383Z'%20fill='url(%23paint2_linear_1292_14058)'/%3e%3cpath%20d='M64.0432%2048.2902C64.0432%2053.1937%2060.0719%2057.1688%2055.173%2057.1688C50.2741%2057.1688%2046.3027%2053.1937%2046.3027%2048.2902C46.3027%2043.3867%2050.2741%2039.4116%2055.173%2039.4116C60.0719%2039.4116%2064.0432%2043.3867%2064.0432%2048.2902Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M55.173%2051.7999C57.1095%2051.7999%2058.6794%2050.2285%2058.6794%2048.2902C58.6794%2046.3518%2057.1095%2044.7805%2055.173%2044.7805C53.2365%2044.7805%2051.6666%2046.3518%2051.6666%2048.2902C51.6666%2050.2285%2053.2365%2051.7999%2055.173%2051.7999ZM55.173%2057.1688C60.0719%2057.1688%2064.0432%2053.1937%2064.0432%2048.2902C64.0432%2043.3867%2060.0719%2039.4116%2055.173%2039.4116C50.2741%2039.4116%2046.3027%2043.3867%2046.3027%2048.2902C46.3027%2053.1937%2050.2741%2057.1688%2055.173%2057.1688Z'%20fill='%233B3B3B'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M98.5596%2048.2065L76.6174%2032.7857L73.8776%2036.6915L95.8198%2052.1123L98.5596%2048.2065Z'%20fill='url(%23paint3_linear_1292_14058)'/%3e%3cpath%20d='M106.06%2050.1594C106.06%2055.0629%20102.088%2059.038%2097.1896%2059.038C92.2907%2059.038%2088.3193%2055.0629%2088.3193%2050.1594C88.3193%2045.2559%2092.2907%2041.2808%2097.1896%2041.2808C102.088%2041.2808%20106.06%2045.2559%20106.06%2050.1594Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M97.1896%2053.6691C99.1261%2053.6691%20100.696%2052.0978%20100.696%2050.1594C100.696%2048.221%2099.1261%2046.6497%2097.1896%2046.6497C95.2531%2046.6497%2093.6832%2048.221%2093.6832%2050.1594C93.6832%2052.0978%2095.2531%2053.6691%2097.1896%2053.6691ZM97.1896%2059.038C102.088%2059.038%20106.06%2055.0629%20106.06%2050.1594C106.06%2045.2559%20102.088%2041.2808%2097.1896%2041.2808C92.2907%2041.2808%2088.3193%2045.2559%2088.3193%2050.1594C88.3193%2055.0629%2092.2907%2059.038%2097.1896%2059.038Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M106.994%2023.0562C106.994%2027.9597%20103.023%2031.9348%2098.1241%2031.9348C93.2252%2031.9348%2089.2539%2027.9597%2089.2539%2023.0562C89.2539%2018.1527%2093.2252%2014.1776%2098.1241%2014.1776C103.023%2014.1776%20106.994%2018.1527%20106.994%2023.0562Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M98.1241%2026.5659C100.061%2026.5659%20101.631%2024.9945%20101.631%2023.0562C101.631%2021.1178%20100.061%2019.5465%2098.1241%2019.5465C96.1876%2019.5465%2094.6178%2021.1178%2094.6178%2023.0562C94.6178%2024.9945%2096.1876%2026.5659%2098.1241%2026.5659ZM98.1241%2031.9348C103.023%2031.9348%20106.994%2027.9597%20106.994%2023.0562C106.994%2018.1527%20103.023%2014.1776%2098.1241%2014.1776C93.2252%2014.1776%2089.2539%2018.1527%2089.2539%2023.0562C89.2539%2027.9597%2093.2252%2031.9348%2098.1241%2031.9348Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M84.5842%2033.3366C84.5842%2038.2402%2080.6129%2042.2153%2075.714%2042.2153C70.8151%2042.2153%2066.8438%2038.2402%2066.8438%2033.3366C66.8438%2028.4331%2070.8151%2024.458%2075.714%2024.458C80.6129%2024.458%2084.5842%2028.4331%2084.5842%2033.3366Z'%20fill='white'/%3e%3cpath%20fill-rule='evenodd'%20clip-rule='evenodd'%20d='M75.714%2036.8463C77.6505%2036.8463%2079.2204%2035.275%2079.2204%2033.3366C79.2204%2031.3983%2077.6505%2029.8269%2075.714%2029.8269C73.7775%2029.8269%2072.2076%2031.3983%2072.2076%2033.3366C72.2076%2035.275%2073.7775%2036.8463%2075.714%2036.8463ZM75.714%2042.2153C80.6129%2042.2153%2084.5842%2038.2402%2084.5842%2033.3366C84.5842%2028.4331%2080.6129%2024.458%2075.714%2024.458C70.8151%2024.458%2066.8438%2028.4331%2066.8438%2033.3366C66.8438%2038.2402%2070.8151%2042.2153%2075.714%2042.2153Z'%20fill='url(%23paint4_linear_1292_14058)'/%3e%3cpath%20d='M293.908%2027.127C294.806%2030.3732%20297.241%2031.9963%20301.212%2031.9963C303.768%2031.9963%20305.702%2031.133%20307.014%2029.4063L312.401%2032.5143C309.846%2036.2094%20306.081%2038.057%20301.108%2038.057C296.826%2038.057%20293.39%2036.762%20290.8%2034.1719C288.21%2031.5819%20286.915%2028.3184%20286.915%2024.3816C286.915%2020.4792%20288.193%2017.233%20290.748%2014.643C293.304%2012.0184%20296.585%2010.7061%20300.59%2010.7061C304.389%2010.7061%20307.515%2012.0184%20309.966%2014.643C312.453%2017.2676%20313.696%2020.5138%20313.696%2024.3816C313.696%2025.2449%20313.61%2026.1601%20313.437%2027.127H293.908ZM293.805%2021.9469H307.014C306.634%2020.1857%20305.84%2018.8734%20304.631%2018.01C303.457%2017.1467%20302.11%2016.715%20300.59%2016.715C298.795%2016.715%20297.31%2017.1812%20296.136%2018.1137C294.961%2019.0115%20294.184%2020.2893%20293.805%2021.9469Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M278.695%2011.4313H286.051L276.209%2037.3317H268.594L258.752%2011.4313H266.108L272.376%2029.5616L278.695%2011.4313Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M252.17%208.32327C251.065%208.32327%20250.098%207.92613%20249.27%207.13184C248.475%206.30303%20248.078%205.33608%20248.078%204.23099C248.078%203.1259%20248.475%202.15895%20249.27%201.33014C250.098%200.501322%20251.065%200.0869141%20252.17%200.0869141C253.31%200.0869141%20254.277%200.501322%20255.071%201.33014C255.9%202.15895%20256.314%203.1259%20256.314%204.23099C256.314%205.33608%20255.9%206.30303%20255.071%207.13184C254.277%207.92613%20253.31%208.32327%20252.17%208.32327ZM248.855%2037.3318V11.4313H255.537V37.3318H248.855Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M244.143%2017.8546H238.29V28.6292C238.29%2029.5271%20238.514%2030.1832%20238.963%2030.5976C239.412%2031.012%20240.068%2031.2538%20240.931%2031.3228C241.795%2031.3574%20242.865%2031.3401%20244.143%2031.271V37.3317C239.55%2037.8498%20236.304%2037.4181%20234.405%2036.0367C232.54%2034.6554%20231.607%2032.1862%20231.607%2028.6292V17.8546H227.101V11.4313H231.607V6.19938L238.29%204.17914V11.4313H244.143V17.8546Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M224.361%2019.2015C224.361%2023.8981%20222.876%2027.9731%20219.907%2031.4265L223.636%2035.3116L218.56%2039.8183L214.623%2035.726C211.826%2037.28%20208.787%2038.057%20205.506%2038.057C200.291%2038.057%20195.854%2036.244%20192.193%2032.6179C188.532%2028.9573%20186.702%2024.4852%20186.702%2019.2015C186.702%2013.9178%20188.532%209.46292%20192.193%205.83685C195.854%202.17625%20200.291%200.345947%20205.506%200.345947C210.721%200.345947%20215.158%202.17625%20218.819%205.83685C222.514%209.46292%20224.361%2013.9178%20224.361%2019.2015ZM205.506%2031.0639C206.853%2031.0639%20208.2%2030.8394%20209.546%2030.3905L203.589%2024.1744L208.666%2019.6677L215.037%2026.2982C216.488%2024.2262%20217.213%2021.8606%20217.213%2019.2015C217.213%2015.7481%20216.091%2012.899%20213.846%2010.6543C211.601%208.40963%20208.821%207.28727%20205.506%207.28727C202.191%207.28727%20199.411%208.40963%20197.166%2010.6543C194.921%2012.899%20193.799%2015.7481%20193.799%2019.2015C193.799%2022.6204%20194.921%2025.4521%20197.166%2027.6969C199.411%2029.9416%20202.191%2031.0639%20205.506%2031.0639Z'%20fill='%23FF7272'/%3e%3cpath%20d='M174.5%201.07111H181.649V37.3318H174.5V1.07111Z'%20fill='%23FF7272'/%3e%3cpath%20d='M170.853%2037.3317H163.135L157.54%2029.458L151.894%2037.3317H144.176L153.655%2024.1225L144.59%2011.4313H152.309L157.54%2018.7352L162.772%2011.4313H170.439L161.374%2024.0707L170.853%2037.3317Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M123.987%2027.127C124.885%2030.3732%20127.32%2031.9963%20131.291%2031.9963C133.847%2031.9963%20135.781%2031.133%20137.093%2029.4063L142.48%2032.5143C139.925%2036.2094%20136.16%2038.057%20131.188%2038.057C126.905%2038.057%20123.469%2036.762%20120.879%2034.1719C118.289%2031.5819%20116.994%2028.3184%20116.994%2024.3816C116.994%2020.4792%20118.272%2017.233%20120.827%2014.643C123.383%2012.0184%20126.664%2010.7061%20130.67%2010.7061C134.468%2010.7061%20137.594%2012.0184%20140.046%2014.643C142.532%2017.2676%20143.775%2020.5138%20143.775%2024.3816C143.775%2025.2449%20143.689%2026.1601%20143.516%2027.127H123.987ZM123.884%2021.9469H137.093C136.713%2020.1857%20135.919%2018.8734%20134.71%2018.01C133.536%2017.1467%20132.189%2016.715%20130.67%2016.715C128.874%2016.715%20127.389%2017.1812%20126.215%2018.1137C125.041%2019.0115%20124.264%2020.2893%20123.884%2021.9469Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M288.733%2058.703C287.982%2058.703%20287.335%2058.5231%20286.792%2058.1633C286.253%2057.7999%20285.836%2057.2899%20285.541%2056.6334C285.25%2055.9732%20285.104%2055.1999%20285.104%2054.3135C285.104%2053.4382%20285.25%2052.6668%20285.541%2051.9992C285.836%2051.3316%20286.246%2050.8105%20286.772%2050.4359C287.302%2050.0613%20287.921%2049.874%20288.629%2049.874C289.059%2049.874%20289.476%2049.9537%20289.88%2050.1132C290.284%2050.2727%20290.646%2050.523%20290.967%2050.8642C291.288%2051.2055%20291.541%2051.6487%20291.726%2052.1939C291.912%2052.7354%20292.004%2053.3937%20292.004%2054.1689V54.7586H285.943V53.5124H290.55C290.55%2053.0747%20290.47%2052.6872%20290.312%2052.3496C290.153%2052.0084%20289.929%2051.7395%20289.642%2051.543C289.357%2051.3464%20289.023%2051.2481%20288.639%2051.2481C288.222%2051.2481%20287.858%2051.3631%20287.547%2051.593C287.239%2051.8193%20287.001%2052.116%20286.832%2052.4832C286.666%2052.8466%20286.584%2053.2416%20286.584%2053.6682V54.6417C286.584%2055.2129%20286.673%2055.6988%20286.852%2056.0993C287.034%2056.4999%20287.287%2056.8059%20287.611%2057.0173C287.936%2057.225%20288.314%2057.3288%20288.748%2057.3288C289.029%2057.3288%20289.286%2057.2843%20289.517%2057.1953C289.749%2057.1026%20289.949%2056.9654%20290.118%2056.7836C290.287%2056.6019%20290.416%2056.3775%20290.505%2056.1105L291.91%2056.3942C291.797%2056.8578%20291.596%2057.2639%20291.304%2057.6126C291.017%2057.9575%20290.654%2058.2264%20290.217%2058.4192C289.784%2058.6084%20289.289%2058.703%20288.733%2058.703Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M280.355%2058.5305V49.9852H281.79V51.3426H281.869C282.008%2050.8827%20282.253%2050.5211%20282.604%2050.2578C282.958%2049.9908%20283.359%2049.8572%20283.805%2049.8572C283.898%2049.8572%20284.007%2049.8609%20284.133%2049.8684C284.262%2049.8758%20284.363%2049.8851%20284.436%2049.8962V51.4873C284.376%2051.4688%20284.27%2051.4484%20284.118%2051.4261C283.966%2051.4001%20283.814%2051.3872%20283.661%2051.3872C283.311%2051.3872%20282.998%2051.4706%20282.723%2051.6375C282.452%2051.8007%20282.237%2052.0288%20282.078%2052.3218C281.919%2052.6111%20281.84%2052.9412%20281.84%2053.3121V58.5305H280.355Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M274.617%2058.7197C274.134%2058.7197%20273.697%2058.6195%20273.307%2058.4192C272.916%2058.2152%20272.607%2057.9204%20272.379%2057.5347C272.154%2057.1489%20272.041%2056.6761%20272.041%2056.116C272.041%2055.6339%20272.124%2055.237%20272.289%2054.9255C272.455%2054.6139%20272.678%2054.3673%20272.959%2054.1855C273.241%2054.0038%20273.555%2053.8666%20273.902%2053.7739C274.25%2053.6811%20274.604%2053.6107%20274.965%2053.5624C275.421%2053.5031%20275.792%2053.4549%20276.077%2053.4178C276.361%2053.377%20276.568%2053.3121%20276.697%2053.2231C276.826%2053.1341%20276.891%2052.9894%20276.891%2052.7891V52.7502C276.891%2052.2643%20276.768%2051.8879%20276.523%2051.6208C276.282%2051.3538%20275.921%2051.2203%20275.441%2051.2203C274.942%2051.2203%20274.548%2051.3445%20274.26%2051.593C273.975%2051.8378%20273.778%2052.1104%20273.669%2052.4108L272.274%2052.0548C272.44%2051.5355%20272.681%2051.1164%20272.999%2050.7975C273.32%2050.4748%20273.689%2050.2411%20274.106%2050.0965C274.523%2049.9481%20274.961%2049.874%20275.421%2049.874C275.726%2049.874%20276.049%2049.9148%20276.389%2049.9964C276.734%2050.0742%20277.055%2050.2189%20277.352%2050.4303C277.654%2050.6417%20277.9%2050.944%20278.092%2051.3371C278.284%2051.7266%20278.38%2052.2328%20278.38%2052.8559V58.5305H276.93V57.3622H276.871C276.775%2057.5773%20276.631%2057.7887%20276.439%2057.9964C276.247%2058.2041%20276.001%2058.3766%20275.699%2058.5138C275.398%2058.651%20275.038%2058.7197%20274.617%2058.7197ZM274.94%2057.3845C275.35%2057.3845%20275.701%2057.2936%20275.992%2057.1119C276.287%2056.9301%20276.51%2056.6927%20276.662%2056.3997C276.818%2056.103%20276.896%2055.7859%20276.896%2055.4484V54.3469C276.843%2054.4062%20276.74%2054.4619%20276.588%2054.5138C276.439%2054.562%20276.269%2054.6046%20276.077%2054.6417C275.885%2054.6751%20275.698%2054.7066%20275.516%2054.7363C275.334%2054.7623%20275.182%2054.7845%20275.059%2054.8031C274.771%2054.8439%20274.508%2054.9125%20274.27%2055.0089C274.035%2055.1053%20273.846%2055.2444%20273.704%2055.4262C273.565%2055.6042%20273.495%2055.8416%20273.495%2056.1383C273.495%2056.55%20273.631%2056.8615%20273.902%2057.0729C274.174%2057.2806%20274.52%2057.3845%20274.94%2057.3845Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M262.516%2058.5305L260.272%2049.9852H261.806L263.3%2056.2607H263.375L264.874%2049.9852H266.408L267.897%2056.2328H267.971L269.456%2049.9852H270.99L268.751%2058.5305H267.237L265.688%2052.3608H265.574L264.025%2058.5305H262.516Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M259.222%2049.9852V51.3204H255.058V49.9852H259.222ZM256.174%2047.9379H257.659V56.0214C257.659%2056.3441%20257.702%2056.587%20257.788%2056.7502C257.874%2056.9097%20257.985%2057.0191%20258.12%2057.0784C258.259%2057.134%20258.41%2057.1619%20258.572%2057.1619C258.691%2057.1619%20258.795%2057.1526%20258.885%2057.134C258.974%2057.1155%20259.044%2057.1007%20259.093%2057.0895L259.361%2058.4637C259.275%2058.5008%20259.153%2058.5379%20258.994%2058.5749C258.835%2058.6157%20258.637%2058.638%20258.398%2058.6417C258.008%2058.6491%20257.644%2058.5712%20257.306%2058.408C256.969%2058.2449%20256.696%2057.9927%20256.487%2057.6514C256.279%2057.3102%20256.174%2056.8818%20256.174%2056.3663V47.9379Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M254.132%2049.9852V51.3204H249.823V49.9852H254.132ZM251.005%2058.5304V48.9949C251.005%2048.4608%20251.109%2048.0176%20251.317%2047.6653C251.526%2047.3092%20251.802%2047.044%20252.146%2046.8697C252.491%2046.6917%20252.864%2046.6027%20253.268%2046.6027C253.566%2046.6027%20253.821%2046.6305%20254.033%2046.6861C254.244%2046.738%20254.402%2046.7863%20254.504%2046.8308L254.157%2048.1771C254.087%2048.1548%20253.998%2048.1289%20253.889%2048.0992C253.779%2048.0658%20253.647%2048.0491%20253.492%2048.0491C253.131%2048.0491%20252.873%2048.1493%20252.717%2048.3495C252.565%2048.5498%20252.489%2048.8391%20252.489%2049.2174V58.5304H251.005Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M245.292%2058.703C244.578%2058.703%20243.954%2058.5194%20243.421%2058.1522C242.888%2057.785%20242.475%2057.2713%20242.18%2056.6112C241.886%2055.951%20241.738%2055.1795%20241.738%2054.2968C241.738%2053.4104%20241.886%2052.6352%20242.18%2051.9713C242.475%2051.3074%20242.888%2050.7919%20243.421%2050.4247C243.954%2050.0576%20244.578%2049.874%20245.292%2049.874C246.007%2049.874%20246.631%2050.0576%20247.164%2050.4247C247.697%2050.7919%20248.11%2051.3074%20248.405%2051.9713C248.699%2052.6352%20248.847%2053.4104%20248.847%2054.2968C248.847%2055.1795%20248.699%2055.951%20248.405%2056.6112C248.11%2057.2713%20247.697%2057.785%20247.164%2058.1522C246.631%2058.5194%20246.007%2058.703%20245.292%2058.703ZM245.297%2057.3066C245.761%2057.3066%20246.145%2057.1693%20246.449%2056.8949C246.753%2056.6204%20246.979%2056.2551%20247.124%2055.7989C247.273%2055.3427%20247.348%2054.8402%20247.348%2054.2912C247.348%2053.746%20247.273%2053.2453%20247.124%2052.7891C246.979%2052.3292%20246.753%2051.9602%20246.449%2051.682C246.145%2051.4039%20245.761%2051.2648%20245.297%2051.2648C244.831%2051.2648%20244.444%2051.4039%20244.136%2051.682C243.831%2051.9602%20243.605%2052.3292%20243.456%2052.7891C243.31%2053.2453%20243.237%2053.746%20243.237%2054.2912C243.237%2054.8402%20243.31%2055.3427%20243.456%2055.7989C243.605%2056.2551%20243.831%2056.6204%20244.136%2056.8949C244.444%2057.1693%20244.831%2057.3066%20245.297%2057.3066Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M238.748%2050.1299C238.695%2049.6032%20238.476%2049.1952%20238.092%2048.9059C237.708%2048.6129%20237.225%2048.4664%20236.643%2048.4664C236.226%2048.4664%20235.865%2048.5406%20235.561%2048.689C235.256%2048.8336%20235.02%2049.0339%20234.851%2049.2898C234.685%2049.542%20234.603%2049.8294%20234.603%2050.1521C234.603%2050.4229%20234.659%2050.6565%20234.771%2050.8531C234.887%2051.0497%20235.038%2051.2147%20235.223%2051.3482C235.412%2051.478%20235.614%2051.5875%20235.829%2051.6765C236.044%2051.7618%20236.251%2051.8322%20236.449%2051.8879L237.442%2052.1772C237.766%2052.2662%20238.099%2052.3867%20238.44%2052.5388C238.781%2052.6908%20239.097%2052.8911%20239.388%2053.1396C239.679%2053.3881%20239.914%2053.696%20240.093%2054.0631C240.275%2054.4303%20240.366%2054.8698%20240.366%2055.3816C240.366%2056.027%20240.217%2056.6%20239.919%2057.1007C239.625%2057.6014%20239.196%2057.9964%20238.633%2058.2857C238.074%2058.575%20237.397%2058.7196%20236.603%2058.7196C235.842%2058.7196%20235.183%2058.5843%20234.628%2058.3135C234.072%2058.0428%20233.636%2057.6589%20233.322%2057.1619C233.008%2056.6612%20232.834%2056.0678%20232.801%2055.3816H234.34C234.369%2055.7933%20234.489%2056.1364%20234.697%2056.4109C234.909%2056.6816%20235.179%2056.8837%20235.506%2057.0173C235.837%2057.1471%20236.199%2057.212%20236.593%2057.212C237.027%2057.212%20237.412%2057.1359%20237.75%2056.9839C238.091%2056.8281%20238.359%2056.613%20238.554%2056.3385C238.749%2056.0604%20238.847%2055.7358%20238.847%2055.365C238.847%2055.0274%20238.761%2054.7511%20238.589%2054.536C238.42%2054.3209%20238.19%2054.1429%20237.899%2054.0019C237.611%2053.861%20237.285%2053.7368%20236.921%2053.6292L235.72%2053.262C234.905%2053.0135%20234.26%2052.6482%20233.784%2052.166C233.31%2051.6839%20233.074%2051.046%20233.074%2050.2523C233.074%2049.5958%20233.233%2049.0228%20233.55%2048.5332C233.868%2048.0436%20234.298%2047.6635%20234.841%2047.3927C235.384%2047.1182%20235.996%2046.981%20236.678%2046.981C237.366%2046.981%20237.973%2047.1164%20238.499%2047.3871C239.029%2047.6579%20239.446%2048.0306%20239.75%2048.5054C240.055%2048.9764%20240.214%2049.5179%20240.227%2050.1299H238.748Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M223.954%2061.913C223.349%2061.913%20222.827%2061.824%20222.391%2061.646C221.957%2061.4679%20221.603%2061.2324%20221.328%2060.9394C221.054%2060.6464%20220.848%2060.3256%20220.713%2059.977L221.988%2059.3873C222.078%2059.5504%20222.197%2059.7229%20222.346%2059.9046C222.498%2060.0901%20222.703%2060.2477%20222.961%2060.3775C223.223%2060.5073%20223.559%2060.5722%20223.969%2060.5722C224.532%2060.5722%20224.997%2060.4183%20225.364%2060.1105C225.731%2059.8064%20225.915%2059.3205%20225.915%2058.6529V56.9728H225.821C225.731%2057.1545%20225.602%2057.3566%20225.433%2057.5792C225.268%2057.8017%20225.04%2057.9946%20224.748%2058.1578C224.457%2058.3209%20224.078%2058.4025%20223.612%2058.4025C223.009%2058.4025%20222.467%2058.2449%20221.983%2057.9297C221.504%2057.6107%20221.123%2057.1415%20220.842%2056.5221C220.564%2055.899%20220.425%2055.1332%20220.425%2054.2245C220.425%2053.3158%20220.562%2052.5369%20220.837%2051.8879C221.115%2051.2388%20221.495%2050.7418%20221.979%2050.3969C222.462%2050.0483%20223.009%2049.874%20223.622%2049.874C224.095%2049.874%20224.477%2049.963%20224.768%2050.141C225.059%2050.3153%20225.286%2050.5193%20225.448%2050.753C225.614%2050.9866%20225.741%2051.1925%20225.831%2051.3705H225.94V49.9852H227.394V58.7197C227.394%2059.454%20227.242%2060.0567%20226.937%2060.5277C226.633%2060.9988%20226.221%2061.3474%20225.701%2061.5736C225.185%2061.7999%20224.603%2061.913%20223.954%2061.913ZM223.939%2057.0228C224.366%2057.0228%20224.727%2056.9116%20225.021%2056.689C225.319%2056.4628%20225.544%2056.1401%20225.696%2055.721C225.852%2055.2982%20225.93%2054.7919%20225.93%2054.2022C225.93%2053.6274%20225.854%2053.1211%20225.701%2052.6834C225.549%2052.2458%20225.326%2051.9046%20225.031%2051.6598C224.737%2051.4113%20224.373%2051.287%20223.939%2051.287C223.492%2051.287%20223.12%2051.4169%20222.822%2051.6765C222.525%2051.9324%20222.3%2052.281%20222.147%2052.7224C221.998%2053.1637%20221.924%2053.657%20221.924%2054.2022C221.924%2054.7623%20222%2055.2537%20222.152%2055.6765C222.304%2056.0993%20222.53%2056.4294%20222.827%2056.6668C223.128%2056.9042%20223.499%2057.0228%20223.939%2057.0228Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M213.888%2053.4567V58.5305H212.403V49.9852H213.828V51.3761H213.922C214.098%2050.9236%20214.372%2050.5601%20214.746%2050.2856C215.124%2050.0112%20215.598%2049.874%20216.171%2049.874C216.69%2049.874%20217.146%2049.9964%20217.536%2050.2411C217.926%2050.4822%20218.229%2050.842%20218.444%2051.3204C218.66%2051.7989%20218.767%2052.3904%20218.767%2053.0951V58.5305H217.283V53.2954C217.283%2052.676%20217.139%2052.192%20216.851%2051.8434C216.563%2051.491%20216.168%2051.3149%20215.665%2051.3149C215.32%2051.3149%20215.014%2051.3983%20214.746%2051.5652C214.482%2051.7321%20214.271%2051.9769%20214.116%2052.2996C213.964%2052.6185%20213.888%2053.0043%20213.888%2053.4567Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M208.923%2058.5305V49.9852H210.407V58.5305H208.923ZM209.673%2048.6667C209.414%2048.6667%20209.193%2048.5703%20209.007%2048.3774C208.825%2048.1808%20208.734%2047.9472%20208.734%2047.6764C208.734%2047.402%20208.825%2047.1683%20209.007%2046.9755C209.193%2046.7789%20209.414%2046.6806%20209.673%2046.6806C209.931%2046.6806%20210.151%2046.7789%20210.333%2046.9755C210.518%2047.1683%20210.611%2047.402%20210.611%2047.6764C210.611%2047.9472%20210.518%2048.1808%20210.333%2048.3774C210.151%2048.5703%20209.931%2048.6667%20209.673%2048.6667Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M206.926%2047.1368V58.5305H205.441V47.1368H206.926Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M199.702%2058.7197C199.219%2058.7197%20198.782%2058.6195%20198.392%2058.4192C198.001%2058.2152%20197.692%2057.9204%20197.464%2057.5347C197.238%2057.1489%20197.126%2056.6761%20197.126%2056.116C197.126%2055.6339%20197.209%2055.237%20197.374%2054.9255C197.54%2054.6139%20197.763%2054.3673%20198.044%2054.1855C198.326%2054.0038%20198.64%2053.8666%20198.987%2053.7739C199.335%2053.6811%20199.689%2053.6107%20200.05%2053.5624C200.506%2053.5031%20200.877%2053.4549%20201.162%2053.4178C201.446%2053.377%20201.653%2053.3121%20201.782%2053.2231C201.911%2053.1341%20201.976%2052.9894%20201.976%2052.7891V52.7502C201.976%2052.2643%20201.853%2051.8879%20201.608%2051.6208C201.367%2051.3538%20201.006%2051.2203%20200.526%2051.2203C200.027%2051.2203%20199.633%2051.3445%20199.345%2051.593C199.06%2051.8378%20198.863%2052.1104%20198.754%2052.4108L197.359%2052.0548C197.525%2051.5355%20197.766%2051.1164%20198.084%2050.7975C198.405%2050.4748%20198.774%2050.2411%20199.191%2050.0965C199.608%2049.9481%20200.046%2049.874%20200.506%2049.874C200.811%2049.874%20201.134%2049.9148%20201.474%2049.9964C201.819%2050.0742%20202.14%2050.2189%20202.437%2050.4303C202.739%2050.6417%20202.985%2050.944%20203.177%2051.3371C203.369%2051.7266%20203.465%2052.2328%20203.465%2052.8559V58.5305H202.015V57.3622H201.956C201.86%2057.5773%20201.716%2057.7887%20201.524%2057.9964C201.332%2058.2041%20201.086%2058.3766%20200.784%2058.5138C200.483%2058.651%20200.123%2058.7197%20199.702%2058.7197ZM200.025%2057.3845C200.435%2057.3845%20200.786%2057.2936%20201.077%2057.1119C201.372%2056.9301%20201.595%2056.6927%20201.747%2056.3997C201.903%2056.103%20201.981%2055.7859%20201.981%2055.4484V54.3469C201.928%2054.4062%20201.825%2054.4619%20201.673%2054.5138C201.524%2054.562%20201.354%2054.6046%20201.162%2054.6417C200.97%2054.6751%20200.783%2054.7066%20200.601%2054.7363C200.419%2054.7623%20200.266%2054.7845%20200.144%2054.8031C199.856%2054.8439%20199.593%2054.9125%20199.355%2055.0089C199.12%2055.1053%20198.931%2055.2444%20198.789%2055.4262C198.65%2055.6042%20198.58%2055.8416%20198.58%2056.1383C198.58%2056.55%20198.716%2056.8615%20198.987%2057.0729C199.259%2057.2806%20199.605%2057.3845%20200.025%2057.3845Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M192.763%2058.703C192.025%2058.703%20191.39%2058.5157%20190.857%2058.1411C190.328%2057.7628%20189.92%2057.2417%20189.636%2056.5778C189.351%2055.9139%20189.209%2055.1536%20189.209%2054.2968C189.209%2053.4289%20189.355%2052.663%20189.646%2051.9992C189.937%2051.3316%20190.347%2050.8105%20190.877%2050.4359C191.406%2050.0613%20192.03%2049.874%20192.748%2049.874C193.327%2049.874%20193.844%2049.9945%20194.297%2050.2356C194.75%2050.4729%20195.116%2050.8067%20195.394%2051.237C195.675%2051.6672%20195.842%2052.1698%20195.895%2052.7446H194.451C194.371%2052.3441%20194.189%2051.9992%20193.905%2051.7099C193.624%2051.4206%20193.246%2051.2759%20192.773%2051.2759C192.359%2051.2759%20191.997%2051.3983%20191.686%2051.6431C191.378%2051.8842%20191.138%2052.2291%20190.966%2052.6779C190.794%2053.1229%20190.708%2053.6496%20190.708%2054.2579C190.708%2054.881%20190.792%2055.4187%20190.961%2055.8712C191.13%2056.3237%20191.368%2056.6742%20191.676%2056.9227C191.987%2057.1712%20192.353%2057.2954%20192.773%2057.2954C193.054%2057.2954%20193.309%2057.238%20193.538%2057.123C193.769%2057.0043%20193.963%2056.8355%20194.118%2056.6167C194.277%2056.3979%20194.388%2056.1346%20194.451%2055.8267H195.895C195.842%2056.3793%20195.682%2056.8726%20195.414%2057.3066C195.146%2057.7405%20194.787%2058.0817%20194.337%2058.3302C193.89%2058.5787%20193.365%2058.703%20192.763%2058.703Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M186.22%2050.1299C186.167%2049.6032%20185.949%2049.1952%20185.565%2048.9059C185.181%2048.6129%20184.698%2048.4664%20184.116%2048.4664C183.699%2048.4664%20183.338%2048.5406%20183.033%2048.689C182.729%2048.8336%20182.492%2049.0339%20182.324%2049.2898C182.158%2049.542%20182.075%2049.8294%20182.075%2050.1521C182.075%2050.4229%20182.132%2050.6565%20182.244%2050.8531C182.36%2051.0497%20182.511%2051.2147%20182.696%2051.3482C182.884%2051.478%20183.086%2051.5875%20183.301%2051.6765C183.517%2051.7618%20183.723%2051.8322%20183.922%2051.8879L184.915%2052.1772C185.239%2052.2662%20185.572%2052.3867%20185.912%2052.5388C186.253%2052.6908%20186.569%2052.8911%20186.861%2053.1396C187.152%2053.3881%20187.387%2053.696%20187.565%2054.0631C187.747%2054.4303%20187.838%2054.8698%20187.838%2055.3816C187.838%2056.027%20187.69%2056.6%20187.392%2057.1007C187.097%2057.6014%20186.669%2057.9964%20186.106%2058.2857C185.547%2058.575%20184.87%2058.7196%20184.076%2058.7196C183.315%2058.7196%20182.656%2058.5843%20182.1%2058.3135C181.544%2058.0428%20181.109%2057.6589%20180.795%2057.1619C180.48%2056.6612%20180.307%2056.0678%20180.273%2055.3816H181.812C181.842%2055.7933%20181.961%2056.1364%20182.17%2056.4109C182.381%2056.6816%20182.651%2056.8837%20182.979%2057.0173C183.31%2057.1471%20183.672%2057.212%20184.066%2057.212C184.499%2057.212%20184.885%2057.1359%20185.222%2056.9839C185.563%2056.8281%20185.831%2056.613%20186.027%2056.3385C186.222%2056.0604%20186.319%2055.7358%20186.319%2055.365C186.319%2055.0274%20186.233%2054.7511%20186.061%2054.536C185.893%2054.3209%20185.663%2054.1429%20185.371%2054.0019C185.083%2053.861%20184.758%2053.7368%20184.393%2053.6292L183.192%2053.262C182.378%2053.0135%20181.733%2052.6482%20181.256%2052.166C180.783%2051.6839%20180.546%2051.046%20180.546%2050.2523C180.546%2049.5958%20180.705%2049.0228%20181.023%2048.5332C181.341%2048.0436%20181.771%2047.6635%20182.314%2047.3927C182.856%2047.1182%20183.469%2046.981%20184.15%2046.981C184.839%2046.981%20185.446%2047.1164%20185.972%2047.3871C186.501%2047.6579%20186.918%2048.0306%20187.223%2048.5054C187.527%2048.9764%20187.686%2049.5179%20187.699%2050.1299H186.22Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M175.076%2052.0715L173.731%2052.3385C173.675%2052.1457%20173.586%2051.9621%20173.463%2051.7877C173.344%2051.6134%20173.182%2051.4706%20172.977%2051.3594C172.771%2051.2481%20172.515%2051.1925%20172.207%2051.1925C171.787%2051.1925%20171.436%2051.2982%20171.155%2051.5096C170.874%2051.7173%20170.733%2051.9862%20170.733%2052.3163C170.733%2052.6018%20170.827%2052.8318%20171.016%2053.0061C171.205%2053.1804%20171.509%2053.3232%20171.929%2053.4345L173.14%2053.746C173.842%2053.9278%20174.365%2054.2078%20174.709%2054.5861C175.053%2054.9644%20175.225%2055.4558%20175.225%2056.0604C175.225%2056.5722%20175.093%2057.0284%20174.828%2057.429C174.567%2057.8258%20174.201%2058.1374%20173.731%2058.3636C173.265%2058.5898%20172.724%2058.703%20172.108%2058.703C171.254%2058.703%20170.558%2058.499%20170.018%2058.091C169.479%2057.6793%20169.148%2057.0952%20169.025%2056.3385L170.46%2056.0938C170.549%2056.5129%20170.733%2056.83%20171.011%2057.0451C171.289%2057.2565%20171.651%2057.3622%20172.098%2057.3622C172.585%2057.3622%20172.973%2057.2491%20173.265%2057.0228C173.556%2056.7929%20173.701%2056.5129%20173.701%2056.1828C173.701%2055.9157%20173.612%2055.6913%20173.433%2055.5096C173.258%2055.3279%20172.988%2055.1906%20172.624%2055.0979L171.334%2054.7808C170.622%2054.5991%20170.096%2054.3098%20169.755%2053.9129C169.418%2053.5161%20169.249%2053.0135%20169.249%2052.4053C169.249%2051.9009%20169.375%2051.4595%20169.626%2051.0812C169.878%2050.7029%20170.225%2050.408%20170.668%2050.1966C171.112%2049.9815%20171.62%2049.874%20172.192%2049.874C173.016%2049.874%20173.665%2050.0742%20174.138%2050.4748C174.611%2050.8717%20174.924%2051.4039%20175.076%2052.0715Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M167.581%2052.0715L166.236%2052.3385C166.18%2052.1457%20166.09%2051.9621%20165.968%2051.7877C165.849%2051.6134%20165.687%2051.4706%20165.482%2051.3594C165.276%2051.2481%20165.02%2051.1925%20164.712%2051.1925C164.292%2051.1925%20163.941%2051.2982%20163.66%2051.5096C163.379%2051.7173%20163.238%2051.9862%20163.238%2052.3163C163.238%2052.6018%20163.332%2052.8318%20163.521%2053.0061C163.709%2053.1804%20164.014%2053.3232%20164.434%2053.4345L165.645%2053.746C166.347%2053.9278%20166.87%2054.2078%20167.214%2054.5861C167.558%2054.9644%20167.73%2055.4558%20167.73%2056.0604C167.73%2056.5722%20167.598%2057.0284%20167.333%2057.429C167.072%2057.8258%20166.706%2058.1374%20166.236%2058.3636C165.769%2058.5898%20165.228%2058.703%20164.613%2058.703C163.759%2058.703%20163.062%2058.499%20162.523%2058.091C161.984%2057.6793%20161.653%2057.0952%20161.53%2056.3385L162.965%2056.0938C163.054%2056.5129%20163.238%2056.83%20163.516%2057.0451C163.794%2057.2565%20164.156%2057.3622%20164.603%2057.3622C165.089%2057.3622%20165.478%2057.2491%20165.769%2057.0228C166.061%2056.7929%20166.206%2056.5129%20166.206%2056.1828C166.206%2055.9157%20166.117%2055.6913%20165.938%2055.5096C165.763%2055.3279%20165.493%2055.1906%20165.129%2055.0979L163.838%2054.7808C163.127%2054.5991%20162.601%2054.3098%20162.26%2053.9129C161.922%2053.5161%20161.754%2053.0135%20161.754%2052.4053C161.754%2051.9009%20161.879%2051.4595%20162.131%2051.0812C162.382%2050.7029%20162.73%2050.408%20163.173%2050.1966C163.617%2049.9815%20164.125%2049.874%20164.697%2049.874C165.521%2049.874%20166.17%2050.0742%20166.643%2050.4748C167.116%2050.8717%20167.429%2051.4039%20167.581%2052.0715Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M156.951%2058.703C156.2%2058.703%20155.553%2058.5231%20155.01%2058.1633C154.471%2057.7999%20154.054%2057.2899%20153.759%2056.6334C153.468%2055.9732%20153.322%2055.1999%20153.322%2054.3135C153.322%2053.4382%20153.468%2052.6668%20153.759%2051.9992C154.054%2051.3316%20154.464%2050.8105%20154.99%2050.4359C155.52%2050.0613%20156.138%2049.874%20156.847%2049.874C157.277%2049.874%20157.694%2049.9537%20158.098%2050.1132C158.501%2050.2727%20158.864%2050.523%20159.185%2050.8642C159.506%2051.2055%20159.759%2051.6487%20159.944%2052.1939C160.129%2052.7354%20160.222%2053.3937%20160.222%2054.1689V54.7586H154.161V53.5124H158.768C158.768%2053.0747%20158.688%2052.6872%20158.529%2052.3496C158.371%2052.0084%20158.147%2051.7395%20157.859%2051.543C157.575%2051.3464%20157.24%2051.2481%20156.857%2051.2481C156.44%2051.2481%20156.076%2051.3631%20155.765%2051.593C155.457%2051.8193%20155.218%2052.116%20155.05%2052.4832C154.884%2052.8466%20154.802%2053.2416%20154.802%2053.6682V54.6417C154.802%2055.2129%20154.891%2055.6988%20155.07%2056.0993C155.252%2056.4999%20155.505%2056.8059%20155.829%2057.0173C156.153%2057.225%20156.532%2057.3288%20156.966%2057.3288C157.247%2057.3288%20157.504%2057.2843%20157.735%2057.1953C157.967%2057.1026%20158.167%2056.9654%20158.336%2056.7836C158.505%2056.6019%20158.634%2056.3775%20158.723%2056.1105L160.128%2056.3942C160.015%2056.8578%20159.813%2057.2639%20159.522%2057.6126C159.234%2057.9575%20158.872%2058.2264%20158.435%2058.4192C158.002%2058.6084%20157.507%2058.703%20156.951%2058.703Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M146.794%2053.4567V58.5305H145.31V49.9852H146.734V51.3761H146.829C147.004%2050.9236%20147.279%2050.5601%20147.653%2050.2856C148.03%2050.0112%20148.505%2049.874%20149.077%2049.874C149.597%2049.874%20150.052%2049.9964%20150.442%2050.2411C150.833%2050.4822%20151.136%2050.842%20151.351%2051.3204C151.566%2051.7989%20151.673%2052.3904%20151.673%2053.0951V58.5305H150.189V53.2954C150.189%2052.676%20150.045%2052.192%20149.757%2051.8434C149.469%2051.491%20149.074%2051.3149%20148.571%2051.3149C148.227%2051.3149%20147.921%2051.3983%20147.653%2051.5652C147.388%2051.7321%20147.178%2051.9769%20147.022%2052.2996C146.87%2052.6185%20146.794%2053.0043%20146.794%2053.4567Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M141.827%2058.5305V49.9852H143.312V58.5305H141.827ZM142.577%2048.6667C142.319%2048.6667%20142.097%2048.5703%20141.912%2048.3774C141.73%2048.1808%20141.639%2047.9472%20141.639%2047.6764C141.639%2047.402%20141.73%2047.1683%20141.912%2046.9755C142.097%2046.7789%20142.319%2046.6806%20142.577%2046.6806C142.835%2046.6806%20143.055%2046.7789%20143.237%2046.9755C143.422%2047.1683%20143.515%2047.402%20143.515%2047.6764C143.515%2047.9472%20143.422%2048.1808%20143.237%2048.3774C143.055%2048.5703%20142.835%2048.6667%20142.577%2048.6667Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M140.047%2052.0715L138.702%2052.3385C138.646%2052.1457%20138.556%2051.9621%20138.434%2051.7877C138.315%2051.6134%20138.153%2051.4706%20137.947%2051.3594C137.742%2051.2481%20137.486%2051.1925%20137.178%2051.1925C136.758%2051.1925%20136.407%2051.2982%20136.126%2051.5096C135.844%2051.7173%20135.704%2051.9862%20135.704%2052.3163C135.704%2052.6018%20135.798%2052.8318%20135.987%2053.0061C136.175%2053.1804%20136.48%2053.3232%20136.9%2053.4345L138.111%2053.746C138.813%2053.9278%20139.336%2054.2078%20139.68%2054.5861C140.024%2054.9644%20140.196%2055.4558%20140.196%2056.0604C140.196%2056.5722%20140.064%2057.0284%20139.799%2057.429C139.537%2057.8258%20139.172%2058.1374%20138.702%2058.3636C138.235%2058.5898%20137.694%2058.703%20137.079%2058.703C136.225%2058.703%20135.528%2058.499%20134.989%2058.091C134.449%2057.6793%20134.119%2057.0952%20133.996%2056.3385L135.431%2056.0938C135.52%2056.5129%20135.704%2056.83%20135.982%2057.0451C136.26%2057.2565%20136.622%2057.3622%20137.069%2057.3622C137.555%2057.3622%20137.944%2057.2491%20138.235%2057.0228C138.526%2056.7929%20138.672%2056.5129%20138.672%2056.1828C138.672%2055.9157%20138.583%2055.6913%20138.404%2055.5096C138.229%2055.3279%20137.959%2055.1906%20137.595%2055.0979L136.304%2054.7808C135.593%2054.5991%20135.067%2054.3098%20134.726%2053.9129C134.388%2053.5161%20134.219%2053.0135%20134.219%2052.4053C134.219%2051.9009%20134.345%2051.4595%20134.597%2051.0812C134.848%2050.7029%20135.196%2050.408%20135.639%2050.1966C136.083%2049.9815%20136.591%2049.874%20137.163%2049.874C137.987%2049.874%20138.636%2050.0742%20139.109%2050.4748C139.582%2050.8717%20139.895%2051.4039%20140.047%2052.0715Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M130.85%2054.9867V49.9852H132.34V58.5305H130.88V57.0507H130.801C130.625%2057.5068%20130.344%2057.887%20129.957%2058.1911C129.573%2058.4916%20129.095%2058.6418%20128.522%2058.6418C128.033%2058.6418%20127.599%2058.5212%20127.222%2058.2802C126.848%2058.0354%20126.553%2057.6737%20126.338%2057.1953C126.126%2056.7169%20126.021%2056.1253%20126.021%2055.4206V49.9852H127.505V55.2203C127.505%2055.8026%20127.649%2056.2662%20127.937%2056.6112C128.224%2056.9561%20128.598%2057.1285%20129.058%2057.1285C129.336%2057.1285%20129.613%2057.0507%20129.887%2056.8949C130.165%2056.7391%20130.395%2056.5036%20130.577%2056.1883C130.763%2055.8731%20130.854%2055.4725%20130.85%2054.9867Z'%20fill='%233B3B3B'/%3e%3cpath%20d='M116.994%2058.5305V47.1368H120.717C121.438%2047.1368%20122.036%2047.2703%20122.509%2047.5373C122.982%2047.8007%20123.336%2048.1586%20123.571%2048.6111C123.806%2049.0598%20123.924%2049.5661%20123.924%2050.1299C123.924%2050.6046%20123.846%2051.0051%20123.69%2051.3315C123.535%2051.6542%20123.326%2051.9138%20123.065%2052.1104C122.807%2052.3033%20122.522%2052.4442%20122.211%2052.5332V52.6445C122.549%2052.663%20122.878%2052.7854%20123.199%2053.0117C123.523%2053.2342%20123.791%2053.5513%20124.003%2053.963C124.215%2054.3747%20124.321%2054.8754%20124.321%2055.4651C124.321%2056.0474%20124.198%2056.5703%20123.954%2057.0339C123.712%2057.4938%20123.338%2057.8592%20122.832%2058.1299C122.325%2058.397%20121.678%2058.5305%20120.891%2058.5305H116.994ZM118.528%2057.0562H120.742C121.477%2057.0562%20122.003%2056.8967%20122.32%2056.5777C122.638%2056.2588%20122.797%2055.8601%20122.797%2055.3816C122.797%2055.0219%20122.716%2054.6918%20122.554%2054.3914C122.392%2054.0909%20122.16%2053.8517%20121.859%2053.6737C121.561%2053.4957%20121.207%2053.4067%20120.796%2053.4067H118.528V57.0562ZM118.528%2052.0659H120.583C120.927%2052.0659%20121.237%2051.9917%20121.511%2051.8434C121.789%2051.695%20122.009%2051.4873%20122.172%2051.2203C122.337%2050.9495%20122.42%2050.6306%20122.42%2050.2634C122.42%2049.7923%20122.272%2049.3973%20121.978%2049.0784C121.683%2048.7594%20121.232%2048.5999%20120.623%2048.5999H118.528V52.0659Z'%20fill='%233B3B3B'/%3e%3cdefs%3e%3clinearGradient%20id='paint0_linear_1292_14058'%20x1='69.6464'%20y1='11.841'%20x2='69.6464'%20y2='33.3367'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23C3C3C3'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint1_linear_1292_14058'%20x1='84.5842'%20y1='24.9254'%20x2='84.5842'%20y2='34.2713'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23C3C3C3'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint2_linear_1292_14058'%20x1='65.6769'%20y1='34.7385'%20x2='65.6769'%20y2='48.2901'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23C3C3C3'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint3_linear_1292_14058'%20x1='86.2186'%20y1='34.7386'%20x2='86.2186'%20y2='50.1594'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23C3C3C3'/%3e%3cstop%20offset='1'%20stop-color='white'/%3e%3c/linearGradient%3e%3clinearGradient%20id='paint4_linear_1292_14058'%20x1='75.714'%20y1='24.458'%20x2='75.714'%20y2='42.2153'%20gradientUnits='userSpaceOnUse'%3e%3cstop%20stop-color='%23FF3030'/%3e%3cstop%20offset='0.953125'%20stop-color='%23FF7272'/%3e%3c/linearGradient%3e%3c/defs%3e%3c/svg%3e", Dde = "data:image/png;base64,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", xde = ":host{display:block;width:100%;height:100vh;font-family:Inter,system-ui,-apple-system,sans-serif}.maintenance-layout{display:flex;width:100%;height:100vh;background:#fff}.main-panel{flex:1;display:flex;flex-direction:column;padding:40px;justify-content:center;align-items:center;text-align:center}.brand{position:absolute;top:40px;left:40px}.logo{height:32px}.content-wrapper{max-width:480px;width:100%}.process-animation{margin-bottom:32px;display:flex;flex-direction:column;align-items:center}.process-spinner{width:64px;height:64px;margin-bottom:16px}.spinner-svg{animation:rotate 2s linear infinite}.spinner-track{stroke:#f2f4f7}.spinner-head{stroke:#7f56d9;animation:dash 1.5s ease-in-out infinite}@keyframes rotate{to{transform:rotate(360deg)}}@keyframes dash{0%{stroke-dasharray:1,150;stroke-dashoffset:0}50%{stroke-dasharray:90,150;stroke-dashoffset:-35}to{stroke-dasharray:90,150;stroke-dashoffset:-124}}.process-step{color:#7f56d9;font-weight:500;font-size:16px}.title{font-size:36px;font-weight:700;color:#101828;margin:0 0 16px;line-height:44px}.message{font-size:18px;color:#475467;margin:0 0 24px;line-height:28px}.hint{font-size:14px;color:#667085}.side-panel{flex:1;display:flex;justify-content:flex-end;padding:20px;background:#fff}.image-container{width:100%;max-width:700px;height:100%;background-size:cover;background-position:center;border-radius:40px}@media(max-width:960px){.side-panel{display:none}}", Gde = { class: "maintenance-layout" }, zde = { class: "main-panel" }, Ude = { class: "brand" }, bde = ["src"], vde = { class: "content-wrapper" }, jde = {
  class: "process-animation",
  "aria-hidden": "true"
}, Hde = {
  class: "process-steps",
  "aria-live": "polite"
}, kde = { class: "process-step" }, Rde = { class: "side-panel" }, Lde = {
  __name: "MaintenanceScreen.ce",
  setup(t) {
    const e = ["Preparing update...", "Optimizing database...", "Updating components...", "Finalizing..."], A = /* @__PURE__ */ me(e[0]);
    let n;
    return Xr(() => {
      let s = 0;
      n = setInterval(() => {
        s = (s + 1) % e.length, A.value = e[s];
      }, 3e3), setTimeout(() => {
        window.location.reload();
      }, 6e4);
    }), ww(() => {
      n && clearInterval(n);
    }), (s, r) => (ee(), Ae("div", Gde, [
      F("main", zde, [
        F("div", Ude, [
          F("img", {
            src: bs(Nde),
            alt: "exlQtive.com",
            class: "logo"
          }, null, 8, bde)
        ]),
        F("div", vde, [
          F("div", jde, [
            r[0] || (r[0] = F("div", { class: "process-spinner" }, [
              F("svg", {
                class: "spinner-svg",
                viewBox: "0 0 64 64",
                fill: "none",
                xmlns: "http://www.w3.org/2000/svg"
              }, [
                F("circle", {
                  class: "spinner-track",
                  cx: "32",
                  cy: "32",
                  r: "28",
                  "stroke-width": "3"
                }),
                F("circle", {
                  class: "spinner-head",
                  cx: "32",
                  cy: "32",
                  r: "28",
                  "stroke-width": "3",
                  "stroke-dasharray": "88 264",
                  "stroke-linecap": "round"
                })
              ])
            ], -1)),
            F("div", Hde, [
              F("span", kde, Mt(A.value), 1)
            ])
          ]),
          r[1] || (r[1] = F("h1", { class: "title" }, "We're updating the system", -1)),
          r[2] || (r[2] = F("p", { class: "message" }, "We'll be back in about 5–10 minutes. This page will refresh automatically.", -1)),
          r[3] || (r[3] = F("p", { class: "hint" }, "No action needed—we'll reload when we're ready.", -1))
        ])
      ]),
      F("aside", Rde, [
        F("div", {
          class: "image-container",
          style: ia({ backgroundImage: `url(${bs(Dde)})` })
        }, null, 4)
      ])
    ]));
  }
}, Sde = /* @__PURE__ */ ZA(Lde, [["styles", [xde]]]);
function Tde() {
  const t = [
    ["exiq-hello-card", j7],
    ["exiq-button", J7],
    ["exiq-book-content-edit-menu", Z7],
    ["exiq-procedure-page-menu", tR],
    ["exiq-chatter-icon", lR],
    ["exiq-generic-selector", hR],
    ["exiq-menu-icon", yR],
    ["exiq-procedures-breadcrumb", vR],
    ["exiq-book-procedure-line", JR],
    ["exiq-book-chapter-line", DL],
    ["exiq-book-table-of-content-edit-box", bL],
    ["exiq-book-content-edit-card", PL],
    ["exiq-maintenance-screen", Sde],
    ["exiq-notion-editor", Fde]
  ];
  for (const [e, A] of t)
    customElements.get(e) || customElements.define(e, /* @__PURE__ */ E7(A));
}
Tde();
export {
  ZA as _,
  F as a,
  je as b,
  Ae as c,
  fr as d,
  Fe as e,
  De as n,
  ee as o,
  Tde as r
};
